/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * Pages module.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 08.12.2017
 */
(function () {
    'use strict';

    var app = angular.module('BlurAdmin.pages', [
        'ui.router',
        'BlurAdmin.pages.dashboard',
        'BlurAdmin.pages.profile',
        'BlurAdmin.pages.login',
        'BlurAdmin.pages.orders',
        'BlurAdmin.pages.barcodeScan',
        'BlurAdmin.pages.shippingTracker',
        'BlurAdmin.pages.shipment',
        'BlurAdmin.pages.shipSettings',
        'BlurAdmin.pages.inventoryManagement',
        'BlurAdmin.pages.reports',
        'BlurAdmin.pages.faqFrontend',
        'BlurAdmin.pages.document',
        'BlurAdmin.pages.accountSettings',
        'BlurAdmin.pages.settings',
        'BlurAdmin.pages.stickerSettings',
        'BlurAdmin.pages.relaySettings',
        'BlurAdmin.pages.productList',
        'BlurAdmin.pages.databaseMachines',
        'BlurAdmin.pages.dubaiMachines',
        'BlurAdmin.pages.machineDashboard',
        'BlurAdmin.pages.bugReportSettings',
   ]).config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider){
        $urlRouterProvider.otherwise('/login');
    }
  app.controller('mainController', fnMainController);
    function fnMainController($scope, $state, $rootScope, $http, $cookies, $location, $window, toastr, Idle, $filter) {
        Idle.watch();
        $scope.$on('IdleTimeout', function() {
            toastr.error("Your session has expired.");
            if($location.path() != '/login'){
                $scope.logOut();
            }
        });
        /**
         * LogOut method is use for logout user.
         * created on 08.12.2017
         */
        $scope.logOut = function () {
            $rootScope.globals = {};

            delete $rootScope['permissionArr'];
            delete $rootScope.globalsearchBy;
            delete $rootScope.globalSetting;
            $cookies.remove('regularStatus');
            $cookies.remove('supplyStatus');
            $cookies.remove('expressStatus');
            $cookies.remove('customersStatus');
            $cookies.remove('reworkStatus');
            $('#orderLogsModel').modal('hide');
            $('#orderDetailsModel').modal('hide');

            $window.localStorage.removeItem('globals');
            $window.localStorage.removeItem('settings');
            $state.go('login', {}, {reload: true});
            return false;
        };

        /**
        * UCCap For First Caracter Capital Of String.
        * Created on 11.06.2017
        */
        $scope.UcCap =  function (string){
            if(string){
                return string.charAt(0).toUpperCase() + string.slice(1);;
            }
            return string;
        }

        /**
        * Get Date Formate Global.
        * created on 11.06.2017
        */
        $scope.getGlobalDateFormat = function (data){
            if(data && $rootScope.globalSetting.dateTimeFormate && data!='0000-00-00 00:00:00'){
//                return data;
              return moment(data).format($rootScope.globalSetting.dateTimeFormate);
//                return moment.utc(data).tz('America/New_York').format($rootScope.globalSetting.dateTimeFormate);
            }else{
              return '';
            }
        }
        $scope.getDateFormated = function (data){
          if(data && $rootScope.globalSetting.dateTimeFormate && data!='0000-00-00 00:00:00'){
            return moment(data).format("MM\/DD\/YYYY");
          }
          else{
              return '';
          }
        }
        /**
        * Get Date Formate Global.
        * created on 01.02.2019
        */
        $scope.getGlobalDateFormatConditionally = function (data){
            if(data && $rootScope.globalSetting.dateTimeFormate && data!='0000-00-00 00:00:00'){
              return moment(data).format($rootScope.globalSetting.dateTimeFormate);
            }else{
              return ' - ';
            }
        }
        /**
        * Save From and To Date Formate Global.
        * created on 07.20.2018
        */
        $scope.saveFromDateFormat = function (data){
            if(data){
              return moment(data).format('YYYY-MM-DD HH:mm:ss');
            }else{
              return '';
            }
        }
        $scope.saveToDateFormat = function (data){
            if(data){
              return moment(data).format('YYYY-MM-DD')+' 23:59:59';
            }else{
              return '';
            }
        }

        /**
        * Get Date Formate Global.
        * created on 11.06.2017
        */
        $scope.getDateByFormat = function (data,formate){
            return moment(data).format(formate)
        }
        $scope.renderWithDollar=function(data){
          if(data){
            return '$'+parseFloat(data).toFixed(2);
          }else{
            return '$0.00';
          }
        }
        /**
         * Data url encode method is use encode request data.
         * created on 08.12.2017
         */
        $scope.dataUrlEncode = function (obj) {
            var str = "";
            for (var key in obj) {
                if (str != "") {
                    str += "&";
                }
                str += key + "=" + encodeURIComponent(obj[key]);
            }
            return str;
        }
        $scope.resetGlobalSearch=function(){
          angular.element('#searchInput').val('');
          $rootScope.globalsearchBy = '';
          $rootScope.globalSearch = '';
        }
        /**
        * Order Action Html method is use for prepare action html part.
        * created on 08.30.2018
        */
       /**
        * display/hide disabled icon 
        * 24 jan 2019
        * shivpratap.chauhan@brainvire.com
        */
        $scope.orderActionHtml=function(data,type,full){
           var row='';
        if($rootScope.displayDisableIcons=='yes')
        {
           if(full.icon_rocket && full.icon_rocket=='enable'){
             row += '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
           }else{
             row += '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
           }
           if(full.icon_tools && full.icon_tools=='enable'){
             row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
           }else{
             row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
           }
           if(full.icon_plane && full.icon_plane=='enable'){
             row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
           }else{
             row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
           }
           if((full.icon_house && full.icon_house=='enable') || (full.is_ups && full.is_ups=='enable' || full.is_ups==1)){
             row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
           }else{
             row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed">';
           }
           if(full.regular_orders && full.regular_orders=='enable'){
             row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
           }
           if ((full.type_total_count != undefined) && (full.type_total_count >= 1)) {
                var typeSlugName;
                var typeExtName;
                for (var i = 1; i <= full.type_total_count; i++) {
                    typeSlugName = full['type_' + i + '_slug'];
                    typeExtName = full['type_' + i + '_extension'];
                    row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                    //console.log(row);
                }
           }
           return row;
        }else if($rootScope.displayDisableIcons=='no'){
           if(full.icon_rocket && full.icon_rocket=='enable'){
             row += '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
           }
           if(full.icon_tools && full.icon_tools=='enable'){
             row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
           }
           if(full.icon_plane && full.icon_plane=='enable'){
             row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
           }
           if((full.icon_house && full.icon_house=='enable') || (full.is_ups && full.is_ups=='enable' || full.is_ups==1)){
             row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
           }
           if ((full.type_total_count != undefined) && (full.type_total_count >= 1)) {
                var typeSlugName;
                var typeExtName;
                for (var i = 1; i <= full.type_total_count; i++) {
                    typeSlugName = full['type_' + i + '_slug'];
                    typeExtName = full['type_' + i + '_extension'];
                    row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                }
           }
           if(full.regular_orders && full.regular_orders=='enable'){
             row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
           }
           return row ;
        }
        
    }
   $scope. sticker_arr=['express','supply','customer','regular','rework'];
 }


})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.barcodeScan', [])
            .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
                .state('barcode', {
                    url: '/barcode',
                    templateUrl: 'app/pages/barcodeScan/barcodeScan.html',
                    controller: 'barcodeScanCtrl as vm',
                    title: 'Scan Barcode',
                    permissionKey:'barcode_dept_list',
                    sidebarMeta: {
                        order: 2,
                        icon: 'fa fa-barcode'
                    },
                }).state('change-status', {
                    url: '/change-status',
                    templateUrl: 'app/pages/barcodeScan/changeStatus.html',
                    controller: 'barcodeScanCtrl as vm',
                    title: 'Change Status',
                    prevStateTitle:'Scan Barcode',
                    prevState:'barcode'
                }).state('damage-order', {
                    url: '/damage-order',
                    templateUrl: 'app/pages/barcodeScan/damageScan.html',
                    controller: 'barcodeScanCtrl as vm',
                    title: 'Damage Order',
                    prevStateTitle:'Scan Barcode',
                    prevState:'barcode'
                }).state('ink-allocation', {
                    url: '/ink-allocation',
                    templateUrl: 'app/pages/barcodeScan/inkScan.html',
                    controller: 'barcodeScanCtrl as vm',
                    title: 'Ink Allocation Order',
                    prevStateTitle:'Scan Barcode',
                    prevState:'barcode'
                })
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  var app = angular.module('BlurAdmin.pages.dashboard', [])
      .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          controller: 'dashboardCtrl',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
        });
  }
  app.filter('randomize', function() {
  return function(input, scope) {
    if (input!=null && input!=undefined && input > 1) {
      return Math.floor((Math.random()*input)+1);
    }
  }
});

function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.bugReportSettings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('bug-report', {
        url: '/bug-report',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Bug Report Settings',
        permissionKey:'bug_report_settings',
        nestedPermission:['bug_report_settings'],
        sidebarMeta: {
          icon: 'fa fa-cogs',
          order: 15,
        },
      }).state('bug-report.shipment-bug-report', {
        url: '/bug-report/shipment-bug-report',
        templateUrl: 'app/pages/bugReportSettings/shipmentBugReport/shipmentBugReport.html',
        controller:'shipmentBugReport as vm',
        title: 'Shipment Bug Report',
        permissionKey:'shipment_bug_report',
        sidebarMeta: {
          order: 0,
        }
      });
      $urlRouterProvider.when('/bug-report', '/bug-report/shipment-bug-report');
    }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.accountSettings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('account-settings', {
        url: '/account-settings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Account Settings',
        permissionKey:'account_settings',
        nestedPermission:['sub_admin_list','role_list','mall_customer_list','retail_customer_list','sub_cust_manage', 'allow_owner_account_customer','subowners_list','subowners_list_owner'],
        sidebarMeta: {
          icon: 'fa fa-users',
          order: 7,
        },
      }).state('account-settings.sub-admin', {
        url: '/sub-admin',
        templateUrl: 'app/pages/accountSettings/users/users.html',
        controller: 'usersCtrl',
        title: 'Manage Sub Admin',
        permissionKey:'sub_admin_list',
        sidebarMeta: {
          order: 0,
        },
      }).state('account-settings.add-sub-admin', {
        url: '/add-sub-admin',
        templateUrl: 'app/pages/accountSettings/users/addUser.html',
        controller: 'usersCtrl',
        title: 'Add Sub Admin',
        prevStateTitle:'Manage Sub Admin',
        prevState:'account-settings.sub-admin',
        sidebarMeta: {
          order:1
        }
      }).state('account-settings.edit-sub-admin', {
        url: '/edit-sub-admin',
        templateUrl: 'app/pages/accountSettings/users/addUser.html',
        controller: 'usersCtrl',
        title: 'Edit Sub Admin',
        prevStateTitle:'Manage Sub Admin',
        prevState:'account-settings.sub-admin',
        sidebarMeta: {
          order:2
        }
      }).state('account-settings.roles', {
        url: '/roles',
        templateUrl: 'app/pages/accountSettings/roles/roles.html',
        controller: 'rolesCtrl',
        title: 'Manage Roles',
        blank: true,
        permissionKey:'role_list',
        sidebarMeta: {
          order: 3,
        },
      }).state('account-settings.add-roles', {
        url: '/add-roles',
        templateUrl: 'app/pages/accountSettings/roles/addRoles.html',
        controller: 'rolesCtrl',
        title: 'Add Role',
        prevStateTitle:'Manage Roles',
        prevState:'account-settings.roles',
        sidebarMeta: {
          order: 4,
        },
      }).state('account-settings.edit-roles', {
        url: '/edit-roles',
        templateUrl: 'app/pages/accountSettings/roles/addRoles.html',
        controller: 'rolesCtrl',
        title: 'Edit Role',
        prevStateTitle:'Manage Roles',
        prevState:'account-settings.roles',
        sidebarMeta: {
          order: 5,
        },
      }).state('account-settings.roles-permission', {
        url: '/roles-permission',
        templateUrl: 'app/pages/accountSettings/roles/rolesPermission.html',
        controller: 'rolesCtrl as vm',
        title: 'Role Permissions',
        prevStateTitle:'Manage Roles',
        prevState:'account-settings.roles'
      }).state('account-settings.mall-customers', {
        url: '/mall-customers',
        templateUrl: 'app/pages/accountSettings/customers/customers.html',
        controller: 'customersCtrl as vm',
        title: 'Mall Customers',
        permissionKey:'mall_customer_list',
        sidebarMeta: {
          order: 6,
        },
      }).state('account-settings.retail-customers', {
        url: '/retail-customers',
        templateUrl: 'app/pages/accountSettings/customers/customers.html',
        controller: 'customersCtrl as vm',
        title: 'Retail Customers',
        permissionKey:'retail_customer_list',
        sidebarMeta: {
          order: 7,
        },
      }).state('account-settings.add-customer', {
        url: '/add-mall-customer',
        templateUrl: 'app/pages/accountSettings/customers/addCustomer.html',
        controller: 'customersCtrl as vm',
        title: 'Add Mall Customer',
        prevStateTitle:'Mall Customers',
        prevState:'account-settings.mall-customers',
        sidebarMeta: {
          order: 7,
        },
      }).state('account-settings.edit-customer', {
        url: '/edit-customer',
        templateUrl: 'app/pages/accountSettings/customers/addCustomer.html',
        controller: 'customersCtrl as vm',
        title: 'Edit Customer',
        sidebarMeta: {
          order: 8,
        },
      }).state('account-settings.sub-customer', {
        url: '/sub-customers',
        templateUrl: 'app/pages/accountSettings/customers/subCustomers.html',
        controller: 'customersCtrl',
        title: 'Sub Customers',
        prevStateTitle:'Mall Customers',
        prevState:'account-settings.mall-customers',
        sidebarMeta: {
          order: 9,
        },
      }).state('account-settings.manage-sub-customer', {
        url: '/manage-sub-customers',
        templateUrl: 'app/pages/accountSettings/customers/subCustomers.html',
        controller: 'customersCtrl',
        title: 'Sub Customers',
        permissionKey:'sub_cust_manage',
        sidebarMeta: {
          order: 10,
        },
      }).state('account-settings.add-sub-customer', {
        url: '/add-sub-customer',
        templateUrl: 'app/pages/accountSettings/customers/addSubCustomer.html',
        controller: 'customersCtrl',
        title: 'Add Sub Customer',
        sidebarMeta: {
          order: 11,
        },
      }).state('account-settings.edit-sub-customer', {
        url: '/edit-sub-customer',
        templateUrl: 'app/pages/accountSettings/customers/addSubCustomer.html',
        controller: 'customersCtrl',
        title: 'Edit Sub Customer',
        sidebarMeta: {
          order: 12,
        },
      }).state('account-settings.view-mall-customer-credit-report', {
        url: '/view-mall-customer-credit-report',
        templateUrl: 'app/pages/accountSettings/customers/storeCreditReport.html',
        controller:'storeCreditReportCtrl as scr',
        title: 'View Customer Credit',
        params: {type: 'mall_customer_credit_report'},
        prevStateTitle:'Mall Customers',
        prevState:'account-settings.mall-customers',
        sidebarMeta: {
          order: 13,
        },
      }).state('account-settings.owner-account', {
        url: '/owner-account',
        templateUrl: 'app/pages/accountSettings/owner/owner.html',
        controller: 'ownerCtrl as vm',
        title: 'Owner Acoount',
        permissionKey:'allow_owner_account_customer',
        sidebarMeta: {
          order: 14,
        },
      }).state('account-settings.add-owner', {
        url: '/add-owner-account',
        templateUrl: 'app/pages/accountSettings/owner/addOwner.html',
        controller: 'ownerCtrl as vm',
        title: 'Add Owner Account',
        prevStateTitle:'Owner Acoount',
        prevState:'account-settings.owner-account',
        sidebarMeta: {
          order: 15
        }
      }).state('account-settings.edit-owner', {
        url: '/edit-owner',
        templateUrl: 'app/pages/accountSettings/owner/addOwner.html',
        controller: 'ownerCtrl as vm',
        title: 'Edit Owner',
        sidebarMeta: {
          order: 16,
        },
      }).state('account-settings.sub-owners', {
        url: '/sub-owners',
        templateUrl: 'app/pages/accountSettings/owner/subOwners.html',
        controller:'subOwnerCtrl as vm',
        title: 'Sub Owners Account',
        params: { type: 'subowners_list'},
        prevStateTitle:'Owner Acoount',
        prevState:'account-settings.owner-account',
        sidebarMeta: {
          order: 17,
        },
      }).state('account-settings.add-sub-owner', {
        url: '/add-sub-owner',
        templateUrl: 'app/pages/accountSettings/owner/addSubOwner.html',
        controller: 'subOwnerCtrl as vm',
        title: 'Add Sub Owner Account',
        prevStateTitle:'Sub Owners Acoount',
        prevState:'account-settings.sub-owners',
        sidebarMeta: {
          order: 18
        }
      }).state('account-settings.edit-sub-owner', {
        url: '/edit-sub-owner',
        templateUrl: 'app/pages/accountSettings/owner/addSubOwner.html',
        controller: 'subOwnerCtrl as vm',
        title: 'Edit Sub Owner Account',
        prevStateTitle:'Sub Owners Acoount',
        prevState:'account-settings.sub-owners',
        sidebarMeta: {
          order: 19,
        },
      }).state('account-settings.owner-customers', {
        url: '/customers-account',
        templateUrl: 'app/pages/accountSettings/subcustomers/subcustomers.html',
        controller: 'subCustomersCtrl as vm',
        title: 'Sub Owners Acoount',
        permissionKey:'subowners_list_owner',
        sidebarMeta: {
          order: 20,
        },
      }).state('account-settings.add-owner-customer', {
        url: '/add-owner-customer',
        templateUrl: 'app/pages/accountSettings/subcustomers/addCustomer.html',
        controller: 'subCustomersCtrl as vm',
        title: 'Add Sub Owner Account',
        prevStateTitle:'Sub Owners Acoount',
        prevState:'account-settings.owner-customers',
        sidebarMeta: {
          order: 21
        }
      }).state('account-settings.edit-owner-customer', {
        url: '/edit-owner-customer',
        templateUrl: 'app/pages/accountSettings/subcustomers/addCustomer.html',
        controller: 'subCustomersCtrl as vm',
        title: 'Edit Sub Owner Account',
        prevStateTitle:'Sub Owners Acoount',
        prevState:'account-settings.owner-customers',
        sidebarMeta: {
          order: 22,
        },
      });
    $urlRouterProvider.when('/account-settings', '/account-settings/sub-admin');
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.databaseMachines', [])
            .config(routeConfig);

    /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('databasemachines', {
        url: '/database-machines',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Database Machines',
        permissionKey:'manage_database_machines',
        nestedPermission:['manage_database_machines','database_machine_slots'],
        sidebarMeta: {
          icon: 'fa fa-industry',
          order: 13,
        },
      }).state('databasemachines.managemachines', {
        url: '/manage-machines',
        templateUrl: 'app/pages/databaseMachines/machines.html',
        controller:'databaseMachinesCtrl as vm',
        title: 'Manage Machines',
        permissionKey:'manage_database_machines',
        sidebarMeta: {
          order: 1,
        }
      }).state('databasemachines.addmachines', {
        url: '/add-machine',
        templateUrl: 'app/pages/databaseMachines/addMachine.html',
        controller: 'databaseMachinesCtrl as vm',
        title: 'Add New Machine',
        prevStateTitle:'Manage Machines',
        prevState:'databasemachines.managemachines',
        sidebarMeta: {
          order:1
        }
      }).state('databasemachines.editmachine', {
        url: '/edit-machine',
        templateUrl: 'app/pages/databaseMachines/addMachine.html',
        controller: 'databaseMachinesCtrl as vm',
        title: 'Edit Machine',
        prevStateTitle:'Manage Machines',
        prevState:'databasemachines.managemachines',
        sidebarMeta: {
          order: 2,
        },
      }).state('databasemachines.machineslots', {
        url: '/machine-slots',
        templateUrl: 'app/pages/databaseMachines/slots.html',
        controller:'machineSlotsCtrl as vm',
        title: 'Machine Slots',
        params: {type: 'database_machine_slots'},
        prevStateTitle:'Manage Machines',
        prevState:'databasemachines.managemachines',
        sidebarMeta: {
          order: 4,
        }
      }).state('databasemachines.addslot', {
        url: '/add-slot',
        templateUrl: 'app/pages/databaseMachines/addSlot.html',
        controller: 'machineSlotsCtrl as vm',
        title: 'Add New Slot',
        prevStateTitle:'Manage Slots',
        prevState:'databasemachines.machineslots',
        sidebarMeta: {
          order:1
        }
      }).state('databasemachines.editslot', {
        url: '/edit-slot',
        templateUrl: 'app/pages/databaseMachines/addSlot.html',
        controller: 'machineSlotsCtrl as vm',
        title: 'Edit Slot',
        prevStateTitle:'Manage Slots',
        prevState:'databasemachines.machineslots',
        sidebarMeta: {
          order: 2,
        },
      }).state('databasemachines.databasejobs', {
        url: '/database-jobs',
        templateUrl: 'app/pages/databaseMachines/databaseJobs/databasejobs.html',
        controller:'databaseJobsCtrl as vm',
        title: 'Database Jobs',
        permissionKey:'manage_database_jobs',
        sidebarMeta: {
          order: 1,
        }
      });
      $urlRouterProvider.when('/database-machines', '/database-machines/manage-machines');
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.document', [])
            .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
                .state('documents', {
                    url: '/documents',
                    templateUrl: 'app/pages/document/document.html',
                    controller: 'documentCtrl',
                    title: 'Documents',
                    permissionKey:'document_view',
                    sidebarMeta: {
                        order: 6,
                        icon: 'fa fa-file'
                    },

                })
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dubaiMachines', [])
            .config(routeConfig);

    /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('dubaimachines', {
        url: '/dubai-machines',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Dubai Machines',
        permissionKey:'manage_dubai_machines',
        nestedPermission:['manage_dubai_machines','dubai_machine_slots','manage_database_jobs'],
        sidebarMeta: {
          icon: 'fa fa-industry',
          order: 13,
        },
      }).state('dubaimachines.managemachines', {
        url: '/manage-machines',
        templateUrl: 'app/pages/dubaiMachines/machines.html',
        controller:'dubaiMachinesCtrl as vm',
        title: 'Manage Machines',
        permissionKey:'manage_dubai_machines',
        sidebarMeta: {
          order: 1,
        }
      }).state('dubaimachines.addmachines', {
        url: '/add-machine',
        templateUrl: 'app/pages/dubaiMachines/addMachine.html',
        controller: 'dubaiMachinesCtrl as vm',
        title: 'Add New Machine',
        prevStateTitle:'Manage Machines',
        prevState:'dubaimachines.managemachines',
        sidebarMeta: {
          order:1
        }
      }).state('dubaimachines.editmachine', {
        url: '/edit-machine',
        templateUrl: 'app/pages/dubaiMachines/addMachine.html',
        controller: 'dubaiMachinesCtrl as vm',
        title: 'Edit Machine',
        prevStateTitle:'Manage Machines',
        prevState:'dubaimachines.managemachines',
        sidebarMeta: {
          order: 2,
        },
      }).state('dubaimachines.machineslots', {
        url: '/machine-slots',
        templateUrl: 'app/pages/dubaiMachines/slots.html',
        controller:'machineSlotsCtrl as vm',
        title: 'Machine Slots',
        params: {type: 'dubai_machine_slots'},
        prevStateTitle:'Manage Machines',
        prevState:'dubaimachines.managemachines',
        sidebarMeta: {
          order: 4,
        }
      }).state('dubaimachines.addslot', {
        url: '/add-slot',
        templateUrl: 'app/pages/dubaiMachines/addSlot.html',
        controller: 'machineSlotsCtrl as vm',
        title: 'Add New Slot',
        prevStateTitle:'Manage Slots',
        prevState:'dubaimachines.machineslots',
        sidebarMeta: {
          order:1
        }
      }).state('dubaimachines.editslot', {
        url: '/edit-slot',
        templateUrl: 'app/pages/dubaiMachines/addSlot.html',
        controller: 'machineSlotsCtrl as vm',
        title: 'Edit Slot',
        prevStateTitle:'Manage Slots',
        prevState:'dubaimachines.machineslots',
        sidebarMeta: {
          order: 2,
        },
      }).state('dubaimachines.dubaijobs', {
        url: '/dubai-jobs',
        templateUrl: 'app/pages/dubaiMachines/dubaiJobs/dubaijobs.html',
        controller:'dubaiJobsCtrl as vm',
        title: 'Dubai Jobs',
        permissionKey:'manage_database_jobs',
        sidebarMeta: {
          order: 1,
        }
      });
      $urlRouterProvider.when('/dubai-machines', '/dubai-machines/manage-machines');
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.faqFrontend', ['ngSanitize'])
            .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
                .state('faq-frontend', {
                    url: '/faq-frontend',
                    templateUrl: 'app/pages/faqFrontend/faqFrontend.html',
                    controller: 'faqFrontendCtrl as vm',
                    title: 'FAQ',
                    permissionKey:'faq_frontend_list',
                    sidebarMeta: {
                        order: 5,
                        icon: 'fa fa-question-circle'
                    },

                })
    }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.inventoryManagement', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('inventorymanagement', {
        url: '/inventory-management',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Manage Inventory',
        permissionKey:'inventorymanagement',
        nestedPermission:['inventorymanagement','warehouse','inventory_products','inventory_settings'],
        sidebarMeta: {
          icon: 'fa fa-cogs',
          order: 13,
        },
      })
     .state('inventorymanagement.warehouse', {
        url: '/warehouse',
        templateUrl: 'app/pages/inventoryManagement/wareHouse/warehouse.html',
        controller:'wareHouseCtrl as wh',
        title: 'Manage Warehouse',
        permissionKey:'warehouse',
        sidebarMeta: {
          order: 1,
        }
      }).state('inventorymanagement.add-warehouse', {
        url: '/add-warehouse',
        templateUrl: 'app/pages/inventoryManagement/wareHouse/addWarehouse.html',
        controller: 'wareHouseCtrl',
        title: 'Add Warehouse',
        prevStateTitle:'Manage Warehouse',
        prevState:'inventorymanagement.warehouse',
        sidebarMeta: {
          order:1
        }
      }).state('inventorymanagement.edit-warehouse', {
        url: '/edit-account',
        templateUrl: 'app/pages/inventoryManagement/wareHouse/addWarehouse.html',
        controller: 'wareHouseCtrl',
        title: 'Edit WareHouse',
        prevStateTitle:'Manage WareHouse',
        prevState:'inventorymanagement.warehouse',
        sidebarMeta: {
          order: 2,
        },
      }).state('inventorymanagement.warehouse-products', {
        url: '/warehouse-products',
        templateUrl: 'app/pages/inventoryManagement/wareHouse/warehouseProducts.html',
        controller:'wareHouseProductsCtrl as whps',
        title: 'WareHouse Products',
        params: {type: 'warehouse_products'},
        prevStateTitle:'Manage WareHouse',
        prevState:'inventorymanagement.warehouse',
        sidebarMeta: {
          order: 3,
        },
      }).state('inventorymanagement.productallocation', {
        url: '/product-allocation',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/productAllocation.html',
        controller: 'productAllocationCtrl as ip',
        title: 'Product Allocation',
        prevStateTitle:'WareHouse Products',
        prevState:'inventorymanagement.warehouse-products',
        sidebarMeta: {
          order: 4,
        },
      }).state('inventorymanagement.invntoryproducts', {
        url: '/inventory-products',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/products.html',
        controller:'inventoryProductsCtrl as ip',
        title: 'Inventory Products',
        permissionKey:'inventory_products',
        sidebarMeta: {
          order: 2,
        }
      }).state('inventorymanagement.addproduct', {
        url: '/add-inventory-product',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/addProduct.html',
        controller: 'inventoryProductsCtrl as ip',
        title: 'Add New Product',
        prevStateTitle:'Inventory Products',
        prevState:'inventorymanagement.invntoryproducts',
        sidebarMeta: {
          order:1
        }
      }).state('inventorymanagement.editproduct', {
        url: '/edit-inventory-product',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/addProduct.html',
        controller: 'inventoryProductsCtrl as ip',
        title: 'Edit Product',
        prevStateTitle:'Inventory Products',
        prevState:'inventorymanagement.invntoryproducts',
        sidebarMeta: {
          order: 2,
        },
      }).state('inventorymanagement.product-allocation', {
        url: '/product-allocation-log',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/allocationLog.html',
        controller: 'productAllocationCtrl',
        title: 'Product Allocation Log',
        prevStateTitle:'Manage Products',
        prevState:'inventorymanagement.invntoryproducts',
        sidebarMeta: {
          order:3
        },
      }).state('inventorymanagement.product-allocation-remove', {
        url: '/product-allocation-remove',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/allocationRemoveLog.html',
        controller: 'productRemoveAllocationCtrl',
        title: 'Product Remove Allocation Log',
        prevStateTitle:'Manage Products',
        prevState:'inventorymanagement.invntoryproducts',
        sidebarMeta: {
          order:4
        },
      }).state('inventorymanagement.product-warehouses', {
        url: '/product-warehouses',
        templateUrl: 'app/pages/inventoryManagement/inventoryProducts/warehouseProducts.html',
        controller:'productWarehousesCtrl as prwh',
        title: 'WareHouse Products',
        params: {type: 'product_warehouses'},
        prevStateTitle:'Manage Products',
        prevState:'inventorymanagement.invntoryproducts',
        sidebarMeta: {
          order: 4,
        }
      }).state('inventorymanagement.inventory-settings', {
        url: '/inventory-settings',
        templateUrl: 'app/pages/inventoryManagement/inventorySettings/inventorysettings.html',
        controller:'inventorySettingsCtrl as vm',
        title: 'Inventory Settings',
        permissionKey:'inventory_settings',
        sidebarMeta: {
          order: 3,
        }
      });
      $urlRouterProvider.when('/inventory-management', '/inventory-management/warehouse');
    }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.login', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('login', {
          url: '/login',
          templateUrl: 'app/pages/login/login.html',
          controller: 'loginCtrl',
          title: 'Login',
//          skipToShow:true,
          blank: true
//          sidebarMeta: {
//            order: 800,
//          },
        });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.machineDashboard', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('machine-dashboard', {
        url: '/machine-dashboard',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Machine Dashboard',
        permissionKey:'machine_dashboard',
        nestedPermission:['machine_dashboard_dashboard','machine_dashboard_settings'],
        sidebarMeta: {
          icon: 'fa fa-industry',
          order: 14,
        },
      }).state('machine-dashboard.settings', {
        url: '/settings',
        templateUrl: 'app/pages/machineDashboard/settings/machineDashboardSettings.html',
        controller:'machineDashboardSettingsCtrl as stc',
        title: 'Dashboard Settings',
        permissionKey:'machine_dashboard_settings',
        prevStateTitle:'Machine Dashboard',
        prevState:'machine-dashboard.dashboard',
        sidebarMeta: {
          order: 0,
        },
      }).state('machine-dashboard.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/machineDashboard/dashboard/machineDashboard.html',
        controller:'machineDashboardCtrl as vm',
        title: 'Machine Dashboard',
        permissionKey:'machine_dashboard_dashboard',
        sidebarMeta: {
          order: 1,
        },
      })
    $urlRouterProvider.when('/machine-dashboard', '/machine-dashboard/dashboard');
  }

})();

(function () {
  'use strict';

  var bapp = angular.module('BlurAdmin.pages.orders', ['ui.select','ngSanitize'])
      .config(routeConfig);
    bapp.directive('limitSelect', function (){
      return {
        restrict: 'EA',
        require: 'uiSelect',
        link: function($scope, $element, $attributes, ctrl) {
            $scope.$select.limit =  2;
            var superSelect = ctrl.select;
            ctrl.select = function() {
                if(ctrl.multiple && ctrl.limit !== undefined && ctrl.selected.length >= ctrl.limit) {
//                    console.log("booooo");
                } else {
                    superSelect.apply(ctrl, arguments);
                }
            };
        }
      }
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('orders', {
          url: '/orders',
          templateUrl: 'app/pages/orders/orders.html',
          controller: 'ordersCtrl',
          title: 'Manage Orders',
          params: {type: 'allOrders'},
          permissionKey:'orders_list',
          sidebarMeta: {
            order: 1,
            icon: 'fa fa-shopping-cart',
          },
        })
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.productList',[])
  .provider('router', function ($stateProvider) {
      this.$get = function ($http, $state) {
          return {
              setUpRoutes: function () {
                   var jsonMenu = localStorage.getItem('blockList')?JSON.parse(localStorage.getItem('blockList')):[];
                  //$http.get('http://192.168.11.35/advancetracker/public/api/v1/products/block').success(function (jsonMenu) {
                  angular.forEach(jsonMenu, function (routeName,key){
                          if (!$state.get('product-list.'+routeName.name)) {
                              $stateProvider.state('product-list.'+routeName.name, {
                                "url": '/'+routeName.name,
                                "params" : {block_type: routeName.name},
                                "templateUrl": "app/pages/productList/resave/resave.html",
                                "permissionKey":"product-block-"+routeName.name,
                                "controller":"resaveCtrl as vm",
                                "title": routeName.name,
                                "sidebarMeta": {
                                  "order": key+2
                                }
                              });
                          }
                      });
                  //  });
              }
          }
      };
  })

  .run(function (router) {
      router.setUpRoutes();
  })
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('product-list', {
        url: '/product-list',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Product List',
        permissionKey:'product_list_menu',
        nestedPermission:['product_block_type_setting'],
        sidebarMeta: {
          icon: 'fa fa-stop',
          order: 10,
        },
      })

      .state('product-list.block-list', {
        url: '/product-list',
        templateUrl: 'app/pages/productList/blockTypeSetting/blockTypeSetting.html',
        controller: 'productBlockCtrl',
        title: 'Block Type Setting',
        blank: true,
        permissionKey:'product_block_type_setting',
        sidebarMeta: {
          order: 0,
        },
      }).state('product-list.add-product-block', {
        url: '/add-product-block',
        templateUrl: 'app/pages/productList/blockTypeSetting/addBlock.html',
        controller: 'productBlockCtrl as vm',
        title: 'Add Block',
        prevStateTitle:'Block Type Setting',
        prevState:'product-list.block-list',
        sidebarMeta: {
          order: 1,
        },
      }).state('product-list.edit-product-block', {
        url: '/edit-product-block',
        templateUrl: 'app/pages/productList/blockTypeSetting/addBlock.html',
        controller: 'productBlockCtrl as vm',
        title: 'Edit Product Block',
        prevStateTitle:'Block Type Setting',
        prevState:'product-list.block-list',
        sidebarMeta: {
          order: 2,
        },
      }).state('product-list.product-block-status', {
        url: '/product-block-status',
        templateUrl: 'app/pages/productList/blockTypeSetting/productBlockStatus.html',
        controller: 'productBlockCtrl',
        title: 'Block Status',
        prevStateTitle:'Block Type Setting',
        prevState:'product-list.block-list'
      });
    $urlRouterProvider.when('/product-list', '/product-list/group-list');
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
    .state('profile', {
        url: '/profile',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Profile'
      }).state('profile.view-profile', {
          url: '/view-profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        }).state('profile.view-customer-credit-report-profile', {
        url: '/view-customer-credit-report-profile',
        templateUrl: 'app/pages/profile/storeCreditReport.html',
        controller:'storeCreditReportCtrl as scr',
        title: 'View Customer Credit',
        params: {type: 'profile_customer_credit_report'},
        prevStateTitle:'Profile',
        prevState:'profile.view-profile',
        sidebarMeta: {
          order: 1,
        },
      }).state('profile.view-owner-credit-report-profile', {
        url: '/view-owner-credit-report-profile',
        templateUrl: 'app/pages/profile/ownerStoreCreditReport.html',
        controller:'ownerStoreCreditReportCtrl as scr',
        title: 'View Owner Credit',
        params: {type: 'profile_owner_credit_report'},
        prevStateTitle:'Profile',
        prevState:'profile.view-profile',
        sidebarMeta: {
          order: 2,
        },
      });
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.relaySettings',[])
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('relay-settings', {
        url: '/relay-settings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Relay Settings',
        permissionKey:'relay',
        nestedPermission:['group_list','relay_settings','relay_status_list','webhook_settings', 'show_relay_priority_setting','show_relay_setting_order_types'],
        sidebarMeta: {
          icon: 'fa fa-code-fork',
          order: 9,
        },
      }).state('relay-settings.group-list', {
        url: '/group-list',
        templateUrl: 'app/pages/relaySettings/group/group.html',
        controller: 'groupCtrl as vm',
        title: 'Group List',
        permissionKey:'group_list',
        sidebarMeta: {
          order: 0
        }
      }).state('relay-settings.add-group', {
        url: '/add-group',
        templateUrl: 'app/pages/relaySettings/group/addGroup.html',
        controller: 'groupCtrl as vm',
        prevStateTitle:'Group List',
        prevState:'relay-settings.group-list',
        title: 'Add Group',
        sidebarMeta: {
          order: 1
        }
      }).state('relay-settings.edit-group', {
        url: '/edit-group',
        templateUrl: 'app/pages/relaySettings/group/addGroup.html',
        controller: 'groupCtrl as vm',
        title: 'Edit Group',
        prevStateTitle:'Group List',
        prevState:'relay-settings.group-list',
        sidebarMeta: {
          order: 2
        }
      }).state('relay-settings.relay', {
        url: '/relay',
        templateUrl: 'app/pages/relaySettings/relay/relay.html',
        controller: 'relayCtrl as vm',
        title: 'Relay',
        permissionKey:'relay_settings',
        sidebarMeta: {
          order: 3
        }
      }).state('relay-settings.relay-status', {
        url: '/relay-status',
        templateUrl: 'app/pages/relaySettings/relayStatus/relayStatus.html',
        controller: 'relayStatusCtrl as vm',
        title: 'Relay Status',
        permissionKey:'relay_status_list',
        sidebarMeta: {
          order: 4
        }
      }).state('relay-settings.add-relay-status', {
        url: '/add-relay-status',
        templateUrl: 'app/pages/relaySettings/relayStatus/addRelayStatus.html',
        controller: 'relayStatusCtrl as vm',
        title: 'Add Relay Status',
        prevStateTitle:'Relay Status',
        prevState:'relay-settings.relay-status',
        sidebarMeta: {
          order: 5
        }
      }).state('relay-settings.edit-relay-status', {
        url: '/edit-relay-status',
        templateUrl: 'app/pages/relaySettings/relayStatus/addRelayStatus.html',
        controller: 'relayStatusCtrl as vm',
        title: 'Edit Relay Status',
        prevStateTitle:'Relay Status',
        prevState:'relay-settings.relay-status',
        sidebarMeta: {
          order: 6
        }
      }).state('relay-settings.webhook', {
        url: '/webhook',
        templateUrl: 'app/pages/relaySettings/webhook/webhook.html',
        controller: 'webhookCtrl as vm',
        title: 'Webhook',
        permissionKey:'webhook_settings',
        sidebarMeta: {
          order: 7
        }
      }).state('relay-settings.priority-list', {
        url: '/priority-list',
        templateUrl: 'app/pages/relaySettings/priority/priority.html',
        controller: 'priorityCtrl as vm',
        title: 'Priority',
        permissionKey:'show_relay_priority_setting',
        sidebarMeta: {
          order: 8
        }
      }).state('relay-settings.add-priority', {
        url: '/add-priority',
        templateUrl: 'app/pages/relaySettings/priority/addPriority.html',
        controller: 'priorityCtrl as vm',
        prevStateTitle:'Priority List',
        prevState:'relay-settings.priority-list',
        title: 'Add priority',
        sidebarMeta: {
          order: 9
        }
      }).state('relay-settings.edit-priority', {
        url: '/edit-priority',
        templateUrl: 'app/pages/relaySettings/priority/addPriority.html',
        controller: 'priorityCtrl as vm',
        title: 'Edit priority',
        prevStateTitle:'Priority List',
        prevState:'relay-settings.priority-list',
        sidebarMeta: {
          order: 10
        }
      }).state('relay-settings.order-type-list', {
        url: '/order-type-list',
        templateUrl: 'app/pages/relaySettings/orderTypes/ordertypes.html',
        controller: 'orderTypesCtrl as vm',
        title: 'Order Types',
        permissionKey:'show_relay_setting_order_types',
        sidebarMeta: {
          order: 11
        }
      }).state('relay-settings.add-order-type', {
        url: '/add-order-type',
        templateUrl: 'app/pages/relaySettings/orderTypes/addOrderType.html',
        controller: 'orderTypesCtrl as vm',
        prevStateTitle:'Order Types',
        prevState:'relay-settings.order-type-list',
        title: 'Add Order Type',
        sidebarMeta: {
          order: 12
        }
      }).state('relay-settings.edit-order-type', {
        url: '/edit-order-type',
        templateUrl: 'app/pages/relaySettings/orderTypes/addOrderType.html',
        controller: 'orderTypesCtrl as vm',
        title: 'Edit Order Type',
        prevStateTitle:'Order Types',
        prevState:'relay-settings.order-type-list',
        sidebarMeta: {
          order: 13
        }
      });
    $urlRouterProvider.when('/relay-settings', '/relay-settings/group-list');
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('reports', {
        url: '/reports',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Reports',
        permissionKey:'report',
        nestedPermission:['report_dashboard_view','report_settings','sales_report','design_report','design_report_3d','shipment_box_report','qa_approved_report','rework_report','damage_report','addon_report','store_credit_report','printed_crystal_report','file_raw_material_report','orders_sales_lst','inventory_report','stock_report','shipping_count_report','order_assembly_report'],
        sidebarMeta: {
          icon: 'fa fa-bar-chart',
          order: 4,
        },
      }).state('reports.report-settings', {
        url: '/report-settings',
        templateUrl: 'app/pages/reports/reportSettings/tabs.html',
        controller:'tabsCtrl as vm',
        title: 'Report Settings',
        permissionKey:'report_settings',
        sidebarMeta: {
          order: 0,
        },
      }).state('reports.add-tab', {
        url: '/add-tab',
        templateUrl: 'app/pages/reports/reportSettings/addTab.html',
        controller:'tabsCtrl as vm',
        title: 'Add Tab',
        prevStateTitle:'Report Settings',
        prevState:'reports.report-settings',
        sidebarMeta: {
          order: 1,
        },
      }).state('reports.edit-tab', {
        url: '/edit-tab',
        templateUrl: 'app/pages/reports/reportSettings/addTab.html',
        controller:'tabsCtrl as vm',
        title: 'Edit Tab',
        prevStateTitle:'Report Settings',
        prevState:'reports.report-settings',
        sidebarMeta: {
          order: 2,
        },
      }).state('reports.assign-product', {
        url: '/assign-product',
        templateUrl: 'app/pages/reports/reportSettings/assignProduct.html',
        controller:'tabsCtrl as vm',
        title: 'Assign Product',
        prevStateTitle:'Report Settings',
        prevState:'reports.report-settings',
        sidebarMeta: {
          order: 4,
        },
      }).state('reports.report-dashboard', {
        url: '/report-dashboard',
        templateUrl: 'app/pages/reports/reportDashboard/reportDashboard.html',
        controller:'reportDashboardCtrl as rpc',
        title: 'Report Dashboard',
        permissionKey:'report_dashboard_view',
        sidebarMeta: {
          order: 8,
        },
      }).state('reports.design-report', {
        url: '/design-report',
        templateUrl: 'app/pages/reports/designReport/designReport.html',
        controller:'designReportCtrl as drc',
        title: 'Design Report',
        permissionKey:'design_report',
        sidebarMeta: {
          order: 9,
        },
      }).state('reports.design-report-3d', {
        url: '/design-report-3d',
        templateUrl: 'app/pages/reports/designReport3D/designReport3D.html',
        controller:'designReport3DCtrl as drc',
        title: '3D Design Report',
        permissionKey:'design_report_3d',
        sidebarMeta: {
          order: 9,
        },
      }).state('reports.sales-report', {
        url: '/sales-report',
        templateUrl: 'app/pages/reports/salesReport/salesReport.html',
        controller:'salesReportCtrl as src',
        title: 'Product Sales Report',
        permissionKey:'sales_report',
        sidebarMeta: {
          order: 10,
        },
      }).state('reports.orders-sales-report', {
        url: '/orders-report',
        templateUrl: 'app/pages/reports/ordersReport/ordersReport.html',
        controller:'ordersReportCtrl as src',
        title: 'Order Sales Report',
        permissionKey:'orders_sales_lst',
        sidebarMeta: {
          order: 11,
        },
      }).state('reports.shipment-report', {
        url: '/shipment-report',
        templateUrl: 'app/pages/reports/shipmentReport/shipmentReport.html',
        controller:'shipmentReportCtrl as sr',
        title: 'Shipment Report',
        permissionKey:'shipment_report',
        sidebarMeta: {
          order: 12,
        },
      }).state('reports.shipment-report2', {
        url: '/shipment-report2',
        templateUrl: 'app/pages/reports/shipmentReport2/shipmentReport2.html',
        controller:'shipmentReport2Ctrl as sr2',
        title: 'Shipment Report 2',
        permissionKey:'shipment_report',
        sidebarMeta: {
          order: 12.5,
        },
      }).state('reports.shipment-report-dashboard', {
        url: '/shipment-report-dashboard',
        templateUrl: 'app/pages/reports/shipmentReportDashboard/reportDashboard.html',
        controller:'shipmentReportDashboardCtrl as rpc',
        title: 'Shipment Dashboard',
        permissionKey:'shipment_report_dashboard_view',
        sidebarMeta: {
          order: 13,
        },
      }).state('reports.damage-report', {
        url: '/damage-report',
        templateUrl: 'app/pages/reports/damageReport/damageReport.html',
        controller:'damageReportCtrl as dmrc',
        title: 'Damage Report',
        permissionKey:'damage_report',
        sidebarMeta: {
          order: 14,
        },
      }).state('reports.rework-report', {
        url: '/rework-report',
        templateUrl: 'app/pages/reports/reworkReport/reworkReport.html',
        controller:'reworkReportCtrl as rrc',
        title: 'Rework Report',
        permissionKey:'rework_report',
        sidebarMeta: {
          order: 15,
        },
      }).state('reports.addon-report', {
        url: '/addon-report',
        templateUrl: 'app/pages/reports/addOnReport/addOnReport.html',
        controller:'addOnReportCtrl as aorc',
        title: 'Add-On Report',
        permissionKey:'addon_report',
        sidebarMeta: {
          order: 16,
        },
      }).state('reports.qa-approved-report', {
        url: '/qa-approved-report',
        templateUrl: 'app/pages/reports/qaApprovedReport/qaApprovedReport.html',
        controller:'qaApprovedReportCtrl as qrc',
        title: 'QA Approved',
        permissionKey:'qa_approved_report',
        sidebarMeta: {
          order: 17,
        },
      })
      .state('reports.relay-report', {
        url: '/relay-report',
        templateUrl: 'app/pages/reports/relayReport/relayReport.html',
        controller:'relayReportCtrl as vm',
        title: 'Relay Report',
        permissionKey:'relay_report',
        sidebarMeta: {
          order: 18,
        },
      }).state('reports.store-credit-report', {
        url: '/store-credit-report',
        templateUrl: 'app/pages/reports/storeCreditReport/storeCreditReport.html',
        controller:'storeCreditReportCtrl as scr',
        title: 'Store Credit Report',
        permissionKey:'store_credit_report',
        sidebarMeta: {
          order: 19,
        },
      }).state('reports.printed-crystal-report', {
        url: '/printed-crystal-report',
        templateUrl: 'app/pages/reports/printedCrystalReport/printedCrystalReport.html',
        controller:'printedCrystalReportCtrl as vm',
        title: 'Printed Crystal',
        permissionKey:'printed_crystal_report',
        sidebarMeta: {
          order: 20,
        },
      }).state('reports.file-raw-material-report', {
        url: '/file-raw-material-report',
        templateUrl: 'app/pages/reports/fileRawMaterialReport/fileRawMaterialReport.html',
        controller:'fileRawMaterialReportCtrl as vm',
        title: 'File/Raw Material',
        permissionKey:'file_raw_material_report',
        sidebarMeta: {
          order: 21,
        },
      }).state('reports.inventory-report', {
        url: '/inventory-report',
        templateUrl: 'app/pages/reports/inventoryReport/inventoryReport.html',
        controller:'invetoryReportCtrl as invr',
        title: 'Inventory Report',
        permissionKey:'inventory_report',
        sidebarMeta: {
          order: 22,
        },
      }).state('reports.stock-report', {
        url: '/stock-report',
        templateUrl: 'app/pages/reports/stockReport/stockReport.html',
        controller:'stockReportCtrl as vm',
        title: 'Stock Report',
        permissionKey:'stock_report',
        sidebarMeta: {
          order: 23,
        },
      }).state('reports.product-sold-report', {
        url: '/product-sold-report',
        templateUrl: 'app/pages/reports/productSoldReport/productSoldReport.html',
        controller:'productSoldReportCtrl as psr',
        title: 'Product Sold Report',
        permissionKey:'product_sold_report',
        sidebarMeta: {
          order: 25,
        },
      }).state('reports.shipping-count-report', {
        url: '/shipping-count-report',
        templateUrl: 'app/pages/reports/shippingCountReport/shippingCountReport.html',
        controller:'shippingCountReportCtrl as scr',
        title: 'Shipment Count Report',
        permissionKey:'shipping_count_report',
        sidebarMeta: {
          order: 26,
        },
      }).state('reports.shipment-box-count-report', {
        url: '/shipment-box-count-report',
        templateUrl: 'app/pages/reports/shipmentBoxCountReport/shipmentBoxCountReport.html',
        controller:'shipmentBoxCountReportCtrl as vm',
        title: 'Shipment Box Count Report',
        permissionKey:'shipment_box_count_report',
        sidebarMeta: {
          order: 27,
        },
      }).state('reports.shipment-box-report', {
        url: '/shipment-box-report',
        templateUrl: 'app/pages/reports/shipmentBoxReport/shipmentBoxReport.html',
        controller:'shipmentBoxReportCtrl as vm',
        title: 'Shipment Box Report',
        permissionKey:'shipment_box_report',
        sidebarMeta: {
          order: 29,
        },
      }).state('reports.order-assembly-report', {
        url: '/order-assembly-report',
        templateUrl: 'app/pages/reports/orderAssemblyReport/orderAssemblyReport.html',
        controller:'orderAssemblyReportCtrl as vm',
        title: 'Order Assembly Report',
        permissionKey:'order_assembly_report',
        sidebarMeta: {
          order: 30,
        },
      }).state('reports.figurine-cost-report', {
        url: '/figurine-cost-report',
        templateUrl: 'app/pages/reports/figurineCostReport/figurineCostReport.html',
        controller:'figurineCostReportCtrl as fcr',
        title: 'Figurine Cost Report',
        permissionKey:'figurine_cost_report',
        sidebarMeta: {
          order: 31,
        },
      });
     $urlRouterProvider.when('/reports', '/reports/design-report');

  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shipSettings', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('shipsettings', {
        url: '/ship-settings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Shipment Settings',
        permissionKey:'shipsettings',
        nestedPermission:['shipment_settings','shipment_manage_accounts','shipment_manage_boxes','shipment_service_boxes','shipment_manage_service_types'],
        sidebarMeta: {
          icon: 'fa fa-cogs',
          order: 12,
        },
      })
      .state('shipsettings.shipment-settings', {
        url: '/ship-settings/shipment-setting',
        templateUrl: 'app/pages/shipSettings/shipmentSettings/shipmentsettings.html',
        controller:'shipmentSettingsCtrl as ss',
        title: 'Shipment Settings',
        permissionKey:'shipment_settings',
        sidebarMeta: {
          order: 0,
        }
      }).state('shipsettings.manage-accounts', {
        url: '/manage-accounts',
        templateUrl: 'app/pages/shipSettings/manageAccounts/manageaccounts.html',
        controller:'manageAccountsCtrl as ma',
        title: 'Manage Accounts',
        permissionKey:'shipment_manage_accounts',
        sidebarMeta: {
          order: 1,
        }
      }).state('shipsettings.add-account', {
        url: '/add-account',
        templateUrl: 'app/pages/shipSettings/manageAccounts/addAccount.html',
        controller: 'manageAccountsCtrl',
        title: 'Add Account',
        prevStateTitle:'Manage Accounts',
        prevState:'shipsettings.manage-accounts',
        sidebarMeta: {
          order:1
        }
      })
      .state('shipsettings.edit-account', {
        url: '/edit-account',
        templateUrl: 'app/pages/shipSettings/manageAccounts/addAccount.html',
        controller: 'manageAccountsCtrl',
        title: 'Edit Account',
        prevStateTitle:'Manage Accounts',
        prevState:'shipsettings.manage-accounts',
        sidebarMeta: {
          order: 2,
        },
      }).state('shipsettings.manage-boxes', {
        url: '/manage-boxes',
        templateUrl: 'app/pages/shipSettings/manageBoxes/manageboxes.html',
        controller:'shipmentBoxesCtrl as mb',
        title: 'Manage Boxes',
        permissionKey:'shipment_manage_boxes',
        sidebarMeta: {
          order: 4,
        }
      }).state('shipsettings.add-box', {
        url: '/add-box',
        templateUrl: 'app/pages/shipSettings/manageBoxes/addBox.html',
        controller: 'shipmentBoxesCtrl',
        title: 'Add Shipment Box',
        prevStateTitle:'Manage Boxes',
        prevState:'shipsettings.manage-boxes',
        sidebarMeta: {
          order:1
        }
      }).state('shipsettings.edit-box', {
        url: '/edit-box',
        templateUrl: 'app/pages/shipSettings/manageBoxes/addBox.html',
        controller: 'shipmentBoxesCtrl',
        title: 'Edit Box',
        prevStateTitle:'Manage Box',
        prevState:'shipsettings.manage-boxes',
        sidebarMeta: {
          order: 2,
        },
      }).state('shipsettings.manage-service-boxes', {
        url: '/manage-service-boxes',
        templateUrl: 'app/pages/shipSettings/manageServiceBoxes/serviceboxes.html',
        controller:'serviceBoxesCtrl as sb',
        title: 'Manage Service Boxes',
        permissionKey:'shipment_service_boxes',
        sidebarMeta: {
          order: 5,
        }
      }).state('shipsettings.add-service-box', {
        url: '/add-service-box',
        templateUrl: 'app/pages/shipSettings/manageServiceBoxes/addServiceBox.html',
        controller: 'serviceBoxesCtrl as sb',
        title: 'Add Service Box',
        prevStateTitle:'Manage Service Boxes',
        prevState:'shipsettings.manage-service-boxes',
        sidebarMeta: {
          order:1
        }
      }).state('shipsettings.edit-service-box', {
        url: '/edit-service-box',
        templateUrl: 'app/pages/shipSettings/manageServiceBoxes/addServiceBox.html',
        controller: 'serviceBoxesCtrl as sb',
        title: 'Edit Service Box',
        prevStateTitle:'Manage Service Boxes',
        prevState:'shipsettings.manage-service-boxes',
        sidebarMeta: {
          order: 2,
        },
      }).state('shipsettings.manage-service-types', {
        url: '/manage-service-types',
        templateUrl: 'app/pages/shipSettings/manageServiceTypes/manageservicetypes.html',
        controller:'manageServiceTypesCtrl as mst',
        title: 'Service Types',
        permissionKey:'shipment_manage_service_types',
        sidebarMeta: {
          order: 6,
        }
      }).state('shipsettings.edit-type', {
        url: '/edit-type',
        templateUrl: 'app/pages/shipSettings/manageServiceTypes/addType.html',
        controller: 'manageServiceTypesCtrl',
        title: 'Edit Service Type',
        prevStateTitle:'Service Types',
        prevState:'shipsettings.manage-service-types',
        sidebarMeta: {
          order: 1,
        },
      });
      $urlRouterProvider.when('/ship-settings', '/ship-settings/shipment-setting');
    }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings', ['ngSanitize','color.picker'])
    .config(routeConfig);
  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider){
    $stateProvider
      .state('settings',{
        url: '/settings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Settings',
        permissionKey:'app_settings',
        nestedPermission:['department_list','faq_list','print_label_list','document_setting','orderstatus_list','block_list','settings','report_label_list','order_button_list','category_list','edit_button_settings','button_type_list','product_rule_list','store_list','rework_setting','job_setting','pull_job_setting', 'relay_button_setting', 'product_type', 'pie_chart_setting', 'button_setting', 'damage_setting','preview_setting','database_status_maping','manage_amazon_stores','tracker_status_map','noy_assembly_setting'],
        sidebarMeta: {
          icon: 'fa fa-cog',
          order: 8,
        },
      }).state('settings.departments', {
        url: '/departments',
        templateUrl: 'app/pages/settings/departments/departments.html',
        controller: 'departmentsCtrl',
        title: 'Departments',
        blank: true,
        permissionKey:'department_list',
        sidebarMeta: {
          order: 0,
        },
      }).state('settings.add-department', {
        url: '/add-department',
        templateUrl: 'app/pages/settings/departments/addDepartment.html',
        controller: 'departmentsCtrl',
        title: 'Add Department',
        prevStateTitle:'Departments',
        prevState:'settings.departments',
        sidebarMeta: {
          order: 1,
        },
      }).state('settings.edit-department', {
        url: '/edit-department',
        templateUrl: 'app/pages/settings/departments/addDepartment.html',
        controller: 'departmentsCtrl',
        title: 'Edit Department',
        prevStateTitle:'Departments',
        prevState:'settings.departments',
        sidebarMeta: {
          order: 2,
        },
      }).state('settings.departments-status', {
        url: '/departments-status',
        templateUrl: 'app/pages/settings/departments/departmentStatus.html',
        controller: 'departmentsCtrl',
        title: 'Departments Status',
        prevStateTitle:'Departments',
        prevState:'settings.departments'
      }).state('settings.faq', {
          url: '/faq',
          templateUrl: 'app/pages/settings/faq/faq.html',
          controller: 'faqCtrl as vm',
          title: 'Manage FAQ',
          permissionKey:'faq_list',
          sidebarMeta: {
              order: 3,
          },
      })
      .state('settings.add-faq', {
          url: '/add-faq',
          templateUrl: 'app/pages/settings/faq/addFaq.html',
          controller: 'faqCtrl as vm',
          title: 'Add FAQ',
          prevStateTitle:'Manage FAQ',
          prevState:'settings.faq',
          sidebarMeta: {
            order: 4,
          },
      })
      .state('settings.edit-faq', {
          url: '/edit-faq',
          templateUrl: 'app/pages/settings/faq/addFaq.html',
          controller: 'faqCtrl as vm',
          title: 'Edit FAQ',
          prevStateTitle:'Manage FAQ',
          prevState:'settings.faq',
          sidebarMeta: {
            order: 5,
          },
      })
      .state('settings.faq-order', {
          url: '/faq-order',
          templateUrl: 'app/pages/settings/faq/faqOrder.html',
          controller: 'faqCtrl as vm',
          title: 'Manage FAQ Order',
          prevStateTitle:'Manage FAQ',
          prevState:'settings.faq'
      }).state('settings.print-labels', {
        url: '/print-labels',
        templateUrl: 'app/pages/settings/printLabels/printLabels.html',
        controller: 'printLabelsCtrl',
        title: 'Print Labels',
        blank: true,
        permissionKey:'print_label_list',
        sidebarMeta: {
          order: 6,
        },
      }).state('settings.add-print-label', {
        url: '/add-print-label',
        templateUrl: 'app/pages/settings/printLabels/addPrintLabel.html',
        controller: 'printLabelsCtrl',
        title: 'Add Print Label',
        prevStateTitle:'Print Labels',
        prevState:'settings.print-labels',
        sidebarMeta: {
          order: 7,
        },
      }).state('settings.edit-print-label', {
        url: '/edit-print-label',
        templateUrl: 'app/pages/settings/printLabels/addPrintLabel.html',
        controller: 'printLabelsCtrl',
        title: 'Edit Print Label',
        prevStateTitle:'Print Labels',
        prevState:'settings.print-labels',
        sidebarMeta: {
          order: 8,
        },
      }).state('settings.document-setting', {
          url: '/document-setting',
          templateUrl: 'app/pages/settings/documentSetting/documentSetting.html',
          controller: 'documentSettingCtrl',
          title: 'Document Setting',
          permissionKey:'document_setting',
          sidebarMeta: {
              order: 9,
          },
      }).state('settings.order-status', {
        url: '/order-status',
        templateUrl: 'app/pages/settings/orderStatus/orderStatus.html',
        controller: 'orderStatusCtrl',
        title: 'Order Status',
        permissionKey:'orderstatus_list',
        sidebarMeta: {
          order: 10,
        },
      }).state('settings.add-order-status', {
        url: '/add-order-status',
        templateUrl: 'app/pages/settings/orderStatus/addOrderStatus.html',
        controller: 'orderStatusCtrl',
        title: 'Add Order Status',
        prevStateTitle:'Order Status',
        prevState:'settings.order-status',
        sidebarMeta: {
          order: 11,
        },
      }).state('settings.edit-order-status', {
        url: '/edit-order-status',
        templateUrl: 'app/pages/settings/orderStatus/addOrderStatus.html',
        controller: 'orderStatusCtrl',
        title: 'Edit Order Status',
        prevStateTitle:'Order Status',
        prevState:'settings.order-status',
        sidebarMeta: {
          order: 12,
        },
      }).state('settings.order-popup-button', {
        url: '/order-popup-button',
        templateUrl: 'app/pages/settings/orderPopupButtons/orderPopupButtons.html',
        controller: 'orderPopupButtonsCtrl',
        title: 'Order Popup Button',
        permissionKey:'order_button_list',
        sidebarMeta: {
          order: 13,
        },
      }).state('settings.add-order-popup-button', {
        url: '/add-order-popup-button',
        templateUrl: 'app/pages/settings/orderPopupButtons/addOrderPopupButton.html',
        controller: 'orderPopupButtonsCtrl',
        title: 'Add Order Popup Button',
        prevStateTitle:'Order Popup Button',
        prevState:'settings.order-popup-button',
        sidebarMeta: {
          order: 14,
        },
      }).state('settings.edit-order-popup-button', {
        url: '/edit-order-popup-button',
        templateUrl: 'app/pages/settings/orderPopupButtons/addOrderPopupButton.html',
        controller: 'orderPopupButtonsCtrl',
        title: 'Edit Order Popup Button',
        prevStateTitle:'Order Popup Button',
        prevState:'settings.order-popup-button',
        sidebarMeta: {
          order: 15,
        },
      }).state('settings.button-order', {
          url: '/button-order',
          templateUrl: 'app/pages/settings/orderPopupButtons/buttonOrder.html',
          controller: 'orderPopupButtonsCtrl',
          title: 'Manage Button Order',
          prevStateTitle:'Order Popup Button',
          prevState:'settings.order-popup-button',
          sidebarMeta: {
            order: 15,
          }
      }).state('settings.blocks', {
        url: '/blocks',
        templateUrl: 'app/pages/settings/dashboardBlocks/blocks.html',
        controller: 'blocksCtrl as vm',
        title: 'Dashboard Blocks',
        blank: true,
        permissionKey:'block_list',
        sidebarMeta: {
          order: 16,
        },
      }).state('settings.add-block', {
        url: '/add-block',
        templateUrl: 'app/pages/settings/dashboardBlocks/addBlock.html',
        controller: 'blocksCtrl as vm',
        title: 'Add Block',
        prevStateTitle:'Dashboard Blocks',
        prevState:'settings.blocks',
        sidebarMeta: {
          order: 17,
        },
      }).state('settings.edit-block', {
        url: '/edit-block',
        templateUrl: 'app/pages/settings/dashboardBlocks/addBlock.html',
        controller: 'blocksCtrl as vm',
        title: 'Edit Block',
        prevStateTitle:'Dashboard Blocks',
        prevState:'settings.blocks',
        sidebarMeta: {
          order: 18,
        },
      }).state('settings.assign-status', {
        url: '/assign-status',
        templateUrl: 'app/pages/settings/dashboardBlocks/assignStatus.html',
        controller: 'blocksCtrl',
        title: 'Assign Status',
        prevStateTitle:'Dashboard Blocks',
        prevState:'settings.blocks',
        sidebarMeta: {
          order: 19,
        },
      }).state('settings.blocks-order', {
          url: '/blocks-order',
          templateUrl: 'app/pages/settings/dashboardBlocks/blockOrder.html',
          controller: 'blocksCtrl',
          title: 'Manage Block Order',
          prevStateTitle:'Dashboard Blocks',
          prevState:'settings.blocks'
      }).state('settings.category',{
        url: '/category-list',
        templateUrl: 'app/pages/settings/category/category.html',
        controller:'categoryCtrl as vm',
        title: 'Category List',
        permissionKey:'category_list',
        sidebarMeta: {
          order: 20,
        },
      })
      .state('settings.add-category',{
        url: '/add-category',
        templateUrl: 'app/pages/settings/category/addCategory.html',
        controller:'categoryCtrl as vm',
        title: 'Add Category',
        prevStateTitle:'Category List',
        prevState:'settings.category',
        sidebarMeta: {
          order: 21,
        },
      }).state('settings.edit-category', {
        url: '/edit-category',
        templateUrl: 'app/pages/settings/category/addCategory.html',
        controller:'categoryCtrl as vm',
        title: 'Edit Category',
        prevStateTitle:'Category List',
        prevState:'settings.category',
        sidebarMeta: {
          order: 22,
        },

      }).state('settings.create-product',{
        url: '/product-list',
        templateUrl: 'app/pages/settings/product/reportLabel.html',
        controller:'reportLabelCtrl as vm',
        title: 'Products List',
        permissionKey:'report_label_list',
        sidebarMeta: {
          order: 23,
        },
      }).state('settings.add-product',{
        url: '/add-product',
        templateUrl: 'app/pages/settings/product/addReportLabel.html',
        controller:'reportLabelCtrl as vm',
        title: 'Add Product',
        prevStateTitle:'Products List',
        prevState:'settings.create-product',
        sidebarMeta: {
          order: 24,
        },
      }).state('settings.edit-product', {
        url: '/edit-product',
        templateUrl: 'app/pages/settings/product/addReportLabel.html',
        controller:'reportLabelCtrl as vm',
        title: 'Edit Product',
        prevStateTitle:'Products List',
        prevState:'settings.create-product',
        sidebarMeta: {
          order: 25,
        },
      }).state('settings.product-rule', {
        url: '/product-rule',
        templateUrl: 'app/pages/settings/productRule/productRule.html',
        controller:'productRuleCtrl as vm',
        title: 'Product Rule',
        permissionKey:'product_rule_list',
        sidebarMeta: {
          order: 26,
        },
      }).state('settings.add-product-rule', {
        url: '/add-product-rule',
        templateUrl: 'app/pages/settings/productRule/addProductRule.html',
        controller:'productRuleCtrl as vm',
        title: 'Add Product Rule',
        prevStateTitle:'Product Rule',
        prevState:'settings.product-rule',
        sidebarMeta: {
          order: 27,
        },
      }).state('settings.edit-product-rule', {
        url: '/edit-product-rule',
        templateUrl: 'app/pages/settings/productRule/addProductRule.html',
        controller:'productRuleCtrl as vm',
        title: 'Edit Product Rule',
        prevStateTitle:'Product Rule',
        prevState:'settings.product-rule',
        sidebarMeta: {
          order: 28,
        },
      }).state('settings.product-rule-order', {
        url: '/product-rule-order',
        templateUrl: 'app/pages/settings/productRule/ruleOrder.html',
        controller:'productRuleCtrl as vm',
        title: 'Product Rule Order',
        prevStateTitle:'Product Rule',
        prevState:'settings.product-rule',
        sidebarMeta: {
          order: 29,
        },
      }).state('settings.edit-button-settings', {
          url: '/edit-button-settings',
          templateUrl: 'app/pages/settings/orderPopupEditBtn/orderPopupEditBtn.html',
          controller: 'orderPopupEditBtnCtrl as vm',
          title: 'Edit Button Settings',
          permissionKey:'edit_button_settings',
          sidebarMeta: {
              order: 30,
          },
      })
      .state('settings.button-type', {
        url: '/button-type',
        templateUrl: 'app/pages/settings/buttonType/buttonType.html',
        controller:'buttonTypeCtrl as vm',
        title: 'Button Type',
        permissionKey:'button_type_list',
        sidebarMeta: {
          order: 31,
        },
      }).state('settings.add-button-type', {
        url: '/add-button-type',
        templateUrl: 'app/pages/settings/buttonType/addButtonType.html',
        controller:'buttonTypeCtrl as vm',
        title: 'Add Button Type',
        prevStateTitle:'Button Type',
        prevState:'settings.button-type',
        sidebarMeta: {
          order: 32,
        },
      }).state('settings.edit-button-type', {
        url: '/edit-button-type',
        templateUrl: 'app/pages/settings/buttonType/addButtonType.html',
        controller:'buttonTypeCtrl as vm',
        title: 'Edit Button Type',
        prevStateTitle:'Button Type',
        prevState:'settings.button-type',
        sidebarMeta: {
          order: 33,
        },
      }).state('settings.store', {
        url: '/store',
        templateUrl: 'app/pages/settings/store/store.html',
        controller:'storeCtrl as vm',
        title: 'Manage Store',
        permissionKey:'store_list',
        sidebarMeta: {
          order: 34,
        },
      }).state('settings.add-store', {
        url: '/add-store',
        templateUrl: 'app/pages/settings/store/addStore.html',
        controller:'storeCtrl as vm',
        title: 'Add Store',
        prevStateTitle:'Manage Store',
        prevState:'settings.store',
        sidebarMeta: {
          order: 35,
        },
      }).state('settings.edit-store', {
        url: '/edit-store',
        templateUrl: 'app/pages/settings/store/addStore.html',
        controller:'storeCtrl as vm',
        title: 'Edit Store',
        prevStateTitle:'Manage Store',
        prevState:'settings.store',
        sidebarMeta: {
          order: 36,
        },
      }).state('settings.map-status', {
        url: '/map-status',
        templateUrl: 'app/pages/settings/store/mapStatus.html',
        controller:'storeCtrl as vm',
        title: 'Map Status',
        prevStateTitle:'Manage Store',
        prevState:'settings.store',
        sidebarMeta: {
          order: 36,
        },
      }).state('settings.magento-status', {
        url: '/magento-status',
        templateUrl: 'app/pages/settings/store/magentoStatus/magentoStatus.html',
        controller:'magentoStatusCtrl as vm',
        title: 'Magento Status',
        // prevStateTitle:'Manage Store',
        // prevState:'settings.store',
        sidebarMeta: {
          order: 34,
        },
      }).state('settings.add-magento-status', {
        url: '/add-magento-status',
        templateUrl: 'app/pages/settings/store/magentoStatus/addMagentoStatus.html',
        controller:'magentoStatusCtrl as vm',
        title: 'Add Magento Status',
        prevStateTitle:'Magento Status',
        prevState:'settings.magento-status',
        sidebarMeta: {
          order: 35,
        },
      }).state('settings.edit-magento-status', {
        url: '/edit-magento-status',
        templateUrl: 'app/pages/settings/store/magentoStatus/addMagentoStatus.html',
        controller:'magentoStatusCtrl as vm',
        title: 'Edit Magento Status',
        prevStateTitle:'Magento Status',
        prevState:'settings.magento-status',
        sidebarMeta: {
          order: 36,
        },
      })
      .state('settings.rework-setting', {
        url: '/rework-setting',
        templateUrl: 'app/pages/settings/reworkSetting/reworkSetting.html',
        controller:'reworkSettingCtrl as vm',
        title: 'Rework Setting',
        permissionKey:'rework_setting',
        sidebarMeta: {
          order: 37
        },
      }).state('settings.job-button-setting', {
        url: '/job-button-setting',
        templateUrl: 'app/pages/settings/jobSetting/jobSetting.html',
        controller:'jobSettingCtrl as vm',
        title: 'Job Button Setting',
        permissionKey:'job_setting',
        sidebarMeta: {
          order: 38
        },
      }).state('settings.pull-job-setting', {
        url: '/pull-job-setting',
        templateUrl: 'app/pages/settings/pullJobSetting/pullJobSetting.html',
        controller:'pullJobSettingCtrl as vm',
        title: 'Pull Job Setting',
        permissionKey:'pull_job_setting',
        sidebarMeta: {
          order: 38
        },
      })
      .state('settings.app-settings', {
          url: '/app-settings',
          templateUrl: 'app/pages/settings/appSettings/appSettings.html',
          controller: 'settingsCtrl as vm',
          title: 'App Settings',
          permissionKey:'settings',
          sidebarMeta: {
              order: 39
          },
      }).state('settings.rework-button-setting', {
        url: '/rework-button-setting',
        templateUrl: 'app/pages/settings/relayButtonSetting/relayButtonSetting.html',
        controller:'relayButtonSettingCtrl as vm',
        title: 'Relay Button Setting',
        permissionKey:'relay_button_setting',
        sidebarMeta: {
          order: 40
        },
      }).state('settings.type',{
        url: '/type',
        templateUrl: 'app/pages/settings/type/type.html',
        controller:'typeCtrl as vm',
        title: 'Type List',
        permissionKey:'product_type',
        sidebarMeta:{
          order: 41,
        },
      }).state('settings.add-type',{
        url: '/add-type',
        templateUrl: 'app/pages/settings/type/addType.html',
        controller:'typeCtrl as vm',
        title: 'Add  Type',
        prevStateTitle:'Type List',
        prevState:'settings.type',
        sidebarMeta: {
          order: 42,
        },
      }).state('settings.edit-type',{
        url: '/edit-type',
        templateUrl: 'app/pages/settings/type/addType.html',
        controller:'typeCtrl as vm',
        title: 'Edit  Type',
        prevStateTitle:' Type List',
        prevState:'settings.type',
        sidebarMeta: {
          order: 43,
        },
    }).state('settings.set-type-priority',{
        url: '/set-type-priority',
        templateUrl: 'app/pages/settings/type/setPriority.html',
        controller:'typeCtrl as vm',
        title: 'Set  Type Priority',
        prevStateTitle:' Type List',
        prevState:'settings.type',
        sidebarMeta: {
          order: 44,
        },
    }).state('settings.view-type',{
        url: '/view-type',
        templateUrl: 'app/pages/settings/type/viewType.html',
        controller:'typeCtrl as vm',
        title: 'View  Type',
        prevStateTitle:' Type List',
        prevState:'settings.type',
        sidebarMeta: {
          order: 45,
        },
    }).state('settings.pie-chart',{
        url: '/pie-chart',
        templateUrl: 'app/pages/settings/pieChart/pie.html',
        controller:'pieChartCtrl as vm',
        title: 'Pie Chart',
        permissionKey:'pie_chart_setting',
        sidebarMeta: {
          order: 46,
        },
      }).state('settings.add-pie',{
        url: '/add-pie',
        templateUrl: 'app/pages/settings/pieChart/addPie.html',
        controller:'pieChartCtrl as vm',
        title: 'Add Pie',
        prevStateTitle:'Pie Chart',
        prevState:'settings.pie-chart',
        sidebarMeta: {
          order: 47,
        },
      }).state('settings.edit-pie', {
        url: '/edit-pie',
        templateUrl: 'app/pages/settings/pieChart/addPie.html',
        controller:'pieChartCtrl as vm',
        title: 'Edit Pie',
        prevStateTitle:'Pie Chart',
        prevState:'settings.pie-chart',
        sidebarMeta: {
          order: 48,
        },
      }).state('settings.button-setting', {
        url: '/button-setting',
        templateUrl: 'app/pages/settings/buttonSetting/buttonSetting.html',
        controller:'buttonSettingCtrl as vm',
        title: 'Button Setting',
        permissionKey:'button_setting',
        sidebarMeta: {
          order: 49
        },
      })
      .state('settings.damage-setting', {
        url: '/damage-setting',
        templateUrl: 'app/pages/settings/damageSetting/damageSetting.html',
        controller:'damageSettingCtrl as vm',
        title: 'Damage Setting',
        permissionKey:'damage_setting',
        sidebarMeta: {
          order: 50
        },
      }).state('settings.preview-setting', {
        url: '/preview-setting',
        templateUrl: 'app/pages/settings/previewSetting/previewSetting.html',
        controller:'previewSettingCtrl as vm',
        title: 'Preview Setting',
        permissionKey:'preview_setting',
        sidebarMeta: {
          order: 51,
        }
      }).state('settings.dashboard-summery', {
        url: '/dashboard-summery',
        templateUrl: 'app/pages/settings/dashboardSummery/dashboardSummery.html',
        controller:'dashboardSummeryCtrl as vm',
        title: 'Dashboard Summery',
        permissionKey:'settings_dashboard_summery',
        sidebarMeta: {
          order: 52,
        }
      }).state('settings.address-verification-settings', {
        url: '/address-verification-settings',
        templateUrl: 'app/pages/settings/addressVerificationSettings/addressVerificationSettings.html',
        controller:'addressVerificationSettingsCtrl as vm',
        title: 'Address Verification Settings',
        permissionKey:'settings_address_verification',
        sidebarMeta: {
          order: 53,
        }
      }).state('settings.database-status', {
        url: '/database-status',
        templateUrl: 'app/pages/settings/databaseStatusMap/databaseStatusMap.html',
        controller: 'databaseStatusMapCtrl as vm',
        title: 'Database Status Mapping',
        permissionKey:'database_status_maping',
        sidebarMeta: {
          order: 54
        }
      }).state('settings.amazon-stores', {
        url: '/amazon-stores',
        templateUrl: 'app/pages/settings/amazonStores/store.html',
        controller:'amazonStoresCtrl as vm',
        title: 'Manage Amazon Stores',
        permissionKey:'manage_amazon_stores',
        sidebarMeta: {
          order: 54,
        },
      }).state('settings.add-amazon-store', {
        url: '/add-amazon-store',
        templateUrl: 'app/pages/settings/amazonStores/addStore.html',
        controller:'amazonStoresCtrl as vm',
        title: 'Add Amazon Store',
        prevStateTitle:'Manage Amazon Stores',
        prevState:'settings.amazon-stores',
        sidebarMeta: {
          order: 35,
        },
      }).state('settings.edit-amazon-store', {
        url: '/edit-amazon-store',
        templateUrl: 'app/pages/settings/amazonStores/addStore.html',
        controller:'amazonStoresCtrl as vm',
        title: 'Edit Amazon Store',
        prevStateTitle:'Manage Amazon Stores',
        prevState:'settings.amazon-stores',
        sidebarMeta: {
          order: 36,
        },
      }).state('settings.amazon-store-products', {
        url: '/amazon-store-products',
        templateUrl: 'app/pages/settings/amazonStores/amazonStoreProducts.html',
        controller:'amazonStoreProductsCtrl as vm',
        title: 'Amazon Store Products',
        params: {type: 'amazon_store_products'},
        prevStateTitle:'Manage Amazon Stores',
        prevState:'settings.amazon-stores',
        sidebarMeta: {
          order: 37,
        }
      }).state('settings.tracker-status-map', {
        url: '/tracker-status-map',
        templateUrl: 'app/pages/settings/trackerStatusMap/mapStatus.html',
        controller:'trackerStatusMapCtrl as vm',
        title: 'Tracker Communication',
        permissionKey:'tracker_status_map',
        sidebarMeta: {
          order: 54,
        }
      }).state('settings.noy-assembly',{
        url: '/noy-assembly',
        templateUrl: 'app/pages/settings/noyAssembly/noyAssembly.html',
        controller:'noyAssemblyCtrl as vm',
        title: 'Noy Assembly Setting',
        permissionKey:'noy_assembly_setting',
        sidebarMeta:{
          order: 56,
        },
      });
    $urlRouterProvider.when('/settings', '/settings/departments');
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shipment', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('shipment', {
        url: '/shipment',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Shipment',
        permissionKey:'shipment',
        nestedPermission:['ready_to_ship','shipment_create','shipped_list'],
        sidebarMeta: {
          icon: 'fa fa-truck',
          order: 4,
        },
      }).state('shipment.shipment-create', {
        url: '/shipment-create',
        templateUrl: 'app/pages/shipment/shipmentCreate/shipmentcreate.html',
        controller:'shipmentCreateCtrl as spc',
        title: 'Create Shipment',
        permissionKey:'shipment_create',
        sidebarMeta: {
          order: 0,
        },
      }).state('shipment.ready-to-ship', {
        url: '/ready-to-ship',
        templateUrl: 'app/pages/shipment/orderReadyToShip/readytoship.html',
        controller:'readytoshipListCtrl as rts',
        title: 'Awaiting Shipment',
        permissionKey:'ready_to_ship',
        sidebarMeta: {
          order: 1,
        },
      }).state('shipment.shipped-list', {
        url: '/shipped-list',
        templateUrl: 'app/pages/shipment/shippedList/shippedlist.html',
        controller:'readytoshipListCtrl as spl',
        title: 'Shipped',
        permissionKey:'shipped_list',
        sidebarMeta: {
          order: 2,
        },
      });
      $urlRouterProvider.when('/shipment', '/shipment/shipment-create');
    }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shippingTracker', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('shipping-board', {
        url: '/shipping-board',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Shipping Board',
        permissionKey:'shipping_board',
        nestedPermission:['shipping_tracker_settings','shipping_block','shipping_tracker_dashboard','shipping_tracker_regular','shipping_tracker_supply','shipping_tracker_customers','shipping_tracker_express','shipping_tracker_figuring','figuring_tracker_dashboard'],
        sidebarMeta: {
          icon: 'fa fa-truck',
          order: 3,
        },
      }).state('shipping-board.shipping-settings', {
        url: '/shipping-settings',
        templateUrl: 'app/pages/shippingTracker/shippingTrackerSettings/shippingTrackerSettings.html',
        controller:'shippingTrackerSettingsCtrl as stc',
        title: 'Shipping Settings',
        permissionKey:'shipping_tracker_settings',
        sidebarMeta: {
          order: 0,
        },
      }).state('shipping-board.preview-dashboard', {
        url: '/customer-sequence',
        templateUrl: 'app/pages/shippingTracker/shippingTrackerSettings/dashboardPreview.html',
        controller: 'shippingTrackerSettingsCtrl',
        title: 'Manage Customer Sequence',
        sidebarMeta: {
          order: 1,
        },
      }).state('shipping-board.shipping-block', {
        url: '/shipping-block',
        templateUrl: 'app/pages/shippingTracker/shippingBlock/shippingBlock.html',
        controller: 'shippingBlockCtrl as vm',
        title: 'Shipping Block',
        permissionKey:'shipping_block',
        sidebarMeta: {
          order: 1,
        },
      }).state('shipping-board.dashboard', {
        url: '/dashboard',
        templateUrl: 'app/pages/shippingTracker/shippingTrackerDashboard/shippingTrackerDashboard.html',
        controller:'shippingTrackerDashboardCtrl as std',
        title: 'Shipping-Dashboard',
        permissionKey:'shipping_tracker_dashboard',
        sidebarMeta: {
          order: 2,
        },
      }).state('shipping-board.figuring-dashboard', {
        url: '/figuring-dashboard',
        templateUrl: 'app/pages/shippingTracker/figuringDashboard/figuringDashboard.html',
        controller:'figuringDashboardCtrl as std',
        title: 'Figurine Dashboard',
        permissionKey:'figuring_tracker_dashboard',
        sidebarMeta: {
          order: 2,
        },
      }).state('shipping-board.regular-status', {
        url: '/regular-status',
        templateUrl: 'app/pages/shippingTracker/regular/orderStatus.html',
        controller:'regularCtrl as reg',
        title: 'Regular Status',
        permissionKey:'shipping_tracker_regular',
        sidebarMeta: {
          order: 3,
        },
      }).state('shipping-board.regular', {
        url: '/regular',
        templateUrl: 'app/pages/shippingTracker/regular/regular.html',
        controller:'ordersCtrl',
        title: 'Regular',
        params: {type: 'regular'},
        prevStateTitle:'Regular Status',
        prevState:'shipping-board.regular-status',
        //permissionKey:'shipping_tracker_regular',
        sidebarMeta: {
          order: 4,
        },
      }).state('shipping-board.supply', {
        url: '/supply',
        templateUrl: 'app/pages/shippingTracker/common/common.html',
        controller:'ordersCtrl',
        title: 'Supply',
        params: {type: 'supply'},
        permissionKey:'shipping_tracker_supply',
        sidebarMeta: {
          order: 5,
        },
      }).state('shipping-board.express', {
        url: '/express',
        templateUrl: 'app/pages/shippingTracker/common/common.html',
        controller:'ordersCtrl',
        title: 'Express',
        params: {type: 'express'},
        permissionKey:'shipping_tracker_express',
        sidebarMeta: {
          order: 6,
        },
      }).state('shipping-board.customer', {
        url: '/customers',
        templateUrl: 'app/pages/shippingTracker/common/common.html',
        controller:'ordersCtrl',
        title: 'Customers',
        params: {type: 'customer'},
        permissionKey:'shipping_tracker_customers',
        sidebarMeta: {
          order: 7,
        },
        }).state('shipping-board.rework', {
        url: '/rework',
        templateUrl: 'app/pages/shippingTracker/common/common.html',
        controller:'ordersCtrl',
        title: 'Rework',
        params: {type: 'rework'},
        permissionKey:'shipping_tracker_rework',
        sidebarMeta: {
          order: 8
        }
      }).state('shipping-board.Figuring', {
        url: '/figuring',
        templateUrl: 'app/pages/shippingTracker/common/common.html',
        controller:'ordersCtrl',
        title: '3D Figurine',
        params: {type: 'figuring'},
        permissionKey:'shipping_tracker_figuring',
        sidebarMeta: {
          order: 9
        }
      })
    $urlRouterProvider.when('/shipping-board', '/shipping-board/shipping-settings');
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings', [])
  .provider('typeRouter', function ($stateProvider) {
      this.$get = function ($http, $state) {
          return {
              setUpTypeRoutes: function () {
                   var jsonMenu = localStorage.getItem('stickerTypeList')?JSON.parse(localStorage.getItem('stickerTypeList')):[];
                  angular.forEach(jsonMenu.data, function (routeName,key){
                          if (!$state.get('sticker-settings.'+routeName.name)) {
                              $stateProvider.state('sticker-settings.'+routeName.name, {
                                "url": '/'+routeName.name,
                                "params" : {
                                    block_type: routeName.name,
                                    type: 'dynamic_sticker'
                                },
                                "templateUrl": "app/pages/stickerSettings/dynamicSticker/printSticker.html",
                                "permissionKey":"type-setting-"+routeName.name,
                                "controller":"dynamicStickerCtrl as ps",
                                "title": routeName.name + ' Sticker',
                                "sidebarMeta": {
                                  "order": key+12
                                }
                              });
                          }
                      });
              }
          }
      };
  }).run(function (typeRouter) {
      typeRouter.setUpTypeRoutes();
  }).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
      .state('sticker-settings', {
        url: '/sticker-settings',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Sticker Settings',
        permissionKey:'sticker_settings',
        nestedPermission:['addon_repeat','print_sticker','supply_sticker','express_sticker','damage_sticker','customer_sticker','3dcategory_sticker'],
        sidebarMeta: {
          icon: 'fa fa-cogs',
          order: 9
        },
      }).state('sticker-settings.addon-repeat', {
        url: '/addon-repeat',
        templateUrl: 'app/pages/stickerSettings/addOnRepeat/addOnRepeat.html',
        controller:'addOnRepeatCtrl as aor',
        title: 'Add-On Repeat',
        permissionKey:'addon_repeat',
        sidebarMeta: {
          order: 0
        },
      }).state('sticker-settings.3dcategory-repeat', {
        url: '/3dcategory-addon',
        templateUrl: 'app/pages/stickerSettings/3dcategory/addOnRepeat.html',
        controller:'CatOnRepeatCtrl as cat',
        title: '3dcategory Add-On',
        permissionKey:'3dcategory_sticker',
        sidebarMeta: {
          order: 0
        },
      })
//      .state('sticker-settings.print-sticker', {
//        url: '/print-sticker',
//        templateUrl: 'app/pages/stickerSettings/printSticker/printSticker.html',
//        controller:'printStickerCtrl as ps',
//        title: 'Print Sticker',
//        permissionKey:'print_sticker',
//        sidebarMeta: {
//          order: 1
//        },
//      })
      .state('sticker-settings.print-preview', {
        url: '/print-sticker-preview',
        templateUrl: 'app/pages/stickerSettings/printSticker/printPreview.html',
        controller:'printStickerCtrl as ps',
        title: 'Print Sticker Preview',
        prevStateTitle:'Print Sticker',
        prevState:'sticker-settings.print-sticker',
        sidebarMeta: {
          order: 2
        },
      })
//      .state('sticker-settings.supply-sticker', {
//        url: '/supply-sticker',
//        templateUrl: 'app/pages/stickerSettings/supplySticker/supplySticker.html',
//        controller:'supplyStickerCtrl as ss',
//        title: 'Supply Sticker',
//        permissionKey:'supply_sticker',
//        sidebarMeta: {
//          order: 3
//        },
//      })
      .state('sticker-settings.supply-sticker-preview', {
        url: '/supply-sticker-preview',
        templateUrl: 'app/pages/stickerSettings/supplySticker/supplyStickerPreview.html',
        controller:'supplyStickerCtrl as ss',
        title: 'Supply Sticker Preview',
        prevStateTitle:'Supply Sticker',
        prevState:'sticker-settings.supply-sticker',
        sidebarMeta: {
          order: 4
        },
      })
//      .state('sticker-settings.express-sticker', {
//        url: '/express-sticker',
//        templateUrl: 'app/pages/stickerSettings/expressSticker/expressSticker.html',
//        controller:'expressStickerCtrl as exp',
//        title: 'Express Sticker',
//        permissionKey:'express_sticker',
//        sidebarMeta: {
//          order: 5
//        }
//      })
      .state('sticker-settings.express-sticker-preview', {
        url: '/express-sticker-preview',
        templateUrl: 'app/pages/stickerSettings/expressSticker/expressStickerPreview.html',
        controller:'expressStickerCtrl as exp',
        title: 'Express Sticker Preview',
        prevStateTitle:'Express Sticker',
        prevState:'sticker-settings.express-sticker',
        sidebarMeta: {
          order: 6
        }
      })
//      .state('sticker-settings.customer-sticker', {
//        url: '/customer-sticker',
//        templateUrl: 'app/pages/stickerSettings/customerSticker/customerSticker.html',
//        controller:'customerStickerCtrl as vm',
//        title: 'Customer Sticker',
//        permissionKey:'customer_sticker',
//        sidebarMeta: {
//          order: 7
//        }
//      })
      .state('sticker-settings.customer-sticker-preview', {
        url: '/customer-sticker-preview',
        templateUrl: 'app/pages/stickerSettings/customerSticker/customerStickerPreview.html',
        controller:'customerStickerCtrl as vm',
        title: 'Customer Sticker Preview',
        prevStateTitle:'Customer Sticker',
        prevState:'sticker-settings.customer-sticker',
        sidebarMeta: {
          order: 8
        }
      }).state('sticker-settings.damage-sticker', {
        url: '/damage-sticker',
        templateUrl: 'app/pages/stickerSettings/damageSticker/damageSticker.html',
        controller:'damageStickerCtrl as vm',
        title: 'Damage Sticker',
        permissionKey:'damage_sticker',
        sidebarMeta: {
          order: 9
        }
      })
//      .state('sticker-settings.rework-sticker', {
//        url: '/rework-sticker',
//        templateUrl: 'app/pages/stickerSettings/reworkSticker/reworkSticker.html',
//        controller:'reworkStickerCtrl as rs',
//        title: 'Rework Sticker',
//        permissionKey:'rework_sticker',
//        sidebarMeta: {
//          order: 10
//        },
//      })
      .state('sticker-settings.rework-preview', {
        url: '/rework-sticker-preview',
        templateUrl: 'app/pages/stickerSettings/reworkSticker/reworkPreview.html',
        controller:'reworkStickerCtrl as rs',
        title: 'Rework Sticker Preview',
        prevStateTitle:'Rework Sticker',
        prevState:'sticker-settings.rework-sticker',
        sidebarMeta: {
          order: 11
        },
      }).state('sticker-settings.dynamic-preview', {
        url: '/dynamic-preview',
        templateUrl: 'app/pages/stickerSettings/dynamicSticker/printPreview.html',
        controller:'dynamicStickerCtrl as ps',
        title: 'Sticker Preview',
        sidebarMeta: {
          order: 12
        },
      })
      ;
    $urlRouterProvider.when('/sticker-settings', '/sticker-settings/addon-repeat');

  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.customers', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('customers', {
          url: '/customers',
          templateUrl: 'app/pages/customers/customers.html',
          controller: 'customersCtrl',
          title: 'Manage Customers',
          permissionKey:'customer_list',
          sidebarMeta: {
            order: 300,
            icon: 'fa fa-user',
          },

        }).state('edit-customers', {
          url: '/edit-customer',
          templateUrl: 'app/pages/customers/editCustomers.html',
          controller: 'customersCtrl',
          title: 'Edit Customer',
        }).state('view-customer', {
          url: '/view-customer',
          templateUrl: 'app/pages/customers/addCustomers.html',
          controller: 'customersCtrl',
          title: 'View Customer',
        });
  }

})();


/**
 * Main app module.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 08.12.2017
 */

'use strict';

var mainApp = angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.router',
    'toastr',
    'ui.slimscroll',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    'ngCookies',
    'datatables',
    'datatables.buttons',
//    'datatables.columnfilter',
    'ngRoute',
    'daterangepicker',
    'ui.select',
    'as.sortable',
    'ngCkeditor',
    'timer',
    'ngIdle',
    'angular-clipboard',
    'ngProgress'
]).run(function ($rootScope, $location, $state, $window, $cookies, $timeout, $http, baSidebarService, apiService, toastrConfig, DTDefaultOptions) {

    /**
     * Set toastr configuration
     **/
    $rootScope.currentYear = moment().format('YYYY');
    toastrConfig.preventOpenDuplicates = true;
    toastrConfig.closeButton = true;
    toastrConfig.positionClass="toast-bottom-right";
    $rootScope.projectName = 'Advance Order Tracking';
    $rootScope.currentState = 'dashboard';
    $rootScope.statusCategory = [{'value':'regular','label':'Regular'},{'value':'express','label':'Express'},{'value':'office','label':'Office'},{'value':'rework','label':'Rework'},{'value':'supply','label':'Supply'}];
    $rootScope.searchStatus = undefined;
    $rootScope.searchLable = undefined;

    DTDefaultOptions.setLoadingTemplate('<div class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( \''+'download.svg'+'\' | appImage )}}"><br><p class="text-center">Loading</p</div></div>');
    $rootScope.loaderImage = 'download.svg';
    //$rootScope.dom='<"top"fpl>rt<"bottom"ip><"clear">';
    $rootScope.dom= "<'row'<'col-md-3 clearfix'l><'col-md-6 form-group clearfix'p><'col-md-3 mt-5px'f>>" +
    "<rt>" +
    "<'row'<'col-md-5'i><'col-md-7'p>><'clear'>";
    $rootScope.shippingDom= "<'row'<'col-md-6 clearfix'l><'col-md-6 form-group clearfix'p>>" +
    "<rt>" +
    "<'row'<'col-md-5'i><'col-md-7'p>><'clear'>";
    /**
     * Set API URL
     **/


    $rootScope.host = "https://3dtrk.com/3dtracker/public";
    //$rootScope.host = "https://api.3dtrk.com";
    
    $rootScope.upsUrl = $rootScope.host+'/Images/new-ups-logo.png';
    $rootScope.barcodeUrl = 'https://api.3dtrk.com/3dtracker/public/Images/Barcode/';
    $rootScope.QRcodeUrl = $rootScope.host+'/Images/QRcode/';
    $rootScope.profilePickUrl = $rootScope.host+'/Images/profile/';
    $rootScope.logoUrl = $rootScope.host+'/logo/';
    $rootScope.baseUrl=$rootScope.host+'/api/v1';
    //$rootScope.baseUrl = 'http://localhost/advancetracker/public/api/v1';
    $rootScope.typeIconUrl=$rootScope.host+'/Images/type_icon/';
    $rootScope.numberOfRecord = 11;
    $rootScope.apiIntervalTimeDashboard = 10;
    $rootScope.apiIntervalTimeOrders = 10;

    /**
     * Store Logged in User Data
     **/
    $rootScope.globals = {};
    $rootScope.globalSetting = {};

    var cookieGlobal = $window.localStorage.getItem('globals');
    if (cookieGlobal) {
        $rootScope.globals = apiService.decriptData(cookieGlobal)
        $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.authdata;
        var cookieSettings = $window.localStorage.getItem('settings');
        $rootScope.globalSetting = apiService.decriptData(cookieSettings);
    }

    var sundate = '';
    var mondate = '';
    var tuedate = '';
    var weddate = '';
    var thudate = '';
    var satdate = '';
    /**
     * Set Default Date configuration and data-table loader
     **/
    $rootScope.datePicker = {};
    $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
    $rootScope.dateRangeConfig = function (){
      /**
       * Set Datapicker Config
       */
      var currentday = moment().weekday();
      if(currentday == 0 || currentday == 1){
          sundate = moment().add('0', 'week').day(0);
          mondate = moment().add('0', 'week').day(1);
          tuedate = moment().add('-1', 'week').day(2);
          weddate = moment().add('-1', 'week').day(3);
          thudate = moment().add('-1', 'week').day(4);
          satdate = moment().add('-1', 'week').day(6);
      }

      if(currentday == 2 || currentday == 3){
          sundate = moment().add('0', 'week').day(0);
          mondate = moment().add('0', 'week').day(1);
          tuedate = moment().add('0', 'week').day(2);
          weddate = moment().add('0', 'week').day(3);
          thudate = moment().add('-1', 'week').day(4);
          satdate = moment().add('-1', 'week').day(6);
      }

      if(currentday == 4 || currentday == 5 || currentday == 6){
          sundate = moment().add('0', 'week').day(0);
          mondate = moment().add('0', 'week').day(1);
          tuedate = moment().add('0', 'week').day(2);
          weddate = moment().add('0', 'week').day(3);
          thudate = moment().add('0', 'week').day(4);
          satdate = moment().add('0', 'week').day(6);
      }
      $rootScope.datePicker.options = {
          //'Cycle 1 - (Sun,Mon)': [sundate, mondate],
          //'Cycle 2 - (Tue,Wed)': [tuedate, weddate],
          //'Cycle 3 - (Thu,Fri,Sat)': [thudate, satdate],
          'Today': [moment(), moment()],
          'Last 7 Days': [moment().subtract(6, 'days'), moment()],
          'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Last 3 months': [moment().subtract(3, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
          'Last 6 months': [moment().subtract(6, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      };

      $rootScope.datePicker.locale = {
          separator: ' To ',
          applyLabel: "Apply",
          fromLabel: "From",
          format: "YYYY-MM-DD", //will give you 2017-01-06
          toLabel: "To",
          cancelLabel: 'Cancel',
          customRangeLabel: 'Custom range'
      };
    }
    /**
     *first time check request valid or not
     */
    $http.get($rootScope.baseUrl+'/is-valid-request')
    .success(function (result) {
    });

    /**
     * Set datatable language data.
     **/
    //DTDefaultOptions.setLanguageSource($rootScope.baseUrl+'../../../../../angular/src/app/datatableLanguage.json');
    DTDefaultOptions.setLanguageSource('./app/datatableLanguage.json');
    /**
     * Redirect Default to login page if user is not logged in
     */
    $rootScope.$on('$stateChangeStart', function (evt, to, params,from) {
        $rootScope.dateRangeConfig();
        $rootScope.subTitle = to.title;
        $rootScope.projectTitle = $rootScope.projectName + ' | ' + $rootScope.subTitle;
        apiService.loaderHide();
        if ($rootScope.globals.currentUser) {
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + $rootScope.globals.currentUser.authdata;
            $rootScope.permissionArr = $rootScope.globals.currentUser.permission;
            $rootScope.userRole=$rootScope.globals.currentUser.userRole;
            $rootScope.userId=$rootScope.globals.currentUser.id;
            $rootScope.customerId=$rootScope.globals.currentUser.customer_id;
            $rootScope.numberOfRecord = ($rootScope.globalSetting.noOfRecord+1);
            $rootScope.orderDefaultSort = parseInt($rootScope.globalSetting.orderDefaultSort);
            $rootScope.defaultrangeglobalsearch = $rootScope.globalSetting.defaultrangeglobalsearch
            $rootScope.productDefaultSort = parseInt($rootScope.globalSetting.productDefaultSort);
            $rootScope.apiIntervalTimeDashboard = $rootScope.globalSetting.dashboardApiTime;
            $rootScope.apiIntervalTimeOrders = $rootScope.globalSetting.orderApiTime;
            toastrConfig.positionClass=$rootScope.globalSetting.messagePosition?$rootScope.globalSetting.messagePosition:"toast-bottom-right";
            $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
            $rootScope.displayDisableIcons =$rootScope.globalSetting.displayDisableIcons;
            $rootScope.customTypeIconAwsPath25x25 = $rootScope.globalSetting.custom_type_aws_path_25x25;
            $rootScope.customTypeIconAwsPath = $rootScope.globalSetting.custom_type_aws_path;
            /**
             * Display Cycle in datepicker if Settings cycle valye yes
             */
             if($rootScope.globalSetting && $rootScope.globalSetting.dashboardDateCycle1=='yes'){
               $rootScope.datePicker.options['Cycle 1 - (Sun,Mon)']=[sundate, mondate];
             }else{
               $rootScope.datePicker.options['Cycle 1 - (Sun,Mon)']=$rootScope.datePicker.options[''];
             }
             if($rootScope.globalSetting && $rootScope.globalSetting.dashboardDateCycle2=='yes'){
               $rootScope.datePicker.options['Cycle 2 - (Tue,Wed)']=[tuedate, weddate];
             }else{
               $rootScope.datePicker.options['Cycle 2 - (Tue,Wed)']=$rootScope.datePicker.options[''];
             }
             if($rootScope.globalSetting && $rootScope.globalSetting.dashboardDateCycle3=='yes'){
                $rootScope.datePicker.options['Cycle 3 - (Thu,Fri,Sat)']=[thudate, satdate];
             }else{
               $rootScope.datePicker.options['Cycle 3 - (Thu,Fri,Sat)']=$rootScope.datePicker.options[''];
             }
             if($rootScope.globalSetting && $rootScope.globalSetting.dashboardDateCycle4=='yes'){
               $rootScope.datePicker.options['Cycle 4 - (60, 2)']=[moment().subtract(62, 'days'), moment().subtract(2, 'days')];
             }else{
               $rootScope.datePicker.options['Cycle 4 - (60, 2)']=$rootScope.datePicker.options[''];
             }

             var currentday = moment().weekday();
             if(currentday > 1) {
              sundate = moment().add('1', 'week').day(0);
              }

            /*sundate = moment().add('0', 'week').day(0);
            mondate = moment().add('0', 'week').day(1);
            tuedate = moment().add('0', 'week').day(2);
            weddate = moment().add('-1', 'week').day(3);
            thudate = moment().add('-1', 'week').day(4);
            satdate = moment().add('-1', 'week').day(6);*/

            $rootScope.datePicker.options['Cycle 5 - (Wed,Sun)']=[weddate, sundate];

            /*sundate = moment().add('0', 'week').day(0);
            mondate = moment().add('-1', 'week').day(1);
            tuedate = moment().add('-1', 'week').day(2);
            weddate = moment().add('0', 'week').day(3);
            thudate = moment().add('0', 'week').day(4);
            satdate = moment().add('0', 'week').day(6);*/

            if(currentday == 1) {
              mondate = moment().add('-1', 'week').day(1);
              tuedate = moment().add('-1', 'week').day(2);
            }
            
            $rootScope.datePicker.options['Cycle 6 - (Mon,Tue)']=[mondate, tuedate];

            $rootScope.datePicker.options['Cycle 7 - (60, 1)']=[moment().subtract(61, 'days'), moment().subtract(1, 'days')];
        }else{
            $rootScope.permissionArr = [];
            $window.localStorage.removeItem('globals');
            $window.localStorage.removeItem('settings');
        }
        if (to.name !== 'login' && !$rootScope.globals.currentUser) {
                evt.preventDefault();
                $state.go('login');
        }

        if (to.name == 'login' && $rootScope.globals.currentUser) {
            $timeout(function () {
                $state.go('dashboard');
            }, 60);
        }

    });
    /** Dynamically set window height -- START */
        var w = angular.element($window);
        function setHeight() {
  		    return w.innerHeight();
  		  };
        $rootScope.$watch(setHeight, function (newValue, oldValue) {
            $rootScope.windowHeight = newValue-100;
            $rootScope.statusHeight = $rootScope.windowHeight-40;
        }, true);
        w.bind('resize', function () {
            $rootScope.$apply();
        });
    /**
    * Global Search use for search globaly on order
    * created on 09.02.2017
    */
    $rootScope.orderListGlobalSearch = function (){
        //var query = angular.element('#searchInput').val().replace(/ /g,'');
        var query = angular.element('#searchInput').val();
        if(!query){
           $rootScope.globalsearchBy = 'Select Search By';
        }else{
           $rootScope.globalsearchBy = 'Keyword';
        }
        if(query.length > 2){
            $rootScope.globalSearch = query;
            if($state.current.name == 'orders'){
                $rootScope.$emit("CallParentMethod", {});
            }else{
                $state.go('orders');
            }
        }
    }
}).config(['KeepaliveProvider', 'IdleProvider','$compileProvider', function(KeepaliveProvider, IdleProvider, $compileProvider) {
   $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|local|data|chrome-extension|ftp|mailto|vmark):/);
   IdleProvider.idle(60*60);
   IdleProvider.timeout(60);
   KeepaliveProvider.interval(60);
  }]);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    baConfigProvider.changeTheme({blur: true});
    
    baConfigProvider.changeColors({
      default: 'rgba(#000000, 0.2)',
      defaultText: '#ffffff',
      dashboard: {
        white: '#ffffff',
      },
    });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#0F8DD1',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#33429D',
    surfieGreen: '#165FCB',
    silverTree: '#0191D8',
    gossip: '#35B9CC',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  var appTheme = angular.module('BlurAdmin.theme');

  /**
    * Limit To Directive for restrict to user for caracter.
    * created on 08.12.2017
    */
    appTheme.directive("limitTo", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                var limit = parseInt(attrs.limitTo);
                var allowedKeys = [8, 38, 40, 46];
                angular.element(elem).on("keypress", function(event) {
                    var key = event.which || event.keyCode;
                    if (this.value.length === limit && allowedKeys.indexOf(key) < 0 ){
                        event.preventDefault();
                    }
                });
            }
        };
    }]);


    /**
    * OnlyCaracter Directive for restrict to user for only caracter.
    * created on 11.20.2017
    */
    appTheme.directive('onlyCaracter', function() {
        return {
          require: 'ngModel',
          link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
              var transformedInput = text.replace(/[^A-Z a-z 0-9_]/g, '');
              if(transformedInput !== text) {
                  ngModelCtrl.$setViewValue(transformedInput);
                  ngModelCtrl.$render();
              }
              return transformedInput;
            }
            ngModelCtrl.$parsers.push(fromUser);
          }
        };
    });

    appTheme.directive("selectpicker", [function() {
        return {
          restrict: 'A',
          require: '?ngOptions',
          //priority: 1500, // make priority bigger than ngOptions and ngRepeat
          link: {
            pre: function(scope, elem, attrs) {
              elem.append('<option data-hidden="true" disabled value=" ">' + (attrs.title || 'Select something') + '</option>')
            },
            post: function(scope, elem, attrs) {
              function refresh() {
                elem.selectpicker('refresh');
              }

              if (attrs.ngModel) {
                scope.$watch(attrs.ngModel, refresh);
              }

              if (attrs.ngDisabled) {
                scope.$watch(attrs.ngDisabled, refresh);
              }

              elem.selectpicker({ dropupAuto: false, hideDisabled: false });
            }
          }
        };
    }]);
    /**
    * isNumber Key Directive for allow only number and dot.
    * created on 11.21.2017
    */
    appTheme.directive("isNumberKey", [function() {
        return {
            restrict: "A",
            link: function(scope, elem, attrs) {
                angular.element(elem).on("keypress", function(evt) {
                  var charCode = (evt.which) ? evt.which : event.keyCode
                  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode!=46)
                      return false;
                  return true;
                });
            }
        };
    }]);
    appTheme.directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }]);
    appTheme.directive('ngEnter', function () {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });
                    event.preventDefault();
                }
            });
        };
    })
    appTheme.directive('checkPhoto', function ($q) {
      return {
          restrict: 'A',
          link: function (scope, element, attrs) {
              attrs.$observe('ngSrc', function (ngSrc) {
                  var deferred = $q.defer();
                  var image = new Image();
                  image.onerror = function () {
                      deferred.resolve(false);
                      element.attr('src', 'assets/img/no_image.png'); // set default image
                  };
                  image.onload = function () {
                      deferred.resolve(true);
                  };
                  image.src = ngSrc;
                  return deferred.promise;
              });
          }
      };
    })
    appTheme.directive('moDateInput', function ($window) {
        return {
            require:'^ngModel',
            restrict:'A',
            link:function (scope, elm, attrs, ctrl) {
                var moment = $window.moment;
                var dateFormat = attrs.moMediumDate;
                attrs.$observe('moDateInput', function (newValue) {
                    if (dateFormat == newValue || !ctrl.$modelValue) return;
                    dateFormat = newValue;
                    ctrl.$modelValue = new Date(ctrl.$setViewValue);
                });

                ctrl.$formatters.unshift(function (modelValue) {
                    scope = scope;
                    if (!dateFormat || !modelValue) return "";
                    var retVal = moment(modelValue).format(dateFormat);
                    return retVal;
                });

                ctrl.$parsers.unshift(function (viewValue) {
                    scope = scope;
                    var date = moment(viewValue, dateFormat);
                    return (date && date.isValid() && date.year() > 1950 ) ? date.toDate() : "";
                });
            }
        };
    });
    appTheme.directive('onErrorSrc', function() {
      return {
        link: function(scope, element, attrs) {
          element.bind('error', function() {
            if (attrs.src != attrs.onErrorSrc) {
              attrs.$set('src', attrs.onErrorSrc);
              attrs.$set('class', '');
              element.parent().find('.down-class').html('');
              element.parent().find('.no-image').removeClass('hide');
              element.next('i.fa-spinner').remove();
              element.remove();
            }
          });
           scope.$watch('ngSrc', function watchNgSrc() {
               element.hide();
               element.after('<i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="margin-top: 50px;margin-left: 60px;"></i>');  // add spinner
           });
           element.on('load', function onLoad() {
               element.show();
               element.next('i.fa-spinner').remove(); // remove spinner
           });
        }
      }
    });
    /**
    * Error Interceptor factory is use logout user after unauthorised.
    * created on 08.12.2017
    */
    appTheme.factory('errorInterceptor', ['$q', '$rootScope', '$location', '$cookies', '$window','$injector',
        function($q, $rootScope, $location, $cookies, $window, $injector) {
            return {
                request: function(config) {
                    return config || $q.when(config);
                },
                requestError: function(request) {
                    return $q.reject(request);
                },
                response: function(response) {
                    return response || $q.when(response);
                },
                responseError: function(response) {
                    if (response && response.status === 401) {
//                        var toastr = $injector.get('toastr');
//                        toastr.error("Your session has expired.");
                        $rootScope.globals = {};
                        $rootScope.permissionArr = [];
                        $window.localStorage.removeItem('globals');;
                        var state = $injector.get('$state');
                        state.go('login', {}, {reload: true});
                    }
                    if (response && response.status === 404) {}
                    if (response && response.status >= 500) {}
                    return $q.reject(response);
                }
            };
        }
    ]);

    appTheme.config(['$httpProvider', function($httpProvider) {
        $httpProvider.interceptors.push('errorInterceptor');
    }]);
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated fadeIn');//zoomIn
        }, delay);
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('apiService', apiService);

function apiService($q, $http,$rootScope) { // inject services and/or providers here
  var urlGet = '';
  var urlPost = '';
  var urlPut = '';
  var urlDelete = '';

  return {
    getAllData: function(apiRoute) {
      urlGet = apiRoute;
      return $http.get(urlGet);
    },
    addData: function(apiRoute, dataAdd) {
      urlPost = apiRoute;
      return $http.post(urlPost, JSON.stringify(dataAdd));
    },
    editData: function(apiRoute, dataEdit) {
      urlPut = apiRoute;
      //putData=JSON.stringify(data);
      return $http.put(urlPut, JSON.stringify(dataEdit));
    },
    deleteData: function(apiRoute) {
      urlDelete = apiRoute;
      return $http.delete(urlDelete);
    },
    loaderShow:function() {
       angular.element('.ajaxLoader').show();
    },
    loaderHide:function() {
       angular.element('.ajaxLoader').hide();
    },
    loaderShowForEncryptedPopUp:function() {
       angular.element('.ajaxLoaderForEncryptedPopUp').show();
    },
    loaderHideForEncryptedPopUp:function() {
       angular.element('.ajaxLoaderForEncryptedPopUp').hide();
    },
    loaderShowForCopyFilePopUp:function() {
       angular.element('.ajaxLoaderForCopyFilePopUp').show();
    },
    loaderHideForCopyFilePopUp:function() {
       angular.element('.ajaxLoaderForCopyFilePopUp').hide();
    },
    loaderShowForUploadButton:function() {
       angular.element('.ajaxLoaderForUploadButton').show();
    },
    loaderHideForUploadButtonp:function() {
       angular.element('.ajaxLoaderForUploadButton').hide();
    },
    popupShow:function() {
      // angular.element('#scan-popup').show();
       //angular.element('.white_overlay').show();
       angular.element('#scan-popup').css("display","block");
       angular.element('.white_overlay').css("display","block");
    },
    popupHide:function() {
      //angular.element('#scan-popup').hide();
      //angular.element('.white_overlay').hide();
      angular.element('#scan-popup').css("display","none");
      angular.element('.white_overlay').css("display","none");
    },
    ellipsisString:function(data, type, full, meta) {
        if (typeof data == 'string') {
            var stringVal = data.toString();
            if(stringVal.length  > 60){
                stringVal = stringVal.substring(0,60)+'...'
            }
            return '<span title="' + data + '">' + stringVal  + '</span>';
        }
    },
    ellipsisString15Car:function(data, type, full, meta) {
        if(data){
          if (typeof data == 'string') {
              var stringVal = data.toString();
              if(stringVal.length  > 15){
                  stringVal = stringVal.substring(0,15)+'...'
              }
              return '<span title="' + data + '">' + stringVal  + '</span>';
          }
        }else{
          return null;
        }
    },
    encriptData:function(data){
      return CryptoJS.AES.encrypt(JSON.stringify(data), "images75long9tinsel");
    },
    decriptData:function(data){
      var decrypted =  CryptoJS.AES.decrypt(data, "images75long9tinsel");
      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    }
  }
}
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.barcodeScan')
            .controller('barcodeScanCtrl', barcodeScanCtrl);

    /** @ngInject */
    function barcodeScanCtrl($scope, $rootScope,$filter, apiService, $uibModal, $cookies, $timeout, $state, $http, $location, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {
        /**
         * permissionArr is use to check permission to display list
         * created on 10.5.2017
         */
        if ($rootScope.permissionArr.indexOf('barcode_dept_list') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'barcode';
        $scope.resetGlobalSearch();
        $scope.duplicateCheck = [];
        $scope.duplicateCheckRow = [];
        $scope.productsScanned = [];
        $scope.qtyScanned = [];
        $scope.productScanDetails = [];
        $scope.isloaded = true;
        $scope.updatedItem = [];
        $scope.showItemUpdated = false;
        $scope.showItemScanned = true;
        $scope.isloadedDepartment = false;
        //$rootScope.IsDamageOrder=false;
        $scope.checkPermission = function(key){
            key = 'dep-'+key;
            if($rootScope.permissionArr.indexOf(key) == -1){
                return false;
            }
            return true;
        }
        /**
         * getBarcodeDeptData is use to get list of Product
         * created on 10.6.2017
         */
        $scope.getBarcodeDeptData = function () {

            $http.get($rootScope.baseUrl + '/departments/active')
                    .success(function (result) {
                        $scope.isloadedDepartment = true;
                        vm.departmentsData = result;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }

        /**
         * goTo Change Status Page is use to get change status page
         * created on 10.6.2017
         */
        $scope.goToChangeStatusPage = function (dept,flag) {
            $cookies.put('department-name', dept);
            $rootScope.deptTypeFlag=flag;
            $rootScope.change_monume = 'false'; 
            if(dept=='barcode_monume'){
              $rootScope.change_monume ='true';
              console.log($rootScope.change_monume);
              $state.go('change-status');
            }
            else if(dept=='damage'){
              $state.go('damage-order');
            }
            else if(dept=='ink_allocation'){
              $state.go('ink-allocation');
            }else{
              $rootScope.IsDamageOrder=false;
              $state.go('change-status');
            }
        }
        $scope.goToDamageStatusPage = function (dept) {
              $cookies.put('department-name', dept);
              $rootScope.IsDamageOrder=true;
              $state.go('change-status');
        }

        /**
         * get department Status is use to get department wise status
         * created on 10.6.2017
         */
        $scope.getDepartmentStatus = function () {
            if ($cookies.get('department-name') && $cookies.get('department-name') != undefined) {
                apiService.loaderShow();
                var defaultStatus = $rootScope.globals.currentUser.statusPermission.toString();
                var dept = $cookies.get('department-name');
                console.log(dept);
                if(dept == 'barcode_monume') {
                    dept = 'all';   
                }
                var bodyData = {
                    name: dept,
                    defaultStatus: defaultStatus
                };
                $http.post($rootScope.baseUrl + '/departments/status', bodyData).success(function (response) {
                    apiService.loaderHide();
                    vm.departmentStatus = response;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });

            } else {
                $state.go('barcode');
            }
        }

        /**
         * show scan is use to show scan pop-up
         * created on 10.9.2017
         */
        $scope.showScan = function () {
            angular.element('#scanStart').hide();
            angular.element('#scan-popup-barcode').show();
            angular.element('#fade').show();
            angular.element('#viewOrder').show();
            angular.element('#txt-barcode').show();
            angular.element('#txt-barcode').focus();
        }
        /**
         * show manual scan is use to show scan pop-up with overlay
         * created on 4.19.2018
         */
        $scope.showManualScan = function () {
          angular.element('#scanStart').hide();
          angular.element('#viewOrder').show();
          angular.element('#txt-barcode').show();
          angular.element('#txt-barcode').focus();
          angular.element('#manualScan').removeClass('hide-element');
        }

        /**
         * hide popup is use to hide scan pop-up
         * created on 10.9.2017
         */
        $scope.hidePopup = function () {
            angular.element('#scan-popup-barcode').hide();
            angular.element('#fade').hide();
            //angular.element('#txt-barcode').attr("disabled", "disabled");
            angular.element('#txt-barcode').hide();
            angular.element(".reset-button").show();
        }
        $scope.doneManualScan = function () {
            angular.element('#txt-barcode').hide();
            angular.element(".reset-button").show();
            angular.element('#manualScan').addClass('hide-element');
        }

        /**
         * scan Barcode is use to scan and display order list
         * created on 10.9.2017
         */

        $scope.scanBarcode = function (val) {
            var vm = this;
            // window.setTimeout(function () {
            //     document.getElementById('txt-barcode').focus();
            // }, 0);
            angular.element('#txt-barcode').val('');
            if(!val || val == undefined){
               angular.element('#txt-barcode').focus();
               if(!$scope.duplicateCheckRow.length){
                   toastr.warning("please scan barcode of order.");
               }
               return;
            }
            val = val.trim();
            if ($scope.duplicateCheck.indexOf(val) !== -1) {
                // window.setTimeout(function () {
                //     document.getElementById('txt-barcode').focus();
                // }, 0);
                angular.element('#txt-barcode').focus();
                if (vm.barcodeText.indexOf('_') > -1)
                {
                  toastr.warning("This item already scanned.");
                }else if (vm.barcodeText.indexOf('-') > -1){
                  toastr.warning("This product already scanned.");
                }else{
                  toastr.warning("This order already scanned.");
                }
                vm.barcodeText = '';
                return;
            }
            apiService.loaderShow();
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'');
            var mallCustomerPrmissionArr = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'');
            $http.post($rootScope.baseUrl + '/status/scanorders', {barcode:val,customer_id:$rootScope.customerId, store_permssion : storePermssion, mall_customer_permission : mallCustomerPrmissionArr}).success(function (response) {
                apiService.loaderHide();
                if (angular.equals({}, response) || response.length == 0) {
                    toastr.warning("No order found with scanned id");
                } else {
                    $scope.duplicateCheck.push(val);
                    angular.forEach(response, function (value, key) {
                        if ($scope.duplicateCheckRow.indexOf(key) == -1) {
                            $scope.loadApiDataToHtml(value);
                            $scope.duplicateCheckRow.push(key);
                        }
                    });
                }
                angular.element(".reset-button").show();
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            });

        }

        $scope.scanInkBarcode = function (val) {
            var vm = this;
            // window.setTimeout(function () {
            //     document.getElementById('txt-barcode').focus();
            // }, 0);
            angular.element('#txt-barcode').val('');
            if(!val || val == undefined){
               angular.element('#txt-barcode').focus();
               if(!$scope.duplicateCheckRow.length){
                   toastr.warning("please scan barcode of product.");
               }
               return;
            }
            
            val = val.trim();
            
            apiService.loaderShow();
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'');
            var mallCustomerPrmissionArr = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'');
            $http.post($rootScope.baseUrl + '/inventory/products/check-ink-product', {barcode:val,customer_id:$rootScope.customerId, store_permssion : storePermssion, mall_customer_permission : mallCustomerPrmissionArr}).success(function (response) {
                apiService.loaderHide();
                if(response.status == 'success')
                {
                  $scope.productsScanned.push(val);
                    console.log(response.data);
                    angular.forEach(response.data, function (value) {
                      $scope.loadInkProductDataToHtml(value);
                      });
                  

                }
                else {
                  toastr.error(response.message);
                }
                angular.element(".reset-button").show();
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            });

        }

        $scope.applyRemoveStock = function() {
          var vm = this;

          apiService.loaderShow();
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'');
            var mallCustomerPrmissionArr = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'');
            $http.post($rootScope.baseUrl + '/inventory/products/scan-ink-product', {barcodes:$scope.productsScanned,customer_id:$rootScope.customerId, store_permssion : storePermssion, mall_customer_permission : mallCustomerPrmissionArr}).success(function (response) {
                apiService.loaderHide();
                if(response.status == 'success') {
                  toastr.success(response.message);
                }
                else {
                  toastr.error(response.message);
                }
                angular.element(".reset-button").show();
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            });
        }

        $scope.checkDuplicate=function(origArr){
                var newArr = [],
                origLen = origArr.length,
                found, x, y;

            for (x = 0; x < origLen; x++) {
                found = undefined;
                for (y = 0; y < newArr.length; y++) {
                    if (origArr[x] === newArr[y]) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    newArr.push(origArr[x]);
                }
            }
            return newArr;
          }
        /**
         * apply Status is use to change status of orders
         * created on 10.9.2017
         */
        $scope.applyStatus = function () {
            if (!vm.orderStatus) {
                toastr.error("Please select order status.");
                //angular.element('#orderStatus').focus();
                return;
            }
            console.log( $rootScope.change_monume);
            angular.element('#txt-barcode').hide();
            if ($scope.duplicateCheckRow.length > 0) {
                apiService.loaderShow();
                var bodyData = {
                    status: vm.orderStatus?vm.orderStatus:'',
                    ids: $scope.duplicateCheckRow.toString(),
                    type_flag:$rootScope.deptTypeFlag?$rootScope.deptTypeFlag:'none',
                    scan_username:$rootScope.globals.currentUser.name,
                    change_monume:  $rootScope.change_monume
                };
                $http.post($rootScope.baseUrl + '/status/bulkupdate', bodyData).success(function (response) {
                    apiService.loaderHide();
                    $scope.changeStatus();
                    toastr.success("Orders updated successfully");
                    $scope.showItemUpdated = true;
                    $scope.showItemScanned = false;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                toastr.error("No scanned order found to apply status.");
            }

        }
        /**
         * get Damage settings data is use to get damage status
         * created on 06.22.2018
         */
         $scope.getDamageSettingData = function () {
          $http.get($rootScope.baseUrl + '/config/setting/save-damage-sticker')
            .success(function (result) {
              if(result.data && result.data!=undefined){
                var damageStickerData=result.data[0];
                vm.changeRegularStatus=damageStickerData.changeRegularStatus;
                vm.changeExpressStatus=damageStickerData.changeExpressStatus;
                vm.changeReworkStatus=damageStickerData.changeReworkStatus;
                vm.changeCustomerStatus=damageStickerData.changeCustomerStatus;
              }
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
          }
        $scope.reprintOrder = function () {
            var damageStatus,damageType,scanOrderType;
            if($cookies.get('department-name')=='Regular'){
              damageStatus=vm.changeRegularStatus?vm.changeRegularStatus:'order_stickers_printed';
              damageType="print";
              scanOrderType="regular";
            }else if($cookies.get('department-name')=='Express'){
              damageStatus=vm.changeExpressStatus?vm.changeExpressStatus:'express_stickers_printed';
              damageType="express";
              scanOrderType="express";
            }else if($cookies.get('department-name')=='Rework'){
              damageStatus=vm.changeReworkStatus?vm.changeReworkStatus:'rework_stickers_printed';
              damageType="rework";
              scanOrderType="rework";
            }else if($cookies.get('department-name')=='Customer'){
              damageStatus=vm.changeCustomerStatus?vm.changeCustomerStatus:'order_stickers_printed';
              damageType="customer";
              scanOrderType="customer";
            }
            if ($scope.duplicateCheckRow.length > 0) {
                apiService.loaderShow();
                var bodyData = {
                    status: damageStatus?damageStatus:'',
                    ids: $scope.duplicateCheckRow.toString(),
                    isdamage:'yes',
                    scan_username:$rootScope.globals.currentUser.name,
                    type_flag:'none'
                };
                $http.post($rootScope.baseUrl + '/status/bulkupdate', bodyData).success(function (response) {
                    apiService.loaderHide();
                    $scope.changeDamageStatus(damageStatus);
                    //toastr.success("Orders updated successfully");
                    // download sticker
                    $scope.scanOrderIds=[];
                    $scope.scanItemsIds=[];
                    angular.forEach($scope.duplicateCheckRow,function(val,key){
                      var splitId=val.split('-');
                      var itemids = val;
                      $scope.scanOrderIds.push(splitId[0]);
                      $scope.scanItemsIds.push(itemids);
                    });
                    $scope.uniqueScanOrderIds=$scope.checkDuplicate($scope.scanOrderIds);
                    var fromDate='null';
                    var toDate='null';
                    var userName = 'null';
                    var loginUserName='null';
                    $http.get($rootScope.baseUrl + '/sticker-print/'+fromDate+'/'+toDate+'/'+userName+'/'+damageType+'/'+loginUserName,{params:{scanordertype:scanOrderType,scanorderIds:$scope.uniqueScanOrderIds.toString(),ismultiple:"enable",itemids:$scope.scanItemsIds.toString()}}).success(function(response) {
                      if(response.status!='fail'){
                        window.open($rootScope.baseUrl + '/sticker-print/'+fromDate+'/'+toDate+'/'+userName+'/'+damageType+'/'+loginUserName+'?scanordertype='+scanOrderType+'&scanorderIds='+$scope.uniqueScanOrderIds.toString()+'&ismultiple=enable&itemids='+$scope.scanItemsIds.toString(), '_self');
                      }else{
                        toastr.error(response.message);
                      }
                    }).error(function(error) {
                    });
                    $scope.showItemUpdated = true;
                    $scope.showItemScanned = false;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                toastr.error("No scanned order found to apply status.");
            }
        }

        /**
         * change Status is use to change status of orders
         * created on 10.11.2017
         */
        $scope.changeStatus = function () {
            $scope.updatedItem = [];
            $scope.isloaded = false;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'');
            var mallCustomerPrmissionArr = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'');
            var bodyData = {
                //status: angular.element("#orderStatus option:selected").val(),
                status: vm.orderStatus,
                ids: $scope.duplicateCheckRow.toString(),
                store_permssion:storePermssion,
                mall_customer_permission:mallCustomerPrmissionArr
            };
            $http.post($rootScope.baseUrl + '/status/bulkrecords', bodyData).success(function (response) {
                if(response.status && response.status == 'success'){
                    angular.element('#tblOrder tbody tr').remove();
                    $scope.isloaded = true;
                    if(response.data){
                        angular.forEach(response.data, function (value, key) {
                            var keyNested = Object.keys(value);
                            $scope.loadApiDataToHtml(value[keyNested[0]]);
                            $scope.updatedItem.push(key);
                        });
                    }
                }
            }).error(function (error) {
                $scope.isloaded = true;
                if (error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });

        }
        $scope.changeDamageStatus = function (status) {
            $scope.updatedItem = [];
            $scope.isloaded = false;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'');
            var mallCustomerPrmissionArr = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'');
            var bodyData = {
                status: status,
                ids: $scope.duplicateCheckRow.toString(),
                store_permssion:storePermssion,
                mall_customer_permission:mallCustomerPrmissionArr
            };
            $http.post($rootScope.baseUrl + '/status/bulkrecords', bodyData).success(function (response) {
                if(response.status && response.status == 'success'){
                    angular.element('#tblOrder tbody tr').remove();
                    $scope.isloaded = true;
                    if(response.data){
                        angular.forEach(response.data, function (value, key) {
                            var keyNested = Object.keys(value);
                            $scope.loadApiDataToHtml(value[keyNested[0]]);
                            $scope.updatedItem.push(key);
                        });
                    }
                }
            }).error(function (error) {
                $scope.isloaded = true;
                if (error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });

        }

        /**
         * reset scan is use to reset scan and status
         * created on 10.9.2017
         */
        $scope.resetScan = function () {
            $state.go($state.$current, null, {
                reload: true
            });
        }

        /**
         * load Api Data To Html is use to load html from api data
         * created on 10.9.2017
         */
        /**
        * display/hide disabled icon 
        * 24 jan 2019
        * shivpratap.chauhan@brainvire.com
        */
        $scope.loadApiDataToHtml = function (value) {
                   var row='';
                  if($rootScope.displayDisableIcons=='yes')
                  {
                   if(value.icon_rocket && value.icon_rocket=='enable'){
                     row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
                   }else{
                     row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                   }
                   if(value.icon_tools && value.icon_tools=='enable'){
                     row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
                   }else{
                     row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                   }
                   if(value.icon_plane && value.icon_plane=='enable'){
                     row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
                   }else{
                     row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                   }
                   if((value.icon_house && value.icon_house=='enable') || (value.is_ups && value.is_ups=='enable' || value.is_ups==1)){
                     row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
                   }else{
                     row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed">';
                   }
                   if ((value.type_total_count != undefined) && (value.type_total_count >= 1)) {
                        var typeSlugName;
                        var typeExtName;
                        for (var i = 1; i <= value.type_total_count; i++) {
                            typeSlugName = value['type_' + i + '_slug'];
                            typeExtName = value['type_' + i + '_extension'];
                            row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                        }
                    }
                    if(value.regular_orders && value.regular_orders=='enable'){
                     row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
                    }
                    row;
                }else if($rootScope.displayDisableIcons=='no'){
                   if(value.icon_rocket && value.icon_rocket=='enable'){
                     row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
                   }
                   if(value.icon_tools && value.icon_tools=='enable'){
                     row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
                   }
                   if(value.icon_plane && value.icon_plane=='enable'){
                     row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
                   }
                   if((value.icon_house && value.icon_house=='enable') || (value.is_ups && value.is_ups=='enable' || value.is_ups==1)){
                     row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
                   }
                   if ((value.type_total_count != undefined) && (value.type_total_count >= 1)) {
                        var typeSlugName;
                        var typeExtName;
                        for (var i = 1; i <= value.type_total_count; i++) {
                            typeSlugName = value['type_' + i + '_slug'];
                            typeExtName = value['type_' + i + '_extension'];
                            row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                        }
                    }
                    if(value.regular_orders && value.regular_orders=='enable'){
                     row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
                    }
                    row;
                }
                var table  = "<tr>";
                 table +="<td style='width:260px;'>"+row+"</td>";
                 table += "<td style='width:260px;'>" + value.prod_qty_id+"</td>";
                 table += "<td style='width:260px;'>" + $scope.UcCap(value.cust_name)+"</td>";
                 table += "<td style='width:260px;text-align:center;background-color:" + (value.color_code?value.color_code:'#8FB801') + "'>" + value.status+"</td>";
                 table += "<td style='width:260px;text-align:center'>" + $scope.getGlobalDateFormat(value.created_time)+"</td>";
                 if(value.is_ups == 1){
                    table += "<td style='width:260px;text-align:center'>";
                    table += "<img width='30' height='30' src='"+$rootScope.upsUrl+"' >";
                    table += "</td>";
                 }
                 table += "</tr>";
                 angular.element('#tblOrder tbody').prepend(table);
        }

        $scope.loadInkProductDataToHtml = function (value) {
          var row='';
          console.log(value);
          var table  = "<tr>";
           table +="<td style='width:260px;'>"+value.name+"</td>";
           table +="<td style='width:260px;'>"+value.sku+"</td>";
           table += "<td style='width:260px;'>" + value.qty+"</td>";
           table += "</tr>";
           angular.element('#tblOrder tbody').prepend(table);
        }

    }
})();

/**
 * Dashboard page handle all action related dashboard.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 09.12.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
            .controller('dashboardCtrl', dashboardCtrl);

    /** @ngInject */
    function dashboardCtrl($scope, $cookies, $rootScope, $q, $state, $http, $location, toastr, apiService, $timeout, baConfig,$interval) {
        $rootScope.currentState = 'dashboard';
        $scope.resetGlobalSearch();

        $rootScope.isPieModified = true;
        $scope.pieChartArr = {};
        $scope.pieChartArrData = {};
        $rootScope.searchStatus = undefined;
        $rootScope.dashboardBlockName=undefined;

        $scope.DesignOrdersCount = 0;
        $scope.DesignItemsCount = 0;
        $scope.QAOrdersCount = 0;
        $scope.QAItemsCount = 0;
        $scope.ShippingOrdersCount = 0;
        $scope.ShippingItemsCount = 0;
        $scope.mallShippingOrdersCount = 0;
        $scope.mallShippingItemsCount = 0;

        $scope.loadfirst = 0;
        $scope.statusCategories = [];
        $timeout(function () {
           angular.element('.input-mini').attr('readonly',true);
        }, 1000);

        /**
         * Main PieChart Data
         * created on 02.12.2018
         */
        var layoutColors = baConfig.colors;
        var theHelp = Chart.helpers;
        $scope.colors = [layoutColors.successLight, layoutColors.danger];
        $scope.colors = [{
            backgroundColor: '#cef353',
            pointBackgroundColor: layoutColors.successLight,
          },{
            backgroundColor: '#f97979',
            pointBackgroundColor:  layoutColors.danger,
          }];
        $scope.labels =["Total", "Comple."];
        $scope.pieChartOptions = {
            tooltips: {
                callbacks: {
                    label: function (tooltipItem, data) {
                        var cData = data.datasets[tooltipItem.datasetIndex].data;
                        var _meta = data.datasets[tooltipItem.datasetIndex]._meta;
                        var meta = _meta[Object.keys(_meta)[0]];
                        var ttLbl = data.labels[tooltipItem.index];
                        var ttData = cData[tooltipItem.index];
                        var ttPct = 0;
                        if (ttData == 0.01) {
                          //return ttLbl + ': 0 (' + ttPct + ' %)';
                          return [ttLbl , 'No. Orders : 0','% : ' + ttPct+' %'];
                        }else{
                          ttPct=Math.round((ttData / Math.floor(meta.total)) * 10000) / 100;
                          //return ttLbl + ': ' + ttData + ' (' + ttPct + ' %)';
                          return [ttLbl , 'No. Orders : '+ttData ,'% : ' + ttPct+' %'];
                        }
                    }
                },
                bodyFontSize:10
            },
            maintainAspectRatio: false,
            elements: {
              arc: {
                borderWidth: 0
              }
            },
            legend: {
              display: false,
              position: 'bottom',
              labels: {
                fontColor: layoutColors.defaultText
                }
            }
        };
        $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        if($rootScope.datePickerRegular){
          $rootScope.datePickerRegular = {date:$rootScope.datePicker.date};
        }
       /**
        * Options method is use configure date picker options
        * created on 10.06.2017
        */
        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                    $scope.loadDataFromAPI();
                    $rootScope.datePicker.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                },
                'hide.daterangepicker':function() {
                    $rootScope.datePicker.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                }
            }
        }
        $scope.getLength = function(obj){
            var keys = Object.keys(obj);
            keys = keys.filter(function(e){return e});
            return keys.length;
        }
        /**
         * focus Input methos is used for focus on date picker.
         * created on 09.26.2017
         */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
         * check permission
         * created on 06.03.2018
         */
        $scope.checkPermission = function(key){
            key = 'das-blc-'+key;
            if($rootScope.permissionArr.indexOf(key) == -1){
                return false;
            }
            return true;
        }


        /**
         * search On Order List is used for load orders by click status.
         * created on 09.26.2017
         */
        $scope.searchOnOrderList = function(status, code, totalOrders,blockName){
            if(totalOrders > 0){
                $rootScope.searchStatus = code;
                $rootScope.searchLable = status;
                $rootScope.dashboardBlockName = blockName;
                $state.go('orders');
            }
        }

        function uniqueRandomInts(upperLimit, amount) {
            var possibleNumbers = _.range(upperLimit + 1);
            var shuffled = _.shuffle(possibleNumbers);
            return shuffled.slice(0, amount);
        }
        Object.size = function(obj) {
            var size = 0, key;
            for (key in obj) {
                if (obj.hasOwnProperty(key)) size++;
            }
            return size;
        };
        var canceler = $q.defer();
        /**
         * Load data from API is used for load status data.
         * created on 09.26.2017
         */
        $scope.loadDataFromAPI = function(){
           if ($rootScope.isPieModified != undefined && $rootScope.isPieModified) {
               $rootScope.isPieModified = false;
                $http.get($rootScope.baseUrl + '/pie/active-index').success(function (result) {
                    angular.forEach(result, function (value, key) {
                        $scope.pieChartArr[value.name] = value.name;
                        $scope.pieChartArrData[value.name] = value;
                    });
                }).error(function (error) {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    }
                });
            }
            $scope.checkS =  canceler.resolve();

            canceler = $q.defer();

            if($scope.loadfirst == 1)
            {
              //apiService.loaderShow();
              $http.post($rootScope.baseUrl + '/system/dashboard/update',{
                      from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
                      to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate),
                      status:($rootScope.globals.currentUser.statusPermission?$rootScope.globals.currentUser.statusPermission.toString():''),
                      store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                      mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():''),
                      customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                  },{
                      timeout: canceler.promise
                  })
                  .success(function (response) {
                      // Get the size of an object
                      //apiService.loaderHide();
                      $scope.statusCategories = [];
                      $scope.piechartData = {};
                      $scope.settingArr  = response['top_property'];
                      $scope.statusCategories = response['data'];
                      
                      angular.forEach($scope.pieChartArrData, function (value, key) {
                          var regularStatistic = $scope.settingArr[value.dashboard_block];
                          var regPerc = regularStatistic['perc'];
                          if ($scope.statusCategories[value.dashboard_block] && $scope.statusCategories[value.dashboard_block][value.closing_status]) {
                              var regCompletePerc = $scope.statusCategories[value.dashboard_block][value.closing_status]['perc'];
                              regPerc = regCompletePerc.split('%')[0];
                          }
                          $scope.piechartData[value.name] = [regularStatistic['total_orders'],regularStatistic['orders_completed'],regPerc, value.dashboard_block];
                      });
                      
                      angular.forEach($scope.piechartData, function (arr, key) {
                          var arr =  $scope.statusCategories[arr[3]];
                          $scope.newChartArr = {};
                          $scope.newChartArr.lable = [];
                          $scope.newChartArr.value = [];
                          $scope.newChartArr.color = [];
                          $scope.newChartArr.dashboard_block_type = [];
                          angular.forEach(arr, function (value, key) {
                            if(value.total){
                              $scope.newChartArr.lable.push(value.label);
                              $scope.newChartArr.value.push(value.total);
                              $scope.newChartArr.dashboard_block_type.push(value.dashboard_block_type);
                              $scope.newChartArr.color.push({
                                  backgroundColor: value.color,
                                  pointBackgroundColor: value.color,
                                });
                            }
                          });
                          //Commented to hide static blocks
                          $scope.pieChartArr[key] = $scope.newChartArr;
                      });
                      $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                  }).error(function (response,ds,ff) {
                      if(ds != -1){
                          //apiService.loaderHide();
                          $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                          $scope.isShowPopup=false;
                          toastr.error("Something went wrong please try again.");
                      }
                  });
            }
            else
            {
              $http.post($rootScope.baseUrl + '/system/dashboard',{
                    from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
                    to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate),
                    status:($rootScope.globals.currentUser.statusPermission?$rootScope.globals.currentUser.statusPermission.toString():''),
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():''),
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                },{
                    timeout: canceler.promise
                })
                .success(function (response) {

                    // Get the size of an object
                    //apiService.loaderHide();
                    $scope.statusCategories = [];
                    $scope.piechartData = {};
                    $scope.settingArr  = response['top_property'];
                    $scope.statusCategories = response['data'];
                    
                    angular.forEach($scope.pieChartArrData, function (value, key) {
                        var regularStatistic = $scope.settingArr[value.dashboard_block];
                        var regPerc = regularStatistic['perc'];
                        if ($scope.statusCategories[value.dashboard_block] && $scope.statusCategories[value.dashboard_block][value.closing_status]) {
                            var regCompletePerc = $scope.statusCategories[value.dashboard_block][value.closing_status]['perc'];
                            regPerc = regCompletePerc.split('%')[0];
                        }
                        $scope.piechartData[value.name] = [regularStatistic['total_orders'],regularStatistic['orders_completed'],regPerc, value.dashboard_block];
                    });
                    
                    angular.forEach($scope.piechartData, function (arr, key) {
                        var arr =  $scope.statusCategories[arr[3]];
                        $scope.newChartArr = {};
                        $scope.newChartArr.lable = [];
                        $scope.newChartArr.value = [];
                        $scope.newChartArr.color = [];
                        $scope.newChartArr.dashboard_block_type = [];
                        angular.forEach(arr, function (value, key) {
                          if(value.total){
                            $scope.newChartArr.lable.push(value.label);
                            $scope.newChartArr.value.push(value.total);
                            $scope.newChartArr.dashboard_block_type.push(value.dashboard_block_type);
                            $scope.newChartArr.color.push({
                                backgroundColor: value.color,
                                pointBackgroundColor: value.color,
                              });
                          }
                        });
                        
                        //Commented to hide static blocks
                        $scope.pieChartArr[key] = $scope.newChartArr;
                    });
                    
                    $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                    //angular.element('#btnrefresh').click();
                    $scope.loadfirst = 1;
                    $scope.loadDataFromAPI();
                }).error(function (response,ds,ff) {
                    if(ds != -1){
                        //apiService.loaderHide();
                        $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                        $scope.isShowPopup=false;
                        toastr.error("Something went wrong please try again.");
                    }
                });
                
              $scope.loadfirst = 1;    
            }

            $scope.loadStatusData('design');
            $scope.loadStatusData('qa');
            $scope.loadStatusData('shipping');
            $scope.loadStatusData('mallshipping');
        }

        /**
         * Load data from API is used for load status data.
         * created on 09.26.2017
         */
        $scope.loadStatusData = function(type)
        {
          $scope.DesignOrdersCount = 0;
          $scope.DesignItemsCount = 0;
          $scope.QAOrdersCount = 0;
          $scope.QAItemsCount = 0;
          $scope.ShippingOrdersCount = 0;
          $scope.ShippingItemsCount = 0;
          $scope.mallShippingOrdersCount = 0;
          $scope.mallShippingItemsCount = 0;

          $http.post($rootScope.baseUrl + '/system/dashboard/status-count',{
            from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
            to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate),
            status:($rootScope.globals.currentUser.statusPermission?$rootScope.globals.currentUser.statusPermission.toString():''),
            store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
            mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():''),
            customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
            type: (type!='')?type:'design'
          },{
              timeout: canceler.promise
          })
          .success(function (response) {
            if(type == 'design')
            {
              $scope.DesignOrdersCount  = response['order_total_count'];
              $scope.DesignItemsCount = response['item_total_count'];
            }
            else if(type == 'qa')
            {
              $scope.QAOrdersCount = response['order_total_count'];
              $scope.QAItemsCount = response['item_total_count'];
            }
            else if(type == 'shipping')
            {
              $scope.ShippingOrdersCount = response['order_total_count'];
              $scope.ShippingItemsCount = response['item_total_count'];
            }
            else if(type == 'mallshipping')
            {
              $scope.mallShippingOrdersCount = response['order_total_count'];
              $scope.mallShippingItemsCount = response['item_total_count'];
            }
          }).error(function (response,ds,ff) {

          });
        };

        /**
         * Get data pie charts.
         * created on 09.26.2017
         */
        var pieColor = 'rgba(255,255,255,0.8)';
        $scope.charts = [{
                color: pieColor,
                description: 'Regular Orders',
            }, {
                color: pieColor,
                description: 'Express Orders',
            }, {
                color: pieColor,
                description: 'Supply',
            }, {
                color: pieColor,
                description: 'Customer Orders',
            }, {
                color: pieColor,
                description: 'Rework',
            }
        ];

        function getRandomArbitrary(min, max) {
            return Math.random() * (max - min) + min;
        }

        function loadPieCharts() {
            $('.chart').each(function () {
                var chart = $(this);
                chart.easyPieChart({
                    easing: 'easeOutBounce',
                    onStep: function (from, to, percent) {
                        $(this.el).find('.percent').text(Math.round(percent));
                    },
                    barColor: chart.attr('rel'),
                    trackColor: 'rgba(0,0,0,0)',
                    size: 68,
                    scaleLength: 0,
                    animation: 2000,
                    lineWidth: 10,
                    lineCap: 'round',
                });
            });

            $('.refresh-data').on('click', function () {
                updatePieCharts();
            });
        }

        function updatePieCharts() {
            $('.pie-charts .chart').each(function (index, chart) {
                var type = $(chart).parent().find('.description .title-pichart').html();
                var show = $scope.piechartData[type][2]?$scope.piechartData[type][2]:0;
                $(chart).data('easyPieChart').update(show);
            });
        }
        // dashboard date  auto refresh
        $scope.startDateTimer=function(){
          $scope.dateTimer=$interval(function(){
            if($location.path() == '/dashboard'){
                    $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
                    $scope.loadDataFromAPI();
              }
          },1000*21600);
        }
        $scope.killDateTimer=function(){
          if(angular.isDefined($scope.dateTimer))
            {
              $interval.cancel($scope.dateTimer);
              $scope.dateTimer=undefined;
            }
        };
        if($rootScope.globals.currentUser && $rootScope.globals.currentUser.statusPermission.length>0){
          console.log($rootScope.globals.currentUser);
          $scope.loadDataFromAPI();
          $scope.startDateTimer();
          $timeout(function () {
              loadPieCharts();
              updatePieCharts();
          }, 300000);

          var timer = $timeout( function refresh(){
              if($location.path() == '/dashboard'){
                  $scope.loadDataFromAPI();
                  timer = $timeout(refresh, ($rootScope.apiIntervalTimeDashboard * 300000));
              }
          }, ($rootScope.apiIntervalTimeDashboard * 300000));
        }else{
          $scope.killDateTimer();
        }

        $scope.getShippingBlockData = function() {
          $http.get($rootScope.baseUrl + '/config/setting/shipping-block')
              .success(function (result) {
                if(result && result.status=='success'){
                    if(result.data.shipping_block_status){
                      var regularBlock=result.data.shipping_block_status[0].status;
                      var regular=[];
                      angular.forEach(regularBlock,function(val,key){
                        regular.push(val.status_code);
                      });
                      $cookies.put('regularStatus',regular.toString());
                      var supplyBlock=result.data.shipping_block_status[1].status;
                      var supply=[];
                      angular.forEach(supplyBlock,function(val,key){
                        supply.push(val.status_code);
                      });
                      $cookies.put('supplyStatus',supply.toString());
                      var expBlock=result.data.shipping_block_status[2].status;
                      var express=[];
                      angular.forEach(expBlock,function(val,key){
                        express.push(val.status_code);
                      });
                      $cookies.put('expressStatus',express.toString());
                      var custBlock=result.data.shipping_block_status[3].status;
                      var customers=[];
                      angular.forEach(custBlock,function(val,key){
                        customers.push(val.status_code);
                      });
                      $cookies.put('customersStatus',customers.toString());
                      var reworkBlock=result.data.shipping_block_status[4].status;
                      var reworkData=[];
                      angular.forEach(reworkBlock,function(val,key){
                        reworkData.push(val.status_code);
                      });
                      $cookies.put('reworkStatus',reworkData.toString());

                    }
                  }
              }).error(function (error) {
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  }
              });
        }
        $scope.getShippingBlockData();
        $scope.resetManualDate=function(){
            $rootScope.datePickerOrder.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePickerOrder.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePickerRegular.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        // block list -- start
        // $scope.getProductBlockList=function(){
        //   $http.get($rootScope.baseUrl + '/products/block')
        //           .success(function(result) {
        //             localStorage.setItem('blockList',JSON.stringify(result));
        //           }).error(function (error) {
        //               if (error.data.code != undefined && error.data.code == 0) {
        //                   toastr.error(error.data.message);
        //               }
        //           });
        // }
        // $scope.getProductBlockList();
        // block list -- end
    }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.databaseMachines')
            .controller('databaseMachinesCtrl', databaseMachinesCtrl);

    /** @ngInject */
    function databaseMachinesCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
        /**
        * permissionArr is use to check permission to display list of machines
        * created on 25.10.2021
        */
        if($rootScope.permissionArr.indexOf('manage_database_machines') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='databasemachines.managemachines';
        $scope.machineTitle="Add Machines";

        var vm = this;
        vm.name = '';
        vm.status = '1';
        $scope.menuStatus = [{
          isOpen: true
        }];

        /**
         * Get data table method is use get list of machines.
         * created on 26.10.2021
         */
        $scope.getDataTable = function ()
        {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/database/machines')
                .success(function(result)
                {
                    if(result.length < $rootScope.numberOfRecord)
                    {
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                        }, 200);
                    }
                    vm.machines = [];
                    var index = 1 ;
                    angular.forEach(result, function(value, key)
                    {
                        var changeStatusValTo = 0;
                        
                        var editLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_edit') != -1){
                        editLinks = ' <a href="javascript:void(0);"  ng-click="editMachine(\'' + value.machine_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        }
                        
                        var deleteLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_delete') != -1){
                            deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/databaseMachines/deleteModal.html' + '\',\'' + value.machine_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                        }
                        
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';

                        var statusLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_status_change') != -1){
                        statusLinks = ' <a ng-click="open(\'' + 'app/pages/databaseMachines/statusModal.html' + '\',\'' + value.machine_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        }

                        if (value.status == 0)
                        {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            if ($rootScope.permissionArr.indexOf('database_machine_status_change') != -1) {
                            statusLinks = ' <a ng-click="open(\'' + 'app/pages/databaseMachines/statusModal.html' + '\',\'' + value.machine_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                            }
                        }

                        var slotsLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_slots') != -1){
                            slotsLinks = ' <a ng-click="viewMachineSlots(' + value.machine_id + ')" href="javascript:void(0);" title="Slots"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></a>';
                        }

                        var downloadLinks = '';
                        if($rootScope.permissionArr.indexOf('machine_barcode_download') != -1){
                            downloadLinks = ' <a ng-click="downloadMachineBarcode(' + value.machine_id + ')" href="javascript:void(0);" title="Download"><i class="fa fa-download" style="color:#fff;" aria-hidden="true"></i></a>';
                        }

                        
                        var data = {
                            index:index,
                            id: value.machine_id,
                            name: value.machine_name,
                            created_at: value.created_at,
                            status:statusBadge,
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + slotsLinks + '&nbsp;' + downloadLinks
                        };

                        this.push(data);
                        ++index;
                        
                    }, vm.machines);
                    defer.resolve(vm.machines);
                })
                .error(function (error)
                {
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            })
            .withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $scope.$apply($compile(nRow)($scope));
            });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function()
            {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No')
            ];

            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name').renderWith($scope.UcCap));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        $scope.downloadMachineBarcode = function (id)
        {
            var urdd = $rootScope.baseUrl + '/database/machine-barcode/'+id
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_machine_barcode_"+id+".pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }
        
        /**
         * Add machine method is use for get add machine page.
         * created on 26.10.2021
         */
        $scope.addMachine = function()
        {
            $cookies.put('machine-id',undefined);
            $state.go('databasemachines.addmachines');
        };

        /**
         * Edit machine method is use for get edit machine page.
         * created on 26.10.2021
         */
        $scope.editMachine = function(id)
        {
            $cookies.put('machine-id',id);
            $state.go('databasemachines.editmachine');
        };

        /**
         * Get edited machine method is use for get edited machine data.
         * created on 26.10.2021
         */
        $scope.getEditedMachine = function()
        {
            if ($cookies.get('machine-id') && $cookies.get('machine-id')!= undefined)
            {
                apiService.loaderShow();

                $http.get($rootScope.baseUrl + '/database/machine/' + $cookies.get('machine-id'))
                .success(function(response) {
                    vm.machineId = response.machine_id;
                    vm.machinelabel = response.machine_label;
                    vm.name = response.machine_name;
                    vm.status = response.status;
                    apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            else {
                $state.go('databasemachines.addmachines');
            }
        };

        /**
         * Save machine data method is use for update/add machine data.
         * created on 26.10.2021
         */
        $scope.saveMachineData = function()
        {
            if (!this.machineFrm.name.$valid)
            {
                toastr.error("Please enter machine name.");
                angular.element('#name').focus();
                return;
            }
            else if (!this.machineFrm.machinelabel.$valid)
            {
                toastr.error("Please enter machine label.");
                angular.element('#machinelabel').focus();
                return;
            }

            apiService.loaderShow();

            $scope.machineId = vm.machineId;

            var bodyData = {
                name: vm.name,
                label: vm.machinelabel,
                status: vm.status,
                affected_by: $rootScope.globals.currentUser.id
            };

            $scope.saveUrl = $rootScope.baseUrl + '/database/machine';
            $scope.httpMethod = 'POST';
            $scope.machineId = vm.machineId;
            if (vm.machineId)
            {
                $scope.saveUrl = $rootScope.baseUrl + '/database/machine/' + vm.machineId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
                }else if (response.status == 'success') {
                  toastr.success(response.message);
                  $state.go('databasemachines.managemachines');
                } else {
                  $state.go('databasemachines.managemachines');
                  toastr.error("Something went wrong please try again.");
                }
            }, function(error) {
                apiService.loaderHide();
                if (error.data.code!= undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                  $state.go('databasemachines.managemachines');
                  toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * Change status method is use for change status of machine.
         * created on 26.10.2021
         */
        $scope.changeStatus = function()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status:  $rootScope.status,
                    updated_by:$rootScope.globals.currentUser.id
                };
                $http.put($rootScope.baseUrl + '/database/machines', bodyData)
                .success(function(result)
                {
                    if (result.status == 'success') {
                        toastr.success('Status updated successfully.');
                        $state.go($state.$current, null, {
                            reload: true
                        });
                    }
                    else
                    {
                        $state.go('databasemachines.managemachines');
                        toastr.error("Something went wrong please try again.");
                    }
                    apiService.loaderHide();
                })
                .error(function(error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        $scope.viewMachineSlots = function(id)
        {
            $cookies.put('machine-id',id);
            $state.go('databasemachines.machineslots');
        };

        /**
         * Open model.
         * created on 26.10.2021
         */
        $scope.open = function(page, id, status)
        {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
    }
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.databaseMachines')
            .controller('machineSlotsCtrl', machineSlotsCtrl);

    /** @ngInject */
    function machineSlotsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
    	if($rootScope.permissionArr.indexOf('database_machine_slots') == -1)
	    {
	        $state.go('dashboard');
	    	toastr.error("You don't have permission to do this.");
	    }

	    var vm = this;
	    $rootScope.currentState='databasemachines.machineslots';
	    $scope.machineTitle="Add New Slots";

	    var vm = this;
        vm.name = '';
        vm.status = '1';
        $scope.menuStatus = [{
          isOpen: true
        }];

        /**
         * Get data table method is use get list of machines.
         * created on 26.10.2021
         */
        $scope.getDataTable = function ()
        {
        	var machineId = 0;
	        if($cookies.get('machine-id') && $cookies.get('machine-id')!= undefined) {
	          machineId = $cookies.get('machine-id');
              $scope.machineId = machineId;
	        }

            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/database/slots/'+machineId)
                .success(function(result)
                {
                    if(result.length < $rootScope.numberOfRecord)
                    {
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                        }, 200);
                    }
                    vm.slots = [];
                    var index = 1 ;
                    angular.forEach(result, function(value, key)
                    {
                        var changeStatusValTo = 0;
                        
                        var editLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_edit') != -1){
                        editLinks = ' <a href="javascript:void(0);"  ng-click="editSlot(\'' + value.slot_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        }
                        
                        var deleteLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_delete') != -1){
                            deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/databaseMachines/deleteModalSlot.html' + '\',\'' + value.slot_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                        }
                        
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';

                        var statusLinks = '';
                        if($rootScope.permissionArr.indexOf('database_machine_status_change') != -1){
                        statusLinks = ' <a ng-click="open(\'' + 'app/pages/databaseMachines/statusModalSlot.html' + '\',\'' + value.slot_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        }

                        if (value.status == 0)
                        {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            if ($rootScope.permissionArr.indexOf('database_machine_status_change') != -1) {
                            statusLinks = ' <a ng-click="open(\'' + 'app/pages/databaseMachines/statusModalSlot.html' + '\',\'' + value.slot_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                            }
                        }

                        var downloadLinks = '';
                        if($rootScope.permissionArr.indexOf('slot_barcode_download') != -1){
                            downloadLinks = ' <a ng-click="downloadSlotBarcode(' + value.slot_id + ')" href="javascript:void(0);" title="Download"><i class="fa fa-download" style="color:#fff;" aria-hidden="true"></i></a>';
                        }

                        var data = {
                            index:index,
                            id: value.slot_id,
                            name: value.slot_name,
                            created_at: value.created_at,
                            status:statusBadge,
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + downloadLinks
                        };

                        this.push(data);
                        ++index;
                        
                    }, vm.slots);
                    defer.resolve(vm.slots);
                })
                .error(function (error)
                {
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            })
            .withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $scope.$apply($compile(nRow)($scope));
            });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function()
            {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No')
            ];

            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name').renderWith($scope.UcCap));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        $scope.downloadSlotBarcode = function (id)
        {
            var urdd = $rootScope.baseUrl + '/database/slot-barcode/'+id
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_slot_barcode_"+id+".pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }

        $scope.SlotBarcodes = function (id)
        {
            var urdd = $rootScope.baseUrl + '/database/slot-barcodes/'+id;
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=id+"_slot_barcodes.pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }

      	/**
         * Add slot method is use for get add slot page.
         * created on 26.10.2021
         */
        $scope.addSlot = function()
        {
            $cookies.put('slot-id',undefined);
            $state.go('databasemachines.addslot');
        };

        /**
         * Edit slot method is use for get edit slot page.
         * created on 26.10.2021
         */
        $scope.editSlot = function(id)
        {
            $cookies.put('slot-id',id);
            $state.go('databasemachines.editslot');
        };

        /**
         * Get edited slot method is use for get edited slot data.
         * created on 26.10.2021
         */
        $scope.getEditedSlot = function()
        {
            if ($cookies.get('slot-id') && $cookies.get('slot-id')!= undefined)
            {
                apiService.loaderShow();

                $http.get($rootScope.baseUrl + '/database/slot/' + $cookies.get('slot-id'))
                .success(function(response) {
                    vm.slotId = response.slot_id;
                    vm.name = response.slot_name;
                    vm.status = response.status;
                    apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            else {
                $state.go('databasemachines.addslot');
            }
        };

        /**
         * Save slot data method is use for update/add slot data.
         * created on 26.10.2021
         */
        $scope.saveSlotData = function()
        {
            if (!this.slotFrm.name.$valid)
            {
                toastr.error("Please enter slot name.");
                angular.element('#name').focus();
                return;
            }

            var machineId = 0;
	        if($cookies.get('machine-id') && $cookies.get('machine-id')!= undefined) {
	          machineId = $cookies.get('machine-id');
	        }

            apiService.loaderShow();

            $scope.slotId = vm.slotId;

            var bodyData = {
            	machine_id: machineId,
                name: vm.name,
                status: vm.status,
                affected_by: $rootScope.globals.currentUser.id
            };

            $scope.saveUrl = $rootScope.baseUrl + '/database/slot';
            $scope.httpMethod = 'POST';
            if (vm.slotId)
            {
                $scope.saveUrl = $rootScope.baseUrl + '/database/slot/' + vm.slotId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
                }else if (response.status == 'success') {
                  toastr.success(response.message);
                  $state.go('databasemachines.machineslots');
                } else {
                  //$state.go('databasemachines.machineslots');
                  toastr.error("Something went wrong please try again.");
                }
            }, function(error) {
                apiService.loaderHide();
                if (error.data.code!= undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                  $state.go('databasemachines.machineslots');
                  toastr.error("Something went wrong please try again.");
                }
            });
        };

		/**
         * Change status method is use for change status of slot.
         * created on 26.10.2021
         */
        $scope.changeStatus = function()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status:  $rootScope.status,
                    updated_by:$rootScope.globals.currentUser.id
                };
                $http.put($rootScope.baseUrl + '/database/slots', bodyData)
                .success(function(result)
                {
                    if (result.status == 'success') {
                        toastr.success('Status updated successfully.');
                        $state.go($state.$current, null, {
                            reload: true
                        });
                    }
                    else
                    {
                        $state.go('databasemachines.machineslots');
                        toastr.error("Something went wrong please try again.");
                    }
                    apiService.loaderHide();
                })
                .error(function(error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        /**
         * Open model.
         * created on 26.10.2021
         */
        $scope.open = function(page, id, status)
        {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
    }
})();
/**
 * Document controller display document list.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.25.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.document')
            .controller('documentCtrl', documentCtrl);

    /** @ngInject */
    function documentCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
        /**
        * permissionArr is use to check permission to display list
        * created on 10.5.2017
        */
        if($rootScope.permissionArr.indexOf('document_view') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'documents';
        $scope.resetGlobalSearch();
        /**
        * getDocumentData is use to get list of Document
        * created on 10.25.2017
        */
        $scope.getDocumentData = function () {
          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/document')
            .success(function(response) {
              vm.documentId = response._id;
              vm.documentTitle = response.title;
              vm.status = response.status;
              vm.description = response.content;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
    }
})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.dubaiMachines')
            .controller('dubaiMachinesCtrl', dubaiMachinesCtrl);

    /** @ngInject */
    function dubaiMachinesCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
        /**
        * permissionArr is use to check permission to display list of machines
        * created on 25.10.2021
        */
        if($rootScope.permissionArr.indexOf('manage_dubai_machines') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='dubaimachines.managemachines';
        $scope.machineTitle="Add Machines";

        var vm = this;
        vm.name = '';
        vm.status = '1';
        $scope.menuStatus = [{
          isOpen: true
        }];

        /**
         * Get data table method is use get list of machines.
         * created on 26.10.2021
         */
        $scope.getDataTable = function ()
        {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/dubai/machines')
                .success(function(result)
                {
                    if(result.length < $rootScope.numberOfRecord)
                    {
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                        }, 200);
                    }
                    vm.machines = [];
                    var index = 1 ;
                    angular.forEach(result, function(value, key)
                    {
                        var changeStatusValTo = 0;
                        
                        var editLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_edit') != -1){
                        editLinks = ' <a href="javascript:void(0);"  ng-click="editMachine(\'' + value.machine_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        }
                        
                        var deleteLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_delete') != -1){
                            deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/dubaiMachines/deleteModal.html' + '\',\'' + value.machine_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                        }
                        
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';

                        var statusLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_status_change') != -1){
                        statusLinks = ' <a ng-click="open(\'' + 'app/pages/dubaiMachines/statusModal.html' + '\',\'' + value.machine_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        }

                        if (value.status == 0)
                        {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            if ($rootScope.permissionArr.indexOf('dubai_machine_status_change') != -1) {
                            statusLinks = ' <a ng-click="open(\'' + 'app/pages/dubaiMachines/statusModal.html' + '\',\'' + value.machine_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                            }
                        }

                        var slotsLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_slots') != -1){
                            slotsLinks = ' <a ng-click="viewMachineSlots(' + value.machine_id + ')" href="javascript:void(0);" title="Slots"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></a>';
                        }

                        var downloadLinks = '';
                        if($rootScope.permissionArr.indexOf('machine_barcode_download') != -1){
                            downloadLinks = ' <a ng-click="downloadMachineBarcode(' + value.machine_id + ')" href="javascript:void(0);" title="Download"><i class="fa fa-download" style="color:#fff;" aria-hidden="true"></i></a>';
                        }

                        
                        var data = {
                            index:index,
                            id: value.machine_id,
                            name: value.machine_name,
                            created_at: value.created_at,
                            status:statusBadge,
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + slotsLinks + '&nbsp;' + downloadLinks
                        };

                        this.push(data);
                        ++index;
                        
                    }, vm.machines);
                    defer.resolve(vm.machines);
                })
                .error(function (error)
                {
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            })
            .withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $scope.$apply($compile(nRow)($scope));
            });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function()
            {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No')
            ];

            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name').renderWith($scope.UcCap));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        $scope.downloadMachineBarcode = function (id)
        {
            var urdd = $rootScope.baseUrl + '/dubai/machine-barcode/'+id
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_machine_barcode_"+id+".pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }
        
        /**
         * Add machine method is use for get add machine page.
         * created on 26.10.2021
         */
        $scope.addMachine = function()
        {
            $cookies.put('machine-id',undefined);
            $state.go('dubaimachines.addmachines');
        };

        /**
         * Edit machine method is use for get edit machine page.
         * created on 26.10.2021
         */
        $scope.editMachine = function(id)
        {
            $cookies.put('machine-id',id);
            $state.go('dubaimachines.editmachine');
        };

        /**
         * Get edited machine method is use for get edited machine data.
         * created on 26.10.2021
         */
        $scope.getEditedMachine = function()
        {
            if ($cookies.get('machine-id') && $cookies.get('machine-id')!= undefined)
            {
                apiService.loaderShow();

                $http.get($rootScope.baseUrl + '/dubai/machine/' + $cookies.get('machine-id'))
                .success(function(response) {
                    vm.machineId = response.machine_id;
                    vm.machinelabel = response.machine_label;
                    vm.name = response.machine_name;
                    vm.status = response.status;
                    apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            else {
                $state.go('dubaimachines.addmachines');
            }
        };

        /**
         * Save machine data method is use for update/add machine data.
         * created on 26.10.2021
         */
        $scope.saveMachineData = function()
        {
            if (!this.machineFrm.name.$valid)
            {
                toastr.error("Please enter machine name.");
                angular.element('#name').focus();
                return;
            }
            else if (!this.machineFrm.machinelabel.$valid)
            {
                toastr.error("Please enter machine label.");
                angular.element('#machinelabel').focus();
                return;
            }

            apiService.loaderShow();

            $scope.machineId = vm.machineId;

            var bodyData = {
                name: vm.name,
                label: vm.machinelabel,
                status: vm.status,
                affected_by: $rootScope.globals.currentUser.id
            };

            $scope.saveUrl = $rootScope.baseUrl + '/dubai/machine';
            $scope.httpMethod = 'POST';
            $scope.machineId = vm.machineId;
            if (vm.machineId)
            {
                $scope.saveUrl = $rootScope.baseUrl + '/dubai/machine/' + vm.machineId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
                }else if (response.status == 'success') {
                  toastr.success(response.message);
                  $state.go('dubaimachines.managemachines');
                } else {
                  $state.go('dubaimachines.managemachines');
                  toastr.error("Something went wrong please try again.");
                }
            }, function(error) {
                apiService.loaderHide();
                if (error.data.code!= undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                  $state.go('dubaimachines.managemachines');
                  toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * Change status method is use for change status of machine.
         * created on 26.10.2021
         */
        $scope.changeStatus = function()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status:  $rootScope.status,
                    updated_by:$rootScope.globals.currentUser.id
                };
                $http.put($rootScope.baseUrl + '/dubai/machines', bodyData)
                .success(function(result)
                {
                    if (result.status == 'success') {
                        toastr.success('Status updated successfully.');
                        $state.go($state.$current, null, {
                            reload: true
                        });
                    }
                    else
                    {
                        $state.go('dubaimachines.managemachines');
                        toastr.error("Something went wrong please try again.");
                    }
                    apiService.loaderHide();
                })
                .error(function(error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        $scope.viewMachineSlots = function(id)
        {
            $cookies.put('machine-id',id);
            $state.go('dubaimachines.machineslots');
        };

        /**
         * Open model.
         * created on 26.10.2021
         */
        $scope.open = function(page, id, status)
        {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        $scope.deleteMachine = function()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    updated_by:$rootScope.globals.currentUser.id
                };
                $http.delete($rootScope.baseUrl + '/dubai/machine/' + $rootScope.deleteId)
                .success(function(result)
                {
                    if (result.status == 'success') {
                        toastr.success('Machine deleted successfully.');
                        $state.go($state.$current, null, {
                            reload: true
                        });
                    }
                    else
                    {
                        $state.go('dubaimachines.managemachines');
                        toastr.error("Something went wrong please try again.");
                    }
                    apiService.loaderHide();
                })
                .error(function(error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        }
    }
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.dubaiMachines')
            .controller('machineSlotsCtrl', machineSlotsCtrl);

    /** @ngInject */
    function machineSlotsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
    	if($rootScope.permissionArr.indexOf('dubai_machine_slots') == -1)
	    {
	        $state.go('dashboard');
	    	toastr.error("You don't have permission to do this.");
	    }

	    var vm = this;
	    $rootScope.currentState='dubaimachines.machineslots';
	    $scope.machineTitle="Add New Slots";

	    var vm = this;
        vm.name = '';
        vm.status = '1';
        $scope.menuStatus = [{
          isOpen: true
        }];

        /**
         * Get data table method is use get list of machines.
         * created on 26.10.2021
         */
        $scope.getDataTable = function ()
        {
        	var machineId = 0;
	        if($cookies.get('machine-id') && $cookies.get('machine-id')!= undefined) {
	          machineId = $cookies.get('machine-id');
              $scope.machineId = machineId;
	        }

            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/dubai/slots/'+machineId)
                .success(function(result)
                {
                    if(result.length < $rootScope.numberOfRecord)
                    {
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                        }, 200);
                    }
                    vm.slots = [];
                    var index = 1 ;
                    angular.forEach(result, function(value, key)
                    {
                        var changeStatusValTo = 0;
                        
                        var editLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_edit') != -1){
                        editLinks = ' <a href="javascript:void(0);"  ng-click="editSlot(\'' + value.slot_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        }
                        
                        var deleteLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_delete') != -1){
                            deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/dubaiMachines/deleteModalSlot.html' + '\',\'' + value.slot_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                        }
                        
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';

                        var statusLinks = '';
                        if($rootScope.permissionArr.indexOf('dubai_machine_status_change') != -1){
                        statusLinks = ' <a ng-click="open(\'' + 'app/pages/dubaiMachines/statusModalSlot.html' + '\',\'' + value.slot_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        }

                        if (value.status == 0)
                        {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            if ($rootScope.permissionArr.indexOf('dubai_machine_status_change') != -1) {
                            statusLinks = ' <a ng-click="open(\'' + 'app/pages/dubaiMachines/statusModalSlot.html' + '\',\'' + value.slot_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                            }
                        }

                        var downloadLinks = '';
                        if($rootScope.permissionArr.indexOf('slot_barcode_download') != -1){
                            downloadLinks = ' <a ng-click="downloadSlotBarcode(' + value.slot_id + ')" href="javascript:void(0);" title="Download"><i class="fa fa-download" style="color:#fff;" aria-hidden="true"></i></a>';
                        }

                        var data = {
                            index:index,
                            id: value.slot_id,
                            name: value.slot_name,
                            created_at: value.created_at,
                            status:statusBadge,
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + downloadLinks
                        };

                        this.push(data);
                        ++index;
                        
                    }, vm.slots);
                    defer.resolve(vm.slots);
                })
                .error(function (error)
                {
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            })
            .withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                $scope.$apply($compile(nRow)($scope));
            });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function()
            {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No')
            ];

            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name').renderWith($scope.UcCap));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        $scope.downloadSlotBarcode = function (id)
        {
            var urdd = $rootScope.baseUrl + '/dubai/slot-barcode/'+id
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_slot_barcode_"+id+".pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }

        $scope.SlotBarcodes = function (id)
        {
            var urdd = $rootScope.baseUrl + '/dubai/slot-barcodes/'+id;
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=id+"_slot_barcodes.pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }

      	/**
         * Add slot method is use for get add slot page.
         * created on 26.10.2021
         */
        $scope.addSlot = function()
        {
            $cookies.put('slot-id',undefined);
            $state.go('dubaimachines.addslot');
        };

        /**
         * Edit slot method is use for get edit slot page.
         * created on 26.10.2021
         */
        $scope.editSlot = function(id)
        {
            $cookies.put('slot-id',id);
            $state.go('dubaimachines.editslot');
        };

        /**
         * Get edited slot method is use for get edited slot data.
         * created on 26.10.2021
         */
        $scope.getEditedSlot = function()
        {
            if ($cookies.get('slot-id') && $cookies.get('slot-id')!= undefined)
            {
                apiService.loaderShow();

                $http.get($rootScope.baseUrl + '/dubai/slot/' + $cookies.get('slot-id'))
                .success(function(response) {
                    vm.slotId = response.slot_id;
                    vm.name = response.slot_name;
                    vm.status = response.status;
                    apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            else {
                $state.go('dubaimachines.addslot');
            }
        };

        /**
         * Save slot data method is use for update/add slot data.
         * created on 26.10.2021
         */
        $scope.saveSlotData = function()
        {
            if (!this.slotFrm.name.$valid)
            {
                toastr.error("Please enter slot name.");
                angular.element('#name').focus();
                return;
            }

            var machineId = 0;
	        if($cookies.get('machine-id') && $cookies.get('machine-id')!= undefined) {
	          machineId = $cookies.get('machine-id');
	        }

            apiService.loaderShow();

            $scope.slotId = vm.slotId;

            var bodyData = {
            	machine_id: machineId,
                name: vm.name,
                status: vm.status,
                affected_by: $rootScope.globals.currentUser.id
            };

            $scope.saveUrl = $rootScope.baseUrl + '/dubai/slot';
            $scope.httpMethod = 'POST';
            if (vm.slotId)
            {
                $scope.saveUrl = $rootScope.baseUrl + '/dubai/slot/' + vm.slotId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function(response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
                }else if (response.status == 'success') {
                  toastr.success(response.message);
                  $state.go('dubaimachines.machineslots');
                } else {
                  //$state.go('databasemachines.machineslots');
                  toastr.error("Something went wrong please try again.");
                }
            }, function(error) {
                apiService.loaderHide();
                if (error.data.code!= undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                  $state.go('dubaimachines.machineslots');
                  toastr.error("Something went wrong please try again.");
                }
            });
        };

		/**
         * Change status method is use for change status of slot.
         * created on 26.10.2021
         */
        $scope.changeStatus = function()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status:  $rootScope.status,
                    updated_by:$rootScope.globals.currentUser.id
                };
                $http.put($rootScope.baseUrl + '/dubai/slots', bodyData)
                .success(function(result)
                {
                    if (result.status == 'success') {
                        toastr.success('Status updated successfully.');
                        $state.go($state.$current, null, {
                            reload: true
                        });
                    }
                    else
                    {
                        $state.go('dubaimachines.machineslots');
                        toastr.error("Something went wrong please try again.");
                    }
                    apiService.loaderHide();
                })
                .error(function(error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        /**
         * Open model.
         * created on 26.10.2021
         */
        $scope.open = function(page, id, status)
        {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.faqFrontend')
            .controller('faqFrontendCtrl', faqFrontendCtrl);

    /** @ngInject */
    function faqFrontendCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
        /**
        * permissionArr is use to check permission to display list
        * created on 10.5.2017
        */
        if($rootScope.permissionArr.indexOf('faq_frontend_list') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'faq-frontend';
        $scope.resetGlobalSearch();
        /**
        * status and status1 is use to default open accordion
        * created on 10.5.2017
        */
        $scope.status=true;
        $scope.status1=false;
        vm.faqFrontendData=[];
        /**
        * getFAQData is use to get list of FAQ
        * created on 10.5.2017
        */
        $scope.getFAQData = function () {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/faq/active')
              .success(function (result) {
                  apiService.loaderHide();
                 vm.faqFrontendData=result;
              }).error(function (error) {
                  apiService.loaderHide();
                  if (error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
    }
})();

/**
 * Login page controller handle all action related user authentication.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 09.12.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.login')
            .controller('loginCtrl', loginCtrl);

    /** @ngInject */
    function loginCtrl($scope, $rootScope, $cookies, $state, $http, toastr, apiService, $window, Idle,router, typeRouter) {

        /**
        * Login method is use for authenticat user.
        * created on 09.12.2017
        */
       $scope.emailAdd = $cookies.get("userName");
       $scope.password = $cookies.get("password");

       if(angular.element("div.fade.modal-backdrop").length){
        	angular.element("div.fade.modal-backdrop").remove();
        }
        if(angular.element("body").hasClass("modal-open")){
          angular.element("body").removeClass("modal-open");
        }
        $scope.login = function () {
            Idle.watch();
            var username = $.trim(this.emailAdd);
            var password = this.password;
            var isUsername = true;


            if(username.indexOf('@') !== -1){
                isUsername = false;
            }
            if (!$scope.loginFrm.emailAdd.$valid && !isUsername) {
                    toastr.error("Please enter email.");
                    return;
            }
            if (!username) {
                angular.element('#inputEmail').focus();
                toastr.error("Please enter username / email.");
                return;
            }
            if (!$scope.loginFrm.password.$valid) {
                angular.element('#inputPassword').focus();
                toastr.error("Please enter password.");
                return;
            }
            apiService.popupShow();
            angular.element('.btn-login').attr('disabled','disabled');
            var bodyData = {
                email: username.toLowerCase(),
                password: password,
            };
            $http({
                url: $rootScope.baseUrl + '/user/login',
                method: "POST",
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                var response = response.data;
                apiService.popupHide();
                if (response.status == 'success') {
                    angular.element('.auth-main').addClass('hide-element');
                    $rootScope.globals = {
                        currentUser: {
                            email: username,
                            name: response.data.name,
                            firstname:response.data.first_name,
                            lastname:response.data.last_name,
                            authdata: response.data.tokenData.access_token,
                            userRole: response.data.role,
                            gender:response.data.gender,
                            profile_pic:(response.data.profile_pic?response.data.profile_pic+'?'+ new Date().getTime():undefined),
                            permission: response.data.permissionArr,
                            statusPermission:response.data.statusPermission,
                            store_permission:response.data.store_permission,
                            mall_customer_permission:response.data.mall_customer_permission,
                            id: response.data.id,
                            customer_id:response.data.customer_id,
                            open_job_override_folder:response.data.open_job_override_folder,
                            open_job_default_folder : response.data.open_job_default_folder,
                            open_job_db_override_folder:response.data.open_job_db_override_folder,
                            open_job_db_default_folder :response.data.open_job_db_default_folder
                        }
                    };
                    $rootScope.permissionArr = response.data.permissionArr;
                    $rootScope.globalSetting = response.data.globalSetting;
                    $rootScope.userRole=response.data.role;
                    $rootScope.userId=response.data.id;
                    $rootScope.customerId=response.data.customer_id;
//                  var encrypted = CryptoJS.AES.encrypt(JSON.stringify($rootScope.globals), "images75long9tinsel");
//                  $window.localStorage.setItem('globals',encrypted);

                    $window.localStorage.setItem('globals',apiService.encriptData($rootScope.globals));



//                  var encrypted = CryptoJS.AES.encrypt(JSON.stringify(response.data.globalSetting), "images75long9tinsel");
//                  $window.localStorage.setItem('settings',encrypted);

                    $window.localStorage.setItem('settings',apiService.encriptData($rootScope.globalSetting));

                    $http.defaults.headers.common['Authorization'] = 'bearer ' + response.access_token; // set authorization
                    if ($scope.rememberme) {
                        $cookies.put("userName", username);
                        $cookies.put("password", password);
                    }else{
//                        $cookies.remove("userName");
//                        $cookies.remove("password");
                    }
                    $rootScope.currentState='dashboard';
                    $state.go('dashboard');
                    toastr.success('Logged in successfully.');
                } else {
                    if (response.message) {
                        if(response.message == 'Record not found.'){
                          toastr.error('Invalid '+(isUsername?'username':'email')+' or password.');
                        }else
                        toastr.error(response.message);
                    } else {
                        $state.go('login');
                        toastr.error("Something went wrong please try again.");
                    }
                }
                angular.element('.btn-login').prop("disabled", false);
            }, function (response) {
                angular.element('.btn-login').prop("disabled", false);
                 apiService.popupHide();
                var response = response.data;
                if (response.code && response.code == 0) {
                    toastr.error(response.message);
                } else {
                    $state.go('login');
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
        $scope.getLogo = function() {
         // get order status
         $http.get($rootScope.baseUrl + '/order/logo')
             .success(function (result) {
               $scope.loginLogo=result.data.file;
             }).error(function (error) {
                 if (error.data && error.data.code != undefined && error.data.code == 0) {
                     toastr.error(error.data.message);
                 }
             });
           }
       // block list -- start
       $scope.getProductBlockList=function(){
         localStorage.removeItem('blockList');
         $http.get($rootScope.baseUrl + '/products/block',{cache: true})
                 .success(function(result) {
                   localStorage.setItem('blockList',JSON.stringify(result));
                   router.setUpRoutes();
                 }).error(function (error) {
                     if (error.data.code != undefined && error.data.code == 0) {
                         toastr.error(error.data.message);
                     }
                 });
       }
       $scope.getProductBlockList();
       // block list -- end
       
       
       //Get sticker type for dynamic sticker
       $scope.getStickerList=function(){
            localStorage.removeItem('stickerTypeList');
            $http.get($rootScope.baseUrl + '/get-active-sticker-type', {cache: true})
                    .success(function (result) {
                        console.log(JSON.stringify(result));
                        localStorage.setItem('stickerTypeList', JSON.stringify(result));
                        typeRouter.setUpTypeRoutes();
                    }).error(function (error) {
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
       }
       $scope.getStickerList();
    }
})();

/**
 * Orders controller handle all action related orders.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 09.27.2017
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.orders')
            .controller('ordersCtrl', ordersCtrl);

    /** @ngInject */
    function ordersCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
      $rootScope.currentState = $state.current.name;
      $rootScope.shipmentOderNumber = '';
      $scope.changeOrderDateButtonData = '';
      $scope.changeOrderCreatedDateOrderId = 0;
      $scope.activeTabIndex = 0;
      $scope.ItemIncrementID = '';
      $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer','3D Designer','Slot Name','Machine Name','DB Status','Tracking Number','Keyword','Region'];
      $scope.colvisOption = [{name: 'colvis',text: 'Select Columns',extend: 'colvis'}]//columns: ':gt(0)'
      
      var that = this;
      that.weight_lbs = 0;
      that.service = '';
      that.account = '';
      that.service_type = '';
      that.total_weight = 0;

      var stage;
      var history = [];
      var backgroundLayer;
      var drawingLayer;
      var isDrawing;
      var currentLine;
      var currentColor = 'rgba(255, 0, 0, 0.4)';
      var currentBrushSize = 20;
      
      $scope.show_shipping_tag = 0;
      $scope.scan_complete = 0;
      $scope.total_weight = 0;
      $scope.defaultService = '';
      $scope.defaultFedex = 0;
      $scope.defaultUSPS = 0;
      $scope.defaultOffice = 0;
      $scope.changeDefaultService = '';
      $scope.fedexpackage = '';
      $scope.show_new_shipping = 0;
      $scope.mask_button_status = ['paid','paid_express','express_design_processing','3d_design_proccessing','3d_design_complete','order_in_design','express_complete','express_order_in_design','order_uploaded_to_relay','order_verified_in_relay',
      'express_uploaded_to_relay','express_verified_in_relay'];

      $scope.checkMaskImageStatus = function(value) {
        //console.log(value);
        //console.log($scope.mask_button_status.includes(value));
        return $scope.mask_button_status.includes(value);
      };

      $scope.selected = {};
      $scope.selectAll = false;
      $scope.isChangeStatus={change:false};
      $scope.isRelayUpload={upload:false};
      $scope.isSelected={select:false};
      $scope.customerStatus = [];
      $scope.fedex_rates = [];

      $scope.download_2d_image = true;
      $scope.editBtnStatus = false;

      $scope.editsoldto = false;
      $scope.editshipto = false;

      $scope.add_business = false;
      $scope.add_home = false;
      $scope.show_checkbox = false;
      $scope.address_verified = false;
      $scope.switch_shipping = "false";

      $scope.packagesaved = false;
      $scope.adpkg = false;
      $scope.custom_packages = 0;
      $scope.order_total_weight = 0;
      
      $scope.orderServiceType = [];
      $scope.ShipmentAccounts = [];
      $scope.ShipmentBoxes = [];
      $scope.packagesdata = [];
      $scope.amazonServices = [];
      $scope.searchByOldNewRelay = '';

      $scope.shipped_by='';
      $scope.delivered_by='';

      $scope.open = open;
      $scope.opened = false;
      $scope.formats = ['yyyy-mm-dd','dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      $scope.format = $scope.formats[0];
      $scope.ship_options = {
          showWeeks: false
      };


      $scope.opendt = function(){
        $scope.opened = true;
      }

      $scope.getRateDone = true;

      $scope.toggleAll=function(selectAll, selectedItems)
      {
        for (var id in selectedItems)
        {
          if (selectedItems.hasOwnProperty(id)) {
            selectedItems[id] = selectAll;
          }
        }
      };

      $scope.toggleOne=function(selectedItems)
      {
        for (var id in selectedItems)
        {
          if (selectedItems.hasOwnProperty(id))
          {
            if(!selectedItems[id])
            {
              $scope.selectAll = false;
              return;
            }
          }
        }
        $scope.selectAll = true;
      }
      
      /**
        * configuration datatable instance
        * created on 10.06.2017
      */
      $scope.vmAdded = this;
      $scope.orderDetailsData = {};
      $scope.jobtypeArr = ['2D-3D', '2D Flat', '2D Flat One','2D-3D One'];
      $scope.engravingArr = ['Add ENG','No ENG'];
      $scope.progressbar = ngProgressFactory.createInstance();
      $scope.progressbar.setHeight('5px');
      
      /**
        * configuration of UI-SELECT for order status filter
        * created on 10.06.2017
      */
      if($rootScope.searchStatus)
      {
        $scope.orderStatusSelected={
          selected : {label:$rootScope.searchLable ,value:$rootScope.searchStatus}
        };
        $scope.dashboardBlock=$rootScope.dashboardBlockName;
      }
      else 
      {
        $scope.orderStatusSelected = {
          selected:{}
        };
      }
      
      /**
         * Add global search on order table
         * Created on 09.02.2018
         */
        if($rootScope.globalsearchBy && $rootScope.globalSearch){
            $timeout(function () {
                $scope.serchBy = $rootScope.globalsearchBy;
                $scope.SearchQuery = $rootScope.globalSearch;
                $scope.vmAdded.dtInstance.DataTable.draw();
            }, 100);
        }

        $timeout(function () {
           angular.element('.input-mini').attr('readonly',true);
        }, 1000);

        console.log($stateParams.type);
        
        if($stateParams.type == 'regular' && $rootScope.shipDashFromDate !== "undefined")
        {
            $rootScope.datePickerRegular = {
                date: {
                  startDate: $rootScope.shipDashFromDate,
                  endDate: $rootScope.shipDashToDate
                }
              };
           $rootScope.datePickerOrder = {
                date: {
                  startDate: $rootScope.shipDashFromDate,
                  endDate: $rootScope.shipDashToDate
                }
              };
        }
        else if($stateParams.type == 'express' && $rootScope.shipDashFromDate !== "undefined")
        {
            $rootScope.datePickerRegular = {
                date: {
                  startDate: $rootScope.shipDashFromDate,
                  endDate: $rootScope.shipDashToDate
                }
              };
           $rootScope.datePickerOrder = {
                date: {
                  startDate: $rootScope.shipDashFromDate,
                  endDate: $rootScope.shipDashToDate
                }
              };
        }
        else
        {
            $rootScope.datePickerOrder = {};
            //$rootScope.datePickerOrder.date = $rootScope.datePicker.date;
            
            if(!$rootScope.datePickerRegular){
              $rootScope.datePickerRegular = {date:$rootScope.datePicker.date};
              $rootScope.datePickerOrder = {date:$rootScope.datePicker.date};
             }else{
               $scope.datePickerRegularShow = true;
               $rootScope.datePickerOrder = {date:$rootScope.datePickerRegular.date};
             }
             
             console.log($rootScope.datePickerOrder);
            if($rootScope.customerName){
                $scope.datePickerOrderShow = false;
                $scope.customerName = $rootScope.customerName;
            }else{
                $scope.datePickerOrderShow = true;
            }
        }

        $scope.openBugReport = function ()
        {
          $scope.bugOrderNumber = $rootScope.orderId;
          $cookies.put('bug-order-number', $rootScope.orderId);
          $scope.bugEmail = $rootScope.globals.currentUser.email_address;
          
          $http.get($rootScope.baseUrl + '/bugreport/shipment_bug_report')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else if (result.status == 'success')
              {
                if (result.data)
                {
                  var result = result.data;
                  //console.log(result.data.shipment_bug_report.bugreporturl);
                  var bugreporturl = result.data.shipment_bug_report.bugreporturl;

                  //var w = window.open("https://bugtracker.zoho.com/portal/3dinnovation/bugiframe.do?projId=57a14e083bf62172224d41c2db9a707e0873c4983b70ef9c&fId=57a14e083bf6217206c9405b7e4e9ec413902cd0809a1c14&action=getiframe&embed=false", "popupWindow", "width=800, height=800, scrollbars=no, top=20, left=350");
                  var w = window.open(bugreporturl, "popupWindow", "width=800, height=800, scrollbars=no, top=20, left=350");
                }
              }
              else {
                toastr.error(result.message);
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        };


        $scope.onSelect = function(item, $model) { };

        /**
        * Api search for order status method is use search order status for filter
        * created on 10.06.2017
        */
        $scope.apiSearchForOrderStatus = function (query)
        {
            if(!$rootScope.globals.currentUser || !$rootScope.globals.currentUser.statusPermission){
                return false;
            }
            var defaultStatus = $rootScope.globals.currentUser.statusPermission.toString();
            $http.post($rootScope.baseUrl + '/status/active',{status:query?query:'',defaultStatus:defaultStatus}).then(
            function (response) {
                var temp = []
                 angular.forEach(response.data,function(value){
                    if($rootScope.searchStatus != value.status_label){
                      temp.push({label: value.status_label, value: value.status_code});
                    }
                });
                //$scope.listOrderStatus.devs = temp;
                $scope.listOrderStatus = temp;
                angular.element(document).ready(function () {
                        angular.element('#orderStatus').selectpicker('refresh');
                    });
            },
            function () {

            });
        }
        $scope.datePickerShip = {};
        $scope.dt = new Date();
        $scope.datePickerShip.options = {
          'Today': [moment(), moment()]
        };

        $scope.datePickerShip.locale = {
          customRangeLabel: 'Custom Date'
        };

        $scope.opened = false;
        $scope.formats = ['yyyy-MM-dd','dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.shipoptions = {
            minDate: moment().format('YYYY-MM-DD'),
            showWeeks: false
        };

        function openshipdate() {
          $scope.amazonServices = [];
            $scope.opened = true;
        }
        $scope.popup1 = {
    opened: false
  };
        $scope.open1 = function() {
          $scope.amazonServices = [];
    $scope.popup1.opened = true;
  };
        $scope.datePickerShip.date = moment().format('YYYY-MM-DD');

        $scope.focusDate=function(){
          angular.element('#shipDate').focus();
        };
        /**
        * Options method is use configure date picker options
        * created on 10.06.2017
        */
        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerOrderShow = true;
                     $rootScope.datePickerOrder.date.startDate = moment($rootScope.datePickerOrder.date.startDate).format('YYYY-MM-DD');
                     $rootScope.datePickerOrder.date.endDate = moment($rootScope.datePickerOrder.date.endDate).format('YYYY-MM-DD');
                },
                'hide.daterangepicker':function() {
                    $rootScope.datePickerOrder.date.startDate = moment($rootScope.datePickerOrder.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePickerOrder.date.endDate = moment($rootScope.datePickerOrder.date.endDate).format('YYYY-MM-DD');
                }
            }
        }

        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }
        $scope.showFilters = false;
        /**
        * Search apply is use to apply filters
        * created on 10.05.2017
        */
        $scope.searchApply = function ()
        {
            console.log($rootScope.datePickerOrder.date.startDate);
            console.log($rootScope.datePickerOrder.date.endDate);
            if($scope.orderStatusSelected.selected){
              $rootScope.searchStatus = $scope.orderStatusSelected.selected.value;
              //$scope.showStatusArr = $scope.orderStatusSelected.selected.label;
              $rootScope.searchLable = $scope.orderStatusSelected.selected.label;
            }else{
               $rootScope.searchStatus='';  
            }
            $scope.vmAdded.dtInstance.DataTable.draw();
            $('#statusModelCompany').modal('hide');
        }

        /**
        * orderList Global Search use to search global
        * created on 10.04.2017
        */
        $scope.orderListGlobalSearchLocal = function ()
        {
            var query = angular.element('#searchInput').val();
            if(!query){
               $scope.serchBy = 'Select Search By';
            } else {
               //$scope.serchBy = 'Product';
               $scope.serchBy = 'Keyword';
            }
            $scope.SearchQuery = query;
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /*$rootScope.$on("CallParentMethod", function(){
           $scope.orderListGlobalSearchLocal();
        });*/

         var customeEventListener = $rootScope.$on("CallParentMethod", function(){
           $scope.orderListGlobalSearchLocal();
        });

        $scope.$on('$destroy', function() {
            customeEventListener();
            $scope.$on('CallParentMethod', function(event, data) {});
        });

        /**
        * remove Single Filter method is use to remove single filter
        * created on 10.12.2017
        */
        $scope.removeSingleFilter = function (type)
        {
            if(type == 'date'){
                $scope.datePickerOrderShow = false;
                $rootScope.datePickerOrder.date={};
            }else if(type == 'query'){
                 $scope.serchBy = 'Select Search By';
                 $scope.SearchQuery = '';
                 $rootScope.globalsearchBy = '';
                 $rootScope.globalSearch = '';
            }else if(type == 'customerName'){
                 $scope.customerName = '';
                 $rootScope.customerName = undefined;
            }else if(type == 'customerEmail'){
                 $scope.customerEmail = '';
                 $rootScope.customerEmail = undefined;
            }else if(type == 'trackingNumber'){
                 $scope.trackingNumber = '';
                 $rootScope.trackingNumber = undefined;
            }else if(type == 'country'){
                 $scope.country = '';
            }else if(type == 'customerPhone'){
                 $scope.customerPhone = '';
                 $rootScope.customerPhone = undefined;
            }else if(type == 'companyName'){
                  $scope.companyName = '';
            }else if(type == 'searchStatus'){
                  $rootScope.searchStatus = undefined;
                  //$scope.showStatusArr = [];
                  $rootScope.searchLable = undefined;
                  //$rootScope.dashboardBlockName=undefined;
                  $scope.orderStatusSelected = {
                    selected:{}
                  };
                  angular.element(document).ready(function () {
                          angular.element('#orderStatus').selectpicker('refresh');
                      });
            }else if(type == 'dashboardBlock'){
                  $scope.dashboardBlock = undefined;
                  $rootScope.dashboardBlockName = undefined;
            }else if(type == 'store'){
                  $scope.store = '0';
            }else if(type == 'jobtype'){
                  $scope.jobtype = '0';
            }else if(type == 'engraving'){
                  $scope.engraving = '0';
            }else if(type == 'searchByType'){
                  $scope.searchByType= '';
            }
            else if(type == 'shipdt'){
                  $scope.shipdt= '';
            }
            else if(type == 'crontype'){
                  $scope.crontype= '';
            }
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        /**
        * reset Search is use to reset filters
        * created on 10.04.2017
        */
        $scope.resetSearch = function ()
        {
            $stateParams.type = 'allOrders';
            $rootScope.shipDashFromDate = undefined;
            $rootScope.searchStatus = undefined;
            $scope.orderStatusSelected = {
              selected:{}
            };
            angular.element(document).ready(function () {
                    angular.element('#orderStatus').selectpicker('refresh');
                });
            $rootScope.customerName = undefined;
            $rootScope.trackingNumber = undefined;
            //$scope.showStatusArr = [];
            $rootScope.searchLable = undefined;
            $scope.dashboardBlock = undefined;
            $rootScope.dashboardBlockName = undefined;
            $scope.serchBy = 'Select Search By';
            $scope.SearchQuery = '';
            $scope.customerName = '';
            $scope.customerEmail = '';
            $scope.customerPhone = '';
            $scope.trackingNumber = '';
            $scope.companyName = '';
            $scope.country = '';
            $scope.shipdt= '';
            $scope.store = '0';
            $scope.jobtype = '0';
            $scope.engraving = '0';
            $scope.crontype= '';
            $scope.searchByOldNewRelay = '';
            //$scope.datePickerOrderShow = false;
            //$rootScope.datePickerOrder = {date:$rootScope.datePicker.date};
            $rootScope.datePickerOrder.date={startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $scope.vmAdded.dtInstance.DataTable.draw();
        }



        $scope.uploadPicture = function (itemId,type,sort)
        {
          $scope.sort = sort;
          $scope.itemId = itemId;
          $scope.itemType = type;
          var fileInput = document.getElementById('uploadImageFile'+sort);
          fileInput.click();
        };

        $scope.uploadMask = function (itemId,type,sort)
        {
          $scope.sort = sort;
          $scope.itemId = itemId;
          $scope.itemType = type;
          var fileInput = document.getElementById('uploadImageMask'+sort);
          fileInput.click();
        };

        $scope.getFile = function ()
        {
          apiService.loaderShow();
          if($scope.itemType == 'regular') {
            var file = document.getElementById("uploadImageFile"+$scope.sort).files[0];
          }
          else if($scope.itemType == 'mask') {
            var file = document.getElementById("uploadImageMask"+$scope.sort).files[0];  
          }

          $http(
          {
            url: $rootScope.baseUrl+'/orderdetail/upload-image-manually',
            method: 'POST',
            headers: {'Content-Type': undefined},
            transformRequest: function (data)
            {
              var formData = new FormData();
              formData.append("file", file);
              formData.append("order_id",$rootScope.orderEntityId);
              formData.append("item_id",$scope.itemId);
              formData.append("type",$scope.itemType);
              return formData;
            },
          }).then(function (response)
          {
            apiService.loaderHide();
            $("input[name='uploadImageFile"+$scope.sort+"']").val('');
            $("input[name='uploadImageMask"+$scope.sort+"']").val('');
            $scope.sort = "";
            $scope.itemId = "";
            $scope.itemType= "";
            var response = response.data;
            if (response.status == 'success') {
              toastr.success('Image Saved successfully');
              $scope.getOrderDetails();
              $scope.getOrderDetailsData();
            }
          }, function (response) {
            $("input[name='uploadImageFile"+$scope.sort+"']").val('');
            $("input[name='uploadImageMask"+$scope.sort+"']").val('');
            apiService.loaderHide();
            var response = response.data;
            if(response.status && response.status == 'error'){
              toastr.error(response.message);
            }else{
              toastr.error("Something went wrong please try again.");
            }
          });
        };

        $scope.makeMaskImage = function (itemId,type,sort, url)
        {
          
          var requestData={
              url : url,
              item_increment_id: itemId
            };

          $http.post($rootScope.baseUrl + '/order/makemasktemp', requestData)
        .success(function(result) {
          //alert(result.url);
          if(result.status == 'success') {
                $('#makeMaskPopup').modal();
              var img = new Image();
              img.src = result.url;
              //console.log(url);
              img.crossOrigin = 'Anonymous';
              img.onload = function()
              {
                var aspectRatio = img.width / img.height;
                var newWidth;
                var newHeight;
                if (window.innerWidth / window.innerHeight > aspectRatio) {
                    newHeight = window.innerHeight * 0.8;
                    newWidth = newHeight * aspectRatio;
                } else {
                    newWidth = window.innerWidth * 0.8;
                    newHeight = newWidth / aspectRatio;
                }

                var container = document.getElementById('container');
                container.style.width = newWidth+"px";
                container.style.height = newHeight+"px";

                // Create a new stage and layers
                if (stage) {
                    stage.destroy();
                }
                stage = new Konva.Stage({
                    container: 'container',
                    width: newWidth,
                    height: newHeight
                });

                // Create a new stage and layers
                if (stage) {
                  stage.destroy();
                }
                stage = new Konva.Stage({
                  container: 'container',
                  width: newWidth,
                  height: newHeight
                });

                backgroundLayer = new Konva.Layer();
                drawingLayer = new Konva.Layer();
                stage.add(backgroundLayer);
                stage.add(drawingLayer);

                var konvaImage = new Konva.Image({
                  x: 0,
                  y: 0,
                  image: img,
                  width: newWidth,
                  height: newHeight
                });
                
                backgroundLayer.add(konvaImage);
                backgroundLayer.draw();
                history = []; // Initialize history with the initial state
              };
            }
          }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
        
            
              
        }

        $scope.addBrush = function (color, buttonId)
        {
          //console.log(buttonId);
            currentColor = color;
            
            document.getElementById(buttonId).style.opacity = '1';
            document.getElementById(buttonId).classList.add('selected');

            stage.off('mousedown touchstart');
            stage.off('mousemove touchmove');
            stage.off('mouseup touchend');

            stage.on('mousedown touchstart', function () {
                isDrawing = true;
                var pos = stage.getPointerPosition();
                currentLine = new Konva.Line({
                    stroke: currentColor,
                    strokeWidth: currentBrushSize,
                    globalCompositeOperation: 'source-over',
                    points: [pos.x, pos.y],
                    lineCap: 'round',
                    lineJoin: 'round'
                });
                drawingLayer.add(currentLine);
            });

            stage.on('mousemove touchmove', function () {
                if (!isDrawing) return;
                var pos = stage.getPointerPosition();
                var newPoints = currentLine.points().concat([pos.x, pos.y]);
                currentLine.points(newPoints);
                drawingLayer.batchDraw();
            });

            stage.on('mouseup touchend', function () {
                isDrawing = false;
                history.push(currentLine);
            });
        }

        $scope.changeBrushSize = function (event, size)
        {
          $(".brush-size").removeClass("selected");
          $("#brush"+size).addClass("selected");
          currentBrushSize = parseInt(event.target.dataset.size, 10);
        }

        $scope.saveMaskImage = function (item_increment_id)
        {
          apiService.loaderShow();
          var dataURL = stage.toDataURL();
            var link = document.createElement('a');
            //console.log(dataURL);
            var requestData={
              order_id:  $rootScope.orderEntityId,
              item_increment_id: item_increment_id,
              url : dataURL
            };

            //console.log(requestData);

            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/order/savemaskimage',
                data: requestData,
                headers: {
                    'Content-type': 'application/json'
                },
                timeout: canceler.promise
            }).then(function(result) {
              $scope.closeMaskImage();
              toastr.success('Image Saved successfully');
              $scope.getOrderDetails();
              $scope.getOrderDetailsData();
              apiService.loaderHide();
            },function errorCallback(response) {
              apiService.loaderHide();
                if(response.status && response.status != -1){
                 
                }
            });
        }

        $scope.closeMaskImage = function ()
        {
          $('#makeMaskPopup').modal('hide'); 
        }

        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.storeDataArrAssoc = {};
        $scope.getStoreData = function ()
        {
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 $scope.storeData = result;
                 angular.forEach($scope.storeData,function(value){
                     $scope.storeDataArrAssoc[value.store_id] = value.store_name;
                });
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        var canceler = $q.defer();
        /**
        * Server data method is use for load data from API.
        * created on 09.27.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            $scope.checkS =  canceler.resolve();

            canceler = $q.defer();

            var isCustomerList = true;
            var prmissionArr = [];
            if($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.statusPermission){
               prmissionArr = $rootScope.globals.currentUser.statusPermission.toString();
            }
            var storePrmissionArr = [];
            if($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.store_permission){
               storePrmissionArr = $rootScope.globals.currentUser.store_permission.toString();
            }
            
            var mallCustomerPrmissionArr = [];
            if($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.mall_customer_permission){
               mallCustomerPrmissionArr = $rootScope.globals.currentUser.mall_customer_permission.toString();
            }
            var log = [];
            var columname = '';
            var sortColmkey = '';
            angular.forEach(aoData[1].value, function (value, key) {
              if (value.data == 'created_at') {
                    columname = value.data
                    sortColmkey = key;
                }

            }, log);
 
            var sortColumnName=aoData[1].value[aoData[2].value[0].column].data;
            console.log($rootScope.datePickerOrder.date.startDate);
            console.log($rootScope.datePickerOrder.date.endDate);
            
            var requestData={
              start: aoData[3].value,
              length: aoData[4].value,
              draw: aoData[0].value,
              order: aoData[2].value,
              search: aoData[5].value,
              columns: aoData[1].value,
              sortcolum:columname,
              sortColmkey: sortColmkey,
              search_column: $scope.serchBy?$scope.serchBy:'',
              query_string: $scope.SearchQuery?$scope.SearchQuery:'',
              customer_role:$rootScope.userRole,
              customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
              customer_name: $scope.customerName?$scope.customerName:'',
              customer_email: $scope.customerEmail?$scope.customerEmail:'',
              customer_phone: $scope.customerPhone?$scope.customerPhone:'',
              tracking_number: $scope.trackingNumber?$scope.trackingNumber:'',
              company_name: $scope.companyName?$scope.companyName:'',
              country:$scope.country?$scope.country:'',
              crontype:$scope.country?$scope.crontype:'',
              from_date:$scope.saveFromDateFormat($rootScope.datePickerOrder.date.startDate),
              to_date: $scope.saveToDateFormat($rootScope.datePickerOrder.date.endDate),
              ship_date:$scope.shipdt?$scope.saveToDateFormat($scope.shipdt):'',
              sort_by_column_name: sortColumnName,
              search_type: $scope.searchByType?$scope.searchByType:'',
              request_page:$stateParams.type?$stateParams.type:''
              
            }
            // for Manage Orders
            if($stateParams.type=='allOrders'){
              requestData['order_status']=$rootScope.searchStatus?$rootScope.searchStatus:prmissionArr;
              requestData['store_permission'] = storePrmissionArr;
              requestData['mall_customer_permission'] = mallCustomerPrmissionArr;
              requestData['dashboard_block_name']=$rootScope.dashboardBlockName?$rootScope.dashboardBlockName:'';
              requestData['store_id']=($scope.store!='0')?$scope.store:'all';
              requestData['jobtype']=($scope.jobtype!='0')?$scope.jobtype:'';
              requestData['engraving']=($scope.engraving!='0')?$scope.engraving:'';
              requestData['crontype']=($scope.crontype!='')?$scope.crontype:'';
              //requestData['isglobalsearch']=$scope.SearchQuery?1:'';
              requestData['isglobalsearch']=$scope.SearchQuery? 'yes':'no';
              requestData['defaultrangeglobalsearch']=$rootScope.defaultrangeglobalsearch?$rootScope.defaultrangeglobalsearch:'';
              if ($scope.serchBy == 'Keyword') {
                  requestData['isglobalsearch'] = 'yes';
              } else {
                  requestData['isglobalsearch'] = 'no';
              }
            }
            if($stateParams.type=='express'){
              requestData['order_status']= $cookies.get('expressStatus')?$cookies.get('expressStatus'):'';
              requestData['store_id']='all';
              requestData['group']='';
              requestData['isexpress']='yes';
            }
            if($stateParams.type=='supply'){
              requestData['order_status']= $cookies.get('supplyStatus')?$cookies.get('supplyStatus'):'';
              requestData['store_id']='all';
              requestData['group']='';
              requestData['from_date']=$rootScope.datePickerRegular?$scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate):'';
              requestData['to_date']= $rootScope.datePickerRegular?$scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate):'';
            }
            if($stateParams.type=='customer'){
              requestData['order_status']= $cookies.get('customersStatus')?$cookies.get('customersStatus'):'';
              requestData['ups']=true;
              requestData['store_id']='all';
              requestData['iscustmer']='yes';
              isCustomerList = false;
            }

            if($stateParams.type=='rework'){
              requestData['order_status']= $cookies.get('reworkStatus')?$cookies.get('reworkStatus'):'';
              requestData['store_id']='all';
              requestData['group']='';
            }
            if($stateParams.type=='figuring'){
              requestData['order_status']= $rootScope.searchStatus?$rootScope.searchStatus:prmissionArr;
              requestData['store_id']='all';
              requestData['group']='';
            }
            var type_figurining = 0;
            if($rootScope.type_figurining == 1) {
              type_figurining = $rootScope.type_figurining;
            }
            requestData['type_figurining']=type_figurining;

            if($stateParams.type=='regular'){
              $rootScope.currentState='shipping-board.regular-status';
              requestData['order_status']= $rootScope.regularCode?$rootScope.regularCode:'';
              requestData['store_id']='all';
              requestData['customer_id']=$rootScope.storeListId?$rootScope.storeListId:0;
              requestData['from_date']=$rootScope.datePickerRegular?$scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate):'';
              requestData['to_date']= $rootScope.datePickerRegular?$scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate):'';
              requestData['dashboard_block_name'] = 'Regular Orders';
              requestData['store_permission'] = storePrmissionArr;
              requestData['mall_customer_permission'] = mallCustomerPrmissionArr;
            }
            requestData['store_permission'] = storePrmissionArr;
            requestData['mall_customer_permission'] = mallCustomerPrmissionArr;
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/order/getorders',
                data: requestData,
                headers: {
                    'Content-type': 'application/json'
                },
                timeout: canceler.promise
            }).then(function(result) {
                var fromDate = result.data.date_range.from_date;
                var toDate = result.data.date_range.to_date;
                
                if ($stateParams.type=='express') {
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                $rootScope.datePickerOrder.date = {};
                $rootScope.datePicker.date = {};
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                $rootScope.datePicker.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePicker.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                }
                else if (isCustomerList) {
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                $rootScope.datePickerOrder.date = {};
                $rootScope.datePicker.date = {};
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                $rootScope.datePicker.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePicker.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                }
                
                 //apiService.loaderHide();
                 $scope.supplyOrderTotal=result.data;
                  var result = result.data.original;
                  $scope.selected={};
                  if(result.data < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                apiService.loaderHide();
                fnCallback(records);
            },function errorCallback(response) {
                if(response.status && response.status != -1){
                 apiService.loaderHide();
                }
            })
        };

        $scope.resetManualDate=function()
        {
          $rootScope.datePickerOrder.date={startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerOrder.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Order details method is use for redirect to product details page.
        * created on 10.06.2017
        */
        function orderDetails(data,type,full){
          return '<a href="" ng-click="open(\''+data+'\',\'' + 'order-details-popup' + '\',\''+full.entity_id+'\')" title="View Order" style="color:white;text-decoration: underline !important;">'+data+'</a>'
        }

        /**
        * Render with dollar method is use for show currency.
        * created on 10.06.2017
        */
        $scope.renderWithDollar=function(data){
          return '$'+parseFloat(data).toFixed(2);
        }

        /**
         * Render shipping to user name else -
         */
        function renderShipToName(data,type,full)
        {
            if (data) {
                return data;
            } else {
                return ' - ';
            }
        }

        /**
         * Render with total Qty
         */
        function renderOrderTotalQty(data,type,full)
        {
            if (data) {
                return data;
            } else {
                return ' - ';
            }
        }


        /**
        * Compile row method is use for compile row in angular.
        * created on 10.06.2017
        */
        function compileRow(row,data)
        {
            $(row).css("background-color", data.color_code?data.color_code:"#8FB801");
            $compile(angular.element(row).contents())($scope);
        }

        function compileHeader(header)
        {
          if (!that.headerCompiled)
          {
                // Use this headerCompiled field to only compile header once
                that.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * created on 10.06.2017
        */
        function initComplete(row,data)
        {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * checkShowCheckBoxOrNot method is used for show hide checkboox by fields.
         * created on 10.09.2017
         */
        $scope.checkShowCheckBoxOrNot = function(type)
        {
          //alert(type+'checkShowCheckBoxOrNot');
            var checkBoxArr = [
                'Orientation',
                'Extra People',
                'Special Instructions',
                'Enter Your Message (Optional)',
                'Engraving',
                'Have Special Instructions? Write Here:',
                'Enter Your Engraving',
                'Background',
                'commentAdded',
                'product Name'
            ];
            if(checkBoxArr.indexOf(type) != -1){
                return true;
            }
            return false;
        }

        /**
         * getHtmlDataText method is used get content from html string.
         * created on 02.20.2018
         */
        $scope.getHtmlDataText = function(text)
        {
            if(/^/.test(text)){
                var div = document.createElement("div");
                div.innerHTML = text;
                return div.textContent || div.innerText || "";
            }
            return text;
        }

        /**
         * checkIsTextArea method is used identify field are text area.
         * created on 10.09.2017
         */
        $scope.checkIsTextArea = function(type)
        {
          //alert(type);
            var textAreaArr = [
                'Any Special Instructions?',
                'Enter Your Engraving',
                'Engraving',
                'Special Instruction',
                'Enter Your Message (Optional)',
                'Have Special Instructions? Write Here:',
                'Add Free Engraving',
                'Special Instructions'
            ];
            if(textAreaArr.indexOf(type) != -1){
                return true;
            }
            return false;
        }

        $scope.directFileUploadDigitalOcean = function (event, item_increment_id, item_id, order_id)
        {
          var file = document.getElementById('directFileUploadDigitalOcean').files[0];
          if (!file) {
              toastr.error('Please select file first to upload');
              return '';
          }
          
          console.log(item_increment_id);
          console.log(item_id);
          console.log(order_id);

          //$('#btnFileUploadDigitalOcean').hide();
            
          apiService.loaderShowForUploadButton();
          var bodyData = {
            order_id: order_id,
            item_id: item_id,
            item_increment_id: item_increment_id
          };
          
          if(file) {
            bodyData.upload_file = file;
          }
          
          $http({
                url: $rootScope.baseUrl + '/orderdetail/upload-file-digitalocean',
                method: 'POST',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var i in bodyData) {
                        formData.append(i, bodyData[i]);
                    }
                    return formData;
                }
            }).then(function (response) {
                $scope.getOrderDetails();
                apiService.loaderHideForUploadButtonp();
                var responseData = response.data;
                if (responseData.status == 'success') {
                    toastr.success(responseData.message);
                    angular.element("#btnFileUploadDigitalOcean").show();
                }
            }, function (error) {
                apiService.loaderHideForUploadButtonp();
                angular.element("#btnFileUploadDigitalOcean").show();
                var errorData = error;
                toastr.error(errorData.message.message);
            });
            jQuery("#directFileUploadDigitalOcean").val('');
            file = '';
        }

        /**
         * Get data table method is use for get list of users.
         * created on 09.27.2017
         */
         var titleHtml = '<label class="custom-checkbox"><input type="checkbox" ng-disabled="!isSelected.select" ng-model="selectAll" ng-click="toggleAll(selectAll, selected)"><span>Select All</span></label>';
         $scope.orderDom= "<'row'<'col-md-3 clearfix'l><'col-md-6 form-group clearfix mt-5px'p><'col-md-3' ZB>>" +
         "<rt>" +
         "<'row'<'col-md-5'i><'col-md-7'p>><'clear'>";
        $scope.getDataTable = function()
        {
            var vm = this;
            var orderFromTitle='Order From';
            if($stateParams.type=='customer'){
              orderFromTitle='Customer Name';
            }
            var totalPermission = 0;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable()
              .renderWith(function(data, type, full, meta) {
                $scope.selected[data.entity_id] = false;
                return '<label class="custom-checkbox"><input type="checkbox" ng-disabled="!isSelected.select" ng-model="selected[\'' + data.entity_id + '\']" ng-click="toggleOne(selected)"><span></span></label>';
              }));
            vm.dtColumns.push(DTColumnBuilder.newColumn('DT_Row_Index').withTitle('Sr.No').withOption('orderable', false));
            if($rootScope.permissionArr.indexOf('order_number_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('increment_id').withTitle('Order Number').renderWith(orderDetails));
            }
            if($rootScope.permissionArr.indexOf('order_from_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('cust_name').withTitle(orderFromTitle).renderWith($scope.UcCap));
            }
            if($rootScope.permissionArr.indexOf('order_to_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to_name').withTitle('Order To').renderWith(renderShipToName));
            }
            if($rootScope.permissionArr.indexOf('order_total_quantity_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('order_total_qty').withTitle('Total Qty').renderWith(renderOrderTotalQty));
            }
            if($rootScope.permissionArr.indexOf('order_amount_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('grand_total').withTitle('Order Amount').renderWith($scope.renderWithDollar));
            }
            if($rootScope.permissionArr.indexOf('order_status_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Order Status').withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('order_date_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            }
            if($stateParams.type=='express'){
              vm.dtColumns.push(DTColumnBuilder.newColumn('shipping_method_name').withTitle('Shipping Method').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_action_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('increment_id').withTitle('Action').renderWith($scope.orderActionHtml).withOption('orderable', false));
            }

            var log = [];
            var sortColNum = $rootScope.orderDefaultSort;
            if (totalPermission <= 6) {
                sortColNum = 1;
                var columname = '';
              angular.forEach(vm.dtColumns, function(value, key) {
                if(value.mData=='created_at'){
                    columname = value.mData;
                    sortColNum = key;
                }

               },log);
            }


            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('autoWidth', false)
                .withOption('sDom', $scope.orderDom)
                .withOption('bLengthChange', true)
                .withOption('order', [sortColNum, 'desc'])
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1) )
                .withOption('bInfo', true)
                .withButtons($scope.colvisOption)
                .withOption('oLanguage',{ "sSearch": "" })
                .withOption('createdRow',compileRow)
                .withOption('headerCallback',compileHeader)
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
            $rootScope.vmAddedNew = vm
        }

        /**
         * Open Order Details model.
         * updated on 09.24.2019
         */
        $scope.open = function (id, size,entityId)
        {
          $("#addresschangedgreen").html('');
          $("#addresschangedyellow").html('');
          $("#addresschangedred").html('');

          $("#regular_shipping_scan").hide();
          $("#amazon_shipping_scan").hide();
          
          $('#address_verified').prop('checked', false);
          angular.element('#btncreatelabel').removeClass('show-element');
          angular.element('#btncreatelabel').addClass('hide-element');
          $("#btncreatelabel").hide();

          $scope.switch_shipping = "false";
          $scope.switch_amazon_shipping = false;
          jQuery("#switch_amazon_shipping").val("false");

          $scope.total_weight = 0;
          $scope.defaultService = '';
          $scope.defaultFedex = 0;
          $scope.defaultUSPS = 0;
          $scope.defaultOffice = 0;
          $scope.allShipmentServices = [];
          $scope.fedex_rates=[];
          $scope.fedexpackage = '';
          $scope.show_new_shipping = 1;
          
          var vm = this;
          vm.total_weight = 0;
          vm.account = '';
          vm.shippingservice = $scope.defaultService;
          vm.shippingservicetype = '';

          if($scope.defaultService == 'fedex') {
            $scope.defaultAccount = $scope.defaultFedex;
          }
          else if($scope.defaultService == 'usps') {
            $scope.defaultAccount = $scope.defaultUSPS;
          }
          else if($scope.defaultService == 'office') {
            $scope.defaultAccount = $scope.defaultOffice;
          }

          $scope.packagesaved = false;

          $scope.getRateDone = true;
          $scope.order_total_weight = 0;
          $scope.custom_packages = 0;

          $scope.packagesdata = [];
          $scope.ShipmentAccounts = [];
          $scope.ShipmentBoxes = [];
          $scope.ShipmentServiceBoxes = [];
          $scope.orderDetailsData = [];
          $scope.orderCommentDataArr = [];
          $scope.commentDataArr = [];
          $scope.officeCommentDataArr = [];
          $scope.reDesignCommentDataArr = [];
          $scope.addOnDataArr = [];

          $scope.CataddOnDataArr = [];
          $scope.orderAddress = [];
          $scope.addOneData = [];
          $scope.caTaddOneData = [];
          $scope.fileRawMaterial = [];

          $scope.shippedDate='';
          $scope.shippedAmount='';
          $scope.shippedMethod='';
          $scope.shippedMethodName='';
          $scope.trackerNumber='';
          $scope.trackerUrl='';
          $scope.shippingNumber='';

          $scope.shipped_by='';
          $scope.delivered_by='';

          $scope.shipmentDate='';
          $scope.shipmentAmount='';
          $scope.shipmentMethod='';
          $scope.shipmentMethodName='';
          $scope.shipmentTrackerNumber='';
          $scope.shipmentTrackerUrl='';
          $scope.ShipmentNumber='';

          $scope.shipped_by='';
          $scope.delivered_by='';

          $scope.isQaStart = false;
          
          $rootScope.orderId = id;
          $rootScope.orderEntityId=entityId;
          $rootScope.popupSize = $(window).height();
          
          $rootScope.popupSize = ($rootScope.popupSize-60);
          $rootScope.popupSizeMin = ($rootScope.popupSize-50);
          $rootScope.borderSize=($rootScope.popupSizeMin-100);

          var totalCheckbox=angular.element('#chk');
          var checked=angular.element('#chk:checked:not(.itilecheck)');
          console.log('open');
          if($scope.orderCommentDataArr.length > 0)
          {
            if(totalCheckbox.length==checked.length){
              $("#amazon_shipping_info").show();
            }
            else {
              $("#amazon_shipping_info").hide();
            }
          }
          else {
            $("#amazon_shipping_info").show();
          }

          $scope.getOrderDetails();
          $scope.getOrderDetailsData();

          $scope.getNoyAssemblySetting();
          
          $scope.getShipmentSettingStatus();

          $scope.killOrderListTimer();
          
          $scope.getFileRawMaterialData();
          $scope.getShowAddOnData();

          $scope.getShowCatAddOnData();
          $scope.getAddOnData();
          $scope.getCatAddOnData();
          $scope.getQaDesignData();
          
          $scope.getOrderShipmentCommentData();
          $scope.getOfficeCommentData();
          $scope.getReDesignCommentData();
          $scope.getEditAndLogSetting();
          $scope.getDynamicButton();
          $scope.getReworkSettingData();
          $scope.getJobSettingData();
          $scope.getRelayButtonSettings();
          $scope.getPullJobSettingData();
          $scope.getRelaySettingData();
          $scope.startOrderDetailsTimer();
          $scope.startOrderCommentTimer();
          $scope.getChangeOrderDateButtonData();
          $scope.getDamageSettingData();
          $scope.getOrderAddress();
          $scope.getShipmentTracking();
          $scope.OrderAddressVerify();
          $scope.getCommentData();
          $scope.getShipmentBoxes();

          $('#orderDetailsModel').modal();

          $("#len").val('');
          $("#wgh").val('');
          $("#hgt").val('');

          $("#displayRate").html('');
          $("#displayDays").html('');

          $("#service_type").val('');
          $("#package").val('');
        };

        $scope.getShipmentTracking = function()
        {
          //$rootScope.orderEntityId=
          $http.get($rootScope.baseUrl + '/shipment/get-order-tracking/'+$rootScope.orderEntityId)
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else if (result.status == 'success') 
              {
                var shipmentdetail = result.data;
                
                $scope.shippedDate=shipmentdetail.shipped_date;
                $scope.shippedAmount=shipmentdetail.shipped_amount;
                $scope.shippedMethod=shipmentdetail.shipped_method;
                $scope.shippedMethodName=shipmentdetail.shipped_method_name;
                $scope.trackerNumber=shipmentdetail.tracker_number;
                $scope.trackerUrl=shipmentdetail.tracker_url;
                $scope.shippingNumber=shipmentdetail.shipping_number;

                $scope.shipmentDate=shipmentdetail.shipment_date;
                $scope.shipmentAmount=shipmentdetail.shipment_amount;
                $scope.shipmentMethod=shipmentdetail.shipment_method;
                $scope.shipmentMethodName=shipmentdetail.shipment_method_name;
                $scope.shipmentTrackerNumber=shipmentdetail.shipment_tracker_number;
                $scope.shipmentTrackerUrl=shipmentdetail.shipment_tracker_url;
                $scope.ShipmentNumber=shipmentdetail.shipment_number;
                $scope.amazon_shipment_id = shipmentdetail.amazon_shipment_id;
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        };

        $scope.gotoShipment = function(event)
        {
          var target = angular.element(event.target);
          var ShipmentNumber = target.attr('aria-label');
          $rootScope.shipmentOderNumber = ShipmentNumber;
          $cookies.put('ShipmentNumber',ShipmentNumber);
          if($rootScope.shipmentOderNumber != '')
          {
            $('#orderDetailsModel').modal('hide');
            var url = '/#/shipment/shipped-list'
            window.open(url, '_blank');
          }
          //$state.go('shipment.shipped-list');
        };

        $scope.getShipemts = function ()
        {
          $scope.shippingservicetype  = '';
          if($scope.defaultService != '')
          {
            $scope.orderServiceType = [];
            $scope.ShipmentAccounts = [];
            
            $scope.getShipmentAccounts($scope.defaultService);
            $scope.getServiceType($scope.defaultService);
            //$scope.getActiveServiceTypes($scope.defaultService);
          }
        };

        $scope.getShipmentSettingStatus = function()
        {
          $http.get($rootScope.baseUrl + '/config/shipmentSetting')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else if (result.data)
              {
                var resultData = result.data;
                var shipmentSetting = resultData.shipment_settings;
                $scope.customerStatus = shipmentSetting.customerStatus;
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        };

        $scope.getShipmentAccounts = function(service)
        {
          if(service == '') {
            service = $scope.defaultService;    
          }
          var vm = this;
          $scope.ShipmentAccounts = [];
          var url = $rootScope.baseUrl + '/shipment/active-account/'+service;
          $http.get(url)
          .success(function(result)
          {
            $scope.getShipmentServiceBoxes(service);
            $scope.ShipmentAccounts = [];
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else
              {
                var data = { };
                $.each( result, function( i, val ) {
                  $scope.ShipmentAccounts.push(val);
                });
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
          
          if(service == 'fedex') {
            vm.account = $scope.defaultFedex;
            $("#account").val($scope.defaultFedex);
          }
          else if(service == 'usps') {
            vm.account = $scope.defaultUSPS;
            $("#account").val($scope.defaultUSPS);
          }
          else if(service == 'office') {
            vm.account = $scope.defaultOffice;
            $("#account").val($scope.defaultOffice);
          }
        };

        $scope.getShipmentBoxes = function()
        {
          $scope.ShipmentBoxes = [];
          $http.get($rootScope.baseUrl + '/shipment/getactiveboxes')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else
              {
                var data = { };

                $.each( result, function( i, val ) {
                  data = { 
                    id: val.box_id,
                    name: val.box_name
                  };
                  
                  $scope.ShipmentBoxes.push(data);
                });
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        };

        $scope.getShipmentServiceBoxes = function (service)
        {
          $scope.ShipmentServiceBoxes = [];
          if(service)
          {
            $http.get($rootScope.baseUrl + '/shipment/getactiveserviceboxes/'+service)
            .success(function(result)
            {
              $scope.ShipmentServiceBoxes = [];
              if (result)
              {
                var data = { };

                $.each( result, function( i, val ) {
                  data = { 
                    service_box_id: val.service_box_id,
                    service_box_3dcode: val.service_box_3dcode,
                    service_box_label: val.service_box_label
                  };
                  $scope.ShipmentServiceBoxes.push(data);
                });
              }
            })
            .error(function(error)
            {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              }
            });
          }
        };

        $scope.getActiveServiceTypes = function (service)
        {
          apiService.loaderShow();
          var vm = this;
          var entity_id = $rootScope.orderEntityId;
          var service = service;
          var accountId = vm.account;
          $scope.orderServiceType = [];
            $http.post($rootScope.baseUrl + '/shipment/active-service-types', {
              id: entity_id ? entity_id : '',
              service: service ? service : '',
              account: accountId ? accountId : 0,
              from: 'order'
            }).then(function(response)
            {
              apiService.loaderHide();
              var responsedata = response.data;
              if (responsedata.status == 'success')
              {
                $scope.orderServiceType = responsedata.types;
              }
            });
        }

        $scope.getServiceType = function (service)
        {
          apiService.loaderShow();
          $scope.orderServiceType = [];
          if(service != '')
          {
            $http.post($rootScope.baseUrl + '/shipment/get-order-service-types/'+service, {
              id: $rootScope.orderEntityId
            })
            .then(function (response)
            {
              apiService.loaderHide();
              if(response.data.status == 'success'){
                $scope.orderServiceType = response.data.types;
              }
            },
            function (error) {
              apiService.loaderHide();
            });
          }
        };

        $scope.OrderAddressVerify = function ()
        {
            $scope.add_business = false;
            $scope.add_home = false;

            apiService.loaderShow();
            $("#addresstype").html('');
            $("#warnings").html('');
            $("#verified").hide();

            $("#addresserror").html('');
            $("#addresserror").hide();
            
            $("#addresschangedgreen").html('');
            $("#addresschangedyellow").html('');
            $("#addresschangedred").html('');

            $http.get($rootScope.baseUrl + '/shipment/order-address-verify/'+$rootScope.orderEntityId)
            .then(function (response)
            {
              apiService.loaderHide();
              
              if(response.data.change_color != "")
              {
                if(response.data.change_color == "green" && response.data.change_message == "")
                {
                  $("#addresschangedgreen").html('Address Verified');
                  $("#addresschangedyellow").html('');
                  $("#addresschangedred").html('');
                }
                else if(response.data.change_color == "green" && response.data.change_message != "")
                {
                  $("#addresschangedgreen").html('Address changed and verfied');
                  $("#addresschangedyellow").html('');
                  $("#addresschangedred").html('');
                }
                else if(response.data.change_color == "yellow")
                {
                  $("#addresschangedgreen").html('');
                  $("#addresschangedyellow").html('Address changed');
                  $("#addresschangedred").html('');
                }
                else if(response.data.change_color == "red")
                {
                  $("#addresschangedgreen").html('');
                  $("#addresschangedyellow").html('');
                  $("#addresschangedred").html('Address Invalid');
                }
              }
              else
              {
                $("#addresschangedgreen").html('');
                $("#addresschangedyellow").html('');
                $("#addresschangedred").html('');
              }
              
              $scope.show_checkbox = response.data.show_checkbox;
              if($scope.show_checkbox == true) {
                $scope.address_verified = false;
              }
              else
              {
                $scope.address_verified = true;
              }

              if(response.data.status == 'success')
              {
                if(response.data.warnings == '')
                {
                  $("#verified").show();
                  $("#warnings").html('');
                  $("#warnings").hide();
                }
                else
                {
                  $("#verified").hide();
                  $("#warnings").html(response.data.warnings);
                  $("#warnings").show();
                }
                if(response.data.address_type == 'BUSINESS')
                {
                    $scope.add_business = true;
                    $scope.add_home = false;
                }
                else if(response.data.address_type == 'RESIDENTIAL')
                {
                    $scope.add_business = false;
                    $scope.add_home = true;
                }
                $("#addresstype").html(response.data.address_type);
              }
              else if(response.data.status=='error')
              {
                $("#verified").hide();
                $("#warnings").html(response.data.message);
                $("#warnings").show();
              }
              else if(response.data.status=='fail'){
                toastr.error(response.data.message);
              }
              $scope.getOrderAddress();
            },
            function (error)
            {
              apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        $scope.OrderSmartyStreetsVerify = function ()
        {
          $("#addresschangedgreen").html('');
          $("#addresschangedyellow").html('');
          $("#addresschangedred").html('');

          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/shipment/address-smartystreets-verify/'+$rootScope.orderEntityId)
          .then(function (response)
          {
            if(response.data.change_color != "")
            {
              if(response.data.change_color == "green" && response.data.change_message == "")
              {
                $("#addresschangedgreen").html('Address Verified');
                $("#addresschangedyellow").html('');
                $("#addresschangedred").html('');
              }
              else if(response.data.change_color == "green" && response.data.change_message != "")
              {
                $("#addresschangedgreen").html('Address changed and verfied');
                $("#addresschangedyellow").html('');
                $("#addresschangedred").html('');
              }
              else if(response.data.change_color == "yellow")
              {
                $("#addresschangedgreen").html('');
                $("#addresschangedyellow").html('Address changed');
                $("#addresschangedred").html('');
              }
              else if(response.data.change_color == "red")
              {
                $("#addresschangedgreen").html('');
                $("#addresschangedyellow").html('');
                $("#addresschangedred").html('Address Invalid');
              }
            }
            else
            {
              $("#addresschangedgreen").html('');
              $("#addresschangedyellow").html('');
              $("#addresschangedred").html('');
            }

            apiService.loaderHide();
            if(response.data.status == 'success')
            {
              toastr.success(response.data.message);
            }
            else if(response.data.status == 'fail') {
              toastr.error(response.data.message);
            }
              $scope.getOrderAddress();
          },
          function (error)
          {
            apiService.loaderHide();
            if (error && error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
          $scope.getOrderAddress();
          $scope.OrderAddressVerify();
        }

        $scope.CheckAddress = function ()
        {
          var totalCheckbox=angular.element('#address_verified');
          var checked=angular.element('#address_verified:checked:not(.itilecheck)');
          var totalChkRdo=totalCheckbox.length-1;
          if(totalChkRdo != checked.length)
          {
            $scope.address_verified = true;
            angular.element('#btncreatelabel').removeClass('hide-element');
            angular.element('#btncreatelabel').addClass('show-element');
            $("#btncreatelabel").show();
          }
          else
          {
            angular.element('#btncreatelabel').removeClass('show-element');
            angular.element('#btncreatelabel').addClass('hide-element');
            $("#btncreatelabel").hide();
          }
          return;
        }

        $scope.getOz = function()
        {
            apiService.loaderShow();
            var weight_lbs = jQuery("#weight_lbs").val();
            var weight_oz = (weight_lbs * 16);
            $("#weight_oz").val(weight_oz);
            apiService.loaderHide();
        };

        $scope.changeShippingService = function (service)
        {
          $("#getRate").hide();
          $("#displayRate").html("");
          $("#displayDays").html("");

          var vm = this;
          if(service != null)
          {
            $scope.changeDefaultService = service;
            vm.shippingservice = service;
            if(service == 'office')
            {
              $("#rowRate").hide();
              $("#rowDeliveryTime").hide();
              $("#rowCreateLable").hide();
              $("#rowSatDel").hide();
              $("#rowOffice").show();
            }
            else
            {
              $("#rowRate").show();
              $("#rowDeliveryTime").show();
              $("#rowCreateLable").show();
              $("#rowSatDel").show();
              $("#rowOffice").hide();
            }

            var offset = 0;
            $scope.orderServiceType = [];
            $scope.ShipmentAccounts = [];
            vm.shippingservicetype = '';

            vm.account = '';
            vm.package = '';
            $scope.getShipmentAccounts(service);
            
            $http.get($rootScope.baseUrl + '/order/'+$rootScope.orderId+'/'+offset+'/0').then(
            function (response)
            {
              if(response.data.status == 'success')
              {
                var mainArray = response.data.data;
                vm.shippingservicetype = '';
                if(service == 'fedex') {
                  vm.account = mainArray.orderData.account_fedex;
                }
                else if(service == 'usps') {
                  vm.account = mainArray.orderData.account_usps;
                }
                $scope.getServiceType(service);
              }
            },
            function (error) {
              $scope.disableQaStart=false;
            });
          }
          else
          {
            vm.packageservice = '';
            vm.account = '';
            $("#package_service option:first").attr('selected',true);
          }
        };

        $scope.openWarning = function (page, size)
        {
            $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: page,
              scope:$scope,
              backdrop: 'static',
              keyboard: false,
              windowClass: 'testclass',
            });
        };

        $scope.changeShippingAccount = function (accountId)
        {
          $("#getRate").hide();
          $("#displayRate").html("");
          $("#displayDays").html("");
          
          if($scope.defaultAccount != '')
          {
            var vm = this;
            $scope.message = 'This account is not for this store';
            
            if($scope.defaultAccount != accountId) {
              $scope.openWarning('app/pages/orders/warningModal.html');
            }
          }
          else
          {
            $scope.getRateDone = true;
            toastr.error("Please select account");
          }
        }

        $scope.notadd = function ()
        {
          var vm = this;
          
          if($scope.changeDefaultService == 'fedex') {
            vm.account = $scope.defaultFedex;
            $scope.defaultAccount = $scope.defaultFedex;
          }
          else if($scope.changeDefaultService == 'usps') {
            vm.account = $scope.defaultUSPS;
            $scope.defaultAccount = $scope.defaultUSPS;
          }
          else if($scope.changeDefaultService == 'office') {
            vm.account = $scope.defaultOffice;
            $scope.defaultAccount = $scope.defaultOffice;
          }
          $scope.getShipmentAccounts($scope.changeDefaultService);
        }

        $scope.yeschange = function() {
            $scope.getRateCheck();
        };

        $scope.nochange = function()
        {
          var vm = this;
          if(vm.shippingservice == 'fedex') {
            vm.account = $scope.defaultFedex;
          }
          else if(vm.shippingservice == 'usps') {
            vm.account = $scope.defaultUSPS;
          }
          else if(vm.shippingservice == 'office') {
            vm.account = $scope.defaultOffice;
          }
          $("#account").val($scope.defaultAccount);
        };

        $scope.changeShippingServiceType = function (service_type)
        {
          var vm = this;
          $("#getRate").hide();
                $("#displayRate").html("");
                $("#displayDays").html("");
            if(service_type != null)
            {
              $scope.getRateCheck();
            }
            else {
                vm.packageservicetype = '';
            }
        };

        $scope.changeShippingPackageType = function (package_type)
        {
          $("#getRate").hide();
                $("#displayRate").html("");
                $("#displayDays").html("");
          if(package_type != null)
          {
            if(package_type > 0)
            {
              $("#main_package_type").val('YOUR_PACKAGING');
              $scope.adpkg = true;
              $http.post($rootScope.baseUrl + '/shipment/get-box-details', {
                id:package_type
              }).success(function(result) {
                if(result.status == 'success')
                {
                  var boxdetails = result.boxdetails;

                  var size = boxdetails.box_size.split('X');
                  $("#len").val(size[0]);
                  $("#wgh").val(size[1]);
                  $("#hgt").val(size[2]);
                  $scope.getRateCheck();
                }
                else if(result.status == 'fail')
                {
                  toastr.error(result.message);
                }
                
              })
              .error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
              });
            }
            else if(package_type != '')
            {
              $("#main_package_type").val(package_type);
              $scope.adpkg = true;
              $scope.getRateCheck();
            }
          }
          else
          {
            $scope.adpkg = false;
            $("#main_package_type").val('');
            $("#main_package_type option:first").attr("select",true);
            $("#len").val('');
            $("#wgh").val('');
            $("#hgt").val('');
          }
        };

        $scope.openPackageCreate = function ()
        {
          if(!$scope.packagesaved)
          {
            var package_type = $("#package").val();
            if(package_type > 0) {
              $scope.adpkg = true;
            }
            else if(package_type != '') {
              $scope.adpkg = true;
            }
            else {
              $scope.adpkg = false;
            }
            $scope.custom_packages = 0;
            $scope.packagesdata = [];
            $("#packagesrow1").html('');
            $("#description").val('');
          }
          else
          {
            $("#packagesrow1").html('');
            $("#description").val('');
            $("#len").val('');
            $("#wgh").val('');
            $("#hgt").val('');
            $("#weight").val('');
            $scope.custom_packages = 0;

            $.each( $scope.packagesdata, function( idx, val ) {
              $scope.addpackage();
              $("#description"+(idx+1)).val(val.package_description);
              $("#weight"+(idx+1)).val(val.weight);
              $("#len"+(idx+1)).val(val.length);
              $("#wgh"+(idx+1)).val(val.width);
              $("#hgt"+(idx+1)).val(val.height);
            });
          }
          $('#packageModel').modal();
        };

        $scope.addpackage = function ()
        {
            var main_package_type = $("#main_package_type").val();
            
            var clone = $("#packagesrow .pkgrow").clone();
            var length = $(".pkgrow").length;
            clone.attr("id", "pkgrow"+length);

            clone.find(".panel-title").html("Package #"+length);
            clone.find("#description").attr("id","description"+length);
            clone.find("#description"+length).val("Package #"+length);
            clone.find("#custompackagetype").attr("id","custompackagetype"+length);
            
            clone.find("#package_type > option").removeAttr("ng-repeat");
            clone.find("#package_type > option").removeAttr("class");

            var pt = clone.find("#package_type");
            pt.attr("id","package_type"+length);
            pt.attr("ng-model","package_type"+length);
            pt.attr("ng-change","changePackageType("+length+")");

            clone.find("#len").attr("id","len"+length);
            clone.find("#wgh").attr("id","wgh"+length);
            clone.find("#hgt").attr("id","hgt"+length);
            clone.find("#weight").attr("id","weight"+length);

            clone.find(".copy").attr("ng-click","clonepackage("+length+")");
            clone.find(".remove").attr('ng-click',"removePackage("+length+")");

            var temp = $compile(clone)($scope);
            $("#packagesrow1").append(temp);
            $("#package_type"+length).removeClass('ng-not-empty');
            $("#package_type"+length).addClass('ng-empty');
            
            if(main_package_type == 'YOUR_PACKAGING') {
              $("#custompackagetype"+length).show();
            }
            else {
              $("#custompackagetype"+length).hide();
            }
            $('#package1 option').removeAttr("selected");
            $("#package1").val(main_package_type);
            $('#package1 option[value="'+main_package_type+'"]').attr('selected', true);
            
            $scope.custom_packages++;
        };

        $scope.clonepackage = function (index)
        {
            var main_package_type = $("#main_package_type").val();
            
            var clone = $("#packagesrow .pkgrow").clone();
            
            clone.attr("id", "pkgrow"+(index+1));

            clone.find(".panel-title").html("Package #"+(index+1));
            clone.find("#description").attr("id","description"+(index+1));
            clone.find("#description"+(index+1)).val("Package #"+(index+1));
            clone.find("#custompackagetype").attr("id","custompackagetype"+(index+1));
            
            clone.find("#package_type > option").removeAttr("ng-repeat");
            clone.find("#package_type > option").removeAttr("class");

            var pt = clone.find("#package_type");
            pt.attr("id","package_type"+(index+1));
            pt.attr("ng-model","package_type"+(index+1));
            pt.attr("ng-change","changePackageType("+(index+1)+")");

            clone.find("#len").attr("id","len"+(index+1));
            clone.find("#wgh").attr("id","wgh"+(index+1));
            clone.find("#hgt").attr("id","hgt"+(index+1));
            clone.find("#weight").attr("id","weight"+(index+1));

            clone.find(".copy").attr("ng-click","clonepackage("+(index+1)+")");
            clone.find(".remove").attr('ng-click',"removePackage("+(index+1)+")");

            var temp = $compile(clone)($scope);
            $("#packagesrow1").append(temp);
            $("#package_type"+(index+1)).removeClass('ng-not-empty');
            $("#package_type"+(index+1)).addClass('ng-empty');
            
            if(main_package_type == 'YOUR_PACKAGING') {
              $("#custompackagetype"+(index+1)).show();
            }
            else {
              $("#custompackagetype"+(index+1)).hide();
            }
            
            $('#package1 option').removeAttr("selected");
            $("#package1").val(main_package_type);
            $('#package1 option[value="'+main_package_type+'"]').attr('selected', true);
            
            $scope.custom_packages++;
        };

        $scope.removePackage = function (index)
        {
            $("#pkgrow"+index).remove();
            $scope.custom_packages--;

            if($scope.custom_packages <= 0) {
              $scope.packagesaved = false;
            }
        }

        $scope.changePackageService = function (service)
        {
            if(service != null)
            {
                $("#service option:first").removeAttr('selected');
                $("#service").val(service);
                $scope.shippingservice = service;
                $scope.shippingservicetype = '';
                $scope.getRateCheck();
            }
            else {
                $scope.shippingservice = '';
                $("#service option:first").attr('selected',true);
            }
        }

        $scope.changePackageServiceType = function (service_type)
        {
            if(service_type != null) {
                $("#service_type option").removeAttr('selected');
                $("#service_type").val(service_type);
                $scope.shippingservicetype = service_type;
                $scope.getRateCheck();
            }
            else {
                $scope.shippingservicetype = '';
                $("#service_type option:first").attr('selected',true);
            }
        }

        $scope.changePackageType = function (index)
        {
            var package_type = $("#package_type"+index).val();
            if(package_type > 0)
            {
              $http.post($rootScope.baseUrl + '/shipment/get-box-details', {
                id:package_type
              }).success(function(result) {
                if(result.status == 'success')
                {
                  var boxdetails = result.boxdetails;

                  var size = boxdetails.box_size.split('X');
                  $("#len"+index).val(size[0]);
                  $("#wgh"+index).val(size[1]);
                  $("#hgt"+index).val(size[2]);
                }
                else if(result.status == 'fail')
                {
                  toastr.error(result.message);
                }
                
              })
              .error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
              });
            }
            else
            {
              $("#len"+index).val('');
              $("#wgh"+index).val('');
              $("#hgt"+index).val('');
            }
        };

        $scope.changeMainPackageType = function(package_type)
        {
          $('#package1 option').removeAttr("selected");
            $("#package1").val(package_type);
            $('#package1 option[value="'+package_type+'"]').attr('selected', true);
            if(package_type == 'YOUR_PACKAGING')
            {
              $scope.adpkg = true;
              var i = 1;
              $('#packagesrow1 .pkgrow').each(function (index, value) {
                $("#custompackagetype"+i).show();
                i++;
              });

            }
            else if(package_type != '')
            {
              $scope.adpkg = true;
              var i = 1;
              $('#packagesrow1 .pkgrow').each(function (index, value) {
                $("#custompackagetype"+i).hide();
                i++;
              });
            }
            else
            {
              $scope.adpkg = false;
              var i = 1;
              $('#packagesrow1 .pkgrow').each(function (index, value) {
                $("#custompackagetype"+i).hide();
                i++;
              });
            }

            $scope.getRateCheck();
        };

        $scope.closePackageCreate = function (id,page)
        {
            if(!$scope.packagesaved)
            {
              $scope.adpkg = false;
              $scope.shippingChange = false;
              $scope.packagesdata = [];
              $scope.custom_packages = 0;

              angular.element("#package_type option:first").attr('selected',true);
              angular.element("#packagesrow1").html('');
              angular.element("#description").val('');
              angular.element("#package_type").val('');
              angular.element("#main_package_type option").removeAttr("selected");
              angular.element("#main_package_type").val('');
              $scope.getRateCheck();
            }
            else
            {
              $scope.custom_packages = $scope.packagesdata.length;
            }
            $('#packageModel').modal('hide');
        };

        $scope.savePackages = function ()
        {
          var length = $("#packagesrow1 .pkgrow").length;
          var validated = false;
          var i = 1;

          var total_lbs = 0;
          var total_oz = 0;

          var main_service_type = $("#service_type").val();
          var main_package_type = $("#main_package_type").val();
          if(length > 0)
          {
            if(main_package_type != '')
            {
              $("#package").val(main_package_type);
              $('#packagesrow1 .pkgrow').each(function (index, value)
              {
                var package_description = $("#description"+i).val();
                if(main_package_type == 'YOUR_PACKAGING') {
                var package_type = $("#package_type"+i).val();
                } else {
                var package_type = main_package_type;
                }
                    
                if(package_description != null)
                {
                  if(package_description != '')
                  {
                      if(package_type != '')
                      {
                        var weight = parseFloat($("#weight"+i).val());
                                if(weight != null && weight != '' && weight > 0)
                                {
                                    if(main_package_type == 'YOUR_PACKAGING')
                                    {
                                        var length = parseFloat($("#len"+i).val());
                                        if(length != null && length != '' && length > 0)
                                        {
                                            var width = parseFloat($("#wgh"+i).val());
                                            if(width != null && width != '' && width > 0)
                                            {
                                                var height = parseFloat($("#hgt"+i).val());
                                                if(width != null && width != '' && width > 0)
                                                {
                                                    $scope.shippingChange = false;

                                                    total_lbs = (total_lbs + weight);
                                                    $scope.packagesdata[(i-1)] = {
                                                        main_package_type:main_package_type,
                                                        package_service_type:main_service_type,
                                                        package_description:package_description,
                                                        package_type:package_type,
                                                        weight:weight,
                                                        length:length,
                                                        width:width,
                                                        height:height
                                                    };
                                                    validated = true;
                                                }
                                                else
                                                {
                                                    toastr.error("Please enter package #"+i+" height");
                                                    validated = false;
                                                }
                                            }
                                            else
                                            {
                                                toastr.error("Please enter package #"+i+" width");
                                                validated = false;
                                            }
                                        }
                                        else
                                        {
                                            toastr.error("Please enter package #"+i+" length");
                                            validated = false;
                                        }
                                    }
                                    else
                                    {
                                        var length = parseFloat($("#len"+i).val());
                                        var width = parseFloat($("#wgh"+i).val());
                                        var height = parseFloat($("#hgt"+i).val());
                                        $scope.shippingChange = false;

                                        total_lbs = (total_lbs + weight);
                                        $scope.packagesdata[(i-1)] = {
                                            main_package_type:main_package_type,
                                            package_service_type:main_service_type,
                                            package_description:package_description,
                                            package_type:package_type,
                                            weight:weight,
                                            length:length,
                                            width:width,
                                            height:height
                                        };
                                        validated = true;
                                    }
                                }
                                else
                                {
                                    toastr.error("Please enter package #"+i+" weight (lbs)");
                                    validated = false;
                                }
                      }
                      else
                      {
                        toastr.error("Please select package #"+i+" package type");
                        validated = false;
                      }
                  }
                  else 
                  {
                    toastr.error("Please enter package #"+i+" description");
                    validated = false;
                  }
                }
                i++;
              });
              
              $('#package1 option').removeAttr("selected");
              $("#package1").val(main_package_type);
              $('#package1 option[value="'+main_package_type+'"]').attr('selected', true);
              
              if(validated)
              {
                $scope.packagesaved = true;
                $("#weight_lbs").val(total_lbs);
                $('#packageModel').modal('hide');
                $scope.getRateCheck();
              }
            }
            else {
              toastr.error("Please select package type");
            }
          }
          else {
            $scope.closePackageCreate();
          }
        };

        $scope.getRateCheck = function()
        {
          $scope.getRateDone = true;
          $("#btncreatelabel").hide();
          $("#displayRate").html('');
          $("#displayDays").html('');

          var weight_lbs = jQuery("#weight_lbs").val();
          var service = jQuery("#service").val();
          var accountId = jQuery("#account").val();
          var service_type = jQuery("#service_type").val();
          var pkg = jQuery("#package").val();
          var packages = $scope.packagesdata;
          
          var validated = false;
          if(weight_lbs != '' && weight_lbs > 0)
          {
            if(service != '' && service != 'office')
            {
              if(accountId != '' && accountId > 0)
              {
                if(service_type != '')
                {
                  if(packages.length > 0)
                  {
                    validated = false;
                  }
                  else if(pkg != '')
                  {
                    validated = true;
                  }
                  else if(pkg > 0)
                  {
                    validated = true;
                  }
                }
              }
            }
          }
          
          if(validated) {
            $scope.getRate();
          }
        };

        $scope.openAddressLog = function ()
        {
          apiService.loaderShow();
          $scope.address_log = [];
          $scope.address_log_green_messages = [];
          $scope.address_log_yellow_messages = [];
          $scope.address_log_red_messages = [];
          $scope.address_message = [];
          $http.post($rootScope.baseUrl + '/order/address-log-messages', {
            order_id: $rootScope.orderEntityId,
            order_number: $rootScope.orderId
          }).success(function(result) {
            if(result.status == 'success')
            {
              $scope.address_log = result.address_log;
              $scope.address_message = result.message;
              $scope.address_log_green_messages[0] = result.data.green;
              $scope.address_log_yellow_messages[0] = result.data.yellow;
              $scope.address_log_red_messages[0] = result.data.red;
            }
            apiService.loaderHide();
          }).error(function (error) {
             apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
              });
          $('#addressLogModel').modal();
        };

        $scope.closeAddressLog = function ()
        {
          $('#addressLogModel').modal('hide');
        };

        $scope.getRate = function()
        {
          
          var vm = this;
          $("#btncreatelabel").hide();
          $scope.getRateDone = true;
            apiService.loaderShow();
            var entity_id = jQuery("#entity_id").val();
            var weight_lbs = jQuery("#weight_lbs").val();
            var weight_oz = jQuery("#weight_oz").val();
            var service = jQuery("#service").val();
            var accountId = jQuery("#account").val();
            var service_type = jQuery("#service_type").val();
            var shipDate = jQuery("#shipDate").val();
            var signature = jQuery("#switch_fedex_signature").val();
            var signature_option = jQuery("#signature_option").val();

            var satdelivery = "No";
            if ($("input[name=satdelivery]").prop('checked') == true)
            {
              satdelivery = "Yes";
            }
            
             
            var pkg = jQuery("#package").val();
            var len = jQuery("#len").val();
            var wgh = jQuery("#wgh").val();
            var hgt = jQuery("#hgt").val();
            var packages = $scope.packagesdata;

            return $http.post($rootScope.baseUrl + '/shipment/get-order-rate', {
              entity_id: entity_id ? entity_id : '',
              weight_lbs: weight_lbs ? weight_lbs : '',
              weight_oz: weight_oz ? weight_oz : '',
              service: service ? service : '',
              service_type : service_type ? service_type : '',
              account: accountId ? accountId : 0,
              shipDate: shipDate ? shipDate : '',
              package : pkg ? pkg : '',
              len: len ? len : '',
              wgh: wgh ? wgh : '',
              hgt: hgt ? hgt : '',
              signature:signature,
              signature_option:signature_option,
              satdelivery: satdelivery,
              packages : packages
            }).then(function(response)
            {
                var responsedata = response.data;
                if (responsedata.status == 'success')
                {
                    $scope.getRateDone = false;
                    $("#getRate").show();
                    $("#displayRate").html("$"+responsedata.rate);
                    
                    if(responsedata.days!="" && responsedata.expected_date != "") {
                        $("#displayDays").html(responsedata.expected_date);
                    }
                    else if(responsedata.days!="") {
                        $("#displayDays").html(responsedata.days+" Days");    
                    }
                    else {
                        $("#displayDays").html("");
                    }
                    
                    if($scope.show_checkbox == true)
                    {
                      var totalCheckbox=angular.element('#address_verified');
                      var checked=angular.element('#address_verified:checked:not(.itilecheck)');
                      var totalChkRdo=totalCheckbox.length-1;
                      if(totalChkRdo==checked.length)
                      {
                        angular.element('#btncreatelabel').removeClass('show-element');
                        angular.element('#btncreatelabel').addClass('hide-element');
                        $("#btncreatelabel").hide(); 
                      }
                      else if($scope.orderCommentDataArr.length > 0)
                      {
                        angular.element('#btncreatelabel').addClass('hide-element');
                        $("#btncreatelabel").hide(); 
                        var totalCheckbox=angular.element('#chk');
                        var checked=angular.element('#chk:checked:not(.itilecheck)');
                        var totalChkRdo=totalCheckbox.length-1;
                        if(totalChkRdo==checked.length)
                        {
                          angular.element('#btncreatelabel').removeClass('show-element');
                          angular.element('#btncreatelabel').addClass('hide-element');
                          $("#btncreatelabel").hide();
                        }
                        else
                        {
                          angular.element('#btncreatelabel').removeClass('hide-element');
                          angular.element('#btncreatelabel').addClass('show-element');
                          $("#btncreatelabel").show(); 
                        }
                      }
                      else
                      {
                        angular.element('#btncreatelabel').removeClass('hide-element');
                        angular.element('#btncreatelabel').addClass('show-element');
                        $("#btncreatelabel").show(); 
                      }
                    }
                    else if($scope.orderCommentDataArr.length > 0)
                    {
                      angular.element('#btncreatelabel').addClass('hide-element');
                      $("#btncreatelabel").hide(); 
                      var totalCheckbox=angular.element('#chk');
                      var checked=angular.element('#chk:checked:not(.itilecheck)');
                      var totalChkRdo=totalCheckbox.length-1;
                      if(totalChkRdo==checked.length)
                      {
                        angular.element('#btncreatelabel').removeClass('show-element');
                        angular.element('#btncreatelabel').addClass('hide-element');
                        $("#btncreatelabel").hide();
                      }
                      else
                      {
                        angular.element('#btncreatelabel').removeClass('hide-element');
                        angular.element('#btncreatelabel').addClass('show-element');
                        $("#btncreatelabel").show(); 
                      }
                    }
                    else
                    {
                      angular.element('#btncreatelabel').removeClass('hide-element');
                      angular.element('#btncreatelabel').addClass('show-element');
                      $("#btncreatelabel").show(); 
                    }
                    toastr.success(responsedata.message);
                }
                else if (responsedata.status == 'error')
                {
                  $("#displayDays").html(responsedata.message);
                }
                else {
                    toastr.error(responsedata.message);
                }
                apiService.loaderHide();
            },function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
            });            
        };

        $scope.getRateNew = function()
        {
            var vm = this;
            $scope.allShipmentServices = [];
            $scope.fedex_rates=[];
            $scope.usps_rates = [];
            $scope.ups_rates = [];
            $scope.getRateDone = true;
            $scope.fedexpackage = '';

            apiService.loaderShow();
            var entity_id = jQuery("#entity_id").val();
            var weight_lbs = jQuery("#weight_lbs").val();
            var weight_oz = jQuery("#weight_oz").val();

            var shipDate = jQuery("#shipDate").val();
            var signature = jQuery("#switch_fedex_signature").val();
            var signature_option = jQuery("#signature_option").val();

            var satdelivery = "No";
            
            var pkg = $("#package").val();

            var fedexpackage = jQuery("#fedexpackage").val();
            var tmp = $("#fedexpackage").val().split('-');
            if(typeof(tmp[0]) != "undefined" && tmp[0] !== null) {
              fedexpackage=tmp[0];
            }

            var len = jQuery("#len").val();
            var wgh = jQuery("#wgh").val();
            var hgt = jQuery("#hgt").val();
            var packages = $scope.packagesdata;

            return $http.post($rootScope.baseUrl + '/shipment/get-order-rate-new', {
              entity_id: entity_id ? entity_id : '',
              weight_lbs: weight_lbs ? weight_lbs : '',
              weight_oz: weight_oz ? weight_oz : '',
              shipDate: shipDate ? shipDate : '',
              package : pkg ? pkg : '',
              fedex_package: fedexpackage?fedexpackage:'',
              len: len ? len : '',
              wgh: wgh ? wgh : '',
              hgt: hgt ? hgt : '',
              signature:signature,
              signature_option:signature_option,
              satdelivery: satdelivery,
              packages : packages
            }).then(function(response)
            {
                var responsedata = response.data;
                if (responsedata.status == 'success')
                {
                    $scope.getRateDone = false;
                    $scope.allShipmentServices = responsedata.data;
                    $scope.fedex_rates = responsedata.fedex_rates;
                    $scope.usps_rates = responsedata.usps_rates;
                    $scope.ups_rates = responsedata.ups_rates;
                    toastr.success(responsedata.message);
                    if($scope.allShipmentServices.length > 0) {
                      toastr.success(responsedata.message);
                    }
                    else {
                      toastr.error('There are no valid services available.');
                    }
                    
                    //$scope.openRatePopup();
                    if(responsedata.error_messages.length > 0)
                    {
                      $.each(responsedata.error_messages, function(key, message) {
                        toastr.error(message);
                      });
                    }
                }
                else if (responsedata.status == 'error')
                {
                  $scope.fedex_rates=[];
            $scope.usps_rates = [];
            $scope.ups_rates = [];
                    toastr.error(responsedata.message);
                }
                else {
                  $scope.fedex_rates=[];
            $scope.usps_rates = [];
            $scope.ups_rates = [];
                    toastr.error(responsedata.message);
                }
                apiService.loaderHide();
            },function (error) {
              $scope.fedex_rates=[];
            $scope.usps_rates = [];
            $scope.ups_rates = [];
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
            });            
        };

        $scope.openRatePopup = function()
        {
          $rootScope.popupSize = $(window).height();
          $rootScope.popupSize = ($rootScope.popupSize-80);
          $rootScope.popupSizeMin = ($rootScope.popupSize-80);

          $rootScope.popupWidth = "150%";

          $scope.popupShow = $uibModal.open({
            animation: true,
            windowClass: 'rate-modal',
            templateUrl: 'app/pages/orders/orderStatusModal.html',
            scope: $scope,
          });
        };

        $scope.createLabelNew = function(accountId,service,service_type,saturday,one_rate)
        {
            if($scope.getRateDone == false)
            {
                apiService.loaderShow();
                $scope.getRateDone=true;

                var satdelivery = "No";
                if ($("input[name=satdelivery]").prop('checked') == true) {
                  satdelivery = "Yes";
                }

                var entity_id = $("#entity_id").val();
                var weight_lbs = $("#weight_lbs").val();
                var weight_oz = $("#weight_oz").val();
                
                var service_box_id = 0;
                if(service == 'fedex' )
                {
                  if(one_rate == 1)
                  {
                    var tmp = $("#fedexpackage").val().split('-');
                    if(typeof(tmp[1]) != "undefined" && tmp[1] !== null) {
                      service_box_id=tmp[1];
                      var pkg = tmp[0];
                    }
                    else if(service_type == 'FEDEX_2_DAY' || service_type == 'FEDEX_EXPRESS_SAVER') {
                      var pkg = $("#fedexpackage").val();
                    }
                    else {
                      var pkg = $("#package").val();
                    }
                  }
                  else {
                      var pkg = $("#package").val();
                    }
                }
                else {
                  var pkg = $("#package").val();
                }

                var len = $("#len").val();
                var wgh = $("#wgh").val();
                var hgt = $("#hgt").val();
                var shipDate = jQuery("#shipDate").val();
                var packages = $scope.packagesdata;
                var signature = jQuery("#switch_fedex_signature").val();
                var signature_option = jQuery("#signature_option").val();

                return $http.post($rootScope.baseUrl + '/shipment/order-create-label-new',
                {
                    username:$rootScope.globals.currentUser.name,
                    entity_id: entity_id ? entity_id : '',
                    weight_lbs: weight_lbs ? weight_lbs : '',
                    weight_oz: weight_oz ? weight_oz : '',
                    service: service ? service : '',
                    account: accountId ? accountId : 0,
                    service_type : service_type ? service_type : '',
                    shipDate: shipDate ? shipDate : '',
                    package : pkg ? pkg : '',
                    packages: packages ? packages : [],
                    service_box_id: service_box_id,
                    one_rate: one_rate,
                    satdelivery: saturday,
                    signature:signature,
                    signature_option:signature_option,
                    length: len,
                    width: wgh,
                    height: hgt,
                    newshipping: 1,
                    saturday: saturday
                }).then(function(response)
                {
                    apiService.loaderHide();
                    var responsedata = response.data;
                    if (responsedata.status == 'success')
                    {
                      $scope.sendToMagento();
                      $scope.getShipmentTracking();
                      $scope.packagesaved = false;
                      var htmls = '';
                      $.each(responsedata.labels, function(key, item) {
                        htmls = htmls + '<a href="'+item+'" target="_blank">Download Label</a><br />';
                        var url = item;
                        window.open(url, '_blank');
                      });
                      toastr.success(responsedata.message);
                      $scope.packagesdata = [];
                    }
                    else {
                      toastr.error(responsedata.message);
                    }

                }, function (error)
                {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                    }
                    apiService.loaderHide();
                });
            }
            else {
                $scope.getRateCheck();
            }
        };

        $scope.switchAmazonShipping = function (event,type)
        {
          var target = angular.element(event.target);
          var old_val = target.val();

          console.log(old_val+ " " + type);
          if(old_val == "false" && type=="amazon")
          {
            target.val("true");
            $scope.switch_regular_shipping = true;
            jQuery("#switch_regular_shipping").val("true");
            $scope.amazonServices = [];

            $scope.dt = new Date();
          }
          else if(old_val == "true" && type=="amazon")
          {
            target.val("false");
            $scope.switch_amazon_shipping = false;
            jQuery("#switch_amazon_shipping").val("false");
            angular.element('#btncreatelabel').addClass('hide-element');
            jQuery("#btncreatelabel").hide();
            jQuery("#displayDays").html('');

            //console.log($scope.delivered_by);
            $scope.dt = new Date($scope.delivered_by);
          }
          else
          {
            target.val("false");
          }

          var new_val = target.val();
          $scope.switch_shipping = new_val;
          $scope.getOrderDetails();
          return;
        }

        $scope.switchNewShipping = function (event,type)
        {
          var target = angular.element(event.target);
          var old_val = target.val();

          console.log(old_val+ " " + type);
          if(old_val == "false" && type=="old")
          {
            target.val("true");
            $scope.show_new_shipping = 0;
            $scope.switch_regular_old_shipping = true;
            jQuery("#switch_regular_old_shipping").val("true");
            angular.element('#btncreatelabel').addClass('hide-element');
            jQuery("#btncreatelabel").hide();
            jQuery("#displayDays").html('');
            $scope.getRateDone = true;
            $scope.allShipmentServices = [];
            $scope.fedex_rates = [];
            $scope.usps_rates = [];
            $scope.ups_rates = [];
          }
          else if(old_val == "true" && type=="new")
          {
            target.val("false");
            $scope.show_new_shipping = 1;
            $scope.switch_regular_new_shipping = false;
            jQuery("#switch_regular_new_shipping").val("false");
            $scope.getRateDone = true;
            $scope.allShipmentServices = [];
            $scope.fedex_rates = [];
            $scope.usps_rates = [];
            $scope.ups_rates = [];
          }
          else {
            target.val("false");
          }

          //$scope.getOrderDetails();
          return;
        }

        $scope.switchAmazonSignature = function (event)
        {
          var target = angular.element(event.target);
          var old_val = target.val();
          if(old_val == "false") {
            target.val("true");
          }
          else {
            target.val("false"); 
          }
          $scope.amazonServices = [];
          return;
        };

        $scope.switchFedexSignature = function(event)
        {
          var target = angular.element(event.target);
          var old_val = target.val();
          if(old_val == "false") {
            target.val("true");
            $("#rowSignatureOptions").show();
          }
          else {
            target.val("false"); 
            $("#rowSignatureOptions").hide();
          }
          return;
        };

        $scope.getAmazonRate = function()
        {
          $scope.amazonServices = [];
          var entity_id = jQuery("#entity_id").val();
          var weight_lbs = jQuery("#weight_lbs").val();
          var weight_oz = (weight_lbs * 16);
          var delivery_date = jQuery("#deliveryDate").val();
          var pkg = jQuery("#package").val();
          var signature = jQuery("#switch_amazon_signature").val();
          $scope.amazonPackage = pkg;
          apiService.loaderShow();

          return $http.post($rootScope.baseUrl + '/shipment/get-amazon-rate', {
            entity_id: entity_id ? entity_id : '',
              weight_lbs: weight_lbs ? weight_lbs : '',
              weight_oz: weight_oz ? weight_oz : '',
              package: pkg ? pkg : '',
              delivery_date:  delivery_date ? delivery_date : '',
              signature:signature
            }).then(function(response)
            {
                var responsedata = response.data;
                if (responsedata.status == 'success')
                {
                  $scope.amazonServices = responsedata.data;
                  //console.log($scope.amazonServices);
                  toastr.success("Rate fatch successfully");
                }
                else if (responsedata.status == 'fail')
                {
                  toastr.error(responsedata.message);
                }
                else {
                    toastr.error(responsedata.message);
                }
                apiService.loaderHide();
            },function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
            });
        };

        $scope.createAmazonLabel = function(carrier,service,service_id,service_offer_id)
        {
            apiService.loaderShow();
            var pkg = jQuery("#package option:selected").text();
            $scope.ordernumber = $rootScope.orderId;
            $scope.amazoncompany = carrier;
            $scope.amazonservice = service;
            $scope.service_id = service_id;
            $scope.service_offer_id = service_offer_id;
            $scope.package = pkg;

            $('#amazonShipmentModel').modal();
            apiService.loaderHide();
        };

        $scope.getAmazonShipment = function(carrier,service,service_id,service_offer_id)
        {
          var entity_id = jQuery("#entity_id").val();
          var weight_lbs = jQuery("#weight_lbs").val();
          var weight_oz = (weight_lbs * 16);
          var delivery_date = jQuery("#deliveryDate").val();
          var pkg = jQuery("#package").val();
          var signature = jQuery("#switch_amazon_signature").val();
          apiService.loaderShow();

          return $http.post($rootScope.baseUrl + '/shipment/create-amazon-shipment', {
            entity_id: entity_id ? entity_id : '',
              weight_lbs: weight_lbs ? weight_lbs : '',
              weight_oz: weight_oz ? weight_oz : '',
              package: pkg ? pkg : '',
              delivery_date:  delivery_date ? delivery_date : '',
              carrier:carrier,
              service:service,
              service_id:service_id,
              service_offer_id:service_offer_id,
              signature:signature,
              username:$rootScope.globals.currentUser.name
            }).then(function(response)
            {
                var responsedata = response.data;
                if (responsedata.status == 'success')
                {
                  $.each(responsedata.labels, function(key, item) {
                    var url = item;
                    window.open(url, '_blank');
                  });
                  $('#amazonShipmentModel').modal('hide');
                  toastr.success(responsedata.message);
                  $scope.getShipmentTracking();
                }
                else if(responsedata.status == 'fail')
                {
                  toastr.error(responsedata.message);
                }
                apiService.loaderHide();
            },function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
            });

          return false;
        };

        $scope.voidAmazonShipment = function (event,shipment_id)
        {
          var targetJob = angular.element(event.target);
          angular.element(targetJob).attr("disabled", "disabled");
          if(shipment_id != '')
          {
            var entity_id = jQuery("#entity_id").val();
            var increment_id = $rootScope.orderId;
            
            apiService.loaderShow();

            return $http.post($rootScope.baseUrl + '/shipment/cancel-amazon-shipment', {
              entity_id: entity_id ? entity_id : '',
              increment_id: increment_id ? increment_id : '',
              shipment_id:shipment_id,
              username:$rootScope.globals.currentUser.name
            }).then(function(response)
            {
                angular.element(targetJob).removeAttr("disabled");
                  var responsedata = response.data;
                  if (responsedata.status == 'success')
                  {
                    toastr.success(responsedata.message);
                    $scope.getShipmentTracking();
                  }
                  else if(responsedata.status == 'fail')
                  {
                    toastr.error(responsedata.message);
                  }
                  apiService.loaderHide();
              },function (error) {
                angular.element(targetJob).removeAttr("disabled");
                  if (error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  }
                  apiService.loaderHide();
              });
          }
          else  {
            angular.element(targetJob).removeAttr("disabled");
            toastr.error('Amazon Shipment ID Blank');
          }
          return false;
        }

        $scope.changeAmazonBox = function (pkg)
        {
          if(pkg != $scope.amazonPackage) {
            angular.element('#amazon_available_services').addClass('hide-element');
          }
          else {
            angular.element('#amazon_available_services').removeClass('hide-element');
          }
        }

        /**
         * showCreateLabel method is used for show Crete Label button.
         * created on 13.08.2020
         */
        $scope.showCreateLabel = function(event)
        {
          angular.element('#btncreatelabel').addClass('hide-element');
          $("#btncreatelabel").hide();
           var totalCheckbox=angular.element('#chk');
           var checked=angular.element('#chk:checked:not(.itilecheck)');
           var totalChkRdo=totalCheckbox.length-1;
           console.log(totalCheckbox.length+"=="+checked.length);
           if(totalCheckbox.length==checked.length){
            angular.element('#btncreatelabel').removeClass('show-element');
                angular.element('#btncreatelabel').addClass('hide-element');
                $("#btncreatelabel").show();
                $("#regular_shipping_scan").show();
                $("#amazon_shipping_scan").show();
                $("#regular_new_shipping_info").show();
              } 
               else
               {
                angular.element('#btncreatelabel').removeClass('hide-element');
                 angular.element('#btncreatelabel').addClass('show-element');
                 $("#btncreatelabel").hide();
                 $("#regular_shipping_scan").hide();
                $("#amazon_shipping_scan").hide();
                 $("#regular_new_shipping_info").hide();
               }
        };

        $scope.createLabel = function()
        {
            if($scope.getRateDone == false)
            {
                apiService.loaderShow();
                $scope.getRateDone=true;

                var satdelivery = "No";
                if ($("input[name=satdelivery]").prop('checked') == true) {
                  satdelivery = "Yes";
                }

                var entity_id = $("#entity_id").val();
                var weight_lbs = $("#weight_lbs").val();
                var weight_oz = $("#weight_oz").val();
                var service = $("#service").val();
                var accountId = $("#account").val();
                var service_type = $("#service_type").val();
                var pkg = $("#package").val();
                var len = $("#len").val();
                var wgh = $("#wgh").val();
                var hgt = $("#hgt").val();
                var shipDate = jQuery("#shipDate").val();
                var packages = $scope.packagesdata;
                var signature = jQuery("#switch_fedex_signature").val();
                var signature_option = jQuery("#signature_option").val();


                return $http.post($rootScope.baseUrl + '/shipment/order-create-label',
                {
                    username:$rootScope.globals.currentUser.name,
                    entity_id: entity_id ? entity_id : '',
                    weight_lbs: weight_lbs ? weight_lbs : '',
                    weight_oz: weight_oz ? weight_oz : '',
                    service: service ? service : '',
                    account: accountId ? accountId : 0,
                    service_type : service_type ? service_type : '',
                    shipDate: shipDate ? shipDate : '',
                    package : pkg ? pkg : '',
                    packages: packages ? packages : [],
                    satdelivery: satdelivery,
                    signature:signature,
                    signature_option:signature_option,
                    length: len,
                    width: wgh,
                    height: hgt
                }).then(function(response)
                {
                    apiService.loaderHide();
                    var responsedata = response.data;
                    if (responsedata.status == 'success')
                    {
                      $scope.sendToMagento();
                      $scope.getShipmentTracking();
                      $scope.packagesaved = false;
                      var htmls = '';
                      $.each(responsedata.labels, function(key, item) {
                        htmls = htmls + '<a href="'+item+'" target="_blank">Download Label</a><br />';
                        var url = item;
                        window.open(url, '_blank');
                      });
                      //$("#downloadlabelpdf").html(htmls);
                      $("#btncreatelabel").hide();
                      toastr.success(responsedata.message);
                      $scope.packagesdata = [];
                    }
                    else {
                      toastr.error(responsedata.message);
                    }

                }, function (error)
                {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                    }
                    apiService.loaderHide();
                });
            }
            else {
                $scope.getRateCheck();
            }
        };

        $scope.createShipment = function ()
        {
          var entity_id = $("#entity_id").val();
          var weight_lbs = $("#weight_lbs").val();
          var service = $("#service").val();
          var accountId = $("#account").val();
          var service_type = $("#service_type").val();
          var pkg = $("#package").val();
          var len = $("#len").val();
          var wgh = $("#wgh").val();
          var hgt = $("#hgt").val();
          var shipDate = jQuery("#shipDate").val();
          var packages = $scope.packagesdata;
          
          if(entity_id != "" && weight_lbs > 0 && service != '' && accountId > 0 && service_type != '')
          {
            if(pkg != '' || $scope.custom_packages >= 1)
            {
              apiService.loaderShow();
              return $http.post($rootScope.baseUrl + '/shipment/order-office-shipment',
              {
                  username:$rootScope.globals.currentUser.name,
                  entity_id: entity_id ? entity_id : '',
                  weight_lbs: weight_lbs ? weight_lbs : '',
                  service: service ? service : '',
                  account: accountId ? accountId : 0,
                  service_type : service_type ? service_type : '',
                  shipDate : shipDate ? shipDate: '',
                  package : pkg ? pkg : '',
                  packages: packages ? packages : [],
                  length: len,
                  width: wgh,
                  height: hgt
              }).then(function(response)
              {
                apiService.loaderHide();
                var responsedata = response.data;
                if (responsedata.status == 'success')
                {
                  $scope.packagesaved = false;
                  var htmls = '';
                  $.each(responsedata.labels, function(key, item) {
                    htmls = htmls + '<a href="'+item+'" target="_blank">Download Label</a><br />';
                    var url = item;
                    window.open(url, '_blank');
                  });
                  toastr.success(responsedata.message);
                  $scope.packagesdata = [];
                  $scope.getShipmentTracking();
                }
              }, function (error)
              {
                  if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
              apiService.loaderHide();
              });
            }
          }
        };

        $scope.sendToMagento = function()
        {
          console.log('sending to magento');
          return $http.post($rootScope.baseUrl + '/shipment/send-order-to-magento',
          {
            order_id: $rootScope.orderEntityId,
            order_number: $rootScope.orderId
          }).then(function(response)
          {
          }, function (error)
          {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
              }
          });
        };

        $scope.resendToMagento = function()
        {
          console.log('resending to magento');
          return $http.post($rootScope.baseUrl + '/shipment/send-order-to-magento',
          {
            order_id: $rootScope.orderEntityId,
            order_number: $rootScope.orderId
          }).then(function(response)
          {
          }, function (error)
          {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
              }
          });
        };

        $scope.subTabSelected = function (QtyId) {
            $scope.selectedQtyId = QtyId;
        };

        $scope.tabSelected = function (item_id)
        {
          $scope.selectedId = item_id;
            setTimeout(function(){
              $("li.single-right-tab").parent().css('display','none');
              angular.element('.product-name').selectpicker('refresh');
            }, 100);
        };

        $scope.closePopup=function()
        {
          $scope.dt = new Date();
          $scope.show_shipping_tag = 0;
          $scope.scan_complete = 0;
            $scope.amazonServices = [];
            $scope.commentDataArr = [];
            $scope.officeCommentDataArr = [];
            $scope.reDesignCommentDataArr = [];
            $scope.addOnDataArr = [];
            $scope.orderDetailsData = [];
            $scope.allShipmentServices = [];
            $rootScope.orderId=undefined;
            $('#orderDetailsModel').modal('hide');
            $scope.orderDetailsData = [];
            $scope.CataddOnDataArr = [];
            $scope.fedex_rates=[];

            $scope.orderAddress = [];
            $scope.addOneData = [];

            $scope.caTaddOneData = [];

            $scope.ShipmentAccounts = [];
            $scope.ShipmentBoxes = [];
            $scope.killOrderDetailsTimer();
            $scope.killOrderCommentTimer();
            $scope.killOrderOfficeCommentTimer();
            $scope.startOrderListTimer();
            $scope.vmAdded.dtInstance.DataTable.draw( false );
            $scope.commentDataArrValidator = false;
            $scope.officeCommentDataArrValidator = false;
            $scope.reDesignCommentDataArrValidator = false;
        };

        $scope.closeOrderLogs = function (id,page) {
            $('#orderLogsModel').modal('hide');
        };
        

        /**
         * Open OrderLog model.
         * created on 10.09.2017
         */
        $scope.openLogHistory = function (id)
        {
          $rootScope.logIncrementId = id;
          $scope.orderLogsArr = [];
          $scope.orderLogsLoaded = false;
          $scope.getOrderLogs();
          $('#orderLogsModel').modal();
        };

        $scope.openProductLogModal = function (id)
        {
          $rootScope.logIncrementId = id;
          $scope.orderLogsLoaded = false;
          $scope.propLogsArr =[];
          $scope.getPropertyLogs();
          $('#productLogsModel').modal();
        };

        $scope.closeProductLogModal=function(){
          $('#productLogsModel').modal('hide');
        }

        $scope.openEngravingLogModal = function (id)
        {
          $rootScope.logIncrementId = id;
          $scope.orderLogsLoaded = false;
          $scope.getEngravingLogs();
          $('#engravingLogsModel').modal();
        };
        
        $scope.closeEngravingLogModal=function(){
          $('#engravingLogsModel').modal('hide');
        }
        
        $scope.openRelayLogModal = function (id)
        {
            $rootScope.relayIncrementId = id;
            $scope.orderLogsLoaded = false;
            $scope.getRelayLogs();
            $('#relayLogsModel').modal();
        };

        $scope.closeRelayLogModal=function() {
          $('#relayLogsModel').modal('hide');
        }

        /**
         * Open Rework model.
         * created on 10.09.2017
         */
        $scope.openRework = function (type,reworkCustomerId,id,productName,itemQty)
        {
            $scope.killOrderDetailsTimer();
            $rootScope.reworkType=type;
            $rootScope.itemId = id;
            $rootScope.rewProductName=productName;
            $rootScope.reworkCustomerId=reworkCustomerId;
            $scope.quantityData=itemQty?itemQty:0;
            $scope.quantityListData=[];
            $scope.specialInstruction = '';
            for(var i=1;i<=$scope.quantityData;i++){
              $scope.quantityListData.push(i);
            }
            if($scope.quantityListData.length==1){
              $scope.reworkQuantity="1";
            }else{
              $scope.reworkQuantity="";
            }
            $scope.getReworkSettingData();
            $('#reworkModalId').modal();
            // reset submit state
            //this.reworkForm.$setPristine();
        };

        $scope.closeReworkModal=function()
        {
          // reset submit state
          $scope.startOrderDetailsTimer();
          $('#reworkModalId').modal('hide');
        }

        /**
         * Open 3DRework model.
         * created on 10.09.2017
         */
        $scope.open3DRework = function (itemId,change_status)
        {
          $('#rework3DModalId').modal('show');
          $rootScope.itemId = itemId;
          $rootScope.itemStatus = change_status;
        };

        $scope.close3DReworkModal=function()
        {
          $rootScope.itemId = '';
          // reset submit state
          $('#rework3DModalId').modal('hide');
        }

        /**
         * rework Order is use to save rework order data.
         * created on 11.28.2017
         */
        $scope.rework3DOrder = function ()
        {
            $scope.progressbar.start();
            if (!this.rework3DForm.$valid) {
              $scope.progressbar.complete();
              return;
            }

            apiService.loaderShow();
            var bodyData={
             entity_id: $rootScope.orderEntityId,
             order_increment_id:$rootScope.orderId,
             item_id:$rootScope.itemId,
             comment:this.specialInstruction?this.specialInstruction:'',
             created_by:$rootScope.globals.currentUser.id,
             status:$rootScope.itemStatus,
             user_name: $rootScope.globals.currentUser.name
            };
            
            var reworkUrl=$rootScope.baseUrl + '/order/rework-order3d';

            $http.post(reworkUrl,bodyData).success(function (response) {
                apiService.loaderHide();
                if(response.status=='success'){
                  $scope.progressbar.complete();
                  toastr.success(response.message);
                  $scope.close3DReworkModal();
                }else{
                  $scope.progressbar.complete();
                  toastr.error(response.message);
                  $scope.close3DReworkModal();
                }
            }).error(function (error) {
                 $scope.progressbar.complete();
                 apiService.loaderHide();
                 if (error && error.code != undefined && error.code == 0) {
                     toastr.error(error.message);
                 } else {
                     toastr.error("Something went wrong please try again.");
                 }
            });
            $scope.getOrderDetails();
            $scope.getOrderDetailsData();
            $scope.close3DReworkModal();
            angular.element('#specialInstruction').val('');
            this.specialInstruction = '';
        };

        /**
         * getOrderLogs is use to get order details.
         * created on 11.29.2017
         */
        $scope.orderLogsLoaded = false;
        $scope.orderLogsArr = [];
        $scope.getOrderLogs = function () {
            $scope.orderLogsArr = [];
            $scope.orderLogsLoaded = false;
            $http.get($rootScope.baseUrl + '/order/getlog/'+$rootScope.logIncrementId+'/general').then(
            function (response) {
                if(response.data.status == 'success'){
                   $scope.orderLogsArr = response.data.data;
                }
                $scope.orderLogsLoaded = true;
            },
            function (error) {
                $scope.orderLogsLoaded = true;
            });
        }
        /**
         * getPropertyEngravingLogs is use to get log history.
         * created on 06.11.2018
         */
        $scope.orderLogsLoaded = false;
        $scope.propLogsArr = [];
        $scope.getPropertyLogs = function () {
            $scope.orderLogsLoaded = false;
            $scope.propLogsArr =[];
            $http.get($rootScope.baseUrl + '/order/getlog/'+$rootScope.logIncrementId+'/Productname').then(
            function (response) {
                $scope.orderLogsLoaded = true;
                if(response.data.status == 'success'){
                   $scope.propLogsArr = response.data.data;
                }
            },
            function (error) {
                $scope.orderLogsLoaded = true;
            });
        }
        $scope.engLogsArr = [];
        $scope.getEngravingLogs = function () {
            $scope.engLogsArr = [];
            $scope.orderLogsLoaded = false;
            $http.get($rootScope.baseUrl + '/order/getlog/'+$rootScope.logIncrementId+'/Productengraving').then(
            function (response) {
                $scope.orderLogsLoaded = true;
                if(response.data.status == 'success'){
                   $scope.engLogsArr = response.data.data;
                }
            },
            function (error) {
                $scope.orderLogsLoaded = true;
            });
        }
        $scope.relayLogsArr = [];
        $scope.getRelayLogs = function () {
            $scope.orderLogsLoaded = false;
            var data={
              item_increment_id:$rootScope.relayIncrementId
            }
            $http.post($rootScope.baseUrl + '/get-relay-item-log',data).then(
            function (response) {
                $scope.orderLogsLoaded = true;
                if(response.data.status == 'success'){
                   $scope.relayLogsArr = response.data.data;
                }
            },
            function (error) {
                $scope.orderLogsLoaded = true;
            });
        }

        $scope.getNoyAssemblySetting = function()
        {
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/config/NoyAssemblySetting')
              .success(function(result) {
                apiService.loaderHide();
                if (result) {
                  if (result.status == 'fail') {
                    toastr.error(result.message);
                  } else {
                    if (result.data)
                    {
                      var resultData=result.data;
                      $scope.noyStatusAfterUpload = resultData.noy_assembly_settings.noy_status_after_upload;
                      $scope.noyAssemblyShipping = resultData.noy_assembly_settings.noy_assembly_shipping;

                    }
                }
                }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
      }
        /**
         * getOrderDetails is use to get order details.
         * created on 11.29.2017
         */
        //$scope.totalItems = 0;
        $scope.getOrderDetails = function (Clicked)
        {
            var offset = 0;
            var vm = this;
            $scope.disableQaStart=true;
            //apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/order/'+$rootScope.orderId+'/'+offset+'/0').then(
            function (response)
            {
                if(response.data.status == 'success'){
                    var mainArray = response.data.data;
                    $scope.orderDetailsData = mainArray;
                    $scope.shipped_by = mainArray.orderData.shipped_by;
                    $scope.delivered_by = mainArray.orderData.delivered_by;

                    if(mainArray.orderData.amazon_account == 1) {
                      $scope.dt = new Date($scope.delivered_by);
                    }

                    //console.log(mainArray.orderData.store_id);
                    //console.log($rootScope.permissionArr.indexOf("scan_shipment_info"));
                    if(mainArray.orderData.store_id == "noy-skincare")
                    {
                      if($scope.noyAssemblyShipping)
                      {
                        if($scope.scan_complete == 0) {
                        $scope.show_shipping_tag = 0;
                        }
                        else {
                          $scope.show_shipping_tag = 1;
                        }
                      }
                      else {
                        $scope.show_shipping_tag = 1;
                      }
                    }
                    else if(mainArray.orderData.status == 'shipped') {
                      $scope.show_shipping_tag = 1;
                    }
                    else if($rootScope.permissionArr.indexOf("scan_shipment_info") !== -1 && $scope.scan_complete == 0){
                      $scope.show_shipping_tag = 0;
                    }
                    else {
                      $scope.show_shipping_tag = 1;
                    }

                    //console.log($scope.show_shipping_tag);

                    $scope.weight_lbs = mainArray.orderData.total_weight;
                    $scope.total_weight = parseFloat(mainArray.orderData.total_weight).toFixed(2);

                    if($scope.defaultService == '')
                    {
                      vm.shippingservice = mainArray.orderData.account_service;
                      $scope.defaultService = mainArray.orderData.account_service;
                      $scope.defaultFedex = mainArray.orderData.account_fedex;
                      $scope.defaultUSPS = mainArray.orderData.account_usps;
                      $scope.defaultOffice = 6;
                      if($scope.defaultService == 'fedex') {
                        $scope.defaultAccount = $scope.defaultFedex;
                      }
                      else if($scope.defaultService == 'usps') {
                        $scope.defaultAccount = $scope.defaultUSPS;
                      }
                      else if($scope.defaultService == 'office') {
                        $scope.defaultAccount = $scope.defaultOffice;
                      }
                      $scope.changeDefaultService = $scope.defaultService;

                      $scope.getShipmentAccounts($scope.changeDefaultService);
                      $scope.getShipemts();
                    }

                    if($scope.orderDetailsData.orderData.is_amazon_store == 1)
                    {
                      //console.log($scope.switch_shipping);
                      if($scope.switch_shipping == "true") {
                        $scope.orderDetailsData.orderData.amazon_account = 0;
                        $scope.show_new_shipping = 0;
                      }
                      else {
                        $scope.orderDetailsData.orderData.amazon_account = 1;
                        $scope.show_new_shipping = 1;
                      }
                      //console.log($scope.orderDetailsData.orderData.amazon_account);
                    }

                    //$scope.commentDataArr = mainArray.comments;
                    //$scope.addOnDataArr = mainArray.addOneItems;
                    //$scope.orderAddress = mainArray.address;
                    //$scope.addOneData = mainArray.orderData.addOne;
                    //$scope.totalItems = mainArray.totalItems;
                  }
                //apiService.loaderHide();
                $scope.disableQaStart=false;
            },
            function (error) {
              $scope.disableQaStart=false;
                //apiService.loaderHide();
            });
        };

        $scope.getOrderAddress = function () {
            $http.get($rootScope.baseUrl + '/orderdetail/getorderaddress/'+$rootScope.orderEntityId).then(
            function (response) {
                if(response.data.status == 'success'){
                    var addArray = response.data;
                    $scope.shipcompany = '';
                    $scope.shipfirstname = '';
                    $scope.shiplastname = '';
                    $scope.shipaddress = '';
                    $scope.shipaddress2 = '';
                    $scope.shipcity = '';
                    $scope.shipphone = '';

                    $scope.orderAddress = addArray.address;
                    $scope.soldcompany = $scope.orderAddress.billing.company;
                    $scope.soldfirstname = $scope.orderAddress.billing.firstname;
                    $scope.soldlastname = $scope.orderAddress.billing.lastname;
                    $scope.soldaddress = $scope.orderAddress.billing.street;
                    $scope.soldaddress2 = $scope.orderAddress.billing.street2;
                    $scope.soldcity = $scope.orderAddress.billing.city;
                    $scope.soldregion = $scope.orderAddress.billing.region;
                    $scope.soldpostcode = $scope.orderAddress.billing.postcode;
                    $scope.soldphone = $scope.orderAddress.billing.telephone;

                    $scope.shipcompany = $scope.orderAddress.shipping.company;
                    $scope.shipfirstname = $scope.orderAddress.shipping.firstname;
                    $scope.shiplastname = $scope.orderAddress.shipping.lastname;
                    $scope.shipaddress = $scope.orderAddress.shipping.street;
                    $scope.shipaddress2 = $scope.orderAddress.shipping.street2;
                    $scope.shipcity = $scope.orderAddress.shipping.city;
                    $scope.shipregion = $scope.orderAddress.shipping.region;
                    $scope.shipcountry = $scope.orderAddress.shipping.country_id;
                    $scope.shippostcode = $scope.orderAddress.shipping.postcode;
                    $scope.shipphone = $scope.orderAddress.shipping.telephone;
                }
            },
            function (error) {
            });
        }

        /**
         * Close the 3D Job start popup
         */
        $scope.close3DJobStartPopUp = function () {
            $('#open3DJobStartPopUp').modal('hide');
        };
        /**
         * Open pop-up of the 3D Job start
         */
        $scope.open3DJobStartPopUp=function(type,name,change_status,event,itemId,status,qtyId,order_type,product_name,customer_id,itemQty,isRework,orderCustomerName)
        {
            $scope.passVar = {
            'event': event,
            'type': type,
            'name': name,
            'change_status': change_status,
            'itemId': itemId,
            'status': status,
            'qtyId': qtyId,
            'order_type': order_type,
            'product_name': product_name,
            'customer_id': customer_id,
            'itemQty': itemQty,
            'isRework': isRework,
            'orderCustomerName': orderCustomerName
            };
            $('#open3DJobStartPopUp').modal();
        }

        $scope.yes3DJobStart=function()
        {
          var catPrice = $('#3djobcategory').val();
          var catText = $('#3djobcategory option:selected').attr("cls");
          var catCost = $('#3djobcategory option:selected').attr("cost");

          
          if(catPrice > 0)
          {
            $scope.applyCatAddOne('',$scope.passVar.itemId,$scope.passVar.proId,$scope.passVar.orderCustomerName,$scope.passVar.customer_id,'jobstart');
            $scope.job3dStart($scope.passVar.event,$scope.passVar.type,$scope.passVar.name, $scope.passVar.itemId, $scope.passVar.status,$scope.passVar.change_status,$scope.passVar.isRework);
            $('#open3DJobStartPopUp').modal('hide');
          }
          else {
            $("#err3djobcategory").html('Please select 3d category');
            return;
          }
        };

        /**
         * job3dStart method is used for start job of 3d design.
         * created on 16.09.2021
         */
        $scope.job3dStart = function (event,type,name, itemId, status,change_status,isRework) {
          var targetJob = angular.element(event.target);
          angular.element(targetJob).attr("disabled", "disabled");
          apiService.loaderShow();

          var bodyData = {
              order_increment_id: $rootScope.orderId,
              item_id: itemId,
              status: change_status,
              user_name: $rootScope.globals.currentUser.name,
              action_type:name
          };
          if(isRework=='enable'){
            bodyData['3d_rework_job_start']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            bodyData['rework_designer_3d']=$rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
          }else{
            bodyData['job_3d_start_date']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            bodyData['employee_name_3d']=$rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
          }
          
          $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
              apiService.loaderHide();
              angular.element(targetJob).removeAttr("disabled");
              if (response.status == 'success') {
                  $scope.getOrderDetails();
              } else {
                  toastr.error(response.message);
              }
          }).error(function (error) {
              apiService.loaderHide();
              angular.element(targetJob).removeAttr("disabled");
              if (error && error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
        }

        /**
         * job3dDone method is used for done job of 3d design.
         * created on 16.09.2021
         */
        $scope.job3dDone = function(event,type,name, itemId, status,change_status,isRework){
          var targetJobDone = angular.element(event.target);
          angular.element(targetJobDone).attr("disabled", "disabled");
          apiService.loaderShow();
          var bodyData = {
              order_increment_id: $rootScope.orderId,
              item_id: itemId,
              status: change_status,
              user_name: $rootScope.globals.currentUser.name,
              action_type:name
          };
          if(isRework=='enable'){
            bodyData['rework_job_3d_done']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            bodyData['employee_name_3d']=$rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
          }else{
            bodyData['job_3d_end_date']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            bodyData['employee_name_3d']=$rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
          }
          $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
              apiService.loaderHide();
              angular.element(targetJobDone).removeAttr("disabled");
              if (response.status == 'success') {
                  $scope.getOrderDetails();
              } else {
                  toastr.error(response.message);
              }
          }).error(function (error) {
              apiService.loaderHide();
              angular.element(targetJobDone).removeAttr("disabled");
              if (error && error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
        }

        /**
         * Edit Sold To Address
         * updated on 10.09.2019
        */
        $scope.editsoldto = false;
        $scope.editSoldTo = function() {
          $scope.editsoldto = true;
        }

        $scope.cancelSoldTo = function() {
          $scope.editsoldto = false;
        }

        $scope.saveSoldTo = function()
        {
          if (!this.soldtoFrm.soldfirstname.$valid) {
          toastr.error("Please enter first name.");
          angular.element('#soldfirstname').focus();
          return;
          }
          else if (!this.soldtoFrm.soldlastname.$valid) {
          toastr.error("Please enter last name.");
          angular.element('#soldlastname').focus();
          return;
          }
          else if (!this.soldtoFrm.soldcompany.$valid) {
          toastr.error("Please enter company name.");
          angular.element('#soldcompany').focus();
          return;
          }
          else if (!this.soldtoFrm.soldaddress.$valid) {
          toastr.error("Please enter address.");
          angular.element('#soldaddress').focus();
          return;
          }
          else if (!this.soldtoFrm.soldcity.$valid) {
          toastr.error("Please enter city.");
          angular.element('#soldcity').focus();
          return;
          }
          else if (!this.soldtoFrm.soldregion.$valid) {
          toastr.error("Please enter region.");
          angular.element('#soldregion').focus();
          return;
          }
          else if (!this.soldtoFrm.soldpostcode.$valid) {
          toastr.error("Please enter zip code.");
          angular.element('#soldpostcode').focus();
          return;
          }


          apiService.loaderShow();
          var bodyData = {
            address_type: 'billing',
            firstname: this.soldfirstname,
            lastname: this.soldlastname,
            company: this.soldcompany,
            address: this.soldaddress,
            address2: this.soldaddress2,
            city: this.soldcity,
            region: this.soldregion,
            postcode: this.soldpostcode,
            phone: this.soldphone
          };
          //$scope.orderId = $rootScope.orderEntityId;
          if ($rootScope.orderEntityId)
          {
            $scope.saveUrl = $rootScope.baseUrl + '/orderdetail/getorderaddress/' + $rootScope.orderEntityId;
            $scope.httpMethod = 'POST';
          
            $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              $scope.editsoldto = false;
              apiService.loaderHide();
              var response = response.data;
              if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
              }else if (response.status == 'success') {
                $scope.getOrderAddress();
                toastr.success(response.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            }, function(error) {
              apiService.loaderHide();
              $scope.editsoldto = false;
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
          }
          
          
        }

        /**
         * Edit Ship To Address
         * updated on 10.09.2019
        */
        $scope.editshipto = false;
        $scope.editShipTo = function() {
          $scope.editshipto = true;
        };

        $scope.cancelShipTo = function() {
          $scope.editshipto = false;
        }

        $scope.saveShipTo = function()
        {
          if (!this.shiptoFrm.shipfirstname.$valid) {
          toastr.error("Please enter first name.");
          angular.element('#shipfirstname').focus();
          return;
          }
          else if (!this.shiptoFrm.shiplastname.$valid) {
          toastr.error("Please enter last name.");
          angular.element('#shiplastname').focus();
          return;
          }
          else if (!this.shiptoFrm.shipcompany.$valid) {
          toastr.error("Please enter company name.");
          angular.element('#shipcompany').focus();
          return;
          }
          else if (!this.shiptoFrm.shipaddress.$valid) {
          toastr.error("Please enter address.");
          angular.element('#shipaddress').focus();
          return;
          }
          else if (!this.shiptoFrm.shipcity.$valid) {
          toastr.error("Please enter city.");
          angular.element('#shipcity').focus();
          return;
          }
          else if (!this.shiptoFrm.shipregion.$valid) {
          toastr.error("Please enter region.");
          angular.element('#shipregion').focus();
          return;
          }
          else if (!this.shiptoFrm.shippostcode.$valid) {
          toastr.error("Please enter zip code.");
          angular.element('#shippostcode').focus();
          return;
          }
          else if (!this.shiptoFrm.shipcountry.$valid) {
          toastr.error("Please enter country code.");
          angular.element('#shipcountry').focus();
          return;
          }
          else if (!this.shiptoFrm.shipphone.$valid) {
          toastr.error("Please enter telephone number.");
          angular.element('#shipphone').focus();
          return;
          }

          apiService.loaderShow();
          var bodyData = {
            address_type: 'shipping',
            firstname: this.shipfirstname,
            lastname: this.shiplastname,
            company: this.shipcompany,
            address: this.shipaddress,
            address2: this.shipaddress2,
            city: this.shipcity,
            region: this.shipregion,
            postcode: this.shippostcode,
            country_id: this.shipcountry,
            phone:this.shipphone
          };
          
          //$scope.orderId = $rootScope.orderEntityId;
          if ($rootScope.orderEntityId)
          {
            $scope.saveUrl = $rootScope.baseUrl + '/orderdetail/getorderaddress/' + $rootScope.orderEntityId;
            $scope.httpMethod = 'POST';
          
            $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              $scope.editshipto = false;
              apiService.loaderHide();
              var response = response.data;
              if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
              }else if (response.status == 'success') {
                toastr.success(response.message);
                $scope.getOrderAddress();
                //$scope.OrderSmartyStreetsVerify();
              } else {
                toastr.error("Something went wrong please try again.");
              }
            }, function(error) {
              apiService.loaderHide();
              $scope.editshipto = false;
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
          }
        };

        $scope.upload2Dimg = function()
        {
          $scope.download_2d_image = false;
          $('#showImage').hide();
          $('#upload2Dimg').show();
          $('#upload3Dimg').hide();
          $('#btn2D').removeClass("btn-danger");
          $('#btn2D').addClass("btn-success");
          $('#btn3D').removeClass("btn-success");
          $('#btn3D').addClass("btn-danger");
        };

        $scope.upload3Dimg = function()
        {
          $scope.download_2d_image = false;
          $('#showImage').hide();
          $('#upload2Dimg').hide();
          $('#upload3Dimg').show();
          $('#btn2D').removeClass("btn-success");
          $('#btn2D').addClass("btn-danger");
          $('#btn3D').removeClass("btn-danger");
          $('#btn3D').addClass("btn-success");
        };

        $scope.upload2DImage=function(event, itemId)
        {
          var file = document.getElementById('2DfileUpload').files[0];
          if (!file) {
              toastr.error('Please select file first to upload');
              return '';
          }
          $("#myBar").css("width", "0%");
          $("#Progress").show();
          //$scope.progressbar.start();
          var elem = document.getElementById("myBar");
          var width = 1;
          var id = setInterval(frame, 150);
          function frame() {
            if (width >= 88) {
              clearInterval(id);
            } else {
              width++; 
              elem.style.width = width + '%'; 
            }
          }
          
          apiService.loaderShowForUploadButton();
          var bodyData = {
            item_id: itemId,
            category: '2D Flat'
          };
          if(file) {
            bodyData.upload_file = file;
          }
          $http(
          {
            url: $rootScope.baseUrl + '/orderdetail/upload-image',
            method: 'POST',
            headers: {
                'Content-Type': undefined
            },
            transformRequest: function (data) {
                var formData = new FormData();
                for (var i in bodyData) {
                    formData.append(i, bodyData[i]);
                }
                return formData;
            }
          }).then(function (response) {
                $scope.getOrderDetails();
                apiService.loaderHideForUploadButtonp();
                var responseData = response.data;
                if (responseData.status == 'success') {
                  toastr.success(responseData.message);
                  $scope.cancelUploadImage();
                    width = 100;
                    $("#myBar").css("width", "100%");
                    $(function() {
                        setTimeout(function() {
                            $("#Progress").hide('blind', {}, 500)
                        }, 1000);
                    });
                }
            }, function (error) {
                //$scope.progressbar.complete();
                apiService.loaderHideForUploadButtonp();
                var errorData = error;
                toastr.error(errorData.message.message);
            });
            jQuery("#2DfileUpload").val('');
            file = '';
        };

        $scope.upload3DImage=function(event, itemId)
        {
          var file = document.getElementById('2DfileUpload').files[0];
          if (!file) {
              toastr.error('Please select file first to upload');
              return '';
          }
          $("#myBar").css("width", "0%");
          $("#Progress").show();
          //$scope.progressbar.start();
          var elem = document.getElementById("myBar");
          var width = 1;
          var id = setInterval(frame, 150);
          function frame() {
            if (width >= 88) {
              clearInterval(id);
            } else {
              width++; 
              elem.style.width = width + '%'; 
            }
          }
          
          apiService.loaderShowForUploadButton();
          var bodyData = {
            item_id: itemId,
            category: '2D-3D'
          };
          if(file) {
            bodyData.upload_file = file;
          }
          $http(
          {
            url: $rootScope.baseUrl + '/orderdetail/upload-image',
            method: 'POST',
            headers: {
                'Content-Type': undefined
            },
            transformRequest: function (data) {
                var formData = new FormData();
                for (var i in bodyData) {
                    formData.append(i, bodyData[i]);
                }
                return formData;
            }
          }).then(function (response) {
                $scope.getOrderDetails();
                apiService.loaderHideForUploadButtonp();
                var responseData = response.data;
                if (responseData.status == 'success') {
                  toastr.success(responseData.message);
                  $scope.cancelUploadImage();
                    width = 100;
                    $("#myBar").css("width", "100%");
                    $(function() {
                        setTimeout(function() {
                            $("#Progress").hide('blind', {}, 500)
                        }, 1000);
                    });
                }
            }, function (error) {
                //$scope.progressbar.complete();
                apiService.loaderHideForUploadButtonp();
                var errorData = error;
                toastr.error(errorData.message.message);
            });
            jQuery("#2DfileUpload").val('');
            file = '';
        };
        $scope.cancelUploadImage = function ()
        {
          $scope.download_2d_image = true;
          $('#showImage').show();
          $('#upload2Dimg').hide();
          $('#upload3Dimg').hide();
          $('#btn2D').addClass("btn-danger");
          $('#btn2D').removeClass("btn-success");
          $('#btn3D').addClass("btn-danger");
          $('#btn3D').removeClass("btn-success");
        }

        $scope.getFileRawMaterialData = function () {
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/orderdetail/filerawmaterial/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success'){
                    apiService.loaderHide();
                    var fileRawMaterial = response.data;
                    $scope.fileRawMaterial = fileRawMaterial.FileRawMaterial;
                }
            },
            function (error) {
              apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
        $scope.getShowAddOnData = function () {
            $http.get($rootScope.baseUrl + '/orderdetail/getaddoneextra/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success'){
                    var showAddOneArray = response.data;
                    $scope.addOnDataArr = showAddOneArray.addOneItems;
                }
            },
            function (error) {
            });
        }

      /* TicketID : 25-05-2020  Name:DVG  */
      $scope.getShowCatAddOnData = function () { 
            $http.get($rootScope.baseUrl + '/orderdetail/getaddoneextra/'+$rootScope.orderId).then( 
            function (response) { 
                if(response.data.status == 'success'){  
                    var showAddOneArray = response.data;  
                    $scope.CataddOnDataArr = showAddOneArray.addOneItems; 
                } 
            },  
            function (error) {  
            }); 
        }
        $scope.getAddOnData = function () {
            $http.get($rootScope.baseUrl + '/orderdetail/getaddonesettings').then(
            function (response) {
                if(response.data.status == 'success'){
                    var addOneArray = response.data;
                    $scope.addOneData = addOneArray.addonesettings;
                    //console.log($scope.addOneData);
                }
            },
            function (error) {
            });
        }

        $scope.getCatAddOnData = function () {  
            $http.get($rootScope.baseUrl + '/orderdetail/getcataddonesettings').then( 
            function (response) {
                if(response.data.status == 'success'){  
                    var addOneArray = response.data;  
                    $scope.addOneCatData = addOneArray.addonesettings;
                    //console.log($scope.addOneCatData);
                } 
            },  
            function (error) {  
            }); 
        } 


        $scope.getQaDesignData = function () {
            $http.get($rootScope.baseUrl + '/orderdetail/getqadesigninfo/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success'){
                    var designArray = response.data.infotab;
                    $scope.totalQuantity=designArray.totalprodcutQty;
                    $scope.designTime=designArray.totalseconds;
                    $scope.qaTime=designArray.totalseconds_qa;
                }
            },
            function (error) {
            });
        }
        $scope.getOrderDetailsData = function () {
            $http.get($rootScope.baseUrl + '/orderdetail/getOrderData/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success'){
                    var detailsArray = response.data.orderdetail;
                    $scope.orderDate=detailsArray.created_at;
                    $scope.orderCustomerName=detailsArray.cust_name;
                    $scope.orderCustomerEmail=detailsArray.customer_email;
                    $scope.orderCustomerId=detailsArray.customer_id;
                    $scope.customerOrders=detailsArray.customer_orders;
                    $scope.expressOrders=detailsArray.express_orders;
                    $scope.regularOrders=detailsArray.regular_orders;
                    $scope.grandTotal=detailsArray.grand_total;
                    $scope.subTotal=detailsArray.subtotal;
                    $scope.iconHouse=detailsArray.icon_house;
                    $scope.iconPlane=detailsArray.icon_plane;
                    $scope.iconRocket=detailsArray.icon_rocket;
                    $scope.iconTools=detailsArray.icon_tools;
                    $scope.isSync=detailsArray.is_sync;
                    $scope.isUps=detailsArray.is_ups;
                    $scope.magentoVersion=detailsArray.magento_version;
                    $scope.orderQuantity=detailsArray.quantity;
                    //$scope.shippedDate=detailsArray.shipped_date;
                    //$scope.shippedAmount=detailsArray.shipping_amount;
                    //$scope.shippedMethod=detailsArray.shipping_method;
                    //$scope.shippedMethodName=detailsArray.shipping_method_name;
                    //$scope.trackerNumber=detailsArray.tracker_number;
                    //$scope.trackerUrl=detailsArray.tracker_url;
                    $scope.storeId=detailsArray.store_id;
                    $scope.updatedDate=detailsArray.updated_at;
                    $scope.getShipemts();
                }
            },
            function (error) {
            });
        }
        $scope.getCommentData = function () {
            $scope.commentDataArrValidator = false;
            $http.get($rootScope.baseUrl + '/orderdetail/getOrderComment/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success'){
                    var commentArray = response.data;
                    $scope.commentDataArr = commentArray.comments;
                    if (commentArray.comments.length == undefined) {
                        $scope.commentDataArrValidator = true;
                    }
                }
            },
            function (error) {
            });
        }

        $scope.getOrderShipmentCommentData = function ()
        {
            $scope.orderCommentDataArr=[];
            $("#regular_shipping_scan").hide();
            $("#amazon_shipping_scan").hide();

            $http.get($rootScope.baseUrl + '/orderdetail/getOrderShipmentComment/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success')
                {
                    var commentArray = response.data;
                    $scope.orderCommentDataArr = commentArray.comments;
                    console.log($scope.orderCommentDataArr.length);
                    if($scope.orderCommentDataArr.length > 0)
                    {
                      $("#regular_shipping_scan").hide();
                      $("#amazon_shipping_scan").hide();
                    }
                    else
                    {
                      $("#regular_shipping_scan").show();
                      $("#amazon_shipping_scan").show();
                    }
                }
            },
            function (error) {
            });
        }

        /***
        Get office coments
        */
        $scope.getOfficeCommentData = function () {
            $scope.officeCommentDataArrValidator = false;
            $http.get($rootScope.baseUrl + '/orderdetail/getOrderOfficeComment/' + $rootScope.orderId).then(
                function (response) {
                    if (response.data.status == 'success') {
                        var commentArray = response.data;
                        $scope.officeCommentDataArr = commentArray.comments;
                        if (commentArray.comments.length == undefined) {
                          $scope.officeCommentDataArrValidator = true;
                        }
                    }
                },
                function (error) {
                });
        }

        /***
        Get redesign coments
        */
        $scope.getReDesignCommentData = function () {
            $scope.reDesignCommentDataArrValidator = false;
            $http.get($rootScope.baseUrl + '/orderdetail/getOrderReDesignComment/' + $rootScope.orderId).then(
                function (response) {
                    if (response.data.status == 'success') {
                        var commentArray = response.data;
                        $scope.reDesignCommentDataArr = commentArray.comments;
                        if (commentArray.comments.length == undefined) {
                          $scope.reDesignCommentDataArrValidator = true;
                        }
                    }
                },
                function (error) {
                });

            console.log($scope.reDesignCommentDataArr);
        }

        /**
         * GetSortOrderNumber is use to get short number of order.
         * created on 11.29.2017
         */
        $scope.getSortOrderNumber = function(num,event){
            var temp = num.split('-');
            return temp[1];
        }

        /**
         * JobStart method is used for start job of design.
         * created on 11.27.2017
         */
        $scope.jobStart = function (event,type,name, itemId, status,change_status,isRework) {
          var targetJob = angular.element(event.target);

          angular.element(targetJob).attr("disabled", "disabled");
          apiService.loaderShow();
          var bodyData = {
              order_increment_id: $rootScope.orderId,
              item_id: itemId,
              status: change_status,
              user_name: $rootScope.globals.currentUser.name,
              //job_start_date: moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss'),
              //employee_name: $rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname,
              action_type:name
          };
          if(isRework=='enable'){
            bodyData['rework_job_start']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            bodyData['rework_designer']=$rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
          }else{
            bodyData['job_start_date']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            bodyData['employee_name']=$rootScope.globals.currentUser.firstname + ' ' + $rootScope.globals.currentUser.lastname;
          }
          $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
              apiService.loaderHide();
              angular.element(targetJob).removeAttr("disabled");
              if (response.status == 'success') {
                  $scope.getOrderDetails();
              } else {
                  toastr.error(response.message);
              }
          }).error(function (error) {
              apiService.loaderHide();
              angular.element(targetJob).removeAttr("disabled");
              if (error && error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
        }

        /**
         * JobDone method is used for done job of design.
         * created on 12.01.2017
         */
        $scope.jobDone = function(event,type,name, itemId, status,change_status,isRework){
          var targetJobDone = angular.element(event.target);
          angular.element(targetJobDone).attr("disabled", "disabled");
          apiService.loaderShow();
          var bodyData = {
              order_increment_id: $rootScope.orderId,
              item_id: itemId,
              status: change_status,
              user_name: $rootScope.globals.currentUser.name,
              //job_end_date: moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss'),
              action_type:name
          };
          if(isRework=='enable'){
            bodyData['rework_job_done']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
          }else{
            bodyData['job_end_date']=moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
          }
          $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
              apiService.loaderHide();
              angular.element(targetJobDone).removeAttr("disabled");
              if (response.status == 'success') {
                  $scope.getOrderDetails();
              } else {
                  toastr.error(response.message);
              }
          }).error(function (error) {
              apiService.loaderHide();
              angular.element(targetJobDone).removeAttr("disabled");
              if (error && error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
        }

        /**
         * qaStart method is used for QA Start of design.
         * created on 12.01.2017
         */
    $scope.isQaStart=false;
        $scope.qaStart = function(event,type,itemId,status,qtyId,change_status){
           $scope.killOrderDetailsTimer();
           $scope.killOrderCommentTimer();
           $scope.killOrderOfficeCommentTimer();
           $scope.killOrderListTimer();
       $scope.isQaStart=true;
           $rootScope.change_status=change_status;
           if (qtyId.indexOf('_') > -1)
            {
              qtyId=qtyId;
            }else{
              qtyId=qtyId+'_1'
            }
           $scope.qaStartArr[itemId] = moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
           var targetQA = angular.element(event.target);
           targetQA.toggleClass('hide-element');
           targetQA.parent().find('.itile').removeClass('hide-element');
           targetQA.parent().find('.timer').removeClass('hide-element');
           $scope.$broadcast('timer-start');
           angular.element('.chk-'+qtyId).removeClass('hide-element');
           toastr.success("Please check all checkbox to continue.");
        }

        /**
         * showQaApprove method is used for show QA Approve button.
         * created on 12.05.2017
         */
        $scope.showQaApprove = function(event,qtyId){
            if (qtyId.indexOf('_') > -1)
            {
              qtyId=qtyId;
            }else{
              qtyId=qtyId+'_1'
            }
           angular.element('.approve-'+qtyId).addClass('hide-element');
           var totalCheckbox=angular.element('.chk-'+qtyId+' input');
           var checked=angular.element('.chk-'+qtyId+' input:checked:not(.itilecheck)');
           var totalChkRdo=totalCheckbox.length-1;
           if(totalChkRdo==checked.length){
             angular.element('.approve-'+qtyId).removeClass('hide-element');
           }
          }

        /**
        * qaApprove method is used for QA Approve of design.
        * created on 12.05.2017
        */
        $scope.itileArr = {};
        $scope.qaStartArr = {};
        $scope.qaEndArr = {};
        $scope.qaApprove = function(event,itemId,status,qtyId, name, qty){
           //call api
            apiService.loaderShow();
            $scope.qaEndArr[itemId] = moment.utc().tz('America/New_York').format('YYYY-MM-DD HH:mm:ss');
            var itileValue;
            var targetQA = angular.element(event.target);
            var time_taken =  targetQA.parent().find('.qa-timer timer span').html();
            if($scope.itileArr[itemId]){
              if($scope.itileArr[itemId]==true){
                itileValue='yes';
              }else if($scope.itileArr[itemId]==false){
                itileValue='no';
              }
            }else{
              itileValue='no';
            }

            angular.element(targetQA).attr("disabled", "disabled");
            var bodyData = {
                order_increment_id: $rootScope.orderId,
                item_id: itemId,
                status: $rootScope.change_status,
                user_name: $rootScope.globals.currentUser.name,
                itile:itileValue,
                qa_start_time:($scope.qaStartArr[itemId]?$scope.qaStartArr[itemId]:''),
                qa_end_time:($scope.qaEndArr[itemId]?$scope.qaEndArr[itemId]:''),
                product_name:name,
                qty : qty,
                time_taken:time_taken,
                action_type:'QA Approve'
            };
            $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
                apiService.loaderHide();
                angular.element(targetQA).removeAttr("disabled");
                if (response.status == 'success') {
                   if (qtyId.indexOf('_') > -1)
                      {
                        qtyId=qtyId;
                      }else{
                        qtyId=qtyId+'_1'
                      }
                     var targetQA = angular.element(event.target);
                     targetQA.parent().find('.itile').addClass('hide-element');
                     $scope.$broadcast('timer-stop');
                     targetQA.parent().find('.timer').addClass('hide-element');
                     angular.element('.chk-'+qtyId).addClass('hide-element');
                     targetQA.toggleClass('hide-element');
                     $scope.getOrderDetails();
                  } else {
                    toastr.error(response.message);
                }
            }).error(function (error) {
                apiService.loaderHide();
                angular.element(targetQA).removeAttr("disabled");
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
            $scope.startOrderCommentTimer();
            //$scope.startOrderListTimer();
      $scope.isQaStart=false;
         }

         /**
          * changeStatusBtn method is used for change order status and display log.
          * created on 07.30.2018
          */
         $scope.changeStatusBtn = function(event,type,name, itemId, status,change_status){

           apiService.loaderShow();
           var bodyData = {
               order_increment_id: $rootScope.orderId,
               item_id: itemId,
               status: change_status,
               user_name: $rootScope.globals.currentUser.name,
               action_type:name
           };
           $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
               apiService.loaderHide();
               if (response.status == 'success') {
                   $scope.getOrderDetails();
               } else {
                   toastr.error(response.message);
               }
           }).error(function (error) {
               apiService.loaderHide();
               if (error && error.code != undefined && error.code == 0) {
                   toastr.error(error.message);
               } else {
                   toastr.error("Something went wrong please try again.");
               }
           });
         }
         /**
          * printSticker method is used for change order status and download sticker.
          * created on 07.30.2018
          */
         $scope.printSticker = function(event,btn_type,name, itemId, status,change_status,order_type){
            var fromDate = 'null';
            var toDate = 'null';
            var userName = 'null';
            var type=order_type?order_type:'null';
            var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
            //type = 'print';
            /*
             var urdd = $rootScope.baseUrl + '/sticker-print/'+fromDate+'/'+toDate+'/'+userName+'/'+type+'/'+loginUserName+'?orderpopupItemId='+itemId+'&scanorderIds='+$rootScope.orderId+'&orderpopupstatus='+status+'&orderpopupusername='+$rootScope.globals.currentUser.name;
             */
            var sticker_type="order_popup_button";
            var tmpType = "dynamic_sticker_" + type;
            type = tmpType;
            var urdd = $rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type +'/'+loginUserName+'/'+sticker_type+'/'+loginUserName+'?orderpopupItemId='+itemId+'&scanorderIds='+$rootScope.orderId+'&orderpopupstatus='+status+'&orderpopupusername='+$rootScope.globals.currentUser.name;
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_print_sticker_"+itemId+".pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });

            var bodyData = {
               order_increment_id: $rootScope.orderId,
               item_id: itemId,
               status: change_status,
               user_name: $rootScope.globals.currentUser.name,
               action_type:name
            };
            $http.post($rootScope.baseUrl + '/order/addlog', bodyData).success(function (response) {
                if (response.status == 'success') {
                    $scope.getOrderDetails();
                } else {
                    toastr.error(response.message);
                }
            }).error(function (error) {
               if (error && error.code != undefined && error.code == 0) {
                   toastr.error(error.message);
               } else {
                   toastr.error("Something went wrong please try again.");
               }
           });
         }
        /**
         * Apply AddOn is use to save AddOn data.
         * created on 11.29.2017
         */
        $scope.applyAddOne = function(event,itemId,proId,cust_name,cust_id){
          var addOnTarget = angular.element(event.target);
          var personPrice = addOnTarget.parent().find('.extra').val();
          var personText = addOnTarget.parent().find('.extra option:selected').text().trim();
          var expressPrice = addOnTarget.parent().find('.express').val();
          var expressText = addOnTarget.parent().find('.express option:selected').text().trim();
          var backgroundPrice = addOnTarget.parent().find('.background').val();
          var backgroundText = addOnTarget.parent().find('.background option:selected').text().trim();
          var engravingPrice = addOnTarget.parent().find('.engraving').val();
          var engravingText = addOnTarget.parent().find('.engraving option:selected').text().trim();
          apiService.loaderShow();
          var bodyData={
            //item_increment_id:proId?proId:itemId+'_1',
            //item_id:itemId,
            item_increment_id:itemId,
            item_id:proId?proId:itemId+'_1',
            order_id:$rootScope.orderId,
            customer_name:cust_name,
            customer_id:cust_id,
            extra_person_price:parseInt(personPrice),
            background_price:parseInt(backgroundPrice),
            engraving_price:parseInt(engravingPrice),
            exoress_price:parseInt(expressPrice),
            extra_person_text:personText,
            background_text:backgroundText,
            engraving_text:engravingText,
            exoress_text:expressText,
          };
          $http.post($rootScope.baseUrl + '/order/storeaddon',bodyData).success(function (response) {
               apiService.loaderHide();
               if(response.status=='success'){
                 addOnTarget.addClass('hide-element');
                 addOnTarget.parent().find('.popuptext').removeClass('show');
                 addOnTarget.parent().find('.addone-apply-btn').addClass('hide-element');
                 //addOnTarget.parent().find('.show-addone').removeClass('hide-element');
                 addOnTarget.parent().parent().find('.cancel-addone').addClass('hide-element');
                 //$scope.addOnDataArr[itemId]=bodyData;
                 $scope.getShowAddOnData();
                 toastr.success(response.message);
               }else{
                 toastr.error(response.message);
               }
            }).error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
        }

        /* TicketID : 25-05-2020  */
        $scope.applyCatAddOne = function(event,itemId,proId,cust_name,cust_id,processfrom){
          if(processfrom == 'order')
          {
            var catPrice = $('#cataddon').val();
            var catText = $('#cataddon option:selected').attr("cls");
            var catCost = $('#cataddon option:selected').attr("cost");
          }
          else
          {
            var catPrice = $('#3djobcategory').val();
            var catText = $('#3djobcategory option:selected').attr("cls");
            var catCost = $('#3djobcategory option:selected').attr("cost");
          }

          apiService.loaderShow();
          var bodyData={
            item_increment_id:itemId,
            item_id:proId?proId:itemId+'_1',
            order_id:$rootScope.orderId,
            customer_name:cust_name,
            customer_id:cust_id,
            cat_price:parseFloat(catPrice),
            cat_text:catText,
            cat_cost:catCost
          };
          $http.post($rootScope.baseUrl + '/order/storecataddon',bodyData).success(function (response) {
               apiService.loaderHide();
               if(response.status=='success'){
                 addOnTarget.addClass('hide-element');
                 addOnTarget.parent().find('.popuptext').removeClass('show');
                 addOnTarget.parent().find('.addone-apply-btn').addClass('hide-element');
                 //addOnTarget.parent().find('.show-addone').removeClass('hide-element');
                 addOnTarget.parent().parent().find('.cancel-addone').addClass('hide-element');
                 //$scope.addOnDataArr[itemId]=bodyData;
                 $scope.getShowCatAddOnData();
                 toastr.success(response.message);
               }else{
                 toastr.error(response.message);
               }
            }).error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
        }

        /**
         * Show AddOn is use to show AddOn options controller.
         * created on 11.29.2017
         */
        $scope.showAddOne = function($event){
            $scope.killOrderDetailsTimer();
            var target = angular.element($event.target);
            if(target.attr('isIcon')){
               target = angular.element($event.target).parent();
            }
            target.toggleClass('hide-element');
            target.parent().find('.popuptext').addClass('show');
            target.parent().find('.addone-apply-btn').removeClass('hide-element');
            target.parent().parent().find('.cancel-addone').removeClass('hide-element');

        }

        $scope.applyFigurineCost = function($event,itemId,proId)
        {
          var figurinecost = $('#figurinecost').val();
          console.log(figurinecost);
          console.log(itemId);
          console.log(proId);

          var target = angular.element($event.target);
          if(target.attr('isFigurine')){
             target = angular.element($event.target).parent();
          }
            
          apiService.loaderShow();
          var bodyData={
            item_increment_id:itemId,
            item_id:proId?proId:itemId+'_1',
            order_id:$rootScope.orderId,
            cat_price:parseFloat(figurinecost),
            username:$rootScope.globals.currentUser.name,
            user_id:$rootScope.globals.currentUser.id
          };
          $http.post($rootScope.baseUrl + '/order/storefigurinecost',bodyData).success(function (response) {
               apiService.loaderHide();
               console.log(response.status);

               if(response.status=='success'){
                 target.addClass('hide-element');
                 target.parent().find('.popuptext').removeClass('show');
                 target.parent().find('.figurine-apply-btn').addClass('hide-element');
                 //addOnTarget.parent().find('.show-addone').removeClass('hide-element');
                 target.parent().parent().find('.cancel-figurine').addClass('hide-element');
                 //$scope.addOnDataArr[itemId]=bodyData;
                 $scope.getShowCatAddOnData();
                 toastr.success(response.message);
               }else{
                 toastr.error(response.message);
               }

            }).error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
        }

        $scope.showFigurineCostPopup = function ($event, itemId, qtyId) {
          $scope.killOrderDetailsTimer();
            var target = angular.element($event.target);
            if(target.attr('isFigurine')){
               target = angular.element($event.target).parent();
            }
            $scope.ItemIncrementID = itemId;
            target.toggleClass('hide-element');
            //target.parent().find('.popuptext').addClass('show');
            $('#figurineCostModel').modal();
            //target.parent().find('.figurine-apply-btn').removeClass('hide-element');
            //target.parent().parent().find('.cancel-figurine').removeClass('hide-element');


        }

        $scope.saveFigurineCost = function () {
          $scope.killOrderDetailsTimer();

          var figurinecost = $("#figurineCost").val();
          console.log(figurinecost);
          console.log($scope.ItemIncrementID);
          var itemId = $scope.ItemIncrementID;
          var proId = null;

          apiService.loaderShow();
          var bodyData={
            item_increment_id:itemId,
            item_id:proId?proId:itemId+'_1',
            order_id:$rootScope.orderId,
            cat_price:parseFloat(figurinecost),
            username:$rootScope.globals.currentUser.name,
            user_id:$rootScope.globals.currentUser.id
          };
          $http.post($rootScope.baseUrl + '/order/storefigurinecost',bodyData).success(function (response) {
               apiService.loaderHide();
               console.log(response.status);

               if(response.status=='success'){
                $('#figurineCostModel').modal('hide');
                $scope.getOrderDetails();
                toastr.success(response.message);
               }else{
                 toastr.error(response.message);
               }

            }).error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }

        $scope.closeFigurineCostPopup = function() {
          $scope.killOrderDetailsTimer();
          $(".add-figurinecost").removeClass('hide-element');
          $(".add-figurinecost").addClass('show-element');
          $('#figurineCostModel').modal('hide');
        }

        $scope.cancelFigurineCost = function ($event) {
          $scope.startOrderDetailsTimer();
            var target = angular.element($event.target);
            if(target.attr('isFigurine')){
               target = angular.element($event.target).parent();
            }
            target.addClass('hide-element');
            target.parent().find('.popuptext').removeClass('show');
            target.parent().find('.figurine-apply-btn').addClass('hide-element');
            target.parent().find('.add-figurinecost').removeClass('hide-element');
            target.parent().find('.add-figurinecost').addClass('show-element');
        }

        /**
         * Cancel AddOn is use to Cancel AddOn options.
         * created on 11.29.2017
         */
        $scope.cancelAddOne = function($event){
            $scope.startOrderDetailsTimer();
            var target = angular.element($event.target);
            if(target.attr('isIcon')){
               target = angular.element($event.target).parent();
            }
            target.addClass('hide-element');
            target.parent().find('.popuptext').removeClass('show');
            target.parent().find('.addone-apply-btn').addClass('hide-element');
            target.parent().find('.add-addone').removeClass('hide-element');
            target.parent().find('.add-addone').addClass('show-element');
        }

        /**
         * AddOn Info is use to show AddOn options popup.
         * created on 11.29.2017
         */
        $scope.addOneInfo = function(event){
            var target = angular.element(event.target);
            //target.toggleClass('hide-element');
            target.parent().find('.showpopuptext').addClass('show');
            //target.parent().find('.show-addone').removeClass('hide-element');
            target.parent().find('.show-popup-close').removeClass('hide-element');
        }

        /**
         * Close AddOn Info is use to hide AddOn options popup.
         * created on 11.29.2017
         */
        $scope.closeAddOnShow = function(event){
            var target = angular.element(event.target);
            target.closest('.showpopuptext').removeClass('show');
        }

        /**
         * rework Order is use to save rework order data.
         * created on 11.28.2017
         */
        $scope.reworkOrder = function () {
            $scope.progressbar.start();
            if (!this.reworkForm.$valid) {
                $scope.progressbar.complete();
               return;
             }
             var rwkQty;
             if($rootScope.reworkType && $rootScope.reworkType=='qtyRework'){
               rwkQty=this.reworkQuantity?this.reworkQuantity:0;
             }else{
               rwkQty=0;
             }
             apiService.loaderShow();
             var bodyData={
               original_order_id:$rootScope.orderId,
               ticket_id:this.ticketId,
               item_id:$rootScope.itemId?$rootScope.itemId:'',
               reason:this.reworkReason,
               solution:this.reworkSolution,
               spe_ins:this.specialInstruction?this.specialInstruction:'',
               qty:rwkQty,
               created_by:$rootScope.globals.currentUser.id,
               product_name:$rootScope.rewProductName?$rootScope.rewProductName:'',
               customer_id:$rootScope.reworkCustomerId,
               rework_order_status:$scope.reworkOrderStatus
             };
             var reworkUrl;
             if($rootScope.reworkType && $rootScope.reworkType=='orderRework'){
               bodyData['increment_id']=$rootScope.orderId;
               reworkUrl=$rootScope.baseUrl + '/order/rework-order';
             }else{
               reworkUrl=$rootScope.baseUrl + '/report/reworkorder';
             }
             $http.post(reworkUrl,bodyData).success(function (response) {
                  apiService.loaderHide();
                  if(response.status=='success'){
                    $scope.progressbar.complete();
                    toastr.success(response.message);
                    $scope.closeReworkModal();
                  }else{
                    $scope.progressbar.complete();
                    toastr.error(response.message);
                    $scope.closeReworkModal();
                  }
               }).error(function (error) {
                   $scope.progressbar.complete();
                   apiService.loaderHide();
                   if (error && error.code != undefined && error.code == 0) {
                       toastr.error(error.message);
                   } else {
                       toastr.error("Something went wrong please try again.");
                   }
               });
               $scope.closeReworkModal();
               $scope.startOrderDetailsTimer();
               angular.element('#reworkReason').val('');
               angular.element('#reworkSolution').val('');
               angular.element('#ticketId').val('');
               angular.element('#reworkQuantity').val('');
               angular.element('#specialInstruction').val('');
               this.reworkReason = '';
               $scope.reworkSolutionList = '';
               this.reworkSolution = '';
               $scope.reworkSolutionList = '';
               this.specialInstruction = '';
               $scope.specialInstruction = '';
        };

        $scope.commentShipmentOrder = function (event)
        {
          var target = angular.element(event.target);
          var comment = target.parent().parent().parent().find('.comment').val();
          if(comment == ""){
            target.parent().parent().parent().find('.error').removeClass('hide-element');
          }else{
            target.parent().parent().parent().find('.error').addClass('hide-element');
          }
          
          var bodyData={
             order_id:$rootScope.orderId,
             user_type:$rootScope.globals.currentUser.userRole,
             username:$rootScope.globals.currentUser.name,
             comment:comment
           };

           $http.post($rootScope.baseUrl + '/order/shipmentcomment',bodyData).success(function (response) {
            if(response.status=='success'){
              $scope.getCommentData();
              $scope.getOrderShipmentCommentData();
              angular.element('.comment').val('');
              toastr.success(response.message);
            }else{
              toastr.error(response.message);
            }
           }).error(function (error) {
            angular.element(target).removeAttr("disabled");
            if (error && error.code != undefined && error.code == 0) {
              toastr.error(error.message);
            } else {
              toastr.error("Something went wrong please try again.");
            }
           });
        };

        /**
         * comment Order is use to save comment order data.
         * created on 11.28.2017
         */

        $scope.commentOrder = function (event,itemId) {
           var target = angular.element(event.target);
           $scope.killOrderCommentTimer();
           angular.element(target).attr("disabled", "disabled");
           $scope.killOrderDetailsTimer();
           var comment = target.parent().parent().parent().find('.comment').val();
           if(comment == ""){
             target.parent().parent().parent().find('.error').removeClass('hide-element');
           }else{
             target.parent().parent().parent().find('.error').addClass('hide-element');
           }
           apiService.loaderShow();
             var bodyData={
               order_id:$rootScope.orderId,
               item_id:itemId,
               user_type:$rootScope.globals.currentUser.userRole,
               username:$rootScope.globals.currentUser.name,
               comment:comment,
             };
             $http.post($rootScope.baseUrl + '/order/comment',bodyData).success(function (response) {
                  apiService.loaderHide();
                  angular.element(target).removeAttr("disabled");
                  if(response.status=='success'){
                    $scope.getCommentData();
                    $scope.getOrderShipmentCommentData();
                    angular.element('.comment').val('');
                    toastr.success(response.message);
                  }else{
                    toastr.error(response.message);
                  }
               }).error(function (error) {
                   apiService.loaderHide();
                   angular.element(target).removeAttr("disabled");
                   if (error && error.code != undefined && error.code == 0) {
                       toastr.error(error.message);
                   } else {
                       toastr.error("Something went wrong please try again.");
                   }
               });
               $scope.startOrderCommentTimer();
        };
        
        /***
         * Office comment Order is use to save office comment order data.
         * created on 04.11.2019
         */
        $scope.officeCommentOrder = function (event,itemId) {
            var target = angular.element(event.target);
            $scope.killOrderOfficeCommentTimer();
            angular.element(target).attr("disabled", "disabled");
            $scope.killOrderDetailsTimer();
            var comment = target.parent().parent().parent().find('.office-comment').val();
            if (comment == "") {
                target.parent().parent().parent().find('.error').removeClass('hide-element');
            } else {
                target.parent().parent().parent().find('.error').addClass('hide-element');
            }
            apiService.loaderShow();
            var bodyData = {
                order_id: $rootScope.orderId,
                item_id: itemId,
                user_type: $rootScope.globals.currentUser.userRole,
                username: $rootScope.globals.currentUser.name,
                comment: comment,
            };
            $http.post($rootScope.baseUrl + '/order/office-comment', bodyData).success(function (response) {
                apiService.loaderHide();
                angular.element(target).removeAttr("disabled");
                if (response.status == 'success') {
                    $scope.getOfficeCommentData();
                    $scope.getReDesignCommentData();
                    angular.element('.office-comment').val('');
                    toastr.success(response.message);
                } else {
                    toastr.error(response.message);
                }
            }).error(function (error) {
                apiService.loaderHide();
                angular.element(target).removeAttr("disabled");
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderOfficeCommentTimer();
        };
        
        /**
         * dynamic display order popup button api
         * created on 11.04.2018
         */
         $scope.getDynamicButton=function(){
             $http.get($rootScope.baseUrl + '/orderpopupbuttons/activebutton')
               .success(function(result) {
                 $scope.dynamicBtnList=result;
               }).error(function (error) {
                   if (error.code != undefined && error.code == 0) {
                       toastr.error(error.message);
                   }
               });
         }
         $scope.checkMultipleStatusForBtn=function(type,status){
           return true;
         }
         /**
          * CheckStatusForBtn method is used for show hide buttons by status.
          * created on 10.09.2017
          */
         $scope.checkStatusForBtn = function(show_status, status){
           var showStatus=angular.fromJson(show_status);
           if(showStatus.indexOf(status)===-1){
             return false;
           }else{
             return true;
           }
         }
         /**
          * changeOrderStatus method is used for change order status.
          * created on 25.06.2018
          */
         $scope.changeOrderStatus=function(type,name,change_status,event,itemId,status,qtyId,order_type,product_name,customer_id,itemQty,isRework,relay_link_price_category)
         {
          if(type=='ReDesign')
            {
              var targetJob = angular.element(event.target);
              angular.element(targetJob).attr("disabled", "disabled");
              $scope.open3DRework(itemId,change_status);
              return false;
            }
            else if(type=='3D Job Done')
            {
              console.log(relay_link_price_category);
              if(relay_link_price_category != '2D Crystal' && relay_link_price_category != 'Base' && relay_link_price_category != 'Other')
              {
                $scope.uploadFiletype = type;
                $scope.uploadFilename = name;
                $scope.uploadFilechange_status = change_status;
                $scope.uploadFileItemIncrementId = itemId;
                $scope.uploadFilestatus = status;
                $scope.uploadFileqtyId = qtyId;
                $scope.uploadFileorder_type = order_type;
                $scope.uploadFileproduct_name = product_name;
                $scope.uploadFilecustomer_id = customer_id;
                $scope.uploadFileitemQty = itemQty;
                $scope.uploadFileisRework = isRework;
                $('#uploadFileConfirm').modal(); return false;
              }
              else {
                $scope.job3dDone(event,type,name, itemId, status,change_status,isRework);
              }
            }else if(type=='Job Start'){
              $scope.jobStart(event,type,name, itemId, status,change_status,isRework)
            }else if(type=='Job Done'){
              $scope.jobDone(event,type,name, itemId, status,change_status,isRework)
            }else if(type=='QA Start'){
              $scope.qaStart(event,type,itemId,status,qtyId,change_status)
            }else if(type=='Order Log'){
              $scope.openLogHistory(itemId)
            }else if(type=='Change Status'){
              $scope.changeStatusBtn(event,type,name, itemId, status,change_status);
            }else if(type=='Print Sticker'){
              $scope.printSticker(event,type,name, itemId, status,change_status,order_type);
            }else if(type=='Rework'){
              $scope.openRework('qtyRework',customer_id,itemId,product_name,itemQty);
            }
         }

         $scope.saveUploadFile = function (event)
          {
            apiService.loaderShow();
            if (!this.uploadFileForm.$valid) {
                apiService.loaderHide();
                return;
            }
            var file = document.getElementById('fileUploadx').files[0];
            if (!file) {
                angular.element("#error-upload-file").show();
                apiService.loaderHide();
                return '';
            }
            var afterDot = file.name.substr(file.name.indexOf('.')+1);
            if (afterDot == "zip" || afterDot == "rar")
            {
             // apiService.loaderHide();
             // toastr.error("Something went wrong please try again.");
             // return '';
                var bodyData = {
                  created_by_name: $rootScope.globals.currentUser.name,
                  created_by: $rootScope.globals.currentUser.id,
                  order_increment_id: $rootScope.orderId,
                  item_increment_id: $scope.uploadFileItemIncrementId,
                  item_qty_id: $scope.uploadFileqtyId
                };
                if(file) {
                  bodyData.upload_file_design_complete = file;
                }

                var fileUploadUrl = $rootScope.baseUrl + '/order/upload-file-design-complete';
                $http({
                    url: fileUploadUrl,
                    method: 'POST',
                    headers: {
                        'Content-Type': undefined
                    },
                    transformRequest: function (data) {
                        var formData = new FormData();
                        for (var i in bodyData) {
                            formData.append(i, bodyData[i]);
                        }
                        return formData;
                    }
                }).then(function (response) {
                  apiService.loaderHide();
                  console.log(response.data);
                  if (response.data.status == 'success')
                  {
                    //$scope.changeStatusBtn(event,$scope.uploadFiletype,$scope.uploadFilename,$scope.uploadFileItemIncrementId,$scope.uploadFilestatus,$scope.uploadFilechange_status);
                    $scope.job3dDone(event,$scope.uploadFiletype,$scope.uploadFilename, $scope.uploadFileItemIncrementId, $scope.uploadFilestatus,$scope.uploadFilechange_status,$scope.uploadFileisRework);
                    toastr.success(response.data.message);
                    $scope.closeModalUploadFilePopUp();
                  }
                  else {
                    toastr.error(response.message);
                    $scope.closeModalUploadFilePopUp();
                  }
                }, function (error) {
                  apiService.loaderHide();
                  if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                  } else {
                    toastr.error("Something went wrong please try again.");
                  }
                });
                $scope.closeModalUploadFilePopUp();
                jQuery("#fileUploadx").val('');
                file = '';
            }
            else
            {
                apiService.loaderHide();
                angular.element("#error-upload-invalid-file").show();
                return '';
            }
         }

          $scope.closeModalUploadFilePopUp = function ()
          {
              $('#uploadFileConfirm').modal('hide');
              $('#error-upload-file').hide();
              $('#error-upload-invalid-file').hide();
          };

          $scope.hideUploadFileValidation = function(query)
          {
            $('#error-upload-file').hide();
            $('#error-upload-invalid-file').hide();
          };
         /**
          * saveProductName method is used for update product name of order.
          * created on 16.05.2018
          */
         $scope.saveProductName=function(item,product){
           if(product){
             apiService.loaderShow();
             var bodyData = {
                 item_increment_id: item.item_increment_id,
                 order_increment_id: $rootScope.orderId,
                 item_id:item.item_increment_id,
                 name:  product,
                 old_prodcutname:product,
                 user_name:$rootScope.globals.currentUser.name
             };
             $http({
                 url: $rootScope.baseUrl+'/order/updateitem',
                 method: "PUT",
                 data: $scope.dataUrlEncode(bodyData),
                 headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
             }).then(function (response) {
                 var response = response.data;
                 if (response.status == 'success') {
                     toastr.success(response.message);
                 }else{
                     if(response.message){
                        toastr.error(response.message);
                     }
                 }
                 $scope.getOrderDetails();
                apiService.loaderHide();
             }, function (response) {
                  toastr.error("Something went wrong please try again.");
                  apiService.loaderHide();
             });
           }else{
             toastr.error("Please select product name.");
           }
           $scope.startOrderDetailsTimer();
         }
         /**
          * saveEngraving method is used for update engraving of order.
          * created on 16.05.2018
          */
         $scope.saveEngraving=function(item,engraving){
           if(engraving){
             apiService.loaderShow();
             var bodyData = {
                 item_increment_id: item.item_increment_id,
                 engravingn:  engraving,
                 order_increment_id: $rootScope.orderId,
                 item_id:item.item_increment_id,
                 old_engravingname:engraving,
                 user_name:$rootScope.globals.currentUser.name
             };
             $http({
                 url: $rootScope.baseUrl+'/order/updateitemengraving',
                 method: "PUT",
                 data: $scope.dataUrlEncode(bodyData),
                 headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
             }).then(function (response) {
                 var response = response.data;
                 if (response.status == 'success') {
                     toastr.success(response.message);
                 }else{
                     if(response.message){
                        toastr.error(response.message);
                     }
                 }
                 $scope.getOrderDetails();
                apiService.loaderHide();
             }, function (response) {
                  toastr.error("Something went wrong please try again.");
                  apiService.loaderHide();
             });
           }
           $scope.startOrderDetailsTimer();
         }
         /**
          * copy engraving success and fail message.
          * created on 11.06.2018
          */
         $scope.success = function () {
            toastr.success('Copied!');
          };

          $scope.fail = function (err) {
            toastr.error('Error!', err);
          };
          /**
           * getEditAndLogSetting method is use to get product and engraving edit btn and log settings.
           * created on 21.06.2018
           */
          $scope.getEditAndLogSetting=function(){
            $http.get($rootScope.baseUrl + '/config/setting/save-edit-button')
                    .success(function (result) {
                      if(result.data && result.data!=undefined){
                        $scope.editBtnStatus=result.data;
                        angular.forEach($scope.editBtnStatus,function(val,key){
                          var status=[];
                          angular.forEach(val.status,function(stsVal,stsKey){
                            status.push(stsVal.status_label);
                          });
                          $scope.editBtnStatus[val.name]={'status':status};
                        });
                      }
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data && error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        }
                    });
          }
          $scope.showEditAndLogBtn=function(type,status,permission){
            console.log($scope.editBtnStatus);
            if($scope.editBtnStatus){
              if($scope.editBtnStatus[type].status.indexOf(status) !== -1 && $rootScope.permissionArr.indexOf(permission) !== -1){
                return true;
              }else{
                return false;
              }
            }
          }
          $scope.showInfoTabReworkBtn=function(status,permission){
            if($scope.availableOrderStatus){
              if($scope.availableOrderStatus.indexOf(status) !== -1 && $rootScope.permissionArr.indexOf(permission) !== -1){
                return true;
              }else{
                return false;
              }
            }
          }
          /**
           * Get all products list method is use to get product data.
           * created on 07.13.2018
           */
          $scope.getAllProductsList = function(){
              $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
              .success(function (response) {
                $scope.allProducts=response;
               angular.element(document).ready(function () {
                 $timeout(function () {
                     angular.element('.product-name').selectpicker('refresh');
                 }, 1000);
               });
              }).error(function (response) {
              });
          }
          $scope.getAllProductsList();
          /**
           * get Rework Setting Data method is use to display Rework Setting data.
           * created on 08.27.2018
           */
          $scope.getReworkSettingData = function() {
            $http.get($rootScope.baseUrl + '/config/reworkSetting')
              .success(function(result) {
                if (result) {
                  if (result.status == 'fail') {
                    //toastr.error(result.message);
                  } else {
                    if (result.data) {
                      $scope.availableOrderStatus=result.data.available_order_status;
                      $scope.reworkOrderStatus=result.data.rework_order_status;
                      $scope.reworkReasonList = result.data.rework_reason;
                      $scope.reworkSolutionList = result.data.rework_solution;
                      // default selected value in dropdown
                      angular.forEach($scope.reworkReasonList,function(val,key){
                        if(val.set_default=='1'){
                          $scope.reworkReason=val.name;
                        }
                      });
                      angular.forEach($scope.reworkSolutionList,function(val,key){
                        if(val.set_default=='1'){
                          $scope.reworkSolution=val.name;
                        }
                      });
                    }
                  }
                }
              }).error(function(error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
                }
              });
          }
          /**
           * get Job Setting Data method is use to display Job Setting data.
           * created on 09.06.2018
           */
          $scope.getJobSettingData = function() {
            $http.get($rootScope.baseUrl + '/config/jobSetting')
              .success(function(result) {
                if (result) {
                  if (result.status == 'fail') {
                    //toastr.error(result.message);
                  } else {
                    if (result.data) {
                      var resultData=result.data;
                      // Open Job
                      $scope.OJvmExecutionCode=resultData.open_job.vm_execution_code;
                      $scope.OJfileLocation=$rootScope.globals.currentUser.open_job_override_folder=="Yes"?$rootScope.globals.currentUser.open_job_default_folder:resultData.open_job.file_location;
                      $scope.OJfolderName=resultData.open_job.folder_name;

                      // Open Job DB
                      $scope.OJDBvmExecutionCode=resultData.open_job_db.vm_execution_code;
                      $scope.OJDBfileLocation=$rootScope.globals.currentUser.open_job_db_override_folder=="Yes"?$rootScope.globals.currentUser.open_job_db_default_folder:resultData.open_job_db.file_location;
                      $scope.OJDBfolderName=resultData.open_job_db.folder_name;

                      // Create Job
                      $scope.CJvmExecutionCode=resultData.create_job.vm_execution_code;
                      $scope.CJfont = resultData.create_job.font;
                      // Create 2D Job
                      $scope.C2DJvmExecutionCode=resultData.create_2d_job.vm_execution_code;
                      $scope.C2DJfont = resultData.create_2d_job.font;
                    }
                  }
                }
              }).error(function(error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
                }
              });
          }
          // define default value
          $scope.createTitle='Create';
          $scope.createButtonUrl='system';
          $scope.readyTitle='Ready';
          $scope.readyUrl='system';
          $scope.title3dcDownload='3DC Download';
          $scope.titlezipDownload='Zip File Download';
          $scope.upload='Download';
          $scope.amazonDownload='A-Download';
          $scope.url3dcDownload='system';
          $scope.createButtonEncrypted='No';
          $scope.readyEncrypted='No';
          $scope.url3dcEncrypted='No';
          $scope.uploadEncrypted='No';
          $scope.amazonEncrypted='No';
          $scope.getRelayButtonSettings = function() {
            $http.get($rootScope.baseUrl + '/config/relayButtonSetting')
              .success(function(result) {
                if (result) {
                  if (result.status == 'fail') {
                    //toastr.error(result.message);
                  } else {
                    if (result.data) {
                      var resultData=result.data;
                      // Create button
                      $scope.createTitle=resultData.create_button.create_title?resultData.create_button.create_title:'Create';
                      $scope.createButtonUrl=resultData.create_button.create_url?resultData.create_button.create_url:'system';
                      var tmpCreateButtonEncrypted = resultData.create_button.create_encrypted?resultData.create_button.create_encrypted:'No';
                      if (tmpCreateButtonEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.createButtonEncrypted = 'Yes';
                      }

                      // Ready Button
                      $scope.readyTitle=resultData.ready_button.ready_title?resultData.ready_button.ready_title:'Ready';
                      $scope.readyUrl=resultData.ready_button.ready_url?resultData.ready_button.ready_url:'system';
                      var tmpreadyEncrypted = resultData.ready_button.ready_encrypted?resultData.ready_button.ready_encrypted:'No';
                      if (tmpreadyEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.readyEncrypted = 'Yes';
                      }

                      // 3DC Download button
                      $scope.title3dcDownload=resultData.download_3dc_button.title_3dc_download?resultData.download_3dc_button.title_3dc_download:'3DC Download';
                      $scope.url3dcDownload = resultData.download_3dc_button.url_3dc_download?resultData.download_3dc_button.url_3dc_download:'system';
                      var tmpurl3dcEncrypted = resultData.download_3dc_button.url_3dc_encrypted?resultData.download_3dc_button.url_3dc_encrypted:'No';
                      if (tmpurl3dcEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.url3dcEncrypted = 'Yes';
                      }
                      
                      // Upload
                      $scope.upload=resultData.upload.upload?resultData.upload.upload:'Download';
                      var tmpuploadEncrypted = resultData.upload.upload_encrypted?resultData.upload.upload_encrypted:'No';
                      if (tmpuploadEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.uploadEncrypted = 'Yes';
                      }
                      
                      // Amazon Download button
                      $scope.amazonDownload=resultData.amazon.download?resultData.amazon.download:'A-Download';
                      var tmpurlAmazonEncrypted = resultData.amazon.encrypted?resultData.amazon.encrypted:'No';
                      if (tmpurlAmazonEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.amazonEncrypted = 'Yes';
                      }

                      $scope.databaseJob = 'Database Job';
                    }
                  }
                }
              }).error(function(error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
                }
              });
          }
          // open job uri
          $scope.getOpenJobUri=function(itemId){
            if(itemId && $scope.OJvmExecutionCode){
              var uri=$scope.OJvmExecutionCode+'%09'+$scope.OJfileLocation+'\\'+itemId+'.vmj';
              //return encodeURI(uri);
              return uri;
            }else{
              return '';
            }
          }
          // open job db uri
          $scope.getOpenJobDBUri=function(itemId,qty){
            if(itemId && $scope.OJDBvmExecutionCode){
              var uri=$scope.OJDBvmExecutionCode+'%09'+$scope.OJDBfileLocation+'\\'+itemId+'.vmj%09'+itemId+'%09'+qty+'%09';
              return uri;
            }else{
              return '';
            }
          }
          // open job db uri
          $scope.getOpenJobDBUriForWeCreate=function(itemId,qty,itemName, isMumbai){
            if (isMumbai == 'YES') {
                itemId = itemId.replace('3dtracker', "3dtrackermumbai");
            }
            if(itemId && $scope.OJDBvmExecutionCode){
              var uri=$scope.OJDBvmExecutionCode+'%09'+itemId+'%09'+itemName+'%09'+qty+'%09';
              return uri;
            }else{
              return '';
            }
          }
          
          $scope.get3dcDownload=function(type, originalReay, relay) {
            if (type == 'indiaserver') {
                return relay.replace('3dtracker', "3dtrackermumbai");
            } else if (type == 'relay') {
                return originalReay;
            } else {
                return relay;
            }
        };
          // create job uri
          $scope.getCreateJobUri=function(prod_name,engraving,engnew,file, isMumbai){
            if (isMumbai == 'YES') {
                file = file.replace('3dtracker', "3dtrackermumbai");
            }
            //$scope.killOrderDetailsTimer();
            var eng,orientation,orientation_dash;
            if(engraving){
              angular.forEach(engraving,function(val,key){
                if(val.label=='Orientation' && val.label=='Choose Orientation'){
                  if(val.label=='Orientation'){
                    orientation=val.value;
                  }
                }else{
                  if(val.label=='Orientation' || val.label=='Choose Orientation'){
                    orientation=val.value;
                  }
                }
                if(val.label=='Enter Your Engraving' && val.label=='Add Free Engraving'){
                  if(val.label=='Enter Your Engraving'){
                    eng=val.value;
                  }
                }else{
                  if(val.label=='Enter Your Engraving' || val.label=='Add Free Engraving'){
                    eng=val.value;
                  }
                }

              });
            }
            if(orientation){
              orientation=orientation;
              orientation_dash='-';
            }else{
              orientation='%20';
              orientation_dash='';
            }
            if(eng){
              eng=engnew?engnew:eng;
              eng=eng.replace('\n','<br />');
              eng=eng.replace('<br />','%CR%');
              eng=eng.replace(/\s+/g,'%20');
              eng=eng.replace(/"/g,'%QM%');
            }else{
              eng='';
            }

            var rpsName=prod_name.trim();
            rpsName=rpsName.replace(/\s+/g,'-');
            if($scope.CJvmExecutionCode){//'%20%22'+eng+'%22%20'
              var uri=$scope.CJvmExecutionCode+'%09'+file+'%20'+rpsName+orientation_dash+orientation+'%20%22'+eng+'%22%20'+$scope.CJfont+'%20';
              return uri;
            }else{
              return '';
            }
          }
          // create 2d job uri
          $scope.getCreate2DJobUri=function(itemId,prod_name,engraving,engnew,file,image_download_path){
            //$scope.killOrderDetailsTimer();
            var eng,orientation,orientation_dash;
            if(engraving){
              // angular.forEach(engraving,function(val,key){
              //   if(val.label=='Orientation'){
              //     orientation=val.value;
              //   }
              //   if(val.label=='Enter Your Engraving'){
              //     eng=val.value;
              //   }
              // });
              angular.forEach(engraving,function(val,key){
                if(val.label=='Orientation' && val.label=='Choose Orientation'){
                  if(val.label=='Orientation'){
                    orientation=val.value;
                  }
                }else{
                  if(val.label=='Orientation' || val.label=='Choose Orientation'){
                    orientation=val.value;
                  }
                }
                if(val.label=='Enter Your Engraving' && val.label=='Add Free Engraving'){
                  if(val.label=='Enter Your Engraving'){
                    eng=val.value;
                  }
                }else{
                  if(val.label=='Enter Your Engraving' || val.label=='Add Free Engraving'){
                    eng=val.value;
                  }
                }

              });
            }
            if(orientation){
              orientation=orientation;
              orientation_dash='-';
            }else{
              orientation='%20';
              orientation_dash='';
            }
            if(eng){
              eng=engnew?engnew:eng;
              eng=eng.replace('\n','<br />');
              eng=eng.replace('<br />','%CR%');
              //eng=eng.replace(' ','%20');
              //eng=eng.replace("",'%QM%');
              eng=eng.replace(/\s+/g,'%20');
              //eng=eng.replace('\"','%QM%');
              eng=eng.replace(/"/g,'%QM%');
            }else{
              eng='';
            }
            var rpsName=prod_name.trim();
            rpsName=rpsName.replace(/\s+/g,'-');
            if($scope.C2DJvmExecutionCode){//'%20%22'+eng+'%22%20'
              //var uri=$scope.C2DJvmExecutionCode+'%09'+file+'%20'+rpsName+orientation_dash+orientation+'%20%22'+eng+'%22%20'+$scope.C2DJfont+'%20';
              //var downloadFile=$rootScope.baseUrl + '/order/download-2d-job/'+itemId;
              var downloadFile=$rootScope.baseUrl + '/download-image-url/'+itemId+ '/regular';
              if(image_download_path != '' && image_download_path != null) {
                var uri=$scope.C2DJvmExecutionCode+'%09'+image_download_path+'%20'+rpsName+orientation_dash+orientation+'%20%22'+eng+'%22%20'+$scope.C2DJfont+'%20';
              }
              else {
                var uri=$scope.C2DJvmExecutionCode+'%09'+downloadFile+'%20'+rpsName+orientation_dash+orientation+'%20%22'+eng+'%22%20'+$scope.C2DJfont+'%20';
              }
              return uri;
            }else{
              return '';
            }
          }
          /**
           * get Relay Setting Data method is use to display Relay Setting data.
           * created on 09.30.2018
           */
          $scope.getRelaySettingData = function() {
              $http.get($rootScope.baseUrl + '/config/relaySetting')
                .success(function(result) {
                  if (result) {
                    if (result.status == 'fail') {
                      //toastr.error(result.message);
                    } else {
                      if (result.data) {
                        var resultData=result.data;
                        $scope.jobService=resultData.job_service;
                        /*
                        $scope.priority=resultData.priority;
                        */
                        $scope.priority = [
                            {'name':'Regular', 'hours':12},
                            {'name':'Express', 'hours':3},
                            {'name':'Preferred', 'hours':8}
                        ];
                      }
                    }
                  }
                }).error(function(error) {
                  if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                  }
                });
          }

          $scope.saveFullRelaySettings=function(event,entityId){
            var targetRelay = angular.element(event.target);
            var jobService =  targetRelay.parents().find('.job-service').val();
            var priority =  targetRelay.parents().find('.priority').val();
            if(!jobService){
              toastr.error('Please select job service');
              return;
            }
            if(!priority){
              toastr.error('Please select priority');
              return;
            }
            $scope.progressbar.start();
            var bodyData = {
                order_id: entityId,
                priority:priority,
                job_service:jobService,
                relay_created_by:$rootScope.globals.currentUser.name
            };
            $http.post($rootScope.baseUrl + '/relay-full-order-save', bodyData).success(function (response) {
                $scope.progressbar.complete();
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.getOrderDetails();
                } else {
                  if(response.message.errors){
                    toastr.error(response.message.message);
                  }else{
                    toastr.error(response.message);
                  }
                }
            }).error(function (error) {
              $scope.progressbar.complete();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
          }

          $scope.saveRelaySettings=function(event,itemId){
            var targetRelay = angular.element(event.target);
            var jobService =  targetRelay.parents().find('.job-service-single').val();
            var priority =  targetRelay.parents().find('.priority-single').val();
            //var relayUserName =  targetRelay.parents().find('.relay-user-name').val();
            if(!jobService){
              toastr.error('Please select job service');
              return;
            }
            if(!priority){
              toastr.error('Please select priority');
              return;
            }
            $scope.progressbar.start();
            var bodyData = {
                order_id: $rootScope.orderEntityId,
                item_id: itemId,
                priority:priority,
                job_service:jobService,
                relay_created_by:$rootScope.globals.currentUser.name
            };
            $http.post($rootScope.baseUrl + '/relay-order-save', bodyData).success(function (response) {
                $scope.progressbar.complete();
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.getOrderDetails();
                } else {
                  if(response.message.errors){
                    toastr.error(response.message.message);
                  }else{
                    toastr.error(response.message);
                  }
                }
            }).error(function (error) {
                $scope.progressbar.complete();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
          }

          $scope.saveNewRelaySettings=function(event,itemId){
            var targetRelay = angular.element(event.target);
            var newjobService =  targetRelay.parents().find('.new-job-service-single').val();
            var newpriority =  targetRelay.parents().find('.new-priority-single').val();
            //var relayUserName =  targetRelay.parents().find('.relay-user-name').val();
            if(!newjobService){
              toastr.error('Please select job service');
              return;
            }
            if(!newpriority){
              toastr.error('Please select priority');
              return;
            }
            $scope.progressbar.start();
            var bodyData = {
                order_id: $rootScope.orderEntityId,
                item_id: itemId,
                priority:newpriority,
                job_service:newjobService,
                relay_created_by:$rootScope.globals.currentUser.name
            };
            $http.post($rootScope.baseUrl + '/new-relay-order-save', bodyData).success(function (response) {
                $scope.progressbar.complete();
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.getOrderDetails();
                } else {
                  if(response.message.errors){
                    toastr.error(response.message.message);
                  }else{
                    toastr.error(response.message);
                  }
                }
            }).error(function (error) {
                $scope.progressbar.complete();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
          }

          $scope.uploadQRManual=function(event, itemId,prod_qty_id)
          {
            var file = document.getElementById('manualQRUpload').files[0];
            if (!file) {
                toastr.error('Please select file first to upload');
                return '';
            }
            $("#myBarQR").css("width", "0%");
            $("#QRProgress").show();
            var elem = document.getElementById("myBar");
            var width = 1;
            var id = setInterval(QRframe, 150);
            function QRframe() {
              if (width >= 88) {
                clearInterval(id);
              } else {
                width++; 
                elem.style.width = width + '%'; 
              }
            }
            apiService.loaderShowForUploadButton();
            var bodyData = {
                order_id: $rootScope.orderEntityId,
                item_id: itemId,
                prod_qty_id: prod_qty_id
            };
            if(file) {
                bodyData.upload_qr = file;
            }
            $http({
                url: $rootScope.baseUrl + '/orderdetail/upload-qr-manually',
                method: 'POST',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var i in bodyData) {
                        formData.append(i, bodyData[i]);
                    }
                    return formData;
                }
            }).then(function (response)
            {
              apiService.loaderHideForUploadButtonp();
              var responseData = response.data;
              if (responseData.status == 'success') {
                toastr.success(responseData.message);
                width = 100;
                $("#myBarQR").css("width", "100%");
                $(function() {
                  setTimeout(function() {
                    $("#QRProgress").hide('blind', {}, 500)
                  }, 1000);
                });
              }
              $scope.getOrderDetails();
            }, function (error) {
                apiService.loaderHideForUploadButtonp();
                var errorData = error;
                toastr.error(errorData.message.message);
            });
            jQuery("#manualQRUpload").val('');
            file = '';
          }

          $scope.requestPreview = function(event,itemId,prod_qty_id)
          {
            var bodyData = {
                order_id: $rootScope.orderEntityId,
                item_id: itemId,
                prod_qty_id: prod_qty_id
            };

            $http.post($rootScope.baseUrl + '/orderdetail/start-preview', bodyData)
            .then(function (response)
            {
              if (response.status == 'success') {

              }
              $scope.getOrderDetails();
            }, function (error) {
              apiService.loaderHideForUploadButtonp();
              var errorData = error;
              toastr.error(errorData.message.message);
            });
          }

          $scope.actionPreview = function(itemId,prod_qty_id,action)
          {
            var bodyData = {
                order_id: $rootScope.orderEntityId,
                item_id: itemId,
                prod_qty_id: prod_qty_id,
                action: action
            };

            $http.post($rootScope.baseUrl + '/orderdetail/action-preview', bodyData)
            .then(function (response)
            {
              if (response.status == 'success') {
                toastr.success(responseData.message);
              }
              $scope.getOrderDetails();
            }, function (error) {
              apiService.loaderHideForUploadButtonp();
              var errorData = error;
              toastr.error(errorData.message.message);
            });
          }
          
          $scope.uploadFileManual=function(event, itemId)
          {
            var file = document.getElementById('manualFileUpload').files[0];
            if (!file) {
                toastr.error('Please select file first to upload');
                return '';
            }
            $('#uploadFileManualButton').hide();
            $("#myBar").css("width", "0%");
            $("#Progress").show();
            //$scope.progressbar.start();
            var elem = document.getElementById("myBar");
            var width = 1;
            var id = setInterval(frame, 150);
            function frame() {
              if (width >= 88) {
                clearInterval(id);
              } else {
                width++; 
                elem.style.width = width + '%'; 
              }
            }
            //$("#myBar").css("opacity", "1");
            apiService.loaderShowForUploadButton();
            var bodyData = {
                order_id: $rootScope.orderEntityId,
                item_id: itemId
            };
            if(file) {
                bodyData.upload_file = file;
            }
            $http({
                url: $rootScope.baseUrl + '/orderdetail/upload-file-manually',
                method: 'POST',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var i in bodyData) {
                        formData.append(i, bodyData[i]);
                    }
                    return formData;
                }
            }).then(function (response) {
                $scope.getOrderDetails();
                //$scope.progressbar.complete();
                apiService.loaderHideForUploadButtonp();
                var responseData = response.data;
                if (responseData.status == 'success') {
                    toastr.success(responseData.message);
                    angular.element("#uploadFileManualButton").show();
                    width = 100;
                    $("#myBar").css("width", "100%");
                    $(function() {
                        setTimeout(function() {
                            $("#Progress").hide('blind', {}, 500)
                        }, 1000);
                    });
                }
            }, function (error) {
                apiService.loaderHideForUploadButtonp();
                var errorData = error;
                toastr.error(errorData.message.message);
            });
            jQuery("#manualFileUpload").val('');
            file = '';
          }
          
          
          $scope.getPullJobSettingData = function() {
            $http.get($rootScope.baseUrl + '/config/pullJobSetting')
              .success(function(result) {
                if (result) {
                  if (result.status == 'fail') {
                    //toastr.error(result.message);
                  } else {
                    if (result.data) {
                      var resultData=result.data;
                      $scope.showOnStatus=resultData.show_on_status;
                      $scope.onChangeStatus=resultData.change_to_status;
                    }
                  }
                }
              }).error(function(error) {
                // if (error.data && error.data.code != undefined && error.data.code == 0) {
                //   toastr.error(error.data.message);
                // }
              });
          }
          $scope.checkStatusForPullJobBtn=function(status) {
            if($scope.showOnStatus){
              if($scope.showOnStatus.indexOf(status)===-1){
                return false;
              }else{
                return true;
              }
            }
          }
          $scope.pullJob=function(oldstatus){
            if($rootScope.orderEntityId){
              var bodyData = {
                  entity_id: $rootScope.orderEntityId,
                  status:$scope.onChangeStatus,
                  old_status:oldstatus,
                  user_name:$rootScope.globals.currentUser.name
              };
              $http.post($rootScope.baseUrl + '/order/getordersdetails', bodyData).success(function (response) {
                  if (response.status == 'success') {
                      toastr.success(response.message);
                      $scope.getOrderDetails();
                  } else {
                      toastr.error(response.message);
                  }
              }).error(function (error) {
                  if (error && error.code != undefined && error.code == 0) {
                      toastr.error(error.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
            }
          }
          $scope.getHours=function(secs) {
            if(secs){
              var hours   = Math.floor(secs / 3600);
              var minutes = Math.floor((secs - (hours * 3600)) / 60);
              var seconds = secs - (hours * 3600) - (minutes * 60);

              // round seconds
              seconds = Math.round(seconds * 100) / 100

              var result = (hours < 10 ? "0" + hours : hours);
                  result += ":" + (minutes < 10 ? "0" + minutes : minutes);
                  result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
              return result;
            }else{
              return '00:00:00';
            }
          }
          $scope.downloadImage=function(item,path,type){
            window.open($rootScope.baseUrl + '/download-image-url/'+item+'/'+type, '_self');
          }

          $scope.downloadMask=function(item,path,qty){
            window.open(path);
          }

          $scope.downloadPreview=function(item,path,qty){
            window.open(path);
          }
          // Used for open and do manipulation pop-up for security key
          $scope.encryptionButtonType = '';
          $scope.verifySecurityKey=function(item,path,buttonType) {
              $scope.verifyItem=item;
              $scope.encryptionButtonType = buttonType;
              $('#verifySecurityKey').modal();
              var interval = setInterval(function(){
            $('#downloadEncryptionInput').focus();
            },1000);
             
          }
          // Used for close pop-up for security key
          $scope.closeverifySecurityKey = function (id,page) {
            $(".key_msg, .msg_icon, .key_msg, .su_msg, .msg_icon, .su_msg").remove();
            $('#disableButtonOfDownload').hide();
            $('#verifySecurityKeyDownloadButton').hide();
            angular.element(".input-div-class").show();
            $('#verifySecurityKey').modal('hide');
            $(".key_msg,.msg_icon").remove();
            $scope.encryptionButtonType = '';
          };
          // for order list change status -- start
          $scope.getActiveStatusData = function() {
           // get order status
           $http.post($rootScope.baseUrl + '/status/activeAll')
               .success(function (result) {
                 $scope.orderStatusList = result;
               }).error(function (error) {
                   if (error.data && error.data.code != undefined && error.data.code == 0) {
                       toastr.error(error.data.message);
                   }
               });
             }
          $scope.resetChangeStatus=function(){
            $scope.isChangeStatus.change=true;
            $scope.orderChangeStatus={statuscode:""};
            //$scope.killOrderListTimer();
            $scope.isSelected.select=true;
            toastr.success("Please select orders to change status.");
            $("#btnuploadrelay").hide();
          }
          $scope.resetRelayUpload=function(){
            $scope.isRelayUpload.upload=true;
            $scope.orderChangeStatus={statuscode:""};
            //$scope.killOrderListTimer();
            $scope.isSelected.select=true;
            toastr.success("Please select orders to change status.");
            $("#btnchangestatus").hide();
          }
          $scope.cancelChangeStatus=function(){
            $scope.isSelected.select=false;
            $scope.selected = {};
            $scope.selectAll = false;
            $scope.isChangeStatus.change=false;
            $scope.vmAdded.dtInstance.DataTable.draw( false );
            $("#btnuploadrelay").show();
          }
          $scope.cancelUploadRelay=function(){
            $scope.isSelected.select=false;
            $scope.selected = {};
            $scope.selectAll = false;
            $scope.isRelayUpload.upload=false;
            $scope.vmAdded.dtInstance.DataTable.draw( false );
            $("#btnchangestatus").show();
          }
          $scope.openChangeStatusModal = function () {
            $scope.entityArray=[];
            if(!$scope.orderChangeStatus.statuscode){
              toastr.error("Please select orders status.");
              angular.element('#orderChangeStatusId').focus();
              return false;
            }
            angular.forEach($scope.selected,function(val,key){
              if(val===true){
                $scope.entityArray.push(key);
              }
            });
            if($scope.entityArray.length<=0){
              toastr.error("Please select orders.");
              return false;
            }
            $scope.selectedOrderCount=$scope.entityArray.length;
            $('#changeStatusConfirm').modal();
          }

          $scope.openUploadRelayModal = function () {
            $scope.entityArray=[];
            angular.forEach($scope.selected,function(val,key){
              if(val===true){
                $scope.entityArray.push(key);
              }
            });
            if($scope.entityArray.length<=0){
              toastr.error("Please select orders.");
              return false;
            }
            $scope.selectedOrderCount=$scope.entityArray.length;
            $('#uploadRelayConfirm').modal();
          }

          $scope.uploadRelayYes=function(event)
          {
            var targetRelay = angular.element(event.target);
            var jobService =  $('#relay-job-service').val();
            var priority =  $('#relay-priority').val();
            console.log(jobService);
            console.log(priority);
            console.log(JSON.stringify($scope.entityArray));
            if(!jobService){
              toastr.error('Please select job service');
              return;
            }
            if(!priority){
              toastr.error('Please select priority');
              return;
            }
            $scope.progressbar.start();
            var bodyData = {
                entity_ids: JSON.stringify($scope.entityArray),
                priority:priority,
                job_service:jobService,
                relay_created_by:$rootScope.globals.currentUser.name
            };
            console.log(bodyData);
            $http.post($rootScope.baseUrl + '/bulk-order-relay-upload', bodyData).success(function (response) {
                $scope.progressbar.complete();
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $('#uploadRelayConfirm').modal('hide');
                    $scope.cancelUploadRelay();
                } else {
                  if(response.message.errors){
                    toastr.error(response.message.message);
                  }else{
                    toastr.error(response.message);
                  }
                }
            }).error(function (error) {
              $scope.progressbar.complete();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
          }

          $scope.updateOrderStatus=function(){
            var data={
              status_code :$scope.orderChangeStatus.statuscode,
              entity_ids: JSON.stringify($scope.entityArray),
              username:$rootScope.globals.currentUser.name
            }
            $http.post($rootScope.baseUrl + '/order/bulkorderchangestatus',data).then(
            function (response) {
              var responseData=response.data;
              if (responseData.status == 'success') {
                  toastr.success(responseData.message);
                  $('#changeStatusConfirm').modal('hide');
                  $scope.cancelChangeStatus();
              } else {
                  toastr.error(responseData.message);
              }
            },
            function (error) {
              if (error && error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
            });
          }
          // for order list change status -- end

          // order list auto refresh
          $scope.startOrderListTimer=function(){
            $scope.orderListTimer=$interval(function(){
              if($location.path() == '/orders'){
                if(!$scope.isSelected.select){
                  $rootScope.vmAddedNew.dtInstance.DataTable.draw(false);
                }
              }
            },$rootScope.apiIntervalTimeOrders * 60 * 10000);
          }
          $scope.startOrderListTimer();
          $scope.killOrderListTimer=function(){
            if(angular.isDefined($scope.orderListTimer))
              {
                $interval.cancel($scope.orderListTimer);
                $scope.orderListTimer=undefined;
              }
          };
          // order details  auto refresh
          $scope.startOrderDetailsTimer=function(){
            $scope.orderDetailsTimer=$interval(function(){
              if($location.path() == '/orders'){
                if($rootScope.orderId && !$scope.isQaStart){
                         $scope.getOrderDetails(1);
                       }
                }
            },100000);
          }
          $scope.killOrderDetailsTimer=function(){
            if(angular.isDefined($scope.orderDetailsTimer))
              {
                $interval.cancel($scope.orderDetailsTimer);
                $scope.orderDetailsTimer=undefined;
              }
          };
          // order details  auto refresh
          $scope.startOrderCommentTimer=function(){
            $scope.orderCommentTimer=$interval(function(){
              if($location.path() == '/orders'){
                if($rootScope.orderId){
                         $scope.getCommentData();
                         $scope.getOrderShipmentCommentData();
                       }
                }
            },10000*60);
          }
          
          // order details  auto refresh
          $scope.startOrderOfficeCommentTimer=function(){
            $scope.orderOfficeCommentTimer = $interval(function () {
                if ($location.path() == '/orders') {
                    if ($rootScope.orderId) {
                        $scope.getOfficeCommentData();
                        $scope.getReDesignCommentData();
                    }
                }
            }, 10000 * 60);
          }
          
          $scope.killOrderCommentTimer=function(){
            if(angular.isDefined($scope.orderCommentTimer))
              {
                $interval.cancel($scope.orderCommentTimer);
                $scope.orderCommentTimer=undefined;
              }
          };
          
          $scope.killOrderOfficeCommentTimer=function() {
            if (angular.isDefined($scope.orderOfficeCommentTimer)) {
                $interval.cancel($scope.orderOfficeCommentTimer);
                $scope.orderOfficeCommentTimer = undefined;
            }
          };
          this.encryptedText = '';
          $scope.encryptedTextData = {};
          this.encryptedErrorText = '';
          // Verify encrypted barcode to download files
          $scope.RemoveMsg = function(){
            $(".key_msg , .msg_icon").remove();
          }
          //Show input type of encrypted file
          $scope.resetEncryptedText = function() {
            $(".key_msg , .msg_icon").remove();
            $('#disableButtonOfDownload').hide();
            angular.element(".input-div-class").show();
          }

        this.copyFromProductId = '';
        /**
         * Close the Copy from button
         */
        $scope.closeCopyProductDataForm = function () {
            $('#openCopyProductDataPopUp').modal('hide');
            document.getElementById('copyFileButton').value = "";
            $(".key_msg_copy, .er_msg_copy").remove();
            this.copyFromProductId = '';
        };
        /**
         * Open pop-up of the Copy from button
         */
        $scope.openCopyProductDataForm=function() {
            document.getElementById('copyFileButton').value = "";
            $(".key_msg_copy, .er_msg_copy").remove();
            $('#openCopyProductDataPopUp').modal();
        }
        /**
         * Call API when clicked on submit button of the copy from
         */
        $scope.copyProductData = function (itemId) {
            var vm = this;
            /*
            if (this.copyFromProductId == undefined || this.copyFromProductId == '') {
                return '';
            }*/
            apiService.loaderShowForCopyFilePopUp();
            //apiService.loaderShowForEncryptedPopUp();
            $('#verifySecurityKeyDownloadButtonxx').hide();
            $http.post($rootScope.baseUrl + '/orderdetail/copy-product-files', {
                copy_to_item_increment_id: itemId,
                copy_from_item_increment_id: vm.copyFromProductId
            }).success(function (response) {
                if (response.status == 'success') {
                    $('#copyPopUpPasteButton').hide();
                    $('#copyFileButton').hide();
                    //$('#openCopyProductDataPopUp').modal('hide');
                    document.getElementById('copyFileButton').value = "";
                    $(".key_msg_copy, .er_msg_copy").remove();
                    toastr.success(response.message);
                    $('.msg_cond2').after('<span class="key_msg_copy copy-msg er_msg_copy">Data copy request is in progress</span>');
                    vm.copyFromProductId = '';
                } else {
                    apiService.loaderHideForCopyFilePopUp();
                    angular.element(".submit_copy_file").show();
                    //apiService.loaderHideForCopyFilePopUp();
                    //apiService.loaderHideForEncryptedPopUp();
                    document.getElementById('copyFileButton').value = "";
                    $(".key_msg_copy, .er_msg_copy").remove();
                    $('.msg_cond2').after('<span class="key_msg_copy er_msg_copy">'+response.message+'</span>');
                    vm.copyFromProductId = '';
                }
            }).error(function (error) {
                //apiService.loaderHideForCopyFilePopUp();
                //apiService.loaderHideForEncryptedPopUp();
                apiService.loaderHideForCopyFilePopUp();
                toastr.error("Something went wrong please try again.");
                $('#openCopyProductDataPopUp').modal('hide');
                document.getElementById('copyFileButton').value = "";
                $(".key_msg_copy, .er_msg_copy").remove();
                vm.copyFromProductId = '';
            });
        }
        
        $scope.copyProductDataLogLoaded = false;
        $scope.copyProductDataLogIncrementId = '';
        $scope.openCopyProductDataLogForm = function (id) {
            angular.element(".submit_copy_file").show();
            angular.element(".copyPopUpPasteButton").show();
            angular.element(".crista_name_copy").show();
            $scope.copyProductDataLogIncrementId = id;
            $scope.copyProductDataLogLoadeds = false;
            $scope.getCopyProductDataLogs();
            $('#openCopyProductDataLogPopUp').modal();
        };
        
        $scope.closeCopyProductDataLogPopUp=function(){
            apiService.loaderHideForCopyFilePopUp();
            $scope.copyProductDataLogIncrementId = '';
            $('#openCopyProductDataLogPopUp').modal('hide');
            angular.element(".submit_copy_file").show();
            angular.element(".copyPopUpPasteButton").show();
            angular.element(".crista_name_copy").show();
        };
        
        $scope.copyProductDataArray = [];
        $scope.getCopyProductDataLogs = function () {
            $scope.copyProductDataLogLoaded = false;
            $http.get($rootScope.baseUrl + '/orderdetail/get-copy-from-log/' + $scope.copyProductDataLogIncrementId).then(
            function (response) {
                $scope.copyProductDataLogLoaded = true;
                if(response.data.status == 'success'){
                   $scope.copyProductDataArray = response.data.data;
                }
            },
            function (error) {
                $scope.copyProductDataLogLoaded = true;
            });
        }
        
        $scope.getOrderNumber = function(query) {
          return $http.post($rootScope.baseUrl + '/orderdetail/autosugget', {searchable_value:query?query:''})
          .then(function(response){
            return response.data.map(function(item){
              return item.item_increment_id;
            });
          });
        };

        $scope.disableCopyLoader = function(itemIncrementId) {
            angular.element(".submit_copy_file").show();
            //apiService.loaderHideForCopyFilePopUp();
            //apiService.loaderHideForEncryptedPopUp();
            apiService.loaderHideForCopyFilePopUp();
            $('#openCopyProductDataPopUp').modal('hide');
            angular.element(".copyPopUpPasteButton").show();
            angular.element(".crista_name_copy").show();
            $http.post($rootScope.baseUrl + '/orderdetail/remove-hide-pop-field', {searchable_value:itemIncrementId?itemIncrementId:''})
        }
        $rootScope.copiedProductId = '';
        $scope.productNumberCopied = function (productId) {
           $cookies.put('copy-from-product-id',undefined);
           $cookies.put('copy-from-product-id', productId);
           $rootScope.copiedProductId = productId;
           toastr.success('Product id ' + productId + ' is copied!');
        };
        
        $scope.pasteCopiedOrderNumber = function () {
            var vm = this;
            var copyId = '';
            if ($cookies.get('copy-from-product-id') && $cookies.get('copy-from-product-id') != undefined) {
                copyId = $cookies.get('copy-from-product-id');
            } else {
                copyId = $rootScope.copiedProductId;
            }
            vm.copyFromProductId = copyId;
        };

          $scope.encryptedInputType = false;
          $scope.scanBarcode = function (val, item, productName, sku) {
            if (val == undefined || val == '') {
                return '';
            }
            var vm = this;
            angular.element('#encryptedText').val('');
            this.encryptedText = '';
            $scope.encryptedTextData = {};
            if (val != undefined || val != '') {
                //val = val.trim();
                apiService.loaderShowForEncryptedPopUp();
                $http.post($rootScope.baseUrl + '/orderdetail/verify-encrypted-key', {
                    encrypted_text : val,
                    item_id:item,
                    product_name:productName,
                    sku:sku
                }).success(function (response) {
                    apiService.loaderHideForEncryptedPopUp();
                    if (response.type == 'KEY_MATCHED') {
                        angular.element(".crista_dwld").show();
                        if (response.data) {
                            var responseData = {
                                original_item_id: response.data.original_item_id,
                                encrypted_string: response.data.encrypted_string
                            };
                            $scope.encryptedTextData = responseData;
                        }
                        //$scope.encryptedTextData = response.data ? response.data.encrypted_string : '';
                        $('#input-div-class').hide();
                        $(".key_msg , .msg_icon").remove();
                        $('#disableButtonOfDownload').hide();
                        //toastr.success(response.message);
                        $('.msg_cond').after('<span class="key_msg su_msg">' + response.message + '</span>');
                        $('.crista_name').after('<div class="msg_icon su_msg"></div>');
                        
                    } else {
                        $(".key_msg , .msg_icon").remove();
                        $('#input-div-class').hide();
                        $('#verifySecurityKeyDownloadButton').hide();
                        angular.element(".crista_disable_btn").show();
                        $('.msg_cond').after('<span class="key_msg er_msg">'+response.message+'</span>');
                        $('.crista_name').after('<div class="msg_icon er_msg"></div>');
                        
                    }
                    
                    
                }).error(function (error) {
                    apiService.loaderHideForEncryptedPopUp();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                    vm.barcodeText = '';
                    angular.element('#txt-barcode').focus();
                });
            }
        }

        // Download encrypted file
        $scope.downloadEncryptedFile = function (val)
        {
            var encrypteString = val.encrypted_string;
            var originalItemId = val.original_item_id;
            apiService.loaderShow();
            window.open($rootScope.baseUrl + '/orderdetail/download-verified-file/' + encrypteString + '/' + $scope.encryptionButtonType + '/' + $rootScope.globals.currentUser.firstname + '/' + originalItemId, '_self');
            apiService.loaderHide();
            $('#verifySecurityKey').modal('hide');
            $('#verifySecurityKeyDownloadButton').hide();
            $(".key_msg, .msg_icon, .key_msg, .su_msg, .msg_icon, .su_msg").remove();
            angular.element(".input-div-class").show();
        }

        $scope.$on('$destroy', function()
        {
          // Make sure that the interval is destroyed too
          $scope.killOrderListTimer();
          $scope.killOrderDetailsTimer();
          $scope.killOrderCommentTimer();
          $scope.killOrderOfficeCommentTimer();
        });
          
          
        /**
        *get all type master for filter records
        */
        $scope.getTypeMaster = function()
        {
          $http.get($rootScope.baseUrl + '/productType/getActiveType/all')
          .success(function (result)
          {
            $scope.isloaded = true;
            if (result) {
                            $scope.typeData = result;
                        }
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }

            });
        }

        /**
         * Open change order date pop-up.
         * created on 11.April.2019
        **/
        $scope.openChangeOrderDatePopUp = function (orderId)
        {
            angular.element('#onChangeStatusId').val('');
            $scope.killOrderDetailsTimer();
            $scope.changeOrderCreatedDateOrderId = orderId;
            $('#orderDateChangeButton').modal();
        };

        /**
         * Call API to change the order date and status
         * Created on 11.April.2019
        **/
        $scope.changeOrderCreatedDate = function()
        {
            var vm = this;
            if (this.onChangeStatus == undefined || this.onChangeStatus == '') {
                return '';
            }
            apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/order/change-create-date-status', {
                order_id: $scope.changeOrderCreatedDateOrderId,
                affected_by: $rootScope.globals.currentUser.name,
                change_status_to: this.onChangeStatus
            }).success(function (response) {
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.closeChangeOrderDatePopUp();
                    apiService.loaderHide();
                    $scope.getOrderDetails();
                    $scope.getOrderDetailsData();
                } else {
                    apiService.loaderHide();
                    toastr.error(response.message);
                    $scope.closeChangeOrderDatePopUp();
                }
                angular.element('#onChangeStatusId').val('');
                vm.onChangeStatus = '';
            }).error(function (error) {
                apiService.loaderHide();
                $scope.closeChangeOrderDatePopUp();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                angular.element('#onChangeStatusId').val('');
                vm.onChangeStatus = '';
            });
        };

        /**
         * Close the change order date pop-up.
         * Created on 11.April.2019
        **/
        $scope.closeChangeOrderDatePopUp = function()
        {
            $('#orderDateChangeButton').modal('hide');
            $scope.startOrderDetailsTimer();
            angular.element('#onChangeStatusId').val('');
            $scope.changeOrderCreatedDateOrderId = 0;
        }

        $scope.changeOrderDateLogLoaded = false;
        $scope.changeOrderDateLogId = '';
        $scope.openChangeOrderDateLogDialog = function (id)
        {
            $scope.changeOrderDateLogId = '';
            $scope.changeOrderDateLogId = id;
            $scope.getChangeOrderDatetDataLogs();
            $('#openChangeOrderDateLogDialog').modal();
        };

        $scope.closeChangeOrderDateLogDialog = function ()
        {
            $('#openChangeOrderDateLogDialog').modal('hide');
            $scope.changeOrderDateLogId = '';
        };

        $scope.getChangeOrderDatetDataLogs = function ()
        {
            $scope.changeOrderDateLogArray = [];
            $scope.changeOrderDateLogLoaded = false;
            $http.get($rootScope.baseUrl + '/orderdetail/get-order-date-change-log/' + $scope.changeOrderDateLogId).then(
                    function (response) {
                        $scope.changeOrderDateLogLoaded = true;
                        if (response.data.status == 'success') {
                            $scope.changeOrderDateLogArray = response.data.data;
                            $scope.changeOrderDateLogId = '';
                        }
                    },
                    function (error) {
                        $scope.changeOrderDateLogId = '';
                        $scope.changeOrderDateLogLoaded = true;
                    });
        }

        $scope.showChangeOrderDateButtons = function (type, status, permission)
        {
            if ($scope.changeStatusButtons) {
                if ($scope.changeStatusButtons[type].status.indexOf(status) !== -1 && $rootScope.permissionArr.indexOf(permission) !== -1) {
                    return true;
                } else {
                    return false;
                }
            }
        }

        $scope.getChangeOrderDateButtonData = function ()
        {
            $http.get($rootScope.baseUrl + '/config/get-save-button-setting')
                    .success(function (result) {
                        if (result.data && result.data != undefined) {
                            $scope.changeStatusButtons = result.data.data;
                            $scope.changeStatusButtonsOnClickStatus = result.data.data_change_status_to.selectedPeople;
                            angular.forEach($scope.changeStatusButtons, function (val, key) {
                                var status = [];
                                angular.forEach(val.status, function (stsVal, stsKey) {
                                    status.push(stsVal.status_label);
                                });
                                $scope.changeStatusButtons[val.name] = {'status': status};
                            });
                        }
                    }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

        $scope.openOrderScan = function (entity_id,store_id)
        {
          $scope.isloaded = false;
          $scope.scan_complete = 0;
          $scope.already_scanned = [];
          $scope.scanOrderID = entity_id;
          $scope.order_store_id = store_id;
          $http.get($rootScope.baseUrl+'/order/get-items-details/'+entity_id)
          .success(function (result) {
            $scope.isloaded = true;
             $scope.orderItemsDetails = result;
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
          $('#orderScanModalPopUp').modal();
          $("#scanOrderNumber").focus();
        };

        $scope.closeOrderScanPopUp = function()
        {
          $scope.scanOrderID = '';
          $scope.already_scanned = [];
          $scope.orderItemsDetails = [];
          $scope.scan_complete = 0;
          $scope.order_store_id = '';
          angular.element('#scanOrderNumber').val('');
          $('#orderScanModalPopUp').modal('hide');
        }

        $scope.scanOrderItem = function ()
        {
          apiService.loaderShow();
          if (!this.scanOrderForm.$valid) {
            apiService.loaderHide();
            return;
          }

          var orderItemNumber = $("#scanOrderNumber").val();
          if(orderItemNumber == '')
          {
            $("#scanOrderNumber").focus();
            toastr.error('Please enter order number');
            apiService.loaderHide();
            return;
          }

          $http.post($rootScope.baseUrl + '/order/get-scan-order-item', {
                scancode: orderItemNumber,
                order_id: $scope.scanOrderID,
                already_scanned:$scope.already_scanned,
                all_item_details:$scope.orderItemsDetails,
                created_by_name: $rootScope.globals.currentUser.name,
                created_by_id: $rootScope.globals.currentUser.id,
            }).success(function (result) {
              apiService.loaderHide();
              angular.element('#scanOrderNumber').val('');
                if (result.status == 'success') {
                  //$scope.already_scanned.push(result.scanned_item);
                  $scope.orderItemsDetails = result.items_details;
                  if(result.all_item_scanned == 1)
                  {
                    $scope.show_shipping_tag = 1;
                    $scope.scan_complete = result.all_item_scanned;
                    $('#orderScanModalPopUp').modal('hide');
                    $scope.getOrderDetails();
                  }
                } else {
                  if($scope.order_store_id == 'noy-skincare') {
                    $scope.closeOrderScanPopUp();
                  }
                  alert(result.message);
                  toastr.error(result.message);
                }
            }).error(function (error) {
              apiService.loaderHide();
              alert(error.message);
                toastr.error(error.message);

            });
        }

        $scope.addScannedItem = function(id)
        {
          apiService.loaderShow();
          
          $http.post($rootScope.baseUrl + '/order/get-scan-order-item', {
                scancode: id,
                order_id: $scope.scanOrderID,
                already_scanned:$scope.already_scanned,
                all_item_details:$scope.orderItemsDetails,
                created_by_name: $rootScope.globals.currentUser.name,
                created_by_id: $rootScope.globals.currentUser.id,
            }).success(function (result) {
              apiService.loaderHide();
              angular.element('#scanOrderNumber').val('');
                if (result.status == 'success') {
                  //$scope.already_scanned.push(result.scanned_item);
                  $scope.orderItemsDetails = result.items_details;
                  if(result.all_item_scanned == 1)
                  {
                    $scope.show_shipping_tag = 1;
                    $scope.scan_complete = result.all_item_scanned;
                    $('#orderScanModalPopUp').modal('hide');
                    $scope.getOrderDetails();
                  }
                } else {
                  toastr.error(result.message);
                }
            }).error(function (error) {
              apiService.loaderHide();
                toastr.error(error.message);

            });
        }

        $scope.dmageSettingPopUpItemOrQty = '';
        $scope.dmageSettingPopUpItemIncrementId = '';
        $scope.openModalDamageSettingPopUp = function (itemIncrementId, orderedQty, isProductQtyOrder)
        {
            if (isProductQtyOrder) {
                $scope.dmageSettingPopUpItemOrQty = 'QTY';
                $scope.dmageSettingPopUpItemIncrementId = isProductQtyOrder;
            } else {
                $scope.dmageSettingPopUpItemOrQty = 'ITEM';
                $scope.dmageSettingPopUpItemIncrementId = itemIncrementId;
            }
            
            $scope.getDamageSettingData();
            $('#damageSettingModalPopUp').modal();
            $('#error-damage-crystal-image-upload-file').hide();
            $('#error-damage-crystal-image-upload-invalid-file').hide();
        };

        $scope.closeModalDamageSettingPopUp = function ()
        {
            $('#damageSettingModalPopUp').modal('hide');
            angular.element('#damageCrystalOrder').val('');
            this.damagesettingCrystalOrder = '';
            angular.element('#damageSpecialInstruction').val('');
            this.damageSpecialInstruction = '';
            $('#error-damage-crystal-image-upload-file').hide();
            $('#error-damage-crystal-image-upload-invalid-file').hide();
        };

        $scope.damageSettingStatus = [];
        $scope.getDamageSettingData = function ()
        {
            $http.get($rootScope.baseUrl + '/config/damageSetting')
                    .success(function (result) {
                        if (result) {
                            if (result.status == 'fail') {
                                toastr.error(result.message);
                            } else {
                                if (result.data) {
                                    $scope.damageSettingReasonList = result.data.damage_reason;
                                    $scope.damageSettingStatus = result.data.available_order_status;
                                    // default selected value in dropdown
                                    angular.forEach($scope.damageSettingReasonList, function (val, key) {
                                        if (val.set_default == '1') {
                                            $scope.damageReason = val.name;
                                        }
                                    });
                                }
                            }
                        }
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };
        
        $scope.saveDamageCrystalReport = function ()
        {
            apiService.loaderShow();
            if (!this.damageSettingForm.$valid) {
                apiService.loaderHide();
                return;
            }
            var file = document.getElementById('manualFileUploadx').files[0];
            if (!file) {
                angular.element("#error-damage-crystal-image-upload-file").show();
                apiService.loaderHide();
                return '';
            }
            var afterDot = file.name.substr(file.name.indexOf('.')+1);
            //var fileType = file.type;
            if (afterDot == "jpeg" || afterDot == "png" || afterDot == "jpg") {
            var bodyData = {
                damage_reason: this.damageReason,
                created_by_name: $rootScope.globals.currentUser.name,
                created_by: $rootScope.globals.currentUser.id,
                crystal_order: this.damagesettingCrystalOrder,
                file_order: $scope.dmageSettingPopUpItemIncrementId,
                special_instruction: (this.damageSpecialInstruction != undefined) ? this.damageSpecialInstruction : '',
                item_increment_id: $scope.dmageSettingPopUpItemIncrementId,
                from: $scope.dmageSettingPopUpItemOrQty
            };
            if(file) {
                bodyData.damage_crystal_image = file;
            }
            var damageSettingUrl = $rootScope.baseUrl + '/damage/crystal-save-data';
            $http({
                url: damageSettingUrl,
                method: 'POST',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var i in bodyData) {
                        formData.append(i, bodyData[i]);
                    }
                    return formData;
                }
            }).then(function (response) {
                response = response.data
                apiService.loaderHide();
                if (response.status == 'success') {
                    //$scope.progressbar.complete();
                    toastr.success(response.message);
                    $scope.closeModalDamageSettingPopUp();
                } else {
                    //$scope.progressbar.complete();
                    toastr.error(response.message);
                    $scope.closeModalDamageSettingPopUp();
                }
            }, function (error) {
                
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.closeModalDamageSettingPopUp();
            jQuery("#manualFileUploadx").val('');
            file = '';
            $scope.startOrderDetailsTimer();
            angular.element('#damageCrystalOrder').val('');
            this.damagesettingCrystalOrder = '';
            angular.element('#damageSpecialInstruction').val('');
            this.damageSpecialInstruction = '';
            
            } else {
                apiService.loaderHide();
                angular.element("#error-damage-crystal-image-upload-invalid-file").show();
                return '';
            }
        };
        
        $scope.showDamageCrystalButton = function (status)
        {
          if($scope.damageSettingStatus != undefined && $scope.damageSettingStatus.indexOf(status) != -1){
                return true;
            }
            return false;
        };
        
        $scope.getTheRelayLinkPriceCategory = function (value)
        {
            if (value == undefined) {
                return false;
            }
            return true;
        };
        $scope.getTheRelayLinkPrice = function (value)
        {
            if (value == undefined) {
                return false;
            }
            return true;
        };

        $scope.getPrintCrystalItems = function(query, orderIncrementId)
        {
          return $http.post($rootScope.baseUrl + '/damage/autosuggest-print-crystal-itemid', {
              searchable_value: query ? query : '',
              order_increment_id: orderIncrementId,
              current_type: $scope.dmageSettingPopUpItemOrQty,
              current_id: $scope.dmageSettingPopUpItemIncrementId
          })
          .then(function(response){
            return response.data.map(function(item){
              return item.order_number;
            });
          });
        };
        
        $scope.getRelayFilesManually = function (itemId) {
          var order_id = $rootScope.orderEntityId;
            toastr.success('Relay files fetching process is started');
            $http.post($rootScope.baseUrl + '/order/get-relay-files-and-move-to-aws', {
                item_id: itemId,
                order_id: order_id
            }).success(function (result) {
                if (result.status == 'success') {
                    toastr.success(result.message);
                    $scope.getOrderDetails();
                } else {
                    toastr.error(result.message);
                }
            }).error(function (error) {
                toastr.error(error.message);

            });
        };

        $scope.hideDamageCrystalImageValidation = function(query)
        {
            $('#error-damage-crystal-image-upload-file').hide();
            $('#error-damage-crystal-image-upload-invalid-file').hide();
        };

        $scope.deleteRelayJobManually = function (itemId) {
          var order_id = $rootScope.orderEntityId;
            $http.post($rootScope.baseUrl + '/order/delete-relay-job', {
                item_id: itemId,
                order_id: order_id
            }).success(function (result) {
                if (result.status == 'success') {
                    toastr.success(result.message);
                    $scope.getOrderDetails();
                } else {
                    toastr.error(result.message);
                }
            }).error(function (error) {
                toastr.error(error.message);

            });
        };

        $scope.relayReworkOrder = function (event,itemId)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          var comment = target.parent().parent().parent().find('.rework-comment').val();
          if(comment == ""){
             target.parent().parent().parent().find('.error').removeClass('hide-element');
          }else{
             target.parent().parent().parent().find('.error').addClass('hide-element');
          }

          apiService.loaderShow();

          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/rework-relay-job', {
                item_id: itemId,
                order_id: order_id,
                description:comment
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
                angular.element('.rework-comment').val('');
                  toastr.success(result.message);
                  $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
                toastr.error(error.message);
          });
          
        };

        $scope.newRelayReworkOrder = function (event,itemId)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          var comment = target.parent().parent().parent().find('.new-rework-comment').val();
          if(comment == ""){
             target.parent().parent().parent().find('.error').removeClass('hide-element');
          }else{
             target.parent().parent().parent().find('.error').addClass('hide-element');
          }

          apiService.loaderShow();

          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/rework-new-relay-job', {
                item_id: itemId,
                order_id: order_id,
                description:comment
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
                angular.element('.new-rework-comment').val('');
                  toastr.success(result.message);
                  $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
                toastr.error(error.message);
          });
          
        };

        $scope.getMachineFile = function (event,itemId)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          apiService.loaderShow();

          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/get-machine-file', {
                item_id: itemId,
                order_id: order_id
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
              toastr.success(result.message);
              $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
              toastr.error(error.message);
          });
        };

        $scope.deleteMachineFile = function (event,itemId)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          apiService.loaderShow();
          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/delete-machine-file', {
                item_id: itemId,
                order_id: order_id
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
              toastr.success(result.message);
              $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
              toastr.error(error.message);
          });
        };
        
        $scope.createDatabaseJob = function(event,itemId,qty_id)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");
          apiService.loaderShow();
          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/create-database-job', {
                item_id: itemId,
                order_id: order_id,
                prod_qty_id:qty_id,
                username:$rootScope.globals.currentUser.name,
                user_id:$rootScope.globals.currentUser.id
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
              toastr.success(result.message);
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
              toastr.error(error.message);
          });
          $scope.startOrderListTimer();
        }

        $scope.getDatabaseJob = function (event,itemId)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          apiService.loaderShow();

          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/get-database-job', {
                item_id: itemId,
                order_id: order_id
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
              toastr.success(result.message);
              $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
              toastr.error(error.message);
          });
          $scope.startOrderListTimer();
        };

        $scope.deleteDatabaseJob = function (event,itemId)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          apiService.loaderShow();
          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/delete-database-job', {
                item_id: itemId,
                order_id: order_id
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
              toastr.success(result.message);
              $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
              toastr.error(error.message);
          });
          $scope.startOrderListTimer();
        }

        $scope.deleteJob = function (event,item_increment_id)
        {
          var target = angular.element(event.target);
          angular.element(target).attr("disabled", "disabled");

          apiService.loaderShow();
          var order_id = $rootScope.orderEntityId;
          $http.post($rootScope.baseUrl + '/order/delete-job', {
                item_increment_id: item_increment_id,
                order_id: order_id
          }).success(function (result) {
            apiService.loaderHide();
            angular.element(target).removeAttr("disabled");
            if (result.status == 'success') {
              toastr.success(result.message);
              $scope.getOrderDetails();
            } else {
                toastr.error(result.message);
            }
          }).error(function (error) {
            angular.element(target).removeAttr("disabled");
              apiService.loaderHide();
              toastr.error(error.message);
          });
          $scope.startOrderListTimer();
        }

        $scope.deleteProduct = function(event, itemId)
        {

        };
    }
})();

/**
 * Profile page controller handle all action related user profile.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 09.12.2017
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, $http, $rootScope, $cookies, $location, toastr, apiService, $state, $filter, fileReader, $window) {
    $rootScope.currentState = 'dashboard';
    /**
    * Get user profile method is use for get user profile data.
    * created on 09.12.2017
    */
    $scope.resetGlobalSearch();
    $scope.noPicture = false;
    $scope.picture = $filter('appImage')('theme/profile-pick-default.png');
    $scope.removePicture = function () {
        $scope.picture = $filter('appImage')('theme/profile-pick-default.png');
        $scope.noPicture = true;
    };
    /**
     * View user method is use for view customer credit report
     * created on 08.01.2019
     */
    $scope.viewCustomerCreditReport = function (id) {
        $cookies.put('customer-id', id);
        $state.go('profile.view-customer-credit-report-profile');
    }

    $scope.uploadPicture = function () {
        var fileInput = document.getElementById('uploadFile');
        fileInput.click();
    };

    $scope.getFile = function () {
        $scope.noPicture = false;
        fileReader.readAsDataUrl(this.file, $scope)
            .then(function (result) {
                $scope.picture = result;
            });
    };

    $scope.resetFolderName = function(val) {
        if(val=='Yes'){
          $scope.OJdefaultFolder= '';  
        }
    };
    
    $scope.resetFolderNameer = function(valn) {
       if(valn=='Yes'){
          $scope.OJDBdefaultFolder= ''; 
        }
    };
    $scope.getUserProfile = function() {
         if(!$rootScope.globals || !$rootScope.globals.currentUser){
             return false;
         }
         var vm = this;
         apiService.loaderShow();
         var userId = $rootScope.globals.currentUser.id?$rootScope.globals.currentUser.id:0;
         $http.get($rootScope.baseUrl+'/user/'+userId)
        .success(function (response) {


                vm.file = response.profile_pic;
                if(response.profile_pic == '' || response.profile_pic == null){
                    $scope.picture = $filter('appImage')('theme/profile-pick-default.png');;
                }else {
                    $scope.picture = $rootScope.profilePickUrl+response.profile_pic;
                    $rootScope.globals.currentUser.profile_pic = response.profile_pic+'?'+ new Date().getTime();
                    $window.localStorage.setItem('globals',apiService.encriptData($rootScope.globals));
                }
                document.getElementById("uploadFile")
                if(response.status && response.status == 1){
                    $scope.userName = response.name;
                    $scope.firstname = response.firstname;
                    $scope.lastname = response.lastname;
                    $scope.gender = response.gender;
                    $scope.email = response.email;
                    $scope.mobile = response.mobile;
                    $scope.role = response.role?response.role:$rootScope.globals.currentUser.userRole;
                    $scope.OJoverrideFolder=response.open_job_override_folder?response.open_job_override_folder:'No';
                    
                    if($scope.OJoverrideFolder=='No'){
                        $scope.OJdefaultFolder= '';
                    } else {
                       $scope.OJdefaultFolder=response.open_job_default_folder?response.open_job_default_folder:''; 
                    }
                    
                    $scope.OJDBoverrideFolder=response.open_job_db_override_folder?response.open_job_db_override_folder:'No';
                    
                     if($scope.OJDBoverrideFolder=='No'){
                        $scope.OJDBdefaultFolder= '';
                    } else {
                       $scope.OJDBdefaultFolder=response.open_job_db_default_folder ?response.open_job_db_default_folder :''; 
                    }
                    
                    
                    $scope.customerCredit = response.customer_credit;
                    $scope.customerId = response.customer_id;
                    
                    
                   
                }else{
                    $rootScope.globals = {};
                    $cookies.remove('globals');
                    toastr.warning('Account is inactive, please contact administrator.');
                    $state.go('login');
                }
//                if (response.status == 'success') {
//                    $scope.userName = response.name;
//                    $scope.firstname = response.firstname;
//                    $scope.lastname = response.lastname;
//                    $scope.gender = response.gender;
//                    $scope.email = response.email;
//                    $scope.mobile = response.mobile;
//                    $scope.role = $rootScope.globals.currentUser.userRole;
//                }else{
//                    $location.path('/dashboard');
//                    toastr.error("Invalid username.");
//                }
        apiService.loaderHide();
        }).error(function (response) {
                apiService.loaderHide();
                //$location.path('/login');
                toastr.error("Something went wrong please try again.");
        });
      }

    /**
    * Update user profile method is use for update user profile data.
    * created on 09.12.2017
    */
    $scope.updateUserProfile = function() {

        if (!this.profileFrm.firstname.$valid) {
            toastr.error("Please enter first name.");
            angular.element('#firstname').focus();
            return;
        }else if (!this.profileFrm.lastname.$valid) {
            toastr.error("Please enter last name.");
             angular.element('#lastname').focus();
            return;
        }else if (!this.profileFrm.mobile.$valid) {
            toastr.error("Please enter mobile number.");
            angular.element('#mobile').focus();
            return;
        }else if (!this.profileFrm.gender.$valid) {
            toastr.error("Please select gender.");
            angular.element('#inlineRadio1').focus();
            return;
         }
         var vm = this;
        apiService.loaderShow();
        // var bodyData = {
        //     user_id: $rootScope.globals.currentUser.id,
        //     username:  this.userName,
        //     mobile:  this.mobile,
        //     email: this.email,
        //     firstname :this.firstname,
        //     lastname :this.lastname,
        //     gender :this.gender
        // };
        var file = document.getElementById("uploadFile").files[0];
            $http({
                url: $rootScope.baseUrl+'/user/changeprofile',
                method: 'POST',
                headers: {'Content-Type': undefined},
                transformRequest: function (data) {
                    var formData = new FormData();
                    ($scope.noPicture == false ? formData.append("file", file):'');
                    ($scope.noPicture == true ? formData.append("removeFile",'true'):'');
                    formData.append("user_id", $rootScope.globals.currentUser.id);
                    formData.append("username", vm.userName);
                    formData.append("mobile",vm.mobile);
                    formData.append("email",vm.email);
                    formData.append("firstname", vm.firstname);
                    formData.append("lastname", vm.lastname);
                    formData.append("gender",vm.gender);
                    formData.append("open_job_override_folder",vm.OJoverrideFolder);
                    formData.append("open_job_default_folder", vm.OJdefaultFolder);
                    formData.append("open_job_db_override_folder", vm.OJDBoverrideFolder);
                    formData.append("open_job_db_default_folder",vm.OJDBdefaultFolder);
                    return formData;
                },
            }).then(function (response) {
                $("input[name='FileUploadProfile']").val('');
                apiService.loaderHide();
                var response = response.data;
                if (response.status == 'success') {
                    toastr.success('Profile Updated Successfully.');

                    if(response.data && response.data.profile_pic && response.data.profile_pic != ''){
                        $rootScope.globals.currentUser.profile_pic = response.data.profile_pic+'?'+ new Date().getTime();
                        $rootScope.globals.currentUser.open_job_override_folder = response.data.open_job_override_folder;
                        $rootScope.globals.currentUser.open_job_default_folder=response.data.open_job_default_folder;
                        $rootScope.globals.currentUser.open_job_db_override_folder=response.data.open_job_db_override_folder;
                        $rootScope.globals.currentUser.open_job_db_default_folder=response.data.open_job_db_default_folder;
                        if($rootScope.globals.currentUser.open_job_override_folder=='No'){
                           $rootScope.globals.currentUser.open_job_default_folder= '';  
                        }
                        
                        if($rootScope.globals.currentUser.open_job_db_override_folder=='No'){
                           $rootScope.globals.currentUser.open_job_db_default_folder= '';  
                        }
                    }
                    if($scope.noPicture == true){
                        $rootScope.globals.currentUser.profile_pic = undefined;
                    }
                    $window.localStorage.setItem('globals',apiService.encriptData($rootScope.globals));
                    $scope.noPicture = false;
                }else{
                    toastr.error("Something went wrong please try again.");
                }
            }, function (response) {
                $("input[name='FileUploadProfile']").val('');
                apiService.loaderHide();
                var response = response.data;
                if(response.status && response.status == 'error'){
                    toastr.error(response.message);
                }else{
                    toastr.error("Something went wrong please try again.");
                }
            });
    }

    /**
    * Change user password method is use for change user password.
    * created on 09.12.2017
    */
    $scope.changeUserPassword = function() {

        if (this.changePwdFrm.password.$error.required) {
            toastr.error("Please enter password.");
            angular.element('#password').focus();
            return;
        }else if (this.changePwdFrm.password.$error.pattern) {
            toastr.error("Please enter valid password.");
            angular.element('#password').focus();
            return;
        }else if (this.changePwdFrm.newPassword.$error.required) {
            toastr.error("Please enter confirm password.");
            angular.element('#newPassword').focus();
            return;
        }else if (this.changePwdFrm.newPassword.$error.pattern) {
            toastr.error("Please enter valid confirm password.");
            angular.element('#newPassword').focus();
            return;
        }else if (this.password != this.newPassword) {
            toastr.error("Confirm password does not match.");
            angular.element('#newPassword').focus();
            return;
        }
        apiService.loaderShow();
        var bodyData = {
            user_id: $rootScope.globals.currentUser.id,
            current_password:  this.password,
            new_password:  this.newPassword
        };
        $http({
            url: $rootScope.baseUrl+'/user/changepassword',
            method: "POST",
            data: $scope.dataUrlEncode(bodyData),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (response) {
            var response = response.data;
            if (response.status == 'success') {
                toastr.success('Password changed successfully.');
            }else{
                if(response.message){
                   toastr.error(response.message);
                }else{
                   toastr.error("Invalid user.");
                }
            }
           apiService.loaderHide();
        }, function (response) {
             toastr.error("Something went wrong please try again.");
             apiService.loaderHide();
        });
        this.password = '';
        this.newPassword = '';
        $state.go($state.$current, null, { reload: true });
    }

  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.prevState=$state.current.prevState;
          $scope.prevStateTitle=$state.current.prevStateTitle;
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if(!$evt.originalEvent){
              return false;
          }  
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes, $rootScope) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                  if(!s.skipToShow){
                    return s.sidebarMeta;
                  }
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                var checkNestedPermission = false;
                var permissionTemp = '';
                if(s.nestedPermission){
                    angular.forEach(s.nestedPermission, function (value, key) {
                        if($rootScope.globals && $rootScope.globals.currentUser.permission.indexOf(value) != -1){
                           if(checkNestedPermission == false){
                             checkNestedPermission = true;
                             permissionTemp = value;
                           }
                        }
                    });
                }
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                  permissionKey: permissionTemp?permissionTemp:s.permissionKey
                //stateRef: s.abstract === true ? meta.defaultSubview : s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop($state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
      // link: function($scope) {
      //   $scope.$watch(function () {
      //     $scope.activeState = $state.current.name;
      //   });
      // }
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        offLabel:'@',
        onLabel:'@',
        disable:'='
      }
    };
  }

})();

/**
 * category controller handle all action related category configuration.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 21.02.2023
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.bugReportSettings')
    .controller('shipmentBugReport', shipmentBugReport);

  /** @ngInject */
  function shipmentBugReport($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile)
  {

     /**
     * permissionArr is use to check permission to display list
     * created on 21.02.2023
     */
    if($rootScope.permissionArr.indexOf('shipment_bug_report')==-1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }

    var vm=this;
    $rootScope.currentState='bug-report.shipment-bug-report';
    $scope.resetGlobalSearch();
    
    $scope.oneAtATime = true;
    $scope.isOpenObject = {};
    $scope.menuStatus = [{
        isOpen: true
    }]

    $scope.getShipmentBugReportData = function()
    {
      $http.get($rootScope.baseUrl + '/bugreport/shipment_bug_report')
      .success(function(result)
      {
        if (result)
        {
          if (result.status == 'fail') {
            toastr.error(result.message);
          }
          else if (result.status == 'success')
          {
            if (result.data)
            {
              var result = result.data;
              //console.log(result.data.shipment_bug_report.bugreporturl);
              vm.bugreporturl = result.data.shipment_bug_report.bugreporturl;
            }
          }
          else {
            toastr.error(result.message);
          }
        }
      })
      .error(function(error)
      {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    };

    $scope.saveshipmentBugReportSetting=function()
    {
      if(!this.shipmentBugReportFrm.$valid){
        return;
      }

      $scope.ShipmentBugReportSettingData = {
        'shipment_bug_report':{
          'bugreporturl':vm.bugreporturl
        }
      };
      
      apiService.loaderShow();
      var bodyData = {
        type: 'shipment_bug_report',
        bug_report_data: angular.toJson($scope.ShipmentBugReportSettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/bugreport/saveSetting', bodyData)
      .success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };
  }

})();

/**
 * Users controller handle all action related users.
 * @author nikunj silvercayde <nikunj@silvercayde.com>
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.accountSettings')
            .controller('ownerCtrl', ownerCtrl);

    /** @ngInject */
    function ownerCtrl($scope, $cookies, $q, $http, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $state, $timeout, $uibModal) {
        var vm = this;
        /**
         * permissionArr is use to check permission to display list
         * created on 09.22.2017
         */
        if ($rootScope.permissionArr.indexOf('allow_owner_account_customer') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState = 'account-settings.owner-account';

        /**
         * add new owner
         */
        $scope.addOwner = function () {
            $cookies.put('owner-id', undefined);
            $state.go('account-settings.add-owner');
        };

        /**
         * getEditedUser method is use for edited customer
         * created on 09.10.2017
         */
        $scope.getEditedCustomer = function () {
            $cookies.put('role-id', undefined);
            if ($rootScope.permissionArr.indexOf('add_owner_account_customer') == -1 && $rootScope.permissionArr.indexOf('edit_owner_account_customer') == -1) {
                $state.go('dashboard');
                toastr.error("You don't have permission to do this.");
            }
            if ($cookies.get('owner-id') && $cookies.get('owner-id') != undefined) {
                apiService.loaderShow();
                $http.get($rootScope.baseUrl + '/owner/show/' + $cookies.get('owner-id'))
                        .success(function (response) {
                            if (response.status == 'success') {
                                response = response.data;
                                vm.customerId = response.id;
                                vm.userName = response.name;
                                vm.customerUName = response.name;
                                vm.email = response.email;
                                vm.mobile = response.mobile;
                                vm.gender = response.gender;
                                vm.firstname = response.firstname;
                                vm.lastname = response.lastname;
                                vm.role = '' + response.role + '';
                                vm.status = response.status;
                                vm.isAvailable = '' + response.dashboard_display + '';
                                //vm.displayname= response.customer_name;
                                vm.displayname = response.display_name;
                                vm.positionId = response.position_id;
                                vm.binId = response.bin_id;
                                vm.shippingPriority = '' + response.priority + '';
                                vm.customerToken = response.customer_token;
                                vm.customerSyncType = response.is_sync;
                                vm.customerGroup = response.relay_customer_group;
                                $cookies.put('role-id', response.role);
                                $scope.getPermissionData(response.id, response.role);
                            }
                            apiService.loaderHide();
                        }).error(function (response) {
                    apiService.loaderHide();
                    toastr.error("Something went wrong please try again.");
                });
            } else {
                $state.go('account-settings.add-owner');
            }
        };

        /**
         * Save customer data method is use for update customer data.
         * created on 09.15.2017
         */
        $scope.saveOwnerData = function () {
            if (!this.customerFrm.firstname.$valid) {
                toastr.error("Please enter first name.");
                angular.element('#firstname').focus();
                return;
            } else if (!this.customerFrm.lastname.$valid) {
                toastr.error("Please enter last name.");
                angular.element('#lastname').focus();
                return;
            } else if (!this.customerFrm.userName.$valid) {
                toastr.error("Please enter user name.");
                angular.element('#userName').focus();
                return;
            } else if (!this.customerFrm.email.$valid) {
                toastr.error("Please enter email.");
                angular.element('#email').focus();
                return;
            } else if (!this.customerFrm.password.$valid && (vm.customerId == undefined || vm.customerId == 'undefined')) {
                toastr.error("Please enter password.");
                angular.element('#password').focus();
                return;
            } else if (!this.customerFrm.newPassword.$valid && (vm.customerId == undefined || vm.customerId == 'undefined')) {
                toastr.error("Please enter confirm password.");
                angular.element('#newPassword').focus();
                return;
            } else if (vm.password != '' && vm.password != vm.newPassword) {
                toastr.error("Confirm password should be same as password.");
                angular.element('#newPassword').focus();
                return;
            } else if (!this.customerFrm.mobile.$valid) {
                toastr.error("Please enter phone number.");
                angular.element('#mobile').focus();
                return;
            } else if (!this.customerFrm.role.$valid) {
                toastr.error("Please select role.");
                angular.element('#role').focus();
                return;
            } else if (!this.customerFrm.status.$valid) {
                toastr.error("Please select status.");
                angular.element('#status').focus();
                return;
            } else if (!this.customerFrm.inlineRadioOptions.$valid) {
                toastr.error("Please select gender.");
                angular.element('#inlineRadio1').focus();
                return;
            }

            apiService.loaderShow();
            var bodyData = {
                "is_manager": "0",
                "user_name": vm.userName,
                "mobile": vm.mobile,
                "email": vm.email,
                "first_name": vm.firstname,
                "last_name": vm.lastname,
                "gender": vm.gender,
                "role": vm.role,
                "status": vm.status,
                "password": (vm.password ? vm.password : ''),
                "dashboard_display": vm.isAvailable,
                "display_name": vm.displayname ? vm.displayname : '',
                "priority": vm.shippingPriority ? vm.shippingPriority : '1',
                "magento_version": 'm1',
                "customer_group": 'General',
                "relay_customer_group": vm.customerGroup
            };
            $scope.saveUrl = $rootScope.baseUrl + '/owner/store';
            $scope.httpMethod = 'POST';
            $scope.editedId = vm.customerId;
            if (vm.customerId) {
                $scope.saveUrl = $rootScope.baseUrl + '/owner/update/' + vm.customerId;
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    var owerUserIdForPermission = response.data.user_id;
                    toastr.success('Owner ' + ($scope.editedId ? 'updated' : 'Added') + ' successfully.');
                    // Add permissions
                    $scope.addPermissions(owerUserIdForPermission, vm.role);
                } else {
                    toastr.error(response.data.message);
                }
                window.history.back();
            }, function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code == 0) {
                    if (response.message == 'The email has already been taken.') {
                        toastr.error(response.message);
                        angular.element('#email').focus();
                    } else if (response.message == 'The name has already been taken.') {
                        toastr.error('This user name already exists.');
                        angular.element('#userName').focus();
                    } else {
                        toastr.error(response.message);
                    }
                } else {
                    window.history.back();
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * getDataTable method is use to get list of customer
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                if ($state.current.name == 'account-settings.mall-customers') {
                    $scope.customerType = 'mall';
                } else if ($state.current.name == 'account-settings.retail-customers') {
                    $scope.customerType = 'retail';
                }
                $http.get($rootScope.baseUrl + '/owner/index')
                        .success(function (result) {
                            if (result.length < $rootScope.numberOfRecord) {
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                            vm.users = [];
                            var index = 1;
                            angular.forEach(result, function (value, key) {
                                var changeStatusValTo = '0';
                                var ordersLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_owner_account_customer' + '\') !== -1" href="javascript:void(0);"  ng-click="showOrders(\'' + value.firstname + ' ' + value.lastname + '\')" title="Show Orders"><i class="fa fa-shopping-cart fa-lg white" aria-hidden="true"></i></a>';
                                var editLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_owner_account_customer' + '\') !== -1" href="javascript:void(0);"  ng-click="editOwner(\'' + value.id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                                var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'delete_owner_account_customer'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/accountSettings/owner/deleteModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                                //var subCustLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'sub_cust_list' + '\') !== -1 && mallCustAction" ng-click="subCustomers(' + value.id + ')" href="javascript:void(0);" title="Sub Customers"><i class="fa fa-users white" aria-hidden="true"></i></i></a>';
                                var subCustLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'subowners_list' + '\') !== -1 " ng-click="subOwners(' + value.id + ')" href="javascript:void(0);" title="Sub Customers"><i class="fa fa-users white" aria-hidden="true"></i></i></a>';
                                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                                var statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_owner_account_customer' + '\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/owner/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';
                                var reportLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'view_customer_credit_report' + '\') !== -1 && mallCustAction" ng-click="viewMallCustomerCreditReport(' + value.customer_id + ')" href="javascript:void(0);" title="Credit report"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></i></a>';
                                if (value.status == 0) {
                                    changeStatusValTo = '1';
                                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                                    statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_owner_account_customer' + '\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/owner/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                                }
                                var data = {
                                    id: value.id,
                                    index: index,
                                    name: value.name,
                                    email: value.email,
                                    mobile: value.mobile,
                                    gender: value.gender,
                                    firstname: value.firstname,
                                    lastname: value.lastname,
                                    cust_type: value.is_sync,
                                    status: statusBadge,
                                    created_at: value.created_at,
                                    operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks  + '&nbsp;' + subCustLinks
                                };
                                this.push(data);
                                index++;
                            }, vm.users);
                            defer.resolve(vm.users);
                        }).error(function (error) {
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord - 1));
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage', {"sSearch": "", 'sInfoFiltered': '(filtered from _MAX_ total entries)'}).withOption('order', [1, 'asc']);
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('name').withTitle('User Name'),
                DTColumnBuilder.newColumn('firstname').withTitle('First Name'),
                DTColumnBuilder.newColumn('lastname').withTitle('Last Name'),
                DTColumnBuilder.newColumn('email').withTitle('Email Id'),
                DTColumnBuilder.newColumn('mobile').withTitle('Phone'),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if ($rootScope.permissionArr.indexOf('edit_owner_account_customer') !== -1 || $rootScope.permissionArr.indexOf('change_status_owner_account_customer') !== -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        };

        $scope.subOwners = function(id) {
            $cookies.put('owner-id', id);
            $state.go('account-settings.sub-owners');
        };

        $scope.editOwner = function (id) {
            $cookies.put('owner-id', id);
            $state.go('account-settings.edit-owner');
        };

        $scope.getPermissionDataForCreateOwner = function () {
            if ($cookies.get('subowner-id') && $cookies.get('subowner-id') != undefined) {
            } else {
                $scope.getPermissionData('', '');
            }
        };

        $scope.getPermissionData = function (userId, roleId) {
            $scope.isloaded = false;
            var postData = {
                role_id: roleId,
                user_id: userId
            };
            var apiRoute = $rootScope.baseUrl + '/roles/permissions-owner';
            var getPermission = apiService.addData(apiRoute, postData);
            getPermission.then(function (response) {
                vm.permissionData = response.data;
                vm.newPermissionData = [];
                vm.largePermissionData = [];
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].permission.length > 15) {
                        vm.newPermissionData.push({cat_name: response.data[i].cat_name, permission: response.data[i].permission});
                    }
                }
                angular.forEach(vm.newPermissionData, function (val, key) {
                    $scope.setOfSets = _.toArray(_.groupBy(val.permission, function (item, index) {
                        return Math.floor(index / 3);
                    }));
                    vm.largePermissionData.push({cat_name: val.cat_name, permission: $scope.setOfSets});
                });
                $scope.isloaded = true;
            },
            function (error) {
                $scope.isloaded = true;
            });
        };

        $scope.addPermissions = function (userId, groupId) {
            var permId = [];
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (permis.perm_checked == true) {
                        permId.push(permis.perm_id);
                    }
                });
            });
            var postData = {
                //group_id: $cookies.get('role-id'),
                group_id: groupId,
                user_id: userId,
                permission: JSON.stringify(permId),
                select_all: vm.allSelected == true ? 1 : 0
            };
            var apiRoute = $rootScope.baseUrl + '/roles/updateownerpermissions';
            var addPermission = apiService.addData(apiRoute, postData);
            addPermission.then(function (response) {},
                    function (error) {});
        };
        
        $scope.CheckUncheckData = function(value) {
            vm.allSelected = true;
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (!permis.perm_checked) {
                        vm.allSelected = false;
                        return;
                    }
                });
            });
        };

        $scope.getCustomerRoles = function () {
            $http.get($rootScope.baseUrl + '/roles', {params: {roletype: 'ROLE_OWNER'}})
                    .success(function (response) {
                        $scope.customerRoleList = response;
                    }).error(function (response) {
            });
        };

        $scope.changeStatus = function () {
            if ($rootScope.deleteId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status: "" + $rootScope.status + ""
                };
                $http.put($rootScope.baseUrl + '/subcustomer', bodyData)
                        .success(function (result) {
                            if (result.status == 'success') {
                                toastr.success('Status updated successfully.');
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        $scope.getActiveGroupLabel = function () {
            $http.get($rootScope.baseUrl + '/customerrelaygroup/active')
                    .success(function (result) {
                        $scope.activeGroupData = result;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };

        /**
         * Delete owner method is use for delete user.
         * created on 10.16.2020
         */
        $scope.deleteOwner = function ()
        {
            if($rootScope.deleteId)
            {
                  apiService.loaderShow();
                  $http.delete($rootScope.baseUrl + '/owner/'+$rootScope.deleteId)
                     .success(function (result) {
                        if (result.status == 'success') {
                            toastr.success('Owner deleted successfully.');
                            $state.go($state.$current, null, { reload: true });;
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        apiService.loaderHide();
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.code != undefined && error.code == 0) {
                            toastr.error(error.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                    });
             }
             $scope.popupShow.close();
        };

        $scope.open = function (page, id, status) {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        $scope.success = function (text) {
            toastr.success(text + ' Copied!');
        };

        $scope.fail = function (err) {
            toastr.error('Error!', err);
        };

        $scope.goBack = function () {
            window.history.back();
        };

        $scope.makeUserNameButtonClickable = function () {
            if ($rootScope.permissionArr.indexOf('edit_customer_user_name') !== -1) {
                $scope.disableUserNameField = false;
            }
        };

        $scope.initMakeUserNameButtonDisable = function () {
            $scope.disableUserNameField = true;
        };
        
        $scope.getPermissionDataForCreateOwner = function () {
            if ($cookies.get('owner-id') && $cookies.get('owner-id') != undefined) {
            } else {
                $scope.getPermissionData('', '');
            }
        };

        $scope.getPermissionData = function (userId, roleId) {
            $scope.isloaded = false;
            var postData = {
                role_id: roleId,
                user_id: userId
            };
            var apiRoute = $rootScope.baseUrl + '/roles/permissions-owner';
            var getPermission = apiService.addData(apiRoute, postData);
            getPermission.then(function (response) {
                vm.permissionData = response.data;
                vm.newPermissionData = [];
                vm.largePermissionData = [];
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].permission.length > 15) {
                        vm.newPermissionData.push({cat_name: response.data[i].cat_name, permission: response.data[i].permission});
                    }
                }
                angular.forEach(vm.newPermissionData, function (val, key) {
                    $scope.setOfSets = _.toArray(_.groupBy(val.permission, function (item, index) {
                        return Math.floor(index / 3);
                    }));
                    vm.largePermissionData.push({cat_name: val.cat_name, permission: $scope.setOfSets});
                });
                $scope.isloaded = true;
            },
            function (error) {
                $scope.isloaded = true;
            });
        };

        $scope.addPermissions = function (userId, groupId) {
            var permId = [];
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (permis.perm_checked == true) {
                        permId.push(permis.perm_id);
                    }
                });
            });
            var postData = {
                //group_id: $cookies.get('role-id'),
                group_id: groupId,
                user_id: userId,
                permission: JSON.stringify(permId),
                select_all: vm.allSelected == true ? 1 : 0
            };
            var apiRoute = $rootScope.baseUrl + '/roles/updateownerpermissions';
            var addPermission = apiService.addData(apiRoute, postData);
            addPermission.then(function (response) {},
                    function (error) {});
        };
        
        $scope.CheckUncheckData = function(value) {
            vm.allSelected = true;
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (!permis.perm_checked) {
                        vm.allSelected = false;
                        return;
                    }
                });
            });
        };
    }
})();

/**
 * Users controller handle all action related users.
 * @author anand malvi <anand.malvi@brainvire.com>
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.accountSettings')
            .controller('subOwnerCtrl', subOwnerCtrl);

    /** @ngInject */
    function subOwnerCtrl($scope, $cookies, $q, $http, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $state, $timeout, $uibModal) {
        var vm = this;
        /**
         * permissionArr is use to check permission to display list
         * created on 09.22.2017
         */
        if ($rootScope.permissionArr.indexOf('allow_owner_account_customer') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState = 'account-settings.owner-account';

        /**
         * add new owner
         */
        $scope.addSubOwner = function () {
            $cookies.put('subowner-id', undefined);
            $state.go('account-settings.add-sub-owner');
        };

        /**
         * getEditedUser method is use for edited customer
         * created on 09.10.2017
         */
        $scope.getEditedSubOwner = function () {
            $cookies.put('role-id', undefined);
            if ($rootScope.permissionArr.indexOf('add_owner_account_customer') == -1 && $rootScope.permissionArr.indexOf('edit_owner_account_customer') == -1) {
                $state.go('dashboard');
                toastr.error("You don't have permission to do this.");
            }
            if ($cookies.get('subowner-id') && $cookies.get('subowner-id') != undefined) {
                apiService.loaderShow();
                $http.get($rootScope.baseUrl + '/owner/sub/show/' + $cookies.get('subowner-id'))
                        .success(function (response) {
                            if (response.status == 'success') {
                                response = response.data;
                                vm.owner_id = response.parent_id;
                                vm.customerId = response.id;
                                vm.userName = response.name;
                                vm.customerUName = response.name;
                                vm.email = response.email;
                                vm.mobile = response.mobile;
                                vm.gender = response.gender;
                                vm.firstname = response.firstname;
                                vm.lastname = response.lastname;
                                vm.role = '' + response.role + '';
                                vm.status = response.status;
                                vm.isAvailable = '' + response.dashboard_display + '';
                                //vm.displayname= response.customer_name;
                                vm.displayname = response.display_name;
                                vm.positionId = response.position_id;
                                vm.binId = response.bin_id;
                                vm.shippingPriority = '' + response.priority + '';
                                vm.customerToken = response.customer_token;
                                vm.customerSyncType = response.is_sync;
                                vm.customerGroup = response.relay_customer_group;
                                $cookies.put('role-id', response.role);
                                console.log(response.id);
                                console.log(response.role);
                                console.log(response.parent_id);
                                $scope.getPermissionData(response.id, response.role, response.parent_id);
                            }
                            apiService.loaderHide();
                        }).error(function (response) {
                    apiService.loaderHide();
                    toastr.error("Something went wrong please try again.");
                });
            } else {
                $state.go('account-settings.add-sub-owner');
            }
        };

        /**
         * Save customer data method is use for update customer data.
         * created on 09.15.2017
         */
        $scope.saveOwnerData = function () {
            if (!this.customerFrm.firstname.$valid) {
                toastr.error("Please enter first name.");
                angular.element('#firstname').focus();
                return;
            } else if (!this.customerFrm.lastname.$valid) {
                toastr.error("Please enter last name.");
                angular.element('#lastname').focus();
                return;
            } else if (!this.customerFrm.userName.$valid) {
                toastr.error("Please enter user name.");
                angular.element('#userName').focus();
                return;
            } else if (!this.customerFrm.email.$valid) {
                toastr.error("Please enter email.");
                angular.element('#email').focus();
                return;
            } else if (!this.customerFrm.password.$valid && (vm.customerId == undefined || vm.customerId == 'undefined')) {
                toastr.error("Please enter password.");
                angular.element('#password').focus();
                return;
            } else if (!this.customerFrm.newPassword.$valid && (vm.customerId == undefined || vm.customerId == 'undefined')) {
                toastr.error("Please enter confirm password.");
                angular.element('#newPassword').focus();
                return;
            } else if (vm.password != '' && vm.password != vm.newPassword) {
                toastr.error("Confirm password should be same as password.");
                angular.element('#newPassword').focus();
                return;
            } else if (!this.customerFrm.role.$valid) {
                toastr.error("Please select role.");
                angular.element('#role').focus();
                return;
            } else if (!this.customerFrm.status.$valid) {
                toastr.error("Please select status.");
                angular.element('#status').focus();
                return;
            }

            if ($cookies.get('owner-id') != undefined) {
                    var id = $cookies.get('owner-id');
                } else {
                    var id = 0;
                }
            apiService.loaderShow();
            var bodyData = {
                "owner_id": id,
                "is_manager": "0",
                "user_name": vm.userName,
                "email": vm.email,
                "first_name": vm.firstname,
                "last_name": vm.lastname,
                "gender": vm.gender,
                "role": vm.role,
                "status": vm.status,
                "password": (vm.password ? vm.password : ''),
                "priority": vm.shippingPriority ? vm.shippingPriority : '1',
                "magento_version": 'm1',
                "customer_group": 'General'
            };
            $scope.saveUrl = $rootScope.baseUrl + '/owner/sub/store';
            $scope.httpMethod = 'POST';
            $scope.editedId = vm.customerId;
            if (vm.customerId) {
                $scope.saveUrl = $rootScope.baseUrl + '/owner/sub/update/' + vm.customerId;
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    var owerUserIdForPermission = response.data.user_id;
                    toastr.success('Owner ' + ($scope.editedId ? 'updated' : 'Added') + ' successfully.');
                    $scope.addPermissions(owerUserIdForPermission, vm.role);
                } else {
                    toastr.error(response.data.message);
                }
                window.history.back();
            }, function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code == 0) {
                    if (response.message == 'The email has already been taken.') {
                        toastr.error(response.message);
                        angular.element('#email').focus();
                    } else if (response.message == 'The name has already been taken.') {
                        toastr.error('This user name already exists.');
                        angular.element('#userName').focus();
                    } else {
                        toastr.error(response.message);
                    }
                } else {
                    window.history.back();
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * getDataTable method is use to get list of customer
         */
        $scope.getDataTable = function () {
            var vm = this;
            if ($cookies.get('owner-id') != undefined) {
                    var id = $cookies.get('owner-id');
                } else {
                    var id = 0;
                }
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                
                $http.get($rootScope.baseUrl + '/owner/sub/index/'+id)
                        .success(function (result) {
                            if (result.length < $rootScope.numberOfRecord) {
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                            vm.users = [];
                            var index = 1;
                            angular.forEach(result, function (value, key) {
                                var changeStatusValTo = '0';
                                var editLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_owner_account_customer' + '\') !== -1" href="javascript:void(0);"  ng-click="editSubOwner(\'' + value.id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                                
                                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                                var statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_owner_account_customer' + '\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/owner/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';
                                
                                if (value.status == 0) {
                                    changeStatusValTo = '1';
                                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                                    statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_owner_account_customer' + '\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/owner/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                                }
                                var data = {
                                    id: value.id,
                                    index: index,
                                    name: value.name,
                                    email: value.email,
                                    mobile: value.mobile,
                                    gender: value.gender,
                                    firstname: value.firstname,
                                    lastname: value.lastname,
                                    cust_type: value.is_sync,
                                    status: statusBadge,
                                    created_at: value.created_at,
                                    operations: editLinks + '&nbsp;' + statusLinks
                                };
                                this.push(data);
                                index++;
                            }, vm.users);
                            defer.resolve(vm.users);
                        }).error(function (error) {
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord - 1));
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage', {"sSearch": "", 'sInfoFiltered': '(filtered from _MAX_ total entries)'}).withOption('order', [1, 'asc']);
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('name').withTitle('User Name'),
                DTColumnBuilder.newColumn('firstname').withTitle('First Name'),
                DTColumnBuilder.newColumn('lastname').withTitle('Last Name'),
                DTColumnBuilder.newColumn('email').withTitle('Email Id'),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if ($rootScope.permissionArr.indexOf('edit_owner_account_customer') !== -1 || $rootScope.permissionArr.indexOf('change_status_owner_account_customer') !== -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        };

        $scope.editSubOwner = function (id) {
            $cookies.put('subowner-id', id);
            $state.go('account-settings.edit-sub-owner');
        };

        $scope.getPermissionDataForCreateSubOwner = function () {
            if ($cookies.get('subowner-id') && $cookies.get('subowner-id') != undefined) {
            } else {
                $scope.getPermissionData('', '');
            }
        };

        $scope.getPermissionData = function (userId, roleId, owner_id) {
            console.log(userId);
            console.log(roleId);
            console.log(owner_id);
            $scope.isloaded = false;
            var postData = {
                role_id: roleId,
                user_id: userId,
                owner_id: owner_id
            };
            var apiRoute = $rootScope.baseUrl + '/roles/permissions-sub-owner';
            var getPermission = apiService.addData(apiRoute, postData);
            getPermission.then(function (response) {
                vm.permissionData = response.data;
                vm.newPermissionData = [];
                vm.largePermissionData = [];
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].permission.length > 15) {
                        vm.newPermissionData.push({cat_name: response.data[i].cat_name, permission: response.data[i].permission});
                    }
                }
                angular.forEach(vm.newPermissionData, function (val, key) {
                    $scope.setOfSets = _.toArray(_.groupBy(val.permission, function (item, index) {
                        return Math.floor(index / 3);
                    }));
                    vm.largePermissionData.push({cat_name: val.cat_name, permission: $scope.setOfSets});
                });
                $scope.isloaded = true;
            },
            function (error) {
                $scope.isloaded = true;
            });
        };

        $scope.addPermissions = function (userId, groupId) {
            var permId = [];
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (permis.perm_checked == true) {
                        permId.push(permis.perm_id);
                    }
                });
            });
            var postData = {
                //group_id: $cookies.get('role-id'),
                group_id: groupId,
                user_id: userId,
                permission: JSON.stringify(permId),
                select_all: vm.allSelected == true ? 1 : 0
            };
            var apiRoute = $rootScope.baseUrl + '/roles/updateownerpermissions';
            var addPermission = apiService.addData(apiRoute, postData);
            addPermission.then(function (response) {},
                    function (error) {});
        };
        
        $scope.CheckUncheckData = function(value) {
            vm.allSelected = true;
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (!permis.perm_checked) {
                        vm.allSelected = false;
                        return;
                    }
                });
            });
        };

        $scope.getCustomerRoles = function () {
            $http.get($rootScope.baseUrl + '/roles', {params: {roletype: 'ROLE_SUB_OWNER'}})
                    .success(function (response) {
                        $scope.customerRoleList = response;
                    }).error(function (response) {
            });
        };

        $scope.changeStatus = function () {
            if ($rootScope.deleteId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status: "" + $rootScope.status + ""
                };
                $http.put($rootScope.baseUrl + '/subcustomer', bodyData)
                        .success(function (result) {
                            if (result.status == 'success') {
                                toastr.success('Status updated successfully.');
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error(result.message);
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        $scope.getActiveGroupLabel = function () {
            $http.get($rootScope.baseUrl + '/customerrelaygroup/active')
                    .success(function (result) {
                        $scope.activeGroupData = result;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };

        $scope.open = function (page, id, status) {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        $scope.success = function (text) {
            toastr.success(text + ' Copied!');
        };

        $scope.fail = function (err) {
            toastr.error('Error!', err);
        };

        $scope.goBack = function () {
            window.history.back();
        };

        $scope.makeUserNameButtonClickable = function () {
            if ($rootScope.permissionArr.indexOf('edit_customer_user_name') !== -1) {
                $scope.disableUserNameField = false;
            }
        };

        $scope.initMakeUserNameButtonDisable = function () {
            $scope.disableUserNameField = true;
        };
    }
})();

/**
 * Users controller handle all action related users.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 10.12.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.accountSettings')
            .controller('customersCtrl', customersCtrl);

    /** @ngInject */
    function customersCtrl($scope, $cookies, $q, $http, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $state, $timeout,$uibModal) {
        var vm = this;
        /**
        * permissionArr is use to check permission to display list
        * created on 09.22.2017
        */
        if($rootScope.permissionArr.indexOf('mall_customer_list') == -1 && $rootScope.permissionArr.indexOf('retail_customer_list') == -1 && $rootScope.permissionArr.indexOf('sub_cust_manage') == -1){
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        $scope.resetGlobalSearch();
        $scope.disableUserNameField = true;
        /**
        * Sub customer login data
        * created on 04.13.2018
        */
        if($rootScope.userRole=='ROLE_CUSTOMER' && $state.current.name=='account-settings.manage-sub-customer'){
          $cookies.put('customer-id',$rootScope.userId);
          $state.go('account-settings.manage-sub-customer');
        }
        if($rootScope.userRole=='ROLE_CUSTOMER'){
          $rootScope.currentState='account-settings.manage-sub-customer';
        }else{
          if($state.current.name=='account-settings.mall-customers'){
            $rootScope.currentState='account-settings.mall-customers';
            $scope.mallCustAction=true;
          }else if($state.current.name=='account-settings.retail-customers'){
            $rootScope.currentState='account-settings.retail-customers';
            $scope.mallCustAction=false;
          }
        }
        /**
        * get role data method is use to get list of customer role
        * created on 04.13.2018
        */
        $scope.getCustomerRoles=function(){
          $http.get($rootScope.baseUrl + '/roles',{params:{roletype:'ROLE_CUSTOMER'}})
              .success(function (response) {
                $scope.customerRoleList=response;
          }).error(function (response) {
  //            toastr.error("Something went wrong please try again.");
          });
        }
        /**
        * get role data method is use to get list of sub customer role
        * created on 04.20.2018
        */
        $scope.getSubCustomerRoles=function(){
          $http.get($rootScope.baseUrl + '/roles',{params:{roletype:'ROLE_SUB_CUSTOMER'}})
              .success(function (response) {
                $scope.subCustomerRoleList=response;
          }).error(function (response) {
  //            toastr.error("Something went wrong please try again.");
          });
        }
        function renderWithCustType(data,full,type){
          if(data=='yes'){
            return 'Mall Customer';
          }else if(data=='no'){
            return 'Retail Customer';
          }else{
            return '';
          }
        }
        /**
        * getDataTable method is use to get list of customer
        * created on 09.10.2017
        */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                if($state.current.name=='account-settings.mall-customers'){
                  $scope.customerType='mall';
                }else if($state.current.name=='account-settings.retail-customers'){
                  $scope.customerType='retail';
                }
                $http.get($rootScope.baseUrl + '/customer',{params:{usertype:$scope.customerType}})
                        .success(function (result) {
                            if(result.length < $rootScope.numberOfRecord){
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                 }, 200);
                             }
                    vm.users = [];
                    var index = 1;
                    angular.forEach(result, function (value, key) {
                        var changeStatusValTo = '0';
                        var ordersLinks = ' <a ng-if="permissionArr.indexOf(\''+'customer_edit'+'\') !== -1" href="javascript:void(0);"  ng-click="showOrders(\'' + value.firstname+' '+value.lastname+ '\')" title="Show Orders"><i class="fa fa-shopping-cart fa-lg white" aria-hidden="true"></i></a>';
                        var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'customer_edit'+'\') !== -1" href="javascript:void(0);"  ng-click="editCustomer(\'' + value.id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        var subCustLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_cust_list'+'\') !== -1 && mallCustAction" ng-click="subCustomers(' + value.id + ')" href="javascript:void(0);" title="Sub Customers"><i class="fa fa-users white" aria-hidden="true"></i></i></a>';
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                        var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'customer_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/customers/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        var reportLinks = ' <a ng-if="permissionArr.indexOf(\''+'view_customer_credit_report'+'\') !== -1 && mallCustAction" ng-click="viewMallCustomerCreditReport(' + value.customer_id + ')" href="javascript:void(0);" title="Credit report"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></i></a>';

                        if (value.status == 0) {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'customer_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/customers/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                        }
                        var data = {
                            id: value.id,
                            index:index,
                            name: value.name,
                            email: value.email,
                            mobile: value.mobile,
                            gender :value.gender,
                            firstname :value.firstname,
                            lastname :value.lastname,
                            cust_type:value.is_sync,
                            status:statusBadge,
                            created_at: value.created_at,
                            operations: editLinks+'&nbsp;'+statusLinks +'&nbsp;'+ordersLinks+'&nbsp;'+subCustLinks+'&nbsp;'+reportLinks
                        };
                        this.push(data);
                        index++;
                    }, vm.users);
                    defer.resolve(vm.users);
                }).error(function (error) {
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('fnRowCallback',
            function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $scope.$apply($compile(nRow)($scope));
            });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('initComplete', function() {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');

            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' }).withOption('order', [1, 'asc']);
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('name').withTitle('User Name'),
                DTColumnBuilder.newColumn('firstname').withTitle('First Name'),
                DTColumnBuilder.newColumn('lastname').withTitle('Last Name'),
                //DTColumnBuilder.newColumn('email').withTitle('Email Id').renderWith(apiService.ellipsisString15Car),
                DTColumnBuilder.newColumn('email').withTitle('Email Id'),
                DTColumnBuilder.newColumn('mobile').withTitle('Phone'),
                //DTColumnBuilder.newColumn('cust_type').withTitle('Customer Type').renderWith(renderWithCustType),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if($rootScope.permissionArr.indexOf('customer_edit') !== -1 || $rootScope.permissionArr.indexOf('customer_changestatus') !== -1 || $rootScope.permissionArr.indexOf('sub_cust_list') !== -1){
                vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }

        }

        /**
        * View user method is use for view customer
        * created on 09.10.2017
        */
        $scope.subCustomers = function (id) {
           $cookies.put('customer-id',id);
           $state.go('account-settings.sub-customer');
        }
        /**
        * View user method is use for view customer credit report
        * created on 09.10.2017
        */
        $scope.viewMallCustomerCreditReport = function (id) {
           $cookies.put('customer-id',id);
           $state.go('account-settings.view-mall-customer-credit-report');
        }
        /**
        * Edit Customer method is use for edit customer
        * created on 09.10.2017
        */
        $scope.addCustomer = function () {
           $cookies.put('customer-id',undefined);
           $state.go('account-settings.add-customer');
        }
        /**
        * Edit Customer method is use for edit customer
        * created on 09.10.2017
        */
        $scope.editCustomer = function (id) {
           $cookies.put('customer-id',id);
           $state.go('account-settings.edit-customer');
        }

        /**
        * Show Orders method is use for show orders of customers
        * created on 09.10.2017
        */
        $scope.showOrders = function (id) {
           $rootScope.customerName = id;
           $state.go('orders');
        }
        /**
         * Change status method is use for change status of customer.
         * created on 04.16.2018
         */
        $scope.changeStatus = function () {
            if($rootScope.deleteId){
                apiService.loaderShow();
                  var bodyData = {
                    id: $rootScope.deleteId,
                    status: ""+$rootScope.status+""
                  };
                  $http.put($rootScope.baseUrl + '/subcustomer', bodyData)
                          .success(function (result) {
                        if (result.status == 'success') {
                            toastr.success('Status updated successfully.');
                             $state.go($state.$current, null, { reload: true });
                        } else {
                            toastr.error(result.message);
                        }
                        apiService.loaderHide();
                  }).error(function (error) {
                        apiService.loaderHide();
                        if (error.code != undefined && error.code == 0) {
                            toastr.error(error.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                     });
                  $scope.popupShow.close();
             }
        };
        /**
        * getEditedUser method is use for edited customer
        * created on 09.10.2017
        */
        $scope.getEditedCustomer = function () {
            if($rootScope.permissionArr.indexOf('customer_add') == -1 && $rootScope.permissionArr.indexOf('customer_edit') == -1){
              $state.go('dashboard');
              toastr.error("You don't have permission to do this.");
            }
            if($cookies.get('customer-id') && $cookies.get('customer-id')!= undefined){
                apiService.loaderShow();
                $http.get($rootScope.baseUrl+'/customer/'+$cookies.get('customer-id'))
                .success(function (response) {
                    if(response.status == 'success'){
                       response = response.data;
                        vm.customerId = response.id;
                        vm.userName = response.name;
                        vm.customerUName=response.name;
                        vm.email = response.email;
                        vm.mobile = response.mobile;
                        vm.gender = response.gender;
                        vm.firstname = response.firstname;
                        vm.lastname = response.lastname;
                        vm.role=''+response.role+'';
                        vm.status = response.status;
                        vm.isAvailable = ''+response.dashboard_display+'';
                        //vm.displayname= response.customer_name;
                        vm.displayname= response.display_name;
                        vm.positionId= response.position_id;
                        vm.binId = response.bin_id;
                        vm.shippingPriority = ''+response.priority+'';
                        vm.customerToken=response.customer_token;
                        vm.customerSyncType=response.is_sync;
                        vm.customerGroup=response.relay_customer_group;
                        if(!vm.customerToken){
                            // get token
                            $http.get($rootScope.baseUrl+'/customer/tokens').success(function(response){
                              vm.customerToken=response.token;
                            }).error(function(error){
                              //toastr.error(error.message);
                            });
                          }
                     }
                     apiService.loaderHide();
                }).error(function (response) {
                   apiService.loaderHide();
                   toastr.error("Something went wrong please try again.");
                });
             }else{
                $state.go('account-settings.add-customer');
             }
        };
        /**
        * getCustomerTokenPositionIdBinId method is use for get customer token, Position id and Bin id
        * created on 04.24.2018
        */
        $scope.getCustomerToken = function () {
          if($cookies.get('customer-id')== undefined){
              // get token
              $http.get($rootScope.baseUrl+'/customer/tokens').success(function(response){
                vm.customerToken=response.token;
              }).error(function(error){
                //toastr.error(error.message);
              });
            }
          }
          $scope.getCustomerPositionId = function () {
            if(!vm.positionId){
              // get Position Id
              $http.get($rootScope.baseUrl+'/customer/customerpostionids').success(function(response){
                vm.positionId=response.data.postionId;
              }).error(function(error){
                if(error.data){
                  toastr.error(error.data.message);
                }
              });
            }
          }
          $scope.getCustomerBinId = function () {
            if(!vm.binId){
              // get Bin Id
              $http.get($rootScope.baseUrl+'/customer/getcustomerbinids').success(function(response){
                vm.binId=response.data.binId;
              }).error(function(error){
                if(error.data){
                  toastr.error(error.data.message);
                }
              });
            }
        }
        $scope.getActiveGroupLabel = function () {
          $http.get($rootScope.baseUrl + '/customerrelaygroup/active')
            .success(function(result) {
              $scope.activeGroupData = result;
            }).error(function(error) {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              }
            });
        }
        /**
         * Save customer data method is use for update customer data.
         * created on 09.15.2017
         */
        $scope.saveCustomerData = function () {
          if (!this.customerFrm.firstname.$valid) {
              toastr.error("Please enter first name.");
              angular.element('#firstname').focus();
              return;
          } else if (!this.customerFrm.lastname.$valid) {
              toastr.error("Please enter last name.");
              angular.element('#lastname').focus();
              return;
          } else if (!this.customerFrm.userName.$valid) {
              toastr.error("Please enter user name.");
              angular.element('#userName').focus();
              return;
          } else if (!this.customerFrm.email.$valid) {
              toastr.error("Please enter email.");
              angular.element('#email').focus();
              return;
          } else if (!this.customerFrm.password.$valid &&  (vm.customerId == undefined || vm.customerId == 'undefined')) {
              toastr.error("Please enter password.");
              angular.element('#password').focus();
              return;
          }else if (!this.customerFrm.newPassword.$valid &&  (vm.customerId == undefined || vm.customerId == 'undefined')) {
              toastr.error("Please enter confirm password.");
              angular.element('#newPassword').focus();
              return;
          }else if (vm.password != '' && vm.password != vm.newPassword) {
              toastr.error("Confirm password should be same as password.");
              angular.element('#newPassword').focus();
              return;
          } else if (!this.customerFrm.mobile.$valid) {
              toastr.error("Please enter phone number.");
              angular.element('#mobile').focus();
              return;
          }  else if(!this.customerFrm.role.$valid) {
              toastr.error("Please select role.");
              angular.element('#role').focus();
              return;
          } else  if (!this.customerFrm.status.$valid) {
              toastr.error("Please select status.");
              angular.element('#status').focus();
              return;
          } else if (!this.customerFrm.inlineRadioOptions.$valid) {
              toastr.error("Please select gender.");
              angular.element('#inlineRadio1').focus();
              return;
          }
            if(vm.isAvailable == '1'){
                if (!this.customerFrm.displayname.$valid ) {
                    toastr.error("Please enter display name.");
                    angular.element('#displayname').focus();
                    return;
                } else if (!this.customerFrm.positionId.$valid  ) {
                    toastr.error("Please enter position id.");
                    angular.element('#positionId').focus();
                    return;
                } else if (!this.customerFrm.binId.$valid) {
                    toastr.error("Please enter bin id.");
                    angular.element('#binId').focus();
                    return;
                }
            }
            apiService.loaderShow();
            var bodyData = {
                "is_manager": "0",
                "user_name": vm.userName,
                "mobile": vm.mobile,
                "email": vm.email,
                "first_name": vm.firstname,
                "last_name": vm.lastname,
                "gender": vm.gender,
                "role": vm.role,
                "status": vm.status,
                "password": (vm.password ? vm.password : ''),
                "dashboard_display": vm.isAvailable,
                //"customer_name": vm.displayname? vm.displayname : '',
                "display_name": vm.displayname? vm.displayname : '',
                "position_id": vm.positionId? vm.positionId : '',
                "bin_id": vm.binId ? vm.binId : '',
                "priority": vm.shippingPriority ? vm.shippingPriority : '1',
                "magento_version":'m1',
                "customer_group":'General',
                "customer_token":vm.customerToken,
                "relay_customer_group":vm.customerGroup
            };

            $scope.saveUrl = $rootScope.baseUrl + '/customer/save';
            $scope.httpMethod = 'POST';
            $scope.editedId = vm.customerId;
            if (vm.customerId) {
                $scope.saveUrl = $rootScope.baseUrl + '/customer/' + vm.customerId;
                $scope.httpMethod = 'PUT';
            }
            $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    toastr.success('Customer ' + ($scope.editedId ? 'updated' : 'Added') + ' successfully.');
                } else {
                    toastr.error(response.data.message);
                }
                window.history.back();
                //$state.go('account-settings.customers');
            }, function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code == 0) {
                    if(response.message == 'The email has already been taken.'){
                        toastr.error(response.message);
                        angular.element('#email').focus();
                    }else if(response.message == 'The name has already been taken.'){
                        toastr.error('This user name already exists.');
                        angular.element('#userName').focus();
                    }else{
                        toastr.error(response.message);
                    }
                } else {
                    window.history.back();
                    //$state.go('account-settings.customers');
                    toastr.error("Something went wrong please try again.");
                }
            });

        }

        /**
         * Add sub customer method is use for get add sub customer page.
         * created on 04.10.2018
         */
        $scope.addSubCustomer = function() {
          $cookies.put('sub-customer-id',undefined);
          $state.go('account-settings.add-sub-customer');
        }
        /**
        * Edit sub customer method is use for edit sub customer
        * created on 04.10.2018
        */
        $scope.editSubCustomer = function (id) {
           $cookies.put('sub-customer-id',id);
           $state.go('account-settings.edit-sub-customer');
        }

       /**
        * Open model.
        * created on 04.10.2018
        */
       $scope.open = function(page, id, status) {
         $rootScope.deleteId = id;
         $rootScope.status = status;
         $scope.popupShow = $uibModal.open({
           animation: true,
           templateUrl: page,
           scope: $scope,
         });
       };
       /**
       * getSubCustDataTable method is use to get list of sub customers
       * created on 04.10.2018
       */
       $scope.getSubCustDataTable = function () {
       	$cookies.put('customer-id', $rootScope.globals.currentUser.id);
         if($cookies.get('customer-id') && $cookies.get('customer-id')!= undefined){
           var vm = this;
           vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
               var defer = $q.defer();
               $http.get($rootScope.baseUrl + '/subcustomer/'+$cookies.get('customer-id'))
                       .success(function (result) {
                           if(result.length < $rootScope.numberOfRecord){
                               $timeout(function () {
                                   angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                   vm.subCustomers = [];
                   var index = 1;
                   angular.forEach(result, function (value, key) {
                       var changeStatusValTo = '0';
                       var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_cust_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/customers/subCustStatusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';
                       var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                       if (value.status == 0) {
                           changeStatusValTo = '1';
                           statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                           statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_cust_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/customers/subCustStatusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                       }
                       var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'sub_cust_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/accountSettings/customers/subCustDeleteModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                       var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_cust_edit'+'\') !== -1" href="javascript:void(0);" ng-click="editSubCustomer(' + value.id + ')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                       var data = {
                           id: value.id,
                           index:index,
                           name: value.name,
                           firstname :value.firstname,
                           lastname :value.lastname,
                           email:value.email,
                           status:statusBadge,
                           created_at: value.created_at,
                           operations: editLinks+ '&nbsp;'+statusLinks +'&nbsp;'+deleteLinks
                       };
                       this.push(data);
                       index++;
                   }, vm.subCustomers);
                   defer.resolve(vm.subCustomers);
               }).error(function (error) {
                   if (error.code != undefined && error.code == 0) {
                       toastr.error(error.message);
                   } else {
                       toastr.error("Something went wrong please try again.");
                   }
               });
               return defer.promise;
           }).withPaginationType('simple_numbers')
           vm.dtOptions.withOption('fnRowCallback',
           function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
             $scope.$apply($compile(nRow)($scope));
           });
           vm.dtOptions.withOption('sDom', $rootScope.dom);
           vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
           vm.dtOptions.withOption('initComplete', function() {
               angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
               angular.element('.dataTables_filter input').attr('class', 'form-control');
               angular.element('.dataTables_length select').attr('class', 'form-control');

           });
           vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' }).withOption('order', [1, 'asc']);
           vm.dtColumns = [
               DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
               DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
               DTColumnBuilder.newColumn('name').withTitle('User Name'),
               DTColumnBuilder.newColumn('firstname').withTitle('First Name'),
               DTColumnBuilder.newColumn('lastname').withTitle('Last Name'),
               DTColumnBuilder.newColumn('email').withTitle('Email Id'),
               DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
               DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
           ];
           if($rootScope.permissionArr.indexOf('sub_cust_edit') !== -1 || $rootScope.permissionArr.indexOf('sub_cust_delete') !== -1 || $rootScope.permissionArr.indexOf('sub_cust_changestatus') !== -1){
               vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
           }
         }
       }
       /**
        * Delete sub customer method is use for delete sub customer.
        * created on 04.11.2018
        */
       $scope.deleteSubCustomer=function() {
         if ($rootScope.deleteId) {
           apiService.loaderShow();
           $http.delete($rootScope.baseUrl + '/subcustomer/' + $rootScope.deleteId)
                   .success(function(result) {
             if (result.status == 'success') {
               toastr.success('Sub customer deleted successfully.');
               $state.go($state.$current, null, {
                 reload: true
               });
             } else {
               toastr.error("Something went wrong please try again.");
             }
               apiService.loaderHide();
           }).error(function (error) {
               apiService.loaderHide();
               if (error.data.code != undefined && error.data.code == 0) {
                   toastr.error(error.data.message);
               } else {
                   toastr.error("Something went wrong please try again.");
               }
           });
         }
         $scope.popupShow.close();
       }

       /**
        * Change status method is use for change sub customer status.
        * created on 04.11.2018
        */
       $scope.subCustChangeStatus=function() {
         if ($rootScope.deleteId) {
           apiService.loaderShow();
           var bodyData = {
             id: $rootScope.deleteId,
             status: ""+$rootScope.status+"",
           };
           $http.put($rootScope.baseUrl + '/subcustomer', bodyData)
             .success(function(result) {
               if (result.status == 'success') {
                 toastr.success('Status updated successfully.');
                 $state.go($state.$current, null, {
                   reload: true
                 });
               } else {
                 if($rootScope.userRole=='ROLE_CUSTOMER'){
                   $state.go('account-settings.manage-sub-customer');
                 }else{
                   $state.go('account-settings.sub-customer');
                 }
                 toastr.error("Something went wrong please try again.");
               }
               apiService.loaderHide();
             }).error(function(error) {
               apiService.loaderHide();
               if (error.data.code != undefined && error.data.code == 0) {
                   toastr.error(error.data.message);
               } else {
                   toastr.error("Something went wrong please try again.");
               }
             });
           $scope.popupShow.close();
         }
       };
       /**
        * Get edited sub customer method is use for get edited sub customer data.
        * created on 04.11.2018
        */
       $scope.getEditedSubCustomer = function () {

           if($rootScope.permissionArr.indexOf('sub_cust_add') == -1 && $rootScope.permissionArr.indexOf('sub_cust_edit') == -1){
             $state.go('dashboard');
             toastr.error("You don't have permission to do this.");
           }

           if ($cookies.get('sub-customer-id') && $cookies.get('sub-customer-id')!= undefined) {
               apiService.loaderShow();
               var vm = this;
               $http.get($rootScope.baseUrl + '/subcustomer/detail/' + $cookies.get('sub-customer-id'))
                       .success(function (response) {
                           var responseData=response.data;
                           vm.subCustId = responseData.id;
                           vm.userName = responseData.username;
                           vm.email=responseData.email;
                           vm.firstname = responseData.firstname;
                           vm.lastname = responseData.lastname;
                           vm.status = responseData.status;
                           vm.role=""+responseData.role+"";
                           apiService.loaderHide();
                       }).error(function (error) {
                           apiService.loaderHide();
                           if (error.code != undefined && error.code == 0) {
                               toastr.error(error.message);
                           } else {
                               toastr.error("Something went wrong please try again.");
                           }
                           $state.go('account-settings.add-sub-customer');
                       });
           }else{
              $state.go('account-settings.add-sub-customer');
           }
       };
       /**
        * Save sub customer data method is use for update/add sub customer data.
        * created on 04.11.2018
        */
       $scope.saveSubCustData = function () {
           if (!this.subCustFrm.firstname.$valid) {
               toastr.error("Please enter first name.");
               angular.element('#firstname').focus();
               return;
           } else if (!this.subCustFrm.lastname.$valid) {
               toastr.error("Please enter last name.");
               angular.element('#lastname').focus();
               return;
           } else if (!this.subCustFrm.userName.$valid) {
               toastr.error("Please enter user name.");
               angular.element('#userName').focus();
               return;
           }else if (!this.subCustFrm.email.$valid) {
               toastr.error("Please enter email.");
               angular.element('#email').focus();
               return;
           }else if (!this.subCustFrm.password.$valid &&  (this.subCustId == undefined || this.subCustId == 'undefined')) {
               toastr.error("Please enter password.");
               angular.element('#password').focus();
               return;
           }else if (!this.subCustFrm.newPassword.$valid &&  (this.subCustId == undefined || this.subCustId == 'undefined')) {
               toastr.error("Please enter confirm password.");
               angular.element('#newPassword').focus();
               return;
           }else if (this.password != this.newPassword) {
               toastr.error("Confirm password should be same as password.");
               angular.element('#newPassword').focus();
               return;
           }else if (!this.subCustFrm.status.$valid) {
               toastr.error("Please select status.");
               angular.element('#status').focus();
               return;
           }else if (!this.subCustFrm.role.$valid) {
               toastr.error("Please select role.");
               angular.element('#role').focus();
               return;
           }
           apiService.loaderShow();
           var bodyData = {
               username: this.userName,
               firstname: this.firstname,
               lastname: this.lastname,
               status: this.status,
               role: this.role,
               email:this.email,
               password: (this.password?this.password:''),
               confirm_password:(this.newPassword?this.newPassword:'')
           };
           $scope.saveUrl = $rootScope.baseUrl + '/subcustomer/'+$cookies.get('customer-id');
           $scope.httpMethod = 'POST';
           $scope.editedId = this.subCustId;
           if (this.subCustId) {
               bodyData['user_id']=this.subCustId;
               $scope.saveUrl = $rootScope.baseUrl + '/subcustomer/' + this.subCustId;
               $scope.httpMethod = 'PUT';
           }
           $http({
               url: $scope.saveUrl,
               method: $scope.httpMethod,
               data: $scope.dataUrlEncode(bodyData),
               headers: {'Content-Type': 'application/x-www-form-urlencoded'}
           }).then(function (response) {
               apiService.loaderHide();
               if (response.data && response.data.status == 'success') {
                   toastr.success('Sub customer ' + ($scope.editedId ? 'updated' : 'Added') + ' successfully.');
                   if($rootScope.userRole=='ROLE_CUSTOMER'){
                     $state.go('account-settings.manage-sub-customer');
                   }else{
                     $state.go('account-settings.sub-customer');
                   }
               } else {
                   toastr.error(response.data.message);
               }
           }, function (response) {
               apiService.loaderHide();
               var response = response;
               if (response.code == 0) {
                   if(response.message == 'The name has already been taken.'){
                       toastr.error('This user name already exists.');
                       angular.element('#userName').focus();
                   }else{
                       toastr.error(response.message);
                   }
               } else {
                 if($rootScope.userRole=='ROLE_CUSTOMER'){
                   $state.go('account-settings.manage-sub-customer');
                 }else{
                   $state.go('account-settings.sub-customer');
                 }
                   toastr.error("Something went wrong please try again.");
               }
           });
        }
        $scope.goToSubCustomerPage=function(){
          if($rootScope.userRole=='ROLE_CUSTOMER'){
            $state.go('account-settings.manage-sub-customer');
          }else{
            $state.go('account-settings.sub-customer');
          }
        }
        $scope.success = function (text) {
           toastr.success(text+' Copied!');
         };

         $scope.fail = function (err) {
           toastr.error('Error!', err);
         };
         $scope.goBack=function() {
            window.history.back();
        }
        $scope.makeUserNameButtonClickable = function() {
            if ($rootScope.permissionArr.indexOf('edit_customer_user_name') !== -1) {
                $scope.disableUserNameField = false;
            }
        }
        $scope.initMakeUserNameButtonDisable = function() {
           $scope.disableUserNameField = true;
        }
      }
})();

/**
 * Roles controller handle all action related user roles permission.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 09.18.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.accountSettings')
    .controller('rolesCtrl', rolesCtrl);

  /** @ngInject */
  function rolesCtrl($scope, $rootScope, apiService, $uibModal, $cookies, $timeout, $state, $http, $location, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.22.2017
     */
    if($rootScope.permissionArr.indexOf('role_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }

    var vm = this;
    $rootScope.currentState='account-settings.roles';
    $scope.resetGlobalSearch();
    function renderRoleType(data,full,type){
      if(data=='ROLE_ADMIN'){
        return 'Admin';
      }else if(data=='ROLE_CUSTOMER'){
        return 'Customer';
      }else if(data=='ROLE_SUB_CUSTOMER'){
        return 'Sub Customer';
      }else if(data=='ROLE_OWNER'){
        return 'Owner';
      }else if(data=='ROLE_SUB_OWNER'){
        return 'Sub Owner';
      }else{
        return '';
      }
    }
    /**
     * Get data table method is use get list of roles.
     * created on 09.18.2017
     */
    $scope.getDataTable = function() {
      var vm = this;
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/roles',{params:{roletype:'ALL'}})
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.users = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'role_edit'+'\') !== -1" href="javascript:void(0);" ng-click="editRoles(\'' + value.id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var rolePermissionLinks = ' <a ng-if="permissionArr.indexOf(\''+'role_permission'+'\') !== -1" href="javascript:void(0);"  ng-click="rolePermissions(\'' + value.id + '\')" title="Role Permissions"><i class="fa fa-key fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'delete_permission_role'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/accountSettings/roles/deleteModal.html' + '\',\'' + value.id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
            var cloneLinks = '  <a ng-if="permissionArr.indexOf(\''+'clone_permission_role'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/accountSettings/roles/cloneModal.html' + '\',\'' + value.id + '\',' + changeStatusValTo + ')" title="Clone" ><i class="fa fa-clone fa-lg white"></i> </a>';
            var data = {
              id: value.id,
              name: value.name,
              roles:value.roles,
              index:index,
              created_at: value.created_at,
              updated_at: value.updated_at,
              operations: editLinks + '&nbsp;' + rolePermissionLinks + '&nbsp;' + deleteLinks + '&nbsp;' + cloneLinks //deleteLinks
            };
            this.push(data);
            ++index;
          }, vm.users);
          defer.resolve(vm.users);
        }).error(function (error) {
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Role Name'),
        DTColumnBuilder.newColumn('roles').withTitle('Role Type').renderWith(renderRoleType),
        DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
      ];
      if($rootScope.permissionArr.indexOf('role_edit') !== -1 || $rootScope.permissionArr.indexOf('role_permission') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

    /**
     * Add roles method is use for get add role.
     * created on 09.18.2017
     */
    $scope.addRoles = function() {
      $cookies.put('role-id',undefined);
      $state.go('account-settings.add-roles');
    }

    /**
     * Edit roles method is use for get edit role form.
     * created on 09.18.2017
     */
    $scope.editRoles = function(id) {
      $cookies.put('role-id',id);
      $state.go('account-settings.edit-roles');
    }

    /**
     * Open model.
     * created on 09.18.2017
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };

    /**
     * Clone role method is use for clone role.
     * created on 11.15.2021
     */

    $scope.cloneRole = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.post($rootScope.baseUrl + '/roles/clone/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Role cloned successfully.');
            $state.go($state.$current, null, {
              reload: true
            });;
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });  
      }   
    };

    /**
     * Delete role method is use for delete role.
     * created on 09.18.2017
     */
    $scope.deleteRole = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/roles/delete/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Role deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });;
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save roles data method is use for update/add role data.
     * created on 09.18.2017
     */
    $scope.saveRolesData = function() {
      var vm = this;
       if (!this.roleFrm.role.$valid) {
        toastr.error("Please enter role name.");
        angular.element('#role').focus();
        return;
      }else if (!this.roleFrm.roleType.$valid) {
       toastr.error("Please select role type.");
       angular.element('#roleType').focus();
       return;
     }
       apiService.loaderShow();
      var bodyData = {
        name: this.role,
        roles:this.roleType
      };
      $scope.saveUrl = $rootScope.baseUrl + '/roles/addrole';
      $scope.httpMethod = 'POST';
      $scope.editedId = this.userId;
      if (this.roleId) {
        $scope.saveUrl = $rootScope.baseUrl + '/roles/' + this.roleId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status == 'success') {
          toastr.success('Role ' + (vm.roleId ? 'updated' : 'Added') + ' successfully.');
          $state.go('account-settings.roles');
        } else {
          $state.go('account-settings.roles');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This role name already exists.');
                angular.element('#role').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('account-settings.roles');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited role method is use for get edited role data.
     * created on 09.18.2017
     */
    $scope.getEditedRole = function() {

        if($rootScope.permissionArr.indexOf('role_add') == -1 && $rootScope.permissionArr.indexOf('role_edit') == -1 && $rootScope.permissionArr.indexOf('role_permission') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('role-id') && $cookies.get('role-id')!= undefined) {
          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/roles/' + $cookies.get('role-id'))
            .success(function(response) {
              vm.role = response.name;
              vm.roleType=response.roles;
              vm.roleId = response.id;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('account-settings.add-roles');
        }
    };

    /**
     * Get role Permission method is use for go to role Permission page.
     * created on 09.19.2017
     */
    $scope.rolePermissions = function(id) {
      $cookies.put('role-id',id);
      $state.go('account-settings.roles-permission');
    };

    /**
     * Get Permission data method is use for get Permission list.
     * created on 09.19.2017
     */
    $scope.getPermissionData = function() {
      // select all
      $http.get($rootScope.baseUrl + '/roles/' + $cookies.get('role-id'))
        .success(function(response) {
          vm.allSelected=response.select_all==1?true:false;
        }).error(function (error) {
        });
      // get permission
      $scope.isloaded = false;
      var postData = {
        roleId: $cookies.get('role-id'),
      };
      if ($cookies.get('role-id') && $cookies.get('role-id')!= undefined) {
        var apiRoute = $rootScope.baseUrl + '/roles/permissions';
        var getPermission = apiService.addData(apiRoute, postData);
        getPermission.then(function(response) {
            vm.permissionData = response.data;
            //vm.allSelected=response.select_all==1?true:false;
            vm.newPermissionData=[];
            vm.largePermissionData=[];
            for(var i=0;i<response.data.length;i++){
              if(response.data[i].permission.length > 15){
                vm.newPermissionData.push({cat_name:response.data[i].cat_name,permission:response.data[i].permission});
              }
            }
            angular.forEach(vm.newPermissionData,function(val,key){
              $scope.setOfSets = _.toArray(_.groupBy(val.permission,function(item, index){
                  return Math.floor(index/3)
              }));
              vm.largePermissionData.push({cat_name:val.cat_name,permission:$scope.setOfSets});
            });
            $scope.isloaded = true;
          },
          function(error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
              $state.go('account-settings.roles');
              toastr.error("Something went wrong please try again.");
            }
            $scope.isloaded = true;
          });

      } else {
          $state.go('account-settings.roles');
        }
    }
    //vm.allSelected=false;
    $scope.CheckUncheckData=function(value){
      vm.allSelected = true;
      angular.forEach(vm.permissionData, function(cat) {
        angular.forEach(cat.permission, function(permis) {
          if(!permis.perm_checked){
            vm.allSelected = false;
            return;
          }
        })
      });
    }
    $scope.CheckUncheckAll = function (all) {
      angular.forEach(vm.permissionData, function(cat) {
        angular.forEach(cat.permission, function(permis) {
          permis.perm_checked=vm.allSelected;
        })
      });
    };
    /**
     * Add Permission method is use for add Permission.
     * created on 09.19.2017
     */
    $scope.addPermissions = function() {
      var permId = [];
      apiService.loaderShow();
      // angular.forEach($("input[type='checkbox']:checked"), function(permis) {
      //   if(permis.value!='on'){
      //     permId.push(permis.value);
      //   }
      // });
      angular.forEach(vm.permissionData, function(cat) {
        angular.forEach(cat.permission, function(permis) {
          if(permis.perm_checked==true){
            permId.push(permis.perm_id);
          }
        })
      });

      var postData = {
        group_id: $cookies.get('role-id'),
        permission: JSON.stringify(permId),
        select_all:vm.allSelected==true?1:0
      };
      var apiRoute = $rootScope.baseUrl + '/roles/updatepermissions';
      var addPermission = apiService.addData(apiRoute, postData);
      addPermission.then(function(response) {
          $state.go('account-settings.roles');
          toastr.success(response.data.message);
          apiService.loaderHide();
        },
        function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
              $state.go('account-settings.roles');
              toastr.error("Something went wrong please try again.");
            }
        });
    }
  }

})();

/**
 * Users controller handle all action related users.
 * @author nikunj silvercayde <nikunj@silvercayde.com>
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.accountSettings')
            .controller('subCustomersCtrl', subCustomersCtrl);

    /** @ngInject */
    function subCustomersCtrl($scope, $cookies, $q, $http, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $state, $timeout, $uibModal) {
        var vm = this;

        /**
         * permissionArr is use to check permission to display list
         * created on 09.22.2017
         */
        if ($rootScope.permissionArr.indexOf('subowners_list_owner') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState = 'account-settings.owner-customers';

        /**
         * getDataTable method is use to get list of customer
         */
        $scope.getDataTable = function ()
        {
            var vm = this;

            var id = $rootScope.globals.currentUser.id;

            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function ()
            {
                var defer = $q.defer();
                
                $http.get($rootScope.baseUrl + '/owner/sub/index/'+id)
                .success(function (result)
                {
                    if (result.length < $rootScope.numberOfRecord) {
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                        }, 200);
                    }
                    vm.users = [];
                    var index = 1;
                    angular.forEach(result, function (value, key)
                    {
                        var editLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_subowner_account_owner' + '\') !== -1" href="javascript:void(0);"  ng-click="editSubOwner(\'' + value.id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';

                        var changeStatusValTo = '0';
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                        var statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_subowner_account_owner' + '\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/subcustomers/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        
                        if (value.status == 0)
                        {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_subowner_account_owner' + '\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/subcustomers/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                        }
                        var data = {
                            id: value.id,
                            index: index,
                            name: value.name,
                            email: value.email,
                            firstname: value.firstname,
                            lastname: value.lastname,
                            status: statusBadge,
                            created_at: value.created_at,
                            operations: editLinks + '&nbsp;' + statusLinks
                        };
                        this.push(data);
                        index++;
                    }, vm.users);
                    defer.resolve(vm.users);
                }).error(function (error)
                {
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $scope.$apply($compile(nRow)($scope));
                });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord - 1));
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage', {"sSearch": "", 'sInfoFiltered': '(filtered from _MAX_ total entries)'}).withOption('order', [1, 'asc']);
            vm.dtColumns = [
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('name').withTitle('User Name'),
                DTColumnBuilder.newColumn('firstname').withTitle('First Name'),
                DTColumnBuilder.newColumn('lastname').withTitle('Last Name'),
                DTColumnBuilder.newColumn('email').withTitle('Email Id'),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        $scope.open = function (page, id, status)
        {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        $scope.changeStatus = function ()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status: "" + $rootScope.status + ""
                };
                $http.put($rootScope.baseUrl + '/subcustomer', bodyData)
                .success(function (result) {
                    if (result.status == 'success') {
                        toastr.success('Status updated successfully.');
                        $state.go($state.$current, null, {reload: true});
                    } else {
                        toastr.error(result.message);
                    }
                    apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };

        /**
         * add new Sub Owner
        */
        $scope.addSubOwner = function ()
        {
            $cookies.put('subowner-id', undefined);
            $state.go('account-settings.add-owner-customer');
        };

        /**
         * edit Sub Owner
        */
        $scope.editSubOwner = function (id)
        {
            $cookies.put('subowner-id', id);
            $state.go('account-settings.edit-owner-customer');
        };

        $scope.goBack = function () {
            window.history.back();
        };

        /**
         * Save customer data method is use for update customer data.
         * created on 09.15.2017
         */
        $scope.saveOwnerData = function () {
            if (!this.customerFrm.firstname.$valid) {
                toastr.error("Please enter first name.");
                angular.element('#firstname').focus();
                return;
            } else if (!this.customerFrm.lastname.$valid) {
                toastr.error("Please enter last name.");
                angular.element('#lastname').focus();
                return;
            } else if (!this.customerFrm.userName.$valid) {
                toastr.error("Please enter user name.");
                angular.element('#userName').focus();
                return;
            } else if (!this.customerFrm.email.$valid) {
                toastr.error("Please enter email.");
                angular.element('#email').focus();
                return;
            } else if (!this.customerFrm.password.$valid && (vm.customerId == undefined || vm.customerId == 'undefined')) {
                toastr.error("Please enter password.");
                angular.element('#password').focus();
                return;
            } else if (!this.customerFrm.newPassword.$valid && (vm.customerId == undefined || vm.customerId == 'undefined')) {
                toastr.error("Please enter confirm password.");
                angular.element('#newPassword').focus();
                return;
            } else if (vm.password != '' && vm.password != vm.newPassword) {
                toastr.error("Confirm password should be same as password.");
                angular.element('#newPassword').focus();
                return;
            } else if (!this.customerFrm.role.$valid) {
                toastr.error("Please select role.");
                angular.element('#role').focus();
                return;
            } else if (!this.customerFrm.status.$valid) {
                toastr.error("Please select status.");
                angular.element('#status').focus();
                return;
            }

            var id = $rootScope.globals.currentUser.id;
            
            apiService.loaderShow();
            var bodyData = {
                "owner_id": id,
                "is_manager": "0",
                "user_name": vm.userName,
                "email": vm.email,
                "first_name": vm.firstname,
                "last_name": vm.lastname,
                "gender": vm.gender,
                "role": vm.role,
                "status": vm.status,
                "password": (vm.password ? vm.password : ''),
                "priority": vm.shippingPriority ? vm.shippingPriority : '1',
                "magento_version": 'm1',
                "customer_group": 'General'
            };
            $scope.saveUrl = $rootScope.baseUrl + '/owner/sub/store';
            $scope.httpMethod = 'POST';
            $scope.editedId = vm.customerId;
            if (vm.customerId) {
                $scope.saveUrl = $rootScope.baseUrl + '/owner/sub/update/' + vm.customerId;
                $scope.httpMethod = 'POST';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    var owerUserIdForPermission = response.data.user_id;
                    toastr.success('Sub Owner ' + ($scope.editedId ? 'updated' : 'Added') + ' successfully.');
                    $scope.addPermissions(owerUserIdForPermission, vm.role);
                } else {
                    toastr.error(response.data.message);
                }
                window.history.back();
            }, function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code == 0) {
                    if (response.message == 'The email has already been taken.') {
                        toastr.error(response.message);
                        angular.element('#email').focus();
                    } else if (response.message == 'The name has already been taken.') {
                        toastr.error('This user name already exists.');
                        angular.element('#userName').focus();
                    } else {
                        toastr.error(response.message);
                    }
                } else {
                    window.history.back();
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * getEditedUser method is use for edited customer
         * created on 09.10.2017
         */
        $scope.getEditedSubOwner = function () {
            $cookies.put('role-id', undefined);
            if ($rootScope.permissionArr.indexOf('edit_subowner_account_owner') == -1) {
                $state.go('dashboard');
                toastr.error("You don't have permission to do this.");
            }
            if ($cookies.get('subowner-id') && $cookies.get('subowner-id') != undefined) {
                apiService.loaderShow();
                $http.get($rootScope.baseUrl + '/owner/sub/show/' + $cookies.get('subowner-id'))
                        .success(function (response) {
                            if (response.status == 'success') {
                                response = response.data;
                                vm.owner_id = response.parent_id;
                                vm.customerId = response.id;
                                vm.userName = response.name;
                                vm.customerUName = response.name;
                                vm.email = response.email;
                                vm.mobile = response.mobile;
                                vm.gender = response.gender;
                                vm.firstname = response.firstname;
                                vm.lastname = response.lastname;
                                vm.role = '' + response.role + '';
                                vm.status = response.status;
                                vm.isAvailable = '' + response.dashboard_display + '';
                                //vm.displayname= response.customer_name;
                                vm.displayname = response.display_name;
                                vm.positionId = response.position_id;
                                vm.binId = response.bin_id;
                                vm.shippingPriority = '' + response.priority + '';
                                vm.customerToken = response.customer_token;
                                vm.customerSyncType = response.is_sync;
                                vm.customerGroup = response.relay_customer_group;
                                $cookies.put('role-id', response.role);
                                console.log(response.id);
                                console.log(response.role);
                                console.log(response.parent_id);
                                $scope.getPermissionData(response.id, response.role, response.parent_id);
                            }
                            apiService.loaderHide();
                        }).error(function (response) {
                    apiService.loaderHide();
                    toastr.error("Something went wrong please try again.");
                });
            } else {
                $state.go('account-settings.add-owner-customer');
            }
        };

        $scope.getPermissionDataForCreateSubOwner = function () {
            if ($cookies.get('subowner-id') && $cookies.get('subowner-id') != undefined) {
            } else {
                $scope.getPermissionData('', '');
            }
        };

        $scope.getPermissionData = function (userId, roleId, owner_id) {
            console.log(userId);
            console.log(roleId);
            console.log(owner_id);
            $scope.isloaded = false;
            var postData = {
                role_id: roleId,
                user_id: userId,
                owner_id: owner_id
            };
            var apiRoute = $rootScope.baseUrl + '/roles/permissions-sub-owner';
            var getPermission = apiService.addData(apiRoute, postData);
            getPermission.then(function (response) {
                vm.permissionData = response.data;
                vm.newPermissionData = [];
                vm.largePermissionData = [];
                for (var i = 0; i < response.data.length; i++) {
                    if (response.data[i].permission.length > 15) {
                        vm.newPermissionData.push({cat_name: response.data[i].cat_name, permission: response.data[i].permission});
                    }
                }
                angular.forEach(vm.newPermissionData, function (val, key) {
                    $scope.setOfSets = _.toArray(_.groupBy(val.permission, function (item, index) {
                        return Math.floor(index / 3);
                    }));
                    vm.largePermissionData.push({cat_name: val.cat_name, permission: $scope.setOfSets});
                });
                $scope.isloaded = true;
            },
            function (error) {
                $scope.isloaded = true;
            });
        };

        $scope.addPermissions = function (userId, groupId) {
            var permId = [];
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (permis.perm_checked == true) {
                        permId.push(permis.perm_id);
                    }
                });
            });
            var postData = {
                //group_id: $cookies.get('role-id'),
                group_id: groupId,
                user_id: userId,
                permission: JSON.stringify(permId),
                select_all: vm.allSelected == true ? 1 : 0
            };
            var apiRoute = $rootScope.baseUrl + '/roles/updateownerpermissions';
            var addPermission = apiService.addData(apiRoute, postData);
            addPermission.then(function (response) {},
                    function (error) {});
        };
        
        $scope.CheckUncheckData = function(value) {
            vm.allSelected = true;
            angular.forEach(vm.permissionData, function (cat) {
                angular.forEach(cat.permission, function (permis) {
                    if (!permis.perm_checked) {
                        vm.allSelected = false;
                        return;
                    }
                });
            });
        };

        $scope.getCustomerRoles = function () {
            $http.get($rootScope.baseUrl + '/roles', {params: {roletype: 'ROLE_SUB_OWNER'}})
                    .success(function (response) {
                        $scope.customerRoleList = response;
                    }).error(function (response) {
            });
        };
    }
})();
/**
 * Users controller handle all action related users.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 10.15.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.accountSettings')
            .controller('usersCtrl', usersCtrl);

    /** @ngInject */
    function usersCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService,  $q) {

        /**
        * permissionArr is use to check permission to display list
        * created on 09.22.2017
        */
        if($rootScope.permissionArr.indexOf('sub_admin_list') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='account-settings.sub-admin';
        $scope.resetGlobalSearch();
        $scope.editedUserId = $cookies.get('sub-admin-id');
         /**
         * Get data of roles dropdown.
         * created on 09.15.2017
         */
        $scope.standardSelectItems = [
          {value: '', label: 'Select Role'},
        ];
        $http.get($rootScope.baseUrl + '/roles',{params:{roletype:'ROLE_ADMIN'}})
            .success(function (response) {
            angular.forEach(response, function (value, key) {
                $scope.standardSelectItems.push({value:value.id, label: value.name})
            });
        }).error(function (response) {
//            toastr.error("Something went wrong please try again.");
        });


        /**
         * Get data table method is use get list of users.
         * created on 09.15.2017
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/sub-admin')
                        .success(function (result) {
                           if(result.length < $rootScope.numberOfRecord){
                               $timeout(function () {
                                   angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                    vm.users = [];
                    var index = 1;
                    angular.forEach(result, function (value, key) {

                        var changeStatusValTo = '0';
                        var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_admin_edit'+'\') !== -1" href="javascript:void(0);" ng-click="editUser(\'' + value.id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'sub_admin_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/accountSettings/users/deleteModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                        var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_admin_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/users/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';

                        if (value.status == 0) {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'sub_admin_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/accountSettings/users/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                        }

                        var data = {
                            id: value.id,
                            index:index,
                            name: value.name,
                            email: value.email,
                            mobile: value.mobile,
                            status: statusBadge,
                            gender: value.gender,
                            role: value.role,
                            firstname: value.firstname,
                            created_at: value.created_at,
                            lastname: value.lastname,
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                        };
                        this.push(data);
                        index++;
                    }, vm.users);
                    defer.resolve(vm.users);
                }).error(function (error) {
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers');
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                         $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            }).withOption('order', [1, 'desc']);

            vm.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('name').withTitle('User Name'),
                DTColumnBuilder.newColumn('firstname').withTitle('First Name'),
                DTColumnBuilder.newColumn('lastname').withTitle('Last Name'),
                DTColumnBuilder.newColumn('email').withTitle('Email Id'),
                DTColumnBuilder.newColumn('role').withTitle('User Role'),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if($rootScope.permissionArr.indexOf('sub_admin_edit') !== -1 || $rootScope.permissionArr.indexOf('sub_admin_delete') !== -1 || $rootScope.permissionArr.indexOf('sub_admin_changestatus') !== -1){
              vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        }

        /**
         * Save user data method is use for update/add user data.
         * created on 09.15.2017
         */
        $scope.saveUserData = function () {

            var role = angular.element('.roleData').val();
            var designation = angular.element('.desigData').val();
            if (!this.userFrm.$valid) {
                return;
            }
            apiService.loaderShow();
            var bodyData = {
                name: this.userName,
                mobile: this.mobile,
                email: this.email,
                firstname: this.firstname,
                lastname: this.lastname,
                gender: this.gender,
                role:  role,
                designation:this.designation,
                status: this.status,
                password: (this.password?this.password:'')
            };
            $scope.saveUrl = $rootScope.baseUrl + '/sub-admin';
            $scope.httpMethod = 'POST';
            $scope.editedId = this.usereditId;
            if (this.usereditId) {
                $scope.saveUrl = $rootScope.baseUrl + '/sub-admin/' + this.usereditId;
                $scope.httpMethod = 'PUT';
            }

            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    toastr.success('Sub admin ' + ($scope.editedId ? 'updated' : 'Added') + ' successfully.');
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                $state.go('account-settings.sub-admin');
            }, function (response) {

                apiService.loaderHide();
//                if(!response.data){
//                  $state.go('account-settings.sub-admin');
//                  toastr.error("Something went wrong please try again.");
//                }
                var response = response.data;
                if (response.code == 0) {
                    if(response.message == 'The email has already been taken.'){
                        toastr.error(response.message);
                        angular.element('#email').focus();
                    }else if(response.message == 'The name has already been taken.'){
                        toastr.error('This user name already exists.');
                        angular.element('#userName').focus();
                    }else{
                        toastr.error(response.message);
                    }
                } else {
                    $state.go('account-settings.sub-admin');
                    toastr.error("Something went wrong please try again.");
                }
            });

        }

        /**
         * Add user method is use for get add user form.
         * created on 09.15.2017
         */
        $scope.addUser = function () {
            $cookies.put('sub-admin-id',undefined);
            $state.go('account-settings.add-sub-admin');
        }

        /**
         * Edit user method is use for get edit user form.
         * created on 09.15.2017
         */
        $scope.editUser = function (id) {
            $cookies.put('sub-admin-id',id);
            $state.go('account-settings.edit-sub-admin');
        }

        /**
         * Open model.
         * created on 09.15.2017
         */
        $scope.open = function (page, id, status) {
            $rootScope.statusId = id;
            $rootScope.status = status;

            $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: page,
              scope:$scope,
            });
        };

        /**
         * Change status method is use for change status of user.
         * created on 09.15.2017
         */
        $scope.changeStatus = function () {
            if($rootScope.statusId){
                apiService.loaderShow();
                  var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status
                  };
                  $http.put($rootScope.baseUrl + '/sub-admin', bodyData)
                          .success(function (result) {
                        if (result.status == 'success') {
                            toastr.success('Status updated successfully.');
                             $state.go($state.$current, null, { reload: true });
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        apiService.loaderHide();
                  }).error(function (error) {
                        apiService.loaderHide();
                        if (error.code != undefined && error.code == 0) {
                            toastr.error(error.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                     });
                  $scope.popupShow.close();

             }
        };

        /**
         * Delete user method is use for delete user.
         * created on 09.15.2017
         */
        $scope.deleteUser = function () {
            if($rootScope.statusId){
                  apiService.loaderShow();
                  $http.delete($rootScope.baseUrl + '/sub-admin/'+$rootScope.statusId)
                     .success(function (result) {
                        if (result.status == 'success') {
                            toastr.success('Sub admin deleted successfully.');
                            $state.go($state.$current, null, { reload: true });;
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        apiService.loaderHide();
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.code != undefined && error.code == 0) {
                            toastr.error(error.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                    });
             }
             $scope.popupShow.close();
        };

        /**
         * Get edited user method is use for get edited user data.
         * created on 09.15.2017
         */
        $scope.getEditedUser = function () {

            if($rootScope.permissionArr.indexOf('sub_admin_add') == -1 && $rootScope.permissionArr.indexOf('sub_admin_edit') == -1){
              $state.go('dashboard');
              toastr.error("You don't have permission to do this.");
            }

            if ($cookies.get('sub-admin-id') && $cookies.get('sub-admin-id')!= undefined) {
                apiService.loaderShow();
                var vm = this;
                $http.get($rootScope.baseUrl + '/sub-admin/' + $cookies.get('sub-admin-id'))
                        .success(function (response) {
                            vm.usereditId = response.id;
                            vm.userName = response.name;
                            vm.email = response.email;
                            vm.mobile = response.mobile;
                            vm.role = response.role;
                            $scope.selected = ''+response.role+'';
                            vm.designation = response.designation?response.designation:'';
                            vm.gender = response.gender;
                            vm.firstname = response.firstname;
                            vm.lastname = response.lastname;
                            vm.status = response.status;
                            vm.database_job_id = response.database_job_id;
                            apiService.loaderHide();
                        }).error(function (error) {
                            apiService.loaderHide();
                            if (error.code != undefined && error.code == 0) {
                                toastr.error(error.message);
                            } else {
                                toastr.error("Something went wrong please try again.");
                            }
                            $state.go('account-settings.add-sub-admin');
                        });
            }else{
               $state.go('account-settings.add-sub-admin');
            }
            $scope.selected = '';
        };

        $scope.downloadBarcode = function ()
        {
            if ($cookies.get('sub-admin-id') && $cookies.get('sub-admin-id')!= undefined)
            {
                var id = $cookies.get('sub-admin-id');
                var urdd = $rootScope.baseUrl + '/user/download-barcode/'+id
                $http.get(urdd,
                {
                     responseType: "arraybuffer"
                }).success(function(response,st,headers,con) {
                    if(headers('Content-Type') == 'application/pdf'){
                        var blob = new Blob([response]);
                        var link=document.createElement('a');
                        link.href=window.URL.createObjectURL(blob);
                        var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                        link.download=fileName+"_user_barcode_"+id+".pdf";
                        link.click();
                    }else{
                        toastr.error('Something went wrong !');
                    }
                }).error(function(error) {
                    toastr.error('Something went wrong !');
                });
            }else{
               $state.go('account-settings.sub-admin');
            }
        }

        $scope.UserBarcodes = function ()
        {
            var urdd = $rootScope.baseUrl + '/user/download/barcodes';
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download="user_barcodes.pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }
    }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.databaseMachines')
            .controller('databaseJobsCtrl', databaseJobsCtrl);

    /** @ngInject */
    function databaseJobsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {

    	if($rootScope.permissionArr.indexOf('manage_database_jobs') == -1)
	    {
	        $state.go('dashboard');
	    	toastr.error("You don't have permission to do this.");
	    }

	    $rootScope.currentState='databasemachines.databasejobs';
	    $scope.machineTitle="Database Jobs";

        $scope.resetGlobalSearch();

	    var vm = this;
        vm.totalTime=0;
        vm.orderNumber='';
        vm.Crystal='';
        vm.showDone = 0;

	    $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);


        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        if(!$rootScope.datePickerDoneReports) {
          $rootScope.datePickerDoneReports = {};
          $rootScope.datePickerDoneReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 11.02.2021
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        $scope.options2 = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options2,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerDoneReports.date.startDate = moment($scope.datePickerDoneReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerDoneReports.date.endDate = moment($scope.datePickerDoneReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerDoneReports.date = $scope.datePickerDoneReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusDoneInput=function(){
          angular.element('#dateDoneRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function (){
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $rootScope.datePickerDoneReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerDoneReports.date = $scope.datePickerDoneReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Render TotalTime split data and get total time.
        * Created on 11.11.2017
        */
        function renderTotalTime(data){
            var temp = data.split('::');
            return temp[3];
        }

        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/database/jobs',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    orderNumber: vm.orderNumber?vm.orderNumber:'',
                    crystal: vm.Crystal?vm.Crystal:'',
                    showDone: vm.showDone?vm.showDone:0,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    done_from_date:$scope.datePickerDoneReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerDoneReports.date.startDate):'',
                    done_to_date:$scope.datePickerDoneReports.date.endDate?$scope.saveToDateFormat($scope.datePickerDoneReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                vm.totalTime = result.data.totalTime;
                var result = result.data.data.original;
                angular.element('.time-class span span').html(vm.totalTime);
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
         * showCreateLabel method is used for show Crete Label button.
         * created on 13.08.2020
         */
        $scope.showDoneDates = function(event)
        {
            var totalCheckbox=angular.element('#chk');
            var checked=angular.element('#chk:checked:not(.itilecheck)');
            var totalChkRdo=totalCheckbox.length-1;
            if(totalCheckbox.length==checked.length){
                vm.showDone = 1;
            }
            else {
                vm.showDone = 0;
            }
        }
        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('datecreate_dat').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('ordernr_txt').withTitle('Order Number').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('glas_txt').withTitle('Crystal').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('slot_txt').withTitle('Slot').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status_txt').withTitle('Status').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('unit_txt').withTitle('Machine').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('dateslot_dat').withTitle('Slot Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('datedone_dat').withTitle('Done Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('timeengrave_tim').withTitle('Engraving Time').withOption('className', 'text-center'));

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Time: <span></span>',
                    className: 'btn btn-success time-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
	}
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.dubaiMachines')
            .controller('dubaiJobsCtrl', dubaiJobsCtrl);

    /** @ngInject */
    function dubaiJobsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {

    	if($rootScope.permissionArr.indexOf('manage_database_jobs') == -1)
	    {
	        $state.go('dashboard');
	    	toastr.error("You don't have permission to do this.");
	    }

	    $rootScope.currentState='dubaimachines.dubaijobs';
	    $scope.machineTitle="Dubai Jobs";

        $scope.resetGlobalSearch();

	    var vm = this;
        vm.totalTime=0;
        vm.orderNumber='';
        vm.Crystal='';
        vm.showDone = 0;

	    $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);


        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        if(!$rootScope.datePickerDoneReports) {
          $rootScope.datePickerDoneReports = {};
          $rootScope.datePickerDoneReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 11.02.2021
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        $scope.options2 = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options2,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerDoneReports.date.startDate = moment($scope.datePickerDoneReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerDoneReports.date.endDate = moment($scope.datePickerDoneReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerDoneReports.date = $scope.datePickerDoneReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusDoneInput=function(){
          angular.element('#dateDoneRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function (){
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $rootScope.datePickerDoneReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerDoneReports.date = $scope.datePickerDoneReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Render TotalTime split data and get total time.
        * Created on 11.11.2017
        */
        function renderTotalTime(data){
            var temp = data.split('::');
            return temp[3];
        }

        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/dubai/jobs',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    orderNumber: vm.orderNumber?vm.orderNumber:'',
                    crystal: vm.Crystal?vm.Crystal:'',
                    showDone: vm.showDone?vm.showDone:0,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    done_from_date:$scope.datePickerDoneReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerDoneReports.date.startDate):'',
                    done_to_date:$scope.datePickerDoneReports.date.endDate?$scope.saveToDateFormat($scope.datePickerDoneReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                vm.totalTime = result.data.totalTime;
                var result = result.data.data.original;
                angular.element('.time-class span span').html(vm.totalTime);
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
         * showCreateLabel method is used for show Crete Label button.
         * created on 13.08.2020
         */
        $scope.showDoneDates = function(event)
        {
            var totalCheckbox=angular.element('#chk');
            var checked=angular.element('#chk:checked:not(.itilecheck)');
            var totalChkRdo=totalCheckbox.length-1;
            if(totalCheckbox.length==checked.length){
                vm.showDone = 1;
            }
            else {
                vm.showDone = 0;
            }
        }
        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('datecreate_dat').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('ordernr_txt').withTitle('Order Number').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('glas_txt').withTitle('Crystal').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('slot_txt').withTitle('Slot').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status_txt').withTitle('Status').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('unit_txt').withTitle('Machine').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('dateslot_dat').withTitle('Slot Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('datedone_dat').withTitle('Done Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('timeengrave_tim').withTitle('Engraving Time').withOption('className', 'text-center'));

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Time: <span></span>',
                    className: 'btn btn-success time-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
	}
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.inventoryManagement')
    .controller('inventorySettingsCtrl', inventorySettingsCtrl);

  /** @ngInject */
  function inventorySettingsCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout)
  {
    /**
     * permissionArr is use to check permission to display list
     * created on 14.02.2020
    */
    if ($rootScope.permissionArr.indexOf('inventory_settings') == -1)
    {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    
    var vm = this;
    $rootScope.currentState = 'inventorymanagement.inventory-settings';
    

    /**
     * menuStatus is use to default open accordion
     * created on 14.02.2020
     */
    $scope.oneAtATime = false;
    $scope.isOpenObject = {};
    $scope.menuStatus = [{
      isOpen: true
    }];

    

    vm.allocateStatus=[];
    vm.removeStatus=[];
    vm.removeAllocationStatus=[];
    vm.minQty = 1;
    vm.emailFrom = '';
    vm.emailTo = '';
    vm.availableEmails=[];
    vm.defCost = 0;
    vm.store_costs = [];

    $scope.orderStatus = [];
    $scope.getActiveStatus = function()
    {
      $http.post($rootScope.baseUrl + '/status/activeAll')
      .success(function(result) {
        $scope.orderStatus = result;
      })
      .error(function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    };

    $scope.getSettingData = function()
    {
      $http.get($rootScope.baseUrl + '/config/inventorySetting')
      .success(function(result)
      {
        if (result.status == 'fail') {
          toastr.error(result.message);
        }
        else
        {
          var resultData = result.data;
          var inventorySetting = resultData.inventory_settings;
          vm.allocateStatus = inventorySetting.allocateStatus;
          vm.removeStatus = inventorySetting.removeStatus;
          vm.removeAllocationStatus = inventorySetting.removeAllocationStatus;
          vm.minQty = inventorySetting.minimum_qty;
          vm.emailFrom = inventorySetting.email_from;
          vm.emailTo = JSON.parse(inventorySetting.email_to);
          vm.defCost = inventorySetting.default_cost;
        }
      })
      .error(function(error)
      {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });

      $http.get($rootScope.baseUrl + '/config/inventorySetting/store-cost')
      .success(function(response) {
        if(response.status == 'success') {
          vm.store_costs = response.store_costs;
        }
      }).error(function (error) {
        if (error.data && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };

    $scope.changedefault = function(index,stid,val)
      {
        var store_costs = [];
        angular.forEach(vm.store_costs, function(value, key)
        {
          if(key == index) {
            value.inventory_cost = vm.defCost;
            value.default_value = val;
          }
        }, store_costs);
      };

    $scope.saveSetting=function()
    {
      if(!this.settingForm.$valid){
        return;
      }
      $scope.storeSettings={
          'store_costs':vm.store_costs
        };

      $scope.inventorySettingData = {
        'inventory_settings':{
          'allocateStatus':vm.allocateStatus,
          'removeStatus':vm.removeStatus,
          'removeAllocationStatus':vm.removeAllocationStatus,
          'minimum_qty': vm.minQty,
          'email_from': vm.emailFrom,
          'email_to': JSON.stringify(vm.emailTo),
          'default_cost':  vm.defCost,
          'store_costs':angular.toJson($scope.storeSettings)
        }
      };
      apiService.loaderShow();
      var bodyData = {
        type: 'inventorySetting',
        sticker_data: angular.toJson($scope.inventorySettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };

      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

      $http.get($rootScope.baseUrl + '/config/inventorySetting/store-cost')
      .success(function(response) {
        if(response.status == 'success') {
          vm.store_costs = response.store_costs;
        }
      }).error(function (error) {
        if (error.data && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };
  } 
})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventoryManagement')
            .controller('inventoryProductsCtrl', inventoryProductsCtrl);

    /** @ngInject */
    function inventoryProductsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
        /**
        * permissionArr is use to check permission to display list inventory products
        * created on 03.06.2020
        */
        if($rootScope.permissionArr.indexOf('inventory_products') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='inventorymanagement.invntoryproducts';
        $scope.productTitle="Add Product";
        $scope.wareHouses=[];
        
        $scope.availableSKU=[];
        $scope.menuStatus = [{
	      isOpen: true
	    }];

	    var ip = this;
	    ip.addqty = '';
      	ip.addbox = '';
      	ip.addsqty = '';
      	ip.addnote = 'Test';
        ip.description = '';
        ip.name = '';
        ip.hscode = '';
        ip.cost = '';
        ip.weight = '';
        ip.length = '';
        ip.width = '';
        ip.height = '';
        ip.itemtype = '';
        ip.crystalcode = '';
        ip.crystalsize = '';
        ip.identification = '';
        ip.addonproduct = '';
        ip.barcode = '';
	    
	    /**
         * Get data table method is use get list of inventory products.
         * created on 03.06.2020
         */
        $scope.getDataTable = function ()
        {
            var ip = this;
            ip.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
            	var defer = $q.defer();
            	$http.get($rootScope.baseUrl + '/inventory/products')
            	.success(function(result)
            	{
            		if(result.length < $rootScope.numberOfRecord)
            		{
                    	$timeout(function () {
                    		angular.element('.dataTables_paginate').hide();
                    	}, 200);
                    }
            		ip.products = [];
              		var index = 1 ;
              		angular.forEach(result, function(value, key)
              		{
              			var changeStatusValTo = 0;
                		
                		var editLinks = '';
                		if($rootScope.permissionArr.indexOf('inventory_product_edit') != -1){
                		editLinks = ' <a href="javascript:void(0);"  ng-click="editProduct(\'' + value.product_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                		}
                		
                		var deleteLinks = '';
                		if($rootScope.permissionArr.indexOf('inventory_product_delete') != -1){
                			deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/inventoryManagement/inventoryProducts/deleteModal.html' + '\',\'' + value.product_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                		}
                		
                		var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';

                		var statusLinks = '';
                		if($rootScope.permissionArr.indexOf('inventory_product_status_change') != -1){
                		statusLinks = ' <a ng-click="open(\'' + 'app/pages/inventoryManagement/inventoryProducts/statusModal.html' + '\',\'' + value.product_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                		}

                		var reportLinks = '';
                		if($rootScope.permissionArr.indexOf('inventory_product_warehoues') != -1){
                			reportLinks = ' <a ng-click="viewProductWarehouses(' + value.product_id + ')" href="javascript:void(0);" title="Warehouses"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></a>';
                		}

                		var logLinks = '';
                		if($rootScope.permissionArr.indexOf('inventory_product_allocation_log') != -1){
                		logLinks = ' <a ng-click="openLogHistory('+value.product_id+')" href="javascript:void(0);" title="Allocation Log"><i class="fa fa-question-circle" style="color:#fff;" aria-hidden="true"></i></a>';
                		}

                		var logRemoveLinks = '';
                		if($rootScope.permissionArr.indexOf('inventory_product_allocation_remove_log') != -1){
                		logRemoveLinks = ' <a ng-click="openRemoveLogHistory('+value.product_id+')" href="javascript:void(0);" title="Remove Allocation Log"><i class="fa fa-question-circle" style="color:#fff;" aria-hidden="true"></i></a>';
                		}

                		var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                		var statusLinks = '';
                		if ($rootScope.permissionArr.indexOf('inventory_product_status_change') != -1) {
                		statusLinks = ' <a ng-click="open(\'' + 'app/pages/inventoryManagement/inventoryProducts/statusModal.html' + '\',\'' + value.product_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                		}
                		
                		if (value.status == 0)
                		{
                			changeStatusValTo = '1';
                			statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                			if ($rootScope.permissionArr.indexOf('inventory_product_status_change') != -1) {
                			statusLinks = ' <a ng-click="open(\'' + 'app/pages/inventoryManagement/inventoryProducts/statusModal.html' + '\',\'' + value.product_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                			}
                		}

                		var minQtyButton = '';
                		if(value.min_qty > 0 && value.available <= value.min_qty) {
                			minQtyButton = '<a href="javascript:void(0);" title="Stock Level Is Low" class="btn btn-danger font-size-14 margin-inline">'+value.min_qty+'</a>';
                		}
                		else if(value.min_qty > 0 && value.available > value.min_qty) {
                			minQtyButton = '<a href="javascript:void(0);" title="Stock Level Is OK" class="btn btn-success font-size-14 margin-inline">'+value.min_qty+'</a>';
                		}
                		else if(value.min_qty <= 0 && value.available > 0) {
                			minQtyButton = '<a href="javascript:void(0);" title="Stock Level Is OK" class="btn btn-success font-size-14 margin-inline">'+value.min_qty+'</a>';	
                		}
                		else if(value.min_qty <= 0 && value.available <= 0) {
                			minQtyButton = '<a href="javascript:void(0);" title="Stock Level Is Low" class="btn btn-danger font-size-14 margin-inline">'+value.min_qty+'</a>';
                		}
                        
                        if($rootScope.permissionArr.indexOf('show_product_type_'+value.itemtype) != -1)
                        {
                    		var data = {
                    			index:index,
                    			id: value.product_id,
                    			name: value.name,
                    			min_qty_alert:minQtyButton,
                    			stock: value.stock,
                    			allocated: value.allocated,
                    			available: value.available,
                                on_the_way: value.on_the_way,
                                in_process: value.in_process,
                    			created_at: value.created_at,
                    			updated_at: value.updated_at,
                    			status:statusBadge,
                    			operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + reportLinks + '&nbsp;' + logLinks + '&nbsp;' + logRemoveLinks
                    		};
                    		this.push(data);
                    		++index;
                        }
                	}, ip.products);
                	defer.resolve(ip.products);
                })
                .error(function (error)
                {
                	if (error.data.code != undefined && error.data.code == 0) {
                		toastr.error(error.data.message);
                	} else {
                		toastr.error("Something went wrong please try again.");
                	}
                });
            	return defer.promise;
          	})
          	.withPaginationType('simple_numbers')
          	ip.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          	ip.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            	$scope.$apply($compile(nRow)($scope));
            });
            ip.dtOptions.withOption('sDom', $rootScope.dom);
            ip.dtOptions.withOption('initComplete', function()
            {
            	angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            	angular.element('.dataTables_filter input').attr('class', 'form-control');
            	angular.element('.dataTables_length select').attr('class', 'form-control');
         	});
          	ip.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          	ip.dtColumns = [
            	DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            	DTColumnBuilder.newColumn('index').withTitle('Sr.No')
            ];

            if ($rootScope.permissionArr.indexOf('inventory_product_name') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name').renderWith($scope.UcCap));
        	}
            if ($rootScope.permissionArr.indexOf('inventory_product_total_stock') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('stock').withTitle('Total Stock').withOption('className', 'text-center'));
           	}
            if ($rootScope.permissionArr.indexOf('inventory_product_total_allocated') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('allocated').withTitle('Total Allocated').withOption('className', 'text-center'));
           	}
            if ($rootScope.permissionArr.indexOf('inventory_product_total_available') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('available').withTitle('Total Available').withOption('className', 'text-center'));
        	}
            
            ip.dtColumns.push(DTColumnBuilder.newColumn('on_the_way').withTitle('On The Way').withOption('className', 'text-center'));
            ip.dtColumns.push(DTColumnBuilder.newColumn('in_process').withTitle('In Process').withOption('className', 'text-center'));

            if ($rootScope.permissionArr.indexOf('inventory_product_min_qty_alert') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('min_qty_alert').withTitle('Minimum Stock').withOption('className', 'text-center'));
        	}
            
            if ($rootScope.permissionArr.indexOf('inventory_product_created_date') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
        	}
            if ($rootScope.permissionArr.indexOf('inventory_product_status') != -1) {
            ip.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'));
          	}
          	ip.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        $scope.CrystalBarcodes = function ()
        {
            var urdd = $rootScope.baseUrl + '/inventory/products/crystal-barcodes';
            $http.get(urdd,
            {
                 responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download="crystal_barcodes.pdf";
                    //link.download="print_sticker_"+itemId+'_'+new Date().getTime()+".pdf";
                    link.click();
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
        }

        $scope.viewProductWarehouses= function (id)
        {
        	$cookies.put('product-id',id);
          	$state.go('inventorymanagement.product-warehouses');	
        }

        $scope.openLogHistory = function (id)
        {
        	$cookies.put('product-id',id);
          	$state.go('inventorymanagement.product-allocation');
      	};

      	$scope.closeLogHistory = function ()
        {
        	$scope.allocationLogsArr = [];
        	$('#allocationLogsModel').modal('hide');
        };

        $scope.openRemoveLogHistory = function (id)
        {
        	$cookies.put('product-id',id);
          	$state.go('inventorymanagement.product-allocation-remove');
      	};

      	$scope.closeRemoveLogHistory = function ()
        {
        	$scope.allocationRemoveLogsArr = [];
        	$('#allocationRemoveLogsModel').modal('hide');
        };

        $scope.viewInventoryProduct = function(id)
        {
        	$cookies.put('product-id',id);
           	$state.go('inventorymanagement.invntoryproducts');
        };

        /**
	     * Add product method is use for get add product page.
	     * created on 03.06.2020
	     */
	    $scope.addProduct = function()
	    {
	    	$cookies.put('product-id',undefined);
	      	$state.go('inventorymanagement.addproduct');
	    };

	    /**
	     * Get edited product method is use for get edited product data.
	     * created on 03.06.2020
	     */
	    $scope.getEditedProduct = function()
	    {
	    	ip.store_costs = [];
            ip.addon_products = [];
            ip.barcode = '';
	    	if ($cookies.get('product-id') && $cookies.get('product-id')!= undefined)
	    	{

	    		apiService.loaderShow();
	          
	          	$http.get($rootScope.baseUrl + '/inventory/products/' + $cookies.get('product-id'))
	            .success(function(response) {
                    ip.productId = response.product_id;
	            	ip.name = response.name;
                    ip.hscode = response.hscode;
                    ip.description = response.description;
                    ip.cost = response.cost;
                    ip.weight = response.weight;
                    ip.length = response.length;
                    ip.width = response.width;
                    ip.height = response.height;
	            	ip.boxqty = response.boxqty;
	            	ip.minQty = response.min_qty;
                    ip.itemtype = response.itemtype;
	            	ip.SKU=JSON.parse(response.sku);
	            	ip.status = response.status;
                    ip.crystalcode = response.crystalcode;
                    ip.crystalsize = response.crystalsize;
                    ip.identification = response.identification;
                    ip.addonproduct = response.addonproduct;
                    ip.barcode =  response.barcode;
	            	apiService.loaderHide();
	            }).error(function (error) {
	                apiService.loaderHide();
	                if (error.data && error.data.code != undefined && error.data.code == 0) {
	                    toastr.error(error.data.message);
	                } else {
	                    toastr.error("Something went wrong please try again.");
	                }
	            });

	            $http.get($rootScope.baseUrl + '/inventory/products/warehouses/' + $cookies.get('product-id'))
	            .success(function(response) {
	            	ip.wareHouses = response;
	            }).error(function (error) {
                	if (error.data && error.data.code == 0) {
                		toastr.error(error.data.message);
                	} else {
                		toastr.error("Something went wrong please try again.");
                	}
            	});
            	$http.get($rootScope.baseUrl + '/inventory/products/store-cost/' + $cookies.get('product-id'))
	            .success(function(response) {
	              if(response.status == 'success') {
	                ip.store_costs = response.store_costs;
	              }
	            }).error(function (error) {
	              if (error.data && error.data.code == 0) {
	                toastr.error(error.data.message);
	              } else {
	                toastr.error("Something went wrong please try again.");
	              }
	            });
                $http.get($rootScope.baseUrl + '/inventory/products/addon-product/' + $cookies.get('product-id'))
                .success(function(response) {
                  if(response.status == 'success') {
                    ip.addon_products = response.addon_products;
                  }
                }).error(function (error) {
                  if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                  } else {
                    toastr.error("Something went wrong please try again.");
                  }
                });
	            $http.get($rootScope.baseUrl + '/inventory/products/sku-box-qty/' + $cookies.get('product-id'))
	            .success(function(response) {
	              if(response.status == 'success') {
	                ip.SkuQty = response.skuboxqty;
	              }
	            }).error(function (error) {
	              if (error.data && error.data.code == 0) {
	                toastr.error(error.data.message);
	              } else {
	                toastr.error("Something went wrong please try again.");
	              }
	            });
	        } else {
	        	ip.name = '';
	        	ip.SKU= '';
	        	ip.minQty = 0;
                ip.cost = 0;
	        	ip.status = 1;
                ip.barcode = '';
	        	ip.SkuQty = [];
	          $state.go('inventorymanagement.addproduct');
	        }
	    };

	    $scope.addItem = function()
	    {
      		$scope.inserted = {
        		name: null,
        		value: null
      		};
      		ip.SkuQty.push($scope.inserted);
  		};

  		$scope.confirmDelete = function(id)
  		{
	      	$scope.itemId = id;
	     	$scope.popupShow = $uibModal.open(
	     	{
	        	animation: true,
	        	templateUrl: 'app/pages/inventoryManagement/inventoryProducts/deleteSkuQty.html',
	        	scope: $scope,
	      	});
	    };

	    $scope.removeItem = function()
	    {
	    	if ($scope.itemId != undefined) {
	        	ip.SkuQty.splice($scope.itemId, 1);
	      	}
	      	$scope.popupShow.close();
	    };

	    $scope.changedefault = function(index,stid,val)
	    {
	      var store_costs = [];
	      angular.forEach(ip.store_costs, function(value, key)
	      {
	        if(key == index) {
	          value.default_value = val;
	        }
	      }, store_costs);
	    };

	    /**
	     * Edit product method is use for get edit product page.
	     * created on 03.06.2020
	     */
	    $scope.editProduct = function(id)
	    {
	    	$cookies.put('product-id',id);
	      	$state.go('inventorymanagement.editproduct');
	    };

	    /**
	     * Save product data method is use for update/add product data.
	     * created on 03.06.2020
	     */
	    $scope.saveinventoryProductData = function()
	    {
	    	if (!this.inventoryProductFrm.name.$valid) {
		    	toastr.error("Please enter product name.");
		        angular.element('#name').focus();
		        return;
		    }
		    else if (!this.inventoryProductFrm.SKU.$valid) {
		    	toastr.error("Please enter product sku.");
		        angular.element('#SKU').focus();
		        return;
		    }
            else if (!this.inventoryProductFrm.itemtype.$valid) {
                toastr.error("Please select item type.");
                angular.element('#itemtype').focus();
                return;
            }
		    else if (!this.inventoryProductFrm.status.$valid) {
		    	toastr.error("Please select status.");
		        angular.element('#status').focus();
		        return;
		    }
		    else if (!this.inventoryProductFrm.boxqty.$valid) {
		    	ip.boxqty = 0;
		    }
		    
		    $scope.storeSettings={
	        'store_costs':ip.store_costs
	      };
	      $scope.skuboxqty={
	        'skuboxqty':ip.SkuQty
	      };

          $scope.addonProductSettings={
            'addon_products':ip.addon_products
            };

		    apiService.loaderShow();
		    var bodyData = {
		        name: ip.name,
		        sku:JSON.stringify(ip.SKU),
		        status: ip.status,
                hscode: ip.hscode,
                description: ip.description,
                cost: ip.cost,
                weight: ip.weight,
                length: ip.length,
                width: ip.width,
                height: ip.height,
		        boxqty: ip.boxqty,
		        min_qty: parseInt(ip.minQty),
		        store_costs:angular.toJson($scope.storeSettings),
		        skuboxqty:angular.toJson($scope.skuboxqty),
                itemtype: ip.itemtype,
                crystalcode: ip.crystalcode,
                crystalsize: ip.crystalsize,
                identification: ip.identification,
                addonproduct: angular.toJson($scope.addonProductSettings),
		        affected_by: $rootScope.globals.currentUser.id,
                barcode: ip.barcode,
		    };
	      	$scope.saveUrl = $rootScope.baseUrl + '/inventory/products';
	      	$scope.httpMethod = 'POST';
	      	$scope.productId = ip.productId;
	      	if (ip.productId)
	      	{
	        	$scope.saveUrl = $rootScope.baseUrl + '/inventory/products/' + ip.productId;
	        	$scope.httpMethod = 'PUT';
	      	}
	      	$http({
		        url: $scope.saveUrl,
		        method: $scope.httpMethod,
		        data: $scope.dataUrlEncode(bodyData),
		        headers: {
		          'Content-Type': 'application/x-www-form-urlencoded'
		        }
		    }).then(function(response) {
	      		var response = response.data;
	        	if (response.code!= undefined && response.code == 0) {
	            	toastr.error(response.message);
	       		}else if (response.status == 'success') {
		          toastr.success(response.message);
		          $state.go('inventorymanagement.invntoryproducts');
		        } else {
		          $state.go('inventorymanagement.invntoryproducts');
		          toastr.error("Something went wrong please try again.");
		        }
	      	}, function(error) {
	        	apiService.loaderHide();
	        	if (error.data.code!= undefined && error.data.code == 0) {
	            	toastr.error(error.data.message);
	        	} else {
		          $state.go('inventorymanagement.invntoryproducts');
		          toastr.error("Something went wrong please try again.");
		        }
	      	});
	  	};

	    /**
	     * Change status method is use for change status of product.
	     * created on 03.06.2020
	     */
	    $scope.changeStatus = function()
	    {
	    	if ($rootScope.deleteId)
	      	{
	        	apiService.loaderShow();
	        	var bodyData = {
	          		id: $rootScope.deleteId,
	          		status:  ""+$rootScope.status+"",
	          		updated_by:$rootScope.globals.currentUser.id
	        	};
	        	$http.put($rootScope.baseUrl + '/inventory/products', bodyData)
	        	.success(function(result)
	        	{
	        		if (result.status == 'success') {
	              		toastr.success('Status updated successfully.');
	              		$state.go($state.$current, null, {
	                		reload: true
	              		});
	            	}
	            	else
	            	{
	              		$state.go('inventorymanagement.invntoryproducts');
	              		toastr.error("Something went wrong please try again.");
	            	}
	            	apiService.loaderHide();
	          	})
	          	.error(function(error)
	          	{
	            	apiService.loaderHide();
	            	if (error.data.code != undefined && error.data.code == 0) {
	                	toastr.error(error.data.message);
	            	} else {
	                	toastr.error("Something went wrong please try again.");
	            	}
	          	});
	        	$scope.popupShow.close();
	    	}
	    };

	    /**
	     * Delete product method is use for delete product.
	     * created on 03.06.2020
	     */
	    $scope.deleteProduct = function()
	    {
	    	if ($rootScope.deleteId)
	    	{
	    		apiService.loaderShow();
	    		$http.delete($rootScope.baseUrl + '/inventory/products/' + $rootScope.deleteId)
                .success(function(result)
                {
                  apiService.loaderHide();
                  if (result.status == 'success')
                  {
                  	toastr.success(result.message);
                  	$state.go($state.$current, null, {
                  		reload: true
                  	});
                  }
                  else if (result.status == 'fail')
                  {
                  	toastr.success(result.message);
                  	$state.go($state.$current, null, {
                  		reload: true
                  	});
                  }
              	}).error(function (error)
              	{
              		apiService.loaderHide();
              		if (error.data && error.data.code == 0) {
              			toastr.error(error.data.message);
              		} else {
              			toastr.error("Something went wrong please try again.");
              		}
              	});
			}
        	$scope.popupShow.close();
		};


		$scope.AddStock = function (id,whid)
	    {
	    	$scope.WareHouseProductId = id;
	      	$scope.WareHouseId = whid;
	      	$scope.addqty = '';
	      	$scope.addbox = '';
	      	$scope.addsqty = '';
	      	$scope.addnote = '';
	      	$scope.boxqty = 0;

	      	$scope.popupShow = $uibModal.open({
	        	animation: true,
	        	templateUrl: 'app/pages/inventoryManagement/inventoryProducts/addWarehouseStock.html',
	        	scope: $scope,
	      	});
	    };

	    $scope.saveWareHouseProduct = function ()
    	{
      		if (!this.WarehouseProductFrm.$valid) {
      			toastr.error("Please enter required fileds");
      			angular.element('#addqty').focus();
      			return;
      		}
      		else if (!this.WarehouseProductFrm.addqty.$valid) {
      			toastr.error("Please enter qty grater than 0.");
      			angular.element('#addqty').focus();
      			return;
      		}
      		
      		apiService.loaderShow();
      		var bodyData = {
      			pid: $cookies.get('product-id'),
      			whpid: $scope.WareHouseProductId,
      			whid: $scope.WareHouseId,
      			qty: this.addqty!=''?this.addqty:0,
      			box: this.addbox!=''?this.addbox:0,
      			totalqty: this.addsqty!=''?this.addsqty:0,
      			note: this.addnote,
          		affected_by: $rootScope.globals.currentUser.id,
        	};

        	$scope.saveUrl = $rootScope.baseUrl + '/inventory/products/addwarehousestock';
        	$scope.httpMethod = 'POST';
        	$http({
        		url: $scope.saveUrl,
        		method: $scope.httpMethod,
        		data: $scope.dataUrlEncode(bodyData),
        		headers: {
        			'Content-Type': 'application/x-www-form-urlencoded'
        		}
        	}).then(function(response) {
        		apiService.loaderHide();
        		var response = response.data;
        		if (response.code!= undefined && response.code == 0) {
        			toastr.error(response.message);
        		}else  if (response.status == 'success') {
        			toastr.success(response.message);
        			$state.go($state.$current, null, {
                		reload: true
              		});
        		} else {
        			toastr.success(response.message);
        		}
        	}, function(error) {
        		apiService.loaderHide();
        		if (error.data.code!= undefined && error.data.code == 0) {
        			toastr.error(error.data.message);
        		} else {
        			$state.go('inventorymanagement.addproduct');
        			toastr.error("Something went wrong please try again.");
        		}
        	});
        };

	    $scope.RemoveStock = function (id)
	    {
	    	$scope.WareHouseProductId = id;
	      	$scope.popupShow = $uibModal.open({
	        	animation: true,
	        	templateUrl: 'app/pages/inventoryManagement/inventoryProducts/removeWarehouseStock.html',
	        	scope: $scope,
	      	});
	    };

	    $scope.removeWareHouseProduct = function ()
      	{
      		if (!this.WarehouseProductFrm.$valid) {
            	toastr.error("Please enter required fileds");
            	angular.element('#addqty').focus();
            	return;
          	}
          	if (!this.WarehouseProductFrm.removeQty.$valid) {
            	toastr.error("Please enter qty grater than 0.");
            	angular.element('#removeQty').focus();
            	return;
          	}
          	apiService.loaderShow();
          	var bodyData = {
            	pid: $cookies.get('product-id'),
            	whpid: $scope.WareHouseProductId,
            	qty: this.removeQty,
            	box: this.removebox!=''?this.removebox:0,
            	totalqty: this.removesqty,
            	note: this.addnote,
            	affected_by: $rootScope.globals.currentUser.id,
          	};

          	$scope.saveUrl = $rootScope.baseUrl + '/inventory/products/removewarehousestock';
          	$scope.httpMethod = 'POST';
          	$http({
            	url: $scope.saveUrl,
              	method: $scope.httpMethod,
              	data: $scope.dataUrlEncode(bodyData),
              	headers: {
                	'Content-Type': 'application/x-www-form-urlencoded'
              	}
          	}).then(function(response) {
            	apiService.loaderHide();
              	var response = response.data;
              	if (response.code!= undefined && response.code == 0) {
                	toastr.error(response.message);
              	}else  if (response.status == 'success') {
                	toastr.success(response.message);
                	$state.go($state.$current, null, {
                		reload: true
              		});
              	} else {
                	toastr.success(response.message);
              	}
          	}, function(error) {
            	apiService.loaderHide();
              	if (error.data.code!= undefined && error.data.code == 0) {
                	toastr.error(error.data.message);
              	} else {
                	$state.go('inventorymanagement.addproduct');
                	toastr.error("Something went wrong please try again.");
              	}
          	});
      	};

      	$scope.moveStock = function (whpid,whid)
      	{
        	if ($cookies.get('product-id') && $cookies.get('product-id')!= undefined)
          	{
            	$scope.WareHouseProductId = whpid;
              	$scope.WareHouseId = whid;
              	$scope.productId = $cookies.get('product-id');

              	$scope.firstWareHouses = [];
            	$scope.secondWareHouses = [];
            	$scope.psku = '';
            	$scope.pname = '';
              	$scope.astock = 0;
              	$scope.addqty = '';
              	$scope.addbox = '';
              	$scope.addsqty = '';
              	$scope.addnote = '';
              	$scope.fWareHouse = '';
              	$scope.sWareHouse = '';

            	apiService.loaderShow();
            	var bodyData = {
                	pid: $cookies.get('product-id'),
                	whpid: whpid,
                	whid: whid
              	};

              	$scope.saveUrl = $rootScope.baseUrl + '/warehouse/active-store-warehouse';
              	$scope.httpMethod = 'POST';
              	$http(
              	{
                	url: $scope.saveUrl,
                  	method: $scope.httpMethod,
                  	data: $scope.dataUrlEncode(bodyData),
                  	headers: {
                    	'Content-Type': 'application/x-www-form-urlencoded'
                  	}
              	}).then(function(response)
        		{
                	apiService.loaderHide();
                	var response = response.data;
                  	if (response.status == 'success')
                  	{
                    	$scope.fWareHouse = response.warehouse_id;
                    	$scope.psku = response.product_sku;
                    	$scope.pname = response.product_name;
                    	$scope.astock = response.available_stock;
                    	$scope.firstWareHouses = response.from_warehouse;
                   		$scope.secondWareHouses = response.to_warehouses;
                  	}
                  	else {
                    	toastr.error(response.message);
                  	}
              	}, function(error)
              	{
                	apiService.loaderHide();
                	if (error.data && error.data.code == 0) {
                		toastr.error(error.data.message);
                	} else {
                    	toastr.error("Something went wrong please try again.");
                	}
              	});
              	$scope.popupShow = $uibModal.open({
                	animation: true,
                	templateUrl: 'app/pages/inventoryManagement/wareHouse/moveWarehouseStock.html',
                	scope: $scope,
              	});
          	}
      	};

      	/**
	     * Open model.
	     * created on 03.06.2020
	     */
	    $scope.open = function(page, id, status)
	    {
	    	$rootScope.deleteId = id;
	      	$rootScope.status = status;
	      	$scope.popupShow = $uibModal.open({
	        	animation: true,
	        	templateUrl: page,
	        	scope: $scope,
	      	});
	    };
	}
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventoryManagement')
            .controller('productAllocationCtrl', productAllocationCtrl);

    /** @ngInject */
    function productAllocationCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
      var vm = this;
        $scope.allocationLogsArr = [];
      
      $scope.removeAllocation = function(allocation_id)
      {
          if(allocation_id > 0)
          {
            apiService.loaderShow();
            $http.delete($rootScope.baseUrl + '/inventory/products/delete-allocation/' + allocation_id)
              .success(function(result) {
                apiService.loaderHide();
                
                  if (result.status == 'success')
                  {
                    toastr.success(result.message);
                    $state.go($state.$current, null, {
                      reload: true
                    });
                  }
                  else 
                  {
                    toastr.error(result.message);
                    $state.go($state.$current, null, {
                      reload: true
                    });
                  }
              }).error(function (error) {
                  apiService.loaderHide();
                  if (error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
          }
        }

        $scope.removeAll = function()
      {
        var productId = 0;
        if($cookies.get('product-id') && $cookies.get('product-id')!= undefined) {
          productId = $cookies.get('product-id');
        }

          apiService.loaderShow();
          $http.delete($rootScope.baseUrl + '/inventory/products/delete-all-allocation/' + productId)
            .success(function(result) {
              apiService.loaderHide();
              
                if (result.status == 'success')
                {
                  toastr.success(result.message);
                  $state.go($state.$current, null, {
                    reload: true
                  });
                }
                else 
                {
                  toastr.error(result.message);
                  $state.go($state.$current, null, {
                    reload: true
                  });
                }
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
      }
      
      $scope.getDataTable = function()
        {
          var productId = 0;
          if($cookies.get('product-id') && $cookies.get('product-id')!= undefined) {
            productId = $cookies.get('product-id');
          }

          $http.get($rootScope.baseUrl + '/inventory/products/' + productId)
          .success(function(response) {
            $scope.productname = response.name
          }).error(function (error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });

          var pal = this;
          pal.dtOptions = DTOptionsBuilder.fromFnPromise(function()
          {
              var defer = $q.defer();
              $http.get($rootScope.baseUrl + '/inventory/products/allocationlog/'+productId)
              .success(function(result)
              {
                  if(result.length < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }
                pal.log = [];
                var index = 1 ;
                
                  angular.forEach(result, function(value, key)
                  {
                    var reportLinks = '';
                    reportLinks = ' <a ng-click="removeAllocation(' + value.allocation_id + ')" href="javascript:void(0);" title="Remove Allocation"><i class="fa fa-trash" style="color:#fff;" aria-hidden="true"></i></a>';

                    var data = {
                      index:index,
                    id: value.allocation_id,
                    pid: value.product_id,
                    name: value.product_name,
                    orderid: value.increment_id,
                    itemid: value.item_increment_id,
                    allocated_by: value.username,
                    qty: value.qty,
                    old_stock : value.old_stock,
                    old_allocated : value.old_allocated,
                    old_available : value.old_available,
                    new_stock : value.new_stock,
                    new_allocated : value.new_allocated,
                    new_available : value.new_available,
                    allocated_at: value.allocated_at,
                    operations: reportLinks
                      };
                    this.push(data);
                    ++index;
                  }, pal.log);
                  defer.resolve(pal.log);
              })
              .error(function (error)
              {
                  if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                  } else {
                    toastr.error("Something went wrong please try again.");
                  }
              });
              return defer.promise;
            })
            .withPaginationType('simple_numbers')
              pal.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
              pal.dtOptions.withOption('fnRowCallback',
                function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                  $scope.$apply($compile(nRow)($scope));
              });
              pal.dtOptions.withOption('sDom', $rootScope.dom);
              pal.dtOptions.withOption('initComplete', function()
              {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
              });
              pal.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
              pal.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('name').withTitle('Name'),
                DTColumnBuilder.newColumn('orderid').withTitle('Order #'),
                DTColumnBuilder.newColumn('itemid').withTitle('Item #'),
                DTColumnBuilder.newColumn('old_allocated').withTitle('Old Allocated'),
                DTColumnBuilder.newColumn('qty').withTitle('Qty Allocated'),
                DTColumnBuilder.newColumn('new_allocated').withTitle('New Allocated'),
                DTColumnBuilder.newColumn('allocated_by').withTitle('Allocated By'),
                DTColumnBuilder.newColumn('allocated_at').withTitle('Allocated Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('operations').withTitle('Action').withOption('orderable', false).withOption('className', 'tableActions')
              ];
          };
        };
    
  })();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventoryManagement')
            .controller('productRemoveAllocationCtrl', productRemoveAllocationCtrl);

    /** @ngInject */
    function productRemoveAllocationCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
    	var vm = this;
        $scope.allocationLogsArr = [];
    	
    	$scope.getDataTable = function()
        {
        	var productId = 0;
        	if($cookies.get('product-id') && $cookies.get('product-id')!= undefined) {
        		productId = $cookies.get('product-id');
        	}

          $http.get($rootScope.baseUrl + '/inventory/products/' + productId)
          .success(function(response) {
            $scope.productname = response.name
          }).error(function (error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });

        	var pal = this;
	        pal.dtOptions = DTOptionsBuilder.fromFnPromise(function()
	        {
	            var defer = $q.defer();
	            $http.get($rootScope.baseUrl + '/inventory/products/allocationremovelog/'+productId)
	            .success(function(result)
	            {
	              	if(result.length < $rootScope.numberOfRecord)
	            	{
	                	$timeout(function () {
	                  		angular.element('.dataTables_paginate').hide();
	                	}, 200);
	              	}
	            	pal.log = [];
	            	var index = 1 ;
	              
	              	angular.forEach(result, function(value, key)
	              	{
	              		var data = {
                  		index:index,
                		id: value.allocation_id,
                		pid: value.product_id,
                		name: value.product_name,
                		orderid: value.increment_id,
                		itemid: value.item_increment_id,
                		allocated_by: value.username,
                    qty: value.qty,
                    old_stock : value.old_stock,
                    old_allocated : value.old_allocated,
                    old_available : value.old_available,
                    new_stock : value.new_stock,
                    new_allocated : value.new_allocated,
                    new_available : value.new_available,
                		removed_at: value.removed_at
                  		};
                		this.push(data);
                		++index;
              		}, pal.log);
              		defer.resolve(pal.log);
            	})
            	.error(function (error)
            	{
              		if (error.data.code != undefined && error.data.code == 0) {
                		toastr.error(error.data.message);
              		} else {
                		toastr.error("Something went wrong please try again.");
              		}
            	});
            	return defer.promise;
          	})
          	.withPaginationType('simple_numbers')
          		pal.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          		pal.dtOptions.withOption('fnRowCallback',
          			function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            			$scope.$apply($compile(nRow)($scope));
            	});
            	pal.dtOptions.withOption('sDom', $rootScope.dom);
           		pal.dtOptions.withOption('initComplete', function()
            	{
            		angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            		angular.element('.dataTables_filter input').attr('class', 'form-control');
            		angular.element('.dataTables_length select').attr('class', 'form-control');
         	  	});
          		pal.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          		pal.dtColumns = [
            		DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            		DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            		DTColumnBuilder.newColumn('name').withTitle('Name'),
            		DTColumnBuilder.newColumn('orderid').withTitle('Order #'),
            		DTColumnBuilder.newColumn('itemid').withTitle('Item #'),
                DTColumnBuilder.newColumn('old_allocated').withTitle('Old Available'),
                DTColumnBuilder.newColumn('qty').withTitle('Qty Removed'),
                DTColumnBuilder.newColumn('new_allocated').withTitle('New Available'),
            		DTColumnBuilder.newColumn('allocated_by').withTitle('Allocated By'),
            		DTColumnBuilder.newColumn('removed_at').withTitle('Removed Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat)
              	];
        	};
    	}
		
	})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventoryManagement')
            .controller('productWarehousesCtrl', productWarehousesCtrl);

    /** @ngInject */
    function productWarehousesCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
      if($rootScope.permissionArr.indexOf('product_warehouses') == -1)
      {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
      }

    	var vm = this;
      $rootScope.currentState='inventorymanagement.product-warehouses';
      $scope.productWarehousesArr = [];
    	
    	$scope.getDataTable = function()
      {
        var productId = 0;
        if($cookies.get('product-id') && $cookies.get('product-id')!= undefined) {
          productId = $cookies.get('product-id');
        }

        var wh = this;
          wh.dtOptions = DTOptionsBuilder.fromFnPromise(function()
          {
            var defer = $q.defer();
            $http.get($rootScope.baseUrl + '/inventory/products/warehouses/'+productId)
            .success(function(result)
            {
              if(result.length < $rootScope.numberOfRecord)
              {
                $timeout(function () {
                  angular.element('.dataTables_paginate').hide();
                }, 200);
              }
              wh.warehouses = [];
              var index = 1 ;
              
              angular.forEach(result, function(value, key)
              {
                var data = {
                  index:index,
                  id: value.warehouse_id,
                  name: value.warehouse_name,
                  stock: value.product_stock,
                  allocated: value.product_allocated,
                  available: value.product_available,
                };
                this.push(data);
                ++index;
              }, wh.warehouses);
              defer.resolve(wh.warehouses);
            })
            .error(function (error)
            {
              if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
            return defer.promise;
          })
          .withPaginationType('simple_numbers')
          wh.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          wh.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $scope.$apply($compile(nRow)($scope));
            });
            wh.dtOptions.withOption('sDom', $rootScope.dom);
            wh.dtOptions.withOption('initComplete', function()
            {
              angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
              angular.element('.dataTables_filter input').attr('class', 'form-control');
              angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            wh.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            wh.dtColumns = [
              DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
              DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
              DTColumnBuilder.newColumn('name').withTitle('Name'),
              DTColumnBuilder.newColumn('stock').withTitle('Stock'),
              DTColumnBuilder.newColumn('allocated').withTitle('Allocated'),
              DTColumnBuilder.newColumn('available').withTitle('Available')
            ];  
      }
		}
	})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventoryManagement')
            .controller('wareHouseCtrl', wareHouseCtrl);

    /** @ngInject */
    function wareHouseCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
        /**
        * permissionArr is use to check permission to display list warehouse
        * created on 03.02.2020
        */
        if($rootScope.permissionArr.indexOf('warehouse') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='inventorymanagement.warehouse';
        $scope.resetGlobalSearch();

        $scope.ptypes = [];

        $scope.warehouseType = function (type)
        {
        	if(type == 'on_the_way' || type == 'on the way') {
        		return 'In Transit';
        	}
        	if(type == 'in_process' || type == 'in process') {
        		return 'China Production';
        	}
        	return type.charAt(0).toUpperCase() + type.slice(1);
        }

        /**
         * Get data table method is use get list of warehouse.
         * created on 03.02.2020
         */
        $scope.getDataTable = function ()
        {
            var wh = this;
            wh.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
            	var defer = $q.defer();
            	$http.get($rootScope.baseUrl + '/warehouse')
            	.success(function(result)
            	{
            		if(result.length < $rootScope.numberOfRecord)
            		{
                    	$timeout(function () {
                    		angular.element('.dataTables_paginate').hide();
                    	}, 200);
                    }
            		wh.warehouses = [];
              		var index = 1 ;
              		angular.forEach(result, function(value, key)
              		{
              			var changeStatusValTo = 0;
                		var editLinks = '';
                		if($rootScope.permissionArr.indexOf('warehoue_edit') != -1){
                			editLinks = ' <a href="javascript:void(0);"  ng-click="editWareHouse(\'' + value.warehouse_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                		}

                		var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                		
                		var statusLinks = '';
                		var	deleteLinks = '';
                		if(value.warehouse_type != 'production') 
                		{
                			if($rootScope.permissionArr.indexOf('warehouse_status_change') != -1){
                			statusLinks = ' <a ng-click="open(\'' + 'app/pages/inventoryManagement/wareHouse/statusModal.html' + '\',\'' + value.warehouse_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                			}
                			if (value.warehouse_status == 0)
                			{
                				changeStatusValTo = '1';
                				statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                				if($rootScope.permissionArr.indexOf('warehouse_status_change') != -1){
                					statusLinks = ' <a ng-click="open(\'' + 'app/pages/inventoryManagement/wareHouse/statusModal.html' + '\',\'' + value.warehouse_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                				}
                			}
                			if($rootScope.permissionArr.indexOf('warehouse_delete') != -1){
                				deleteLinks = '  <a href="javascript:void(0);" ng-click="open(\'' + 'app/pages/inventoryManagement/wareHouse/deleteModal.html' + '\',\'' + value.warehouse_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                			}
                		}

                		var reportLinks = '';
                		if($rootScope.permissionArr.indexOf('warehouse_products') != -1){
                	 		reportLinks = ' <a ng-click="viewWareHouseProducts(' + value.warehouse_id + ')" href="javascript:void(0);" title="Products Stock"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></a>';
                		}
                		
                		if($rootScope.permissionArr.indexOf('show_warehouse_'+value.warehouse_id) != -1)
                		{
	                		var data = {
	                			index:index,
	                			id: value.warehouse_id,
	                			name: value.warehouse_name,
	                			type: value.warehouse_type,
	                			created_at: value.created_at,
	                			updated_at: value.updated_at,
	                			status:statusBadge,
	                			operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + reportLinks
	                		};
	                		this.push(data);
	                		++index;
                		}
                	}, wh.warehouses);
                	defer.resolve(wh.warehouses);
                })
                .error(function (error)
                {
                	if (error.data.code != undefined && error.data.code == 0) {
                		toastr.error(error.data.message);
                	} else {
                		toastr.error("Something went wrong please try again.");
                	}
                });
            	return defer.promise;
          	})
          	.withPaginationType('simple_numbers')
          	wh.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          	wh.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            	$scope.$apply($compile(nRow)($scope));
            });
            wh.dtOptions.withOption('sDom', $rootScope.dom);
            wh.dtOptions.withOption('initComplete', function()
            {
            	angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            	angular.element('.dataTables_filter input').attr('class', 'form-control');
            	angular.element('.dataTables_length select').attr('class', 'form-control');
         	});
          	wh.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          	wh.dtColumns = [
            	DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            	DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            	DTColumnBuilder.newColumn('name').withTitle('Name'),
            	DTColumnBuilder.newColumn('type').withTitle('Type').renderWith($scope.warehouseType),
            	DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
            	DTColumnBuilder.newColumn('updated_at').withTitle('Modified Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
            	DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
          	];
          	wh.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        /**
	     * Open model.
	     * created on 10.03.2019
	     */
	    $scope.open = function(page, id, status)
	    {
	      $rootScope.deleteId = id;
	      $rootScope.status = status;
	      $scope.popupShow = $uibModal.open({
	        animation: true,
	        templateUrl: page,
	        scope: $scope,
	      });
    	};

    	/**
	     * Change status method is use for change status of warehouse.
	     * created on 10.03.2019
	     */
	    $scope.changeStatus = function()
	    {
	    	if ($rootScope.deleteId)
	      	{
	        	apiService.loaderShow();
	        	var bodyData = {
	          		id: $rootScope.deleteId,
	          		status:  ""+$rootScope.status+"",
	          		updated_by:$rootScope.globals.currentUser.id
	        	};
	        	$http.put($rootScope.baseUrl + '/warehouse', bodyData)
	        	.success(function(result)
	        	{
	        		if (result.status == 'success') {
	              		toastr.success('Status updated successfully.');
	              		$state.go($state.$current, null, {
	                		reload: true
	              		});
	            	}
	            	else
	            	{
	              		$state.go('inventorymanagement.warehouse');
	              		toastr.error("Something went wrong please try again.");
	            	}
	            	apiService.loaderHide();
	          	})
	          	.error(function(error)
	          	{
	            	apiService.loaderHide();
	            	if (error.data.code != undefined && error.data.code == 0) {
	                	toastr.error(error.data.message);
	            	} else {
	                	toastr.error("Something went wrong please try again.");
	            	}
	          	});
	        	$scope.popupShow.close();
	    	}
	    };
        

        $scope.viewWareHouseProducts = function(id)
        {
        	$cookies.put('warehouse-id',id);
           	$state.go('inventorymanagement.warehouse-products');
        };

        /**
	     * Add warehouse method is use for get add warehouse page.
	     * created on 03.02.2020
	     */
	    $scope.addWareHouse = function()
	    {
	    	$cookies.put('warehouse-id',undefined);
	      	$state.go('inventorymanagement.add-warehouse');
	    };


	    /**
	     * Get edited warehouse method is use for get edited warehouse data.
	     * created on 03.02.2020
	     */
	    $scope.getEditedWareHouse = function()
	    {
	    	$scope.ptypes = [];

	    	if ($cookies.get('warehouse-id') && $cookies.get('warehouse-id')!= undefined) {
	          apiService.loaderShow();
	          var wh = this;
	          var product_types = '';
	          $http.get($rootScope.baseUrl + '/warehouse/' + $cookies.get('warehouse-id'))
	            .success(function(response) {
	            	wh.warehouseId = response.warehouse_id;
	            	wh.name = response.warehouse_name;
	            	wh.type = response.warehouse_type;
	            	product_types = response.product_types;
	            	
	            	if(product_types != '') {
	            		$scope.ptypes = product_types.split(',');
	            	}
	            	wh.status = response.warehouse_status;
	            	apiService.loaderHide();
	            }).error(function (error) {
	                apiService.loaderHide();
	                if (error.data && error.data.code != undefined && error.data.code == 0) {
	                    toastr.error(error.data.message);
	                } else {
	                    toastr.error("Something went wrong please try again.");
	                }
	            });
	        } else {
	          $state.go('inventorymanagement.add-warehouse');
	        }
	    };

	    /**
	     * Edit warehouse method is use for get edit warehouse page.
	     * created on 03.02.2020
	     */
	    $scope.editWareHouse = function(id)
	    {
	    	$cookies.put('warehouse-id',id);
	      	$state.go('inventorymanagement.edit-warehouse');
	    };

	    $scope.checkPTypeExists = function(val)
	    {
	    	//alert(val);
	    	var i = 0; var found = false;
	    	for(i = 0; i < $scope.ptypes.length; i++) {
	    		if(val == $scope.ptypes[i]) {
	    			//console.log($scope.ptypes[i]+ " "+val);
	    			return true;
	    		}
	    	}
	    	return found;
	    }


	    /**
	     * Save warehouse data method is use for update/add warehouse data.
	     * created on 03.02.2020
	     */
	    $scope.saveWareHouseData = function()
	    {
	      if (!this.warehouseFrm.name.$valid) {
	        toastr.error("Please enter warehouse name.");
	        angular.element('#name').focus();
	        return;
	      }
	      else if (!this.warehouseFrm.type.$valid) {
	        toastr.error("Please select type.");
	        angular.element('#type').focus();
	        return;
	      }
	      else if (!this.warehouseFrm.status.$valid) {
	        toastr.error("Please select status.");
	        angular.element('#status').focus();
	        return;
	      }

	      var product_types=[];
	      $("input:checkbox[class=product_types]:checked").each(function(){
    product_types.push($(this).val());
});

	      apiService.loaderShow();
	      var bodyData = {
	        name: this.name,
	        type: this.type,
	        status: this.status,
	        product_types: product_types,
	        affected_by: $rootScope.globals.currentUser.id,
	      };
	      $scope.saveUrl = $rootScope.baseUrl + '/warehouse';
	      $scope.httpMethod = 'POST';
	      $scope.warehouseId = this.warehouseId;
	      if (this.warehouseId) {
	        $scope.saveUrl = $rootScope.baseUrl + '/warehouse/' + this.warehouseId;
	        $scope.httpMethod = 'PUT';
	      }
	      $http({
	        url: $scope.saveUrl,
	        method: $scope.httpMethod,
	        data: $scope.dataUrlEncode(bodyData),
	        headers: {
	          'Content-Type': 'application/x-www-form-urlencoded'
	        }
	      }).then(function(response) {
	      	apiService.loaderHide();
	      	var response = response.data;
	        if (response.code!= undefined && response.code == 0) {
	              toastr.error(response.message);
	        }else  if (response.status == 'success') {
	          toastr.success(response.message);
	          $state.go('inventorymanagement.warehouse');
	        } else {
	          toastr.error(response.message);
	        }
	      }, function(error) {
	        apiService.loaderHide();
	        if (error.data.code!= undefined && error.data.code == 0) {
	            toastr.error(error.data.message);
	        } else {
	          $state.go('inventorymanagement.warehouse');
	          toastr.error("Something went wrong please try again.");
	        }
	      });
	  	};

	    /**
	     * Change status method is use for change status of warehouse.
	     * created on 03.02.2020
	     */
	    $scope.changeStatus = function()
	    {
	    	if ($rootScope.deleteId)
	      	{
	        	apiService.loaderShow();
	        	var bodyData = {
	          		id: $rootScope.deleteId,
	          		status:  ""+$rootScope.status+"",
	          		updated_by:$rootScope.globals.currentUser.id
	        	};
	        	$http.put($rootScope.baseUrl + '/warehouse', bodyData)
	        	.success(function(result)
	        	{
	        		if (result.status == 'success') {
	              		toastr.success('Status updated successfully.');
	              		$state.go($state.$current, null, {
	                		reload: true
	              		});
	            	}
	            	else
	            	{
	              		$state.go('inventorymanagement.warehouse');
	              		toastr.error("Something went wrong please try again.");
	            	}
	            	apiService.loaderHide();
	          	})
	          	.error(function(error)
	          	{
	            	apiService.loaderHide();
	            	if (error.data.code != undefined && error.data.code == 0) {
	                	toastr.error(error.data.message);
	            	} else {
	                	toastr.error("Something went wrong please try again.");
	            	}
	          	});
	        	$scope.popupShow.close();
	    	}
	    };

	    /**
	     * Delete account method is use for delete warehouse.
	     * created on 03.02.2020
	     */
	    $scope.deleteWareHouse = function()
	    {
	    	if ($rootScope.deleteId)
	    	{
	    		apiService.loaderShow();
	    		$http.delete($rootScope.baseUrl + '/warehouse/' + $rootScope.deleteId)
                .success(function(result)
                {
                  apiService.loaderHide();
                  if (result.status == 'success')
                  {
                  	toastr.success(result.message);
                  	$state.go($state.$current, null, {
                  		reload: true
                  	});
                  }
                  else if (result.status == 'fail')
                  {
                  	toastr.success(result.message);
                  	$state.go($state.$current, null, {
                  		reload: true
                  	});
                  }
              	}).error(function (error)
              	{
              		apiService.loaderHide();
              		if (error.data && error.data.code == 0) {
              			toastr.error(error.data.message);
              		} else {
              			toastr.error("Something went wrong please try again.");
              		}
              	});
			}
        	$scope.popupShow.close();
	    };
	}
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventoryManagement')
            .controller('wareHouseProductsCtrl', wareHouseProductsCtrl);

    /** @ngInject */
    function wareHouseProductsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
        var vm = this;
        $scope.stockLogsArr = [];

    	  $scope.getDataTable = function()
        {
          var wareHouseId = 0;
        	if($cookies.get('warehouse-id') && $cookies.get('warehouse-id')!= undefined) {
        		wareHouseId = $cookies.get('warehouse-id');
        	}
        	
			    $http.get($rootScope.baseUrl + '/warehouse/' + $cookies.get('warehouse-id'))
          .success(function(response) {
            $scope.from_warehouse_id = response.warehouse_id;
            $scope.warehouse_name = response.warehouse_name;
            $scope.warehouse_type = $scope.UcCap(response.warehouse_type);
          }).error(function (error) {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });

          var wh = this;
          wh.dtOptions = DTOptionsBuilder.fromFnPromise(function()
          {
            var defer = $q.defer();
            $http.get($rootScope.baseUrl + '/warehouse/products/'+wareHouseId)
            .success(function(result)
            {
              if(result.length < $rootScope.numberOfRecord)
            	{
                $timeout(function () {
                  angular.element('.dataTables_paginate').hide();
                }, 200);
              }
            	wh.products = [];
              var index = 1 ;
              
              angular.forEach(result, function(value, key)
              {
                var addStockLink = ' <a ng-click="AddStock('+value.warehouse_product_id+',' + value.warehouse_id + ',' + value.product_id + ')" href="javascript:void(0);" title="Add Stock"><i class="fa fa-plus" style="color:#fff;" aria-hidden="true"></i></a>';
              	var removeStockLink = ' <a ng-click="RemoveStock('+value.warehouse_product_id+',\'' + value.product_id + '\')" href="javascript:void(0);" title="Remove Stock" ng-if="'+value.product_available+' > 0"><i class="fa fa-minus" style="color:#fff;" aria-hidden="true"></i></a>';
                var moveLinks = ' <a ng-click="moveStock('+value.warehouse_product_id+',' + value.warehouse_id + ',\'' + value.product_id + '\')" href="javascript:void(0);" title="Move Stock" ng-if="'+value.product_available+' > 0" style="color:#fff;font-size:20px">&#8644;</a>'; //&#8633;
                var stockHistoryLink = ' <a ng-click="openLogHistory('+value.warehouse_product_id+')" href="javascript:void(0);" title="Stock History" ng-if="'+value.warehouse_product_id+' > 0"><i class="fa fa-question-circle" style="color:#fff;" aria-hidden="true"></i></a>';

                var allocationHistoryLink = '';
                if(value.warehouse_type == 'production') {
                  //allocationHistoryLink = ' <a ng-click="openAllocationHistory('+value.warehouse_product_id+')" href="javascript:void(0);" title="Allocation History" ng-if="'+value.warehouse_product_id+' > 0"><i class="fa fa-question-circle" style="color:#fff;" aria-hidden="true"></i></a>';
                }
                
                if($rootScope.permissionArr.indexOf('show_product_type_'+value.itemtype) != -1)
                {
                  var data = {
                    index:index,
                  	id: value.warehouse_id,
                    name: value.product_name,
                  	stock: value.product_stock,
                  	allocated: value.product_allocated,
                  	available: value.product_available,
                  	updated_at: value.updated_at,
                    operations: addStockLink + '&nbsp;' + removeStockLink + '&nbsp;' + moveLinks + '&nbsp;' + stockHistoryLink + '&nbsp;' + allocationHistoryLink
                  };
                  this.push(data);
                  ++index;
                }
              }, wh.products);
              defer.resolve(wh.products);
            })
            .error(function (error)
            {
              if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
            return defer.promise;
          })
          .withPaginationType('simple_numbers')
          wh.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          wh.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            	$scope.$apply($compile(nRow)($scope));
            });
            wh.dtOptions.withOption('sDom', $rootScope.dom);
            wh.dtOptions.withOption('initComplete', function()
            {
            	angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            	angular.element('.dataTables_filter input').attr('class', 'form-control');
            	angular.element('.dataTables_length select').attr('class', 'form-control');
         	  });
          	wh.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          	wh.dtColumns = [
            	DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            	DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            	DTColumnBuilder.newColumn('name').withTitle('Name'),
            	DTColumnBuilder.newColumn('stock').withTitle('Stock'),
            	DTColumnBuilder.newColumn('allocated').withTitle('Allocated'),
            	DTColumnBuilder.newColumn('available').withTitle('Available'),
            	DTColumnBuilder.newColumn('updated_at').withTitle('Updated Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
              DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions')
            ];
        };

        $scope.AddStock = function (id,whid,pid)
        {
          $cookies.put('report-label-id',pid);
          $scope.WareHouseProductId = id;
          $scope.WareHouseId = whid;
          $scope.addqty = '';
          $scope.addbox = '';
          $scope.addnote = '';
          $scope.addsqty = '';
          
          apiService.loaderShow();
          $scope.boxqty = 0;  
          $http.get($rootScope.baseUrl + '/inventory/products/' + pid)
          .success(function(response) {
            apiService.loaderHide();
            if(response.boxqty != '') {
              $scope.productName = response.name;
              $scope.boxqty = response.boxqty;
            }
            else {
              $scope.boxqty = 0;
            }
          }).error(function (error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
          $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/inventoryManagement/wareHouse/addWarehouseStock.html',
              scope: $scope,
            });
        };

        $scope.RemoveStock = function (id,pid)
        {
          $cookies.put('report-label-id',pid);
          $scope.WareHouseProductId = id;
          apiService.loaderShow();
          $scope.boxqty = 0;  
          $http.get($rootScope.baseUrl + '/inventory/products/' + pid)
          .success(function(response) {
            if(response.boxqty != '') {
              $scope.boxqty = response.boxqty;
            }
            else {
              $scope.boxqty = 0;
            }
            apiService.loaderHide();
          }).error(function (error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
          $scope.popupShow = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/inventoryManagement/wareHouse/removeWarehouseStock.html',
            scope: $scope,
          });
          
        };

        $scope.ChangeTotalStock = function (qty,box,type)
        {
          if(!qty) { qty = 0; }
          if(!box) { box = 0; }
          console.log(box);
          console.log($scope.boxqty);
          var totalboxqty = 0;
          if(box > 0) {
            totalboxqty = ($scope.boxqty * box);
          }

          console.log(totalboxqty);
          
          var totalqty = 0;
          totalqty = (totalboxqty+qty);
          if(type=='add') {
            $scope.addsqty = totalqty;
          }
          else if(type=='move') {
            $scope.addsqty = totalqty;
          }
          else if(type=='remove') {
            $scope.removesqty = totalqty;
          }
        };

        $scope.saveWareHouseProduct = function ()
        {
          if (!this.WarehouseProductFrm.$valid) {
            toastr.error("Please enter required fileds");
            angular.element('#addsqty').focus();
            return;
          }
          if (!this.WarehouseProductFrm.addsqty.$valid) {
            toastr.error("Please enter qty grater than 0.");
            angular.element('#addsqty').focus();
            return;
          }

          apiService.loaderShow();
            var bodyData = {
              pid: $cookies.get('report-label-id'),
              whpid: $scope.WareHouseProductId,
              whid: $scope.WareHouseId,
              qty: this.addqty?this.addqty:0,
              boxqty: $scope.boxqty?$scope.boxqty:0,
              box: this.addbox?this.addbox:0,
              totalqty: this.addsqty,
              note: this.addnote,
              affected_by: $rootScope.globals.currentUser.id,
            };
            
          $scope.saveUrl = $rootScope.baseUrl + '/inventory/products/addwarehousestock';
          $scope.httpMethod = 'POST';
          $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              apiService.loaderHide();
              var response = response.data;
              if (response.code!= undefined && response.code == 0) {
                toastr.error(response.message);
              }else  if (response.status == 'success') {
                toastr.success(response.message);
                $state.go($state.$current, null, {
                  reload: true
                });
              } else {
                toastr.success(response.message);
              }
            }, function(error) {
              apiService.loaderHide();
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                $state.go('settings.create-product');
                toastr.error("Something went wrong please try again.");
              }
            });
        };

        $scope.removeWareHouseProduct = function ()
        {
          if (!this.WarehouseProductFrm.$valid) {
            toastr.error("Please enter required fileds");
            angular.element('#addqty').focus();
            return;
          }
          if (!this.WarehouseProductFrm.removesqty.$valid) {
            toastr.error("Please enter qty grater than 0.");
            angular.element('#removesqty').focus();
            return;
          }

          apiService.loaderShow();
          var bodyData = {
            pid: $cookies.get('report-label-id'),
            whpid: $scope.WareHouseProductId,
            qty: this.removeQty?this.removeQty:0,
            box: this.removebox?this.removebox:0,
            boxqty: $scope.boxqty?$scope.boxqty:0,
            totalqty: this.removesqty?this.removesqty:0,
            note: this.addnote,
            affected_by: $rootScope.globals.currentUser.id,
          };

          $scope.saveUrl = $rootScope.baseUrl + '/inventory/products/removewarehousestock';
          $scope.httpMethod = 'POST';
          $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              apiService.loaderHide();
              var response = response.data;
              if (response.code!= undefined && response.code == 0) {
                toastr.error(response.message);
              }else  if (response.status == 'success') {
                toastr.success(response.message);
                window.location.reload();
              } else {
                toastr.error(response.message);
              }
            }, function(error) {
              apiService.loaderHide();
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                $state.go('settings.create-product');
                toastr.error("Something went wrong please try again.");
              }
            });
        };

        $scope.openLogHistory = function (id)
        {
          $scope.stockLogsArr = [];
          $http.get($rootScope.baseUrl + '/inventory/products/warehouse-stock/' + id)
            .success(function(response) {
              $scope.stockLogsArr = response;
            }).error(function (error)
            {
              if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
          $('#wareHouseLogsModel').modal();
        };

        $scope.closeLogHistory = function ()
        {
          $scope.stockLogsArr = [];

          $('#wareHouseLogsModel').modal('hide');
        };

        $scope.openAllocationHistory = function(id)
        {
          $cookies.put('warehouse-product-id',id);
          $state.go('inventorymanagement.product-allocation');
        };

        $scope.moveStock = function (whpid,whid,pid)
        {
          $scope.WareHouseProductId = whpid;
          $scope.WareHouseId = whid;
          $scope.productId = pid;

          $scope.firstWareHouses = [];
          $scope.secondWareHouses = [];
          $scope.psku = '';
          $scope.pname = '';
          $scope.astock = 0;
          $scope.addqty = '';
          $scope.addbox = '';
          $scope.addsqty = '';
          $scope.addnote = '';
          $scope.fWareHouse = '';
          $scope.sWareHouse = '';

          apiService.loaderShow();
          var bodyData = {
            pid: pid,
            whpid: whpid,
            whid: whid
          };

          $scope.saveUrl = $rootScope.baseUrl + '/warehouse/active-store-warehouse';
          $scope.httpMethod = 'POST';
          $http(
          {
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response)
            {
              apiService.loaderHide();
              var response = response.data;
              if (response.status == 'success')
              {
                $scope.fWareHouse = response.warehouse_id;
                $scope.psku = response.product_sku;
                $scope.pname = response.product_name;
                $scope.astock = response.available_stock;
                $scope.firstWareHouses = response.from_warehouse;
                $scope.secondWareHouses = response.to_warehouses;
              }
              else {
                toastr.error(response.message);
              }
          }, function(error)
          {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
              toastr.error(error.data.message);
            } else {
              toastr.error("Something went wrong please try again.");
            }
          });

          apiService.loaderShow();
          $scope.boxqty = 0;  
          $http.get($rootScope.baseUrl + '/inventory/products/' + pid)
          .success(function(response) {
            if(response.boxqty != '') {
              $scope.boxqty = response.boxqty;
            }
            else {
              $scope.boxqty = 0;
            }
            apiService.loaderHide();
          }).error(function (error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
          $scope.popupShow = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/inventoryManagement/wareHouse/moveWarehouseStock.html',
            scope: $scope,
          });
        };

        $scope.moveWareHouseStock = function()
        {
          apiService.loaderShow();
          var whpid = $scope.WareHouseProductId;
          var whid = $scope.WareHouseId;
          var pid = $scope.productId;
          var bqty = $scope.addqty;
          var box = $scope.addbox;
          var tqty = $scope.addsqty;
          var boxqty = $scope.boxqty;
          var note = $scope.addnote;
          var twhid = $scope.sWareHouse;

          apiService.loaderShow();
          var bodyData = {
            pid: pid,
            whpid: whpid,
            whid: whid,
            towhid: twhid,
            box_qty: bqty,
            box: box,
            boxqty: boxqty,
            tot_qty: tqty,
            note: note,
            affected_by: $rootScope.globals.currentUser.id
          };

          $scope.saveUrl = $rootScope.baseUrl + '/warehouse/move-stock-warehouse';
          $scope.httpMethod = 'POST';
          $http(
          {
            url: $scope.saveUrl,
            method: $scope.httpMethod,
            data: $scope.dataUrlEncode(bodyData),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(function(response)
          {
            apiService.loaderHide();
              var response = response.data;
              if (response.status == 'success') {
                toastr.success(response.message);
                $state.go($state.$current, null, {
                  reload: true
                });
              }
              else {
                toastr.error(response.message);
              }
          }, function(error)
          {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
              toastr.error(error.data.message);
            } else {
              toastr.error("Something went wrong please try again.");
            }
          }
        );
      };
    }
})();
(function()
{
  'use strict';
  angular.module('BlurAdmin.pages.machineDashboard')
  .controller('machineDashboardCtrl', machineDashboardCtrl);

    /** @ngInject */
    function machineDashboardCtrl($scope, $timeout, apiService, $uibModal, $http, $rootScope, $q, toastr, $state, baConfig,$location, $interval,$cookies)
    {
      /**
      * permissionArr is use to check permission to display list
      * created on 11.15.2017
      */
      if ($rootScope.permissionArr.indexOf('machine_dashboard_dashboard') == -1)
      {
        $state.go('dashboard');
        toastr.error("You don't have permission to do this.");
      }
      var vm = this;
      $rootScope.currentState = 'machine-dashboard.dashboard';
      $scope.resetGlobalSearch();
      $scope.destroy=false;
      $scope.machineData = [];
      vm.showAll = true;
      vm.stores = [];
      vm.qrlogin_url = "https://3dinnodb.vip/";
      
      /**
      * declare data and reset global variables.
      * created on 11.23.2017
      */
      if (!$rootScope.datePickerRegular)
      {
        $rootScope.datePickerRegular = {
          date: $rootScope.datePicker.date
        };
      }
$scope.datePickerRegularShow = true;
      $rootScope.datePickerRegular={date:{startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}};

      /**
      * Options method is use configure date picker options
      * Created on 11.15.2017
      */
      $timeout(function() {
        angular.element('.input-mini').attr('readonly', true);
      }, 1000);
      $scope.options = {
        applyClass: 'btn-green',
        maxDate: moment(),
        locale: $rootScope.datePicker.locale,
        ranges: $rootScope.datePicker.options,
        eventHandlers: {
          'apply.daterangepicker': function() {
          $scope.datePickerRegularShow = true;
          $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
          $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
        },
        'hide.daterangepicker': function() {
          $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
          $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
        }
      }
    }

    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.focusInput = function() {
      angular.element('#dateRange').focus();
    }
    
    $scope.resetManualDate=function()
    {
      $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
      $rootScope.datePickerRegular.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
    }

    $scope.applyFilter = function()
    {
      if (!this.machineDashboardFrm.datePicker.$valid) {
        toastr.error("Please enter valid date range.");
        angular.element('#dateRange').focus();
        return;
      }

      $scope.getCrystalData();
      $scope.getMachineData();
    }

    $scope.resetFilter = function()
    {
      vm.stores = [];
      $rootScope.regularFlag = false;
      $rootScope.datePickerRegular={date:{startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}};
    }

    /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          vm.storeData = [];
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

    $scope.getMachineData = function() {
      apiService.loaderShow();
      var bodyData = {
        from_date: $scope.datePickerRegularShow ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $scope.datePickerRegularShow ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      $http.post($rootScope.baseUrl + '/database/getMachines', bodyData).success(function(response) {
        apiService.loaderHide();
        $scope.machineData = response;
        if (response && response.status == 'success') {
          
        } else {
          //toastr.error("Something went wrong please try again.");
        }
      }).error(function(error) {
        apiService.loaderHide();
        $rootScope.regularFlag = true;
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }

    $scope.getCrystalData = function() {
      var all = 1;
      if(vm.showAll == false) {
        var all = 0;
      }
      $scope.crystalData = [];
      $scope.total_slotted = 0;
      $scope.total_needed = 0;
      apiService.loaderShow();
      var bodyData = {
        from_date: $scope.datePickerRegularShow ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $scope.datePickerRegularShow ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : ''),
        showAll:all,
        stores:vm.stores.toString()
      };
      $http.post($rootScope.baseUrl + '/inventory/products/getCrystals', bodyData).success(function(response) {
        apiService.loaderHide();
        $scope.crystalData = response.data;
        $scope.total_slotted = response.total_slotted;
        $scope.total_needed = response.total_needed;
      }).error(function(error) {
        apiService.loaderHide();
        $rootScope.regularFlag = true;
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }

    /**
      * Open model.
      * created on 11.15.2017
    */
    $scope.open = function(productName, size, productId)
    {
      $rootScope.productName = productName;
      $rootScope.productId = productId;
      $rootScope.popupSize = $(window).height();
      $rootScope.popupSize = ($rootScope.popupSize - 40);
      $rootScope.popupSizeMin = ($rootScope.popupSize - 80);
      $rootScope.fromDate = $rootScope.datePickerRegular.date.startDate;
      $rootScope.toDate = $rootScope.datePickerRegular.date.endDate;
      
      $scope.popupShow = $uibModal.open({
        animation: true,
        size: size,
        templateUrl: 'app/pages/machineDashboard/dashboard/crystalStatusModal.html',
        scope: $scope,
      });
      
      $scope.killCrystalDetailsTimer();
      $scope.startCrystalDetailsTimer();
    };

    $scope.killCrystalDetailsTimer=function(){
      if(angular.isDefined($scope.crysalTimer))
        {
          $interval.cancel($scope.crysalTimer);
          $scope.crysalTimer=undefined;
        }
    };

    $scope.startCrystalDetailsTimer=function(){
      $scope.crysalTimer=$interval(function(){
        if($rootScope.productId){
          $scope.getCrystalStatus();
        }
      },10000);
    }
    $scope.startCrystalDetailsTimer();
    $scope.getCrystalStatus = function()
    {
      var listStatus = [];
      //apiService.loaderShow();
      var bodyData = {
        from_date: $scope.saveFromDateFormat($rootScope.fromDate),
        to_date: $scope.saveToDateFormat($rootScope.toDate),
        productId: $rootScope.productId ? $rootScope.productId : 0,
        store_id: $rootScope.storeListId ? $rootScope.storeListId : 0,
        fixstatus: $cookies.get('regularStatus')?$cookies.get('regularStatus'):'',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      $http.post($rootScope.baseUrl + '/ordertracker/crystal-status', bodyData).success(function(response) {
        //apiService.loaderHide();
        if (response && response.status == 'success') {
          $scope.readyshipment = false;
          var displaybtn = 0; var allStatus= 0;
          if (response.data && response.data.length == 0) {
            $rootScope.popupSize = 201;
          } else {
            $scope.statusData = response.data;
            $scope.regOrderTotal = response.total;
          }
        } else {
          toastr.error("Something went wrong please try again.");
        }

      }).error(function(error) {
        //apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }

    $scope.closePopup=function(){
      $rootScope.productId=undefined;
      $scope.killCrystalDetailsTimer();
      $scope.startCrystalDetailsTimer();
    }
  }
})();
/**
 * Machine dashboard controller is handle all actions related to Settings.
 * @author Nikunj SilverCayde
 * created on 11.7.2017
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.machineDashboard')
    .controller('machineDashboardSettingsCtrl', machineDashboardSettingsCtrl);
  /** @ngInject */
  function machineDashboardSettingsCtrl($scope, apiService, $http, $rootScope, toastr, $state)
  {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.7.2017
     */
    if ($rootScope.permissionArr.indexOf('machine_dashboard_settings') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'machine-dashboard.settings';
    $scope.resetGlobalSearch();
    /**
     * declare data.
     * created on 11.10.2017
     */
    vm.orderStatusData = [];
    $scope.setOfSets = [];
    /**
     * get Selected Status Data method is use to display Selected status data.
     * created on 11.10.2017
     */
    $scope.getSelectedStatusData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/setting/machine-dashboard')
          .success(function (result) {
            $scope.isloaded = true;
            if(result){
              if(result.status=='success'){
                vm.selectedStatusData = result.data;
                if(result.data.locationStatus){
                  vm.locationStatus=result.data.locationStatus;
                }
              }else{
                vm.locationStatus=[
                          {
                            "_id": {
                              "block": "All Orders In Bin",
                              "key":"allOrdersInBeen",
                              "color_code": "#ae8801",
                              "img": "thumbs-up"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Ready To Ship",
                              "key":"readyToShip",
                              "color_code": "#87b986",
                              "img": "thumbs-up"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "All In Production",
                              "key":"allInProduction",
                              "color_code": "#00aeef",
                              "img": "clock-circular-outline"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Not Ready To Ship",
                              "key":"notReadyToShip",
                              "color_code": "#9e0b0f",
                              "img": "cancel"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Shipped",
                              "key":"shipped",
                              "color_code": "#6d370a",
                              "img": "truck"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Arrived",
                              "key":"arrived",
                              "color_code": "#181568",
                              "img": "truck"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "No Orders",
                              "key":"noOrders",
                              "color_code": "#000000",
                              "img": "skull"
                            },
                            "status": []
                          }
                        ];
              }
              var half_length = Math.ceil(vm.locationStatus.length / 2);
              var leftArray = vm.locationStatus.splice(0,half_length);
              var rightArray = vm.locationStatus.splice(0,vm.locationStatus.length);
              $scope.setOfSets.push(leftArray);
              $scope.setOfSets.push(rightArray);
            }
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });
    }
    /**
     * get Active Status Data method is use to display Active status data.
     * created on 10.26.2017
     */
    $scope.getActiveStatusData = function() {
      $scope.isloaded = false;
      $http.post($rootScope.baseUrl + '/status/activeAll')
          .success(function (result) {
            vm.orderStatusData = result;
            $scope.isloaded = true;
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message, 'Error');
              }
          });
    }
    /**
     * get Regular Status Data method is use to display Regular status data.
     * created on 11.22.2017
     */
    vm.regularStatusData=[{color_code:"#000000",is_active:1,status_code:"none",status_label:"NONE"}]
    $scope.getRegularStatusData = function() {
      $scope.isloaded = false;
      //$http.get($rootScope.baseUrl + '/config/setting/shipping-block')
      $http.post($rootScope.baseUrl + '/status/activeAll')
          .success(function (result) {
            //var regularBlock=result.data.shipping_block_status[0].status;
            var regularBlock=result;
            angular.forEach(regularBlock,function(val,key){
              vm.regularStatusData.push(val);
            });
            $scope.isloaded = true;
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message, 'Error');
              }
          });
    }
    /**
    * remove regular status data method is use to delete regular status.
    * created on 06.07.2018
    */
    $scope.removeRegularStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 06.07.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }
    /**
    * sortable Options.
    * created on 06.07.2018
    */
    $scope.sortableOptionStatus = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
    /**
     * save Machine Dashboard Settings Data method is use to add Shipping Tracker data.
     * created on 11.10.2017
     */
    $scope.saveMachineDashboardSettings = function(){
          $scope.temp = [];
          angular.forEach($scope.setOfSets,function(value,key){
            angular.forEach(value,function(val,ke){
              $scope.temp.push(val);
            });
          });
        vm.shippingTrackerData = {};
          vm.shippingTrackerData = {
              'locationStatus':$scope.temp
          };
        apiService.loaderShow();
        var bodyData = {
          settingData: angular.toJson(vm.shippingTrackerData),
        };
        $http.post($rootScope.baseUrl + '/config/setting/save-machine-dashboard', bodyData).success(function(response) {
          apiService.loaderHide();
          toastr.success(response.message);
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
    }
    
  }
})();

/**
 * Block type controller handle all action related.
 * @author Anand Malvi <anand.malvi@brainvire.com>
 * created on 09.26.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.productList')
    .controller('productBlockCtrl', productBlockCtrl);

  /** @ngInject */
  function productBlockCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile,router) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.26.2017
     */
    if($rootScope.permissionArr.indexOf('product_list_menu') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='product-list.block-list';
    $scope.resetGlobalSearch();
    function renderWithBlockType(data,full,type){
      if(data){
        if(data=='is_regular'){
          return 'Regular';
        }else if(data=='is_customer'){
          return 'Customer';
        }else if(data=='is_express'){
          return 'Express';
        }else if(data=='is_supply'){
          return 'Supply';
        }else if(data=='is_rework'){
          return 'Rework';
        }else if(data=='all'){
          return 'All';
        }else{
          return '';
        }
      }else {
        return '';
      }
    }
    /**
     * Get data table method is use get list of Block type setting.
     * created on 09.26.2017
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/products/block')
                .success(function(result) {
                  localStorage.setItem('blockList',JSON.stringify(result));
                  $scope.reloadState();
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.departments = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_block_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editProductBlock(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'product_block_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/productList/blockTypeSetting/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_block_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/productList/blockTypeSetting/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_block_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/productList/blockTypeSetting/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              name: value.name,
              type:value.block_type,
              index:index,
              created_at: value.created_at,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.departments);
          defer.resolve(vm.departments);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Block Name'),
        DTColumnBuilder.newColumn('type').withTitle('Type').renderWith(renderWithBlockType),
        DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('product_block_edit') !== -1 || $rootScope.permissionArr.indexOf('product_block_delete') !== -1 || $rootScope.permissionArr.indexOf('product_block_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add product block method is use for get add product page.
     * created on 09.26.2017
     */
    $scope.addProductBlock = function() {
        $cookies.put('product-block-id', undefined);
        $state.go('product-list.add-product-block');
    }

    /**
     * Edit block type method is use for get edit block page.
     * created on 09.26.2017
     */
    $scope.editProductBlock = function(id) {
      $cookies.put('product-block-id',id);
      $state.go('product-list.edit-product-block');
    }

    /**
     * Open model.
     * created on 09.26.2017
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of Block.
     * created on 09.26.2017
     */
    $scope.blockChangeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status:  ""+$rootScope.status+"",
          updated_by:$rootScope.globals.currentUser.id
        };
        $http.put($rootScope.baseUrl + '/products/block', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('product-list.block-list');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete Block method is use for delete Block.
     * created on 09.26.2017
     */
    $scope.deleteProductBlock = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/products/block/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Block deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save Block data method is use for update/add block data.
     * created on 09.26.2017
     */
    $scope.saveBlockData = function() {
      var vm = this;
       if (!this.productBlockFrm.blockName.$valid) {
        toastr.error("Please enter block name.");
        angular.element('#blockName').focus();
        return;
      } else if (!this.productBlockFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }
//      else if (!this.productBlockFrm.deptIcon.$valid) {
//       toastr.error("Please select department icon.");
//       angular.element('#deptIcon').focus();
//       return;
//     }

       apiService.loaderShow();
      var bodyData = {
        name: this.blockName,
        status: this.status,
        //department_icon: this.departmentIcon,
        block_type:this.blockType,
        affected_by: $rootScope.globals.currentUser.id,
      };


      $scope.saveUrl = $rootScope.baseUrl + '/products/block';
      $scope.httpMethod = 'POST';
      $scope.productBlockId = this.productBlockId;
      if (this.productBlockId) {
        $scope.saveUrl = $rootScope.baseUrl + '/products/block/' + this.productBlockId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Block ' + ($scope.productBlockId ? 'updated' : 'added') + ' successfully.');
          $state.go('product-list.block-list');
        } else {
          $state.go('product-list.add-product-block');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This Block name already exists.');
                angular.element('#blockName').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('product-list.block-list');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited block method is use for get edited block data.
     * created on 09.26.2017
     */
    $scope.getEditedBlock = function() {


        if($rootScope.permissionArr.indexOf('add_product_block') == -1 && $rootScope.permissionArr.indexOf('product_block_edit') == -1 && $rootScope.permissionArr.indexOf('assign_product_block') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('product-block-id') && $cookies.get('product-block-id')!= undefined) {

          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/products/block/' + $cookies.get('product-block-id'))
            .success(function(response) {
              vm.blockName = response.name;
              vm.productBlockId = response._id;
              vm.status = response.status;
              //vm.departmentIcon=response.department_icon;
              vm.blockType=response.block_type?response.block_type:'none';
              vm.orderStatus = response.statusList;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('product-list.add-product-block');
        }
    };

    /**
     * Get block status method is use for go to block status page.
     * created on 09.26.2017
     */
    $scope.assignBlockStatus = function() {
      $state.go('product-list.product-block-status');
    };
    /**
     * drag and drop status data.
     * created on 09.27.2017
     */
     $scope.getStatusAndProductBlockData = function() {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
                .success(function (result) {
                  $scope.orderStatus = result;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    }
                    $state.go('product-list.block-list');
                });
            /**
             * get department status data.
             * created on 09.27.2017
             */
            $scope.setOfSets = [];
            $http.get($rootScope.baseUrl + '/products/setting')
                    .success(function (result) {
                      $scope.itemsList=result;
                      var half_length = Math.ceil($scope.itemsList.length / 2);
                      var leftArray = $scope.itemsList.splice(0,half_length);
                      var rightArray = $scope.itemsList.splice(0,$scope.itemsList.length);
                      $scope.setOfSets.push(leftArray);
                      $scope.setOfSets.push(rightArray);
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        $state.go('product-list.block-list');
                    });

            $scope.$watch('setOfSets', function(model) {
                $scope.modelAsJson = angular.toJson(model, true);
                $scope.temp = {}
                if(model && model!= undefined){
                  angular.forEach(model, function (value, key) {
                    angular.forEach(value, function (val, ky) {
                    var demo = [];
//                    console.log(val.status);
                    angular.forEach(val.status, function (value1, key1) {
                          demo.push({'status':value1.status_label,'status_code':value1.status_code?value1.status_code:'','color_code':value1.color_code?value1.color_code:'','is_active':(value1.is_active != undefined ? value1.is_active:1)})
                    });
                    $scope.temp[val._id.block] = demo;
                  });
                  });
                }
            }, true);
    };
    /**
    * Add block status data method is use to save block status.
    * created on 09.27.2017
    */
    $scope.addBlockStatus= function(){
       apiService.loaderShow();
       var bodyData={'settingdata':JSON.stringify($scope.temp)};
       $http.post($rootScope.baseUrl + '/products/setting',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('product-list.block-list');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
     }

    /**
    * remove block status data method is use to delete block status.
    * created on 09.27.2017
    */
    $scope.removeBlockStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 09.27.2017
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 09.27.2017
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
    $scope.reloadState = function() {
            router.setUpRoutes();
        };
    /**
    * get department icon list
    * created on 04.03.2018
    */
    /* $scope.getDepartmentIconList = function() {
     $http.get($rootScope.baseUrl + '/departments/depicon')
         .success(function (result) {
           if(result.status!="fail"){
             angular.element(document).ready(function () {
               angular.element('#deptIcon').selectpicker("refresh");
             });
             $scope.departmentIconList = result;
           }
         }).error(function (error) {
             if (error.data && error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             }
         });
    } */

  }

})();

/**
 * Orders controller handle all action related orders.
 * @author Anand Malvi <anand.malvi@brainvire.com>
 * created on 02.12.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.shippingTracker')
            .controller('resaveCtrl', resaveCtrl);

    /** @ngInject */
    function resaveCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory) {

        //$rootScope.currentState = 'shipping-board.resave';
        $rootScope.currentState = $state.current.name;
        var vm = this;

        // get dynamic product list type
        vm.blockType=$state.current.params.block_type;
        $scope.activeTabIndex=0;
        $scope.shortByField = '';
        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer','Keyword'];
        $scope.colvisOption = [{name: 'colvis',text: 'Select Columns',extend: 'colvis'}]//columns: ':gt(0)'
        $scope.vmAdded = this;
        $scope.orderDetailsData = {};
        $scope.jobtypeArr = [
            '2D-3D',
            '2D Flat',
            'Redesign'
        ];
        $scope.engravingArr = [
            'Add ENG',
            'No ENG'
        ];

        $scope.datePickerRegularShow = true;
        if (!$rootScope.datePickerRegular) {
          $rootScope.datePickerRegular = {
            date: $rootScope.datePicker.date
          };
        }


        if($rootScope.searchStatus){
            $scope.orderStatusSelected={
              selected : {label:$rootScope.searchLable ,value:$rootScope.searchStatus}
            };
            $scope.dashboardBlock=$rootScope.dashboardBlockName;
        }else{
            $scope.orderStatusSelected = {
              selected:{}
            };
        }
        /**
         * Add global search on order table
         * Created on 09.02.2018
         */
        if($rootScope.globalsearchBy && $rootScope.globalSearch){
            $timeout(function () {
                $scope.serchBy = $rootScope.globalsearchBy;
                $scope.SearchQuery = $rootScope.globalSearch;
                $scope.vmAdded.dtInstance.DataTable.draw();
            }, 100);
        }

        $timeout(function () {
           angular.element('.input-mini').attr('readonly',true);
        }, 1000);

        $rootScope.datePickerOrder = {};
        $rootScope.datePickerOrder.date = $rootScope.datePicker.date;

        if($rootScope.productNumber){
            $scope.datePickerOrderShow = false;
            $scope.productNumber = $rootScope.productNumber;
        }else{
            $scope.datePickerOrderShow = true;
        }

        $scope.onSelect = function(item, $model) {
        };

        /**
        * Api search for order status method is use search order status for filter
        * created on 10.06.2017
        */
        $scope.apiSearchForOrderStatus = function (query) {
            if(!$rootScope.globals.currentUser || !$rootScope.globals.currentUser.statusPermission){
                return false;
            }
            var defaultStatus = $rootScope.globals.currentUser.statusPermission.toString();
            $http.post($rootScope.baseUrl + '/status/active',{status:query?query:'',defaultStatus:defaultStatus}).then(
            function (response) {
                var temp = []
                 angular.forEach(response.data,function(value){
                    if($rootScope.searchStatus != value.status_label){
                      temp.push({label: value.status_label, value: value.status_code});
                    }
                });
                //$scope.listOrderStatus.devs = temp;
                $scope.listOrderStatus = temp;
                angular.element(document).ready(function () {
                        angular.element('#orderStatus').selectpicker('refresh');
                    });
            },
            function () {

            });
        }

        /**
        * Options method is use configure date picker options
        * created on 10.06.2017
        */
        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers: {
                'apply.daterangepicker': function () {
                    $scope.datePickerRegularShow = true;
                    $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
                },
                'hide.daterangepicker': function () {
                    $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
                }
            }
        }
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }
        $scope.showFilters = false;
        /**
        * Search apply is use to apply filters
        * created on 10.05.2017
        */
        $scope.searchApply = function (){
            if($scope.orderStatusSelected.selected){
              $rootScope.searchStatus = $scope.orderStatusSelected.selected.value;
              //$scope.showStatusArr = $scope.orderStatusSelected.selected.label;
              $rootScope.searchLable = $scope.orderStatusSelected.selected.label;
            }

            $scope.vmAdded.dtInstance.DataTable.draw();
            $('#statusModelCompany').modal('hide');
        }

        /**
        * orderList Global Search use to search global
        * created on 10.04.2017
        */
        $scope.orderListGlobalSearchLocal = function (){
            var query = angular.element('#searchInput').val();
            if(!query){
               $scope.serchBy = 'Select Search By';
            } else {
               //$scope.serchBy = 'Product';
               $scope.serchBy = 'Keyword';
            }
            $scope.SearchQuery = query;
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /*$rootScope.$on("CallParentMethod", function(){
           $scope.orderListGlobalSearchLocal();
        });*/

         var customeEventListener = $rootScope.$on("CallParentMethod", function(){
           $scope.orderListGlobalSearchLocal();
        });

        $scope.$on('$destroy', function() {
            customeEventListener();
            $scope.$on('CallParentMethod', function(event, data) {});
        });

        /**
        * remove Single Filter method is use to remove single filter
        * created on 10.12.2017
        */
        $scope.removeSingleFilter = function (type){
            if(type == 'date'){
                $scope.datePickerRegular.date = false;
                $rootScope.datePickerRegular.date={};
            }else if(type == 'productNumber'){
                  vm.productNumber = '';
            }else if(type == 'productFromTo'){
                  vm.productFromTo = '';
            }else if(type == 'productStatus'){
                  vm.productStatus = '';
            }
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * reset Search is use to reset filters
        * created on 10.04.2017
        */
        $scope.resetSearch = function () {
            $rootScope.searchStatus = undefined;
            $scope.orderStatusSelected = {
                selected: {}
            };
            angular.element(document).ready(function () {
                angular.element('#orderStatus').selectpicker('refresh');
            });
            vm.productNumber = '';
            vm.productFromTo = '';
            vm.productStatus = '';
            $rootScope.datePickerRegular = {date: {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}};
            $scope.vmAdded.dtInstance.DataTable.draw();
        }



        var canceler = $q.defer();
        /**
        * Server data method is use for load data from API.
        * created on 09.27.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            $scope.checkS =  canceler.resolve();

            canceler = $q.defer();

            var prmissionArr = [];
            if($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.statusPermission){
               prmissionArr = $rootScope.globals.currentUser.statusPermission.toString();
            }

            var log = [];
            var columname = '';
            var sortColmkey = '';
            angular.forEach(aoData[1].value, function (value, key) {
              if (value.data == 'created_at') {
                    columname = value.data
                    sortColmkey = key;
                }

            }, log);

            var requestData={
              start: aoData[3].value,
              length: aoData[4].value,
              draw: aoData[0].value,
              order: aoData[2].value,
              search: aoData[5].value,
              columns: aoData[1].value,
              sortcolum:columname,
              sortColmkey: sortColmkey,
              search_column: $scope.serchBy?$scope.serchBy:'',
              customer_id: vm.customerId ? vm.customerId : '',
              product_number: vm.productNumber ? vm.productNumber : '',
              product_from_to: vm.productFromTo ? vm.productFromTo : '',
              product_status: vm.productStatus ? vm.productStatus : '',
              query_string: $scope.SearchQuery?$scope.SearchQuery:'',
              from_date: $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate),
              to_date: $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate),
              permission_statuses: $rootScope.searchStatus?$rootScope.searchStatus:prmissionArr,
              def_sortable_column : $scope.shortByField,
              block_name:vm.blockType
            }

            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/orderdetail/get-items',
                data: requestData,
                headers: {
                    'Content-type': 'application/json'
                },
                timeout: canceler.promise
            }).then(function(result) {
                 //apiService.loaderHide();
                 $scope.supplyOrderTotal=result.data;
                  var result = result.data.original;
                  if(result.data < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //apiService.loaderHide();
                fnCallback(records);
            },function errorCallback(response) {
                if(response.status && response.status != -1){
                 //apiService.loaderHide();
                }
            })
        };

        /**
        * Order details method is use for redirect to product details page.
        * created on 10.06.2017
        */
        function orderDetails(data,type,full){
            return '<a href="" ng-click="open(\''+data+'\',\'' + 'order-details-popup' + '\',\''+full.entity_id+'\')" title="View Order" style="color:white;text-decoration: underline !important;">'+data+'</a>'
        }

        /**
        * Added actions
        * created on 10.06.2017
        */
        function actionColumn(data,type,full){
            return ''
        }


        /**
         * Render shipping to user name else -
         */
        function renderShipToName(data,type,full){
            if (data) {
                return data;
            } else {
                return ' - ';
            }
        }



        /**
        * Compile row method is use for compile row in angular.
        * created on 10.06.2017
        */
        function compileRow(row,data){
            $(row).css("background-color", data.color_code?data.color_code:"#8FB801");
            $compile(angular.element(row).contents())($scope);
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * created on 10.06.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }



        /**
         * getHtmlDataText method is used get content from html string.
         * created on 02.20.2018
         */
        $scope.getHtmlDataText = function(text){
            if(/^/.test(text)){
                var div = document.createElement("div");
                div.innerHTML = text;
                return div.textContent || div.innerText || "";
            }
            return text;
        }

        /**
         * checkIsTextArea method is used identify field are text area.
         * created on 10.09.2017
         */
        $scope.checkIsTextArea = function(type){
            var textAreaArr = [
                'Any Special Instructions?',
                'Enter Your Engraving',
                'Special Instruction',
                'Add Free Engraving',
                'Special Instructions'
            ];
            if(textAreaArr.indexOf(type) != -1){
                return true;
            }
            return false;
        }


        /**
         * Get data table method is use for get list of users.
         * created on 09.27.2017
         */
         $scope.orderDom= "<'row'<'col-md-3 clearfix'l><'col-md-6 form-group clearfix mt-5px'p><'col-md-3' ZB>>" +
         "<rt>" +
         "<'row'<'col-md-5'i><'col-md-7'p>><'clear'>";
        $scope.getProductDataTable = function() {
            var vm = this;
            var orderFromTitle='Order From';
            if($stateParams.type=='customer'){
              orderFromTitle='Customer Name';
            }
            var totalPermission = 0;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('DT_Row_Index').withTitle('Sr.No').withOption('orderable', false));

            if($rootScope.permissionArr.indexOf('resave_product_number_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Product Number')/*.renderWith(orderDetails)*/);
            }
            if($rootScope.permissionArr.indexOf('product_from_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('cust_name').withTitle('Order From').renderWith($scope.UcCap));
            }
            if($rootScope.permissionArr.indexOf('resave_product_to_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to_name').withTitle('Order To').renderWith(renderShipToName));
            }
            if($rootScope.permissionArr.indexOf('resave_product_status_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('item_status').withTitle('Status').withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('resave_product_date_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('resave_product_action_column') != -1){
                totalPermission = totalPermission + 1;
                // vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Action').renderWith(actionColumn).withOption('className', 'tableActions').withOption('orderable', false));
                vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Action').renderWith($scope.orderActionHtml).withOption('className', 'tableActions').withOption('orderable', false));
            }

            var sortColNum = $rootScope.productDefaultSort
            if (totalPermission <= 5) {
                sortColNum = 1;
                $scope.shortByField = 'created_at';
            } else {
                $scope.shortByField = '';
            }

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('autoWidth', false)
//                .withOption('sDom', 'ZlB< "row" >rtip')
                .withOption('sDom', $scope.orderDom)
                .withOption('bLengthChange', true)
                .withOption('order', [sortColNum, 'desc'])
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1) )
                .withOption('bInfo', true)
                .withButtons($scope.colvisOption)
                .withOption('oLanguage',{ "sSearch": "" })
                .withOption('createdRow',compileRow)
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
            $rootScope.vmAddedNew = vm
        }

        /**
         * Open Order Details model.
         * created on 10.09.2017
         */
        $scope.open = function (id, size,entityId) {
            $scope.orderDetailsData = [];
            $scope.commentDataArr = [];
            $scope.addOnDataArr = [];
            $scope.orderAddress = [];
            $scope.addOneData = [];

            $rootScope.orderId = id;
            $rootScope.orderEntityId=entityId;
            $rootScope.popupSize = $(window).height();
            $rootScope.popupSize = ($rootScope.popupSize-60);
            $rootScope.popupSizeMin = ($rootScope.popupSize-50);
            $rootScope.borderSize=($rootScope.popupSizeMin-100);
            $scope.killOrderListTimer();
            //$scope.getOrderDetails();
            $('#orderDetailsModel').modal();
            $scope.getOrderAddress();
            $scope.getShowAddOnData();
            $scope.getAddOnData();
            $scope.getQaDesignData();
            $scope.getOrderDetailsData();
            $scope.getCommentData();
            $scope.getEditAndLogSetting();
            $scope.getDynamicButton();
            $scope.getReworkSettingData();
            $scope.getJobSettingData();
            $scope.getPullJobSettingData();
            $scope.getRelaySettingData();
            $scope.startOrderDetailsTimer();
            $scope.startOrderCommentTimer();
            $scope.getOrderDetails();
        };


        $scope.subTabSelected = function (QtyId) {
            $scope.selectedQtyId = QtyId;
        };

        $scope.tabSelected = function (item_id) {
              $scope.selectedId = item_id;
              setTimeout(function(){
                $("li.single-right-tab").parent().css('display','none');
                angular.element('.product-name').selectpicker('refresh');
              }, 100);
        };


        $scope.closePopup=function(){
            $rootScope.orderId=undefined;
            $('#orderDetailsModel').modal('hide');
            $scope.orderDetailsData = [];
            $scope.commentDataArr = [];
            $scope.addOnDataArr = [];
            $scope.orderAddress = [];
            $scope.addOneData = [];
            $scope.killOrderDetailsTimer();
            $scope.killOrderCommentTimer();
            $scope.startOrderListTimer();
            $scope.vmAdded.dtInstance.DataTable.draw( false );
        }


        $scope.closeOrderLogs = function (id,page) {
            $('#orderLogsModel').modal('hide');
        };


        /**
         * Open OrderLog model.
         * created on 10.09.2017
         */
        $scope.openLogHistory = function (id) {
            $rootScope.logIncrementId = id;
            $scope.orderLogsArr = [];
            $scope.orderLogsLoaded = false;
            $scope.getOrderLogs();
            $('#orderLogsModel').modal();
//            $scope.popupShow = $uibModal.open({
//              animation: true,
//              templateUrl: page,
//              scope:$scope,
//              size: 'order-log-model',
//            });
        };
        $scope.openProductLogModal = function (id) {
            $rootScope.logIncrementId = id;
            $scope.orderLogsLoaded = false;
            $scope.getPropertyLogs();
            $('#productLogsModel').modal();
        };
        $scope.closeProductLogModal=function(){
          $('#productLogsModel').modal('hide');
        }
        $scope.openEngravingLogModal = function (id) {
            $rootScope.logIncrementId = id;
            $scope.orderLogsLoaded = false;
            $scope.getEngravingLogs();
            $('#engravingLogsModel').modal();
        };
        $scope.closeEngravingLogModal=function(){
          $('#engravingLogsModel').modal('hide');
        }
        $scope.openRelayLogModal = function (id) {
            $rootScope.relayIncrementId = id;
            $scope.orderLogsLoaded = false;
            $scope.getRelayLogs();
            $('#relayLogsModel').modal();
        };
        $scope.closeRelayLogModal=function(){
          $('#relayLogsModel').modal('hide');
        }




        /**
         * GetSortOrderNumber is use to get short number of order.
         * created on 11.29.2017
         */
        $scope.getSortOrderNumber = function(num,event){
            var temp = num.split('-');
            return temp[1];
        }






        /**
         * Show AddOn is use to show AddOn options controller.
         * created on 11.29.2017
         */
        $scope.showAddOne = function($event){
            $scope.killOrderDetailsTimer();
            var target = angular.element($event.target);
            if(target.attr('isIcon')){
               target = angular.element($event.target).parent();
            }
            target.toggleClass('hide-element');
            target.parent().find('.popuptext').addClass('show');
            target.parent().find('.addone-apply-btn').removeClass('hide-element');
            target.parent().parent().find('.cancel-addone').removeClass('hide-element');

        }

        /**
         * Cancel AddOn is use to Cancel AddOn options.
         * created on 11.29.2017
         */
        $scope.cancelAddOne = function($event){
            $scope.startOrderDetailsTimer();
            var target = angular.element($event.target);
            if(target.attr('isIcon')){
               target = angular.element($event.target).parent();
            }
            target.addClass('hide-element');
            target.parent().find('.popuptext').removeClass('show');
            target.parent().find('.addone-apply-btn').addClass('hide-element');
            target.parent().find('.add-addone').removeClass('hide-element');
            target.parent().find('.add-addone').addClass('show-element');
        }

        /**
         * AddOn Info is use to show AddOn options popup.
         * created on 11.29.2017
         */
        $scope.addOneInfo = function(event){
            var target = angular.element(event.target);
            //target.toggleClass('hide-element');
            target.parent().find('.showpopuptext').addClass('show');
            //target.parent().find('.show-addone').removeClass('hide-element');
            target.parent().find('.show-popup-close').removeClass('hide-element');
        }

        /**
         * Close AddOn Info is use to hide AddOn options popup.
         * created on 11.29.2017
         */
        $scope.closeAddOnShow = function(event){
            var target = angular.element(event.target);
            target.closest('.showpopuptext').removeClass('show');
        }




        /**
         * dynamic display order popup button api
         * created on 11.04.2018
         */
         $scope.getDynamicButton=function(){
             $http.get($rootScope.baseUrl + '/orderpopupbuttons/activebutton')
               .success(function(result) {
                 $scope.dynamicBtnList=result;
               }).error(function (error) {
                   if (error.code != undefined && error.code == 0) {
                       toastr.error(error.message);
                   }
               });
         }
         $scope.checkMultipleStatusForBtn=function(type,status){
           return true;
         }
         /**
          * CheckStatusForBtn method is used for show hide buttons by status.
          * created on 10.09.2017
          */
         $scope.checkStatusForBtn = function(show_status, status){
           var showStatus=angular.fromJson(show_status);
           if(showStatus.indexOf(status)===-1){
             return false;
           }else{
             return true;
           }
         }



         /**
          * copy engraving success and fail message.
          * created on 11.06.2018
          */
         $scope.success = function () {
            toastr.success('Copied!');
          };

          $scope.fail = function (err) {
            toastr.error('Error!', err);
          };
          /**
           * getEditAndLogSetting method is use to get product and engraving edit btn and log settings.
           * created on 21.06.2018
           */
          $scope.getEditAndLogSetting=function(){
            $http.get($rootScope.baseUrl + '/config/setting/save-edit-button')
                    .success(function (result) {
                      if(result.data && result.data!=undefined){
                        $scope.editBtnStatus=result.data;
                        angular.forEach($scope.editBtnStatus,function(val,key){
                          var status=[];
                          angular.forEach(val.status,function(stsVal,stsKey){
                            status.push(stsVal.status_label);
                          });
                          $scope.editBtnStatus[val.name]={'status':status};
                        });
                      }
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data && error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        }
                    });
          }

          /**
           * Get all products list method is use to get product data.
           * created on 07.13.2018
           */
          $scope.getAllProductsList = function(){
              $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
              .success(function (response) {
                $scope.allProducts=response;
               angular.element(document).ready(function () {
                 $timeout(function () {
                     angular.element('.product-name').selectpicker('refresh');
                 }, 1000);
               });
              }).error(function (response) {
              });
          }
          $scope.getAllProductsList();



          // order list auto refresh
          $scope.startOrderListTimer=function(){
            $scope.orderListTimer=$interval(function(){
              if($location.path() == '/orders'){
                  $rootScope.vmAddedNew.dtInstance.DataTable.draw(false);
                }
            },$rootScope.apiIntervalTimeOrders * 60 * 1000);
          }
          $scope.startOrderListTimer();
          $scope.killOrderListTimer=function(){
            if(angular.isDefined($scope.orderListTimer))
              {
                $interval.cancel($scope.orderListTimer);
                $scope.orderListTimer=undefined;
              }
          };
          // order details  auto refresh
          $scope.startOrderDetailsTimer=function(){
            $scope.orderDetailsTimer=$interval(function(){
              if($location.path() == '/orders'){
                if($rootScope.orderId){
                         $scope.getOrderDetails(1);
                       }
                }
            },10000);
          }
          $scope.killOrderDetailsTimer=function(){
            if(angular.isDefined($scope.orderDetailsTimer))
              {
                $interval.cancel($scope.orderDetailsTimer);
                $scope.orderDetailsTimer=undefined;
              }
          };
          // order details  auto refresh
          $scope.startOrderCommentTimer=function(){
            $scope.orderCommentTimer=$interval(function(){
              if($location.path() == '/orders'){
                if($rootScope.orderId){
                         $scope.getCommentData();
                       }
                }
            },1000*60);
          }
          $scope.killOrderCommentTimer=function(){
            if(angular.isDefined($scope.orderCommentTimer))
              {
                $interval.cancel($scope.orderCommentTimer);
                $scope.orderCommentTimer=undefined;
              }
          };

       }
})();

/**
 * group controller handle all action related group configuration.
 * @author Harsha Prajapati
 * created on 09.12.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.relaySettings')
    .controller('groupCtrl', groupCtrl);

  /** @ngInject */
  function groupCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.12.2018
     */
    if($rootScope.permissionArr.indexOf('group_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='relay-settings.group-list';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of group.
     * created on 09.12.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/customerrelaygroup')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.group = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'group_edit'+'\') !== -1" href="javascript:void(0);" ng-click="editGroup(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'group_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/relaySettings/group/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'group_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/group/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'group_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/group/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              group_name: value.group_label,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.group);
          defer.resolve(vm.group);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('group_name').withTitle('Group Label'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('group_edit') !== -1 || $rootScope.permissionArr.indexOf('group_delete') !== -1 || $rootScope.permissionArr.indexOf('group_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add group method is use for get add group page.
     * created on 09.12.2018
     */
    $scope.addGroup = function() {
      $cookies.put('group-id',undefined);
      $state.go('relay-settings.add-group');
    }

    /**
     * Edit group method is use for get edit group page.
     * created on 09.12.2018
     */
    $scope.editGroup = function(id) {
      $cookies.put('group-id',id);
      $state.go('relay-settings.edit-group');
    }

    /**
     * Open model.
     * created on 09.12.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of group.
     * created on 09.12.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/customerrelaygroup', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('relay-settings.group-list');
              toastr.error("Something went wrong please try again.");
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete group method is use for delete group.
     * created on 09.12.2018
     */
    $scope.deleteGroup = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/customerrelaygroup/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Group deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save group data method is use for update/add group data.
     * created on 09.12.2018
     */
    $scope.saveGroupData = function() {
       if (!this.groupFrm.$valid) {
          return;
        }
       apiService.loaderShow();
      var bodyData = {
        group_label: vm.groupLabel,
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/customerrelaygroup';
      $scope.httpMethod = 'POST';
      //$scope.groupId = vm.groupId;
      if (vm.groupId) {
        $scope.saveUrl = $rootScope.baseUrl + '/customerrelaygroup/' + vm.groupId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status == 'success') {
          toastr.success('Group ' + (vm.groupId ? 'updated' : 'added') + ' successfully.');
          $state.go('relay-settings.group-list');
        } else {
          toastr.error(response.message);
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This group label already exists.');
                angular.element('#groupLabel').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('relay-settings.group-list');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited group method is use for get edited group data.
     * created on 09.12.2018
     */
    $scope.getEditedGroup = function() {

        if($rootScope.permissionArr.indexOf('group_add') == -1 && $rootScope.permissionArr.indexOf('group_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('group-id') && $cookies.get('group-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/customerrelaygroup/' + $cookies.get('group-id'))
            .success(function(response) {
              apiService.loaderHide();
              vm.groupLabel = response.group_label;
              vm.groupId = response._id;
              vm.status = response.status;
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('relay-settings.add-group');
        }
    };

  }

})();

/**
 * priority controller handle all action related priority configuration.
 * @author Anand Malvi
 * created on 09.12.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.relaySettings')
            .controller('orderTypesCtrl', orderTypesCtrl);

    /** @ngInject */
    function orderTypesCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {
        var vm = this;
        /**
         * permissionArr is use to check permission to display list
         * created on 09.12.2018
         */
        if ($rootScope.permissionArr.indexOf('show_relay_setting_order_types') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        $rootScope.currentState = 'relay-settings.order-type-list';
        $scope.resetGlobalSearch();

        $scope.getDataTable = function ()
        {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function ()
            {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/relay/ordertype/index')
                        .success(function (result) {
                            if (result.length < $rootScope.numberOfRecord) {
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                            vm.ordertype = [];
                            var index = 1;
                            angular.forEach(result, function (value, key) {
                                var changeStatusValTo = '0';
                                var editLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_relay_order_type' + '\') !== -1" href="javascript:void(0);" ng-click="editOrderType(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                                var deleteLinks = '  <a ng-if="permissionArr.indexOf(\'' + 'delete_relay_order_type' + '\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/relaySettings/orderTypes/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                                var statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_relay_order_type' + '\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/orderTypes/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                                if (value.status == 0) {
                                    changeStatusValTo = '1';
                                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                                    statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_relay_order_type' + '\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/orderTypes/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                                }
                                var data = {
                                    id: value._id,
                                    index: index,
                                    order_type: value.order_type,
                                    created_at: value.created_at,
                                    status: statusBadge,
                                    operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                                };
                                this.push(data);
                                ++index;
                            }, vm.ordertype);
                            defer.resolve(vm.ordertype);
                        }).error(function (error) {
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord - 1));
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage', {"sSearch": "", 'sInfoFiltered': '(filtered from _MAX_ total entries)'});
            vm.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('order_type').withTitle('Order Type'),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if ($rootScope.permissionArr.indexOf('edit_relay_order_type') !== -1 || $rootScope.permissionArr.indexOf('delete_relay_order_type') !== -1 || $rootScope.permissionArr.indexOf('change_status_relay_priority') !== -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        }

        /**
        * get all type master
        */
        $scope.getTypeMaster = function()
        {
            $scope.isloaded = false;
            $http.get($rootScope.baseUrl + '/productType/getActiveType/all')
            .success(function(result)
            {
                $scope.isloaded = true;
                if (result) {
                    $scope.typeData =result;
                    $scope.typeMultiSelectData=result;
                }
            }).error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                $scope.isloaded = true;
            });
        }

        // on select main type hide this value
        $scope.setAddOnType = function(mainType)
        {
            $http.get($rootScope.baseUrl + '/productType/getActiveType/all'+'?main_type='+mainType)
            .success(function(result)
            {
                if (result) {
                    $scope.typeMultiSelectData =result;
                }
            }).error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

        //get dashboard block type key
        function getBlockType(type)
        {
            var original_type=type;
            if(type)
            {
                type=type.toLowerCase();
                if(type=='regular'){
                    return 'is_regular';
                }else if(type=='customer'){
                    return 'is_customer';
                }else if(type=='express'){
                    return 'is_express';
                }else if(type=='supply'){
                    return 'is_supply';
                }else if(type=='rework'){
                    return 'icon_tools';
                }else{
                    return original_type;
                }
            }else {
                return '';
            }
        }

        //get dashboard block type key
        function renderBlockType(type)
        {
            var original_type=type;
            if(type)
            {
                type=type.toLowerCase();
                if(type=='is_regular'){
                    return 'Regular';
                }else if(type=='is_customer'){
                    return 'Customer';
                }else if(type=='is_express'){
                    return 'Express';
                }else if(type=='is_supply'){
                    return 'Supply';
                }else if(type=='icon_tools'){
                    return 'Rework';
                }else{
                    return original_type;
                }
            }else {
                return '';
            }
        }

        function renderWithBlockType(data,full,type)
        {
            if(data)
            {
                if(data=='is_regular'){
                    return 'Regular';
                }else if(data=='is_customer'){
                    return 'Customer';
                }else if(data=='is_express'){
                    return 'Express';
                }else if(data=='is_supply'){
                    return 'Supply';
                }else{
                    return '';
                }
            }else {
                return '';
            }
        }

        function isJSON(str)
        {
            try {
                return (JSON.parse(str) && !!str);
            } catch (e) {
                return false;
            }
        }

        $scope.addOrderType = function ()
        {
            $cookies.put('ordertype-id', undefined);
            $state.go('relay-settings.add-order-type');
        }

        $scope.getEditedOrderType = function ()
        {
            if ($rootScope.permissionArr.indexOf('create_relay_order_type') == -1 && $rootScope.permissionArr.indexOf('edit_relay_order_type') == -1) {
                $state.go('dashboard');
                toastr.error("You don't have permission to do this.");
            }

            if ($cookies.get('ordertype-id') && $cookies.get('ordertype-id') != undefined)
            {
                apiService.loaderShow();
                $http.get($rootScope.baseUrl + '/relay/ordertype/show/' + $cookies.get('ordertype-id'))
                .success(function (response)
                {
                    var blockType='';
                    apiService.loaderHide();
                    vm.orderTypeId = response._id;
                    vm.orderType = response.order_type;
                    vm.mainType = renderBlockType(response.main_type);
                    $scope.setAddOnType(response.main_type);
                    vm.status = response.status;

                    var renderType=[];
                    // this statment for render sub types
                    if(isJSON(response.sub_types))
                    {
                        blockType=JSON.parse(response.sub_types);
                        if(blockType.length>0)
                        {
                            angular.forEach(blockType, function (value, key)
                            {
                                var type=renderBlockType(value);
                                if(type) {
                                    renderType.push(type);
                                }
                            });
                        }
                    }
                    else
                    {
                        var type=renderBlockType(response.sub_types);
                        if(type) {
                            renderType.push(type);
                        }
                    }

                    vm.blockType=renderType;

                }).error(function (error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('relay-settings.add-order-type');
            }
        };

        $scope.editOrderType = function (id)
        {
            $cookies.put('ordertype-id', id);
            $state.go('relay-settings.edit-order-type');
        }
        
        $scope.open = function (page, id, status)
        {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        $scope.deleteOrderType = function ()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/relay/ordertype/delete/' + $rootScope.deleteId)
                        .success(function (result) {
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                toastr.success('Order Type deleted successfully.');
                                $state.go($state.$current, null, {
                                    reload: true
                                });
                            } else {
                                toastr.error("Something went wrong please try again.");
                            }
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };

        $scope.changeStatus = function ()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status: "" + $rootScope.status + "",
                };
                $http.put($rootScope.baseUrl + '/relay/ordertype/change-stauts', bodyData)
                        .success(function (result) {
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                toastr.success('Status updated successfully.');
                                $state.go($state.$current, null, {
                                    reload: true
                                });
                            } else {
                                $state.go('relay-settings.order-type-list');
                                toastr.error("Something went wrong please try again.");
                            }
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();

            }
        };

        $scope.saveOrderTypeData = function ()
        {
            if (!this.orderTypeFrm.$valid) {
                return;
            }
            
            apiService.loaderShow();
            var bodyData = {
                order_type: vm.orderType,
                status: vm.status,
                main_type:getBlockType(vm.mainType),
                sub_types:angular.toJson(vm.blockType),
                affected_by: $rootScope.globals.currentUser.id,
            };
            $scope.saveUrl = $rootScope.baseUrl + '/relay/ordertype/create';
            $scope.httpMethod = 'POST';
            
            if (vm.orderTypeId) {
                $scope.saveUrl = $rootScope.baseUrl + '/relay/ordertype/update/' + vm.orderTypeId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.status == 'success') {
                    toastr.success('Order Type ' + (vm.orderTypeId ? 'updated' : 'added') + ' successfully.');
                    $state.go('relay-settings.order-type-list');
                } else {
                    toastr.error(response.message);
                }
            }, function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    if (error.data.message == 'The name has already been taken.') {
                        toastr.error('This group label already exists.');
                        angular.element('#orderTypeLabel').focus();
                    } else {
                        toastr.error(error.data.message);
                    }
                } else {
                    $state.go('relay-settings.order-type-list');
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
    }
})();

/**
 * priority controller handle all action related priority configuration.
 * @author Anand Malvi
 * created on 09.12.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.relaySettings')
            .controller('priorityCtrl', priorityCtrl);

    /** @ngInject */
    function priorityCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {
        var vm = this;
        /**
         * permissionArr is use to check permission to display list
         * created on 09.12.2018
         */
        if ($rootScope.permissionArr.indexOf('show_relay_priority_setting') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        $rootScope.currentState = 'relay-settings.priority-list';
        $scope.resetGlobalSearch();

        $scope.getDataTable = function () {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/relay/priority/index')
                        .success(function (result) {
                            if (result.length < $rootScope.numberOfRecord) {
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                            vm.priority = [];
                            var index = 1;
                            angular.forEach(result, function (value, key) {
                                var changeStatusValTo = '0';
                                var editLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_relay_priority' + '\') !== -1" href="javascript:void(0);" ng-click="editPriority(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                                var deleteLinks = '  <a ng-if="permissionArr.indexOf(\'' + 'delete_relay_priority' + '\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/relaySettings/priority/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                                var statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_relay_priority' + '\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/priority/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
                                if (value.status == 0) {
                                    changeStatusValTo = '1';
                                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                                    statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_relay_priority' + '\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/priority/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                                }
                                var data = {
                                    id: value._id,
                                    priority_name: value.priority_name,
                                    order_type: value.order_type,
                                    index: index,
                                    created_at: value.created_at,
                                    status: statusBadge,
                                    operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                                };
                                this.push(data);
                                ++index;
                            }, vm.priority);
                            defer.resolve(vm.priority);
                        }).error(function (error) {
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord - 1));
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage', {"sSearch": "", 'sInfoFiltered': '(filtered from _MAX_ total entries)'});
            vm.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
                DTColumnBuilder.newColumn('priority_name').withTitle('Priority'),
                DTColumnBuilder.newColumn('order_type').withTitle('Order Type'),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if ($rootScope.permissionArr.indexOf('edit_relay_priority') !== -1 || $rootScope.permissionArr.indexOf('delete_relay_priority') !== -1 || $rootScope.permissionArr.indexOf('change_status_relay_priority') !== -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        }

        /**
        * get all type master
        */
        $scope.getOrderTypes = function()
        {
            $scope.isloaded = false;
            $http.get($rootScope.baseUrl + '/relay/ordertype/index')
            .success(function(result)
            {
                $scope.isloaded = true;
                if (result) {
                    $scope.typeData =result;
                }
            }).error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                $scope.isloaded = true;
            });
        }

        $scope.addPriority = function () {
            $cookies.put('priority-id', undefined);
            $state.go('relay-settings.add-priority');
        }

        $scope.getEditedPriority = function () {
            if ($rootScope.permissionArr.indexOf('create_relay_priority') == -1 && $rootScope.permissionArr.indexOf('edit_relay_priority') == -1) {
                $state.go('dashboard');
                toastr.error("You don't have permission to do this.");
            }
            if ($cookies.get('priority-id') && $cookies.get('priority-id') != undefined) {
                apiService.loaderShow();
                $http.get($rootScope.baseUrl + '/relay/priority/show/' + $cookies.get('priority-id'))
                        .success(function (response) {
                            apiService.loaderHide();
                            vm.priorityId = response._id;
                            vm.priorityName = response.priority_name;
                            vm.status = response.status;
                            vm.orderType = response.order_type;
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('relay-settings.add-priority');
            }
        };

        $scope.editPriority = function (id) {
            $cookies.put('priority-id', id);
            $state.go('relay-settings.edit-priority');
        }
        
        $scope.open = function (page, id, status) {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        $scope.deletePriority = function () {
            if ($rootScope.deleteId) {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/relay/priority/delete/' + $rootScope.deleteId)
                        .success(function (result) {
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                toastr.success('Priority deleted successfully.');
                                $state.go($state.$current, null, {
                                    reload: true
                                });
                            } else {
                                toastr.error("Something went wrong please try again.");
                            }
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };

        $scope.changeStatus = function () {
            if ($rootScope.deleteId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status: "" + $rootScope.status + "",
                };
                $http.put($rootScope.baseUrl + '/relay/priority/change-stauts', bodyData)
                        .success(function (result) {
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                toastr.success('Status updated successfully.');
                                $state.go($state.$current, null, {
                                    reload: true
                                });
                            } else {
                                $state.go('relay-settings.priority-list');
                                toastr.error("Something went wrong please try again.");
                            }
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();

            }
        };

        $scope.savePriorityData = function () {
            if (!this.priorityFrm.$valid) {
                return;
            }
            apiService.loaderShow();
            var bodyData = {
                priority_name: vm.priorityName,
                order_type: (vm.orderType == undefined) ? '' : vm.orderType,
                status: vm.status,
                affected_by: $rootScope.globals.currentUser.id,
            };
            $scope.saveUrl = $rootScope.baseUrl + '/relay/priority/create';
            $scope.httpMethod = 'POST';
            //$scope.groupId = vm.priorityId;
            if (vm.priorityId) {
                $scope.saveUrl = $rootScope.baseUrl + '/relay/priority/update/' + vm.priorityId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.status == 'success') {
                    toastr.success('Priority ' + (vm.priorityId ? 'updated' : 'added') + ' successfully.');
                    $state.go('relay-settings.priority-list');
                } else {
                    toastr.error(response.message);
                }
            }, function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    if (error.data.message == 'The name has already been taken.') {
                        toastr.error('This group label already exists.');
                        angular.element('#priorityLabel').focus();
                    } else {
                        toastr.error(error.data.message);
                    }
                } else {
                    $state.go('relay-settings.priority-list');
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
    }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.relaySettings')
    .controller('relayCtrl', relayCtrl);

  /** @ngInject */
  function relayCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout) {
    /**
     * permissionArr is use to check permission to display list
     * created on 09.12.2018
     */
    if ($rootScope.permissionArr.indexOf('relay_settings') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'relay-settings.relay';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 09.12.2018
     */
    $scope.oneAtATime = false;
    $scope.isOpenObject = {};
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 08.27.2018
     */
    vm.autoUpload = false;
    vm.newRelayStart = false;
    vm.sandbox = false;
    vm.hours='';
    vm.minute='';
    vm.second='';
    vm.statusForUpload=[];
    vm.groupForUpload=[];
    vm.storeForUpload=[];
    vm.jobService=[];
    vm.priority=[];
    vm.store_persons=[];
    vm.alignment='center';
    vm.bold=false;
    vm.italic=false;
    vm.mirror=false;
    $scope.priorityTimeHoursData = [];
    $scope.priorityMinitsData = [];
    // Priority Hours
//    vm.priorityRegHour = '';
//    vm.priorityPrefHour = '';
//    vm.priorityExpressHour = '';
    // Priority Types
//    vm.priorityRegType = '';
//    vm.priorityPrefType = '';
//    vm.priorityExpressType = '';
    // Prioriy Dynamic Generated Data
//    vm.priorityRegularData = [];
//    vm.priorityPreferredData = [];
//    vm.priorityExpressData = [];
    vm.allDynamicPriorities = [];
    
    /**
    * get all type master
    */
    $scope.getOrderTypes = function()
    {
        $scope.isloaded = false;
        $http.get($rootScope.baseUrl + '/relay/ordertype/index')
        .success(function(result)
        {
            $scope.isloaded = true;
            if (result) {
                $scope.typeData =result;
            }
        }).error(function(error)
        {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            }
            $scope.isloaded = true;
        });
    }
        
    /**
     * get Active Status method is use to display all active order status.
     * created on 08.28.2018
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    //$scope.fontList=['Aharoni','Algerian','Arial','Arial Black','Britannic Bold','Bookman','Calibri','Courier','Courier New','Comic Sans MS','David','Elephant','Footlight MT Light','Georgia','Garamond','Helvetica','Impact','Times New Roman','Times','Trebuchet MS','Verdana'];
    $scope.fontList=['Arial', 'Times New Roman', 'English 111 Vivace BT', 'Georgia', 'Monotype Corsiva', 'Script MT Bold'];
    //$scope.sizeList=[4,6,8,9,10,11,12,14,16,18,20,22,24,26,28,36,48,72];
    $scope.hoursData=[];
    $scope.getHour=function(){
      for(var i=0;i<=23;i++){
        var hrs=i;
        if(hrs<10){
          hrs='0'+hrs;
        }
        $scope.hoursData.push(hrs);
      }
    }
    $scope.minuteData=[];
    $scope.secondData=[];
    $scope.getMinutesAndSecond=function(){
      for(var i=0;i<=59;i++){
        var min=i;
        if(min<10){
          min='0'+min;
        }
        $scope.minuteData.push(min);
        $scope.secondData.push(min);
      }
    }
    $scope.priorityHoursData=[];
    $scope.getPriorityHour=function(){
      for(var i=1;i<=24;i++){
            $scope.priorityHoursData.push(i);
        }
    }
    $scope.getActiveGroupLabel = function () {
      $http.get($rootScope.baseUrl + '/customerrelaygroup/active')
        .success(function(result) {
          $scope.activeGroupData = result;
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    $scope.getStoreData = function () {
      $http.get($rootScope.baseUrl+'/store')
          .success(function (result) {
             $scope.storeData=result;
          }).error(function (error) {
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
    }
    /**
     * get Relay Setting Data method is use to display Relay Setting data.
     * created on 09.30.2018
     */
    $scope.getRelaySettingData = function() {
      vm.store_persons = [];
        $http.get($rootScope.baseUrl + '/config/relaySetting')
          .success(function(result) {
            if (result) {
              if (result.status == 'fail') {
                toastr.error(result.message);
              } else {
                if (result.data) {
                  var resultData=result.data;
                  vm.apiKey=resultData.api_key;
                  var relaySetting=resultData.relay_settings;
                  vm.autoUpload = relaySetting.auto_upload;
                  vm.newRelayStart = relaySetting.new_relay_start;
                  vm.sandbox =relaySetting.sandbox;
                  vm.hours=relaySetting.upload_cycle_time.hours;
                  vm.minute=relaySetting.upload_cycle_time.minute;
                  vm.second=relaySetting.upload_cycle_time.second;
                  vm.statusForUpload=relaySetting.status_for_upload;
                  vm.groupForUpload=relaySetting.group_for_upload;
                  vm.storeForUpload=relaySetting.store_for_upload;
                  vm.preExpStatusAfterUpload=relaySetting.preferred_express_status_after_upload;
                  vm.regStatusAfterUpload=relaySetting.regular_status_after_upload;
                  var notUploadOrders=resultData.not_uploaded_orders;
                  vm.nupPreExpStatusAfterUpload=notUploadOrders.preferred_express_status_after_upload;
                  vm.nupRegStatusAfterUpload=notUploadOrders.regular_status_after_upload;
                  var basicSetting=resultData.general_settings.basic_settings;
                  vm.distanceXY=basicSetting.distance_xy;
                  vm.distanceLayer=basicSetting.distance_layer;
                  vm.layerQuantity=basicSetting.layer_quantity;
                  vm.brightnessMultiplicator=basicSetting.brightness_multiplicator;
                  vm.gainMultiplicator=basicSetting.gain_multiplicator;
                  vm.brightness=basicSetting.brightness;
                  vm.gain=basicSetting.gain;
                  vm.sharpness=basicSetting.sharpness;
                  var textSetting=resultData.general_settings.text_settings;
                  vm.contour=textSetting.additional_layers.contour;
                  vm.cover=textSetting.additional_layers.cover;
                  vm.font=textSetting.font;
                  vm.size=textSetting.size;
                  vm.alignment=textSetting.alignment;
                  vm.rotateZ=textSetting.rotate_z;
                  vm.bold=textSetting.bold;
                  vm.italic=textSetting.italic;
                  vm.mirror=textSetting.mirror;
                  vm.jobService=resultData.job_service;
                  vm.allDynamicPriorities = resultData.dynamic_generated_priority ? resultData.dynamic_generated_priority : [];
                    var tmpDynamicarray = [];
                    for (var objectKey in vm.allDynamicPriorities) {
                        vm.allDynamicPriorities[objectKey].field_name = objectKey;
                        tmpDynamicarray.push(vm.allDynamicPriorities[objectKey]);
                    }
                    tmpDynamicarray.sort(function (a, b) {
                        a = parseInt(a['sequence']);
                        b = parseInt(b['sequence']);
                        return a - b;
                    });
                    $scope.tmpDynamicObject = {};
                    for (var objectKey in tmpDynamicarray) {
                        $scope.tmpDynamicObject[tmpDynamicarray[objectKey].field_name] = tmpDynamicarray[objectKey];
                    }
                    vm.allDynamicPriorities = $scope.tmpDynamicObject;

                          
                    angular.forEach(tmpDynamicarray, function (value, key) {
                        var assignVal = value.field_name;
                        $scope.isOpenObject[assignVal] = true;
                    })
                }
              }
            }
          }).error(function(error) {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });

          $http.get($rootScope.baseUrl + '/config/store-persons')
            .success(function(response) {
              if(response.status == 'success') {
                vm.store_persons = response.store_persons;
                vm.statusfor2D = response.status_for_2d;
                console.log(vm.statusfor2D);
              }
            }).error(function (error) {
              if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });


          $http.get($rootScope.baseUrl + '/config/new-relay-stores')
            .success(function(response) {
              if(response.status == 'success') {
                vm.new_relay_stores = response.new_relay_stores;
              }
            }).error(function (error) {
              if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
    };
    $scope.addItem = function(type, secondType, orderType) {
      $scope.insertedJob = {
        label:null,
        value: null,
        set_default: '0'
      };
      $scope.insertedPrty = {
        name: null,
        hours:'1',
        order_type: 'Express'
      };
//      $scope.insertRegularPriority   =  {types:'Regular', time_from_hour:'12', time_from_min:'00', time_to_hour:'12', time_to_min:'00', hours_send:'1', from_time:'PM', time_to:'PM'};
//      $scope.insertPreferredPriority =  {types:'Preferred', time_from_hour:'12', time_from_min:'00', time_to_hour:'12', time_to_min:'00', hours_send:'1', from_time:'PM', time_to:'PM'};
//      $scope.insertExpressPriority   =  {types:'Express', time_from_hour:'12', time_from_min:'00', time_to_hour:'12', time_to_min:'00', hours_send:'1', from_time:'PM', time_to:'PM'};
      if (type == 'job_service') {
        vm.jobService.push($scope.insertedJob);
      }
//      else if (type == 'priority') {
//        vm.priority.push($scope.insertedPrty);
//      } else if (type === 'priority_regular') {
//        $scope.insertRegularPriority = $scope.generateDynamicData(vm.priorityRegularData, $scope.insertRegularPriority);
//        vm.priorityRegularData.push($scope.insertRegularPriority);
//      } else if (type === 'priority_preferred') {
//        $scope.insertPreferredPriority = $scope.generateDynamicData(vm.priorityPreferredData, $scope.insertPreferredPriority);
//        vm.priorityPreferredData.push($scope.insertPreferredPriority);
//      } else if (type === 'priority_express') {
//        $scope.insertExpressPriority = $scope.generateDynamicData(vm.priorityExpressData, $scope.insertExpressPriority);
//        vm.priorityExpressData.push($scope.insertExpressPriority);
//      }
      else if (secondType === 'DYNAMIC') {
          var getTypeName = type;
          
          $scope.insertDynamicPriorityGenData = {
              types : orderType,
              time_from_hour : '12',
              time_from_min : '00',
              time_to_hour : '12',
              time_to_min : '00',
              hours_send : '1',
              from_time : 'PM',
              time_to : 'PM'
          };
          $scope.insertDynamicPriorityGenData = $scope.generateDynamicData(vm.allDynamicPriorities[getTypeName].data, $scope.insertDynamicPriorityGenData);
          vm.allDynamicPriorities[getTypeName].data.push($scope.insertDynamicPriorityGenData);
          
      }
    };
    
    $scope.fromTmpArray;
    $scope.toTmpArray;
    $scope.allTmpArray;
    /**
     * Generate the dynamic object values for priority
     */
    $scope.generateDynamicData = function (priorityObject, tmpObject) {
        var objectLength = priorityObject.length;
        if (objectLength >= 1) {
            var lastObject = priorityObject[objectLength - 1];
            var fromHour = parseInt(lastObject.time_from_hour);
            var fromMin = parseInt(lastObject.time_from_min);
            var toHour = parseInt(lastObject.time_to_hour);
            var toMin = parseInt(lastObject.time_to_min);

            $scope.allTmpArray = $scope.incrementByOne(lastObject);
            
            
            // From Min and Hour
            fromMin = $scope.allTmpArray.fromMins;
            fromHour = $scope.allTmpArray.fromHours;

            // To Min and Hour
            toMin = $scope.allTmpArray.toMins;
            toHour = $scope.allTmpArray.toHours;
            
            
            
            
//            $scope.fromTmpArray = $scope.incrementByOne(fromMin, fromHour);
//            $scope.toTmpArray = $scope.incrementByOne(toMin, toHour);

            // From Min and Hour
//            fromMin = $scope.fromTmpArray.mins;
//            fromHour = $scope.fromTmpArray.hours;

            // To Min and Hour
//            toMin = $scope.toTmpArray.mins;
//            toHour = $scope.toTmpArray.hours;

            tmpObject.time_from_hour = $scope.addZeroToValue(fromHour.toString());
            tmpObject.time_from_min = fromMin; //$scope.addZeroToValue(fromMin.toString());
            tmpObject.time_to_hour = $scope.addZeroToValue(toHour.toString());
            tmpObject.time_to_min = toMin; //$scope.addZeroToValue(toMin.toString());
            
            return tmpObject;
        } else {
            return tmpObject;
        }
    };

    /**
     * Add Zero before value if value is less than or equals 9
     */
    $scope.addZeroToValue = function (value) {
        if (value <= 9) {
            return '0' + value;
        } else {
            return value;
        }
    };

    /**
     * Increment value by one based on conditions
     */
//    $scope.incrementByOne = function (min, hour) {
    $scope.incrementByOne = function (lastObj) {
        var returnObj = {};
        
        var timevalue = lastObj.time_to_hour + ":" + lastObj.time_to_min;
        var time = moment("12-may-2014" + ', ' + timevalue);
        var newTime = moment(time).add('m', 1);
        
        var newFromHours = newTime.format("h");
        var newFrommins = newTime.format("mm");
        
        var timevalue2 = newFromHours + ":" + newFrommins;
        var time2 = moment("12-may-2014" + ', ' + timevalue2);
        var newTime2 = moment(time2).add('m', 59);
        
        var newToHours = newTime2.format("h");
        var newTomins = newTime2.format("mm");
        
        returnObj.fromHours = newFromHours;
        returnObj.fromMins = newFrommins;
        
        returnObj.toHours = newToHours;
        returnObj.toMins = newTomins;
        
        return returnObj;
        
        /*var returnObj = {};
        if (min == 59 && hour == 12) {
            returnObj.mins = 0;
            returnObj.hours = 1;
            return returnObj;
        } else if (min == 59) {
            hour += 1;
            returnObj.mins = 0;
            returnObj.hours = hour;
            return returnObj;
        } else {
            min += 1;
            returnObj.mins = min;
            returnObj.hours = hour;
            return returnObj;
        }*/
    };

    $scope.confirmDelete = function(id, type, secondType) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $rootScope.secondTypeForDelete = secondType;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/relaySettings/relay/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "job_service") {
          vm.jobService.splice($rootScope.itemId, 1);
        } else if ($rootScope.secondTypeForDelete == "DYNAMIC") {
          //vm.priority.splice($rootScope.itemId, 1);
          
          vm.allDynamicPriorities[$rootScope.itemType].data.splice($rootScope.itemId, 1);
          
          
        }
        
//        else if ($rootScope.itemType == "priority") {
//          vm.priority.splice($rootScope.itemId, 1);
//        } else if ($rootScope.itemType === 'priority_regular') {
//            vm.priorityRegularData.splice($rootScope.itemId, 1);
//        } else if ($rootScope.itemType === 'priority_preferred') {
//            vm.priorityPreferredData.splice($rootScope.itemId, 1);
//        } else if ($rootScope.itemType ==='priority_express') {
//            vm.priorityExpressData.splice($rootScope.itemId, 1);
//        }
      }
      $scope.popupShow.close();
    };
    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 09.14.2018
     */
    $scope.validateArr = function(dataArr, setAsDefault) {
      var errorKey = -1;
      var errorId = '';
      var temp = [];
      var isOnlyDefaultError = 0;
      var errorMessageDefault = 0;
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + setAsDefault + '-' + i).removeClass('focus-error');
        var n = dataArr[i];
        if (setAsDefault != undefined) {
          isOnlyDefaultError = 1;
          if (n.set_default == '1') {
            temp.push(i);
          }
        }
      }
      if (isOnlyDefaultError && errorId == "" && dataArr.length > 0) {
        if (temp.length < 1) {
          errorKey = 0;
        } else if (temp.length > 1) {
          errorKey = temp[temp.length - 1];
          errorMessageDefault = 1;
        }
        errorId = setAsDefault;
      }
      if (errorKey > -1) {
        if (errorMessageDefault == 1) {
          toastr.error('Set As Default already exists.');
          angular.element('#' + errorId + '-' + errorKey).addClass('focus-error');
          angular.element('#' + errorId + '-' + errorKey).focus();
          return 1;
        }
      }
      return 0;
    }
    $scope.saveRelaySetting=function(){
      if(!this.relayFrm.$valid){
        return;
      }
      var jobService = $scope.validateArr(vm.jobService, 'itemDefaultJob');
      if (jobService == 1) {
        return false;
      }
      // var priority = $scope.validateArr(vm.priority, 'itemDefaultPriority');
      // if (priority == 1) {
      //   return false;
      // }

      $scope.storePersonSettings={
        'store_persons':vm.store_persons
      };

      $scope.relaySettingData = {
        'api_key':vm.apiKey,
        'relay_settings':{
          'auto_upload':vm.autoUpload,
          'new_relay_start':vm.newRelayStart,
          'sandbox':vm.sandbox,
          'upload_cycle_time':{'hours':vm.hours ,'minute':vm.minute ,'second':vm.second },
          'status_for_upload':vm.statusForUpload ,
          'group_for_upload': vm.groupForUpload,
          'store_for_upload':vm.storeForUpload,
          'preferred_express_status_after_upload': vm.preExpStatusAfterUpload,
          'regular_status_after_upload': vm.regStatusAfterUpload
        },
        'not_uploaded_orders':{
          'preferred_express_status_after_upload': vm.nupPreExpStatusAfterUpload,
          'regular_status_after_upload': vm.nupRegStatusAfterUpload
        },
        'general_settings':{
          'basic_settings':{
            'distance_xy':vm.distanceXY,
            'distance_layer':vm.distanceLayer,
            'layer_quantity':vm.layerQuantity,
            'brightness_multiplicator':vm.brightnessMultiplicator,
            'gain_multiplicator':vm.gainMultiplicator,
            'brightness':vm.brightness,
            'gain':vm.gain,
            'sharpness':vm.sharpness,
            'method':vm.method,
            'preset_id':vm.presetId
          },
          'text_settings':{
            'additional_layers':{'contour':vm.contour,'cover':vm.cover},
            'font':vm.font,
            'size':vm.size,
            'alignment':vm.alignment,
            'rotate_z':vm.rotateZ,
            'bold':vm.bold,
            'italic':vm.italic,
            'mirror':vm.mirror
          }
        },
        'job_service': vm.jobService,
        'priority':vm.priority
        ,
//        'priority_regular' : vm.priorityRegularData,
//        'priority_preferred' : vm.priorityPreferredData,
//        'priority_express' : vm.priorityExpressData,
        
//        'priority_data':{
//            'regular':{
//                'hours': vm.priorityRegHour,
//                'order_type': vm.priorityRegType
//            },
//            'preferred':{
//                'hours': vm.priorityPrefHour,
//                'order_type': vm.priorityPrefType
//            },
//            'express':{
//                'hours': vm.priorityExpressHour,
//                'order_type': vm.priorityExpressType
//            }
//        },
        'dynamic_generated_priority':vm.allDynamicPriorities
      };
      apiService.loaderShow();

      var bodyData1 = {
        type: 'store_persons',
        store_persons:angular.toJson($scope.storePersonSettings),
        status_for_2d: vm.statusfor2D,
        affected_by: $rootScope.globals.currentUser.id
      };
      $http.post($rootScope.baseUrl + '/config/save-store-persons', bodyData1).success(function(response) {
        
      }).error(function(error) {
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
      
      var bodyData = {
        type: 'relaySetting',
        sticker_data: angular.toJson($scope.relaySettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
        //$scope.getRelaySettingData();
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    $scope.getPriorityTimeHour=function() {
            var i = 1;
            for (i; i <= 12; i++) {
                if (i < 10) {
                    $scope.priorityTimeHoursData.push('0' + i);
                } else {
                    $scope.priorityTimeHoursData.push(i);
                }
            }
    }

    $scope.getPriorityMinit=function() {
            var i = 0;
            for (i; i <= 59; i++) {
                if (i < 10) {
                    $scope.priorityMinitsData.push('0' + i);
                } else {
                    $scope.priorityMinitsData.push(i);
                }
            }
    }
  }
})();

/**
 * relayStatus controller handle all action related relayStatus configuration.
 * @author Harsha Prajapati
 * created on 09.17.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.relaySettings')
    .controller('relayStatusCtrl', relayStatusCtrl);

  /** @ngInject */
  function relayStatusCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.17.2018
     */
    if($rootScope.permissionArr.indexOf('relay_status_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='relay-settings.relay-status';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of relay status.
     * created on 09.17.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/customerrelaystatus')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.relayStatus = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'relay_status_edit'+'\') !== -1" href="javascript:void(0);" ng-click="editRelayStatus(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'relay_status_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/relaySettings/relayStatus/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'relay_status_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/relayStatus/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'relay_status_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/relaySettings/relayStatus/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              relay_status_title: value.relay_status_title,
              relay_status_code:value.relay_status_code,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.relayStatus);
          defer.resolve(vm.relayStatus);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('relay_status_title').withTitle('Relay Status Title'),
        DTColumnBuilder.newColumn('relay_status_code').withTitle('Relay Status Code'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('relay_status_edit') !== -1 || $rootScope.permissionArr.indexOf('relay_status_delete') !== -1 || $rootScope.permissionArr.indexOf('relay_status_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add RelayStatus method is use for get add RelayStatus page.
     * created on 09.17.2018
     */
    $scope.addRelayStatus = function() {
      $cookies.put('relay-status-id',undefined);
      $state.go('relay-settings.add-relay-status');
    }

    /**
     * Edit RelayStatus method is use for get edit RelayStatus page.
     * created on 09.17.2018
     */
    $scope.editRelayStatus = function(id) {
      $cookies.put('relay-status-id',id);
      $state.go('relay-settings.edit-relay-status');
    }

    /**
     * Open model.
     * created on 09.17.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of RelayStatus.
     * created on 09.17.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/customerrelaystatus', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('relay-settings.relay-status');
              toastr.error("Something went wrong please try again.");
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();
      }
    };

    /**
     * Delete RelayStatus method is use for delete RelayStatus.
     * created on 09.17.2018
     */
    $scope.deleteRelayStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/customerrelaystatus/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Relay Status deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save RelayStatus data method is use for update/add RelayStatus data.
     * created on 09.17.2018
     */
    $scope.saveRelayStatusData = function() {
       if (!this.relayStatusFrm.$valid) {
          return;
        }
       apiService.loaderShow();
      var bodyData = {
        relay_status_id:vm.relayStatusEditId,
        relay_status_title: vm.relayStatusTitle,
        relay_status_code:vm.relayStatusCode,
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/customerrelaystatus';
      $scope.httpMethod = 'POST';
      if (vm.relayStatusId) {
        $scope.saveUrl = $rootScope.baseUrl + '/customerrelaystatus/' + vm.relayStatusId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status == 'success') {
          toastr.success('Relay Status ' + (vm.relayStatusId ? 'updated' : 'added') + ' successfully.');
          $state.go('relay-settings.relay-status');
        } else {
          toastr.error(response.message);
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This relay status title already exists.');
                angular.element('#relayStatusTitle').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('relay-settings.relay-status');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited RelayStatus method is use for get edited RelayStatus data.
     * created on 09.17.2018
     */
    $scope.getEditedRelayStatus = function() {

        if($rootScope.permissionArr.indexOf('relay_status_add') == -1 && $rootScope.permissionArr.indexOf('relay_status_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('relay-status-id') && $cookies.get('relay-status-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/customerrelaystatus/' + $cookies.get('relay-status-id'))
            .success(function(response) {
              apiService.loaderHide();
              vm.relayStatusTitle = response.relay_status_title;
              vm.relayStatusCode=response.relay_status_code;
              vm.relayStatusId = response._id;
              vm.relayStatusEditId=response.relay_status_id;
              vm.status = response.status;
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('relay-settings.add-relay-status');
        }
    };

  }

})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.relaySettings')
    .controller('webhookCtrl', webhookCtrl);

  /** @ngInject */
  function webhookCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.21.2018
     */
    if($rootScope.permissionArr.indexOf('webhook_settings') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='relay-settings.webhook';
    $scope.resetGlobalSearch();
    vm.mapStatusList=[];
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    vm.mapRegularStatusList=[];
    vm.mapExpressStatusList=[];
    vm.mapReworkStatusList=[];
    $scope.addItem = function(type) {
      $scope.inserted = {
        relay_status: '',
        order_status: '',
        get_data_api:false
      };
      if(type=='regular'){
        vm.mapRegularStatusList.push($scope.inserted);
      }else if(type=='express'){
        vm.mapExpressStatusList.push($scope.inserted);
      }else if(type=='rework'){
        vm.mapReworkStatusList.push($scope.inserted);
      }

    };

    $scope.confirmDelete = function(id,type) {
      $rootScope.itemId = id;
      $rootScope.itemType=type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/relaySettings/webhook/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if($rootScope.itemType=='regular'){
          vm.mapRegularStatusList.splice($rootScope.itemId, 1);
        }else if($rootScope.itemType=='express'){
          vm.mapExpressStatusList.splice($rootScope.itemId, 1);
        }else if($rootScope.itemType=='rework'){
          vm.mapReworkStatusList.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };

    $scope.getActiveStatus=function(){
      // active relay status
      $http.get($rootScope.baseUrl + '/customerrelaystatus/active')
          .success(function (result) {
            vm.relayStatusList = result;
          }).error(function (error) {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });

      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          vm.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    $scope.getWebhookSettingData = function() {
        $http.get($rootScope.baseUrl + '/config/webhookSetting')
          .success(function(result) {
            if (result) {
              if (result.status == 'fail') {
                toastr.error(result.message);
              } else {
                if (result.data) {
                  var resultData=result.data;
                  vm.webhookUrl=resultData.webhook_url;
                  vm.mapRegularStatusList=resultData.map_regular_statuses?resultData.map_regular_statuses:[];
                  vm.mapExpressStatusList=resultData.map_express_statuses?resultData.map_express_statuses:[];
                  vm.mapReworkStatusList=resultData.map_rework_statuses?resultData.map_rework_statuses:[];
                }
              }
            }
          }).error(function(error) {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
    }
    $scope.saveWebhookSetting=function(){
      if(!this.webhookFrm.$valid){
        return;
      }
      $scope.webhookSettingData = {
        'webhook_url': vm.webhookUrl,
        'map_express_statuses':vm.mapExpressStatusList,
        'map_regular_statuses':vm.mapRegularStatusList,
        'map_rework_statuses':vm.mapReworkStatusList
      };
      apiService.loaderShow();
      var bodyData = {
        type: 'webhookSetting',
        sticker_data: angular.toJson($scope.webhookSettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
  }

})();


(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('addOnReportCtrl', addOnReportCtrl);

    /** @ngInject */
    function addOnReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
        if ($rootScope.permissionArr.indexOf('addon_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.companyName='';
        vm.customerName='';
        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.addon-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }
        /**
        * Set Focus Of Date Picker
        * Created on 11.07.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'all');
            var companyName= vm.companyName?vm.companyName:'null';
            var customerName = vm.customerName?vm.customerName:'null';
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl + '/report/add-one/'+fromDate+'/'+toDate+'/'+store+'/'+companyName+'/'+customerName+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.companyName='';
          vm.customerName='';
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalCost = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/add-one',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    customer_name: vm.customerName?vm.customerName:'',
                    company_name: vm.companyName?vm.companyName:'',
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
              apiService.loaderHide();
                 vm.totalCost = result.data.totalPrice;
                 angular.element('.price-class span span').html(vm.totalCost);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.07.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('customer_name').withTitle('Customer Name').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('extra_person_text').withTitle('Extra People').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('exoress_text').withTitle('Express Type').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('background_text').withTitle('Background').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('engraving_text').withTitle('Engraving').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_price').withTitle('Total Price').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Cost: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
    }
})();


(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('damageReportCtrl', damageReportCtrl);

    /** @ngInject */
    function damageReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
        if ($rootScope.permissionArr.indexOf('damage_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.productName="";
        $rootScope.currentState = 'reports.damage-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
              vm.productData=response;
            }).error(function (response) {
            });
        }
        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.07.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'all');
            var productName = vm.productName?vm.productName:'null';
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl +'/report/damage/'+fromDate+'/'+toDate+'/'+productName+'/'+store+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.productName="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalCost = 0;
        vm.totalQty = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
          apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/damage',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    prouct_name: (vm.productName?vm.productName:''),
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 vm.totalCost = result.data.totalPrice;
                 vm.totalQty = result.data.totalQty;
                 angular.element('.qty-class span span').html(vm.totalQty);
                 angular.element('.price-class span span').html(vm.totalCost);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Render with name method is use for show name.
        * Created on 11.07.2017
        */
        function renderWithName(data){
           var temp = data.split('::');
           return temp[0];
        }
        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.07.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
          angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
          angular.element('.dataTables_filter input').attr('class', 'form-control');
          angular.element('.dataTables_length select').attr('class', 'form-control');
          angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_date').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('increment_itemid').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_name').withTitle('Product Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_qty').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('scan_date').withTitle('Scan Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('cost').withTitle('Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price_category').withTitle('3D Category').renderWith(renderWitRelayCategory).withOption('className', 'text-center'));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price').withTitle('3D Price').renderWith(renderWitRelayPrice).withOption('className', 'text-center'));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('cost').withTitle('Product Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('total_order_cost').withTitle('Total Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Qty: <span></span>',
                    className: 'btn btn-success qty-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Cost: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }

        function renderWitRelayCategory(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWitRelayPrice(data){
          if(data){
            return '$' + data;
          }else{
            return 'N/A';
          }
        }
    }
})();

/**
 * Design report controller handle all action related design report.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 11.07.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('designReportCtrl', designReportCtrl);

    /** @ngInject */
    function designReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
         /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
        if ($rootScope.permissionArr.indexOf('design_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.designerName="";
        vm.productName="";
        vm.category="";
        $timeout(function () {
            //angular.element('.apply-css').hide();
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.design-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * getDesignerData is use to get list of Designer Name
        * created on 11.8.2017
        */
        $scope.getDesignerData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/user/designerslist')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.designerData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
         * Get category list method is use to get category data.
         * created on 07.25.2018
         */
        // $scope.getCategoryData = function(){
        //     $http.get($rootScope.baseUrl + '/reportsettingscategory/getactivecategory')
        //     .success(function (response) {
        //       vm.categoryData=response;
        //     }).error(function (response) {
        //     });
        // }
        $scope.getCategoryData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/category')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.categoryData=result.data;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
              vm.productData=response;
            }).error(function (response) {
            });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.07.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
          // if(vm.applyFlag==false && vm.designerName=='0' && vm.store=='0' && vm.productName=='0' && vm.category=='0'){
          //   toastr.warning("Please select date first.");
          //   $timeout(function () {
          //       angular.element('.apply-css').hide();
          //   }, 200);
          // }else {
          //   $timeout(function () {
          //       angular.element('.apply-css').show();
          //   }, 200);
          // }
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){

            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'null');
            var productName = (vm.productName?vm.productName:'null');
            var designer =  (vm.designerName!= ''?vm.designerName:'null');
            var category = (vm.category?vm.category:'null');
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl + '/report/design/'+fromDate+'/'+toDate+'/'+productName+'/'+store+'/'+designer+'/'+category+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          // $state.go($state.$current, null, {
          //   reload: true
          // });
          vm.store = "0";
          vm.designerName="";
          vm.productName="";
          vm.category="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalPrice = 0;
        vm.totalQty = 0;
        vm.totalTime=0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            //$scope.isloaded = false;
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/design',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    prouct_name: (vm.productName?vm.productName:''),
                    designer: (vm.designerName!= '0'?vm.designerName:''),
                    category: (vm.category?vm.category:''),
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
              apiService.loaderHide();
                 vm.totalPrice = result.data.totalPrice;
                 vm.totalQty = result.data.totalQty;
                 vm.totalTime = result.data.totalTime;
                 angular.element('.qty-class span span').html(vm.totalQty);
                 angular.element('.price-class span span').html(vm.totalPrice);
                 angular.element('.time-class span span').html(vm.totalTime);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
              //$scope.isloaded = true;
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }
        /**
        * Render Designer split data and get designer name.
        * Created on 11.11.2017
        */
        function renderDesigner(data){
          if(data){
            var temp = data.split('::');
            return temp[0];
          }else{
            return '';
          }

        }
        /**
        * Render JobStart split data and get job start time.
        * Created on 11.11.2017
        */
        function renderJobStart(data){
            var temp = data.split('::');
            return temp[1];
        }
        /**
        * Render JobDone split data and get job done time.
        * Created on 11.11.2017
        */
        function renderJobDone(data){
            var temp = data.split('::');
            return temp[2];
        }
        /**
        * Render TotalTime split data and get total time.
        * Created on 11.11.2017
        */
        function renderTotalTime(data){
            var temp = data.split('::');
            return temp[3];
        }
        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.07.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        /**
        * renderWithCategory method is use for display category otherwise N/A.
        * Created on 11.07.2017
        */
        function renderWithCategory(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('employee_name').withTitle('Designer').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_category').withTitle('Category').renderWith(renderWithCategory).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Product').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty_ordered').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('job_start_date').withTitle('Job Start').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('job_end_date').withTitle('Job Done').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('time_taken_for').withTitle('Total Time').withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('design_cost').withTitle('Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Qty: <span></span>',
                    className: 'btn btn-success qty-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Time: <span></span>',
                    className: 'btn btn-success time-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Cost: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }


    }
})();

/**
 * Design report controller handle all action related 3d design report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 17.09.2021
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('designReport3DCtrl', designReport3DCtrl);

    /** @ngInject */
    function designReport3DCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
         /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
        if ($rootScope.permissionArr.indexOf('design_report_3d') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.designerName="";
        vm.productName="";
        vm.category="";
        $timeout(function () {
            //angular.element('.apply-css').hide();
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.design-report-3d';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * getDesignerData is use to get list of Designer Name
        * created on 11.8.2017
        */
        $scope.getDesignerData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/user/designerslist')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.designerData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
         * Get category list method is use to get category data.
         * created on 07.25.2018
         */
        // $scope.getCategoryData = function(){
        //     $http.get($rootScope.baseUrl + '/reportsettingscategory/getactivecategory')
        //     .success(function (response) {
        //       vm.categoryData=response;
        //     }).error(function (response) {
        //     });
        // }
        $scope.getCategoryData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/category')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.categoryData=result.data;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
              vm.productData=response;
            }).error(function (response) {
            });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.07.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
          // if(vm.applyFlag==false && vm.designerName=='0' && vm.store=='0' && vm.productName=='0' && vm.category=='0'){
          //   toastr.warning("Please select date first.");
          //   $timeout(function () {
          //       angular.element('.apply-css').hide();
          //   }, 200);
          // }else {
          //   $timeout(function () {
          //       angular.element('.apply-css').show();
          //   }, 200);
          // }
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){

            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'null');
            var productName = (vm.productName?vm.productName:'null');
            var designer =  (vm.designerName!= ''?vm.designerName:'null');
            var category = (vm.category?vm.category:'null');
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl + '/report/design3d/'+fromDate+'/'+toDate+'/'+productName+'/'+store+'/'+designer+'/'+category+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          // $state.go($state.$current, null, {
          //   reload: true
          // });
          vm.store = "0";
          vm.designerName="";
          vm.productName="";
          vm.category="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalPrice = 0;
        vm.totalQty = 0;
        vm.totalTime=0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            //$scope.isloaded = false;
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/design3d',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    prouct_name: (vm.productName?vm.productName:''),
                    designer: (vm.designerName!= '0'?vm.designerName:''),
                    category: (vm.category?vm.category:''),
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
              apiService.loaderHide();
                 vm.totalPrice = result.data.totalPrice;
                 vm.totalQty = result.data.totalQty;
                 vm.totalTime = result.data.totalTime;
                 angular.element('.qty-class span span').html(vm.totalQty);
                 angular.element('.price-class span span').html(vm.totalPrice);
                 angular.element('.time-class span span').html(vm.totalTime);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
              //$scope.isloaded = true;
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }
        /**
        * Render Designer split data and get designer name.
        * Created on 11.11.2017
        */
        function renderDesigner(data){
          if(data){
            var temp = data.split('::');
            return temp[0];
          }else{
            return '';
          }

        }
        /**
        * Render JobStart split data and get job start time.
        * Created on 11.11.2017
        */
        function renderJobStart(data){
            var temp = data.split('::');
            return temp[1];
        }
        /**
        * Render JobDone split data and get job done time.
        * Created on 11.11.2017
        */
        function renderJobDone(data){
            var temp = data.split('::');
            return temp[2];
        }
        /**
        * Render TotalTime split data and get total time.
        * Created on 11.11.2017
        */
        function renderTotalTime(data){
            var temp = data.split('::');
            return temp[3];
        }
        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.07.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        /**
        * renderWithCategory method is use for display category otherwise N/A.
        * Created on 11.07.2017
        */
        function renderWithCategory(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Product').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty_ordered').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));

            if($rootScope.permissionArr.indexOf('3d_design_report_column_employee_name') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('employee_name_3d').withTitle('Designer').withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_time_taken') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_time_taken').withTitle('Order Time').withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_job_3d_start') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('job_3d_start_date').withTitle('Job Start').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_job_3d_end') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('job_3d_end_date').withTitle('Job Done').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_time_taken') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('time_taken_for_3d').withTitle('Total Time').withOption('className', 'tableDate'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_relay_link_price_category') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price_category').withTitle('3D Category').renderWith(renderWithCategory).withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_relay_link_price') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price').withTitle('3D Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('3d_design_report_column_relay_link_price') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_our_cost').withTitle('Our Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            }
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Qty: <span></span>',
                    className: 'btn btn-success qty-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Time: <span></span>',
                    className: 'btn btn-success time-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Cost: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }


    }
})();

/**
 * Figurine Cost controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 31.05.2025
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('figurineCostReportCtrl', figurineCostReportCtrl);

    /** @ngInject */
    function figurineCostReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder)
    {
        /**
         * permissionArr is use to check permission of user
         * created on 14.07.2020
         */
        if ($rootScope.permissionArr.indexOf('figurine_cost_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        var vm = this;
        $scope.resetGlobalSearch();
        $scope.isloaded = false;
        vm.store = "0";

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.figurine-cost-report';

        $scope.serchByList = ['Added At','Order ID','Name','Qty','Cost','Added By'];

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 14.07.2020
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 14.07.2020
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 14.07.2020
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Export function is used for export report
        * Created on 03.06.2025
        */
        $scope.export = function (type)
        {
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            var store_id = (vm.store);
            
            if(sortOptions[0][0] && sortOptions[0][1])
            {
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'');
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'');
            
            window.open($rootScope.baseUrl +'/report/export-figurine-cost/'+fromDate+'/'+toDate+'/'+store_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }

        /**
        * reset Search is use to reset filters
        * Created on 14.07.2020
        */
        $scope.resetSearch = function ()
        {
            vm.productName = '';
            vm.warehouseName = '';
            $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Server data method is use for load data from API.
        * Created on 14.07.2020
        */
        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            $http(
            {
                method: 'POST',
                url: $rootScope.baseUrl + '/report/figurinecost',
                data: 
                {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():''),
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result)
            {
                apiService.loaderHide();
                var result = result.data.data.original;
                if(result.recordsTotal < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                }else{
                    angular.element('.dataTables_paginate').show();
                }
                
                if(result.data.length>0){
                    angular.element('.apply-css').show();
                }else{
                    angular.element('.apply-css').hide();
                }
                
                if(result)
                {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                }
                else
                {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                
                $scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
                apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 14.07.2020
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 14.07.2020
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }

        function renderWithProduct(data)
        {
            if(data){
                return data;
            }
            else{
                return 'N/A';
            }
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 14.07.2020
        */
        function initComplete(row,data)
        {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
        * getStoreData is use to get list of Store
        * created on 03.06.2025
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2017
         */
        $scope.getDataTable = function()
        {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('figurine_cost_created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));

            vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Order ID').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Name').withOption('className', 'text-left'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('cust_name').withTitle('Sold To').withOption('className', 'text-left'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price').withTitle('3D Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty_ordered').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('figurine_cost_total').withTitle('Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('figurine_cost_by_user').withTitle('Added By').withOption('className', 'text-center'));

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withButtons([{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                className: 'btn btn-danger margin-rigth-10 apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('csv');
                }
            },{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                className: 'btn btn-danger apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('xls');
                }
            }])
            .withOption('serverSide', true)
            .withPaginationType('simple_numbers')
            .withOption('deferRender', true)
            .withOption('searching', true)
            .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
            .withOption('bLengthChange', true)
            .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
            .withOption('bInfo', true)
            .withOption('autoWidth', true)
            .withOption('order', [0, 'desc'])
            .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
            .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
    }
})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('fileRawMaterialReportCtrl', fileRawMaterialReportCtrl);

    /** @ngInject */
    function fileRawMaterialReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 09.27.2018
         */
        if ($rootScope.permissionArr.indexOf('file_raw_material_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 09.27.2018
        */
        $scope.vmAdded = this;
        $rootScope.currentState = 'reports.file-raw-material-report';

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * Options method is use configure date picker options
        * Created on 09.27.2018
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }


        /**
        * Set Focus Of Date Picker
        * Created on 09.27.2018
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 09.27.2018
        */
        $scope.searchApply = function (){
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
          var userId = $rootScope.globals.currentUser.id?$rootScope.globals.currentUser.id:0;
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var used = vm.used?vm.used:'null';
            var file_raw_order = vm.fileRawOrder?vm.fileRawOrder:'null';
            var order_from = vm.orderFrom?vm.orderFrom:'null';
            var product_name = vm.productName?vm.productName:'null';
            var approved = vm.approved?vm.approved:'null';
            var reset = vm.reset?vm.reset:'null';
            var customer_id = $rootScope.customerId?$rootScope.customerId:0;
            window.open($rootScope.baseUrl + '/report/damage-crystal-report/'+fromDate+'/'+toDate+'/'+used+'/'+file_raw_order+'/'+order_from+'/'+product_name+'/'+approved+'/'+reset+'/'+customer_id+'/'+userId+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'', '_self');
          }
        /**
        * reset Search is use to reset filters
        * Created on 09.27.2018
        */
        $scope.resetSearch = function (){
          vm.used="";
          vm.fileRawOrder="";
          vm.orderFrom="";
          vm.productName="";
          vm.approved="";
          vm.reset="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        /**
        * Server data method is use for load data from API.
        * Created on 09.27.2018
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/damage-crystal-report-list',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    file_raw_order: vm.fileRawOrder?vm.fileRawOrder:'',
                    order_from: vm.orderFrom?vm.orderFrom:'',
                    product_name: vm.productName?vm.productName:'',
                    approved: vm.approved?vm.approved:'',
                    credited: vm.credited?vm.credited:'',
                    reset: vm.reset?vm.reset:'',
                    used: vm.used?vm.used:'',
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    customer_id:$rootScope.customerId,
                    customer_role:$rootScope.userRole,
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                vm.totalPrice = result.data.total_price;
                vm.totalApprovedPrice = result.data.approved_total_price;
                angular.element('.total-price-class span span').html(vm.totalPrice);
                angular.element('.total-approved-price-class span span').html(vm.totalApprovedPrice);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 09.27.2018
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }
        function renderWithCustomerName(data) {
            if (data != '') {
                return data;
            } else {
                return ' - ';
            }
        }
        function renderWithFileDownloadFrom(data) {
            if (data != '') {
                return data;
            } else {
                return ' - ';
            }
        }
        //Encryption id variable
        $scope.encryptionId = '';
        
        /**
         * Action Column
         * @param {type} data
         * @returns {String}
         */
        function addActionColumn(data, type, full) {
            var resetButton = ' <a ng-if="permissionArr.indexOf(\'' + 'reset_button_in_printed_crystal_report' + '\') !== -1" href="javascript:void(0);" ng-click="openResetConfirmBox(\''+data+'\')" style="margin-left: 10px;" class="btn btn-danger btn-with-icon">Reset</a>';
            var logsButton = ' <i ng-if="permissionArr.indexOf(\'' + 'log_button_in_printed_crystal_report' + '\') !== -1" class="fa fa-history fa-lg cursor-pointer ng-scope" title="View reset log" ng-click="openResetLogModal(\''+full.microtime+'\')"></i>';
            return resetButton + '&nbsp;' + logsButton;
        }
        
        function addResetColumn(data, type, full) {
            if (full.is_reset == 'Yes') {
                var resetAt = ' - ';
                if (full.reset_at) {
                    resetAt = full.reset_at
                }
                return 'Reset by ' + full.reset_by_user + '</br>At ' + resetAt;
            }
            if (full.approved == 'Yes') {
                var reset = ' <a id="damage-crystal-reset-button-'+data+'" ng-if="permissionArr.indexOf(\'' + 'file_raw_material_report_reset_button' + '\') !== -1" href="javascript:void(0);" class="btn btn-success btn-with-icon" ng-click="resetCrystalData(\''+full.file_order+'\',\''+data+'\')">Reset</a>';
                return '<div id="reset-by-user-data-'+data+'" style="white-space: normal;">' + reset + '</div>';
            } else {
                var reset = ' <a id="damage-crystal-reset-button-'+data+'" ng-if="permissionArr.indexOf(\'' + 'file_raw_material_report_reset_button' + '\') !== -1" href="javascript:void(0);" class="btn btn-success btn-with-icon" ng-click="resetCrystalData(\''+full.file_order+'\',\''+data+'\')" style="display:none">Reset</a>';
                return '<div id="reset-by-user-data-'+data+'" style="white-space: normal;">' + reset + '</div>';
            }
            return '';
        }
        function addImageInListing(data, type, full) {
            return '<a ng-click="openImageInFullScreen(\''+full.original_image_path+'\')" height="80px" width="80px" title="Click here to view full image"> <img height="80px" width="80px" style="margin: 10px 0px;" class="image" src="' + data + '"></a>';
        }
        
        $scope.openImageInFullScreen = function(imageSrc) {
            var modal = document.getElementById("damageImagePreview");
            var modalImg = document.getElementById("img01");
            modal.style.display = "block";
            modalImg.src = imageSrc;
        }
        function addApproveColumn(data, type, full) {
            if (full.approved_by_user) {
                var approvedAt = ' - ';
                if (full.approved_at) {
                    approvedAt = full.approved_at;
                }
                if (full.approved == 'Yes') {
                    return 'Approved by ' + full.approved_by_user + '</br>At ' + approvedAt;
                } else {
                    return 'Not approved by ' + full.approved_by_user + '</br>At ' + approvedAt;
                }
            }
            var yes = '';
            if (full.approved != 'No') {
                var column = 'Yes';
                if ($rootScope.permissionArr.indexOf('file_raw_material_report_damage_yes_button') != -1) {
                yes = ' <a id="damage-crystal-yes-button-'+data+'" href="javascript:void(0);" class="btn btn-primary btn-with-icon" ng-click="updateResetField(\''+data+'\',\''+column+'\')"> Yes </a>';
            	}
            }
            var column = 'No'; var no = '';
            if ($rootScope.permissionArr.indexOf('file_raw_material_report_damage_no_button') != -1) {
            no = ' <a id="damage-crystal-no-button-'+data+'" href="javascript:void(0);" class="btn btn-danger btn-with-icon" ng-click="updateResetField(\''+data+'\',\''+column+'\')"> No </a>';
        	}
            return '<div id="approved-by-user-data-'+data+'" style="white-space: normal;">' + yes + '&nbsp;' + no + '</div>';
        }

        function addCreditedColumn(data, type, full) {
            if (full.credited_by_user) {
                var creditedAt = ' - ';
                if (full.credited_at) {
                    creditedAt = full.credited_at;
                }
                if (full.credited == 'Yes') {
                    return 'Credited by ' + full.credited_by_user + '</br>At ' + creditedAt;
                } else {
                    return 'Not credited by ' + full.credited_by_user + '</br>At ' + creditedAt;
                }
            }
            var yes = '';
            if (full.credited != 'No') {
                var column = 'Yes';
                if ($rootScope.permissionArr.indexOf('file_raw_material_report_damage_yes_button') != -1) {
                yes = ' <a id="damage-crystal-credited-yes-button-'+data+'" href="javascript:void(0);" class="btn btn-primary btn-with-icon" ng-click="updateCreditedField(\''+data+'\',\''+column+'\')"> Yes </a>';
                }
            }
            var column = 'No'; var no = '';
            if ($rootScope.permissionArr.indexOf('file_raw_material_report_damage_no_button') != -1) {
            no = ' <a id="damage-crystal-credited-no-button-'+data+'" href="javascript:void(0);" class="btn btn-danger btn-with-icon" ng-click="updateCreditedField(\''+data+'\',\''+column+'\')"> No </a>';
            }
            return '<div id="credited-by-user-data-'+data+'" style="white-space: normal;">' + yes + '&nbsp;' + no + '</div>';
        }

        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open Reset logs modal
         * @param {type} id
         * @returns {undefined}
         */
        $scope.openResetLogModal = function (id) {
            $rootScope.printCrystalResetLogId = id;
            $('#printCrystalResetLogIdModel').modal();
            $scope.getResetEncryptionAPILogs();
        };
        
        $scope.hideResetLogModal=function(){
          $('#printCrystalResetLogIdModel').modal('hide');
        }
        
        /**
         * Hide Encryption reset pop-up
         * @returns {undefined}
         */
        $scope.hideResetPopUp = function () {
            $('#openResetConfirmModal').modal('hide');
        }
        
        /**
         * Open encryption confirm-pop-up
         * @param {type} id
         * @returns {undefined}
         */
        $scope.openResetConfirmBox = function(id) {
            $scope.encryptionId = id;
            $('#openResetConfirmModal').modal();
        }
        $scope.viewSpecialInsctuction = '';
        $scope.viewFullSpecialInstructionText = function(data) {
            $('#openSeeFullText').modal();
            $scope.viewSpecialInsctuction = unescape(data);
        };
        
        $scope.hideSeeFullText = function() {
            $('#openSeeFullText').modal('hide');
            $scope.viewSpecialInsctuction = '';
        };
        
        $scope.approvedUpdatedAt = '';
        $scope.updateResetField = function(id, type) {
            $scope.approvedUpdatedAt = '';
            var byTYpe = 'Not';
            var userName = $rootScope.globals.currentUser.name;
            $http.post($rootScope.baseUrl + '/damage/update-report-approved-field',
                {
                    id: id,
                    approved: type,
                    approved_by_user: userName
                }
            ).success(function (response) {
                if (response.status == 'success') {
                    if (type == 'Yes') {
                        angular.element("#damage-crystal-reset-button-" + id).show();
                        byTYpe = '';
                    }
                    var atusertime = response.data.approved_at;
                    var showString = byTYpe + ' Approved by ' + userName + ' At ' + atusertime.toString();
                    $('#damage-crystal-yes-button-' + id).hide();
                    $('#damage-crystal-no-button-' + id).hide();
                    $('#approved-by-user-data-' + id).text(showString);
                    $scope.approvedUpdatedAt = response.data.approved_at;
                    //$scope.searchApply();
                }
            }).error(function (error) {});
        }
        
        $scope.creditedUpdatedAt = '';
        $scope.updateCreditedField = function(id, type) {
            $scope.creditedUpdatedAt = '';
            var byTYpe = 'Not';
            var userName = $rootScope.globals.currentUser.name;
            $http.post($rootScope.baseUrl + '/damage/update-report-credited-field',
                {
                    id: id,
                    credited: type,
                    credited_by_user: userName
                }
            ).success(function (response) {
                if (response.status == 'success') {
                    if (type == 'Yes') {
                        byTYpe = '';
                    }
                    var atusertime = response.data.credited_at;
                    var showString = byTYpe + ' Credited by ' + userName + ' At ' + atusertime.toString();
                    $('#damage-crystal-credited-yes-button-' + id).hide();
                    $('#damage-crystal-credited-no-button-' + id).hide();
                    $('#credited-by-user-data-' + id).text(showString);
                    $scope.creditedUpdatedAt = response.data.credited_at;
                    //$scope.searchApply();
                }
            }).error(function (error) {});
        }

        $scope.resetCrystalData = function(itemId, damageCystalId) {
            apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/damage/update-report-reset-field-reset-encryption', {
                item_increment_id: itemId,
                damage_crystal_id: damageCystalId,
                reset_by_user: $rootScope.globals.currentUser.name
            }).success(function (response) {
                if (response.status == 'success') {
                    $('#damage-crystal-reset-button-' + damageCystalId).hide();
                    var showString = 'Reset by ' + $rootScope.globals.currentUser.name + ' At ' + response.reset_at;
                    $('#reset-by-user-data-' + damageCystalId).text(showString);
                    toastr.success(response.message);
                    apiService.loaderHide();
                } else {
                    apiService.loaderHide();
                    toastr.error(response.message);
                }
                //$scope.searchApply();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
        
        $scope.resetEncryptionLogsArr = [];
        $scope.getResetEncryptionAPILogs = function () {
            $scope.resetEncryptionLogsArr = [];
            $scope.resetEncryptionLogsLoaded = false;
            $http.get($rootScope.baseUrl + '/encryption/get-reset-key-logs/'+$rootScope.printCrystalResetLogId).then(
            function (response) {
                $scope.resetEncryptionLogsLoaded = true;
                if(response.data.status == 'success'){
                console.log(response.data);
                   $scope.resetEncryptionLogsArr = response.data.data;
                }
            },
            function (error) {
                $scope.resetEncryptionLogsLoaded = true;
            });
        }
        
        /**
         * Reset the encryption key API call
         * @returns {undefined}
         */
        $scope.resetEncryptionFieldAPICall = function() {
            if ($scope.encryptionId) {
                apiService.loaderShow();
                var bodyData = {
                    encryption_id: $scope.encryptionId
                };
                $http.post($rootScope.baseUrl + '/encryption/reset-key', bodyData)
                        .success(function (result) {
                            //$scope.searchApply();
                            $('#openResetConfirmModal').modal('hide');
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                $('#openResetConfirmModal').modal('hide');
                                toastr.success('Encryption reset successfully');
                            }
                            if (result.status == 'fail') {
                                toastr.error(result.message);
                            }
                        }).error(function (error) {
                    $('#openResetConfirmModal').modal('hide');
                    apiService.loaderHide();
                    if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
        }
        
        function decreseKeyLength(data) {
            if (data) {
                var stringVal = data.toString();
                if (stringVal.length > 20) {
                    stringVal = stringVal.substring(0, 20) + '...';
                }
                var encryptedData = escape(data);
                return '<a ng-click="viewFullSpecialInstructionText(\'' + encryptedData + '\')" style="cursor: pointer; color: #ffffff;">' + stringVal + '</a>';

            } else {
                return ' - ';
            }
        }
        function addDollarSign(data) {
            if (data == 0) {
                return ' - ';
            } else {
                return '$' + data;
            }
        }
        
        function checkUploadedBy(data) {
            if (data) {
                return data;
            } else {
                return ' - ';
            }
        }
        function checkUploadedFile(data) {
            
            var dataReturn = '';
            if (data) {
                dataReturn = '<a href="'+data+'" class="btn btn-danger btn-with-icon">Download</a>';
            } else {
                dataReturn = '<a href="" class="btn btn-danger btn-with-icon" disabled>Download</a>';
            }
            return dataReturn;
        }
        /**
         * Get data table method is use for get list of users.
         * Created on 09.27.2018
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_from').withTitle('Order From').withOption('className', 'tableDate'));
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('damage_by').withTitle('Damage By').withOption('className', 'tableDate'));
            
            if ($rootScope.permissionArr.indexOf('file_raw_report_product_name') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_name').withTitle('Product name').withOption('className', 'tableDate'));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_file_order') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('file_order').withTitle('File Order Number').withOption('className', 'tableDate'));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_raw_order') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('raw_order').withTitle('Raw Order Number').withOption('className', 'tableDate'));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_reason') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('reason').withTitle('Reason').withOption('className', 'tableDate'));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_used_status') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('used_status').withTitle('Used status').withOption('className', 'tableDate'));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_product_price') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_price').withTitle('Product Price').renderWith(addDollarSign).withOption('className', 'tableDate'));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_special_instruction') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('special_instruction').withTitle('Special Instruction').withOption('className', 'text-center').renderWith(decreseKeyLength));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_original_image_path') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('original_image_path_80x80').withTitle('Image Uploaded').renderWith(addImageInListing).withOption('className', 'tableDate').withOption('orderable', false));
            }
            if ($rootScope.permissionArr.indexOf('file_raw_report_file_created_by') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('file_created_by').withTitle('Uploaded By').renderWith(checkUploadedBy).withOption('className', 'tableDate'));
            }

            vm.dtColumns.push(DTColumnBuilder.newColumn('file_uploaded_at').withTitle('Uploaded Date').renderWith($scope.getGlobalDateFormatConditionally).withOption('className', 'tableDate'));
        		
        	if ($rootScope.permissionArr.indexOf('file_raw_report_uploaded_file') != -1) {
        	vm.dtColumns.push(DTColumnBuilder.newColumn('file_manual_url').withTitle('Uploaded File').renderWith(checkUploadedFile).withOption('className', 'tableDate').withOption('orderable', false));
            }
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Date Created').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormatConditionally));
            vm.dtColumns.push(DTColumnBuilder.newColumn('_id').withTitle('Approved').renderWith(addApproveColumn).withOption('className', 'tableActions').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('_id').withTitle('Reset').renderWith(addResetColumn).withOption('className', 'tableActions').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('_id').withTitle('Credited').renderWith(addCreditedColumn).withOption('className', 'tableActions').withOption('orderable', false));

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                        text: 'Total Price: $<span></span>',
                        className: 'btn btn-success total-price-class report-btn margin-rigth-10 apply-css',
                        action: function ( e, dt, node, config ) {
                            return;
                        }
                    },{
                        text: 'Total Approved Price: $<span></span>',
                        className: 'btn btn-success total-approved-price-class report-btn margin-rigth-10 apply-css',
                        action: function ( e, dt, node, config ) {
                            return;
                        }
                    },{
                        text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                        className: 'btn btn-danger margin-rigth-10 apply-css',
                        action: function (e, dt, node, config) {
                            $scope.export('csv');
                        }
                    }, {
                        text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                        className: 'btn btn-danger apply-css',
                        action: function (e, dt, node, config) {
                            $scope.export('xls');
                        }
                    }
                ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [12, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('createdRow', compileRow)
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
//            if($rootScope.permissionArr.indexOf('reset_button_in_printed_crystal_report') !== -1 || $rootScope.permissionArr.indexOf('log_button_in_printed_crystal_report') !== -1){
//                vm.dtColumns.push(DTColumnBuilder.newColumn('_id').withTitle('Action').renderWith(addActionColumn).withOption('className', 'tableActions').withOption('orderable', false));
//            }
        }
        $scope.closeImagePrev=function(){
            $('#damageImagePreview').hide();
            var modalImg = document.getElementById("img01");
            modalImg.src = '';
        };
        

    }
})();

/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('invetoryReportCtrl', invetoryReportCtrl);

    /** @ngInject */
    function invetoryReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder)
    {
        /**
         * permissionArr is use to check permission of user
         * created on 14.07.2020
         */
        if ($rootScope.permissionArr.indexOf('inventory_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        var vm = this;
        $scope.resetGlobalSearch();
        $scope.isloaded = false;

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.inventory-report';

        $scope.serchByList = ['Product','Order ID','Old Available','Allocated','New Available','Allocated By','Allocated Date','Removed','Removed By','Removed Date'];

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 14.07.2020
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 14.07.2020
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 14.07.2020
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Export function is used for export report
        * Created on 14.07.2020
        */
        $scope.export = function (type)
        {
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            
            if(sortOptions[0][0] && sortOptions[0][1])
            {
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var productName = vm.productName?vm.productName:'null';
            var warehouseName = vm.warehouseName?vm.warehouseName:'null';
            window.open($rootScope.baseUrl +'/report/inventory-export/'+fromDate+'/'+toDate+'/'+productName+'/'+warehouseName+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }

        /**
        * reset Search is use to reset filters
        * Created on 14.07.2020
        */
        $scope.resetSearch = function ()
        {
            vm.productName = '';
            vm.warehouseName = '';
            $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Server data method is use for load data from API.
        * Created on 14.07.2020
        */
        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            $http(
            {
                method: 'POST',
                url: $rootScope.baseUrl + '/report/inventory',
                data: 
                {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    prouct_name: vm.productName?vm.productName:'',
                    warehouse_name: vm.warehouseName?vm.warehouseName:'',
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result)
            {
                apiService.loaderHide();
                var result = result.data.data.original;
                if(result.recordsTotal < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                }else{
                    angular.element('.dataTables_paginate').show();
                }
                
                if(result.data.length>0){
                    angular.element('.apply-css').show();
                }else{
                    angular.element('.apply-css').hide();
                }
                
                if(result)
                {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                }
                else
                {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                
                $scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
                apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 14.07.2020
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 14.07.2020
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }

        function renderWithProduct(data)
        {
            if(data){
                return data;
            }
            else{
                return 'N/A';
            }
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 14.07.2020
        */
        function initComplete(row,data)
        {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2017
         */
        $scope.getDataTable = function()
        {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('allocation_id').withTitle('Sr.No').withOption('className', 'text-center'));
            
            if ($rootScope.permissionArr.indexOf('inventory_report_order_id') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Order ID').renderWith(renderWithProduct).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_product_name') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Product Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_old_allocated') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('old_allocated').withTitle('Old Allocated').renderWith(renderInteger).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_allocated') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('allocated').withTitle('Allocated').renderWith(renderInteger).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_new_allocated') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('new_allocated').withTitle('New Allocated').renderWith(renderInteger).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_allocated_at') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('allocated_at').withTitle('Allocated Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_removed_at') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('removed_at').withTitle('Removed Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            }
            if ($rootScope.permissionArr.indexOf('inventory_report_warehouse_name') != -1) {
            vm.dtColumns.push(DTColumnBuilder.newColumn('warehouse_name').withTitle('Warehouse Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            }
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withButtons([{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                className: 'btn btn-danger margin-rigth-10 apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('csv');
                }
            },{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                className: 'btn btn-danger apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('xls');
                }
            }])
            .withOption('serverSide', true)
            .withPaginationType('simple_numbers')
            .withOption('deferRender', true)
            .withOption('searching', true)
            .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
            .withOption('bLengthChange', true)
            .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
            .withOption('bInfo', true)
            .withOption('autoWidth', true)
            .withOption('order', [0, 'desc'])
            .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
            .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }


        /**
         * Get all products list method is use to get product data.
         * created on 14.07.2020
         */
        $scope.getProductData = function()
        {
            $http.get($rootScope.baseUrl + '/inventory/products')
            .success(function (response)
            {
              vm.productData=response;
              vm.productData.splice(0,0,{id: -1, name: 'All'});
            }).error(function (response) {
            });
        }

        /**
         * Get all warehouse list method is use to get warehouse data.
         * created on 14.07.2020
         */
        $scope.getWarehouseData = function()
        {
            $http.get($rootScope.baseUrl + '/warehouse')
            .success(function (response)
            {
              vm.warehouseData=response;
              vm.warehouseData.splice(0,0,{id: -1, warehouse_name: 'All'});
            }).error(function (response) {
            });
        }
    }
})();
/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('orderAssemblyReportCtrl', orderAssemblyReportCtrl);

    /** @ngInject */
    function orderAssemblyReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder)
    {
        /**
         * permissionArr is use to check permission of user
         * created on 14.07.2020
         */
        if ($rootScope.permissionArr.indexOf('order_assembly_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        var vm = this;
        $scope.resetGlobalSearch();
        $scope.isloaded = false;

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.order-assembly-report';

        $scope.serchByList = ['Assembly Date','Order Number','Total Cubes','Total Other','Assemble By'];

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 14.07.2020
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 14.07.2020
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 14.07.2020
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Export function is used for export report
        * Created on 14.07.2020
        */
        $scope.export = function (type)
        {
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            
            if(sortOptions[0][0] && sortOptions[0][1])
            {
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            
            window.open($rootScope.baseUrl +'/report/order-assembly-export/'+fromDate+'/'+toDate+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }

        /**
        * reset Search is use to reset filters
        * Created on 14.07.2020
        */
        $scope.resetSearch = function ()
        {
            $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Server data method is use for load data from API.
        * Created on 14.07.2020
        */
        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            $http(
            {
                method: 'POST',
                url: $rootScope.baseUrl + '/report/order-assembly',
                data: 
                {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result)
            {
                apiService.loaderHide();
                var result = result.data.data.original;
                if(result.recordsTotal < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                }else{
                    angular.element('.dataTables_paginate').show();
                }
                
                if(result.data.length>0){
                    angular.element('.apply-css').show();
                }else{
                    angular.element('.apply-css').hide();
                }
                
                if(result)
                {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                }
                else
                {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                
                $scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
                apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 14.07.2020
        */
        function renderInteger(data)
        {
            if(typeof data !== "undefined") {
                return parseInt(data);
            }
            else {
                return 0;
            }
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 14.07.2020
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }

        function renderWithProduct(data)
        {
            if(data){
                return data;
            }
            else{
                return 'N/A';
            }
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 14.07.2020
        */
        function initComplete(row,data)
        {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2017
         */
        $scope.getDataTable = function()
        {
            var vm = this;
            vm.dtColumns = [];
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').withOption('className', 'text-center').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('increment_id').withTitle('Order Number').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_crystals').withTitle('Total Crystals').withOption('className', 'text-center').renderWith(renderInteger));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_bases').withTitle('Total Bases').withOption('className', 'text-center').renderWith(renderInteger));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_other').withTitle('Total Other').withOption('className', 'text-center').renderWith(renderInteger));
            vm.dtColumns.push(DTColumnBuilder.newColumn('assembly_by').withTitle('Assemble By').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('assembly_at').withTitle('Assemble At').withOption('className', 'text-center').renderWith($scope.getGlobalDateFormat));

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withButtons([{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                className: 'btn btn-danger margin-rigth-10 apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('csv');
                }
            },{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                className: 'btn btn-danger apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('xls');
                }
            }])
            .withOption('serverSide', true)
            .withPaginationType('simple_numbers')
            .withOption('deferRender', true)
            .withOption('searching', true)
            .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
            .withOption('bLengthChange', true)
            .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
            .withOption('bInfo', true)
            .withOption('autoWidth', true)
            .withOption('order', [0, 'desc'])
            .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
            .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
    }
})();
/**
 * Sales report controller handle all action related Sales report.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 11.02.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('ordersReportCtrl', ordersReportCtrl);

    /** @ngInject */
    function ordersReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.02.2017
         */
        if ($rootScope.permissionArr.indexOf('orders_sales_lst') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.02.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.productName = '';
        vm.customerName = '';
        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.orders-sales-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.current_user_id  = ($rootScope.globals.currentUser.id?$rootScope.globals.currentUser.id:'');
        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        
        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.02.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2017
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
            //alert('hello');
           // console.log('hello test');
           /// console.log(vm.customerName);
           // return false;

            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
          //  var productName ="";
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'all');
            var customerName = vm.customerName?vm.customerName:'null';
           // var productName = vm.productName?vm.productName:'null';
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl +'/report/orderexport/'+fromDate+'/'+toDate+'/'+customerName+'/'+store+'/'+customer_id+'/'+$scope.current_user_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.02.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.productName = '';
          vm.customerName = '';
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalPrice = 0;
        vm.totalQty = 0;
        vm.subTotal = 0;
        vm.totalCost = 0;
        vm.total3D = 0;

        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/orderSales',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    current_user_id:($rootScope.globals.currentUser.id?$rootScope.globals.currentUser.id:''),
                   // prouct_name: vm.productName?vm.productName:'',
                    customer_name: vm.customerName?vm.customerName:'',
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 console.log(result.data);
                // return false;
                 vm.totalPrice = result.data.totalPrice;
                 vm.totalQty = result.data.totalQty;
                 vm.totalCost = result.data.totalCost;
                 vm.total3D = result.data.total3D;

                 vm.subTotal = result.data.subTotal;
                 angular.element('.qty-class span span').html(vm.totalQty);
                 angular.element('.price-class span span').html(vm.totalPrice);
                 angular.element('.sub-price-class span span').html(vm.subTotal);
                 angular.element('.3d-total-class span span').html(vm.total3D);
                 angular.element('.cost-total-class span span').html(vm.totalCost);

                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWitRelayCategory(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWitRelayPrice(data){
          if(data){
            return '$' + data;
          }else{
            return '$0';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2017
         */
        $scope.getDataTable = function()
        {
            var vm = this;
            vm.dtColumns = [];
            
            if($rootScope.permissionArr.indexOf('order_report_order_date') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order<br />Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            }
            if($rootScope.permissionArr.indexOf('order_report_order_number') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('increment_id').withTitle('Order<br />No').withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('order_report_soldto') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('sold_to').withTitle('Sold<br />To').withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_shipto') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to').withTitle('Ship<br />To').withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_quantity') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('quantity').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('order_report_relay_category') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price_category').withTitle('3D<br />Category').renderWith(renderWitRelayCategory).withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_subtotal') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('subtotal').withTitle('Sub<br />Total').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('order_report_grand_total') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('grand_total').withTitle('Total').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            }
            if($rootScope.permissionArr.indexOf('order_report_relay_link_price') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price').withTitle('3D<br />Price').renderWith($scope.renderWithDollar).withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_cost') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('cost').withTitle('Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_processing_fee') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_processing_fee').withTitle('Processing<br />Fee').renderWith($scope.renderWithDollar).withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_shipment_processing_fee') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_processing_fee').withTitle('Shipping<br />Fee').renderWith(renderWitRelayPrice).withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_box_cost') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('box_cost').withTitle('Box<br />Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center').withOption('orderable', false));
            }
            if($rootScope.permissionArr.indexOf('order_report_total_cost') != -1){
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_total_cost').withTitle('Order<br />Total Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center').withOption('orderable', false));
            }

            vm.dtColumns.push(DTColumnBuilder.newColumn('region_state').withTitle('Region').renderWith(renderWitRelayCategory).withOption('className', 'text-center').withOption('orderable', false));
            

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Cost: $<span></span>',
                    className: 'btn btn-success cost-total-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total 3D Price: $<span></span>',
                    className: 'btn btn-success 3d-total-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Qty: <span></span>',
                    className: 'btn btn-success qty-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Sub Total Price: $<span></span>',
                    className: 'btn btn-success sub-price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Price: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }

        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
              vm.productData=response;
              console.log(vm.productData);
            //  vm.productData.splice(0,0,{id: -1, report_label: 'All'});
            }).error(function (response) {
            });
        }

    }
})();


(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('printedCrystalReportCtrl', printedCrystalReportCtrl);

    /** @ngInject */
    function printedCrystalReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 09.27.2018
         */
        if ($rootScope.permissionArr.indexOf('printed_crystal_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 09.27.2018
        */
        $scope.vmAdded = this;
        $rootScope.currentState = 'reports.printed-crystal-report';

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * Options method is use configure date picker options
        * Created on 09.27.2018
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }


        /**
        * Set Focus Of Date Picker
        * Created on 09.27.2018
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 09.27.2018
        */
        $scope.searchApply = function (){
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var used = vm.used?vm.used:'null';
            var all_search = vm.allSearch?vm.allSearch:'null';
            window.open($rootScope.baseUrl + '/report/print-crystal-report/'+fromDate+'/'+toDate+'/'+used+'/'+all_search+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'', '_self');
          }
        /**
        * reset Search is use to reset filters
        * Created on 09.27.2018
        */
        $scope.resetSearch = function (){
          vm.used="";
          vm.allSearch="";
          $scope.datePickerReports.date = {startDate: '', endDate:''};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        /**
        * Server data method is use for load data from API.
        * Created on 09.27.2018
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/printed-crystal-report',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    used: vm.used?vm.used:'',
                    all_search: vm.allSearch?vm.allSearch:'',
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 09.27.2018
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }
        function renderWithCustomerName(data) {
            if (data != '') {
                return data;
            } else {
                return ' - ';
            }
        }
        function renderWithFileDownloadFrom(data) {
            if (data != '') {
                return data;
            } else {
                return ' - ';
            }
        }
        //Encryption id variable
        $scope.encryptionId = '';
        
        /**
         * Action Column
         * @param {type} data
         * @returns {String}
         */
        function addActionColumn(data, type, full) {
            var resetButton = ' <a ng-if="permissionArr.indexOf(\'' + 'reset_button_in_printed_crystal_report' + '\') !== -1" href="javascript:void(0);" ng-click="openResetConfirmBox(\''+data+'\')" style="margin-left: 10px;" class="btn btn-danger btn-with-icon">Reset</a>';
            var logsButton = ' <i ng-if="permissionArr.indexOf(\'' + 'log_button_in_printed_crystal_report' + '\') !== -1" class="fa fa-history fa-lg cursor-pointer ng-scope" title="View reset log" ng-click="openResetLogModal(\''+full.microtime+'\')"></i>';
            return resetButton + '&nbsp;' + logsButton;
        }
        function compileRow(row, data) {
            $compile(angular.element(row).contents())($scope);
        }
        /**
         * Open Reset logs modal
         * @param {type} id
         * @returns {undefined}
         */
        $scope.openResetLogModal = function (id) {
            $rootScope.printCrystalResetLogId = id;
            $('#printCrystalResetLogIdModel').modal();
            $scope.getResetEncryptionAPILogs();
        };
        
        $scope.hideResetLogModal=function(){
          $('#printCrystalResetLogIdModel').modal('hide');
        }
        
        /**
         * Hide Encryption reset pop-up
         * @returns {undefined}
         */
        $scope.hideResetPopUp = function () {
            $('#openResetConfirmModal').modal('hide');
        }
        
        /**
         * Open encryption confirm-pop-up
         * @param {type} id
         * @returns {undefined}
         */
        $scope.openResetConfirmBox = function(id) {
            $scope.encryptionId = id;
            $('#openResetConfirmModal').modal();
        }
        
        $scope.resetEncryptionLogsArr = [];
        $scope.getResetEncryptionAPILogs = function () {
            $scope.resetEncryptionLogsArr = [];
            $scope.resetEncryptionLogsLoaded = false;
            $http.get($rootScope.baseUrl + '/encryption/get-reset-key-logs/'+$rootScope.printCrystalResetLogId).then(
            function (response) {
                $scope.resetEncryptionLogsLoaded = true;
                if(response.data.status == 'success'){
                console.log(response.data);
                   $scope.resetEncryptionLogsArr = response.data.data;
                }
            },
            function (error) {
                $scope.resetEncryptionLogsLoaded = true;
            });
        }
        
        /**
         * Reset the encryption key API call
         * @returns {undefined}
         */
        $scope.resetEncryptionFieldAPICall = function() {
            if ($scope.encryptionId) {
                apiService.loaderShow();
                var bodyData = {
                    encryption_id: $scope.encryptionId
                };
                $http.post($rootScope.baseUrl + '/encryption/reset-key', bodyData)
                        .success(function (result) {
                            $scope.searchApply();
                            $('#openResetConfirmModal').modal('hide');
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                $('#openResetConfirmModal').modal('hide');
                                toastr.success('Encryption reset successfully');
                            }
                            if (result.status == 'fail') {
                                toastr.error(result.message);
                            }
                        }).error(function (error) {
                    $('#openResetConfirmModal').modal('hide');
                    apiService.loaderHide();
                    if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
        }
        
        function decreseKeyLength(data) {
            var stringVal = data.toString();
            if (stringVal.length > 20) {
                stringVal = stringVal.substring(0, 20) + '...';
            }
            return '<span title="' + data + '">' + stringVal + '</span>';
        }
        /**
         * Get data table method is use for get list of users.
         * Created on 09.27.2018
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_from_name').withTitle('Order From').withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to_name').withTitle('Order To').withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('customer_name').withTitle('Scan By').withOption('className', 'tableDate').renderWith(renderWithCustomerName));
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_name').withTitle('Product Name').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_number').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('microtime').withTitle('Key').withOption('className', 'text-center').renderWith(decreseKeyLength));
            vm.dtColumns.push(DTColumnBuilder.newColumn('is_used').withTitle('Used').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('downloaded_order_from').withTitle('Download From').withOption('className', 'text-center').renderWith(renderWithFileDownloadFrom));
            vm.dtColumns.push(DTColumnBuilder.newColumn('used_date').withTitle('Date Used').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormatConditionally));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormatConditionally));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [1, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('createdRow', compileRow)
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
            if($rootScope.permissionArr.indexOf('reset_button_in_printed_crystal_report') !== -1 || $rootScope.permissionArr.indexOf('log_button_in_printed_crystal_report') !== -1){
                vm.dtColumns.push(DTColumnBuilder.newColumn('_id').withTitle('Action').renderWith(addActionColumn).withOption('className', 'tableActions').withOption('orderable', false));
            }
        }
        
        

    }
})();

/**
 * Product Sold report controller handle all action related Product Sold report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 14.07.2021
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('productSoldReportCtrl', productSoldReportCtrl);

    /** @ngInject */
    function productSoldReportCtrl($scope, $uibModal, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder)
    {
        /**
         * permissionArr is use to check permission of user
         * created on 14.07.2021
         */
        if ($rootScope.permissionArr.indexOf('product_sold_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();

        /**
        * configuration datatable instance
        * Created on 14.07.2021
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.storeData = "";
        vm.stores=[];

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.product-sold-report';

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 14.07.2021
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * getStoreData is use to get list of Store
        * created on 27.4.2021
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 $scope.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        $scope.getProductType = function ()
        {
            $http.get($rootScope.baseUrl+'/config/get-product-types')
              .success(function (result) {
                  //$scope.isloaded = true;
                 $scope.productTypeData=result.data;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2021
        */
        $scope.export = function (type)
        {
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'asc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var stores = (vm.stores!= ''?vm.stores.toString():'null');
            
            window.open($rootScope.baseUrl +'/report/productsold/'+fromDate+'/'+toDate+'/'+stores+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function ()
        {
          vm.stores = "";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalPrice = 0;
        vm.totalQty = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            var product_types = '';
            if(vm.product_types) {
                //console.log(vm.product_types.toString());
                product_types = vm.product_types.toString();
            }

            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/productsold',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    stores:vm.stores.toString(),
                    product_types: product_types,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            
            //vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Product Name'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('sold').withTitle('Sold Qty').renderWith(renderInteger).withOption('className', 'text-center').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_stock').withTitle('Total Stock').renderWith(renderInteger).withOption('className', 'text-center').withOption('orderable', false));
            
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }

        

    }
})();


(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('qaApprovedReportCtrl', qaApprovedReportCtrl);

    /** @ngInject */
    function qaApprovedReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
        if ($rootScope.permissionArr.indexOf('qa_approved_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.personName="";
        vm.productName = '';
        $timeout(function () {
            angular.element('.apply-css').hide();
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.qa-approved-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * getQAPersonData is use to get list of QA Approved Person Name
        * created on 11.7.2017
        */
        $scope.getQAPersonData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/user/qalist')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.personData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
              vm.productData=response;
            }).error(function (response) {
            });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }


        /**
        * Set Focus Of Date Picker
        * Created on 11.07.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'all');
            var personName = vm.personName!= ''?vm.personName:'null';
            var productName = vm.productName?vm.productName:'null';
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl + '/report/qa-approved/'+fromDate+'/'+toDate+'/'+store+'/'+productName+'/'+personName+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.personName="";
          vm.productName = '';
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalQty = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/qa-approved',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    prouct_name: vm.productName?vm.productName:'',
                    qa_name: (vm.personName!= ''?vm.personName:''),
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
              apiService.loaderHide();
                 vm.totalQty = result.data.totalQty;
                 angular.element('.qty-class span span').html(vm.totalQty);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_date').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_id').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('approved_by').withTitle('Approve By').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_name').withTitle('Product Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qa_end_time').withTitle('QA Approved Time').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('time_taken').withTitle('Time').withOption('className', 'tableDate'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('itile').withTitle('Itile').withOption('className', 'text-center'));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Qty: <span></span>',
                    className: 'btn btn-success qty-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
    }
})();


(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('relayReportCtrl', relayReportCtrl);

    /** @ngInject */
    function relayReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 09.27.2018
         */
        if ($rootScope.permissionArr.indexOf('relay_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 09.27.2018
        */
        $scope.vmAdded = this;
        $rootScope.currentState = 'reports.relay-report';

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * Options method is use configure date picker options
        * Created on 09.27.2018
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }


        /**
        * Set Focus Of Date Picker
        * Created on 09.27.2018
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 09.27.2018
        */
        $scope.searchApply = function (){
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var status = vm.status?vm.status:'null';
            //var customer_id = $rootScope.customerId;
            window.open($rootScope.baseUrl + '/report/relayorderlog/'+fromDate+'/'+toDate+'/'+status+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'', '_self');
          }
        /**
        * reset Search is use to reset filters
        * Created on 09.27.2018
        */
        $scope.resetSearch = function (){
          vm.status="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalCost = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 09.27.2018
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/relaylog',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    status: vm.status?vm.status:'',
                    // customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    // customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 vm.totalCost = result.data.totalPrice;
                 angular.element('.price-class span span').html(vm.totalCost);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 09.27.2018
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }
        function renderWithStatus(data){
          if(data){
            if(data=='success'){
              return '<span class="label label-success font-size-14 margin-inline">Success</span>';
            }else{
              return '<span class="label label-danger font-size-14 margin-inline">Fail</span>';
            }
          }else{
            return '';
          }
        }
        /**
         * Get data table method is use for get list of users.
         * Created on 09.27.2018
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_increment_id').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Relay Upload Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'text-center').renderWith(renderWithStatus));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [1, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }



    }
})();

/**
 * Report dashboard controller handle all action related design report.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 02.12.2018
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('reportDashboardCtrl', reportDashboardCtrl);

    /** @ngInject */
    function reportDashboardCtrl($scope, $http, $rootScope, $state, baConfig, $uibModal, apiService, toastr, DTColumnBuilder, DTOptionsBuilder,$timeout) {
         /**
         * permissionArr is use to check permission of user
         * created on 02.12.2018
         */
        if ($rootScope.permissionArr.indexOf('report_dashboard_view') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        $rootScope.currentState = 'reports.report-dashboard';
        $scope.resetGlobalSearch();

        /**
         * Set Configuration of date range
         */
        $scope.storeData = [];
        $scope.totaldata = 0;
        $scope.timeData = {
            'daily':0,
            'weekly':0,
            'monthly':0,
            'yearly':0,
        }

        $scope.dateRanges = [{
                key: 'daily',
                from_date:$scope.saveFromDateFormat(moment().format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }, {
                key: 'weekly',
                from_date:$scope.saveFromDateFormat(moment().startOf('isoWeek').format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }, {
                key: 'monthly',
                from_date:$scope.saveFromDateFormat(moment().startOf('month').format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }, {
                key: 'yearly',
                from_date:$scope.saveFromDateFormat(moment().startOf('year').format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }
        ];

       /**
        * Options method is use configure date picker options
        * created on 10.06.2017
        */
        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {

                'apply.daterangepicker' : function() {

                    $rootScope.datePicker.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                },
                'hide.daterangepicker':function() {
                    $rootScope.datePicker.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                }
            }
        }
        /**
         * focus Input methos is used for focus on date picker.
         * created on 09.26.2017
         */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }
        /**
         * reset dashboard is use to reset data
         * Created on 05.01.2018
         */
        $scope.resetDashboard = function() {
          $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.loadDataFromAPI();
        }
        $scope.renderWithTotal=function(data){
            if(data && data!=0){
              return data.toFixed(2);
            }else{
              return data;
            }
        }
        /**
         * Load data from API is used for load status data.
         * created on 09.26.2017
         */
        $scope.loadDataFromAPI = function(){
            apiService.loaderShow();
            var customer_id = $rootScope.customerId;
            $http.post($rootScope.baseUrl + '/report/dashboard',{
                from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
                to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate),
                data:$scope.dateRanges,
                customer_id:customer_id,
                store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():''),
            })
            .success(function (response) {
                apiService.loaderHide();
                $scope.timeData = response.data.header;
                $scope.storeData = response.data.store;
                $scope.totaldata = Object.keys($scope.storeData).length;

            }).error(function (response) {
                apiService.loaderHide();
            });
        }
        $scope.loadDataFromAPI();
        var layoutColors = baConfig.colors;
        $scope.piechartDataKeys = [];
        $scope.colors = [layoutColors.successLight, layoutColors.danger];
        $scope.colors = [{
            backgroundColor: '#cef353',
            pointBackgroundColor: layoutColors.successLight,
          },{
            backgroundColor: '#f97979',
            pointBackgroundColor:  layoutColors.danger,
          }];
          $scope.pieChartOptions = {
              // tooltips:{
              //   callbacks: {
              //       label: function (tooltipItem, data) {
              //           var cData = data.datasets[tooltipItem.datasetIndex].data;
              //           var _meta = data.datasets[tooltipItem.datasetIndex]._meta;
              //           var meta = _meta[Object.keys(_meta)[0]];
              //           var ttLbl = data.labels[tooltipItem.index];
              //           var ttData = cData[tooltipItem.index];
              //           if (ttData == 0.01) {
              //             return ttLbl+': 0';
              //           }else{
              //             return ttLbl+': '+ttData;
              //           }
              //       }
              //   }
              // },
              elements: {
                arc: {
                  borderWidth: 0
                }
              },
              cutoutPercentage:-1,
              animation:{
                duration:0
              }
        };
        /**
         * Load chart data is used for load chart data.
         * created on 09.26.2017
         */
        $scope.loadChartData = function(id, name, position, total){
            apiService.loaderShow();
            $scope.total = total;
            $scope.position=position?position:'';
            $scope.storeName = name+' '+$scope.position;
            $rootScope.storeId=id;
            $http.post($rootScope.baseUrl+'/report/storepopup/'+id,{
                from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
                to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate)
            }).success(function(response){
              apiService.loaderHide();
              $scope.categoryCrystalData=response;
              $rootScope.catPopupSize = $(window).height();
              $rootScope.catPopupSize = ($rootScope.catPopupSize-100);
              $rootScope.catPopupSizeMin = ($rootScope.catPopupSize-50);
              $scope.popupShow = $uibModal.open({
                  animation: true,
                  size: 'report-chart',
                  templateUrl: 'app/pages/reports/reportDashboard/categoryCrystalModel.html',
                  scope:$scope,
              });
            }).error(function(error){
              apiService.loaderHide();
            });
        }
        /**
       * Export function is used for export report
       * Created on 26.06.2018
       */
       $scope.export = function (type){
           var fromDate = $rootScope.datePicker.date.startDate?$scope.saveFromDateFormat($rootScope.datePicker.date.startDate):'null';
           var toDate = $rootScope.datePicker.date.endDate?$scope.saveToDateFormat($rootScope.datePicker.date.endDate):'null';
           var storeId = ($rootScope.storeId?$rootScope.storeId:'null');
           window.open($rootScope.baseUrl + '/report/storeexport/'+fromDate+'/'+toDate+'/'+storeId+'/'+type+'', '_self');
       }

    }
})();

/**
 * Departments controller handle all action related user Department.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 04.25.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.reports')
    .controller('tabsCtrl', tabsCtrl);

  /** @ngInject */
  function tabsCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 04.25.2018
     */
    if($rootScope.permissionArr.indexOf('report_settings') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='reports.report-settings';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of report tabs.
     * created on 04.25.2018
     */
    $scope.getDataTable = function() {
      var vm = this;
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/reportsettings')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.tabs = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'tab_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editTab(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'tab_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/reports/reportSettings/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
            var assignProduct = ' <a ng-if="permissionArr.indexOf(\''+'tab_category'+'\') !== -1" href="javascript:void(0);"   ng-click="assignProduct(\'' + value._id + '\')" title="Assign Product"><i class="fa fa-wrench fa-lg white" aria-hidden="true"></i></a>';
            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'tab_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/reports/reportSettings/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'tab_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/reports/reportSettings/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              name: value.name,
              category_val:value.category_val,
              index:index,
              created_at: value.created_at,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + assignProduct
              };
            this.push(data);
            ++index;
          }, vm.tabs);
          defer.resolve(vm.tabs);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Tab Name'),
        DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('tab_edit') !== -1 || $rootScope.permissionArr.indexOf('tab_delete') !== -1 || $rootScope.permissionArr.indexOf('tab_changestatus') !== -1 || $rootScope.permissionArr.indexOf('tab_category') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add tab method is use for get add tab page.
     * created on 04.25.2018
     */
    $scope.addTab = function() {
      $cookies.put('tab-id',undefined);
      $state.go('reports.add-tab');
    }

    /**
     * Edit tab method is use for get edit tab page.
     * created on 04.25.2018
     */
    $scope.editTab = function(id) {
      $cookies.put('tab-id',id);
      $state.go('reports.edit-tab');
    }
    /**
     * Tab category method is use for get tab category page.
     * created on 04.25.2018
     */
    $scope.tabCategory = function(id) {
      $cookies.put('tab-id',id);
      $state.go('reports.assign-category');
    }
    /**
     * Assign product method is use for assign product to category.
     * created on 04.26.2018
     */
    $scope.assignProduct = function(id) {
      $cookies.put('tab-id',id);
      $state.go('reports.assign-product');
    }
    /**
     * Open model.
     * created on 04.25.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of tab.
     * created on 04.25.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status:  ""+$rootScope.status+"",
          updated_by:$rootScope.globals.currentUser.id
        };
        $http.put($rootScope.baseUrl + '/reportsettings', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('reports.report-settings');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete tab method is use for delete tab.
     * created on 04.25.2018
     */
    $scope.deleteTab = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/reportsettings/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Tab deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save tab data method is use for update/add tab data.
     * created on 04.25.2018
     */
    $scope.saveTabData = function() {
       if (!this.tabFrm.tab.$valid) {
        toastr.error("Please enter tab name.");
        angular.element('#tab').focus();
        return;
      }else if (!this.tabFrm.category.$valid) {
          toastr.error("Please enter category.");
          angular.element('#category').focus();
          return;
        }else if (!this.tabFrm.status.$valid) {
          toastr.error("Please select status.");
          return;
        }
       apiService.loaderShow();
      var bodyData = {
        name: vm.tab,
        category_val:JSON.stringify(vm.category),
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id
      };
      $scope.saveUrl = $rootScope.baseUrl + '/reportsettings';
      $scope.httpMethod = 'POST';
      if (vm.tabId) {
        $scope.saveUrl = $rootScope.baseUrl + '/reportsettings/' + vm.tabId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Tab ' + (vm.tabId ? 'updated' : 'added') + ' successfully.');
          $state.go('reports.report-settings');
        } else {
          $state.go('reports.report-settings');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This tab name already exists.');
                angular.element('#tab').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('reports.report-settings');
          toastr.error("Something went wrong please try again.");
        }
      });

    }
    /**
     * Get edited tab method is use for get edited tab data.
     * created on 04.25.2018
     */
    $scope.setOfSets = [];
    vm.categoryData=[];
    $scope.getEditedTab = function() {

        if($rootScope.permissionArr.indexOf('tab_add') == -1 && $rootScope.permissionArr.indexOf('tab_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('tab-id') && $cookies.get('tab-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/reportsettings/' + $cookies.get('tab-id'))
            .success(function(response) {
              vm.tab = response.name;
              vm.category=response.category_val?JSON.parse(response.category_val):'';
              vm.tabId = response._id;
              vm.status = response.status;
              vm.settingsvluecategory=response.settingsvluecategory?JSON.parse(response.settingsvluecategory):'';
              if(!response.settingsvlue){
                angular.forEach(vm.category,function(val,key){
                  vm.categoryData.push({
                    category:val,
                    product:[]
                  })
                });
              }else{
                vm.categoryData=JSON.parse(response.settingsvlue);
                angular.forEach(vm.category,function(val,key){
                  if(vm.settingsvluecategory.indexOf(val)===-1){
                    vm.categoryData.push({
                          category:val,
                          product:[]
                        })
                  }
                });
                angular.forEach(vm.settingsvluecategory,function(val,key){
                  if(vm.category.indexOf(val)===-1){
                    vm.categoryData.splice(key,1);
                  }
                });
              }
              var half_length = Math.ceil(vm.categoryData.length / 2);
              var leftArray = vm.categoryData.splice(0,half_length);
              var rightArray = vm.categoryData.splice(0,vm.categoryData.length);
              $scope.setOfSets.push(leftArray);
              $scope.setOfSets.push(rightArray);
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('reports.add-tab');
        }
    };
    /**
     * Get category list method is use to get category data.
     * created on 04.27.2018
     */
    $scope.getCategoryList = function(){
        $http.get($rootScope.baseUrl + '/reportsettingscategory/getactivecategory')
        .success(function (response) {
          $scope.categoryList=response;
        }).error(function (response) {
        });
    }
    /**
     * Get all products list method is use to get product data.
     * created on 04.27.2018
     */
    $scope.getAllProductsList = function(){
        $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
        .success(function (response) {
          vm.allProducts=response;
        }).error(function (response) {
        });
    }
    /**
    * remove Product data method is use to delete product.
    * created on 04.26.2018
    */
    $scope.removeProduct = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate product.
    * created on 04.26.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el,ke) {
          return el.report_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 04.26.2018
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.report_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.modelValue);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
    /**
     * add product method is use to save product data.
     * created on 04.27.2018
     */
    $scope.addProduct = function(){
      $scope.temp = [];
      angular.forEach($scope.setOfSets,function(value,key){
        angular.forEach(value,function(val,ke){
          $scope.temp.push(val);
        });
      });
      apiService.loaderShow();
      var bodyData={
        'settingsvlue':JSON.stringify($scope.temp),
        'settingsvluecategory':JSON.stringify(vm.category),
        'affected_by' :$rootScope.globals.currentUser.id
      };
      $http.put($rootScope.baseUrl + '/reportsettings/blocksettigs/'+$cookies.get('tab-id'),bodyData).success(function (response) {
           apiService.loaderHide();
           toastr.success(response.message);
           $state.go('reports.report-settings');
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }
  }

})();

/**
 * Rework report controller handle all action related Rework report.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 11.07.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('reworkReportCtrl', reworkReportCtrl);

    /** @ngInject */
    function reworkReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
        if ($rootScope.permissionArr.indexOf('rework_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.productName="";
        $rootScope.currentState = 'reports.rework-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
              vm.productData=response;
            }).error(function (response) {
            });
        }
        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }


        /**
        * Set Focus Of Date Picker
        * Created on 11.07.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'all');
            var productName = vm.productName?vm.productName:'null';
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl + '/report/rework/'+fromDate+'/'+toDate+'/'+store+'/'+productName+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.productName="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalCost = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/rework',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    prouct_name: vm.productName?vm.productName:'',
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 vm.totalCost = result.data.totalPrice;
                 angular.element('.price-class span span').html(vm.totalCost);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };
        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.07.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('original_order_id').withTitle('Original Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('new_order_id').withTitle('Rework Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('product_name').withTitle('Product Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('reason').withTitle('Reason').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('solution').withTitle('Solution').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('price').withTitle('Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('User').withOption('className', 'text-center'));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Cost: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }



    }
})();

/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('salesReportCtrl', salesReportCtrl);

    /** @ngInject */
    function salesReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.02.2017
         */
        if ($rootScope.permissionArr.indexOf('sales_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.02.2017
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.productName = '';
        vm.BoxSKU = '';
        vm.customerName = '';
        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.sales-report';

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
        /**
        * Options method is use configure date picker options
        * Created on 11.02.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2017
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2017
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var userId = $rootScope.globals.currentUser.id?$rootScope.globals.currentUser.id:0;
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var store = (vm.store!= '0'?vm.store:'all');
            var customerName = vm.customerName?vm.customerName:'null';
            var productName = vm.productName?vm.productName:'null';
            var BoxSKU = vm.BoxSKU?vm.BoxSKU:'null';
            var customer_id = $rootScope.customerId;
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl +'/report/export/'+fromDate+'/'+toDate+'/'+productName+'/'+customerName+'/'+store+'/'+customer_id+'/'+BoxSKU+'/'+userId+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.02.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.productName = '';
          vm.customerName = '';
          vm.BoxSKU = '';
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalPrice = 0;
        vm.totalQty = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/sales',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    store_id: (vm.store!= '0'?vm.store:''),
                    prouct_name: vm.productName?vm.productName:'',
                    customer_name: vm.customerName?vm.customerName:'',
                    box_sku: vm.BoxSKU?vm.BoxSKU:'',
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 vm.totalPrice = result.data.totalPrice;
                 vm.totalQty = result.data.totalQty;
                 angular.element('.qty-class span span').html(vm.totalQty);
                 angular.element('.price-class span span').html(vm.totalPrice);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWitRelayCategory(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        function renderWitRelayPrice(data){
          if(data){
            return '$' + data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('item_increment_id').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Product Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('cust_name').withTitle('Customer Name').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty_ordered').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('price').withTitle('Price').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('job_by_relay_or_silvercyade').withTitle('Design By').withOption('className', 'text-center'));
            
            if ($rootScope.permissionArr.indexOf('product_sales_3d_category') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price_category').withTitle('3D Category').renderWith(renderWitRelayCategory).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('product_sales_3d_price') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('relay_link_price').withTitle('3D Price').renderWith(renderWitRelayPrice).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('product_sales_total_cost') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('product_price').withTitle('Total Cost').renderWith(renderWitRelayPrice).withOption('className', 'text-center'));
            }

            if ($rootScope.permissionArr.indexOf('product_sales_total_order_cost') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('total_order_cost').withTitle('Total Order Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-right'));
            }

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Qty: <span></span>',
                    className: 'btn btn-success qty-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: 'Total Price: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }

        /**
         * Get all products list method is use to get product data.
         * created on 07.25.2018
         */
        $scope.getProductData = function(){
            $http.get($rootScope.baseUrl + '/inventory/products/getproduct/active')
            .success(function (response) {
              vm.productData=response;
              vm.productData.splice(0,0,{id: -1, name: 'All'});
            }).error(function (response) {
            });
        }

        $scope.getProductBoxData = function(){
            $http.get($rootScope.baseUrl + '/inventory/products/getbox/sku')
            .success(function (response) {
              vm.BoxData=response;
              vm.BoxData.splice(0,0,{id: -1, sku: 'All'});
            }).error(function (response) {
            });
        }
    }
})();

/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2021
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('shipmentBoxCountReportCtrl', shipmentBoxCountReportCtrl);

    /** @ngInject */
    function shipmentBoxCountReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.02.2021
         */
        if ($rootScope.permissionArr.indexOf('shipment_box_count_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.02.2021
        */
        $scope.vmAdded = this;
        

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.shipment-box-count-report';

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        
        
        /**
        * Options method is use configure date picker options
        * Created on 11.02.2021
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2021
        */
        $scope.export = function (type){
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            
            window.open($rootScope.baseUrl +'/report/shipment-box-count/'+fromDate+'/'+toDate+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function (){
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/shipment-box-count',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('package').withTitle('Box').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('count').withTitle('Total').withOption('className', 'text-center'));
            
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
    }
})();

/**
 * Shipment Box report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 05.01.2023
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('shipmentBoxReportCtrl', shipmentBoxReportCtrl);

    /** @ngInject */
    function shipmentBoxReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 05.01.2023
         */
        if ($rootScope.permissionArr.indexOf('shipment_box_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.AllBoxes = [];
        $scope.isloaded = false;
        $scope.resetGlobalSearch();

        /**
        * configuration datatable instance
        * Created on 05.01.2023
        */
        $scope.vmAdded = this;
        

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.shipment-box-report';

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        
        
        /**
        * Options method is use configure date picker options
        * Created on 05.01.2023
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2021
        */
        $scope.export = function (type){
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            
            window.open($rootScope.baseUrl +'/report/shipment-box-report/'+fromDate+'/'+toDate+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function (){
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/shipment-box-report',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    boxid: vm.boxid?vm.boxid:'',
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        $scope.getBoxData = function ()
        {
            $scope.AllBoxes = [];
            $http.get($rootScope.baseUrl + '/shipment/getactiveboxes')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else
              {
                var data = { };

                $.each( result, function( i, val ) {
                  data = { 
                    label: val.box_name
                  };
                  
                  $scope.AllBoxes.push(data);
                });
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        }
        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_number').withTitle('Shipment Number').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('box').withTitle('Box').withOption('className', 'text-center').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('qty').withTitle('Quantity').withOption('className', 'text-center').withOption('orderable', false));
            
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }
    }
})();

/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2021
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('shipmentReportCtrl', shipmentReportCtrl);

    /** @ngInject */
    function shipmentReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.02.2021
         */
        if ($rootScope.permissionArr.indexOf('shipment_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.02.2021
        */
        $scope.vmAdded = this;
        vm.store = "0";
        vm.shipmentNumber = '';
        vm.customerName = '';
        vm.trackingNumber = '';
        vm.address_type = '';
        vm.service = '';
        vm.storeData=[];

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.shipment-report';

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        
        
        /**
        * Options method is use configure date picker options
        * Created on 11.02.2021
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2021
        */
        $scope.export = function (type){
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var service = (vm.service!= ''?vm.service:'null');
            var shipmentNumber = (vm.shipmentNumber!= ''?vm.shipmentNumber:'null');
            var customerName = (vm.customerName!= ''?vm.customerName:'null');
            var tracking_number = (vm.trackingNumber!= ''?vm.trackingNumber:'null');
            var store = (vm.store!= ''?vm.store:'null');
            var address_type = (vm.address_type!= ''?vm.address_type:'null');

            window.open($rootScope.baseUrl +'/report/shipment/'+fromDate+'/'+toDate+'/'+shipmentNumber+'/'+customerName+'/'+tracking_number+'/'+service+'/'+store+'/'+address_type+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
            //window.open($rootScope.baseUrl +'/report/export/'+fromDate+'/'+toDate+'/'+shipmentNumber+'/'+customerName+'/'+trackingNumber+'/'+customer_id+'/'+sortColIndex+'/'+sortColOrder+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        vm.totalPrice = 0;

        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.shipmentNumber = '';
          vm.customerName = '';
          vm.trackingNumber = '';
          vm.address_type = '';
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalPrice = 0;
        vm.totalQty = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/shipment',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    shipment_number: vm.shipmentNumber?vm.shipmentNumber:'',
                    customer_name: vm.customerName?vm.customerName:'',
                    tracking_number: vm.trackingNumber?vm.trackingNumber:'',
                    service: vm.service?vm.service:'',
                    store: vm.store?vm.store:'',
                    address_type: vm.address_type?vm.address_type:'',
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'',
                    customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                    customer_role:$rootScope.userRole,
                    store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                    mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 vm.totalPrice = result.data.totalPrice;
                 angular.element('.price-class span span').html(vm.totalPrice);
                 
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Shipment Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('order_number').withTitle('Order No').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_order_number').withTitle('Shipment No'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('sold_to').withTitle('Sold To').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to').withTitle('Ship To').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('service_type').withTitle('Service Used'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('service_type_requested').withTitle('Service Requested'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('country_id').withTitle('Country').withOption('className', 'text-center').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_items_count').withTitle('Total Items').withOption('className', 'text-center').withOption('orderable', false));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('total_items').withTitle('Total Items').withOption('className', 'text-center').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_weight').withTitle('Weight').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('box').withTitle('Box').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('processing_fee').withTitle('Processing Fee').renderWith($scope.renderWithDollar).withOption('className', 'text-center').withOption('orderable', false));
            vm.dtColumns.push(DTColumnBuilder.newColumn('charge').withTitle('Charge').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('tracking_number').withTitle('Tracking No').renderWith(renderWithProduct).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_by').withTitle('Shipped By').withOption('className', 'text-center'));
            //vm.dtColumns.push(DTColumnBuilder.newColumn('qty_ordered').withTitle('Qty').renderWith(renderInteger).withOption('className', 'text-center'));
            
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Total Price: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }

        
        /**
        * getStoreData is use to get list of Store
        * created on 27.4.2021
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
    }
})();


/*
 * Shipment Report 2
 * Created July 2026
 * True separated implementation. No DataTables / no withFnServerData.
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.reports')
    .controller('shipmentReport2Ctrl', shipmentReport2Ctrl);

  shipmentReport2Ctrl.$inject = ['$scope', '$http', '$rootScope', '$state', 'apiService', 'toastr'];

  function shipmentReport2Ctrl($scope, $http, $rootScope, $state, apiService, toastr) {
    var vm = this;

    if ($rootScope.permissionArr && $rootScope.permissionArr.indexOf('shipment_report') === -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
      return;
    }

    $rootScope.currentState = 'reports.shipment-report2';
    if ($scope.resetGlobalSearch) $scope.resetGlobalSearch();

    vm.rows = [];
    vm.storeData = [];
    vm.loading = false;
    vm.error = '';
    vm.totalPrice = '0.00';
    vm.page = 1;
    vm.perPage = ($rootScope.numberOfRecord ? $rootScope.numberOfRecord - 1 : 50);
    vm.totalRecords = 0;
    vm.totalPages = 1;
    vm.sortColumn = 0;
    vm.sortDir = 'desc';

    vm.store = '0';
    vm.service = '';
    vm.shipmentNumber = '';
    vm.customerName = '';
    vm.trackingNumber = '';
    vm.address_type = '';

    $scope.datePickerReports = $rootScope.datePickerReports || {};
    $scope.datePickerReports.date = $scope.datePickerReports.date || {
      startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    };

    $scope.options = {
      applyClass: 'btn-green',
      maxDate: moment(),
      locale: $rootScope.datePicker.locale,
      ranges: $rootScope.datePicker.options,
      eventHandlers: {
        'apply.daterangepicker': function () {
          $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
          $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
          $rootScope.datePickerReports = $rootScope.datePickerReports || {};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
        }
      }
    };

    $scope.focusInput = function () { angular.element('#dateRange').focus(); };

    vm.columns = [
      { key: 'created_at', title: 'Shipment Date', sortable: true, index: 0 },
      { key: 'shipment_order_number', title: 'Shipment No', sortable: true, index: 1 },
      { key: 'sold_to', title: 'Sold To', sortable: false, index: 2 },
      { key: 'ship_to', title: 'Ship To', sortable: false, index: 3 },
      { key: 'service_type', title: 'Service Used', sortable: true, index: 2 },
      { key: 'service_type_requested', title: 'Service Requested', sortable: false, index: 5 },
      { key: 'country_id', title: 'Country', sortable: false, index: 6 },
      { key: 'shipment_items_count', title: 'Total Items', sortable: false, index: 7 },
      { key: 'shipment_weight', title: 'Weight', sortable: false, index: 8 },
      { key: 'box', title: 'Box', sortable: false, index: 9 },
      { key: 'processing_fee', title: 'Processing Fee', sortable: false, index: 10, money: true },
      { key: 'charge', title: 'Charge', sortable: true, index: 3, money: true },
      { key: 'tracking_number', title: 'Tracking No', sortable: true, index: 4 },
      { key: 'created_by', title: 'Shipped By', sortable: true, index: 5 }
    ];

    vm.getStoreData = function () {
      $http.get($rootScope.baseUrl + '/store')
        .success(function (res) { vm.storeData = res || []; })
        .error(function () { toastr.error('Could not load stores.'); });
    };

    function buildColumnsPayload() {
      return vm.columns.map(function (col) {
        return { data: col.key, name: '', searchable: true, orderable: !!col.sortable, search: { value: '', regex: false } };
      });
    }

    function buildPayload() {
      return {
        start: (vm.page - 1) * vm.perPage,
        length: vm.perPage,
        draw: vm.page,
        order: [{ column: vm.sortColumn, dir: vm.sortDir }],
        search: { value: '', regex: false },
        columns: buildColumnsPayload(),
        shipment_number: vm.shipmentNumber || '',
        customer_name: vm.customerName || '',
        tracking_number: vm.trackingNumber || '',
        service: vm.service || '',
        store: vm.store && vm.store !== '0' ? vm.store : '',
        address_type: vm.address_type || '',
        from_date: $scope.datePickerReports.date.startDate ? $scope.saveFromDateFormat($scope.datePickerReports.date.startDate) : '',
        to_date: $scope.datePickerReports.date.endDate ? $scope.saveToDateFormat($scope.datePickerReports.date.endDate) : '',
        customer_id: ($rootScope.userRole === 'ROLE_CUSTOMER' || $rootScope.userRole === 'ROLE_SUB_CUSTOMER') ? $rootScope.customerId : 0,
        customer_role: $rootScope.userRole,
        store_permssion: $rootScope.globals.currentUser.store_permission ? $rootScope.globals.currentUser.store_permission.toString() : '',
        mall_customer_permission: $rootScope.globals.currentUser.mall_customer_permission ? $rootScope.globals.currentUser.mall_customer_permission.toString() : ''
      };
    }

    function parseOriginal(res) {
      if (res && res.data && res.data.data && res.data.data.original) return res.data.data.original;
      if (res && res.data && res.data.original) return res.data.original;
      return { data: [], recordsTotal: 0, recordsFiltered: 0, draw: 1 };
    }

    vm.load = function () {
      vm.loading = true;
      vm.error = '';
      apiService.loaderShow();
      $http({ method: 'POST', url: $rootScope.baseUrl + '/report/shipment', data: buildPayload(), headers: { 'Content-type': 'application/json' } })
        .then(function (res) {
          apiService.loaderHide();
          vm.loading = false;
          var original = parseOriginal(res);
          vm.rows = original.data || [];
          vm.totalRecords = original.recordsFiltered || original.recordsTotal || 0;
          vm.totalPages = Math.max(1, Math.ceil(vm.totalRecords / vm.perPage));
          vm.totalPrice = res.data && res.data.totalPrice ? res.data.totalPrice : '0.00';
        }, function (err) {
          apiService.loaderHide();
          vm.loading = false;
          vm.rows = [];
          vm.totalRecords = 0;
          vm.totalPages = 1;
          vm.error = 'Shipment Report 2 failed to load. Check Network response.';
          console.error('Shipment Report 2 error:', err);
        });
    };

    vm.apply = function () { vm.page = 1; vm.load(); };

    vm.reset = function () {
      vm.store = '0'; vm.service = ''; vm.shipmentNumber = ''; vm.customerName = ''; vm.trackingNumber = ''; vm.address_type = '';
      $scope.datePickerReports.date = { startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD') };
      $rootScope.datePickerReports = $rootScope.datePickerReports || {};
      $rootScope.datePickerReports.date = $scope.datePickerReports.date;
      vm.page = 1; vm.sortColumn = 0; vm.sortDir = 'desc'; vm.load();
    };

    vm.sort = function (col) {
      if (!col.sortable) return;
      if (vm.sortColumn === col.index) vm.sortDir = vm.sortDir === 'asc' ? 'desc' : 'asc';
      else { vm.sortColumn = col.index; vm.sortDir = 'asc'; }
      vm.page = 1;
      vm.load();
    };

    vm.nextPage = function () { if (vm.page < vm.totalPages) { vm.page++; vm.load(); } };
    vm.prevPage = function () { if (vm.page > 1) { vm.page--; vm.load(); } };

    vm.formatCell = function (row, col) {
      var value = row[col.key];
      if (value === null || value === undefined || value === '') return col.money ? '$0.00' : 'N/A';
      if (col.key === 'created_at' && $scope.getGlobalDateFormat) return $scope.getGlobalDateFormat(value);
      if (col.money) return $scope.renderWithDollar ? $scope.renderWithDollar(value) : ('$' + parseFloat(value || 0).toFixed(2));
      return value;
    };

    vm.export = function (type) {
      var from = $scope.datePickerReports.date.startDate ? $scope.saveFromDateFormat($scope.datePickerReports.date.startDate) : 'null';
      var to = $scope.datePickerReports.date.endDate ? $scope.saveToDateFormat($scope.datePickerReports.date.endDate) : 'null';
      var shipmentNumber = vm.shipmentNumber ? encodeURIComponent(vm.shipmentNumber) : 'null';
      var customerName = vm.customerName ? encodeURIComponent(vm.customerName) : 'null';
      var trackingNumber = vm.trackingNumber ? encodeURIComponent(vm.trackingNumber) : 'null';
      var service = vm.service ? encodeURIComponent(vm.service) : 'null';
      var store = vm.store && vm.store !== '0' ? encodeURIComponent(vm.store) : 'null';
      var addressType = vm.address_type ? encodeURIComponent(vm.address_type) : 'null';
      window.open($rootScope.baseUrl + '/report/shipment/' + from + '/' + to + '/' + shipmentNumber + '/' + customerName + '/' + trackingNumber + '/' + service + '/' + store + '/' + addressType + '/' + vm.sortColumn + '/' + vm.sortDir + '/' + type, '_self');
    };

    vm.getStoreData();
    vm.load();
  }
})();

/**
 * Report dashboard controller handle all action related design report.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 02.12.2018
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('shipmentReportDashboardCtrl', shipmentReportDashboardCtrl);

    /** @ngInject */
    function shipmentReportDashboardCtrl($scope, $http, $rootScope, $state, baConfig, $uibModal, apiService, toastr, DTColumnBuilder, DTOptionsBuilder,$timeout) {
         /**
         * permissionArr is use to check permission of user
         * created on 02.12.2018
         */
        if ($rootScope.permissionArr.indexOf('report_dashboard_view') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        $rootScope.currentState = 'reports.shipment-report-dashboard';
        $scope.resetGlobalSearch();

        /**
         * Set Configuration of date range
         */
        $scope.storeData = [];
        $scope.totaldata = 0;
        $scope.timeData = {
            'daily':0,
            'weekly':0,
            'monthly':0,
            'yearly':0,
        }
        if($rootScope.datePickerReports) {
          $rootScope.datePicker.date = $rootScope.datePickerReports.date;
        }
        else
        {
          $rootScope.datePickerReports = {};
          $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        
        $scope.dateRanges = [{
                key: 'daily',
                from_date:$scope.saveFromDateFormat(moment().format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }, {
                key: 'weekly',
                from_date:$scope.saveFromDateFormat(moment().startOf('isoWeek').format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }, {
                key: 'monthly',
                from_date:$scope.saveFromDateFormat(moment().startOf('month').format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }, {
                key: 'yearly',
                from_date:$scope.saveFromDateFormat(moment().startOf('year').format('YYYY-MM-DD')),
                to_date:$scope.saveToDateFormat(moment())
            }
        ];

       /**
        * Options method is use configure date picker options
        * created on 10.06.2017
        */
        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {

                'apply.daterangepicker' : function() {
                    $rootScope.datePickerReports.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePickerReports.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                },
                'hide.daterangepicker':function() {
                    $rootScope.datePickerReports.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePickerReports.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.startDate = moment($rootScope.datePicker.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePicker.date.endDate = moment($rootScope.datePicker.date.endDate).format('YYYY-MM-DD');
                }
            }
        }
        /**
         * focus Input methos is used for focus on date picker.
         * created on 09.26.2017
         */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }
        /**
         * reset dashboard is use to reset data
         * Created on 05.01.2018
         */
        $scope.resetDashboard = function() {
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.loadDataFromAPI();
        }
        $scope.renderWithTotal=function(data){
            if(data && data!=0){
              return data.toFixed(2);
            }else{
              return data;
            }
        }
        /**
         * Load data from API is used for load status data.
         * created on 09.26.2017
         */
        $scope.loadDataFromAPI = function()
        {
            apiService.loaderShow();
            var customer_id = $rootScope.customerId;
            $http.post($rootScope.baseUrl + '/report/shipmentDashboard',{
                from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
                to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate),
                data:$scope.dateRanges,
                customer_id:customer_id,
                store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():''),
            }).success(function (response) {
                apiService.loaderHide();
                $scope.timeData = response.data.header;
                $scope.storeData = response.data.store;
               // console.log($scope.storeData);
                $scope.totaldata = Object.keys($scope.storeData).length;

            }).error(function (response) {
                apiService.loaderHide();
            });
        }
        $scope.loadDataFromAPI();
        var layoutColors = baConfig.colors;
        $scope.piechartDataKeys = [];
        $scope.colors = [layoutColors.successLight, layoutColors.danger];
        $scope.colors = [{
            backgroundColor: '#cef353',
            pointBackgroundColor: layoutColors.successLight,
          },{
            backgroundColor: '#f97979',
            pointBackgroundColor:  layoutColors.danger,
          }];
          $scope.pieChartOptions = {
              // tooltips:{
              //   callbacks: {
              //       label: function (tooltipItem, data) {
              //           var cData = data.datasets[tooltipItem.datasetIndex].data;
              //           var _meta = data.datasets[tooltipItem.datasetIndex]._meta;
              //           var meta = _meta[Object.keys(_meta)[0]];
              //           var ttLbl = data.labels[tooltipItem.index];
              //           var ttData = cData[tooltipItem.index];
              //           if (ttData == 0.01) {
              //             return ttLbl+': 0';
              //           }else{
              //             return ttLbl+': '+ttData;
              //           }
              //       }
              //   }
              // },
              elements: {
                arc: {
                  borderWidth: 0
                }
              },
              cutoutPercentage:-1,
              animation:{
                duration:0
              }
        };
        /**
         * Load chart data is used for load chart data.
         * created on 09.26.2017
         */

         $scope.searchApply = function (){
            
            console.log($scope);
           // $scope.vmAdded.dtInstance.DataTable.draw();
        }


        $scope.loadChartData = function(id, name, position, total)
        {
            apiService.loaderShow();
            $scope.total = total;
            $scope.position=position?position:'';
            $scope.storeName = name+' '+$scope.position;
            $rootScope.storeId=id;
            $http.post($rootScope.baseUrl+'/report/shipment_storepopup/'+id,{

                from_date:$scope.saveFromDateFormat($rootScope.datePicker.date.startDate),
                to_date:$scope.saveToDateFormat($rootScope.datePicker.date.endDate)
            }).success(function(response){
              apiService.loaderHide();
              $scope.categoryCrystalData=response;
              $rootScope.catPopupSize = $(window).height();
              $rootScope.catPopupSize = ($rootScope.catPopupSize-100);
              $rootScope.catPopupSizeMin = ($rootScope.catPopupSize-50);

             // console.log($scope.categoryCrystalData);
             
             $timeout(function () {
                      // $('.odd').hide();
                      // $(".dataTables_empty").hide();
                      // $(".dataTables_filter").hide();
                      
                    }, 200);
             
              $scope.popupShow = $uibModal.open({
                  animation: true,
                  size: 'report-chart',
                  templateUrl: 'app/pages/reports/shipmentReportDashboard/categoryCrystalModel.html',
                  scope:$scope,
              });

              $scope.reloadData = function() {
                 $scope.dtInstance.rerender(); 
              }

            }).error(function(error){
              apiService.loaderHide();
            });
        }
       
        


        /**
       * Export function is used for export report
       * Created on 26.06.2018
       */



       $scope.export = function (type){
           var fromDate = $rootScope.datePicker.date.startDate?$scope.saveFromDateFormat($rootScope.datePicker.date.startDate):'null';
           var toDate = $rootScope.datePicker.date.endDate?$scope.saveToDateFormat($rootScope.datePicker.date.endDate):'null';
           var storeId = ($rootScope.storeId?$rootScope.storeId:'null');
           window.open($rootScope.baseUrl + '/report/storeexport_report_dashboard/'+fromDate+'/'+toDate+'/'+storeId+'/'+type+'', '_self');
       }

    }
})();

/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2021
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('shippingCountReportCtrl', shippingCountReportCtrl);

    /** @ngInject */
    function shippingCountReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.02.2021
         */
        if ($rootScope.permissionArr.indexOf('shipping_count_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.02.2021
        */
        $scope.vmAdded = this;
        

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.shipping-count-report';

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }
        
        
        /**
        * Options method is use configure date picker options
        * Created on 11.02.2021
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 11.02.2021
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.02.2021
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2021
        */
        $scope.export = function (type){
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            if(sortOptions[0][0] && sortOptions[0][1]){
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            
            window.open($rootScope.baseUrl +'/report/shipping-count/'+fromDate+'/'+toDate+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.02.2021
        */
        $scope.resetSearch = function (){
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $rootScope.datePickerReports.date = $scope.datePickerReports.date;
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        /**
        * Server data method is use for load data from API.
        * Created on 11.02.2021
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/shipping-count',
                data: {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    from_date:$scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'',
                    to_date:$scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').hide();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 11.02.2021
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.02.2021
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.02.2021
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2021
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipped_by').withTitle('Shipped By').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('count').withTitle('Total').withOption('className', 'text-center'));
            
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }

        
        /**
        * getStoreData is use to get list of Store
        * created on 27.4.2021
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }
    }
})();

/**
 * Sales report controller handle all action related Sales report.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 11.02.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('stockReportCtrl', stockReportCtrl);

    /** @ngInject */
    function stockReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder)
    {
        /**
         * permissionArr is use to check permission of user
         * created on 14.07.2020
         */
        if ($rootScope.permissionArr.indexOf('stock_report') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }

        var vm = this;
        $scope.resetGlobalSearch();
        $scope.isloaded = false;

        $timeout(function () {
            angular.element('.dataTables_paginate').hide();
        }, 200);
        $rootScope.currentState = 'reports.stock-report';

        $scope.serchByList = ['Product','Stock','Allocated','Available','Updated Date'];

        if(!$rootScope.datePickerReports) {
          $rootScope.datePickerReports = {};
          $rootScope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Options method is use configure date picker options
        * Created on 14.07.2020
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                     $rootScope.datePickerReports.date = $scope.datePickerReports.date;
                }
            }
        }

        /**
        * Set Focus Of Date Picker
        * Created on 14.07.2020
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 14.07.2020
        */
        $scope.searchApply = function (){
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Export function is used for export report
        * Created on 14.07.2020
        */
        $scope.export = function (type)
        {
            var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
            var sortColIndex = 0;
            var sortColOrder = 'desc';
            
            if(sortOptions[0][0] && sortOptions[0][1])
            {
                sortColIndex = sortOptions[0][0];
                sortColOrder = sortOptions[0][1];
            }
            
            var productName = vm.productName?vm.productName:'null';
            var warehouseName = vm.warehouseName?vm.warehouseName:'null';
            window.open($rootScope.baseUrl +'/report/stock-export/'+productName+'/'+warehouseName+'/'+sortColIndex+'/'+sortColOrder+'/'+type, '_self');
        }

        /**
        * reset Search is use to reset filters
        * Created on 14.07.2020
        */
        $scope.resetSearch = function ()
        {
            vm.productName = '';
            vm.warehouseName = '';
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        /**
        * Server data method is use for load data from API.
        * Created on 14.07.2020
        */
        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            $http(
            {
                method: 'POST',
                url: $rootScope.baseUrl + '/report/stock',
                data: 
                {
                    start: aoData[3].value,
                    length: aoData[4].value,
                    draw: aoData[0].value,
                    order: aoData[2].value,
                    search: aoData[5].value,
                    columns: aoData[1].value,
                    prouct_name: vm.productName?vm.productName:'',
                    warehouse_name: vm.warehouseName?vm.warehouseName:''
                },
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result)
            {
                apiService.loaderHide();
                var result = result.data.data.original;
                if(result.recordsTotal < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                }else{
                    angular.element('.dataTables_paginate').show();
                }
                
                if(result.data.length>0){
                    angular.element('.apply-css').show();
                }else{
                    angular.element('.apply-css').hide();
                }
                
                if(result)
                {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                }
                else
                {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                
                $scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
                apiService.loaderHide();
            })
        };

        /**
        * Rnder only integer value.
        * Created on 14.07.2020
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 14.07.2020
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }

        function renderWithProduct(data)
        {
            if(data){
                return data;
            }
            else{
                return 'N/A';
            }
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 14.07.2020
        */
        function initComplete(row,data)
        {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.02.2017
         */
        $scope.getDataTable = function()
        {
            var vm = this;
            vm.dtColumns = [];
            if ($rootScope.permissionArr.indexOf('stock_report_warehouse_name') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('warehouse_name').withTitle('Warehouse Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('stock_report_product_name') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('name').withTitle('Product Name').renderWith(renderWithProduct).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('stock_report_product_stock') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('stock').withTitle('Stock').renderWith(renderInteger).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('stock_report_product_allocated') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('allocated').withTitle('Allocated').renderWith(renderInteger).withOption('className', 'text-center'));
            }
            if ($rootScope.permissionArr.indexOf('stock_report_product_available') != -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('available').withTitle('Available').renderWith(renderInteger).withOption('className', 'text-center'));
            }

            vm.dtColumns.push(DTColumnBuilder.newColumn('on_the_way').withTitle('In Transit').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('in_process').withTitle('China Production').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_stock').withTitle('Total Stock').renderWith(renderInteger).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('total_cost').withTitle('Total Cost').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('updated_at').withTitle('Updated Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withButtons([{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                className: 'btn btn-danger margin-rigth-10 apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('csv');
                }
            },{
                text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                className: 'btn btn-danger apply-css',
                action: function ( e, dt, node, config ) {
                    $scope.export('xls');
                }
            }])
            .withOption('serverSide', true)
            .withPaginationType('simple_numbers')
            .withOption('deferRender', true)
            .withOption('searching', true)
            .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
            .withOption('bLengthChange', true)
            .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
            .withOption('bInfo', true)
            .withOption('autoWidth', true)
            .withOption('order', [0, 'desc'])
            .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
            .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }


        /**
         * Get all products list method is use to get product data.
         * created on 14.07.2020
         */
        $scope.getProductData = function()
        {
            $http.get($rootScope.baseUrl + '/inventory/products')
            .success(function (response)
            {
              vm.productData=response;
              vm.productData.splice(0,0,{id: -1, name: 'All'});
            }).error(function (response) {
            });
        }

        /**
         * Get all products list method is use to get product data.
         * created on 14.07.2020
         */
        $scope.getWarehouseData = function()
        {
            $http.get($rootScope.baseUrl + '/warehouse')
            .success(function (response)
            {
              vm.warehouseData=response;
              vm.warehouseData.splice(0,0,{id: -1, warehouse_name: 'All'});
            }).error(function (response) {
            });
        }
    }
})();
/**
 * Rework report controller handle all action related Rework report.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 11.07.2017
 */

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reports')
            .controller('storeCreditReportCtrl', storeCreditReportCtrl);

    /** @ngInject */
    function storeCreditReportCtrl($scope, $http, $rootScope, $state, $timeout, $compile, apiService, toastr, DTColumnBuilder, DTOptionsBuilder, $stateParams, $cookies) {
        /**
         * permissionArr is use to check permission of user
         * created on 11.07.2017
         */
//        if ($rootScope.permissionArr.indexOf('store_credit_report') == -1) {
//            $state.go('dashboard');
//            toastr.error("You don't have permission to do this.");
//        }
        var vm = this;
        $scope.resetGlobalSearch();
        /**
        * configuration datatable instance
        * Created on 11.07.2017
        */
       
        $scope.vmAdded = this;
        vm.store = "0";
        vm.mall = "0";
        vm.action="";
        $rootScope.currentState = 'reports.store-credit-report';
        if($stateParams.type == 'mall_customer_credit_report') {
            $rootScope.currentState = 'account-settings.mall-customers';
        }
        if($stateParams.type == 'profile_customer_credit_report') {
            $rootScope.currentState = 'dashboard';
        }

        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer'];

        $scope.datePickerReports = {};
        $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        /**
        * getStoreData is use to get list of Store
        * created on 11.7.2017
        */
        $scope.getStoreData = function () {
          //$scope.isloaded = false;
          $http.get($rootScope.baseUrl+'/store')
              .success(function (result) {
                  //$scope.isloaded = true;
                 vm.storeData=result;
              }).error(function (error) {
                  //$scope.isloaded = true;
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
        * getMallData is use to get list of Owner's Mall
        * created on 16.4.2021
        */
        $scope.getMallData = function ()
        {
            $http.get($rootScope.baseUrl+'/owner/getmalls')
              .success(function (result) {
                vm.mallData=result;
            }).error(function (error) {
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
            });
        }   

        /**
        * Options method is use configure date picker options
        * Created on 11.07.2017
        */

        $scope.options = {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : {
                'apply.daterangepicker' : function() {
                     $scope.datePickerReports.date.startDate = moment($scope.datePickerReports.date.startDate).format('YYYY-MM-DD');
                     $scope.datePickerReports.date.endDate = moment($scope.datePickerReports.date.endDate).format('YYYY-MM-DD');
                }
            }
        }


        /**
        * Set Focus Of Date Picker
        * Created on 29.12.2018
        */
        $scope.focusInput=function(){
          angular.element('#dateRange').focus();
        }

        /**
        * Search apply is use to apply filters
        * Created on 11.07.2017
        */
        $scope.searchApply = function (){
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
         /**
        * Export function is used for export report
        * Created on 11.03.2017
        */
        $scope.export = function (type){
          var sortOptions = $scope.vmAdded.dtInstance.DataTable.order();
          var sortColIndex = 0;
          var sortColOrder = 'desc';
          if(sortOptions[0][0] && sortOptions[0][1]){
              sortColIndex = sortOptions[0][0];
              sortColOrder = sortOptions[0][1];
          }
            var fromDate = $scope.datePickerReports.date.startDate?$scope.saveFromDateFormat($scope.datePickerReports.date.startDate):'null';
            var toDate = $scope.datePickerReports.date.endDate?$scope.saveToDateFormat($scope.datePickerReports.date.endDate):'null';
            var storeIds = vm.store!= ''?vm.store:'null';
            var actions = vm.action!= ''?vm.action:'null';
            var addInformations = vm.addInformation?vm.addInformation:'null';
            var isFromMallCustomer = 'null';
            var mallCustomerId = 'null';
            if($stateParams.type=='mall_customer_credit_report') {
                isFromMallCustomer = 'enable';
                mallCustomerId = 'null';
                if($cookies.get('customer-id') && $cookies.get('customer-id')!= undefined) {
                    mallCustomerId = $cookies.get('customer-id');
                }
            }
            if($stateParams.type=='profile_customer_credit_report') {
                isFromMallCustomer = 'enable';
                mallCustomerId = 'null';
                if($cookies.get('customer-id') && $cookies.get('customer-id')!= undefined) {
                    mallCustomerId = $cookies.get('customer-id');
                }
            }
            var storePermssion = ($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():'')
            var mallCustomerPermission = ($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            window.open($rootScope.baseUrl + '/report/store-creditreport/'+fromDate+'/'+toDate+'/'+storeIds+'/'+actions+'/'+addInformations+'/'+sortColIndex+'/'+sortColOrder+'/'+isFromMallCustomer+'/'+mallCustomerId+'/'+type+'?store_permssion='+storePermssion+'&mall_customer_permission='+mallCustomerPermission, '_self');
        }
        /**
        * reset Search is use to reset filters
        * Created on 11.07.2017
        */
        $scope.resetSearch = function (){
          vm.store = "0";
          vm.action="";
          vm.addInformation="";
          $scope.datePickerReports.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
          $scope.vmAdded.dtInstance.DataTable.draw();
        }
        vm.totalCost = 0;
        /**
        * Server data method is use for load data from API.
        * Created on 11.07.2017
        */
        function serverData(sSource, aoData, fnCallback, oSettings) {
            apiService.loaderShow();
            var requestData = {
                start: aoData[3].value,
                length: aoData[4].value,
                draw: aoData[0].value,
                order: aoData[2].value,
                search: aoData[5].value,
                columns: aoData[1].value,
                store_id: (vm.store != '0' ? vm.store : ''),
                action: vm.action ? vm.action : '',
                add_information: vm.addInformation ? vm.addInformation : '',
                type: $stateParams.type,
                mall: vm.mall,
                from_date: $scope.datePickerReports.date.startDate ? $scope.saveFromDateFormat($scope.datePickerReports.date.startDate) : '',
                to_date: $scope.datePickerReports.date.endDate ? $scope.saveToDateFormat($scope.datePickerReports.date.endDate) : '',
                store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
                mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
            }
            
            if($stateParams.type=='mall_customer_credit_report') {
                requestData['is_from_mall_customer'] = 'enable';
                if($cookies.get('customer-id') && $cookies.get('customer-id')!= undefined && $cookies.get('customer-id')!= "null") {
                    requestData['mall_customer_id'] = $cookies.get('customer-id');
                }
            }
            if($stateParams.type=='profile_customer_credit_report') {
                requestData['is_from_mall_customer'] = 'disable';
                if($cookies.get('customer-id') && $cookies.get('customer-id')!= undefined && $cookies.get('customer-id')!= "null") {
                    requestData['mall_customer_id'] = $cookies.get('customer-id');
                    requestData['is_from_mall_customer'] = 'enable';
                }
            }
            $http({
                method: 'POST',
                url: $rootScope.baseUrl + '/report/store-credit-report-list',
                data: requestData,
                headers: {
                    'Content-type': 'application/json'
                }
            }).then(function(result) {
                apiService.loaderHide();
                 vm.totalCost = result.data.totalPrice;
                 angular.element('.price-class span span').html(vm.totalCost);
                 var result = result.data.data.original;
                 if(result.recordsTotal < $rootScope.numberOfRecord){
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                  }else{
                        angular.element('.dataTables_paginate').show();
                  }
                  if(result.data.length>0){
                    angular.element('.apply-css').show();
                  }else{
                    angular.element('.apply-css').show();
                  }
                  if(result){
                      var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                  }else{
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }
                //$scope.isloaded = true;
                fnCallback(records);
            },function errorCallback(response) {
              apiService.loaderHide();
            })
        };
        /**
        * Rnder only integer value.
        * Created on 11.07.2017
        */
        function renderInteger(data){
            return parseInt(data);
        }

        /**
        * Change Date Formate method is use for formate date.
        * Created on 11.07.2017
        */
        function changeDateFormate(data){
            return moment(data).format('YYYY-MM-DD h:mm A')
        }
        function renderWithProduct(data){
          if(data){
            return data;
          }else{
            return 'N/A';
          }
        }

        function getActionType(data,full,type){
            if (type.magento_version) {
                if (type.magento_version == 'm2') {
                    if (data == 1) {
                        return 'Store Credit used in order';
                    } else if (data == 2) {
                        return 'Reimburse of spent Store Credit';
                    } else if (data == 3) {
                        return 'Refund by Store Credit';
                    } else if (data == 4) {
                        return 'Order canceled';
                    } else if (data == 5) {
                        return 'Balance adjusted by admin';
                    }
                }
            }
            if (data == 1) {
                return 'Updated';
            } else if (data == 2) {
                return 'Created';
            } else if (data == 3) {
                return 'Used';
            } else if (data == 4) {
                return 'Refunded';
            } else if (data == 5) {
                return 'Reverted';
            }
        }
        function isCustomerNotified(data){
            if (data == 1) {
                return 'Yes';
            } else {
                return 'No';
            }
        }
        function additionalInfo(data) {
            var stringVal = data.toString();
            if (stringVal.length > 40) {
                stringVal = stringVal.substring(0, 40) + '...';
            }
            return '<span title="' + data + '">' + stringVal + '</span>';
        }
        // function renderWithOnlyOrderNumber(data){
        //   if(data){
        //     return data.split('#')[1];
        //   }else{
        //     return '';
        //   }
        // }
        function renderWithStoreCreditChange(data){
          if(data){
            var dataStr=data.toString();
            if(dataStr.includes('-')){
              return '-$'+dataStr.split('-')[1];
            }else{
              return '$'+data;
            }
          }else{
            return '$00.00';
          }
        }
        /**
        * Init complete method is use for add class on DOM of datatable.
        * Created on 11.07.2017
        */
        function initComplete(row,data){
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * Get data table method is use for get list of users.
         * Created on 11.07.2017
         */
        $scope.getDataTable = function() {
            var vm = this;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn('order_increment_id').withTitle('Order Number').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat));
            vm.dtColumns.push(DTColumnBuilder.newColumn('store_name').withTitle('Website').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('customer_name').withTitle('Customer Name').withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('action').withTitle('Action').withOption('className', 'tableDate').renderWith(getActionType));
            vm.dtColumns.push(DTColumnBuilder.newColumn('delta').withTitle('Store Credit Change').renderWith(renderWithStoreCreditChange).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('amount').withTitle('Store Credit').renderWith($scope.renderWithDollar).withOption('className', 'text-center'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('is_customer_notified').withTitle('Customer Notified?').withOption('className', 'tableDate').renderWith(isCustomerNotified));
            vm.dtColumns.push(DTColumnBuilder.newColumn('additional_info').withTitle('Additional Information').withOption('className', 'text-center').renderWith(additionalInfo));
            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withButtons([{
                    text: 'Store Credit: $<span></span>',
                    className: 'btn btn-success price-class report-btn margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        return;
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i>  CSV',
                    className: 'btn btn-danger margin-rigth-10 apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('csv');
                    }
                },{
                    text: '<i class="fa fa-file-excel-o" aria-hidden="true"></i> Excel',
                    className: 'btn btn-danger apply-css',
                    action: function ( e, dt, node, config ) {
                        $scope.export('xls');
                    }
                }
            ])
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('sDom', '<"col-md-3 clearfix"l>Brtip')
                .withOption('bLengthChange', true)
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1))
                .withOption('bInfo', true)
                .withOption('autoWidth', true)
                .withOption('order', [0, 'desc'])
                .withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' })
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
        }



    }
})();

/**
 * Shipment Boxes controller handle all action related Boxes.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 09.23.2019
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.shipSettings')
            .controller('shipmentBoxesCtrl', shipmentBoxesCtrl);

    /** @ngInject */
    function shipmentBoxesCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService,  $q)
    {
        /**
        * permissionArr is use to check permission to display list
        * created on 09.23.2019
        */
        if($rootScope.permissionArr.indexOf('shipment_manage_boxes') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='shipsettings.manage-boxes';
        $scope.resetGlobalSearch();

        $scope.AvailableQty =  function (qty)
        {
            if(qty != undefined){
                return qty
            }
            else {
              return 0;
            }
        }

        /**
         * Get data table method is use get list of boxes.
         * created on 09.23.2019
         */
        $scope.getDataTable = function ()
        {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            $http.get($rootScope.baseUrl + '/shipment/getboxes')
                    .success(function(result) {
                        if(result.length < $rootScope.numberOfRecord){
                            $timeout(function () {
                                angular.element('.dataTables_paginate').hide();
                             }, 200);
                         }
              vm.boxes = [];
              var index = 1 ;
              angular.forEach(result, function(value, key) {
                var changeStatusValTo = '0';
                var editLinks = ' <a href="javascript:void(0);"   ng-click="editBox(\'' + value.box_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                var deleteLinks = '  <a href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/shipSettings/manageBoxes/deleteModal.html' + '\',\'' + value.box_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                var statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageBoxes/statusModal.html' + '\',\'' + value.box_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

                if (value.box_status == '0') {
                    changeStatusValTo = '1';
                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                    statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageBoxes/statusModal.html' + '\',\'' + value.box_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                }

                var data = {
                  index:index,
                  id: value.box_id,
                  name: value.box_name,
                  size: value.box_size,
                  availabel_qty: value.availabel_qty,
                  created_at: value.created_at,
                  status:statusBadge,
                  operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks //+ '&nbsp;' + departmentStatusLinks
                  };
                this.push(data);
                ++index;
              }, vm.boxes);
              defer.resolve(vm.boxes);
            }).error(function (error) {
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            return defer.promise;
          }).withPaginationType('simple_numbers')
          vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $scope.$apply($compile(nRow)($scope));
            });
          vm.dtOptions.withOption('sDom', $rootScope.dom);
          vm.dtOptions.withOption('initComplete', function() {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
         });
          vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          vm.dtColumns = [
            DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            DTColumnBuilder.newColumn('name').withTitle('Box Title'),
            DTColumnBuilder.newColumn('size').withTitle('Size'),
            DTColumnBuilder.newColumn('availabel_qty').withTitle('Available Qty').renderWith($scope.AvailableQty),
            DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
          ];

          vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        }

        /**
         * Add Box method is use for get add box form.
         * created on 09.23.2019
         */
        $scope.addBox = function ()
        {
            $cookies.put('box-id',undefined);
            $state.go('shipsettings.add-box');
        }

        /**
         * Edit box method is use for get edit box page.
         * created on 10.03.2019
         */
        $scope.editBox = function(id)
        {
          $cookies.put('box-id',id);
            $state.go('shipsettings.edit-box');
        };

        $scope.getServiceBoxes = function ()
        {
          var vm = this;
          $http.get($rootScope.baseUrl+'/shipment/serviceboxes')
              .success(function (result) {
                vm.serviceBoxes=result;
              }).error(function (error) {
                  if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
         * Get edited box method is use for get edited shipment box data.
         * created on 09.23.2019
         */
        $scope.getEditedBox = function ()
        {
            $scope.store_costs = [];
            if ($cookies.get('box-id') && $cookies.get('box-id')!= undefined)
            {
                var ma = this;
                  apiService.loaderShow();
                  $http.get($rootScope.baseUrl + '/shipment/editbox/' + $cookies.get('box-id'))
                    .success(function(response) {
                      ma.boxeditId = response.box_id;
                      ma.name = response.box_name;
                      ma.status = response.box_status;
                      var result = response.box_size.split('X');
                      
                      ma.length = parseFloat(result[0]);
                      ma.width = parseFloat(result[1]);
                      ma.height = parseFloat(result[2]);
                      ma.servicebox = response.service_box_id;
                      ma.availabel_qty = parseInt(response.availabel_qty);
                      apiService.loaderHide();
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data && error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                    });
                    $http.get($rootScope.baseUrl + '/shipment/getbox/store-cost/' + $cookies.get('box-id'))
                    .success(function(response) {
                      if(response.status == 'success') {
                        ma.store_costs = response.store_costs;
                      }
                    }).error(function (error) {
                      if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                      } else {
                        toastr.error("Something went wrong please try again.");
                      }
                    });
                } else {
                  $state.go('shipsettings.add-box');
                }
        };

        /**
         * Save shipment box data method is use for update/add shipment box data.
         * created on 09.26.2017
         */
        $scope.saveBoxData = function()
        {
            if (!this.boxFrm.$valid) {
                return;
            }
            $scope.storeSettings={
              'store_costs':this.store_costs
            };

            apiService.loaderShow();
            var bodyData = {
                name: this.name,
                length: this.length,
                width: this.width,
                height: this.height,
                status: this.status,
                service_box: this.servicebox,
                availabel_qty: this.availabel_qty,
                store_costs:angular.toJson($scope.storeSettings),
                affected_by: $rootScope.globals.currentUser.name
            };

            $scope.saveUrl = $rootScope.baseUrl + '/shipment/save-box';
            $scope.httpMethod = 'POST';
            $scope.editedId = this.boxeditId;
            if (this.boxeditId) {
                $scope.saveUrl = $rootScope.baseUrl + '/shipment/save-box/' + this.boxeditId;
                $scope.httpMethod = 'PUT';
            }

            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    toastr.success('Box ' + ($scope.editedId ? 'updated' : 'added') + ' successfully.');
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                $state.go('shipsettings.manage-boxes');
            }, function (response) {

                apiService.loaderHide();

                $state.go('shipsettings.manage-boxes');
                toastr.error("Something went wrong please try again.");
            });
        };

        $scope.AddStock = function ()
        {
          var ma = this;
          $scope.ServiceBoxId = $cookies.get('box-id');
          $scope.addqty = '';
          $scope.addnote = '';
          $scope.addsqty = '';
          $scope.boxName = ma.name;

          apiService.loaderShow();

          $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/shipSettings/manageBoxes/addBoxStock.html',
              scope: $scope,
          });

          apiService.loaderHide();
        }


        $scope.RemoveStock = function ()
        {
          $scope.ServiceBoxId = $cookies.get('box-id');
          $scope.addqty = '';
          $scope.addnote = '';
          $scope.addsqty = '';
          $scope.boxName = '';
          apiService.loaderShow();

          $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/shipSettings/manageBoxes/removeBoxStock.html',
              scope: $scope,
          });

          apiService.loaderHide();
        }

        $scope.ChangeTotalStock = function (qty,type)
        {
          if(!qty) { qty = 0; }

          if(type=='add') {
            $scope.addsqty = qty;
          }
          else if(type=='remove') {
            $scope.removesqty = qty;
          }
        }

        $scope.saveBoxStock = function ()
        {
          if (!this.shipmentBoxStockFrm.$valid) {
            toastr.error("Please enter required fileds");
            angular.element('#addqty').focus();
            return;
          }

          apiService.loaderShow();
          var bodyData = {
            boxid: $cookies.get('box-id'),
            qty: this.addqty?this.addqty:0,
            totalqty: this.addsqty?this.addsqty:0,
            note: this.addnote,
            affected_by: $rootScope.globals.currentUser.id,
          };
          $scope.saveUrl = $rootScope.baseUrl + '/shipment/add-shipment-box-stock';
          $scope.httpMethod = 'POST';
          $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              apiService.loaderHide();
              $scope.$dismiss();
              $state.go($state.$current, null, {
                  reload: true
              });
            }, function(error) {
              apiService.loaderHide();
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                $state.go('shipsettings.manage-boxes');
                toastr.error("Something went wrong please try again.");
              }
            });
        }

        $scope.removeBoxStock = function ()
        {
          if (!this.shipmentBoxStockFrm.$valid) {
            toastr.error("Please enter required fileds");
            angular.element('#removeQty').focus();
            return;
          }

          apiService.loaderShow();
          var bodyData = {
            boxid: $cookies.get('box-id'),
            qty: this.removeQty?this.removeQty:0,
            totalqty: this.removesqty?this.removesqty:0,
            note: this.addnote,
            affected_by: $rootScope.globals.currentUser.id,
          };
          $scope.saveUrl = $rootScope.baseUrl + '/shipment/remove-shipment-box-stock';
          $scope.httpMethod = 'POST';
          $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              apiService.loaderHide();
              $scope.$dismiss();
              $state.go($state.$current, null, {
                  reload: true
                });
            }, function(error) {
              apiService.loaderHide();
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                $state.go('shipsettings.manage-boxes');
                toastr.error("Something went wrong please try again.");
              }
            });
        }

        $scope.BoxStockLog = function ()
        {
          var ma = this;
          $scope.ShipmentBoxId = $cookies.get('box-id');
          $scope.boxName = ma.name;
          $scope.stockLogsArr = [];
          $scope.stockLogsLoaded = false;

          apiService.loaderShow();
          $scope.getStockLogs();
          $('#stockLogsModel').modal();
          apiService.loaderHide();
        }

        $scope.closeStockLogs = function (id,page) {
            $('#stockLogsModel').modal('hide');
        };

        /**
         * getOrderLogs is use to get order details.
         * created on 11.29.2021
         */
        $scope.stockLogsLoaded = false;
        $scope.stockLogsArr = [];
        $scope.getStockLogs = function ()
        {
          $scope.ShipmentBoxId = $cookies.get('box-id');
            $scope.stockLogsArr = [];
            $scope.stockLogsLoaded = false;
            $http.get($rootScope.baseUrl + '/shipment/get-box-stocklog/'+$scope.ShipmentBoxId).then(
            function (response) {
                $scope.stockLogsLoaded = true;
                if(response.data.status == 'success'){
                   $scope.stockLogsArr = response.data.data;
                }
                
            },
            function (error) {
                $scope.stockLogsLoaded = true;
            });
        }
        /**
         * Open model.
         * created on 10.03.2019
         */
        $scope.open = function(page, id, status)
        {
          $rootScope.deleteId = id;
          $rootScope.status = status;
          $scope.popupShow = $uibModal.open({
            animation: true,
            templateUrl: page,
            scope: $scope,
          });
        };

        /**
       * Change status method is use for change status of box.
       * created on 10.03.2019
       */
      $scope.changeBoxStatus = function()
      {
        if ($rootScope.deleteId)
          {
            apiService.loaderShow();
            var bodyData = {
                id: $rootScope.deleteId,
                status:  ""+$rootScope.status+"",
                updated_by:$rootScope.globals.currentUser.id
            };
            $http.put($rootScope.baseUrl + '/shipment/getboxes', bodyData)
            .success(function(result)
            {
              if (result.status == 'success') {
                    toastr.success('Status updated successfully.');
                    $state.go($state.$current, null, {
                      reload: true
                    });
                }
                else
                {
                    $state.go('shipsettings.manage-boxes');
                    toastr.error("Something went wrong please try again.");
                }
                apiService.loaderHide();
              })
              .error(function(error)
              {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
              });
            $scope.popupShow.close();
        }
      };

      /**
       * Delete box method is use for delete box.
       * created on 10.03.2019
       */
      $scope.deleteBox = function()
      {
        if ($rootScope.deleteId)
        {
            apiService.loaderShow();
            $http.delete($rootScope.baseUrl + '/shipment/box/' + $rootScope.deleteId)
            .success(function(result)
            {
                if (result.status == 'success')
                {
                  toastr.success(result.message);
                  $state.go($state.$current, null, {
                      reload: true
                  });
                } else {
                  toastr.error("Something went wrong please try again.");
                }
                apiService.loaderHide();
            })
            .error(function (error)
            {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
        $scope.popupShow.close();
      };
    }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.shipSettings')
            .controller('manageAccountsCtrl', manageAccountsCtrl);

    /** @ngInject */
    function manageAccountsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory,fileReader)
    {
        /**
        * permissionArr is use to check permission to display list
        * created on 10.03.2019
        */
        if($rootScope.permissionArr.indexOf('shipment_manage_accounts') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='shipsettings.manage-accounts';
        $scope.resetGlobalSearch();

        $scope.itemType = '';
        $scope.noSignature = false;
        $scope.signature = $filter('appImage')('theme/profile-pick-default.png');

        $scope.removeSignature = function () {
        	console.log('remove signature');
	        $scope.signature = $filter('appImage')('theme/profile-pick-default.png');
	        $scope.noSignature = true;
	        document.getElementById('uploadSignature').value= null;
	    };

	    $scope.uploadSignature = function ()
	    {
	    	$scope.itemType = '';
	    	$scope.itemType = 'signature';
	        var fileInput = document.getElementById('uploadSignature');
	        fileInput.click();
	    };

	    $scope.getFile = function ()
	    {
	    	if($scope.itemType == 'signature')
	    	{
	    		$scope.noSignature = false;
	        	fileReader.readAsDataUrl(this.file, $scope)
	            .then(function (result) {
	            	$scope.signature = result;
	            });
	        }
	        else if($scope.itemType == 'letterhead')
	        {
	        	$scope.noLetterHead = false;
	        	fileReader.readAsDataUrl(this.file, $scope)
	            .then(function (result) {
	                $scope.letterhead = result;
	            });
	        }
	    };

    	$scope.noLetterHead = false;
        $scope.letterhead = $filter('appImage')('theme/profile-pick-default.png');

        $scope.removeLetterHead = function ()
        {
        	console.log('remove letterhead');
	        $scope.letterhead = $filter('appImage')('theme/profile-pick-default.png');
	        $scope.noLetterHead = true;
	        document.getElementById('uploadLetterHead').value= null;
	    };

	    $scope.uploadLetterHead = function ()
	    {
	    	$scope.itemType = '';
	    	$scope.itemType = 'letterhead';
	        var fileInput = document.getElementById('uploadLetterHead');
	        fileInput.click();
	    };

        /**
         * Get data table method is use get list of shipment accounts.
         * created on 10.03.2019
         */
        $scope.getDataTable = function ()
        {
            var ma = this;
            ma.dtOptions = DTOptionsBuilder.fromFnPromise(function()
            {
            	var defer = $q.defer();
            	$http.get($rootScope.baseUrl + '/shipment/accounts')
            	.success(function(result)
            	{
            		if(result.length < $rootScope.numberOfRecord)
            		{
                    	$timeout(function () {
                    		angular.element('.dataTables_paginate').hide();
                    	}, 200);
                    }
            		ma.accounts = [];
              		var index = 1 ;
              		angular.forEach(result, function(value, key)
              		{
              			var changeStatusValTo = '0';
                		
                		var editLinks = ' <a href="javascript:void(0);"   ng-click="editAccount(\'' + value.account_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                		var deleteLinks = '  <a href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/shipSettings/manageAccounts/deleteModal.html' + '\',\'' + value.account_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                		
                		var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                		var statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageAccounts/statusModal.html' + '\',\'' + value.account_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

                		if (value.account_status == 0)
                		{
                			changeStatusValTo = '1';
                			statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                			statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageAccounts/statusModal.html' + '\',\'' + value.account_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                		}

                		var data = {
                			index:index,
                			id: value.account_id,
                			service: value.account_service,
                			account_number: value.account_number,
                			company_name: value.account_company_name,
                			person_name: value.account_person_name,
                			city: value.account_city,
                			type: value.account_type,
                			created_at: value.created_at,
                			updated_at: value.updated_at,
                			status:statusBadge,
                			operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                		};
                		this.push(data);
                		++index;
                	}, ma.accounts);
                	defer.resolve(ma.accounts);
                })
                .error(function (error)
                {
                	if (error.data.code != undefined && error.data.code == 0) {
                		toastr.error(error.data.message);
                	} else {
                		toastr.error("Something went wrong please try again.");
                	}
                });
            	return defer.promise;
          	})
          	.withPaginationType('simple_numbers')
          	ma.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          	ma.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
            	$scope.$apply($compile(nRow)($scope));
            });
            ma.dtOptions.withOption('sDom', $rootScope.dom);
            ma.dtOptions.withOption('initComplete', function()
            {
            	angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            	angular.element('.dataTables_filter input').attr('class', 'form-control');
            	angular.element('.dataTables_length select').attr('class', 'form-control');
         	});
          	ma.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          	ma.dtColumns = [
            	DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            	DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            	DTColumnBuilder.newColumn('service').withTitle('Service'),
            	//DTColumnBuilder.newColumn('type').withTitle('Type'),
            	DTColumnBuilder.newColumn('account_number').withTitle('Account Number'),
            	DTColumnBuilder.newColumn('company_name').withTitle('Company Name'),
            	DTColumnBuilder.newColumn('person_name').withTitle('Person Name'),
            	DTColumnBuilder.newColumn('city').withTitle('City'),
            	DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
            	DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
          	];
          	ma.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        /**
	     * Add account method is use for get add account page.
	     * created on 10.03.2019
	     */
	    $scope.addAccount = function()
	    {
	    	$cookies.put('account-id',undefined);
	      	$state.go('shipsettings.add-account');
	    };


	    /**
	     * Get edited account method is use for get edited account data.
	     * created on 10.03.2019
	     */
	    $scope.getEditedAccount = function()
	    {
	    	if ($cookies.get('account-id') && $cookies.get('account-id')!= undefined) {
	          apiService.loaderShow();
	          var ma = this;
	          $http.get($rootScope.baseUrl + '/shipment/account/' + $cookies.get('account-id'))
	            .success(function(response) {
	            	if(response.signature == '' || response.signature == null){
	                    ma.signature = $filter('appImage')('theme/profile-pick-default.png');;
	                }else {
	                    ma.signature = 'https://3dtrk.com/Images/signature/'+response.signature;
	                }
	                
	                if(response.letterhead == '' || response.letterhead == null){
	                    ma.letterhead = $filter('appImage')('theme/profile-pick-default.png');;
	                }else {
	                    ma.letterhead = 'https://3dtrk.com/Images/letterhead/'+response.letterhead;
	                }
	            	ma.accountId = response.account_id;
	            	ma.account_number = response.account_number;
	            	ma.meter_number = response.account_meter_number;
	            	ma.account_key = response.account_key;
	            	ma.account_password = response.account_password;
	            	ma.service = response.account_service;
	            	ma.company_name = response.account_company_name;
	            	ma.person_name = response.account_person_name;
	            	ma.phone = response.account_phone;
	            	ma.zipcode =  response.account_zipcode;
	            	ma.city = response.account_city;
	            	ma.state = response.account_region;
	            	ma.status = response.account_status;
	            	ma.taxaccount = response.account_taxon;
	            	ma.address = response.account_address_street;
	            	ma.type = response.account_type;
	            	ma.etd = response.account_etd;
	            	ma.hubid = response.hubid;
	            	ma.pfeedomestic = response.pfeedomestic;
	            	ma.pfeeinternational = response.pfeeinternational;
	              apiService.loaderHide();
	            }).error(function (error) {
	                apiService.loaderHide();
	                if (error.data && error.data.code != undefined && error.data.code == 0) {
	                    toastr.error(error.data.message);
	                } else {
	                    toastr.error("Something went wrong please try again.");
	                }
	            });
	        } else {
	          $state.go('shipsettings.add-account');
	        }
	    };

	    /**
	     * Edit account method is use for get edit account page.
	     * created on 10.03.2019
	     */
	    $scope.editAccount = function(id)
	    {
	    	$cookies.put('account-id',id);
	      	$state.go('shipsettings.edit-account');
	    };

	    $scope.changeService = function(service)
	    {
	    	if(service != '')
	    	{
	    		if(service == 'office')
	    		{
	    			this.account_number = '00000';
	    			this.meter_number = '00000';
	    			this.account_key = 'office';
	    			this.account_password = 'office';
	    		}
	    		else
	    		{
	    			if ($cookies.get('account-id') && $cookies.get('account-id')!= undefined)
	    			{
	    				apiService.loaderShow();
	    				var ma = this;
	    				$http.get($rootScope.baseUrl + '/shipment/account/' + $cookies.get('account-id'))
	    				.success(function(response) {
	    					apiService.loaderHide();
	    					ma.account_number = response.account_number;
	    					ma.meter_number =  response.meter_number;
	    					ma.account_key = response.account_key;
	            			ma.account_password = response.account_password;
	    				}).error(function (error) {
			                apiService.loaderHide();
			            });
			        }
			        else
			        {
	    				this.account_number = '';
	    				this.meter_number = '';
	    				this.account_key = '';
	    				this.account_password = '';
	    			}
	    		}
	    	}
	    	else
	    	{

	    		toastr.error("Please select service.");
		        angular.element('#service').focus();
		        return;
	    	}
	    };

	    /**
	     * Save account data method is use for update/add shipment account data.
	     * created on 10.03.2019
	     */
	    $scope.saveAccountData = function()
	    {
	      if (!this.accountFrm.service.$valid) {
	        toastr.error("Please select service.");
	        angular.element('#service').focus();
	        return;
	      }
	      else if (!this.accountFrm.account_number.$valid) {
	        toastr.error("Please enter account number.");
	        angular.element('#account_number').focus();
	        return;
	      }
	      else if (!this.accountFrm.meter_number.$valid) {
	        toastr.error("Please enter meter number.");
	        angular.element('#meter_number').focus();
	        return;
	      }
	      else if (!this.accountFrm.account_key.$valid) {
	        toastr.error("Please enter account key.");
	        angular.element('#account_key').focus();
	        return;
	      }
	      else if (!this.accountFrm.account_password.$valid) {
	        toastr.error("Please enter password.");
	        angular.element('#account_password').focus();
	        return;
	      }
	      else if (!this.accountFrm.company_name.$valid) {
	        toastr.error("Please enter company name.");
	        angular.element('#company_name').focus();
	        return;
	      }
	      else if (!this.accountFrm.person_name.$valid) {
	        toastr.error("Please enter person name.");
	        angular.element('#person_name').focus();
	        return;
	      }
	      else if (!this.accountFrm.phone.$valid) {
	        toastr.error("Please enter phone number.");
	        angular.element('#phone').focus();
	        return;
	      }
	      else if (!this.accountFrm.city.$valid) {
	        toastr.error("Please enter city name.");
	        angular.element('#city').focus();
	        return;
	      }
	      else if (!this.accountFrm.state.$valid) {
	        toastr.error("Please select state.");
	        angular.element('#state').focus();
	        return;
	      }
	      else if (!this.accountFrm.address.$valid) {
	        toastr.error("Please enter address.");
	        angular.element('#address').focus();
	        return;
	      }
	      else if (!this.accountFrm.type.$valid) {
	        toastr.error("Please select type.");
	        angular.element('#type').focus();
	        return;
	      }
	      else if (!this.accountFrm.etd.$valid) {
	        toastr.error("Please select ETD.");
	        angular.element('#etd').focus();
	        return;
	      }
	      else if (!this.accountFrm.status.$valid) {
	        toastr.error("Please select status.");
	        angular.element('#status').focus();
	        return;
	      }
	      else if (!this.accountFrm.taxaccount.$valid) {
	        toastr.error("Please select tax on.");
	        angular.element('#taxshipper').focus();
	        return;
	      }
	      else if (!this.accountFrm.pfeedomestic.$valid)
	      {
	        toastr.error("Please enter processing fee for domestic.");
	        angular.element('#pfeedomestic').focus();
	        return;
	      }
	      else if (!this.accountFrm.pfeeinternational.$valid)
	      {
	        toastr.error("Please enter processing fee for international.");
	        angular.element('#pfeeinternational').focus();
	        return;
	      }

	      var signature = document.getElementById("uploadSignature").files[0];

	      var letterhead = document.getElementById("uploadLetterHead").files[0];
	      
	      var vm = this;
	      $scope.saveUrl = $rootScope.baseUrl + '/shipment/accounts';
	      $scope.httpMethod = 'POST';
	      $scope.accountId = vm.accountId;
	      if (vm.accountId) {
	        $scope.saveUrl = $rootScope.baseUrl + '/shipment/account/' + vm.accountId;
	        $scope.httpMethod = 'POST';
	      }
	      $http({
	        url: $scope.saveUrl,
	        method: $scope.httpMethod,
	        headers: {'Content-Type': undefined},
            transformRequest: function (data)
            {
              var formData = new FormData();
              formData.append("service", vm.service);
              formData.append("account_number", vm.account_number);
              formData.append("meter_number", vm.meter_number);
              formData.append("account_key", vm.account_key);
              formData.append("account_password", vm.account_password);
              formData.append("status", vm.status);
              formData.append("taxon", vm.taxaccount);
              formData.append("company_name", vm.company_name);
              formData.append("person_name", vm.person_name);
              formData.append("address", vm.address);
              formData.append("phone", vm.phone);
              formData.append("zipcode", vm.zipcode);
              formData.append("city", vm.city);
              formData.append("state", vm.state);
              formData.append("type", vm.type);
              formData.append("hubid", vm.hubid);
              formData.append("etd", vm.etd);
              formData.append("pfeedomestic", vm.pfeedomestic);
              formData.append("pfeeinternational", vm.pfeeinternational);
              formData.append("affected_by", $rootScope.globals.currentUser.name);
              ($scope.noSignature == false ? formData.append("signature", signature):'');
	          ($scope.noSignature == true ? formData.append("removeSignature",'true'):'');
	          ($scope.noLetterHead == false ? formData.append("letterhead", letterhead):'');
	          ($scope.noLetterHead == true ? formData.append("removeLetterHead",'true'):'');
              return formData;
            },
	      }).then(function(response) {
	        apiService.loaderHide();
	        var response = response.data;
	        if (response.code!= undefined && response.code == 0) {
	              toastr.error(response.message);
	        }
	        else if (response.status == 'success')
	        {
	          toastr.success(response.message);

	          if(response.uploadmessage != '') {
	          	toastr.success(response.uploadmessage);
	          }
	          if(response.errormessage != '') {
	          	toastr.error(response.errormessage);
	          }

	          $state.go('shipsettings.manage-accounts');
	        }
	        else {
	          $state.go('shipsettings.manage-accounts');
	          toastr.error("Something went wrong please try again.");
	        }
	      }, function(error) {
	        apiService.loaderHide();
	        if (error.data.code!= undefined && error.data.code == 0) {
	            toastr.error(error.data.message);
	        } else {
	          $state.go('shipsettings.manage-accounts');
	          toastr.error("Something went wrong please try again.");
	        }
	      });
	  	};

	    /**
	     * Open model.
	     * created on 10.03.2019
	     */
	    $scope.open = function(page, id, status)
	    {
	      $rootScope.deleteId = id;
	      $rootScope.status = status;
	      $scope.popupShow = $uibModal.open({
	        animation: true,
	        templateUrl: page,
	        scope: $scope,
	      });
    	};

    	/**
	     * Change status method is use for change status of account.
	     * created on 10.03.2019
	     */
	    $scope.changeStatus = function()
	    {
	    	if ($rootScope.deleteId)
	      	{
	        	apiService.loaderShow();
	        	var bodyData = {
	          		id: $rootScope.deleteId,
	          		status:  ""+$rootScope.status+"",
	          		updated_by:$rootScope.globals.currentUser.id
	        	};
	        	$http.put($rootScope.baseUrl + '/shipment/accounts', bodyData)
	        	.success(function(result)
	        	{
	        		if (result.status == 'success') {
	              		toastr.success('Status updated successfully.');
	              		$state.go($state.$current, null, {
	                		reload: true
	              		});
	            	}
	            	else
	            	{
	              		$state.go('shipsettings.manage-accounts');
	              		toastr.error("Something went wrong please try again.");
	            	}
	            	apiService.loaderHide();
	          	})
	          	.error(function(error)
	          	{
	            	apiService.loaderHide();
	            	if (error.data.code != undefined && error.data.code == 0) {
	                	toastr.error(error.data.message);
	            	} else {
	                	toastr.error("Something went wrong please try again.");
	            	}
	          	});
	        	$scope.popupShow.close();
	    	}
	    };

	    /**
	     * Delete account method is use for delete account.
	     * created on 10.03.2019
	     */
	    $scope.deleteAccount = function()
	    {
	    	if ($rootScope.deleteId)
	    	{
	        	apiService.loaderShow();
	        	$http.delete($rootScope.baseUrl + '/shipment/account/' + $rootScope.deleteId)
	        	.success(function(result)
	        	{
	          		if (result.status == 'success')
	          		{
	            		toastr.success(result.message);
	            		$state.go($state.$current, null, {
	              			reload: true
	            		});
	          		} else {
	            		toastr.error("Something went wrong please try again.");
	          		}
	            	apiService.loaderHide();
	        	})
	        	.error(function (error)
	        	{
	            	apiService.loaderHide();
	            	if (error.data.code != undefined && error.data.code == 0) {
	                	toastr.error(error.data.message);
	            	} else {
	                	toastr.error("Something went wrong please try again.");
	            	}
	        	});
			}
	    	$scope.popupShow.close();
	    };
	}
})();
/**
 * Shipment Service Boxes controller handle all action related Boxes.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 21.04.2021
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.shipSettings')
            .controller('serviceBoxesCtrl', serviceBoxesCtrl);

    /** @ngInject */
    function serviceBoxesCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService,  $q)
    {
        /**
        * permissionArr is use to check permission to display list
        * created on 09.23.2021
        */
        if($rootScope.permissionArr.indexOf('shipment_service_boxes') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='shipsettings.manage-service-boxes';
        $scope.resetGlobalSearch();

        /**
        * UCCap For First Caracter Capital Of String.
        * Created on 11.06.2021
        */
        $scope.UcCap =  function (string){
            if(string){
                return string.charAt(0).toUpperCase() + string.slice(1);;
            }
            return string;
        }

        $scope.OneRate =  function (box)
        {
            if(box == 1){
                return "Yes"
            }
            else {
              return "No";
            }
        }
        $scope.AvailableQty =  function (qty)
        {
            if(qty != undefined){
                return qty
            }
            else {
              return 0;
            }
        }

        $scope.renderWitPrice = function(price)
        {
          console.log(price);
          if(price){
            return '$' + price;
          }else{
            return 'N/A';
          }
        }

        /**
         * Get data table method is use get list of boxes.
         * created on 09.23.2021
         */
        $scope.getDataTable = function ()
        {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            $http.get($rootScope.baseUrl + '/shipment/serviceboxes')
                    .success(function(result) {
                        if(result.length < $rootScope.numberOfRecord){
                            $timeout(function () {
                                angular.element('.dataTables_paginate').hide();
                             }, 200);
                         }
              vm.boxes = [];
              var index = 1 ;
              angular.forEach(result, function(value, key) {
                var changeStatusValTo = '0';
                
                var editLinks = ' ';
                if ($rootScope.permissionArr.indexOf('shipment_edit_service_box') != -1) {
                  editLinks = ' <a href="javascript:void(0);"  ng-click="editBox(\'' + value.service_box_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                }

                var deleteLinks = ' ';
                if ($rootScope.permissionArr.indexOf('shipment_delete_service_box') != -1) {
                  deleteLinks = '  <a href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/shipSettings/manageServiceBoxes/deleteModal.html' + '\',\'' + value.service_box_id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                }

                var statusBadge = ' ';
                var statusLinks = ' ';
                
                if ($rootScope.permissionArr.indexOf('shipment_status_service_box') != -1)
                {
                  statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                  statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageServiceBoxes/statusModal.html' + '\',\'' + value.service_box_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

                  if (value.service_box_status == '0') {
                      changeStatusValTo = '1';
                      statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                      statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageServiceBoxes/statusModal.html' + '\',\'' + value.service_box_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                  }
                }

                var data = {
                  index:index,
                  id: value.service_box_id,
                  service: value.service,
                  name: value.service_box_label,
                  code: value.service_box_code,
                  onerate: value.service_box_one_rate,
                  availabel_qty: value.service_box_availabel_qty,
                  price: value.service_box_price,
                  status:statusBadge,
                  operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks //+ '&nbsp;' + departmentStatusLinks
                  };
                this.push(data);
                ++index;
              }, vm.boxes);
              defer.resolve(vm.boxes);
            }).error(function (error) {
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            return defer.promise;
          }).withPaginationType('simple_numbers')
          vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $scope.$apply($compile(nRow)($scope));
            });
          vm.dtOptions.withOption('sDom', $rootScope.dom);
          vm.dtOptions.withOption('initComplete', function() {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
         });
          vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          vm.dtColumns = [
            DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            DTColumnBuilder.newColumn('service').withTitle('Service').renderWith($scope.UcCap),
            DTColumnBuilder.newColumn('name').withTitle('Box Title'),
            DTColumnBuilder.newColumn('code').withTitle('Box Code'),
            DTColumnBuilder.newColumn('onerate').withTitle('One Rate').renderWith($scope.OneRate),
            DTColumnBuilder.newColumn('price').withTitle('price').renderWith($scope.renderWitPrice),
            DTColumnBuilder.newColumn('availabel_qty').withTitle('Available Qty').renderWith($scope.AvailableQty),
          ];

          vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        }

        /**
         * Add Box method is use for get add box form.
         * created on 09.23.2021
         */
        $scope.addBox = function ()
        {
            $cookies.put('box-id',undefined);
            $state.go('shipsettings.add-service-box');
        }

        /**
         * Edit box method is use for get edit box page.
         * created on 10.03.2021
         */
        $scope.editBox = function(id)
        {
          $cookies.put('box-id',id);
            $state.go('shipsettings.edit-service-box');
        };

        /**
         * Get edited box method is use for get edited shipment box data.
         * created on 09.23.2021
         */
        $scope.getEditedBox = function ()
        {
            $scope.store_costs = [];
            if ($cookies.get('box-id') && $cookies.get('box-id')!= undefined)
            {
                var ma = this;
                  apiService.loaderShow();
                  $http.get($rootScope.baseUrl + '/shipment/editservicebox/' + $cookies.get('box-id'))
                    .success(function(response) {
                      ma.boxeditId = response.service_box_id;
                      ma.service = response.service;
                      ma.name = response.service_box_label;
                      ma.code = response.service_box_code;
                      ma.status = response.service_box_status;
                      ma.onerate = response.service_box_one_rate;
                      ma.availabel_qty = response.service_box_availabel_qty;
                      ma.price = response.service_box_price;
                      apiService.loaderHide();
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data && error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                    });
                } else {
                  $state.go('shipsettings.add-service-box');
                }
        };

        $scope.AddStock = function ()
        {
          var ma = this;
          $scope.ServiceBoxId = $cookies.get('box-id');
          $scope.addqty = '';
          $scope.addnote = '';
          $scope.addsqty = '';
          $scope.boxName = ma.name;

          apiService.loaderShow();

          $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/shipSettings/manageServiceBoxes/addServiceBoxStock.html',
              scope: $scope,
          });

          apiService.loaderHide();
        }


        $scope.RemoveStock = function ()
        {
          $scope.ServiceBoxId = $cookies.get('box-id');
          $scope.addqty = '';
          $scope.addnote = '';
          $scope.addsqty = '';
          $scope.boxName = '';
          apiService.loaderShow();

          $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: 'app/pages/shipSettings/manageServiceBoxes/removeServiceBoxStock.html',
              scope: $scope,
          });

          apiService.loaderHide();
        }

        $scope.ChangeTotalStock = function (qty,type)
        {
          if(!qty) { qty = 0; }

          if(type=='add') {
            $scope.addsqty = qty;
          }
          else if(type=='remove') {
            $scope.removesqty = qty;
          }
        }

        $scope.saveServiceBoxStock = function ()
        {
          if (!this.serviceBoxStockFrm.$valid) {
            toastr.error("Please enter required fileds");
            angular.element('#addqty').focus();
            return;
          }

          apiService.loaderShow();
          var bodyData = {
            boxid: $cookies.get('box-id'),
            qty: this.addqty?this.addqty:0,
            totalqty: this.addsqty?this.addsqty:0,
            note: this.addnote,
            affected_by: $rootScope.globals.currentUser.id,
          };
          $scope.saveUrl = $rootScope.baseUrl + '/shipment/add-service-box-stock';
          $scope.httpMethod = 'POST';
          $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              apiService.loaderHide();
              $scope.$dismiss();
              $state.go($state.$current, null, {
                  reload: true
              });
            }, function(error) {
              apiService.loaderHide();
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                $state.go('shipsettings.manage-service-boxes');
                toastr.error("Something went wrong please try again.");
              }
            });
        }

        $scope.removeServiceBoxStock = function ()
        {
          if (!this.serviceBoxStockFrm.$valid) {
            toastr.error("Please enter required fileds");
            angular.element('#removeQty').focus();
            return;
          }

          apiService.loaderShow();
          var bodyData = {
            boxid: $cookies.get('box-id'),
            qty: this.removeQty?this.removeQty:0,
            totalqty: this.removesqty?this.removesqty:0,
            note: this.addnote,
            affected_by: $rootScope.globals.currentUser.id,
          };
          $scope.saveUrl = $rootScope.baseUrl + '/shipment/remove-service-box-stock';
          $scope.httpMethod = 'POST';
          $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              apiService.loaderHide();
              $scope.$dismiss();
              $state.go($state.$current, null, {
                  reload: true
                });
            }, function(error) {
              apiService.loaderHide();
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                $state.go('shipsettings.manage-service-boxes');
                toastr.error("Something went wrong please try again.");
              }
            });
        }

        $scope.ServiceBoxStockLog = function ()
        {
          var ma = this;
          $scope.ServiceBoxId = $cookies.get('box-id');
          $scope.boxName = ma.name;
          $scope.stockLogsArr = [];
          $scope.stockLogsLoaded = false;

          apiService.loaderShow();
          $scope.getStockLogs();
          $('#stockLogsModel').modal();
          apiService.loaderHide();
        }

        $scope.closeStockLogs = function (id,page) {
            $('#stockLogsModel').modal('hide');
        };

        /**
         * getOrderLogs is use to get order details.
         * created on 11.29.2021
         */
        $scope.stockLogsLoaded = false;
        $scope.stockLogsArr = [];
        $scope.getStockLogs = function () {
          $scope.ServiceBoxId = $cookies.get('box-id');
            $scope.stockLogsArr = [];
            $scope.stockLogsLoaded = false;
            $http.get($rootScope.baseUrl + '/shipment/get-servicebox-stocklog/'+$scope.ServiceBoxId).then(
            function (response) {
                $scope.stockLogsLoaded = true;
                if(response.data.status == 'success'){
                   $scope.stockLogsArr = response.data.data;
                }
                
            },
            function (error) {
                $scope.stockLogsLoaded = true;
            });
        }

        /**
         * Save shipment box data method is use for update/add shipment box data.
         * created on 09.26.2021
         */
        $scope.saveBoxData = function()
        {
            if (!this.boxFrm.$valid) {
                return;
            }
            
            apiService.loaderShow();
            var bodyData = {
                service: this.service,
                name: this.name,
                code: this.code,
                onerate: parseInt(this.onerate),
                status: this.status,
                availabel_qty: this.availabel_qty,
                price: this.price,
                affected_by: $rootScope.globals.currentUser.name
            };

            $scope.saveUrl = $rootScope.baseUrl + '/shipment/save-service-box';
            $scope.httpMethod = 'POST';
            $scope.editedId = this.boxeditId;
            if (this.boxeditId) {
                $scope.saveUrl = $rootScope.baseUrl + '/shipment/save-service-box/' + this.boxeditId;
                $scope.httpMethod = 'PUT';
            }

            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    toastr.success('Box ' + ($scope.editedId ? 'updated' : 'added') + ' successfully.');
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                $state.go('shipsettings.manage-service-boxes');
            }, function (response) {

                apiService.loaderHide();

                $state.go('shipsettings.manage-service-boxes');
                toastr.error("Something went wrong please try again.");
            });
        };

        /**
         * Open model.
         * created on 10.03.2019
         */
        $scope.open = function(page, id, status)
        {
          $rootScope.deleteId = id;
          $rootScope.status = status;
          $scope.popupShow = $uibModal.open({
            animation: true,
            templateUrl: page,
            scope: $scope,
          });
        };

        /**
       * Change status method is use for change status of box.
       * created on 10.03.2019
       */
      $scope.changeBoxStatus = function()
      {
        if ($rootScope.deleteId)
          {
            apiService.loaderShow();
            var bodyData = {
                id: $rootScope.deleteId,
                status: $rootScope.status,
                updated_by: $rootScope.globals.currentUser.name
            };
            $http.put($rootScope.baseUrl + '/shipment/updateserviceboxstatus', bodyData)
            .success(function(result)
            {
              if (result.status == 'success') {
                    toastr.success('Status updated successfully.');
                    $state.go($state.$current, null, {
                      reload: true
                    });
                }
                else
                {
                    $state.go('shipsettings.manage-service-boxes');
                    toastr.error("Something went wrong please try again.");
                }
                apiService.loaderHide();
              })
              .error(function(error)
              {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
              });
            $scope.popupShow.close();
        }
      };

      /**
       * Delete box method is use for delete box.
       * created on 10.03.2019
       */
      $scope.deleteBox = function()
      {
        if ($rootScope.deleteId)
        {
            apiService.loaderShow();
            $http.delete($rootScope.baseUrl + '/shipment/delete-service-box/' + $rootScope.deleteId)
            .success(function(result)
            {
                if (result.status == 'success')
                {
                  toastr.success(result.message);
                  $state.go($state.$current, null, {
                      reload: true
                  });
                } else {
                  toastr.error("Something went wrong please try again.");
                }
                apiService.loaderHide();
            })
            .error(function (error)
            {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
        $scope.popupShow.close();
      };
    }

})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.shipSettings')
    .controller('shipmentSettingsCtrl', shipmentSettingsCtrl);

  /** @ngInject */
  function shipmentSettingsCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout)
  {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.09.2019
     */
    if ($rootScope.permissionArr.indexOf('shipment_settings') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var ss = this;
    $rootScope.currentState = 'ship-settings.shipment-settings';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 11.09.2019
     */
    $scope.oneAtATime = false;
    $scope.isOpenObject = {};
    
    ss.customerStatus=[];
    ss.customerStatusAfterShipment=[];

    ss.mallStatus=[];
    ss.mallStatusAfterShipment=[];
    ss.mallStatusAfterShip=[];

    ss.shipmentStatus=[];
    ss.shipmentStatusAfterShipping=[];

    ss.officeStatus=[];
    ss.officeStatusAfterShipment=[];
    
    ss.alignment = 'center';
    ss.bold = false;

    $scope.getActiveStatus = function()
    {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    $scope.getSettingData = function()
    {
      $http.get($rootScope.baseUrl + '/config/shipmentSetting')
      .success(function(result)
      {
        if (result)
        {
          if (result.status == 'fail') {
            toastr.error(result.message);
          }
          else
          {
            if (result.data)
            {
              var resultData = result.data;
              var shipmentSetting = resultData.shipment_settings;
              ss.customerStatus = shipmentSetting.customerStatus;
              ss.customerStatusAfterShipment = shipmentSetting.customerStatusAfterShipment;
              ss.mallStatus = shipmentSetting.mallStatus;
              ss.mallStatusAfterShipment = shipmentSetting.mallStatusAfterShipment;
              ss.mallStatusAfterShip = shipmentSetting.mallStatusAfterShip;
              ss.shipmentStatus = shipmentSetting.shipmentStatus;
              ss.shipmentStatusAfterShipping = shipmentSetting.shipmentStatusAfterShipping;
              ss.officeStatus = shipmentSetting.officeStatus;
              ss.officeStatusAfterShipment = shipmentSetting.officeStatusAfterShipment;
            }
          }
        }
      })
      .error(function(error)
      {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    };

    $scope.saveSetting=function()
    {
      if(!this.shpstFrm.$valid){
        return;
      }

      $scope.shipmentSettingData = {
        'shipment_settings':{
          'customerStatus':ss.customerStatus,
          'customerStatusAfterShipment':ss.customerStatusAfterShipment,
          'mallStatus':ss.mallStatus,
          'mallStatusAfterShipment':ss.mallStatusAfterShipment,
          'mallStatusAfterShip':ss.mallStatusAfterShip,
          'shipmentStatus':ss.shipmentStatus,
          'shipmentStatusAfterShipping':ss.shipmentStatusAfterShipping,
        }
      };
      apiService.loaderShow();
      var bodyData = {
        type: 'shipmentSetting',
        sticker_data: angular.toJson($scope.shipmentSettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };
 } 
})();

/**
 * Shipment Boxes controller handle all action related Boxes.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 09.23.2019
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.shipSettings')
            .controller('manageServiceTypesCtrl', manageServiceTypesCtrl);

    /** @ngInject */
    function manageServiceTypesCtrl($scope, $state, $cookies, $http, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService,  $q)
    {
        /**
        * permissionArr is use to check permission to display list
        * created on 09.23.2019
        */
        if($rootScope.permissionArr.indexOf('shipment_manage_service_types') == -1)
        {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        $rootScope.currentState='shipsettings.manage-service-types';
        $scope.resetGlobalSearch();

        /**
         * Get data table method is use get list of service types.
         * created on 10.02.2019
         */
        $scope.getDataTable = function ()
        {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
            var defer = $q.defer();
            $http.get($rootScope.baseUrl + '/shipment/list-service-types')
                    .success(function(result) {
                        if(result.length < $rootScope.numberOfRecord){
                            $timeout(function () {
                                angular.element('.dataTables_paginate').hide();
                             }, 200);
                         }
              vm.types = [];
              var index = 1 ;
              angular.forEach(result, function(value, key) {
                var changeStatusValTo = '0';
                var editLinks = ' <a href="javascript:void(0);" ng-click="editType(\'' + value.type_id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                //var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'box_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/shipment/manageBoxes/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                var statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageServiceTypes/statusModal.html' + '\',\'' + value.type_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

                if (value.type_status == '0') {
                    changeStatusValTo = '1';
                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                    statusLinks = ' <a ng-click="open(\'' + 'app/pages/shipSettings/manageServiceTypes/statusModal.html' + '\',\'' + value.type_id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                }

                var data = {
                  index:index,
                  id: value.type_id,
                  label: value.type_label,
                  code: value.type_code,
                  seq: value.sequence_no,
                  created_at: value.created_at,
                  updated_at: value.updated_at,
                  status:statusBadge,
                  operations: editLinks + '&nbsp;' + statusLinks  //+ '&nbsp;' + departmentStatusLinks
                  };
                this.push(data);
                ++index;
              }, vm.types);
              defer.resolve(vm.types);
            }).error(function (error) {
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            return defer.promise;
          }).withPaginationType('simple_numbers')
          vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $scope.$apply($compile(nRow)($scope));
            });
          vm.dtOptions.withOption('sDom', $rootScope.dom);
          vm.dtOptions.withOption('initComplete', function() {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
         });
          vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
          vm.dtColumns = [
            DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
            DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
            DTColumnBuilder.newColumn('label').withTitle('Label'),
            DTColumnBuilder.newColumn('code').withTitle('Code'),
            DTColumnBuilder.newColumn('seq').withTitle('Sort #'),
            DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
            DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
          ];
          vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
        };

        /**
     * Open model.
     * created on 10.02.2019
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of service type.
     * created on 10.02.2019
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status:  ""+$rootScope.status+"",
          updated_by:$rootScope.globals.currentUser.id
        };
        $http.post($rootScope.baseUrl + '/shipment/change-service-type-status', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('shipsettings.manage-service-types');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Edit type method is use for get edit service type page.
     * created on 10.02.2019
     */
    $scope.editType = function(id) {
      $cookies.put('type-id',id);
      $state.go('shipsettings.edit-type');
    }



        /**
         * Get edited box method is use for get edited shipment service type data.
         * created on 10.02.2019
         */
        $scope.getEditedType = function ()
        {
            if ($cookies.get('type-id') && $cookies.get('type-id')!= undefined) {
              apiService.loaderShow();
              var mst = this;
              $http.get($rootScope.baseUrl + '/shipment/edit-service-type/' + $cookies.get('type-id'))
                .success(function(response) {
                  mst.code = response.type_code;
                  mst.label = response.type_label;
                  mst.typeId = response.type_id;
                  mst.status = response.type_status;
                  
                  apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
              $state.go('shipsettings.manage-service-types');
            }
        };

        /**
         * Save shipment service type data method is use for update shipment service type data.
         * created on 10.02.2019
         */
        $scope.saveTypeData = function()
        {
            if (!this.typeFrm.$valid) {
                return;
            }
            apiService.loaderShow();
            var bodyData = {
                id: this.typeId,
                label: this.label,
                status: this.status,
                affected_by:$rootScope.globals.currentUser.id
            };

            $scope.editedId = this.typeId;
            if (this.typeId) {
                $scope.saveUrl = $rootScope.baseUrl + '/shipment/save-service-type';
                $scope.httpMethod = 'POST';
            }

            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                if (response.data && response.data.status == 'success') {
                    toastr.success('Type ' + ($scope.editedId ? 'updated' : '') + ' successfully.');
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                $state.go('shipsettings.manage-service-types');
            }, function (response) {

                apiService.loaderHide();

                $state.go('shipsettings.manage-service-types');
                toastr.error("Something went wrong please try again.");
            });
        };
    }

})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('addressVerificationSettingsCtrl', addressVerificationSettingsCtrl);

  /** @ngInject */
  function addressVerificationSettingsCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout) {
    /**
     * permissionArr is use to check permission to display list
     * created on 18.06.2021
     */
    if ($rootScope.permissionArr.indexOf('settings_address_verification') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.address-verification-settings';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 18.06.2021
     */
    $scope.oneAtATime = true;
    $scope.isOpenObject = {};
    $scope.menuStatus = [{
        isOpen: true
    }]

    /**
     * declare data.
     * created on 18.06.2021
     */
    vm.autoCheck = false;
    vm.orderCheck = false;
    vm.storeForUpload=[];
    
    $scope.getStoreData = function ()
    {
      $http.get($rootScope.baseUrl+'/store')
      .success(function (result) {
         $scope.storeData=result;
      }).error(function (error) {
          if (error && error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
          } else {
              toastr.error("Something went wrong please try again.");
          }
      });
    }

    /**
     * get Relay Setting Data method is use to display Relay Setting data.
     * created on 18.06.2021
     */
    $scope.getVerificatonSettingData = function()
    {
        $http.get($rootScope.baseUrl + '/config/verificationSetting')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else
              {
                if (result.data)
                {
                  var resultData = result.data;
                  var verificationSetting = resultData.verification_settings;
                  vm.autoCheck = verificationSetting.auto_check;
                  vm.orderCheck = verificationSetting.save_order_check;
                  vm.storeForCheck = verificationSetting.store_for_check;
                }
              }
            }
          }).error(function(error) {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
    };
    
    $scope.saveVerificatonSetting=function()
    {
      if(!this.verificatonFrm.$valid){
        return;
      }
      
      $scope.verificationSettingData = {
        'verification_settings':{
          'auto_check':vm.autoCheck,
          'save_order_check':vm.orderCheck,
          'store_for_check':vm.storeForCheck,
        },
      };
      
      apiService.loaderShow();
      var bodyData = {
        type: 'verificationSetting',
        sticker_data: angular.toJson($scope.verificationSettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
  }
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.settings')
            .controller('amazonStoreProductsCtrl', amazonStoreProductsCtrl);

    /** @ngInject */
    function amazonStoreProductsCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
      if($rootScope.permissionArr.indexOf('view_amazon_store_products') == -1)
      {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
      }

    	var vm = this;
      $rootScope.currentState='settings.amazon-store-products';
      $scope.productsArr = [];
    	
    	$scope.getDataTable = function()
      {
        var storeId = 0;
        if($cookies.get('amazon-store-id') && $cookies.get('amazon-store-id')!= undefined) {
          storeId = $cookies.get('amazon-store-id');
        }

        var vm = this;
          vm.dtOptions = DTOptionsBuilder.fromFnPromise(function()
          {
            var defer = $q.defer();
            $http.get($rootScope.baseUrl + '/amazonstores/products/'+storeId)
            .success(function(result)
            {
              if(result.length < $rootScope.numberOfRecord)
              {
                $timeout(function () {
                  angular.element('.dataTables_paginate').hide();
                }, 200);
              }
              vm.warehouses = [];
              var index = 1 ;
              
              angular.forEach(result, function(value, key)
              {
                var data = {
                  index:index
                };
                this.push(data);
                ++index;
              }, vm.warehouses);
              defer.resolve(vm.warehouses);
            })
            .error(function (error)
            {
              if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
            return defer.promise;
          })
          .withPaginationType('simple_numbers')
          vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
          vm.dtOptions.withOption('fnRowCallback',
            function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
              $scope.$apply($compile(nRow)($scope));
            });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function()
            {
              angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
              angular.element('.dataTables_filter input').attr('class', 'form-control');
              angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtColumns = [
              DTColumnBuilder.newColumn('index').withTitle('Sr.No').withOption('order', [0, 'desc']),
              //DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
              
            ];  
      }
		}
	})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('amazonStoresCtrl', amazonStoresCtrl);

  /** @ngInject */
  function amazonStoresCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 08.27.2018
     */
    if($rootScope.permissionArr.indexOf('manage_amazon_stores') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    vm.shipmentPopup = false;
    vm.service = '';
    vm.relay_api_key = '';
    vm.ciproductsetting = '';
    $rootScope.currentState='settings.amazon-stores';
    $scope.accounts = [];
    
    $scope.resetGlobalSearch();
    function renderWithSystemType(data, type, full){
      if(data=='m1'){
        return 'Magento 1';
      }else if(data=='m2'){
        return 'Magento 2';
      }else if(data=='pos'){
        return 'POS';
      }else if(data=='erp'){
        return 'ERP System';
      }else if(data=='amazon'){
        return 'Amazon';
      }else if(data=='other'){
        return 'Other';
      }else{
        return '';
      }
    }
    function renderWithStoreUrl(data, type, full){
      if(data){
        return '<a href="'+data+'" target="_blank" title="Redirect to Store URL" style="background-color:white;padding:2px">'+data+'</a>';
      }else{
        return '';
      }
    }
    /**
     * Get data table method is use get list of store.
     * created on 08.27.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/amazonstores')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.store = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'store_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editStore(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'store_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/store/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
            
            
            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'store_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/store/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'store_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/store/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var productLinks = '';
            if($rootScope.permissionArr.indexOf('view_amazon_store_products') != -1){
              productLinks = ' <a ng-click="viewAmazonStoreProducts(' + value._id + ')" href="javascript:void(0);" title="Amzaon Store Products"><i class="fa fa-bar-chart" style="color:#fff;" aria-hidden="true"></i></a>';
            }

            console.log(value._id);

            var data = {
              id: value._id,
              store_name: value.store_name,
              store_code:value.store_code,
              store_url:value.store_url,
              system:value.type_of_system,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks + '&nbsp;' + productLinks
              };
            this.push(data);
            ++index;
          }, vm.store);
          defer.resolve(vm.store);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('store_name').withTitle('Store Name'),
        DTColumnBuilder.newColumn('store_code').withTitle('Store Code'),
        DTColumnBuilder.newColumn('system').withTitle('System').renderWith(renderWithSystemType),
        DTColumnBuilder.newColumn('store_url').withTitle('Store URL').renderWith(renderWithStoreUrl),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('store_edit') !== -1 || $rootScope.permissionArr.indexOf('store_delete') !== -1 || $rootScope.permissionArr.indexOf('store_changestatus') !== -1 || $rootScope.permissionArr.indexOf('map_status') !== -1 || $rootScope.permissionArr.indexOf('magento_status_list') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

    $scope.viewAmazonStoreProducts= function (id)
    {
      $cookies.put('amazon-store-id',id);
      $state.go('settings.amazon-store-products');  
    }

    $scope.accounts = [];
    $scope.getAccounts= function ()
    {
      $http.get($rootScope.baseUrl + '/shipment/active-accounts')
      .success(function(result) {
        angular.forEach(result, function(value, key) {
          $scope.accounts.push(value);
        });
      })
      .error(function (error)
      {
        if (error.data && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };
    $scope.getAccounts();

     /**
     * Add store method is use for get add store page.
     * created on 08.27.2018
     */
    $scope.addStore = function() {
      $cookies.put('store-id',undefined);
      $state.go('settings.add-amazon-store');
    }

    /**
     * Edit store method is use for get edit store page.
     * created on 08.27.2018
     */
    $scope.editStore = function(id) {
      $cookies.put('store-id',id);
      $state.go('settings.edit-amazon-store');
    }
    
    /**
     * Open model.
     * created on 08.27.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of store.
     * created on 08.27.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/storesystem', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete store method is use for delete store.
     * created on 08.27.2018
     */
    $scope.deleteStore = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/storesystem/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Store deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save store data method is use for update/add store data.
     * created on 08.27.2018
     */
    $scope.saveStoreData = function() {
       if (!this.storeFrm.$valid) {
        return;
      }
      var is_amazon_store = 1;
       apiService.loaderShow();
      var bodyData = {
        store_name: vm.storeName,
        store_code:vm.storeCode,
        store_id:vm.storeCode,
        website_id:vm.storeCode,
        type_of_system:vm.systemType,
        store_url:vm.storeUrl,
        store_username:vm.userName,
        token:vm.storeToken,
        relay_api_key: vm.relay_api_key,
        auto_refresh:vm.autoRefreshTime,
        auto_import:vm.autoImportTime,
        status: vm.status,
        is_amazon_store: is_amazon_store,
        shipment_popup_show: vm.shipmentPopup,
        service:vm.service,
        account_fedex:vm.accountFedex,
        account_usps:vm.accountUsps,
        ciproductsetting: vm.ciproductsetting,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/amazonstores';
      $scope.httpMethod = 'POST';
      if (vm.storeId) {
        $scope.saveUrl = $rootScope.baseUrl + '/amazonstores/' + vm.storeId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status == 'success') {
          toastr.success('Store ' + (vm.storeId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.amazon-stores');
        }else{
          toastr.error(response.message);
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited Report label method is use for get edited Report label data.
     * created on 08.27.2018
     */
    $scope.getEditedStore = function() {

        if($rootScope.permissionArr.indexOf('store_add') == -1 && $rootScope.permissionArr.indexOf('store_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('store-id') && $cookies.get('store-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/storesystem/' + $cookies.get('store-id'))
            .success(function(response) {
              apiService.loaderHide();
              vm.storeName = response.store_name;
              vm.storeCode=response.store_code;
              vm.systemType=response.type_of_system;
              vm.storeId = response._id;
              vm.storeUrl=response.store_url;
              vm.autoRefreshTime=response.auto_refresh;
              vm.autoImportTime=response.auto_import;
              vm.userName=response.store_username;
              vm.storeToken=response.token;
              vm.relay_api_key=response.relay_api_key;
              vm.service=response.service;
              vm.accountFedex=response.account_fedex;
              vm.accountUsps=response.account_usps;
              vm.status = response.status;
              vm.ciproductsetting = response.ciproductsetting;
              if(response.shipment_popup_show == "true") {
                vm.shipmentPopup = true;
              }
              else {
                vm.shipmentPopup = false;
              }
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $scope.getStoreToken();
          $state.go('settings.add-amazon-store');
        }
    };
    /**
    * getStoreToken method is use for get store token
    * created on 08.28.2018
    */
    $scope.getStoreToken = function () {
        $http.get($rootScope.baseUrl+'/customer/tokens').success(function(response){
          vm.storeToken=response.token;
        }).error(function(error){
          //toastr.error(error.message);
        });
      }
    $scope.success = function (text) {
       toastr.success(text+' Copied!');
     };

     $scope.fail = function (err) {
       toastr.error('Error!', err);
     };

     $scope.getStatusData = function() {
        // get order status
        $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function (result) {
              vm.orderStatus = result;
            }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });

          }
      
    /**
    * label Exists method is use check duplicate status.
    * created on 06.19.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 06.19.2018
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
  }

})();

/**
 * FAQ Frontend controller display faq question and answer list.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.5.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.settings')
            .controller('settingsCtrl', settingsCtrl);

    /** @ngInject */
    function settingsCtrl($scope, $timeout, $filter, fileReader, apiService, $cookies, $uibModal, $window, $q, $http, $rootScope, toastr, $state) {
        /**
         * permissionArr is use to check permission to display list
         * created on 10.5.2017
         */
        if ($rootScope.permissionArr.indexOf('settings') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'settings.app-settings';
        $scope.resetGlobalSearch();
        /**
         * status and status1 is use to default open accordion
         * created on 10.5.2017
         */
        $scope.dateTimeFormate = {
            'YYYY-MM-DD': 'YYYY-MM-DD',
            'YYYY-MM-DD HH:mm:ss': 'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DD h:mm A': 'YYYY-MM-DD HH:mm A',
            'MM-DD-YYYY': 'MM-DD-YYYY',
            'MM-DD-YYYY HH:mm:ss': 'MM-DD-YYYY HH:mm:ss',
            'MM-DD-YYYY h:mm A': 'MM-DD-YYYY HH:mm A',
            'MM/DD/YYYY hh:mm A': 'MM/DD/YYYY hh:mm A'
        };
        $scope.selected = 'YYYY-MM-DD h:mm A';

        $scope.messagePosition="toast-bottom-right";
        $scope.noPicture = false;
        $scope.picture = $filter('appImage')('theme/logo-placeholder.png');
        $scope.removePicture = function () {
            $scope.picture = $filter('appImage')('theme/logo-placeholder.png');
            $scope.noPicture = true;
        };

        $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function () {
            $scope.noPicture = false;
            fileReader.readAsDataUrl(this.file, $scope)
                .then(function (result) {
                    $scope.picture = result;
                });
        };

        /**
         * Save Settings is use to save Settings
         * Created on 11.07.2017
         */
        $scope.saveSettings = function () {
            var vm = this;
            if (!this.settingFrm.email.$valid) {
                toastr.error("Please enter from email.");
                angular.element('#email').focus();
                return;
            } else if (!this.settingFrm.cemail.$valid) {
                toastr.error("Please enter contact email.");
                angular.element('#cemail').focus();
                return;
            }else if (!this.settingFrm.dashboardTime.$valid) {
                toastr.error("Please enter dashboard time.");
                angular.element('#dashboardTime').focus();
                return;
            } else if (!this.settingFrm.orderTime.$valid) {
                toastr.error("Please enter order time.");
                angular.element('#orderTime').focus();
                return;
            } else if (!this.settingFrm.record.$valid) {
                toastr.error("Please select record.");
                angular.element('#record').focus();
                return;
            } else if (this.selected == '') {
                toastr.error("Please select date format.");
                angular.element('#dateFormate').focus();
                return;
            }else if (!this.settingFrm.defaultSort.$valid) {
                toastr.error("Please select manage order default sort column.");
                angular.element('#defaultSort').focus();
                return;
            }else if (!this.settingFrm.productDefaultSort.$valid) {
                toastr.error("Please select product default sort column.");
                angular.element('#productDefaultSort').focus();
                return;
            }
            apiService.loaderShow();
            var file = document.getElementById("uploadFile").files[0];
            $http({
                url: $rootScope.baseUrl + '/config/setting/save',
                method: 'POST',
                headers: {'Content-Type': undefined},
                transformRequest: function (data) {
                    var formData = new FormData();
                    ($scope.noPicture == false? formData.append("file", file):'');
                    ($scope.noPicture == true ? formData.append("removeFile",'true'):'');
                    formData.append("fromEmail", vm.email);
                    formData.append("contactEmail", vm.cemail);
                    formData.append("noOfRecord", vm.record);
                    formData.append("dashboardApiTime", vm.dashboardTime);
                    formData.append("orderApiTime", vm.orderTime);
                    formData.append("dateTimeFormate", vm.selected);
                    formData.append("orderDefaultSort", vm.defaultSort);
                    formData.append("productDefaultSort", vm.productDefaultSort);
                    formData.append("messagePosition", vm.messagePosition);
                    formData.append("debug", vm.debug);
                    formData.append("dashboardDateCycle1", vm.cycle1);
                    formData.append("dashboardDateCycle2", vm.cycle2);
                    formData.append("dashboardDateCycle3", vm.cycle3);
                    formData.append("dashboardDateCycle4", vm.cycle4);
                    formData.append("defaultrangeglobalsearch", vm.globalSearchCycle);
                    formData.append("type", 'global-setting');
                    formData.append("displayDisableIcons",vm.displayDisableIcons);
                    return formData;
                },
            }).then(function (response) {
                apiService.loaderHide();
                $("input[name='FileUploadLogo']").val('');
                $scope.noPicture = false;
                if (response.data && response.data.status == 'success') {
                  if(response.data.data.file && response.data.data.file != ''){
                      $rootScope.globalSetting.file = response.data.data.file;
                  }
                  if($scope.noPicture == true){
                      $rootScope.globalSetting.file = undefined;
                  }
                  $window.localStorage.setItem('settings',apiService.encriptData(response.data.data));
                    // var encrypted = CryptoJS.AES.encrypt(JSON.stringify(response.data.data), "images75long9tinsel");
                    // $window.localStorage.setItem('settings',encrypted);
                   $rootScope.globalSetting = response.data.data;
                    toastr.success('Settings save successfully.');
                } else {
                    toastr.error("Something went wrong please try again.");
                }
             }, function (response) {
                 $("input[name='FileUploadLogo']").val('');
                $scope.noPicture = false;
                apiService.loaderHide();
                var response = response.data;
                if (response && response.code == 0) {
                    toastr.error(response.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }


        /**
         * getSettings is use to get list settings
         * created on 11.06.2017
         */
        $scope.getSettings = function () {
            var vm = this;
            $scope.isloaded = false;
            $http.get($rootScope.baseUrl + '/config/setting/global-setting')
                    .success(function (result) {
                        if(result.status == 'success'){
                            var result = result.data;
                            vm.email = result.fromEmail;
                            vm.cemail = result.contactEmail;
                            vm.record = ''+result.noOfRecord+'';
                            vm.dashboardTime = result.dashboardApiTime;
                            vm.orderTime = result.orderApiTime;
                            vm.selected = result.dateTimeFormate;
                            vm.defaultSort=result.orderDefaultSort;
                            vm.productDefaultSort=result.productDefaultSort;
                            vm.messagePosition=result.messagePosition?result.messagePosition:'toast-bottom-right';
                            vm.file = result.file;
                            vm.cycle1=result.dashboardDateCycle1;
                            vm.cycle2=result.dashboardDateCycle2;
                            vm.cycle3=result.dashboardDateCycle3;
                            vm.cycle4=result.dashboardDateCycle4;
                            vm.globalSearchCycle=result.defaultrangeglobalsearch?result.defaultrangeglobalsearch:'yes';
                            vm.displayDisableIcons=result.displayDisableIcons;
                            vm.customTypeIconAwsPath25x25 = result.custom_type_aws_path_25x25;
                            vm.customTypeIconAwsPath = result.custom_type_aws_path;
                            if(result.file == '' || result.file == null){
                                $scope.picture = $filter('appImage')('theme/logo-placeholder.png');
                            }else {
                                $scope.picture = $rootScope.logoUrl+result.file;
                            }
                            document.getElementById("uploadFile")
                            vm.debug = result.debug;
                        }else{
                           toastr.error(result.message);
                        }
                        $scope.isloaded = true;
                    }).error(function (error) {
                $scope.isloaded = true;
                if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
    }
})();

/**
 * button setting controller display button settings.
 * @author Anand Malvi
 * created on 12.04.2019
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.settings')
            .controller('buttonSettingCtrl', buttonSettingCtrl);

    /** @ngInject */
    function buttonSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService, $timeout)
    {
        /**
         * permissionArr is use to check permission to display list
         * created on on 12.04.2019
         **/
        if ($rootScope.permissionArr.indexOf('button_setting') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'settings.button-setting';
        $scope.showOnStatus = {};
        $scope.multipleDemo = {};
        
        /**
         * get active status data.
         * created on 12.04.2019
         *//*
          $scope.getActiveStatusData = function () {
          $http.post($rootScope.baseUrl + '/status/activeAll')
          .success(function (result) {
          $scope.orderStatusList = result;
          }).error(function (error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
          }
          });
          }
          
          /**
          * Save button setting data is use for update button setting data.
          * created on 12.04.2019
          *//*
           $scope.saveButtonSettingData = function () {
           if (!this.buttonFrm.$valid) {
           return;
           }
           apiService.loaderShow();
           $scope.buttonData = {};
           $scope.buttonData['button_setting'] = {
           show_on_status: angular.toJson(this.showOnStatus.selectd),
           change_to_status: this.onChangeStatus ? this.onChangeStatus : ''
           
           };
           var bodyData = {
           sticker_data: angular.toJson($scope.buttonData),
           affected_by: $rootScope.globals.currentUser.id,
           type: 'buttonSetting',
           };
           $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function (response) {
           apiService.loaderHide();
           toastr.success(response.message);
           }).error(function (error) {
           console.log(error);
           apiService.loaderHide();
           if (error.data.code != undefined && error.data.code == 0) {
           toastr.error(error.data.message);
           } else {
           toastr.error("Something went wrong please try again.");
           }
           });
           };
           
           /**
           * Get edited button setting.
           * created on 12.04.2019
           *//*
            $scope.getEditedOrderPopupButton = function () {
            var vm = this;
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/config/buttonSetting')
            .success(function (result) {
            apiService.loaderHide();
            if (result) {
            if (result.status == 'fail') {
            } else {
            if (result.data) {
            var resultData = result.data;
            vm.showOnStatus.selectd = resultData.button_setting.show_on_status ? angular.fromJson(resultData.button_setting.show_on_status) : '';
            vm.onChangeStatus = resultData.button_setting.change_to_status ? resultData.button_setting.change_to_status : '';
            }
            }
            }
            }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
            }
            });
            };
            */

        $scope.getStatusAndEditBtnData = function () {
            $scope.multipleDemo.selectedPeople = [];
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
                    .success(function (result) {
                        vm.orderStatus = result;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
            /**
             * get edit button settings status data.
             * created on 06.19.2018
             */
            $scope.setOfSets = [];
            $http.get($rootScope.baseUrl + '/config/get-save-button-setting')
                    .success(function (result) {
                        if (result.status == 'success') {
                            if (result.data && result.data != undefined) {
                                vm.editBtnStatus = result.data.data;
                                vm.showOnStatus = {};
                                $scope.multipleDemo.selectedPeople = result.data.data_change_status_to ? result.data.data_change_status_to.selectedPeople:[];
                            }
                        } else {
                            vm.editBtnStatus = [
                                {"name": "Change Date", "status": []},
                                {"name": "Change Date 2", "status": []}
                            ];
                        }
                        var half_length = Math.ceil(vm.editBtnStatus.length / 2);
                        var leftArray = vm.editBtnStatus.splice(0, half_length);
                        var rightArray = vm.editBtnStatus.splice(0, vm.editBtnStatus.length);
                        $scope.setOfSets.push(leftArray);
                        $scope.setOfSets.push(rightArray);
                    }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });

        };
        

        $scope.addEditBtnStatus = function () {
            $scope.temp = [];
            angular.forEach($scope.setOfSets, function (value, key) {
                angular.forEach(value, function (val, ke) {
                    $scope.temp.push(val);
                });
            });
            apiService.loaderShow();
            var bodyData = {
                'settingData': angular.toJson($scope.temp),
                'data_change_status_to': $scope.multipleDemo
            };
            $http.post($rootScope.baseUrl + '/config/setting/save-button-setting', bodyData).success(function (response) {
                apiService.loaderHide();
                toastr.success(response.message);

            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        $scope.removeStatus = function (item, arr) {
            arr.splice(arr.indexOf(item), 1);
        }

        /**
         * label Exists method is use check duplicate status.
         * created on 06.19.2018
         */
        function labelExists(label, destSortableScope) {
            return destSortableScope.modelValue.some(function (el) {
                return el.status_label === label;
            });
        }

        /**
         * sortable Options.
         * created on 06.19.2018
         */
        $scope.sortableOptions = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                if (sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) {
                    return true;
                } else {
                    if (labelExists(sourceItemHandleScope.itemScope.modelValue.status_label, destSortableScope)) {
                        return false;
                    } else {
                        return true;
                    }
                }
            },
            itemMoved: function (eventObj) {
                eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
            },
            containment: '#sortable-container',
            allowDuplicates: true,
            longTouch: true
        };

        $scope.sortableCloneOptions = {
            containment: '#sortable-container',
            allowDuplicates: true,
            clone: true,
            longTouch: true
        };

    }
})();

/**
 * button type controller handle all action related button type configuration.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 07.06.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('buttonTypeCtrl', buttonTypeCtrl);

  /** @ngInject */
  function buttonTypeCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 07.06.2018
     */
    if($rootScope.permissionArr.indexOf('button_type_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.button-type';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of buttonType.
     * created on 07.06.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/buttoncategory')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.buttonType = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'button_type_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editButtonType(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'button_type_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/buttonType/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'button_type_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/buttonType/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'button_type_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/buttonType/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              button_type: value.button_type,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.buttonType);
          defer.resolve(vm.buttonType);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
     vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('button_type').withTitle('Button Type'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('button_type_edit') !== -1 || $rootScope.permissionArr.indexOf('button_type_delete') !== -1 || $rootScope.permissionArr.indexOf('button_type_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add ButtonType method is use for get add Button Type page.
     * created on 07.06.2018
     */
    $scope.addButtonType = function() {
      $cookies.put('button-type-id',undefined);
      $state.go('settings.add-button-type');
    }

    /**
     * Edit ButtonType method is use for get edit Button Type page.
     * created on 07.06.2018
     */
    $scope.editButtonType = function(id) {
      $cookies.put('button-type-id',id);
      $state.go('settings.edit-button-type');
    }

    /**
     * Open model.
     * created on 07.06.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of button Type.
     * created on 07.06.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/buttoncategory', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.button-type');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete button Type method is use for delete button Type.
     * created on 07.06.2018
     */
    $scope.deleteButtonType = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/buttoncategory/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Button Type deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save Button Type data method is use for update/add Button Type data.
     * created on 07.06.2018
     */
    $scope.saveButtonTypeData = function() {
       if (!this.buttonTypeFrm.buttonType.$valid) {
        toastr.error("Please enter button type.");
        angular.element('#buttonType').focus();
        return;
      }else if (!this.buttonTypeFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }
       apiService.loaderShow();
      var bodyData = {
        button_type: vm.buttonType,
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/buttoncategory';
      $scope.httpMethod = 'POST';
      $scope.buttonTypeId = vm.buttonTypeId;
      if (vm.buttonTypeId) {
        $scope.saveUrl = $rootScope.baseUrl + '/buttoncategory/' + vm.buttonTypeId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Button Type ' + ($scope.buttonTypeId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.button-type');
        } else {
          $state.go('settings.button-type');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This button type already exists.');
                angular.element('#buttonType').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.button-type');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited buttonType method is use for get edited buttonType data.
     * created on 07.06.2018
     */
    $scope.getEditedButtonType = function() {

        if($rootScope.permissionArr.indexOf('button_type_add') == -1 && $rootScope.permissionArr.indexOf('button_type_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('button-type-id') && $cookies.get('button-type-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/buttoncategory/' + $cookies.get('button-type-id'))
            .success(function(response) {
              vm.buttonType = response.button_type;
              vm.buttonTypeId = response._id;
              vm.status = response.status;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-button-type');
        }
    };

  }

})();

/**
 * category controller handle all action related category configuration.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 05.04.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('categoryCtrl', categoryCtrl);

  /** @ngInject */
  function categoryCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 05.04.2018
     */
    if($rootScope.permissionArr.indexOf('category_list')==-1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm=this;
    $rootScope.currentState='settings.category';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of category.
     * created on 05.04.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/reportsettingscategory')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.categoryList = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'category_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editCategory(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'category_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/category/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'category_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/category/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'category_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/category/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              name: value.name,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.categoryList);
          defer.resolve(vm.categoryList);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Category Label'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('category_edit') !== -1 || $rootScope.permissionArr.indexOf('category_delete') !== -1 || $rootScope.permissionArr.indexOf('category_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add category method is use for get add category page.
     * created on 05.04.2018
     */
    $scope.addCategory = function() {
      $cookies.put('category-id',undefined);
      $state.go('settings.add-category');
    }

    /**
     * Edit category method is use for get edit category page.
     * created on 05.04.2018
     */
    $scope.editCategory = function(id) {
      $cookies.put('category-id',id);
      $state.go('settings.edit-category');
    }

    /**
     * Open model.
     * created on 05.04.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of category.
     * created on 05.04.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/reportsettingscategory', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete category method is use for delete category.
     * created on 05.04.2018
     */
    $scope.deleteCategory = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/reportsettingscategory/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Category deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save category data method is use for update/add category data.
     * created on 05.04.2018
     */
    $scope.saveCategoryData = function() {
       if (!this.categoryFrm.category.$valid) {
        toastr.error("Please enter category label.");
        angular.element('#category').focus();
        return;
      }else if (!this.categoryFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }
       apiService.loaderShow();
      var bodyData = {
        name: vm.category,
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/reportsettingscategory';
      $scope.httpMethod = 'POST';
      if (vm.categoryId) {
        $scope.saveUrl = $rootScope.baseUrl + '/reportsettingscategory/' + vm.categoryId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Category ' + (vm.categoryId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.category');
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This category already exists.');
                angular.element('#category').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.category');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited category method is use for get edited category data.
     * created on 05.04.2018
     */
    $scope.getEditedCategory = function() {

        if($rootScope.permissionArr.indexOf('category_add') == -1 && $rootScope.permissionArr.indexOf('category_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('category-id') && $cookies.get('category-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/reportsettingscategory/' + $cookies.get('category-id'))
            .success(function(response) {
              apiService.loaderHide();
              vm.category = response.name;
              vm.categoryId = response._id;
              vm.status = response.status;
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-category');
        }
    };

  }

})();

/**
 * Rework controller display Rework settings.
 * @author Harsha Prajapati
 * created on 08.27.2018
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.settings')
            .controller('damageSettingCtrl', damageSettingCtrl);

    /** @ngInject */
    function damageSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService, $timeout) {
        /**
         * permissionArr is use to check permission to display list
         * created on 08.27.2018
         */
        if ($rootScope.permissionArr.indexOf('damage_setting') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'settings.damage-setting';
        $scope.resetGlobalSearch();
        /**
         * menuStatus is use to default open accordion
         * created on 08.27.2018
         */
        $scope.oneAtATime = false;
        $scope.menuStatus = [
            { isOpen: true },
            { isOpen: true },
            { isOpen: true }
        ]
        /**
         * declare data.
         * created on 08.27.2018
         */
        vm.damageReason = [];
        //vm.reworkSolution = [];


        /**
         * save Damage setting method is use for add Damage Setting data.
         * created on 08.27.2018
         */
        $scope.saveDamageSetting = function () {
            var reason = $scope.validateArr(vm.damageReason, 'itemDefaultReason');
            if (reason == 1) {
                return false;
            }
            /*var solution = $scope.validateArr(vm.reworkSolution, 'itemDefaultSol');
             if (solution == 1) {
             return false;
             }*/
            $scope.damageSettingData = {
                'damage_reason': vm.damageReason,
                //'rework_solution':vm.reworkSolution,
                'available_order_status':vm.availableOrderStatus,
                //'rework_order_status':vm.reworkOrderStatus
            };
            apiService.loaderShow();
            var bodyData = {
                type: 'damageSetting',
                sticker_data: angular.toJson($scope.damageSettingData),
                affected_by: $rootScope.globals.currentUser.id,
            };
            console.log(bodyData);
//            return '';
            $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function (response) {
                apiService.loaderHide();
                toastr.success(response.message);
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        };

        /**
         * get Damage Setting Data method is use to display Damage Setting data.
         * created on 08.27.2018
         */
        $scope.getDamageSettingData = function () {
            $scope.isloaded = false;
            $http.get($rootScope.baseUrl + '/config/damageSetting')
                    .success(function (result) {
                        $scope.isloaded = true;
                        if (result) {
                            if (result.status == 'fail') {
                                toastr.error(result.message);
                            } else {
                                if (result.data) {
                                    vm.availableOrderStatus = result.data.available_order_status;
                                    //vm.reworkOrderStatus = result.data.rework_order_status;
                                    vm.damageReason = result.data.damage_reason;
                                    //vm.reworkSolution = result.data.rework_solution;
                                }
                            }
                        }
                    }).error(function (error) {
                $scope.isloaded = true;
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };


        $scope.addItem = function (type) {
            //this.reworkSettingFrm.$setPristine();
            $scope.inserted = {
                name: null,
                set_default: '0'
            };
            if (type == 'damage_reason') {
                vm.damageReason.push($scope.inserted);
            }
            /*
            else if (type == 'rework_solution') {
                vm.reworkSolution.push($scope.inserted);
            }*/
        };

        $scope.confirmDelete = function (id, type) {
            $rootScope.itemId = id;
            $rootScope.itemType = type;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/settings/damageSetting/deleteModal.html',
                scope: $scope
            });
        };

        $scope.removeItem = function () {
            if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
                if ($rootScope.itemType == "damage_reason") {
                    vm.damageReason.splice($rootScope.itemId, 1);
                }
                /*
                else if ($rootScope.itemType == "rework_solution") {
                    vm.reworkSolution.splice($rootScope.itemId, 1);
                }
                */
            }
            $scope.popupShow.close();
        };
        /**
         * validateArr method is use to validate empty inline grid element.
         * created on 10.30.2017
         */
        $scope.validateArr = function (dataArr, setAsDefault) {
            var errorKey = -1;
            var errorId = '';
            var temp = [];
            var isOnlyDefaultError = 0;
            var errorMessageDefault = 0;
            for (var i = 0; i < dataArr.length; i++) {
                angular.element('#' + setAsDefault + '-' + i).removeClass('focus-error');
                var n = dataArr[i];
                if (setAsDefault != undefined) {
                    isOnlyDefaultError = 1;
                    if (n.set_default == '1') {
                        temp.push(i);
                    }
                }
            }
            if (isOnlyDefaultError && errorId == "" && dataArr.length > 0) {
                if (temp.length < 1) {
                    errorKey = 0;
                } else if (temp.length > 1) {
                    errorKey = temp[temp.length - 1];
                    errorMessageDefault = 1;
                }
                errorId = setAsDefault;
            }
            if (errorKey > -1) {
                if (errorMessageDefault == 1) {
                    toastr.error('Set As Default already exists.');
                    angular.element('#' + errorId + '-' + errorKey).addClass('focus-error');
                    angular.element('#' + errorId + '-' + errorKey).focus();
                    return 1;
                }
            }
            return 0;
        };

        /**
         * get Active Status method is use to display all active order status.
         * created on 08.28.2018
         */
        $scope.getActiveStatus = function () {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
                    .success(function (result) {
                        $scope.orderStatus = result;
                    }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

    }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('blocksCtrl', blocksCtrl);

  /** @ngInject */
  function blocksCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 10.12.2017
     */
    if($rootScope.permissionArr.indexOf('block_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.blocks';
    $scope.dateList=[7, 15, 30, 60, 90];
    $scope.resetGlobalSearch();
    function renderWithBlockType(data,full,type){
      if(data){
        if(data=='is_regular'){
          return 'Regular';
        }else if(data=='is_customer'){
          return 'Customer';
        }else if(data=='is_express'){
          return 'Express';
        }else if(data=='is_supply'){
          return 'Supply';
        }else{
          return '';
        }
      }else {
        return '';
      }
    }
    /**
     * Get data table method is use get list of dashboard blocks.
     * created on 10.12.2017
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/dashboardblocks')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.blocks = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'block_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editBlock(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'block_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/dashboardBlocks/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'block_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/dashboardBlocks/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'block_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/dashboardBlocks/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }
            
            var data = {
              id: value._id,
              name: value.name,
              block_type:value.dashboard_block_type?value.dashboard_block_type:'none',
             'main_block_type':value.main_block_type?value.main_block_type:'',
              index:index,
              created_at: value.created_at,
              date: value.date,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.blocks);
          defer.resolve(vm.blocks);

        }).error(function (error) {

            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Block Name'),
        DTColumnBuilder.newColumn('block_type').withTitle('Add On Type'),
        DTColumnBuilder.newColumn('main_block_type').withTitle('Main Block Type'),
        DTColumnBuilder.newColumn('date').withTitle('Days').renderWith(manageDays),
        DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('block_edit') !== -1 || $rootScope.permissionArr.indexOf('block_delete') !== -1 || $rootScope.permissionArr.indexOf('block_changestatus') !== -1 || $rootScope.permissionArr.indexOf('assign_status') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }
    
    function manageDays(data,type,full) {
            if (data == undefined || data == '') {
                return 'Default';
            } else {
                return data + ' Days';
            }
    }
    

     /**
     * Add Block method is use for get add block page.
     * created on 10.12.2017
     */
    $scope.addBlock = function() {
      $cookies.put('block-id',undefined);
      $state.go('settings.add-block');
    }

    /**
     * Edit block method is use for get edit block page.
     * created on 10.12.2017
     */
    $scope.editBlock = function(id) {
      $cookies.put('block-id',id);
      $state.go('settings.edit-block');
    }

    /**
     * Open model.
     * created on 10.12.2017
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of block.
     * created on 10.12.2017
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+ $rootScope.status +""
        };
        $http.put($rootScope.baseUrl + '/dashboardblocks', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.blocks');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete Block method is use for delete Block.
     * created on 10.12.2017
     */
    $scope.deleteBlock = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/dashboardblocks/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Block deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save block data method is use for update/add block data.
     * created on 10.12.2017
     */
    $scope.model={};
    $scope.saveBlockData = function() {
      //var vm = this;
     // console.log($scope.model.blockType);
     if (!this.blockFrm.$valid) {
        return;
      }
      apiService.loaderShow();
      var blockType=[];
      angular.forEach($scope.model.blockType, function (value, key){
        var type=getBlockType(value);
         if(type)
         {
            blockType.push(type); 
         }
      });
      var bodyData = {
        name: this.block,
        date: this.date,
        dashboard_block_type:blockType.length>0?JSON.stringify(blockType):'',
        status: this.status,
       main_block_type:getBlockType(this.mainType),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/dashboardblocks';
      $scope.httpMethod = 'POST';
      $scope.blockId = this.blockId;
      if (this.blockId) {
        $scope.saveUrl = $rootScope.baseUrl + '/dashboardblocks/' + this.blockId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Block ' + ($scope.blockId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.blocks');
        } else {
          $state.go('settings.blocks');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This block name already exists.');
                angular.element('#block').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.blocks');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited block method is use for get edited block data.
     * created on 10.12.2017
     */
    $scope.getEditedBlock = function() {

        if($rootScope.permissionArr.indexOf('block_add') == -1 && $rootScope.permissionArr.indexOf('block_edit') == -1 && $rootScope.permissionArr.indexOf('assign_status') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('block-id') && $cookies.get('block-id')!= undefined) {
          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/dashboardblocks/' + $cookies.get('block-id'))
            .success(function(response) {
             var blockType='';
             var renderType=[];
             // this statment for render dashboard block type
         if(isJSON(response.dashboard_block_type)){
             blockType=JSON.parse(response.dashboard_block_type);
              if(blockType.length>0){
           
                angular.forEach(blockType, function (value, key){
                  var type=renderBlockType(value);
                   if(type)
                   {
                      renderType.push(type); 
                   }
                });
            }}else {
            var type=renderBlockType(response.dashboard_block_type);
                   if(type)
                   {
                      renderType.push(type); 
                   }
            }
              vm.block = response.name;
              vm.date = response.date;
              vm.blockId = response._id;
              $scope.model.blockType=renderType;
              vm.status = response.status;
              vm.statusList = response.statusList;
              vm.mainType   =renderBlockType(response.main_block_type);
              $scope.setAddOnType(vm.mainType);
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-block');
        }
    };

    /**
     * Get Assign status method is use for go to assign status page.
     * created on 10.12.2017
     */
    $scope.assignStatus = function() {
      $state.go('settings.assign-status');
    };
    /**
     * drag and drop status data.
     * created on 10.12.2017
     */
     $scope.getStatusAndBlockData = function() {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll',{status:''})
                .success(function (result) {
                  $scope.orderStatus = result;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    }
                    $state.go('settings.blocks');
                });
            /**
             * get block status data.
             * created on 10.12.2017
             */
             $scope.setOfSets = [];
          $http.get($rootScope.baseUrl +'/dashboardblocks/setting')
                    .success(function (result) {
                      $scope.itemsList=result;
                      var half_length = Math.ceil($scope.itemsList.length / 2);
                      var leftArray = $scope.itemsList.splice(0,half_length);
                      var rightArray = $scope.itemsList.splice(0,$scope.itemsList.length);
                      $scope.setOfSets.push(leftArray);
                      $scope.setOfSets.push(rightArray);
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        $state.go('settings.blocks');
                    });

                    $scope.$watch('setOfSets', function(model) {
                        $scope.modelAsJson = angular.toJson(model, true);
                        $scope.temp = {}
                        if(model && model!= undefined){
                          angular.forEach(model, function (value, key) {
                            angular.forEach(value, function (val, ky) {
                            var demo = []
                            angular.forEach(val.status, function (value1, key1) {
                                  demo.push({'status':value1.status_label,'status_code':value1.status_code?value1.status_code:'','color_code':value1.color_code?value1.color_code:'','is_active':(value1.is_active != undefined ? value1.is_active:1)})
                            });
                            $scope.temp[val._id.block] = demo;
                          });
                          });
                        }
                    }, true);
      };
    /**
    * Add Block status data method is use to save Block status.
    * created on 10.12.2017
    */
    $scope.addBlockStatus= function(){
       apiService.loaderShow();
       var bodyData={'settingdata':JSON.stringify($scope.temp)};
       $http.post($rootScope.baseUrl + '/dashboardblocks/setting',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('settings.blocks');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
     }

    /**
    * remove block status data method is use to delete block status.
    * created on 10.12.2017
    */
    $scope.removeBlockStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 10.12.2017
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 10.12.2017
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };

    /**
     * get active block method is use for get active dashboard block list.
     * created on 04.04.2018
     */
    $scope.getActiveBlockData=function(){
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/dashboardblocks/active')
          .success(function (result) {
            $scope.isloaded = true;
            $scope.blockOrder=result;
            $scope.updatedBlock=result;
          }).error(function (error) {
            $scope.isloaded = true;
              if (error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
    }
    /**
    * block sortable Options.
    * created on 04.04.2018
    */
    $scope.sortableBlockOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedBlock = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * save Faq Order is use to save sort order and display faq this order.
    * created on 10.17.2017
    */
    $scope.saveBlockOrder=function(){
      $scope.temp=[];
      angular.forEach($scope.updatedBlock,function(value,key){
        $scope.temp.push({'id':value._id,'sort_order':key+1})
      });
      //apiService.loaderShow();
      var bodyData={
        'data':JSON.stringify($scope.temp)
      };
      $http.post($rootScope.baseUrl + '/dashboardblocks/bulkupdate',bodyData).success(function (response) {
           //apiService.loaderHide();
           if(response.status=="fail"){
             toastr.error(response.message);
           }else{
             toastr.success(response.message);
             $state.go('settings.blocks');
           }

        }).error(function (error) {
            //apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }
   /**
    * get all type master
    */
    $scope.getTypeMaster = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/productType/getActiveType/all')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
             $scope.typeData =result;
             $scope.typeMultiSelectData=result;
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }
  //get dashboard block type key
   function getBlockType(type){
        var original_type=type;
        if(type){
        type=type.toLowerCase();
        if(type=='regular'){
          return 'is_regular';
        }else if(type=='customer'){
          return 'is_customer';
        }else if(type=='express'){
          return 'is_express';
        }else if(type=='supply'){
          return 'is_supply';
        }else if(type=='rework'){
          return 'icon_tools';
        }else{
          return original_type;
        }
      }else {
        return '';
      }
    }
    
    //get dashboard block type key
   function renderBlockType(type){
        var original_type=type;
        if(type){
        type=type.toLowerCase();
        if(type=='is_regular'){
          return 'Regular';
        }else if(type=='is_customer'){
          return 'Customer';
        }else if(type=='is_express'){
          return 'Express';
        }else if(type=='is_supply'){
          return 'Supply';
        }else if(type=='icon_tools'){
          return 'Rework';
        }else{
          return original_type;
        }
      }else {
        return '';
      }
    }
    function isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}

// on select main type hide this value
 $scope.setAddOnType = function(mainType){
    $http.get($rootScope.baseUrl + '/productType/getActiveType/all'+'?main_type='+mainType)
           .success(function(result) {
             if (result) {
                $scope.typeMultiSelectData =result;
             }
           }).error(function(error) {
             if (error.data && error.data.code != undefined && error.data.code == 0) {
               toastr.error(error.data.message);
             }
           }); 
   }
    
}

})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('dashboardSummeryCtrl', dashboardSummeryCtrl);

  /** @ngInject */
  function dashboardSummeryCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout)
  {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.09.2019
     */
    if ($rootScope.permissionArr.indexOf('settings_dashboard_summery') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.dashboard-summery';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 11.09.2019
     */
    $scope.oneAtATime = false;
    $scope.isOpenObject = {};
    
    vm.designStatus=[];
    vm.productionStatus=[];
    vm.shippingStatus=[];
    vm.mallShippingStatus=[];

    vm.alignment = 'center';
    vm.bold = false;

    $scope.getActiveStatus = function()
    {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    $scope.getDashboardSummeryData = function()
    {
      $http.get($rootScope.baseUrl + '/config/dashboardSummery')
      .success(function(result)
      {
        if (result)
        {
          if (result.status == 'fail') {
            toastr.error(result.message);
          }
          else
          {
            if (result.data)
            {
              var resultData = result.data;
              var status_settings = resultData.status_settings;
              vm.designStatus = status_settings.designStatus;
              vm.productionStatus = status_settings.productionStatus;
              vm.shippingStatus=status_settings.shippingStatus;
              vm.mallShippingStatus=status_settings.mallShippingStatus;
            }
          }
        }
      })
      .error(function(error)
      {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    };

    $scope.saveDashbordSummery=function()
    {
      if(!this.dashboardFrm.$valid){
        return;
      }

      $scope.dashboardSummeryData = {
        'status_settings':{
          'designStatus':vm.designStatus,
          'productionStatus':vm.productionStatus,
          'shippingStatus': vm.shippingStatus,
          'mallShippingStatus': vm.mallShippingStatus,
        }
      };
      apiService.loaderShow();
      var bodyData = {
        type: 'dashboardSummery',
        sticker_data: angular.toJson($scope.dashboardSummeryData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };
 } 
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('databaseStatusMapCtrl', databaseStatusMapCtrl);

  /** @ngInject */
  function databaseStatusMapCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.21.2018
     */
    if($rootScope.permissionArr.indexOf('database_status_maping') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.database-status';
    $scope.resetGlobalSearch();
    vm.mapStatusList=[];
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    vm.mapRegularStatusList=[];
    vm.mapExpressStatusList=[];
    vm.mapReworkStatusList=[];
    $scope.addItem = function(type) {
      $scope.inserted = {
        database_status: '',
        order_status: ''
      };
      if(type=='regular'){
        vm.mapRegularStatusList.push($scope.inserted);
      }else if(type=='express'){
        vm.mapExpressStatusList.push($scope.inserted);
      }else if(type=='rework'){
        vm.mapReworkStatusList.push($scope.inserted);
      }

    };

    $scope.confirmDelete = function(id,type) {
      $rootScope.itemId = id;
      $rootScope.itemType=type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/settings/databaseStatusMap/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if($rootScope.itemType=='regular'){
          vm.mapRegularStatusList.splice($rootScope.itemId, 1);
        }else if($rootScope.itemType=='express'){
          vm.mapExpressStatusList.splice($rootScope.itemId, 1);
        }else if($rootScope.itemType=='rework'){
          vm.mapReworkStatusList.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };

    $scope.getActiveStatus=function(){
      // active relay status
      $http.get($rootScope.baseUrl + '/databasestatus/active')
          .success(function (result) {
            vm.databaseStatusList = result;
          }).error(function (error) {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });

      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          vm.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    $scope.getDatabaseSettingData = function() {
        $http.get($rootScope.baseUrl + '/config/databaseSetting')
          .success(function(result) {
            if (result) {
              if (result.status == 'fail') {
                toastr.error(result.message);
              } else {
                if (result.data) {
                  var resultData=result.data;
                  vm.mapRegularStatusList=resultData.map_regular_statuses?resultData.map_regular_statuses:[];
                  vm.mapExpressStatusList=resultData.map_express_statuses?resultData.map_express_statuses:[];
                  vm.mapReworkStatusList=resultData.map_rework_statuses?resultData.map_rework_statuses:[];
                }
              }
            }
          }).error(function(error) {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
    }
    $scope.saveDatabaseSetting=function(){
      if(!this.settingFrm.$valid){
        return;
      }
      $scope.webhookSettingData = {
        'map_express_statuses':vm.mapExpressStatusList,
        'map_regular_statuses':vm.mapRegularStatusList,
        'map_rework_statuses':vm.mapReworkStatusList
      };
      apiService.loaderShow();
      var bodyData = {
        type: 'databaseSetting',
        sticker_data: angular.toJson($scope.webhookSettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
  }

})();

/**
 * Departments controller handle all action related user Department.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 09.26.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('departmentsCtrl', departmentsCtrl);

  /** @ngInject */
  function departmentsCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.26.2017
     */
    if($rootScope.permissionArr.indexOf('department_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.departments';
    $scope.resetGlobalSearch();
    function renderWithDeptType(data,full,type){
      if(data){
        if(data=='is_regular'){
          return 'Regular';
        }else if(data=='is_customer'){
          return 'Customer';
        }else if(data=='is_express'){
          return 'Express';
        }else{
          return '';
        }
      }else {
        return '';
      }
    }
    /**
     * Get data table method is use get list of departments.
     * created on 09.26.2017
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/departments')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.departments = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'department_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editDepartment(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'department_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/departments/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'department_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/departments/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'department_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/departments/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              name: value.name,
              type:value.status_block_flag,
              index:index,
              created_at: value.created_at,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks //+ '&nbsp;' + departmentStatusLinks
              };
            this.push(data);
            ++index;
          }, vm.departments);
          defer.resolve(vm.departments);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Department Name'),
        DTColumnBuilder.newColumn('type').withTitle('Type').renderWith(renderWithDeptType),
        DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('department_edit') !== -1 || $rootScope.permissionArr.indexOf('department_delete') !== -1 || $rootScope.permissionArr.indexOf('department_changestatus') !== -1 || $rootScope.permissionArr.indexOf('select_department') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add departments method is use for get add department page.
     * created on 09.26.2017
     */
    $scope.addDepartment = function() {
      $cookies.put('department-id',undefined);
      $state.go('settings.add-department');
    }

    /**
     * Edit department method is use for get edit department page.
     * created on 09.26.2017
     */
    $scope.editDepartment = function(id) {
      $cookies.put('department-id',id);
      $state.go('settings.edit-department');
    }

    /**
     * Open model.
     * created on 09.26.2017
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of department.
     * created on 09.26.2017
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status:  ""+$rootScope.status+"",
          updated_by:$rootScope.globals.currentUser.id
        };
        $http.put($rootScope.baseUrl + '/departments', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.departments');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete department method is use for delete department.
     * created on 09.26.2017
     */
    $scope.deleteDepartment = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/departments/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Department deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save department data method is use for update/add department data.
     * created on 09.26.2017
     */
    $scope.saveDepartmentData = function() {
      var vm = this;
       if (!this.departmentFrm.department.$valid) {
        toastr.error("Please enter department name.");
        angular.element('#department').focus();
        return;
      }else if (!this.departmentFrm.deptIcon.$valid) {
       toastr.error("Please select department icon.");
       angular.element('#deptIcon').focus();
       return;
     }else if (!this.departmentFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }
       apiService.loaderShow();
      var bodyData = {
        name: this.department,
        status: this.status,
        department_icon: this.departmentIcon,
        status_block_flag:this.deptType,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/departments';
      $scope.httpMethod = 'POST';
      $scope.departmentId = this.departmentId;
      if (this.departmentId) {
        $scope.saveUrl = $rootScope.baseUrl + '/departments/' + this.departmentId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Department ' + ($scope.departmentId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.departments');
        } else {
          $state.go('settings.departments');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This department name already exists.');
                angular.element('#department').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.departments');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited department method is use for get edited department data.
     * created on 09.26.2017
     */
    $scope.getEditedDepartment = function() {

        if($rootScope.permissionArr.indexOf('department_add') == -1 && $rootScope.permissionArr.indexOf('department_edit') == -1 && $rootScope.permissionArr.indexOf('select_department') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('department-id') && $cookies.get('department-id')!= undefined) {
          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/departments/' + $cookies.get('department-id'))
            .success(function(response) {
              vm.department = response.name;
              vm.departmentId = response._id;
              vm.status = response.status;
              vm.departmentIcon=response.department_icon;
              vm.deptType=response.status_block_flag?response.status_block_flag:'none';
              vm.orderStatus = response.statusList;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-department');
        }
    };

    /**
     * Get department status method is use for go to department status page.
     * created on 09.26.2017
     */
    $scope.departmentsStatus = function() {
      $state.go('settings.departments-status');
    };
    /**
     * drag and drop status data.
     * created on 09.27.2017
     */
     $scope.getStatusAndDepartmentData = function() {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
                .success(function (result) {
                  $scope.orderStatus = result;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    }
                    $state.go('settings.departments');
                });
            /**
             * get department status data.
             * created on 09.27.2017
             */
            $scope.setOfSets = [];
            $http.get($rootScope.baseUrl + '/departments/setting')
                    .success(function (result) {
                      $scope.itemsList=result;
                      var half_length = Math.ceil($scope.itemsList.length / 2);
                      var leftArray = $scope.itemsList.splice(0,half_length);
                      var rightArray = $scope.itemsList.splice(0,$scope.itemsList.length);
                      $scope.setOfSets.push(leftArray);
                      $scope.setOfSets.push(rightArray);
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        $state.go('settings.departments');
                    });

            $scope.$watch('setOfSets', function(model) {
                $scope.modelAsJson = angular.toJson(model, true);
                $scope.temp = {}
                if(model && model!= undefined){
                  angular.forEach(model, function (value, key) {
                    angular.forEach(value, function (val, ky) {
                    var demo = [];
//                    console.log(val.status);
                    angular.forEach(val.status, function (value1, key1) {
                          demo.push({'status':value1.status_label,'status_code':value1.status_code?value1.status_code:'','color_code':value1.color_code?value1.color_code:'','is_active':(value1.is_active != undefined ? value1.is_active:1)})
                    });
                    $scope.temp[val._id.block] = demo;
                  });
                  });
                }
            }, true);
    };
    /**
    * Add department status data method is use to save department status.
    * created on 09.27.2017
    */
    $scope.addDepartmentStatus= function(){
       apiService.loaderShow();
       var bodyData={'settingdata':JSON.stringify($scope.temp)};
       $http.post($rootScope.baseUrl + '/departments/setting',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('settings.departments');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
     }

    /**
    * remove department status data method is use to delete department status.
    * created on 09.27.2017
    */
    $scope.removeDepartmentStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 09.27.2017
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 09.27.2017
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
    /**
    * get department icon list
    * created on 04.03.2018
    */
    $scope.getDepartmentIconList = function() {
     $http.get($rootScope.baseUrl + '/departments/depicon')
         .success(function (result) {
           if(result.status!="fail"){
             angular.element(document).ready(function () {
               angular.element('#deptIcon').selectpicker("refresh");
             });
             $scope.departmentIconList = result;
           }
         }).error(function (error) {
             if (error.data && error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             }
         });
       }

  }

})();

/**
 * documentSetting controller handle all action related documentSetting.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.25.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.settings')
            .controller('documentSettingCtrl', documentSettingCtrl);

    /** @ngInject */
    function documentSettingCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, $state) {
        /**
        * permissionArr is use to check permission to display list
        * created on 09.22.2017
        */
        if($rootScope.permissionArr.indexOf('document_setting') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }
        $scope.resetGlobalSearch();
        // setup editor options
        $scope.editorOptions = {
            height : 200,
        };
        var vm = this;
        $rootScope.currentState = 'settings.document-setting';
        /**
         * Get document Setting data method is use for get edited document setting data.
         * created on 10.25.2017
         */
        $scope.getDocumentSettingData = function() {
              apiService.loaderShow();
              var vm = this;
              $http.get($rootScope.baseUrl + '/document')
                .success(function(response) {
                  vm.documentId = response._id;
                  vm.documentTitle = response.title;
                  vm.status = response.status;
                  vm.description = response.content;
                  apiService.loaderHide();
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
        }
        /**
         * Save document setting data method is use for update document setting data.
         * created on 10.25.2017
         */
        $scope.saveDocumentSettingData = function() {
          var vm = this;
           if (!this.documentSettingFrm.documentTitle.$valid) {
            toastr.error("Please enter document title.");
            angular.element('#documentTitle').focus();
            return;
          } else if (!this.documentSettingFrm.description.$valid) {
            toastr.error("Please enter description.");
            angular.element('#description').focus();
            return;
          }else if (!this.documentSettingFrm.status.$valid) {
            toastr.error("Please select status.");
            return;
          }
           apiService.loaderShow();
          var bodyData = {
            title: this.documentTitle,
            content:this.description,
            status: this.status,
            affected_by: $rootScope.globals.currentUser.id,
          };
            $scope.saveUrl = $rootScope.baseUrl + '/document';
            $scope.httpMethod = 'PUT';
          $http({
            url: $scope.saveUrl,
            method: $scope.httpMethod,
            data: $scope.dataUrlEncode(bodyData),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }).then(function(response) {
            apiService.loaderHide();
            var response = response.data;
            if (response.code!= undefined && response.code == 0) {
                  toastr.error(response.message );
            }else  if (response.status == 'success') {
              toastr.success(response.message);
            } else {

              toastr.error("Something went wrong please try again.");
            }
          }, function(error) {
            apiService.loaderHide();
            if (error.data.code!= undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
            } else {
              $state.go('dashboard');
              toastr.error("Something went wrong please try again.");
            }
          });

        }

    }
})();

/**
 * FAQ controller handle all action related faqs.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 9.18.2017
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.settings')
            .controller('faqCtrl', faqCtrl);

    /** @ngInject */
    function faqCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, $state) {
        /**
        * permissionArr is use to check permission to display list
        * created on 09.22.2017
        */
        if($rootScope.permissionArr.indexOf('faq_list') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }
        // setup editor options
        $scope.editorOptions = {
            height : 200,
        };
        var vm = this;
        $rootScope.currentState = 'settings.faq';
        $scope.resetGlobalSearch();

        vm.faqs = [];

        /**
        * getDataTable is use to get list of FAQ
        * created on 09.18.2017
        */
        $scope.getDataTable = function () {
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/faq')
                        .success(function (result) {
                            if(result.length < $rootScope.numberOfRecord){
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                 }, 200);
                             }
                    var index = 1;
                    angular.forEach(result, function (value, key) {
                        var changeStatusValTo = '0';
                        var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'faq_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/faq/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';
                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                        if (value.status == 0) {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'faq_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/faq/statusModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                        }
                        var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'faq_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/faq/deleteModal.html' + '\',' + value.id + ',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                        var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'faq_edit'+'\') !== -1" href="javascript:void(0);" ng-click="vm.editFaq(' + value.id + ')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        var data = {
                            id: value.id,
                            index: index,
                            question: value.question,
                            answer: value.answer,
                            sort_order:value.sort_order,
                            created_at: value.created_at,
                            status: statusBadge,
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                        };
                        index++;
                        this.push(data);
                    }, vm.faqs);
                    defer.resolve(vm.faqs);
                }).error(function (error) {
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;

            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('question').withTitle('FAQ Question').renderWith(apiService.ellipsisString),
                DTColumnBuilder.newColumn('sort_order').withTitle('FAQ Order').withOption('className', 'text-center'),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if($rootScope.permissionArr.indexOf('faq_edit') !== -1 || $rootScope.permissionArr.indexOf('faq_delete') !== -1 || $rootScope.permissionArr.indexOf('faq_changestatus') !== -1){
              vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').notSortable().withOption('className', 'tableActions'));
            }
        }

        //method
        vm.addFaq = addFaq;
        vm.editFaq = editFaq;
        vm.saveFaq = saveFaq;
        vm.getFaqDataById = getFaqDataById;
        vm.deleteFaq = deleteFaq;
        vm.changeStatus = changeStatus;
        /**
         * Add Faq method is use for get add Faq.
         * created on 09.18.2017
         */
        function addFaq() {
            $cookies.put('faq-id',undefined);
            $state.go('settings.add-faq');
        }
        /**
         * Edit Faq method is use for get edit Faq form.
         * created on 09.18.2017
         */
        function editFaq(faqId) {

            $cookies.put('faq-id',faqId);
            $state.go('settings.edit-faq');
        }
        /**
         * Get FAQ data by id method is use for get FAQ data.
         * created on 09.18.2017
         */
        function getFaqDataById() {
            if($rootScope.permissionArr.indexOf('faq_add') == -1 && $rootScope.permissionArr.indexOf('faq_edit') == -1){
              $state.go('dashboard');
              toastr.error("You don't have permission to do this.");
            }
            if ($cookies.get('faq-id') && $cookies.get('faq-id')!= undefined) {
                apiService.loaderShow();
                var byIdRoute = $rootScope.baseUrl + '/faq/' + $cookies.get('faq-id');
                var getFaqById = apiService.getAllData(byIdRoute);
                getFaqById.then(function (response) {
                    vm.faqId = response.data.id;
                    vm.question = response.data.question;
                    vm.answer = response.data.answer;
                    vm.sortorder = response.data.sort_order?response.data.sort_order:1;
                    vm.status = response.data.status;
                    apiService.loaderHide();
                }, function (error) {
                    apiService.loaderHide();
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
        }

        /**
         * Save Faq method is use for save FAQ data.
         * created on 09.18.2017
         */
        function saveFaq() {

            if (!vm.question) {
                toastr.error("Please enter FAQ Question.");
                angular.element('#FAQQuestion').focus();
                return;
            } else if (!vm.answer) {
                toastr.error("Please enter FAQ Answer.");
                angular.element('#FAQAnswer').focus();
                return;
            } else if (!vm.sortorder) {
                toastr.error("Please enter Sort Order.");
                angular.element('#SortOrder').focus();
                return;
            }else if (vm.status == undefined) {
                toastr.error("Please select status.");
                angular.element('#status').focus();
                return;
            }
            apiService.loaderShow();
            var postData = {
                question: vm.question,
                answer: vm.answer,
                sort_order:vm.sortorder,
                status: vm.status,
                affected_by: $rootScope.globals.currentUser.id,
                ip_address: '',
            };

            var addFaq;
            if (this.faqId) {
                var editRoute = $rootScope.baseUrl + '/faq/' + this.faqId;
                addFaq = apiService.editData(editRoute, postData);
            } else {
                var addRoute = $rootScope.baseUrl + '/faq';
                addFaq = apiService.addData(addRoute, postData);
            }

            addFaq.then(function (response) {

                vm.faqs = response.data;
                if (response.data.status == 'success') {
                    $state.go('settings.faq');
                    toastr.success('FAQ ' + ($cookies.get('faq-id') ? 'updated' : 'Added') + ' successfully.');
                }
                apiService.loaderHide();
            }, function (error) {
                  if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                  } else {
                    $state.go('settings.faq');
                    toastr.error("Something went wrong please try again.");
                  }
                apiService.loaderHide();
            });
        }

        /**
         * open method is use for open confirmation popup.
         * created on 09.18.2017
         */
        $scope.open = function (page, id, status) {
            $rootScope.statusId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        /**
         * Delete Faq method is use for delete Faq.
         * created on 09.18.2017
         */
        function deleteFaq() {
            apiService.loaderShow();
            vm.faqId = $rootScope.statusId;
            var deleteRoute = $rootScope.baseUrl + '/faq/' + vm.faqId;
            var deleteFaq = apiService.deleteData(deleteRoute);
            deleteFaq.then(function (response) {
                $state.go($state.$current, null, {reload: true});
                vm.faqs = response.data;
                $scope.popupShow.close();
                toastr.success("FAQ deleted successfully");
                apiService.loaderHide();
            },
                    function (error) {
                        $scope.popupShow.close();
                        if (error.code != undefined && error.code == 0) {
                            toastr.error(error.message);
                        } else {
                            toastr.error("Something went wrong please try again.");
                        }
                        apiService.loaderHide();
                    });
        }

        /**
         * Change status method is use for change FAQ status.
         * created on 09.18.2017
         */
        function changeStatus() {
            if ($rootScope.statusId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.statusId,
                    status: $rootScope.status,
                    updated_by: $rootScope.globals.currentUser.id,
                };
                $http.put($rootScope.baseUrl + '/faq', bodyData)
                        .success(function (result) {
                            if (result.status == 'success') {
                                toastr.success('Status updated successfully.');
                                $state.go($state.$current, null, {reload: true});
                            } else {
                                toastr.error("Something went wrong please try again.");
                            }
                            apiService.loaderHide();
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };
        /**
         * get FAQ method is use for get FAQ question list.
         * created on 10.17.2017
         */
        $scope.getFaqData=function(){
          $scope.isloaded = false;
          $http.get($rootScope.baseUrl + '/faq/active')
              .success(function (result) {
                $scope.isloaded = true;
                vm.faq=result;
                vm.updatedFAQ=result;
              }).error(function (error) {
                $scope.isloaded = true;
                  if (error.code != undefined && error.code == 0) {
                      toastr.error(error.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
        }

        /**
         * ellipsisQuestion method is use for get ellipsis FAQ question.
         * created on 10.17.2017
         */
        $scope.ellipsisQuestion=function(que){
          if (typeof que == 'string') {
              var stringVal = que.toString();
              if(stringVal.length  > 150){
                  stringVal = stringVal.substring(0,150)+'...'
              }
              return '<span title="' + que + '">' + stringVal  + '</span>';

          }
        }
        /**
        * sortable Options.
        * created on 10.17.2017
        */
        $scope.sortableOptions = {
          accept: function (sourceItemHandleScope, destSortableScope) {
                return true;
          },
          orderChanged: function (event) {
            vm.updatedFAQ = event.source.sortableScope.modelValue.map(function(a) {return a;});
          },
          containment: '#sortable-container',
          allowDuplicates: false,
        };
        $scope.$watch('vm.updatedFAQ', function(model) {
          $scope.modelAsJson = angular.toJson(model, true);
          $scope.temp=[];
          if(model && model!= undefined){
            angular.forEach(model, function (value, key) {
                  $scope.temp.push({'id':value.id,'sort_order':key+1})
            });
          }
        });
        /**
        * save Faq Order is use to save sort order and display faq this order.
        * created on 10.17.2017
        */
        $scope.saveFaqOrder=function(){
          //apiService.loaderShow();
          var bodyData={
            'data':JSON.stringify($scope.temp)
          };
          $http.post($rootScope.baseUrl + '/faq/bulkupdate',bodyData).success(function (response) {
               //apiService.loaderHide();
               if(response.status=="fail"){
                 toastr.error(response.message);
               }else{
                 toastr.success(response.message);
                 $state.go('settings.faq');
               }

            }).error(function (error) {
                //apiService.loaderHide();
                if (error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
    }
})();

/**
 * Job controller display Job button settings.
 * @author Harsha Prajapati
 * created on 09.06.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('jobSettingCtrl', jobSettingCtrl);

  /** @ngInject */
  function jobSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout) {
    /**
     * permissionArr is use to check permission to display list
     * created on 09.06.2018
     */
    if ($rootScope.permissionArr.indexOf('job_setting') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.job-button-setting';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 09.06.2018
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]

    /**
     * get Job Setting Data method is use to display Job Setting data.
     * created on 09.06.2018
     */
    $scope.getJobSettingData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/jobSetting')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                var resultData=result.data;
                // Open Job
                vm.OJvmExecutionCode=resultData.open_job.vm_execution_code;
                vm.OJfileLocation=resultData.open_job.file_location;
                //vm.OJfolderName=resultData.open_job.folder_name;

                // Open Job DB
                vm.OJDBvmExecutionCode=resultData.open_job_db.vm_execution_code;
                vm.OJDBfileLocation=resultData.open_job_db.file_location;
                //vm.OJDBfolderName=resultData.open_job_db.folder_name;

                // Create Job
                vm.CJvmExecutionCode=resultData.create_job.vm_execution_code;
                //vm.CJfileDownloadLink=resultData.create_job.file_download_link;
                vm.CJfont = resultData.create_job.font;

                // Create 2D Job
                vm.C2DJvmExecutionCode=resultData.create_2d_job.vm_execution_code;
                //vm.C2DJfileDownloadLink=resultData.create_2d_job.file_download_link;
                vm.C2DJfont = resultData.create_2d_job.font;
              }
            }
          }
        }).error(function(error) {
          $scope.isloaded = true;
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * save Job setting method is use for add Job Setting data.
     * created on 09.06.2018
     */
    $scope.saveJobSetting = function() {
      if(!this.jobSettingFrm.$valid){
        return false;
      }
      $scope.jobData={};
      $scope.jobData['open_job'] = {
          'vm_execution_code': vm.OJvmExecutionCode,
          'file_location': vm.OJfileLocation
          //'folder_name':vm.OJfolderName
        };
      $scope.jobData['open_job_db'] = {
          'vm_execution_code': vm.OJDBvmExecutionCode,
          'file_location': vm.OJDBfileLocation
          //'folder_name':vm.OJDBfolderName
        };
      $scope.jobData['create_job'] = {
          'vm_execution_code': vm.CJvmExecutionCode,
          //'file_download_link': vm.CJfileDownloadLink,
          'font': vm.CJfont
        };
      $scope.jobData['create_2d_job'] = {
          'vm_execution_code': vm.C2DJvmExecutionCode,
          //'file_download_link': vm.C2DJfileDownloadLink,
          'font': vm.C2DJfont
        };
      apiService.loaderShow();
      var bodyData = {
        type: 'jobSetting',
        sticker_data: angular.toJson($scope.jobData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };


  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('noyAssemblyCtrl', noyAssemblyCtrl);

  /** @ngInject */
  function noyAssemblyCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout)
  {
    /**
         * permissionArr is use to check permission to display list
         * created on 11.03.2023
         */
        if ($rootScope.permissionArr.indexOf('noy_assembly_setting') == -1) {
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'settings.noy-assembly';
        $scope.resetGlobalSearch();
        /**
         * menuStatus is use to default open accordion
         * created on 11.03.2023
         */
        $scope.oneAtATime = false;
        $scope.isOpenObject = {};
        $scope.menuStatus = [{
            isOpen: true
        }];

        /**
         * get Active Status method is use to display all active order status.
         * created on 08.28.2018
         */
        $scope.getActiveStatus = function() {
          // get order status
          $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function(result) {
              $scope.orderStatus = result;
            }).error(function(error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              }
            });
        }

        $scope.saveNoyAssemblySetting=function()
        {
          if(!this.noyAssemblyFrm.$valid){
            return;
          }

          $scope.NoyAssemblySettingData = {
            'noy_assembly_settings':{
                'noy_status_after_upload': vm.noyStatusAfterUpload,
                'noy_assembly_shipping': vm.noyAssemblyShipping
            }
          };
          apiService.loaderShow();
          var bodyData = {
            type: 'NoyAssemblySetting',
            sticker_data: angular.toJson($scope.NoyAssemblySettingData),
            affected_by: $rootScope.globals.currentUser.id,
          };
          $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
            apiService.loaderHide();
            toastr.success(response.message);
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            } else {
              toastr.error("Something went wrong please try again.");
            }
          });
        }

        $scope.getNoyAssemblySetting = function()
        {
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/config/NoyAssemblySetting')
              .success(function(result) {
                apiService.loaderHide();
                if (result) {
                  if (result.status == 'fail') {
                    toastr.error(result.message);
                  } else {
                    if (result.data)
                    {
                      var resultData=result.data;
                      vm.noyStatusAfterUpload = resultData.noy_assembly_settings.noy_status_after_upload;
                      vm.noyAssemblyShipping = resultData.noy_assembly_settings.noy_assembly_shipping;

                    }
                }
                }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
      }
    }
})();
/**
 * orderPopupButtons controller handle all action related orderPopupButtons configuration.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 04.03.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('orderPopupButtonsCtrl', orderPopupButtonsCtrl);

  /** @ngInject */
  function orderPopupButtonsCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 04.03.2018
     */
    if($rootScope.permissionArr.indexOf('order_button_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $scope.resetGlobalSearch();
    $scope.showOnStatus={};
    $rootScope.currentState='settings.order-popup-button';
    $scope.pattern=false;
    $scope.eventApi = {
        onChange:  function(api, color, $event) {
          $scope.buttonColor = color;
          var regexp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/;
          if (!regexp.test(color)) {
            $scope.pattern=true;
          }else{
            $scope.pattern=false;
          }
        },
    };
    /**
    * Set color for button color field.
    * created on 04.06.2018
    */
    function colorForField(data, type, full, meta) {
        return '<span style="background-color:' + data + ';" class="label  font-size-14 margin-inline">' + data  + '</span>';
    }

    function renderWithMultipleStatus(data, type, full){
      if(data){
        var status= angular.fromJson(data).toString();
        var row=status.split(',');
        return '<div title="'+status+ '">'+row[0]+'</div>';
      }else{
        return '';
      }

    }
    /**
     * Get data table method is use get list of printLabels.
     * created on 04.03.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/orderpopupbuttons')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.orderPopupButtons = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'order_button_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editOrderPopupButton(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'order_button_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/orderPopupButtons/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'order_button_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/orderPopupButtons/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'order_button_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/orderPopupButtons/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              name: value.name,
              show_on_status:value.show_on_status,
              change_to_status:value.change_to_status_title,
              button_color:value.button_color,
              button_type:value.button_type,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.orderPopupButtons);
          defer.resolve(vm.orderPopupButtons);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Button Name'),
        DTColumnBuilder.newColumn('show_on_status').withTitle('Show on Status').withOption('className', 'tableStatus').renderWith(renderWithMultipleStatus),
        DTColumnBuilder.newColumn('change_to_status').withTitle('On Click Change Status').withOption('className', 'tableStatus'),
        DTColumnBuilder.newColumn('button_color').withTitle('Button Color').renderWith(colorForField).withOption('className', 'text-center'),
        DTColumnBuilder.newColumn('button_type').withTitle('Button Type').withOption('className', 'text-center'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('order_button_edit') !== -1 || $rootScope.permissionArr.indexOf('order_button_delete') !== -1 || $rootScope.permissionArr.indexOf('order_button_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add OrderPopupButton method is use for get add OrderPopupButton page.
     * created on 04.03.2018
     */
    $scope.addOrderPopupButton = function() {
      $cookies.put('button-id',undefined);
      $state.go('settings.add-order-popup-button');
    }

    /**
     * Edit OrderPopupButton method is use for get edit OrderPopupButton page.
     * created on 04.03.2018
     */
    $scope.editOrderPopupButton = function(id) {
      $cookies.put('button-id',id);
      $state.go('settings.edit-order-popup-button');
    }
    /**
     * get active status data.
     * created on 04.03.2018
     */
     $scope.getActiveStatusData = function() {
        // get order status
        $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function (result) {
              $scope.orderStatusList = result;
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
          }
    /**
     * Open model.
     * created on 04.03.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of order popup button.
     * created on 04.03.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/orderpopupbuttons', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.order-popup-button');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete order popup button method is use for delete order popup button.
     * created on 04.03.2018
     */
    $scope.deleteOrderPopupButton = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/orderpopupbuttons/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Order popup button deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save Order popup button data method is use for update/add Order popup button data.
     * created on 04.03.2018
     */
    $scope.saveOrderPopupButtonData = function() {
       if (!this.buttonFrm.$valid) {
          return;
        }
       apiService.loaderShow();
      var bodyData = {
        name: this.buttonName,
        button_type: this.buttonType,
        button_color:this.buttonColor,
        show_on_status:angular.toJson(this.showOnStatus.selectd),
        status:this.status,
        change_to_status: this.onChangeStatus?this.onChangeStatus:'',
        affected_by: $rootScope.globals.currentUser.id,
        order_type:this.buttonType=='Print Sticker'?this.orderType:''
      };
      $scope.saveUrl = $rootScope.baseUrl + '/orderpopupbuttons';
      $scope.httpMethod = 'POST';
      $scope.buttonId = this.buttonId;
      if (this.buttonId) {
        $scope.saveUrl = $rootScope.baseUrl + '/orderpopupbuttons/' + this.buttonId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Order popup button ' + ($scope.buttonId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.order-popup-button');
        } else {
          $state.go('settings.order-popup-button');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This button name already exists.');
                angular.element('#buttonName').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.order-popup-button');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited order popup button method is use for get edited order popup button data.
     * created on 04.03.2018
     */
    $scope.getEditedOrderPopupButton = function() {

        if($rootScope.permissionArr.indexOf('order_button_add') == -1 && $rootScope.permissionArr.indexOf('order_button_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }
        $scope.buttonColor = '#CA0058';
        if ($cookies.get('button-id') && $cookies.get('button-id')!= undefined) {
          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/orderpopupbuttons/' + $cookies.get('button-id'))
            .success(function(response) {
              vm.buttonName = response.name;
              vm.buttonType=response.button_type;
              vm.showOnStatus.selectd=response.show_on_status?angular.fromJson(response.show_on_status):'';
              vm.buttonColor=response.button_color;
              vm.buttonId = response._id;
              vm.onChangeStatus = response.change_to_status;
              vm.status=response.status;
              vm.orderType=response.order_type;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-order-popup-button');
        }
    };
    $scope.getActiveButtonType=function(){
      $http.get($rootScope.baseUrl + '/buttoncategory/active')
        .success(function(response) {
          $scope.activeButtonType=response;
        }).error(function (error) {
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }
    /**
     * Set color options method is use set color picker default options.
     * created on 10.19.2017
     */
    $scope.setColorOptions = function () {
       $scope.options = {
          required:true,
          inputClass: 'form-control',
          format:'hexString',
          id: 'buttonColor',
          name: 'buttonColor',
          placeholder:"Button Color Code",
          swatchPos:'right',
          pos:'bottom right',
          restrictToFormat:true,
          preserveInputFormat:true,
        }
     }

    //set default color

    $scope.setColorOptions();
    /**
     * get active block method is use for get active dashboard block list.
     * created on 04.04.2018
     */
    $scope.getActiveButtonData=function(){
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/orderpopupbuttons/activebutton')
          .success(function (result) {
            $scope.isloaded = true;
            $scope.buttonOrder=result;
            $scope.updatedButton=result;
          }).error(function (error) {
            $scope.isloaded = true;
              if (error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
    }
    /**
    * block sortable Options.
    * created on 04.04.2018
    */
    $scope.sortableButtonOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedButton = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * save Faq Order is use to save sort order and display faq this order.
    * created on 10.17.2017
    */
    $scope.saveButtonOrder=function(){
      $scope.temp=[];
      angular.forEach($scope.updatedButton,function(value,key){
        $scope.temp.push({'id':value._id,'sort_order':key+1})
      });
      //apiService.loaderShow();
      var bodyData={
        'data':JSON.stringify($scope.temp)
      };
      $http.post($rootScope.baseUrl + '/orderpopupbuttons/bulkupdate',bodyData).success(function (response) {
           //apiService.loaderHide();
           if(response.status=="fail"){
             toastr.error(response.message);
           }else{
             toastr.success(response.message);
             $state.go('settings.order-popup-button');
           }

        }).error(function (error) {
            //apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }

    /**
    * get dynamic enable stickers
    * created on 08.23.2018
    */
    $scope.getStikerEnableType = function () {
       // get order status
       $http.get($rootScope.baseUrl + '/productType/get-sticker-enable-type')
               .success(function (result) {
                   $scope.typeStickerData = result.data;
               }).error(function (error) {
           if (error.data && error.data.code != undefined && error.data.code == 0) {
               toastr.error(error.data.message);
           }
       });
    }

  }

})();

/**
 * Departments controller handle all action related user Department.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 09.26.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('orderPopupEditBtnCtrl', orderPopupEditBtnCtrl);

  /** @ngInject */
  function orderPopupEditBtnCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.26.2017
     */
    if($rootScope.permissionArr.indexOf('edit_button_settings') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.edit-button-settings';
    $scope.resetGlobalSearch();
    /**
     * drag and drop status data.
     * created on 06.19.2018
     */
     $scope.getStatusAndEditBtnData = function() {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
                .success(function (result) {
                  vm.orderStatus = result;
                }).error(function (error) {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    }
                });
            /**
             * get edit button settings status data.
             * created on 06.19.2018
             */
            $scope.setOfSets = [];
            $http.get($rootScope.baseUrl + '/config/setting/save-edit-button')
                    .success(function (result) {
                      if(result.status=='success'){
                        if(result.data && result.data!=undefined){
                          vm.editBtnStatus=result.data;
                        }
                      }else{
                        vm.editBtnStatus=[
                                  {
                                    "name":"Product Name Edit",
                                    "status": []
                                  },
                                  {
                                    "name":"Engraving Edit",
                                    "status": []
                                  },
                                  {
                                    "name":"Product Log",
                                    "status": []
                                  },
                                  {
                                    "name":"Engraving Log",
                                    "status": []
                                  }
                                ];
                      }
                      var half_length = Math.ceil(vm.editBtnStatus.length / 2);
                      var leftArray = vm.editBtnStatus.splice(0,half_length);
                      var rightArray = vm.editBtnStatus.splice(0,vm.editBtnStatus.length);
                      $scope.setOfSets.push(leftArray);
                      $scope.setOfSets.push(rightArray);
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data && error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        }
                    });

    };
    /**
    * Add edit button status data method is use to save order popup edit button status.
    * created on 06.19.2018
    */
    $scope.addEditBtnStatus= function(){
       $scope.temp = [];
       angular.forEach($scope.setOfSets,function(value,key){
         angular.forEach(value,function(val,ke){
           $scope.temp.push(val);
         });
       });
       apiService.loaderShow();
       var bodyData={'settingData':angular.toJson($scope.temp)};
       $http.post($rootScope.baseUrl + '/config/setting/save-edit-button',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('settings.edit-button-settings');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data && error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
     }

    /**
    * remove status data method is use to delete status.
    * created on 06.19.2018
    */
    $scope.removeStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 06.19.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 06.19.2018
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };

  }

})();

/**
 * Order status controller handle all action related order status.
 * @author Jahid Dal <jahid.dal@brainvire.com>
 * created on 10.19.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('orderStatusCtrl', orderStatusCtrl);

  /** @ngInject */
  function orderStatusCtrl($scope, $state, $http, $cookies, $uibModal, $rootScope, $timeout, toastr, DTOptionsBuilder, DTColumnBuilder, $compile, apiService, $q ,DTDefaultOptions) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.22.2017
     */
    if($rootScope.permissionArr.indexOf('orderstatus_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.order-status';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of users.
     * created on 10.19.2017
     */

     $scope.getDataTable = function () {

            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/status')
                        .success(function (result) {
                            if(result.length < $rootScope.numberOfRecord){
                               $timeout(function () {
                                   angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                    vm.users = [];
                    var index = 1;
                    angular.forEach(result, function (value, key) {

                        var changeStatusValTo = '0';
                        var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'orderstatus_edit'+'\') !== -1" href="javascript:void(0);"  ng-click="editOrderStatus(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                        var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'orderstatus_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/orderStatus/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

                        var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                        var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'orderstatus_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/orderStatus/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Inactive"><img src="assets/img/switch-off.png" width="24"/></a>';

                        if (value.is_active == 0) {
                            changeStatusValTo = '1';
                            statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                            statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'orderstatus_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/orderStatus/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                        }

                        var data = {
                            id: value._id,
                            index:index,
                            status_code: value.status_code,
                            status_label: value.status_label,
                            created_at: value.created_at,
                            status: statusBadge,
                            created_by: value.created_by,
                            ip_address: value.role,
                            color_code:value.color_code?value.color_code:'#CA0058',
                            operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                        };
                        this.push(data);
                        index++;
                    }, vm.users);
                    defer.resolve(vm.users);
                }).error(function (error) {
                    var response = error.data;
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
            vm.dtOptions.withOption('fnRowCallback',
                function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                    $scope.$apply($compile(nRow)($scope));
                });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('status_label').withTitle('Order Status Title'),
                DTColumnBuilder.newColumn('status_code').withTitle('Order Status Code'),
                DTColumnBuilder.newColumn('color_code').withTitle('Color Code').renderWith(colorForField).withOption('className', 'text-center'),
                DTColumnBuilder.newColumn('created_at').withTitle('Created Date').withOption('className', 'tableDate').renderWith($scope.getGlobalDateFormat),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if($rootScope.permissionArr.indexOf('orderstatus_edit') !== -1 || $rootScope.permissionArr.indexOf('orderstatus_delete') !== -1 || $rootScope.permissionArr.indexOf('orderstatus_changestatus') !== -1){
              vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        }
    /**
    * Set color for color status fields field.
    * created on 09.21.2017
    */
    function colorForField(data, type, full, meta) {
        return '<span style="background-color:' + data + ';" class="label  font-size-14 margin-inline">' + data  + '</span>';
    }
    $scope.pattern=false;
    $scope.eventApi = {
        onChange:  function(api, color, $event) {
          $scope.orderStatusColorCode = color;
          var regexp = /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/;
          if (!regexp.test(color)) {
            $scope.pattern=true;
          }else{
            $scope.pattern=false;
          }
        },
    };
    /**
     * Save Order status data method is use for update/add order status data.
     * created on 09.21.2017
     */
    $scope.saveOrderStatusData = function() {

      if (!this.orderStatusFrm.orderStatusTitle.$valid) {
        toastr.error("Please enter order status title.");
        angular.element('#orderStatusTitle').focus();
        return;
      } else if (!this.orderStatusFrm.orderStatusCode.$valid) {
        toastr.error("Please enter order status code.");
        angular.element('#orderStatusCode').focus();
        return;
      } else if (!this.orderStatusFrm.orderStatusColorCode.$valid) {
        toastr.error("Please enter order status color code.");
        angular.element('#orderStatusColorCode').focus();
        return;
      } else if (!this.orderStatusFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }else if (!this.orderStatusFrm.orderStatusCategory.$valid) {
        toastr.error("Please select order status category.");
        return;
      }
      apiService.loaderShow();
      var bodyData = {
        status_label: this.orderStatusTitle,
        status_code: this.orderStatusCode,
        color_code: this.orderStatusColorCode,
        is_default: 1,
        is_active: this.status,
        affected_by: $rootScope.globals.currentUser.id,
        ip_address:'121212',
        block:this.orderStatusCategory
      };

      $scope.saveUrl = $rootScope.baseUrl + '/status';
      $scope.httpMethod = 'POST';
      $scope.orderStatusId = this.orderStatusId;
      if (this.orderStatusId) {
        $scope.saveUrl = $rootScope.baseUrl + '/status/' + this.orderStatusId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else if (response.status == 'success') {
          toastr.success('Order status ' + ($scope.orderStatusId ? 'updated' : 'Added') + ' successfully.');
          $state.go('settings.order-status');
        } else {
          toastr.error("Invalid order status.");
          $state.go('settings.order-status');
        }

      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          $state.go('settings.order-status');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Add order status method is use for get add order status form.
     * created on 09.21.2017
     */
    $scope.addOrderStatus = function() {
      $cookies.put('order-status-id',undefined);
      $state.go('settings.add-order-status');
    }

    /**
     * Edit user method is use for get edit user form.
     * created on 09.15.2017
     */
    $scope.editOrderStatus = function(id) {
      $cookies.put('order-status-id',id);
      $state.go('settings.edit-order-status');
    }

    /**
     * Open model.
     * created on 09.15.2017
     */
    $scope.open = function(page, id, status) {
      $rootScope.statusId = id;
      $rootScope.status = status;

      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
        resolve: {
          items: function() {
            return $scope.items;
          }
        }
      });
    };

    /**
     * Change status method is use for change status of order status.
     * created on 09.21.2017
     */
    $scope.changeStatus = function() {
      if ($rootScope.statusId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.statusId,
          is_active:  ""+$rootScope.status+"",
          updated_by:$rootScope.globals.currentUser.id
        };
        $http.post($rootScope.baseUrl + '/status/changestatus', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.order-status');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete order status method is use for delete order status.
     * created on 09.21.2017
     */
    $scope.deleteOrderStatus = function() {
      if ($rootScope.statusId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/status/' + $rootScope.statusId)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Order status deleted successfully.');
              $state.go($state.$current, null, {
                reload: true
              });;
            } else {
              $state.go('settings.order-status');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
      }
      $scope.popupShow.close();
    };

    /**
     * Get edited order status method is use for get edited order status.
     * created on 09.19.2017
     */
    $scope.getEditedOrderStatus = function() {

      if($rootScope.permissionArr.indexOf('orderstatus_add') == -1 && $rootScope.permissionArr.indexOf('orderstatus_edit') == -1){
        $state.go('dashboard');
        toastr.error("You don't have permission to do this.");
      }
      $scope.orderStatusColorCode = '#CA0058';
      if ($cookies.get('order-status-id') && $cookies.get('order-status-id')!= undefined) {
        apiService.loaderShow();
        var vm = this;
        $http.get($rootScope.baseUrl + '/status/' + $cookies.get('order-status-id'))
          .success(function(response) {
            vm.orderStatusId = response._id;
            vm.orderStatusTitle = response.status_label;
            vm.orderStatusCategory = response.block?response.block:'';
            $timeout(function() {
                 $scope.setColorOptions();
                 vm.orderStatusCode = response.status_code;
            }, 200);
            vm.orderStatusColorCode = response.color_code;
            vm.status = response.is_active;
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
            $state.go('settings.add-order-status');
          });
      } else {
        $state.go('settings.add-order-status');
      }
    };

    /**
     * Set color options method is use set color picker default options.
     * created on 10.19.2017
     */
    $scope.setColorOptions = function () {
       $scope.options = {
          required:true,
          inputClass: 'form-control',
          format:'hexString',
          id: 'orderStatusColorCode',
          name: 'orderStatusColorCode',
          placeholder:"Order Status Color Code",
          swatchPos:'right',
          pos:'bottom right',
          restrictToFormat:true,
          preserveInputFormat:true,
        }
     }

    //set default color

    $scope.setColorOptions();
  }

})();

/**
 * Pie controller handle all action related Pie configuration.
 * @author Anand Malvi <anand.malvi@brainvire.com>
 * created on 18.02.2019
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.settings')
            .controller('pieChartCtrl', pieChartCtrl);

    /** @ngInject */
    function pieChartCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

        $rootScope.isPieModified = true;
        /**
         * permissionArr is use to check permission to display list
         * created on 05.04.2018
         */
        if ($rootScope.permissionArr.indexOf('pie_chart_setting') == -1) {
            $state.go('dashboard');
            toastr.error("You don't have permission to do this.");
        }
        var vm = this;
        $rootScope.currentState = 'settings.pie-chart';
        $scope.resetGlobalSearch();

        /**
         * Add pie method is use for get add Pie page.
         */
        $scope.addPie = function () {
            $cookies.put('pie-chart-id', undefined);
            $state.go('settings.add-pie');
        }

        /**
         * Get edited pie method is use for get edited pie data.
         */
        $scope.getEditedPie = function () {
            if ($rootScope.permissionArr.indexOf('add_pie_chart') == -1 && $rootScope.permissionArr.indexOf('edit_pie_chart') == -1) {
                $state.go('dashboard');
                toastr.error("You don't have permission to do this.");
            }
            if ($cookies.get('pie-chart-id') && $cookies.get('pie-chart-id') != undefined) {
                apiService.loaderShow();
                $http.get($rootScope.baseUrl + '/pie/show/' + $cookies.get('pie-chart-id'))
                        .success(function (response) {
                            apiService.loaderHide();
                            vm.pieChartLabel = response.name;
                            vm.status = response.status;
                            vm.dashboardBlock = response.dashboard_block;
                            vm.orderStatus = response.closing_status;
                            vm.stickertype = response.sticker_type;
                            vm.createSticker = response.create_sticker == 'true' ? true : false;
                            vm.pieId = response._id;
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                $state.go('settings.add-pie');
            }
        };
        
        /**
         * Get all dashboard blocks
         */
        $scope.getDashboardBlocks = function () {
            vm.dashboardBlocksList = [];
            $http.get($rootScope.baseUrl + '/dashboardblocks')
                    .success(function (result) {
                        vm.dashboardBlocksList = result;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

        /**
         * get active status data.
         */
        $scope.getActiveStatusData = function () {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
                    .success(function (result) {
                        vm.orderStatusList = result;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

        /**
         * get dynamic enable stickers
         * created on 08.23.2018
         */
        $scope.getStikerEnableType = function () {
            // get order status
            $http.get($rootScope.baseUrl + '/productType/get-sticker-enable-type')
                    .success(function (result) {
                        vm.enableStckerType = result.data;
                    }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

        /**
         * Save pie data method is use for update/add pie data.
         * created on 05.04.2018
         */
        $scope.savePieData = function () {
            $rootScope.isPieModified = true;
            if (!this.pieChartFrm.pieChartLabel.$valid) {
                toastr.error("Please enter pie label.");
                angular.element('#pieChartLabel').focus();
                return;
            } else if (!this.pieChartFrm.status.$valid) {
                toastr.error("Please select status.");
                return;
            }
            apiService.loaderShow();
            var bodyData = {
                name: vm.pieChartLabel,
                status: vm.status,
                dashboard_block: vm.dashboardBlock,
                closing_status: vm.orderStatus,
                sticker_type: vm.stickertype,
                create_sticker: vm.createSticker,
                affected_by: $rootScope.globals.currentUser.id,
            };
            $scope.saveUrl = $rootScope.baseUrl + '/pie/create';
            $scope.httpMethod = 'POST';
            if (vm.pieId) {
                $scope.saveUrl = $rootScope.baseUrl + '/pie/update/' + vm.pieId;
                $scope.httpMethod = 'PUT';
            }
            $http({
                url: $scope.saveUrl,
                method: $scope.httpMethod,
                data: $scope.dataUrlEncode(bodyData),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            }).then(function (response) {
                apiService.loaderHide();
                var response = response.data;
                if (response.code != undefined && response.code == 0 || response.status == "fail") {
                    toastr.error(response.message);
                } else if (response.status == 'success') {
                    toastr.success('Pie ' + (vm.pieId ? 'updated' : 'added') + ' successfully.');
                    $state.go('settings.pie-chart');
                }
            }, function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    if (error.data.message == 'This pie name already exists.') {
                        toastr.error('This pie label already exists.');
                        angular.element('#pieChartLabel').focus();
                    } else {
                        toastr.error(error.data.message);
                    }
                } else {
                    $state.go('settings.pie-chart');
                    toastr.error("Something went wrong please try again.");
                }
            });
        }

        /**
         * Delete pie
         */
        $scope.deletePie = function () {
            $rootScope.isPieModified = true;
            if ($rootScope.deleteId) {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/pie/delete/' + $rootScope.deleteId)
                        .success(function (result) {
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                toastr.success('Pie deleted successfully.');
                                $state.go($state.$current, null, {
                                    reload: true
                                });
                            }
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };
        
        /**
         * Change status of Pie
         */
        $scope.changeStatus = function () {
            $rootScope.isPieModified = true;
            if ($rootScope.deleteId) {
                apiService.loaderShow();
                var bodyData = {
                    id: $rootScope.deleteId,
                    status: "" + $rootScope.status + "",
                };
                $http.put($rootScope.baseUrl + '/pie/change-status', bodyData)
                        .success(function (result) {
                            apiService.loaderHide();
                            if (result.status == 'success') {
                                toastr.success('Status updated successfully.');
                                $state.go($state.$current, null, {
                                    reload: true
                                });
                            }
                            if (result.status == 'fail') {
                                toastr.error(result.message);
                            }
                        }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                $scope.popupShow.close();
            }
        };
        
        /**
         * Edit pie method is use for get edit pie page.
         */
        $scope.editPie = function (id) {
            $cookies.put('pie-chart-id', id);
            $state.go('settings.edit-pie');
        }

        /**
         * Open model.
         */
        $scope.open = function (page, id, status) {
            $rootScope.deleteId = id;
            $rootScope.status = status;
            $scope.popupShow = $uibModal.open({
                animation: true,
                templateUrl: page,
                scope: $scope,
            });
        };

        /**
         * Get data table method is use get list of pie.
         * created on 05.04.2018
         */
        $scope.getDataTable = function () {
            var vm = this;
            vm.dtOptions = DTOptionsBuilder.fromFnPromise(function () {
                var defer = $q.defer();
                $http.get($rootScope.baseUrl + '/pie/index')
                        .success(function (result) {
                            if (result.length < $rootScope.numberOfRecord) {
                                $timeout(function () {
                                    angular.element('.dataTables_paginate').hide();
                                }, 200);
                            }
                            vm.pieList = [];
                            var index = 1;
                            angular.forEach(result, function (value, key) {
                                var changeStatusValTo = '0';
                                var editLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'edit_pie_chart' + '\') !== -1" href="javascript:void(0);"   ng-click="editPie(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
                                var deleteLinks = '  <a ng-if="permissionArr.indexOf(\'' + 'delete_pie_chart' + '\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/pieChart/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

                                var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
                                var statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_pie_chart' + '\') !== -1" ng-click="open(\'' + 'app/pages/settings/pieChart/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

                                if (value.status == 0) {
                                    changeStatusValTo = '1';
                                    statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                                    statusLinks = ' <a ng-if="permissionArr.indexOf(\'' + 'change_status_pie_chart' + '\') !== -1" ng-click="open(\'' + 'app/pages/settings/pieChart/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
                                }

                                var data = {
                                    id: value._id,
                                    name: value.name,
                                    dashboard_block: value.dashboard_block,
                                    closing_status: value.closing_status_label,
                                    index: index,
                                    updated_at: value.updated_at,
                                    status: statusBadge,
                                    operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
                                };
                                this.push(data);
                                ++index;
                            }, vm.pieList);
                            defer.resolve(vm.pieList);
                        }).error(function (error) {
                    if (error.data && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
                return defer.promise;
            }).withPaginationType('simple_numbers')
            vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord - 1));
            vm.dtOptions.withOption('fnRowCallback',
                    function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                        $scope.$apply($compile(nRow)($scope));
                    });
            vm.dtOptions.withOption('sDom', $rootScope.dom);
            vm.dtOptions.withOption('initComplete', function () {
                angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
                angular.element('.dataTables_filter input').attr('class', 'form-control');
                angular.element('.dataTables_length select').attr('class', 'form-control');
            });
            vm.dtOptions.withOption('oLanguage', {"sSearch": "", 'sInfoFiltered': '(filtered from _MAX_ total entries)'});
            vm.dtColumns = [
                DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
                DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
                DTColumnBuilder.newColumn('name').withTitle('Pie Label'),
                DTColumnBuilder.newColumn('dashboard_block').withTitle('Dashboard Block'),
                DTColumnBuilder.newColumn('closing_status').withTitle('Closing Status'),
                DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
            ];
            if ($rootScope.permissionArr.indexOf('edit_pie_chart') !== -1 || $rootScope.permissionArr.indexOf('delete_pie_chart') !== -1 || $rootScope.permissionArr.indexOf('change_status_pie_chart') !== -1) {
                vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
            }
        }
    }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('previewSettingCtrl', previewSettingCtrl);

  /** @ngInject */
  function previewSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout)
  {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.09.2019
    */
    if ($rootScope.permissionArr.indexOf('preview_setting') == -1)
    {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }

    var vm = this;
    $rootScope.currentState = 'settings.preview-setting';
    
    $scope.orderStatus = [];
    $scope.getActiveStatus = function()
    {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    $scope.getPreviewSettingData = function ()
    {
      var vm = this;
      $http.get($rootScope.baseUrl + '/config/preview/setting')
      .success(function (response) {
        if(response.status == 'success'){
          var result = response.data.data;
          $scope.orderStatusRequestPreview = result.orderStatusRequestPreview;
          $scope.orderStatusAfterPreview = result.orderStatusAfterPreview;
          $scope.orderStatusAfterApprove = result.orderStatusAfterApprove;
          $scope.orderStatusAfterReject = result.orderStatusAfterReject;
        }else{
          toastr.error(result.message);
        }
          $scope.isloaded = true;
      }).error(function (error) {
        if (error && error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }

    $scope.savePreviewSettings = function ()
    {
      var vm = this;
      if (!this.previewSettingFrm.orderStatusRequestPreview.$valid) {
          toastr.error("Please select status");
          angular.element('#orderStatusRequestPreview').focus();
          return;
      }
      else if (!this.previewSettingFrm.orderStatusAfterPreview.$valid) {
          toastr.error("Please select status");
          angular.element('#orderStatusAfterPreview').focus();
          return;
      }
      else if (!this.previewSettingFrm.orderStatusAfterApprove.$valid) {
          toastr.error("Please select status");
          angular.element('#orderStatusAfterApprove').focus();
          return;
      }
      else if (!this.previewSettingFrm.orderStatusAfterReject.$valid) {
          toastr.error("Please select status");
          angular.element('#orderStatusAfterReject').focus();
          return;
      }
      apiService.loaderShow();
      
      $scope.previewSettingData = {
          'orderStatusRequestPreview': vm.orderStatusRequestPreview,
          'orderStatusAfterPreview': vm.orderStatusAfterPreview,
          'orderStatusAfterApprove': vm.orderStatusAfterApprove,
          'orderStatusAfterReject': vm.orderStatusAfterReject
      };

      var bodyData = {
          type: 'preview-setting',
          preview_setting: angular.toJson($scope.previewSettingData),
          affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/preview-setting', bodyData)
      .success(function (response)
      {
        apiService.loaderHide();
          if (response.status == 'success') {
            toastr.success('Settings save successfully.');
          } else {
              toastr.error("Something went wrong please try again.");
          }
      }).error(function (error) {
          apiService.loaderHide();
          if (error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
          } else {
              toastr.error("Something went wrong please try again.");
          }
      });
    }
 } 
})();

/**
 * printLabels controller handle all action related printLabels configuration.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.25.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('printLabelsCtrl', printLabelsCtrl);

  /** @ngInject */
  function printLabelsCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 10.25.2017
     */
    if($rootScope.permissionArr.indexOf('print_label_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.print-labels';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of printLabels.
     * created on 10.25.2017
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/printlabels')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.printLabels = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'print_label_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editPrintLabel(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'print_label_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/printLabels/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'print_label_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/printLabels/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'print_label_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/printLabels/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              label_name: value.label_name,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks //+ '&nbsp;' + departmentStatusLinks
              };
            this.push(data);
            ++index;
          }, vm.printLabels);
          defer.resolve(vm.printLabels);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('label_name').withTitle('Print Label'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('print_label_edit') !== -1 || $rootScope.permissionArr.indexOf('print_label_delete') !== -1 || $rootScope.permissionArr.indexOf('print_label_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add printLabel method is use for get add department page.
     * created on 10.25.2017
     */
    $scope.addPrintLabel = function() {
      $cookies.put('print-label-id',undefined);
      $state.go('settings.add-print-label');
    }

    /**
     * Edit printLabel method is use for get edit printLabel page.
     * created on 10.25.2017
     */
    $scope.editPrintLabel = function(id) {
      $cookies.put('print-label-id',id);
      $state.go('settings.edit-print-label');
    }

    /**
     * Open model.
     * created on 10.25.2017
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of print label.
     * created on 10.25.2017
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/printlabels', bodyData)
          .success(function(result) {
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.print-labels');
              toastr.error("Something went wrong please try again.");
            }
            apiService.loaderHide();
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete print label method is use for delete print label.
     * created on 10.25.2017
     */
    $scope.deletePrintLabel = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/printlabels/' + $rootScope.deleteId)
                .success(function(result) {
          if (result.status == 'success') {
            toastr.success('Print label deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
            apiService.loaderHide();
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save print label data method is use for update/add print label data.
     * created on 10.25.2017
     */
    $scope.savePrintLabelData = function() {
      var vm = this;
       if (!this.printlabelFrm.printLabel.$valid) {
        toastr.error("Please enter print label.");
        angular.element('#printLabel').focus();
        return;
      }else if (!this.printlabelFrm.printLabelValue.$valid) {
       toastr.error("Please enter print label value.");
       angular.element('#printLabelValue').focus();
       return;
     }else if (!this.printlabelFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }
       apiService.loaderShow();
      var bodyData = {
        label_name: this.printLabel,
        label_code:this.printLabelValue,
        status: this.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/printlabels';
      $scope.httpMethod = 'POST';
      $scope.printLabelId = this.printLabelId;
      if (this.printLabelId) {
        $scope.saveUrl = $rootScope.baseUrl + '/printlabels/' + this.printLabelId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Print label ' + ($scope.printLabelId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.print-labels');
        } else {
          $state.go('settings.print-labels');
          toastr.error("Something went wrong please try again.");
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This print label already exists.');
                angular.element('#printLabel').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.print-labels');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited Print label method is use for get edited Print label data.
     * created on 10.25.2017
     */
    $scope.getEditedPrintLabel = function() {

        if($rootScope.permissionArr.indexOf('print_label_add') == -1 && $rootScope.permissionArr.indexOf('print_label_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('print-label-id') && $cookies.get('print-label-id')!= undefined) {
          apiService.loaderShow();
          var vm = this;
          $http.get($rootScope.baseUrl + '/printlabels/' + $cookies.get('print-label-id'))
            .success(function(response) {
              vm.printLabel = response.label_name;
              vm.printLabelValue=response.label_code;
              vm.printLabelId = response._id;
              vm.status = response.status;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-print-label');
        }
    };

  }

})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('reportLabelCtrl', reportLabelCtrl);

  /** @ngInject */
  function reportLabelCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 04.30.2018
     */
    if($rootScope.permissionArr.indexOf('report_label_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.create-product';
    $scope.resetGlobalSearch();
    $scope.availableSKU=[];
    $scope.productTitle="Add Product";
    //$scope.fontList=['Aharoni','Algerian','Arial','Arial Black','Britannic Bold','Bookman','Calibri','Courier','Courier New','Comic Sans MS','David','Elephant','Footlight MT Light','Georgia','Garamond','Helvetica','Impact','Times New Roman','Times','Trebuchet MS','Verdana'];
    $scope.fontList=['Arial', 'Times New Roman', 'English 111 Vivace BT', 'Georgia', 'Monotype Corsiva', 'Script MT Bold'];
    //$scope.sizeList=[4,6,8,9,10,11,12,14,16,18,20,22,24,26,28,36,48,72];
    vm.orientationList=[];
    vm.isOrientation=true;
    vm.alignment='center';
    vm.bold=false;
    vm.italic=false;
    vm.mirror=false;
    vm.basicSettings=true;
    vm.sendBasicSettings=false;
    vm.textSettings=true;
    vm.sendTextSettings=false;
    vm.isRelayUpload=false;
    vm.relaypersons = 0;
    $scope.wareHouses=[];
    vm.storeWareHouses=[];
    vm.addqty = '';
    vm.addbox = '';
    vm.addnote = '';
    vm.addsqty = '';
    $scope.menuStatus = [{
      isOpen: true
    }];

    /**
     * Get data table method is use get list of reportLabel.
     * created on 04.30.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/reportsettingslabel')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.reportLabel = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'report_label_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editReportLabel(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'report_label_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/product/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'report_label_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/product/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'report_label_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/product/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              name: value.name,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.reportLabel);
          defer.resolve(vm.reportLabel);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Product Label'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('report_label_edit') !== -1 || $rootScope.permissionArr.indexOf('report_label_delete') !== -1 || $rootScope.permissionArr.indexOf('report_label_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add report Label method is use for get add report label page.
     * created on 04.30.2018
     */
    $scope.addReportLabel = function() {
      $cookies.put('report-label-id',undefined);
      $state.go('settings.add-product');
    }

    /**
     * Edit report Label method is use for get edit Report Label page.
     * created on 04.30.2018
     */
    $scope.editReportLabel = function(id) {
      $cookies.put('report-label-id',id);
      $state.go('settings.edit-product');
    }

    /**
     * Open model.
     * created on 04.30.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of report label.
     * created on 04.30.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/reportsettingslabel', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete report label method is use for delete report label.
     * created on 04.30.2018
     */
    $scope.deleteReportLabel = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/reportsettingslabel/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Product deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };
    /**
     * Get edited Report label method is use for get edited Report label data.
     * created on 04.30.2018
     */
    $scope.getEditedReportLabel = function() {
        vm.stores_relay = [];
        vm.store_costs = [];
        if($rootScope.permissionArr.indexOf('report_label_add') == -1 && $rootScope.permissionArr.indexOf('report_label_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('report-label-id') && $cookies.get('report-label-id')!= undefined) {
          $scope.productTitle="Edit Product";
          //apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/reportsettingslabel/' + $cookies.get('report-label-id'))
            .success(function(response) {
              //apiService.loaderHide();
              vm.reportLabel = response.name;
              vm.SKU=JSON.parse(response.sku);
              vm.reportLabelId = response._id;
              vm.status = response.status;
              vm.weight = response.weight;
              vm.cost = response.cost;
              vm.length = response.length;
              vm.width = response.width;
              vm.height = response.height;
              vm.basicSettings=response.default_basic_settings=='true'?true:false;
              vm.sendBasicSettings=response.send_default_basic_settings=='true'?true:false;
              vm.textSettings=response.default_text_settings=='true'?true:false;
              vm.sendTextSettings=response.send_default_text_settings=='true'?true:false;
              vm.isOrientation=response.orientation=='true'?true:false;
              vm.isRelayUpload=response.is_relay_upload=='true'?true:false;
              vm.relaypersons = response.relaypersons;
            }).error(function (error) {
                //apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $http.get($rootScope.baseUrl + '/reportsettingslabel/warehouses/' + $cookies.get('report-label-id'))
            .success(function(response) {
              $scope.wareHouses = response;
            }).error(function (error) {
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $http.get($rootScope.baseUrl + '/reportsettingslabel/store-cost/' + $cookies.get('report-label-id'))
            .success(function(response) {
              if(response.status == 'success') {
                vm.store_costs = response.store_costs;
              }
            }).error(function (error) {
              if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
            $http.get($rootScope.baseUrl + '/reportsettingslabel/store-relay/' + $cookies.get('report-label-id'))
            .success(function(response) {
              if(response.status == 'success') {
                vm.stores_relay = response.stores_relay;
              }
            }).error(function (error) {
              if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
        } else {
          $state.go('settings.add-product');
        }
    };

    $scope.refreshWarehouses = function()
    {
      if ($cookies.get('report-label-id') && $cookies.get('report-label-id')!= undefined)
      {
        $scope.wareHouses = [];
        $http.get($rootScope.baseUrl + '/reportsettingslabel/warehouses/' + $cookies.get('report-label-id'))
        .success(function(response) {
          $scope.wareHouses = response;
        }).error(function (error)
        {
          if (error.data && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
      }
    }

    $scope.AddStock = function (id,whid)
    {
      $scope.WareHouseProductId = id;
      $scope.WareHouseId = whid;
      $scope.addqty = '';
      $scope.addbox = '';
      $scope.addnote = '';
      $scope.addsqty = '';
      
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/settings/product/addWarehouseStock.html',
        scope: $scope,
      });
    };

    $scope.RemoveStock = function (id)
    {
      $scope.WareHouseProductId = id;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/settings/product/removeWarehouseStock.html',
        scope: $scope,
      });
    };

    $scope.saveWareHouseProduct = function ()
    {
      if (!this.WarehouseProductFrm.$valid) {
        toastr.error("Please enter required fileds");
        angular.element('#addqty').focus();
        return;
      }
      if (!this.WarehouseProductFrm.addqty.$valid) {
        toastr.error("Please enter qty grater than 0.");
        angular.element('#addqty').focus();
        return;
      }

      apiService.loaderShow();
        var bodyData = {
          pid: $cookies.get('report-label-id'),
          whpid: $scope.WareHouseProductId,
          whid: $scope.WareHouseId,
          qty: this.addqty,
          box: this.addbox!=''?this.addbox:0,
          totalqty: this.addsqty,
          note: this.addnote,
          affected_by: $rootScope.globals.currentUser.id,
        };

      $scope.saveUrl = $rootScope.baseUrl + '/reportsettingslabel/addwarehousestock';
      $scope.httpMethod = 'POST';
      $http({
          url: $scope.saveUrl,
          method: $scope.httpMethod,
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          apiService.loaderHide();
          var response = response.data;
          if (response.code!= undefined && response.code == 0) {
            toastr.error(response.message);
          }else  if (response.status == 'success') {
            toastr.success(response.message);
            window.location.reload();
          } else {
            toastr.success(response.message);
          }
        }, function(error) {
          apiService.loaderHide();
          if (error.data.code!= undefined && error.data.code == 0) {
              toastr.error(error.data.message);
          } else {
            $state.go('settings.create-product');
            toastr.error("Something went wrong please try again.");
          }
        });
    };

    $scope.removeWareHouseProduct = function ()
    {
      if (!this.WarehouseProductFrm.$valid) {
        toastr.error("Please enter required fileds");
        angular.element('#addqty').focus();
        return;
      }
      if (!this.WarehouseProductFrm.removeQty.$valid) {
        toastr.error("Please enter qty grater than 0.");
        angular.element('#removeQty').focus();
        return;
      }

      apiService.loaderShow();
      var bodyData = {
        pid: $cookies.get('report-label-id'),
        whpid: $scope.WareHouseProductId,
        qty: this.removeQty,
        box: this.removebox!=''?this.removebox:0,
        totalqty: this.removesqty,
        note: this.addnote,
        affected_by: $rootScope.globals.currentUser.id,
      };

      $scope.saveUrl = $rootScope.baseUrl + '/reportsettingslabel/removewarehousestock';
      $scope.httpMethod = 'POST';
      $http({
          url: $scope.saveUrl,
          method: $scope.httpMethod,
          data: $scope.dataUrlEncode(bodyData),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(function(response) {
          apiService.loaderHide();
          var response = response.data;
          if (response.code!= undefined && response.code == 0) {
            toastr.error(response.message);
          }else  if (response.status == 'success') {
            toastr.success(response.message);
            window.location.reload();
          } else {
            toastr.success(response.message);
          }
        }, function(error) {
          apiService.loaderHide();
          if (error.data.code!= undefined && error.data.code == 0) {
              toastr.error(error.data.message);
          } else {
            $state.go('settings.create-product');
            toastr.error("Something went wrong please try again.");
          }
        });
    };

    $scope.moveStock = function (whpid,whid)
    {
      if ($cookies.get('report-label-id') && $cookies.get('report-label-id')!= undefined)
      {
        $scope.WareHouseProductId = whpid;
          $scope.WareHouseId = whid;
          $scope.productId = $cookies.get('report-label-id');

          $scope.firstWareHouses = [];
          $scope.secondWareHouses = [];
          $scope.psku = '';
          $scope.pname = '';
          $scope.astock = 0;
          $scope.addqty = '';
          $scope.addbox = '';
          $scope.addsqty = '';
          $scope.addnote = '';
          $scope.fWareHouse = '';
          $scope.sWareHouse = '';

          apiService.loaderShow();
          var bodyData = {
            pid: $cookies.get('report-label-id'),
            whpid: whpid,
            whid: whid
          };

          $scope.saveUrl = $rootScope.baseUrl + '/warehouse/active-store-warehouse';
          $scope.httpMethod = 'POST';
          $http(
          {
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response)
            {
              apiService.loaderHide();
              var response = response.data;
              if (response.status == 'success')
              {
                $scope.fWareHouse = response.warehouse_id;
                $scope.psku = response.product_sku;
                $scope.pname = response.product_name;
                $scope.astock = response.available_stock;
                $scope.firstWareHouses = response.from_warehouse;
                $scope.secondWareHouses = response.to_warehouses;
              }
              else {
                toastr.error(response.message);
              }
          }, function(error)
          {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
              toastr.error(error.data.message);
            } else {
              toastr.error("Something went wrong please try again.");
            }
          });
          $scope.popupShow = $uibModal.open({
            animation: true,
            templateUrl: 'app/pages/inventoryManagement/wareHouse/moveWarehouseStock.html',
            scope: $scope,
          });
      }
    };

    $scope.openLogHistory = function (id)
    {
      $scope.stockLogsArr = [];
      $http.get($rootScope.baseUrl + '/reportsettingslabel/warehouse-stock/' + id)
        .success(function(response) {
          $scope.stockLogsArr = response;
        }).error(function (error)
        {
          if (error.data && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
      $('#wareHouseLogsModel').modal();
    };

    $scope.closeLogHistory = function ()
    {
      $scope.stockLogsArr = [];

      $('#wareHouseLogsModel').modal('hide');
    };

    $scope.dismiss = function() {
        $scope.refreshWarehouses();
    };

    $scope.changedefault = function(index,stid,val)
    {
      var store_costs = [];
      angular.forEach(vm.store_costs, function(value, key)
      {
        if(key == index) {
          value.default_value = val;
        }
      }, store_costs);
    };

    $scope.changedefaultrelay = function(index,stid,val)
    {
      var stores_relay = [];
      angular.forEach(vm.stores_relay, function(value, key)
      {
        if(key == index)
        {
          if(val == true) {
            value.is_relay_upload = false;
            value.express_disbale = false;
          }
          else {
            value.is_relay_upload = true;
            value.express_relay_upload = false;
            value.express_disbale = true;
          }
        }
      }, stores_relay);
    };

    $scope.changeExpressRelay = function(index,stid,val)
    {
      var stores_relay = [];
      angular.forEach(vm.stores_relay, function(value, key)
      {
        if(key == index)
        {
          if(val == true) {
            value.express_relay_upload = false;
          }
          else {
            value.express_relay_upload = true;
          }
        }
      }, stores_relay);
    };
    

    $scope.getProductGeneralSettings = function() {
        if ($cookies.get('report-label-id') && $cookies.get('report-label-id')!= undefined) {
          $http.get($rootScope.baseUrl + '/reportsettingslabel/' + $cookies.get('report-label-id'))
            .success(function(response) {
              if(response.data){
                var responseData=angular.fromJson(response.data);
                if(vm.isOrientation==false){
                  vm.method=responseData.without_orientation.method;
                  vm.presetId=responseData.without_orientation.preset_id;
                }else{
                  vm.orientationList=responseData.with_orientation;
                }
                if(vm.basicSettings==false){
                  var basicSetting=responseData.basic_settings;
                  vm.distanceXY=basicSetting.distance_xy;
                  vm.distanceLayer=basicSetting.distance_layer;
                  vm.layerQuantity=basicSetting.layer_quantity;
                  vm.brightnessMultiplicator=basicSetting.brightness_multiplicator;
                  vm.gainMultiplicator=basicSetting.gain_multiplicator;
                  vm.brightness=basicSetting.brightness;
                  vm.gain=basicSetting.gain;
                  vm.sharpness=basicSetting.sharpness;
                }
                if(vm.textSettings==false){
                  var textSetting=responseData.text_settings;
                  vm.contour=textSetting.additional_layers.contour;
                  vm.cover=textSetting.additional_layers.cover;
                  vm.font=textSetting.font;
                  vm.size=textSetting.size;
                  vm.alignment=textSetting.alignment;
                  vm.rotateZ=textSetting.rotate_z;
                  vm.bold=textSetting.bold;
                  vm.italic=textSetting.italic;
                  vm.mirror=textSetting.mirror;
                }
              }
            }).error(function (error) {
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
    };
    $scope.$watch('vm.isOrientation', function (value) {
          $scope.getProductGeneralSettings();
    });
    $scope.$watch('vm.basicSettings', function (value) {
        if (value == true) {
            $scope.getRelayDefaultSettings();
        }else{
            $scope.getProductGeneralSettings();
        }
    });
    $scope.$watch('vm.textSettings', function (value) {
        if (value == true) {
            $scope.getRelayDefaultSettings();
        }else{
            $scope.getProductGeneralSettings();
        }
    });
    /**
     * get Relay Setting Data method is use to display Relay Setting data.
     * created on 09.30.2018
     */
    $scope.getRelayDefaultSettings = function() {
        $http.get($rootScope.baseUrl + '/config/relaySetting')
          .success(function(result) {
            if (result) {
              if (result.status == 'fail') {
                //toastr.error(result.message);
              } else {
                if (result.data) {
                  var resultData=result.data;
                  if(resultData.general_settings){
                    var basicSetting=resultData.general_settings.basic_settings;
                    vm.distanceXY=basicSetting.distance_xy;
                    vm.distanceLayer=basicSetting.distance_layer;
                    vm.layerQuantity=basicSetting.layer_quantity;
                    vm.brightnessMultiplicator=basicSetting.brightness_multiplicator;
                    vm.gainMultiplicator=basicSetting.gain_multiplicator;
                    vm.brightness=basicSetting.brightness;
                    vm.gain=basicSetting.gain;
                    vm.sharpness=basicSetting.sharpness;
                    var textSetting=resultData.general_settings.text_settings;
                    vm.contour=textSetting.additional_layers.contour;
                    vm.cover=textSetting.additional_layers.cover;
                    vm.font=textSetting.font;
                    vm.size=textSetting.size;
                    vm.alignment=textSetting.alignment;
                    vm.rotateZ=textSetting.rotate_z;
                    vm.bold=textSetting.bold;
                    vm.italic=textSetting.italic;
                    vm.mirror=textSetting.mirror;
                  }
                }
              }
            }
          }).error(function(error) {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
    }
    $scope.addItem = function() {
      $scope.inserted = {
        orientation: '',
        method: '',
        preset_id:null
      };
      vm.orientationList.push($scope.inserted);
    };

    $scope.confirmDelete = function(id) {
      $rootScope.itemId = id;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/settings/product/deleteItemModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined) {
          vm.orientationList.splice($rootScope.itemId, 1);
      }
      $scope.popupShow.close();
    };
    /**
     * Save report label data method is use for update/add report label data.
     * created on 04.30.2018
     */
    $scope.saveReportLabelData = function() {
       if (!this.reportLabelFrm.$valid) {
        return;
      }
      $scope.generalSettings={
        'with_orientation':vm.isOrientation==true?vm.orientationList:[],
        'without_orientation':vm.isOrientation==false?{'method':vm.method,'preset_id':vm.presetId}:'',
        'basic_settings':{
          'distance_xy':vm.distanceXY,
          'distance_layer':vm.distanceLayer,
          'layer_quantity':vm.layerQuantity,
          'brightness_multiplicator':vm.brightnessMultiplicator,
          'gain_multiplicator':vm.gainMultiplicator,
          'brightness':vm.brightness,
          'gain':vm.gain,
          'sharpness':vm.sharpness
        },
        'text_settings':{
          'additional_layers':{'contour':vm.contour,'cover':vm.cover},
          'font':vm.font,
          'size':vm.size,
          'alignment':vm.alignment,
          'rotate_z':vm.rotateZ,
          'bold':vm.bold,
          'italic':vm.italic,
          'mirror':vm.mirror
        }
      };
      $scope.storeSettings={
        'store_costs':vm.store_costs
      };
      $scope.storeRelaySettings={
        'stores_relay':vm.stores_relay
      };

      apiService.loaderShow();
      var bodyData = {
        name: vm.reportLabel,
        sku:JSON.stringify(vm.SKU),
        status: vm.status,
        default_basic_settings:vm.basicSettings,
        send_default_basic_settings:vm.sendBasicSettings,
        default_text_settings:vm.textSettings,
        send_default_text_settings:vm.sendTextSettings,
        orientation:vm.isOrientation,
        is_relay_upload:vm.isRelayUpload,
        data:angular.toJson($scope.generalSettings),
        affected_by: $rootScope.globals.currentUser.id,
        weight: vm.weight,
        cost: vm.cost,
        length: vm.length,
        width: vm.width,
        height: vm.height,
        store_costs:angular.toJson($scope.storeSettings),
        stores_relay:angular.toJson($scope.storeRelaySettings),
        relaypersons: vm.relaypersons
      };
      $scope.saveUrl = $rootScope.baseUrl + '/reportsettingslabel';
      $scope.httpMethod = 'POST';
      if (vm.reportLabelId) {
        $scope.saveUrl = $rootScope.baseUrl + '/reportsettingslabel/' + vm.reportLabelId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0) {
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Product ' + (vm.reportLabelId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.create-product');
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This product label name already exists.');
                angular.element('#reportLabel').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.create-product');
          toastr.error("Something went wrong please try again.");
        }
      });

    }
  }

})();

/**
 * productRule controller handle all action related productRule configuration.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 08.23.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('productRuleCtrl', productRuleCtrl);

  /** @ngInject */
  function productRuleCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 08.23.2018
     */
    if($rootScope.permissionArr.indexOf('product_rule_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.product-rule';
    $scope.resetGlobalSearch();
    function renderWithMultipleProduct(data, type, full){
      if(data){
        var status= angular.fromJson(data).toString();
        return '<div title="'+status+ '" style="width:400px;overflow:hidden;text-overflow:ellipsis">'+status+'</div>';
      }else{
        return '';
      }

    }
    /**
     * Get data table method is use get list of productRule.
     * created on 08.23.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/statusbycategory')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.productRule = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_rule_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editProductRule(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'product_rule_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/productRule/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_rule_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/productRule/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_rule_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/productRule/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              product_label: value.product_label,
              order_status: value.order_status_title,
              rule_name: value.rule_name,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.productRule);
          defer.resolve(vm.productRule);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('rule_name').withTitle('Rule Name'),
        DTColumnBuilder.newColumn('order_status').withTitle('Order Status'),
        DTColumnBuilder.newColumn('product_label').withTitle('Product').renderWith(renderWithMultipleProduct),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('product_rule_edit') !== -1 || $rootScope.permissionArr.indexOf('product_rule_delete') !== -1 || $rootScope.permissionArr.indexOf('product_rule_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

     /**
     * Add Product Rule method is use for get add Product Rule page.
     * created on 08.23.2018
     */
    $scope.addProductRule = function() {
      $cookies.put('product-rule-id',undefined);
      $state.go('settings.add-product-rule');
    }

    /**
     * Edit Product Rule method is use for get edit Report Label page.
     * created on 08.23.2018
     */
    $scope.editProductRule = function(id) {
      $cookies.put('product-rule-id',id);
      $state.go('settings.edit-product-rule');
    }

    /**
     * Open model.
     * created on 08.23.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of Product Rule.
     * created on 08.23.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/statusbycategory', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete Product Rule method is use for delete Product Rule.
     * created on 08.23.2018
     */
    $scope.deleteProductRule = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/statusbycategory/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Product rule deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save Product Rule data method is use for update/add Product Rule data.
     * created on 08.23.2018
     */
    $scope.saveProductRuleData = function() {
     if (!this.productRuleFrm.ruleName.$valid) {
       toastr.error("Please enter rule name.");
       angular.element('#ruleName').focus();
       return;
     }else if (!this.productRuleFrm.orderStatus.$valid) {
      toastr.error("Please select order status.");
      angular.element('#orderStatusId').focus();
      return;
    }else if (!this.productRuleFrm.productLabel.$valid) {
      toastr.error("Please select product.");
      angular.element('#productLabelId').focus();
      return;
      }else if (!this.productRuleFrm.status.$valid) {
        toastr.error("Please select status.");
        return;
      }
       apiService.loaderShow();
      var bodyData = {
        product_label: JSON.stringify(vm.productLabel),
        order_status:vm.orderStatus,
        rule_name:vm.ruleName,
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/statusbycategory';
      $scope.httpMethod = 'POST';
      if (vm.productRuleId) {
        $scope.saveUrl = $rootScope.baseUrl + '/statusbycategory/' + vm.productRuleId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status== 'fail') {
              toastr.error(response.message);
              angular.element('#ruleName').focus();
        }else  if (response.status == 'success') {
          toastr.success('Product rule ' + (vm.productRuleId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.product-rule');
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            toastr.error(error.data.message);
        } else {
          $state.go('settings.product-rule');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited Report label method is use for get edited Report label data.
     * created on 08.23.2018
     */
    $scope.getEditedProductRole = function() {

        if($rootScope.permissionArr.indexOf('product_rule_add') == -1 && $rootScope.permissionArr.indexOf('product_rule_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('product-rule-id') && $cookies.get('product-rule-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/statusbycategory/' + $cookies.get('product-rule-id'))
            .success(function(response) {
              vm.productLabel = response.product_label?JSON.parse(response.product_label):'';
              vm.orderStatus=response.order_status;
              vm.ruleName=response.rule_name;
              vm.productRuleId = response._id;
              vm.status = response.status;
              apiService.loaderHide();
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-product-rule');
        }
    };

    /**
     * Get all products list method is use to get product data.
     * created on 08.23.2018
     */
    $scope.getProductData = function(){
        $http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
        .success(function (response) {
          vm.productData=response;
          // angular.element(document).ready(function () {
          //         angular.element('#productLabelId').selectpicker('refresh');
          //     });
        }).error(function (error) {
          if (error.data && error.data.code == 0) {
              toastr.error(error.data.message);
          } else {
              toastr.error("Something went wrong please try again.");
          }
        });
    }
    /**
     * get active status data.
     * created on 08.23.2018
     */
     $scope.getActiveStatusData = function() {
        // get order status
        $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function (result) {
              vm.orderStatusList = result;
              // angular.element(document).ready(function () {
              //         angular.element('#orderStatusId').selectpicker('refresh');
              //     });
            }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
          }
          /**
           * get active product rule method is use for get active product rule list.
           * created on 08.24.2018
           */
          $scope.getActiveProductRuleData=function(){
            $scope.isloaded = false;
            $http.get($rootScope.baseUrl + '/statusbycategory/active-rule')
                .success(function (result) {
                  $scope.isloaded = true;
                  $scope.ruleOrder=result;
                  $scope.updatedRuleOrder=result;
                }).error(function (error) {
                  $scope.isloaded = true;
                    if (error.code != undefined && error.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
          }
          /**
          * rule sortable Options.
          * created on 08.24.2018
          */
          $scope.sortableRuleOptions = {
            accept: function (sourceItemHandleScope, destSortableScope) {
                  return true;
            },
            orderChanged: function (event) {
              $scope.updatedRuleOrder = event.source.sortableScope.modelValue.map(function(a) {return a;});
            },
            containment: '#sortable-container',
            allowDuplicates: false,
          };
          /**
          * save Faq Order is use to save sort order and display faq this order.
          * created on 10.17.2017
          */
          $scope.saveProductRuleOrder=function(){
            $scope.temp=[];
            angular.forEach($scope.updatedRuleOrder,function(value,key){
              $scope.temp.push({'id':value._id,'sort_order':key+1})
            });
            //apiService.loaderShow();
            var bodyData={
              'data':JSON.stringify($scope.temp)
            };
            $http.post($rootScope.baseUrl + '/statusbycategory/bulkupdate',bodyData).success(function (response) {
                 //apiService.loaderHide();
                 if(response.status=="fail"){
                   toastr.error(response.message);
                 }else{
                   toastr.success('Product rule order updated successfully.');
                   $state.go('settings.product-rule');
                 }

              }).error(function (error) {
                  //apiService.loaderHide();
                  if (error.code != undefined && error.code == 0) {
                      toastr.error(error.message);
                  } else {
                      toastr.error("Something went wrong please try again.");
                  }
              });
          }
  }

})();

/**
 * Job controller display Job button settings.
 * @author Harsha Prajapati
 * created on 09.06.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('pullJobSettingCtrl', pullJobSettingCtrl);

  /** @ngInject */
  function pullJobSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout) {
    /**
     * permissionArr is use to check permission to display list
     * created on 09.06.2018
     */
    if ($rootScope.permissionArr.indexOf('pull_job_setting') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.pull-job-setting';
    /**
     * get active status data.
     * created on 04.03.2018
     */
     $scope.getActiveStatusData = function() {
        // get order status
        $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function (result) {
              $scope.orderStatusList = result;
            }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
          }
    /**
     * get Job Setting Data method is use to display Job Setting data.
     * created on 09.06.2018
     */
    $scope.getPullJobSettingData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/pullJobSetting')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                var resultData=result.data;
                vm.showOnStatus=resultData.show_on_status;
                vm.onChangeStatus=resultData.change_to_status;
              }
            }
          }
        }).error(function(error) {
          $scope.isloaded = true;
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * save Job setting method is use for add Job Setting data.
     * created on 09.06.2018
     */
    $scope.savePullJobSetting = function() {
      if(!this.pullJobSettingFrm.$valid){
        return false;
      }
      $scope.jobData={};
      $scope.jobData['show_on_status']=vm.showOnStatus;
      $scope.jobData['change_to_status']=vm.onChangeStatus;
      apiService.loaderShow();
      var bodyData = {
        type: 'pullJobSetting',
        sticker_data: angular.toJson($scope.jobData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };


  }
})();

/**
 * Relay button controller display Relay button settings.
 * @author Anand Malvi
 * created on 17.12.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('relayButtonSettingCtrl', relayButtonSettingCtrl);

  /** @ngInject */
  function relayButtonSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout) {
    /**
     * permissionArr is use to check permission to display list
     * created on 09.06.2018
     */
    if ($rootScope.permissionArr.indexOf('relay_button_setting') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.rework-button-setting';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 09.06.2018
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    $scope.relayIsOpen=true;
    /**
     * get Job Setting Data method is use to display Job Setting data.
     * created on 09.06.2018
     */
    vm.createButtonUrl='system';
    vm.defaultRelayOrderBy='asc';
    vm.readyUrl='system';
    vm.url3dcDownload='system';
    vm.createButtonEncrypted='No';
    vm.readyEncrypted='No';
    vm.url3dcEncrypted='No';
    vm.uploadEncrypted='No';
    vm.amazonEncrypted='No';
    vm.uploadOrderStatus='';
    vm.amazoneOrderStatus='';
    vm.uploadOrderStatusForUpload='';
    $scope.getRelayButtonSettings = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/relayButtonSetting')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            if (result.status == 'fail') {
              //toastr.error(result.message);
            } else {
              if (result.data) {
                var resultData=result.data;
                // Create button
                vm.createTitle=resultData.create_button.create_title?resultData.create_button.create_title:'';
                vm.createButtonUrl=resultData.create_button.create_url?resultData.create_button.create_url:'system';
                vm.createButtonEncrypted=resultData.create_button.create_encrypted?resultData.create_button.create_encrypted:'No';
                vm.createOrderStatus=resultData.create_button.create_order_status?resultData.create_button.create_order_status:'';

                // Ready Button
                vm.readyTitle=resultData.ready_button.ready_title;
                vm.readyUrl=resultData.ready_button.ready_url?resultData.ready_button.ready_url:'system';
                vm.readyEncrypted=resultData.ready_button.ready_encrypted?resultData.ready_button.ready_encrypted:'No';
                vm.readyOrderStatus=resultData.ready_button.ready_order_status?resultData.ready_button.ready_order_status:'';

                // 3DC Download button
                vm.title3dcDownload=resultData.download_3dc_button.title_3dc_download;
                vm.url3dcDownload = resultData.download_3dc_button.url_3dc_download?resultData.download_3dc_button.url_3dc_download:'system';
                vm.url3dcEncrypted = resultData.download_3dc_button.url_3dc_encrypted?resultData.download_3dc_button.url_3dc_encrypted:'No';
                vm.download3dcOrderStatus=resultData.download_3dc_button.download_3dc_order_status?resultData.download_3dc_button.download_3dc_order_status:'';
                
		vm.defaultRelayOrderBy=resultData.relay_fetch.default_relay_orderby?resultData.relay_fetch.default_relay_orderby:'asc';
               
                // Upload
                vm.upload=resultData.upload.upload?resultData.upload.upload:'Download';
                vm.uploadEncrypted=resultData.upload.upload_encrypted?resultData.upload.upload_encrypted:'No';
                vm.uploadOrderStatus=resultData.upload.upload_order_status?resultData.upload.upload_order_status:'';
                vm.uploadOrderStatusForUpload=resultData.upload.upload_order_status_for_upload?resultData.upload.upload_order_status_for_upload:'';

                // Amazon File download
                vm.amazonDownload=resultData.amazon.download?resultData.amazon.download:'A-Download';
                vm.amazonEncrypted=resultData.amazon.encrypted?resultData.amazon.encrypted:'No';
                vm.amazoneOrderStatus=resultData.amazon.download_order_status?resultData.amazon.download_order_status:'';
              }
            }
          }
        }).error(function(error) {
          $scope.isloaded = true;
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * save Job setting method is use for add Job Setting data.
     * created on 09.06.2018
     */
    $scope.SaveRelayButtonSetting = function() {
      if(!this.relayButtonSettingFrm.$valid){
        return false;
      }
      $scope.relayData={};
      //Create button
      $scope.relayData['create_button'] = {
          'create_title': vm.createTitle,
          'create_url': vm.createButtonUrl,
          'create_encrypted': vm.createButtonEncrypted,
          'create_order_status':vm.createOrderStatus

        };
      $scope.relayData['ready_button'] = {
          'ready_title': vm.readyTitle,
          'ready_url': vm.readyUrl,
          'ready_encrypted': vm.readyEncrypted,
          'ready_order_status':vm.readyOrderStatus
        };
      $scope.relayData['download_3dc_button'] = {
          'title_3dc_download': vm.title3dcDownload,
          'url_3dc_download'  : vm.url3dcDownload,
          'url_3dc_encrypted': vm.url3dcEncrypted,
          'download_3dc_order_status': vm.download3dcOrderStatus
          
        };

      $scope.relayData['relay_fetch'] = {
          'default_relay_orderby': vm.defaultRelayOrderBy,
      };

      $scope.relayData['upload'] = {
          'upload': vm.upload,
          'upload_encrypted': vm.uploadEncrypted,
          'upload_order_status': vm.uploadOrderStatus,
          'upload_order_status_for_upload': vm.uploadOrderStatusForUpload
        };
        
      $scope.relayData['amazon'] = {
          'download': vm.amazonDownload,
          'encrypted': vm.amazonEncrypted,
          'download_order_status': vm.amazoneOrderStatus
        };
 
      apiService.loaderShow();
      var bodyData = {
        type: 'relayButtonSetting',
        sticker_data: angular.toJson($scope.relayData),
        affected_by: $rootScope.globals.currentUser.id,
      };
     // console.log(bodyData);
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };
    // relay fetch -- start
    $scope.relayFetchDate={};
    $scope.relayFetchDate.date={};
    $scope.options = {
        applyClass: 'btn-green',
        maxDate: moment(),
        locale: $rootScope.datePicker.locale,
        eventHandlers : {
            'apply.daterangepicker' : function() {
                 $scope.relayFetchDate.date.startDate = moment($scope.relayFetchDate.date.startDate).format('YYYY-MM-DD');
                 $scope.relayFetchDate.date.endDate = moment($scope.relayFetchDate.date.endDate).format('YYYY-MM-DD');
            }
          }
    }
    $scope.focusInput=function(){
      angular.element('#relayFetchDateId').focus();
    }
    $scope.fetchRelayData = function() {
            if (!this.relayFetchFrm.$valid) {
                return false;
            }
            apiService.loaderShow();
            var bodyData = {
                from_date: $scope.saveFromDateFormat($scope.relayFetchDate.date.startDate),
                to_date: $scope.saveToDateFormat($scope.relayFetchDate.date.endDate)
            };
            $http.post($rootScope.baseUrl + '/relay/setting/fetch-files-manual', bodyData).success(function (response) {
                apiService.loaderHide();
                toastr.success(response.message);
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
    }
    
    /**
     * get Active Status method is use to display all active order status.
     * created on 03.17.2019
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
  }
})();

/**
 * Rework controller display Rework settings.
 * @author Harsha Prajapati
 * created on 08.27.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('reworkSettingCtrl', reworkSettingCtrl);

  /** @ngInject */
  function reworkSettingCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService,$timeout) {
    /**
     * permissionArr is use to check permission to display list
     * created on 08.27.2018
     */
    if ($rootScope.permissionArr.indexOf('rework_setting') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'settings.rework-setting';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 08.27.2018
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 08.27.2018
     */
    vm.reworkReason = [];
    vm.reworkSolution = [];

    /**
     * get Rework Setting Data method is use to display Rework Setting data.
     * created on 08.27.2018
     */
    $scope.getReworkSettingData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/reworkSetting')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.availableOrderStatus=result.data.available_order_status;
                vm.reworkOrderStatus=result.data.rework_order_status;
                vm.reworkReason = result.data.rework_reason;
                vm.reworkSolution = result.data.rework_solution;
              }
            }
          }
        }).error(function(error) {
          $scope.isloaded = true;
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }


    $scope.addItem = function(type) {
      //this.reworkSettingFrm.$setPristine();
      $scope.inserted = {
        name: null,
        set_default: '0'
      };
      if (type == 'rework_reason') {
        vm.reworkReason.push($scope.inserted);
      } else if (type == 'rework_solution') {
        vm.reworkSolution.push($scope.inserted);
      }
    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/settings/reworkSetting/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "rework_reason") {
          vm.reworkReason.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "rework_solution") {
          vm.reworkSolution.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };
    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 10.30.2017
     */
    $scope.validateArr = function(dataArr, setAsDefault) {
      var errorKey = -1;
      var errorId = '';
      var temp = [];
      var isOnlyDefaultError = 0;
      var errorMessageDefault = 0;
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + setAsDefault + '-' + i).removeClass('focus-error');
        var n = dataArr[i];
        if (setAsDefault != undefined) {
          isOnlyDefaultError = 1;
          if (n.set_default == '1') {
            temp.push(i);
          }
        }
      }
      if (isOnlyDefaultError && errorId == "" && dataArr.length > 0) {
        if (temp.length < 1) {
          errorKey = 0;
        } else if (temp.length > 1) {
          errorKey = temp[temp.length - 1];
          errorMessageDefault = 1;
        }
        errorId = setAsDefault;
      }
      if (errorKey > -1) {
        if (errorMessageDefault == 1) {
          toastr.error('Set As Default already exists.');
          angular.element('#' + errorId + '-' + errorKey).addClass('focus-error');
          angular.element('#' + errorId + '-' + errorKey).focus();
          return 1;
        }
      }
      return 0;
    }
    /**
     * save Rework setting method is use for add Rework Setting data.
     * created on 08.27.2018
     */
    $scope.saveReworkSetting = function() {
      var reason = $scope.validateArr(vm.reworkReason, 'itemDefaultReason');
      if (reason == 1) {
        return false;
      }
      var solution = $scope.validateArr(vm.reworkSolution, 'itemDefaultSol');
      if (solution == 1) {
        return false;
      }
      $scope.reworkSettingData = {
        'rework_reason':vm.reworkReason,
        'rework_solution':vm.reworkSolution,
        'available_order_status':vm.availableOrderStatus,
        'rework_order_status':vm.reworkOrderStatus
      };
      apiService.loaderShow();
      var bodyData = {
        type: 'reworkSetting',
        sticker_data: angular.toJson($scope.reworkSettingData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };
    /**
     * get Active Status method is use to display all active order status.
     * created on 08.28.2018
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('storeCtrl', storeCtrl);

  /** @ngInject */
  function storeCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 08.27.2018
     */
    if($rootScope.permissionArr.indexOf('store_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    vm.service = '';
    vm.ciproductsetting = '';
    $rootScope.currentState='settings.store';
    $scope.accounts = [];
    vm.shipmenRateMargin = 0;
    
    $scope.resetGlobalSearch();
    function renderWithSystemType(data, type, full){
      if(data=='m1'){
        return 'Magento 1';
      }else if(data=='m2'){
        return 'Magento 2';
      }else if(data=='pos'){
        return 'POS';
      }else if(data=='erp'){
        return 'ERP System';
      }else if(data=='amazon'){
        return 'Amazon';
      }else if(data=='other'){
        return 'Other';
      }else{
        return '';
      }
    }
    function renderWithStoreUrl(data, type, full){
      if(data){
        return '<a href="'+data+'" target="_blank" title="Redirect to Store URL" style="background-color:white;padding:2px">'+data+'</a>';
      }else{
        return '';
      }
    }
    /**
     * Get data table method is use get list of store.
     * created on 08.27.2018
     */
    $scope.getDataTable = function() {
      var vm = this;

      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/storesystem')
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.store = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'store_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editStore(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'store_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/store/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
            var mapStatus = '  <a ng-if="permissionArr.indexOf(\''+'map_status'+'\') !== -1" href="" ng-click="storeMapStatus(\'' + value.store_id + '\')" title="Map Status" ><i class="fa fa-cog fa-lg white"></i> </a>';
            var magentoStatus = '  <a ng-if="permissionArr.indexOf(\''+'magento_status_list'+'\') !== -1" href="" ng-click="magentoStatus(\'' + value.store_id + '\')" title="Magento Status" ><i class="fa fa-list fa-lg white"></i> </a>';
            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'store_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/store/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'store_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/store/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              store_name: value.store_name,
              store_code:value.store_code,
              store_url:value.store_url,
              system:value.type_of_system,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks+ '&nbsp;' + mapStatus+ '&nbsp;' + magentoStatus
              };
            this.push(data);
            ++index;
          }, vm.store);
          defer.resolve(vm.store);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('store_name').withTitle('Store Name'),
        DTColumnBuilder.newColumn('store_code').withTitle('Store Code'),
        DTColumnBuilder.newColumn('system').withTitle('System').renderWith(renderWithSystemType),
        DTColumnBuilder.newColumn('store_url').withTitle('Store URL').renderWith(renderWithStoreUrl),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('store_edit') !== -1 || $rootScope.permissionArr.indexOf('store_delete') !== -1 || $rootScope.permissionArr.indexOf('store_changestatus') !== -1 || $rootScope.permissionArr.indexOf('map_status') !== -1 || $rootScope.permissionArr.indexOf('magento_status_list') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }

    }

    $scope.accounts = [];
    $scope.getAccounts= function ()
    {
      $http.get($rootScope.baseUrl + '/shipment/active-accounts')
      .success(function(result) {
        angular.forEach(result, function(value, key) {
          $scope.accounts.push(value);
        });
      })
      .error(function (error)
      {
        if (error.data && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    };
    $scope.getAccounts();

     /**
     * Add store method is use for get add store page.
     * created on 08.27.2018
     */
    $scope.addStore = function() {
      $cookies.put('store-id',undefined);
      $cookies.put('store-map-id',undefined);
      $state.go('settings.add-store');
    }

    /**
     * Edit store method is use for get edit store page.
     * created on 08.27.2018
     */
    $scope.editStore = function(id) {
      $cookies.put('store-id',id);
      $state.go('settings.edit-store');
    }
    $scope.storeMapStatus = function(id) {
      $cookies.put('store-map-id',id);
      //$scope.getStatusMapData();
      $state.go('settings.map-status');
    }
    $scope.magentoStatus = function(id) {
      $cookies.put('store-map-id',id);
      $state.go('settings.magento-status');
    }
    /**
     * Open model.
     * created on 08.27.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of store.
     * created on 08.27.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/storesystem', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };

    /**
     * Delete store method is use for delete store.
     * created on 08.27.2018
     */
    $scope.deleteStore = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/storesystem/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Store deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save store data method is use for update/add store data.
     * created on 08.27.2018
     */
    $scope.saveStoreData = function() {
       if (!this.storeFrm.$valid) {
        return;
      }
       apiService.loaderShow();
      var bodyData = {
        store_name: vm.storeName,
        store_code:vm.storeCode,
        type_of_system:vm.systemType,
        store_url:vm.storeUrl,
        store_username:vm.userName,
        token:vm.storeToken,
        service:vm.service,
        account_fedex:vm.accountFedex,
        account_usps:vm.accountUsps,
        account_ups:vm.accountUps,
        auto_refresh:vm.autoRefreshTime,
        auto_import:vm.autoImportTime,
        shipment_rate_margin:vm.shipmenRateMargin,
        status: vm.status,
        ciproductsetting: vm.ciproductsetting,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/storesystem';
      $scope.httpMethod = 'POST';
      if (vm.storeId) {
        $scope.saveUrl = $rootScope.baseUrl + '/storesystem/' + vm.storeId;
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status == 'success') {
          toastr.success('Store ' + (vm.storeId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.store');
        }else{
          toastr.error(response.message);
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited Report label method is use for get edited Report label data.
     * created on 08.27.2018
     */
    $scope.getEditedStore = function() {

        if($rootScope.permissionArr.indexOf('store_add') == -1 && $rootScope.permissionArr.indexOf('store_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('store-id') && $cookies.get('store-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/storesystem/' + $cookies.get('store-id'))
            .success(function(response) {
              apiService.loaderHide();
              vm.storeName = response.store_name;
              vm.storeCode=response.store_code;
              vm.systemType=response.type_of_system;
              vm.storeId = response._id;
              vm.storeUrl=response.store_url;
              vm.autoRefreshTime=response.auto_refresh;
              vm.autoImportTime=response.auto_import;
              vm.userName=response.store_username;
              vm.storeToken=response.token;
              vm.service=response.service;
              vm.accountFedex=response.account_fedex;
              vm.accountUsps=response.account_usps;
              vm.accountUps=response.account_ups;
              vm.shipmenRateMargin = response.shipment_rate_margin;
              vm.status = response.status;
              vm.ciproductsetting = response.ciproductsetting;
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $scope.getStoreToken();
          $state.go('settings.add-store');
        }
    };
    /**
    * getStoreToken method is use for get store token
    * created on 08.28.2018
    */
    $scope.getStoreToken = function () {
        $http.get($rootScope.baseUrl+'/customer/tokens').success(function(response){
          vm.storeToken=response.token;
        }).error(function(error){
          //toastr.error(error.message);
        });
      }
    $scope.success = function (text) {
       toastr.success(text+' Copied!');
     };

     $scope.fail = function (err) {
       toastr.error('Error!', err);
     };

     $scope.getStatusData = function() {
        // get order status
        $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function (result) {
              vm.orderStatus = result;
            }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });

          }
      /**
       * get status map settings data.
       * created on 09.10.2018
       */

    $scope.getStatusMapData = function() {
      if($cookies.get('store-map-id')){
        // get Magento status
        vm.mapStatusData=[];
        $scope.setOfSets = [];
            // get store map data
        $http.get($rootScope.baseUrl + '/magentostatussetting/'+$cookies.get('store-map-id'))
          .success(function (result) {
            if(result && result!=undefined){
              vm.mapStatusData=result;
              var half_length = Math.ceil(vm.mapStatusData.length / 2);
              var leftArray = vm.mapStatusData.splice(0,half_length);
              var rightArray = vm.mapStatusData.splice(0,vm.mapStatusData.length);
              $scope.setOfSets.push(leftArray);
              $scope.setOfSets.push(rightArray);
            }else{
              // $http.get($rootScope.baseUrl + '/magentostatus/active/'+$cookies.get('store-map-id'))
              //     .success(function (result) {
              //       vm.magentoStatus = result;
              //       angular.forEach(vm.magentoStatus,function(val,key){
              //         vm.mapStatusData.push({'magento_status_title':val.magento_status_title,'magento_status_code':val.magento_status_code,'status':[]});
              //       });
              //       var half_length = Math.ceil(vm.mapStatusData.length / 2);
              //       var leftArray = vm.mapStatusData.splice(0,half_length);
              //       var rightArray = vm.mapStatusData.splice(0,vm.mapStatusData.length);
              //       $scope.setOfSets.push(leftArray);
              //       $scope.setOfSets.push(rightArray);
              //     }).error(function (error) {
              //
              //     });
            }
          }).error(function (error) {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });
      }
    };
    $scope.addMapStatusData= function(){
       $scope.temp = [];
       angular.forEach($scope.setOfSets,function(value,key){
         angular.forEach(value,function(val,ke){
           $scope.temp.push(val);
         });
       });
       apiService.loaderShow();
       var bodyData={'settingData':angular.toJson($scope.temp),'store_id':$cookies.get('store-map-id')};
       $http.post($rootScope.baseUrl + '/magentostatussetting',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('settings.store');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data && error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
     }

    /**
    * remove status data method is use to delete status.
    * created on 06.19.2018
    */
    $scope.removeStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 06.19.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }

    /**
    * sortable Options.
    * created on 06.19.2018
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
  }

})();


(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('trackerStatusMapCtrl', trackerStatusMapCtrl);

  /** @ngInject */
  function trackerStatusMapCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 08.27.2018
     */
    if($rootScope.permissionArr.indexOf('tracker_status_map') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    
    $rootScope.currentState='settings.tracker-status-map';
    
    $scope.resetGlobalSearch();
    
    $scope.getStatusData = function()
    {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
      .success(function (result) {
        vm.orderStatus = result;
      }).error(function (error) {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    }

    $scope.addMapStatusData= function()
    {
       $scope.temp = [];
       angular.forEach($scope.setOfSets,function(value,key){
         angular.forEach(value,function(val,ke){
           $scope.temp.push(val);
         });
       });
       apiService.loaderShow();
       var bodyData={'settingData':angular.toJson($scope.temp)};
       $http.post($rootScope.baseUrl + '/trackerstatusmap',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('settings.tracker-status-map');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data && error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
    }

    $scope.getStatusMapData = function() {
        // get Magento status
        vm.mapStatusData=[];
        $scope.setOfSets = [];
            // get store map data
        $http.get($rootScope.baseUrl + '/trackerstatusmap')
          .success(function (result) {
            if(result && result!=undefined){
              vm.mapStatusData=result;
              var half_length = Math.ceil(vm.mapStatusData.length / 2);
              var leftArray = vm.mapStatusData.splice(0,half_length);
              var rightArray = vm.mapStatusData.splice(0,vm.mapStatusData.length);
              $scope.setOfSets.push(leftArray);
              $scope.setOfSets.push(rightArray);
            }
          }).error(function (error) {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });
    }
  }

})();

/**
 * ProductType controller handle all action related Product Type.
 * @author shivpratap chauhan <shivpratap.chauhan@brainvire.com>
 * created on 18-01-2019
 */
(function(){
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('typeCtrl',typeCtrl);

  /** @ngInject */
  function typeCtrl($scope,$filter, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr,DTOptionsBuilder, DTColumnBuilder,$q,$compile,fileReader, router, typeRouter){
     /**
     * permissionArr is use to check permission to display list
     * created on 18.01.2019
     */
 
     $rootScope.currentState = $state.current.name;
 
    if($rootScope.permissionArr.indexOf('product_type')==-1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm=this;
    $rootScope.currentState='settings.type';
    $scope.resetGlobalSearch();
    /**
     * Get data table method is use get list of Product type.
     * created on 18.01.2019
     */
    $scope.availableSKU=[];
    $scope.getDataTable=function(){
      var vm = this;
      var operations='';
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function(){
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/productType')
                .success(function(result) {
                    localStorage.setItem('stickerTypeList',JSON.stringify(result));
                    $scope.reloadTypeState();
                     result=result.data;
                   if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.producTypeList = [];
          var index = 1 ;
          angular.forEach(result, function(value, key){
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_type_edit'+'\') !== -1" href="javascript:void(0);"   ng-click="editProductType(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'product_type_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/type/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_type_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/type/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';
            var viewLinks = ' <a ng-if="permissionArr.indexOf(\''+'view_product_type'+'\') !== -1" href="javascript:void(0);"   ng-click="viewProductType(\'' + value._id + '\')" title="View"><img src="assets/img/info.png" width="24"/></a>';
            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'product_type_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/type/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }
           if($scope.sticker_arr.includes(value.name.toLowerCase()))
           {
              operations=viewLinks;  
           }else{
             operations='&nbsp;'+editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks;   
           }
          var typeIcon='<img style="padding:5px"  src="'+value.image_resize_path+'"/>';
          var data={
              id: value._id,
              name: value.name,
              index:index,
              updated_at: value.updated_at,
              priority_no :value.priority_no>0?value.priority_no:'',
              show_in_blocks:value.show_in_blocks=='true'?'Yes':'No',
              status:statusBadge,
              typeIcon:typeIcon,
              operations:operations
              };
            this.push(data);
            ++index;
          }, vm.producTypeList);
          defer.resolve(vm.producTypeList);
        }).error(function (error) {
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function(){
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns=[
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible().withOption('order', [1, 'desc']),
        DTColumnBuilder.newColumn('name').withTitle('Type'),
        DTColumnBuilder.newColumn('show_in_blocks').withTitle('Show In Blocks'),
        DTColumnBuilder.newColumn('priority_no').withTitle('Priority'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
        DTColumnBuilder.newColumn('typeIcon').withTitle('Type Icon').withOption('className', 'tableStatus'),
      ];
    if($rootScope.permissionArr.indexOf('product_type_edit') !== -1 || $rootScope.permissionArr.indexOf('prodcuct_type_delete') !== -1 || $rootScope.permissionArr.indexOf('product_type_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false));
      }
    }
     /**
     * Add category method is use for get add category page.
     * created on 05.04.2018
     */
    $scope.addType=function(){
      $cookies.put('product-type-id',undefined);
      $state.go('settings.add-type');
    }
    /**
     * Open model.
     * created on 05.04.2018
     */
    $scope.open=function(page, id, status){
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };

    /**
     * Edit product method is use for get edit category page.
     * created on 05.04.2018
     */
    $scope.editProductType = function(id) {
      $cookies.put('product-type-id',id);
      $state.go('settings.edit-type');
    }
    /**
     * Delete Product Type method is use for .
     * created on 05.04.2018
     */
    $scope.deleteProductType = function() {
      if ($rootScope.deleteId){
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/productType/destroy/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Type has been deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };


    /**
     * Get edited category method is use for get edited category data.
     * created on 05.04.2018
     */
    $scope.getEditedProductType = function() {

        if($rootScope.permissionArr.indexOf('product_type_edit') == -1 && $rootScope.permissionArr.indexOf('product_type_add') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('product-type-id') && $cookies.get('product-type-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/productType/' + $cookies.get('product-type-id'))
            .success(function(response) {

              apiService.loaderHide();
              vm.productType = response.data.name;
             
              vm.productId = response.data._id;
              vm.status = response.data.status;
              vm.image = response.data.image_path;
              vm.SKU=JSON.parse(response.data.sku);
              vm.swtich=response.data.swtich=='true'?true:false;
              vm.show_in_blocks=response.data.show_in_blocks=='true'?true:false;
                if(response.data.image_path == '' || response.data.image_path == null){
                    vm.image = $filter('appImage')('theme/profile-pick-default.png');;
                }
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-type');
        }
    };
    /**
     * view product type
     * @returns 
     */
     $scope.viewProductType = function(id) {
      $cookies.put('product-type-id',id);
      $state.go('settings.view-type');
    }
    /**
     * getViewType method is use for get View page data
     * @returns
     */
     $scope.getViewType = function() {
        
        if($rootScope.permissionArr.indexOf('view_product_type') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('product-type-id') && $cookies.get('product-type-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/productType/' + $cookies.get('product-type-id'))
            .success(function(response) {

              apiService.loaderHide();
              vm.productType = response.data.name;
             
              vm.productId = response.data._id;
              vm.status = response.data.status=='1'?'Active':'Inactive';
              vm.image = response.data.image_resize_path;
              vm.SKU=JSON.parse(response.data.sku);
              vm.swtich=response.data.swtich=='true'?'Yes':'No';
              vm.show_in_blocks=response.data.show_in_blocks=='true'?'Yes':'No';
                if(response.data.image_path == '' || response.data.image_path == null){
                    vm.image = $filter('appImage')('theme/profile-pick-default.png');;
                }
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.type');
        }
    };

    $scope.reloadTypeState = function() {
        typeRouter.setUpTypeRoutes();
    };
    /**
     * Save Product Type data method is use for update/add product type data.
     * created on 18.01.2019
     */
  $scope.saveProductTypeData=function(){
   var  image= document.getElementById("uploadFile").files[0];
   if(!this.productTypeFrm.product_type.$valid){
        toastr.error("Please enter  type.");
        angular.element('#product-type').focus();
        return;
      }else if (!this.productTypeFrm.status.$valid){
        toastr.error("Please select status.");
        return;
      }
      apiService.loaderShow();
      var bodyData={
        name: vm.productType,
        status: vm.status,
       "swtich":vm.swtich!=undefined?vm.swtich:false,
       "show_in_blocks":vm.show_in_blocks!=undefined?vm.show_in_blocks:false,
       "sku":JSON.stringify(vm.SKU), 
        affected_by: $rootScope.globals.currentUser.id,
        "image":image
      };
      $scope.saveUrl = $rootScope.baseUrl + '/productType';
      $scope.httpMethod = 'POST';
      if (vm.productId){
        $scope.saveUrl = $rootScope.baseUrl + '/productType/update/' + vm.productId;
        $scope.httpMethod = 'POST';
      }
        $http({
                    method:$scope.httpMethod,
                    url:$scope.saveUrl,
                    headers: {'Content-Type': undefined},
                    data:bodyData,
                    transformRequest: function (data, headersGetter){
                        var formData = new FormData();
                        angular.forEach(data, function (value, key) {
                            formData.append(key, value);
                        });
                        return formData;
                    }
                }).then(function(response){
        apiService.loaderHide();
        var response = response.data;
        if (response.code!= undefined && response.code == 0){
              toastr.error(response.message);
        }else  if (response.status == 'success') {
          toastr.success('Type ' + (vm.productId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.type');
        }
      },function(error){
        apiService.loaderHide();
        if (error.data && error.data.code == 0) {
            if(error.data.message == 'The name has already been taken.'){
                toastr.error('This category already exists.');
                angular.element('#category').focus();
            }else{
                toastr.error(error.data.message);
            }
        } else {
          $state.go('settings.type');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

       /**
     * Change status method is use for change status of product Type.
     * created on 05.04.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/productType', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();

      }
    };
    /**
     * Get Active Type Data
     * @returns 
     */
     $scope.getActiveTypeData=function(){
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/productType/getActiveType')
          .success(function (result) {
            $scope.isloaded = true;
            $scope.buttonOrder=result;
            $scope.updatedButton=result;
          }).error(function (error) {
            $scope.isloaded = true;
              if (error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
          });
    }
    $scope.setOfSets = [];
    $scope.getAllTypes = function() {
            // get order status
            $http.get($rootScope.baseUrl + '/productType/getActiveType/all')
                .success(function (result) {
                  $scope.allTypes = result;
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    }
                    $state.go('settings.type');
                });
            /**
             * get edit button settings status data.
             * created on 06.19.2018
             */
            
            $http.get($rootScope.baseUrl + '/productType/getSavedPriority')
                    .success(function (result) {
                      if(result.status=='success'){
                        if(result.data && result.data!=undefined){
                          vm.addType=result.data;
                        }
                      }else{
                        vm.addType=[
                                  {
                                    "name":"Add On Type",
                                    "typeData": []
                                  },
                                  {
                                    "name":"Regular Types",
                                    "typeData": []
                                  }
                                ];
                      }
                      
                      var half_length = Math.ceil(vm.addType.length / 2);
                      var leftArray = vm.addType.splice(0,half_length);
                      var rightArray = vm.addType.splice(0,vm.addType.length);
                      $scope.setOfSets.push(leftArray);
                      $scope.setOfSets.push(rightArray);
                    }).error(function (error) {
                        apiService.loaderHide();
                        if (error.data && error.data.code != undefined && error.data.code == 0) {
                            toastr.error(error.data.message);
                        }
                    });
      };
    /**
     *  upload PIcture is use for upload icon for master type .
     * created on 05.04.2018
     */
    $scope.uploadPicture = function () {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };

        $scope.getFile = function () {
            $scope.noPicture = false;
            fileReader.readAsDataUrl(this.file, $scope)
                .then(function (result) {
                    vm.image = result;
                });
        };
        function labelExists(name,destSortableScope) {
            return destSortableScope.modelValue.some(function(el) {
              return el.name === name;
            });
        }
        function checkTypeExists(sourceType,allTypes){
            return true;
            
        }
        
        var canceler = $q.defer();
        var tmparr = [];
        function checklabelexistsonotherplace(name) {
               var alength = $scope.setOfSets[0][0].typeData.length;
               if (alength > 0) {
                     for (var i = 0; i < alength; i++) {
                        if ($scope.setOfSets[0][0].typeData[i].name == name) {
                          toastr.error('Item Already added in blocks');
                            tmparr.push('yes');
                            return false;
                        } 
                    }
                }
                var anlength =  $scope.setOfSets[1][0].typeData.length;
                if (anlength > 0) {
                    for (var j = 0; j < anlength; j++) {
                       // console.log(tmplist[1].typeData[j].name);
                        if ($scope.setOfSets[1][0].typeData[j].name == name) {
                            //var abc = false;
                            toastr.error('Item Already added in blocks');
                            tmparr.push('yes');
                            return false;
                        } 
                    }
                }
                return true;
      
        }
        
        
        
       /**
    * sortable Options.
    * created on 14.02.2019
    */
    $scope.sortableOptions = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        
         var sourceType   =sourceItemHandleScope.itemScope.modelValue.name;
         //console.log(getexistingdataforeventcheck());
         //return false;
          checklabelexistsonotherplace(sourceType);
        console.log();
        if(!checklabelexistsonotherplace(sourceType)){
            return false;
        }
        

        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
              
               //return false;
            return true;
        } else{
            if(labelExists(sourceType,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
//          console.log(eventObj.source.itemScope.item);
//          console.log(eventObj.dest.sortableScope.modelValue);
          if(!labelExists(eventObj.source.itemScope.item,eventObj.dest.sortableScope)){
          eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
          }
            
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
  $scope.removeType = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }
    
    /**
     * add  type priority 
     */ 
      $scope.addTypePriority= function(){
       apiService.loaderShow();
       var bodyData={'data':JSON.stringify($scope.setOfSets)};
       $http.post($rootScope.baseUrl + '/productType/bulkupdate',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
            $state.go('settings.type');
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });
     }
}

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.shipment')
            .controller('readytoshipListCtrl', readytoshipListCtrl);

    /** @ngInject */
    function readytoshipListCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
        var that = this;
        if ($cookies.get('ShipmentNumber') && $cookies.get('ShipmentNumber')!= undefined) {
            that.orderNumber = $cookies.get('ShipmentNumber');
        }
        else {
            that.orderNumber = $rootScope.shipmentOderNumber?$rootScope.shipmentOderNumber:'';
        }
        that.soldTo = '';
        that.shipTo = '';

        $cookies.put('ShipmentNumber',undefined);
        $rootScope.shipmentOderNumber = '';

        $rootScope.currentState=$state.current.name;
        $scope.changeOrderDateButtonData = '';
        $scope.changeOrderCreatedDateOrderId = 0;
        $scope.activeTabIndex=0;
        
        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer','Keyword'];
        $scope.colvisOption = [{name: 'colvis',text: 'Select Columns',extend: 'colvis'}]//columns: ':gt(0)'
        
        $scope.selected = {};
        $scope.selectAll = false;
        $scope.isChangeStatus={change:false};
        $scope.isSelected={select:false};

        $scope.defaultService = '';
        $scope.defaultFedex = 0;
        $scope.defaultUSPS = 0;
        $scope.defaultOffice = 0;

        $scope.editsoldto = false;
        $scope.editshipto = false;
        
        $scope.packagesaved = false;
        $scope.adpkg = false;
        $scope.custom_packages = 0;
        $scope.order_total_weight = 0;
        $scope.add_business = false;
        $scope.add_home = false;
        
        $scope.package_type = '';
        $scope.packagesdata = [];
        $scope.orderServiceType = [];
        $scope.ShipmentBoxes = [];
        $scope.ShipmentAccounts = [];

        $scope.shippingdatachange = '';
        $scope.shippingChange = false;

        $scope.services = [
            {name:'fedex', label:'FedEx'}
        ];
        
        $scope.shippingservice = "";
        $scope.shippingservicetype = "";
        $scope.packageservice = "";
        $scope.packageservicetype = "";

        that.weight_lbs = 0;
        that.service = '';
        that.account = '';
        that.service_type = '';

        that.shippingservice = $scope.defaultService;
        that.shippingservicetype = '';
        
        $scope.orderNumber = $rootScope.shipmentOderNumber?$rootScope.shipmentOderNumber:'';
        $scope.soldTo = '';
        $scope.shipTo = '';

        $scope.dt = new Date();
        $scope.opened = false;
        $scope.formats = ['yyyy-MM-dd','dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.shipoptions = {
            minDate: moment().format('YYYY-MM-DD'),
            showWeeks: false
        };


        function openshipdate() {
            $scope.opened = true;
        }

        $scope.popup1 = {
            opened: false
        };

        $scope.open1 = function() {
            $scope.popup1.opened = true;
        };


        $scope.toggleAll=function(selectAll, selectedItems)
        {
            for (var id in selectedItems)
            {
                if (selectedItems.hasOwnProperty(id)) {
                    selectedItems[id] = selectAll;
                }
            }
        }

        $scope.toggleOne=function(selectedItems)
        {
            for (var id in selectedItems)
            {
                if (selectedItems.hasOwnProperty(id))
                {
                    if(!selectedItems[id])
                    {
                        $scope.selectAll = false;
                        return;
                    }
                }
            }
            $scope.selectAll = true;
        }

        $scope.duplicateCheck = [];
        $scope.duplicateCheckRow = [];
        $scope.isloaded = true;
        $scope.updatedItem = [];
        $scope.showItemUpdated = false;
        $scope.showItemScanned = true;
        $scope.isloadedDepartment = false;

        $scope.resetScan = function ()
        {
            $scope.duplicateCheck = [];
            $scope.duplicateCheckRow = [];
            $scope.showItemScanned = false;
            angular.element('#scanStart').show();
            angular.element('#manualScan').addClass('hide-element');
            angular.element('#scan-popup-barcode').hide();
            angular.element('#fade').hide();
            angular.element('#txt-barcode').hide();
            angular.element("#resetScan").hide();
        }

        $scope.showScan = function ()
        {
            angular.element("#resetScan").show();
            angular.element('#scanStart').hide();
            angular.element('#scan-popup-barcode').show();
            angular.element('#fade').show();
            angular.element('#viewOrder').show();
            angular.element('#txt-barcode').show();
            angular.element('#txt-barcode').focus();
        }

        $scope.showManualScan = function ()
        {
            angular.element('#scanStart').hide();
            angular.element('#viewOrder').show();
            angular.element('#txt-barcode').show();
            angular.element('#txt-barcode').focus();
            angular.element('#manualScan').removeClass('hide-element');
        }

        $scope.hidePopup = function ()
        {
            angular.element('#scanStart').hide();
            angular.element('#scan-popup-barcode').hide();
            angular.element('#fade').hide();
            angular.element('#txt-barcode').hide();
            angular.element("#resetScan").show();
        }

        $scope.doneManualScan = function ()
        {
            angular.element('#txt-barcode').hide();
            angular.element("#resetScan").show();
            angular.element('#manualScan').addClass('hide-element');
        }

        $scope.scanBarcode = function (val)
        {
            var vm = this;
            if(!val || val == undefined)
            {
                angular.element('#txt-barcode').focus();
                if(!$scope.duplicateCheckRow.length){
                    toastr.warning("please scan barcode of order.");
                }
                return;
            }
            
            val = val.trim();
            if ($scope.duplicateCheck.indexOf(val) !== -1)
            {
                angular.element('#txt-barcode').focus();
                if (vm.barcodeText.indexOf('_') > -1) {
                    toastr.warning("This item already scanned.");
                }
                else if (vm.barcodeText.indexOf('-') > -1) {
                    toastr.warning("This product already scanned.");
                } else {
                    toastr.warning("This order already scanned.");
                }
                vm.barcodeText = '';
                return;
            }
            
            apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/shipment/scanorders', {barcode:val,customer_id:$rootScope.customerId,allproducts:$scope.duplicateCheck})
            .success(function (response)
            {
                apiService.loaderHide();
                if (angular.equals({}, response) || response.length == 0) {
                    toastr.warning("No order found with scanned id");
                }
                else 
                {
                    if(response.status != 'fail')
                    {
                        $scope.duplicateCheck.push(val);
                        angular.forEach(response, function (value, key)
                        {
                            if ($scope.duplicateCheckRow.indexOf(key) == -1)
                            {
                                $scope.loadApiDataToHtml(value);
                                $scope.duplicateCheckRow.push(key);
                            }
                        });
                        
                        angular.element("#resetScan").show();
                        vm.barcodeText = '';
                        angular.element('#txt-barcode').focus();
                    }
                    else
                    {
                        toastr.error(response.message);
                    }
                }
            })
            .error(function (error)
            {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                else {
                    toastr.error("Something went wrong please try again.");
                }
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            });
        }

        $scope.loadApiDataToHtml = function (value)
        {
            var row='';
            if($rootScope.displayDisableIcons=='yes')
            {
                if(value.icon_rocket && value.icon_rocket=='enable'){
                    row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
                }
                else{
                    row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                }
                if(value.icon_tools && value.icon_tools=='enable'){
                    row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
                }
                else{
                    row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                }
                
                if(value.icon_plane && value.icon_plane=='enable'){
                    row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
                }
                else{
                    row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                }

                if((value.icon_house && value.icon_house=='enable') || (value.is_ups && value.is_ups=='enable' || value.is_ups==1)){
                    row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
                }
                else{
                    row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed">';
                }
                
                if ((value.type_total_count != undefined) && (value.type_total_count >= 1))
                {
                    var typeSlugName;
                    var typeExtName;
                    for (var i = 1; i <= value.type_total_count; i++) {
                        typeSlugName = value['type_' + i + '_slug'];
                        typeExtName = value['type_' + i + '_extension'];
                        row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                    }
                }
                
                if(value.regular_orders && value.regular_orders=='enable'){
                    row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
                }
                row;
            }
            else if($rootScope.displayDisableIcons=='no')
            {
                if(value.icon_rocket && value.icon_rocket=='enable'){
                    row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
                }
                if(value.icon_tools && value.icon_tools=='enable'){
                    row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
                }
                if(value.icon_plane && value.icon_plane=='enable'){
                    row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
                }
                if((value.icon_house && value.icon_house=='enable') || (value.is_ups && value.is_ups=='enable' || value.is_ups==1)){
                    row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
                }
                if ((value.type_total_count != undefined) && (value.type_total_count >= 1)) {
                    var typeSlugName;
                    var typeExtName;
                    for (var i = 1; i <= value.type_total_count; i++)
                    {
                        typeSlugName = value['type_' + i + '_slug'];
                        typeExtName = value['type_' + i + '_extension'];
                        row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                    }
                }
                
                if(value.regular_orders && value.regular_orders=='enable'){
                    row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
                }
                row;
            }

            var table  = "<tr>";
            table +="<td style='width:260px;'>"+row+"</td>";
            table += "<td style='width:260px;'>" + value.prod_qty_id+"</td>";
            table += "<td style='width:260px;'>" + value.product_name+" ("+value.product_sku+")</td>";
            table += "<td style='width:260px;'>" + $scope.UcCap(value.cust_name)+"</td>";
            table += "<td style='width:260px;'>" + value.total_qty+"</td>";
            table += "<td style='width:260px;'>" + value.weight+" lbs</td>";
            table += "<td style='width:260px;text-align:center;background-color:" + (value.color_code?value.color_code:'#8FB801') + "'>" + value.status+"</td>";
            table += "<td style='width:260px;text-align:center'>" + $scope.getGlobalDateFormat(value.created_time)+"</td>";
            if(value.is_ups == 1)
            {
                table += "<td style='width:260px;text-align:center'>";
                table += "<img width='30' height='30' src='"+$rootScope.upsUrl+"' >";
                table += "</td>";
            }
            table += "</tr>";
            angular.element('#tblOrder_1 tbody').prepend(table);
        }
        
        $scope.vmAdded = this;
        $scope.orderDetailsData = {};
        $scope.jobtypeArr = ['2D-3D','2D Flat','Redesign'];
        $scope.engravingArr = ['Add ENG','No ENG'];
        $scope.progressbar = ngProgressFactory.createInstance();
        $scope.progressbar.setHeight('5px');
        
        if($rootScope.searchStatus)
        {
            $scope.orderStatusSelected = {
                selected : {label:$rootScope.searchLable ,value:$rootScope.searchStatus}
            };
            $scope.dashboardBlock = $rootScope.dashboardBlockName;
        }
        else
        {
            $scope.orderStatusSelected = {
              selected:{}
            };
        }
        
        if($rootScope.globalsearchBy && $rootScope.globalSearch)
        {
            $timeout(function () {
                $scope.serchBy = $rootScope.globalsearchBy;
                $scope.SearchQuery = $rootScope.globalSearch;
                $scope.vmAdded.dtInstance.DataTable.draw();
            }, 100);
        }

        $timeout(function () {
            angular.element('.input-mini').attr('readonly',true);
        }, 1000);

        $rootScope.datePickerOrder = {};
        //$rootScope.datePickerOrder.date = $rootScope.datePicker.date;
        $rootScope.datePickerOrder.date={startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};

        if($rootScope.customerName)
        {
            $scope.datePickerOrderShow = false;
            $scope.customerName = $rootScope.customerName;
        }
        else {
            $scope.datePickerOrderShow = true;
        }

        $scope.onSelect = function(item, $model) {
        };

        $scope.apiSearchForOrderStatus = function (query)
        {
            if(!$rootScope.globals.currentUser || !$rootScope.globals.currentUser.statusPermission){
                return false;
            }
            var defaultStatus = $rootScope.globals.currentUser.statusPermission.toString();
            
            $http.post($rootScope.baseUrl + '/status/active',{status:query?query:'',defaultStatus:defaultStatus})
            .then(function (response)
            {
                var temp = []
                angular.forEach(response.data,function(value){
                    if($rootScope.searchStatus != value.status_label){
                        temp.push({label: value.status_label, value: value.status_code});
                    }
                });
                $scope.listOrderStatus = temp;
                angular.element(document).ready(function () {
                    angular.element('#orderStatus').selectpicker('refresh');
                });
            },
            function () {
            });
        }

        $scope.options = 
        {
            applyClass: 'btn-green',
            maxDate: moment(),
            locale: $rootScope.datePicker.locale,
            ranges: $rootScope.datePicker.options,
            eventHandlers : 
            {
                'apply.daterangepicker' : function() {
                     $scope.datePickerOrderShow = true;
                     $rootScope.datePickerOrder.date.startDate = moment($rootScope.datePickerOrder.date.startDate).format('YYYY-MM-DD');
                     $rootScope.datePickerOrder.date.endDate = moment($rootScope.datePickerOrder.date.endDate).format('YYYY-MM-DD');
                },
                'hide.daterangepicker':function() {
                    $rootScope.datePickerOrder.date.startDate = moment($rootScope.datePickerOrder.date.startDate).format('YYYY-MM-DD');
                    $rootScope.datePickerOrder.date.endDate = moment($rootScope.datePickerOrder.date.endDate).format('YYYY-MM-DD');
                }
            }
        }
        
        $scope.focusInput=function(){
            angular.element('#dateRange').focus();
        }
        $scope.showFilters = false;
        
        $scope.searchApply = function ()
        {
            var vm = this;
            if($scope.orderStatusSelected.selected)
            {
                $rootScope.searchStatus = $scope.orderStatusSelected.selected.value;
                $rootScope.searchLable = $scope.orderStatusSelected.selected.label;
            }
            else{
                $rootScope.searchStatus='';
            }

            if(vm.orderNumber == '')
            {
                $cookies.put('ShipmentNumber',undefined);
                $rootScope.shipmentOderNumber='';
            }
            
            $scope.vmAdded.dtInstance.DataTable.draw();
            $('#statusModelCompany').modal('hide');
        }

        $scope.orderListGlobalSearchLocal = function ()
        {
            var query = angular.element('#searchInput').val();
            if(!query){
               $scope.serchBy = 'Select Search By';
            } else {
               $scope.serchBy = 'Keyword';
            }

            $scope.SearchQuery = query;
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        var customeEventListener = $rootScope.$on("CallParentMethod", function(){
            $scope.orderListGlobalSearchLocal();
        });

        $scope.$on('$destroy', function()
        {
            customeEventListener();
            $scope.$on('CallParentMethod', function(event, data) {});
        });

        $scope.removeSingleFilter = function (type)
        {
            if(type == 'date')
            {
                $scope.datePickerOrderShow = false;
                $rootScope.datePickerOrder.date={};
            }
            else if(type == 'query')
            {
                $scope.serchBy = 'Select Search By';
                $scope.SearchQuery = '';
                $rootScope.globalsearchBy = '';
                $rootScope.globalSearch = '';
            }
            else if(type == 'customerName')
            {
                $scope.customerName = '';
                $rootScope.customerName = undefined;
            }
            else if(type == 'companyName')
            {
                  $scope.companyName = '';
            }
            else if(type == 'searchStatus')
            {
                $rootScope.searchStatus = undefined;
                $rootScope.searchLable = undefined;
                $scope.orderStatusSelected = {
                    selected:{}
                };
                angular.element(document).ready(function () {
                    angular.element('#orderStatus').selectpicker('refresh');
                });
            }
            else if(type == 'dashboardBlock')
            {
                $scope.dashboardBlock = undefined;
                $rootScope.dashboardBlockName = undefined;
            }
            else if(type == 'store') {
                $scope.store = '0';
            }
            else if(type == 'jobtype'){
                $scope.jobtype = '0';
            }
            else if(type == 'engraving'){
                $scope.engraving = '0';
            }
            else if(type == 'searchByType'){
                $scope.searchByType= '';
            }
            $scope.vmAdded.dtInstance.DataTable.draw();
        }
        
        $scope.resetSearch = function ()
        {
            $rootScope.searchStatus = undefined;
            $scope.orderStatusSelected = {
                selected:{}
            };
            
            angular.element(document).ready(function () {
                angular.element('#orderStatus').selectpicker('refresh');
            });
            
            that.orderNumber = '';
            that.soldTo = '';
            that.shipTo = '';
            $cookies.put('ShipmentNumber',undefined);
            $rootScope.shipmentOderNumber = undefined;
            $rootScope.customerName = undefined;
            $rootScope.searchLable = undefined;
            $scope.dashboardBlock = undefined;
            $rootScope.dashboardBlockName = undefined;
            $scope.serchBy = 'Select Search By';
            $scope.SearchQuery = '';
            $scope.customerName = '';
            $scope.companyName = '';
            $scope.store = '0';
            $scope.jobtype = '0';
            $scope.engraving = '0';
            $rootScope.datePickerOrder.date={startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $scope.vmAdded.dtInstance.DataTable.draw();
        }

        $scope.storeDataArrAssoc = {};
        $scope.getStoreData = function ()
        {
            $http.get($rootScope.baseUrl+'/store')
            .success(function (result) {
                $scope.storeData = result;
                angular.forEach($scope.storeData,function(value){
                    $scope.storeDataArrAssoc[value.store_id] = value.store_name;
                });
            }).error(function (error)
            {
                if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }
        var canceler = $q.defer();

        function serverData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            $scope.checkS =  canceler.resolve();
            canceler = $q.defer();
            var prmissionArr = [];
            if($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.statusPermission){
                prmissionArr = $rootScope.globals.currentUser.statusPermission.toString();
            }
            
            var log = [];
            var columname = '';
            var sortColmkey = '';
            angular.forEach(aoData[1].value, function (value, key)
            {
                if (value.data == 'created_at') {
                    columname = value.data
                    sortColmkey = key;
                }
            }, log);

            var sortColumnName=aoData[1].value[aoData[2].value[0].column].data;
            var requestData = {
                start: aoData[3].value,
                length: aoData[4].value,
                draw: aoData[0].value,
                order: aoData[2].value,
                search: aoData[5].value,
                columns: aoData[1].value,
                sortcolum:columname,
                sortColmkey: sortColmkey,
                search_column: $scope.serchBy?$scope.serchBy:'',
                query_string: $scope.SearchQuery?$scope.SearchQuery:'',
                customer_role:$rootScope.userRole,
                customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                customer_name: $scope.customerName?$scope.customerName:'',
                company_name: $scope.companyName?$scope.companyName:'',
                orderNumber: that.orderNumber?that.orderNumber:'',
                sold_to: that.soldTo?that.soldTo:'',
                ship_to: that.shipTo?that.shipTo:'',
                from_date:$scope.datePickerOrderShow? $scope.saveFromDateFormat($rootScope.datePickerOrder.date.startDate):'',
                to_date: $scope.datePickerOrderShow?$scope.saveToDateFormat($rootScope.datePickerOrder.date.endDate):'',
                sort_by_column_name: sortColumnName,
                search_type: $scope.searchByType?$scope.searchByType:'',
                request_page:$stateParams.type?$stateParams.type:''
            }

            requestData['order_status']='';
            requestData['dashboard_block_name']='';
            requestData['store_id']='all';
            requestData['jobtype']='';
            requestData['engraving']='';
            requestData['isglobalsearch']='no';
            requestData['defaultrangeglobalsearch']='';
            
            if($stateParams.type=='allOrders')
            {
                requestData['order_status']=$rootScope.searchStatus?$rootScope.searchStatus:prmissionArr;
                requestData['dashboard_block_name']=$rootScope.dashboardBlockName?$rootScope.dashboardBlockName:'';
                requestData['store_id']=($scope.store!='0')?$scope.store:'all';
                requestData['jobtype']=($scope.jobtype!='0')?$scope.jobtype:'';
                requestData['engraving']=($scope.engraving!='0')?$scope.engraving:'';
                requestData['isglobalsearch']=$scope.SearchQuery? 'yes':'no';
                requestData['defaultrangeglobalsearch']=$rootScope.defaultrangeglobalsearch?$rootScope.defaultrangeglobalsearch:'';
                if ($scope.serchBy == 'Keyword') {
                    requestData['isglobalsearch'] = 'yes';
                } else {
                    requestData['isglobalsearch'] = 'no';
                }
            }
            if($stateParams.type=='express')
            {
                requestData['order_status']= $cookies.get('expressStatus')?$cookies.get('expressStatus'):'';
                requestData['store_id']='all';
                requestData['group']='';
                requestData['isexpress']='yes';
            }
            if($stateParams.type=='supply')
            {
                requestData['order_status']= $cookies.get('supplyStatus')?$cookies.get('supplyStatus'):'';
                requestData['store_id']='all';
                requestData['group']='';
            }
            if($stateParams.type=='customer')
            {
                requestData['order_status']= $cookies.get('customersStatus')?$cookies.get('customersStatus'):'';
                requestData['ups']=true;
                requestData['store_id']='all';
                requestData['iscustmer']='yes';
            }
            if($stateParams.type=='rework')
            {
                requestData['order_status']= $cookies.get('reworkStatus')?$cookies.get('reworkStatus'):'';
                requestData['store_id']='all';
                requestData['group']='';
            }
            if($stateParams.type=='regular')
            {
                $rootScope.currentState='shipping-board.regular-status';
                requestData['order_status']= $rootScope.regularCode?$rootScope.regularCode:'';
                requestData['store_id']='all';
                requestData['customer_id']=$rootScope.storeListId?$rootScope.storeListId:0;
                requestData['from_date']=$rootScope.datePickerRegular?$scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate):'';
                requestData['to_date']= $rootScope.datePickerRegular?$scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate):'';
                requestData['dashboard_block_name'] = 'Regular Orders';
            }

            $http(
            {
                method: 'POST',
                url: $rootScope.baseUrl + '/shipment/getshipments',
                data: requestData,
                headers: {
                    'Content-type': 'application/json'
                },
                timeout: canceler.promise
            }).then(function(result) 
            {
                var fromDate = result.data.date_range.from_date;
                var toDate = result.data.date_range.to_date;
                
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                $rootScope.datePickerOrder.date = {};
                $rootScope.datePicker.date = {};
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                $rootScope.datePicker.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePicker.date.endDate = toDate.substr(0, toDate.indexOf(' '));
                
                $scope.supplyOrderTotal=result.data;
                
                var result = result.data.original;
                $scope.selected={};
                if(result.data < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                }
                else {
                    angular.element('.dataTables_paginate').show();
                }
                
                if(result)
                {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                }
                else
                {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }

                apiService.loaderHide();
                fnCallback(records);
            },
            function errorCallback(response)
            {
                if(response.status && response.status != -1){
                    apiService.loaderHide();
                }
            })
        };

        $scope.resetManualDate=function()
        {
            $rootScope.datePickerOrder.date={startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePickerOrder.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
        }

        /**
        * Order details method is use for redirect to product details page.
        * created on 10.06.2017
        */
        function orderDetails(data,type,full){
            return '<a href="" ng-click="open(\''+data+'\',\'' + 'order-details-popup' + '\',\''+full.entity_id+'\')" title="View Order" style="color:white;text-decoration: underline !important;">'+data+'</a>'
        }

        /**
        * Render with dollar method is use for show currency.
        * created on 10.06.2017
        */
        $scope.renderWithDollar=function(data){
            return '$'+parseFloat(data).toFixed(2);
        }

        /**
         * Render shipping to user name else -
         */
        function renderShipToName(data,type,full)
        {
            if (data) {
                return data;
            } else {
                return ' - ';
            }
        }

        /**
         * Render with total Qty
         */
        function renderOrderTotalQty(data,type,full)
        {
            if (data) {
                return data;
            } else {
                return ' - ';
            }
        }


        /**
        * Compile row method is use for compile row in angular.
        * created on 10.06.2017
        */
        function compileRow(row,data)
        {
            $(row).css("background-color", data.color_code?data.color_code:"#8FB801");
            $compile(angular.element(row).contents())($scope);
        }

        function compileHeader(header)
        {
            if (!that.headerCompiled) {
                // Use this headerCompiled field to only compile header once
                that.headerCompiled = true;
                $compile(angular.element(header).contents())($scope);
            }
        }

        /**
        * Init complete method is use for add class on DOM of datatable.
        * created on 10.06.2017
        */
        function initComplete(row,data)
        {
            angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
            angular.element('.dataTables_filter input').attr('class', 'form-control');
            angular.element('.dataTables_length select').attr('class', 'form-control');
            angular.element('.buttons-collection').attr('class', 'form-control');
        }

        /**
         * checkShowCheckBoxOrNot method is used for show hide checkboox by fields.
         * created on 10.09.2017
         */
        $scope.checkShowCheckBoxOrNot = function(type)
        {
            var checkBoxArr = [
                'Orientation',
                'Extra People',
                'Special Instructions',
                'Enter Your Engraving',
                'Background',
                'commentAdded',
                'product Name'
            ];
            if(checkBoxArr.indexOf(type) != -1){
                return true;
            }
            return false;
        }

        /**
         * getHtmlDataText method is used get content from html string.
         * created on 02.20.2018
         */
        $scope.getHtmlDataText = function(text)
        {
            if(/^/.test(text)){
                var div = document.createElement("div");
                div.innerHTML = text;
                return div.textContent || div.innerText || "";
            }
            return text;
        }

        /**
         * checkIsTextArea method is used identify field are text area.
         * created on 10.09.2017
         */
        $scope.checkIsTextArea = function(type)
        {
            var textAreaArr = [
                'Any Special Instructions?',
                'Enter Your Engraving',
                'Special Instruction',
                'Add Free Engraving',
                'Special Instructions'
            ];
            if(textAreaArr.indexOf(type) != -1){
                return true;
            }
            return false;
        }

        /**
         * Get data table method is use for get list of users.
         * created on 09.27.2017
         */
        var titleHtml = '<label class="custom-checkbox"><input type="checkbox" ng-disabled="!isSelected.select" ng-model="selectAll" ng-click="toggleAll(selectAll, selected)"><span>Select All</span></label>';
        $scope.orderDom= "<'row'<'col-md-3 clearfix'l><'col-md-6 form-group clearfix mt-5px'p><'col-md-3' ZB>>" +
        "<rt>"+"<'row'<'col-md-5'i><'col-md-7'p>><'clear'>";
        $scope.getDataTable = function()
        {
            var vm = this;
            var orderFromTitle='Order From';
            if($stateParams.type=='customer'){
              orderFromTitle='Customer Name';
            }
            var totalPermission = 0;
            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable()
              .renderWith(function(data, type, full, meta) {
                $scope.selected[data.shipment_order_id] = false;
                return '<label class="custom-checkbox"><input type="checkbox" ng-disabled="!isSelected.select" ng-model="selected[\'' + data.shipment_order_id + '\']" ng-click="toggleOne(selected)"><span></span></label>';
              }));

            vm.dtColumns.push(DTColumnBuilder.newColumn('DT_Row_Index').withTitle('Sr.No').withOption('orderable', false));
            
            if($rootScope.permissionArr.indexOf('order_number_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_order_number').withTitle('Shipment Number').renderWith(orderDetails));
            }

            if($rootScope.permissionArr.indexOf('order_from_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('sold_to').withTitle('Sold To'));
            }

            if($rootScope.permissionArr.indexOf('order_to_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to').withTitle('Ship To'));
            }

            if($rootScope.permissionArr.indexOf('order_total_quantity_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('total_items').withTitle('Total Qty').renderWith(renderOrderTotalQty));
            }
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_by').withTitle('Created By'));

            if($rootScope.permissionArr.indexOf('order_status_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableDate'));
            }

            if($rootScope.permissionArr.indexOf('order_date_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            }

            if($rootScope.permissionArr.indexOf('delete_awaiting_shipment') != -1)
            {
                vm.dtColumns.push(DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function(data, type, full, meta) {
                    return '<a href="javascript:void(0);"  ng-click="openModal(\'' + 'app/pages/shipment/orderReadyToShip/deleteModal.html' + '\',\'' + data.shipment_order_id + '\',0)" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';
                }));
            }

            
            var log = [];
            var sortColNum = ($rootScope.orderDefaultSort+1);
            if (totalPermission <= 6) {
                sortColNum = 1;
                var columname = '';
              angular.forEach(vm.dtColumns, function(value, key) {
                if(value.mData=='created_at'){
                    columname = value.mData;
                    sortColNum = key;
                }

               },log);
            }


            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                .withOption('serverSide', true)
                .withPaginationType('simple_numbers')
                .withOption('deferRender', true)
                .withOption('searching', true)
                .withOption('autoWidth', false)
                .withOption('sDom', $scope.orderDom)
                .withOption('bLengthChange', true)
                .withOption('order', [sortColNum, 'desc'])
                .withOption('iDisplayLength', ($rootScope.numberOfRecord-1) )
                .withOption('bInfo', true)
                .withButtons($scope.colvisOption)
                .withOption('oLanguage',{ "sSearch": "" })
                .withOption('createdRow',compileRow)
                .withOption('headerCallback',compileHeader)
                .withOption('initComplete', initComplete);
            $scope.vmAdded = vm;
            $rootScope.vmAddedNew = vm
        };

        $scope.getDataTableShipped = function()
        {
            var vm = this;
            var totalPermission = 0;

            vm.dtColumns = [];
            vm.dtColumns.push(DTColumnBuilder.newColumn(null).withTitle(titleHtml).notSortable()
              .renderWith(function(data, type, full, meta) {
                $scope.selected[data.shipment_order_id] = false;
                return '<label class="custom-checkbox"><input type="checkbox" ng-disabled="!isSelected.select" ng-model="selected[\'' + data.entity_id + '\']" ng-click="toggleOne(selected)"><span></span></label>';
              }));

            vm.dtColumns.push(DTColumnBuilder.newColumn('DT_Row_Index').withTitle('Sr.No').withOption('orderable', false));

            if($rootScope.permissionArr.indexOf('order_number_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('shipment_order_number').withTitle('Shipment Number').renderWith(orderDetails));
            }

            if($rootScope.permissionArr.indexOf('order_from_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('sold_to').withTitle('Sold To'));
            }

            if($rootScope.permissionArr.indexOf('order_to_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('ship_to').withTitle('Ship To'));
            }

            if($rootScope.permissionArr.indexOf('order_total_quantity_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('total_items').withTitle('Total Qty').renderWith(renderOrderTotalQty));
            }

            if($rootScope.permissionArr.indexOf('shipment_order_store_name') != -1)
            {
                //totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('store_name').withTitle('Store').withOption('orderable', false));
            }

            if($rootScope.permissionArr.indexOf('shipment_order_account_name') != -1)
            {
                //totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('account_name').withTitle('Shipment Account').withOption('orderable', false));
            }
            
            vm.dtColumns.push(DTColumnBuilder.newColumn('created_by').withTitle('Created By'));
            vm.dtColumns.push(DTColumnBuilder.newColumn('shipped_by').withTitle('Shipped By'));

            if($rootScope.permissionArr.indexOf('order_status_column') != -1)
            {
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableDate'));
            }

            if($rootScope.permissionArr.indexOf('order_date_column') != -1){
                totalPermission = totalPermission + 1;
                vm.dtColumns.push(DTColumnBuilder.newColumn('created_at').withTitle('Order Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
                vm.dtColumns.push(DTColumnBuilder.newColumn('shipped_at').withTitle('Shipped Date').renderWith($scope.getGlobalDateFormat).withOption('className', 'tableDate'));
            }

            

            var log = [];
            var sortColNum = ($rootScope.orderDefaultSort+1);
            if (totalPermission <= 6) {
                sortColNum = 1;
                var columname = '';
              angular.forEach(vm.dtColumns, function(value, key) {
                if(value.mData=='created_at'){
                    columname = value.mData;
                    sortColNum = key;
                }

               },log);
            }

            vm.dtInstance = {};
            vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverShippedData)
            .withOption('serverSide', true)
            .withPaginationType('simple_numbers')
            .withOption('deferRender', true)
            .withOption('searching', true)
            .withOption('autoWidth', false)
            .withOption('sDom', $scope.orderDom)
            .withOption('bLengthChange', true)
            .withOption('order', [sortColNum, 'desc'])
            .withOption('iDisplayLength', ($rootScope.numberOfRecord-1) )
            .withOption('bInfo', true)
            .withButtons($scope.colvisOption)
            .withOption('oLanguage',{ "sSearch": "" })
            .withOption('createdRow',compileRow)
            .withOption('headerCallback',compileHeader)
            .withOption('initComplete', initComplete);

            $scope.vmAdded = vm;
            $rootScope.vmAddedNew = vm
        };

        function serverShippedData(sSource, aoData, fnCallback, oSettings)
        {
            apiService.loaderShow();
            var columname = '';
            var sortColmkey = '';

            var storePrmissionArr = [];
            if($rootScope.globals && $rootScope.globals.currentUser && $rootScope.globals.currentUser.store_permission){
               storePrmissionArr = $rootScope.globals.currentUser.store_permission.toString();
            }

            var log = [];
            angular.forEach(aoData[1].value, function (value, key)
            {
                if (value.data == 'created_at') {
                    columname = value.data
                    sortColmkey = key;
                }
            }, log);

            var sortColumnName=aoData[1].value[aoData[2].value[0].column].data;
            
            var requestData = 
            {
                start: aoData[3].value,
                length: aoData[4].value,
                draw: aoData[0].value,
                order: aoData[2].value,
                search: aoData[5].value,
                columns: aoData[1].value,
                sortcolum:columname,
                sortColmkey: sortColmkey,
                search_column: $scope.serchBy?$scope.serchBy:'',
                query_string: $scope.SearchQuery?$scope.SearchQuery:'',
                customer_role:$rootScope.userRole,
                customer_id:($rootScope.userRole=='ROLE_CUSTOMER' || $rootScope.userRole=='ROLE_SUB_CUSTOMER')?$rootScope.customerId:0,
                customer_name: $scope.customerName?$scope.customerName:'',
                company_name: $scope.companyName?$scope.companyName:'',
                orderNumber: $scope.orderNumber?$scope.orderNumber:that.orderNumber?that.orderNumber:'',
                sold_to: that.soldTo?that.soldTo:'',
                ship_to: that.shipTo?that.shipTo:'',
                from_date:$scope.datePickerOrderShow? $scope.saveFromDateFormat($rootScope.datePickerOrder.date.startDate):'',
                to_date: $scope.datePickerOrderShow?$scope.saveToDateFormat($rootScope.datePickerOrder.date.endDate):'',
                sort_by_column_name: sortColumnName,
                search_type: $scope.searchByType?$scope.searchByType:'',
                request_page:$stateParams.type?$stateParams.type:''
            }

            requestData['order_status']='';
            requestData['dashboard_block_name']='';
            requestData['store_id']=storePrmissionArr;
            requestData['isglobalsearch']='no';
            requestData['defaultrangeglobalsearch']='';

            $http(
            {
                method: 'POST',
                url: $rootScope.baseUrl + '/shipment/getshipped',
                data: requestData,
                headers: {
                    'Content-type': 'application/json'
                },
                timeout: canceler.promise
            }).then(function(result) 
            {
                var fromDate = result.data.date_range.from_date;
                var toDate = result.data.date_range.to_date;

                $rootScope.datePickerOrder.date = {};
                $rootScope.datePickerOrder.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePickerOrder.date.endDate = toDate.substr(0, toDate.indexOf(' '));

                $rootScope.datePicker.date = {};
                $rootScope.datePicker.date.startDate = fromDate.substr(0, fromDate.indexOf(' '));
                $rootScope.datePicker.date.endDate = toDate.substr(0, toDate.indexOf(' '));

                $scope.supplyOrderTotal=result.data;

                var result = result.data.original;
                $scope.selected={};
                if(result.data < $rootScope.numberOfRecord)
                {
                    $timeout(function () {
                        angular.element('.dataTables_paginate').hide();
                    }, 200);
                }
                else {
                    angular.element('.dataTables_paginate').show();
                }
                
                if(result)
                {
                    var records = {
                        'draw': result.draw,
                        'iTotalDisplayRecords': result.recordsFiltered,
                        'iTotalRecords': result.recordsTotal,
                        'aaData': result.data
                    };
                }
                else
                {
                    var records = {
                        'draw': 1,
                        'iTotalDisplayRecords': 0,
                        'iTotalRecords': 0,
                        'aaData': []
                    };
                }

                apiService.loaderHide();
                fnCallback(records);
            },
            function errorCallback(response)
            {
                if(response.status && response.status != -1){
                    apiService.loaderHide();
                }
            });
        }

        $scope.deleteShipment = function()
        {
            if ($rootScope.deleteId)
            {
                apiService.loaderShow();
                $http.delete($rootScope.baseUrl + '/shipment/' + $rootScope.deleteId)
                .success(function(result)
                {
                    if (result.status == 'success')
                    {
                      toastr.success(result.message);
                      $state.go($state.$current, null, {
                          reload: true
                      });
                    } else {
                      toastr.error("Something went wrong please try again.");
                    }
                    apiService.loaderHide();
                })
                .error(function (error)
                {
                    apiService.loaderHide();
                    if (error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            $scope.popupShow.close();
        };

        /**
         * Open model.
         * created on 11.14.2019
         */
        $scope.openModal = function(page, id, status)
        {
          $rootScope.deleteId = id;
          $rootScope.status = status;
          $scope.popupShow = $uibModal.open({
            animation: true,
            templateUrl: page,
            scope: $scope,
          });
        };

        /**
         * Open Order Details model.
         * created on 10.09.2017
         */
        $scope.open = function (id, size,entityId)
        {
            var vm = this;
            vm.account = '';
            vm.weight_lbs = 0;
            vm.weight_oz = 0;
            vm.shippingservice = '';
            vm.account = '';
            vm.shippingservicetype  = '';
            vm.package1 = '';
            vm.package = '';
            vm.len = 0;
            vm.wgh = 0;
            vm.hgt = 0;
            vm.total_weight = 0;
            vm.account = '';
            vm.shippingservice = $scope.defaultService;
            vm.shippingservicetype = '';

            $scope.packagesaved = false;

            $scope.getRateDone = true;
            $scope.order_total_weight = 0;
            $scope.custom_packages = 0;

            $scope.packagesdata = [];
            $scope.ShipmentBoxes = [];
            $scope.ShipmentServiceBoxes = [];
            $scope.ShipmentAccounts = [];
            $scope.orderDetailsData = [];

            $scope.commentDataArr = [];
            $scope.officeCommentDataArr = [];
            $scope.addOnDataArr = [];
            $scope.orderAddress = [];
            $scope.addOneData = [];
            $scope.fileRawMaterial = [];
            $scope.shipmentServiceType = [];
            $scope.trackingData = [];

            $scope.isQaStart=false;
            $rootScope.orderId = id;
            $rootScope.orderEntityId=entityId;
            $rootScope.popupSize = $(window).height();
            $rootScope.popupSize = ($rootScope.popupSize-60);
            $rootScope.popupSizeMin = ($rootScope.popupSize-50);
            $rootScope.borderSize=($rootScope.popupSizeMin-100);
            
            $scope.getOrderDetails();

            $scope.getShipmentBoxes();
            $scope.getTrackingData();
            $scope.getOrderAddress();
            
            $scope.getOrderVerify();

            $scope.getOrderDetailsData();
            
            $scope.getCommentData();
            
            jQuery("#downloadlabelpdf").html('');
            jQuery("#btncreatelabel").show();
            $scope.killOrderListTimer();
            $('#orderDetailsModel').modal();
        };

        $scope.getCommentData = function ()
        {
            $http.get($rootScope.baseUrl + '/shipment/getShipmentComment/'+$rootScope.orderId).then(
            function (response) {
                if(response.data.status == 'success')
                {
                    var commentArray = response.data;
                    $scope.commentDataArr = commentArray.comments;
                }
            },
            function (error) {
            });
        }

        $scope.getShipemts = function ()
        {
            $scope.shippingservicetype  = '';
            if($scope.defaultService != '')
            {
                $scope.orderServiceType = [];
                $scope.ShipmentAccounts = [];
            
                $scope.getShipmentAccounts($scope.defaultService);
                $scope.getServiceType($scope.defaultService);
            }
        };

        $scope.getTrackingData = function ()
        {
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/shipment/mastertracking/'+$rootScope.orderId).then(
            function (response) {
                apiService.loaderHide();
                if(response.data.status == 'success'){
                    var mainArray = response.data.data;

                    $scope.trackingData = mainArray.trackingData;
                }
                $scope.disableQaStart=false;
            },
            function (error) {
              $scope.disableQaStart=false;
                apiService.loaderHide();
            });
        };

        $scope.getShipmentAccounts = function(service)
        {
            if(service == '') {
                service = $scope.defaultService;    
            }
            $scope.getShipmentServiceBoxes(service);
            $scope.ShipmentAccounts = [];
            $http.get($rootScope.baseUrl + '/shipment/active-account/'+service)
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else
              {
                var data = { };

                $.each( result, function( i, val ) {
                  $scope.ShipmentAccounts.push(val);
                });
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });

          var vm = this;

          if(service == 'fedex') {
            vm.account = $scope.defaultFedex;
          }
          else if(service == 'usps') {
            vm.account = $scope.defaultUSPS;
          }
          else if(service == 'office') {
            vm.account = $scope.defaultOffice;
          }
        };

        $scope.getShipmentSettingStatus = function()
        {
          $http.get($rootScope.baseUrl + '/config/shipmentSetting')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else if (result.data)
              {
                var resultData = result.data;
                var shipmentSetting = resultData.shipment_settings;
                $scope.customerStatus = shipmentSetting.customerStatus;
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        };

        $scope.getShipmentBoxes = function()
        {
            $http.get($rootScope.baseUrl + '/shipment/getactiveboxes')
            .success(function(result)
            {
                if (result)
                {
                    if (result.status == 'fail') {
                        toastr.error(result.message);
                    }
                    else
                    {
                        var data = {};
                        $.each( result, function( i, val ) {
                            data = { 
                                id: val.box_id,
                                name: val.box_name
                            };
                            $scope.ShipmentBoxes.push(data);
                        });
                    }
                }
            })
            .error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
                }
            });
        };

        $scope.getShipmentServiceBoxes = function (service)
        {
          $scope.ShipmentServiceBoxes = [];
          if(service)
          {
            $http.get($rootScope.baseUrl + '/shipment/getactiveserviceboxes/'+service)
            .success(function(result)
            {
              if (result)
              {
                var data = { };

                $.each( result, function( i, val ) {
                  data = { 
                    service_box_3dcode: val.service_box_3dcode,
                    service_box_label: val.service_box_label
                  };
                  $scope.ShipmentServiceBoxes.push(data);
                });
              }
            })
            .error(function(error)
            {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
              }
            });
          }
        };

        $scope.subTabSelected = function (QtyId) {
            $scope.selectedQtyId = QtyId;
        };

        $scope.tabSelected = function (item_id)
        {
            scope.selectedId = item_id;
            setTimeout(function(){
                $("li.single-right-tab").parent().css('display','none');
                angular.element('.product-name').selectpicker('refresh');
            }, 100);
        };

        $scope.closePopup=function()
        {
            $rootScope.orderId=undefined;
            $('#orderDetailsModel').modal('hide');
            jQuery("#displayRate").html('');
            jQuery("#displayDays").html("");
            $scope.orderDetailsData = [];
            $scope.commentDataArr = [];
            $scope.officeCommentDataArr = [];
            $scope.addOnDataArr = [];
            $scope.orderAddress = [];
            $scope.addOneData = [];
            $scope.shipmentServiceType = [];
            $scope.killOrderDetailsTimer();
            $scope.killOrderCommentTimer();
            $scope.killOrderOfficeCommentTimer();
            $scope.startOrderListTimer();
            $scope.vmAdded.dtInstance.DataTable.draw( false );
        }

        $scope.closeOrderLogs = function (id,page) {
            $('#orderLogsModel').modal('hide');
        };

        $scope.EnableScan = function () 
        {
            $scope.duplicateCheck = [];
            $scope.duplicateCheckRow = [];
            $scope.isloaded = true;
            $scope.updatedItem = [];
            $scope.showItemUpdated = false;
            $scope.showItemScanned = true;
            $scope.isloadedDepartment = false;
            angular.element('#scanStart').show();
        }

        $scope.changeShippingService = function (service)
        {
            $("#getRate").hide();
            $("#displayRate").html("");
            $("#displayDays").html("");
            var vm = this;
            if(service != null)
            {
              if(service == 'office')
              {
                $("#rowRate").hide();
                $("#rowDeliveryTime").hide();
                $("#rowCreateLable").hide();
                $("#rowSatDel").hide();
                $("#rowOffice").show();
              }
              else
              {
                $("#rowRate").show();
                $("#rowDeliveryTime").show();
                $("#rowCreateLable").show();
                $("#rowSatDel").show();
                $("#rowOffice").hide();
              }
                var offset = 0;
                $scope.orderServiceType = [];
                $scope.ShipmentAccounts = [];
                vm.shippingservicetype = '';
                vm.account = '';
                vm.package = '';
                $scope.getShipmentAccounts(service);
                $http.get($rootScope.baseUrl + '/shipment/'+$rootScope.orderId+'/'+offset+'/0').then(
                function (response) {
                    apiService.loaderHide();
                    if(response.data.status == 'success'){
                        var mainArray = response.data.data;

                        $scope.orderDetailsData = mainArray;
                        $scope.shippingservicetype = '';
                        if(service == 'fedex') {
                        vm.account = mainArray.orderData.account_fedex;
                        }
                        else if(service == 'usps') {
                        vm.account = mainArray.orderData.account_usps;
                        }
                        $scope.getServiceType(service);
                    }
                    $scope.disableQaStart=false;
                },
                function (error) {
                  $scope.disableQaStart=false;
                    apiService.loaderHide();
                });
            }
            else
            {
                vm.account = '';
                vm.packageservice = '';
                $("#package_service option:first").attr('selected',true);
            }
        };

        $scope.openWarning = function (page, size)
        {
            $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: page,
              scope:$scope,
              backdrop: 'static',
              keyboard: false,
              windowClass: 'testclass',
            });
        };

        $scope.changeShippingAccount = function (accountId)
        {
            $("#getRate").hide();
                $("#displayRate").html("");
                $("#displayDays").html("");
            var vm = this;
            if(accountId != '')
            {
                if(vm.shippingservice == 'fedex' && $scope.defaultFedex != accountId) {
                  $scope.openWarning('app/pages/shipment/orderReadyToShip/warningModal.html');
                }
                else if(vm.shippingservice == 'usps' && $scope.defaultUSPS != accountId) {
                  $scope.openWarning('app/pages/shipment/orderReadyToShip/warningModal.html');
                }
            }
            else
            {
                $scope.getRateDone = true;
                
                toastr.error("Please select account");
            }
        };

        $scope.yeschange = function() {
            $scope.getRateCheck();
        };

        $scope.nochange = function()
        {
          var vm = this;
          if(vm.shippingservice == 'fedex') {
            vm.account = $scope.defaultFedex;
          }
          else if(vm.shippingservice == 'usps') {
            vm.account = $scope.defaultUSPS;
          }
          else if(vm.shippingservice == 'office') {
            vm.account = $scope.defaultOffice;
          }
          $("#account").val(vm.account);
        };

        $scope.dismiss = function() {
            $scope.getRateCheck();
        };

        $scope.changeShippingServiceType = function (service_type)
        {
            $("#getRate").hide();
                $("#displayRate").html("");
                $("#displayDays").html("");
            if(service_type != null) {
                $scope.getRateCheck();
            }
            else 
            {
                vm.packageservicetype = '';
                $("#package_service_type option:first").attr('selected',true);
            }
        }

        $scope.changeShippingPackageType = function (package_type)
        {
            $("#getRate").hide();
                $("#displayRate").html("");
                $("#displayDays").html("");
            if(package_type != null)
            {
                if(package_type > 0)
                {
                    $("#main_package_type").val('YOUR_PACKAGING');
                    $scope.adpkg = true;
                    $http.post($rootScope.baseUrl + '/shipment/get-box-details', {
                        id:package_type
                    })
                    .success(function(result)
                    {
                        if(result.status == 'success')
                        {
                            var boxdetails = result.boxdetails;
                            var size = boxdetails.box_size.split('X');
                            $("#len").val(size[0]);
                            $("#wgh").val(size[1]);
                            $("#hgt").val(size[2]);
                            $scope.getRateCheck();
                        }
                        else if(result.status == 'fail') {
                            toastr.error(result.message);
                        }
                    })
                    .error(function (error)
                    {
                        apiService.loaderHide();
                        if (error && error.code != undefined && error.code == 0) {
                            toastr.error(error.message);
                        }
                        else {
                            toastr.error("Something went wrong please try again.");
                        }
                    });
                }
                else if(package_type != '')
                {
                    $("#main_package_type").val(package_type);
                    $scope.adpkg = true;
                    $scope.getRateCheck();
                }
            }
            else
            {
                $scope.adpkg = false;
                $("#main_package_type").val('');
                $("#main_package_type option:first").attr("select",true);
                $("#len").val('');
                $("#wgh").val('');
                $("#hgt").val('');
            }
        };

        $scope.changePackageService = function (service)
        {
            if(service != null)
            {
                $("#service option:first").removeAttr('selected');
                $("#service").val(service);
                $scope.shippingservice = service;
            }
            else {
                $scope.shippingservice = '';
                $("#service option:first").attr('selected',true);
            }
        }

        $scope.changePackageServiceType = function (service_type)
        {
            if(service_type != null)
            {
                $("#service_type option:first").removeAttr('selected');
                $("#service_type").val(service_type);
                $scope.shippingservicetype = service_type;
            }
            else {
                $scope.shippingservicetype = '';
                $("#service_type option:first").attr('selected',true);
            }
        }

        $scope.openPackageCreate = function ()
        {
            if(!$scope.packagesaved)
            {
                var package_type = $("#package").val();
                if(package_type > 0) {
                  $scope.adpkg = true;
                }
                else if(package_type != '') {
                  $scope.adpkg = true;
                }
                else {
                  $scope.adpkg = false;
                }
                $scope.custom_packages = 0;
                $scope.packagesdata = [];
                $("#packagesrow1").html('');
                $("#description").val('');
                $("#package_type").removeClass('ng-not-empty');
                $("#package_type").addClass('ng-empty');
            }
            else
            {
                $("#packagesrow1").html('');
                $("#description").val('');
                $("#len").val('');
                $("#wgh").val('');
                $("#hgt").val('');
                $("#weight").val('');
                $("#package_type").removeClass('ng-not-empty');
                $("#package_type").addClass('ng-empty');
                $scope.custom_packages = 0;

                $.each( $scope.packagesdata, function( idx, val ) {
                  $scope.addpackage();
                  $("#description"+(idx+1)).val(val.package_description);
                  $("#weight"+(idx+1)).val(val.weight);
                  $("#len"+(idx+1)).val(val.length);
                  $("#wgh"+(idx+1)).val(val.width);
                  $("#hgt"+(idx+1)).val(val.height);
                });
            }
            $('#packageModel').modal();
        };

        $scope.addpackage = function ()
        {
            var main_package_type = $("#main_package_type").val();
            
            var clone = $("#packagesrow .pkgrow").clone();
            var length = $(".pkgrow").length;
            clone.attr("id", "pkgrow"+length);

            clone.find(".panel-title").html("Package #"+length);
            clone.find("#description").attr("id","description"+length);
            clone.find("#description"+length).val("Package #"+length);
            clone.find("#custompackagetype").attr("id","custompackagetype"+length);
            
            clone.find("#package_type > option").removeAttr("ng-repeat");
            clone.find("#package_type > option").removeAttr("class");

            var pt = clone.find("#package_type");
            pt.attr("id","package_type"+length);
            pt.attr("ng-model","package_type"+length);
            pt.attr("ng-change","changePackageType("+length+")");

            clone.find("#len").attr("id","len"+length);
            clone.find("#wgh").attr("id","wgh"+length);
            clone.find("#hgt").attr("id","hgt"+length);
            clone.find("#weight").attr("id","weight"+length);

            clone.find(".copy").attr("ng-click","clonepackage("+length+")");
            clone.find(".remove").attr('ng-click',"removePackage("+length+")");

            var temp = $compile(clone)($scope);
            $("#packagesrow1").append(temp);
            $("#package_type"+length).removeClass('ng-not-empty');
            $("#package_type"+length).addClass('ng-empty');
            
            if(main_package_type == 'YOUR_PACKAGING') {
              $("#custompackagetype"+length).show();
            }
            else {
              $("#custompackagetype"+length).hide();
            }
            $('#package1 option').removeAttr("selected");
            $("#package1").val(main_package_type);
            $('#package1 option[value="'+main_package_type+'"]').attr('selected', true);
            
            $scope.custom_packages++;
        }

        $scope.clonepackage = function (index)
        {
            $("#service_type option:first").attr('selected',true);
            var main_package_type = $("#main_package_type").val();
            
            var clone = $("#packagesrow .pkgrow").clone();
            clone.attr("id", "pkgrow"+(index+1));

            clone.find(".panel-title").html("Package #"+(index+1));
            clone.find("#description").attr("id","description"+(index+1));
            clone.find("#description"+(index+1)).val("Package #"+(index+1));
            clone.find("#custompackagetype").attr("id","custompackagetype"+(index+1));
            
            clone.find("#package_type > option").removeAttr("ng-repeat");
            clone.find("#package_type > option").removeAttr("class");

            var pt = clone.find("#package_type");
            pt.attr("id","package_type"+(index+1));
            pt.attr("ng-model","package_type"+(index+1));
            pt.attr("ng-change","changePackageType("+(index+1)+")");

            clone.find("#len").attr("id","len"+(index+1));
            clone.find("#wgh").attr("id","wgh"+(index+1));
            clone.find("#hgt").attr("id","hgt"+(index+1));
            clone.find("#weight").attr("id","weight"+(index+1));

            clone.find(".copy").attr("ng-click","clonepackage("+(index+1)+")");
            clone.find(".remove").attr('ng-click',"removePackage("+(index+1)+")");

            var temp = $compile(clone)($scope);
            $("#packagesrow1").append(temp);
            $("#package_type"+(index+1)).removeClass('ng-not-empty');
            $("#package_type"+(index+1)).addClass('ng-empty');
            
            if(main_package_type == 'YOUR_PACKAGING') {
              $("#custompackagetype"+(index+1)).show();
            }
            else {
              $("#custompackagetype"+(index+1)).hide();
            }
            $('#package1 option').removeAttr("selected");
            $("#package1").val(main_package_type);
            $('#package1 option[value="'+main_package_type+'"]').attr('selected', true);
            
            $scope.custom_packages++;
        }

        $scope.removePackage = function (index)
        {
            $("#pkgrow"+index).remove();
            $scope.custom_packages--;

            if($scope.custom_packages <= 0) {
              $scope.packagesaved = false;
            }
        }

        $scope.changeMainPackageType = function(package_type)
        {
            $('#package1 option').removeAttr("selected");
            $("#package1").val(package_type);
            $('#package1 option[value="'+package_type+'"]').attr('selected', true);
            if(package_type == 'YOUR_PACKAGING')
            {
              $scope.adpkg = true;
              var i = 1;
              $('#packagesrow1 .pkgrow').each(function (index, value) {
                $("#custompackagetype"+i).show();
                i++;
              });

            }
            else if(package_type != '')
            {
              $scope.adpkg = true;
              var i = 1;
              $('#packagesrow1 .pkgrow').each(function (index, value) {
                $("#custompackagetype"+i).hide();
                i++;
              });
            }
            else
            {
              $scope.adpkg = false;
              var i = 1;
              $('#packagesrow1 .pkgrow').each(function (index, value) {
                $("#custompackagetype"+i).hide();
                i++;
              });
            }
        };

        $scope.changePackageType = function (index)
        {
            var package_type = $("#package_type"+index).val();
            if(package_type > 0)
            {
              $http.post($rootScope.baseUrl + '/shipment/get-box-details', {
                id:package_type
              }).success(function(result) {
                if(result.status == 'success')
                {
                  var boxdetails = result.boxdetails;

                  var size = boxdetails.box_size.split('X');
                  $("#len"+index).val(size[0]);
                  $("#wgh"+index).val(size[1]);
                  $("#hgt"+index).val(size[2]);
                }
                else if(result.status == 'fail')
                {
                  toastr.error(result.message);
                }
                
              })
              .error(function (error) {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
              });
            }
            else
            {
              $("#len"+index).val('');
              $("#wgh"+index).val('');
              $("#hgt"+index).val('');
            }
        }

        $scope.savePackages = function ()
        {
            var length = $("#packagesrow1 .pkgrow").length;
            var validated = false;
            var i = 1;

            var total_lbs = 0;
            var total_oz = 0;

            var package_service_type = $("#package_service_type").val();
            var main_package_type = $("#main_package_type").val();

            if(main_package_type != '')
            {
                $("#package").val(main_package_type);
                $('#packagesrow1 .pkgrow').each(function (index, value)
                {
                    var package_description = $("#description"+i).val();
                    if(main_package_type == 'YOUR_PACKAGING') {
                        var package_type = $("#package_type"+i).val();
                    } else {
                        var package_type = main_package_type;
                    }

                    if(package_description != null)
                    {
                        if(package_description != '')
                        {
                            if(package_type != '')
                            {
                                var weight = parseFloat($("#weight"+i).val());
                                if(weight != null && weight != '' && weight > 0)
                                {
                                    if(main_package_type == 'YOUR_PACKAGING')
                                    {
                                        var length = parseFloat($("#len"+i).val());
                                        if(length != null && length != '' && length > 0)
                                        {
                                            var width = parseFloat($("#wgh"+i).val());
                                            if(width != null && width != '' && width > 0)
                                            {
                                                var height = parseFloat($("#hgt"+i).val());
                                                if(width != null && width != '' && width > 0)
                                                {
                                                    $scope.shippingChange = false;

                                                    total_lbs = (total_lbs + weight);
                                                    $scope.packagesdata[(i-1)] = {
                                                        main_package_type:main_package_type,
                                                        package_service_type:package_service_type,
                                                        package_description:package_description,
                                                        package_type:package_type,
                                                        weight:weight,
                                                        length:length,
                                                        width:width,
                                                        height:height
                                                    };
                                                    validated = true;
                                                }
                                                else
                                                {
                                                    toastr.error("Please enter package #"+i+" height");
                                                    validated = false;
                                                }
                                            }
                                            else
                                            {
                                                toastr.error("Please enter package #"+i+" width");
                                                validated = false;
                                            }
                                        }
                                        else
                                        {
                                            toastr.error("Please enter package #"+i+" length");
                                            validated = false;
                                        }
                                    }
                                    else
                                    {
                                        var length = parseFloat($("#len"+i).val());
                                        var width = parseFloat($("#wgh"+i).val());
                                        var height = parseFloat($("#hgt"+i).val());
                                        $scope.shippingChange = false;

                                        total_lbs = (total_lbs + weight);
                                        $scope.packagesdata[(i-1)] = {
                                            main_package_type:main_package_type,
                                            package_service_type:package_service_type,
                                            package_description:package_description,
                                            package_type:package_type,
                                            weight:weight,
                                            length:length,
                                            width:width,
                                            height:height
                                        };
                                        validated = true;
                                    }
                                }
                                else
                                {
                                    toastr.error("Please enter package #"+i+" weight (lbs)");
                                    validated = false;
                                }
                            }
                            else
                            {
                                toastr.error("Please select package #"+i+" package type");
                                validated = false;
                            }
                        }
                        else
                        {
                            toastr.error("Please enter package #"+i+" description");
                            validated = false;
                        }
                    }
                    i++;
                });

                $('#package1 option').removeAttr("selected");
                $("#package1").val(main_package_type);
                $('#package1 option[value="'+main_package_type+'"]').attr('selected', true);

                if(validated)
                {
                    $scope.getRateCheck();
                    $scope.packagesaved = true;
                    $("#weight_lbs").val(total_lbs);
                    $('#packageModel').modal('hide');
                }
            }
            else {
                toastr.error("Please select package type");
            }
        };

        $scope.closePackageCreate = function (id,page)
        {
            if(!$scope.packagesaved)
            {
                $scope.adpkg = false;
                $scope.shippingChange = false;
                $scope.packagesdata = [];
                $scope.custom_packages = 0;
                angular.element("#package_type option:first").attr('selected',true);
                angular.element("#packagesrow1").html('');
                angular.element("#description").val('');
                angular.element("#package_type").val('');
                angular.element("#main_package_type option").removeAttr("selected");
                angular.element("#main_package_type").val('');
                $scope.getRateCheck();
            }
            else {
                $scope.custom_packages = $scope.packagesdata.length;
            }
            $('#packageModel').modal('hide');
        };

        $scope.getOz = function()
        {
            apiService.loaderShow();
            var weight_lbs = $("#weight_lbs").val();
            var weight_oz = (weight_lbs * 16);
            $("#weight_oz").val(weight_oz);
            apiService.loaderHide();
        };

        $scope.getRateCheck = function()
        {
          $scope.getRateDone = true;
          var weight_lbs = jQuery("#weight_lbs").val();
          var service = jQuery("#service").val();
          var accountId = jQuery("#account").val();
          var service_type = jQuery("#service_type").val();
          var pkg = jQuery("#package").val();
          var packages = $scope.packagesdata;
          
          var validated = false;
          if(weight_lbs != '' && weight_lbs > 0)
          {
            if(service != '' && service != 'office')
            {
              if(accountId != '' && accountId > 0)
              {
                if(service_type != '')
                {
                  if(packages.length > 0)
                  {
                    validated = true;
                  }
                  else if(pkg != '')
                  {
                    validated = true;
                  }
                  else if(pkg > 0)
                  {
                    validated = true;
                  }
                }
              }
            }
          }
          
          if(validated) {
            $scope.getRate();
          }
        };

        $scope.getRate = function()
        {
            $scope.getRateDone = true;
            apiService.loaderShow();
            var entity_id = $("#entity_id").val();
            var weight_lbs = $("#weight_lbs").val();
            var weight_oz = $("#weight_oz").val();
            var service = $("#service").val();
            var accountId = jQuery("#account").val();
            var service_type = $("#service_type").val();
            var pkg = $("#package").val();
            var len = $("#len").val();
            var wgh = $("#wgh").val();
            var hgt = $("#hgt").val();
            var shipDate = jQuery("#shipDate").val();
            var packages = $scope.packagesdata;

            var satdelivery = "No";
            if ($("input[name=satdelivery]").prop('checked') == true)
            {
              satdelivery = "Yes";
            }

            return $http.post($rootScope.baseUrl + '/shipment/get-shipment-rate', {
              shipment_number: $rootScope.orderId,
              entity_id: entity_id ? entity_id : '',
              weight_lbs: weight_lbs ? weight_lbs : '',
              weight_oz: weight_oz ? weight_oz : '',
              service: service ? service : '',
              account: accountId ? accountId : 0,
              service_type : service_type ? service_type : '',
              shipDate: shipDate ? shipDate : '',
              package : pkg ? pkg : '',
              len: len ? len : '',
              wgh: wgh ? wgh : '',
              hgt: hgt ? hgt : '',
              satdelivery: satdelivery,
              packages : packages
            }).then(function(response)
            {
                var responsedata = response.data;
                if (responsedata.status == 'success')
                {
                    $scope.getRateDone = false;
                    $("#getRate").show();
                    $("#displayRate").html("$"+responsedata.rate);
                    
                    if(responsedata.days!="" && responsedata.expected_date != "") {
                        $("#displayDays").html(responsedata.expected_date);
                    }
                    else if(responsedata.days!="") {
                        $("#displayDays").html(responsedata.days+" Days");    
                    }
                    else {
                        $("#displayDays").html("");
                    }
                    toastr.success(responsedata.message);
                }
                else {
                    toastr.error(responsedata.message);
                }
                apiService.loaderHide();
            },function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
            });            
        };

        $scope.createLabel = function()
        {
            if($scope.getRateDone == false)
            {
                apiService.loaderShow();
                var packages = $scope.packagesdata;

                var satdelivery = "No";
                if ($("input[name=satdelivery]").prop('checked') == true) {
                  satdelivery = "Yes";
                }

                var shipment_number = $rootScope.orderId;
                var entity_id = $("#entity_id").val();
                var weight_lbs = $("#weight_lbs").val();
                var weight_oz = $("#weight_oz").val();
                var service = $("#service").val();
                var accountId = $("#account").val();
                var service_type = $("#service_type").val();
                var shipDate = jQuery("#shipDate").val();
                var pkg = $("#package").val();
                var len = $("#len").val();
                var wgh = $("#wgh").val();
                var hgt = $("#hgt").val();

                return $http.post($rootScope.baseUrl + '/shipment/createlabel',
                {
                    username:$rootScope.globals.currentUser.name,
                    shipment_number: shipment_number ? shipment_number : '',
                    entity_id: entity_id ? entity_id : '',
                    weight_lbs: weight_lbs ? weight_lbs : '',
                    weight_oz: weight_oz ? weight_oz : '',
                    service: service ? service : '',
                    account: accountId ? accountId : 0,
                    service_type : service_type ? service_type : '',
                    shipDate: shipDate ? shipDate : '',
                    satdelivery: satdelivery,
                    package : pkg ? pkg : '',
                    length: len ? len : 0,
                    width: wgh ? wgh : 0,
                    height: hgt ? hgt : 0,
                    packages : packages
                }).then(function(response)
                {
                    apiService.loaderHide();
                    var responsedata = response.data;
                    if (responsedata.status == 'success')
                    {
                        var htmls = '';
                        $.each(responsedata.labels, function(key, item)
                        {
                            htmls = htmls + '<a href="'+item+'" target="_blank">Download Label</a><br />';
                            var url = item;
                            window.open(url, '_blank');
                            //$scope.printPDF();
                        });
                        $("#downloadlabelpdf").html(htmls);
                        $("#btncreatelabel").hide();
                        $scope.sendToMagento();
                        toastr.success(responsedata.message);
                        $scope.closePopup();
                    }
                }, function (error)
                {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
                });
            }
            else {
                $scope.getRateCheck();
            }
        };

        $scope.sendToMagento = function()
        {
          console.log('sending to magento');
          return $http.post($rootScope.baseUrl + '/shipment/shipment-order-to-magento',
          {
            shipment_number: $rootScope.orderId
          }).then(function(response)
          {
          }, function (error)
          {
              if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
              }
          });
        };

        $scope.createOfficeShipped = function ()
        {
            var shipment_number = $rootScope.orderId;
            var entity_id = $("#entity_id").val();
            var weight_lbs = $("#weight_lbs").val();
            var service = $("#service").val();
            var accountId = $("#account").val();
            var service_type = $("#service_type").val();
            var pkg = $("#package").val();
            var len = $("#len").val();
            var wgh = $("#wgh").val();
            var hgt = $("#hgt").val();
            var shipDate = jQuery("#shipDate").val();
            var packages = $scope.packagesdata;
            
            if(entity_id != '' && weight_lbs > 0 && service != '' && accountId > 0 && service_type != '')
            {
                apiService.loaderShow();
                return $http.post($rootScope.baseUrl + '/shipment/office-pickup',
                {
                    username:$rootScope.globals.currentUser.name,
                    shipment_number: shipment_number ? shipment_number : '',
                    entity_id: entity_id ? entity_id : '',
                    weight_lbs: weight_lbs ? weight_lbs : '',
                    service: service ? service : '',
                    account: accountId ? accountId : 0,
                    service_type : service_type ? service_type : '',
                    shipDate : shipDate ? shipDate: '',
                    package : pkg ? pkg : '',
                    packages: packages ? packages : [],
                    length: len,
                    width: wgh,
                    height: hgt
                }).then(function(response)
                {
                    apiService.loaderHide();
                    var responsedata = response.data;
                    if (responsedata.status == 'success')
                    {
                        $scope.packagesaved = false;
                        var htmls = '';
                        $.each(responsedata.labels, function(key, item) {
                            htmls = htmls + '<a href="'+item+'" target="_blank">Download Label</a><br />';
                            var url = item;
                            window.open(url, '_blank');
                        });
                        $scope.packagesdata = [];
                        toastr.success(responsedata.message);
                        $scope.closePopup();
                    }
                }, function (error)
                {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                apiService.loaderHide();
                });
            }
            else
            {
                console.log('shipment_number'+shipment_number);
                console.log('entity_id'+entity_id);
                console.log('weight_lbs'+weight_lbs);
                console.log('service'+service);
                console.log('accountId'+accountId);
                console.log('service_type'+service_type);
                toastr.error('check parameters');
            }
        };

        $scope.createOfficeLabel = function ()
        {
            var shipment_number = $rootScope.orderId;
            var entity_id = $("#entity_id").val();
            var weight_lbs = $("#weight_lbs").val();
            var service = $("#service").val();
            var accountId = $("#account").val();
            var service_type = $("#service_type").val();
            var pkg = $("#package").val();
            var len = $("#len").val();
            var wgh = $("#wgh").val();
            var hgt = $("#hgt").val();
            var shipDate = jQuery("#shipDate").val();
            var packages = $scope.packagesdata;

            if(entity_id > 0 && weight_lbs > 0 && service != '' && accountId > 0 && service_type != '')
            {
                apiService.loaderShow();
                return $http.post($rootScope.baseUrl + '/shipment/office-label',
                {
                    username:$rootScope.globals.currentUser.name,
                    shipment_number: shipment_number ? shipment_number : '',
                    entity_id: entity_id ? entity_id : '',
                    weight_lbs: weight_lbs ? weight_lbs : '',
                    service: service ? service : '',
                    account: accountId ? accountId : 0,
                    service_type : service_type ? service_type : '',
                    shipDate : shipDate ? shipDate: '',
                    package : pkg ? pkg : '',
                    packages: packages ? packages : [],
                    length: len,
                    width: wgh,
                    height: hgt
                }).then(function(response)
                {
                    apiService.loaderHide();
                    var responsedata = response.data;
                    if (responsedata.status == 'success')
                    {
                        //toastr.success(responsedata.message);
                        $scope.closePopup();
                    }
                }, function (error)
                {
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                    }
                    apiService.loaderHide();
                });
            }
        };

        $scope.downloadLabel = function ()
        {
            $http.post($rootScope.baseUrl + '/shipment/shipment-label', {
                id:$rootScope.orderId
            }).success(function(result) {
                if(result.status == 'success') {
                    window.open(result.path, '_blank');
                }
                else if(result.status == 'fail') {
                    toastr.error(result.message);
                }
            }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };

        
        /**
         * getOrderDetails is use to get order details.
         * created on 11.29.2017
         */
        //$scope.totalItems = 0;
        $scope.getOrderDetails = function (Clicked)
        {
            apiService.loaderShow();
            var vm = this;
            var offset = 0;
            $scope.disableQaStart=true;
            $http.get($rootScope.baseUrl + '/shipment/'+$rootScope.orderId+'/'+offset+'/0').then(
            function (response) {
                apiService.loaderHide();
                if(response.data.status == 'success'){
                    var mainArray = response.data.data;

                    $scope.orderDetailsData = mainArray;
                    vm.shippingservice = mainArray.orderData.account_service;
                    $scope.total_weight = parseFloat(mainArray.orderData.total_weight).toFixed(2);
                    vm.weight_lbs = parseFloat(mainArray.orderData.total_weight).toFixed(2);
                    if($scope.defaultService == '')
                    {
                        $scope.defaultService = mainArray.orderData.account_service;
                        $scope.defaultFedex = mainArray.orderData.account_fedex;
                        $scope.defaultUSPS = mainArray.orderData.account_usps;
                        
                        $scope.defaultOffice = 6;
                        if($scope.defaultService == 'fedex') {
                            $scope.defaultAccount = $scope.defaultFedex;
                        }
                        else if($scope.defaultService == 'usps') {
                            $scope.defaultAccount = $scope.defaultUSPS;
                        }
                        else if($scope.defaultService == 'office') {
                            $scope.defaultAccount = $scope.defaultOffice;
                        }
                        
                        $scope.changeDefaultService = $scope.defaultService;

                        $scope.orderStatus = mainArray.orderData.status_label;
                        $scope.orderStatusColor = mainArray.orderData.status_color;
                        $scope.getShipemts();
                        $scope.getShipmentAccounts($scope.changeDefaultService);
                    }
                }
                $scope.disableQaStart=false;
            },
            function (error) {
              $scope.disableQaStart=false;
                apiService.loaderHide();
            });
        }

        $scope.getOrderAddress = function ()
        {
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/shipment/getaddress/'+$rootScope.orderId).then(
            function (response)
            {
                apiService.loaderHide();
                if(response.data.status == 'success'){
                    var addArray = response.data;
                    $scope.orderAddress = addArray.address;
                    $scope.soldfirstname = $scope.orderAddress.billing.firstname;
                    $scope.soldlastname = $scope.orderAddress.billing.lastname;
                    $scope.soldcompany = $scope.orderAddress.billing.company;
                    $scope.soldaddress = $scope.orderAddress.billing.street;
                    $scope.soldcity = $scope.orderAddress.billing.city;
                    $scope.soldregion = $scope.orderAddress.billing.region;
                    $scope.soldpostcode = $scope.orderAddress.billing.postcode;
                    $scope.soldcountry = $scope.orderAddress.billing.country_id;

                    $scope.shipfirstname = $scope.orderAddress.shipping.firstname;
                    $scope.shiplastname = $scope.orderAddress.shipping.lastname;
                    $scope.shipcompany = $scope.orderAddress.shipping.company;
                    $scope.shipaddress = $scope.orderAddress.shipping.street;
                    $scope.shipcity = $scope.orderAddress.shipping.city;
                    $scope.shipregion = $scope.orderAddress.shipping.region;
                    $scope.shippostcode = $scope.orderAddress.shipping.postcode;
                    $scope.shipcountry = $scope.orderAddress.shipping.country_id;
                }
            },
            function (error) {
                apiService.loaderHide();
            });
        }

        /**
         * Edit Sold To Address
         * updated on 10.09.2019
        */
        $scope.editsoldto = false;
        $scope.editSoldTo = function() {
          $scope.editsoldto = true;
        }

        $scope.cancelSoldTo = function() {
          $scope.editsoldto = false;
        }

        $scope.saveSoldTo = function()
        {
          if (!this.soldtoFrm.soldfirstname.$valid) {
          toastr.error("Please enter first name.");
          angular.element('#soldfirstname').focus();
          return;
          }
          else if (!this.soldtoFrm.soldlastname.$valid) {
          toastr.error("Please enter last name.");
          angular.element('#soldlastname').focus();
          return;
          }
          else if (!this.soldtoFrm.soldcompany.$valid) {
          toastr.error("Please enter company name.");
          angular.element('#soldcompany').focus();
          return;
          }
          else if (!this.soldtoFrm.soldaddress.$valid) {
          toastr.error("Please enter address.");
          angular.element('#soldaddress').focus();
          return;
          }
          else if (!this.soldtoFrm.soldcity.$valid) {
          toastr.error("Please enter city.");
          angular.element('#soldcity').focus();
          return;
          }
          else if (!this.soldtoFrm.soldregion.$valid) {
          toastr.error("Please enter region.");
          angular.element('#soldregion').focus();
          return;
          }
          else if (!this.soldtoFrm.soldpostcode.$valid) {
          toastr.error("Please enter zip code.");
          angular.element('#soldpostcode').focus();
          return;
          }
          else if (!this.soldtoFrm.soldcountry.$valid) {
          toastr.error("Please enter country code.");
          angular.element('#soldcountry').focus();
          return;
          }

          apiService.loaderShow();
          var bodyData = {
            address_type: 'billing',
            firstname: this.soldfirstname,
            lastname: this.soldlastname,
            company: this.soldcompany,
            address: this.soldaddress,
            city: this.soldcity,
            region: this.soldregion,
            postcode: this.soldpostcode,
            country: this.soldcountry
          };
          $scope.orderId = $rootScope.orderId;
          if ($scope.orderId)
          {
            $scope.saveUrl = $rootScope.baseUrl + '/shipment/getaddress/' + $scope.orderId;
            $scope.httpMethod = 'POST';
          
            $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              $scope.editsoldto = false;
              apiService.loaderHide();
              var response = response.data;
              if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
              }else if (response.status == 'success') {
                $scope.getOrderAddress();
                toastr.success(response.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            }, function(error) {
              apiService.loaderHide();
              $scope.editsoldto = false;
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
          }
        }

        /**
         * Edit Ship To Address
         * updated on 10.09.2019
        */
        $scope.editshipto = false;
        $scope.editShipTo = function() {
          $scope.editshipto = true;
        };

        $scope.cancelShipTo = function() {
          $scope.editshipto = false;
        }

        $scope.saveShipTo = function()
        {
          if (!this.shiptoFrm.shipfirstname.$valid) {
          toastr.error("Please enter first name.");
          angular.element('#shipfirstname').focus();
          return;
          }
          else if (!this.shiptoFrm.shiplastname.$valid) {
          toastr.error("Please enter last name.");
          angular.element('#shiplastname').focus();
          return;
          }
          else if (!this.shiptoFrm.shipcompany.$valid) {
          toastr.error("Please enter company name.");
          angular.element('#shipcompany').focus();
          return;
          }
          else if (!this.shiptoFrm.shipaddress.$valid) {
          toastr.error("Please enter address.");
          angular.element('#shipaddress').focus();
          return;
          }
          else if (!this.shiptoFrm.shipcity.$valid) {
          toastr.error("Please enter city.");
          angular.element('#shipcity').focus();
          return;
          }
          else if (!this.shiptoFrm.shipregion.$valid) {
          toastr.error("Please enter region.");
          angular.element('#shipregion').focus();
          return;
          }
          else if (!this.shiptoFrm.shippostcode.$valid) {
          toastr.error("Please enter zip code.");
          angular.element('#shippostcode').focus();
          return;
          }
          else if (!this.shiptoFrm.shipcountry.$valid) {
          toastr.error("Please enter country code.");
          angular.element('#shipcountry').focus();
          return;
          }

          apiService.loaderShow();
          var bodyData = {
            address_type: 'shipping',
            firstname: this.shipfirstname,
            lastname: this.shiplastname,
            company: this.shipcompany,
            address: this.shipaddress,
            city: this.shipcity,
            region: this.shipregion,
            postcode: this.shippostcode,
            country: this.shipcountry
          };
          
          $scope.orderId = $rootScope.orderId;
          if ($scope.orderId)
          {
            $scope.saveUrl = $rootScope.baseUrl + '/shipment/getaddress/' + $scope.orderId;
            $scope.httpMethod = 'POST';
          
            $http({
              url: $scope.saveUrl,
              method: $scope.httpMethod,
              data: $scope.dataUrlEncode(bodyData),
              headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function(response) {
              $scope.editshipto = false;
              apiService.loaderHide();
              var response = response.data;
              if (response.code!= undefined && response.code == 0) {
                    toastr.error(response.message);
              }else if (response.status == 'success') {
                toastr.success(response.message);
                $scope.getOrderAddress();
                $scope.getOrderVerify();
              } else {
                toastr.error("Something went wrong please try again.");
              }
            }, function(error) {
              apiService.loaderHide();
              $scope.editshipto = false;
              if (error.data.code!= undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              } else {
                toastr.error("Something went wrong please try again.");
              }
            });
          }
        };

        $scope.getOrderVerify = function ()
        {
            $scope.add_business = false;
            $scope.add_home = false;

            apiService.loaderShow();
            jQuery("#addresstype").html('');
            jQuery("#warnings").html('');
            jQuery("#verified").hide();
            $http.get($rootScope.baseUrl + '/shipment/addressverify/'+$rootScope.orderId).then(
            function (response)
            {
                apiService.loaderHide();
                if(response.data.status == 'success')
                {
                    if(response.data.warnings == '')
                    {
                        jQuery("#verified").show();
                        jQuery("#warnings").html('');
                        jQuery("#warnings").hide();  
                    }
                    else
                    {
                        jQuery("#verified").hide();
                        jQuery("#warnings").html(response.data.warnings);
                        jQuery("#warnings").show();
                    }
                    if(response.data.address_type == 'BUSINESS')
                    {
                        $scope.add_business = true;
                        $scope.add_home = false;
                    }
                    else if(response.data.address_type == 'RESIDENTIAL')
                    {
                        $scope.add_business = false;
                        $scope.add_home = true;
                    }
                    jQuery("#addresstype").html(response.data.address_type);
                }
                else if(response.data.status=='error')
                {
                    $("#verified").hide();
                    $("#warnings").html(response.data.message);
                    $("#warnings").show();
                }
                else if(response.data.status=='fail'){
                    toastr.error(response.data.message);
                }
            },
            function (error)
            {
                apiService.loaderHide();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }

        $scope.getFedexServiceType = function ()
        {
            apiService.loaderShow();
            $http.get($rootScope.baseUrl + '/shipment/get-shipment-service-type/'+$rootScope.orderId).then(
            function (response)
            {
                apiService.loaderHide();
                if(response.data.status == 'success'){
                    $scope.shipmentServiceType = response.data.types;
                }
            },
            function (error) {
                apiService.loaderHide();
            });
        }

        $scope.getServiceType = function (service)
        {
            if(service == '') {
                service = $scope.defaultService;
            }
            
            $scope.shipmentServiceType = [];
            if(service != '')
            {
                $http.post($rootScope.baseUrl + '/shipment/get-shipment-service-types/'+service, {
                  id: $rootScope.orderId
                })
                .then(function (response)
                {
                  apiService.loaderHide();
                  if(response.data.status == 'success'){
                    $scope.shipmentServiceType = response.data.types;
                  }
                },
                function (error) {
                  apiService.loaderHide();
                });

                console.log($scope.shipmentServiceType);
            }
        }

        $scope.getOrderDetailsData = function () {
            $scope.getShipemts();
        }

        /**
           * Get all products list method is use to get product data.
           * created on 07.13.2018
        */
        $scope.getAllProductsList = function()
        {
            /*$http.get($rootScope.baseUrl + '/reportsettingslabel/getactivelabel')
            .success(function (response) {
                $scope.allProducts=response;
                angular.element(document).ready(function () {
                    $timeout(function () {
                    angular.element('.product-name').selectpicker('refresh');
                    }, 1000);
                });
            }).error(function (response) { });*/
        }
        $scope.getAllProductsList();

        /**
           * get Rework Setting Data method is use to display Rework Setting data.
           * created on 08.27.2018
        */
        $scope.getReworkSettingData = function()
        {
            $http.get($rootScope.baseUrl + '/config/reworkSetting')
            .success(function(result)
            {
                if (result)
                {
                    if (result.status == 'fail') {
                    }
                    else
                    {
                        if (result.data)
                        {
                            $scope.availableOrderStatus=result.data.available_order_status;
                            $scope.reworkOrderStatus=result.data.rework_order_status;
                            $scope.reworkReasonList = result.data.rework_reason;
                            $scope.reworkSolutionList = result.data.rework_solution;
                            angular.forEach($scope.reworkReasonList,function(val,key)
                            {
                                if(val.set_default=='1'){
                                $scope.reworkReason=val.name;
                                }
                            });
                            angular.forEach($scope.reworkSolutionList,function(val,key)
                            {
                                if(val.set_default=='1'){
                                    $scope.reworkSolution=val.name;
                                }
                            });
                        }
                    }
                }
            }).error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }

        /**
           * get Job Setting Data method is use to display Job Setting data.
           * created on 09.06.2018
        */
        $scope.getJobSettingData = function()
        {
            $http.get($rootScope.baseUrl + '/config/jobSetting')
            .success(function(result)
            {
                if (result)
                {
                    if (result.status == 'fail') {
                    }
                    else
                    {
                        if (result.data) {
                            var resultData=result.data;
                            $scope.OJvmExecutionCode=resultData.open_job.vm_execution_code;
                            $scope.OJfileLocation=$rootScope.globals.currentUser.open_job_override_folder=="Yes"?$rootScope.globals.currentUser.open_job_default_folder:resultData.open_job.file_location;
                            
                            $scope.OJDBvmExecutionCode=resultData.open_job_db.vm_execution_code;
                            $scope.OJDBfileLocation=$rootScope.globals.currentUser.open_job_db_override_folder=="Yes"?$rootScope.globals.currentUser.open_job_db_default_folder:resultData.open_job_db.file_location;

                            $scope.CJvmExecutionCode=resultData.create_job.vm_execution_code;
                            $scope.CJfont = resultData.create_job.font;
                            // Create 2D Job
                            $scope.C2DJvmExecutionCode=resultData.create_2d_job.vm_execution_code;
                            $scope.C2DJfont = resultData.create_2d_job.font;
                        }
                    }
                }
            }).error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }
         
        // define default value
        $scope.createTitle='Create';
        $scope.createButtonUrl='system';
        $scope.readyTitle='Ready';
        $scope.readyUrl='system';
        $scope.title3dcDownload='3DC Download';
        $scope.upload='Download';
        $scope.amazonDownload='A-Download';
        $scope.url3dcDownload='system';
        $scope.createButtonEncrypted='No';
        $scope.readyEncrypted='No';
        $scope.url3dcEncrypted='No';
        $scope.uploadEncrypted='No';
        $scope.amazonEncrypted='No';
        
        $scope.getRelayButtonSettings = function()
        {
            $http.get($rootScope.baseUrl + '/config/relayButtonSetting')
              .success(function(result) {
                if (result) {
                  if (result.status == 'fail') {
                    //toastr.error(result.message);
                  } else {
                    if (result.data) {
                      var resultData=result.data;
                      // Create button
                      $scope.createTitle=resultData.create_button.create_title?resultData.create_button.create_title:'Create';
                      $scope.createButtonUrl=resultData.create_button.create_url?resultData.create_button.create_url:'system';
                      var tmpCreateButtonEncrypted = resultData.create_button.create_encrypted?resultData.create_button.create_encrypted:'No';
                      if (tmpCreateButtonEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.createButtonEncrypted = 'Yes';
                      }

                      // Ready Button
                      $scope.readyTitle=resultData.ready_button.ready_title?resultData.ready_button.ready_title:'Ready';
                      $scope.readyUrl=resultData.ready_button.ready_url?resultData.ready_button.ready_url:'system';
                      var tmpreadyEncrypted = resultData.ready_button.ready_encrypted?resultData.ready_button.ready_encrypted:'No';
                      if (tmpreadyEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.readyEncrypted = 'Yes';
                      }

                      // 3DC Download button
                      $scope.title3dcDownload=resultData.download_3dc_button.title_3dc_download?resultData.download_3dc_button.title_3dc_download:'3DC Download';
                      $scope.url3dcDownload = resultData.download_3dc_button.url_3dc_download?resultData.download_3dc_button.url_3dc_download:'system';
                      var tmpurl3dcEncrypted = resultData.download_3dc_button.url_3dc_encrypted?resultData.download_3dc_button.url_3dc_encrypted:'No';
                      if (tmpurl3dcEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.url3dcEncrypted = 'Yes';
                      }
                      
                      // Upload
                      $scope.upload=resultData.upload.upload?resultData.upload.upload:'Download';
                      var tmpuploadEncrypted = resultData.upload.upload_encrypted?resultData.upload.upload_encrypted:'No';
                      if (tmpuploadEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.uploadEncrypted = 'Yes';
                      }
                      
                      // Amazon Download button
                      $scope.amazonDownload=resultData.amazon.download?resultData.amazon.download:'A-Download';
                      var tmpurlAmazonEncrypted = resultData.amazon.encrypted?resultData.amazon.encrypted:'No';
                      if (tmpurlAmazonEncrypted == 'Yes' && $rootScope.permissionArr.indexOf('view_encrypted_pop_up') != -1) {
                          $scope.amazonEncrypted = 'Yes';
                      }
                    }
                  }
                }
              }).error(function(error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
                }
              });
        }
        
        // open job uri
        $scope.getOpenJobUri=function(itemId)
        {
            if(itemId && $scope.OJvmExecutionCode)
            {
                var uri=$scope.OJvmExecutionCode+'%09'+$scope.OJfileLocation+'\\'+itemId+'.vmj';
                return uri;
            }
            else{
                return '';
            }
        }
        
        // open job db uri
        $scope.getOpenJobDBUri=function(itemId,qty)
        {
            if(itemId && $scope.OJDBvmExecutionCode){
              var uri=$scope.OJDBvmExecutionCode+'%09'+$scope.OJDBfileLocation+'\\'+itemId+'.vmj%09'+itemId+'%09'+qty+'%09';
              return uri;
            }else{
              return '';
            }
        }
        
        // open job db uri
        $scope.getOpenJobDBUriForWeCreate=function(itemId,qty,itemName)
        {
            if(itemId && $scope.OJDBvmExecutionCode)
            {
                var uri=$scope.OJDBvmExecutionCode+'%09'+itemId+'%09'+itemName+'%09'+qty+'%09';
                return uri;
            }
            else{
                return '';
            }
        }
        
        // create job uri
        $scope.getCreateJobUri=function(prod_name,engraving,engnew,file)
        {
            var eng,orientation,orientation_dash;
            if(engraving)
            {
                angular.forEach(engraving,function(val,key)
                {
                    if(val.label=='Orientation' && val.label=='Choose Orientation'){
                        if(val.label=='Orientation'){
                        orientation=val.value;
                        }
                    }
                    else
                    {
                        if(val.label=='Orientation' || val.label=='Choose Orientation'){
                        orientation=val.value;
                        }
                    }
                    
                    if(val.label=='Enter Your Engraving' && val.label=='Add Free Engraving')
                    {
                        if(val.label=='Enter Your Engraving'){
                            eng=val.value;
                        }
                    }
                    else{
                        if(val.label=='Enter Your Engraving' || val.label=='Add Free Engraving'){
                            eng=val.value;
                        }
                    }
                });
            }
        
            if(orientation)
            {
                orientation=orientation;
                orientation_dash='-';
            }else{
                orientation='%20';
                orientation_dash='';
            }
            
            if(eng)
            {
                eng=engnew?engnew:eng;
                eng=eng.replace('\n','<br />');
                eng=eng.replace('<br />','%CR%');
                eng=eng.replace(/\s+/g,'%20');
                eng=eng.replace(/"/g,'%QM%');
            }
            else{
                eng='';
            }
        
            var rpsName=prod_name.trim();
            rpsName=rpsName.replace(/\s+/g,'-');
            
            if($scope.CJvmExecutionCode){
                var uri=$scope.CJvmExecutionCode+'%09'+file+'%20'+rpsName+orientation_dash+orientation+'%20%22'+eng+'%22%20'+$scope.CJfont+'%20';
                return uri;
            }else{
                return '';
            }
        }
        
        // create 2d job uri
        $scope.getCreate2DJobUri=function(itemId,prod_name,engraving,engnew,file)
        {
            var eng,orientation,orientation_dash;
            if(engraving)
            {
                angular.forEach(engraving,function(val,key)
                {
                    if(val.label=='Orientation' && val.label=='Choose Orientation'){
                        if(val.label=='Orientation'){
                        orientation=val.value;
                        }
                    }else{
                        if(val.label=='Orientation' || val.label=='Choose Orientation'){
                            orientation=val.value;
                        }
                    }
                    if(val.label=='Enter Your Engraving' && val.label=='Add Free Engraving'){
                        if(val.label=='Enter Your Engraving'){
                            eng=val.value;
                        }
                    }else{
                        if(val.label=='Enter Your Engraving' || val.label=='Add Free Engraving'){
                        eng=val.value;
                        }
                    }
                });
            }
            
            if(orientation){
              orientation=orientation;
              orientation_dash='-';
            }else{
              orientation='%20';
              orientation_dash='';
            }
            
            if(eng)
            {
              eng=engnew?engnew:eng;
              eng=eng.replace('\n','<br />');
              eng=eng.replace('<br />','%CR%');
              eng=eng.replace(/\s+/g,'%20');
              eng=eng.replace(/"/g,'%QM%');
            }
            else{
              eng='';
            }
            
            var rpsName=prod_name.trim();
            rpsName=rpsName.replace(/\s+/g,'-');
            if($scope.C2DJvmExecutionCode)
            {
                var downloadFile=$rootScope.baseUrl + '/download-image-url/'+itemId+ '/regular';
                var uri=$scope.C2DJvmExecutionCode+'%09'+downloadFile+'%20'+rpsName+orientation_dash+orientation+'%20%22'+eng+'%22%20'+$scope.C2DJfont+'%20';
                return uri;
            }else{
              return '';
            }
        }
        
        /**
            * get Relay Setting Data method is use to display Relay Setting data.
            * created on 09.30.2018
        */
        $scope.getRelaySettingData = function()
        {
            $http.get($rootScope.baseUrl + '/config/relaySetting')
            .success(function(result)
            {
                if (result)
                {
                    if (result.status == 'fail') {
                    }
                    else
                    {
                        if (result.data)
                        {
                            var resultData=result.data;
                            $scope.jobService=resultData.job_service;
                        
                            $scope.priority = [
                            {'name':'Regular', 'hours':12},
                            {'name':'Express', 'hours':3},
                            {'name':'Preferred', 'hours':8}
                            ];
                        }
                    }
                }
            }).error(function(error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }
        
        $scope.saveRelaySettings=function(event,itemId)
        {
            var targetRelay = angular.element(event.target);
            var jobService =  targetRelay.parents().find('.job-service-single').val();
            var priority =  targetRelay.parents().find('.priority-single').val();
            
            if(!jobService){
              toastr.error('Please select job service');
              return;
            }
            
            if(!priority){
              toastr.error('Please select priority');
              return;
            }
            
            $scope.progressbar.start();
            var bodyData = {
                item_id: itemId,
                priority:priority,
                job_service:jobService,
                relay_created_by:$rootScope.globals.currentUser.name
            };
            $http.post($rootScope.baseUrl + '/relay-order-save', bodyData)
            .success(function (response)
            {
                $scope.progressbar.complete();
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.getOrderDetails();
                } else {
                  if(response.message.errors){
                    toastr.error(response.message.message);
                  }else{
                    toastr.error(response.message);
                  }
                }
            }).error(function (error) {
                $scope.progressbar.complete();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
        }
          
        $scope.uploadFileManual=function(event, itemId)
        {
            var file = document.getElementById('manualFileUpload').files[0];
            if (!file) {
                toastr.error('Please select file first to upload');
                return '';
            }
            $('#uploadFileManualButton').hide();
            $("#myBar").css("width", "0%");
            $("#Progress").show();
            
            var elem = document.getElementById("myBar");
            var width = 1;
            var id = setInterval(frame, 150);
            
            function frame() {
              if (width >= 88) {
                clearInterval(id);
              } else {
                width++; 
                elem.style.width = width + '%'; 
              }
            }
            
            apiService.loaderShowForUploadButton();
            var bodyData = {
                item_id: itemId
            };
            if(file) {
                bodyData.upload_file = file;
            }
            
            $http(
            {
                url: $rootScope.baseUrl + '/orderdetail/upload-file-manually',
                method: 'POST',
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    for (var i in bodyData) {
                        formData.append(i, bodyData[i]);
                    }
                    return formData;
                }
            }).then(function (response) {
                $scope.getOrderDetails();
                //$scope.progressbar.complete();
                apiService.loaderHideForUploadButtonp();
                var responseData = response.data;
                if (responseData.status == 'success') {
                    toastr.success(responseData.message);
                    angular.element("#uploadFileManualButton").show();
                    width = 100;
                    $("#myBar").css("width", "100%");
                    $(function() {
                        setTimeout(function() {
                            $("#Progress").hide('blind', {}, 500)
                        }, 1000);
                    });
                }
            }, function (error) {
                //$scope.progressbar.complete();
                apiService.loaderHideForUploadButtonp();
                var errorData = error;
                toastr.error(errorData.message.message);
            });
            jQuery("#manualFileUpload").val('');
            file = '';
        }
          
        $scope.saveFullRelaySettings=function(event,entityId)
        {
            var targetRelay = angular.element(event.target);
            var jobService =  targetRelay.parents().find('.job-service').val();
            var priority =  targetRelay.parents().find('.priority').val();
            if(!jobService){
              toastr.error('Please select job service');
              return;
            }
            if(!priority){
              toastr.error('Please select priority');
              return;
            }
            $scope.progressbar.start();
            var bodyData = {
                order_id: entityId,
                priority:priority,
                job_service:jobService,
                relay_created_by:$rootScope.globals.currentUser.name
            };
            $http.post($rootScope.baseUrl + '/relay-full-order-save', bodyData)
            .success(function (response)
            {
                $scope.progressbar.complete();
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.getOrderDetails();
                } else {
                  if(response.message.errors){
                    toastr.error(response.message.message);
                  }else{
                    toastr.error(response.message);
                  }
                }
            }).error(function (error) {
              $scope.progressbar.complete();
                if (error && error.code != undefined && error.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
            $scope.startOrderDetailsTimer();
        }

        $scope.getPullJobSettingData = function()
        {
            $http.get($rootScope.baseUrl + '/config/pullJobSetting')
            .success(function(result)
            {
                if (result)
                {
                    if (result.status == 'fail') {
                    }
                    else
                    {
                        if (result.data) {
                            var resultData=result.data;
                            $scope.showOnStatus=resultData.show_on_status;
                            $scope.onChangeStatus=resultData.change_to_status;
                        }
                    }
                }
            }).error(function(error) {});
        }
        
        $scope.checkStatusForPullJobBtn=function(status)
        {
            if($scope.showOnStatus)
            {
                if($scope.showOnStatus.indexOf(status)===-1){
                    return false;
                }else{
                    return true;
                }
            }
        }
        
        $scope.pullJob=function(oldstatus)
        {
            if($rootScope.orderEntityId)
            {
                var bodyData = {
                  entity_id: $rootScope.orderEntityId,
                  status:$scope.onChangeStatus,
                  old_status:oldstatus,
                  user_name:$rootScope.globals.currentUser.name
                };
                $http.post($rootScope.baseUrl + '/order/getordersdetails', bodyData)
                .success(function (response)
                {
                    if (response.status == 'success') {
                        toastr.success(response.message);
                        $scope.getOrderDetails();
                    } else {
                        toastr.error(response.message);
                    }
                }).error(function (error)
                {
                    if (error && error.code != undefined && error.code == 0) {
                      toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
        }
        
        $scope.getHours=function(secs)
        {
            if(secs)
            {
                var hours   = Math.floor(secs / 3600);
                var minutes = Math.floor((secs - (hours * 3600)) / 60);
                var seconds = secs - (hours * 3600) - (minutes * 60);

                // round seconds
                seconds = Math.round(seconds * 100) / 100

                var result = (hours < 10 ? "0" + hours : hours);
                result += ":" + (minutes < 10 ? "0" + minutes : minutes);
                result += ":" + (seconds  < 10 ? "0" + seconds : seconds);
                return result;
            }else{
              return '00:00:00';
            }
        }

        $scope.downloadImage=function(item,path,type){
            window.open($rootScope.baseUrl + '/download-image-url/'+item+'/'+type, '_self');
        }
        
        // Used for open and do manipulation pop-up for security key
        $scope.encryptionButtonType = '';
        $scope.verifySecurityKey=function(item,path,buttonType)
        {
            $scope.verifyItem=item;
            $scope.encryptionButtonType = buttonType;
            $('#verifySecurityKey').modal();
            var interval = setInterval(function(){
            $('#downloadEncryptionInput').focus();
            },1000);
        }
        
        // Used for close pop-up for security key
        $scope.closeverifySecurityKey = function (id,page)
        {
            $(".key_msg, .msg_icon, .key_msg, .su_msg, .msg_icon, .su_msg").remove();
            $('#disableButtonOfDownload').hide();
            $('#verifySecurityKeyDownloadButton').hide();
            angular.element(".input-div-class").show();
            $('#verifySecurityKey').modal('hide');
            $(".key_msg,.msg_icon").remove();
            $scope.encryptionButtonType = '';
        };
        
        // for order list change status -- start
        $scope.getActiveStatusData = function()
        {
            // get order status
            $http.post($rootScope.baseUrl + '/status/activeAll')
            .success(function (result) {
                $scope.orderStatusList = result;
            }).error(function (error)
            {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        }
        
        $scope.resetChangeStatus=function()
        {
            $scope.isChangeStatus.change=true;
            $scope.orderChangeStatus={statuscode:""};
            $scope.isSelected.select=true;
            toastr.success("Please select orders to change status.");
        }
        
        $scope.cancelChangeStatus=function()
        {
            $scope.isSelected.select=false;
            $scope.selected = {};
            $scope.selectAll = false;
            $scope.isChangeStatus.change=false;
            $scope.vmAdded.dtInstance.DataTable.draw( false );
        }
        
        $scope.openChangeStatusModal = function ()
        {
            $scope.entityArray=[];
            if(!$scope.orderChangeStatus.statuscode){
              toastr.error("Please select orders status.");
              angular.element('#orderChangeStatusId').focus();
              return false;
            }
            angular.forEach($scope.selected,function(val,key){
              if(val===true){
                $scope.entityArray.push(key);
              }
            });
            if($scope.entityArray.length<=0){
              toastr.error("Please select orders.");
              return false;
            }
            $scope.selectedOrderCount=$scope.entityArray.length;
            $('#changeStatusConfirm').modal();
        }
        
        $scope.updateOrderStatus=function()
        {
            var data={
              status_code :$scope.orderChangeStatus.statuscode,
              entity_ids: JSON.stringify($scope.entityArray),
              username:$rootScope.globals.currentUser.name
            }
            $http.post($rootScope.baseUrl + '/order/bulkorderchangestatus',data).then(
            function (response) {
              var responseData=response.data;
              if (responseData.status == 'success') {
                  toastr.success(responseData.message);
                  $('#changeStatusConfirm').modal('hide');
                  $scope.cancelChangeStatus();
              } else {
                  toastr.error(responseData.message);
              }
            },
            function (error) {
              if (error && error.code != undefined && error.code == 0) {
                  toastr.error(error.message);
              } else {
                  toastr.error("Something went wrong please try again.");
              }
            });
        }
        // for order list change status -- end

        // order list auto refresh
        $scope.startOrderListTimer=function()
        {
            $scope.orderListTimer=$interval(function(){
              if($location.path() == '/orders'){
                if(!$scope.isSelected.select){
                  $rootScope.vmAddedNew.dtInstance.DataTable.draw(false);
                }
              }
            },$rootScope.apiIntervalTimeOrders * 60 * 1000);
        }
        
        $scope.startOrderListTimer();
        $scope.killOrderListTimer=function()
        {
            if(angular.isDefined($scope.orderListTimer))
            {
                $interval.cancel($scope.orderListTimer);
                $scope.orderListTimer=undefined;
            }
        };
        
        // order details  auto refresh
        $scope.startOrderDetailsTimer=function()
        {
            $scope.orderDetailsTimer=$interval(function()
            {
                if($location.path() == '/orders'){
                if($rootScope.orderId && !$scope.isQaStart){
                         $scope.getOrderDetails(1);
                       }
                }
            },10000);
        }
        
        $scope.killOrderDetailsTimer=function()
        {
            if(angular.isDefined($scope.orderDetailsTimer))
            {
                $interval.cancel($scope.orderDetailsTimer);
                $scope.orderDetailsTimer=undefined;
            }
        };
        
        // order details  auto refresh
        $scope.startOrderCommentTimer=function()
        {
            $scope.orderCommentTimer=$interval(function(){
              if($location.path() == '/orders'){
                if($rootScope.orderId){
                         //$scope.getCommentData();
                       }
                }
            },1000*60);
        }
          
        // order details  auto refresh
        $scope.startOrderOfficeCommentTimer=function()
        {
            $scope.orderOfficeCommentTimer = $interval(function () {
                if ($location.path() == '/orders') {
                    if ($rootScope.orderId) {
                        $scope.getOfficeCommentData();
                    }
                }
            }, 1000 * 60);
        }
          
        $scope.killOrderCommentTimer=function()
        {
            if(angular.isDefined($scope.orderCommentTimer))
              {
                $interval.cancel($scope.orderCommentTimer);
                $scope.orderCommentTimer=undefined;
              }
        };
          
        $scope.killOrderOfficeCommentTimer=function()
        {
            if (angular.isDefined($scope.orderOfficeCommentTimer)) {
                $interval.cancel($scope.orderOfficeCommentTimer);
                $scope.orderOfficeCommentTimer = undefined;
            }
        };
        
        this.encryptedText = '';
        $scope.encryptedTextData = {};
        this.encryptedErrorText = '';
        
        // Verify encrypted barcode to download files
        $scope.RemoveMsg = function(){
            $(".key_msg , .msg_icon").remove();
        }
        
        //Show input type of encrypted file
        $scope.resetEncryptedText = function()
        {
            $(".key_msg , .msg_icon").remove();
            $('#disableButtonOfDownload').hide();
            angular.element(".input-div-class").show();
        }

        this.copyFromProductId = '';
        /**
         * Close the Copy from button
         */
        $scope.closeCopyProductDataForm = function ()
        {
            $('#openCopyProductDataPopUp').modal('hide');
            document.getElementById('copyFileButton').value = "";
            $(".key_msg_copy, .er_msg_copy").remove();
            this.copyFromProductId = '';
        };
        /**
         * Open pop-up of the Copy from button
         */
        $scope.openCopyProductDataForm=function()
        {
            document.getElementById('copyFileButton').value = "";
            $(".key_msg_copy, .er_msg_copy").remove();
            $('#openCopyProductDataPopUp').modal();
        }

        /**
         * Call API when clicked on submit button of the copy from
         */
        $scope.copyProductData = function (itemId)
        {
            var vm = this;
            apiService.loaderShowForCopyFilePopUp();
            //apiService.loaderShowForEncryptedPopUp();
            $('#verifySecurityKeyDownloadButtonxx').hide();
            $http.post($rootScope.baseUrl + '/orderdetail/copy-product-files', {
                copy_to_item_increment_id: itemId,
                copy_from_item_increment_id: vm.copyFromProductId
            }).success(function (response) {
                if (response.status == 'success') {
                    $('#copyPopUpPasteButton').hide();
                    $('#copyFileButton').hide();
                    //$('#openCopyProductDataPopUp').modal('hide');
                    document.getElementById('copyFileButton').value = "";
                    $(".key_msg_copy, .er_msg_copy").remove();
                    toastr.success(response.message);
                    $('.msg_cond2').after('<span class="key_msg_copy copy-msg er_msg_copy">Data copy request is in progress</span>');
                    vm.copyFromProductId = '';
                } else {
                    apiService.loaderHideForCopyFilePopUp();
                    angular.element(".submit_copy_file").show();
                    //apiService.loaderHideForCopyFilePopUp();
                    //apiService.loaderHideForEncryptedPopUp();
                    document.getElementById('copyFileButton').value = "";
                    $(".key_msg_copy, .er_msg_copy").remove();
                    $('.msg_cond2').after('<span class="key_msg_copy er_msg_copy">'+response.message+'</span>');
                    vm.copyFromProductId = '';
                }
            }).error(function (error) {
                //apiService.loaderHideForCopyFilePopUp();
                //apiService.loaderHideForEncryptedPopUp();
                apiService.loaderHideForCopyFilePopUp();
                toastr.error("Something went wrong please try again.");
                $('#openCopyProductDataPopUp').modal('hide');
                document.getElementById('copyFileButton').value = "";
                $(".key_msg_copy, .er_msg_copy").remove();
                vm.copyFromProductId = '';
            });
        }
        
        $scope.copyProductDataLogLoaded = false;
        $scope.copyProductDataLogIncrementId = '';
        $scope.openCopyProductDataLogForm = function (id)
        {
            angular.element(".submit_copy_file").show();
            angular.element(".copyPopUpPasteButton").show();
            angular.element(".crista_name_copy").show();
            $scope.copyProductDataLogIncrementId = id;
            $scope.copyProductDataLogLoadeds = false;
            $scope.getCopyProductDataLogs();
            $('#openCopyProductDataLogPopUp').modal();
        };
        
        $scope.closeCopyProductDataLogPopUp=function()
        {
            apiService.loaderHideForCopyFilePopUp();
            $scope.copyProductDataLogIncrementId = '';
            $('#openCopyProductDataLogPopUp').modal('hide');
            angular.element(".submit_copy_file").show();
            angular.element(".copyPopUpPasteButton").show();
            angular.element(".crista_name_copy").show();
        };
        
        $scope.copyProductDataArray = [];
        $scope.getCopyProductDataLogs = function ()
        {
            $scope.copyProductDataLogLoaded = false;
            $http.get($rootScope.baseUrl + '/orderdetail/get-copy-from-log/' + $scope.copyProductDataLogIncrementId).then(
            function (response) {
                $scope.copyProductDataLogLoaded = true;
                if(response.data.status == 'success'){
                   $scope.copyProductDataArray = response.data.data;
                }
            },
            function (error) {
                $scope.copyProductDataLogLoaded = true;
            });
        }
        
        $scope.getOrderNumber = function(query)
        {
            return $http.post($rootScope.baseUrl + '/orderdetail/autosugget', {searchable_value:query?query:''})
            .then(function(response){
                return response.data.map(function(item){
                    return item.item_increment_id;
                });
            });
        };

        $scope.disableCopyLoader = function(itemIncrementId)
        {
            angular.element(".submit_copy_file").show();
            //apiService.loaderHideForCopyFilePopUp();
            //apiService.loaderHideForEncryptedPopUp();
            apiService.loaderHideForCopyFilePopUp();
            $('#openCopyProductDataPopUp').modal('hide');
            angular.element(".copyPopUpPasteButton").show();
            angular.element(".crista_name_copy").show();
            $http.post($rootScope.baseUrl + '/orderdetail/remove-hide-pop-field', {searchable_value:itemIncrementId?itemIncrementId:''})
        };

        $rootScope.copiedProductId = '';
        $scope.productNumberCopied = function (productId)
        {
           $cookies.put('copy-from-product-id',undefined);
           $cookies.put('copy-from-product-id', productId);
           $rootScope.copiedProductId = productId;
           toastr.success('Product id ' + productId + ' is copied!');
        };
        
        $scope.pasteCopiedOrderNumber = function ()
        {
            var vm = this;
            var copyId = '';
            if ($cookies.get('copy-from-product-id') && $cookies.get('copy-from-product-id') != undefined) {
                copyId = $cookies.get('copy-from-product-id');
            } else {
                copyId = $rootScope.copiedProductId;
            }
            vm.copyFromProductId = copyId;
        };

        // Download encrypted file
        $scope.downloadEncryptedFile = function (val)
        {
            var encrypteString = val.encrypted_string;
            var originalItemId = val.original_item_id;
            apiService.loaderShow();
            window.open($rootScope.baseUrl + '/orderdetail/download-verified-file/' + encrypteString + '/' + $scope.encryptionButtonType + '/' + $rootScope.globals.currentUser.firstname + '/' + originalItemId, '_self');
            apiService.loaderHide();
            $('#verifySecurityKey').modal('hide');
            $('#verifySecurityKeyDownloadButton').hide();
            $(".key_msg, .msg_icon, .key_msg, .su_msg, .msg_icon, .su_msg").remove();
            angular.element(".input-div-class").show();
        };

        $scope.$on('$destroy', function()
        {
            // Make sure that the interval is destroyed too
            $scope.killOrderListTimer();
            $scope.killOrderDetailsTimer();
            $scope.killOrderCommentTimer();
            $scope.killOrderOfficeCommentTimer();
        });
          
        /**
        *get all type master for filter records
        */
        $scope.getTypeMaster = function()
        {
            $http.get($rootScope.baseUrl + '/productType/getActiveType/all')
            .success(function (result)
            {
                $scope.isloaded = true;
                if (result) {
                    $scope.typeData = result;
                }
            }).error(function (error) {
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };

        /**
         * Open change order date pop-up.
         * created on 11.April.2019
        **/
        $scope.openChangeOrderDatePopUp = function (orderId)
        {
            angular.element('#onChangeStatusId').val('');
            $scope.killOrderDetailsTimer();
            $scope.changeOrderCreatedDateOrderId = orderId;
            $('#orderDateChangeButton').modal();
        };

        /**
         * Call API to change the order date and status
         * Created on 11.April.2019
        **/
        $scope.changeOrderCreatedDate = function()
        {
            var vm = this;
            if (this.onChangeStatus == undefined || this.onChangeStatus == '') {
                return '';
            }
            apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/order/change-create-date-status', {
                order_id: $scope.changeOrderCreatedDateOrderId,
                affected_by: $rootScope.globals.currentUser.name,
                change_status_to: this.onChangeStatus
            }).success(function (response)
            {
                if (response.status == 'success') {
                    toastr.success(response.message);
                    $scope.closeChangeOrderDatePopUp();
                    apiService.loaderHide();
                    $scope.getOrderDetails();
                    $scope.getOrderDetailsData();
                } else {
                    apiService.loaderHide();
                    toastr.error(response.message);
                    $scope.closeChangeOrderDatePopUp();
                }
                angular.element('#onChangeStatusId').val('');
                vm.onChangeStatus = '';
            }).error(function (error) {
                apiService.loaderHide();
                $scope.closeChangeOrderDatePopUp();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
                angular.element('#onChangeStatusId').val('');
                vm.onChangeStatus = '';
            });
        };

        /**
         * Close the change order date pop-up.
         * Created on 11.April.2019
        **/
        $scope.closeChangeOrderDatePopUp = function()
        {
            $('#orderDateChangeButton').modal('hide');
            $scope.startOrderDetailsTimer();
            angular.element('#onChangeStatusId').val('');
            $scope.changeOrderCreatedDateOrderId = 0;
        };

        $scope.changeOrderDateLogLoaded = false;
        $scope.changeOrderDateLogId = '';
        $scope.openChangeOrderDateLogDialog = function (id)
        {
            $scope.changeOrderDateLogId = '';
            $scope.changeOrderDateLogId = id;
            $scope.getChangeOrderDatetDataLogs();
            $('#openChangeOrderDateLogDialog').modal();
        };

        $scope.closeChangeOrderDateLogDialog = function ()
        {
            $('#openChangeOrderDateLogDialog').modal('hide');
            $scope.changeOrderDateLogId = '';
        };

        $scope.getChangeOrderDatetDataLogs = function ()
        {
            $scope.changeOrderDateLogArray = [];
            $scope.changeOrderDateLogLoaded = false;
            $http.get($rootScope.baseUrl + '/orderdetail/get-order-date-change-log/' + $scope.changeOrderDateLogId)
            .then(function (response)
            {
                $scope.changeOrderDateLogLoaded = true;
                if (response.data.status == 'success') {
                    $scope.changeOrderDateLogArray = response.data.data;
                    $scope.changeOrderDateLogId = '';
                }
            },
            function (error) {
                $scope.changeOrderDateLogId = '';
                $scope.changeOrderDateLogLoaded = true;
            });
        };

        $scope.showChangeOrderDateButtons = function (type, status, permission)
        {
            if ($scope.changeStatusButtons)
            {
                if ($scope.changeStatusButtons[type].status.indexOf(status) !== -1 && $rootScope.permissionArr.indexOf(permission) !== -1) {
                    return true;
                }
                else {
                    return false;
                }
            }
        };

        $scope.getChangeOrderDateButtonData = function ()
        {
            $http.get($rootScope.baseUrl + '/config/get-save-button-setting')
                    .success(function (result) {
                        if (result.data && result.data != undefined) {
                            $scope.changeStatusButtons = result.data.data;
                            $scope.changeStatusButtonsOnClickStatus = result.data.data_change_status_to.selectedPeople;
                            angular.forEach($scope.changeStatusButtons, function (val, key) {
                                var status = [];
                                angular.forEach(val.status, function (stsVal, stsKey) {
                                    status.push(stsVal.status_label);
                                });
                                $scope.changeStatusButtons[val.name] = {'status': status};
                            });
                        }
                    }).error(function (error) {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
            });
        };

        $scope.voidlabel = function(shipment_order_number,trackingnumber)
        {
            $scope.shipment_order_number = shipment_order_number;
            $scope.trackingnumber = trackingnumber;
            $scope.openWarning('app/pages/shipment/orderReadyToShip/warningModalVoidLabel.html');
        };


        $scope.labelvoid = function (shipment_order_number,trackingnumber)
        {
            if(shipment_order_number != '' && trackingnumber != '')
            {
                var vm = this;
                apiService.loaderShow();
                $http.post($rootScope.baseUrl + '/shipment/labelvoid', {
                    shipment_order_number: shipment_order_number,
                    trackingnumber: trackingnumber,
                    affected_by: $rootScope.globals.currentUser.name,
                }).success(function (response)
                {
                    apiService.loaderHide();
                    if (response.status == 'success') {
                        toastr.success(result.message);
                        $scope.getTrackingData();
                    }
                    else {
                        toastr.error(response.message);
                    }
                }).error(function (error)
                {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            }
            else {
                toastr.error("Shipment Order id zero or Tracking number blank");
                return false;
            }

            $scope.shipment_order_number = '';
            $scope.trackingnumber = '';
        };
    }
})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.shipment')
            .controller('shipmentCreateCtrl', shipmentCreateCtrl);

    /** @ngInject */
    function shipmentCreateCtrl($scope, $rootScope,$filter, apiService, $uibModal, $cookies, $timeout, $state, $http, $location, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile,$sce)
    {
    	var vm = this;
        $rootScope.currentState = 'shipment-create';
    	$scope.resetGlobalSearch();
    	vm.barcodeText = '';
        $scope.duplicateCheck = [];
        $scope.duplicateCheckRow = [];
        $scope.isloaded = true;
        $scope.updatedItem = [];
        $scope.totalItems = 0;
        $scope.showTotalItems = false;
        $scope.showItemUpdated = false;
        $scope.showItemScanned = true;
        $scope.isloadedDepartment = false;
        $scope.storeListId = $rootScope.storeListId;
        $scope.storeName = $rootScope.storeName;
        $scope.storeUserName = $rootScope.storeUserName;
        $scope.fromDate = $rootScope.fromDate;
        $scope.toDate = $rootScope.toDate;
        $rootScope.customerId = $rootScope.storeListId;
        $scope.fromDateFormated = $scope.getGlobalDateFormat($scope.fromDate);
        $scope.toDateFormated = $scope.getGlobalDateFormat($scope.toDate);
        $scope.validateAddress = [];
        $scope.doneScanning = false;
        $scope.message = '';
        $scope.scanningitem = '';
        $scope.mallStatus = '';

        console.log($scope.storeName);
        console.log($scope.storeUserName);
        console.log($scope.fromDate);
        console.log($scope.toDate);
        console.log($rootScope.customerId);

        $scope.to_trusted = function(html_code) {
            return $sce.trustAsHtml(html_code);
        }
        $scope.getMallStatus = function ()
        {
          $scope.mallStatus = '';
          $http.get($rootScope.baseUrl + '/config/shipmentSetting')
          .success(function(result)
          {
            if (result)
            {
              if (result.status == 'fail') {
                toastr.error(result.message);
              }
              else
              {
                if (result.data)
                {
                  var resultData = result.data;
                  var shipmentSetting = resultData.shipment_settings;
                  $scope.mallStatus = shipmentSetting.mallStatus;
                  $scope.getStoreItems();
                }
              }
            }
          })
          .error(function(error)
          {
            if (error.data && error.data.code != undefined && error.data.code == 0) {
              toastr.error(error.data.message);
            }
          });
        };

        $scope.getMallStatus();
        $scope.getStoreItems = function()
        {
            if($rootScope.storeListId > 0)
            {
                apiService.loaderShow();
                var bodyData = {
                    from_date: $scope.saveFromDateFormat($rootScope.fromDate),
                    to_date: $scope.saveToDateFormat($rootScope.toDate),
                    store_id: $rootScope.storeListId ? $rootScope.storeListId : 0,
                    fixstatus: $scope.mallStatus
                };

                $http.post($rootScope.baseUrl + '/ordertracker/regular-status', bodyData)
                .success(function(response)
                {
                    apiService.loaderHide();
                    console.log(response);
                    console.log($scope.mallStatus);
                    if (response && response.status == 'success')
                    {
                        $.each(response.data, function (key, val)
                        {
                            if(val.status_code == $scope.mallStatus && val.total_orders > 0)
                            {
                                if((val.status_code != 'shipped' && val.status_code != 'arrived'))
                                {
                                    $scope.showTotalItems = true;
                                    $scope.totalItems = val.item_total;
                                }
                            }
                        });
                    }
                })
                .error(function(error) 
                {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                      toastr.error(error.data.message);
                    } else {
                      toastr.error("Something went wrong please try again.");
                    }
                });


            }
        };
        
        $scope.resetScan = function ()
        {
            $scope.doneScanning = false;
        	$state.go($state.$current, null, {
                reload: true
            });
        }

    	/**
         * show scan is use to show scan pop-up
         * created on 05.08.2019
         */
        $scope.showScan = function ()
        {
            $scope.doneScanning = false;
            angular.element('#scanStart').hide();
            angular.element('#scan-popup-barcode').show();
            angular.element('#fade').show();
            angular.element('#viewOrder').show();
            angular.element('#txt-barcode').show();
            angular.element('#txt-barcode').focus();
        }
        /**
         * show manual scan is use to show scan pop-up with overlay
         * created on 05.08.2019
         */
        $scope.showManualScan = function ()
        {
          angular.element('#scanStart').hide();
          angular.element('#viewOrder').show();
          angular.element('#txt-barcode').show();
          angular.element('#txt-barcode').focus();
          angular.element('#manualScan').removeClass('hide-element');
        }

        /**
         * hide popup is use to hide scan pop-up
         * created on 05.08.2019
         */
        $scope.hidePopup = function ()
        {
            $scope.doneScanning = true;
            angular.element('#scan-popup-barcode').hide();
            angular.element('#viewOrder').show();
            angular.element('#fade').hide();
            angular.element('#txt-barcode').hide();
            angular.element(".reset-button").show();
        }

        $scope.doneManualScan = function ()
        {
            //angular.element('#txt-barcode').hide();
            angular.element(".reset-button").show();
            angular.element('#manualScan').removeClass('hide-element');
            $scope.CheckShipmentOrders();
        };
        
        $scope.CheckShipmentOrders = function ()
        {
            apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/shipment/check-shipment-orders', {allproducts:$scope.duplicateCheck,customer_id:$rootScope.customerId,fromDate:$scope.fromDate,toDate:$scope.toDate})
            .success(function (response)
            {
                apiService.loaderHide();
                if(response.status == 'success')
                {
                    angular.element('#txt-barcode').hide();
                    angular.element('#manualScan').addClass('hide-element');
                    $scope.doneScanning = true;
                    $scope.hidePopup();
                }
                else if(response.type == "missing")
                {
                    $scope.message = response.message;
                    $scope.open('app/pages/shipment/shipmentCreate/warningMissingModal.html');
                }
                else if(response.type == "warning") {
                    $scope.message = response.message;
                    $scope.open('app/pages/shipment/shipmentCreate/warningModal.html');
                }
                else {
                    toastr.error(response.message);
                }
            }).error(function (error) {
                $scope.hidePopup();
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                else if (error && error.code != undefined && error.code == 0) {
                    toastr.warning(error.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        }

        $scope.yesCreate = function()
        {
            $scope.doneScanning = true;
            $scope.showItemScanned = true;
            angular.element('#manualScan').addClass('hide-element');
            angular.element('#scan-popup-barcode').hide();
            angular.element('#viewOrder').show();
            angular.element('#fade').hide();
            angular.element('#txt-barcode').hide();
            angular.element(".reset-button").show();
        }

        $scope.yesadd = function()
        {
            var val = $scope.scanningitem;
            if ($scope.duplicateCheck.indexOf(val) == -1)
            {
                apiService.loaderShow();
                $http.post($rootScope.baseUrl + '/shipment/addscanorder', {barcode:val,customer_id:$rootScope.customerId})
                .success(function (response)
                {
                    apiService.loaderHide();
                    if(response.status != 'fail')
                    {
                        angular.forEach(response, function (value, key)
                        {
                            if ($scope.duplicateCheck.indexOf(key) == -1)
                            {
                                $scope.duplicateCheck.push(key);
                                $scope.loadApiDataToHtml(value);
                                $scope.duplicateCheckRow.push(key);
                            }
                        });

                        angular.element("#resetScan").show();
                        angular.element('#txt-barcode').focus();
                        angular.element('#txt-barcode').val('');
                    }
                    else if(response.status == 'fail') {
                        toastr.error(response.message);
                    }
                    else {
                        toastr.error("No Order Found");
                    }
                });
            }
            this.barcodeText = '';
        };

        $scope.notadd = function()
        {
            angular.element('#txt-barcode').focus();
            angular.element('#txt-barcode').val('');
        };

        $scope.applyStatus = function ()
        {
            $scope.doneScanning = false;
            angular.element('#txt-barcode').hide();
            if ($scope.duplicateCheckRow.length > 0)
            {
                var customer_id = 0;
                if($rootScope.customerId > 0) {
                    customer_id = $rootScope.customerId;
                }
                
                apiService.loaderShow();
                var bodyData = {
                    ids: $scope.duplicateCheckRow.toString(),
                    username:$rootScope.globals.currentUser.name,
                    customer_id:customer_id
                };
                $http.post($rootScope.baseUrl + '/shipment/create-shipment', bodyData).success(function (response)
                {
                    apiService.loaderHide();
                    if(response.status=='success')
                    {
                        $scope.message = response.message;
                        $scope.open('app/pages/shipment/shipmentCreate/successModal.html');
                        //$scope.resetScan();
                        //toastr.success(response.message);
                        //$scope.showItemUpdated = true;
                        //$scope.showItemScanned = false;
                        
                    }
                    else {
                        toastr.error(response.message);
                    }
                    
                }).error(function (error) {
                    apiService.loaderHide();
                    if (error.data && error.data.code != undefined && error.data.code == 0) {
                        toastr.error(error.data.message);
                    } else {
                        toastr.error("Something went wrong please try again.");
                    }
                });
            } else {
                toastr.error("No scanned order found to create shipment.");
            }
        }

        $scope.shipmentCreated = function()
        {
            $scope.resetScan();
            $scope.showItemUpdated = true;
            $scope.showItemScanned = false;
            $state.go('shipment.ready-to-ship', null, {
                reload: true
            });
        };

        $scope.scanBarcode = function (val,storeId)
        {
            var vm = this;
            if(!val || val == undefined)
            {
                angular.element('#txt-barcode').focus();
                if(!$scope.duplicateCheckRow.length){
                    toastr.warning("please scan barcode of order.");
                }
                return;
            }
            
            val = val.trim();
            if ($scope.duplicateCheck.indexOf(val) !== -1)
            {
                angular.element('#txt-barcode').focus();
                if (vm.barcodeText.indexOf('_') > -1) {
                    toastr.warning("This item already scanned.");
                }
                else if (vm.barcodeText.indexOf('-') > -1) {
                    toastr.warning("This product already scanned.");
                } else {
                    toastr.warning("This order already scanned.");
                }
                vm.barcodeText = '';
                return;
            }
            /*else if (vm.barcodeText.indexOf('-') == -1) {
                toastr.warning("Please enter order item number");
                vm.barcodeText = '';
                return;
            }
            console.log(vm.barcodeText.indexOf('-'));*/

            if($scope.duplicateCheck.length == 1)
            {
                apiService.loaderShow();
                $http.post($rootScope.baseUrl + '/shipment/get-order-shipping-address', {orderid:$scope.duplicateCheck[0]})
                .success(function (response)
                {
                    apiService.loaderHide();
                    if(response.status != 'fail')
                    {
                        $scope.validateAddress = response.order_address;
                        $scope.getScanned(val,storeId);

                    }
                    else {
                        toastr.error(response.message);
                    }
                })
                .error(function (error)
                {
                    apiService.loaderHide();
                    toastr.error("Something went wrong please try again.");
                });
                //$scope.getOrderShippingAddress($scope.duplicateCheck[0]);
            }
            else {
                $scope.getScanned(val,storeId);
            }
        }

        $scope.getScanned = function (val, storeId)
        {
            apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/shipment/scanorders', {barcode:val,customer_id:$rootScope.customerId,allproducts:$scope.duplicateCheck,fromDate:$scope.fromDate,toDate:$scope.toDate,validate_address:$scope.validateAddress})
            .success(function (response)
            {
                apiService.loaderHide();
                if (angular.equals({}, response) || response.length == 0) {
                    toastr.warning("No order found with scanned id");
                }
                else 
                {
                    $scope.scanningitem =  val;

                    if(response.status == 'fail') {
                        toastr.warning(response.message);
                    }
                    else if(response.status == "missing")
                    {
                        $scope.message = response.message;
                        $scope.open('app/pages/shipment/shipmentCreate/warningMissingModal.html');
                    }
                    else if(response.status == "warning")
                    {
                        $scope.message = response.message;
                        $scope.open('app/pages/shipment/shipmentCreate/warningModal.html');
                    }
                    else
                    {
                        //$scope.duplicateCheck.push(val);
                        angular.forEach(response, function (value, key)
                        {
                            if ($scope.duplicateCheckRow.indexOf(key) == -1)
                            {
                                $scope.duplicateCheck.push(key);
                                $scope.loadApiDataToHtml(value);
                                $scope.duplicateCheckRow.push(key);
                            }
                        });

                        angular.element("#resetScan").show();
                        vm.barcodeText = '';
                        angular.element('#txt-barcode').focus();
                        angular.element('#txt-barcode').val('');
                    }
                }
            })
            .error(function (error)
            {
                apiService.loaderHide();
                if (error.data && error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                }
                else {
                    toastr.error("Something went wrong please try again.");
                }
                vm.barcodeText = '';
                angular.element('#txt-barcode').focus();
            });
        };

        $scope.open = function (page, size)
        {
          $scope.popupShow = $uibModal.open({
              animation: true,
              templateUrl: page,
              scope:$scope,
            });
        };

        $scope.checkDuplicate=function(origArr)
        {
        	var newArr = [],
            origLen = origArr.length,
            found, x, y;

            for (x = 0; x < origLen; x++)
            {
            	found = undefined;
                for (y = 0; y < newArr.length; y++)
                {
                	if (origArr[x] === newArr[y])
                	{
                    	found = true;
                    	break;
                    }
                }
                if (!found) {
                	newArr.push(origArr[x]);
                }
            }
            return newArr;
        }

        /**
         * load Api Data To Html is use to load html from api data
         * created on 05.08.2019
         */
        $scope.loadApiDataToHtml = function (value)
        {
        	var row='';
            if($rootScope.displayDisableIcons=='yes')
            {
            	if(value.icon_rocket && value.icon_rocket=='enable'){
                	row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
                }
                else{
                	row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                }
                if(value.icon_tools && value.icon_tools=='enable'){
                	row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
                }
                else{
                	row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                }
                
                if(value.icon_plane && value.icon_plane=='enable'){
                	row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
                }
                else{
                	row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed"> ';
                }

                if((value.icon_house && value.icon_house=='enable') || (value.is_ups && value.is_ups=='enable' || value.is_ups==1)){
                	row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
                }
                else{
                	row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" style="opacity:0.3;cursor:not-allowed">';
                }
                
                if ((value.type_total_count != undefined) && (value.type_total_count >= 1))
                {
                	var typeSlugName;
                    var typeExtName;
                    for (var i = 1; i <= value.type_total_count; i++) {
                    	typeSlugName = value['type_' + i + '_slug'];
                        typeExtName = value['type_' + i + '_extension'];
                        row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                    }
                }
                
                if(value.regular_orders && value.regular_orders=='enable'){
                	row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
                }
                row;
            }
            else if($rootScope.displayDisableIcons=='no')
            {
            	if(value.icon_rocket && value.icon_rocket=='enable'){
                	row = '<img src="'+$filter('appImage')('rocket.png')+'" height="25px" width="25px" title="Express"> ';
                }
                if(value.icon_tools && value.icon_tools=='enable'){
                	row += '<img src="'+$filter('appImage')('rework.png')+'" height="25px" width="25px" title="Rework"> ';
                }
                if(value.icon_plane && value.icon_plane=='enable'){
                	row += '<img src="'+$filter('appImage')('Preffered.png')+'" height="25px" width="25px" title="Preffered"> ';
                }
                if((value.icon_house && value.icon_house=='enable') || (value.is_ups && value.is_ups=='enable' || value.is_ups==1)){
                	row += '<img src="'+$filter('appImage')('Customer.png')+'" height="25px" width="25px" title="Customers">';
                }
                if ((value.type_total_count != undefined) && (value.type_total_count >= 1)) {
                	var typeSlugName;
                    var typeExtName;
                    for (var i = 1; i <= value.type_total_count; i++)
                    {
                    	typeSlugName = value['type_' + i + '_slug'];
                        typeExtName = value['type_' + i + '_extension'];
                        row += '<img src="'+$rootScope.customTypeIconAwsPath25x25+'/' + typeSlugName + '.' + typeExtName + '" height="25px" width="25px" title="' + typeSlugName + '">';
                    }
                }
                
                if(value.regular_orders && value.regular_orders=='enable'){
                	row += '<img src="'+$filter('appImage')('regular.png')+'" height="25px" width="25px" title="Regular"> ';
                }
                row;
            }
            var table  = "<tr>";
            table +="<td style='width:260px;'>"+row+"</td>";
            table += "<td style='width:260px;'>" + value.prod_qty_id+"</td>";
            table += "<td style='width:260px;'>" + value.product_name+" ("+value.product_sku+")</td>";
            table += "<td style='width:260px;'>" + $scope.UcCap(value.cust_name)+"</td>";
            table += "<td style='width:260px;'>" + value.total_qty+"</td>";
            table += "<td style='width:260px;'>" + value.weight+" lbs</td>";
            table += "<td style='width:260px;text-align:center;background-color:" + (value.color_code?value.color_code:'#8FB801') + "'>" + value.status+"</td>";
            table += "<td style='width:260px;text-align:center'>" + $scope.getGlobalDateFormat(value.created_time)+"</td>";
            if(value.is_ups == 1)
            {
            	table += "<td style='width:260px;text-align:center'>";
                table += "<img width='30' height='30' src='"+$rootScope.upsUrl+"' >";
                table += "</td>";
            }
            table += "</tr>";
            angular.element('#tblOrder tbody').prepend(table);
        }
    }
})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.shipment')
            .controller('shippedListCtrl', shippedListCtrl);

    /** @ngInject */
    function shippedListCtrl($scope, $filter, $state, $http, $location, $uibModal, $rootScope, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile, $timeout, apiService,$interval,$stateParams,$cookies,ngProgressFactory)
    {
    	var that = this;
        $rootScope.currentState=$state.current.name;
        $scope.changeOrderDateButtonData = '';
        $scope.changeOrderCreatedDateOrderId = 0;
        $scope.activeTabIndex=0;
        
        $scope.serchByList = ['Product','SKU','Invoice Number','Sales Man','Order Number','Designer','Keyword'];
        $scope.colvisOption = [{name: 'colvis',text: 'Select Columns',extend: 'colvis'}]//columns: ':gt(0)'
        
        $scope.selected = {};
        $scope.selectAll = false;
        $scope.isChangeStatus={change:false};
        $scope.isSelected={select:false};

        $scope.defaultAccount = 0;	
    }
})();
(function()
{
  'use strict';
  angular.module('BlurAdmin.pages.shippingTracker')
  .controller('figuringDashboardCtrl', figuringDashboardCtrl);

    /** @ngInject */
    function figuringDashboardCtrl($scope, $timeout, apiService, $uibModal, $http, $rootScope, $q, toastr, $state, baConfig,$location, $interval,$cookies)
    {
      /**
      * permissionArr is use to check permission to display list
      * created on 11.15.2017
      */
      if ($rootScope.permissionArr.indexOf('figuring_tracker_dashboard') == -1)
      {
        $state.go('dashboard');
        toastr.error("You don't have permission to do this.");
      }
      var vm = this;
      $rootScope.currentState = 'shipping-board.figuring-dashboard';
      $scope.resetGlobalSearch();
      $scope.destroy=false;
      /**
      * declare data and reset global variables.
      * created on 11.23.2017
      */
      $rootScope.isPieModified = true;
      $scope.pieChartArr = {};
      $scope.pieChartArrData = {};
      $scope.totalCounterShow = '0/0';
      $scope.totalInkStock = 0;
      $scope.colour_stock_data = [];
      $scope.showDynamicStickerCounter = false;
      $rootScope.regularCode = undefined;
      $rootScope.regularStatus = undefined;
      $rootScope.storeName = undefined;
      $scope.datePickerRegularShow = true;

      $scope.mallStatus = '';
      $scope.readyshipment = false;

      if (!$rootScope.datePickerRegular)
      {
        $rootScope.datePickerRegular = {
          date: $rootScope.datePicker.date
        };
      }

      /**
      * Options method is use configure date picker options
      * Created on 11.15.2017
      */
      $timeout(function() {
        angular.element('.input-mini').attr('readonly', true);
      }, 1000);
      $scope.options = {
        applyClass: 'btn-green',
        maxDate: moment(),
        locale: $rootScope.datePicker.locale,
        ranges: $rootScope.datePicker.options,
        eventHandlers: {
          'apply.daterangepicker': function() {
          $scope.datePickerRegularShow = true;
          $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
          $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
        },
        'hide.daterangepicker': function() {
          $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
          $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
        }
      }
    }

    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.focusInput = function() {
      angular.element('#dateRange').focus();
    }
    /**
      * Open model.
      * created on 11.15.2017
    */
    $scope.open = function(store, size, storeId, user)
    {
      $scope.mallStatus = '';
      $rootScope.storeListId = storeId;
      $rootScope.popupSize = $(window).height();
      $rootScope.popupSize = ($rootScope.popupSize - 40);
      $rootScope.popupSizeMin = ($rootScope.popupSize - 80);
      $rootScope.storeName = store;
      $rootScope.storeUserName = user;
      $rootScope.fromDate = $rootScope.datePickerRegular.date.startDate;
      $rootScope.toDate = $rootScope.datePickerRegular.date.endDate;
      $scope.getMallStatus();

      $scope.popupShow = $uibModal.open({
        animation: true,
        size: size,
        templateUrl: 'app/pages/shippingTracker/figuringDashboard/orderStatusModal.html',
        scope: $scope,
      });
      
      $scope.killStickerDetailsTimer();
      $scope.startRegularDetailsTimer();
    };

    /**
     * Main PieChart Data
     * created on 02.12.2018
     */
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.successLight, layoutColors.danger];
    $scope.colors = [{
      backgroundColor: '#cef353',
      pointBackgroundColor: layoutColors.successLight,
    },
    {
      backgroundColor: '#f97979',
      pointBackgroundColor: layoutColors.danger,
    }];

    $scope.labels = ["Total", "Comple."];
    $scope.pieChartOptions = 
    {
      tooltips: 
      {
        callbacks: 
        {
          label: function(tooltipItem, data) 
          {
            var cData = data.datasets[tooltipItem.datasetIndex].data;
            var _meta = data.datasets[tooltipItem.datasetIndex]._meta;
            var meta = _meta[Object.keys(_meta)[0]];
            var ttLbl = data.labels[tooltipItem.index];
            var ttData = cData[tooltipItem.index];
            var ttPct = 0;
            if (ttData == 0.01) {
              //return ttLbl + ': 0 (' + ttPct + ' %)';
              return [ttLbl, 'No. Orders : 0', '% : ' + ttPct + ' %'];
            } else {
              ttPct = Math.round((ttData / Math.floor(meta.total)) * 10000) / 100;
              //return ttLbl + ': ' + ttData + ' (' + ttPct + ' %)';
              return [ttLbl, 'No. Orders : ' + ttData, '% : ' + ttPct + ' %'];
            }
          }
        },
        bodyFontSize: 10
      },
      options: {
        maintainAspectRatio: false,
      },
      elements: 
      {
        arc: {
          borderWidth: 0
        }
      },
      legend: 
      {
        display: false,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.getMallStatus = function ()
    {
      $scope.mallStatus = '';
      $http.get($rootScope.baseUrl + '/config/shipmentSetting')
      .success(function(result)
      {
        if (result)
        {
          if (result.status == 'fail') {
            toastr.error(result.message);
          }
          else
          {
            if (result.data)
            {
              var resultData = result.data;
              var shipmentSetting = resultData.shipment_settings;
              $scope.mallStatus = shipmentSetting.mallStatus;
            }
          }
        }
      })
      .error(function(error)
      {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    };

    $scope.gotoShipmentCreate = function (user)
    {
      $rootScope.storeUserName = user;
      $state.go('shipment.shipment-create');
    }

    var canceler = $q.defer();
    /**
     * Load data from API is used for load status data.
     * created on 09.26.2017
     */
     $scope.loadDataFromAPI = function()
     {
      $scope.showDynamicStickerCounter = false;
      
      if ($rootScope.isPieModified != undefined && $rootScope.isPieModified)
      {
        $rootScope.isPieModified = false;
        $http.get($rootScope.baseUrl + '/pie/active-index').success(function (result)
        {
          angular.forEach(result, function (value, key)
          {
            $scope.pieChartArr[value.name] = value.name;
            $scope.pieChartArrData[value.name] = value;
          });
        }).error(function (error)
        {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
      }
      $scope.checkS =  canceler.resolve();

            canceler = $q.defer();
            //apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/system/dashboard', {
                from_date: $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate),
                to_date: $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate),
                status: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.statusPermission.toString() : ''),
                store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
                mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
            },{
                    timeout: canceler.promise
                })
                .success(function (response) {
                    // Get the size of an object
                    //apiService.loaderHide();
                    $scope.statusCategories = [];
                    $scope.piechartData = {};
                    $scope.settingArr  = response['top_property'];
                    $scope.statusCategories = response['data'];
                    
                    angular.forEach($scope.pieChartArrData, function (value, key) {
                        var regularStatistic = $scope.settingArr[value.dashboard_block];
                        var regPerc = regularStatistic['perc'];
                        if ($scope.statusCategories[value.dashboard_block] && $scope.statusCategories[value.dashboard_block][value.closing_status]) {
                            var regCompletePerc = $scope.statusCategories[value.dashboard_block][value.closing_status]['perc'];
                            regPerc = regCompletePerc.split('%')[0];
                        }
                        $scope.piechartData[value.name] = [regularStatistic['total_orders'],regularStatistic['orders_completed'],regPerc, value.dashboard_block];
                    });
                    
                    angular.forEach($scope.piechartData, function (arr, key) {
                        var arr =  $scope.statusCategories[arr[3]];
                        $scope.newChartArr = {};
                        $scope.newChartArr.lable = [];
                        $scope.newChartArr.value = [];
                        $scope.newChartArr.color = [];
                        
                        $scope.newChartArr.dashboard_block_type = [];
                        angular.forEach(arr, function (value, key) {
                          if(value.total){
                            $scope.newChartArr.lable.push(value.label);
                            $scope.newChartArr.value.push(value.total);
                            $scope.newChartArr.dashboard_block_type.push(value.dashboard_block_type);
                            $scope.newChartArr.color.push({
                                backgroundColor: value.color,
                                pointBackgroundColor: value.color,
                                
                              });
                          }
                        });
                        //Commented to hide static blocks
                        $scope.pieChartArr[key] = $scope.newChartArr;
                    });
                    
                    $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                }).error(function (response,ds,ff) {
                    if(ds != -1){
                        //apiService.loaderHide();
                        $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                        $scope.isShowPopup=false;
                        toastr.error("Something went wrong please try again.");
                    }
                });
                
        }
    


    $scope.loadDataFromAPI();
    /**
     * get Shipping store is used for display store list.
     * created on 11.23.2017
     */
    $scope.getShippingData = function() {
      //apiService.loaderShow();
      var bodyData = {
        from_date: $scope.datePickerRegularShow ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $scope.datePickerRegularShow ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      $http.post($rootScope.baseUrl + '/customer/getFiguringStores', bodyData).success(function(response) {
        //apiService.loaderHide();
        $rootScope.regularFlag = true;
        if (response && response.status == 'success') {
          $scope.storeData = response.data;
          $scope.orderTotal = response.total;
        } else {
          toastr.error("Something went wrong please try again.");
        }
      }).error(function(error) {
        //apiService.loaderHide();
        $rootScope.regularFlag = true;
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.applyFilter = function() {
      if (!this.shippingDashboardFrm.datePicker.$valid) {
        toastr.error("Please enter valid date range.");
        angular.element('#dateRange').focus();
        return;
      }
      $scope.getShippingData();
      $scope.loadDataFromAPI();
      $scope.getTypeMaster();
//      $scope.getDynamicStickerCounter();
      $scope.startStickerDetailsTimer();
      $scope.getTotalInkStock();
      /*$scope.getTypeMaster();
      $scope.getStickerDetails('print');
      $scope.getStickerDetails('express');
      $scope.getStickerDetails('supply');
      $scope.getStickerDetails('customer');
      $scope.getStickerDetails('rework');*/
    }
    
    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.resetFilter = function() {
      $rootScope.regularFlag = false;
      // $rootScope.datePickerRegular = {
      //   date: $rootScope.datePicker.date
      // };
      $rootScope.datePickerRegular={date:{startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}};
      $scope.loadDataFromAPI();
      $scope.getTypeMaster();
      $scope.getTotalInkStock();
//      $scope.getDynamicStickerCounter();
    }

    $scope.getTotalInkStock = function() {

      $http.get($rootScope.baseUrl + '/inventory/products/get-total-ink-stock')
        .success(function(result) {
          if (result) {
            $scope.totalInkStock = result.total_stock;
            $scope.colour_stock_data = result.color_stock;
            console.log($scope.colour_stock_data);
           //$scope.typeData=$scope.chunkArray(result,5);
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * search On Order List is used for load orders by click status.
     * created on 11.17.2017
     */
    $scope.searchOnOrderList = function(status, code, storeId, startDate, endDate, store, type_figurining) {
      $rootScope.storeId = storeId;
      $rootScope.storeName = store;
      $rootScope.regularCode = code;
      $rootScope.regularStatus = status;
      $rootScope.type_figurining = 1;
      $cookies.put('type_figurining', 1);
      $rootScope.datePickerRegular = {
        date: {
          startDate: startDate,
          endDate: endDate
        }
      };
      $state.go('shipping-board.regular');
    }
    
    /**
     * get Regular status is used for display regular order status list.
     * created on 11.20.2017
     */
    $scope.getRegularStatus = function() {
      var listStatus = [];
      //apiService.loaderShow();
      var bodyData = {
        from_date: $scope.saveFromDateFormat($rootScope.fromDate),
        to_date: $scope.saveToDateFormat($rootScope.toDate),
        store_id: $rootScope.storeListId ? $rootScope.storeListId : 0,
        fixstatus: $cookies.get('regularStatus')?$cookies.get('regularStatus'):'',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : ''),
        type_figurining: 1
      };
      $http.post($rootScope.baseUrl + '/ordertracker/regular-status', bodyData).success(function(response) {
        //apiService.loaderHide();
        if (response && response.status == 'success') {
          $scope.readyshipment = false;
          var displaybtn = 0; var allStatus= 0;
          if (response.data && response.data.length == 0) {
            $rootScope.popupSize = 201;
          } else {
            $scope.statusData = response.data;
            $.each($scope.statusData, function (key, val)
            {
              if(val.total_orders > 0) {
                allStatus = val.total_orders;
              }
              listStatus.push(val.status_code);
            });

            var indx = listStatus.indexOf($scope.mallStatus);
            
            $.each($scope.statusData, function (key, val)
            {
              if(listStatus.indexOf(val.status_code) >= indx && val.total_orders > 0)
              {
                if(indx == listStatus.indexOf(val.status_code) && val.total_orders > 0) {
                  displaybtn = 1;
                }
              }
            });

            $.each($scope.statusData, function (key, val)
            {
              if(listStatus.indexOf(val.status_code) < indx && val.total_orders > 0) {
                displaybtn = 0;
              }
            });

            if(allStatus == 0) {
              displaybtn = 0;
            } 

            if(displaybtn == 1) {
              $scope.readyshipment = true;
            }
            $scope.regOrderTotal = response.total;
          }
        } else {
          toastr.error("Something went wrong please try again.");
        }

      }).error(function(error) {
        //apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    
    $scope.getRegularStickerdetails=function(){
      var bodyData = {
        from_date: $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_id: $rootScope.storeListId ? $rootScope.storeListId : 0,
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      var userName = ($rootScope.globals.currentUser.name ? $rootScope.globals.currentUser.name : 'null');
      $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/print', bodyData).success(function(response) {
        //apiService.loaderHide();
        if (response.status != 'fail') {
          $scope.designCompleteTotalOrder = response.totalorder ? response.totalorder : 0;
          $scope.designCompleteTotalProduct = response.totalproduct ? response.totalproduct : 0;
        } else {
          $scope.designCompleteTotalOrder = 0;
          $scope.designCompleteTotalProduct = 0;
          toastr.error('Print sticker details not found.');
        }
      }).error(function(error) {
        //apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    
    /**
     * downloadSticker function is used for download pdf sticker
     * Created on 26.06.2018
     */
    $scope.downloadSticker = function(type) {
        var fromDate = $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : 'null';
        var toDate = $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : 'null';
        var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
        var userName = 'null';
        var urdd = $rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type+'/'+loginUserName;
        var fileNameWithType = 'print';
        if (type == 'rework') {
            fileNameWithType = 'rework';
        }
        $http.get(urdd,
            {
                responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_" +fileNameWithType+"_sticker.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    $scope.loadDataFromAPI();
                    $scope.getStickerDetails(type);
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
    }

    $scope.downloadUserSticker = function(type, user) {
      var fromDate = $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : 'null';
      var toDate = $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : 'null';
      var userName = user ? user : 'null';
      var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
      var storePermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : '');
      var mallCustomerPermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '');
      var downloadUrl=$rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type+'/'+loginUserName+'?store_permssion='+storePermission+'&mall_customer_permission='+mallCustomerPermission;
      $http.get(downloadUrl,
            {
                responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_print_sticker.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    $scope.loadDataFromAPI();
                    $scope.getRegularStickerdetails();
                    $scope.getRegularStatus();
                }else{
                    toastr.error('Something went wrong !');
                }
       }).error(function(error) {
        toastr.error('Something went wrong !');
      });
    }
    /**
     * getStickerDetails function is used for get sticker details
     * Created on 07.03.2018
     */
     vm.regTotalOrder = 0;
     vm.regTotalProduct = 0;
     vm.regStatusColor = '#7d7d7d';
     vm.expTotalOrder = 0;
     vm.expTotalProduct = 0;
     vm.expStatusColor = '#7d7d7d';
     vm.supTotalOrder = 0;
     vm.supTotalProduct = 0;
     vm.supStatusColor = '#7d7d7d';
     vm.custTotalOrder = 0;
     vm.custTotalProduct = 0;
     vm.custStatusColor = '#7d7d7d';
     vm.reworkTotalOrder = 0;
     vm.reworkTotalProduct = 0;
     vm.reworkStatusColor = '#7d7d7d';
    $scope.getStickerDetails = function(type) {
      var bodyData = {
        from_date: $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : ''
      };
      var userName = ($rootScope.globals.currentUser.name ? $rootScope.globals.currentUser.name : 'null');
      if (type == 'print') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.regStatus = response.status;
            vm.regTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.regTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.regStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Print sticker details not found.');
          }

        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
      }
      if (type == 'express') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.expStatus = response.status;
            vm.expTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.expTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.expStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Express sticker details not found.');
          }
        }).error(function(error) {

        });
      }
      if (type == 'supply') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.supStatus = response.status;
            vm.supTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.supTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.supStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Supply sticker details not found.');
          }
        }).error(function(error) {

        });
      }
      if (type == 'customer') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.custStatus = response.status;
            vm.custTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.custTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.custStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Customer sticker details not found.');
          }
        }).error(function(error) {});
      }
      if (type == 'rework') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.reworkStatus = response.status;
            vm.reworkTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.reworkTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.reworkStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Rework sticker details not found.');
          }
        }).error(function(error) {});
      }
    }
    
    // auto refresh sticker details
    $scope.startStickerDetailsTimer=function(){
      $scope.stickerTimer=$interval(function(){
          if(!$scope.destroy){
              $scope.getShippingData();
            
//        if($location.path() == '/shippin-board/dashboard'){
//          if($rootScope.regularFlag == true){
//            $scope.getStickerDetails('print');
//            $scope.getStickerDetails('express');
//            $scope.getStickerDetails('supply');
//            $scope.getStickerDetails('customer');
//            $scope.getStickerDetails('rework');
//            $scope.loadDataFromAPI();
            //$scope.obj=[];
           angular.forEach($scope.typeMaster, function(value, key) {
              if (value) {
                $scope.getDynamicStickerDetails(value.sticker_type,key, value);
             }
           });
           $scope.totalCounterShow = '0/0';
           var item = 0;
           var order = 0;
           angular.forEach($scope.totalCounter, function(value, key) {
                if (value && $rootScope.permissionArr.indexOf('view-pie-chart-shipping-dashboard-' + value[0].pie_name) != -1) {
                    item = item + value[0].item;
                    order = order + value[0].order;
                }
           });
           $scope.totalCounterShow = order + '/' + item;
           
//          }
//        }
          }
            
      },15000);
    }
    
//    $scope.getDynamicStickerCounter=function(){
//        $scope.getShippingData();
//        $scope.loadDataFromAPI();
//        angular.forEach($scope.typeMaster, function (value, key) {
//            if (value) {
//                $scope.getDynamicStickerDetails(value.sticker_type, key, value);
//            }
//        });
//    }
    
    $scope.startStickerDetailsTimer();
    $scope.killStickerDetailsTimer=function(){
      if(angular.isDefined($scope.stickerTimer))
        {
          $interval.cancel($scope.stickerTimer);
          $scope.stickerTimer=undefined;
        }
    };    
    // shipping - regular popup details timer
    $scope.startRegularDetailsTimer=function(){
      $scope.regularTimer=$interval(function(){
        if($location.path() == '/shipping-board/dashboard'){
          if($rootScope.storeListId){
            $scope.getRegularStickerdetails();
            $scope.getRegularStatus();
          }
        }
      },10000);
    }
    $scope.killRegularDetailsTimer=function(){
      if(angular.isDefined($scope.regularTimer))
        {
          $interval.cancel($scope.regularTimer);
          $scope.regularTimer=undefined;
        }
    };
    $scope.closePopup=function(){
      $rootScope.storeListId=undefined;
      $scope.killRegularDetailsTimer();
      $scope.startStickerDetailsTimer();
    }
      /**
    * get all type master
    */
    $scope.getTypeMaster = function() {
      $scope.isloaded = false;
      $scope.showDynamicStickerCounter = false;
      //$http.get($rootScope.baseUrl + '/productType/getActiveType')
      $http.get($rootScope.baseUrl + '/pie/active-sticker-index')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
           $scope.typeMaster=result;
           //$scope.typeData=$scope.chunkArray(result,5);
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }
    $scope.$on("$destroy", function() {
        $scope.destroy=true;
        $scope.killStickerDetailsTimer();
        $scope.killRegularDetailsTimer();
    });
    /**
     * this method use for get chunk of array o
     * @param {type} myArray
     * @param {type} chunk_size
     * @returns {Array}
     */
   $scope.chunkArray= function(myArray, chunk_size){
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];
    var myChunk  = [];
    for (index = 0; index < arrayLength; index += chunk_size) {
        myChunk = myArray.slice(index, index+chunk_size);
        // Do something if you want with the group
        tempArray.push(myChunk);
    }
   return tempArray;
   }
   /**
    * this method is used for get dynamic sticker details
    * create 1 feb 2019
    */
   $scope.obj=[];
   $scope.totalCounter = {};
   $scope.getDynamicStickerDetails = function(type ,key, pieDetails) {
     var type_master=type;
    var typeName = "dynamic_sticker_" + type;
    type = "dynamic_sticker_" + type;
    var bodyData = {
        from_date: $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        type : type_master,
        pie_data : pieDetails,
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      var userName = ($rootScope.globals.currentUser.name ? $rootScope.globals.currentUser.name : 'null');
      $http.post($rootScope.baseUrl + '/sticker-print/getFiguringStickerDetail/' + userName + '/' + typeName, bodyData).success(function(response) {
          if (response.status != 'fail') {
                var tmp={};
                tmp.regStatus = response.status;
                tmp.regTotalOrder= response.totalorder ? response.totalorder : 0;
                tmp.regTotalProduct = response.totalproduct ? response.totalproduct : 0;
                tmp.regStatusColor= response.color_code ? response.color_code : '#7d7d7d';
                tmp.regStatusColor= response.color_code ? response.color_code : '#7d7d7d';
                tmp.stickerType = pieDetails.sticker_type ? pieDetails.sticker_type : 'none';
                $scope.obj[pieDetails.name]=tmp;
                $scope.totalCounter[type_master] = [{order:tmp.regTotalOrder, item:tmp.regTotalProduct, pie_name:pieDetails.name}];
          } else {
            toastr.error('Print sticker details not found.');
          }

        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
      }
      /**
       * this method used for downloadDynamicSticker
       */
    $scope.downloadDynamicSticker = function(type)
    {
        var pieDashboardBlock = type.dashboard_block;
        var sticker_type="dynamic";
        var onlyTypeName = type.sticker_type;
        type="dynamic_sticker_"+type.sticker_type;
        var fromDate = $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : 'null';
        var toDate = $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : 'null';
        var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
        var userName = 'null';
        var storePermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : '');
        var mallCustomerPermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '');
        var urdd = $rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type +'/'+loginUserName+'/'+sticker_type+'/'+pieDashboardBlock+'?store_permssion='+storePermission+'&mall_customer_permission='+mallCustomerPermission;
        var fileNameWithType = 'print';
        if (type == 'rework') {
            fileNameWithType = 'rework';
        }
        $http.get(urdd,
            {
                responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_" + onlyTypeName + "_sticker.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    $scope.loadDataFromAPI();
                    $scope.getStickerDetails(type);
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
    }

    $scope.resetManualDate=function()
    {
      $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
      $rootScope.datePickerRegular.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
    }
  }
})();
/**
 * Shipping Tracker regular controller is handle all actions related to regular module.
 * @author Harsha Prajapati
 * created on 11.16.2017
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.shippingTracker')
    .controller('regularCtrl', regularCtrl);
  /** @ngInject */
  function regularCtrl($scope, $timeout, apiService, $uibModal, $http, $rootScope, toastr, $state, DTOptionsBuilder, DTColumnBuilder,$compile,$filter,$cookies) {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.16.2017
     */
    if ($rootScope.permissionArr.indexOf('shipping_tracker_regular') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'shipping-board.regular-status';
    $scope.resetGlobalSearch();
    /**
     * declare data.
     * created on 11.16.2017
     */
     if($rootScope.regularFlag!=true){
       $state.go('shipping-board.dashboard');
     }
     $timeout(function () {
           angular.element('.input-mini').attr('readonly',true);
        }, 1000);
     if(!$rootScope.datePickerRegular){
        $rootScope.datePickerRegular = {date:$rootScope.datePicker.date};
     }else{
       $scope.datePickerRegularShow = true;
     }
     /**
    * Options method is use configure date picker options
    * Created on 11.16.2017
    */

    $scope.options = {
        applyClass: 'btn-green',
        maxDate: moment(),
        locale: $rootScope.datePicker.locale,
        ranges: $rootScope.datePicker.options,
        eventHandlers : {
            'apply.daterangepicker' : function() {
              $scope.datePickerRegularShow = true;
              $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
              $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
            },
            'hide.daterangepicker':function() {
                $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
                $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
            }
        }
    }

    $scope.resetManualDate=function(){
            $rootScope.datePickerOrder.date={startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePickerOrder.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
            $rootScope.datePickerRegular.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
    }
    /**
    * Set Focus Of Date Picker
    * Created on 11.16.2017
    */
    $scope.focusInput=function(){
      angular.element('#dateRange').focus();
    }
    /**
    * reset Search is use to reset filters
    * created on 11.21.2017
    */
    $scope.resetSearch = function (){
        $rootScope.regularFlag=false;
        //$rootScope.datePickerRegular = {date:$rootScope.datePicker.date};
        $rootScope.datePickerRegular={date:{startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}};
        $state.go('shipping-board.dashboard')
    }
    /**
     * get Regular status is used for display regular order status list.
     * created on 11.20.2017
     */
    $scope.getRegularStatus = function() {
      apiService.loaderShow();
      var bodyData = {
        from_date: $scope.datePickerRegularShow ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $scope.datePickerRegularShow ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_id: 'all',
        fixstatus:$cookies.get('regularStatus')?$cookies.get('regularStatus'):'',
        store_permssion:($rootScope.globals.currentUser.store_permission?$rootScope.globals.currentUser.store_permission.toString():''),
        mall_customer_permission:($rootScope.globals.currentUser.mall_customer_permission?$rootScope.globals.currentUser.mall_customer_permission.toString():'')
      };
      $http.post($rootScope.baseUrl + '/ordertracker/regular-status', bodyData).success(function(response) {
        apiService.loaderHide();
        if (response && response.status == 'success') {
          if (response.data && response.data.length == 0) {
            $rootScope.popupSize = 201;
          } else {
            $scope.statusData = response.data;
            $scope.regOrderTotal = response.total;
          }
        }

      }).error(function(error) {
        apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    /**
     * search On Order List is used for load orders by click status.
     * created on 11.17.2017
     */
    $scope.searchOnOrderList = function(status, code) {
      $rootScope.regularCode = code;
      $rootScope.regularStatus = status;
      //$scope.datePickerRegularShow=true;
      $rootScope.datePickerRegular=$rootScope.datePickerRegular;
      $rootScope.storeListId = undefined;
      $rootScope.storeName = undefined;
      $state.go('shipping-board.regular');
    }
  }
})();

/**
 * Shipping Tracker dashboard controller is handle all actions related to Settings.
 * @author Harsha Prajapati
 * created on 11.7.2017
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.shippingTracker')
    .controller('shippingBlockCtrl', shippingBlockCtrl);
  /** @ngInject */
  function shippingBlockCtrl($scope, apiService, $http, $rootScope, toastr, $state,$cookies) {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.7.2017
     */
    if ($rootScope.permissionArr.indexOf('shipping_block') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'shipping-board.shipping-block';
    $scope.resetGlobalSearch();
    /**
     * declare data.
     * created on 11.10.2017
     */
    vm.orderStatusData = [];
    /**
     * get Selected Status Data method is use to display Selected status data.
     * created on 11.10.2017
     */
    $scope.getSelectedStatusData = function() {
      $scope.setOfSets = [];
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/setting/shipping-block')
          .success(function (result) {
            $scope.isloaded = true;
            if(result){
              if(result.status=='success'){
                if(result.data.shipping_block_status){
                  vm.shippingBlockStatus=result.data.shipping_block_status;
                  var regularBlock=result.data.shipping_block_status[0].status;
                  var regular=[];
                  angular.forEach(regularBlock,function(val,key){
                    regular.push(val.status_code);
                  });
                  $cookies.put('regularStatus',regular.toString());
                  var supplyBlock=result.data.shipping_block_status[1].status;
                  var supply=[];
                  angular.forEach(supplyBlock,function(val,key){
                    supply.push(val.status_code);
                  });
                  $cookies.put('supplyStatus',supply.toString());
                  var expBlock=result.data.shipping_block_status[2].status;
                  var express=[];
                  angular.forEach(expBlock,function(val,key){
                    express.push(val.status_code);
                  });
                  $cookies.put('expressStatus',express.toString());
                  var custBlock=result.data.shipping_block_status[3].status;
                  var customers=[];
                  angular.forEach(custBlock,function(val,key){
                    customers.push(val.status_code);
                  });
                  $cookies.put('customersStatus',customers.toString());
                  
                  var reworkBlock=result.data.shipping_block_status[4].status;
                  var rework=[];
                  angular.forEach(reworkBlock,function(val,key){
                    rework.push(val.status_code);
                  });
                  $cookies.put('reworkStatus',rework.toString());
                }
              }else{
                vm.shippingBlockStatus=[
                          {
                            "block":"Regular",
                            "status": []
                          },
                          {
                            "block":"Supply",
                            "status": []
                          },
                          {
                            "block":"Express",
                            "status": []
                          },
                          {
                            "block":"Customers",
                            "status": []
                          },
                          {
                            "block":"Rework",
                            "status": []
                          }
                        ];
              }
              var half_length = Math.ceil(vm.shippingBlockStatus.length / 2);
              var leftArray = vm.shippingBlockStatus.splice(0,half_length);
              var rightArray = vm.shippingBlockStatus.splice(0,vm.shippingBlockStatus.length);
              $scope.setOfSets.push(leftArray);
              $scope.setOfSets.push(rightArray);
            }
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });
    }
    /**
     * get Active Status Data method is use to display Active status data.
     * created on 10.26.2017
     */
    $scope.getActiveStatusData = function() {
      $http.post($rootScope.baseUrl + '/status/activeAll')
          .success(function (result) {
            vm.orderStatusData = result;
          }).error(function (error) {
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message, 'Error');
              }
          });
    }
    /**
    * remove regular status data method is use to delete regular status.
    * created on 06.07.2018
    */
    $scope.removeRegularStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 06.07.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }
    /**
    * sortable Options.
    * created on 06.07.2018
    */
    $scope.sortableOptionStatus = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
    /**
     * save Shipping Tracker Settings Data method is use to add Shipping Tracker data.
     * created on 11.10.2017
     */
    $scope.saveShippingBlockStatus = function(){
        $scope.temp = [];
        angular.forEach($scope.setOfSets,function(value,key){
          angular.forEach(value,function(val,ke){
            $scope.temp.push(val);
          });
        });
        vm.shippingTrackerData = {
            'shipping_block_status':$scope.temp
        };
        var bodyData = {
          settingData: angular.toJson(vm.shippingTrackerData),
        };
        $http.post($rootScope.baseUrl + '/config/setting/save-shipping-block', bodyData).success(function(response) {
          toastr.success(response.message);
          $scope.getSelectedStatusData();
        }).error(function(error) {
          if (error && error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
    }
  }
})();

(function()
{
  'use strict';
  angular.module('BlurAdmin.pages.shippingTracker')
  .controller('shippingTrackerDashboardCtrl', shippingTrackerDashboardCtrl);

    /** @ngInject */
    function shippingTrackerDashboardCtrl($scope, $timeout, apiService, $uibModal, $http, $rootScope, $q, toastr, $state, baConfig,$location, $interval,$cookies)
    {
      /**
      * permissionArr is use to check permission to display list
      * created on 11.15.2017
      */
      if ($rootScope.permissionArr.indexOf('shipping_tracker_dashboard') == -1)
      {
        $state.go('dashboard');
        toastr.error("You don't have permission to do this.");
      }
      var vm = this;
      $rootScope.currentState = 'shipping-board.dashboard';
      $scope.resetGlobalSearch();
      $scope.destroy=false;
      /**
      * declare data and reset global variables.
      * created on 11.23.2017
      */
      $rootScope.isPieModified = true;
      $scope.pieChartArr = {};
      $scope.pieChartArrData = {};
      $scope.totalCounterShow = '';
      $scope.showDynamicStickerCounter = false;
      $rootScope.regularCode = undefined;
      $rootScope.regularStatus = undefined;
      $rootScope.storeName = undefined;
      $scope.datePickerRegularShow = true;

      $scope.mallStatus = '';
      $scope.readyshipment = false;

      if (!$rootScope.datePickerRegular)
      {
        $rootScope.datePickerRegular = {
          date: $rootScope.datePicker.date
        };
      }

      /**
      * Options method is use configure date picker options
      * Created on 11.15.2017
      */
      $timeout(function() {
        angular.element('.input-mini').attr('readonly', true);
      }, 1000);
      $scope.options = {
        applyClass: 'btn-green',
        maxDate: moment(),
        locale: $rootScope.datePicker.locale,
        ranges: $rootScope.datePicker.options,
        eventHandlers: {
          'apply.daterangepicker': function() {
          $scope.datePickerRegularShow = true;
          $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
          $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
        },
        'hide.daterangepicker': function() {
          $rootScope.datePickerRegular.date.startDate = moment($rootScope.datePickerRegular.date.startDate).format('YYYY-MM-DD');
          $rootScope.datePickerRegular.date.endDate = moment($rootScope.datePickerRegular.date.endDate).format('YYYY-MM-DD');
        }
      }
    }

    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.focusInput = function() {
      angular.element('#dateRange').focus();
    }
    /**
      * Open model.
      * created on 11.15.2017
    */
    $scope.open = function(store, size, storeId, user)
    {
      $scope.mallStatus = '';
      $rootScope.storeListId = storeId;
      $rootScope.popupSize = $(window).height();
      $rootScope.popupSize = ($rootScope.popupSize - 40);
      $rootScope.popupSizeMin = ($rootScope.popupSize - 80);
      $rootScope.storeName = store;
      $rootScope.storeUserName = user;
      $rootScope.fromDate = $rootScope.datePickerRegular.date.startDate;
      $rootScope.toDate = $rootScope.datePickerRegular.date.endDate;
      
      $scope.getMallStatus();

      $scope.popupShow = $uibModal.open({
        animation: true,
        size: size,
        templateUrl: 'app/pages/shippingTracker/shippingTrackerDashboard/orderStatusModal.html',
        scope: $scope,
      });
      
      $scope.killStickerDetailsTimer();
      $scope.startRegularDetailsTimer();
    };

    /**
     * Main PieChart Data
     * created on 02.12.2018
     */
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.successLight, layoutColors.danger];
    $scope.colors = [{
      backgroundColor: '#cef353',
      pointBackgroundColor: layoutColors.successLight,
    },
    {
      backgroundColor: '#f97979',
      pointBackgroundColor: layoutColors.danger,
    }];

    $scope.labels = ["Total", "Comple."];
    $scope.pieChartOptions = 
    {
      tooltips: 
      {
        callbacks: 
        {
          label: function(tooltipItem, data) 
          {
            var cData = data.datasets[tooltipItem.datasetIndex].data;
            var _meta = data.datasets[tooltipItem.datasetIndex]._meta;
            var meta = _meta[Object.keys(_meta)[0]];
            var ttLbl = data.labels[tooltipItem.index];
            var ttData = cData[tooltipItem.index];
            var ttPct = 0;
            if (ttData == 0.01) {
              //return ttLbl + ': 0 (' + ttPct + ' %)';
              return [ttLbl, 'No. Orders : 0', '% : ' + ttPct + ' %'];
            } else {
              ttPct = Math.round((ttData / Math.floor(meta.total)) * 10000) / 100;
              //return ttLbl + ': ' + ttData + ' (' + ttPct + ' %)';
              return [ttLbl, 'No. Orders : ' + ttData, '% : ' + ttPct + ' %'];
            }
          }
        },
        bodyFontSize: 10
      },
      options: {
        maintainAspectRatio: false,
      },
      elements: 
      {
        arc: {
          borderWidth: 0
        }
      },
      legend: 
      {
        display: false,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.getMallStatus = function ()
    {
      $scope.mallStatus = '';
      $http.get($rootScope.baseUrl + '/config/shipmentSetting')
      .success(function(result)
      {
        if (result)
        {
          if (result.status == 'fail') {
            toastr.error(result.message);
          }
          else
          {
            if (result.data)
            {
              var resultData = result.data;
              var shipmentSetting = resultData.shipment_settings;
              $scope.mallStatus = shipmentSetting.mallStatus;
            }
          }
        }
      })
      .error(function(error)
      {
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        }
      });
    };

    $scope.gotoShipmentCreate = function (user)
    {
      $rootScope.storeUserName = user;
      $state.go('shipment.shipment-create');
    }

    var canceler = $q.defer();
    /**
     * Load data from API is used for load status data.
     * created on 09.26.2017
     */
     $scope.loadDataFromAPI = function()
     {
      $scope.showDynamicStickerCounter = false;
      
      if ($rootScope.isPieModified != undefined && $rootScope.isPieModified)
      {
        $rootScope.isPieModified = false;
        $http.get($rootScope.baseUrl + '/pie/active-index').success(function (result)
        {
          angular.forEach(result, function (value, key)
          {
            $scope.pieChartArr[value.name] = value.name;
            $scope.pieChartArrData[value.name] = value;
          });
        }).error(function (error)
        {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
      }
      $scope.checkS =  canceler.resolve();

            canceler = $q.defer();
            //apiService.loaderShow();
            $http.post($rootScope.baseUrl + '/system/dashboard', {
                from_date: $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate),
                to_date: $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate),
                status: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.statusPermission.toString() : ''),
                store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
                mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
            },{
                    timeout: canceler.promise
                })
                .success(function (response) {
                    // Get the size of an object
                    //apiService.loaderHide();
                    $scope.statusCategories = [];
                    $scope.piechartData = {};
                    $scope.settingArr  = response['top_property'];
                    $scope.statusCategories = response['data'];
                    
                    angular.forEach($scope.pieChartArrData, function (value, key) {
                        var regularStatistic = $scope.settingArr[value.dashboard_block];
                        var regPerc = regularStatistic['perc'];
                        if ($scope.statusCategories[value.dashboard_block] && $scope.statusCategories[value.dashboard_block][value.closing_status]) {
                            var regCompletePerc = $scope.statusCategories[value.dashboard_block][value.closing_status]['perc'];
                            regPerc = regCompletePerc.split('%')[0];
                        }
                        $scope.piechartData[value.name] = [regularStatistic['total_orders'],regularStatistic['orders_completed'],regPerc, value.dashboard_block];
                    });
                    
                    angular.forEach($scope.piechartData, function (arr, key) {
                        var arr =  $scope.statusCategories[arr[3]];
                        $scope.newChartArr = {};
                        $scope.newChartArr.lable = [];
                        $scope.newChartArr.value = [];
                        $scope.newChartArr.color = [];
                        
                        $scope.newChartArr.dashboard_block_type = [];
                        angular.forEach(arr, function (value, key) {
                          if(value.total){
                            $scope.newChartArr.lable.push(value.label);
                            $scope.newChartArr.value.push(value.total);
                            $scope.newChartArr.dashboard_block_type.push(value.dashboard_block_type);
                            $scope.newChartArr.color.push({
                                backgroundColor: value.color,
                                pointBackgroundColor: value.color,
                                
                              });
                          }
                        });
                        //Commented to hide static blocks
                        $scope.pieChartArr[key] = $scope.newChartArr;
                    });
                    
                    $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                }).error(function (response,ds,ff) {
                    if(ds != -1){
                        //apiService.loaderHide();
                        $rootScope.lastRefreshTime = $rootScope.globalSetting.dateTimeFormate?moment().format($rootScope.globalSetting.dateTimeFormate):moment().format('YYYY-MM-DD hh:mm A');
                        $scope.isShowPopup=false;
                        toastr.error("Something went wrong please try again.");
                    }
                });
                
        }
    


    $scope.loadDataFromAPI();
    /**
     * get Shipping store is used for display store list.
     * created on 11.23.2017
     */
    $scope.getShippingData = function() {
      //apiService.loaderShow();
      var bodyData = {
        from_date: $scope.datePickerRegularShow ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $scope.datePickerRegularShow ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      $http.post($rootScope.baseUrl + '/customer/getStores', bodyData).success(function(response) {
        //apiService.loaderHide();
        $rootScope.regularFlag = true;
        if (response && response.status == 'success') {
          $scope.storeData = response.data;
          $scope.orderTotal = response.total;
        } else {
          toastr.error("Something went wrong please try again.");
        }
      }).error(function(error) {
        //apiService.loaderHide();
        $rootScope.regularFlag = true;
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.applyFilter = function() {
      if (!this.shippingDashboardFrm.datePicker.$valid) {
        toastr.error("Please enter valid date range.");
        angular.element('#dateRange').focus();
        return;
      }
      $scope.getShippingData();
      $scope.loadDataFromAPI();
      $scope.getTypeMaster();
//      $scope.getDynamicStickerCounter();
      $scope.startStickerDetailsTimer();
      /*$scope.getTypeMaster();
      $scope.getStickerDetails('print');
      $scope.getStickerDetails('express');
      $scope.getStickerDetails('supply');
      $scope.getStickerDetails('customer');
      $scope.getStickerDetails('rework');*/
    }
    
    /**
     * Set Focus Of Date Picker
     * Created on 11.15.2017
     */
    $scope.resetFilter = function() {
      $rootScope.regularFlag = false;
      // $rootScope.datePickerRegular = {
      //   date: $rootScope.datePicker.date
      // };
      $rootScope.datePickerRegular={date:{startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')}};
      $scope.loadDataFromAPI();
      $scope.getTypeMaster();
//      $scope.getDynamicStickerCounter();
    }

    /**
     * search On Order List is used for load orders by click status.
     * created on 11.17.2017
     */
    $scope.searchOnOrderList = function(status, code, storeId, startDate, endDate, store) {
      $rootScope.storeId = storeId;
      $rootScope.storeName = store;
      $rootScope.regularCode = code;
      $rootScope.regularStatus = status;
      $rootScope.type_figurining = 0;
      $cookies.put('type_figurining', 0);
      
      $rootScope.shipDashFromDate = startDate;
      $rootScope.shipDashToDate = endDate;

      $rootScope.datePickerRegular = {
        date: {
          startDate: startDate,
          endDate: endDate
        }
      };

      console.log($rootScope.shipDashFromDate);
      console.log($rootScope.shipDashToDate);
      $state.go('shipping-board.regular');
    }
    
    /**
     * get Regular status is used for display regular order status list.
     * created on 11.20.2017
     */
    $scope.getRegularStatus = function() {
      var listStatus = [];

      //apiService.loaderShow();
      var bodyData = {
        from_date: $scope.saveFromDateFormat($rootScope.fromDate),
        to_date: $scope.saveToDateFormat($rootScope.toDate),
        store_id: $rootScope.storeListId ? $rootScope.storeListId : 0,
        fixstatus: $cookies.get('regularStatus')?$cookies.get('regularStatus'):'',
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      $http.post($rootScope.baseUrl + '/ordertracker/regular-status', bodyData).success(function(response) {
        //apiService.loaderHide();
        if (response && response.status == 'success') {
          $scope.readyshipment = false;
          var displaybtn = 0; var allStatus= 0;
          if (response.data && response.data.length == 0) {
            $rootScope.popupSize = 201;
          } else {
            $scope.statusData = response.data;
            $.each($scope.statusData, function (key, val)
            {
              if(val.total_orders > 0) {
                allStatus = val.total_orders;
              }
              listStatus.push(val.status_code);
            });

            var indx = listStatus.indexOf($scope.mallStatus);
            
            $.each($scope.statusData, function (key, val)
            {
              if(listStatus.indexOf(val.status_code) >= indx && val.total_orders > 0)
              {
                if(indx == listStatus.indexOf(val.status_code) && val.total_orders > 0) {
                  displaybtn = 1;
                }
              }
            });

            $.each($scope.statusData, function (key, val)
            {
              if(listStatus.indexOf(val.status_code) < indx && val.total_orders > 0) {
                displaybtn = 0;
              }
            });

            if(allStatus == 0) {
              displaybtn = 0;
            } 

            if(displaybtn == 1) {
              $scope.readyshipment = true;
            }
            $scope.regOrderTotal = response.total;
          }
        } else {
          toastr.error("Something went wrong please try again.");
        }

      }).error(function(error) {
        //apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    
    $scope.getRegularStickerdetails=function(){
      var bodyData = {
        from_date: $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        store_id: $rootScope.storeListId ? $rootScope.storeListId : 0,
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '')
      };
      var userName = ($rootScope.globals.currentUser.name ? $rootScope.globals.currentUser.name : 'null');
      $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/print', bodyData).success(function(response) {
        //apiService.loaderHide();
        if (response.status != 'fail') {
          $scope.designCompleteTotalOrder = response.totalorder ? response.totalorder : 0;
          $scope.designCompleteTotalProduct = response.totalproduct ? response.totalproduct : 0;
        } else {
          $scope.designCompleteTotalOrder = 0;
          $scope.designCompleteTotalProduct = 0;
          toastr.error('Print sticker details not found.');
        }
      }).error(function(error) {
        //apiService.loaderHide();
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    
    /**
     * downloadSticker function is used for download pdf sticker
     * Created on 26.06.2018
     */
    $scope.downloadSticker = function(type) {
        var fromDate = $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : 'null';
        var toDate = $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : 'null';
        var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
        var userName = 'null';
        var urdd = $rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type+'/'+loginUserName;
        var fileNameWithType = 'print';
        if (type == 'rework') {
            fileNameWithType = 'rework';
        }
        $http.get(urdd,
            {
                responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_" +fileNameWithType+"_sticker.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    $scope.loadDataFromAPI();
                    $scope.getStickerDetails(type);
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
    }

    $scope.downloadUserSticker = function(type, user) {
      var fromDate = $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : 'null';
      var toDate = $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : 'null';
      var userName = user ? user : 'null';
      var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
      var storePermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : '');
      var mallCustomerPermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '');
      var downloadUrl=$rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type+'/'+loginUserName+'?store_permssion='+storePermission+'&mall_customer_permission='+mallCustomerPermission;
      $http.get(downloadUrl,
            {
                responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_print_sticker.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    $scope.loadDataFromAPI();
                    $scope.getRegularStickerdetails();
                    $scope.getRegularStatus();
                }else{
                    toastr.error('Something went wrong !');
                }
       }).error(function(error) {
        toastr.error('Something went wrong !');
      });
    }
    /**
     * getStickerDetails function is used for get sticker details
     * Created on 07.03.2018
     */
     vm.regTotalOrder = 0;
     vm.regTotalProduct = 0;
     vm.regStatusColor = '#7d7d7d';
     vm.expTotalOrder = 0;
     vm.expTotalProduct = 0;
     vm.expStatusColor = '#7d7d7d';
     vm.supTotalOrder = 0;
     vm.supTotalProduct = 0;
     vm.supStatusColor = '#7d7d7d';
     vm.custTotalOrder = 0;
     vm.custTotalProduct = 0;
     vm.custStatusColor = '#7d7d7d';
     vm.reworkTotalOrder = 0;
     vm.reworkTotalProduct = 0;
     vm.reworkStatusColor = '#7d7d7d';
    $scope.getStickerDetails = function(type) {
      var bodyData = {
        from_date: $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : ''
      };
      var userName = ($rootScope.globals.currentUser.name ? $rootScope.globals.currentUser.name : 'null');
      if (type == 'print') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.regStatus = response.status;
            vm.regTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.regTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.regStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Print sticker details not found.');
          }

        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
      }
      if (type == 'express') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.expStatus = response.status;
            vm.expTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.expTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.expStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Express sticker details not found.');
          }
        }).error(function(error) {

        });
      }
      if (type == 'supply') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.supStatus = response.status;
            vm.supTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.supTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.supStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Supply sticker details not found.');
          }
        }).error(function(error) {

        });
      }
      if (type == 'customer') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.custStatus = response.status;
            vm.custTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.custTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.custStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Customer sticker details not found.');
          }
        }).error(function(error) {});
      }
      if (type == 'rework') {
        $http.post($rootScope.baseUrl + '/sticker-print/getstickerdetail/' + userName + '/' + type, bodyData).success(function(response) {
          if (response.status != 'fail') {
            vm.reworkStatus = response.status;
            vm.reworkTotalOrder = response.totalorder ? response.totalorder : 0;
            vm.reworkTotalProduct = response.totalproduct ? response.totalproduct : 0;
            vm.reworkStatusColor = response.color_code ? response.color_code : '#7d7d7d';
          } else {
            toastr.error('Rework sticker details not found.');
          }
        }).error(function(error) {});
      }
    }
    
    // auto refresh sticker details
    $scope.startStickerDetailsTimer=function(){
      $scope.stickerTimer=$interval(function(){
          if(!$scope.destroy){
              $scope.getShippingData();
            
//        if($location.path() == '/shippin-board/dashboard'){
//          if($rootScope.regularFlag == true){
//            $scope.getStickerDetails('print');
//            $scope.getStickerDetails('express');
//            $scope.getStickerDetails('supply');
//            $scope.getStickerDetails('customer');
//            $scope.getStickerDetails('rework');
//            $scope.loadDataFromAPI();
            //$scope.obj=[];
           angular.forEach($scope.typeMaster, function(value, key) {
              if (value) {
                $scope.getDynamicStickerDetails(value.sticker_type,key, value);
             }
           });
           $scope.totalCounterShow = '';
           var item = 0;
           var order = 0;
           angular.forEach($scope.totalCounter, function(value, key) {
                if (value && $rootScope.permissionArr.indexOf('view-pie-chart-shipping-dashboard-' + value[0].pie_name) != -1) {
                    item = item + value[0].item;
                    order = order + value[0].order;
                }
           });
           $scope.totalCounterShow = order + '/' + item;
           
//          }
//        }
          }
            
      },1500000);
    }
    
//    $scope.getDynamicStickerCounter=function(){
//        $scope.getShippingData();
//        $scope.loadDataFromAPI();
//        angular.forEach($scope.typeMaster, function (value, key) {
//            if (value) {
//                $scope.getDynamicStickerDetails(value.sticker_type, key, value);
//            }
//        });
//    }
    
    $scope.startStickerDetailsTimer();
    $scope.killStickerDetailsTimer=function(){
      if(angular.isDefined($scope.stickerTimer))
        {
          $interval.cancel($scope.stickerTimer);
          $scope.stickerTimer=undefined;
        }
    };    
    // shipping - regular popup details timer
    $scope.startRegularDetailsTimer=function(){
      $scope.regularTimer=$interval(function(){
        if($location.path() == '/shipping-board/dashboard'){
          if($rootScope.storeListId){
            $scope.getRegularStickerdetails();
            $scope.getRegularStatus();
          }
        }
      },10000);
    }
    $scope.killRegularDetailsTimer=function(){
      if(angular.isDefined($scope.regularTimer))
        {
          $interval.cancel($scope.regularTimer);
          $scope.regularTimer=undefined;
        }
    };
    $scope.closePopup=function(){
      $rootScope.storeListId=undefined;
      $scope.killRegularDetailsTimer();
      $scope.startStickerDetailsTimer();
    }
      /**
    * get all type master
    */
    $scope.getTypeMaster = function() {
      $scope.isloaded = false;
      $scope.showDynamicStickerCounter = false;
      //$http.get($rootScope.baseUrl + '/productType/getActiveType')
      $http.get($rootScope.baseUrl + '/pie/active-sticker-index')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
           $scope.typeMaster=result;
           //$scope.typeData=$scope.chunkArray(result,5);
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }
    $scope.$on("$destroy", function() {
        $scope.destroy=true;
        $scope.killStickerDetailsTimer();
        $scope.killRegularDetailsTimer();
    });
    /**
     * this method use for get chunk of array o
     * @param {type} myArray
     * @param {type} chunk_size
     * @returns {Array}
     */
   $scope.chunkArray= function(myArray, chunk_size){
    var index = 0;
    var arrayLength = myArray.length;
    var tempArray = [];
    var myChunk  = [];
    for (index = 0; index < arrayLength; index += chunk_size) {
        myChunk = myArray.slice(index, index+chunk_size);
        // Do something if you want with the group
        tempArray.push(myChunk);
    }
   return tempArray;
   }
   /**
    * this method is used for get dynamic sticker details
    * create 1 feb 2019
    */
   $scope.obj=[];
   $scope.totalCounter = {};
   $scope.getDynamicStickerDetails = function(type ,key, pieDetails) {
     var type_master=type;
    var typeName = "dynamic_sticker_" + type;
    type = "dynamic_sticker_" + type;
    var bodyData = {
        from_date: $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : '',
        to_date: $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : '',
        type : type_master,
        pie_data : pieDetails,
        store_permssion: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : ''),
        mall_customer_permission: ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : ''),
        from_page : 'shipping'
      };
      var userName = ($rootScope.globals.currentUser.name ? $rootScope.globals.currentUser.name : 'null');
      $http.post($rootScope.baseUrl + '/sticker-print/getDynamicStickerDetail/' + userName + '/' + typeName, bodyData).success(function(response) {
          if (response.status != 'fail') {
                var tmp={};
                tmp.regStatus = response.status;
                tmp.regTotalOrder= response.totalorder ? response.totalorder : 0;
                tmp.regTotalProduct = response.totalproduct ? response.totalproduct : 0;
                tmp.regStatusColor= response.color_code ? response.color_code : '#7d7d7d';
                tmp.regStatusColor= response.color_code ? response.color_code : '#7d7d7d';
                tmp.stickerType = pieDetails.sticker_type ? pieDetails.sticker_type : 'none';
                $scope.obj[pieDetails.name]=tmp;
                $scope.totalCounter[type_master] = [{order:tmp.regTotalOrder, item:tmp.regTotalProduct, pie_name:pieDetails.name}];
          } else {
            toastr.error('Print sticker details not found.');
          }

        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
      }
      /**
       * this method used for downloadDynamicSticker
       */
    $scope.downloadDynamicSticker = function(type)
    {
        var pieDashboardBlock = type.dashboard_block;
        var sticker_type="dynamic";
        var onlyTypeName = type.sticker_type;
        type="dynamic_sticker_"+type.sticker_type;
        var fromDate = $rootScope.datePickerRegular.date.startDate ? $scope.saveFromDateFormat($rootScope.datePickerRegular.date.startDate) : 'null';
        var toDate = $rootScope.datePickerRegular.date.endDate ? $scope.saveToDateFormat($rootScope.datePickerRegular.date.endDate) : 'null';
        var loginUserName=($rootScope.globals.currentUser.name?$rootScope.globals.currentUser.name:'null');
        var userName = 'null';
        var storePermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.store_permission.toString() : '');
        var mallCustomerPermission = ($rootScope.globals.currentUser ? $rootScope.globals.currentUser.mall_customer_permission.toString() : '');
        var urdd = $rootScope.baseUrl + '/sticker-print/' + fromDate + '/' + toDate + '/' + userName + '/' + type +'/'+loginUserName+'/'+sticker_type+'/'+pieDashboardBlock+'?store_permssion='+storePermission+'&mall_customer_permission='+mallCustomerPermission;
        var fileNameWithType = 'print';
        if (type == 'rework') {
            fileNameWithType = 'rework';
        }
        $http.get(urdd,
            {
                responseType: "arraybuffer"
            }).success(function(response,st,headers,con) {
                if (headers('Content-Type') == 'application/json') {
                    var decodedString = String.fromCharCode.apply(null, new Uint8Array(response));
                    var obj = JSON.parse(decodedString);
                    toastr.error(obj.message);
                }else if(headers('Content-Type') == 'application/pdf'){
                    var blob = new Blob([response]);
                    var link=document.createElement('a');
                    link.href=window.URL.createObjectURL(blob);
                    var fileName=$scope.getGlobalDateFormat(moment()).replace(' ','_');
                    link.download=fileName+"_" + onlyTypeName + "_sticker.pdf";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    $scope.loadDataFromAPI();
                    $scope.getStickerDetails(type);
                }else{
                    toastr.error('Something went wrong !');
                }
            }).error(function(error) {
                toastr.error('Something went wrong !');
            });
    }

    $scope.resetManualDate=function()
    {
      $rootScope.datePicker.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
      $rootScope.datePickerRegular.date = {startDate: moment().subtract(6, 'days').format('YYYY-MM-DD'), endDate: moment().format('YYYY-MM-DD')};
    }
  }
})();
/**
 * Shipping Tracker dashboard controller is handle all actions related to Settings.
 * @author Harsha Prajapati
 * created on 11.7.2017
 */
(function() {
  'use strict';
  angular.module('BlurAdmin.pages.shippingTracker')
    .controller('shippingTrackerSettingsCtrl', shippingTrackerSettingsCtrl);
  /** @ngInject */
  function shippingTrackerSettingsCtrl($scope, apiService, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.7.2017
     */
    if ($rootScope.permissionArr.indexOf('shipping_tracker_settings') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'shipping-board.shipping-settings';
    $scope.resetGlobalSearch();
    /**
     * declare data.
     * created on 11.10.2017
     */
    vm.orderStatusData = [];
    $scope.setOfSets = [];
    /**
     * get Selected Status Data method is use to display Selected status data.
     * created on 11.10.2017
     */
    $scope.getSelectedStatusData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/setting/shipping-tracker-dashboard')
          .success(function (result) {
            $scope.isloaded = true;
            if(result){
              if(result.status=='success'){
                vm.selectedStatusData = result.data;
                if(result.data.locationStatus){
                  vm.locationStatus=result.data.locationStatus;
                }
              }else{
                vm.locationStatus=[
                          {
                            "_id": {
                              "block": "All Orders In Bin",
                              "key":"allOrdersInBeen",
                              "color_code": "#ae8801",
                              "img": "thumbs-up"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Ready To Ship",
                              "key":"readyToShip",
                              "color_code": "#87b986",
                              "img": "thumbs-up"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "All In Production",
                              "key":"allInProduction",
                              "color_code": "#00aeef",
                              "img": "clock-circular-outline"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Not Ready To Ship",
                              "key":"notReadyToShip",
                              "color_code": "#9e0b0f",
                              "img": "cancel"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Shipped",
                              "key":"shipped",
                              "color_code": "#6d370a",
                              "img": "truck"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "Arrived",
                              "key":"arrived",
                              "color_code": "#181568",
                              "img": "truck"
                            },
                            "status": []
                          },
                          {
                            "_id": {
                              "block": "No Orders",
                              "key":"noOrders",
                              "color_code": "#000000",
                              "img": "skull"
                            },
                            "status": []
                          }
                        ];
              }
              var half_length = Math.ceil(vm.locationStatus.length / 2);
              var leftArray = vm.locationStatus.splice(0,half_length);
              var rightArray = vm.locationStatus.splice(0,vm.locationStatus.length);
              $scope.setOfSets.push(leftArray);
              $scope.setOfSets.push(rightArray);
            }
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });
    }
    /**
     * get Active Status Data method is use to display Active status data.
     * created on 10.26.2017
     */
    $scope.getActiveStatusData = function() {
      $scope.isloaded = false;
      $http.post($rootScope.baseUrl + '/status/activeAll')
          .success(function (result) {
            vm.orderStatusData = result;
            $scope.isloaded = true;
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message, 'Error');
              }
          });
    }
    /**
     * get Regular Status Data method is use to display Regular status data.
     * created on 11.22.2017
     */
    vm.regularStatusData=[{color_code:"#000000",is_active:1,status_code:"none",status_label:"NONE"}]
    $scope.getRegularStatusData = function() {
      $scope.isloaded = false;
      //$http.get($rootScope.baseUrl + '/config/setting/shipping-block')
      $http.post($rootScope.baseUrl + '/status/activeAll')
          .success(function (result) {
            //var regularBlock=result.data.shipping_block_status[0].status;
            var regularBlock=result;
            angular.forEach(regularBlock,function(val,key){
              vm.regularStatusData.push(val);
            });
            $scope.isloaded = true;
          }).error(function (error) {
              $scope.isloaded = true;
              if (error && error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message, 'Error');
              }
          });
    }
    /**
    * remove regular status data method is use to delete regular status.
    * created on 06.07.2018
    */
    $scope.removeRegularStatus = function(item,arr){
      arr.splice(arr.indexOf(item), 1);
    }

    /**
    * label Exists method is use check duplicate status.
    * created on 06.07.2018
    */
    function labelExists(label,destSortableScope) {
        return destSortableScope.modelValue.some(function(el) {
          return el.status_label === label;
        });
    }
    /**
    * sortable Options.
    * created on 06.07.2018
    */
    $scope.sortableOptionStatus = {
     accept: function (sourceItemHandleScope, destSortableScope) {
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id){
            return true;
        } else{
            if(labelExists(sourceItemHandleScope.itemScope.modelValue.status_label,destSortableScope)){
                return false;
            } else{
                return true;
            }
        }
      },
      itemMoved: function (eventObj) {
            eventObj.source.itemScope.sortableScope.insertItem(eventObj.source.index, eventObj.source.itemScope.item);
      },
      containment: '#sortable-container',
      allowDuplicates: true,
      longTouch :true
    };

    $scope.sortableCloneOptions = {
        containment: '#sortable-container',
        allowDuplicates: true,
        clone:true,
        longTouch :true
    };
    /**
     * save Shipping Tracker Settings Data method is use to add Shipping Tracker data.
     * created on 11.10.2017
     */
    $scope.saveShippingTrackerSettings = function(){
          $scope.temp = [];
          angular.forEach($scope.setOfSets,function(value,key){
            angular.forEach(value,function(val,ke){
              $scope.temp.push(val);
            });
          });
        vm.shippingTrackerData = {};
          vm.shippingTrackerData = {
              'locationStatus':$scope.temp
          };
        apiService.loaderShow();
        var bodyData = {
          settingData: angular.toJson(vm.shippingTrackerData),
        };
        $http.post($rootScope.baseUrl + '/config/setting/save-shipping-dashboard', bodyData).success(function(response) {
          apiService.loaderHide();
          toastr.success(response.message);
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          } else {
            toastr.error("Something went wrong please try again.");
          }
        });
    }
    /**
     * get Shipping store is used for display store list.
     * created on 11.23.2017
     */
    $scope.getShippingData = function() {
      $scope.previewLoaded=false;
      var bodyData = {
        from_date:'',
        to_date:''
      };
      $http.post($rootScope.baseUrl + '/customer/getCustomersList', bodyData).success(function(response) {
        $scope.previewLoaded=true;
        if (response && response.status == 'success') {
          $scope.storeData = response.data;
          $scope.updatedStoreData=response.data;
        } else {
          toastr.error("Something went wrong please try again.");
        }
      }).error(function(error) {
        $scope.previewLoaded=true;
        if (error.data && error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    /**
    * sortable Options.
    * created on 04.06.2018
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedStoreData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * save dashboard Order is use to save sort order and display dashboard this order.
    * created on 04.06.2018
    */
    $scope.saveDashboardOrder=function(){
      $scope.temp=[];
      angular.forEach($scope.updatedStoreData,function(value,key){
        $scope.temp.push({'id':value.id,'position_id':key+1})
      });
      apiService.loaderShow();
      var bodyData={
        'data':JSON.stringify($scope.temp)
      };
      $http.post($rootScope.baseUrl + '/customer/bulkupdate',bodyData).success(function (response) {
           apiService.loaderHide();
           if(response.status=="fail"){
             toastr.error(response.message);
           }else{
             toastr.success(response.message);
             $state.go('shipping-board.shipping-settings');
           }

        }).error(function (error) {
            apiService.loaderHide();
            if (error.code != undefined && error.code == 0) {
                toastr.error(error.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }
  }
})();

/**
 * Add on Repeat controller display Add on Repeat settings.
 * @author Nikunj SilverCayde <nikunj@silvercayde.com>
 * created on 18.10.2021
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('CatOnRepeatCtrl', CatOnRepeatCtrl);

  /** @ngInject */
  function CatOnRepeatCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService) {
    /**
     * permissionArr is use to check permission to display list
     * created on 18.10.2021
     */



    if ($rootScope.permissionArr.indexOf('3dcategory_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    
    var vm = this;
    $rootScope.currentState = 'sticker-settings.3dcategory-repeat';
    $scope.resetGlobalSearch();
    
    /**
     * menuStatus is use to default open accordion
     * created on 10.30.2017
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 18.10.2021
     */
    
    vm.catData = [];
    
    /**
     * get Add-On Repeat Data method is use to display Add-On Repeat data.
     * created on 18.10.2021
    */
    $scope.getAddOnRepeatData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/3dcategory')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            $scope.addOnRepeatData = result.data;
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.catData = result.data.cat.cat_type;
              }
            }
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }


    $scope.addItem = function(type) {
      
      $scope.inserted = {
        name: null,
        value: null,
        price: 0,
        set_default: '0'
      };
      $scope.insertedExp = {
        name: null,
        value: null,
        price: 0,
      };
      
      if (type == 'cat') {
        vm.catData.push($scope.insertedExp);
      } 
    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/stickerSettings/3dcategory/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        
        if ($rootScope.itemType == "cat") {
          vm.catData.splice($rootScope.itemId, 1);
        } 
      }
      $scope.popupShow.close();
    };

    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 18.10.2021
     */
    $scope.validateArr = function(dataArr, nameElement, titleElement, valueElement, priceElement, setAsDefault) {
      var errorKey = -1;
      var errorId = '';
      var temp = [];
      var isOnlyDefaultError = 0;
      var errorMessageDefault = 0;
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + nameElement + '-' + i).removeClass('has-error');
        angular.element('#' + titleElement + '-' + i).removeClass('has-error');
        angular.element('#' + valueElement + '-' + i).removeClass('has-error');
        angular.element('#' + priceElement + '-' + i).removeClass('has-error');
        angular.element('#' + setAsDefault + '-' + i).removeClass('has-error');
        var n = dataArr[i];
        if (n.name == undefined) {
          errorKey = i;
          errorId = titleElement;
          break;
        } else if (n.value == undefined) {
          errorKey = i;
          errorId = valueElement;
          break;
        } else if (n.price == undefined) {
          errorKey = i;
          errorId = priceElement;
          break;
        } else if (setAsDefault != undefined) {
          isOnlyDefaultError = 1;
          if (n.set_default == '1') {
            temp.push(i);
          }
        }
      }
      if (isOnlyDefaultError && errorId == "" && dataArr.length > 0) {
        if (temp.length < 1) {
          errorKey = 0;
        } else if (temp.length > 1) {
          errorKey = temp[temp.length - 1];
          errorMessageDefault = 1;
        }
        errorId = setAsDefault;
      }
      if (errorKey > -1) {
        angular.element('#' + errorId + '-' + errorKey).addClass('has-error');
        angular.element('#' + errorId + '-' + errorKey + ' input').focus();
        if (errorMessageDefault == 1) {
          toastr.error('Set As Default already exists.');
          return 1;
        } else {
          toastr.error('Field should not be empty.');
          return 1;
        }
      }
      return 0;
    }
    /**
     * save AddOn Repeat setting method is use for add AddOn Repeat data.
     * created on 18.10.2021
     */
    $scope.saveAddOnRepeatSettings = function() {
      // check empty field validation
      var cat = $scope.validateArr(vm.catData, 'itemNameExp', 'itemTitleExp', 'itemValueExp','itemPriceExp');
      console.log(cat);
      if (cat == 1) {
        return false;
      }
      
      $scope.stickerData = {};

      
      $scope.stickerData['cat'] = {
          'cat_type': vm.catData
        };

      
      apiService.loaderShow();
      var bodyData = {
        type: '3dcategory',
        sticker_data: angular.toJson($scope.stickerData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };

  }
})();

/**
 * Add on Repeat controller display Add on Repeat settings.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.30.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('addOnRepeatCtrl', addOnRepeatCtrl);

  /** @ngInject */
  function addOnRepeatCtrl($scope, $uibModal, $http, $rootScope, toastr, $state, apiService) {
    /**
     * permissionArr is use to check permission to display list
     * created on 10.30.2017
     */
    if ($rootScope.permissionArr.indexOf('addon_repeat') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.addon-repeat';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 10.30.2017
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 10.31.2017
     */
    vm.extraPeopleData = [];
    vm.expressData = [];
    vm.backgroundData = [];
    vm.engravingData = [];

    /**
     * get Add-On Repeat Data method is use to display Add-On Repeat data.
     * created on 10.30.2017
     */
    $scope.getAddOnRepeatData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/AddOn')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            $scope.addOnRepeatData = result.data;
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.extraPeopleData = result.data.extra_people.add_extra_people;
                vm.expressData = result.data.express.express_type;
                vm.backgroundData = result.data.background.add_background;
                vm.engravingData = result.data.engraving.add_engraving;
              }
            }
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }


    $scope.addItem = function(type) {
      $scope.inserted = {
        name: null,
        value: null,
        set_default: '0'
      };
      $scope.insertedExp = {
        name: null,
        value: null,
      };
      if (type == 'extrapeople') {
        vm.extraPeopleData.push($scope.inserted);
      } else if (type == 'express') {
        vm.expressData.push($scope.insertedExp);
      } else if (type == 'background') {
        vm.backgroundData.push($scope.inserted);
      } else if (type == 'engraving') {
        vm.engravingData.push($scope.inserted);
      }
    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/stickerSettings/addOnRepeat/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "extrapeople") {
          vm.extraPeopleData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "express") {
          vm.expressData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "background") {
          vm.backgroundData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "engraving") {
          vm.engravingData.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };

    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 10.30.2017
     */
    $scope.validateArr = function(dataArr, titleElement, valueElement, setAsDefault) {
      var errorKey = -1;
      var errorId = '';
      var temp = [];
      var isOnlyDefaultError = 0;
      var errorMessageDefault = 0;
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + titleElement + '-' + i).removeClass('has-error');
        angular.element('#' + valueElement + '-' + i).removeClass('has-error');
        angular.element('#' + setAsDefault + '-' + i).removeClass('has-error');
        var n = dataArr[i];
        if (n.name == undefined) {
          errorKey = i;
          errorId = titleElement;
          break;
        } else if (n.value == undefined) {
          errorKey = i;
          errorId = valueElement;
          break;
        } else if (setAsDefault != undefined) {
          isOnlyDefaultError = 1;
          if (n.set_default == '1') {
            temp.push(i);
          }
        }
      }
      if (isOnlyDefaultError && errorId == "" && dataArr.length > 0) {
        if (temp.length < 1) {
          errorKey = 0;
        } else if (temp.length > 1) {
          errorKey = temp[temp.length - 1];
          errorMessageDefault = 1;
        }
        errorId = setAsDefault;
      }
      if (errorKey > -1) {
        angular.element('#' + errorId + '-' + errorKey).addClass('has-error');
        angular.element('#' + errorId + '-' + errorKey + ' input').focus();
        if (errorMessageDefault == 1) {
          toastr.error('Set As Default already exists.');
          return 1;
        } else {
          toastr.error('Field should not be empty.');
          return 1;
        }
      }
      return 0;
    }
    /**
     * save AddOn Repeat setting method is use for add AddOn Repeat data.
     * created on 10.30.2017
     */
    $scope.saveAddOnRepeatSettings = function() {
      // check empty field validation

      var extrapeople = $scope.validateArr(vm.extraPeopleData, 'itemTitleExtra', 'itemValueExtra', 'itemDefaultExtra');
      if (extrapeople == 1) {
        return false;
      }
      var express = $scope.validateArr(vm.expressData, 'itemTitleExp', 'itemValueExp');
      if (express == 1) {
        return false;
      }
      var background = $scope.validateArr(vm.backgroundData, 'itemTitleBG', 'itemValueBG', 'itemDefaultBG');
      if (background == 1) {
        return false;
      }
      var engraving = $scope.validateArr(vm.engravingData, 'itemTitleEng', 'itemValueEng', 'itemDefaultEng');
      if (engraving == 1) {
        return false;
      }
      $scope.stickerData = {};

      $scope.stickerData['extra_people'] = {
          'add_extra_people': vm.extraPeopleData
        };
      $scope.stickerData['express'] = {
          'express_type': vm.expressData
        };
      $scope.stickerData['background'] = {
          'add_background': vm.backgroundData
        };
      $scope.stickerData['engraving'] = {
          'add_engraving': vm.engravingData
        };
      apiService.loaderShow();
      var bodyData = {
        type: 'AddOn',
        sticker_data: angular.toJson($scope.stickerData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };

  }
})();

/**
 * customer Sticker controller display customer Sticker Settings.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 07.03.2018
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('customerStickerCtrl', customerStickerCtrl);

  /** @ngInject */
  function customerStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 07.03.2018
     */
    if ($rootScope.permissionArr.indexOf('customer_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.customer-sticker';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 07.03.2018
     */
    vm.displayIcon=false;
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 07.03.2018
     */
    vm.printLabel=[];
    vm.fontSizeData=[];
    vm.layAwayLabelData=[];
    vm.shippingData=[];
    vm.expressLabelData=[];
   /**
    * get customer Sticker Data method is use to display customer Sticker data.
    * created on 07.03.2018
    */
   $scope.getCustomerStickerData = function() {
     $scope.isloaded = false;
     $http.get($rootScope.baseUrl + '/config/customer')
       .success(function(result) {
         $scope.isloaded = true;
         if(result){
         $scope.customerStickerData = result.data;
         if(result.status=='fail'){
           toastr.error(result.message);
         }else{
           if(result.data){
             vm.availableOrderStatus=result.data.express_print_sticker_setting.available_order_status;
             vm.finalOrderStatus=result.data.express_print_sticker_setting.express_final_order_status;
             vm.maxOrderNumber=parseInt(result.data.express_print_sticker_setting.express_max_number_order);
             vm.displayIcon=result.data.express_print_sticker_setting.display_icon;
             vm.printLabel=result.data.express_label_print_setting.express_label_to_print;
             vm.fontSizeData=result.data.express_font_size_setting.express_entity_to_print_custom_font;
             vm.layAwayLabelData=result.data.express_layaway_label_setting.express_layaway_label_to_print;
             vm.shippingData=result.data.express_shipping_method_setting.express_shipping_to_print;
             vm.expressLabelData=result.data.express_label_setting.express_label_to_print;

           }
         }
         //use to selected value not display in dropdown list
         $scope.getPrintLabel();
      }
       }).error(function(error) {
         if (error.data && error.data.code != undefined && error.data.code == 0) {
           toastr.error(error.data.message);
         }
         $scope.isloaded = true;
       });
   }
   $scope.addItem = function(type) {
     $scope.inserted = {
       name: null,
       value: null,
     };
     if(type=='fontsize'){
       vm.fontSizeData.push($scope.inserted);
     }else if(type=='layaway'){
       vm.layAwayLabelData.push($scope.inserted);
     }else if(type=='shipping'){
       vm.shippingData.push($scope.inserted);
     }else if(type=='express'){
       vm.expressLabelData.push($scope.inserted);
     }

   };

   $scope.confirmDelete = function(id,type) {
     $rootScope.itemId = id;
     $rootScope.itemType=type;
     $scope.popupShow = $uibModal.open({
       animation: true,
       templateUrl: 'app/pages/stickerSettings/customerSticker/deleteModal.html',
       scope: $scope,
     });
   };

   $scope.removeItem = function() {
     if($rootScope.itemId != undefined && $rootScope.itemType != undefined){
       if($rootScope.itemType=="fontsize"){
          vm.fontSizeData.splice($rootScope.itemId, 1);
       }else if($rootScope.itemType=="layaway"){
         vm.layAwayLabelData.splice($rootScope.itemId, 1);
       }else if($rootScope.itemType=="shipping"){
         vm.shippingData.splice($rootScope.itemId, 1);
       }else if($rootScope.itemType=="express"){
         vm.expressLabelData.splice($rootScope.itemId, 1);
       }
     }
     $scope.popupShow.close();
   };
   /**
    * validateArr method is use to validate empty inline grid element.
    * created on 07.03.2018
    */
   $scope.validateArr = function(dataArr,titleElement,valueElement){
     var errorKey = -1;
     var errorId = '';

     for(var i = 0; i < dataArr.length; i++) {
         angular.element('#'+titleElement+'-'+i).removeClass('has-error');
         angular.element('#'+valueElement+'-'+i).removeClass('has-error');
         var n = dataArr[i];
         if(n.name == undefined){
           errorKey = i;
           errorId = titleElement;
           break;
         }else if(n.value == undefined){
           errorKey = i;
           errorId = valueElement;
           break;
         }
     }
     if(errorKey > -1){
         angular.element('#'+errorId+'-'+errorKey).addClass('has-error');
         angular.element('#'+errorId+'-'+errorKey+' input').focus();
         toastr.error('Field should not be empty.');
         return 1;
     }
     return 0;
   }
   /**
    * save customer Sticker setting method is use for add customer Sticker data.
    * created on 07.03.2018
    */
  $scope.saveCustomerStickerSettings = function() {
    // check empty field validation
       var fontsize = $scope.validateArr(vm.fontSizeData,'itemTitleFont','itemValueFont');
       if(fontsize == 1){
         return false;
       }
       var layaway = $scope.validateArr(vm.layAwayLabelData,'itemTitleLayaway','itemValueLayaway');
       if(layaway == 1){
          return false;
       }
       var shipping = $scope.validateArr(vm.shippingData,'itemTitleShipping','itemValueShipping');
       if(shipping == 1){
          return false;
       }
       var express = $scope.validateArr(vm.expressLabelData,'itemTitleExpress','itemValueExpress');
       if(express == 1){
          return false;
       }
       $scope.stickerData={};
       angular.forEach(vm.printLabel,function(val,key){
         vm.printLabel[key]['sort_order']=key+1;
       });
         $scope.stickerData['express_print_sticker_setting']={'available_order_status':vm.availableOrderStatus,
                  'express_final_order_status':vm.finalOrderStatus,
                  'express_max_number_order':vm.maxOrderNumber,
                  'display_icon':vm.displayIcon?vm.displayIcon:false};
         $scope.stickerData['express_label_print_setting']={'express_label_to_print':vm.printLabel};
         $scope.stickerData['express_font_size_setting']={'express_entity_to_print_custom_font':vm.fontSizeData};
         $scope.stickerData['express_layaway_label_setting']={'express_layaway_label_to_print':vm.layAwayLabelData};
         $scope.stickerData['express_shipping_method_setting']={'express_shipping_to_print':vm.shippingData};
         $scope.stickerData['express_label_setting']={'express_label_to_print':vm.expressLabelData};

       apiService.loaderShow();
       var bodyData={
         type:'customer',
         sticker_data:angular.toJson($scope.stickerData),
         affected_by:$rootScope.globals.currentUser.id,
       };
       $http.post($rootScope.baseUrl + '/config/expressprintsticker',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });

   };

    /**
     * get Active Status method is use to display all active order status.
     * created on 07.03.2018
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * get Print Label method is use to display all active print label.
     * created on 07.03.2018
     */
     $scope.getPrintLabel = function() {
       $http.get($rootScope.baseUrl + '/printlabels/active')
         .success(function(result) {
           if (result.status == 'fail') {
             toastr.error(result.message);
           } else {
             $scope.printLabelData=result;
             angular.forEach(result,function(val,key){
               angular.forEach(vm.printLabel,function(v,k){
                 if(val.label_name==v.label_name){
                   $scope.printLabelData[key]['sort_order']=v.sort_order;
                   $scope.printLabelData[key]['font']=v.font;
                 }
               });
             });
             // USE TO REMOVE $hashkey in object
             //$scope.printLabelData=angular.fromJson(angular.toJson( $scope.printLabelData ));
           }
         }).error(function(error) {
           apiService.loaderHide();
           if (error.data && error.data.code != undefined && error.data.code == 0) {
             toastr.error(error.data.message);
           }
         });
     }

    /**
    * sortable Options.
    * created on 04.23.2018
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedCustomerPreviewData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * get customer preview method is use to get preview data.
    * created on 04.23.2018
    */
    vm.customerPreviewData=[];
    vm.displayData=[];
    $scope.typeListkey = {};
    $scope.getCustomerPreviewData=function(){
      $http.get($rootScope.baseUrl+'/config/stickerprintorder/customer').success(function(response){
        var tempAdded = true;
        angular.forEach(response,function(val,key){
            vm.customerPreviewData.push(val);
            if( (val.label_code == 'layaway' || val.label_code == 'express') && tempAdded){
                vm.displayData.push(val);
                tempAdded = false;
            }else if(val.label_code != 'layaway' && val.label_code != 'express'){
                vm.displayData.push(val);
            }
            $scope.typeListkey[val.label_code] = val.label_name;
        });
        $scope.updatedCustomerPreviewData=vm.customerPreviewData;
        if(vm.displayData.length>0){
          var firstData=(vm.displayData.length-2);
          vm.firstArray = vm.displayData.splice(0,vm.displayData.length);
          vm.secondArray = vm.displayData.splice(0,vm.displayData.length);
        }
      }).error(function(error){

      });
    }
    /**
    * save customer Order is use to save sort order and display data this order.
    * created on 04.23.2018
    */
    $scope.saveCustomerStickerOrder=function(){
      $scope.stickerDataPreview = {};
      angular.forEach($scope.updatedCustomerPreviewData,function(val,key){
        $scope.updatedCustomerPreviewData[key]['sort_order']=key+1;
      });
        $scope.stickerDataPreview['express_print_sticker_setting']={'available_order_status':vm.availableOrderStatus,
                 'express_final_order_status':vm.finalOrderStatus,
                 'express_max_number_order':vm.maxOrderNumber,
                'display_icon':vm.displayIcon?vm.displayIcon:false};
        $scope.stickerDataPreview['express_label_print_setting']={'express_label_to_print':$scope.updatedCustomerPreviewData};
        $scope.stickerDataPreview['express_font_size_setting']={'express_entity_to_print_custom_font':vm.fontSizeData};
        $scope.stickerDataPreview['express_layaway_label_setting']={'express_layaway_label_to_print':vm.layAwayLabelData};
        $scope.stickerDataPreview['express_shipping_method_setting']={'express_shipping_to_print':vm.shippingData};
        $scope.stickerDataPreview['express_label_setting']={'express_label_to_print':vm.expressLabelData};

      apiService.loaderShow();
      var bodyData={
        type:'customer',
        sticker_data:angular.toJson($scope.stickerDataPreview),
        affected_by:$rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker',bodyData).success(function (response) {
           apiService.loaderHide();
           toastr.success(response.message);
           $state.go($state.$current, null, {reload: true});
           //$state.go('sticker-settings.customer-sticker');
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }
  }
})();

/**
 * Print Sticker controller display Print Sticker Settings.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.25.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('damageStickerCtrl', damageStickerCtrl);

  /** @ngInject */
  function damageStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 10.25.2017
     */
    if ($rootScope.permissionArr.indexOf('damage_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.damage-sticker';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 10.25.2017
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]

    /**
     * get Active Status method is use to display all active order status.
     * created on 10.26.2017
     */
    $scope.getActiveAndEditedStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
        // get damage sticker saved data
        $http.get($rootScope.baseUrl + '/config/setting/save-damage-sticker')
          .success(function (result) {
            if(result.data && result.data!=undefined){
              var damageStickerData=result.data[0];
              vm.changeRegularStatus=damageStickerData.changeRegularStatus;
              vm.changeExpressStatus=damageStickerData.changeExpressStatus;
              vm.changeReworkStatus=damageStickerData.changeReworkStatus;
              vm.changeCustomerStatus=damageStickerData.changeCustomerStatus;
            }
          }).error(function (error) {
              apiService.loaderHide();
              if (error.data && error.data.code != undefined && error.data.code == 0) {
                  toastr.error(error.data.message);
              }
          });
    }
    /**
     * save damage sticker settings method is use to save damage settings.
     * created on 06.22.2018
     */
    $scope.saveDamageStickerSettings = function() {
      apiService.loaderShow();
      var damageData=[{'changeRegularStatus':vm.changeRegularStatus,
        'changeExpressStatus':vm.changeExpressStatus,
        'changeReworkStatus':vm.changeReworkStatus,'changeCustomerStatus':vm.changeCustomerStatus}]

      var bodyData={'settingData':angular.toJson(damageData)};
      $http.post($rootScope.baseUrl + '/config/setting/save-damage-sticker',bodyData).success(function (response) {
           apiService.loaderHide();
           toastr.success(response.message);
           $state.go($state.$current, null, {
               reload: true
           });
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data && error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }

  }
})();

/**
 * Print Sticker controller display Print Sticker Settings.
 * @author Harsha Prajapati <anand.malvi@brainvire.com>
 * created on 01.24.2019
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('dynamicStickerCtrl', dynamicStickerCtrl);

  /** @ngInject */
  function dynamicStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state, $stateParams) {
    /**
     * permissionArr is use to check permission to display list
     * created on 01.24.2019
     */
    /* if ($rootScope.permissionArr.indexOf('print_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    } */
      
    var vm = this;
    //$rootScope.currentState = 'sticker-settings.print-sticker';
    $rootScope.currentState = $state.current.name;
    $rootScope.currentStateName;
    if($stateParams.type == 'dynamic_sticker') {
        vm.currentStateName = 'dynamic_sticker_' + $state.current.params.block_type;
        $rootScope.currentStateName = vm.currentStateName;
    }
    
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 01.24.2019
     */
    vm.displayIcon=false;
    vm.newSticker=false;
    vm.newSticker2='';
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 01.24.2019
     */
    vm.printLabel = [];
    vm.fontSizeData = [];
    vm.layAwayLabelData = [];
    vm.shippingData = [];
    vm.expressLabelData = [];
    /**
     * get Sticker Data method is use to display Print Sticker data.
     * created on 01.24.2019
     */
    $scope.getPrintStickerData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/' + $rootScope.currentStateName)
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            $scope.printStickerData = result.data;
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.availableOrderStatus = result.data.express_print_sticker_setting.available_order_status;
                vm.finalOrderStatus = result.data.express_print_sticker_setting.express_final_order_status;
                vm.maxOrderNumber = parseInt(result.data.express_print_sticker_setting.express_max_number_order);
                vm.displayIcon=result.data.express_print_sticker_setting.display_icon;
                vm.newSticker=result.data.express_print_sticker_setting.new_sticker;
                vm.newSticker2=result.data.express_print_sticker_setting.new_sticker2;
                vm.printLabel = result.data.express_label_print_setting.express_label_to_print;
                vm.fontSizeData = result.data.express_font_size_setting.express_entity_to_print_custom_font;
                vm.layAwayLabelData = result.data.express_layaway_label_setting.express_layaway_label_to_print;
                vm.shippingData = result.data.express_shipping_method_setting.express_shipping_to_print;
                vm.expressLabelData = result.data.express_label_setting.express_label_to_print;

              }
            }
            //use to selected value not display in dropdown list
            $scope.getPrintLabel();
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }

    $scope.addItem = function(type) {
      $scope.inserted = {
        name: null,
        value: null,
      };
      if (type == 'fontsize') {
        vm.fontSizeData.push($scope.inserted);
      } else if (type == 'layaway') {
        vm.layAwayLabelData.push($scope.inserted);
      } else if (type == 'shipping') {
        vm.shippingData.push($scope.inserted);
      } else if (type == 'express') {
        vm.expressLabelData.push($scope.inserted);
      }

    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/stickerSettings/dynamicSticker/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "fontsize") {
          vm.fontSizeData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "layaway") {
          vm.layAwayLabelData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "shipping") {
          vm.shippingData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "express") {
          vm.expressLabelData.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };
    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 01.24.2019
     */
    $scope.validateArr = function(dataArr, titleElement, valueElement) {
      var errorKey = -1;
      var errorId = '';
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + titleElement + '-' + i).removeClass('has-error');
        angular.element('#' + valueElement + '-' + i).removeClass('has-error');
        var n = dataArr[i];
        if (n.name == undefined) {
          errorKey = i;
          errorId = titleElement;
          break;
        } else if (n.value == undefined) {
          errorKey = i;
          errorId = valueElement;
          break;
        }
      }
      if (errorKey > -1) {
        angular.element('#' + errorId + '-' + errorKey).addClass('has-error');
        angular.element('#' + errorId + '-' + errorKey + ' input').focus();
        toastr.error('Field should not be empty.');
        return 1;
      }
      return 0;
    }
    /**
     * save Sticker setting method is use for add Print Sticker data.
     * created on 01.24.2019
     */
    $scope.savePrintStickerSettings = function() {
      // check empty field validation
      var fontsize = $scope.validateArr(vm.fontSizeData, 'itemTitleFont', 'itemValueFont');
      if (fontsize == 1) {
        return false;
      }
      var layaway = $scope.validateArr(vm.layAwayLabelData, 'itemTitleLayaway', 'itemValueLayaway');
      if (layaway == 1) {
        return false;
      }
      var shipping = $scope.validateArr(vm.shippingData, 'itemTitleShipping', 'itemValueShipping');
      if (shipping == 1) {
        return false;
      }
      var express = $scope.validateArr(vm.expressLabelData, 'itemTitleExpress', 'itemValueExpress');
      if (express == 1) {
        return false;
      }
      $scope.stickerData = {};
      angular.forEach(vm.printLabel,function(val,key){
        vm.printLabel[key]['sort_order']=key+1;
      });
      //angular.forEach($scope.printStickerData, function(value, key) {
        $scope.stickerData['express_print_sticker_setting'] = {
            'available_order_status': vm.availableOrderStatus,
            'express_final_order_status': vm.finalOrderStatus,
            'express_max_number_order': vm.maxOrderNumber,
            'display_icon':vm.displayIcon?vm.displayIcon:false,
            'new_sticker': vm.newSticker?vm.newSticker:false,
            'new_sticker2': vm.newSticker2?vm.newSticker2:''
          };
        $scope.stickerData['express_label_print_setting'] = {
            'express_label_to_print': vm.printLabel
          };
        $scope.stickerData['express_font_size_setting'] = {
            'express_entity_to_print_custom_font': vm.fontSizeData
          };
        $scope.stickerData['express_layaway_label_setting'] = {
            'express_layaway_label_to_print': vm.layAwayLabelData
          };
        $scope.stickerData['express_shipping_method_setting'] = {
            'express_shipping_to_print': vm.shippingData
          };
        $scope.stickerData['express_label_setting'] = {
            'express_label_to_print': vm.expressLabelData
          };
    //  });
      apiService.loaderShow();
      var bodyData = {
        type: vm.currentStateName,
        sticker_data: angular.toJson($scope.stickerData),
        affected_by: $rootScope.globals.currentUser.id,
      };

      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };

    /**
     * get Active Status method is use to display all active order status.
     * created on 01.24.2019
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    //$scope.printLabel = {};
    /**
     * get Label method is use to display all active print label.
     * created on 01.24.2019
     */
    $scope.getPrintLabel = function() {
      $http.get($rootScope.baseUrl + '/printlabels/active')
        .success(function(result) {
          if (result.status == 'fail') {
            toastr.error(result.message);
          } else {
            $scope.printLabelData=result;
            angular.forEach(result,function(val,key){
              angular.forEach(vm.printLabel,function(v,k){
                if(val.label_name==v.label_name){
                  $scope.printLabelData[key]['sort_order']=v.sort_order;
                  $scope.printLabelData[key]['font']=v.font;
                }
              });
            });
            // USE TO REMOVE $hashkey in object
            //$scope.printLabelData=angular.fromJson(angular.toJson( $scope.printLabelData ));
          }
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    
    $scope.doTheBack = function() {
        window.history.back();
    };

    /**
    * sortable Options.
    * created on 01.24.2019
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedPrintPreviewData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * get preview method is use to get preview data.
    * created on 01.24.2019
    */
    vm.printPreviewData=[];
    vm.displayData=[];
    $scope.typeListkey = {};
    $scope.getPrintPreviewData=function(){
      $http.get($rootScope.baseUrl+'/config/stickerprintorder/' + $rootScope.currentStateName).success(function(response){
        var tempAdded = true;
        angular.forEach(response,function(val,key){
            vm.printPreviewData.push(val);
            if( (val.label_code == 'layaway' || val.label_code == 'express') && tempAdded){
                vm.displayData.push(val);
                tempAdded = false;
            }else if(val.label_code != 'layaway' && val.label_code != 'express'){
                vm.displayData.push(val);
            }
            $scope.typeListkey[val.label_code] = val.label_name;
        });
        $scope.updatedPrintPreviewData=vm.printPreviewData;
        if(vm.displayData.length>0){
          var firstData=(vm.displayData.length-2);
          vm.firstArray = vm.displayData.splice(0,vm.displayData.length);
          vm.secondArray = vm.displayData.splice(0,vm.displayData.length);
        }
      }).error(function(error){

      });
    }
    /**
    * save Order is use to save sort order and display data this order.
    * created on 01.24.2019
    */

    $scope.savePrintPreviewOrder=function(){
      $scope.stickerDataPreview = {};
      angular.forEach($scope.updatedPrintPreviewData,function(val,key){
        $scope.updatedPrintPreviewData[key]['sort_order']=key+1;
      });
      $scope.stickerDataPreview['express_print_sticker_setting'] = {
          'available_order_status': vm.availableOrderStatus,
          'express_final_order_status': vm.finalOrderStatus,
          'express_max_number_order': vm.maxOrderNumber,
          'display_icon':vm.displayIcon?vm.displayIcon:false,
          'new_sticker':vm.newSticker?vm.newSticker:false,
          'new_sticker2': vm.newSticker2?vm.newSticker2:''
        };
      $scope.stickerDataPreview['express_label_print_setting'] = {
          'express_label_to_print': $scope.updatedPrintPreviewData
        };
      $scope.stickerDataPreview['express_font_size_setting'] = {
          'express_entity_to_print_custom_font': vm.fontSizeData
        };
      $scope.stickerDataPreview['express_layaway_label_setting'] = {
          'express_layaway_label_to_print': vm.layAwayLabelData
        };
      $scope.stickerDataPreview['express_shipping_method_setting'] = {
          'express_shipping_to_print': vm.shippingData
        };
      $scope.stickerDataPreview['express_label_setting'] = {
          'express_label_to_print': vm.expressLabelData
        };
      apiService.loaderShow();
      var bodyData = {
        type: $rootScope.currentStateName,
        sticker_data: angular.toJson($scope.stickerDataPreview),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
        $state.go($state.$current, null, {reload: true});
        //$state.go('sticker-settings.print-sticker');
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
    $scope.onSelected = function (selectedItem) {
        $scope.inserted = {
            name: selectedItem.label_name,
            value: 10,
        };
        vm.fontSizeData.push($scope.inserted);
    }
  }
})();

/**
 * Print Sticker controller display Print Sticker Settings.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.25.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('printStickerCtrl', printStickerCtrl);

  /** @ngInject */
  function printStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 10.25.2017
     */
    if ($rootScope.permissionArr.indexOf('print_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.print-sticker';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 10.25.2017
     */
    vm.displayIcon=false;
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 10.31.2017
     */
    vm.printLabel = [];
    vm.fontSizeData = [];
    vm.layAwayLabelData = [];
    vm.shippingData = [];
    vm.expressLabelData = [];
    /**
     * get Print Sticker Data method is use to display Print Sticker data.
     * created on 10.26.2017
     */
    $scope.getPrintStickerData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/print')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            $scope.printStickerData = result.data;
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.availableOrderStatus = result.data.express_print_sticker_setting.available_order_status;
                vm.finalOrderStatus = result.data.express_print_sticker_setting.express_final_order_status;
                vm.maxOrderNumber = parseInt(result.data.express_print_sticker_setting.express_max_number_order);
                vm.displayIcon=result.data.express_print_sticker_setting.display_icon;
                vm.printLabel = result.data.express_label_print_setting.express_label_to_print;
                vm.fontSizeData = result.data.express_font_size_setting.express_entity_to_print_custom_font;
                vm.layAwayLabelData = result.data.express_layaway_label_setting.express_layaway_label_to_print;
                vm.shippingData = result.data.express_shipping_method_setting.express_shipping_to_print;
                vm.expressLabelData = result.data.express_label_setting.express_label_to_print;

              }
            }
            //use to selected value not display in dropdown list
            $scope.getPrintLabel();
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }

    $scope.addItem = function(type) {
      $scope.inserted = {
        name: null,
        value: null,
      };
      if (type == 'fontsize') {
        vm.fontSizeData.push($scope.inserted);
      } else if (type == 'layaway') {
        vm.layAwayLabelData.push($scope.inserted);
      } else if (type == 'shipping') {
        vm.shippingData.push($scope.inserted);
      } else if (type == 'express') {
        vm.expressLabelData.push($scope.inserted);
      }

    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/stickerSettings/printSticker/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "fontsize") {
          vm.fontSizeData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "layaway") {
          vm.layAwayLabelData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "shipping") {
          vm.shippingData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "express") {
          vm.expressLabelData.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };
    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 10.27.2017
     */
    $scope.validateArr = function(dataArr, titleElement, valueElement) {
      var errorKey = -1;
      var errorId = '';
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + titleElement + '-' + i).removeClass('has-error');
        angular.element('#' + valueElement + '-' + i).removeClass('has-error');
        var n = dataArr[i];
        if (n.name == undefined) {
          errorKey = i;
          errorId = titleElement;
          break;
        } else if (n.value == undefined) {
          errorKey = i;
          errorId = valueElement;
          break;
        }
      }
      if (errorKey > -1) {
        angular.element('#' + errorId + '-' + errorKey).addClass('has-error');
        angular.element('#' + errorId + '-' + errorKey + ' input').focus();
        toastr.error('Field should not be empty.');
        return 1;
      }
      return 0;
    }
    /**
     * save Print Sticker setting method is use for add Print Sticker data.
     * created on 10.27.2017
     */
    $scope.savePrintStickerSettings = function() {
      // check empty field validation
      var fontsize = $scope.validateArr(vm.fontSizeData, 'itemTitleFont', 'itemValueFont');
      if (fontsize == 1) {
        return false;
      }
      var layaway = $scope.validateArr(vm.layAwayLabelData, 'itemTitleLayaway', 'itemValueLayaway');
      if (layaway == 1) {
        return false;
      }
      var shipping = $scope.validateArr(vm.shippingData, 'itemTitleShipping', 'itemValueShipping');
      if (shipping == 1) {
        return false;
      }
      var express = $scope.validateArr(vm.expressLabelData, 'itemTitleExpress', 'itemValueExpress');
      if (express == 1) {
        return false;
      }
      $scope.stickerData = {};
      angular.forEach(vm.printLabel,function(val,key){
        vm.printLabel[key]['sort_order']=key+1;
      });
      //angular.forEach($scope.printStickerData, function(value, key) {
        $scope.stickerData['express_print_sticker_setting'] = {
            'available_order_status': vm.availableOrderStatus,
            'express_final_order_status': vm.finalOrderStatus,
            'express_max_number_order': vm.maxOrderNumber,
            'display_icon':vm.displayIcon?vm.displayIcon:false
          };
        $scope.stickerData['express_label_print_setting'] = {
            'express_label_to_print': vm.printLabel
          };
        $scope.stickerData['express_font_size_setting'] = {
            'express_entity_to_print_custom_font': vm.fontSizeData
          };
        $scope.stickerData['express_layaway_label_setting'] = {
            'express_layaway_label_to_print': vm.layAwayLabelData
          };
        $scope.stickerData['express_shipping_method_setting'] = {
            'express_shipping_to_print': vm.shippingData
          };
        $scope.stickerData['express_label_setting'] = {
            'express_label_to_print': vm.expressLabelData
          };
    //  });
      apiService.loaderShow();
      var bodyData = {
        type: 'print',
        sticker_data: angular.toJson($scope.stickerData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };

    /**
     * get Active Status method is use to display all active order status.
     * created on 10.26.2017
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    //$scope.printLabel = {};
    /**
     * get Print Label method is use to display all active print label.
     * created on 10.26.2017
     */
    $scope.getPrintLabel = function() {
      $http.get($rootScope.baseUrl + '/printlabels/active')
        .success(function(result) {
          if (result.status == 'fail') {
            toastr.error(result.message);
          } else {
            $scope.printLabelData=result;
            angular.forEach(result,function(val,key){
              angular.forEach(vm.printLabel,function(v,k){
                if(val.label_name==v.label_name){
                  $scope.printLabelData[key]['sort_order']=v.sort_order;
                  $scope.printLabelData[key]['font']=v.font;
                }
              });
            });
            // USE TO REMOVE $hashkey in object
            //$scope.printLabelData=angular.fromJson(angular.toJson( $scope.printLabelData ));
          }
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    /**
    * sortable Options.
    * created on 04.20.2018
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedPrintPreviewData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * get print preview method is use to get preview data.
    * created on 04.23.2018
    */
    vm.printPreviewData=[];
    vm.displayData=[];
    $scope.typeListkey = {};
    $scope.getPrintPreviewData=function(){
      $http.get($rootScope.baseUrl+'/config/stickerprintorder/print').success(function(response){
        var tempAdded = true;
        angular.forEach(response,function(val,key){
            vm.printPreviewData.push(val);
            if( (val.label_code == 'layaway' || val.label_code == 'express') && tempAdded){
                vm.displayData.push(val);
                tempAdded = false;
            }else if(val.label_code != 'layaway' && val.label_code != 'express'){
                vm.displayData.push(val);
            }
            $scope.typeListkey[val.label_code] = val.label_name;
        });
        $scope.updatedPrintPreviewData=vm.printPreviewData;
        if(vm.displayData.length>0){
          var firstData=(vm.displayData.length-2);
          vm.firstArray = vm.displayData.splice(0,vm.displayData.length);
          vm.secondArray = vm.displayData.splice(0,vm.displayData.length);
        }
      }).error(function(error){

      });
    }
    /**
    * save print Order is use to save sort order and display data this order.
    * created on 04.23.2018
    */

    $scope.savePrintPreviewOrder=function(){
      $scope.stickerDataPreview = {};
      angular.forEach($scope.updatedPrintPreviewData,function(val,key){
        $scope.updatedPrintPreviewData[key]['sort_order']=key+1;
      });
      $scope.stickerDataPreview['express_print_sticker_setting'] = {
          'available_order_status': vm.availableOrderStatus,
          'express_final_order_status': vm.finalOrderStatus,
          'express_max_number_order': vm.maxOrderNumber,
          'display_icon':vm.displayIcon?vm.displayIcon:false
        };
      $scope.stickerDataPreview['express_label_print_setting'] = {
          'express_label_to_print': $scope.updatedPrintPreviewData
        };
      $scope.stickerDataPreview['express_font_size_setting'] = {
          'express_entity_to_print_custom_font': vm.fontSizeData
        };
      $scope.stickerDataPreview['express_layaway_label_setting'] = {
          'express_layaway_label_to_print': vm.layAwayLabelData
        };
      $scope.stickerDataPreview['express_shipping_method_setting'] = {
          'express_shipping_to_print': vm.shippingData
        };
      $scope.stickerDataPreview['express_label_setting'] = {
          'express_label_to_print': vm.expressLabelData
        };
      apiService.loaderShow();
      var bodyData = {
        type: 'print',
        sticker_data: angular.toJson($scope.stickerDataPreview),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
        $state.go($state.$current, null, {reload: true});
        //$state.go('sticker-settings.print-sticker');
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
  }
})();

/**
 * Express Sticker controller display Express Sticker Settings.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 11.01.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('expressStickerCtrl', expressStickerCtrl);

  /** @ngInject */
  function expressStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 11.01.2017
     */
    if ($rootScope.permissionArr.indexOf('express_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.express-sticker';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 11.01.2017
     */
    vm.displayIcon=false;
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 10.31.2017
     */
    vm.printLabel = [];
    vm.fontSizeData = [];
    vm.layAwayLabelData = [];
    vm.shippingData = [];
    vm.expressLabelData = [];
    /**
     * get Express Sticker Data method is use to display Express Sticker data.
     * created on 11.01.2017
     */
    $scope.getExpressStickerData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/express')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            $scope.expressStickerData = result.data;
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.availableOrderStatus = result.data.express_print_sticker_setting.available_order_status;
                vm.finalOrderStatus = result.data.express_print_sticker_setting.express_final_order_status;
                vm.maxOrderNumber = parseInt(result.data.express_print_sticker_setting.express_max_number_order);
                vm.displayIcon=result.data.express_print_sticker_setting.display_icon;
                vm.printLabel = result.data.express_label_print_setting.express_label_to_print;
                vm.fontSizeData = result.data.express_font_size_setting.express_entity_to_print_custom_font;
                vm.layAwayLabelData = result.data.express_layaway_label_setting.express_layaway_label_to_print;
                vm.shippingData = result.data.express_shipping_method_setting.express_shipping_to_print;
                vm.expressLabelData = result.data.express_label_setting.express_label_to_print;
              }
            }
            //use to selected value not display in dropdown list
            $scope.getPrintLabel();
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }

    $scope.addItem = function(type) {
      $scope.inserted = {
        name: null,
        value: null,
      };
      if (type == 'fontsize') {
        vm.fontSizeData.push($scope.inserted);
      } else if (type == 'layaway') {
        vm.layAwayLabelData.push($scope.inserted);
      } else if (type == 'shipping') {
        vm.shippingData.push($scope.inserted);
      } else if (type == 'express') {
        vm.expressLabelData.push($scope.inserted);
      }

    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/stickerSettings/expressSticker/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "fontsize") {
          vm.fontSizeData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "layaway") {
          vm.layAwayLabelData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "shipping") {
          vm.shippingData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "express") {
          vm.expressLabelData.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };
    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 11.01.2017
     */
    $scope.validateArr = function(dataArr, titleElement, valueElement) {
      var errorKey = -1;
      var errorId = '';

      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + titleElement + '-' + i).removeClass('has-error');
        angular.element('#' + valueElement + '-' + i).removeClass('has-error');
        var n = dataArr[i];
        if (n.name == undefined) {
          errorKey = i;
          errorId = titleElement;
          break;
        } else if (n.value == undefined) {
          errorKey = i;
          errorId = valueElement;
          break;
        }
      }
      if (errorKey > -1) {
        angular.element('#' + errorId + '-' + errorKey).addClass('has-error');
        angular.element('#' + errorId + '-' + errorKey + ' input').focus();
        toastr.error('Field should not be empty.');
        return 1;
      }
      return 0;
    }
    /**
     * save Print Sticker setting method is use for add Print Sticker data.
     * created on 11.01.2017
     */
    $scope.saveExpressStickerSettings = function() {
      // check empty field validation
      var fontsize = $scope.validateArr(vm.fontSizeData, 'itemTitleFont', 'itemValueFont');
      if (fontsize == 1) {
        return false;
      }
      var layaway = $scope.validateArr(vm.layAwayLabelData, 'itemTitleLayaway', 'itemValueLayaway');
      if (layaway == 1) {
        return false;
      }
      var shipping = $scope.validateArr(vm.shippingData, 'itemTitleShipping', 'itemValueShipping');
      if (shipping == 1) {
        return false;
      }
      var express = $scope.validateArr(vm.expressLabelData, 'itemTitleExpress', 'itemValueExpress');
      if (express == 1) {
        return false;
      }
      $scope.stickerData = {};
      angular.forEach(vm.printLabel,function(val,key){
        vm.printLabel[key]['sort_order']=key+1;
      });
        $scope.stickerData['express_print_sticker_setting'] = {
            'available_order_status': vm.availableOrderStatus,
            'express_final_order_status': vm.finalOrderStatus,
            'express_max_number_order': vm.maxOrderNumber,
            'display_icon':vm.displayIcon?vm.displayIcon:false
          };
        $scope.stickerData['express_label_print_setting'] = {
            'express_label_to_print': vm.printLabel
          };
        $scope.stickerData['express_font_size_setting'] = {
            'express_entity_to_print_custom_font': vm.fontSizeData
          };
        $scope.stickerData['express_layaway_label_setting'] = {
            'express_layaway_label_to_print': vm.layAwayLabelData
          };
        $scope.stickerData['express_shipping_method_setting'] = {
            'express_shipping_to_print': vm.shippingData
          };
        $scope.stickerData['express_label_setting'] = {
            'express_label_to_print': vm.expressLabelData
          };
      apiService.loaderShow();
      var bodyData = {
        type: 'express',
        sticker_data: angular.toJson($scope.stickerData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };

    /**
     * get Active Status method is use to display all active order status.
     * created on 11.01.2017
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * get Print Label method is use to display all active print label.
     * created on 11.01.2017
     */
     $scope.getPrintLabel = function() {
       $http.get($rootScope.baseUrl + '/printlabels/active')
         .success(function(result) {
           if (result.status == 'fail') {
             toastr.error(result.message);
           } else {
             $scope.printLabelData=result;
             angular.forEach(result,function(val,key){
               angular.forEach(vm.printLabel,function(v,k){
                 if(val.label_name==v.label_name){
                   $scope.printLabelData[key]['sort_order']=v.sort_order;
                   $scope.printLabelData[key]['font']=v.font;
                 }
               });
             });
             // USE TO REMOVE $hashkey in object
             //$scope.printLabelData=angular.fromJson(angular.toJson( $scope.printLabelData ));
           }
         }).error(function(error) {
           apiService.loaderHide();
           if (error.data && error.data.code != undefined && error.data.code == 0) {
             toastr.error(error.data.message);
           }
         });
     }

    /**
    * sortable Options.
    * created on 04.23.2018
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedExpressPreviewData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * get express preview method is use to get preview data.
    * created on 04.23.2018
    */
    vm.expressPreviewData=[];
    vm.displayData=[];
    $scope.typeListkey = {};
    $scope.getExpressPreviewData=function(){
      $http.get($rootScope.baseUrl+'/config/stickerprintorder/express').success(function(response){
        var tempAdded = true;
        angular.forEach(response,function(val,key){
            vm.expressPreviewData.push(val);
            if( (val.label_code == 'layaway' || val.label_code == 'express') && tempAdded){
                vm.displayData.push(val);
                tempAdded = false;
            }else if(val.label_code != 'layaway' && val.label_code != 'express'){
                vm.displayData.push(val);
            }
            $scope.typeListkey[val.label_code] = val.label_name;
        });
        $scope.updatedExpressPreviewData=vm.expressPreviewData;
        if(vm.displayData.length>0){
          var firstData=(vm.displayData.length-2);
          vm.firstArray = vm.displayData.splice(0,vm.displayData.length);
          vm.secondArray = vm.displayData.splice(0,vm.displayData.length);
        }
      }).error(function(error){

      });
    }
    /**
    * save experr Order is use to save sort order and display data this order.
    * created on 04.23.2018
    */
    $scope.saveExpressStickerOrder=function(){
      $scope.stickerDataPreview = {};
      angular.forEach($scope.updatedExpressPreviewData,function(val,key){
        $scope.updatedExpressPreviewData[key]['sort_order']=key+1;
      });
        $scope.stickerDataPreview['express_print_sticker_setting'] = {
            'available_order_status': vm.availableOrderStatus,
            'express_final_order_status': vm.finalOrderStatus,
            'express_max_number_order': vm.maxOrderNumber,
            'display_icon':vm.displayIcon?vm.displayIcon:false
          };
        $scope.stickerDataPreview['express_label_print_setting'] = {
            'express_label_to_print': $scope.updatedExpressPreviewData
          };
        $scope.stickerDataPreview['express_font_size_setting'] = {
            'express_entity_to_print_custom_font': vm.fontSizeData
          };
        $scope.stickerDataPreview['express_layaway_label_setting'] = {
            'express_layaway_label_to_print': vm.layAwayLabelData
          };
        $scope.stickerDataPreview['express_shipping_method_setting'] = {
            'express_shipping_to_print': vm.shippingData
          };
        $scope.stickerDataPreview['express_label_setting'] = {
            'express_label_to_print': vm.expressLabelData
          };
      apiService.loaderShow();
      var bodyData = {
        type: 'express',
        sticker_data: angular.toJson($scope.stickerDataPreview),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
        $state.go($state.$current, null, {reload: true});
        //$state.go('sticker-settings.express-sticker');
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
  }
})();

/**
 * Print Sticker controller display Print Sticker Settings.
 * @author Anand Malvi <anand.malvi@brainvire.com>
 * created on 10.25.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('reworkStickerCtrl', reworkStickerCtrl);

  /** @ngInject */
  function reworkStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 10.25.2017
     */
    if ($rootScope.permissionArr.indexOf('rework_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.rework-sticker';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 10.25.2017
     */
    vm.displayIcon=false;
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 10.31.2017
     */
    vm.printLabel = [];
    vm.fontSizeData = [];
    vm.layAwayLabelData = [];
    vm.shippingData = [];
    vm.expressLabelData = [];
    /**
     * get Print Sticker Data method is use to display Print Sticker data.
     * created on 10.26.2017
     */
    $scope.getReworkStickerData = function() {
      $scope.isloaded = false;
      $http.get($rootScope.baseUrl + '/config/rework')
        .success(function(result) {
          $scope.isloaded = true;
          if (result) {
            $scope.printStickerData = result.data;
            if (result.status == 'fail') {
              toastr.error(result.message);
            } else {
              if (result.data) {
                vm.availableOrderStatus = result.data.express_print_sticker_setting.available_order_status;
                vm.finalOrderStatus = result.data.express_print_sticker_setting.express_final_order_status;
                vm.maxOrderNumber = parseInt(result.data.express_print_sticker_setting.express_max_number_order);
                vm.displayIcon=result.data.express_print_sticker_setting.display_icon;
                vm.printLabel = result.data.express_label_print_setting.express_label_to_print;
                vm.fontSizeData = result.data.express_font_size_setting.express_entity_to_print_custom_font;
                vm.layAwayLabelData = result.data.express_layaway_label_setting.express_layaway_label_to_print;
                vm.shippingData = result.data.express_shipping_method_setting.express_shipping_to_print;
                vm.expressLabelData = result.data.express_label_setting.express_label_to_print;

              }
            }
            //use to selected value not display in dropdown list
            $scope.getPrintLabel();
          }
        }).error(function(error) {
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
          $scope.isloaded = true;
        });
    }

    $scope.addItem = function(type) {
      $scope.inserted = {
        name: null,
        value: null,
      };
      if (type == 'fontsize') {
        vm.fontSizeData.push($scope.inserted);
      } else if (type == 'layaway') {
        vm.layAwayLabelData.push($scope.inserted);
      } else if (type == 'shipping') {
        vm.shippingData.push($scope.inserted);
      } else if (type == 'express') {
        vm.expressLabelData.push($scope.inserted);
      }

    };

    $scope.confirmDelete = function(id, type) {
      $rootScope.itemId = id;
      $rootScope.itemType = type;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: 'app/pages/stickerSettings/reworkSticker/deleteModal.html',
        scope: $scope,
      });
    };

    $scope.removeItem = function() {
      if ($rootScope.itemId != undefined && $rootScope.itemType != undefined) {
        if ($rootScope.itemType == "fontsize") {
          vm.fontSizeData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "layaway") {
          vm.layAwayLabelData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "shipping") {
          vm.shippingData.splice($rootScope.itemId, 1);
        } else if ($rootScope.itemType == "express") {
          vm.expressLabelData.splice($rootScope.itemId, 1);
        }
      }
      $scope.popupShow.close();
    };
    /**
     * validateArr method is use to validate empty inline grid element.
     * created on 10.27.2017
     */
    $scope.validateArr = function(dataArr, titleElement, valueElement) {
      var errorKey = -1;
      var errorId = '';
      for (var i = 0; i < dataArr.length; i++) {
        angular.element('#' + titleElement + '-' + i).removeClass('has-error');
        angular.element('#' + valueElement + '-' + i).removeClass('has-error');
        var n = dataArr[i];
        if (n.name == undefined) {
          errorKey = i;
          errorId = titleElement;
          break;
        } else if (n.value == undefined) {
          errorKey = i;
          errorId = valueElement;
          break;
        }
      }
      if (errorKey > -1) {
        angular.element('#' + errorId + '-' + errorKey).addClass('has-error');
        angular.element('#' + errorId + '-' + errorKey + ' input').focus();
        toastr.error('Field should not be empty.');
        return 1;
      }
      return 0;
    }
    /**
     * save Print Sticker setting method is use for add Print Sticker data.
     * created on 10.27.2017
     */
    $scope.saveReworkStickerSettings = function() {
      // check empty field validation
      var fontsize = $scope.validateArr(vm.fontSizeData, 'itemTitleFont', 'itemValueFont');
      if (fontsize == 1) {
        return false;
      }
      var layaway = $scope.validateArr(vm.layAwayLabelData, 'itemTitleLayaway', 'itemValueLayaway');
      if (layaway == 1) {
        return false;
      }
      var shipping = $scope.validateArr(vm.shippingData, 'itemTitleShipping', 'itemValueShipping');
      if (shipping == 1) {
        return false;
      }
      var express = $scope.validateArr(vm.expressLabelData, 'itemTitleExpress', 'itemValueExpress');
      if (express == 1) {
        return false;
      }
      $scope.stickerData = {};
      angular.forEach(vm.printLabel,function(val,key){
        vm.printLabel[key]['sort_order']=key+1;
      });
      //angular.forEach($scope.printStickerData, function(value, key) {
        $scope.stickerData['express_print_sticker_setting'] = {
            'available_order_status': vm.availableOrderStatus,
            'express_final_order_status': vm.finalOrderStatus,
            'express_max_number_order': vm.maxOrderNumber,
            'display_icon':vm.displayIcon?vm.displayIcon:false
          };
        $scope.stickerData['express_label_print_setting'] = {
            'express_label_to_print': vm.printLabel
          };
        $scope.stickerData['express_font_size_setting'] = {
            'express_entity_to_print_custom_font': vm.fontSizeData
          };
        $scope.stickerData['express_layaway_label_setting'] = {
            'express_layaway_label_to_print': vm.layAwayLabelData
          };
        $scope.stickerData['express_shipping_method_setting'] = {
            'express_shipping_to_print': vm.shippingData
          };
        $scope.stickerData['express_label_setting'] = {
            'express_label_to_print': vm.expressLabelData
          };
    //  });
      apiService.loaderShow();
      var bodyData = {
        type: 'rework',
        sticker_data: angular.toJson($scope.stickerData),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });

    };

    /**
     * get Active Status method is use to display all active order status.
     * created on 10.26.2017
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    //$scope.printLabel = {};
    /**
     * get Print Label method is use to display all active print label.
     * created on 10.26.2017
     */
    $scope.getPrintLabel = function() {
      $http.get($rootScope.baseUrl + '/printlabels/active')
        .success(function(result) {
          if (result.status == 'fail') {
            toastr.error(result.message);
          } else {
            $scope.printLabelData=result;
            angular.forEach(result,function(val,key){
              angular.forEach(vm.printLabel,function(v,k){
                if(val.label_name==v.label_name){
                  $scope.printLabelData[key]['sort_order']=v.sort_order;
                  $scope.printLabelData[key]['font']=v.font;
                }
              });
            });
            // USE TO REMOVE $hashkey in object
            //$scope.printLabelData=angular.fromJson(angular.toJson( $scope.printLabelData ));
          }
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }
    /**
    * sortable Options.
    * created on 04.20.2018
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedPrintPreviewData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * get print preview method is use to get preview data.
    * created on 04.23.2018
    */
    vm.printPreviewData=[];
    vm.displayData=[];
    $scope.typeListkey = {};
    $scope.getReworkPreviewData=function(){
      $http.get($rootScope.baseUrl+'/config/stickerprintorder/rework').success(function(response){
        var tempAdded = true;
        angular.forEach(response,function(val,key){
            vm.printPreviewData.push(val);
            if( (val.label_code == 'layaway' || val.label_code == 'express') && tempAdded){
                vm.displayData.push(val);
                tempAdded = false;
            }else if(val.label_code != 'layaway' && val.label_code != 'express'){
                vm.displayData.push(val);
            }
            $scope.typeListkey[val.label_code] = val.label_name;
        });
        $scope.updatedPrintPreviewData=vm.printPreviewData;
        if(vm.displayData.length>0){
          var firstData=(vm.displayData.length-2);
          vm.firstArray = vm.displayData.splice(0,vm.displayData.length);
          vm.secondArray = vm.displayData.splice(0,vm.displayData.length);
        }
      }).error(function(error){

      });
    }
    /**
    * save print Order is use to save sort order and display data this order.
    * created on 04.23.2018
    */

    $scope.savePrintPreviewOrder=function(){
      $scope.stickerDataPreview = {};
      angular.forEach($scope.updatedPrintPreviewData,function(val,key){
        $scope.updatedPrintPreviewData[key]['sort_order']=key+1;
      });
      $scope.stickerDataPreview['express_print_sticker_setting'] = {
          'available_order_status': vm.availableOrderStatus,
          'express_final_order_status': vm.finalOrderStatus,
          'express_max_number_order': vm.maxOrderNumber,
          'display_icon':vm.displayIcon?vm.displayIcon:false
        };
      $scope.stickerDataPreview['express_label_print_setting'] = {
          'express_label_to_print': $scope.updatedPrintPreviewData
        };
      $scope.stickerDataPreview['express_font_size_setting'] = {
          'express_entity_to_print_custom_font': vm.fontSizeData
        };
      $scope.stickerDataPreview['express_layaway_label_setting'] = {
          'express_layaway_label_to_print': vm.layAwayLabelData
        };
      $scope.stickerDataPreview['express_shipping_method_setting'] = {
          'express_shipping_to_print': vm.shippingData
        };
      $scope.stickerDataPreview['express_label_setting'] = {
          'express_label_to_print': vm.expressLabelData
        };
      apiService.loaderShow();
      var bodyData = {
        type: 'rework',
        sticker_data: angular.toJson($scope.stickerDataPreview),
        affected_by: $rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker', bodyData).success(function(response) {
        apiService.loaderHide();
        toastr.success(response.message);
        $state.go($state.$current, null, {reload: true});
        //$state.go('sticker-settings.print-sticker');
      }).error(function(error) {
        apiService.loaderHide();
        if (error.data.code != undefined && error.data.code == 0) {
          toastr.error(error.data.message);
        } else {
          toastr.error("Something went wrong please try again.");
        }
      });
    }
  }
})();

/**
 * Supply Sticker controller display Supply Sticker Settings.
 * @author Harsha Prajapati <harsha.prajapati@brainvire.com>
 * created on 10.31.2017
 */
(function() {
  'use strict';

  angular.module('BlurAdmin.pages.stickerSettings')
    .controller('supplyStickerCtrl', supplyStickerCtrl);

  /** @ngInject */
  function supplyStickerCtrl($scope, $timeout, apiService, $cookies, $uibModal, $q, $http, $rootScope, toastr, $state) {
    /**
     * permissionArr is use to check permission to display list
     * created on 10.31.2017
     */
    if ($rootScope.permissionArr.indexOf('supply_sticker') == -1) {
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState = 'sticker-settings.supply-sticker';
    $scope.resetGlobalSearch();
    /**
     * menuStatus is use to default open accordion
     * created on 10.31.2017
     */
    $scope.oneAtATime = false;
    $scope.menuStatus = [{
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      },
      {
        isOpen: true
      }
    ]
    /**
     * declare data.
     * created on 10.31.2017
     */
    vm.printLabel=[];
    vm.fontSizeData=[];
    vm.layAwayLabelData=[];
    vm.shippingData=[];
    vm.expressLabelData=[];
   /**
    * get Supply Sticker Data method is use to display Supply Sticker data.
    * created on 10.31.2017
    */
   $scope.getSupplyStickerData = function() {
     $scope.isloaded = false;
     $http.get($rootScope.baseUrl + '/config/supply')
       .success(function(result) {
         $scope.isloaded = true;
         if(result){
         $scope.supplyStickerData = result.data;
         if(result.status=='fail'){
           toastr.error(result.message);
         }else{
           if(result.data){
             vm.availableOrderStatus=result.data.express_print_sticker_setting.available_order_status;
             vm.finalOrderStatus=result.data.express_print_sticker_setting.express_final_order_status;
             vm.maxOrderNumber=parseInt(result.data.express_print_sticker_setting.express_max_number_order);
             vm.printLabel=result.data.express_label_print_setting.express_label_to_print;
             vm.fontSizeData=result.data.express_font_size_setting.express_entity_to_print_custom_font;
             vm.layAwayLabelData=result.data.express_layaway_label_setting.express_layaway_label_to_print;
             vm.shippingData=result.data.express_shipping_method_setting.express_shipping_to_print;
             vm.expressLabelData=result.data.express_label_setting.express_label_to_print;

           }
         }
         //use to selected value not display in dropdown list
         $scope.getPrintLabel();
      }
       }).error(function(error) {
         if (error.data && error.data.code != undefined && error.data.code == 0) {
           toastr.error(error.data.message);
         }
         $scope.isloaded = true;
       });
   }
   $scope.addItem = function(type) {
     $scope.inserted = {
       name: null,
       value: null,
     };
     if(type=='fontsize'){
       vm.fontSizeData.push($scope.inserted);
     }else if(type=='layaway'){
       vm.layAwayLabelData.push($scope.inserted);
     }else if(type=='shipping'){
       vm.shippingData.push($scope.inserted);
     }else if(type=='express'){
       vm.expressLabelData.push($scope.inserted);
     }

   };

   $scope.confirmDelete = function(id,type) {
     $rootScope.itemId = id;
     $rootScope.itemType=type;
     $scope.popupShow = $uibModal.open({
       animation: true,
       templateUrl: 'app/pages/stickerSettings/supplySticker/deleteModal.html',
       scope: $scope,
     });
   };

   $scope.removeItem = function() {
     if($rootScope.itemId != undefined && $rootScope.itemType != undefined){
       if($rootScope.itemType=="fontsize"){
          vm.fontSizeData.splice($rootScope.itemId, 1);
       }else if($rootScope.itemType=="layaway"){
         vm.layAwayLabelData.splice($rootScope.itemId, 1);
       }else if($rootScope.itemType=="shipping"){
         vm.shippingData.splice($rootScope.itemId, 1);
       }else if($rootScope.itemType=="express"){
         vm.expressLabelData.splice($rootScope.itemId, 1);
       }
     }
     $scope.popupShow.close();
   };
   /**
    * validateArr method is use to validate empty inline grid element.
    * created on 10.31.2017
    */
   $scope.validateArr = function(dataArr,titleElement,valueElement){
     var errorKey = -1;
     var errorId = '';

     for(var i = 0; i < dataArr.length; i++) {
         angular.element('#'+titleElement+'-'+i).removeClass('has-error');
         angular.element('#'+valueElement+'-'+i).removeClass('has-error');
         var n = dataArr[i];
         if(n.name == undefined){
           errorKey = i;
           errorId = titleElement;
           break;
         }else if(n.value == undefined){
           errorKey = i;
           errorId = valueElement;
           break;
         }
     }
     if(errorKey > -1){
         angular.element('#'+errorId+'-'+errorKey).addClass('has-error');
         angular.element('#'+errorId+'-'+errorKey+' input').focus();
         toastr.error('Field should not be empty.');
         return 1;
     }
     return 0;
   }
   /**
    * save Supply Sticker setting method is use for add Supply Sticker data.
    * created on 10.31.2017
    */
  $scope.saveSupplyStickerSettings = function() {
    // check empty field validation
       var fontsize = $scope.validateArr(vm.fontSizeData,'itemTitleFont','itemValueFont');
       if(fontsize == 1){
         return false;
       }
       var layaway = $scope.validateArr(vm.layAwayLabelData,'itemTitleLayaway','itemValueLayaway');
       if(layaway == 1){
          return false;
       }
       var shipping = $scope.validateArr(vm.shippingData,'itemTitleShipping','itemValueShipping');
       if(shipping == 1){
          return false;
       }
       var express = $scope.validateArr(vm.expressLabelData,'itemTitleExpress','itemValueExpress');
       if(express == 1){
          return false;
       }
       $scope.stickerData={};
       angular.forEach(vm.printLabel,function(val,key){
         vm.printLabel[key]['sort_order']=key+1;
       });
         $scope.stickerData['express_print_sticker_setting']={'available_order_status':vm.availableOrderStatus,
                  'express_final_order_status':vm.finalOrderStatus,
                  'express_max_number_order':vm.maxOrderNumber};
         $scope.stickerData['express_label_print_setting']={'express_label_to_print':vm.printLabel};
         $scope.stickerData['express_font_size_setting']={'express_entity_to_print_custom_font':vm.fontSizeData};
         $scope.stickerData['express_layaway_label_setting']={'express_layaway_label_to_print':vm.layAwayLabelData};
         $scope.stickerData['express_shipping_method_setting']={'express_shipping_to_print':vm.shippingData};
         $scope.stickerData['express_label_setting']={'express_label_to_print':vm.expressLabelData};

       apiService.loaderShow();
       var bodyData={
         type:'supply',
         sticker_data:angular.toJson($scope.stickerData),
         affected_by:$rootScope.globals.currentUser.id,
       };
       $http.post($rootScope.baseUrl + '/config/expressprintsticker',bodyData).success(function (response) {
            apiService.loaderHide();
            toastr.success(response.message);
         }).error(function (error) {
             apiService.loaderHide();
             if (error.data.code != undefined && error.data.code == 0) {
                 toastr.error(error.data.message);
             } else {
                 toastr.error("Something went wrong please try again.");
             }
         });

   };

    /**
     * get Active Status method is use to display all active order status.
     * created on 10.31.2017
     */
    $scope.getActiveStatus = function() {
      // get order status
      $http.post($rootScope.baseUrl + '/status/activeAll')
        .success(function(result) {
          $scope.orderStatus = result;
        }).error(function(error) {
          apiService.loaderHide();
          if (error.data && error.data.code != undefined && error.data.code == 0) {
            toastr.error(error.data.message);
          }
        });
    }

    /**
     * get Supply Label method is use to display all active print label.
     * created on 10.31.2017
     */
     $scope.getPrintLabel = function() {
       $http.get($rootScope.baseUrl + '/printlabels/active')
         .success(function(result) {
           if (result.status == 'fail') {
             toastr.error(result.message);
           } else {
             $scope.printLabelData=result;
             angular.forEach(result,function(val,key){
               angular.forEach(vm.printLabel,function(v,k){
                 if(val.label_name==v.label_name){
                   $scope.printLabelData[key]['sort_order']=v.sort_order;
                   $scope.printLabelData[key]['font']=v.font;
                 }
               });
             });
             // USE TO REMOVE $hashkey in object
             //$scope.printLabelData=angular.fromJson(angular.toJson( $scope.printLabelData ));
           }
         }).error(function(error) {
           apiService.loaderHide();
           if (error.data && error.data.code != undefined && error.data.code == 0) {
             toastr.error(error.data.message);
           }
         });
     }

    /**
    * sortable Options.
    * created on 04.23.2018
    */
    $scope.sortableOptions = {
      accept: function (sourceItemHandleScope, destSortableScope) {
            return true;
      },
      orderChanged: function (event) {
        $scope.updatedSupplyPreviewData = event.source.sortableScope.modelValue.map(function(a) {return a;});
      },
      containment: '#sortable-container',
      allowDuplicates: false,
    };
    /**
    * get supply preview method is use to get preview data.
    * created on 04.23.2018
    */
    vm.supplyPreviewData=[];
    vm.displayData=[];
    $scope.typeListkey = {};
    $scope.getSupplyPreviewData=function(){
      $http.get($rootScope.baseUrl+'/config/stickerprintorder/supply').success(function(response){
        var tempAdded = true;
        angular.forEach(response,function(val,key){
            vm.supplyPreviewData.push(val);
            if( (val.label_code == 'layaway' || val.label_code == 'express') && tempAdded){
                vm.displayData.push(val);
                tempAdded = false;
            }else if(val.label_code != 'layaway' && val.label_code != 'express'){
                vm.displayData.push(val);
            }
            $scope.typeListkey[val.label_code] = val.label_name;
        });
        $scope.updatedSupplyPreviewData=vm.supplyPreviewData;
        if(vm.displayData.length>0){
          var firstData=(vm.displayData.length-2);
          vm.firstArray = vm.displayData.splice(0,vm.displayData.length);
          vm.secondArray = vm.displayData.splice(0,vm.displayData.length);
        }
      }).error(function(error){

      });
    }
    /**
    * save supply Order is use to save sort order and display data this order.
    * created on 04.23.2018
    */
    $scope.saveSupplyStickerOrder=function(){
      $scope.stickerDataPreview = {};
      angular.forEach($scope.updatedSupplyPreviewData,function(val,key){
        $scope.updatedSupplyPreviewData[key]['sort_order']=key+1;
      });
        $scope.stickerDataPreview['express_print_sticker_setting']={'available_order_status':vm.availableOrderStatus,
                 'express_final_order_status':vm.finalOrderStatus,
                 'express_max_number_order':vm.maxOrderNumber};
        $scope.stickerDataPreview['express_label_print_setting']={'express_label_to_print':$scope.updatedSupplyPreviewData};
        $scope.stickerDataPreview['express_font_size_setting']={'express_entity_to_print_custom_font':vm.fontSizeData};
        $scope.stickerDataPreview['express_layaway_label_setting']={'express_layaway_label_to_print':vm.layAwayLabelData};
        $scope.stickerDataPreview['express_shipping_method_setting']={'express_shipping_to_print':vm.shippingData};
        $scope.stickerDataPreview['express_label_setting']={'express_label_to_print':vm.expressLabelData};

      apiService.loaderShow();
      var bodyData={
        type:'supply',
        sticker_data:angular.toJson($scope.stickerDataPreview),
        affected_by:$rootScope.globals.currentUser.id,
      };
      $http.post($rootScope.baseUrl + '/config/expressprintsticker',bodyData).success(function (response) {
           apiService.loaderHide();
           toastr.success(response.message);
           $state.go($state.$current, null, {reload: true});
           //$state.go('sticker-settings.supply-sticker');
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
    }
  }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);

(function() {
  'use strict';

  angular.module('BlurAdmin.pages.settings')
    .controller('magentoStatusCtrl', magentoStatusCtrl);

  /** @ngInject */
  function magentoStatusCtrl($scope, $rootScope, $cookies, apiService, $uibModal, $timeout, $state, $http, toastr, DTOptionsBuilder, DTColumnBuilder, $q, $compile) {

     /**
     * permissionArr is use to check permission to display list
     * created on 09.21.2018
     */
    if($rootScope.permissionArr.indexOf('magento_status_list') == -1){
      $state.go('dashboard');
      toastr.error("You don't have permission to do this.");
    }
    var vm = this;
    $rootScope.currentState='settings.store';

    /**
     * Get data table method is use get list of magento status.
     * created on 09.21.2018
     */
    $scope.getDataTable = function() {
      var vm = this;
      if($cookies.get('store-map-id') && $cookies.get('store-map-id')!= undefined){
      vm.dtOptions = DTOptionsBuilder.fromFnPromise(function() {
        var defer = $q.defer();
        $http.get($rootScope.baseUrl + '/magentostatus/index/'+$cookies.get('store-map-id'))
                .success(function(result) {
                    if(result.length < $rootScope.numberOfRecord){
                        $timeout(function () {
                            angular.element('.dataTables_paginate').hide();
                         }, 200);
                     }
          vm.magentoStatus = [];
          var index = 1 ;
          angular.forEach(result, function(value, key) {
            var changeStatusValTo = '0';
            var editLinks = ' <a ng-if="permissionArr.indexOf(\''+'magento_status_edit'+'\') !== -1" href="javascript:void(0);" ng-click="editMagentoStatus(\'' + value._id + '\')" title="Edit"><i class="fa fa-pencil-square-o fa-lg white" aria-hidden="true"></i></a>';
            var deleteLinks = '  <a ng-if="permissionArr.indexOf(\''+'magento_status_delete'+'\') !== -1" href="javascript:void(0);"  ng-click="open(\'' + 'app/pages/settings/store/magentoStatus/deleteModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" title="Delete" ><i class="fa fa-trash-o fa-lg white"></i> </a>';

            var statusBadge = '<span class="label label-success font-size-14 margin-inline">Active</span>';
            var statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'magento_status_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/store/magentoStatus/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="InActive"><img src="assets/img/switch-off.png" width="24"/></a>';

            if (value.status == 0) {
                changeStatusValTo = '1';
                statusBadge = '<span class="label label-danger font-size-14 margin-inline">InActive</span>';
                statusLinks = ' <a ng-if="permissionArr.indexOf(\''+'magento_status_changestatus'+'\') !== -1" ng-click="open(\'' + 'app/pages/settings/store/magentoStatus/statusModal.html' + '\',\'' + value._id + '\',' + changeStatusValTo + ')" href="javascript:void(0);" title="Active"><img src="assets/img/switch-on.png" width="24"/></a>';
            }

            var data = {
              id: value._id,
              magento_status_title: value.magento_status_title,
              magento_status_code:value.magento_status_code,
              index:index,
              updated_at: value.updated_at,
              status:statusBadge,
              operations: editLinks + '&nbsp;' + statusLinks + '&nbsp;' + deleteLinks
              };
            this.push(data);
            ++index;
          }, vm.magentoStatus);
          defer.resolve(vm.magentoStatus);
        }).error(function (error) {
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
        return defer.promise;
      }).withPaginationType('simple_numbers')
      vm.dtOptions.withOption('iDisplayLength', ($rootScope.numberOfRecord-1));
      vm.dtOptions.withOption('fnRowCallback',
        function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
          $scope.$apply($compile(nRow)($scope));
        });
      vm.dtOptions.withOption('sDom', $rootScope.dom);
      vm.dtOptions.withOption('initComplete', function() {
        angular.element('.dataTables_filter input').attr('placeholder', 'Search ...');
        angular.element('.dataTables_filter input').attr('class', 'form-control');
        angular.element('.dataTables_length select').attr('class', 'form-control');
     });
      vm.dtOptions.withOption('oLanguage',{ "sSearch": "",'sInfoFiltered':'(filtered from _MAX_ total entries)' });
      vm.dtColumns = [
        DTColumnBuilder.newColumn('index').withTitle('Sr.No'),
        DTColumnBuilder.newColumn('id').withTitle('No').notVisible(),
        DTColumnBuilder.newColumn('magento_status_title').withTitle('Magento Status Title'),
        DTColumnBuilder.newColumn('magento_status_code').withTitle('Magento Status Code'),
        DTColumnBuilder.newColumn('status').withTitle('Status').withOption('className', 'tableStatus'),
      ];
      if($rootScope.permissionArr.indexOf('magento_status_edit') !== -1 || $rootScope.permissionArr.indexOf('magento_status_delete') !== -1 || $rootScope.permissionArr.indexOf('magento_status_changestatus') !== -1){
        vm.dtColumns.push(DTColumnBuilder.newColumn('operations').withTitle('Actions').withOption('orderable', false).withOption('className', 'tableActions'));
      }
    }
  }

     /**
     * Add MagentoStatus method is use for get add MagentoStatus page.
     * created on 09.21.2018
     */
    $scope.addMagentoStatus = function() {
      $cookies.put('magento-status-id',undefined);
      $state.go('settings.add-magento-status');
    }

    /**
     * Edit MagentoStatus method is use for get edit MagentoStatus page.
     * created on 09.21.2018
     */
    $scope.editMagentoStatus = function(id) {
      $cookies.put('magento-status-id',id);
      $state.go('settings.edit-magento-status');
    }

    /**
     * Open model.
     * created on 09.21.2018
     */
    $scope.open = function(page, id, status) {
      $rootScope.deleteId = id;
      $rootScope.status = status;
      $scope.popupShow = $uibModal.open({
        animation: true,
        templateUrl: page,
        scope: $scope,
      });
    };
    /**
     * Change status method is use for change status of MagentoStatus.
     * created on 09.21.2018
     */
    $scope.changeStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        var bodyData = {
          id: $rootScope.deleteId,
          status: ""+$rootScope.status+"",
        };
        $http.put($rootScope.baseUrl + '/magentostatus', bodyData)
          .success(function(result) {
            apiService.loaderHide();
            if (result.status == 'success') {
              toastr.success('Status updated successfully.');
              $state.go($state.$current, null, {
                reload: true
              });
            } else {
              $state.go('settings.magento-status');
              toastr.error("Something went wrong please try again.");
            }
          }).error(function(error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
          });
        $scope.popupShow.close();
      }
    };

    /**
     * Delete MagentoStatus method is use for delete MagentoStatus.
     * created on 09.21.2018
     */
    $scope.deleteMagentoStatus = function() {
      if ($rootScope.deleteId) {
        apiService.loaderShow();
        $http.delete($rootScope.baseUrl + '/magentostatus/' + $rootScope.deleteId)
                .success(function(result) {
                  apiService.loaderHide();
          if (result.status == 'success') {
            toastr.success('Magento Status deleted successfully.');
            $state.go($state.$current, null, {
              reload: true
            });
          } else {
            toastr.error("Something went wrong please try again.");
          }
        }).error(function (error) {
            apiService.loaderHide();
            if (error.data.code != undefined && error.data.code == 0) {
                toastr.error(error.data.message);
            } else {
                toastr.error("Something went wrong please try again.");
            }
        });
      }
      $scope.popupShow.close();
    };

    /**
     * Save MagentoStatus data method is use for update/add MagentoStatus data.
     * created on 09.21.2018
     */
    $scope.saveMagentoStatusData = function() {
       if (!this.magentoStatusFrm.$valid) {
          return;
        }
       apiService.loaderShow();
      var bodyData = {
        magento_status_title: vm.magentoStatusTitle,
        magento_status_code:vm.magentoStatusCode,
        status: vm.status,
        affected_by: $rootScope.globals.currentUser.id,
      };
      $scope.saveUrl = $rootScope.baseUrl + '/magentostatus/'+$cookies.get('store-map-id');
      $scope.httpMethod = 'POST';
      if (vm.magentoStatusId) {
        $scope.saveUrl = $rootScope.baseUrl + '/magentostatus/' + vm.magentoStatusId+'/'+$cookies.get('store-map-id');
        $scope.httpMethod = 'PUT';
      }
      $http({
        url: $scope.saveUrl,
        method: $scope.httpMethod,
        data: $scope.dataUrlEncode(bodyData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(function(response) {
        apiService.loaderHide();
        var response = response.data;
        if (response.status == 'success') {
          toastr.success('Magento Status ' + (vm.magentoStatusId ? 'updated' : 'added') + ' successfully.');
          $state.go('settings.magento-status');
        } else {
          toastr.error(response.message);
        }
      }, function(error) {
        apiService.loaderHide();
        if (error.data.code!= undefined && error.data.code == 0) {
            toastr.error(error.data.message);
        } else {
          $state.go('settings.magento-status');
          toastr.error("Something went wrong please try again.");
        }
      });

    }

    /**
     * Get edited MagentoStatus method is use for get edited MagentoStatus data.
     * created on 09.21.2018
     */
    $scope.getEditedMagentoStatus = function() {

        if($rootScope.permissionArr.indexOf('magento_status_add') == -1 && $rootScope.permissionArr.indexOf('magento_status_edit') == -1){
          $state.go('dashboard');
          toastr.error("You don't have permission to do this.");
        }

        if ($cookies.get('magento-status-id') && $cookies.get('magento-status-id')!= undefined) {
          apiService.loaderShow();
          $http.get($rootScope.baseUrl + '/magentostatus/' + $cookies.get('magento-status-id'))
            .success(function(response) {
              apiService.loaderHide();
              vm.magentoStatusTitle = response.magento_status_title;
              vm.magentoStatusCode=response.magento_status_code;
              vm.magentoStatusId = response._id;
              vm.status = response.status;
            }).error(function (error) {
                apiService.loaderHide();
                if (error.data.code != undefined && error.data.code == 0) {
                    toastr.error(error.data.message);
                } else {
                    toastr.error("Something went wrong please try again.");
                }
            });
        } else {
          $state.go('settings.add-magento-status');
        }
    };

  }

})();

angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/barcodeScan/barcodeScan.html','<div class="widgets profile" ng-init="getBarcodeDeptData()" ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Choose Department"><div ng-show="isloadedDepartment"><div class="row"><div class="col-sm-4 col-md-2" ng-if="checkPermission(dept.name)" ng-repeat="dept in vm.departmentsData"><div class="dept-icon cursor-pointer" ng-click="goToChangeStatusPage(dept.name,dept.status_block_flag)"><i ng-if="dept.department_icon" class="{{dept.department_icon}} fa-3x" aria-hidden="true"></i> <i ng-if="!dept.department_icon" class="fa fa-desktop fa-3x" aria-hidden="true"></i> <span>{{dept.name}}</span></div></div><div class="col-sm-4 col-md-2" ng-if="permissionArr.indexOf(\'dept_damage\') !== - 1"><div class="dept-icon cursor-pointer" ng-click="goToChangeStatusPage(\'damage\')"><i class="fa fa-chain-broken fa-3x" aria-hidden="true"></i> <span>Damage</span></div></div><div class="col-sm-4 col-md-2" ng-if="permissionArr.indexOf(\'barcode_monume\') !== - 1"><div class="dept-icon cursor-pointer" ng-click="goToChangeStatusPage(\'barcode_monume\')"><i class="fa fa-th fa-3x"></i> <span>Change to Monume</span></div></div><div class="col-sm-4 col-md-2" ng-if="permissionArr.indexOf(\'dept_all\') !== - 1"><div class="dept-icon cursor-pointer" ng-click="goToChangeStatusPage(\'all\')"><i class="fa fa-th fa-3x"></i> <span>All</span></div></div></div></div><div ng-show="!isloadedDepartment" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div>');
$templateCache.put('app/pages/barcodeScan/changeStatus.html','<div class="widgets profile role-permission" ng-init="getDepartmentStatus();getDamageSettingData()" ba-panel="" ba-panel-title="Scanned Orders <div class=\'pull-right\'> <span ng-show=\'showItemScanned\'>Total Item Scanned : {{duplicateCheckRow.length}}</span> <span ng-show=\'showItemUpdated\'>Total Item Updated : {{updatedItem.length}}</span></div>"><div><form class="form-horizontal" name="changeStatusFrm" novalidate=""><div class="row"><div class="col-md-12 barcodeCont"><div class="form-group row clearfix"><a id="resetScan" class="btn btn-danger btn-with-icon reset-button" href="javascript:void(0);" ng-click="resetScan()"><i class="fa fa-undo"></i> Reset Scan</a> <button id="manualScan" type="button" class="btn btn-success btn-with-icon hide-element" ng-click="doneManualScan()"><i class="ion-android-checkmark-circle"></i>Done Scanning</button> <a ui-sref="barcode" ng-show="showItemScanned && duplicateCheckRow.length" class="btn btn-warning btn-with-icon save-cancel-btn"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-show="showItemScanned && duplicateCheckRow.length && !IsDamageOrder" class="btn btn-primary btn-with-icon save-cancel-btn" ng-click="applyStatus()"><i class="ion-android-checkmark-circle"></i>Apply Status</button> <button type="button" ng-if="showItemScanned && duplicateCheckRow.length && IsDamageOrder" class="btn btn-primary btn-with-icon apply-cancel-margin" ng-click="reprintOrder()"><i class="ion-android-checkmark-circle"></i>Reprint</button> <button ui-sref="barcode" ng-show="showItemUpdated" type="button" class="btn btn-success save-cancel-btn btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Done</button><div class="col-md-3 col-sm-4 pull-right" ng-show="showItemScanned && duplicateCheckRow.length && !IsDamageOrder"><ui-select ng-model="vm.orderStatus" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" style="margin-top:4px"><ui-select-match placeholder="Change order status to">{{$select.selected.status}}</ui-select-match><ui-select-choices repeat="status.status_code as status in vm.departmentStatus | filter: $select.search"><span ng-bind-html="status.status"></span></ui-select-choices></ui-select></div></div><div class="row text-center" id="scanStart"><div class="col-md-offset-4"><div class="col-md-3 col-sm-5"><div class="dept-icon cursor-pointer" ng-click="showScan()"><img src="assets/img/barcode-scanner.png"> <span>Scan Barcode</span></div></div><div class="col-md-3 col-sm-5"><div class="dept-icon cursor-pointer" ng-click="showManualScan()"><i class="fa fa-barcode fa-4x" aria-hidden="true"></i> <span>Manual Scan</span></div></div></div></div><div class="viewOrder" id="viewOrder"><div><div class="col-md-12"><div id="tblOrder1" class="row form-group clearfix"><input type="text" ng-model="barcodeText" class="form-control" placeholder="Enter Order ID" id="txt-barcode" name="txt-barcode" ng-blur="scanBarcode(barcodeText)" ng-enter="scanBarcode(barcodeText)" style="display:none"></div></div><div class="row"><div class="col-md-12 scan"><div class="horizontal-scroll"><table ng-show="isloaded" class="table table-bordered with-scroll row-border hover" id="tblOrder"><thead><tr style="display:none"><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th></tr></thead><tbody></tbody></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div></div></div><div class="row"><div class="pull-left summary-footer-barcode-scan"><span ng-show="showItemScanned">Total Item Scanned : {{duplicateCheckRow.length}}</span>&nbsp;&nbsp; <span ng-show="showItemUpdated">Total Item Updated : {{updatedItem.length}}</span></div><div class="btn-scan-barcode-scan"><a ui-sref="barcode" ng-show="showItemScanned && duplicateCheckRow.length" class="btn btn-warning btn-with-icon apply-cancel-margin"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-show="showItemScanned && duplicateCheckRow.length && !IsDamageOrder" class="btn btn-primary btn-with-icon apply-cancel-margin" ng-click="applyStatus()"><i class="ion-android-checkmark-circle"></i>Apply Status</button> <button type="button" ng-if="showItemScanned && duplicateCheckRow.length && IsDamageOrder" class="btn btn-primary btn-with-icon apply-cancel-margin" ng-click="reprintOrder()"><i class="ion-android-checkmark-circle"></i>Reprint</button> <button ui-sref="barcode" ng-show="showItemUpdated" type="button" class="btn btn-success btn-with-icon save-permission apply-cancel-margin"><i class="ion-android-checkmark-circle"></i>Done</button><div class="col-md-3 col-sm-4 pull-right" ng-show="showItemScanned && duplicateCheckRow.length && !IsDamageOrder"><ui-select ng-model="vm.orderStatus" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" style="margin-top:4px"><ui-select-match placeholder="Change order status to">{{$select.selected.status}}</ui-select-match><ui-select-choices repeat="status.status_code as status in vm.departmentStatus | filter: $select.search"><span ng-bind-html="status.status"></span></ui-select-choices></ui-select></div></div></div></form></div></div><div id="scan-popup-barcode"><div class="left"><h2>SCAN ORDERS...</h2><p><a href="javascript:void(0);" class="btn btn-warning btn-with-icon" ng-click="hidePopup()">Done Scanning</a></p></div></div><div class="black_overlay" id="fade"></div>');
$templateCache.put('app/pages/barcodeScan/damageScan.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Choose Damage Department"><div class="row"><div class="col-sm-4 col-md-2"><div class="dept-icon cursor-pointer" ng-click="goToDamageStatusPage(\'Regular\')"><i class="fa fa-cart-plus fa-3x" aria-hidden="true"></i> <span>Regular</span></div></div><div class="col-sm-4 col-md-2"><div class="dept-icon cursor-pointer" ng-click="goToDamageStatusPage(\'Express\')"><i class="fa fa-line-chart fa-3x" aria-hidden="true"></i> <span>Express</span></div></div><div class="col-sm-4 col-md-2"><div class="dept-icon cursor-pointer" ng-click="goToDamageStatusPage(\'Rework\')"><i class="fa fa-retweet fa-3x" aria-hidden="true"></i> <span>Rework</span></div></div><div class="col-sm-4 col-md-2"><div class="dept-icon cursor-pointer" ng-click="goToDamageStatusPage(\'Customer\')"><i class="fa fa-users fa-3x" aria-hidden="true"></i> <span>Customer</span></div></div><div class="col-sm-4 col-md-2" ng-if="permissionArr.indexOf(\'ink_allocation\') !== - 1"><div class="dept-icon cursor-pointer" ng-click="goToChangeStatusPage(\'ink_allocation\')"><i class="fa fa-line-chart fa-3x" aria-hidden="true"></i> <span>Ink Allocation</span></div></div></div></div>');
$templateCache.put('app/pages/barcodeScan/inkScan.html','<div class="widgets profile role-permission"><div><form class="form-horizontal" name="changeStatusFrm" novalidate=""><div class="row"><div class="col-md-12 barcodeCont"><div class="form-group row clearfix"><a id="resetScan" class="btn btn-danger btn-with-icon reset-button" href="javascript:void(0);" ng-click="resetScan()"><i class="fa fa-undo"></i> Reset Scan</a> <button id="manualScan" type="button" class="btn btn-success btn-with-icon hide-element" ng-click="doneManualScan()"><i class="ion-android-checkmark-circle"></i>Done Scanning</button> <a ui-sref="barcode" ng-show="showItemScanned && duplicateCheckRow.length" class="btn btn-warning btn-with-icon save-cancel-btn"><i class="ion-android-warning"></i>Cancel</a> <button ui-sref="barcode" ng-show="showItemUpdated" type="button" class="btn btn-success save-cancel-btn btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Done</button><div class="col-md-3 col-sm-4 pull-right" ng-show="showItemScanned && duplicateCheckRow.length && !IsDamageOrder"></div></div><div class="row text-center" id="scanStart"><div class="col-md-offset-4"><div class="col-md-3 col-sm-5"><div class="dept-icon cursor-pointer" ng-click="showScan()"><img src="assets/img/barcode-scanner.png"> <span>Scan Barcode</span></div></div><div class="col-md-3 col-sm-5"><div class="dept-icon cursor-pointer" ng-click="showManualScan()"><i class="fa fa-barcode fa-4x" aria-hidden="true"></i> <span>Manual Scan</span></div></div></div></div><div class="viewOrder" id="viewOrder"><div><div class="col-md-12"><div id="tblOrder1" class="row form-group clearfix"><input type="text" ng-model="barcodeText" class="form-control" placeholder="Enter Product SKU" id="txt-barcode" name="txt-barcode" ng-blur="scanInkBarcode(barcodeText)" ng-enter="scanInkBarcode(barcodeText)" style="display:none"></div></div><div class="row"><div class="col-md-12"><div class="btn-scan-barcode-scan"><a ui-sref="barcode" ng-show="productsScanned && productsScanned.length" class="btn btn-warning btn-with-icon apply-cancel-margin"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-show="productsScanned && productsScanned.length" class="btn btn-primary btn-with-icon apply-cancel-margin" ng-click="applyRemoveStock()"><i class="ion-android-checkmark-circle"></i>Remove Stock</button></div></div><div class="col-md-12 scan"><div class="horizontal-scroll"><table ng-show="isloaded" class="table table-bordered with-scroll row-border hover" id="tblOrder"><thead><tr style="display:none"><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th></tr></thead><tbody></tbody></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div></div></div><div class="row"><div class="pull-left summary-footer-barcode-scan"><span ng-show="showItemScanned">Total Products Scanned : {{productsScanned.length}}</span>&nbsp;&nbsp; <span ng-show="showQtyScanned">Total Qty Scanned : {{qtyScanned.length}}</span></div></div></form></div></div><div id="scan-popup-barcode"><div class="left"><h2>SCAN PRODUCT...</h2><p><a href="javascript:void(0);" class="btn btn-warning btn-with-icon" ng-click="hidePopup()">Done Scanning</a></p></div></div><div class="black_overlay" id="fade"></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<div ng-if="globals.currentUser.statusPermission.length<=0" class="row" ng-init="resetManualDate();"><span>Welcome {{globals.currentUser.firstname}} {{globals.currentUser.lastname}}</span></div><div ng-if="globals.currentUser.statusPermission.length>0"><div class="row mb-10"><div class="col-md-2"><div class="input-group cur-pntr"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePicker.date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon date-picker input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-1 pull-right"><button type="button" id="btnrefresh" ng-click="loadDataFromAPI()" class="btn btn-warning btn-with-icon pull-right"><i class="fa fa-refresh"></i>Refresh</button></div><div class="col-md-2 pull-right"><div ba-panel="" ba-panel-class="inline-panel"><i class="fa fa-clock-o"></i> Last Refresh : {{lastRefreshTime}}</div></div><div class="col-md-1 pull-right" ng-if="permissionArr.indexOf(\'view-order-count-main-dashboard\') !== -1" style="width: 270px;"><div ba-panel="" ba-panel-class="inline-panel">Design : {{DesignOrdersCount}} / {{DesignItemsCount}}</div></div><div class="col-md-1 pull-right" ng-if="permissionArr.indexOf(\'view-order-count-main-dashboard\') !== -1" style="width: 270px;"><div ba-panel="" ba-panel-class="inline-panel">Production : {{QAOrdersCount}} / {{QAItemsCount}}</div></div><div class="col-md-1 pull-right" ng-if="permissionArr.indexOf(\'view-order-count-main-dashboard\') !== -1" style="width: 270px;"><div ba-panel="" ba-panel-class="inline-panel">Customer Shipping : {{ShippingOrdersCount}} / {{ShippingItemsCount}}</div></div><div class="col-md-1 pull-right" ng-if="permissionArr.indexOf(\'view-order-count-main-dashboard\') !== -1" style="width: 270px;"><div ba-panel="" ba-panel-class="inline-panel">Mall Shipping : {{mallShippingOrdersCount}} / {{mallShippingItemsCount}}</div></div></div><div class="row chart-align-margin"><div class="dash-block-width col-sm-6" ng-repeat="(key,chart) in pieChartArr" ng-if="permissionArr.indexOf(\'view-pie-chart-main-dashboard-\'+ key) !== -1"><div ba-panel="" ba-panel-title="{{key}}" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row" style="height: 140px"><canvas ng-if="chart.value.length>0" id="doughnut" chart-options="pieChartOptions" chart-colors="chart.color" class="chart chart-doughnut" chart-data="chart.value" chart-labels="chart.lable" chart-click="changeData"></canvas><div style="font-size:15px;top:62%;z-index:-1" class="traffic-text">{{piechartData[key][2]}} <span style="font-size:12px;line-height: 7px;">%</span></div></div></div></div></div><div class="masonry"><div ng-if="checkPermission(key)" ng-repeat="( key, data) in statusCategories" class="item"><div ba-panel="" ba-panel-title="{{key}}" ba-panel-class="with-scroll"><table class="table"><tr><th style="text-align: left;">Status Name</th><th>No. Orders</th><th>No. Products</th><th>%</th></tr><tr ng-if="status.label !=\'\' && getLength(data)" ng-repeat="(type, status) in data" ng-attr-style="background-color: {{status.color}};" ng-class="{\'poitr-cur\':status.total}" ng-click="searchOnOrderList(status.label, type, status.total,key)"><td style="text-align: left;">{{status.label}}</td><td class="text-center">{{status.total}}</td><td class="text-center">{{status.item_total}}</td><td class="text-center">{{status.perc}}</td></tr><tr ng-if="!getLength(data)"><td colspan="4">No data available</td></tr></table></div></div></div></div>');
$templateCache.put('app/pages/document/document.html','<style type="text/css">\nh1.page-title {\n    font-size: 21px;\n    padding: 0;\n    margin: 0;\n}\nul.prd_dnl {\n     list-style: none;\n}\nul.prd_dnl li {\n    display: block;\n    float: left;\n    width: 201px;\n    margin: 37px 27px 37px 0px;\n}\n.download_preview{ padding-left:68px; padding-right:68px}\n.innercntr{width:100%; float:left; position:relative; -webkit-border-radius: 5px; -moz-border-radius: 5px; border-radius: 5px; padding:20px; -webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; -moz-box-shadow: 0 0 16px 0 #000;-webkit-box-shadow: 0 0 16px 0 #000; box-shadow: 0 0 16px 0 #000;}\n.download_preview ul li span{display:block; padding-top:16px;}\n.download_preview ul li span a{background:#959595 url(../images/arrow_down.png) no-repeat 8px 13px; padding:10px 0px 10px 20px; text-decoration:none; color:#fff; font-weight:700; font-size:14px; line-height:18px; display:block; text-align:center}\n.clear {\n    clear: both;\n    height: 0px;\n}\n.booklets{width:100%; float:left; position:relative; border-top:dotted 1px #fff; padding:54px 0px; margin-top:24px;}\n</style><div class="widgets profile faqfrontend" ba-panel=""><div ng-init="getDocumentData()"><div ng-if="status==\'1\'" ng-bind-html="description"></div><div ng-if="status==\'0\'">No data available in document</div></div></div>');
$templateCache.put('app/pages/dubaiMachines/addMachine.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';"><div class="panel-content" ng-init="getEditedMachine()"><form class="form-horizontal" name="machineFrm" novalidate="" ng-submit="machineFrm.$valid && saveMachineData()"><div class="row"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>{{machineTitle}}</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (machineFrm.name.$error.required || machineFrm.name.$error.maxlength) && machineFrm.name.$touched}"><label for="name" class="col-sm-4 control-label">Machine Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="name" limit-to="150" ng-maxlength="150" type="text" ng-model="vm.name" name="name" required="" class="form-control" placeholder="Machine Name"> <span class="error" ng-show="machineFrm.$submitted && machineFrm.name.$error.required">Please enter machine name.</span> <span class="error" ng-show="!machineFrm.name.$error.pattern && machineFrm.name.$error.maxlength && machineFrm.name.$touched">Machine Name should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (machineFrm.machinelabel.$error.required || machineFrm.machinelabel.$error.maxlength) && machineFrm.machinelabel.$touched}"><label for="machinelabel" class="col-sm-4 control-label">Machine Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="machinelabel" limit-to="150" ng-maxlength="150" type="text" ng-model="vm.machinelabel" name="machinelabel" required="" class="form-control" placeholder="Machine Sticker Label"> <span class="error" ng-show="machineFrm.$submitted && machineFrm.machinelabel.$error.required">Please enter machine label.</span> <span class="error" ng-show="!machineFrm.machinelabel.$error.pattern && machineFrm.machinelabel.$error.maxlength && machineFrm.machinelabel.$touched">Machine Label should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="machineFrm.$submitted && machineFrm.status.$error.required">Please select status.</span></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 text-right"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="dubaimachines.managemachines" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="machineId"></div></div></form></div></div>');
$templateCache.put('app/pages/dubaiMachines/addSlot.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';"><div class="panel-content" ng-init="getEditedSlot()"><form class="form-horizontal" name="slotFrm" novalidate="" ng-submit="slotFrm.$valid && saveSlotData()"><div class="row"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>{{slotTitle}}</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (slotFrm.name.$error.required || slotFrm.name.$error.maxlength) && slotFrm.name.$touched}"><label for="name" class="col-sm-4 control-label">Slot Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="name" limit-to="150" ng-maxlength="150" type="text" ng-model="vm.name" name="name" required="" class="form-control" placeholder="Slot Name"> <span class="error" ng-show="slotFrm.$submitted && slotFrm.name.$error.required">Please enter slot name.</span> <span class="error" ng-show="!slotFrm.name.$error.pattern && slotFrm.name.$error.maxlength && slotFrm.name.$touched">Slot Name should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="slotFrm.$submitted && slotFrm.status.$error.required">Please select status.</span></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 text-right"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="dubaimachines.machineslots" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="slotId"></div></div></form></div></div>');
$templateCache.put('app/pages/dubaiMachines/deleteModal.html','<div class="modal-content" ng-controller="dubaiMachinesCtrl"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteMachine()">YES</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/dubaiMachines/deleteModalSlot.html','<div class="modal-content" ng-controller="machineSlotsCtrl"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteSlot()">YES</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/dubaiMachines/machines.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addMachine()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/dubaiMachines/slots.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addSlot()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button> <button type="button" ng-click="SlotBarcodes(machineId)" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Barcodes</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/dubaiMachines/statusModal.html','<div class="modal-content" ng-controller="dubaiMachinesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/dubaiMachines/statusModalSlot.html','<div class="modal-content" ng-controller="machineSlotsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/faqFrontend/faqFrontend.html','<div class="widgets profile faqfrontend" ba-panel=""><div ng-init="getFAQData()"><uib-accordion ng-if="vm.faqFrontendData.length>0"><uib-accordion-group ng-if="$index==0" is-open="status" ng-repeat="faq in vm.faqFrontendData track by $index" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-minus-circle fa-lg\': status, \'fa fa-plus-circle fa-lg\': !status}"></i> <span class="accordion-title">{{faq.question}}</span></uib-accordion-heading><div class="horizontal-scroll anchor-color"><p ng-bind-html="faq.answer" class="word-break"></p></div></uib-accordion-group><uib-accordion-group ng-if="$index!=0" is-open="status1" ng-repeat="faq in vm.faqFrontendData track by $index" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-minus-circle fa-lg\': status1, \'fa fa-plus-circle fa-lg\': !status1}"></i> <span class="accordion-title">{{faq.question}}</span></uib-accordion-heading><div class="horizontal-scroll"><p ng-bind-html="faq.answer"></p></div></uib-accordion-group></uib-accordion><div ng-if="vm.faqFrontendData.length<=0" class="text-center"><span>No data available</span></div></div></div>');
$templateCache.put('app/pages/databaseMachines/addMachine.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';"><div class="panel-content" ng-init="getEditedMachine()"><form class="form-horizontal" name="machineFrm" novalidate="" ng-submit="machineFrm.$valid && saveMachineData()"><div class="row"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>{{machineTitle}}</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (machineFrm.name.$error.required || machineFrm.name.$error.maxlength) && machineFrm.name.$touched}"><label for="name" class="col-sm-4 control-label">Machine Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="name" limit-to="150" ng-maxlength="150" type="text" ng-model="vm.name" name="name" required="" class="form-control" placeholder="Machine Name"> <span class="error" ng-show="machineFrm.$submitted && machineFrm.name.$error.required">Please enter machine name.</span> <span class="error" ng-show="!machineFrm.name.$error.pattern && machineFrm.name.$error.maxlength && machineFrm.name.$touched">Machine Name should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (machineFrm.machinelabel.$error.required || machineFrm.machinelabel.$error.maxlength) && machineFrm.machinelabel.$touched}"><label for="machinelabel" class="col-sm-4 control-label">Machine Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="machinelabel" limit-to="150" ng-maxlength="150" type="text" ng-model="vm.machinelabel" name="machinelabel" required="" class="form-control" placeholder="Machine Sticker Label"> <span class="error" ng-show="machineFrm.$submitted && machineFrm.machinelabel.$error.required">Please enter machine label.</span> <span class="error" ng-show="!machineFrm.machinelabel.$error.pattern && machineFrm.machinelabel.$error.maxlength && machineFrm.machinelabel.$touched">Machine Label should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="machineFrm.$submitted && machineFrm.status.$error.required">Please select status.</span></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 text-right"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="databasemachines.managemachines" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="machineId"></div></div></form></div></div>');
$templateCache.put('app/pages/databaseMachines/addSlot.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';"><div class="panel-content" ng-init="getEditedSlot()"><form class="form-horizontal" name="slotFrm" novalidate="" ng-submit="slotFrm.$valid && saveSlotData()"><div class="row"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>{{slotTitle}}</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (slotFrm.name.$error.required || slotFrm.name.$error.maxlength) && slotFrm.name.$touched}"><label for="name" class="col-sm-4 control-label">Slot Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="name" limit-to="150" ng-maxlength="150" type="text" ng-model="vm.name" name="name" required="" class="form-control" placeholder="Slot Name"> <span class="error" ng-show="slotFrm.$submitted && slotFrm.name.$error.required">Please enter slot name.</span> <span class="error" ng-show="!slotFrm.name.$error.pattern && slotFrm.name.$error.maxlength && slotFrm.name.$touched">Slot Name should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="slotFrm.$submitted && slotFrm.status.$error.required">Please select status.</span></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 text-right"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="databasemachines.machineslots" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="slotId"></div></div></form></div></div>');
$templateCache.put('app/pages/databaseMachines/deleteModal.html','<div class="modal-content" ng-controller="databaseMachinesCtrl"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteProduct()">YES</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/databaseMachines/deleteModalSlot.html','<div class="modal-content" ng-controller="machineSlotsCtrl"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteSlot()">YES</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/databaseMachines/machines.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addMachine()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/databaseMachines/slots.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addSlot()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button> <button type="button" ng-click="SlotBarcodes(machineId)" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Barcodes</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/databaseMachines/statusModal.html','<div class="modal-content" ng-controller="databaseMachinesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/databaseMachines/statusModalSlot.html','<div class="modal-content" ng-controller="machineSlotsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/login/login.html','<main class="auth-main" ng-controller="loginCtrl"><div class="auth-block" ng-init="getLogo()"><h1><img ng-if="!loginLogo" class="login-logo" ng-src="{{::( \'logo-new\' | profilePicture )}}"> <img ng-if="loginLogo" class="login-logo" ng-src="{{logoUrl+loginLogo}}"></h1><form class="form-horizontal" name="loginFrm" novalidate=""><div class="form-group" ng-class="{\'has-error\':loginFrm.emailAdd.$touched && loginFrm.emailAdd.$error.required}"><label for="inputEmail3" class="col-sm-3 control-label">Username/Email</label><div class="col-sm-9"><input type="text" name="emailAdd" required="" ng-model="emailAdd" class="form-control" id="inputEmail" placeholder="Username / Email"></div></div><div class="form-group" ng-class="{\'has-error\': loginFrm.password.$touched && loginFrm.password.$error.required}"><label for="inputPassword3" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" required="" name="password" ng-model="password" class="form-control" id="inputPassword" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-9 pull-right"><div class="has-success mr-3px clearfix pull-left"><div class="checkbox"><label class="custom-checkbox has-success"><input ng-model="rememberme" type="checkbox" id="checkboxSuccess" value="option1"> <span>Remember Me</span></label></div></div><button type="submit" ng-click="login()" class="btn btn-default pull-right btn-auth btn-login">Sign in</button></div></div></form></div></main>');
$templateCache.put('app/pages/orders/changeStatusModal.html','<div class="modal fade" id="changeStatusConfirm" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change <strong ng-if="selectedOrderCount==1">{{selectedOrderCount}} order</strong> <strong ng-if="selectedOrderCount>1">{{selectedOrderCount}} orders</strong> status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="updateOrderStatus()">YES</button> <button type="button" class="btn btn-warning" data-dismiss="modal">NO</button></div></div></div></div>');
$templateCache.put('app/pages/orders/orderDetails.html','<style>\r\n  .right-tab > .tab-content{\r\n    max-height: {{popupSizeMin}}px;\r\n    overflow-y: auto;\r\n  }\r\n  #packageModel .panel-body { background: #FFF; }\r\n  #getrate.btn:hover {transform:none;}\r\n  #shippingFrm .form-group label { color:#7d7d7d; font-weight: 600;  }\r\n  #rowRate { padding-top: 10px; }\r\n  #rowDeliveryTime { padding-top: 10px; }\r\n  #packagesrow1 .form-group .control-label { color: #000; }\r\n  .input-group-addon-warning { background-color : #4F6DA2 !important; border-color:#4F6DA2 !important }\r\n  .modal.fade.ng-isolate-scope.testclass.in {z-index: 1150 !important;}\r\n  .rate-modal { z-index: 2000 !important; }\r\n  .rate-modal.modal { left:-250px; right:0; top:20px; bottom:0;  }\r\n  .rate-modal::before { height: 40%;  }\r\n  .rate-modal.modal .modal-dialog .modal-body div { color:#fff; }\r\n</style><div id="orderDetailsModel" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content order-details-model"><div class="modal-body"><uib-tabset active="1" class="right-tab tab-height"><div class="row absolute-500-width"><div class="col-lg-7 col-sm-8 col-xs-11"><img width="50" class="pull-left margin-right-10" height="37" ng-src="assets/img/magento_logo_symbol.png"><div class="internal-tab"><span class="white order-number"><b>Order Number : {{orderId}}</b></span> <span class="label white label-tab pull-right" ng-style="{\'background-color\':orderDetailsData.orderData.statusColor}">{{orderDetailsData.orderData.statusName}}</span></div></div><div ng-if="permissionArr.indexOf(\'pull_job\') !== - 1 && checkStatusForPullJobBtn(orderDetailsData.orderData.statusName)" class="col-lg-4 col-sm-2 col-xs-6"><button type="button" class="btn btn-primary pull-right mt-5px" ng-click="pullJob(orderDetailsData.orderData.status)">Pull Job</button></div></div><button type="button" class="close close-details white" ng-click="closePopup()" aria-label="Close">&times;</button><uib-tab index="1" heading="Order Details"><div class="row vertical-tab right-tab1"><div class="col-md-12 col-lg-12 left-tab-content"><uib-tabset active="0"><uib-tab heading="Info" index="0"><div class="info-content"><div class="row"><div class="col-sm-12 col-md-12 col-lg-4" ng-if="permissionArr.indexOf(\'buyer_info\') !== - 1"><div ba-panel="" ba-panel-title="Buyer / Recipient Info" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-md-12 col-lg-6 order-details-ship-to" ng-if="!editsoldto"><strong>Sold To :</strong><p style="float: right;" ng-if="permissionArr.indexOf(\'change_soldto_address\') !== -1"><a href="javascript:void(0);" ng-click="editSoldTo()" class="btn btn-primary">Edit</a></p><p>{{orderAddress.billing.firstname}} {{orderAddress.billing.lastname}}</p><p>{{orderAddress.billing.company}}</p><p>{{orderAddress.billing.street}}</p><p>{{orderAddress.billing.street2}}</p><p>{{orderAddress.billing.city}} {{orderAddress.billing.region}} {{orderAddress.billing.country_id}} {{orderAddress.billing.postcode}}</p><p>{{orderAddress.billing.telephone}}</p><p><a href="{{orderAddress.billing.email}}" target="_blank">{{orderAddress.billing.email}}</a></p><br><strong>Correct Address :</strong><p style="float: right;" ng-if="permissionArr.indexOf(\'verify_address_smartystreets\') !== -1"><a href="javascript:void(0);" ng-click="OrderSmartyStreetsVerify()" class="btn btn-primary">Verify</a></p></div><div class="col-md-12 col-lg-6 order-details-ship-to" id="editsoldto" ng-if="editsoldto"><form class="form-horizontal" name="soldtoFrm" novalidate="" ng-submit="soldtoFrm.$valid && saveSoldTo()"><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldfirstname" id="soldfirstname" ng-model="soldfirstname" class="form-control" placeholder="First Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldfirstname.$error.required">Please enter first name.</span> <span class="error" ng-show="soldtoFrm.soldfirstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="soldtoFrm.soldfirstname.$error.maxlength && soldtoFrm.soldfirstname.$touched">First Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldlastname" ng-model="soldlastname" class="form-control" placeholder="Last Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldlastname.$error.required">Please enter last name.</span> <span class="error" ng-show="soldtoFrm.soldlastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="soldtoFrm.soldlastname.$error.maxlength && soldtoFrm.soldlastname.$touched">Last Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="soldcompany" id="soldcompany" ng-model="soldcompany" class="form-control" placeholder="Company Name" limit-to="150" ng-maxlength="150" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="soldtoFrm.soldcompany.$error.pattern">Please enter valid company name.</span> <span class="error" ng-show="soldtoFrm.soldcompany.$error.maxlength && soldtoFrm.soldcompany.$touched">Company Name should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="soldaddress" ng-model="soldaddress" class="form-control" placeholder="Address" limit-to="150" ng-maxlength="150" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldaddress.$error.required">Please enter address.</span> <span class="error" ng-show="soldtoFrm.soldaddress.$error.maxlength && soldtoFrm.soldaddress.$touched">Address should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="soldaddress2" ng-model="soldaddress2" class="form-control" placeholder="Address" limit-to="150" ng-maxlength="150"> <span class="error" ng-show="soldtoFrm.soldaddress2.$error.maxlength && soldtoFrm.soldaddress2.$touched">Address should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldcity" id="soldcity" ng-model="soldcity" class="form-control" placeholder="City" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldcity.$error.required">Please enter city.</span> <span class="error" ng-show="soldtoFrm.soldcity.$error.pattern">Please enter valid city name.</span> <span class="error" ng-show="soldtoFrm.soldcity.$error.maxlength && soldtoFrm.soldcity.$touched">City should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldregion" id="soldregion" ng-model="soldregion" class="form-control" placeholder="Region" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldregion.$error.required">Please enter region.</span> <span class="error" ng-show="soldtoFrm.soldregion.$error.pattern">Please enter valid region.</span> <span class="error" ng-show="soldtoFrm.soldregion.$error.maxlength && soldtoFrm.soldregion.$touched">Region should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldpostcode" id="soldpostcode" ng-model="soldpostcode" class="form-control" placeholder="Zip Code" limit-to="5" ng-maxlength="5" ng-pattern="/^[0-9\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldpostcode.$error.required">Please enter zip code.</span> <span class="error" ng-show="soldtoFrm.soldpostcode.$error.pattern">Please enter valid zip code.</span> <span class="error" ng-show="soldtoFrm.soldpostcode.$error.maxlength && soldtoFrm.soldpostcode.$touched">Zip code should not be greater than 5 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldphone" id="soldphone" ng-model="soldphone" class="form-control" placeholder="Telephone"></div><div class="col-md-12 col-sm-12"><button type="button" class="btn btn-warning mr-5" ng-click="cancelSoldTo()">Cancel</button> <button type="submit" class="btn btn-info">Save</button></div></form></div><div class="col-md-12 col-lg-6 order-details-ship-to" ng-if="!editshipto"><strong>Ship To :</strong> <a href="javascript:void(0)" ng-if="permissionArr.indexOf(\'address_log_show\') !== -1" ng-click="openAddressLog()" style="font-size:20px; font-weight: bolder;">+</a> <label class="custom-switch switcher-container" ng-if="show_checkbox && permissionArr.indexOf(\'address_show_checkbox\') !== -1"><input type="checkbox" value="true" id="address_verified" ng-click="CheckAddress()"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <a href="javascript:void(0);" ng-if="permissionArr.indexOf(\'verify_address\') !== -1" ng-click="OrderAddressVerify()" class="btn btn-primary" style="float: right; margin-left: 5px;">Verify</a> <a href="javascript:void(0);" ng-if="permissionArr.indexOf(\'change_shipto_address\') !== -1" ng-click="editShipTo()" style="float: right;" class="btn btn-primary">Edit</a><br><p>{{orderAddress.shipping.firstname}} {{orderAddress.shipping.lastname}}</p><p>{{orderAddress.shipping.company}}</p><p>{{orderAddress.shipping.street}}</p><p>{{orderAddress.shipping.street2}}</p><p>{{orderAddress.shipping.city}} {{orderAddress.shipping.region}} {{orderAddress.shipping.country_id}} {{orderAddress.shipping.postcode}}</p><p>{{orderAddress.shipping.telephone}}</p><p><a href="mailto:{{orderAddress.shipping.email}}" class="text-success">{{orderAddress.shipping.email}}</a></p><p><strong>Address Type: <span id="addresstype"></span></strong> <span style="color:#6ba03a;font-size: 24px;padding-left: 5px;" ng-if="add_business"><i class="fa fa-building-o"></i></span> <span style="color:#6ba03a;font-size: 24px;" ng-if="add_home"><i class="fa fa-home"></i></span><br></p></div><div class="col-md-12 col-lg-6 order-details-ship-to" id="editshipto" ng-if="editshipto"><form class="form-horizontal" name="shiptoFrm" novalidate="" ng-submit="shiptoFrm.$valid && saveShipTo()"><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipfirstname" id="shipfirstname" ng-model="shipfirstname" class="form-control" placeholder="First Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipfirstname.$error.required">Please enter first name.</span> <span class="error" ng-show="shiptoFrm.shipfirstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="shiptoFrm.shipfirstname.$error.maxlength && shiptoFrm.shipfirstname.$touched">First Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shiplastname" ng-model="shiplastname" class="form-control" placeholder="Last Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shiplastname.$error.required">Please enter last name.</span> <span class="error" ng-show="shiptoFrm.shiplastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="shiptoFrm.shiplastname.$error.maxlength && shiptoFrm.shiplastname.$touched">Last Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="shipcompany" id="shipcompany" ng-model="shipcompany" class="form-control" placeholder="Company Name" limit-to="150" ng-maxlength="150" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="shiptoFrm.shipcompany.$error.pattern">Please enter valid company name.</span> <span class="error" ng-show="shiptoFrm.shipcompany.$error.maxlength && shiptoFrm.shipcompany.$touched">Company Name should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="shipaddress" ng-model="shipaddress" class="form-control" placeholder="Address" limit-to="150" ng-maxlength="150" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipaddress.$error.required">Please enter address.</span> <span class="error" ng-show="shiptoFrm.shipaddress.$error.maxlength && shiptoFrm.shipaddress.$touched">Address should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="shipaddress2" ng-model="shipaddress2" class="form-control" placeholder="Address Line 2" limit-to="150" ng-maxlength="150"> <span class="error" ng-show="shiptoFrm.shipaddress2.$error.maxlength && shiptoFrm.shipaddress2.$touched">Address should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipcity" id="shipcity" ng-model="shipcity" class="form-control" placeholder="City" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipcity.$error.required">Please enter city.</span> <span class="error" ng-show="shiptoFrm.shipcity.$error.pattern">Please enter valid city name.</span> <span class="error" ng-show="shiptoFrm.shipcity.$error.maxlength && shiptoFrm.shipcity.$touched">City should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipregion" id="shipregion" ng-model="shipregion" class="form-control" placeholder="Region" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipregion.$error.required">Please enter region.</span> <span class="error" ng-show="shiptoFrm.shipregion.$error.pattern">Please enter valid region.</span> <span class="error" ng-show="shiptoFrm.shipregion.$error.maxlength && shiptoFrm.shipregion.$touched">Region should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shippostcode" id="shippostcode" ng-model="shippostcode" class="form-control" placeholder="Zip Code"> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shippostcode.$error.required">Please enter zip code.</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipcountry" id="shipcountry" ng-model="shipcountry" class="form-control" placeholder="Country Code" limit-to="2" ng-maxlength="2" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipcountry.$error.required">Please enter country code.</span> <span class="error" ng-show="shiptoFrm.shipcountry.$error.pattern">Please enter valid country code.</span> <span class="error" ng-show="shiptoFrm.shipcountry.$error.maxlength && shiptoFrm.shipcountry.$touched">Contry code should not be greater than 2 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipphone" id="shipphone" ng-model="shipphone" class="form-control" placeholder="Telephone" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipphone.$error.required">Please enter telephone number.</span></div><div class="col-md-12 col-sm-12"><button type="button" class="btn btn-warning mr-5" ng-click="cancelShipTo()">Cancel</button> <button type="submit" class="btn btn-info">Save</button></div></form></div></div><div class="row"><div class="col-md-12 col-lg-6 order-details-ship-to" ng-if="!editsoldto"><span id="addresschangedgreen" style="color:#6ba03a;font-weight:bolder;font-size:16px;"></span> <span id="addresschangedyellow" style="color:#fdd602;font-weight:bolder;font-size:16px;"></span> <span id="addresschangedred" style="color:#ff0000;font-weight:bolder;font-size:16px;"></span></div><div class="col-md-12 col-lg-6 order-details-ship-to" ng-if="!editshipto"><span id="verified" style="display:none;color:#6ba03a;font-weight:bolder;font-size:16px;">Fedex Address Verified<br></span> <span id="warnings" style="display:none;color:#fdd602; font-weight:bold;font-size:16px;"></span> <span id="addresserror" style="display:none;color:#ff0000;font-weight:bolder;font-size:16px;"></span></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-4" ng-if="permissionArr.indexOf(\'order_summary_info\') !== - 1"><div ba-panel="" ba-panel-title="Order Summary" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-sm-6 buyer-title">Order Number :</div><div class="col-sm-6 pull-right text-right"><p>{{orderDetailsData.orderData.increment_id}}</p></div></div><div class="row"><div class="col-sm-7 buyer-title">Number of Products in Order :</div><div class="col-sm-5 pull-right text-right"><p>{{orderQuantity}}</p></div></div><div class="row"><div class="col-sm-6 buyer-title">Order Date :</div><div class="col-sm-6 pull-right text-right"><p>{{getGlobalDateFormat(orderDate)}}</p></div></div><div class="row"><div class="col-sm-6 buyer-title">Total Qty :</div><div class="col-sm-6 pull-right text-right"><p>{{totalQuantity}}</p></div></div><div class="row"><div class="col-sm-6 buyer-title">Order Price :</div><div class="col-sm-6 pull-right text-right"><p>{{renderWithDollar(grandTotal)}}</p></div></div><div class="row" ng-if="orderDetailsData.orderData.created_at_old && orderDetailsData.orderData.created_at_old !== \'\'"><div class="col-sm-6 buyer-title">Old Order Date :</div><div class="col-sm-6 pull-right text-right"><p>{{getGlobalDateFormat(orderDetailsData.orderData.created_at_old)}}</p></div></div><div class="row"><i class="fa fa-history fa-lg cursor-pointer" title="View change date log" style="float: right; margin-left: 5px; padding-right: 10px; padding-top: 10px;" ng-click="openChangeOrderDateLogDialog(orderDetailsData.orderData.increment_id)" ng-if="permissionArr.indexOf(\'change_order_date_log_button\') !== -1"></i> <button type="button" class="btn btn-info" style="float: right; margin-right: 10px;" ng-if="permissionArr.indexOf(\'change_order_date_button\') !== -1 && showChangeOrderDateButtons(\'Change Date\', orderDetailsData.orderData.statusName, \'change_order_date_button\') && !orderDetailsData.orderData.created_at_is_changed && orderDetailsData.orderData.created_at_is_changed != \'enable\'" ng-click="openChangeOrderDatePopUp(orderId)">Change Date</button> <button type="button" class="btn btn-info" style="float: right; margin-right: 10px;" ng-if="permissionArr.indexOf(\'change_order_date_button_two\') !== -1 && showChangeOrderDateButtons(\'Change Date 2\', orderDetailsData.orderData.statusName, \'change_order_date_button_two\') && orderDetailsData.orderData.created_at_is_changed && orderDetailsData.orderData.created_at_is_changed == \'enable\'" ng-click="openChangeOrderDatePopUp(orderId)">Change Date 2</button></div></div></div><div class="col-sm-12 col-md-12 col-lg-4" ng-if="permissionArr.indexOf(\'user_time_info\') !== - 1"><div ba-panel="" ba-panel-title="User <p class=\'pull-right\' style=\'margin-right:15px\'>Time</p>" ba-panel-class="xsmall-panel light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-sm-8 buyer-title">Design Total Time :</div><div class="col-sm-4 pull-right text-right"><p>{{getHours(designTime)}}</p></div></div><div class="row"><div class="col-sm-8 buyer-title">QA Approve Total Time :</div><div class="col-sm-4 pull-right text-right"><p>{{getHours(qaTime)}}</p></div></div><div class="row"><div class="col-sm-7 buyer-title">Order In Production Scan Date :</div><div class="col-sm-5 pull-right text-right"><p ng-if="orderDetailsData.orderData.orderinproductiontime">{{getGlobalDateFormat(orderDetailsData.orderData.orderinproductiontime)}}</p><p ng-if="!orderDetailsData.orderData.orderinproductiontime">N/A</p></div></div><div class="row"><div class="col-sm-7 buyer-title">Order Printed Scan Date :</div><div class="col-sm-5 pull-right text-right"><p ng-if="orderDetailsData.orderData.orderpritedtime">{{getGlobalDateFormat(orderDetailsData.orderData.orderpritedtime)}}</p><p ng-if="!orderDetailsData.orderData.orderpritedtime">N/A</p></div></div><div class="row"><div class="col-sm-7 buyer-title">Ready To Ship Date :</div><div class="col-sm-5 pull-right text-right"><p ng-if="orderDetailsData.orderData.readytoshiptime">{{getGlobalDateFormat(orderDetailsData.orderData.readytoshiptime)}}</p><p ng-if="!orderDetailsData.orderData.readytoshiptime">N/A</p></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12 col-lg-4" ng-if="permissionArr.indexOf(\'tracking_info\') !== - 1"><div ba-panel="" ba-panel-title="Tracking" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-sm-5 buyer-title">Date Shipped :</div><div class="col-sm-7 pull-right text-right"><p ng-if="shippedDate">{{getGlobalDateFormat(shippedDate)}}</p><p ng-if="!shippedDate">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Requested Method:</div><div class="col-sm-7 pull-right text-right"><p ng-if="shippedMethodName">{{shippedMethodName}}</p><p ng-if="!shippedMethodName">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Shipping Cost :</div><div class="col-sm-7 pull-right text-right"><p ng-if="shippedAmount">${{shippedAmount}}</p><p ng-if="!shippedAmount">$0</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Shipment Date :</div><div class="col-sm-7 pull-right text-right"><p ng-if="shipmentDate">{{getGlobalDateFormat(shipmentDate)}}</p><p ng-if="!shipmentDate">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Shipment Method :</div><div class="col-sm-7 pull-right text-right"><p ng-if="shipmentMethodName">{{shipmentMethodName}}</p><p ng-if="!shipmentMethodName">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Shipment Tracking Number:</div><div class="col-sm-7 pull-right text-right"><p ng-if="shipmentTrackerNumber.length>0"><a href="{{shipmentTrackerUrl}}" target="_blank">{{shipmentTrackerNumber}}</a></p><p ng-if="shipmentTrackerNumber.length<=0">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Shipment Number :</div><div class="col-sm-7 pull-right text-right"><p ng-if="ShipmentNumber"><a class="btn btn-link" ng-click="gotoShipment($event)" aria-label="{{ShipmentNumber}}">{{ShipmentNumber}}</a></p><p ng-if="!ShipmentNumber">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Shipment Cost :</div><div class="col-sm-7 pull-right text-right"><p ng-if="shipmentAmount">${{shipmentAmount}}</p><p ng-if="!shipmentAmount">$0</p></div></div><div class="row"><div class="col-sm-2"><button type="button" class="btn btn-danger" ng-if="orderDetailsData.orderData.magento_status!=\'success\'" ng-click="resendToMagento()"><i class="fa fa-shopping-cart"></i></button> <button type="button" class="btn btn-success" ng-if="orderDetailsData.orderData.magento_status==\'success\'"><i class="fa fa-shopping-cart"></i></button></div><div class="col-sm-4"><button type="button" class="btn btn-danger" ng-if="orderDetailsData.orderData.amazon_account == 1 && shipment_voided != 1 && amazon_shipment_id !=\'\'" ng-click="voidAmazonShipment($event,amazon_shipment_id)">Void Shipment</button></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-4" ng-if="permissionArr.indexOf(\'shipment_comments\') !== -1"><div ba-panel="" ba-panel-title="Shipment Instructions" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-md-6"></div><div class="col-md-4 text-right" ng-if="orderCommentDataArr.length > 0"><span class="">Check Instructions</span></div><div class="col-md-2 text-right" ng-if="permissionArr.indexOf(\'shipment_comment_chk\') !== -1 && orderCommentDataArr.length > 0"><label class="custom-switch switcher-container"><input type="checkbox" value="true" id="chk" ng-click="showCreateLabel($event)"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="col-md-12"><div class="form-group clearfix"><textarea rows="2" name="ordercomment" class="comment form-control bg-white" placeholder="Comment"></textarea> <span class="error hide-element">Required!</span></div></div><div class="col-md-12"><button type="button" ng-click="commentShipmentOrder($event)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Comment</button></div></div><div class="row"><div class="horizontal-scroll" ng-if="orderCommentDataArr.length > 0"><div class="col-md-12" style="padding-bottom:5px"><table class="table table-bordered table-align mt-5px"><thead><tr><th>Date | Time</th><th>User Name</th><th>Comment</th></tr></thead><tbody><tr ng-repeat="com in orderCommentDataArr"><td>{{getGlobalDateFormat(com.created_at)}}</td><td>{{com.username}}</td><td><div style="width:110px;overflow:hidden" title="{{com.comment}}">{{com.comment}}</div></td></tr></tbody></table></div></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-4" ng-if="permissionArr.indexOf(\'relay_info\') !== - 1"><div ba-panel="" ba-panel-title="Relay" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div ng-init="enableRelaySettings=true"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">Job Service</div><select id="jobService" class="form-control job-service disable-opacity-info" value="{{orderDetailsData.orderData.job_service}}" name="jobService" ng-disabled="enableRelaySettings"><option value="">Select Job Service</option><option value="{{job.value}}" ng-selected="job.set_default==\'1\' || job.value==orderDetailsData.orderData.job_service" ng-repeat="job in jobService">{{job.label}}</option></select></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">Priority</div><select id="priority" class="form-control priority disable-opacity-info" value="{{orderDetailsData.orderData.priority}}" name="priority" ng-disabled="enableRelaySettings"><option value="">Select Priority</option><option value="{{prty.hours}}" ng-selected="prty.hours==orderDetailsData.orderData.priority" ng-repeat="prty in priority">{{prty.name}}</option></select></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">Uploaded Time</div><input type="text" readonly="" value="{{getGlobalDateFormat(orderDetailsData.orderData.relay_job_done)}}" name="uploaded" placeholder="Uploaded Time" class="form-control"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">User Name</div><input type="text" readonly="" value="{{orderDetailsData.orderData.relay_created_by}}" name="relayUserName" placeholder="User Name" class="form-control"></div></div></div><div class="row"><div class="col-md-12 col-sm-6">{{item.is_relay}} <button ng-if="permissionArr.indexOf(\'relay_upload_manually\') !== - 1 && orderDetailsData.orderData.is_relay!=\'enable\'" type="button" class="btn btn-info mr-5" ng-disabled="enableRelaySettings" ng-click="saveFullRelaySettings($event,orderDetailsData.orderData.entity_id)">Upload Manually</button> <button ng-show="permissionArr.indexOf(\'relay_edit_settings\') !== - 1 && orderDetailsData.orderData.is_relay!=\'enable\'" type="button" class="btn btn-info" ng-click="enableRelaySettings=false;killOrderDetailsTimer()">Edit Settings</button></div></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-8 col-lg-8"><div class="row"><div class="col-sm-12 col-md-12 col-lg-6" ng-if="showInfoTabReworkBtn(orderDetailsData.orderData.status,\'rework_info\')"><div ba-panel="" ba-panel-title="Rework" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-sm-5 buyer-title">Rework Whole Order :</div><div class="col-sm-7 pull-right text-right"><button type="button" ng-click=\'openRework("orderRework",orderCustomerId)\' class="btn btn-danger btn-with-icon" ng-disabled="orderDetailsData.orderData.is_reworked==\'enable\'"><i class="fa fa-wrench"></i>Rework</button></div></div></div></div><div class="col-md-12 col-lg-6" ng-if="permissionArr.indexOf(\'delivery_info\') !== - 1"><div ba-panel="" ba-panel-title="Delivery Date" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-sm-5 buyer-title">Ship By:</div><div class="col-sm-7 pull-right text-right"><p ng-if="shipped_by">{{getDateFormated(shipped_by)}}</p><p ng-if="!shipped_by">N/A</p></div></div><div class="row"><div class="col-sm-5 buyer-title">Delivery By:</div><div class="col-sm-7 pull-right text-right"><p ng-if="delivered_by">{{getDateFormated(delivered_by)}}</p><p ng-if="!delivered_by">N/A</p></div></div><div class="row"><div class="col-sm-12 pull-right text-right">&nbsp;</div></div><div class="row" ng-if="permissionArr.indexOf(\'bug_report_popup\') !== - 1"><div class="col-sm-12 pull-right text-right"><button type="button" ng-click="openBugReport()" class="btn btn-danger btn-with-icon"><i class="fa fa-wrench"></i>Bug Report</button></div></div></div></div></div></div><div class="col-sm-12 col-md-4 col-lg-4"><div class="row" ng-if="orderDetailsData.orderData.amazon_account == 0"><div class="col-md-12 col-lg-12" id="regular_shipping_scan" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && show_shipping_tag == 0 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 0"><div ba-panel="" ba-panel-title="Regular Shipping Info"><div class="row"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Create Shipment</label></div><div class="col-md-8 col-lg-8"><span class="text-success" style="font-size: 20px; font-weight: bolder;"></span>&nbsp; <button type="button" ng-click="openOrderScan(orderDetailsData.orderData.entity_id,orderDetailsData.orderData.store_id)" class="btn btn-primary">Create Shipment <i class="fa fa-barcode"></i></button></div></div></div></div><div class="col-md-12 col-lg-12" id="regular_new_shipping_info" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && show_shipping_tag == 1 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 0 && show_new_shipping == 1"><div ba-panel="" ba-panel-title="Regular New Shipping Info"><input type="hideen" name="entity_id" id="entity_id" value="{{ orderDetailsData.orderData.entity_id }}" style="display: none;"><div class="row"><div class="col-sm-4 buyer-title">Requested Method:</div><div class="col-sm-4 pull-center text-center"><span ng-if="shippedMethodName" style="font-size:20px; font-weight: bold;color:#e85656;">{{shippedMethodName}}</span></div><div class="col-sm-4">&nbsp;</div></div><div class="row"><label class="custom-switch switcher-container" ng-if="permissionArr.indexOf(\'switch_regular_new_shipping\') !== -1 && orderDetailsData.orderData.is_amazon_store == 0" style="float: right;"><input type="checkbox" value="false" id="switch_regular_new_shipping" ng-model="switch_regular_new_shipping" ng-click="switchNewShipping($event,\'old\')"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="row" id="rowWeight"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Weight</label></div><div class="col-md-8 col-lg-8"><div class="col-md-6 pull-left" style="padding:0px"><input type="number" class="form-control" name="weight_lbs" id="weight_lbs" placeholder="lb" value="{{ total_weight }}"></div><div class="col-md-6" style="padding-left:2px;padding-right:2px"><input type="number" class="form-control" name="weight_oz" id="weight_oz" placeholder="oz" value=""></div></div></div><div class="row" id="rowPackage"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Package</label></div><div class="col-md-7 col-lg-7"><select class="form-control" ng-if="custom_packages <= 1" name="package" id="package" placeholder="Please Select" ng-model="package" ng-change="changeShippingPackageType(package)"><option value="">Please Select</option><option ng-repeat="box in ShipmentBoxes" value="{{box.id}}">{{box.name}}</option></select></div></div><div class="row" id="rowFedExPackage"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Fedex Package</label></div><div class="col-md-7 col-lg-7"><select class="form-control" ng-if="ShipmentServiceBoxes.length > 0" name="fedexpackage" id="fedexpackage" placeholder="Please Select" ng-model="fedexpackage"><option value="">Please Select</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}-{{sbox.service_box_id}}">{{sbox.service_box_label}}</option></select></div></div><div class="row" id="rowSize"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Size</label></div><div class="col-md-8 col-lg-8"><div class="col-md-4 pull-left" style="padding:0px"><input type="number" class="form-control" placeholder="L" name="len" id="len" value=""></div><div class="col-md-4" style=""><input type="number" class="form-control" placeholder="W" name="wgh" id="wgh" value=""></div><div class="col-md-4 pull-right" style="padding:0px"><input type="number" class="form-control" placeholder="H" name="hgt" id="hgt" value=""></div></div></div><div class="row datepicker" id="rowShipDate"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Ship Date</label></div><div class="col-md-8 col-lg-8"><input type="text" name="shipDate" id="shipDate" class="form-control" uib-datepicker-popup="{{format}}" ng-model="dt" is-open="popup1.opened" datepicker-options="shipoptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><button type="button" class="btn btn-default" ng-click="open1()">Ship Date</button></span></div></div><div class="row" ng-if="permissionArr.indexOf(\'fedex_signature_options_new\') !== -1"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Signature Required</label></div><div class="col-md-7 col-lg-7" style="margin-top:5px;"><label class="custom-switch switcher-container"><input type="checkbox" value="false" id="switch_fedex_signature" ng-model="switch_fedex_signature" ng-click="switchFedexSignature($event)"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div></div><div class="row" id="rowRate"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Rate</label></div><div class="col-md-8 col-lg-8"><span class="text-success" id="displayRate" style="font-size: 20px; font-weight: bolder;"></span>&nbsp; <button type="button" ng-if="permissionArr.indexOf(\'get_rate\') !== - 1" ng-click="getRateNew()" id="getrate" class="btn btn-primary">Get Rate <i class="fa fa-refresh"></i></button></div></div></div></div><div class="col-md-12 col-lg-12" id="regular_old_shipping_info" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && show_shipping_tag == 1 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 0 && show_new_shipping == 0"><div ba-panel="" ba-panel-title="Regular Old Shipping Info"><input type="hideen" name="entity_id" id="entity_id" value="{{ orderDetailsData.orderData.entity_id }}" style="display: none;"><div class="row"><div class="col-sm-4 buyer-title">Requested Method:</div><div class="col-sm-4 pull-center text-center"><span ng-if="shippedMethodName" style="font-size:20px; font-weight: bold;color:#e85656;">{{shippedMethodName}}</span></div><div class="col-sm-4">&nbsp;</div></div><div class="row"><label class="custom-switch switcher-container" ng-if="permissionArr.indexOf(\'switch_regular_new_shipping\') !== -1 && orderDetailsData.orderData.is_amazon_store == 0" style="float: right;"><input type="checkbox" value="true" id="switch_regular_old_shipping" ng-model="switch_regular_old_shipping" ng-click="switchNewShipping($event,\'new\')"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="row"><label class="custom-switch switcher-container" ng-if="permissionArr.indexOf(\'switch_amazon_shipping\') !== -1 && orderDetailsData.orderData.is_amazon_store == 1" style="float: right;"><input type="checkbox" value="false" id="switch_regular_shipping" ng-model="switch_regular_shipping" ng-click="switchAmazonShipping($event,\'regular\')"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="row" id="rowWeight"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Weight</label></div><div class="col-md-8 col-lg-8"><div class="col-md-6 pull-left" style="padding:0px"><input type="number" class="form-control" name="weight_lbs" id="weight_lbs" placeholder="lb" value="{{ total_weight }}"></div><div class="col-md-6" style="padding-left:2px;padding-right:2px"><input type="number" class="form-control" name="weight_oz" id="weight_oz" placeholder="oz" value=""></div></div></div><div class="row" id="rowService"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Service</label></div><div class="col-md-8 col-lg-8"><select class="form-control" name="service" id="service" placeholder="Please Select" ng-model="shippingservice" ng-change="changeShippingService(shippingservice)"><option value="">Please Select</option><option value="fedex" selected="">Fedex</option><option value="usps">USPS</option><option value="ups">UPS</option><option value="office">Office</option></select></div></div><div class="row" id="rowAccounts"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Accounts</label></div><div class="col-md-8 col-lg-8"><select class="form-control" name="account" id="account" placeholder="Please Select" ng-model="account" ng-change="changeShippingAccount(account)"><option value="">Please Select</option><option ng-if="ShipmentAccounts.length == 1" ng-repeat="acc in ShipmentAccounts" value="{{acc.account_id}}" ng-selected="{{ defaultAccount }}">{{acc.account_company_name}}</option><option ng-if="ShipmentAccounts.length > 1" ng-repeat="acc in ShipmentAccounts" value="{{acc.account_id}}">{{acc.account_company_name}}</option></select></div></div><div class="row" id="rowServiceType"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Type</label></div><div class="col-md-8 col-lg-8"><select class="form-control" name="service_type" id="service_type" placeholder="Please Select" ng-model="shippingservicetype" ng-change="changeShippingServiceType(shippingservicetype)"><option value="">Please Select</option><option ng-repeat="data in orderServiceType" value="{{ data.code }}">{{ data.label }}</option></select></div></div><div class="row" id="rowPackage"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Package</label></div><div class="col-md-7 col-lg-7"><select class="form-control" ng-if="custom_packages <= 1" name="package" id="package" placeholder="Please Select" ng-model="package" ng-change="changeShippingPackageType(package)"><option value="">Please Select</option><option ng-repeat="box in ShipmentBoxes" value="{{box.id}}">{{box.name}}</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}">{{sbox.service_box_label}}</option></select><select class="form-control" ng-if="custom_packages > 1" name="package1" id="package1" placeholder="Please Select" ng-model="package1" ng-change="changeShippingPackageType(package1)"><option value="">Please Select</option><option ng-if="shippingservice == \'fedex\'" value="YOUR_PACKAGING">Custom Box</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}">{{sbox.service_box_label}}</option></select></div><div class="col-md-1 col-lg-1" style="padding-top: 10px"><a href="javascript:void(0)" ng-if="shippingservice != \'usps\'" ng-click="openPackageCreate()" style="font-size:20px; font-weight: bolder;">+</a></div></div><div class="row" id="custompackagecount" ng-if="custom_packages > 1"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Custom Packages</label></div><div class="col-md-8 col-lg-8" style="padding-top:10px">{{custom_packages}}</div></div><div class="row" id="rowSize"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Size</label></div><div class="col-md-8 col-lg-8"><div class="col-md-4 pull-left" style="padding:0px"><input type="number" class="form-control" placeholder="L" name="len" id="len" value=""></div><div class="col-md-4" style=""><input type="number" class="form-control" placeholder="W" name="wgh" id="wgh" value=""></div><div class="col-md-4 pull-right" style="padding:0px"><input type="number" class="form-control" placeholder="H" name="hgt" id="hgt" value=""></div></div></div><div class="row datepicker" id="rowShipDate"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Ship Date</label></div><div class="col-md-8 col-lg-8"><input type="text" name="shipDate" id="shipDate" class="form-control" uib-datepicker-popup="{{format}}" ng-model="dt" is-open="popup1.opened" datepicker-options="shipoptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><button type="button" class="btn btn-default" ng-click="open1()">Ship Date</button></span></div></div><div class="row" id="rowShipDate" ng-if="permissionArr.indexOf(\'fedex_signature_options\') !== -1 && shippingservice == \'fedex\'"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Signature Required</label></div><div class="col-md-7 col-lg-7" style="margin-top:5px;"><label class="custom-switch switcher-container"><input type="checkbox" value="false" id="switch_fedex_signature" ng-model="switch_fedex_signature" ng-click="switchFedexSignature($event)"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div></div><div class="row" id="rowSignatureOptions" ng-if="permissionArr.indexOf(\'fedex_signature_options\') !== -1 && shippingservice == \'fedex\'" style="display: none;"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Signature Options</label></div><div class="col-md-7 col-lg-7" style="margin-top:5px;"><select class="form-control" name="signature_option" id="signature_option" placeholder="Please Select" ng-model="signature_option"><option value="">Please Select</option><option value="ADULT">Adult</option><option value="DIRECT">Direct</option><option value="INDIRECT">Indirect</option><option value="SERVICE_DEFAULT">Service Default</option></select></div></div><div class="row" id="rowRate"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Rate</label></div><div class="col-md-8 col-lg-8"><span class="text-success" id="displayRate" style="font-size: 20px; font-weight: bolder;"></span>&nbsp; <button type="button" ng-if="permissionArr.indexOf(\'get_rate\') !== - 1" ng-click="getRate()" id="getrate" class="btn btn-primary">Get Rate <i class="fa fa-refresh"></i></button> <button type="button" id="btncreatelabel" class="btn btn-sm btn-ship btn-success" ng-if="permissionArr.indexOf(\'create_label\') !== -1 && address_verified && orderCommentDataArr.length == 0" ng-click="createLabel()" ng-disabled="getRateDone">Create Label <i class="fa fa-bolt"></i></button> <button type="button" id="btncreatelabel" class="btn btn-sm btn-ship btn-success hide-element" ng-if="permissionArr.indexOf(\'create_label\') !== -1 && orderCommentDataArr.length > 0" ng-click="createLabel()" ng-disabled="getRateDone">Create Label <i class="fa fa-bolt"></i></button></div></div><div class="row" id="rowDeliveryTime"><div class="col-md-3 col-lg-3"><label class="pull-left">Delivery Time</label></div><div class="col-md-8 col-lg-8"><span class="shipping-deliv-time" id="displayDays" style="font-size: 20px; font-weight: bolder;"></span></div></div><div class="row" id="rowCreateLable"><div class="col-md-3 col-lg-3" style="padding:10px"></div><div class="col-md-8 col-lg-8"><span id="downloadlabelpdf"></span></div></div><div class="row" id="rowSatDel"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Saturday Delivery</label></div><div class="col-md-8 col-lg-8"><input type="checkbox" name="satdelivery" id="satdelivery" ng-model="satdel" ng-click="getRateCheck()" value="saturday">Saturday Delivery</div></div><div class="row" id="rowOffice" style="display: none;"><div class="col-md-3 col-lg-3" style="padding:10px"></div><div class="col-md-8 col-lg-8"><span class="text-success" style="font-size: 20px; font-weight: bolder;"></span> <button type="button" ng-click="createShipment()" id="createshipment" class="btn btn-success">Create Shipment <i class="fa fa-refresh"></i></button></div></div></div></div></div><div class="row" ng-if="orderDetailsData.orderData.amazon_account == 1"><div class="col-sm-12 col-md-12 col-lg-12" id="amazon_shipping_scan" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && show_shipping_tag == 0 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 1"><div ba-panel="" ba-panel-title="Amazon Shipping Info"><div class="row"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Create Amazon Shipment</label></div><div class="col-md-8 col-lg-8"><span class="text-success" style="font-size: 20px; font-weight: bolder;"></span>&nbsp; <button type="button" ng-click="openOrderScan(orderDetailsData.orderData.entity_id,orderDetailsData.orderData.store_id)" class="btn btn-primary">Create Amazon Shipment <i class="fa fa-barcode"></i></button></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-12" id="amazon_shipping_info" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && show_shipping_tag == 1 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 1"><div ba-panel="" ba-panel-title="Amazon Shipping Info"><input type="hideen" name="entity_id" id="entity_id" value="{{ orderDetailsData.orderData.entity_id }}" style="display: none;"><div class="row"><div class="col-sm-4 buyer-title">Requested Method:</div><div class="col-sm-4 pull-center text-center"><span ng-if="shippedMethodName" style="font-size:20px; font-weight: bold; color:#e85656;">{{shippedMethodName}}</span></div><div class="col-sm-4">&nbsp;</div></div><div class="row"><label class="custom-switch switcher-container" ng-if="permissionArr.indexOf(\'switch_amazon_shipping\') !== -1 && orderDetailsData.orderData.is_amazon_store == 1" style="float: right;"><input type="checkbox" value="false" id="switch_amazon_shipping" ng-model="switch_amazon_shipping" ng-click="switchAmazonShipping($event,\'amazon\')"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="row"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Ship By</label></div><div class="col-md-8 col-lg-8" style="padding-top:10px">{{getDateFormated(shipped_by)}}</div></div><div class="row"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Weight</label></div><div class="col-md-8 col-lg-8"><div class="col-md-6 pull-left" style="padding:0px"><input type="number" class="form-control" name="weight_lbs" id="weight_lbs" placeholder="lb" value="{{ total_weight }}"></div><div class="col-md-6" style="padding-left:2px;padding-right:2px"><input type="number" class="form-control" name="weight_oz" id="weight_oz" placeholder="oz" value=""></div></div></div><div class="row"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Package</label></div><div class="col-md-7 col-lg-7"><select class="form-control" name="package" id="package" placeholder="Please Select" ng-model="package" ng-change="changeAmazonBox(package)"><option value="">Please Select</option><option ng-repeat="box in ShipmentBoxes" value="{{box.id}}">{{box.name}}</option></select></div></div><div class="row datepicker"><div class="col-md-3 col-lg-3" style="padding:10px"><label for="deliveryDate" class="pull-left">Delivery Date</label></div><div class="col-md-8 col-lg-8"><input type="text" name="deliveryDate" id="deliveryDate" class="form-control" uib-datepicker-popup="{{format}}" ng-model="dt" is-open="popup1.opened" datepicker-options="shipoptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><button type="button" class="btn btn-default" ng-click="open1()">Delivery Date</button></span></div></div><div class="row" ng-if="permissionArr.indexOf(\'switch_amazon_signature\') !== - 1"><div class="col-md-3 col-lg-3" style="padding:10px;"><label class="pull-left">Signature Required</label></div><div class="col-md-7 col-lg-7" style="margin-top:5px;"><label class="custom-switch switcher-container"><input type="checkbox" value="false" id="switch_amazon_signature" ng-click="switchAmazonSignature($event)"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div></div><div class="row"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Rate</label></div><div class="col-md-8 col-lg-8"><span class="text-success" id="displayAmazonRate" style="font-size: 20px; font-weight: bolder;"></span>&nbsp; <button type="button" ng-if="permissionArr.indexOf(\'get_rate\') !== - 1" ng-click="getAmazonRate()" id="getamazonrate" class="btn btn-primary">Get Rate <i class="fa fa-refresh"></i></button></div></div></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 1 && amazonServices.length > 0"><div ba-panel="" ba-panel-title="Amazon Shipping Rates" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><table id="amazon_available_services" width="100%"><tr><th width="5%">&nbsp;</th><th width="25%" style="text-align: center;">Service</th><th width="15%" style="text-align: center;">Delivery Date</th><th width="15%" style="text-align: center;">Rate</th><th width="20%">&nbsp;</th><th style="text-align: center;">Action</th></tr><tr ng-repeat="acc in amazonServices"><td width="5%" style="text-align: center;"><div ng-if="acc.carrier_name == \'FEDEX\'"><img src="https://3dtrk.com/3dtracker/public/Images/fedex.jpg"></div><div ng-if="acc.carrier_name == \'USPS\'"><img src="https://3dtrk.com/3dtracker/public/Images/usps.jpg"></div><div ng-if="acc.carrier_name == \'UPS\'"><img src="https://3dtrk.com/3dtracker/public/Images/ups.png"></div></td><td width="25%" style="text-align: left; font-weight: bold;font-size: 18px;">{{ acc.shipping_service_name}}</td><td width="15%" style="text-align: center;font-weight: bold;font-size: 18px;">{{getDateFormated(acc.latest_estimated_delivery_date)}}</td><td width="15%" style="text-align: center;font-weight: bold;font-size: 18px;">{{ acc.rate }}</td><td width="20%">&nbsp;</td><td style="text-align: center;"><button type="button" ng-if="orderDetailsData.orderData.shipment_popup_show ==\'true\'" class="btn btn-sm btn-ship btn-success ng-scope" style="margin-bottom: 5px;" ng-click="createAmazonLabel(acc.carrier_name, acc.shipping_service_name, acc.shipping_service_id, acc.shipping_service_offer_id)">Create Label</button> <button type="button" ng-if="orderDetailsData.orderData.shipment_popup_show !=\'true\'" class="btn btn-sm btn-ship btn-success ng-scope" style="margin-bottom: 5px;" ng-click="getAmazonShipment(acc.carrier_name, acc.shipping_service_name, acc.shipping_service_id, acc.shipping_service_offer_id)">Create Label</button></td></tr></table></div></div><div class="col-md-12 col-lg-12" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1 && customerStatus.indexOf(orderDetailsData.orderData.status) !== - 1 && orderDetailsData.orderData.amazon_account == 0 && allShipmentServices.length > 0"><div ba-panel="" ba-panel-title="Shipping Rates" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><table id="all_available_services" width="100%"><tr><th width="5%" style="text-align: center;">&nbsp;</th><th width="20%" style="text-align: center;">Service</th><th width="15%" style="text-align: center;">Box</th><th width="15%" style="text-align: center;">Delivery Date</th><th width="15%" style="text-align: center;">Account Name</th><th width="15%" style="text-align: center;">Rate</th><th width="15%" style="text-align: center;">Action</th></tr><tr ng-repeat="acc in allShipmentServices"><td width="5%" style="text-align: center;"><div ng-if="acc.carrier_name == \'FEDEX\'"><img src="https://3dtrk.com/3dtracker/public/Images/fedex.jpg"></div><div ng-if="acc.carrier_name == \'USPS\'"><img src="https://3dtrk.com/3dtracker/public/Images/usps.jpg"></div><div ng-if="acc.carrier_name == \'UPS\'"><img src="https://3dtrk.com/3dtracker/public/Images/ups.png"></div></td><td width="20%" style="text-align: left; font-weight: bold;font-size: 18px;">{{ acc.shipping_service_name}}</td><td width="15%" style="text-align: left; font-weight: bold;font-size: 18px;">{{ acc.box}}</td><td width="15%" style="text-align: center;font-weight: bold;font-size: 18px;">{{getDateFormated(acc.latest_estimated_delivery_date)}}</td><td width="15%" style="text-align: center;font-weight: bold;font-size: 18px;">{{ acc.account_name }}</td><td width="15%" style="text-align: center;font-weight: bold;font-size: 18px;">{{ acc.rate }}</td><td width="15%" style="text-align: center;"><button type="button" ng-click="createLabelNew(acc.account,acc.service,acc.service_code,acc.saturday, acc.one_rate);" class="btn btn-sm btn-ship btn-success ng-scope" style="margin-bottom:5px;">Create Label</button></td></tr></table></div></div></div></div></uib-tab><uib-tab heading="{{getSortOrderNumber(item.item_increment_id)}}" class="tab-{{item.item_increment_id}}" select="tabSelected(item.item_increment_id)" ng-repeat="item in orderDetailsData.items track by item.item_increment_id"><style>\r\n                      .tab-{{item.item_increment_id}} a {\r\n                        background-color: {{item.item_status_Color}};\r\n                        color:white !important;\r\n                      }\r\n                    </style><div ng-if="item.item_increment_id == selectedId"><uib-tabset class="tabs-right" active="0"><uib-tab index="$index" heading="{{getSortOrderNumber(qtyItem.prod_qty_id)}}" ng-if="item.quantityList.length > 0" select="subTabSelected(qtyItem.prod_qty_id)" class="sub-tab-{{qtyItem.prod_qty_id}}" style="width:73px;" ng-repeat="qtyItem in item.quantityList track by $index"><style>\r\n                            .sub-tab-{{qtyItem.prod_qty_id}} a {\r\n                              background-color: {{qtyItem.color_code}};\r\n                              color:white !important;\r\n                            }\r\n                          </style><div ng-if="qtyItem.prod_qty_id == selectedQtyId"><div ng-init="subIndex = $index" ng-include="\'app/pages/orders/orderDetailsSingleItem.html\'"></div></div></uib-tab><uib-tab index="0" heading="{{getSortOrderNumber(item.item_increment_id)}}_1" class="sub-tab-{{item.item_increment_id}} single-right-tab" style="width:73px;" ng-if="item.quantityList.length == 0"><div ng-init="subIndex = 0" ng-include="\'app/pages/orders/orderDetailsSingleItem.html\'"></div></uib-tab></uib-tabset></div></uib-tab></uib-tabset></div></div></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><style>\r\n  .log-modal-height.modal-body{\r\n    max-height: {{borderSize}}px;\r\n    overflow-y: auto;\r\n  }\r\n</style><div id="orderLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Order Logs</span> <button type="button" class="close" ng-click="closeOrderLogs()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Item Status</th><th class="nStatus">New Item Status</th><th class="date">Date</th><th class="date">Action Type</th><th class="date">Transition Type</th></tr></thead><tbody><tr ng-repeat="data in orderLogsArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{data.old_status}}</td><td class="nStatus">{{data.new_status}}</td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td><td><span ng-if="data.action_type">{{data.action_type}}</span> <span ng-if="!data.action_type">--</span></td><td>{{data.transition_type?data.transition_type:\'-\'}}</td></tr><tr ng-if="!orderLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="ItemJobModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Item Job</span> <button type="button" class="close" ng-click="closeItemJob()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!ItemJobLoaded">Loading....</div><div ng-if="ItemJobLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Item Status</th><th class="nStatus">New Item Status</th><th class="date">Date</th><th class="date">Action Type</th><th class="date">Transition Type</th></tr></thead><tbody><tr ng-repeat="data in itemJobArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{data.old_status}}</td><td class="nStatus">{{data.new_status}}</td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td><td><span ng-if="data.action_type">{{data.action_type}}</span> <span ng-if="!data.action_type">--</span></td><td>{{data.transition_type?data.transition_type:\'-\'}}</td></tr><tr ng-if="!itemJobArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="productLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Product Name Log</span> <button type="button" class="close" ng-click="closeProductLogModal()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Value</th><th class="nStatus">New Value</th><th class="date">Date | Time</th></tr></thead><tbody><tr ng-repeat="data in propLogsArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus"><div class="long-text-wrap">{{data.old_prodcutname}}</div></td><td class="nStatus"><div class="long-text-wrap">{{data.new_productname}}</div></td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td></tr><tr ng-if="!propLogsArr.length"><td colspan="4" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="engravingLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Engraving Log</span> <button type="button" class="close" ng-click="closeEngravingLogModal()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Value</th><th class="nStatus">New Value</th><th class="date">Date | Time</th></tr></thead><tbody><tr ng-repeat="data in engLogsArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus"><div class="long-text-wrap">{{data.old_engravingname}}</div></td><td class="nStatus"><div class="long-text-wrap">{{data.new_engravingname}}</div></td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td></tr><tr ng-if="!engLogsArr.length"><td colspan="4" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="openCopyProductDataLogPopUp" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Copy from product log</span> <button type="button" class="close" ng-click="closeCopyProductDataLogPopUp()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!copyProductDataLogLoaded">Loading....</div><div ng-if="copyProductDataLogLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Copy from which order number</th><th class="date">Date | Time</th></tr></thead><tbody><tr ng-repeat="data in copyProductDataArray"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{data.copy_from_item_increment_id}}</td><td class="date">{{getGlobalDateFormat(data.created_at)}}</td></tr><tr ng-if="!copyProductDataArray.length"><td colspan="3" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="reworkModalId" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeReworkModal()">&times;</button> <i class="fa fa-wrench" aria-hidden="true"></i><span>Rework</span></div><form name="reworkForm" novalidate="" ng-submit="reworkForm.$valid && reworkOrder()"><div class="modal-body modal-max-height"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (reworkForm.reworkReason.$error.required) && reworkForm.reworkReason.$touched}"><label for="reworkReason">Rework Reason <span class="asterisk_input"></span></label><select required="" id="reworkReason" name="reworkReason" class="form-control roleData" ng-model="reworkReason"><option value="">Select Rework Reason</option><option ng-repeat="item in reworkReasonList" value="{{item.name}}" ng-selected="item.set_default==\'1\'">{{item.name}}</option></select><span class="error" ng-show="reworkForm.$submitted && reworkForm.reworkReason.$error.required">Please select rework reason.</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (reworkForm.reworkSolution.$error.required) && reworkForm.reworkSolution.$touched}"><label for="reworkSolution">Rework Solution <span class="asterisk_input"></span></label><select required="" id="reworkSolution" name="reworkSolution" class="form-control roleData" ng-model="reworkSolution"><option value="">Select Rework Solution</option><option ng-repeat="item in reworkSolutionList" value="{{item.name}}">{{item.name}}</option></select><span class="error" ng-show="reworkForm.$submitted && reworkForm.reworkSolution.$error.required">Please select rework solution.</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (reworkForm.ticketId.$error.required ) && reworkForm.ticketId.$touched}"><label for="ticketId">Ticket Id <span class="asterisk_input"></span></label> <input required="" type="number" is-number-key="" id="ticketId" name="ticketId" ng-model="ticketId" class="form-control" placeholder="Ticket Id"> <span class="error" ng-show="reworkForm.$submitted && reworkForm.ticketId.$error.required">Please enter ticket Id.</span></div></div><div class="col-md-6"><div class="form-group"><label for="input04">Created By</label> <input type="text" readonly="readonly" ng-model="globals.currentUser.name" class="form-control" placeholder="Created By"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="specialInstruction">Special Instruction</label> <textarea rows="2" id="specialInstruction" name="specialInstruction" ng-model="specialInstruction" class="form-control" placeholder="Special Instruction"></textarea></div></div><div class="col-md-6" ng-show="reworkType==\'qtyRework\'"><div class="form-group" ng-class="{\'has-error\': (reworkForm.reworkQuantity.$error.required) && reworkForm.reworkQuantity.$touched}"><label for="reworkQuantity">Quantity <span class="asterisk_input"></span></label><select id="reworkQuantity" name="reworkQuantity" class="form-control roleData" ng-model="reworkQuantity" ng-required="reworkType==\'qtyRework\'"><option value="">Select Quantity</option><option value="{{qty}}" ng-repeat="(key,qty) in quantityListData">{{qty}}</option></select><span class="error" ng-show="reworkForm.$submitted && reworkForm.reworkQuantity.$error.required">Please select quantity.</span></div></div></div></div><div class="modal-footer padding-top-0"><button type="submit" class="btn btn-primary">Apply</button> <button type="button" class="btn btn-warning" ng-click="closeReworkModal()">Cancel</button></div></form></div></div></div><div id="rework3DModalId" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="close3DReworkModal()">&times;</button> <i class="fa fa-wrench" aria-hidden="true"></i><span>Rework</span></div><form name="rework3DForm" novalidate="" ng-submit="rework3DForm.$valid && rework3DOrder()"><div class="modal-body modal-max-height"><div class="row"><div class="col-md-6"><div class="form-group"><label for="input04">Created By</label> <input type="text" readonly="readonly" ng-model="globals.currentUser.name" class="form-control" placeholder="Created By"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (rework3DForm.specialInstruction.$error.required ) && rework3DForm.specialInstruction.$touched}"><label for="specialInstruction">Comment <span class="asterisk_input"></span></label> <textarea rows="2" id="specialInstruction" name="specialInstruction" ng-model="specialInstruction" class="form-control" placeholder="Comment" required=""></textarea> <span class="error" ng-show="rework3DForm.$submitted && rework3DForm.specialInstruction.$error.required">Please enter comment.</span></div></div></div></div><div class="modal-footer padding-top-0"><button type="submit" class="btn btn-primary">Apply</button> <button type="button" class="btn btn-warning" ng-click="close3DReworkModal()">Cancel</button></div></form></div></div></div><div id="relayLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Relay Log</span> <button type="button" class="close" ng-click="closeRelayLogModal()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered relay-table border-1px-solid"><thead><tr><th class="date">Date | Time</th><th class="oldStatus">Status</th><th>Response</th></tr></thead><tbody><tr ng-repeat="data in relayLogsArr"><td class="date">{{getGlobalDateFormat(data.created_at)}}</td><td class="oldStatus"><span ng-if="data.status==\'success\'" class="label label-success white font-size-14 margin-inline">{{data.status}}</span> <span ng-if="data.status==\'fail\'" class="label label-danger white font-size-14 margin-inline">{{data.status}}</span></td><td class="nStatus"><div class="long-text-wrap">{{data.response}}</div></td></tr><tr ng-if="!relayLogsArr.length"><td colspan="3" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="orderDateChangeButton" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeChangeOrderDatePopUp()">&times;</button> <i class="fa fa-wrench" aria-hidden="true"></i><span>Confirmation for change order date</span></div><div class="modal-body text-center" style="font-size: 18px;">Are you sure you want to change the date?</div><div class="row"><div class="modal-body text-center" style="width: 75%; margin-left: 73px;"><div class="form-group row clearfix"><label for="onChangeStatusId" class="col-sm-4 control-label" style="margin-top: 8px;font-size: 15px;">Change status to<span class="asterisk_input"></span></label><div class="col-sm-8"><select id="onChangeStatusId" class="form-control" ng-model="onChangeStatus" name="onChangeStatus" style="font-size: 15px;"><option value="">Select Status</option><option ng-repeat="status in changeStatusButtonsOnClickStatus" value="{{status.status_code}}">{{status.status_label}}</option></select><span class="error" ng-show="!onChangeStatus">Please select change status.</span></div></div></div></div><div class="modal-footer"><button ng-disabled="!onChangeStatus" type="button" class="btn btn-primary" style="width: 60px;" ng-click="changeOrderCreatedDate()">Yes</button> <button type="button" class="btn btn-warning" style="width: 60px;" ng-click="closeChangeOrderDatePopUp()">No</button></div></div></div></div><div id="openChangeOrderDateLogDialog" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Change order date log</span> <button type="button" class="close" ng-click="closeChangeOrderDateLogDialog()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!changeOrderDateLogLoaded">Loading....</div><div ng-if="changeOrderDateLogLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">Change By Name</th><th class="oldStatus">Old Date</th><th class="date">Current Date</th></tr></thead><tbody><tr ng-repeat="data in changeOrderDateLogArray"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{getGlobalDateFormat(data.old_date)}}</td><td class="date">{{getGlobalDateFormat(data.current_date)}}</td></tr><tr ng-if="!changeOrderDateLogArray.length"><td colspan="3" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="damageSettingModalPopUp" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeModalDamageSettingPopUp()">&times;</button> <i class="fa fa-chain-broken" aria-hidden="true"></i><span>Damage Crystal</span></div><form name="damageSettingForm" novalidate="" ng-submit="damageSettingForm.$valid && saveDamageCrystalReport()"><div class="modal-body modal-max-height"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (damageSettingForm.damageReason.$error.required) && damageSettingForm.damageReason.$touched}"><label for="damageReason">Damage Reason <span class="asterisk_input"></span></label><select required="" id="damageReason" name="damageReason" class="form-control roleData" ng-model="damageReason"><option value="">Select Damage Reason</option><option ng-repeat="item in damageSettingReasonList" value="{{item.name}},{{item.set_default}}" ng-selected="item.set_default==\'1\'">{{item.name}}</option></select><span class="error" ng-show="damageSettingForm.$submitted && damageSettingForm.damageReason.$error.required">Please select Damage reason.</span></div></div><div class="col-md-6"><div class="form-group"><label for="input04">Created By</label> <input type="text" readonly="readonly" ng-model="globals.currentUser.name" class="form-control" placeholder="Created By"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (damageSettingForm.damageFileOrder.$error.required) && damageSettingForm.damageFileOrder.$touched}"><label for="damageFileOrder">File Order <span class="asterisk_input"></span></label> <input required="" type="text" id="damageFileOrder" name="damageFileOrder" ng-model="dmageSettingPopUpItemIncrementId" class="form-control" placeholder="File Order" disabled=""> <span class="error" ng-show="damageSettingForm.$submitted && damageSettingForm.damageFileOrder.$error.required">Please enter file order.</span></div></div><div class="col-md-6"><div class="form-group"><label for="damageCrystalOrder">Raw material <span class="asterisk_input"></span></label> <input required="" type="text" id="damageCrystalOrder" name="damageCrystalOrder" ng-model="damagesettingCrystalOrder" class="form-control" placeholder="Raw material" uib-typeahead="orderno for orderno in getPrintCrystalItems($viewValue, orderId)" autocomplete="off" typeahead-focus-on-select="false" typeahead-select-on-blur="true"><span id="error-raw-material" class="error" ng-show="damageSettingForm.$submitted && damageSettingForm.damageCrystalOrder.$error.required">Please enter raw material.</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="damageSpecialInstruction">Special Instruction</label> <textarea rows="2" id="specialInstruction" name="damageSpecialInstruction" ng-model="damageSpecialInstruction" class="form-control" placeholder="Special Instruction"></textarea></div></div><div class="col-md-6"><div class="form-group"><input type="file" class="upload-file-manual" id="manualFileUploadx" name="manualFileUploadx" required="" accept=".png,.jpeg,.jpg" ng-click="hideDamageCrystalImageValidation()" style="width: 210px;"> <label for="manualFileUploadx"><i class="fa fa-upload fa-lg"></i><span id="manualFileUpload-text">Choose a file&hellip;</span></label></div></div><span class="error" id="error-damage-crystal-image-upload-file" style="margin-top: 10px;margin-left: 15px;font-size: 15px; display: none">Please select a file.</span> <span class="error" id="error-damage-crystal-image-upload-invalid-file" style="margin-top: 10px;margin-left: 15px;font-size: 15px; display: none">Please select PNG or JPEG or JPG file.</span></div></div><div class="modal-footer padding-top-0"><button type="submit" class="btn btn-primary">Apply</button> <button type="button" class="btn btn-warning" ng-click="closeModalDamageSettingPopUp()">Cancel</button></div></form></div></div></div><div id="orderScanModalPopUp" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog" style="width:70%;height:50%;top:-250px;"><div class="modal-content" style="height:100%;"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeOrderScanPopUp()">&times;</button> <i class="fa fa-barcode" aria-hidden="true"></i><span>Scan Crystal</span></div><form name="scanOrderForm" ng-submit="scanOrderForm.$valid && scanOrderItem()"><div class="modal-body modal-max-height"><div class="row"><div class="col-md-4"></div><div class="col-md-4 text-center"><div class="form-group"><label for="scanOrderNumber">Order Number</label> <input type="text" id="scanOrderNumber" name="scanOrderNumber" ng-model="scanOrderNumber" class="form-control" placeholder="Order Number" autofocus=""></div></div><div class="col-md-4"></div></div><div class="row"><div class="col-sm-12"><div class="row" ng-repeat="(key,itemdetails) in orderItemsDetails" style="margin-bottom:20px;"><div class="col-sm-2" style="font-size:20px;font-weight:bolder;text-align:left;">{{ itemdetails.product_name }}</div><div class="col-sm-4" style="font-size:20px;font-weight:bolder;text-align:left;">{{ itemdetails.sku }}</div><div class="col-sm-2" style="font-size:20px;font-weight:bolder;text-align:center;">{{ itemdetails.qty }} - {{ itemdetails.scanned }}</div><div class="col-sm-2" style="text-align:center;"><span ng-if="itemdetails.qty == 1 && itemdetails.scanned == 0" style="color:#ff0000;font-size: 20px;font-weight:bolder;"><i class="fa fa-times" aria-hidden="true"></i></span> <span ng-if="itemdetails.qty > 1 && itemdetails.scanned < itemdetails.qty" style="color:#ff0000;font-size:20px;font-weight:bolder;"><i class="fa fa-times" aria-hidden="true"></i></span> <span ng-if="itemdetails.qty == itemdetails.scanned" style="color:#6ba03a;font-size:20px;"><i class="fa fa-check-circle" aria-hidden="true"></i></span></div><div class="col-sm-2" ng-if="permissionArr.indexOf(\'add_scan_item\') !== - 1 && itemdetails.qty != itemdetails.scanned"><a href="" ng-click="addScannedItem(key)" style="color:#6ba03a;font-size:20px;"><i class="fa fa-plus" aria-hidden="true"></i></a></div></div></div></div></div></form></div></div></div><div id="packageModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal" style="width: 35%;"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Packages</span> <button type="button" class="close" ng-click="closePackageCreate()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height" style="height: 500px"><div class="row"><div class="form-group"><label class="control-label col-sm-3" style="color:#000;">Package Type</label><div class="col-sm-9"><select class="form-control" name="main_package_type" id="main_package_type" placeholder="Please Select" ng-model="packagetype" ng-change="changeMainPackageType(packagetype)"><option value="">Please Select</option><option value="YOUR_PACKAGING">Custom Box</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}">{{sbox.service_box_label}}</option></select></div></div><br></div><div class="row"><div class="col-sm-12"><div id="packagesrow" style="display: none;"><div class="row pkgrow" style="padding: 10px;"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title">Package #1</h4><div style="float: right;margin-top:-25px;"><button type="button" class="copy btn btn-success" title="Copy Package"><i class="fa fa-copy"></i></button> <button type="button" class="remove btn btn-danger" title="Remove Package"><i class="fa fa-trash"></i></button></div></div><div class="panel-body row-fluid lite-pad"><form class="form form-horizontal"><div class="form-group"><label class="control-label col-sm-3">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description[]" id="description" placeholder="Description"></div></div><div class="form-group" id="custompackagetype"><label class="control-label col-sm-3">Package Type</label><div class="col-sm-9"><select class="form-control" name="package_type[]" id="package_type" placeholder="Please Select"><option value="">Please Select</option><option ng-repeat="box in ShipmentBoxes" value="{{box.id}}">{{box.name}}</option></select></div></div><div class="form-group"><div class="row"><div class="col-md-4 col-lg-3" style="padding:10px"><label class="control-label pull-right">Size</label></div><div class="col-md-8 col-lg-9"><div class="col-md-4 pull-left" style="padding:0px"><input type="number" class="form-control" placeholder="L" name="len[]" id="len" value=""></div><div class="col-md-4" style=""><input type="number" class="form-control" placeholder="W" name="wgh[]" id="wgh" value=""></div><div class="col-md-4 pull-right" style="padding:0px"><input type="number" class="form-control" placeholder="H" name="hgt[]" id="hgt" value=""></div></div></div></div><div class="form-group"><label class="control-label col-sm-3">Weight (lbs)</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="weight[]" id="weight" value="" placeholder="0"></div></div></form></div></div></div></div><div id="packagesrow1"></div><div class="row" style="padding-top: 10px;"><div class="col-sm-12"><button type="button" class="btn btn-primary" ng-if="adpkg" ng-click="addpackage()">Add New Package</button></div></div></div></div></div><div class="modal-footer text-center"><div class="clearfix"><button type="button" class="btn btn-success btn-modal-ok pull-right" ng-click="savePackages()">Save Changes</button> <a class="btn btn-primary pull-left" ng-click="closePackageCreate()">Cancel</a></div></div></div></div></div><div id="addressLogModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal" style="width: 35%;"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Address Log</span> <button type="button" class="close" ng-click="closeAddressLog()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height" style="height: 500px"><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-12 col-lg-12"><label class="pull-center">Old Address</label></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Street</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.old_street }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Street2</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.old_street2 }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">City</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.old_city }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Region</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.old_region }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Post Code</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.old_postcode }}</span></div></div></div><div class="col-md-6"><div class="row"><div class="col-md-12 col-lg-12"><label class="pull-center">New Address</label></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Street</label></div><div class="col-md-8 col-lg-8"><span class="pull-left" style="color:#FF0000" ng-if="address_log.old_street.trim() != address_log.new_street.trim()">{{ address_log.new_street }}</span> <span class="pull-left" ng-if="address_log.old_street.trim() == address_log.new_street.trim()">{{ address_log.new_street }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Street2</label></div><div class="col-md-8 col-lg-8"><span class="pull-left" style="color:#FF0000" ng-if="address_log.old_street2.trim() != address_log.new_street2.trim()">{{ address_log.new_street2 }}</span> <span class="pull-left" ng-if="address_log.old_street2.trim() == address_log.new_street2.trim()">{{ address_log.new_street2 }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">City</label></div><div class="col-md-8 col-lg-8"><span class="pull-left" style="color:#FF0000" ng-if="address_log.old_city.trim() != address_log.new_city.trim()">{{ address_log.new_city }}</span> <span class="pull-left" ng-if="address_log.old_city.trim() == address_log.new_city.trim()">{{ address_log.new_city }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Region</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.new_region }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Post Code</label></div><div class="col-md-8 col-lg-8"><span class="pull-left" style="color:#FF0000" ng-if="address_log.old_postcode.trim() != address_log.new_postcode.trim()">{{ address_log.new_postcode }}</span> <span class="pull-left" ng-if="address_log.old_postcode.trim() == address_log.new_postcode.trim()">{{ address_log.new_postcode }}</span></div></div><div class="row"><div class="col-md-4 col-lg-4"><label class="pull-left">Type</label></div><div class="col-md-8 col-lg-8"><span class="pull-left">{{ address_log.address_smartystreet_type }}</span></div></div></div></div><div class="row"><div class="col-md-12"><div ng-if="address_log_green_messages.length >= 1" ng-repeat="grn in address_log_green_messages"><span style="color:#6ba03a;font-size: 20px;" ng-if="address_log_green_messages.length > 0"><i class="fa fa-check-circle"></i><strong>{{ grn }}</strong></span></div></div></div><div class="row"><div class="col-md-12"><div ng-if="address_log_yellow_messages.length >= 1" ng-repeat="ylw in address_log_yellow_messages"><span style="color:#fd7e14;font-size: 20px;" ng-if="address_log_yellow_messages.length >= 1"><i class="fa fa-exclamation-triangle"></i><strong>{{ ylw }}</strong></span></div></div></div><div class="row"><div class="col-md-12"><div ng-if="address_log_red_messages.length >= 1" ng-repeat="red in address_log_red_messages"><span style="color:#ff0000;font-size: 20px;" ng-if="address_log_red_messages.length >= 1"><i class="fa fa-sensor-alert"></i><strong>{{ red }}</strong></span></div></div></div><div class="row"><div class="col-md-12"><div ng-if="address_message.length >= 1" ng-repeat="msg in address_message"><strong>{{ msg }}</strong></div></div></div></div><div class="modal-footer text-center"></div></div></div></div><div id="amazonShipmentModel" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content order-details-model"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to ship order<br>#<span style="font-weight: bold;font-size: 15px;line-height:25px;">{{ ordernumber }}</span><br>With "<span style="font-weight: bold;font-size: 15px;line-height:25px;">{{ amazoncompany }}</span>"<br>"<span style="font-weight: bold;font-size: 15px;line-height:25px;">{{ amazonservice }}</span>"<br>Package:"<span style="font-weight: bold;font-size: 15px;line-height:25px;">{{ package }}</span>"</div><div class="modal-footer"><a class="btn btn-sm btn-ship btn-success" style="float:left;" ng-click="getAmazonShipment(amazoncompany,amazonservice,service_id,service_offer_id)">Yes</a> <button type="button" class="btn btn-sm btn-warning" data-dismiss="modal">No</button></div></div></div></div><div id="jobSlotLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Slot Logs</span> <button type="button" class="close" ng-click="closeJobSlotLogs()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!jobSlotLogsLoaded">Loading....</div><div ng-if="jobSlotLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Slot Name</th><th class="oldStatus">Machine Name</th><th class="oldStatus">Old Status</th><th class="nStatus">New Status</th><th class="date">Date</th></tr></thead><tbody><tr ng-repeat="data in jobSlotLogsArr"><td class="uName">{{data.removed_by_name}}</td><td class="oldStatus">{{data.slot_txt}}</td><td class="oldStatus">{{data.unit_txt}}</td><td class="oldStatus">{{data.old_status_txt}}</td><td class="nStatus">{{data.status_txt}}</td><td class="date">{{getGlobalDateFormat(data.removed_dat)}}</td></tr><tr ng-if="!jobSlotLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="figurineCostModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><form name="figurineCostForm"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Figurine Cost</span> <button type="button" class="close" ng-click="closeFigurineCostPopup()" aria-label="Close">\xD7</button></div><div class="modal-body modal-max-height"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (figurineCostForm.figurineCost.$error.required) && figurineCostForm.figurineCost.$touched}"><label for="figurineCost" style="color:black;">Figurine Cost <span class="asterisk_input"></span></label> <input type="text" id="figurineCost" name="figurineCost" ng-model="figurineCost" class="form-control" placeholder="Figurine Cost" ng-required="true"> <span class="error" ng-show="figurineCostForm.$submitted && figurineCostForm.figurineCost.$error.required">Please enter figurine cost.</span></div></div></div></div><div class="modal-footer padding-top-0"><button type="submit" class="btn btn-primary" ng-click="saveFigurineCost()">Apply</button> <button type="button" class="btn btn-warning" ng-click="closeFigurineCostPopup()">Cancel</button></div></form></div></div></div>');
$templateCache.put('app/pages/orders/orderDetailsSingleItem.html','<style>\r\n/*    .sub-tab-{{item.item_increment_id}} a{\r\n        background-color: {{item.item_status_Color}} !important;\r\n        color:white !important;\r\n    }\r\n    .sub-tab-{{qtyItem.prod_qty_id}} a{\r\n        background-color: {{qtyItem.color_code}} !important;\r\n        color:white !important;\r\n    }*/\r\n    .tabs-right .active a:not(.btn){\r\n        background-color: white !important;\r\n        color:black !important;\r\n    }\r\n    .order-popup-border{\r\n      border-left: 1px solid #e6e6e6;\r\n      border-right: 1px solid #e6e6e6;\r\n      /* height: {{borderSize}}px; */\r\n    }\r\n    .bg-white{\r\n      background-color: white !important;\r\n    }\r\n</style><div class="row" style="margin-top:15px"><div class="col-md-12 col-lg-4 margin-top-3"><div class="row form-group" ng-init="isProductEdit=true"><div class="col-md-10 col-sm-10"><div ng-show="isProductEdit==true"><div class="row margin-top-3"><div class="col-sm-12"><span class="label product-label" title="{{item.name}}" ng-if="permissionArr.indexOf(\'product_name\') !== - 1">{{item.name}}</span> <label ng-if="subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <span ng-show="subIndex == 0"><button ng-show="showEditAndLogBtn(\'Product Name Edit\',item.item_status,\'product_edit\')" ng-click="isProductEdit=false;killOrderDetailsTimer()" title="Edit Product Name" class="btn btn-edit btn-xs">Edit</button> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Product Log\',item.item_status,\'product_log\')" title="View Log" ng-click="openProductLogModal(item.item_increment_id)"></i></span></div></div></div><div ng-show="isProductEdit==false"><div class="row"><div class="col-sm-9"><select id="productName" class="form-control product-name selectpicker with-search" data-live-search="true" title="Select Product" ng-model="item.name" name="productName" ng-options="item.report_label as item.report_label for item in allProducts"></select></div><div class="col-sm-3 pl-0 pr-0"><i class="fa fa-check cursor-pointer icon-font-size text-green" title="Save Product Name" ng-click="saveProductName(item,item.name);isProductEdit=true"></i> <i class="fa fa-times cursor-pointer icon-font-size text-red" title="Cancel" ng-click="startOrderDetailsTimer();isProductEdit=true"></i> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Product Log\',item.item_status,\'product_log\')" title="View Log" ng-click="openProductLogModal(item.item_increment_id)"></i></div></div></div></div><div class="col-md-2 col-sm-2 pl-0 form-group margin-top-3"><span class="label product-label">QTY : {{item.qty_ordered}}</span></div></div><div class="row form-group"><div class="col-md-12"><span ng-if="item.quantityList.length == 0" class="label white label-tab" ng-style="{\'background-color\':item.item_status_Color}">{{item.item_status}}</span> <span ng-if="item.quantityList.length > 0" class="label white label-tab" ng-style="{\'background-color\':qtyItem.color_code}">{{qtyItem.status_label}}</span></div></div></div><div class="col-md-12 col-lg-4"><div class="row form-group"><div class="col-md-6 col-lg-5 col-sm-6" ng-if="permissionArr.indexOf(\'barcode_view\') !== - 1"><img ng-if="!qtyItem.prod_qty_id" ng-src="{{::item.barcode_image_url}}" alt="Barcode" style="margin-left:-8px"><p ng-if="!qtyItem.prod_qty_id" class="margin-bottom-0 text-bold">{{::item.item_increment_id}}.vmj</p><img ng-if="qtyItem.prod_qty_id" ng-src="{{::qtyItem.barcode_image_url}}" alt="Barcode" style="margin-left:-8px"><p ng-if="qtyItem.prod_qty_id" class="margin-bottom-0 text-bold">{{::qtyItem.prod_qty_id}}.vmj</p></div><div class="col-md-6 col-lg-7 col-sm-6 form-group margin-top-3"><button ng-click="cancelAddOne($event)" style="margin-top:-15px;margin-right:5px" class="hide-element cancel-addone btn btn-with-icon btn-danger btn-xs"><i class="ion-android-warning" isicon="true"></i>Cancel</button><div class="popup" ng-if="subIndex == 0"><button ng-if="permissionArr.indexOf(\'3d_category_addon_button\') !== - 1 && !getTheRelayLinkPriceCategory(item.relay_link_price_category) && !getTheRelayLinkPrice(item.relay_link_price)" ng-click="showAddOne($event)" class="add-addone btn btn-with-icon btn-primary btn-sm pull-right font16px"><i class="ion-android-checkmark-circle" isicon="true"></i>3D Category Add-on ?</button> <button ng-click="applyCatAddOne($event, item.item_increment_id, qtyItem.prod_qty_id,orderCustomerName,orderCustomerId,\'order\')" class="addone-apply-btn hide-element btn btn-with-icon btn-success btn-xs pull-right"><i class="ion-android-checkmark-circle"></i>Apply</button> <span ng-if="permissionArr.indexOf(\'relay_links_3d_category\') !== -1 && getTheRelayLinkPriceCategory(item.relay_link_price_category)" class="label product-label" style="display: inline-block; margin-bottom: 4px;">3D Category : {{item.relay_link_price_category}}</span> <span ng-if="permissionArr.indexOf(\'relay_links_3d_price\') !== -1 && getTheRelayLinkPrice(item.relay_link_price)" style="display: inline-block;" class="label product-label">3D Price : {{item.relay_link_price}}</span> <span class="popuptext" id="myPopup"><div class="add-one"><select class="form-control-add-one cat" id="cataddon"><option value="0">3D Category Addon</option><option value="{{addOneitem.value}}" cls="{{addOneitem.name}}" cost="{{addOneitem.price}}" ng-selected="addOneitem.set_default==\'1\'" ng-repeat="addOneitem in addOneCatData.cat.cat_type">{{addOneitem.title}}</option></select></div></span></div><button ng-click="cancelFigurineCost($event)" style="margin-top:-15px;margin-right:5px" class="hide-element cancel-figurine btn btn-with-icon btn-danger btn-xs"><i class="ion-android-warning" isfigurine="true"></i>Cancel</button><div class="popup" ng-if="subIndex == 0"><button ng-if="permissionArr.indexOf(\'figurine_cost_button\') !== - 1 && !item.figurine_cost" ng-click="showFigurineCostPopup($event, item.item_increment_id, qtyItem.prod_qty_id)" class="add-figurinecost btn btn-with-icon btn-primary btn-sm pull-right font16px"><i class="ion-android-checkmark-circle" isicon="true"></i>Figurine Cost ?</button> <button ng-click="applyFigurineCost($event, item.item_increment_id, qtyItem.prod_qty_id)" class="figurine-apply-btn hide-element btn btn-with-icon btn-success btn-xs pull-right"><i class="ion-android-checkmark-circle"></i>Apply</button> <span ng-if="permissionArr.indexOf(\'figurine_cost_button\') !== -1 && item.figurine_cost" class="label product-label" style="display: inline-block; margin-bottom: 4px;">Figurine Cost : {{item.figurine_cost}}</span></div><br><span ng-if="permissionArr.indexOf(\'job_by_relay_or_silvercayde\') !== -1 && item.job_by_relay_or_silvercyade != \'\'" class="label product-label" style="display: inline-block; margin-bottom: 4px;margin-top: 4px;">Job By : {{item.job_by_relay_or_silvercyade}}</span></div><div class="col-md-6 col-lg-12 col-sm-6 margin-top-3"><button ng-click="cancelAddOne($event)" style="margin-top:-15px;margin-right:5px" class="hide-element cancel-addone btn btn-with-icon btn-danger btn-xs"><i class="ion-android-warning" isicon="true"></i>Cancel</button><div class="popup" ng-if="subIndex == 0"><button ng-show="showEditAndLogBtn(\'Copy Order Number\',item.item_status,\'copy_from_to_copy_number_button\')" ng-if="permissionArr.indexOf(\'copy_from_to_copy_number_button\') !== - 1" clipboard="" text="item.item_increment_id" ng-click="productNumberCopied(item.item_increment_id)" class="add-addone ml-5 btn btn-with-icon btn-primary btn-sm pull-right font16px">Copy</button> <button ng-if="!addOnDataArr[item.item_increment_id] && permissionArr.indexOf(\'add_on_btn\') !== - 1" ng-click="showAddOne($event)" class="add-addone btn btn-with-icon btn-primary btn-sm pull-right font16px"><i class="ion-android-checkmark-circle" isicon="true"></i>Add-on ?</button> <button ng-click="applyAddOne($event, item.item_increment_id, qtyItem.prod_qty_id,orderCustomerName,orderCustomerId)" class="addone-apply-btn hide-element btn btn-with-icon btn-success btn-xs pull-right"><i class="ion-android-checkmark-circle"></i>Apply</button> <button ng-if="addOnDataArr[item.item_increment_id] && permissionArr.indexOf(\'show_add_on\') !== - 1" ng-click="addOneInfo($event)" class="show-addone btn btn-with-icon btn-success btn-sm pull-right font16px"><i class="fa fa-eye fa-lg white"></i>Show Info</button> <span class="popuptext" id="myPopup"><div class="add-one"><select class="form-control-add-one extra"><option value="0">No Extra People</option><option value="{{addOneitem.value}}" ng-selected="addOneitem.set_default==\'1\'" ng-repeat="addOneitem in addOneData.extra_people.add_extra_people">{{addOneitem.name}}</option></select><select class="form-control-add-one express"><option value="0">No Express</option><option value="{{addOneitem.value}}" ng-selected="addOneitem.set_default==\'1\'" ng-repeat="addOneitem in addOneData.express.express_type">{{addOneitem.name}}</option></select><select class="form-control-add-one background"><option value="0">No Background</option><option value="{{addOneitem.value}}" ng-selected="addOneitem.set_default==\'1\'" ng-repeat="addOneitem in addOneData.background.add_background">{{addOneitem.name}}</option></select><select class="form-control-add-one engraving"><option value="0">No Engraving</option><option value="{{addOneitem.value}}" ng-selected="addOneitem.set_default==\'1\'" ng-repeat="addOneitem in addOneData.engraving.add_engraving">{{addOneitem.name}}</option></select></div></span> <span class="showpopuptext" id="showPopup"><div class="add-one"><table class="table table-condensed addontable"><tbody><tr><th colspan="2" class="font16px">Add-On <button style="line-height:10px;color:white;padding-right:10px" type="button" class="close show-popup-close hide-element" ng-click="closeAddOnShow($event)" aria-label="Close">\xD7</button></th></tr><tr><td><b>No Extra People :</b></td><td>{{addOnDataArr[item.item_increment_id].extra_person_text}}</td></tr><tr><td><b>No Express :</b></td><td>{{addOnDataArr[item.item_increment_id].exoress_text}}</td></tr><tr><td><b>No Background :</b></td><td>{{addOnDataArr[item.item_increment_id].background_text}}</td></tr><tr><td><b>No Engraving :</b></td><td>{{addOnDataArr[item.item_increment_id].engraving_text}}</td></tr></tbody></table></div></span></div></div></div></div><div class="col-md-12 col-lg-4"><div ng-if="subIndex == 0"><button ng-repeat="btn in dynamicBtnList" ng-disabled="btn.button_type==\'QA Start\' && disableQaStart" ng-style="{\'background-color\':btn.button_color};" ng-if="btn.button_type !=\'3D Job Start\' && permissionArr.indexOf(btn.name) !== -1 && checkStatusForBtn(btn.show_on_status,item.item_status)" ng-click="changeOrderStatus(btn.button_type,btn.name,btn.change_to_status,$event,item.item_increment_id, item.item_status,getSortOrderNumber(item.item_increment_id),btn.order_type,item.name,item.customer_id,item.qty_ordered,orderDetailsData.orderData.icon_tools,item.relay_link_price_category)" class="btn btn-dynamic btn-with-icon margin-right-10 pull-right margin-top-3"><i class="fa fa-check"></i> {{btn.name}}</button> <button ng-repeat="btn in dynamicBtnList" ng-disabled="btn.button_type==\'QA Start\' && disableQaStart" ng-style="{\'background-color\':btn.button_color};" ng-if="btn.button_type==\'3D Job Start\' && permissionArr.indexOf(btn.name) !== -1 && checkStatusForBtn(btn.show_on_status,item.item_status)" ng-click="open3DJobStartPopUp(btn.button_type,btn.name,btn.change_to_status,$event,item.item_increment_id, item.item_status,getSortOrderNumber(item.item_increment_id),btn.order_type,item.name,item.customer_id,item.qty_ordered,orderDetailsData.orderData.icon_tools,orderCustomerName)" class="btn btn-dynamic btn-with-icon margin-right-10 pull-right margin-top-3"><i class="fa fa-check"></i> {{btn.name}}</button> <button ng-click="qaApprove($event, item.item_increment_id, item.item_status, getSortOrderNumber(item.item_increment_id), item.name, item.qty_ordered)" class="hide-element approve-{{getSortOrderNumber(item.item_increment_id)}}_1 btn btn-success btn-with-icon margin-right-10 pull-right margin-top-3"><i class="fa fa-user"></i> QA Approve</button><div class="chk-{{getSortOrderNumber(item.item_increment_id)}}_1 form-group itile hide-element pull-right itile-padding" style="text-align:center;margin-top:-20px"><label for="inputFirstName" class="control-label">ITILE</label><div class="timer hide-element qa-timer"><timer autostart="false" interval="1000"><i class="fa fa-clock-o" style="color: #a9908c;"></i> {{hhours}}:{{mminutes}}:{{sseconds}}</timer></div><div class="mt-5px"><label class="custom-switch switcher-container"><input type="checkbox" ng-model="itileArr[item.item_increment_id]" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))" class="itilecheck"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div></div></div></div></div><div class="row"><div class="col-lg-12"><a ng-if="permissionArr.indexOf(\'open_job\') !== - 1" ng-href="{{getOpenJobUri(item.item_increment_id)}}" class="btn btn-success btn-with-icon margin-right-10"><i class="fa fa-check-square"></i>Open Job</a> <a ng-if="permissionArr.indexOf(\'open_job_db\') !== - 1" ng-href="{{getOpenJobDBUri(item.item_increment_id,item.qty_ordered)}}" class="btn btn-success btn-with-icon margin-right-10"><i class="fa fa-check-square"></i>Open Job DB</a> <a ng-if="permissionArr.indexOf(\'create_job\') !== - 1 && item.has_filedownload" ng-href="{{getCreateJobUri(item.name,item.product_options.options,item.engravingn,item.has_filedownload)}}" class="btn btn-info btn-with-icon margin-right-10"><i class="fa fa-check-square"></i>Create Job</a><a ng-if="!item.product_options && permissionArr.indexOf(\'create_2d_job\') !== - 1 && item.has_2d_image ==\'enable\'" ng-href="{{getCreate2DJobUri(item.item_increment_id,item.name,item.m2_custom_options,item.engravingn,item.regular,item.image_download_path)}}" class="btn btn-info btn-with-icon"><i class="fa fa-check-square"></i>Create 2D Job</a> <a ng-if="item.product_options && permissionArr.indexOf(\'create_2d_job\') !== - 1 && item.has_2d_image ==\'enable\'" ng-href="{{getCreate2DJobUri(item.item_increment_id,item.name,item.product_options.options,item.engravingn,item.regular,item.image_download_path)}}" class="btn btn-info btn-with-icon"><i class="fa fa-check-square"></i>Create 2D Job</a><a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'new_relay_3dc_file_download\') !== - 1 && createButtonEncrypted==\'No\' && !item.product_options" ng-href="{{createButtonUrl==\'relay\' ? getCreateJobUri(item.name,item.m2_custom_options,item.engravingn,item.original_relay_3dc_file_url) : createButtonUrl==\'indiaserver\' ? getCreateJobUri(item.name,item.m2_custom_options,item.engravingn,item.relay_3dc_file_url, \'YES\') : getCreateJobUri(item.name,item.m2_custom_options,item.engravingn,item.relay_3dc_file_url)}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{createTitle}}</a> <a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'new_relay_3dc_file_download\') !== - 1 && createButtonEncrypted==\'No\' && item.product_options" ng-href="{{createButtonUrl==\'relay\' ? getCreateJobUri(item.name,item.product_options.options,item.engravingn,item.original_relay_3dc_file_url) : createButtonUrl==\'indiaserver\' ? getCreateJobUri(item.name,item.product_options.options,item.engravingn,item.relay_3dc_file_url, \'YES\') : getCreateJobUri(item.name,item.product_options.options,item.engravingn,item.relay_3dc_file_url)}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{createTitle}}</a><a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'new_relay_3dc_file_download\') !== - 1 && createButtonEncrypted==\'Yes\'" ng-click="verifySecurityKey(item.item_increment_id,item.mask,\'3DC\')" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{createTitle}}</a><a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'new_relay_vmj_file_download\') !== - 1 && readyEncrypted==\'No\'" ng-href="{{readyUrl==\'relay\' ? getOpenJobDBUriForWeCreate(item.original_relay_vmj_file_url,item.qty_ordered,item.item_increment_id) : readyUrl==\'indiaserver\' ? getOpenJobDBUriForWeCreate(item.relay_vmj_file_url,item.qty_ordered,item.item_increment_id, \'YES\') : getOpenJobDBUriForWeCreate(item.relay_vmj_file_url,item.qty_ordered,item.item_increment_id)}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{readyTitle}}</a><a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'new_relay_vmj_file_download\') !== - 1 && readyEncrypted==\'Yes\'" ng-click="verifySecurityKey(item.item_increment_id,item.mask,\'VMJ\')" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{readyTitle}}</a><a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'relay_3dc_only_file_download\') !== - 1 && url3dcEncrypted==\'No\'" ng-href="{{get3dcDownload(url3dcDownload, item.original_relay_3dc_file_url, item.relay_3dc_file_url)}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{title3dcDownload}}</a><a style="margin-left: 10px;" ng-if="item.is_relay_download ==\'enable\' && permissionArr.indexOf(\'relay_3dc_only_file_download\') !== - 1 && url3dcEncrypted==\'Yes\'" ng-click="verifySecurityKey(item.item_increment_id,item.mask,\'3DC_FILE_DOWNLOAD\')" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{title3dcDownload}}</a><a style="margin-left: 10px;" ng-if="permissionArr.indexOf(\'zip_file_download\') !== - 1 && item.zipurl != \'\'" ng-href="{{ item.zipurl }}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{titlezipDownload}}</a><a style="margin-left: 10px;" ng-if="item.is_database_job_download ==\'enable\' && permissionArr.indexOf(\'new_relay_vmj_file_download\') !== - 1 && readyEncrypted==\'No\'" ng-href="{{readyUrl==\'relay\' ? getOpenJobDBUriForWeCreate(item.original_relay_vmj_file_url,item.qty_ordered,item.item_increment_id) : readyUrl==\'indiaserver\' ? getOpenJobDBUriForWeCreate(item.relay_databse_job_file_url,item.qty_ordered,item.item_increment_id, \'YES\') : getOpenJobDBUriForWeCreate(item.relay_databse_job_file_url,item.qty_ordered,item.item_increment_id)}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{databaseJob}}</a><a style="margin-left: 10px;" ng-if="item.design_uploaded_file" href="{{ item.design_uploaded_file }}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>Download Zip File</a><a id="uploadFileManualButton" style="margin-left: 10px;" ng-if="item.file_is_manual_Uploaded ==\'enable\' && permissionArr.indexOf(\'file_upload_button\') !== - 1 && uploadEncrypted==\'No\'" ng-href="{{item.file_manual_url}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{upload}}</a><a id="uploadFileManualButton" style="margin-left: 10px;" ng-if="item.file_is_manual_Uploaded ==\'enable\' && permissionArr.indexOf(\'file_upload_button\') !== - 1 && uploadEncrypted==\'Yes\'" ng-click="verifySecurityKey(item.item_increment_id,item.mask,\'UPLOAD_FILE_DOWNLOAD\')" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{upload}}</a><a id="amazonDownloadButton" style="margin-left: 10px;" ng-if="item.amazon_file_available ==\'enable\' && permissionArr.indexOf(\'amazon_download_button\') !== - 1 && amazonEncrypted==\'No\'" ng-href="{{getOpenJobDBUriForWeCreate(item.amazon_file_download_url,item.qty_ordered,item.item_increment_id)}}" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{amazonDownload}}</a><a id="amazonDownloadButton" style="margin-left: 10px;" ng-if="item.amazon_file_available ==\'enable\' && permissionArr.indexOf(\'amazon_download_button\') !== - 1 && amazonEncrypted==\'Yes\'" ng-click="verifySecurityKey(item.item_increment_id,item.mask,\'AMAZON_FILE_DOWNLOAD\')" class="btn btn-danger btn-with-icon"><i class="fa fa-download fa-lg"></i>{{amazonDownload}}</a><a ng-if="showDamageCrystalButton(item.item_status)" id="damage-setting-button" style="margin-left: 10px;" class="btn btn-with-icon btn-primary" ng-click="openModalDamageSettingPopUp(item.item_increment_id, item.qty_ordered, qtyItem.prod_qty_id)"><i class="fa fa-lg"></i>Damage</a></div></div><h3 class="with-line"></h3><div class="row"><div class="col-md-4"><div class="row" ng-if="permissionArr.indexOf(\'order_data_info\') !== - 1"><div class="col-md-12 col-lg-6" ng-if="item.bundle_label"><div class="form-group clearfix"><label class="control-label">{{item.bundle_label}}</label> <input type="text" readonly="true" name="bundle" value="{{item.bundle_text}}" placeholder="Bundle" class="form-control"></div></div><div ng-if="!m2_is_custom_options"><div class="col-md-12 col-lg-6" ng-if="!checkIsTextArea(field.label) && field.label != \'Upload Your Image\'" ng-repeat="field in item.product_options.options"><div class="form-group clearfix"><label for="field" class="control-label">{{field.label}} <span ng-show="field.label == \'Upload Your 3DC File\' || field.label == \'file\'">(link)</span></label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <input type="text" readonly="true" name="field-{{$index}}" value="{{getHtmlDataText(field.value)}}" placeholder="link" class="form-control"></div></div><div ng-if="!item.product_options.options && !item.bundle_label && m2_is_custom_options" class="no-info-ord">No Information</div></div><div ng-if="!m2_is_custom_options"><div class="col-md-12 col-lg-6" ng-if="!checkIsTextArea(field.label)" ng-repeat="field in item.m2_custom_options"><div class="form-group clearfix"><label for="field" class="control-label">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <input type="text" readonly="true" name="field-{{$index}}" value="{{getHtmlDataText(field.value)}}" placeholder="link" class="form-control"></div></div></div></div></div><div class="col-md-4 order-popup-border"><div class="row form-group" ng-if="permissionArr.indexOf(\'order_images\') !== - 1"><div class="col-md-12 col-lg-6 col-sm-6"><label class="control-label">Photo</label><div class="image-view" style="height:145px"><img ng-if="item.thumb" ng-class="{\'img-border\':item.thumb}" on-error-src="" style="max-width:100%;" height="140px" ng-src="{{item.thumb}}"> <a ng-if="item.regular" class="down-class" href="" ng-click="downloadImage(item.item_increment_id,item.regular,\'regular\')" title="Download Photo"><i class="fa fa-download fa-2x"></i></a> <a ng-if="item.regular" class="down-class" href="{{item.regular}}" title="Open Image"><i class="fa fa-folder-open fa-2x"></i></a><div ng-class="{\'hide\':item.regular}" class="no-image">No Image<br></div></div><div ng-if="item.download_image"><a href="" ng-click="downloadImage(item.item_increment_id,item.regular,\'regular\')" title="Download Image">Download Image</a></div><div ng-if="permissionArr.indexOf(\'order_upload_image\') !== - 1"><a href="" class="change-userpic" ng-click="uploadPicture(item.item_id,\'regular\',getSortOrderNumber(item.item_increment_id))">Change Photo</a> <input type="file" name="FileUploadProfile{{getSortOrderNumber(item.item_increment_id)}}" ng-show="false" id="uploadImageFile{{getSortOrderNumber(item.item_increment_id)}}" ng-file-select="onFileSelect($files)" fileread="file"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><label class="control-label">Mask Image</label><div class="image-view" style="height:145px"><img ng-if="item.mask_thumb" ng-class="{\'img-border\':item.mask_thumb}" on-error-src="" style="max-width:100%;" height="140px" ng-src="{{item.mask_thumb}}"> <a ng-if="item.mask" class="down-class" href="" ng-click="downloadImage(item.item_increment_id,item.mask,\'mask\')" title="Download Mask Image"><i class="fa fa-download fa-2x"></i></a> <a ng-if="item.mask" class="down-class" href="{{item.mask}}" title="Open Image"><i class="fa fa-folder-open fa-2x"></i></a><div ng-class="{\'hide\':item.mask}" class="no-image">No Image</div></div><div ng-if="permissionArr.indexOf(\'order_upload_mask\') !== - 1"><a href="" class="change-userpic" ng-click="uploadMask(item.item_id,\'mask\',getSortOrderNumber(item.item_increment_id))" style="height: 30px; margin-top:50px;">Change Mask Image</a> <input type="file" name="FileUploadMask{{getSortOrderNumber(item.item_increment_id)}}" ng-show="false" id="uploadImageMask{{getSortOrderNumber(item.item_increment_id)}}" ng-file-select="onFileSelect($files)" fileread="file"></div><div ng-if="permissionArr.indexOf(\'order_make_mask\') !== - 1 && checkMaskImageStatus(item.item_status_code)"><button class="btn maskbutton" ng-click="makeMaskImage(item.item_id,\'mask\',getSortOrderNumber(item.item_increment_id),item.mask)" ng-if="item.mask != null && item.mask !=\'\'">Make Mask Image</button> <button class="btn maskbutton" ng-click="makeMaskImage(item.item_id,\'mask\',getSortOrderNumber(item.item_increment_id),item.regular)" ng-if="item.mask == null || item.mask ==\'\'">Make Mask Image</button></div></div></div><div class="row form-group"><div class="col-md-6"><a ng-if="item.has_2d_image ==\'enable\' && permissionArr.indexOf(\'2d_image_download\') !== - 1" href="" ng-click="downloadImage(item.item_increment_id,item.regular,\'regular\')" class="btn btn-primary btn-with-icon" style="background-color:#337ab7 !important;color:#fff !important"><i class="fa fa-download fa-lg"></i>2D Download</a></div><div class="col-md-6"><a ng-if="item.has_filedownload && permissionArr.indexOf(\'3d_image_download\') !== - 1" target="_self" ng-href="{{item.has_filedownload}}" download="" class="btn btn-primary btn-with-icon" style="background-color:#337ab7 !important;color:#fff !important"><i class="fa fa-download fa-lg"></i>File Download</a></div><div class="col-md-6" ng-show="showEditAndLogBtn(\'Copy Button\',item.item_status,\'copy_from_button\')" ng-if="item.regular == \'\' && item.show_is_copied != \'enable\' && permissionArr.indexOf(\'copy_from_button\') !== - 1"><button ng-click="openCopyProductDataForm()" style="margin-left: 10px;" class="btn btn-primary btn-with-icon" type="button"><i class="ion-android-download" title="Copy files"></i>Copy</button> <i ng-show="showEditAndLogBtn(\'Copy From Log\',item.item_status,\'copy_from_log_button\')" ng-if="permissionArr.indexOf(\'copy_from_log_button\') !== - 1" class="fa fa-history fa-lg cursor-pointer" title="View Copy Log" ng-click="openCopyProductDataLogForm(item.item_increment_id)"></i></div><div class="col-md-6" ng-show="showEditAndLogBtn(\'Re-Copy Button\',item.item_status,\'re_copy_from_button\')" ng-if="item.show_is_copied == \'enable\' && permissionArr.indexOf(\'re_copy_from_button\') !== - 1"><button ng-click="openCopyProductDataForm()" style="margin-left: 10px;" class="btn btn-success btn-with-icon" type="button"><i class="ion-android-download" title="Copy files"></i>RE-Copy</button> <i ng-show="showEditAndLogBtn(\'Copy From Log\',item.item_status,\'copy_from_log_button\')" ng-if="permissionArr.indexOf(\'copy_from_log_button\') !== - 1" class="fa fa-history fa-lg cursor-pointer" title="View Copy Log" ng-click="openCopyProductDataLogForm(item.item_increment_id)"></i></div><div ng-if="item.disable_copy_loader == \'enable\'" ng-init="disableCopyLoader(item.item_increment_id)"></div></div><div class="row form-group margin-top-3"><div ng-if="!m2_is_custom_options && checkIsTextArea(field.label)" ng-repeat="field in item.m2_custom_options"><div class="form-group clearfix"><div ng-if="field.label!=\'Enter Your Engraving\' && field.label!=\'Add Free Engraving\' && field.label!=\'Enter Your Message (Optional)\' && field.label!=\'Engraving\'"><label class="control-label">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <textarea ng-if="field.value != \'\'" rows="2" name="engraving" readonly="" class="form-control" placeholder="{{field.label}}" ng-model="field.value"></textarea> <textarea ng-if="field.value == \'\'" rows="2" name="engraving" readonly="" class="form-control" placeholder="{{field.label}}" ng-model="field.print_value"></textarea></div><div ng-if="field.label==\'Enter Your Engraving\' || field.label==\'Add Free Engraving\' || field.label==\'Engraving\' || field.label==\'Enter Your Message (Optional)\'"><div ng-if="item.engravingn" ng-init="isEngravingEdit=true"><div ng-show="isEngravingEdit==true"><label ng-if="!item.engravingn" class="control-label">{{field.label}}</label> <label ng-if="item.engravingn" class="control-label ng-binding label white label-tab ng-binding ng-scope" style="background-color: rgb(37, 197, 22);">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <span ng-show="subIndex == 0"><button style="margin-left:10px" ng-show="showEditAndLogBtn(\'Engraving Edit\',item.item_status,\'engraving_edit\')" ng-click="isEngravingEdit=false;killOrderDetailsTimer()" title="Edit Engraving" class="btn btn-edit btn-xs mr-3px">Edit</button> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i> <button ng-if="permissionArr.indexOf(\'copy_engraving\') !== - 1" style="margin-left:10px" clipboard="" text="item.engravingn" on-copied="success()" on-error="fail(err)" class="btn btn-info btn-xs">Copy Engraving</button></span> <textarea rows="2" readonly="" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="item.engravingn"></textarea></div><div ng-show="isEngravingEdit==false"><label ng-if="!item.engravingn" class="control-label">{{field.label}}</label> <label ng-if="item.engravingn" class="control-label ng-binding label white label-tab ng-binding ng-scope" style="background-color: rgb(37, 197, 22);">{{field.label}}</label> <span><i class="fa fa-check cursor-pointer icon-font-size text-green" title="Save Engraving" ng-click="saveEngraving(item,item.engravingn)"></i> <i class="fa fa-times cursor-pointer icon-font-size text-red" title="Cancel" ng-click="startOrderDetailsTimer();isEngravingEdit=true"></i> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i></span> <textarea rows="2" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="item.engravingn"></textarea></div></div><div ng-if="!item.engravingn" ng-init="isEngravingNEdit=true"><div ng-show="isEngravingNEdit==true"><label class="control-label">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <span ng-show="subIndex == 0"><button style="margin-left:10px" ng-show="showEditAndLogBtn(\'Engraving Edit\',item.item_status,\'engraving_edit\')" ng-click="isEngravingNEdit=false;killOrderDetailsTimer()" title="Edit Engraving" class="btn btn-edit btn-xs mr-3px">Edit</button> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i> <button ng-if="permissionArr.indexOf(\'copy_engraving\') !== - 1 && field.option_value" style="margin-left:10px" clipboard="" text="field.option_value" on-copied="success()" on-error="fail(err)" class="btn btn-info btn-xs">Copy Engraving</button> <button ng-if="permissionArr.indexOf(\'copy_engraving\') !== - 1 && !field.option_value" style="margin-left:10px" clipboard="" text="field.value" on-copied="success()" on-error="fail(err)" class="btn btn-info btn-xs">Copy Engraving</button></span> <textarea rows="2" readonly="" name="engraving" ng-if="field.option_value" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="field.option_value"></textarea> <textarea rows="2" readonly="" name="engraving" ng-if="!field.option_value" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="field.value"></textarea></div><div ng-show="isEngravingNEdit==false"><label class="control-label">{{field.label}}</label> <span><i class="fa fa-check cursor-pointer icon-font-size text-green" title="Save Engraving" ng-click="saveEngraving(item,field.option_value)"></i> <i class="fa fa-times cursor-pointer icon-font-size text-red" title="Cancel" ng-click="startOrderDetailsTimer();isEngravingNEdit=true"></i> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i></span> <textarea rows="2" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="field.option_value"></textarea></div></div></div></div></div><div ng-if="checkIsTextArea(field.label)" class="col-md-12" ng-repeat="field in item.product_options.options"><div class="form-group clearfix"><div ng-if="field.label!=\'Enter Your Engraving\' && field.label!=\'Add Free Engraving\' && field.label!=\'Engraving\'"><label class="control-label">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <textarea rows="2" name="engraving" readonly="" class="form-control" placeholder="{{field.label}}" ng-model="field.value"></textarea></div><div ng-if="field.label==\'Enter Your Engraving\' || field.label==\'Add Free Engraving\' || field.label==\'Engraving\'"><div ng-if="item.engravingn" ng-init="isEngravingEdit=true"><div ng-show="isEngravingEdit==true"><label ng-if="!item.engravingn" class="control-label">{{field.label}}</label> <label ng-if="item.engravingn" class="control-label ng-binding label white label-tab ng-binding ng-scope" style="background-color: rgb(37, 197, 22);">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <span ng-show="subIndex == 0"><button style="margin-left:10px" ng-show="showEditAndLogBtn(\'Engraving Edit\',item.item_status,\'engraving_edit\')" ng-click="isEngravingEdit=false;killOrderDetailsTimer()" title="Edit Engraving" class="btn btn-edit btn-xs mr-3px">Edit</button> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i> <button ng-if="permissionArr.indexOf(\'copy_engraving\') !== - 1" style="margin-left:10px" clipboard="" text="item.engravingn" on-copied="success()" on-error="fail(err)" class="btn btn-info btn-xs">Copy Engraving</button></span> <textarea rows="2" readonly="" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="item.engravingn"></textarea></div><div ng-show="isEngravingEdit==false"><label ng-if="!item.engravingn" class="control-label">{{field.label}}</label> <label ng-if="item.engravingn" class="control-label ng-binding label white label-tab ng-binding ng-scope" style="background-color: rgb(37, 197, 22);">{{field.label}}</label> <span><i class="fa fa-check cursor-pointer icon-font-size text-green" title="Save Engraving" ng-click="saveEngraving(item,item.engravingn)"></i> <i class="fa fa-times cursor-pointer icon-font-size text-red" title="Cancel" ng-click="startOrderDetailsTimer();isEngravingEdit=true"></i> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i></span> <textarea rows="2" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="item.engravingn"></textarea></div></div><div ng-if="!item.engravingn" ng-init="isEngravingNEdit=true"><div ng-show="isEngravingNEdit==true"><label class="control-label">{{field.label}}</label> <label ng-if="checkShowCheckBoxOrNot(field.label) && subIndex == 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label> <span ng-show="subIndex == 0"><button style="margin-left:10px" ng-show="showEditAndLogBtn(\'Engraving Edit\',item.item_status,\'engraving_edit\')" ng-click="isEngravingNEdit=false;killOrderDetailsTimer()" title="Edit Engraving" class="btn btn-edit btn-xs mr-3px">Edit</button> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i> <button ng-if="permissionArr.indexOf(\'copy_engraving\') !== - 1" style="margin-left:10px" clipboard="" text="field.value" on-copied="success()" on-error="fail(err)" class="btn btn-info btn-xs">Copy Engraving</button></span> <textarea rows="2" readonly="" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="field.value"></textarea></div><div ng-show="isEngravingNEdit==false"><label class="control-label">{{field.label}}</label> <span><i class="fa fa-check cursor-pointer icon-font-size text-green" title="Save Engraving" ng-click="saveEngraving(item,field.value)"></i> <i class="fa fa-times cursor-pointer icon-font-size text-red" title="Cancel" ng-click="startOrderDetailsTimer();isEngravingNEdit=true"></i> <i class="fa fa-history fa-lg cursor-pointer" ng-show="showEditAndLogBtn(\'Engraving Log\',item.item_status,\'engraving_log\')" title="View Log" ng-click="openEngravingLogModal(item.item_increment_id)"></i></span> <textarea rows="2" name="engraving" class="form-control mt-5px" placeholder="{{field.label}}" ng-model="field.value"></textarea></div></div></div></div></div></div></div><div class="col-md-4 other-info role-permission form-group panel-mb-5"><label class="control-label" ng-if="permissionArr.indexOf(\'office_comment_tab\') !== - 1 || permissionArr.indexOf(\'comment_tab\') !== - 1 || permissionArr.indexOf(\'designer_tab\') !== - 1 || permissionArr.indexOf(\'rework_tab\') !== - 1 || permissionArr.indexOf(\'qrcode_tab\') !== - 1 || permissionArr.indexOf(\'relay_tab\') !== - 1 || permissionArr.indexOf(\'file_upload_tab\') !== - 1 || permissionArr.indexOf(\'filerawmaterial_tab\') !== - 1">Other Info</label><uib-accordion close-others="false"><uib-accordion-group ng-if="permissionArr.indexOf(\'comment_tab\') !== - 1" ng-init="open1=(commentDataArr[item.item_increment_id].length > 0?true:false)" is-open="commentDataArrValidator" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': commentDataArrValidator, \'fa fa-angle-down fa-lg\': !commentDataArrValidator}"></i> <span class="accordion-title">Comments</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group clearfix"><textarea rows="2" name="comment" class="comment form-control bg-white" placeholder="Comment"></textarea> <span class="error hide-element">Required!</span></div></div></div><div class="row"><div class="col-md-12"><button type="button" ng-click="commentOrder($event,item.item_increment_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Comment</button><label ng-if="commentDataArr[item.item_increment_id].length > 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element pull-right" style="padding-right:5px"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div></div><div class="row"><div class="horizontal-scroll" ng-if="commentDataArr[item.item_increment_id].length > 0"><div class="col-md-12" style="padding-bottom:5px"><table class="table table-bordered table-align mt-5px"><thead><tr><th>Date | Time</th><th>User Name</th><th>Comment</th></tr></thead><tbody><tr ng-repeat="com in commentDataArr[item.item_increment_id]"><td>{{getGlobalDateFormat(com.created_at)}}</td><td>{{com.username}}</td><td><div style="width:110px;overflow:hidden" title="{{com.comment}}">{{com.comment}}</div></td></tr></tbody></table></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'office_comment_tab\') !== - 1" ng-init="open2=(officeCommentDataArr[item.item_increment_id].length > 0?true:false)" is-open="officeCommentDataArrValidator" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': officeCommentDataArrValidator, \'fa fa-angle-down fa-lg\': !officeCommentDataArrValidator}"></i> <span class="accordion-title">Office Comments</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group clearfix"><textarea rows="2" name="office_comment" class="office-comment form-control bg-white" placeholder="Office Comment"></textarea> <span class="error hide-element">Required!</span></div></div></div><div class="row"><div class="col-md-12"><button type="button" ng-click="officeCommentOrder($event,item.item_increment_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Comment</button> <label ng-if="officeCommentDataArr[item.item_increment_id].length > 0" class="custom-switch switcher-container chk-{{getSortOrderNumber(item.item_increment_id)}}_1 hide-element pull-right" style="padding-right:5px"><input type="checkbox" value="true" id="chk" ng-click="showQaApprove($event, getSortOrderNumber(item.item_increment_id))"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div></div><div class="row"><div class="horizontal-scroll" ng-if="officeCommentDataArr[item.item_increment_id].length > 0"><div class="col-md-12" style="padding-bottom:5px"><table class="table table-bordered table-align mt-5px"><thead><tr><th>Date | Time</th><th>User Name</th><th>Comment</th></tr></thead><tbody><tr ng-repeat="com in officeCommentDataArr[item.item_increment_id]"><td>{{getGlobalDateFormat(com.created_at)}}</td><td>{{com.username}}</td><td><div style="width:110px;overflow:hidden" title="{{com.comment}}">{{com.comment}}</div></td></tr></tbody></table></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'redesign_comment_tab\') !== - 1" ng-init="open2=(reDesignCommentDataArr[item.item_increment_id].length > 0?true:false)" is-open="reDesignCommentDataArrValidator" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': reDesignCommentDataArrValidator, \'fa fa-angle-down fa-lg\': !reDesignCommentDataArrValidator}"></i> <span class="accordion-title">ReDesign Comments</span></uib-accordion-heading><div class="row"><div class="horizontal-scroll" ng-if="reDesignCommentDataArr[item.item_increment_id].length > 0"><div class="col-md-12" style="padding-bottom:5px"><table class="table table-bordered table-align mt-5px"><thead><tr><th>Date | Time</th><th>User Name</th><th>Comment</th></tr></thead><tbody><tr ng-repeat="com in reDesignCommentDataArr[item.item_increment_id]"><td>{{getGlobalDateFormat(com.created_time)}}</td><td>{{com.user_name}}</td><td><div style="width:110px;overflow:hidden" title="{{com.comment}}">{{com.comment}}</div></td></tr></tbody></table></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'designer_tab\') !== - 1" ng-init="open3=false" is-open="open3" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open3, \'fa fa-angle-down fa-lg\': !open3}"></i> <span class="accordion-title">Designer Info</span></uib-accordion-heading><div ng-if="iconTools!=\'enable\'"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="designerName" class="control-label">Designer</label> <input type="text" readonly="" ng-model="item.employee_name" name="designerName" placeholder="Designer" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="jobStart" class="control-label">Job Start</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.job_start_date)}}" name="jobStart" placeholder="Job Start" class="form-control bg-white"></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="jobDone" class="control-label">Job Done</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.job_end_date)}}" name="jobDone" placeholder="Job Done" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="approvedBy" class="control-label">Approved By</label> <input type="text" readonly="" ng-model="item.approve_by" name="approvedBy" placeholder="Approved By" class="form-control bg-white"></div></div></div><div class="row" ng-show="item.approve_by != \'\'"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="TotalTimeTaken" class="control-label">Total time taken</label> <input type="text" readonly="" ng-model="item.time_taken" name="TotalTimeTaken" placeholder="Total time taken" class="form-control bg-white"></div></div></div></div><div ng-if="iconTools==\'enable\'"><div class="row"><div class="col-md-6"><div class="form-group clearfix"><label for="reworkDesigner" class="control-label">Rework Designer</label> <input id="reworkDesigner" type="text" readonly="" ng-model="item.trackerInfo.rework_designer" name="reworkDesigner" placeholder="Rework Designer" class="form-control bg-white"></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="reworkStart" class="control-label">Rework Start</label> <input id="reworkStart" type="text" readonly="" ng-model="item.trackerInfo.rework_job_start" name="reworkStart" placeholder="Rework Start" class="form-control bg-white"></div></div><div class="col-md-6"><div class="form-group clearfix"><label for="reworkDone" class="control-label">Rework Done</label> <input id="reworkDone" type="text" readonly="" ng-model="item.trackerInfo.rework_job_done" name="reworkDone" placeholder="Rework Done" class="form-control bg-white"></div></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'3d_designer_tab\') !== - 1" ng-init="open4=false" is-open="open4" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open4, \'fa fa-angle-down fa-lg\': !open4}"></i> <span class="accordion-title">3D Designer Info</span></uib-accordion-heading><div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="designerName" class="control-label">3D Designer</label> <input type="text" readonly="" ng-model="item.employee_name_3d" name="designerName" placeholder="Designer" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="job3dStart" class="control-label">3D Job Start</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.job_3d_start_date)}}" name="job3dStart" placeholder="Job Start" class="form-control bg-white"></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="job3dDone" class="control-label">3D Job Done</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.job_3d_end_date)}}" name="job3dDone" placeholder="Job Done" class="form-control bg-white"></div></div></div><div class="row" ng-show="item.approve_by != \'\'"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="TotalTimeTaken3D" class="control-label">Total time taken</label> <input type="text" readonly="" ng-model="item.time_taken_3d" name="TotalTimeTaken3D" placeholder="Total time taken" class="form-control bg-white"></div></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'rework_tab\') !== - 1 && iconTools==\'enable\'" ng-init="open4=true" is-open="open4" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open4, \'fa fa-angle-down fa-lg\': !open4}"></i> <span class="accordion-title">Rework Info</span></uib-accordion-heading><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Rework Reason</label> <input type="text" readonly="" ng-model="item.rework_reason" name="reworkReason" placeholder="Rework Reason" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Rework Solution</label> <input type="text" readonly="" ng-model="item.rework_solution" name="reworkSolution" placeholder="Rework Solution" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Ticket Id</label> <input type="text" readonly="" ng-model="item.ticket_id" name="ticketId" placeholder="Ticket Id" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Created By</label> <input type="text" readonly="" ng-model="item.rework_created_by" name="createdBy" placeholder="Created By" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Special Instruction</label> <textarea rows="2" readonly="" name="specialInstruction" ng-model="item.special_instruction" class="form-control bg-white" placeholder="Special Instruction"></textarea></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Quantity</label> <input type="text" readonly="" ng-model="item.rework_quantity" name="quantity" placeholder="Quantity" class="form-control bg-white"></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'qrcode_tab\') !== - 1" ng-init="open5=false" is-open="open5" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open5, \'fa fa-angle-down fa-lg\': !open5}"></i> <span class="accordion-title">Preview</span> <span ng-if="!qtyItem.prod_qty_id && item.requested_preview"><span ng-if="!item.preview_uploaded"><img width="20" height="20" ng-src="{{::typeIconUrl}}red_circle.png" alt="Red" align="right"></span> <span ng-if="item.preview_uploaded && !item.action_preview"><img width="20" height="20" ng-src="{{::typeIconUrl}}green_circle.png" alt="Green" align="right"></span> <span ng-if="item.preview_uploaded && item.action_preview == \'approve\'"><img width="20" height="20" ng-src="{{::typeIconUrl}}green_circle.png" alt="Green" align="right"></span> <span ng-if="item.preview_uploaded && item.action_preview == \'reject\'"><img width="20" height="20" ng-src="{{::typeIconUrl}}red_circle.png" alt="Red" align="right"></span></span> <span ng-if="qtyItem.prod_qty_id && qtyItem.requested_preview"><span ng-if="!qtyItem.preview_uploaded"><img width="20" height="20" ng-src="{{::typeIconUrl}}red_circle.png" alt="Red" align="right"></span> <span ng-if="qtyItem.preview_uploaded && !qtyItem.action_preview"><img width="20" height="20" ng-src="{{::typeIconUrl}}green_circle.png" alt="Green" align="right"></span> <span ng-if="qtyItem.preview_uploaded && qtyItem.action_preview == \'approve\'"><img width="20" height="20" ng-src="{{::typeIconUrl}}green_circle.png" alt="Green" align="right"></span> <span ng-if="qtyItem.preview_uploaded && qtyItem.action_preview == \'reject\'"><img width="20" height="20" ng-src="{{::typeIconUrl}}red_circle.png" alt="Red" align="right"></span></span></uib-accordion-heading><div class="row" ng-if="!qtyItem.prod_qty_id && !item.requested_preview"><button ng-if="!qtyItem.prod_qty_id" type="button" class="btn btn-info mr-3px" ng-click="requestPreview($event,item.item_id,\'\')">Request Preview</button></div><div class="row" ng-if="qtyItem.prod_qty_id && !qtyItem.requested_preview"><button ng-if="qtyItem.prod_qty_id" type="button" class="btn btn-info mr-3px" ng-click="requestPreview($event,item.item_id,qtyItem.prod_qty_id)">Request Preview</button></div><div class="row" ng-if="!qtyItem.prod_qty_id && item.requested_preview"><div ng-if="!item.action_preview"><div class="col-md-8"><div class="row"><div class="col-md-12 col-lg-12 col-sm-12"><div class="form-group clearfix"><input type="file" class="upload-file-manual" id="manualQRUpload" name="manualQRUpload"> <label for="manualQRUpload"><i class="fa fa-upload fa-lg"></i><span id="manualQRUpload-text">Choose a file&hellip;</span></label></div></div><div class="col-md-12"><div id="QRProgress" style="margin-bottom: 10px; display: none;"><div id="myBarQR" class="progress-bar-striped" style="height: 20px; width: 0%;"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" ng-disabled="item.qr_is_manual_Uploaded==\'enable\'" ng-click="uploadQRManual($event,item.item_id,\'\')">Upload</button></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_time" class="control-label">Preview Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_job_start)}}" name="uploaded_preview_time" placeholder="Preview Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_name" class="control-label">User Name</label> <input type="text" readonly="" value="{{item.preview_job_user}}" name="uploaded_preview_name" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row" ng-if="item.preview_job_end"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_time" class="control-label">Upload Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_job_end)}}" name="uploaded_image_time" placeholder="Upload Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_name" class="control-label">Upload User Name</label> <input type="text" readonly="" value="{{item.preview_job_user}}" name="uploaded_image_name" placeholder="Upload User Name" class="form-control bg-white relay-user-name"></div></div></div></div><div class="col-md-4 text-center"><img ng-if="item.preview_image_path" width="120" height="120" ng-src="{{ item.preview_thumb_path }}" alt="{{ item.preview_thumb_path }}"> <a ng-if="item.preview_image_path" class="down-class" href="" ng-click="downloadPreview(item.item_increment_id,item.preview_image_path,\'\')" title="Download Photo"><i class="fa fa-download fa-2x"></i></a><div ng-if="item.preview_thumb_path"><br><br><button type="button" class="btn btn-success mr-3px" ng-click="actionPreview(item.item_id,\'\',\'approve\')">Approve</button><br><br><button type="button" class="btn btn-danger mr-3px" ng-click="actionPreview(item.item_id,\'\',\'reject\')">Reject</button></div></div></div><div ng-if="item.action_preview == \'approve\'"><div class="col-md-8"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_time" class="control-label">Preview Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_job_start)}}" name="uploaded_preview_time" placeholder="Preview Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_name" class="control-label">User Name</label> <input type="text" readonly="" value="{{item.preview_job_user}}" name="uploaded_preview_name" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row" ng-if="item.preview_job_end"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_time" class="control-label">Upload Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_job_end)}}" name="uploaded_image_time" placeholder="Upload Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_name" class="control-label">Upload User Name</label> <input type="text" readonly="" value="{{item.preview_job_user}}" name="uploaded_image_name" placeholder="Upload User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Approved At</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_approve_at)}}" placeholder="Approved At" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Approved By</label> <input type="text" readonly="" value="{{item.preview_approve_user}}" placeholder="Approved By" class="form-control bg-white"></div></div></div></div><div class="col-md-4 text-center"><img ng-if="item.preview_image_path" width="120" height="120" ng-src="{{ item.preview_thumb_path }}" alt="{{ item.preview_thumb_path }}"> <a ng-if="item.preview_image_path" class="down-class" href="" ng-click="downloadPreview(item.item_increment_id,item.preview_image_path,\'\')" title="Download Photo"><i class="fa fa-download fa-2x"></i></a></div></div><div ng-if="item.action_preview == \'reject\'"><div class="col-md-8"><div class="row"><div class="col-md-12 col-lg-12 col-sm-12"><div class="form-group clearfix"><input type="file" class="upload-file-manual" id="manualQRUpload" name="manualQRUpload"> <label for="manualQRUpload"><i class="fa fa-upload fa-lg"></i><span id="manualQRUpload-text">Choose a file&hellip;</span></label></div></div><div class="col-md-12"><div id="QRProgress" style="margin-bottom: 10px; display: none;"><div id="myBarQR" class="progress-bar-striped" style="height: 20px; width: 0%;"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" ng-disabled="item.qr_is_manual_Uploaded==\'enable\'" ng-click="uploadQRManual($event,item.item_id,\'\')">Upload</button></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_time" class="control-label">Preview Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_job_start)}}" name="uploaded_preview_time" placeholder="Preview Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_name" class="control-label">User Name</label> <input type="text" readonly="" value="{{item.preview_job_user}}" name="uploaded_preview_name" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row" ng-if="item.preview_job_end"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_time" class="control-label">Upload Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_job_end)}}" name="uploaded_image_time" placeholder="Upload Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_name" class="control-label">Upload User Name</label> <input type="text" readonly="" value="{{item.preview_job_user}}" name="uploaded_image_name" placeholder="Upload User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Rejected At</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.preview_reject_at)}}" placeholder="Rejected At" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Rejected By</label> <input type="text" readonly="" value="{{item.preview_reject_user}}" placeholder="Rejected By" class="form-control bg-white"></div></div></div></div><div class="col-md-4 text-center"><img ng-if="item.preview_image_path" width="120" height="120" ng-src="{{ item.preview_thumb_path }}" alt="{{ item.preview_thumb_path }}"> <a ng-if="item.preview_image_path" class="down-class" href="" ng-click="downloadPreview(item.item_increment_id,item.preview_image_path,\'\')" title="Download Photo"><i class="fa fa-download fa-2x"></i></a></div></div></div><div class="row" ng-if="qtyItem.prod_qty_id && qtyItem.requested_preview"><div ng-if="!qtyItem.action_preview"><div class="col-md-8"><div class="row"><div class="col-md-12 col-lg-12 col-sm-12"><div class="form-group clearfix"><input type="file" class="upload-file-manual" id="manualQRUpload" name="manualQRUpload"> <label for="manualQRUpload"><i class="fa fa-upload fa-lg"></i><span id="manualQRUpload-text">Choose a file&hellip;</span></label></div></div><div class="col-md-12"><div id="QRProgress" style="margin-bottom: 10px; display: none;"><div id="myBarQR" class="progress-bar-striped" style="height: 20px; width: 0%;"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" ng-disabled="qtyItem.qr_is_manual_Uploaded==\'enable\'" ng-click="uploadQRManual($event,qtyItem.quote_id,qtyItem.prod_qty_id)">Upload</button></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_time" class="control-label">Preview Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_job_start)}}" name="uploaded_preview_time" placeholder="Preview Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_name" class="control-label">User Name</label> <input type="text" readonly="" value="{{qtyItem.preview_job_user}}" name="uploaded_preview_name" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row" ng-if="qtyItem.preview_job_end"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_time" class="control-label">Upload Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_job_end)}}" name="uploaded_image_time" placeholder="Upload Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_name" class="control-label">Upload User Name</label> <input type="text" readonly="" value="{{qtyItem.preview_job_user}}" name="uploaded_image_name" placeholder="Upload User Name" class="form-control bg-white relay-user-name"></div></div></div></div><div class="col-md-4 text-center"><img ng-if="qtyItem.preview_thumb_path" width="120" height="120" ng-src="{{ qtyItem.preview_thumb_path }}" alt="{{ qtyItem.preview_thumb_path }}"> <a ng-if="qtyItem.preview_image_path" class="down-class" href="" ng-click="downloadPreview(qtyItem.parent_id,qtyItem.preview_image_path,qtyItem.prod_qty_id)" title="Download Photo"><i class="fa fa-download fa-2x"></i></a><div ng-if="qtyItem.preview_thumb_path"><br><br><button type="button" class="btn btn-success mr-3px" ng-click="actionPreview(qtyItem.quote_id,qtyItem.prod_qty_id,\'approve\')">Approve</button><br><br><button type="button" class="btn btn-danger mr-3px" ng-click="actionPreview(qtyItem.quote_id,qtyItem.prod_qty_id,\'reject\')">Reject</button></div></div></div><div ng-if="qtyItem.action_preview == \'approve\'"><div class="col-md-8"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_time" class="control-label">Preview Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_job_start)}}" name="uploaded_preview_time" placeholder="Preview Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_name" class="control-label">User Name</label> <input type="text" readonly="" value="{{qtyItem.preview_job_user}}" name="uploaded_preview_name" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row" ng-if="qtyItem.preview_job_end"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_time" class="control-label">Upload Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_job_end)}}" name="uploaded_image_time" placeholder="Upload Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_name" class="control-label">Upload User Name</label> <input type="text" readonly="" value="{{qtyItem.preview_job_user}}" name="uploaded_image_name" placeholder="Upload User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Approved At</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_approve_at)}}" placeholder="Approved At" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Approved By</label> <input type="text" readonly="" value="{{qtyItem.preview_approve_user}}" placeholder="Approved By" class="form-control bg-white"></div></div></div></div><div class="col-md-4 text-center"><img ng-if="qtyItem.preview_thumb_path" width="120" height="120" ng-src="{{ qtyItem.preview_thumb_path }}" alt="{{ qtyItem.preview_thumb_path }}"> <a ng-if="qtyItem.preview_image_path" class="down-class" href="" ng-click="downloadPreview(item.item_increment_id,qtyItem.preview_image_path,qtyItem.prod_qty_id)" title="Download Photo"><i class="fa fa-download fa-2x"></i></a></div></div><div ng-if="qtyItem.action_preview == \'reject\'"><div class="col-md-8"><div class="row"><div class="col-md-12 col-lg-12 col-sm-12"><div class="form-group clearfix"><input type="file" class="upload-file-manual" id="manualQRUpload" name="manualQRUpload"> <label for="manualQRUpload"><i class="fa fa-upload fa-lg"></i><span id="manualQRUpload-text">Choose a file&hellip;</span></label></div></div><div class="col-md-12"><div id="QRProgress" style="margin-bottom: 10px; display: none;"><div id="myBarQR" class="progress-bar-striped" style="height: 20px; width: 0%;"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" ng-disabled="qtyItem.qr_is_manual_Uploaded==\'enable\'" ng-click="uploadQRManual($event,qtyItem.quote_id,qtyItem.prod_qty_id)">Upload</button></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_time" class="control-label">Preview Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_job_start)}}" name="uploaded_preview_time" placeholder="Preview Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_preview_name" class="control-label">User Name</label> <input type="text" readonly="" value="{{qtyItem.preview_job_user}}" name="uploaded_preview_name" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row" ng-if="qtyItem.preview_job_end"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_time" class="control-label">Upload Request Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_job_end)}}" name="uploaded_image_time" placeholder="Upload Request Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded_image_name" class="control-label">Upload User Name</label> <input type="text" readonly="" value="{{qtyItem.preview_job_user}}" name="uploaded_image_name" placeholder="Upload User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Rejected At</label> <input type="text" readonly="" value="{{getGlobalDateFormat(qtyItem.preview_reject_at)}}" placeholder="Rejected At" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Rejected By</label> <input type="text" readonly="" value="{{qtyItem.preview_reject_user}}" placeholder="Rejected By" class="form-control bg-white"></div></div></div></div><div class="col-md-4 text-center"><img ng-if="qtyItem.preview_image_path" width="120" height="120" ng-src="{{ qtyItem.preview_thumb_path }}" alt="{{ qtyItem.preview_thumb_path }}"> <a ng-if="qtyItem.preview_image_path" class="down-class" href="" ng-click="downloadPreview(qtyItem.item_increment_id,qtyItem.preview_image_path,qtyItem.prod_qty_id)" title="Download Photo"><i class="fa fa-download fa-2x"></i></a></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'relay_tab\') !== - 1" ng-init="open6=false" is-open="open6" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open6, \'fa fa-angle-down fa-lg\': !open6}"></i> <span class="accordion-title">Relay</span></uib-accordion-heading><div ng-init="enableSettings=true"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="jobService" class="control-label">Job Service</label><select id="jobService" class="form-control bg-white job-service-single disable-opacity" value="{{item.job_service}}" name="jobService" ng-disabled="enableSettings"><option value="">Select Job Service</option><option value="{{job.value}}" ng-selected="job.set_default==\'1\' || job.value==item.job_service" ng-repeat="job in jobService">{{job.label}}</option></select></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="priority" class="control-label">Priority</label><select id="priority" class="form-control bg-white priority-single disable-opacity" value="{{item.priority}}" name="priority" ng-disabled="enableSettings"><option value="">Select Priority</option><option value="{{prty.hours}}" ng-selected="prty.hours==item.priority" ng-repeat="prty in priority">{{prty.name}}</option></select></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded" class="control-label">Uploaded Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.relay_job_done)}}" name="uploaded" placeholder="Uploaded Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="relayUserName" class="control-label">User Name</label> <input type="text" readonly="" value="{{item.relay_created_by}}" name="relayUserName" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'relay_upload_manually\') !== - 1 && item.is_relay!=\'enable\'" type="button" class="btn btn-info mr-3px" ng-disabled="enableSettings" ng-click="saveRelaySettings($event,item.item_id,item.job_service,item.priority)">Upload Manually</button> <button ng-show="permissionArr.indexOf(\'relay_edit_settings\') !== - 1 && item.is_relay!=\'enable\'" type="button" class="btn btn-info mr-3px" ng-click="enableSettings=false;killOrderDetailsTimer()">Edit Settings</button> <button type="button" class="btn btn-danger" ng-click="openRelayLogModal(item.item_increment_id)">Relay Log</button></div></div><div ng-if="permissionArr.indexOf(\'get_relay_links_button\') !== - 1" class="row" style="margin-top:8px;"><div class="col-md-6"><button type="button" class="btn btn-danger" ng-click="getRelayFilesManually(item.item_id)">Get Relay Links</button></div><div class="col-md-6" ng-if="permissionArr.indexOf(\'delete_relay_button\') !== - 1"><button type="button" class="btn btn-danger" ng-click="deleteRelayJobManually(item.item_id)">Delete Relay Job</button></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'new_relay_tab\') !== - 1" ng-init="open7=false" is-open="open7" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open7, \'fa fa-angle-down fa-lg\': !open7}"></i> <span class="accordion-title">New Relay</span></uib-accordion-heading><div ng-init="enableSettings=true"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="newjobService" class="control-label">Job Service</label><select id="newjobService" class="form-control bg-white new-job-service-single disable-opacity" value="{{item.job_service}}" name="newjobService" ng-disabled="enableSettings"><option value="">Select Job Service</option><option value="{{job.value}}" ng-selected="job.set_default==\'1\' || job.value==item.job_service" ng-repeat="job in jobService">{{job.label}}</option></select></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="newpriority" class="control-label">Priority</label><select id="newpriority" class="form-control bg-white new-priority-single disable-opacity" value="{{item.priority}}" name="newpriority" ng-disabled="enableSettings"><option value="">Select Priority</option><option value="{{prty.hours}}" ng-selected="prty.hours==item.priority" ng-repeat="prty in priority">{{prty.name}}</option></select></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded" class="control-label">Uploaded Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.relay_job_done)}}" name="uploaded" placeholder="Uploaded Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="relayUserName" class="control-label">User Name</label> <input type="text" readonly="" value="{{item.relay_created_by}}" name="relayUserName" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'relay_upload_manually\') !== - 1 && item.is_relay!=\'enable\'" type="button" class="btn btn-info mr-3px" ng-disabled="enableSettings" ng-click="saveNewRelaySettings($event,item.item_id,item.job_service,item.priority)">New Upload Manually</button> <button ng-show="permissionArr.indexOf(\'relay_edit_settings\') !== - 1 && item.is_relay!=\'enable\'" type="button" class="btn btn-info mr-3px" ng-click="enableSettings=false;killOrderDetailsTimer()">Edit Settings</button> <button type="button" class="btn btn-danger" ng-click="openRelayLogModal(item.item_increment_id)">Relay Log</button></div></div><div ng-if="permissionArr.indexOf(\'get_relay_links_button\') !== - 1" class="row" style="margin-top:8px;"><div class="col-md-6"><button type="button" class="btn btn-danger" ng-click="getRelayFilesManually(item.item_id)">Get Relay Links</button></div><div class="col-md-6" ng-if="permissionArr.indexOf(\'delete_relay_button\') !== - 1"><button type="button" class="btn btn-danger" ng-click="deleteRelayJobManually(item.item_id)">Delete Relay Job</button></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'file_upload_tab\') !== - 1" ng-init="open7=false" is-open="open7" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open7, \'fa fa-angle-down fa-lg\': !open7}"></i> <span class="accordion-title">Upload</span></uib-accordion-heading><div style="position:relative"><div class="row"><div class="col-md-12 col-lg-7 col-sm-6" style="margin-bottom: 15px;"><div class="form-group clearfix"><input type="file" class="upload-file-manual" id="manualFileUpload" name="manualFileUpload"> <label ng-click="uploadPicture()" for="manualFileUpload"><i class="fa fa-upload fa-lg"></i><span id="manualFileUpload-text">Choose a file&hellip;</span></label></div></div><div class="col-md-12"><div id="Progress" style="margin-bottom: 10px; display: none;"><div id="myBar" class="progress-bar-striped" style="height: 15px; width: 0%;"></div></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="uploaded" class="control-label">Uploaded Time</label> <input type="text" readonly="" value="{{getGlobalDateFormat(item.file_uploaded_at)}}" name="fileUploadedAt" placeholder="Uploaded Time" class="form-control bg-white"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="relayUserName" class="control-label">User Name</label> <input type="text" readonly="" value="{{item.file_created_by}}" name="fileUserName" placeholder="User Name" class="form-control bg-white relay-user-name"></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" ng-disabled="item.file_is_manual_Uploaded==\'enable\'" ng-click="uploadFileManual($event,item.item_id)">Upload</button> <button ng-show="item.file_is_manual_Uploaded==\'enable\'" type="button" class="btn btn-info mr-3px" ng-click="uploadFileManual($event,item.item_id)">Re-upload</button></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'damage_details_tab\') !== - 1 && item.is_damage_crystal_create == true" ng-init="open8=( item.is_damage_crystal_create == true ? true : false)" is-open="open8" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open8, \'fa fa-angle-down fa-lg\': !open8}"></i> <span class="accordion-title">Damage Details</span></uib-accordion-heading><div class="row"><div class="col-md-6 col-lg-6 col-sm-6"><div class="form-group clearfix"><label for="Special-Instruction" class="control-label">Special Instruction</label> <textarea style="height:170px;" readonly="" class="form-control bg-white" placeholder="Special Instruction"> {{item.damage_crystal_special_instruction}} </textarea></div></div><div class="col-md-6 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Reason</label> <textarea readonly="" class="form-control bg-white" placeholder="Reason">{{item.damage_crystal_reason}}</textarea></div></div><div class="col-md-6 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Approved By</label> <input type="text" readonly="" value="{{item.damage_crystal_approved_by}}" placeholder="Approved By" class="form-control bg-white"></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'filerawmaterial_tab\') !== - 1" ng-init="open8=false" is-open="open8" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open8, \'fa fa-angle-down fa-lg\': !open8}"></i> <span class="accordion-title">File Raw Material Info</span></uib-accordion-heading><div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Reason</label><br>{{ fileRawMaterial.reason }}</div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Special Instruction</label><br>{{ fileRawMaterial.special_instruction }}</div></div></div><div class="row" ng-show="fileRawMaterial.approved_by_user != \'\'"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Approved By</label><br>{{ fileRawMaterial.approved_by_user }}</div></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'rework_relay_tab\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': rework_description, \'fa fa-angle-down fa-lg\': !rework_description}"></i> <span class="accordion-title">Relay Rework</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group clearfix"><textarea rows="2" name="rework_description" class="rework-comment form-control bg-white" placeholder="Rework Description"></textarea> <span class="error hide-element">Required!</span></div></div></div><div class="row"><div class="col-md-12"><button type="button" ng-click="relayReworkOrder($event,item.item_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Rework</button></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'rework_new_relay_tab\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': new_rework_description, \'fa fa-angle-down fa-lg\': !new_rework_description}"></i> <span class="accordion-title">New Relay Rework</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group clearfix"><textarea rows="2" name="new_rework_description" class="new-rework-comment form-control bg-white" placeholder="Rework Description"></textarea> <span class="error hide-element">Required!</span></div></div></div><div class="row"><div class="col-md-12"><button type="button" ng-click="newRelayReworkOrder($event,item.item_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Rework</button></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'check_database_job_link\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': get_database_job, \'fa fa-angle-down fa-lg\': !get_database_job}"></i> <span class="accordion-title">Get Database Job</span></uib-accordion-heading><div class="row"><div class="col-md-12 col-lg-12 col-sm-12"><div class="row"><div class="col-md-12 col-lg-7 col-sm-6" style="margin-bottom: 15px;"><div class="form-group clearfix"><input type="file" class="upload-file-manual" id="manualDatabaseUpload" name="manualDatabaseUpload"> <label for="manualDatabaseUpload"><i class="fa fa-upload fa-lg"></i><span id="manualFileUpload-text">Choose a file&hellip;</span></label></div></div><div class="col-md-12"><div id="DatabaseProgress" style="margin-bottom: 10px; display: none;"><div id="myProgressBar" class="progress-bar-striped" style="height: 15px; width: 0%;"></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" id="uploadDatabaseButton" ng-click="uploadDatabaseFile($event,item.item_id)">Upload</button></div></div></div></div><div class="row"><div class="col-md-12"><button type="button" ng-if="item.is_database_job_download ==\'enable\' && permissionArr.indexOf(\'new_relay_vmj_file_download\') !== - 1 && readyEncrypted==\'No\'" ng-click="deleteDatabaseJob($event,item.item_id)" class="pull-left btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fas fa-trash"></i> Delete Database Job</button> <button type="button" ng-click="getDatabaseJob($event,item.item_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Get Database Job</button></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'check_machine_files_link\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': get_machine_files, \'fa fa-angle-down fa-lg\': !get_machine_files}"></i> <span class="accordion-title">Get Machine File</span></uib-accordion-heading><div class="row"><div class="col-md-12"><button type="button" ng-click="getMachineFile($event,item.item_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Get Machine File</button> <button type="button" ng-if="item.file_is_manual_Uploaded ==\'enable\'" ng-click="deleteMachineFile($event,item.item_id)" class="pull-left btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fas fa-trash"></i> Delete Machine File</button></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'check_database_slot_info\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': get_database_slot, \'fa fa-angle-down fa-lg\': !get_database_slot}"></i> <span class="accordion-title">Get Database Slot Info</span></uib-accordion-heading><div class="row" ng-if="item.quantityList.length == 0"><div class="col-md-12 col-lg-12 col-sm-12"><button type="button" ng-if="permissionArr.indexOf(\'delete_database_slot_info\') !== - 1" ng-click="deleteJob($event,item.item_increment_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fas fa-trash"></i> Delete Job</button></div></div><div class="row" ng-if="item.quantityList.length == 0"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Machine Name:</label><br>{{item.machine_name}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Slot:</label><br>{{item.slot_name}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Created Date:</label><br>{{getGlobalDateFormat(item.datecreate_dat)}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Slotted Date:</label><br>{{getGlobalDateFormat(item.dateslot_dat)}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Engraving Time:</label><br>{{item.timeengrave_tim}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Printed Date:</label><br>{{getGlobalDateFormat(item.datedone_dat)}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Status:</label><br>{{item.slot_status}}</div></div><div class="col-md-12 col-lg-6 col-sm-6" ng-if="permissionArr.indexOf(\'create_database_job\') !== - 1"><button type="button" ng-click="createDatabaseJob($event,item.item_id,0)" ng-if="item.job_slot_id == 0" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Create Database Job</button></div></div><div class="row" ng-if="item.quantityList.length > 0"><div class="col-md-12 col-lg-12 col-sm-12"><button type="button" ng-if="permissionArr.indexOf(\'delete_database_slot_info\') !== - 1" ng-click="deleteJob($event,qtyItem.parent_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fas fa-trash"></i> Delete Job</button></div></div><div class="row" ng-if="item.quantityList.length > 0"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Machine Name:</label><br>{{qtyItem.machine_name}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Slot:</label><br>{{qtyItem.slot_name}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Created Date:</label><br>{{getGlobalDateFormat(qtyItem.datecreate_dat)}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Slotted Date:</label><br>{{getGlobalDateFormat(qtyItem.dateslot_dat)}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Engraving Time:</label><br>{{qtyItem.timeengrave_tim}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Printed Date:</label><br>{{getGlobalDateFormat(qtyItem.datedone_dat)}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Status:</label><br>{{qtyItem.slot_status}}</div></div><div class="col-md-12 col-lg-6 col-sm-6" ng-if="permissionArr.indexOf(\'create_database_job\') !== - 1"><button type="button" ng-click="createDatabaseJob($event,item.item_id,qtyItem.prod_qty_id)" ng-if="qtyItem.job_slot_id == 0" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fa fa-list-alt"></i>Create Database Job</button></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'delete_product\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': delete_product, \'fa fa-angle-down fa-lg\': !delete_product}"></i> <span class="accordion-title">Delete Product</span></uib-accordion-heading><div class="row"><div class="col-md-12"><button type="button" ng-click="deleteProduct($event,item.item_id)" class="pull-right btn btn-xs btn-danger btn-with-icon comment-btn-cls"><i class="fas fa-trash"></i> Delete Product</button></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'check_allocation_info\') !== - 1" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': check_allocation_info, \'fa fa-angle-down fa-lg\': !check_allocation_info}"></i> <span class="accordion-title">Allocation Info</span></uib-accordion-heading><div class="row" ng-if="item.quantityList.length == 0"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Allocation ID:</label><br>{{item.allocation_id}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Allocation By:</label><br>{{item.allocation_by}}</div></div></div><div class="row" ng-if="item.quantityList.length > 0"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Allocation ID:</label><br>{{qtyItem.allocation_id}}</div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group clearfix"><label class="control-label">Allocation By:</label><br>{{item.allocation_by}}</div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'direct_file_upload_tab\') !== - 1" ng-init="open9=false" is-open="open9" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open9, \'fa fa-angle-down fa-lg\': !open9}"></i> <span class="accordion-title">Upload</span></uib-accordion-heading><div style="position:relative"><div class="row"><div class="col-md-12 col-lg-7 col-sm-6" style="margin-bottom: 15px;"><div class="form-group clearfix"><input type="file" class="upload-direct-file" id="directFileUpload" name="directFileUpload"> <label for="directFileUpload"><i class="fa fa-upload fa-lg"></i><span id="directFileUpload-text">Choose a file&hellip;</span></label></div></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-info mr-3px" ng-click="directFileUploadS3(item.item_increment_id,item.item_id,item.order_id)">Upload</button></div></div></div></uib-accordion-group><uib-accordion-group ng-if="permissionArr.indexOf(\'direct_file_upload_digitalocean_tab\') !== - 1" ng-init="open9=false" is-open="open9" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon accordion-icon" ng-class="{\'fa fa-angle-up fa-lg\': open9, \'fa fa-angle-down fa-lg\': !open9}"></i> <span class="accordion-title">Upload DigitalOcean</span></uib-accordion-heading><div style="position:relative"><div class="row"><div class="col-md-12 col-lg-7 col-sm-6" style="margin-bottom: 15px;"><div class="form-group clearfix"><input type="file" class="upload-direct-file" id="directFileUploadDigitalOcean" name="directFileUploadDigitalOcean"> <label for="directFileUploadDigitalOcean"><i class="fa fa-upload fa-lg"></i><span id="directFileUploadDigitalOcean-text">Choose a file&hellip;</span></label></div></div></div><div class="row"><div class="col-md-12"><button type="button" id="btnFileUploadDigitalOcean" class="btn btn-info mr-3px" ng-click="directFileUploadDigitalOcean($event,item.item_increment_id,item.item_id,item.order_id)">Upload</button></div></div></div></uib-accordion-group></uib-accordion></div></div><div id="verifySecurityKey" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Please verify security key</span> <button type="button" class="close" ng-click="closeverifySecurityKey()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div class="datatable-scroll"><div class="uName">Scan</div><div class="verified">If security verified the download button will be appear</div><div class="cristal_info"><div class="msg_cond input-div-class" id="input-div-class"><input id="downloadEncryptionInput" type="text" name="encryptedText" class="crista_name encypted-dnowload-button encryptedInput" placeholder="Enter Order Id" ng-model="encryptedText" ng-blur="scanBarcode(encryptedText, item.item_increment_id, item.name, item.sku)" ng-enter="scanBarcode(encryptedText, item.item_increment_id, item.name, item.sku)" ng-focus="RemoveMsg()"></div><button id="verifySecurityKeyDownloadButton" type="button" class="crista_dwld" style="display: none" ng-model="encryptedTextData" ng-click="downloadEncryptedFile(encryptedTextData)">Download</button> <button id="disableButtonOfDownload" type="button" class="crista_disable_btn" style="display: none" ng-click="resetEncryptedText()">Reset</button></div></div></div></div></div></div><div id="openCopyProductDataPopUp" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Please enter id</span> <button type="button" class="close" ng-click="closeCopyProductDataForm()" aria-label="Close">x</button></div><div class="modal-body text-center log-modal-height"><div class="datatable-scroll" style="height:300px;"><div class="cristal_info"><div class="row"><div class="msg_cond2 input-div-class col-md-12" id="input-div-class"><div class="col-md-12 main-copy-div"><button id="copyPopUpPasteButton" type="button" class="col-md-3 btn btn-primary copyPopUpPasteButton" ng-click="pasteCopiedOrderNumber()">Paste</button> <input id="copyFileButton" type="text" name="copyFromProductId" class="crista_name_copy encypted-dnowload-button encryptedInput" placeholder="Enter Product Id" ng-model="copyFromProductId" uib-typeahead="orderno for orderno in getOrderNumber($viewValue)" autocomplete="off" typeahead-focus-on-select="false" typeahead-select-on-blur="true"></div></div><button id="verifySecurityKeyDownloadButtonxx" type="button" class="submit_copy_file" ng-click="copyProductData(item.item_increment_id)">Submit</button></div></div></div></div></div></div></div><div id="open3DJobStartPopUp" class="modal fade" role="dialog"><div class="modal-dialog log-modal"><div class="modal-content order-details-model"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center"><div class="datatable-scroll" style="height:150px;"><div class="add-one"><select class="form-control-add-one" name="3djobcategory" id="3djobcategory" required=""><option value="0">3D Category Addon</option><option value="{{addOneitem.value}}" cls="{{addOneitem.name}}" cost="{{addOneitem.price}}" ng-repeat="addOneitem in addOneCatData.cat.cat_type">{{addOneitem.title}}</option></select><span id="err3djobcategory" style="color:#FFFFFF;font-size: 16px;"></span></div></div></div><div class="modal-footer"><a class="btn btn-lg btn-success" style="float:left;margin-left:30px;font-size: 20px !important;" ng-click="yes3DJobStart();">Apply</a> <button type="button" class="btn btn-lg btn-warning" style="margin-right:30px;font-size: 20px !important;" ng-click="close3DJobStartPopUp()">Cancel</button></div></div></div></div><div id="makeMaskPopup" class="modal fade" role="dialog"><div class="modal-dialog log-modal"><script src="https://cdnjs.cloudflare.com/ajax/libs/konva/8.3.3/konva.min.js"></script><div class="modal-content order-details-model" style="max-width:100%;max-height:100%;height:80%;width:80%;top:40%"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Create Mask Image</span> <button type="button" class="close" ng-click="closeMaskImage()" aria-label="Close">X</button></div><div class="modal-body text-center"><div id="container" style="height: 600px;"></div><div class="toolbar"><div><label>Brush Type:</label> <button id="red-brush" class="color-brush selected" ng-click="addBrush(\'rgba(255, 0, 0, 0.4)\', \'red-brush\')">Disregard</button> <button id="green-brush" class="color-brush" ng-click="addBrush(\'rgba(0, 255, 0, 0.4)\', \'green-brush\')">Keep</button> <button id="blue-brush" class="color-brush" ng-click="addBrush(\'rgba(0, 0, 255, 0.4)\', \'blue-brush\')">Keep as 2D</button></div></div><div class="toolbar toolbar-center"><button id="save" class="action-button" ng-click="saveMaskImage(item.item_increment_id)">Save</button></div></div><div class="modal-footer"></div></div></div></div><style type="text/css">\r\n  .upload-file-manual{\r\n    /*width: 0.1px;\r\n    height: 0.1px;\r\n    opacity: 0;\r\n    overflow: hidden;\r\n    position: absolute;\r\n    z-index: -1;*/\r\n    margin-left: 64px;\r\n    margin-top: 7px;\r\n  }\r\n  .upload-file-manual::focus{\r\n    outline: none !important;\r\n    box-shadow: none !important;\r\n  }\r\n  input.upload-file-manual + label{\r\n    background-color: #d3394c;\r\n    margin: 0;\r\n    padding: 9px 12px;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    transition: all 0.1s ease;\r\n    -ms-transition: all 0.1s ease;\r\n    -webkit-transition: all 0.1s ease;\r\n    border: 1px solid #c31d31;\r\n    position: absolute;\r\n    top: 0;\r\n    z-index: 99;\r\n  }\r\n  /*input.upload-file-manual + label:hover{\r\n    transform: scale(1.13);\r\n    -ms-transform: scale(1.13);\r\n    -webkit-transform: scale(1.13);\r\n    transition: all 0.1s ease;\r\n    -ms-transition: all 0.1s ease;\r\n    -webkit-transition: all 0.1s ease;\r\n    border-color: \r\n  }*/\r\n  input.upload-file-manual + label i{\r\n    color: #fff;\r\n    margin-right: 10px;\r\n  }\r\n  .modal .modal-dialog input.upload-file-manual + label span{\r\n    color: #fff;\r\n    font-weight: normal;\r\n    font-size: 15px;\r\n  }\r\n  @-moz-document url-prefix() {\r\n    .upload-file-manual{\r\n      margin-left: 82px;\r\n    }\r\n  }\r\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none){\r\n    .upload-file-manual{\r\n      opacity: 0;\r\n    }\r\n  }\r\n\r\n  #container {\r\n            border: 1px solid #ccc;\r\n            background-color: black;\r\n        }\r\n        .toolbar {\r\n            margin-top: 20px;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            width: 100%;\r\n            max-width: 800px;\r\n        }\r\n        .toolbar div {\r\n            display: flex;\r\n            align-items: center;\r\n        }\r\n        .toolbar label {\r\n            margin-right: 10px;\r\n        }\r\n        .toolbar button {\r\n            margin: 5px;\r\n            padding: 10px;\r\n            border: none;\r\n            cursor: pointer;\r\n            font-size: 16px;\r\n        }\r\n        #red-brush {\r\n            background-color: rgba(255, 0, 0, 0.4);\r\n            color: black;\r\n            font-weight: bold;\r\n        }\r\n        #green-brush {\r\n            background-color: rgba(0, 255, 0, 0.4);\r\n            color: black;\r\n            font-weight: bold;\r\n        }\r\n        #blue-brush {\r\n            background-color: rgba(0, 0, 255, 0.4);\r\n            color: black;\r\n            font-weight: bold;\r\n        }\r\n        .brush-size button {\r\n            background-color: white;\r\n            color: black;\r\n            border: 1px solid black;\r\n            opacity: 1;\r\n        }\r\n        .selected {\r\n            border: 2px solid black;\r\n        }\r\n        .brush-size.selected {\r\n            background-color: orange;\r\n            color: black;\r\n            border: 2px solid black;\r\n        }\r\n        .color-brush.selected {\r\n            opacity: 1;\r\n        }\r\n        .action-button {\r\n            background-color: orange;\r\n            border: 2px solid black;\r\n            color: black;\r\n            opacity: 1;\r\n            font-weight: bold;\r\n        }\r\n        #makeMaskPopup.modal {\r\n          width: 1200px;\r\n          height: 1200px;\r\n        }\r\n        button.maskbutton {\r\n          background: #00abff !important;\r\n          border-color: #00abff !important;\r\n          margin-left: 5px !important;\r\n          font-size: 15px !important;\r\n          font-weight: bold;\r\n          color: black;\r\n        }\r\n</style>');
$templateCache.put('app/pages/orders/orders.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-lg-7 col-sm-7 col-xx-12"><span class="filter-lable" ng-if="serchBy!=\'Select Search By\' && SearchQuery"><i class="show-filters">{{serchBy}} :</i>{{SearchQuery}} <i ng-click="removeSingleFilter(\'query\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="customerName"><i class="show-filters">Customer Name :</i>{{customerName}} <i ng-click="removeSingleFilter(\'customerName\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="customerEmail"><i class="show-filters">Customer Email :</i>{{customerEmail}} <i ng-click="removeSingleFilter(\'customerEmail\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="customerPhone"><i class="show-filters">Customer Phone :</i>{{customerPhone}} <i ng-click="removeSingleFilter(\'customerPhone\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="companyName"><i class="show-filters">Company Name :</i>{{companyName}} <i ng-click="removeSingleFilter(\'companyName\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="searchStatus"><i class="show-filters">Order Status :</i>{{searchLable}} <i ng-click="removeSingleFilter(\'searchStatus\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="trackingNumber"><i class="show-filters">Tracking Number :</i>{{trackingNumber}} <i ng-click="removeSingleFilter(\'trackingNumber\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="dashboardBlock"><i class="show-filters">Dashboard Block :</i>{{dashboardBlock}} <i ng-click="removeSingleFilter(\'dashboardBlock\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="datePickerOrderShow"><i class="show-filters">Date :</i>{{datePickerOrder.date.startDate}} | {{datePickerOrder.date.endDate}} <i ng-click="removeSingleFilter(\'date\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="store!=\'0\'"><i class="show-filters">Store :</i>{{storeDataArrAssoc[store]}} <i ng-click="removeSingleFilter(\'store\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="jobtype!=\'0\'"><i class="show-filters">Job Type :</i>{{jobtype}} <i ng-click="removeSingleFilter(\'jobtype\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="engraving!=\'0\'"><i class="show-filters">Engraving :</i>{{engraving}} <i ng-click="removeSingleFilter(\'engraving\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="searchByType"><i class="show-filters">Type :</i>{{searchByType}} <i ng-click="removeSingleFilter(\'searchByType\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="shipdt"><i class="show-filters">Ship Date :</i>{{shipdt | date:\'yyyy-MM-dd\' }} <i ng-click="removeSingleFilter(\'shipdt\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="country"><i class="show-filters">Country :</i>{{country}} <i ng-click="removeSingleFilter(\'country\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="region"><i class="show-filters">Region :</i>{{region}} <i ng-click="removeSingleFilter(\'region\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span></div><div class="col-lg-3 text-right"><div ng-if="isChangeStatus.change==true"><div class="form-group row clearfix" ng-init="getActiveStatusData()"><div class="col-lg-8 col-sm-8 col-md-8"><ui-select ng-model="orderChangeStatus.statuscode" ng-disabled="false" search-enabled="true" append-to-body="true" class="btn-group bootstrap-select form-control reports" name="orderChangeStatus" id="orderChangeStatusId"><ui-select-match placeholder="Select Status">{{$select.selected.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatusList | filter: $select.search">{{status.status_label}}</ui-select-choices></ui-select></div><div class="col-lg-4 col-sm-4 col-md-4 pl-0 pr-0 text-left"><button type="button" ng-click="openChangeStatusModal()" class="btn btn-primary btn-icon"><i class="fa fa-check"></i></button> <button type="button" ng-click="cancelChangeStatus()" class="btn btn-danger btn-icon"><i class="fa fa-times"></i></button></div></div></div><div class="row text-left" ng-if="isRelayUpload.upload==true"><button type="button" ng-click="openUploadRelayModal()" class="btn btn-primary btn-icon"><i class="fa fa-check"></i></button> <button type="button" ng-click="cancelUploadRelay()" class="btn btn-danger btn-icon"><i class="fa fa-times"></i></button></div></div><div class="col-lg-3 text-right"><button type="button" id="btnuploadrelay" ng-click="resetRelayUpload()" class="mb-10 btn btn-info btn-with-icon mr-5" ng-if="isRelayUpload.upload==false && permissionArr.indexOf(\'bulk_relay_upload\') !== - 1 && permissionArr.indexOf(\'relay_upload_manually\') !== - 1"><i class="ion-android-checkmark-circle"></i>Upload on Relay</button> <button type="button" id="btnchangestatus" ng-click="resetChangeStatus()" class="mb-10 btn btn-info btn-with-icon ml-5" ng-if="isChangeStatus.change==false && permissionArr.indexOf(\'change_order_status\') !== - 1"><i class="ion-android-checkmark-circle"></i>Change Status</button></div><div class="pull-right mr-16"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-primary btn-with-icon"><i class="ion-android-checkmark-circle"></i>Reset</button> <button ng-if="permissionArr.indexOf(\'filter_button_order_page\') !== - 1" type="button" data-toggle="modal" data-target="#statusModelCompany" class="margin-right-10 pull-right btn btn-success btn-with-icon"><i class="fa fa-filter"></i>Filters</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div class="modal fade" id="statusModelCompany" role="dialog" ng-init="store = \'0\';jobtype = \'0\';engraving = \'0\'"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header bg-info"><button type="button" class="close" data-dismiss="modal">&times;</button> <i class="fa fa-filter" aria-hidden="true"></i><span>Filters</span></div><div class="modal-body min-height-200 modal-max-height"><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12"><select id="selected" ng-init="serchBy = \'Select Search By\'" class="form-control roleData" ng-model="serchBy"><option value="Select Search By">Select Search By</option><option ng-repeat="item in serchByList" value="{{item}}">{{item}}</option></select></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="query" type="text" rel="1" ng-model="SearchQuery" name="query" class="form-control" placeholder="{{serchBy}}"></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="firstname" type="text" rel="1" ng-model="customerName" name="customerName" class="form-control" placeholder="Customer Name"></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="email" type="text" rel="1" ng-model="customerEmail" name="customerEmail" class="form-control" placeholder="Customer Email"></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="phone" type="text" rel="1" ng-model="customerPhone" name="customerPhone" class="form-control" placeholder="Customer Phone"></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="tracking_number" type="text" rel="1" ng-model="trackingNumber" name="trackingNumber" class="form-control" placeholder="Tracking Number"></div></div></div></div><div class="row"><div class="col-md-4"><div class="input-group cur-pntr"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerOrder.date" type="text" placeholder="Select Date" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column" ng-show="permissionArr.indexOf(\'filter_company_name_main_order_page\') > 1"><input id="companyName" type="text" rel="1" ng-model="companyName" name="companyName" class="form-control" placeholder="Company Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"></div></div></div><div class="col-md-4" ng-init="apiSearchForOrderStatus()"><div class="form-group" ng-if="permissionArr.indexOf(\'filter_status_main_order_page\') !== - 1"><select ng-model="orderStatusSelected.selected" class="form-control selectpicker with-search" data-live-search="true" title="Select Status" id="orderStatus" ng-options="statusSelected as statusSelected.label for statusSelected in listOrderStatus"><option value="">Select Status</option></select></div></div></div><div class="row"><div class="col-md-4" ng-init="getStoreData()"><div class="form-group" ng-show="permissionArr.indexOf(\'filter_store_main_order_page\') > 1"><select ng-model="store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-4"><div class="form-group"><select ng-model="jobtype" class="form-control"><option value="0">Job Type</option><option ng-repeat="job in jobtypeArr" value="{{job}}">{{job}}</option></select></div></div><div class="col-md-4"><div class="form-group"><select ng-model="engraving" class="form-control"><option value="0">Engraving</option><option ng-repeat="eng in engravingArr" value="{{eng}}">{{eng}}</option></select></div></div></div><div class="row"><div class="col-md-4"><div ng-init="getTypeMaster()" class="form-group row clearfix" ng-show="permissionArr.indexOf(\'filter_product_type_order_page\') > 1"><div class="col-sm-12"><select id="selected" class="form-control roleData" ng-model="searchByType"><option value="">Select Search Type</option><option ng-repeat="item in typeData" value="{{item.slug}}">{{item.name}}</option></select></div></div></div><div class="col-md-4"><div class="input-group" ng-show="permissionArr.indexOf(\'filter_ship_date_order_page\') > 1"><input class="form-control date-picker with-warning-addon" uib-datepicker-popup="{{format}}" datepicker-options="ship_options" ng-model="shipdt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" placeholder="Amazon Ship Date" readonly=""> <span class="input-group-btn"><span ng-click="opendt()" class="input-group-addon input-group-addon-warning addon-right"><i class="fa fa-calendar"></i></span></span></div></div><div class="col-md-4"><div class="form-group"><select ng-model="country" class="form-control"><option value="">Select International Orders</option><option value="international">International</option></select></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-show="permissionArr.indexOf(\'filter_old_new_relay\') > 1"><div class="col-sm-12"><select id="selected" class="form-control roleData" ng-model="searchByOldNewRelay"><option value="">Select Relay Type</option><option value="oldRelay">Relay</option><option value="NewRelay">Clipra</option></select></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="searchApply()">Apply</button> <button type="button" class="btn btn-warning" data-dismiss="modal">Cancel</button></div></div></div></div><div ng-include="\'app/pages/orders/changeStatusModal.html\'"></div><div ng-include="\'app/pages/orders/orderDetails.html\'"></div><div ng-include="\'app/pages/orders/uploadRelayModal.html\'"></div><div ng-include="\'app/pages/orders/uploadFileModal.html\'"></div>');
$templateCache.put('app/pages/orders/uploadFileModal.html','<div class="modal fade" id="uploadFileConfirm" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Upload File</span></div><form name="uploadFileForm" novalidate="" ng-submit="uploadFileForm.$valid && saveUploadFile($event,name,change_status,itemId,status,qtyId,order_type,product_name,customer_id,itemQty,isRework)"><div class="modal-body modal-max-height"><div class="row"><div class="col-md-12"><div class="form-group"><input type="file" class="upload-file-manual" id="fileUploadx" name="fileUploadx" required="" accept=".zip,.rar" ng-click="hideUploadFileValidation()" style="width: 210px;"> <label for="fileUploadx"><i class="fa fa-upload fa-lg"></i><span id="fileUpload-text">Choose a file&hellip;</span></label></div></div><span class="error" id="error-upload-file" style="margin-top: 10px;margin-left: 15px;font-size: 15px; display: none">Please select a file.</span> <span class="error" id="error-upload-invalid-file" style="margin-top: 10px;margin-left: 15px;font-size: 15px; display: none">Please select ZIP or RAR.</span></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary">Upload File</button> <button type="button" class="btn btn-warning" data-dismiss="modal">NO</button></div></form></div></div></div>');
$templateCache.put('app/pages/orders/uploadRelayModal.html','<div class="modal fade" id="uploadRelayConfirm" role="dialog" ng-init="getRelaySettingData()"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Upload on Relay</span></div><div class="modal-body text-center"><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">Job Service</div><select id="relay-job-service" class="form-control job-service disable-opacity-info" name="jobService"><option value="">Select Job Service</option><option value="{{job.value}}" ng-selected="job.set_default==\'1\'" ng-repeat="job in jobService">{{job.label}}</option></select></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">Priority</div><select id="relay-priority" class="form-control priority disable-opacity-info" name="priority" ng-disabled="enableRelaySettings"><option value="">Select Priority</option><option value="{{prty.hours}}" ng-repeat="prty in priority">{{prty.name}}</option></select></div></div></div><div class="row"><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">Uploaded Time</div><input type="text" readonly="" value="" name="uploaded" placeholder="Uploaded Time" class="form-control"></div></div><div class="col-md-12 col-lg-6 col-sm-6"><div class="form-group"><div class="buyer-title">User Name</div><input type="text" readonly="" value="" name="relayUserName" placeholder="User Name" class="form-control"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="uploadRelayYes($event)" ng-if="permissionArr.indexOf(\'relay_upload_manually\') !== - 1">Upload Manually</button> <button type="button" class="btn btn-warning" data-dismiss="modal">NO</button></div></div></div></div>');
$templateCache.put('app/pages/orders/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning !</span></div><div class="modal-body text-center"><div>This account is not for this store</div></div><div class="modal-footer"><span ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1">Still You want to continue?</span>&nbsp; <button type="button" class="btn btn-success" ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1" ng-click="yesadd();$dismiss();">Yes</button> <button type="button" class="btn btn-warning" ng-click="notadd();$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content" ng-init="getUserProfile()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><h3 class="with-line">General Information</h3><form class="form-horizontal" name="profileFrm" novalidate="" ng-submit="profileFrm.$valid && updateUserProfile()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Profile Picture</label><div class="col-sm-8"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" name="FileUploadProfile" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)" fileread="file"></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (profileFrm.firstname.$error.required || profileFrm.firstname.$error.pattern || profileFrm.firstname.$error.maxlength) && profileFrm.firstname.$touched}"><label for="inputFirstName" class="col-sm-4 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="firstname" type="text" ng-model="firstname" limit-to="20" ng-maxlength="20" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="profileFrm.$submitted && profileFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="profileFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="profileFrm.firstname.$error.maxlength && profileFrm.firstname.$touched">First Name should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (profileFrm.lastname.$error.required || profileFrm.lastname.$error.pattern || profileFrm.lastname.$error.maxlength) && profileFrm.lastname.$touched}"><label for="inputFirstName" class="col-sm-4 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="lastname" type="text" ng-model="lastname" limit-to="20" ng-maxlength="20" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="profileFrm.$submitted && profileFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="profileFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="profileFrm.lastname.$error.maxlength && profileFrm.lastname.$touched">Last Name should not be greater than 20 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="username" class="col-sm-4 control-label">User Name</label><div class="col-sm-8"><input type="text" ng-model="userName" class="form-control" placeholder="User Name" disabled="disabled"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-4 control-label">Email</label><div class="col-sm-8"><input type="email" ng-model="email" class="form-control" id="inputEmail3" placeholder="johndoe@domain.com" disabled="disabled"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (profileFrm.mobile.$error.required || profileFrm.mobile.$error.pattern) && profileFrm.mobile.$touched}"><label for="inputLastName" class="col-sm-4 control-label">Mobile Number <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="mobile" limit-to="15" type="text" ng-model="mobile" name="mobile" ng-minlength="10" required="" class="form-control" placeholder="123-123-1234" ng-pattern="/^(\\+?(\\d{1}|\\d{2}|\\d{3})[- ]?)?\\d{3}[- ]?\\d{3}[- ]?\\d{4}$/"> <span class="error" ng-show="profileFrm.$submitted && profileFrm.mobile.$error.required">Please enter mobile number.</span> <span class="error" ng-show="!profileFrm.mobile.$error.minlength && profileFrm.mobile.$error.pattern">Please enter valid phone number</span> <span class="error" ng-show="profileFrm.mobile.$error.minlength">Number must contain atleast 10 digits.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-4 control-label">Role</label><div class="col-sm-8"><input type="text" ng-model="role" class="form-control" id="inputOccupation" placeholder="Role" disabled="disabled"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Gender <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input checked="checked" ng-model="gender" required="" type="radio" name="gender" id="inlineRadio1" value="male"> <span>Male</span></label> <label class="radio-inline custom-radio nowrap"><input ng-model="gender" type="radio" name="gender" required="" id="inlineRadio2" value="female"> <span>Female</span></label> <span class="error" ng-show="profileFrm.$submitted && profileFrm.gender.$error.required">Please select gender.</span></div></div></div></div><h3 class="with-line" ng-show="permissionArr.indexOf(\'view_customer_credit_report_profile\') !== - 1">Store Credit</h3><div class="row" ng-show="permissionArr.indexOf(\'view_customer_credit_report_profile\') !== - 1"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Click to view report <span></span></label><div class="col-sm-8"><div class="col-sm-8"><a class="dt-button btn btn-success price-class report-btn margin-rigth-10 apply-css" tabindex="0" aria-controls="DataTables_Table_0" ng-click="viewCustomerCreditReport(customerId)" href="javascript:void(0);" title="Click to view credit report" style="padding: 10px 40px 10px 40px;"><span>Click to view report</span></a></div></div></div></div></div><div ng-show="permissionArr.indexOf(\'open_job_in_profile\') !== - 1"><h3 class="with-line">Open Job</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="OJoverrideFolder" class="col-sm-4 control-label">Override Folder <span class="asterisk_input"></span></label><div class="col-sm-8"><select id="OJoverrideFolder" class="form-control" ng-model="OJoverrideFolder" name="OJoverrideFolder" ng-change="resetFolderName(OJoverrideFolder)" required=""><option value="">Select Override Open Job Folder</option><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="profileFrm.$submitted && profileFrm.OJoverrideFolder.$error.required">Please select override open job folder.</span></div></div></div><div class="col-md-6" ng-show="OJoverrideFolder==\'Yes\'"><div class="form-group row clearfix"><label for="OJdefaultFolder" class="col-sm-4 control-label">File Location<span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="OJdefaultFolder" class="form-control" id="OJdefaultFolder" placeholder="File Location" name="OJdefaultFolder" ng-required="OJoverrideFolder==\'Yes\'"> <span class="error" ng-show="profileFrm.$submitted && profileFrm.OJdefaultFolder.$error.required">Please enter file location.</span></div></div></div></div></div><div ng-show="permissionArr.indexOf(\'open_job_db_in_profile\') !== - 1"><h3 class="with-line">Open Job DB</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="OJDBoverrideFolder" class="col-sm-4 control-label">Override Folder <span class="asterisk_input"></span></label><div class="col-sm-8"><select id="OJDBoverrideFolder" class="form-control" ng-model="OJDBoverrideFolder" ng-change="resetFolderNameer(OJDBoverrideFolder)" name="OJDBoverrideFolder" required=""><option value="">Select Override Open Job DB Folder</option><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="profileFrm.$submitted && profileFrm.OJDBoverrideFolder.$error.required">Please select override open job db folder.</span></div></div></div><div class="col-md-6" ng-show="OJDBoverrideFolder==\'Yes\'"><div class="form-group row clearfix"><label for="OJDBdefaultFolder" class="col-sm-4 control-label">File Location<span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="OJDBdefaultFolder" class="form-control" id="OJDBdefaultFolder" placeholder="File Location" name="OJDBdefaultFolder" ng-required="OJDBoverrideFolder==\'Yes\'"> <span class="error" ng-show="profileFrm.$submitted && profileFrm.OJDBdefaultFolder.$error.required">Please enter file location.</span></div></div></div></div></div><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-primary btn-with-icon save-profile mr-8"><i class="ion-android-checkmark-circle"></i>Update Profile</button> <a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></div></div></form><div ng-show="permissionArr.indexOf(\'change_password_in_profile\') !== - 1"><h3 class="with-line">Change Password</h3><form class="form-horizontal" name="changePwdFrm" novalidate="" ng-submit="changePwdFrm.$valid && changeUserPassword()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': changePwdFrm.password.$touched && (changePwdFrm.password.$error.required || changePwdFrm.password.$error.pattern)}"><label for="inputPassword" class="col-sm-4 control-label">New Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="password" type="password" ng-model="password" name="password" required="" class="form-control" ng-minlength="6" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="changePwdFrm.$submitted && changePwdFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!changePwdFrm.password.$error.minlength && changePwdFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="changePwdFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\':changePwdFrm.newPassword.$touched && (changePwdFrm.newPassword.$error.required || changePwdFrm.newPassword.$error.pattern) }"><label for="inputConfirmPassword" class="col-sm-4 control-label" style="padding: 0px">Confirm Password <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="password" required="" ng-model="newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="password"> <span class="error" ng-show="changePwdFrm.$submitted && changePwdFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="changePwdFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-12"><button type="submit" class="btn btn-primary btn-with-icon save-profile mr-8"><i class="ion-android-checkmark-circle"></i>Change Password</button> <a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></div></div></form></div></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/profile/storeCreditReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div ng-if="permissionArr.indexOf(\'store_filter_store_credit_of_report\') !== - 1" class="col-md-3" ng-init="getMallData()"><div class="form-group"><select ng-model="scr.mall" class="form-control"><option value="0">Select Mall</option><option ng-repeat="m in scr.mallData" value="{{m.id}}">{{m.name}}</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/customers/addCustomer.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\';vm.gender=\'male\';vm.shippingPriority=\'1\';vm.isAvailable=\'0\'"><div class="panel-content" ng-init="getEditedCustomer()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="customerFrm" novalidate="" ng-submit="customerFrm.$valid && saveCustomerData()"><h3 class="with-line">Customer information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.firstname.$error.required || customerFrm.firstname.$error.pattern || customerFrm.firstname.$error.maxlength) && customerFrm.firstname.$touched}"><label for="firstname" class="col-sm-3 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" ng-model="vm.firstname" limit-to="50" ng-maxlength="50" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.maxlength && customerFrm.firstname.$touched">First Name should not be greater than 50 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.lastname.$error.required || customerFrm.lastname.$error.pattern || customerFrm.lastname.$error.maxlength) && customerFrm.lastname.$touched}"><label for="lastname" class="col-sm-3 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" ng-model="vm.lastname" limit-to="50" ng-maxlength="50" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.maxlength && customerFrm.lastname.$touched">Last Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="initMakeUserNameButtonDisable()"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.userName.$error.required || customerFrm.userName.$error.pattern || customerFrm.userName.$error.maxlength) && customerFrm.userName.$touched}"><label for="userName" class="col-sm-3 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-9" style="position:relative; margin-right: 0px; padding-right: 0px;"><div class="col-sm-6" style="width: 75%;margin-right: 2px;padding: 0px;"><input ng-disabled="disableUserNameField" id="userName" type="text" ng-model="vm.userName" required="" limit-to="20" ng-maxlength="20" name="userName" class="form-control col-sm-3" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/" style="float: left;"> <i class="fa fa-copy fa-lg" ng-if="vm.customerId && vm.customerUName" title="Copy User Name" clipboard="" text="vm.userName" on-copied="success(\'User Name\')" on-error="fail(err)" style="position: absolute;right: 20px;top: 10px;cursor: pointer;"></i></div><div class="col-sm-3" style="width: 20%;margin: 0px;float: left;padding-left: 0px;padding-right: 0px;"><a ng-disabled="permissionArr.indexOf(\'edit_customer_user_name\') == -1" ng-click="makeUserNameButtonClickable()" class="btn" style="color:#fefefe; width: 95%; float: right; margin-top: 0px; margin-right: 0px; margin-left: 10px; background: #216e0ee0;">Edit</a></div><span class="error" ng-show="customerFrm.$submitted && customerFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="customerFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="customerFrm.userName.$error.maxlength && customerFrm.userName.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.email.$error.required || customerFrm.email.$error.email) && customerFrm.email.$touched}"><label for="email" class="col-sm-3 control-label">Email Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" ng-model="vm.email" ng-disabled="permissionArr.indexOf(\'edit_customer_user_email\') == -1" name="email" required="" class="form-control" placeholder="johndoe@domain.com"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.email.$error.required">Please enter email.</span> <span class="error" ng-show="customerFrm.email.$error.email">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.password.$error.required || customerFrm.password.$error.pattern) && customerFrm.password.$touched}"><label for="password" class="col-sm-3 control-label">Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" name="password" style="display: none;"> <input id="password" type="password" ng-model="vm.password" ng-minlength="6" name="password" ng-required="!vm.customerId" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!customerFrm.password.$error.minlength && customerFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="customerFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.newPassword.$error.required || customerFrm.newPassword.$error.pattern) && customerFrm.newPassword.$touched}"><label class="col-sm-3 control-label" for="newPassword">Conf. Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" ng-required="!vm.customerId" ng-model="vm.newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="vm.password"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="customerFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.mobile.$error.required || customerFrm.mobile.$error.pattern) && customerFrm.mobile.$touched}"><label for="mobile" class="col-sm-3 control-label">Phone <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="mobile" limit-to="15" type="text" ng-model="vm.mobile" name="mobile" ng-minlength="10" required="" class="form-control" placeholder="123-123-1234" ng-pattern="/^(\\+?(\\d{1}|\\d{2}|\\d{3})[- ]?)?\\d{3}[- ]?\\d{3}[- ]?\\d{4}$/"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.mobile.$error.required">Please enter phone number.</span> <span class="error" ng-show="!customerFrm.mobile.$error.minlength && customerFrm.mobile.$error.pattern">Please enter valid phone number</span> <span class="error" ng-show="customerFrm.mobile.$error.minlength">Number must contain atleast 10 digits.</span></div></div></div><div class="col-md-6" ng-init="getCustomerRoles()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="role" class="form-control roleData" ng-model="vm.role" required="" name="role"><option value="">Select Role</option><option ng-repeat="role in customerRoleList" value="{{role.id}}">{{role.name}}</option></select><span class="error" ng-show="customerFrm.$submitted && customerFrm.role.$error.required">Please select role.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': customerFrm.inlineRadioOptions.$error.required && customerFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="vm.status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="customerFrm.$submitted && customerFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': customerFrm.inlineRadioOptions.$error.required && customerFrm.inlineRadioOptions.$touched}"><label for="gender" class="col-sm-3 control-label">Gender <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.gender" type="radio" name="inlineRadioOptions" id="gender" value="male"> <span>Male</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.gender" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="female"> <span>Female</span></label> <span class="error" ng-show="customerFrm.$submitted && customerFrm.inlineRadioOptions.$error.required">Please select gender.</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="getCustomerToken()"><div class="form-group row clearfix"><label for="customerToken" class="col-sm-3 control-label">Token</label><div class="col-sm-9"><textarea id="customerToken" disabled="" ng-model="vm.customerToken" name="customerToken" class="form-control" placeholder="Enter Token" style="position:relative"></textarea> <i class="fa fa-copy fa-lg" title="Copy Token" clipboard="" text="vm.customerToken" on-copied="success(\'Token\')" on-error="fail(err)" style="position: absolute;right: 20px;bottom: 8px;cursor: pointer;"></i></div></div></div><div class="col-md-6" ng-init="getActiveGroupLabel()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Customer Group <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="group" class="form-control" ng-model="vm.customerGroup" required="" name="group" ng-disabled="vm.customerSyncType==\'no\'"><option value="">Select Customer Group</option><option ng-repeat="group in activeGroupData" value="{{group.group_label}}">{{group.group_label}}</option></select><span class="error" ng-show="customerFrm.$submitted && customerFrm.group.$error.required">Please select customer group.</span></div></div></div></div><h3 class="with-line">Shipping tracker dashboard</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-3 control-label">Is Available</label><div class="col-sm-9"><select id="isAvailable" class="form-control roleData" ng-model="vm.isAvailable"><option value="">Select Value</option><option value="1">Yes</option><option value="0">No</option></select></div></div></div></div><div ng-if="vm.isAvailable==\'1\'"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.displayname.$error.required || customerFrm.displayname.$error.maxlength) && customerFrm.displayname.$touched}"><label for="displayname" class="col-sm-3 control-label">Display Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="displayname" type="text" ng-model="vm.displayname" limit-to="32" ng-maxlength="32" name="displayname" required="" class="form-control" placeholder="Display Name"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.displayname.$error.required">Please enter display name.</span> <span class="error" ng-show="customerFrm.displayname.$error.maxlength && customerFrm.displayname.$touched">Display Name should not be greater than 32 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-3 control-label">Shipping Priority</label><div class="col-sm-9"><select id="shippingPriority" class="form-control roleData" ng-model="vm.shippingPriority"><option value="1">High</option><option value="0">Normal</option></select></div></div></div></div><div class="row"><div class="col-md-6" ng-init="getCustomerPositionId()"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.positionId.$error.required || customerFrm.positionId.$error.pattern) && customerFrm.positionId.$touched}"><label for="positionId" class="col-sm-3 control-label">Position Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="positionId" type="text" ng-model="vm.positionId" name="positionId" required="" class="form-control" placeholder="Position Id" ng-pattern="/^[\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.positionId.$error.required">Please enter position id.</span> <span class="error" ng-show="customerFrm.positionId.$error.pattern">Please enter valid position id.</span></div></div></div><div class="col-md-6" ng-init="getCustomerBinId()"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.binId.$error.required || customerFrm.binId.$error.pattern) && customerFrm.binId.$touched}"><label for="binId" class="col-sm-3 control-label">Bin Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="binId" type="text" ng-model="vm.binId" name="binId" required="" class="form-control" placeholder="Bin Id" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.binId.$error.required">Please enter bin id.</span> <span class="error" ng-show="customerFrm.binId.$error.pattern">Please enter valid bin id.</span></div></div></div></div></div><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ng-click="goBack()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></div></div><input type="hidden" ng-model="vm.customerId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/customers/addSubCustomer.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\'"><div class="panel-content" ng-init="getEditedSubCustomer()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="subCustFrm" novalidate="" ng-submit="subCustFrm.$valid && saveSubCustData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (subCustFrm.firstname.$error.required || subCustFrm.firstname.$error.pattern || subCustFrm.firstname.$error.maxlength) && subCustFrm.firstname.$touched}"><label for="inputFirstName" class="col-sm-3 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" ng-model="firstname" limit-to="50" ng-maxlength="50" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="subCustFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="subCustFrm.firstname.$error.maxlength && subCustFrm.firstname.$touched">First Name should not be greater than 50 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (subCustFrm.lastname.$error.required || subCustFrm.lastname.$error.pattern || subCustFrm.lastname.$error.maxlength) && subCustFrm.lastname.$touched}"><label for="inputFirstName" class="col-sm-3 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" ng-model="lastname" limit-to="50" ng-maxlength="50" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="subCustFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="subCustFrm.lastname.$error.maxlength && subCustFrm.lastname.$touched">Last Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (subCustFrm.userName.$error.required || subCustFrm.userName.$error.pattern || subCustFrm.userName.$error.maxlength) && subCustFrm.userName.$touched}"><label for="username" class="col-sm-3 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="userName" type="text" ng-model="userName" ng-disabled="subCustId" required="" limit-to="20" ng-maxlength="20" name="userName" class="form-control" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.]*$/"> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="subCustFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="subCustFrm.userName.$error.maxlength && subCustFrm.userName.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (subCustFrm.email.$error.required || subCustFrm.email.$error.email) && subCustFrm.email.$touched}"><label for="email" class="col-sm-3 control-label">Email Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" ng-model="email" name="email" required="" class="form-control" placeholder="johndoe@domain.com"> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.email.$error.required">Please enter email.</span> <span class="error" ng-show="subCustFrm.email.$error.email">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (subCustFrm.password.$error.required || subCustFrm.password.$error.pattern) && subCustFrm.password.$touched}"><label for="inputEmail3" class="col-sm-3 control-label">Password <span ng-show="!subCustId" class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" ng-model="password" ng-minlength="6" name="password" ng-required="!subCustId" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!subCustFrm.password.$error.minlength && subCustFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="subCustFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (subCustFrm.newPassword.$error.required || subCustFrm.newPassword.$error.pattern) && subCustFrm.newPassword.$touched}"><label class="col-sm-3 control-label">Conf. Password <span ng-show="!subCustId" class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" ng-required="!subCustId" ng-model="newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="password"> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="subCustFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': subCustFrm.status.$error.required && subCustFrm.status.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="subCustFrm.$submitted && subCustFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-6" ng-init="getSubCustomerRoles()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="role" class="form-control roleData" ng-model="role" required="" name="role"><option value="">Select Role</option><option ng-repeat="role in subCustomerRoleList" value="{{role.id}}">{{role.name}}</option></select><span class="error" ng-show="subCustFrm.$submitted && subCustFrm.role.$error.required">Please select role.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ng-click="goToSubCustomerPage()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="subCustId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/customers/customers.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'customer_add\') !== - 1 && mallCustAction" ng-click="addCustomer()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase" class="mb-10"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/customers/statusModal.html','<div class="modal-content" ng-controller="customersCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/customers/storeCreditReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/customers/subCustDeleteModal.html','<div class="modal-content" ng-controller="customersCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteSubCustomer()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/customers/subCustStatusModal.html','<div class="modal-content" ng-controller="customersCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="subCustChangeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/customers/subCustomers.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><div class="row"><div class="col-md-12"><a ng-if="userRole!=\'ROLE_CUSTOMER\'" ng-click="goBack()" class="btn btn-warning btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button ng-if="permissionArr.indexOf(\'sub_cust_add\') !== - 1" ng-click="addSubCustomer()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getSubCustDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/owner/addOwner.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status = \'1\';vm.gender = \'male\';vm.shippingPriority = \'1\';vm.isAvailable = \'0\'"><div class="panel-content" ng-init="getEditedCustomer(); getPermissionDataForCreateOwner();"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="customerFrm" novalidate="" ng-submit="customerFrm.$valid && saveOwnerData()"><h3 class="with-line">Owner information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.firstname.$error.required || customerFrm.firstname.$error.pattern || customerFrm.firstname.$error.maxlength) && customerFrm.firstname.$touched}"><label for="firstname" class="col-sm-3 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" ng-model="vm.firstname" limit-to="50" ng-maxlength="50" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.maxlength && customerFrm.firstname.$touched">First Name should not be greater than 50 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.lastname.$error.required || customerFrm.lastname.$error.pattern || customerFrm.lastname.$error.maxlength) && customerFrm.lastname.$touched}"><label for="lastname" class="col-sm-3 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" ng-model="vm.lastname" limit-to="50" ng-maxlength="50" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.maxlength && customerFrm.lastname.$touched">Last Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="initMakeUserNameButtonDisable()"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.userName.$error.required || customerFrm.userName.$error.pattern || customerFrm.userName.$error.maxlength) && customerFrm.userName.$touched}"><label for="userName" class="col-sm-3 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-9" style="position:relative; margin-right: 0px; padding-right: 0px;"><div class="col-sm-6" style="width: 75%;margin-right: 2px;padding: 0px;"><input ng-disabled="disableUserNameField" id="userName" type="text" ng-model="vm.userName" required="" limit-to="20" ng-maxlength="20" name="userName" class="form-control col-sm-3" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/" style="float: left;"> <i class="fa fa-copy fa-lg" ng-if="vm.customerId && vm.customerUName" title="Copy User Name" clipboard="" text="vm.userName" on-copied="success(\'User Name\')" on-error="fail(err)" style="position: absolute;right: 20px;top: 10px;cursor: pointer;"></i></div><div class="col-sm-3" style="width: 20%;margin: 0px;float: left;padding-left: 0px;padding-right: 0px;"><a ng-disabled="permissionArr.indexOf(\'edit_customer_user_name\') == -1" ng-click="makeUserNameButtonClickable()" class="btn" style="color:#fefefe; width: 95%; float: right; margin-top: 0px; margin-right: 0px; margin-left: 10px; background: #216e0ee0;">Edit</a></div><span class="error" ng-show="customerFrm.$submitted && customerFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="customerFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="customerFrm.userName.$error.maxlength && customerFrm.userName.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.email.$error.required || customerFrm.email.$error.email) && customerFrm.email.$touched}"><label for="email" class="col-sm-3 control-label">Email Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" ng-model="vm.email" ng-disabled="permissionArr.indexOf(\'edit_customer_user_email\') == -1" name="email" required="" class="form-control" placeholder="johndoe@domain.com"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.email.$error.required">Please enter email.</span> <span class="error" ng-show="customerFrm.email.$error.email">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.password.$error.required || customerFrm.password.$error.pattern) && customerFrm.password.$touched}"><label for="password" class="col-sm-3 control-label">Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" name="password" style="display: none;"> <input id="password" type="password" ng-model="vm.password" ng-minlength="6" name="password" ng-required="!vm.customerId" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!customerFrm.password.$error.minlength && customerFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="customerFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.newPassword.$error.required || customerFrm.newPassword.$error.pattern) && customerFrm.newPassword.$touched}"><label class="col-sm-3 control-label" for="newPassword">Conf. Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" ng-required="!vm.customerId" ng-model="vm.newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="vm.password"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="customerFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.mobile.$error.required || customerFrm.mobile.$error.pattern) && customerFrm.mobile.$touched}"><label for="mobile" class="col-sm-3 control-label">Phone <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="mobile" limit-to="15" type="text" ng-model="vm.mobile" name="mobile" ng-minlength="10" required="" class="form-control" placeholder="123-123-1234" ng-pattern="/^(\\+?(\\d{1}|\\d{2}|\\d{3})[- ]?)?\\d{3}[- ]?\\d{3}[- ]?\\d{4}$/"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.mobile.$error.required">Please enter phone number.</span> <span class="error" ng-show="!customerFrm.mobile.$error.minlength && customerFrm.mobile.$error.pattern">Please enter valid phone number</span> <span class="error" ng-show="customerFrm.mobile.$error.minlength">Number must contain atleast 10 digits.</span></div></div></div><div class="col-md-6" ng-init="getCustomerRoles()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="role" class="form-control roleData" ng-model="vm.role" required="" name="role"><option value="">Select Role</option><option ng-repeat="role in customerRoleList" value="{{role.id}}">{{role.name}}</option></select><span class="error" ng-show="customerFrm.$submitted && customerFrm.role.$error.required">Please select role.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': customerFrm.inlineRadioOptions.$error.required && customerFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="vm.status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="customerFrm.$submitted && customerFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': customerFrm.inlineRadioOptions.$error.required && customerFrm.inlineRadioOptions.$touched}"><label for="gender" class="col-sm-3 control-label">Gender <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.gender" type="radio" name="inlineRadioOptions" id="gender" value="male"> <span>Male</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.gender" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="female"> <span>Female</span></label> <span class="error" ng-show="customerFrm.$submitted && customerFrm.inlineRadioOptions.$error.required">Please select gender.</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="getActiveGroupLabel()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Customer Group <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="group" class="form-control" ng-model="vm.customerGroup" required="" name="group" ng-disabled="vm.customerSyncType == \'no\'"><option value="">Select Customer Group</option><option ng-repeat="group in activeGroupData" value="{{group.group_label}}">{{group.group_label}}</option></select><span class="error" ng-show="customerFrm.$submitted && customerFrm.group.$error.required">Please select customer group.</span></div></div></div></div><div class="row"><uib-accordion ng-show="isloaded"><uib-accordion-group is-open="false" ng-repeat="permission in vm.permissionData track by $index" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><span>{{permission.cat_name}}</span></uib-accordion-heading><div class="horizontal-scroll"><table class="table permission-table"><tbody ng-if="permission.permission.length <= 15"><tr class="no-top-border" ng-repeat="perm in permission.permission"><td class="align-right"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{perm.perm_id}}" ng-model="perm.perm_checked" ng-change="CheckUncheckData(perm.perm_checked)"> <span></span></label></td><td class="col-md-12 col-sm-12 align-left">{{perm.perm_name}}</td></tr></tbody><tbody ng-if="permission.permission.length > 15 && permission.cat_name == data.cat_name" ng-repeat="data in vm.largePermissionData"><tr class="no-top-border" ng-repeat="perm in data.permission"><td class="col-md-4 align-left border-left" ng-repeat="p in perm"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{p.perm_id}}" ng-model="p.perm_checked" ng-change="CheckUncheckData(p.perm_checked)"> <span></span></label> <span>{{p.perm_name}}</span></td></tr></tbody></table></div></uib-accordion-group></uib-accordion></div><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ng-click="goBack()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></div></div><input type="hidden" ng-model="vm.customerId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/owner/addSubOwner.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status = \'1\';"><div class="panel-content" ng-init="getEditedSubOwner(); getPermissionDataForCreateSubOwner();"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="customerFrm" novalidate="" ng-submit="customerFrm.$valid && saveOwnerData()"><h3 class="with-line">Sub Owner information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.firstname.$error.required || customerFrm.firstname.$error.pattern || customerFrm.firstname.$error.maxlength) && customerFrm.firstname.$touched}"><label for="firstname" class="col-sm-3 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" ng-model="vm.firstname" limit-to="50" ng-maxlength="50" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.maxlength && customerFrm.firstname.$touched">First Name should not be greater than 50 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.lastname.$error.required || customerFrm.lastname.$error.pattern || customerFrm.lastname.$error.maxlength) && customerFrm.lastname.$touched}"><label for="lastname" class="col-sm-3 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" ng-model="vm.lastname" limit-to="50" ng-maxlength="50" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.maxlength && customerFrm.lastname.$touched">Last Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="initMakeUserNameButtonDisable()"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.userName.$error.required || customerFrm.userName.$error.pattern || customerFrm.userName.$error.maxlength) && customerFrm.userName.$touched}"><label for="userName" class="col-sm-3 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-9" style="position:relative; margin-right: 0px; padding-right: 0px;"><div class="col-sm-6" style="width: 75%;margin-right: 2px;padding: 0px;"><input ng-disabled="disableUserNameField" id="userName" type="text" ng-model="vm.userName" required="" limit-to="40" ng-maxlength="40" name="userName" class="form-control col-sm-3" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/" style="float: left;"> <i class="fa fa-copy fa-lg" ng-if="vm.customerId && vm.customerUName" title="Copy User Name" clipboard="" text="vm.userName" on-copied="success(\'User Name\')" on-error="fail(err)" style="position: absolute;right: 20px;top: 10px;cursor: pointer;"></i></div><div class="col-sm-3" style="width: 20%;margin: 0px;float: left;padding-left: 0px;padding-right: 0px;"><a ng-disabled="permissionArr.indexOf(\'edit_customer_user_name\') == -1" ng-click="makeUserNameButtonClickable()" class="btn" style="color:#fefefe; width: 95%; float: right; margin-top: 0px; margin-right: 0px; margin-left: 10px; background: #216e0ee0;">Edit</a></div><span class="error" ng-show="customerFrm.$submitted && customerFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="customerFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="customerFrm.userName.$error.maxlength && customerFrm.userName.$touched">Username should not be greater than 40 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.email.$error.required || customerFrm.email.$error.email) && customerFrm.email.$touched}"><label for="email" class="col-sm-3 control-label">Email Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" ng-model="vm.email" ng-disabled="permissionArr.indexOf(\'edit_customer_user_email\') == -1" name="email" required="" class="form-control" placeholder="johndoe@domain.com"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.email.$error.required">Please enter email.</span> <span class="error" ng-show="customerFrm.email.$error.email">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.password.$error.required || customerFrm.password.$error.pattern) && customerFrm.password.$touched}"><label for="password" class="col-sm-3 control-label">Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" name="password" style="display: none;"> <input id="password" type="password" ng-model="vm.password" ng-minlength="6" name="password" ng-required="!vm.customerId" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!customerFrm.password.$error.minlength && customerFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="customerFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.newPassword.$error.required || customerFrm.newPassword.$error.pattern) && customerFrm.newPassword.$touched}"><label class="col-sm-3 control-label" for="newPassword">Conf. Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" ng-required="!vm.customerId" ng-model="vm.newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="vm.password"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="customerFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': customerFrm.inlineRadioOptions.$error.required && customerFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="vm.status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="customerFrm.$submitted && customerFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-6" ng-init="getCustomerRoles()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="role" class="form-control roleData" ng-model="vm.role" required="" name="role"><option value="">Select Role</option><option ng-repeat="role in customerRoleList" value="{{role.id}}">{{role.name}}</option></select><span class="error" ng-show="customerFrm.$submitted && customerFrm.role.$error.required">Please select role.</span></div></div></div></div><div class="row" ng-if="vm.customerId"><uib-accordion ng-show="isloaded"><uib-accordion-group is-open="false" ng-repeat="permission in vm.permissionData track by $index" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><span>{{permission.cat_name}}</span></uib-accordion-heading><div class="horizontal-scroll"><table class="table permission-table"><tbody ng-if="permission.permission.length <= 15"><tr class="no-top-border" ng-repeat="perm in permission.permission"><td class="align-right"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{perm.perm_id}}" ng-model="perm.perm_checked" ng-change="CheckUncheckData(perm.perm_checked)"> <span></span></label></td><td class="col-md-12 col-sm-12 align-left">{{perm.perm_name}}</td></tr></tbody><tbody ng-if="permission.permission.length > 15 && permission.cat_name == data.cat_name" ng-repeat="data in vm.largePermissionData"><tr class="no-top-border" ng-repeat="perm in data.permission"><td class="col-md-4 align-left border-left" ng-repeat="p in perm"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{p.perm_id}}" ng-model="p.perm_checked" ng-change="CheckUncheckData(p.perm_checked)"> <span></span></label> <span>{{p.perm_name}}</span></td></tr></tbody></table></div></uib-accordion-group></uib-accordion></div><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ng-click="goBack()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></div></div><input type="hidden" ng-model="vm.customerId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/owner/deleteModal.html','<div class="modal-content" ng-controller="ownerCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteOwner()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/owner/owner.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'add_owner_account_customer\') !== -1" ng-click="addOwner()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase" class="mb-10"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/owner/statusModal.html','<div class="modal-content" ng-controller="ownerCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/owner/subOwners.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll" ng-controller="subOwnerCtrl"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'add_owner_account_customer\') !== -1" ng-click="addSubOwner()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase" class="mb-10"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/roles/addRoles.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-init="getEditedRole()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="roleFrm" novalidate="" ng-submit="roleFrm.$valid && saveRolesData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': roleFrm.role.$error.required && roleFrm.role.$touched}"><label for="roleFrm" class="col-sm-3 control-label">Role Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="role" type="text" ng-model="role" name="role" required="" class="form-control" placeholder="Role Name"> <span class="error" ng-show="roleFrm.$submitted && roleFrm.role.$error.required">Please enter role name.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': roleFrm.roleType.$error.required && roleFrm.roleType.$touched}"><label for="roleType" class="col-sm-3 control-label">Role Type <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="roleType" class="form-control" ng-model="roleType" required="" name="roleType"><option value="">Select Role Type</option><option value="ROLE_ADMIN">Admin</option><option value="ROLE_CUSTOMER">Customer</option><option value="ROLE_SUB_CUSTOMER">Sub Customer</option><option value="ROLE_OWNER">Owner</option><option value="ROLE_SUB_OWNER">Sub Owner</option></select><span class="error" ng-show="roleFrm.$submitted && roleFrm.roleType.$error.required">Please select role type.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="account-settings.roles" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="roleId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/roles/cloneModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to clone this role?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="cloneRole()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/roles/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteRole()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/roles/roles.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'role_add\') !== - 1" ng-click="addRoles()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/roles/rolesPermission.html','<div class="widgets profile role-permission" ba-panel=""><div ng-init="getPermissionData()"><uib-accordion ng-show="isloaded"><div class="row"><div class="col-md-12 form-group"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" ng-model="vm.allSelected" ng-change="CheckUncheckAll(vm.allSelected)"><span></span></label> <span ng-show="vm.allSelected">Deselect All</span> <span ng-hide="vm.allSelected">Select All</span></div></div><uib-accordion-group is-open="false" ng-repeat="permission in vm.permissionData track by $index" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><span>{{permission.cat_name}}</span></uib-accordion-heading><div class="horizontal-scroll"><table class="table permission-table"><tbody ng-if="permission.permission.length<=15"><tr class="no-top-border" ng-repeat="perm in permission.permission"><td class="align-right"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{perm.perm_id}}" ng-model="perm.perm_checked" ng-change="CheckUncheckData(perm.perm_checked)"> <span></span></label></td><td class="col-md-12 col-sm-12 align-left">{{perm.perm_name}}</td></tr></tbody><tbody ng-if="permission.permission.length>15 && permission.cat_name==data.cat_name" ng-repeat="data in vm.largePermissionData"><tr class="no-top-border" ng-repeat="perm in data.permission"><td class="col-md-4 align-left border-left" ng-repeat="p in perm"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{p.perm_id}}" ng-model="p.perm_checked" ng-change="CheckUncheckData(p.perm_checked)"> <span></span></label> <span>{{p.perm_name}}</span></td></tr></tbody></table></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addPermissions()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="account-settings.roles" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/subcustomers/addCustomer.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status = \'1\';"><div class="panel-content" ng-init="getEditedSubOwner(); getPermissionDataForCreateSubOwner();"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="customerFrm" novalidate="" ng-submit="customerFrm.$valid && saveOwnerData()"><h3 class="with-line">Sub Owner information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.firstname.$error.required || customerFrm.firstname.$error.pattern || customerFrm.firstname.$error.maxlength) && customerFrm.firstname.$touched}"><label for="firstname" class="col-sm-3 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" ng-model="vm.firstname" limit-to="50" ng-maxlength="50" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="customerFrm.firstname.$error.maxlength && customerFrm.firstname.$touched">First Name should not be greater than 50 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.lastname.$error.required || customerFrm.lastname.$error.pattern || customerFrm.lastname.$error.maxlength) && customerFrm.lastname.$touched}"><label for="lastname" class="col-sm-3 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" ng-model="vm.lastname" limit-to="50" ng-maxlength="50" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="customerFrm.lastname.$error.maxlength && customerFrm.lastname.$touched">Last Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="initMakeUserNameButtonDisable()"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.userName.$error.required || customerFrm.userName.$error.pattern || customerFrm.userName.$error.maxlength) && customerFrm.userName.$touched}"><label for="userName" class="col-sm-3 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-9" style="position:relative; margin-right: 0px; padding-right: 0px;"><div class="col-sm-6" style="width: 75%;margin-right: 2px;padding: 0px;"><input ng-disabled="disableUserNameField" id="userName" type="text" ng-model="vm.userName" required="" limit-to="40" ng-maxlength="40" name="userName" class="form-control col-sm-3" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/" style="float: left;"> <i class="fa fa-copy fa-lg" ng-if="vm.customerId && vm.customerUName" title="Copy User Name" clipboard="" text="vm.userName" on-copied="success(\'User Name\')" on-error="fail(err)" style="position: absolute;right: 20px;top: 10px;cursor: pointer;"></i></div><div class="col-sm-3" style="width: 20%;margin: 0px;float: left;padding-left: 0px;padding-right: 0px;"><a ng-disabled="permissionArr.indexOf(\'edit_customer_user_name\') == -1" ng-click="makeUserNameButtonClickable()" class="btn" style="color:#fefefe; width: 95%; float: right; margin-top: 0px; margin-right: 0px; margin-left: 10px; background: #216e0ee0;">Edit</a></div><span class="error" ng-show="customerFrm.$submitted && customerFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="customerFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="customerFrm.userName.$error.maxlength && customerFrm.userName.$touched">Username should not be greater than 40 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.email.$error.required || customerFrm.email.$error.email) && customerFrm.email.$touched}"><label for="email" class="col-sm-3 control-label">Email Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" ng-model="vm.email" name="email" required="" class="form-control" placeholder="johndoe@domain.com"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.email.$error.required">Please enter email.</span> <span class="error" ng-show="customerFrm.email.$error.email">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.password.$error.required || customerFrm.password.$error.pattern) && customerFrm.password.$touched}"><label for="password" class="col-sm-3 control-label">Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" name="password" style="display: none;"> <input id="password" type="password" ng-model="vm.password" ng-minlength="6" name="password" ng-required="!vm.customerId" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!customerFrm.password.$error.minlength && customerFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="customerFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (customerFrm.newPassword.$error.required || customerFrm.newPassword.$error.pattern) && customerFrm.newPassword.$touched}"><label class="col-sm-3 control-label" for="newPassword">Conf. Password <span ng-show="!vm.customerId" class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" ng-required="!vm.customerId" ng-model="vm.newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="vm.password"> <span class="error" ng-show="customerFrm.$submitted && customerFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="customerFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': customerFrm.inlineRadioOptions.$error.required && customerFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="vm.status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="customerFrm.$submitted && customerFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-6" ng-init="getCustomerRoles()"><div class="form-group row clearfix"><label for="role" class="col-sm-3 control-label">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="role" class="form-control roleData" ng-model="vm.role" required="" name="role"><option value="">Select Role</option><option ng-repeat="role in customerRoleList" value="{{role.id}}">{{role.name}}</option></select><span class="error" ng-show="customerFrm.$submitted && customerFrm.role.$error.required">Please select role.</span></div></div></div></div><div class="row" ng-if="vm.customerId"><uib-accordion ng-show="isloaded"><uib-accordion-group is-open="false" ng-repeat="permission in vm.permissionData track by $index" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><span>{{permission.cat_name}}</span></uib-accordion-heading><div class="horizontal-scroll"><table class="table permission-table"><tbody ng-if="permission.permission.length <= 15"><tr class="no-top-border" ng-repeat="perm in permission.permission"><td class="align-right"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{perm.perm_id}}" ng-model="perm.perm_checked" ng-change="CheckUncheckData(perm.perm_checked)"> <span></span></label></td><td class="col-md-12 col-sm-12 align-left">{{perm.perm_name}}</td></tr></tbody><tbody ng-if="permission.permission.length > 15 && permission.cat_name == data.cat_name" ng-repeat="data in vm.largePermissionData"><tr class="no-top-border" ng-repeat="perm in data.permission"><td class="col-md-4 align-left border-left" ng-repeat="p in perm"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="chk{{p.perm_id}}" ng-model="p.perm_checked" ng-change="CheckUncheckData(p.perm_checked)"> <span></span></label> <span>{{p.perm_name}}</span></td></tr></tbody></table></div></uib-accordion-group></uib-accordion></div><div class="row"><div class="col-md-6"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ng-click="goBack()" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></div></div><input type="hidden" ng-model="vm.customerId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/subcustomers/statusModal.html','<div class="modal-content" ng-controller="subCustomersCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/subcustomers/subcustomers.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-click="addSubOwner()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase" class="mb-10"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/accountSettings/users/addUser.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\'"><span ng-init="gender=\'male\'"></span><div class="panel-content" ng-init="getEditedUser()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="userFrm" novalidate="" ng-submit="userFrm.$valid && saveUserData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.firstname.$error.required || userFrm.firstname.$error.pattern || userFrm.firstname.$error.maxlength) && userFrm.firstname.$touched}"><label for="inputFirstName" class="col-sm-3 control-label">First Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="firstname" type="text" ng-model="firstname" limit-to="20" ng-maxlength="20" name="firstname" required="" class="form-control" placeholder="First Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="userFrm.$submitted && userFrm.firstname.$error.required">Please enter first name.</span> <span class="error" ng-show="userFrm.firstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="userFrm.firstname.$error.maxlength && userFrm.firstname.$touched">First Name should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.lastname.$error.required || userFrm.lastname.$error.pattern || userFrm.lastname.$error.maxlength) && userFrm.lastname.$touched}"><label for="inputFirstName" class="col-sm-3 control-label">Last Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="lastname" type="text" ng-model="lastname" limit-to="20" ng-maxlength="20" name="lastname" required="" class="form-control" placeholder="Last Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="userFrm.$submitted && userFrm.lastname.$error.required">Please enter last name.</span> <span class="error" ng-show="userFrm.lastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="userFrm.lastname.$error.maxlength && userFrm.lastname.$touched">Last Name should not be greater than 20 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.userName.$error.required || userFrm.userName.$error.pattern || userFrm.userName.$error.maxlength) && userFrm.userName.$touched}"><label for="username" class="col-sm-3 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="userName" type="text" ng-model="userName" required="" limit-to="20" ng-maxlength="20" name="userName" class="form-control" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/"> <span class="error" ng-show="userFrm.$submitted && userFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="userFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="userFrm.userName.$error.maxlength && userFrm.userName.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.email.$error.required || userFrm.email.$error.email) && userFrm.email.$touched}"><label for="inputEmail3" class="col-sm-3 control-label">Email Id <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="email" type="email" ng-model="email" name="email" required="" class="form-control" placeholder="johndoe@domain.com"> <span class="error" ng-show="userFrm.$submitted && userFrm.email.$error.required">Please enter email.</span> <span class="error" ng-show="userFrm.email.$error.email">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.password.$error.required || userFrm.password.$error.pattern) && userFrm.password.$touched}"><label for="inputEmail3" class="col-sm-3 control-label">Password <span ng-show="!editedUserId" class="asterisk_input"></span></label><div class="col-sm-9"><input id="password" type="password" ng-model="password" ng-minlength="6" name="password" ng-required="!usereditId" class="form-control" placeholder="Password" ng-pattern="/^(?=.*[A-Za-z])(?=.*\\d)[A-Za-z\\d!@#$%^&]/"> <span class="error" ng-show="userFrm.$submitted && userFrm.password.$error.required">Please enter password.</span> <span class="error" ng-show="!userFrm.password.$error.minlength && userFrm.password.$error.pattern">Password must be alpha numeric.</span> <span class="error" ng-show="userFrm.password.$error.minlength">Password must be at least 6 characters.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.newPassword.$error.required || userFrm.newPassword.$error.pattern) && userFrm.newPassword.$touched}"><label class="col-sm-3 control-label">Conf. Password <span ng-show="!editedUserId" class="asterisk_input"></span></label><div class="col-sm-9"><input type="password" ng-required="!usereditId" ng-model="newPassword" name="newPassword" class="form-control" id="newPassword" placeholder="Confirm Password" ng-pattern="password"> <span class="error" ng-show="userFrm.$submitted && userFrm.newPassword.$error.required">Please enter confirm password.</span> <span class="error" ng-show="userFrm.newPassword.$error.pattern">Confirm Password should match with Password.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (userFrm.mobile.$error.required || userFrm.mobile.$error.pattern) && userFrm.mobile.$touched}"><label for="mobile" class="col-sm-3 control-label">Phone <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="mobile" limit-to="15" type="text" ng-model="mobile" name="mobile" ng-minlength="10" required="" class="form-control" placeholder="123-123-1234" ng-pattern="/^(\\+?(\\d{1}|\\d{2}|\\d{3})[- ]?)?\\d{3}[- ]?\\d{3}[- ]?\\d{4}$/"> <span class="error" ng-show="userFrm.$submitted && userFrm.mobile.$error.required">Please enter phone number.</span> <span class="error" ng-show="!userFrm.mobile.$error.minlength && userFrm.mobile.$error.pattern">Please enter valid phone number</span> <span class="error" ng-show="userFrm.mobile.$error.minlength">Number must contain atleast 10 digits.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-3 control-label">Role <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="selected" class="form-control roleData" ng-model="selected" name="role" required=""><option ng-repeat="formOfTrans in standardSelectItems" value="{{formOfTrans.value}}">{{formOfTrans.label}}</option></select><span class="error" ng-show="userFrm.$submitted && userFrm.role.$error.required">Please select role.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': userFrm.inlineRadioOptions.$error.required && userFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="userFrm.$submitted && userFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-3 control-label">Designation <span class="asterisk_input"></span></label><div class="col-sm-9"><select id="designation" class="form-control desigData" ng-model="designation" name="designation" required=""><option value="">Select Designation</option><option value="ROLE_ADMIN" ng-selected="designation==\'ROLE_ADMIN\'">Admin</option><option value="ROLE_DESIGNER" ng-selected="designation==\'ROLE_DESIGNER\'">Designer</option><option value="ROLE_QA" ng-selected="designation==\'ROLE_QA\'">QA</option></select><span class="error" ng-show="userFrm.$submitted && userFrm.designation.$error.required">Please select designation.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': userFrm.inlineRadioOptions.$error.required && userFrm.inlineRadioOptions.$touched}"><label for="inputFirstName" class="col-sm-3 control-label">Gender <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="gender" required="" checked="checked" ng-model="gender" type="radio" name="inlineRadioOptions" value="male"> <span>Male</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="gender" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="female"> <span>Female</span></label> <span class="error" ng-show="userFrm.$submitted && userFrm.inlineRadioOptions.$error.required">Please select gender.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-if="usereditId > 0"><label class="col-sm-3 control-label">Download Barcode</label><div class="col-sm-9"><button type="button" class="btn btn-primary btn-with-icon" ng-click="downloadBarcode(usereditId)"><i class="ion-android-checkmark-circle"></i> Download</button></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="account-settings.sub-admin" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="usereditId"></form></div></div>');
$templateCache.put('app/pages/accountSettings/users/deleteModal.html','<div class="modal-content" ng-controller="usersCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteUser()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/users/statusModal.html','<div class="modal-content" ng-controller="usersCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/accountSettings/users/users.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-if="permissionArr.indexOf(\'sub_admin_add\') !== - 1" ng-click="addUser()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/bugReportSettings/shipmentBugReport/shipmentBugReport.html','<div class="widgets profile faqfrontend" ba-panel=""><div ng-init="getShipmentBugReportData()"><form class="form-horizontal" name="shipmentBugReportFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="shipmentBugReportFrm.$valid && saveshipmentBugReportSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Shipment Bug Report Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row" ng-class="{\'has-error\': (shipmentBugReportFrm.bugreporturl.$error.required) && shipmentBugReportFrm.bugreporturl.$touched}"><label for="bugreporturl" class="col-sm-3 control-label">Bug Report URL</label><div class="col-sm-9"><input id="bugreporturl" type="text" ng-model="vm.bugreporturl" name="bugreporturl" required="" class="form-control" placeholder="Bug Report URL"> <span class="error" ng-show="shipmentBugReportFrm.$submitted && shipmentBugReportFrm.bugreporturl.$error.required">Please enter url.</span></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="shipmentBugReportFrm.$valid && saveshipmentBugReportSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></form></div></div>');
$templateCache.put('app/pages/dubaiMachines/dubaiJobs/dubaijobs.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="input-group"><input id="dateDoneRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options2" ng-model="datePickerDoneReports.date" placeholder="Select Done Date" type="text" readonly=""> <span ng-click="focusDoneInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-1 text-right"><span class="">Done Check</span></div><div class="col-md-1 text-right"><label class="custom-switch switcher-container"><input type="checkbox" value="true" id="chk" ng-click="showDoneDates($event)"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="Crystal" type="text" ng-model="vm.Crystal" name="Crystal" class="form-control" placeholder="Crystal"></div></div></div></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/databaseMachines/databaseJobs/databasejobs.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-6"><div class="row"><div class="col-md-6"><div class="input-group"><input id="dateDoneRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options2" ng-model="datePickerDoneReports.date" placeholder="Select Done Date" type="text" readonly=""> <span ng-click="focusDoneInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-1 text-right"><span class="">Done Check</span></div><div class="col-md-1 text-right"><label class="custom-switch switcher-container"><input type="checkbox" value="true" id="chk" ng-click="showDoneDates($event)"><div class="switcher success"><div class="handle-container"><span class="handle handle-on"><i class="fa fa-check"></i></span> <span class="handle"></span> <span class="handle handle-off"><i class="fa fa-times"></i></span></div></div></label></div><div class="col-md-4"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="Crystal" type="text" ng-model="vm.Crystal" name="Crystal" class="form-control" placeholder="Crystal"></div></div></div></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventorySettings/inventorysettings.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getActiveStatus();"><div ng-init="getSettingData()"><form class="form-horizontal" name="settingForm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="settingForm.$valid && saveSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Inventory Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="allocateStatus" class="col-sm-3 control-label">Status for allocate stock</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.allocateStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="allocateStatus" id="allocateStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="removeStatus" class="col-sm-3 control-label">Status for Remove stock</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.removeStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="removeStatus" id="removeStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="removeAllocationStatus" class="col-sm-3 control-label">Status for Remove Allocation</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.removeAllocationStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="removeAllocationStatus" id="removeAllocationStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="minQty" class="col-sm-3 control-label">Minimum Qty Alert</label><div class="col-sm-9"><input id="minQty" type="number" ng-model="vm.minQty" name="minQty" required="" class="form-control" placeholder="Min Qty"> <span class="error" ng-show="settingForm.$submitted && settingForm.minQty.$error.required">Please enter minimum qty alert.</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="emailFrom" class="col-sm-3 control-label">Email From</label><div class="col-sm-9"><input id="emailFrom" type="email" ng-model="vm.emailFrom" name="emailFrom" required="" class="form-control" placeholder="From Email Address"> <span class="error" ng-show="settingForm.$submitted && settingForm.emailFrom.$error.required">Please enter from emaill address.</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="emailTo" class="col-sm-3 control-label">Email To</label><div class="col-sm-9"><ui-select multiple="" tagging="" tagging-label="" ng-model="vm.emailTo" search-enabled="true" sortable="true" title="Select Email" required="" name="emailTo" id="emailTo" class="form-control multipleSelect"><ui-select-match placeholder="Select Email">{{$item}}</ui-select-match><ui-select-choices repeat="emailto in availableEmails | filter:$select.search">{{emailto}}</ui-select-choices></ui-select><span class="error" ng-show="settingForm.$submitted && settingForm.emailTo.$error.required">Please enter email address.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Order Box Cost</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row"><label for="defCost" class="col-sm-3 control-label">Default Cost</label><div class="col-sm-9"><input id="defCost" type="number" ng-model="vm.defCost" name="defCost" required="" class="form-control" placeholder="Default Cost"> <span class="error" ng-show="settingForm.$submitted && settingForm.defCost.$error.required">Please enter default cost.</span></div></div></div><div class="col-md-6"><div class="form-group row"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Store Code</th><th class="width-10-per">Use Default</th><th class="width-20-per">Price</th></tr></thead><tr class="editable-row" ng-if="vm.store_costs.length > 0" ng-repeat="sc in vm.store_costs"><td class="text-center">{{ sc.store_name }}</td><td class="text-center">{{ sc.store_code }}</td><td class="text-center"><a ng-if="sc.default_value == 0" ng-click="changedefault($index,sc.store_id,1)" href="javascript:void(0);" title="No"><img src="assets/img/switch-on.png" width="24"></a> <a ng-if="sc.default_value == 1" ng-click="changedefault($index,sc.store_id,0)" href="javascript:void(0);" title="Yes"><img src="assets/img/switch-off.png" width="24"></a></td><td ng-if="sc.default_value == 0"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left">$</span> <input type="text" is-number-key="" class="form-control" placeholder="Price" ng-model="sc.inventory_cost" value="{{sc.inventory_cost}}" name="storecost{{$index}}" required=""> <span class="error" ng-show="settingForm.$submitted && settingForm[\'storecost\' +$index].$error.required">Please enter price.</span></div></td><td ng-if="sc.default_value == 1">${{sc.inventory_cost}}</td></tr><tr ng-if="vm.store_costs.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="settingForm.$valid && saveSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/addProduct.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';"><div class="panel-content" ng-init="getEditedProduct()"><form class="form-horizontal" name="inventoryProductFrm" novalidate="" ng-submit="inventoryProductFrm.$valid && saveinventoryProductData()"><div class="row"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>{{productTitle}}</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.name.$error.required || inventoryProductFrm.name.$error.maxlength) && inventoryProductFrm.name.$touched}"><label for="name" class="col-sm-4 control-label">Product Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="name" limit-to="150" ng-maxlength="150" type="text" ng-model="ip.name" name="name" required="" class="form-control" placeholder="Product Name"> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.name.$error.required">Please enter product name.</span> <span class="error" ng-show="!inventoryProductFrm.name.$error.pattern && inventoryProductFrm.name.$error.maxlength && inventoryProductFrm.name.$touched">Product Name should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': inventoryProductFrm.SKU.$error.required && inventoryProductFrm.SKU.$touched}"><label for="SKU" class="col-sm-4 control-label">SKU <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" tagging="" tagging-label="" ng-model="ip.SKU" search-enabled="true" sortable="true" title="Select SKU" required="" name="SKU" id="SKU" class="form-control multipleSelect"><ui-select-match placeholder="Select SKU">{{$item}}</ui-select-match><ui-select-choices repeat="sku in availableSKU | filter:$select.search">{{sku}}</ui-select-choices></ui-select><span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.SKU.$error.required">Please enter sku.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="ip.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="ip.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.status.$error.required">Please select status.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.name"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Warehouses Inventory</span></uib-accordion-heading><div class="row" ng-if="ip.name"><div class="col-md-12"><div class="form-group row"><div class="col-sm-12"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-30-per">Warehouse Name</th><th class="width-15-per">Stock</th><th class="width-15-per">Allocated</th><th class="width-15-per">Available</th><th class="width-15-per">Action</th></tr></thead><tbody><tr ng-if="ip.wareHouses.length > 0" ng-repeat="warehouse in ip.wareHouses"><td>{{ warehouse.warehouse_name }}</td><td class="text-center">{{ warehouse.product_stock }}</td><td class="text-center">{{ warehouse.product_allocated }}</td><td class="text-center">{{ warehouse.product_available }}</td><td class="text-center"><a href="javascript:void(0);" title="Add Stock" ng-click="AddStock(warehouse.warehouse_product_id,warehouse.warehouse_id)"><i class="fa fa-plus" style="color:#fff;font-size:18px"></i></a>&nbsp; <a href="javascript:void(0);" title="Remove Stock" ng-click="RemoveStock(warehouse.warehouse_product_id)" ng-if="warehouse.product_available > 0" style="color:#fff;font-size:18px"><i class="fa fa-minus"></i></a>&nbsp; <a href="javascript:void(0);" title="Move Stock" ng-click="moveStock(warehouse.warehouse_product_id,warehouse.warehouse_id)" ng-if="warehouse.product_available > 0" style="color:#fff;font-size:18px">&#8644;</a> <a href="javascript:void(0);" title="Stock History" ng-click="openLogHistory(warehouse.warehouse_product_id)" ng-if="warehouse.warehouse_product_id > 0" style="color:#fff;font-size:18px"><i class="fa fa-question-circle"></i></a></td></tr></tbody></table></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.name"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Store Prices</span></uib-accordion-heading><div class="row" ng-if="ip.name"><div class="col-sm-8"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Store Code</th><th class="width-10-per">Use Default</th><th class="width-20-per">Price</th></tr></thead><tr class="editable-row" ng-if="ip.store_costs.length > 0" ng-repeat="sc in ip.store_costs"><td class="text-center">{{ sc.store_name }}</td><td class="text-center">{{ sc.store_code }}</td><td class="text-center"><a ng-if="sc.default_value == 0" ng-click="changedefault($index,sc.store_id,1)" href="javascript:void(0);" title="No"><img src="assets/img/switch-on.png" width="24"></a> <a ng-if="sc.default_value == 1" ng-click="changedefault($index,sc.store_id,0)" href="javascript:void(0);" title="Yes"><img src="assets/img/switch-off.png" width="24"></a></td><td ng-if="sc.default_value == 0"><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left">$</span> <input type="text" is-number-key="" class="form-control" placeholder="Price" ng-model="sc.product_cost" value="{{sc.product_cost}}" name="storecost{{$index}}" required=""> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm[\'storecost\' +$index].$error.required">Please enter price.</span></div></td><td ng-if="sc.default_value == 1">${{sc.product_cost}}</td></tr><tr ng-if="ip.store_costs.length < 1"><td colspan="2">No data available in table</td></tr></table></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.name"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Qty / Box</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.boxqty.$error.required || inventoryProductFrm.boxqty.$error.maxlength) && inventoryProductFrm.boxqty.$touched}"><label for="boxqty" class="col-sm-4 control-label">Qty in Box <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="boxqty" type="number" min="1" ng-model="ip.boxqty" name="boxqty" required="" class="form-control" placeholder="Qty"> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.boxqty.$error.required">Please enter quantity.</span> <span class="error" ng-show="!inventoryProductFrm.boxqty.$error.pattern && inventoryProductFrm.boxqty.$error.min && inventoryProductFrm.boxqty.$touched">Qty should be greater than 0</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.SKU"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>SKU / Qty in Box</span></uib-accordion-heading><div class="row form-group"><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">SKU</th><th class="width-45-per">Qty</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem()"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ip.SkuQty.length > 0" ng-repeat="extra in ip.SkuQty" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExtra-{{$index}}"><input only-caracter="" type="text" ng-model="extra.sku" limit-to="30" value="{{extra.sku}}" ng-maxlength="30" name="sku" required="" class="form-control height28px" placeholder="SKU"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExtra-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="extra.qty" limit-to="30" ng-maxlength="30" name="qty" required="" class="form-control height28px" placeholder="Qty"></div></div></div></div></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index)"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ip.SkuQty.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.name"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Minimum Qty Alert</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.minQty.$error.required || inventoryProductFrm.minQty.$error.maxlength) && inventoryProductFrm.boxqty.$touched}"><label for="minQty" class="col-sm-4 control-label">Minimum Qty <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="minQty" type="number" ng-model="ip.minQty" name="minQty" required="" class="form-control" placeholder="Min Qty"> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.minQty.$error.required">Please enter minimum qty alert.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[6].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[6].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[6].isOpen}"></i> <span>Cost Settings</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row" ng-class="{\'has-error\': (inventoryProductFrm.weight.$error.required || inventoryProductFrm.weight.$error.maxlength) && inventoryProductFrm.weight.$touched}"><label for="weight" class="col-sm-4 control-label">Weight</label><div class="col-sm-8"><div class="input-group mb-0px"><input type="text" is-number-key="" ng-model="ip.weight" id="weight" name="weight" class="form-control with-primary-addon" placeholder="Weight" ng-required=""> <span class="input-group-addon input-group-addon-default addon-right" id="productweight">lbs</span> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.weight.$error.required">Please enter weight.</span></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="cost" class="col-sm-4 control-label">Cost</label><div class="col-sm-8"><div class="input-group mb-0px"><span class="input-group-addon input-group-addon-default addon-left">$</span> <input type="text" is-number-key="" ng-model="ip.cost" id="cost" name="cost" class="form-control" placeholder="Cost"> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.cost.$error.required">Please enter cost.</span></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="length" class="col-sm-2 control-label">Length, Width & Height</label><div class="col-sm-10"><div class="row"><div class="col-md-4 col-sm-4"><input type="text" is-number-key="" ng-model="ip.length" id="length" name="length" class="form-control" placeholder="Length"></div><div class="col-md-4 col-sm-4"><input type="text" is-number-key="" ng-model="ip.width" id="width" name="width" class="form-control" placeholder="Width"></div><div class="col-md-4 col-sm-4"><div class="input-group mb-0px"><input type="text" is-number-key="" ng-model="ip.height" id="height" name="height" class="form-control" placeholder="Height"> <span class="input-group-addon input-group-addon-default addon-right" id="productheight">(in)</span></div></div></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[7].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[7].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[7].isOpen}"></i> <span>International Shipment Settings</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.hscode.$error.required || inventoryProductFrm.hscode.$error.maxlength) && inventoryProductFrm.hscode.$touched}"><label for="hscode" class="col-sm-4 control-label">HS Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="hscode" ng-maxlength="20" type="text" ng-model="ip.hscode" name="hscode" required="" class="form-control" placeholder="HS Code"> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.hscode.$error.required">Please enter hs code.</span> <span class="error" ng-show="!inventoryProductFrm.hscode.$error.pattern && inventoryProductFrm.hscode.$error.maxlength && inventoryProductFrm.hscode.$touched">HS Code should not be greater than 20 characters</span></div></div></div><div class="col-md-8"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.description.$error.required || inventoryProductFrm.description.$error.maxlength) && inventoryProductFrm.description.$touched}"><label for="description" class="col-sm-2 control-label">Description <span class="asterisk_input"></span></label><div class="col-sm-10"><input id="description" type="text" maxlength="100" ng-model="ip.description" name="description" required="" class="form-control" placeholder="Product Description"> <span class="error" ng-show="inventoryProductFrm.$submitted && inventoryProductFrm.description.$error.required">Please enter product description.</span> <span class="error" ng-show="inventoryProductFrm.description.$error.maxlength && inventoryProductFrm.description.$touched">Product Description should not be greater than 100 characters</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[8].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[8].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[8].isOpen}"></i> <span>Label Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="length" class="col-sm-2 control-label">Item Type</label><div class="col-sm-10"><select class="form-control" ng-model="ip.itemtype" name="itemtype" id="itemtype" required=""><option value="">Select Type</option><option value="crystal">Crystal</option><option value="base">Base</option><option value="cosmetic">Cosmetic</option><option value="ink">Ink</option><option value="other">Other</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[9].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.SKU"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[9].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[9].isOpen}"></i> <span>Database Job Setting</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.crystalcode.$error.maxlength) && inventoryProductFrm.crystalcode.$touched}"><label for="crystalcode" class="col-sm-4 control-label">Crystal Code</label><div class="col-sm-8"><input id="crystalcode" ng-maxlength="50" type="text" ng-model="ip.crystalcode" name="crystalcode" class="form-control" placeholder="Crystal Code"> <span class="error" ng-show="inventoryProductFrm.crystalcode.$error.maxlength && inventoryProductFrm.crystalcode.$touched">Crystal Code should not be greater than 50 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.crystalsize.$error.maxlength) && inventoryProductFrm.crystalsize.$touched}"><label for="crystalsize" class="col-sm-4 control-label">Crystal Size</label><div class="col-sm-8"><input id="crystalsize" ng-maxlength="50" type="text" ng-model="ip.crystalsize" name="crystalsize" class="form-control" placeholder="Crystal Size"> <span class="error" ng-show="inventoryProductFrm.crystalsize.$error.maxlength && inventoryProductFrm.crystalsize.$touched">Crystal Size should not be greater than 50 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (inventoryProductFrm.identification.$error.maxlength) && inventoryProductFrm.identification.$touched}"><label for="identification" class="col-sm-4 control-label">Identification</label><div class="col-sm-8"><input id="identification" ng-maxlength="50" type="text" ng-model="ip.identification" name="identification" class="form-control" placeholder="Identification"> <span class="error" ng-show="inventoryProductFrm.identification.$error.maxlength && inventoryProductFrm.identification.$touched">Identification should not be greater than 50 characters</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[10].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.SKU"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[10].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[10].isOpen}"></i> <span>Addon Product</span></uib-accordion-heading><div class="row" ng-init="getProductData();getStoreData()"><div class="col-md-8"><div class="form-group row"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Addons</th></tr></thead><tbody><tr class="editable-row" ng-if="ip.addon_products.length > 0" ng-repeat="sc in ip.addon_products"><td class="text-center">{{ sc.store_name }} {{ sc.addonproducts }}</td><td><div class="input-group"><input type="text" class="form-control" placeholder="Addon Product" ng-model="sc.addonproducts" value="{{sc.addonproducts}}" name="addonproducts{{$index}}"></div></td></tr></tbody></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[11].isOpen" panel-class="panel accordion-panel panel-blur" ng-if="ip.itemtype == \'cosmetic\'"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[11].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[11].isOpen}"></i> <span>Barcode</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="barcode" class="col-sm-4 control-label">Product Barcode</label><div class="col-sm-8"><input id="barcode" type="text" ng-model="ip.barcode" name="barcode" class="form-control" placeholder="Product Barcode"></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 text-right"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="inventorymanagement.invntoryproducts" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="productId"></div></div></form></div></div><div id="wareHouseLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Warehouse Stock Logs</span> <button type="button" class="close" ng-click="closeLogHistory()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="date">Date</th><th class="date">Action Type</th><th class="uName">User Name</th><th class="oldStatus">QTY Per Box</th><th class="oldStatus">Boxes</th><th class="nStatus">Total QTY</th><th class="nStatus">Note</th><th class="nStatus">From</th><th class="nStatus">To</th></tr></thead><tbody><tr ng-repeat="data in stockLogsArr"><td class="date">{{getGlobalDateFormat(data.updated_at)}}</td><td class="date">{{data.log_type}}</td><td class="uName">{{data.updated_by}}</td><td>{{data.single_qty}}</td><td>{{data.total_box}}</td><td>{{data.total_qty}}</td><td class="nStatus">{{data.note}}</td><td class="nStatus">{{data.from_warehouse}}</td><td class="nStatus">{{data.to_warehouse}}</td></tr><tr ng-if="!stockLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><style type="text/css">\r\n  .width-15-per { width:15%; }\r\n</style>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/addWarehouseStock.html','<div class="modal-content" ng-controller="inventoryProductsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Add Warehouse Stock</span></div><div class="modal-body"><form class="form-horizontal" name="WarehouseProductFrm" novalidate="" ng-submit="WarehouseProductFrm.$valid && saveWareHouseProduct()"><div class="row"><div class="col-sm-4"><input id="addqty" type="number" min="0" ng-min="0" ng-minlength="0" ng-model="addqty" name="addqty" class="form-control" placeholder="Quantity"> <span class="error" ng-show="!WarehouseProductFrm.addqty.$error.pattern && WarehouseProductFrm.addqty.$error.minlength && WarehouseProductFrm.addqty.$touched">Qty should not be less than 0</span></div><div class="col-sm-4"><input id="addbox" type="number" min="0" ng-min="0" ng-minlength="0" ng-model="addbox" name="addbox" class="form-control" placeholder="Box"> <span class="error" ng-show="!WarehouseProductFrm.addbox.$error.pattern && WarehouseProductFrm.addbox.$error.minlength && WarehouseProductFrm.addqty.$touched">Box should not be less than 0</span></div><div class="col-sm-4"><input id="addsqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="addsqty" name="addsqty" required="" class="form-control" placeholder="Total Quantity"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addsqty.$error.required">Please enter Total Quantity.</span> <span class="error" ng-show="!WarehouseProductFrm.addsqty.$error.pattern && WarehouseProductFrm.addsqty.$error.minlength && WarehouseProductFrm.addsqty.$touched">Qty should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!WarehouseProductFrm.addnote.$error.pattern && WarehouseProductFrm.addnote.$error.maxlength && WarehouseProductFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="WareHouseProductId"> <input type="hidden" ng-model="WareHouseId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/allocationLog.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8"><h3>Product Name: <span>{{ productname }}</span></h3></div><div class="col-md-4"><button type="button" ng-click="removeAll()" class="btn btn-danger btn-with-icon add-new-btn"><i class="ion-trash-a"></i>Remove All Allocation</button></div><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/allocationRemoveLog.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><h3>Product Name: <span>{{ productname }}</span></h3></div><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/deleteModal.html','<div class="modal-content" ng-controller="inventoryProductsCtrl"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteProduct()">YES</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/deleteSkuQty.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/productAllocation.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-8"><h3>Product Name: <span>{{ productname }}</span></h3></div><div class="col-md-4"><button type="button" ng-click="removeAll()" class="btn btn-danger btn-with-icon add-new-btn"><i class="ion-trash-a"></i>Remove All Allocation</button></div><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/products.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addProduct()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button> <button type="button" ng-click="CrystalBarcodes()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Barcodes</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div><div id="allocationLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Allocation Stock Log</span> <button type="button" class="close" ng-click="closeLogHistory()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="date">Date</th><th class="uName">Order</th><th class="uName">Item</th><th class="oldStatus">QTY</th><th class="uName">Allocated By</th></tr></thead><tbody><tr ng-repeat="data in allocationLogsArr"><th class="date">{{getGlobalDateFormat(data.allocated_at)}}</th><th class="uName">{{ data.increment_id }}</th><th class="uName">{{ data.item_increment_id }}</th><th class="oldStatus">1</th><th class="uName">{{ data.username }}</th></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/removeWarehouseStock.html','<div class="modal-content" ng-controller="inventoryProductsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Remove Warehouse Stock</span></div><div class="modal-body"><form class="form-horizontal" name="WarehouseProductFrm" novalidate="" ng-submit="WarehouseProductFrm.$valid && removeWareHouseProduct()"><div class="row"><div class="col-sm-4"><input id="removeQty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removeQty" name="removeQty" required="" class="form-control" placeholder="Quantity"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.removeQty.$error.required">Please enter Quantity.</span> <span class="error" ng-show="!WarehouseProductFrm.removeQty.$error.pattern && WarehouseProductFrm.removeQty.$error.minlength && WarehouseProductFrm.removeQty.$touched">Qty should not be less than 1</span></div><div class="col-sm-4"><input id="removebox" type="number" min="0" ng-min="0" ng-model="removebox" name="removebox" class="form-control" placeholder="Box"></div><div class="col-sm-4"><input id="removesqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removesqty" name="removesqty" required="" class="form-control" placeholder="Total Quantity"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.removesqty.$error.required">Please enter Total Quantity.</span> <span class="error" ng-show="!WarehouseProductFrm.removesqty.$error.pattern && WarehouseProductFrm.removesqty.$error.minlength && WarehouseProductFrm.removesqty.$touched">Qty should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!WarehouseProductFrm.addnote.$error.pattern && WarehouseProductFrm.addnote.$error.maxlength && WarehouseProductFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="WareHouseProductId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/statusModal.html','<div class="modal-content" ng-controller="inventoryProductsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/inventoryManagement/inventoryProducts/warehouseProducts.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/addWarehouse.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';type=\'stock\';"><div class="panel-content" ng-init="getEditedWareHouse()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="warehouseFrm" novalidate="" ng-submit="warehouseFrm.$valid && saveWareHouseData()"><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (warehouseFrm.name.$error.required || warehouseFrm.name.$error.pattern || warehouseFrm.name.$error.maxlength) && warehouseFrm.name.$touched}"><label for="name" class="col-sm-3 control-label">Warehouse Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="name" type="text" ng-model="name" limit-to="50" ng-maxlength="50" name="name" required="" class="form-control" placeholder="Warehouse Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="warehouseFrm.$submitted && warehouseFrm.name.$error.required">Please enter warehouse name.</span> <span class="error" ng-show="warehouseFrm.name.$error.pattern">Please enter valid warehouse name.</span> <span class="error" ng-show="warehouseFrm.name.$error.maxlength && warehouseFrm.name.$touched">Warehouse Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label for="type" class="col-sm-3 control-label">Type <span class="asterisk_input"></span></label><div class="col-sm-9"><select class="form-control" ng-model="type" name="type" id="type" required=""><option value="">Select Type</option><option value="production">Production</option><option value="stock">Stock</option><option value="on the way">In Transit</option><option value="in process">China Production</option><option value="ink">Ink</option></select><span class="error" ng-show="warehouseFrm.$submitted && warehouseFrm.type.$error.required">Please select type.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="inlineRadio1" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio1" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="warehouseFrm.$submitted && warehouseFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label for="type" class="col-sm-3 control-label">Product Type <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" class="product_types" ng-checked="checkPTypeExists(\'crystal\')" id="product_type_crystal" name="product_types[]" value="crystal"><span>Crystal</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" class="product_types" ng-checked="checkPTypeExists(\'base\')" id="product_type_base" name="product_types[]" value="base"><span>Base</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" class="product_types" ng-checked="checkPTypeExists(\'other\')" id="product_type_other" name="product_types[]" value="other"><span>Other</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" class="product_types" ng-checked="checkPTypeExists(\'cosmetic\')" id="product_type_cosmetic" name="product_types[]" value="cosmetic"><span>Cosmetic</span></label> <label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" class="product_types" ng-checked="checkPTypeExists(\'ink\')" id="product_type_ink" name="product_types[]" value="ink"><span>Ink</span></label></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="inventorymanagement.warehouse" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="warehouseId"></form></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/addWarehouseStock.html','<div class="modal-content" ng-controller="wareHouseProductsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Add Stock for {{ productName }}</span></div><div class="modal-body"><form class="form-horizontal" name="WarehouseProductFrm" novalidate="" ng-submit="WarehouseProductFrm.$valid && saveWareHouseProduct()"><div class="row"><div class="col-sm-4"><input id="addqty" type="number" min="0" ng-min="0" ng-minlength="1" ng-model="addqty" name="addqty" class="form-control" placeholder="Pieces" ng-change="ChangeTotalStock(addqty,addbox,\'add\')"> <span class="error" ng-show="!WarehouseProductFrm.addqty.$error.pattern && WarehouseProductFrm.addqty.$error.min && WarehouseProductFrm.addqty.$touched">Piece should not be less than 1</span></div><div class="col-sm-4"><input id="addbox" type="number" min="0" ng-min="0" ng-model="addbox" name="addbox" class="form-control" placeholder="Box" ng-change="ChangeTotalStock(addqty,addbox,\'add\')"> <span class="error" ng-show="!WarehouseProductFrm.addqty.$error.pattern && WarehouseProductFrm.addqty.$error.min && WarehouseProductFrm.addqty.$touched">Box should not be less than 1</span></div><div class="col-sm-4"><input id="addsqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="addsqty" name="addsqty" required="" class="form-control" placeholder="Total Pieces" readonly="readonly"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addsqty.$error.required">Please enter Total Quantity.</span> <span class="error" ng-show="!WarehouseProductFrm.addsqty.$error.pattern && WarehouseProductFrm.addsqty.$error.minlength && WarehouseProductFrm.addsqty.$touched">Pieces should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!WarehouseProductFrm.addnote.$error.pattern && WarehouseProductFrm.addnote.$error.maxlength && WarehouseProductFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="WareHouseProductId"> <input type="hidden" ng-model="WareHouseId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/deleteModal.html','<div class="modal-content" ng-controller="wareHouseCtrl"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="deleteWareHouse()">YES</button> <button type="button" class="btn btn-info" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/moveWarehouseStock.html','<div class="modal-content" ng-controller="wareHouseProductsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Move Warehouse Stock</span></div><div class="modal-body"><form class="form-horizontal" name="WarehouseProductFrm" novalidate="" ng-submit="WarehouseProductFrm.$valid && moveWareHouseStock()"><div class="row"><div class="col-sm-4"><strong>Product SKU:</strong></div><div class="col-sm-8">{{psku}}</div><div class="col-sm-4"><br><strong>Product Name:</strong></div><div class="col-sm-8"><br><span style="font-size: 25px;">{{pname}}</span></div></div><hr><div class="row"><div class="col-sm-4"><strong>From Warehouse:</strong></div><div class="col-sm-8"><select class="form-control" name="fWareHouse" id="fWareHouse" ng-model="fWareHouse" required=""><option ng-repeat="fwh in firstWareHouses" value="{{fwh.warehouse_id}}">{{fwh.warehouse_name}}</option></select></div><div class="col-sm-4"><br><strong>Available Stock:</strong></div><div class="col-sm-8"><br>{{astock}}</div></div><div class="row"><div class="col-sm-4"><br><strong>Pieces in Box:</strong></div><div class="col-sm-8"><br><input id="addqty" type="number" min="1" ng-min="1" ng-minlength="1" max="{{astock}}" ng-max="{{astock}}" ng-maxlength="{{astock}}" ng-model="addqty" name="addqty" required="" class="form-control" placeholder="Pieces" ng-change="ChangeTotalStock(addqty,addbox,\'move\')"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addqty.$error.required">Please enter Pieces.</span> <span class="error" ng-show="!WarehouseProductFrm.addqty.$error.pattern && WarehouseProductFrm.addqty.$error.minlength && WarehouseProductFrm.addqty.$touched">Pieces should not be less than 1</span> <span class="error" ng-show="!WarehouseProductFrm.addqty.$error.pattern && WarehouseProductFrm.addqty.$error.max && WarehouseProductFrm.addqty.$touched">Pieces should not be grather than {{astock}}</span></div></div><div class="row"><div class="col-sm-4"><br><strong>Box:</strong></div><div class="col-sm-8"><br><input id="addbox" type="number" min="0" ng-min="0" ng-model="addbox" name="addbox" class="form-control" placeholder="Box" ng-change="ChangeTotalStock(addqty,addbox,\'move\')"></div></div><div class="row"><div class="col-sm-4"><br><strong>Total Pieces:</strong></div><div class="col-sm-8"><br><input id="addsqty" type="number" min="1" ng-min="1" max="{{astock}}" ng-max="{{astock}}" ng-maxlength="{{astock}}" ng-minlength="1" ng-model="addsqty" name="addsqty" required="" class="form-control" placeholder="Total Pieces"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addsqty.$error.required">Please enter Total Pieces.</span> <span class="error" ng-show="!WarehouseProductFrm.addsqty.$error.pattern && WarehouseProductFrm.addsqty.$error.minlength && WarehouseProductFrm.addsqty.$touched">Pieces should not be less than 1</span> <span class="error" ng-show="!Pieces.addsqty.$error.pattern && WarehouseProductFrm.addsqty.$error.maxlength && WarehouseProductFrm.addsqty.$touched">Pieces should not be grather than {{astock}}</span> <span class="error" ng-show="!WarehouseProductFrm.addsqty.$error.pattern && WarehouseProductFrm.addsqty.$error.max && WarehouseProductFrm.addsqty.$touched">Pieces should not be grather than {{astock}}</span></div></div><div class="row"><div class="col-sm-4"><br><strong>Note:</strong></div><div class="col-sm-8"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!WarehouseProductFrm.addnote.$error.pattern && WarehouseProductFrm.addnote.$error.maxlength && WarehouseProductFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><hr><div class="row"><div class="col-sm-4"><strong>To Warehouse:</strong></div><div class="col-sm-8"><select class="form-control" name="sWareHouse" id="sWareHouse" ng-model="sWareHouse" required=""><option value="">Select Warehouse</option><option ng-repeat="wh in secondWareHouses" value="{{wh.warehouse_id}}">{{wh.warehouse_name}}</option></select><span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.sWareHouse.$error.required">Please select warehouse.</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="WareHouseProductId"> <input type="hidden" ng-model="productId"> <input type="hidden" ng-model="WareHouseId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/removeWarehouseStock.html','<div class="modal-content" ng-controller="wareHouseProductsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Remove Warehouse Stock</span></div><div class="modal-body"><form class="form-horizontal" name="WarehouseProductFrm" novalidate="" ng-submit="WarehouseProductFrm.$valid && removeWareHouseProduct()"><div class="row"><div class="col-sm-4"><input id="removeQty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removeQty" name="removeQty" class="form-control" placeholder="Quantity" ng-change="ChangeTotalStock(removeQty,removebox,\'remove\')"> <span class="error" ng-show="!WarehouseProductFrm.removeQty.$error.pattern && WarehouseProductFrm.removeQty.$error.min && WarehouseProductFrm.removeQty.$touched">Qty should not be less than 1</span></div><div class="col-sm-4"><input id="removebox" type="number" min="1" ng-min="1" ng-model="removebox" name="removebox" class="form-control" placeholder="Box" ng-change="ChangeTotalStock(removeQty,removebox,\'remove\')"> <span class="error" ng-show="!WarehouseProductFrm.removebox.$error.pattern && WarehouseProductFrm.removebox.$error.min && WarehouseProductFrm.removebox.$touched">Box should not be less than 1</span></div><div class="col-sm-4"><input id="removesqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removesqty" name="removesqty" required="" class="form-control" placeholder="Total Quantity" readonly="readonly"> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.removesqty.$error.required">Please enter Quantity or Box.</span> <span class="error" ng-show="!WarehouseProductFrm.removesqty.$error.pattern && WarehouseProductFrm.removesqty.$error.min && WarehouseProductFrm.removesqty.$touched">Qty should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="WarehouseProductFrm.$submitted && WarehouseProductFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!WarehouseProductFrm.addnote.$error.pattern && WarehouseProductFrm.addnote.$error.maxlength && WarehouseProductFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="WareHouseProductId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/statusModal.html','<div class="modal-content" ng-controller="wareHouseCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/warehouse.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addWareHouse()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/inventoryManagement/wareHouse/warehouseProducts.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3">Warehouse Name: <strong>{{ warehouse_name }}</strong></div><div class="col-md-2">Warehouse Type: <strong>{{ warehouse_type }}</strong></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div id="wareHouseLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal" style="width:1350px;"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Warehouse Stock Logs</span> <button type="button" class="close" ng-click="closeLogHistory()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="date">Date</th><th class="date">Action Type</th><th class="uName">User Name</th><th class="oldStatus">Single pc.</th><th class="oldStatus">Boxes</th><th class="oldStatus">pc/Box</th><th class="nStatus">Old pc</th><th class="nStatus">Total pc</th><th class="nStatus">New pc</th><th class="nStatus">Note</th><th class="nStatus">From</th><th class="nStatus">To</th></tr></thead><tbody><tr ng-repeat="data in stockLogsArr"><td class="date">{{getGlobalDateFormat(data.updated_at)}}</td><td class="date">{{data.log_type}}</td><td class="uName">{{data.updated_by}}</td><td>{{data.single_qty}}</td><td>{{data.total_box}}</td><td>{{data.box_qty}}</td><td class="nStatus">{{data.old_qty}}</td><td ng-if="data.log_type == \'Add\'">+ {{data.total_qty}}</td><td ng-if="data.log_type == \'Remove\'">- {{data.total_qty}}</td><td ng-if="data.log_type == \'Move\'"><span ng-if="data.from_warehouse_id == 0">-</span><span ng-if="data.from_warehouse_id != 0">+</span> {{data.total_qty}}</td><td class="nStatus">{{data.new_qty}}</td><td class="nStatus">{{data.note}}</td><td class="nStatus">{{data.from_warehouse}}</td><td class="nStatus">{{data.to_warehouse}}</td></tr><tr ng-if="!stockLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/machineDashboard/dashboard/crystalStatusModal.html','<div class="modal-content" ng-init="getCrystalStatus()" ng-style="{\'height\': popupSize}"><div class="modal-header bg-info"><div class="row text-center"><div class="col-md-3"></div><div class="col-md-9"><h3 class="col-md-9 col-sm-9">{{productName}} ({{fromDate}} To {{toDate}}) ({{regOrderTotal?regOrderTotal:0}})</h3><button type="button" class="close close-details" ng-click="$dismiss();closePopup();" aria-label="Close">&times;</button></div></div></div><div class="modal-body shipping-modal"><div ng-if="popupSize == 201" class="margin-top-12 text-center" style="margin-top:20px;color: black">No status found</div><div ng-if="popupSize != 201" class="row margin-top-10"><div class="col-md-12"><div class="pie-charts"><div ng-if="key" class="col-md-3 col-sm-6" ng-repeat="(key,value) in statusData"><div class="cursor-pointer regular-status-box" ng-style="{\'background-color\':value.color_code?value.color_code:\'#000\'}"><div class="pie-chart-item"><div class="description padding-0"><div class="title-pichart" title="{{ key }}"><div class="cut-text">{{ key }}</div></div><div ng-class="{\'font16px\':chart.smallFont}" class="description-total">Total Orders: {{value.total_orders}}</div><div ng-class="{\'font16px\':chart.smallFont}" class="description-stats">Total Items: {{value.item_total}}</div></div></div></div></div></div></div></div></div><div class="modal-footer"></div></div><style>\n  .shipping-modal.modal-body {\n    max-height: {{popupSizeMin}}px;\n    overflow-y:scroll;\n    overflow-x:hidden;\n  }\n</style>');
$templateCache.put('app/pages/machineDashboard/dashboard/machineDashboard.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="resetManualDate();"><form class="form-horizontal" name="machineDashboardFrm" novalidate=""><div class="row"><div class="col-sm-3 col-lg-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerRegular.date" name="datePicker" type="text" readonly="" required=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getStoreData()"><div class="form-group row"><div class="col-sm-12"><ui-select multiple="" ng-model="vm.stores" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="stores" id="stores"><ui-select-match placeholder="Stores">{{$item.store_name}}</ui-select-match><ui-select-choices repeat="store.store_id as store in vm.storeData | filter: $select.search"><span ng-bind-html="store.store_name"></span></ui-select-choices></ui-select></div></div></div><div class="col-sm-3 col-lg-3"><div class="form-group row"><label for="showAll" class="col-sm-5 control-label">Show Status</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.showAll" on-label="All" off-label="QA Approved"></ba-switcher></div></div></div><div class="col-sm-3 col-lg-3"><a href="{{ vm.qrlogin_url }}" class="btn btn-primary" target="_blank">Open Machines</a>&nbsp; <button type="button" ng-click="applyFilter()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetFilter()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button> <span class="">Total Slotted: {{ total_slotted }}</span> / <span class="">Total Needed: {{ total_needed }}</span></div></div><h3 class="with-line"></h3><div class="row" ng-init="getCrystalData()"><div ng-if="crystalData.length>0" class="col-lg-2 col-md-4 col-sm-4 margin-top-10" ng-repeat="crystal in crystalData"><button type="button" class="btn btn-primary btn-with-icon btn-xm shipping-btn min-width-200 white-space-normal"><div class="textclassforcurt" title="{{crystal.name}}" style="text-align: center;height:3.3em;width: 200px;">{{crystal.name}}<br>S: {{crystal.total_inslot}} / N: {{crystal.total_items}}</div></button></div><div ng-if="crystalData.length<=0" class="text-center"><span>No data available</span></div></div><h3 class="with-line"></h3><div class="row" ng-init="getMachineData()"><div ng-if="machineData.length>0" class="col-lg-2 col-md-4 col-sm-4 margin-top-10" ng-repeat="machine in machineData"><button type="button" class="btn btn-primary btn-with-icon btn-xm shipping-btn min-width-200 white-space-normal" style="min-height: 50px;"><div class="textclassforcurt" title="{{machine.machine_name}}" style="text-align: center;height:3.3em;width: 200px;">{{machine.machine_name}}<br>{{machine.total_inslot}} / {{machine.total_slots}}</div></button></div><div ng-if="machineData.length<=0" class="text-center"><span>No data available</span></div></div></form></div><style>\n.min-width-200 { min-width: 200px; }\n</style>');
$templateCache.put('app/pages/machineDashboard/settings/machineDashboardSettings.html','<div class="widgets profile shipping-tracker" ba-panel=""><div ng-init="getSelectedStatusData()"><form class="form-horizontal" name="settingsFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="machine-dashboard.dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveMachineDashboardSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="isloaded" class="panel-heading-padding row"><div class="col-md-4"><div class="row" ng-init="getRegularStatusData()"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="<label style=\'background-color:#00abff\'>All Status</label>" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="stc.regularStatusData"><tr ng-repeat="status in stc.regularStatusData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="<label ng-style={\'background-color\':sts._id.color_code}>{{sts._id.block}} <img class=\'pull-right m-top-8\' ng-src=\'assets/img/{{sts._id.img}}.png\' alt=\'skull\' height=\'20\' width=\'20\'></label>" ba-panel-class="light-text with-scroll shipping-inner-panel" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptionStatus" ng-model="sts.status"><tr ng-if="sts.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}}</span></td></tr></tbody></table></div></div></div></div><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="machine-dashboard.dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveMachineDashboardSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/productList/blockTypeSetting/addBlock.html','<div ba-panel="" ng-init="status=\'1\';blockType=\'none\'"><div class="panel-content" ng-init="getEditedBlock()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="productBlockFrm" novalidate="" ng-submit="productBlockFrm.$valid && saveBlockData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (productBlockFrm.blockName.$error.required || productBlockFrm.blockName.$error.pattern || productBlockFrm.blockName.$error.maxlength) && productBlockFrm.blockName.$touched}"><label for="productBlockFrm" class="col-sm-4 control-label">Block Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="blockName" limit-to="20" ng-maxlength="20" type="text" ng-model="blockName" name="blockName" required="" class="form-control" placeholder="Block Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="productBlockFrm.$submitted && productBlockFrm.blockName.$error.required">Please enter block name.</span> <span class="error" ng-show="productBlockFrm.blockName.$error.pattern">Please enter valid block name.</span> <span class="error" ng-show="!productBlockFrm.blockName.$error.pattern && productBlockFrm.blockName.$error.maxlength && productBlockFrm.blockName.$touched">Block name should not be greater than 20 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="blockType" class="col-sm-4 control-label">Type</label><div class="col-sm-8"><select class="form-control" ng-model="blockType" name="blockType" id="blockType"><option value="none">Select Type</option><option value="all">All</option><option value="is_regular">Regular</option><option value="is_customer">Customer</option><option value="is_express">Express</option><option value="is_supply">Supply</option><option value="is_rework">Rework</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="productBlockFrm.$submitted && productBlockFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row" ng-if="productBlockId"><div class="col-md-12"><div class="form-group row clearfix"><label for="status" class="col-md-2 control-label">Block Status<span>&nbsp;</span></label><div class="col-md-6"><div ui-sref="product-list.product-block-status" class="panel panel-blur bootstrap-panel xsmall-panel cur-pntr" style="overflow-y:auto;padding: 15px 22px;"><div class="tag" ng-repeat="(key,item) in orderStatus"><span ng-if="key" style="background-color:{{item}};" class="status-label">{{key}}</span></div></div></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="product-list.block-list" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="productBlockId"></form></div></div>');
$templateCache.put('app/pages/productList/blockTypeSetting/blockTypeSetting.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'assign_product_block\') !== - 1" ng-click="assignBlockStatus()" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-list-alt"></i>Product Status</button> <button ng-if="permissionArr.indexOf(\'add_product_block\') !== - 1" ng-click="addProductBlock()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/productList/blockTypeSetting/deleteModal.html','<div class="modal-content" ng-controller="productBlockCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteProductBlock()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/productList/blockTypeSetting/productBlockStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="product-list.block-list" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addBlockStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-4" ng-init="getStatusAndProductBlockData()"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableCloneOptions" data-ng-model="orderStatus"><tr ng-repeat="item in orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}}</span></td></tr></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ng-repeat="dept in set"><div ba-panel="" ba-panel-title="{{dept._id.block}}" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableOptions" data-ng-model="dept.status"><tr ng-if="dept.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in dept.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-if="item.status_label != \'\'" ng-style="{\'background-color\':item.color_code};" class="status-label cursor"><i ng-if="item.is_active == 1" title="Active" class="fa fa-check-square" aria-hidden="true"></i> <i ng-if="item.is_active == 0" title="In Active" class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{item.status_label}} <a ng-click="removeBlockStatus(item,dept.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span> <span ng-if="item.status_label == \'\'">&nbsp;</span></td></tr></table></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="product-list.block-list" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addBlockStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/productList/blockTypeSetting/statusModal.html','<div class="modal-content" ng-controller="departmentsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="blockChangeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/productList/resave/resave.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-md-9"><span class="filter-lable" ng-if="vm.productNumber"><i class="show-filters">Product Number :</i>{{vm.productNumber}} <i ng-click="removeSingleFilter(\'productNumber\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="vm.productStatus"><i class="show-filters">Status :</i>{{vm.productStatus[\'label\']}} <i ng-click="removeSingleFilter(\'productStatus\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="vm.productFromTo"><i class="show-filters">Product From Or To :</i>{{vm.productFromTo}} <i ng-click="removeSingleFilter(\'productFromTo\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span> <span class="filter-lable" ng-if="datePickerRegular.date.startDate"><i class="show-filters">Date :</i>{{datePickerRegular.date.startDate}} | {{datePickerRegular.date.endDate}} <i ng-click="removeSingleFilter(\'date\')" title="Remove" class="cursor-pointer fa fa-times margin-left-5"></i></span></div><div class="col-md-3 pull-right"><button type="button" ng-click="resetSearch()" class="pull-right btn btn-primary btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Reset</button> <button type="button" ng-click="searchApply()" class="margin-right-10 pull-right btn btn-success btn-with-icon ng-scope"><i class="ion-android-checkmark-circle"></i>Search</button></div></div><div class="row" style="margin-top: 15px"><div class="col-md-3 form-group clearfix" ng-if="permissionArr.indexOf(\'product_search_by_date\') !== - 1"><div class="input-group cur-pntr"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerRegular.date" type="text" placeholder="Select Date" readonly=""> <span ng-click="focusInput()" class="input-group-addon date-picker input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3 form-group clearfix" ng-if="permissionArr.indexOf(\'product_search_by_product_number\') !== - 1"><input id="productNumber" type="text" ng-model="vm.productNumber" name="productNumber" class="form-control" placeholder="Product Number"></div><div class="col-md-3 form-group clearfix" ng-if="permissionArr.indexOf(\'product_search_by_product_from_to\') !== - 1"><input id="productFromTo" name="productFromTo" class="form-control" placeholder="Product From Or To" type="text" ng-model="vm.productFromTo"></div><div class="col-md-3 form-group clearfix" ng-init="apiSearchForOrderStatus()" ng-if="permissionArr.indexOf(\'product_search_by_status\') !== - 1"><select ng-model="vm.productStatus" class="form-control selectpicker with-search" data-live-search="true" title="Select Status" id="orderStatus" ng-options="statusSelected as statusSelected.label for statusSelected in listOrderStatus"><option value="">Product Status</option></select></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getProductDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div ng-include="\'app/pages/orders/orderDetails.html\'"></div>');
$templateCache.put('app/pages/relaySettings/group/addGroup.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedGroup()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="groupFrm" novalidate="" ng-submit="groupFrm.$valid && saveGroupData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="groupLabel" class="col-sm-4 control-label">Group Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="groupLabel" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.groupLabel" name="groupLabel" required="" class="form-control" placeholder="Group Label"> <span class="error" ng-show="groupFrm.$submitted && groupFrm.groupLabel.$error.required">Please enter group label.</span> <span class="error" ng-show="groupFrm.groupLabel.$error.maxlength && groupFrm.groupLabel.$touched">Group Label should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="groupFrm.$submitted && groupFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="relay-settings.group-list" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.groupId"></form></div></div>');
$templateCache.put('app/pages/relaySettings/group/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteGroup()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/group/group.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'group_add\') !== - 1" ng-click="addGroup()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/relaySettings/group/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/orderTypes/addOrderType.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status = \'1\';"><div class="panel-content" ng-init="getEditedOrderType();"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="orderTypeFrm" novalidate="" ng-submit="orderTypeFrm.$valid && saveOrderTypeData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="orderTypeLabel" class="col-sm-4 control-label">Order Type <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="orderTypeLabel" limit-to="50" ng-maxlength="50" type="text" ng-model="vm.orderType" name="orderTypeLabel" required="" class="form-control" placeholder="Order Type"> <span class="error" ng-show="orderTypeFrm.$submitted && orderTypeFrm.orderTypeLabel.$error.required">Please enter order type.</span> <span class="error" ng-show="orderTypeFrm.orderTypeLabel.$error.maxlength && orderTypeFrm.orderTypeLabel.$touched">Order Type should not be greater than 50 characters</span></div></div></div></div><div ng-init="getTypeMaster()" class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="type master" class="col-sm-4 control-label">Main Type<span class="asterisk_input"></span></label><div class="col-sm-8"><select required="" class="form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required" name="mainType" ng-change="setAddOnType(vm.mainType)" ng-model="vm.mainType"><option value="">Select Main Type</option><option value="none">None</option><option value="{{type.name}}" ng-repeat="type in typeData">{{type.name}}</option></select><span class="error" ng-show="orderTypeFrm.$submitted && orderTypeFrm.mainType.$error.required">Please select main type.</span></div></div></div></div><div ng-init="getTypeMaster()" class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="type master" class="col-sm-4 control-label">Add On Type</label><div class="col-sm-8"><ui-select multiple="" name="blockType" ng-model="vm.blockType" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Select Add On Type">{{$item.name}}</ui-select-match><ui-select-choices repeat="multipleItem.name as multipleItem in typeMultiSelectData | filter: $select.search">{{multipleItem.name}}</ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="orderTypeFrm.$submitted && orderTypeFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="relay-settings.order-type-list" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.orderTypeId"></form></div></div>');
$templateCache.put('app/pages/relaySettings/orderTypes/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteOrderType()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/orderTypes/ordertypes.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'create_relay_order_type\') !== -1" ng-click="addOrderType()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/relaySettings/orderTypes/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/priority/addPriority.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status = \'1\';"><div class="panel-content" ng-init="getEditedPriority();"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="priorityFrm" novalidate="" ng-submit="priorityFrm.$valid && savePriorityData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="priorityLabel" class="col-sm-4 control-label">Priority Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="priorityLabel" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.priorityName" name="priorityLabel" required="" class="form-control" placeholder="Priority Name"> <span class="error" ng-show="priorityFrm.$submitted && priorityFrm.priorityLabel.$error.required">Please priority name.</span> <span class="error" ng-show="priorityFrm.priorityLabel.$error.maxlength && priorityFrm.priorityLabel.$touched">Priority name should not be greater than 40 characters</span></div></div></div></div><div ng-init="getOrderTypes()" class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="stickerType" class="col-sm-4 control-label">Select Type <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control" ng-model="vm.orderType" name="stickerType" id="stickerType"><option value="">Type</option><option value="{{type.order_type}}" ng-repeat="type in typeData">{{type.order_type}}</option></select><span class="error" ng-show="priorityFrm.$submitted && priorityFrm.stickerType.$error.required">Please priority type.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="priorityFrm.$submitted && priorityFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="relay-settings.priority-list" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.priorityId"></form></div></div>');
$templateCache.put('app/pages/relaySettings/priority/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deletePriority()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/priority/priority.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'create_relay_priority\') !== -1" ng-click="addPriority()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/relaySettings/priority/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/relay/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/relay/relay.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getActiveStatus(); getPriorityHour(); getPriorityMinit(); getPriorityTimeHour();"><div ng-init="getRelaySettingData()"><form class="form-horizontal" name="relayFrm" novalidate="" ng-submit="submittedRelayFrm = true"><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="relayFrm.$valid && saveRelaySetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Relay Api Key</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row"><label for="apiKey" class="col-sm-3 control-label">Api Key</label><div class="col-sm-9"><input type="text" ng-model="vm.apiKey" id="apiKey" name="apiKey" class="form-control" placeholder="Api Key"></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Relay Settings</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row"><label for="autoUpload" class="col-sm-5 control-label">Auto Upload</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.autoUpload" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label for="sandbox" class="col-sm-5 control-label">Sandbox</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.sandbox" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="uploadCycleTime" class="col-sm-5 control-label">Upload Cycle Time</label><div class="col-sm-7"><div class="row" ng-init="getMinutesAndSecond()"><div class="col-md-4 col-sm-4" ng-init="getHour()"><select class="form-control" ng-model="vm.hours" name="uploadCycleTime" id="hours"><option value="">Hours</option><option value="{{hrs}}" ng-repeat="(key,hrs) in hoursData">{{hrs}}</option></select></div><div class="col-md-4 col-sm-4"><select class="form-control" ng-model="vm.minute" name="uploadCycleTime" id="minute"><option value="">Minutes</option><option value="{{min}}" ng-repeat="(key,min) in minuteData">{{min}}</option></select></div><div class="col-md-4 col-sm-4"><select class="form-control" ng-model="vm.second" name="uploadCycleTime" id="second"><option value="">Seconds</option><option value="{{sec}}" ng-repeat="(key,sec) in secondData">{{sec}}</option></select></div></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="statusForUpload" class="col-sm-5 control-label">Status For Upload</label><div class="col-sm-7"><ui-select multiple="" ng-model="vm.statusForUpload" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="statusForUpload" id="statusForUpload"><ui-select-match placeholder="Status For Upload">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row" ng-init="getActiveGroupLabel()"><label for="groupForUpload" class="col-sm-5 control-label">Group For Upload</label><div class="col-sm-7"><ui-select multiple="" ng-model="vm.groupForUpload" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="groupForUpload" id="groupForUpload"><ui-select-match placeholder="Group For Upload">{{$item.group_label}}</ui-select-match><ui-select-choices repeat="grp.group_label as grp in activeGroupData | filter: $select.search"><span ng-bind-html="grp.group_label"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-6"><div class="form-group row" ng-init="getStoreData()"><label for="storeForUpload" class="col-sm-5 control-label">Store For Upload</label><div class="col-sm-7"><ui-select multiple="" ng-model="vm.storeForUpload" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="storeForUpload" id="storeForUpload"><ui-select-match placeholder="Store For Upload">{{$item.store_name}}</ui-select-match><ui-select-choices repeat="store.store_id as store in storeData | filter: $select.search"><span ng-bind-html="store.store_name"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="newRelayStart" class="col-sm-5 control-label">New Relay</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.newRelayStart" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Not Upload Orders</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row"><label for="nupPreExpStatusAfterUpload" class="col-sm-5 control-label">Preferred / Express Status</label><div class="col-sm-7"><select class="form-control" ng-model="vm.nupPreExpStatusAfterUpload" name="nupPreExpStatusAfterUpload" id="nupPreExpStatusAfterUpload"><option value="">Preferred / Express Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div><div class="col-md-6"><div class="form-group row"><label for="nupRegStatusAfterUpload" class="col-sm-5 control-label">Regular Status</label><div class="col-sm-7"><select class="form-control" ng-model="vm.nupRegStatusAfterUpload" name="nupRegStatusAfterUpload" id="nupRegStatusAfterUpload"><option value="">Regular Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>General Settings</span></uib-accordion-heading><h3 class="with-line font16px">Default Basic Settings</h3><div class="row"><div class="col-md-6"><div class="form-group row"><label for="distanceXY" class="col-sm-5 control-label">Distance XY</label><div class="col-sm-7"><div class="input-group mb-0px"><input type="text" is-number-key="" limit-to="5" ng-model="vm.distanceXY" id="distanceXY" name="distanceXY" class="form-control with-primary-addon" placeholder="Distance XY" aria-describedby="distance-xy"> <span class="input-group-addon input-group-addon-default addon-right" id="distance-xy">mm</span></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="distanceLayer" class="col-sm-5 control-label">Distance Layer</label><div class="col-sm-7"><div class="input-group mb-0px"><input type="text" is-number-key="" limit-to="5" ng-model="vm.distanceLayer" id="distanceLayer" name="distanceLayer" class="form-control" placeholder="Distance Layer" aria-describedby="distance-layer"> <span class="input-group-addon input-group-addon-default addon-right" id="distance-layer">mm</span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="layerQuantity" class="col-sm-5 control-label">Layer Quantity</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.layerQuantity" id="layerQuantity" name="layerQuantity" class="form-control" placeholder="Layer Quantity"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="brightnessMultiplicator" class="col-sm-5 control-label">Brightness Multiplicator</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.brightnessMultiplicator" id="brightnessMultiplicator" name="brightnessMultiplicator" class="form-control" placeholder="Brightness Multiplicator"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="gainMultiplicator" class="col-sm-5 control-label">Gain Multiplicator</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.gainMultiplicator" id="gainMultiplicator" name="gainMultiplicator" class="form-control" placeholder="Gain Multiplicator"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="brightness" class="col-sm-5 control-label">Brightness</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.brightness" id="brightness" name="brightness" class="form-control" placeholder="Brightness"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="gain" class="col-sm-5 control-label">Gain</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.gain" id="gain" name="gain" class="form-control" placeholder="Gain"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="sharpness" class="col-sm-5 control-label">Sharpness</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.sharpness" id="sharpness" name="sharpness" class="form-control" placeholder="Sharpness"></div></div></div></div><h3 class="with-line font16px">Default Text Settings</h3><div class="row"><div class="col-md-6"><div class="form-group row"><label for="additionalLayers" class="col-sm-5 control-label">Additional Layers</label><div class="col-sm-7"><div class="row"><div class="col-md-6 col-sm-6"><input type="text" is-number-key="" ng-model="vm.contour" id="contour" name="contour" class="form-control" placeholder="Contour"></div><div class="col-md-6 col-sm-6"><input type="text" is-number-key="" ng-model="vm.cover" id="cover" name="cover" class="form-control" placeholder="Cover"></div></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="font" class="col-sm-5 control-label">Font</label><div class="col-sm-7"><select ng-model="vm.font" id="font" name="font" class="form-control"><option value="">Select Font</option><option ng-style="{\'font-family\':font}" value="{{font}}" ng-repeat="(key,font) in fontList">{{font}}</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="size" class="col-sm-5 control-label">Size</label><div class="col-sm-7"><input type="text" is-number-key="" limit-to="4" ng-model="vm.size" id="size" name="size" class="form-control" placeholder="Size"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="font" class="col-sm-5 control-label">Alignment</label><div class="col-sm-7"><select ng-model="vm.alignment" id="alignment" name="alignment" class="form-control"><option value="">Select Alignment</option><option value="left">Left</option><option value="right">Right</option><option value="center">Center</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="rotateZ" class="col-sm-5 control-label">Rotate Z</label><div class="col-sm-7"><input type="text" is-number-key="" ng-model="vm.rotateZ" id="rotateZ" name="rotateZ" class="form-control" placeholder="Rotate Z"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="bold" class="col-sm-5 control-label">Bold</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.bold" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="italic" class="col-sm-5 control-label">Italic</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.italic" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label for="mirror" class="col-sm-5 control-label">Mirror</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.mirror" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Service</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Service</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th>Label</th><th>Service</th><th>Set As Default</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'job_service\', \'\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.jobService.length > 0" ng-repeat="job in vm.jobService" class="editable-row"><td><input only-caracter="" type="text" ng-model="job.label" limit-to="30" ng-maxlength="30" name="jobLabel{{$index}}" required="" class="form-control height28px" placeholder="Service Label" id="itemLabelJob-{{$index}}"> <span class="error" ng-show="relayFrm[\'jobLabel\' +$index].$touched && relayFrm[\'jobLabel\' +$index].$error.required">Please enter label.</span></td><td><input only-caracter="" type="text" ng-model="job.value" limit-to="30" ng-maxlength="30" name="jobTitle{{$index}}" required="" class="form-control height28px" placeholder="Service Value" id="itemTitleJob-{{$index}}"> <span class="error" ng-show="relayFrm[\'jobTitle\' +$index].$touched && relayFrm[\'jobTitle\' +$index].$error.required">Please enter service.</span></td><td><select class="form-control roleData height28px" ng-model="job.set_default" name="jobDefault{{$index}}" id="itemDefaultJob-{{$index}}"><option value="0">0</option><option value="1">1</option></select></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'job_service\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.jobService.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Store Person Settings</span></uib-accordion-heading><div class="row"><div class="col-sm-8"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Store Code</th><th class="width-15-per">Upload</th><th class="width-15-per">New Relay Upload</th></tr></thead><tbody><tr class="editable-row" ng-if="vm.store_persons.length > 0" ng-repeat="sr in vm.store_persons"><td>{{ sr.store_name }}</td><td>{{ sr.store_code }}</td><td><ba-switcher switcher-style="primary" switcher-value="sr.is_person_upload" on-label="Yes" off-label="No"></ba-switcher></td><td><ba-switcher switcher-style="primary" switcher-value="sr.new_relay_upload" on-label="Yes" off-label="No"></ba-switcher></td></tr></tbody></table></div></div><div class="row"><div class="col-sm-8"><div class="form-group row"><label for="statusfor2D" class="col-sm-5 control-label">Stauts for 2D</label><div class="col-sm-7"><select class="form-control" ng-model="vm.statusfor2D" name="statusfor2D" id="statusfor2D"><option value="">Stauts for 2D</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[6].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[6].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[6].isOpen}"></i> <span>New Relay Store Settings</span></uib-accordion-heading><div class="row"><div class="col-sm-8"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Store Code</th><th class="width-15-per">Upload</th></tr></thead><tbody><tr class="editable-row" ng-if="vm.new_relay_stores.length > 0" ng-repeat="sr in vm.new_relay_stores"><td>{{ sr.store_name }}</td><td>{{ sr.store_code }}</td><td><ba-switcher switcher-style="primary" switcher-value="sr.is_person_upload" on-label="Yes" off-label="No"></ba-switcher></td></tr></tbody></table></div></div></uib-accordion-group><div ng-repeat="(key, dynamicPriority) in vm.allDynamicPriorities" style="margin-top: 5px;"><uib-accordion-group is-open="isOpenObject[key]" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': isOpenObject[key], \'fa fa-angle-down fa-lg\': !isOpenObject[key]}"></i> <span>{{key}}</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label"></label><div class="col-md-8"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th>Hours</th><th>Order Type</th></tr></thead><tbody><tr><td><select class="form-control height28px" ng-model="dynamicPriority.hours" name="priorityExpressHourName" id="priorityExpressHourId-{{$index}}"><option value="">Select Hours</option><option value="Custom">Custom</option><option value="{{hrs}}" ng-repeat="(key,hrs) in priorityHoursData">{{hrs}}</option></select></td><td><input type="text" name="priorityExpressTypeName" id="priorityExpressTypeId-{{$index}}" ng-model="dynamicPriority.order_type" class="form-control roleData height28px" ng-disabled="true"></td></tr></tbody></table></div><div class="horizontal-scroll anand" style="margin-top: 42px" ng-if="dynamicPriority.hours === \'Custom\'"><table class="table table-bordered"><thead><tr><th style="width: 35%;">Time From</th><th style="width: 35%;">Time To</th><th style="width: 9%;">Hours</th><th style="width: 14%;">Order Types</th><th class="width-10-per" style="width: 7%;"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(key, \'DYNAMIC\', dynamicPriority.order_type)"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="dynamicPriority.data.length > 0" ng-repeat="singlePriority in dynamicPriority.data" class="editable-row"><td style="width: 200px;"><div><div style="float: left; width: 32%;"><select class="form-control height28px" ng-model="singlePriority.time_from_hour" name="express-priority-time-from-name-{{$index}}" id="express-priority-time-from-id-{{$index}}"><option value="{{hrs}}" ng-repeat="(key,hrs) in priorityTimeHoursData">{{hrs}}</option></select></div><div style="float: left; width: 32%; margin-left: 5px;"><select class="form-control height28px" ng-model="singlePriority.time_from_min" name="express-priority-time-from-min-name-{{$index}}" id="express-priority-time-from-min-id-{{$index}}"><option value="{{hrs}}" ng-repeat="(key,hrs) in priorityMinitsData">{{hrs}}</option></select></div><div style="float: right; width: 32%;"><select class="form-control height28px" ng-model="singlePriority.from_time" name="express-priority-time-from-name-{{$index}}" id="express-priority-time-from-id-{{$index}}"><option value="PM">PM</option><option value="AM">AM</option></select></div></div></td><td style="width: 200px;"><div><div style="float: left; width: 32%;"><select class="form-control height28px" ng-model="singlePriority.time_to_hour" name="express-priority-time-to-name-{{$index}}" id="express-priority-time-to-id-{{$index}}"><option value="{{hrs}}" ng-repeat="(key,hrs) in priorityTimeHoursData">{{hrs}}</option></select></div><div style="float: left; width: 32%; margin-left: 5px;"><select class="form-control height28px" ng-model="singlePriority.time_to_min" name="express-priority-time-to-min-name-{{$index}}" id="express-priority-time-to-min-id-{{$index}}"><option value="{{hrs}}" ng-repeat="(key,hrs) in priorityMinitsData">{{hrs}}</option></select></div><div style="float: left; width: 32%; margin-left: 5px;"><select class="form-control height28px" ng-model="singlePriority.time_to" name="express-priority-time-to-name-{{$index}}" id="express-priority-time-to-id-{{$index}}"><option value="PM">PM</option><option value="AM">AM</option></select></div></div></td><td><select class="form-control height28px" ng-model="singlePriority.hours_send" name="express-priority-hour-send-name-{{$index}}" id="express-priority-hour-send-id-{{$index}}"><option value="noupload">No Upload</option><option value="{{hrs}}" ng-repeat="(key,hrs) in priorityHoursData">{{hrs}}</option></select></td><td><select class="form-control roleData height28px" ng-model="singlePriority.types" name="express-priority-type-name-{{$index}}" id="express-priority-type-id-{{$index}}"><option value="Regular">Regular</option><option value="Preferred">Preferred</option><option value="Express">Express</option></select></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index, key, \'DYNAMIC\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr></table></div></div></div></uib-accordion-group></div></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="relayFrm.$valid && saveRelaySetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div></div>');
$templateCache.put('app/pages/relaySettings/relayStatus/addRelayStatus.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedRelayStatus()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="relayStatusFrm" novalidate="" ng-submit="relayStatusFrm.$valid && saveRelayStatusData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="relayStatusEditId" class="col-sm-4 control-label">Relay Status Id <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="relayStatusEditId" type="text" is-number-key="" ng-model="vm.relayStatusEditId" name="relayStatusEditId" required="" class="form-control" placeholder="Relay Status Id"> <span class="error" ng-show="relayStatusFrm.$submitted && relayStatusFrm.relayStatusEditId.$error.required">Please enter relay status id.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="relayStatusTitle" class="col-sm-4 control-label">Relay Status Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="relayStatusTitle" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.relayStatusTitle" name="relayStatusTitle" required="" class="form-control" placeholder="Relay Status Title" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="relayStatusFrm.$submitted && relayStatusFrm.relayStatusTitle.$error.required">Please enter relay status title.</span> <span class="error" ng-show="relayStatusFrm.relayStatusTitle.$error.pattern">Please enter valid relay status title.</span> <span class="error" ng-show="relayStatusFrm.relayStatusTitle.$error.maxlength && relayStatusFrm.relayStatusTitle.$touched">Relay Status Title should not be greater than 40 characters.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="relayStatusCode" class="col-sm-4 control-label">Relay Status Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="relayStatusCode" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.relayStatusCode" name="relayStatusCode" required="" class="form-control" placeholder="Relay Status Code" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="relayStatusFrm.$submitted && relayStatusFrm.relayStatusCode.$error.required">Please enter relay status code.</span> <span class="error" ng-show="relayStatusFrm.relayStatusCode.$error.pattern">Please enter valid relay status code.</span> <span class="error" ng-show="relayStatusFrm.relayStatusCode.$error.maxlength && relayStatusFrm.relayStatusCode.$touched">Relay Status Code should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="relayStatusFrm.$submitted && relayStatusFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="relay-settings.relay-status" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.relayStatusId"></form></div></div>');
$templateCache.put('app/pages/relaySettings/relayStatus/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteRelayStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/relayStatus/relayStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'relay_status_add\') !== - 1" ng-click="addRelayStatus()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/relaySettings/relayStatus/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/webhook/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/relaySettings/webhook/webhook.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getWebhookSettingData();getActiveStatus()"><form class="form-horizontal" name="webhookFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="webhookFrm.$valid && saveWebhookSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Webhook URL</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="webhookUrl" class="col-md-2 control-label">Webhook URL</label><div class="col-md-9"><input type="text" ng-model="vm.webhookUrl" id="webhookUrl" name="webhookUrl" class="form-control" placeholder="Webhook URL"></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Express</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-2 control-label">Map Statuses</label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Relay Status</th><th class="width-45-per">Order Status</th><th class="width-45-per">Get Data</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.mapExpressStatusList.length > 0" ng-repeat="map in vm.mapExpressStatusList" class="editable-row"><td><select class="form-control height28px" ng-model="map.relay_status" name="relayStatus{{$index}}" id="relayStatus-{{$index}}" required=""><option value="">Relay Status</option><option value="{{status.relay_status_code}}" ng-repeat="status in vm.relayStatusList">{{status.relay_status_title}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'relayStatus\' +$index].$error.required">Please select relay status.</span></td><td><select class="form-control height28px" ng-model="map.order_status" name="orderStatus{{$index}}" id="orderStatus-{{$index}}" required=""><option value="">Order Status</option><option value="{{status.status_code}}" ng-repeat="status in vm.orderStatus">{{status.status_label}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'orderStatus\' +$index].$error.required">Please select order status.</span></td><td class="text-center webhook-switch"><ba-switcher switcher-style="primary" switcher-value="map.get_data_api" on-label="Yes" off-label="No"></ba-switcher></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.mapExpressStatusList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Regular</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-2 control-label">Map Statuses</label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Relay Status</th><th class="width-45-per">Order Status</th><th class="width-45-per">Get Data</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'regular\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.mapRegularStatusList.length > 0" ng-repeat="map in vm.mapRegularStatusList" class="editable-row"><td><select class="form-control height28px" ng-model="map.relay_status" name="relayStatusReg{{$index}}" id="relayStatusReg-{{$index}}" required=""><option value="">Relay Status</option><option value="{{status.relay_status_code}}" ng-repeat="status in vm.relayStatusList">{{status.relay_status_title}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'relayStatusReg\' +$index].$error.required">Please select relay status.</span></td><td><select class="form-control height28px" ng-model="map.order_status" name="orderStatusReg{{$index}}" id="orderStatusReg-{{$index}}" required=""><option value="">Order Status</option><option value="{{status.status_code}}" ng-repeat="status in vm.orderStatus">{{status.status_label}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'orderStatusReg\' +$index].$error.required">Please select order status.</span></td><td class="text-center webhook-switch"><ba-switcher switcher-style="primary" switcher-value="map.get_data_api" on-label="Yes" off-label="No"></ba-switcher></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'regular\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.mapRegularStatusList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Rework</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-2 control-label">Map Statuses</label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Relay Status</th><th class="width-45-per">Order Status</th><th class="width-45-per">Get Data</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'rework\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.mapReworkStatusList.length > 0" ng-repeat="map in vm.mapReworkStatusList" class="editable-row"><td><select class="form-control height28px" ng-model="map.relay_status" name="relayStatusRew{{$index}}" id="relayStatusRew-{{$index}}" required=""><option value="">Relay Status</option><option value="{{status.relay_status_code}}" ng-repeat="status in vm.relayStatusList">{{status.relay_status_title}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'relayStatusRew\' +$index].$error.required">Please select relay status.</span></td><td><select class="form-control height28px" ng-model="map.order_status" name="orderStatusRew{{$index}}" id="orderStatusRew-{{$index}}" required=""><option value="">Order Status</option><option value="{{status.status_code}}" ng-repeat="status in vm.orderStatus">{{status.status_label}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'orderStatusRew\' +$index].$error.required">Please select order status.</span></td><td class="text-center webhook-switch"><ba-switcher switcher-style="primary" switcher-value="map.get_data_api" on-label="Yes" off-label="No"></ba-switcher></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'rework\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.mapReworkStatusList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="webhookFrm.$valid && saveWebhookSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div>');
$templateCache.put('app/pages/reports/damageReport/damageReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="dmrc.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.report_label}}</ui-select-match><ui-select-choices repeat="product.report_label as product in dmrc.productData | filter: $select.search"><span ng-bind-html="product.report_label"></span></ui-select-choices></ui-select></div></div><div ng-if="permissionArr.indexOf(\'store_filter_damage_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="dmrc.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in dmrc.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/addOnReport/addOnReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="firstname" type="text" ng-model="aorc.customerName" name="customerName" class="form-control" placeholder="Customer Name"></div></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="firstname" type="text" ng-model="aorc.companyName" name="companyName" class="form-control" placeholder="Company Name"></div></div></div><div ng-if="permissionArr.indexOf(\'store_filter_add_on_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="aorc.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in aorc.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/designReport/designReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group" ng-init="getDesignerData()"><input id="designerName" type="text" ng-model="drc.designerName" name="customerDesigner" class="form-control" placeholder="Enter Designer Name"></div></div><div class="col-md-3"><div class="form-group" ng-init="getCategoryData()"><ui-select ng-model="drc.category" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Category">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="cat.name as cat in drc.categoryData | filter: $select.search"><span ng-bind-html="cat.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="drc.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.report_label}}</ui-select-match><ui-select-choices repeat="product.report_label as product in drc.productData | filter: $select.search"><span ng-bind-html="product.report_label"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div ng-if="permissionArr.indexOf(\'store_filter_design_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="drc.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in drc.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/designReport3D/designReport3D.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group" ng-init="getDesignerData()"><input id="designerName" type="text" ng-model="drc.designerName" name="customerDesigner" class="form-control" placeholder="Enter Designer Name"></div></div><div class="col-md-3"><div class="form-group" ng-init="getCategoryData()"><ui-select ng-model="drc.category" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Category">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="cat.name as cat in drc.categoryData | filter: $select.search"><span ng-bind-html="cat.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="drc.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.report_label}}</ui-select-match><ui-select-choices repeat="product.report_label as product in drc.productData | filter: $select.search"><span ng-bind-html="product.report_label"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div ng-if="permissionArr.indexOf(\'store_filter_design_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="drc.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in drc.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/figurineCostReport/figurineCostReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="fcr.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in fcr.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::(loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div>');
$templateCache.put('app/pages/reports/fileRawMaterialReport/fileRawMaterialReport.html','<style>\n\n/* The Modal (background) */\n.damageImagePreviewClass {\n  display: none; /* Hidden by default */\n  position: fixed; /* Stay in place */\n  z-index: 1; /* Sit on top */\n  padding-top: 100px; /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%; /* Full width */\n  height: 100%; /* Full height */\n  overflow: auto; /* Enable scroll if needed */\n  background-color: rgb(0,0,0); /* Fallback color */\n  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */\n}\n\n/* Modal Content (image) */\n.modal-damageImagePreviewClassClose {\n  margin: auto;\n  display: block;\n  width: 80%;\n  max-width: 1200px;\n}\n\n/* The Close Button */\n.damageImagePreviewClassClose {\n  position: absolute;\n  top: 90px;\n  right: 35px;\n  color: #f1f1f1;\n  font-size: 40px;\n  font-weight: bold;\n  transition: 0.3s;\n}\n\n.damageImagePreviewClassClose:hover,\n.damageImagePreviewClassClose:focus {\n  color: #bbb;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n/* 100% Image Width on Smaller Screens */\n@media only screen and (max-width: 700px){\n  .modal-damageImagePreviewClassClose {\n    width: 100%;\n  }\n}\n</style><div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-2"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-2" ng-if="permissionArr.indexOf(\'file_raw_material_report_search_orderfrom\') !== -1"><div class="form-group"><input id="order_from" type="text" ng-model="vm.orderFrom" name="order_from" class="form-control" placeholder="Customer Name"></div></div><div class="col-md-2" ng-if="permissionArr.indexOf(\'file_raw_material_report_search_productname\') !== -1"><div class="form-group"><input id="product_name" type="text" ng-model="vm.productName" name="product_name" class="form-control" placeholder="Product"></div></div><div class="col-md-2"><div class="form-group"><select ng-model="vm.used" class="form-control"><option value="">Select Used</option><option value="Yes">Yes</option><option value="No">No</option></select></div></div><div class="col-md-2"><div class="form-group"><select ng-model="vm.approved" class="form-control"><option value="">Select Approved</option><option value="Yes">Yes</option><option value="No">No</option></select></div></div><div class="col-md-2"><div class="form-group"><select ng-model="vm.reset" class="form-control"><option value="">Select Reset</option><option value="YES">Yes</option><option value="NO">No</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered row-border hover" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div id="openResetConfirmModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content" style="height: 170px;"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to reset this record?</div><div class="row" style="float: right;"><button type="button" class="btn btn-primary" ng-click="resetEncryptionFieldAPICall()" style="margin-right: 10px;">Yes</button> <button type="button" class="btn btn-danger" ng-click="hideResetPopUp()" style="margin-right:30px;">No</button></div></div></div></div><div id="damageImagePreview" class="damageImagePreviewClass"><span class="damageImagePreviewClassClose" ng-click="closeImagePrev()">&times;</span> <img class="modal-damageImagePreviewClassClose" id="img01"><div id="caption"></div></div><div id="openSeeFullText" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal damage-report-special-instruction-pop-up"><div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Special Instruction</span></div><div class="row" style="margin: 20px;"><h3>{{viewSpecialInsctuction}}</h3></div><div class="damage-report-special-instruction-pop-up-btn-warp"><button type="button" class="btn btn-danger" ng-click="hideSeeFullText()" style="margin-right:30px;">Close</button></div></div></div></div>');
$templateCache.put('app/pages/reports/inventoryReport/inventoryReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="invr.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="product.name as product in invr.productData | filter: $select.search"><span ng-bind-html="product.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-init="getWarehouseData()"><div class="form-group"><ui-select ng-model="invr.warehouseName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Warehouse">{{$select.selected.warehouse_name}}</ui-select-match><ui-select-choices repeat="warehouse.warehouse_name as warehouse in invr.warehouseData | filter: $select.search"><span ng-bind-html="warehouse.warehouse_name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::(loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div>');
$templateCache.put('app/pages/reports/orderAssemblyReport/orderAssemblyReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-4"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::(loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div>');
$templateCache.put('app/pages/reports/ordersReport/ordersReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="firstname" type="text" ng-model="src.customerName" name="customerName" class="form-control" placeholder="Customer Name"></div></div></div><div class="col-md-3" ng-init="getStoreData()" ng-if="permissionArr.indexOf(\'orders_sales_store\') !== -1"><div class="form-group"><select ng-model="src.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in src.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/printedCrystalReport/printedCrystalReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group"><select ng-model="vm.used" class="form-control"><option value="">Select Used</option><option value="Yes">Yes</option><option value="No">No</option></select></div></div><div class="col-md-3"><div class="form-group"><input id="addInformation" type="text" ng-model="vm.allSearch" name="addInformation" class="form-control" placeholder="User | Product | Order Number"></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div id="openResetConfirmModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content" style="height: 170px;"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to reset this record?</div><div class="row" style="float: right;"><button type="button" class="btn btn-primary" ng-click="resetEncryptionFieldAPICall()" style="margin-right: 10px;">Yes</button> <button type="button" class="btn btn-danger" ng-click="hideResetPopUp()" style="margin-right:30px;">No</button></div></div></div></div><div id="printCrystalResetLogIdModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Reset Log</span> <button type="button" class="close" ng-click="hideResetLogModal()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!resetEncryptionLogsLoaded">Loading....</div><div ng-if="resetEncryptionLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">Order Number</th><th class="oldStatus">Download File</th><th class="nStatus">Date of Reset</th><th class="date">Reset By</th></tr></thead><tbody><tr ng-repeat="data in resetEncryptionLogsArr"><td>{{data.order_number}}</td><td>{{data.downloaded_order_from}}</td><td>{{getGlobalDateFormat(data.created_at)}}</td><td>{{data.reset_by}}</td></tr><tr ng-if="!resetEncryptionLogsArr.length"><td colspan="4" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/pages/reports/productSoldReport/productSoldReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-4"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-4"><div class="form-group row" ng-init="getStoreData()"><div class="col-sm-12"><ui-select multiple="" ng-model="psr.stores" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="stores" id="stores"><ui-select-match placeholder="Stores">{{$item.store_name}}</ui-select-match><ui-select-choices repeat="store.store_id as store in storeData | filter: $select.search"><span ng-bind-html="store.store_name"></span></ui-select-choices></ui-select></div></div></div><div class="col-md-4"><div class="form-group row" ng-init="getProductType()"><div class="col-sm-12"><ui-select multiple="" ng-model="psr.product_types" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="product_types" id="product_types"><ui-select-match placeholder="Product Types">{{$item.type}}</ui-select-match><ui-select-choices repeat="p.code as p in productTypeData | filter: $select.search"><span ng-bind-html="p.type"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/qaApprovedReport/qaApprovedReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="qrc.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.report_label}}</ui-select-match><ui-select-choices repeat="product.report_label as product in qrc.productData | filter: $select.search"><span ng-bind-html="product.report_label"></span></ui-select-choices></ui-select></div></div><div class="col-md-3"><div class="form-group"><input id="customerDesigner" type="text" ng-model="qrc.personName" name="customerDesigner2" class="form-control" placeholder="Enter QA Approved Person Name"></div></div><div ng-if="permissionArr.indexOf(\'store_filter_qa_approved_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="qrc.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in qrc.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/relayReport/relayReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group"><select ng-model="vm.status" class="form-control"><option value="">Select Status</option><option value="success">Success</option><option value="fail">Fail</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/reportDashboard/categoryCrystalModel.html','<div class="modal-content modal-categoryCrystal"><div class="modal-header bg-info"><div class="col-md-12"><div class="text-center m-t-5"><h4><i class="fa fa-pie-chart" aria-hidden="true"></i><span>{{storeName}}</span><span>( {{datePicker.date.startDate}} To {{datePicker.date.endDate}} )</span> <span class="m-l-15">Total : ${{total?total:0}}</span></h4></div><div class="btn-actions"><button type="button" ng-click="export(\'xls\')" class="btn btn-danger btn-with-icon"><i class="fa fa-file-excel-o" aria-hidden="true"></i>Excel</button> <button type="button" ng-click="export(\'csv\')" class="btn btn-danger btn-with-icon"><i class="fa fa-file-excel-o" aria-hidden="true"></i>CSV</button> <button type="button" class="close pull-right m-l-15" ng-click="$dismiss()">&times;</button></div></div></div><div class="modal-body vertical-tab" ng-style="{\'height\': catPopupSize}"><uib-tabset class="tab-height" ng-if="categoryCrystalData.length!=0"><uib-tab heading="{{key}}" ng-repeat="(key,value) in categoryCrystalData"><div ng-if="val.values.length>0" class="col-md-4 col-lg-3 mb-10" ng-repeat="(ke,val) in value"><div style="border:1px solid #bfbaba;padding:0 5px"><h3 class="v-align-bottom text-center">{{ke}}</h3><div class="chartjs-canvas-holder-first-row"><canvas chart-options="pieChartOptions" chart-colors="colors" class="chart chart-pie" chart-data="val.values" chart-labels="val.labels" chart-click="changeData"></canvas></div></div></div></uib-tab></uib-tabset><div ng-if="categoryCrystalData.length<=0"><h3 class="text-center">No data available</h3></div></div><div class="modal-footer"><p>&nbsp;</p></div></div><style>\n  .tab-height>.tab-content {\n    max-height: {{catPopupSizeMin}}px;\n    overflow-y:auto;\n  }\n</style>');
$templateCache.put('app/pages/reports/reportDashboard/reportDashboard.html','<div class="row pie-charts"><div class="pie-chart-item-container block-top-border" ng-repeat="timeBreak in dateRanges"><div ba-panel=""><div class="pie-chart-item"><div class="col-md-7"><select class="form-control report-dashboard-select" ng-model="timeBreak.key"><option value="daily">Daily</option><option value="weekly">Weekly</option><option value="monthly">Monthly</option><option value="yearly">Yearly</option></select></div><div class="col-md-12 report-dashboard-lable-main"><span>Total : ${{renderWithTotal(timeData[timeBreak.key])}}</span></div></div></div></div></div><div class="row mb-10"><div class="col-sm-6 col-lg-3"><div class="input-group cur-pntr"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePicker.date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon date-picker input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-6 col-lg-3"><button type="button" ng-click="loadDataFromAPI()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetDashboard()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><h3 class="with-line"></h3><div class="row pie-charts"><div ng-if="totaldata>0 && store.display_name" ng-click="loadChartData(store.customer_id,store.display_name,store.position_id,renderWithTotal(store.total?store.total:0))" class="col-lg-3 col-sm-4 poitr-cur radius-zero" ng-repeat="store in storeData"><div ba-panel=""><div class="text-center report-dashboard-store-name cut-text-report-dash" title="{{store.display_name}} {{store.position_id}}">{{store.display_name}} {{store.position_id}}</div><div class="text-center report-dashboard-lable nowrap">Total : ${{renderWithTotal(store.total?store.total:0)}}</div></div></div><div ng-if="totaldata<=0" class="text-center"><span>No data available</span></div></div>');
$templateCache.put('app/pages/reports/reportSettings/addTab.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedTab()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="tabFrm" novalidate="" ng-submit="tabFrm.$valid && saveTabData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (tabFrm.tab.$error.required || tabFrm.tab.$error.pattern || tabFrm.tab.$error.maxlength) && tabFrm.tab.$touched}"><label for="tab" class="col-sm-4 control-label">Tab Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="tab" limit-to="25" ng-maxlength="25" type="text" ng-model="vm.tab" name="tab" required="" class="form-control" placeholder="Tab Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="tabFrm.$submitted && tabFrm.tab.$error.required">Please enter tab name.</span> <span class="error" ng-show="tabFrm.tab.$error.pattern">Please enter valid tab name.</span> <span class="error" ng-show="!tabFrm.tab.$error.pattern && tabFrm.tab.$error.maxlength">tab name should not be greater than 25 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-init="getCategoryList()"><label for="category" class="col-sm-4 control-label">Category <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.category" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect" name="category" id="category" required=""><ui-select-match placeholder="Select Category">{{$item.name}}</ui-select-match><ui-select-choices repeat="cat.name as cat in categoryList | filter: $select.search">{{cat.name}}</ui-select-choices></ui-select><span class="error" ng-show="tabFrm.$submitted && tabFrm.category.$error.required">Please enter category.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="tabFrm.$submitted && tabFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="reports.report-settings" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.tabId"></form></div></div>');
$templateCache.put('app/pages/reports/reportSettings/assignProduct.html','<div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addProduct()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="reports.report-settings" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><div class="col-md-4"><div class="row" ng-init="getAllProductsList()"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Products" ba-panel-class="light-text with-scroll"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="vm.allProducts"><tr ng-repeat="(key,item) in vm.allProducts" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" style="background-color:#125396" class="status-label cursor">{{item.report_label}}</span></td></tr></tbody></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}" ng-init="getEditedTab()"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{cat.category}}" ba-panel-class="light-text with-scroll" ng-repeat="cat in set"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="cat.product"><tr ng-if="cat.product.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="prod in cat.product" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span style="background-color:#125396" class="status-label cursor">{{prod.report_label}} <a ng-click="removeProduct(prod,cat.product)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addProduct()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="reports.report-settings" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/reports/reportSettings/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteTab()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/reports/reportSettings/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/reports/reportSettings/tabCategory.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content"><h3 class="with-line">Assign Category <button ng-if="permissionArr.indexOf(\'select_department\') !== - 1" ng-click="assignProduct()" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-list-alt"></i>Assign Product</button></h3><form class="form-horizontal" name="tabCategoryFrm" novalidate=""><div class="row"><div class="col-md-3"><div class="form-group row"><div class="col-md-12"><div class="checkbox"><label class="custom-checkbox has-success"><input ng-model="vm.heartCrystal" type="checkbox" id="heartCrystal"> <span>Heart Crystal</span></label></div></div></div><div class="form-group row"><div class="col-md-12"><div class="checkbox"><label class="custom-checkbox has-success"><input ng-model="vm.prestigeCrystal" type="checkbox" id="prestigeCrystal"> <span>Prestige Crystal</span></label></div></div></div><div class="form-group row"><div class="col-md-12"><div class="checkbox"><label class="custom-checkbox has-success"><input ng-model="vm.diamondCrystal" type="checkbox" id="diamondCrystal"> <span>Diamond Crystal</span></label></div></div></div></div><div class="col-md-3"><div class="form-group row"><div class="col-md-12"><div class="checkbox"><label class="custom-checkbox has-success"><input ng-model="vm.cubeCrystal" type="checkbox" id="cubeCrystal"> <span>Cube Crystal</span></label></div></div></div><div class="form-group row"><div class="col-md-12"><div class="checkbox"><label class="custom-checkbox has-success"><input ng-model="vm.serratedCrystal" type="checkbox" id="serratedCrystal"> <span>Serrated Crystal</span></label></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addDepartmentStatus()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="reports.report-settings" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div></form></div></div>');
$templateCache.put('app/pages/reports/reportSettings/tabs.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'tab_add\') !== - 1" ng-click="addTab()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/reworkReport/reworkReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="rrc.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.report_label}}</ui-select-match><ui-select-choices repeat="product.report_label as product in rrc.productData | filter: $select.search"><span ng-bind-html="product.report_label"></span></ui-select-choices></ui-select></div></div><div ng-if="permissionArr.indexOf(\'store_filter_rework_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="rrc.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in rrc.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/salesReport/salesReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getProductData()" ng-if="permissionArr.indexOf(\'product_filter_sales_of_report\') !== - 1"><div class="form-group"><ui-select ng-model="src.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="product.name as product in src.productData | filter: $select.search"><span ng-bind-html="product.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-init="getProductBoxData()" ng-if="permissionArr.indexOf(\'box_filter_sales_of_report\') !== - 1"><div class="form-group"><ui-select ng-model="src.BoxSKU" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select SKU">{{$select.selected.sku}}</ui-select-match><ui-select-choices repeat="box.sku as box in src.BoxData | filter: $select.search"><span ng-bind-html="box.sku"></span></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-if="permissionArr.indexOf(\'customer_filter_sales_of_report\') !== - 1"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="firstname" type="text" ng-model="src.customerName" name="customerName" class="form-control" placeholder="Customer Name"></div></div></div><div ng-if="permissionArr.indexOf(\'store_filter_sales_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="src.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in src.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/shipmentBoxCountReport/shipmentBoxCountReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/shipmentBoxReport/shipmentBoxReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3" ng-init="getBoxData()"><div class="input-group"><select id="boxid" ng-model="vm.boxid" name="boxid" class="form-control ng-pristine ng-valid ng-empty ng-touched"><option value="">Select Box</option><option ng-repeat="box in AllBoxes" value="{{box.label}}">{{box.label}}</option></select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/shipmentReport2/shipmentReport2.html','<div class="widgets profile shipment-report2" ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Shipment Report 2"><div ng-controller="shipmentReport2Ctrl as sr2"><div class="row mb-10"><div class="col-md-2"><div class="input-group cur-pntr"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" type="text" readonly=""><span ng-click="focusInput()" class="input-group-addon date-picker input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-2"><select class="form-control" ng-model="sr2.store"><option value="0">All Stores</option><option ng-repeat="store in sr2.storeData" value="{{store.store_id || store.store_code || store.id || store._id}}">{{store.store_name || store.name || store.store_code || store.store_id || store._id}}</option></select></div><div class="col-md-2"><input type="text" class="form-control" placeholder="Service" ng-model="sr2.service"></div><div class="col-md-2"><input type="text" class="form-control" placeholder="Shipment Number" ng-model="sr2.shipmentNumber"></div><div class="col-md-2"><input type="text" class="form-control" placeholder="Customer Name" ng-model="sr2.customerName"></div><div class="col-md-2"><input type="text" class="form-control" placeholder="Tracking Number" ng-model="sr2.trackingNumber"></div></div><div class="row mb-10"><div class="col-md-2"><select class="form-control" ng-model="sr2.address_type"><option value="">All Address Types</option><option value="domestic">Domestic</option><option value="international">International</option></select></div><div class="col-md-10 text-right"><button type="button" class="btn btn-primary btn-with-icon" ng-click="sr2.apply()"><i class="ion-search"></i> Apply</button> <button type="button" class="btn btn-warning btn-with-icon" ng-click="sr2.reset()"><i class="ion-refresh"></i> Reset</button> <button type="button" class="btn btn-danger btn-with-icon" ng-click="sr2.export(\'csv\')" ng-disabled="sr2.loading"><i class="fa fa-file-excel-o"></i> CSV</button> <button type="button" class="btn btn-danger btn-with-icon" ng-click="sr2.export(\'xls\')" ng-disabled="sr2.loading"><i class="fa fa-file-excel-o"></i> Excel</button></div></div><div class="row mb-10"><div class="col-md-12"><span class="label label-success font-size-14">Total Price: ${{sr2.totalPrice}}</span> <span class="label label-info font-size-14">Records: {{sr2.totalRecords}}</span> <span ng-if="sr2.loading" class="label label-warning font-size-14">Loading...</span> <span ng-if="sr2.error" class="label label-danger font-size-14">{{sr2.error}}</span></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div class="horizontal-scroll"><table class="table table-bordered table-hover row-border"><thead><tr><th ng-repeat="col in sr2.columns" ng-click="sr2.sort(col)" ng-class="{\'cursor-pointer\': col.sortable, \'text-center\': true}">{{col.title}} <span ng-if="col.sortable && sr2.sortColumn === col.index"><i ng-if="sr2.sortDir === \'asc\'" class="fa fa-sort-asc"></i><i ng-if="sr2.sortDir === \'desc\'" class="fa fa-sort-desc"></i></span></th></tr></thead><tbody><tr ng-if="!sr2.loading && sr2.rows.length === 0"><td colspan="{{sr2.columns.length}}" class="text-center">No data available</td></tr><tr ng-repeat="row in sr2.rows track by $index"><td ng-repeat="col in sr2.columns" class="text-center">{{sr2.formatCell(row, col)}}</td></tr></tbody></table></div><div class="row" style="margin-top:10px;"><div class="col-md-6">Page {{sr2.page}} of {{sr2.totalPages}}</div><div class="col-md-6 text-right"><button type="button" class="btn btn-default" ng-click="sr2.prevPage()" ng-disabled="sr2.page <= 1 || sr2.loading">Previous</button> <button type="button" class="btn btn-default" ng-click="sr2.nextPage()" ng-disabled="sr2.page >= sr2.totalPages || sr2.loading">Next</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/reports/shipmentReport/shipmentReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="shipmentNumber" type="text" ng-model="sr.shipmentNumber" name="shipmentNumber" class="form-control" placeholder="Shipment Number"></div></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="customerName" type="text" ng-model="sr.customerName" name="customerName" class="form-control" placeholder="Customer Name"></div></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><input id="trackingNumber" type="text" ng-model="sr.trackingNumber" name="trackingNumber" class="form-control" placeholder="Tracking Number"></div></div></div></div><div class="row"><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><select ng-model="sr.service" class="form-control"><option value="">Select Service</option><option value="fedex">Fedex</option><option value="usps">USPS</option><option value="ups">UPS</option><option value="office">Office</option></select></div></div></div><div class="col-md-3" ng-if="permissionArr.indexOf(\'store_filter_shipment_report\') !== - 1" ng-init="getStoreData()"><div class="form-group"><select ng-model="sr.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in sr.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-3"><div class="form-group row clearfix"><div class="col-sm-12 filter_column"><select ng-model="sr.address_type" class="form-control"><option value="">Select Shipment Types</option><option value="domestic">Domestic</option><option value="international">International</option></select></div></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/shipmentReportDashboard/categoryCrystalModel.html','<div class="modal-content modal-categoryCrystal"><div class="modal-header bg-header-back"><div class="col-md-12"><div class="text-center m-t-5"><h4><i class="fa fa-pie-chart" aria-hidden="true"></i><span>{{storeName}}</span><span>( {{datePicker.date.startDate}} To {{datePicker.date.endDate}} )</span> <span class="m-l-15">Total : ${{total?total:0}}</span></h4></div><div class="btn-actions"><button type="button" ng-click="export(\'xls\')" class="btn btn-danger btn-with-icon"><i class="fa fa-file-excel-o" aria-hidden="true"></i>Excel</button> <button type="button" ng-click="export(\'csv\')" class="btn btn-danger btn-with-icon"><i class="fa fa-file-excel-o" aria-hidden="true"></i>CSV</button> <button type="button" class="close pull-right m-l-15" ng-click="$dismiss()">&times;</button></div></div></div><div class="modal-body vertical-tab bck-clss"><div class="row"><div class="col-md-12 datatable-scroll"><div class="container"><table class="table table-bordered"><thead><tr><th class="data-labal-color-dg">Shipment Order Number</th><th class="data-labal-color-dg">Tracking Number</th><th class="data-labal-color-dg">Tracking Type</th><th class="data-labal-color-dg">Service</th><th class="data-labal-color-dg">Service Type</th><th class="data-labal-color-dg">Charge</th><th class="data-labal-color-dg">Created Date</th></tr></thead><tbody><tr ng-repeat="data in categoryCrystalData" ng-if="categoryCrystalData.length > 0"><td class="data-labal-color-dg">{{data[\'shipment_order_number\']}}</td><td class="data-labal-color-dg text-center">{{data[\'tracking_number\']}}</td><td class="data-labal-color-dg text-center">{{data[\'tracking_type\']}}</td><td class="data-labal-color-dg text-center">{{data[\'service\']}}</td><td class="data-labal-color-dg text-center">{{data[\'service_type\']}}</td><td class="data-labal-color-dg text-center">{{data[\'charge\']}}</td><td class="data-labal-color-dg text-center">{{data[\'created_at\']}}</td></tr></tbody></table></div><br><div ng-if="categoryCrystalData.length <= 0" class="text-center"><label class="data-labal-color-dg text-center">No Data Available</label></div></div></div><div class="modal-footer"><p>&nbsp;</p></div></div><style>\n  .bck-clss{\n    background-color: #4380c1;\n  }\n  .bg-header-back{\n    background-color: #282828;\n  }\n  .data-labal-color-dg{\n   color: #ffffff;\n  }\n  .tab-height>.tab-content {\n    max-height: {{catPopupSizeMin}}px;\n    overflow-y:auto;\n  }\n</style></div>');
$templateCache.put('app/pages/reports/shipmentReportDashboard/reportDashboard.html','<div class="row mb-10"><div class="col-sm-6 col-lg-3"><div class="input-group cur-pntr"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePicker.date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon date-picker input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-6 col-lg-3"><button type="button" ng-click="loadDataFromAPI()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetDashboard()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><h3 class="with-line"></h3><div class="row pie-charts"><div ng-if="totaldata>0 && store.display_name" ng-click="loadChartData(store.customer_id,store.display_name,store.position_id,renderWithTotal(store.total?store.total:0))" class="col-lg-3 col-sm-4 poitr-cur radius-zero" ng-repeat="store in storeData"><div ba-panel=""><div class="text-center report-dashboard-store-name cut-text-report-dash" title="{{store.display_name}} {{store.position_id}}">{{store.display_name}} {{store.position_id}}</div><div class="text-center report-dashboard-lable nowrap">Total : ${{renderWithTotal(store.total?store.total:0)}}</div></div></div><div ng-if="totaldata<=0" class="text-center"><span>No data available</span></div></div>');
$templateCache.put('app/pages/reports/shippingCountReport/shippingCountReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/storeCreditReport/storeCreditReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerReports.date" placeholder="Select Date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="form-group"><select ng-model="scr.action" class="form-control"><option value="" selected="">Select Action</option><option value="1">Updated</option><option value="2">Created</option><option value="3">Used</option><option value="4">Refunded</option><option value="5">Reverted</option></select></div></div><div ng-if="permissionArr.indexOf(\'store_filter_store_credit_of_report\') !== - 1" class="col-md-3" ng-init="getStoreData()"><div class="form-group"><select ng-model="scr.store" class="form-control"><option value="0">Select Store</option><option ng-repeat="store in scr.storeData" value="{{store.store_id}}">{{store.store_name}}</option></select></div></div><div class="col-md-3"><div class="form-group"><input id="addInformation" type="text" ng-model="scr.addInformation" name="addInformation" class="form-control" placeholder="Additional Info | Customer | Order Number"></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div>');
$templateCache.put('app/pages/reports/stockReport/stockReport.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3" ng-init="getProductData()"><div class="form-group"><ui-select ng-model="vm.productName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Product">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="product.name as product in vm.productData | filter: $select.search"><span ng-bind-html="product.name"></span></ui-select-choices></ui-select></div></div><div class="col-md-3" ng-init="getWarehouseData()"><div class="form-group"><ui-select ng-model="vm.warehouseName" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select Warehoue">{{$select.selected.warehouse_name}}</ui-select-match><ui-select-choices repeat="warehouse.warehouse_name as warehouse in vm.warehouseData | filter: $select.search"><span ng-bind-html="warehouse.warehouse_name"></span></ui-select-choices></ui-select></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::(loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageAccounts/addAccount.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';service=\'\';phone=\'\';etd=\'0\';"><div class="panel-content" ng-init="getEditedAccount()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="accountFrm" novalidate="" ng-submit="accountFrm.$valid && saveAccountData()"><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label for="service" class="col-sm-3 control-label">Service <span class="asterisk_input"></span></label><div class="col-sm-9"><select class="form-control" ng-model="service" name="service" id="service" ng-change="changeService(service)" ng-required=""><option value="">Select Service</option><option value="fedex">Fedex</option><option value="usps">USPS</option><option value="ups">UPS</option><option value="office">Office</option></select><span class="error" ng-show="accountFrm.$submitted && accountFrm.service.$error.required">Please select service.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.account_number.$error.required || accountFrm.account_number.$error.pattern) && accountFrm.account_number.$touched}"><label for="account_number" class="col-sm-3 control-label">Account Number <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="account_number" limit-to="80" type="text" ng-model="account_number" name="account_number" ng-minlength="5" class="form-control" placeholder="123456789"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.account_number.$error.required">Please enter account number.</span> <span class="error" ng-show="!accountFrm.account_number.$error.minlength && accountFrm.account_number.$error.pattern">Please enter valid account number</span> <span class="error" ng-show="accountFrm.account_number.$error.minlength">Account Number must contain atleast 5 digits.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.meter_number.$error.required || accountFrm.meter_number.$error.pattern) && accountFrm.meter_number.$touched}"><label for="meter_number" class="col-sm-3 control-label">Meter Number <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="meter_number" limit-to="15" type="text" ng-model="meter_number" name="meter_number" ng-minlength="5" class="form-control" placeholder="123456789"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.meter_number.$error.required">Please enter meter number.</span> <span class="error" ng-show="!accountFrm.meter_number.$error.minlength && accountFrm.meter_number.$error.pattern">Please enter valid meter number</span> <span class="error" ng-show="accountFrm.meter_number.$error.minlength">Meter Number must contain atleast 5 digits.</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.account_key.$error.required || accountFrm.account_key.$error.pattern || accountFrm.account_key.$error.maxlength) && accountFrm.account_key.$touched}"><label for="account_key" class="col-sm-3 control-label">Key <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="account_key" type="text" ng-model="account_key" limit-to="150" ng-maxlength="150" name="account_key" required="" class="form-control" placeholder="Key" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.account_key.$error.required">Please enter key.</span> <span class="error" ng-show="accountFrm.account_key.$error.pattern">Please enter valid key.</span> <span class="error" ng-show="accountFrm.account_key.$error.maxlength && accountFrm.account_key.$touched">Key should not be greater than 150 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.account_password.$error.required || accountFrm.account_password.$error.pattern || accountFrm.account_password.$error.maxlength) && accountFrm.account_password.$touched}"><label for="account_password" class="col-sm-3 control-label">Password <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="account_password" type="text" ng-model="account_password" limit-to="70" ng-maxlength="70" name="account_password" class="form-control" placeholder="Password"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.account_password.$error.required">Please enter account password.</span> <span class="error" ng-show="accountFrm.account_password.$error.pattern">Please enter valid account password.</span> <span class="error" ng-show="accountFrm.account_password.$error.maxlength && accountFrm.account_password.$touched">Account Password should not be greater than 70 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.company_name.$error.required || accountFrm.company_name.$error.pattern || accountFrm.company_name.$error.maxlength) && accountFrm.company_name.$touched}"><label for="company_name" class="col-sm-3 control-label">Company Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="company_name" type="text" ng-model="company_name" limit-to="50" ng-maxlength="50" name="company_name" required="" class="form-control" placeholder="Company Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.company_name.$error.required">Please enter company name.</span> <span class="error" ng-show="accountFrm.company_name.$error.pattern">Please enter valid company name.</span> <span class="error" ng-show="accountFrm.company_name.$error.maxlength && accountFrm.company_name.$touched">Company Name should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.person_name.$error.required || accountFrm.person_name.$error.pattern || accountFrm.person_name.$error.maxlength) && accountFrm.person_name.$touched}"><label for="person_name" class="col-sm-3 control-label">Person Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="person_name" type="text" ng-model="person_name" limit-to="50" ng-maxlength="50" name="person_name" required="" class="form-control" placeholder="Person Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.person_name.$error.required">Please enter name.</span> <span class="error" ng-show="accountFrm.person_name.$error.pattern">Please enter valid name.</span> <span class="error" ng-show="accountFrm.person_name.$error.maxlength && accountFrm.person_name.$touched">Name should not be greater than 50 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.phone.$error.required || accountFrm.phone.$error.pattern) && accountFrm.phone.$touched}"><label for="phone" class="col-sm-3 control-label">Phone <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="phone" limit-to="15" type="text" ng-model="phone" name="phone" ng-minlength="10" required="" class="form-control" placeholder="123-123-1234" ng-pattern="/^(\\+?(\\d{1}|\\d{2}|\\d{3})[- ]?)?\\d{3}[- ]?\\d{3}[- ]?\\d{4}$/"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.phone.$error.required">Please enter phone number.</span> <span class="error" ng-show="!accountFrm.phone.$error.minlength && accountFrm.phone.$error.pattern">Please enter valid phone number</span> <span class="error" ng-show="accountFrm.phone.$error.minlength">Number must contain atleast 10 digits.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="city" class="col-sm-3 control-label">City <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="city" type="text" ng-model="city" limit-to="30" ng-maxlength="30" name="city" required="" class="form-control" placeholder="City" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.city.$error.required">Please enter city.</span> <span class="error" ng-show="accountFrm.city.$error.pattern">Please enter valid city name.</span> <span class="error" ng-show="accountFrm.city.$error.maxlength && accountFrm.city.$touched">City name should not be greater than 30 characters</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label for="state" class="col-sm-3 control-label">State <span class="asterisk_input"></span></label><div class="col-sm-9"><select class="form-control" ng-model="state" name="state" id="state" required=""><option value="">Select State</option><option value="AK">Alaska</option><option value="AL">Alabama</option><option value="AR">Arkansas</option><option value="AZ">Arizona</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="NY">New York</option><option value="DC">Washington, D.C.</option><option value="WV">West Virginia</option><option value="WY">Wyoming</option></select><span class="error" ng-show="accountFrm.$submitted && accountFrm.state.$error.required">Please select State.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.zipcode.$error.required || accountFrm.zipcode.$error.pattern) && accountFrm.zipcode.$touched}"><label for="zipcode" class="col-sm-3 control-label">Zip Code<span class="asterisk_input"></span></label><div class="col-sm-9"><input id="zipcode" limit-to="6" type="text" ng-model="zipcode" name="zipcode" ng-minlength="5" required="" class="form-control" placeholder="11111"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.zipcode.$error.required">Please enter zipcode.</span> <span class="error" ng-show="accountFrm.zipcode.$error.minlength">Zipcode must contain atleast 5 digits.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="address" class="col-sm-3 control-label">Address</label><div class="col-sm-9"><textarea id="address" ng-model="address" name="address" class="form-control" placeholder="Enter Address" style="position:relative"></textarea></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix"><label for="type" class="col-sm-3 control-label">Type <span class="asterisk_input"></span></label><div class="col-sm-9"><select class="form-control" ng-model="type" name="type" id="type" required=""><option value="">Select Type</option><option value="testing">Testing</option><option value="production">Production</option></select><span class="error" ng-show="accountFrm.$submitted && accountFrm.type.$error.required">Please select type.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="accountFrm.$submitted && accountFrm.status.$error.required">Please select status.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="taxshipper" class="col-sm-3 control-label">Tax On <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="taxaccount" type="radio" name="taxaccount" id="taxshipper" value="shipper"> <span>Shipper</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="taxaccount" type="radio" name="taxaccount" id="taxreceiver" value="receiver"> <span>Receiver</span></label> <span class="error" ng-show="accountFrm.$submitted && accountFrm.taxaccount.$error.required">Please select tax on.</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.hubid.$error.required || accountFrm.hubid.$error.pattern) && accountFrm.hubid.$touched}"><label for="hubid" class="col-sm-3 control-label">HubID<span class="asterisk_input"></span></label><div class="col-sm-9"><input id="hubid" limit-to="4" type="text" ng-model="hubid" name="hubid" ng-minlength="4" class="form-control" placeholder="1111"> <span class="error" ng-show="accountFrm.hubid.$error.minlength">HubID must contain 4 digits.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="etd" class="col-sm-3 control-label">ETD <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="etd" type="radio" name="etd" id="etd" value="1"> <span>New ETD</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="etd" type="radio" name="etd" id="etd2" value="0"> <span>Old Commercial Invoice</span></label> <span class="error" ng-show="accountFrm.$submitted && accountFrm.etd.$error.required">Please select ETD.</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.pfeedomestic.$error.required) && accountFrm.pfeedomestic.$touched}"><label for="pfeedomestic" class="col-sm-3 control-label">Processing Fee Domestic <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="pfeedomestic" type="number" ng-model="pfeedomestic" name="pfeedomestic" required="" class="form-control" placeholder="0.00"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.pfeedomestic.$error.required">Please enter processing fee for domestic.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (accountFrm.pfeeinternational.$error.required) && accountFrm.pfeeinternational.$touched}"><label for="pfeeinternational" class="col-sm-3 control-label">Processing Fee International <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="pfeeinternational" type="number" ng-model="pfeeinternational" name="pfeeinternational" required="" class="form-control" placeholder="0.00"> <span class="error" ng-show="accountFrm.$submitted && accountFrm.pfeeinternational.$error.required">Please enter processing fee for international.</span></div></div></div></div><div class="row" ng-if="accountId"><div class="col-md-4"><div class="form-group row clearfix"><label for="uploadSignature" class="col-sm-4 control-label">Upload Signature</label><div class="col-sm-8"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ signature }}" ng-click="uploadSignature()"></div><i class="ion-ios-close-outline" ng-click="removeSignature()" ng-if="!noSignature"></i> <a href="" class="change-userpic" ng-click="uploadSignature()">Change Signature</a> <input type="file" name="FileUploadSignature" ng-show="false" id="uploadSignature" ng-file-select="onFileSelect($files)" fileread="file"></div></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="uploadLetterHead" class="col-sm-4 control-label">Upload Letter Head</label><div class="col-sm-8"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ letterhead }}" ng-click="uploadLetterHead()"></div><i class="ion-ios-close-outline" ng-click="removeLetterHead()" ng-if="!noLetterHead"></i> <a href="" class="change-userpic" ng-click="uploadLetterHead()">Change Letter Head</a> <input type="file" name="FileUploadLetterHead" ng-show="false" id="uploadLetterHead" ng-file-select="onFileSelect($files)" fileread="file"></div></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="shipsettings.manage-accounts" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="accountId"></form></div></div>');
$templateCache.put('app/pages/shipSettings/manageAccounts/deleteModal.html','<div class="modal-content" ng-controller="manageAccountsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteAccount()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/manageAccounts/manageaccounts.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-click="addAccount()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageAccounts/statusModal.html','<div class="modal-content" ng-controller="manageAccountsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/manageBoxes/addBox.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';name=\'\';"><div class="panel-content" ng-init="getEditedBox()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="boxFrm" novalidate="" ng-submit="boxFrm.$valid && saveBoxData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.name.$error.required || boxFrm.name.$error.pattern || boxFrm.name.$error.maxlength) && boxFrm.name.$touched}"><label for="name" class="col-sm-3 control-label">Box Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="name" type="text" ng-model="name" limit-to="30" ng-maxlength="30" name="name" required="" class="form-control" placeholder="Box Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.name.$error.required">Please enter box name.</span> <span class="error" ng-show="boxFrm.name.$error.pattern">Please enter valid box name.</span> <span class="error" ng-show="boxFrm.name.$error.maxlength && boxFrm.name.$touched">Box Name should not be greater than 30 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': boxFrm.inlineRadioOptions.$error.required && boxFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="boxFrm.$submitted && boxFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.length.$error.required || boxFrm.length.$error.pattern || boxFrm.length.$error.maxlength) && boxFrm.length.$touched}"><label for="length" class="col-sm-3 control-label">Length <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="length" type="number" ng-model="length" limit-to="7" ng-maxlength="7" name="length" required="" class="form-control" placeholder="Length" ng-pattern="/^[0-9.]*$/"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.length.$error.required">Please enter length.</span> <span class="error" ng-show="boxFrm.length.$error.pattern">Please enter valid length.</span> <span class="error" ng-show="boxFrm.length.$error.maxlength && boxFrm.length.$touched">Length should not be greater than 7 numbers</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.width.$error.required || boxFrm.width.$error.pattern || boxFrm.width.$error.maxlength) && boxFrm.width.$touched}"><label for="width" class="col-sm-3 control-label">Width <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="width" type="number" ng-model="width" limit-to="7" ng-maxlength="7" name="width" required="" class="form-control" placeholder="Width" ng-pattern="/^[0-9.]*$/"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.width.$error.required">Please enter width.</span> <span class="error" ng-show="boxFrm.width.$error.pattern">Please enter valid width.</span> <span class="error" ng-show="boxFrm.width.$error.maxlength && boxFrm.width.$touched">Width should not be greater than 7 numbers</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.height.$error.required || boxFrm.height.$error.pattern || boxFrm.height.$error.maxlength) && boxFrm.height.$touched}"><label for="height" class="col-sm-3 control-label">Height <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="height" type="number" ng-model="height" limit-to="7" ng-maxlength="7" name="height" required="" class="form-control" placeholder="Height" ng-pattern="/^[0-9.]*$/"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.height.$error.required">Please enter height.</span> <span class="error" ng-show="boxFrm.height.$error.pattern">Please enter valid height.</span> <span class="error" ng-show="boxFrm.height.$error.maxlength && boxFrm.height.$touched">Height should not be greater than 7 numbers</span></div></div></div></div><div class="row"><div class="col-md-6" ng-if="boxeditId"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.availabel_qty.$error.required || boxFrm.availabel_qty.$error.pattern) && boxFrm.availabel_qty.$touched}"><label for="availabel_qty" class="col-sm-3 control-label">Available Qty <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="availabel_qty" type="number" ng-model="availabel_qty" ng-pattern="/^-?[0-9][^\\.]*$/" ng-min="1" name="availabel_qty" required="" class="form-control" value="0" placeholder="Available Qty"> <a ng-click="AddStock()" href="javascript:void(0);" title="Add Stock"><i class="fa fa-plus" style="color:#fff;" aria-hidden="true"></i></a>&nbsp; <a ng-click="RemoveStock()" href="javascript:void(0);" title="Remove Stock"><i class="fa fa-minus" style="color:#fff;" aria-hidden="true"></i></a>&nbsp; <a ng-click="BoxStockLog()" href="javascript:void(0);" title="Stock Log"><i class="fa fa-history" style="color:#fff;" aria-hidden="true"></i></a> <span class="error" ng-show="boxFrm.$submitted && boxFrm.availabel_qty.$error.required">Please enter available qty.</span> <span class="error" ng-show="boxFrm.availabel_qty.$error.pattern">Please enter valid quantity.</span> <span class="error" ng-show="boxFrm.availabel_qty.$error.min && boxFrm.availabel_qty.$touched">Available Qty should not be less than 0</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': boxFrm.servicebox.$touched}" ng-init="getServiceBoxes()"><label for="servicebox" class="col-sm-3 control-label">Service Box</label><div class="col-sm-9"><select class="form-control" name="servicebox" id="servicebox" placeholder="Please Select" ng-model="servicebox"><option value="0">Please Select</option><option ng-repeat="sb in serviceBoxes" value="{{sb.service_box_id}}">{{sb.service_box_label}}</option></select></div></div></div></div><div class="row"><div class="col-sm-4"><div class="form-group"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Store Code</th><th class="width-20-per">Price</th></tr></thead><tbody><tr class="editable-row" ng-if="store_costs.length > 0" ng-repeat="sc in store_costs"><td class="text-center">{{ sc.store_name }}</td><td class="text-center">{{ sc.store_code }}</td><td><div class="input-group"><span class="input-group-addon input-group-addon-default addon-left">$</span> <input type="text" is-number-key="" class="form-control" placeholder="Price" ng-model="sc.box_cost" value="{{sc.box_cost}}" name="storecost{{$index}}" required=""> <span class="error" ng-show="boxFrm.$submitted && boxFrm[\'storecost\' +$index].$error.required">Please enter price.</span></div></td></tr><tr ng-if="store_costs.length < 1"><td colspan="3">No data available in table</td></tr></tbody></table></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="shipsettings.manage-boxes" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="boxeditId"></form></div></div><div id="stockLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Stock Logs</span> <button type="button" class="close" ng-click="closeStockLogs()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!stockLogsLoaded">Loading....</div><div ng-if="stockLogsLoaded" class="datatable-scroll"><div class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="date">Date</th><th class="oldStatus">Old Stock</th><th class="nStatus">New Stock</th><th class="date">Note</th><th class="uName">User Name</th></tr></thead><tbody><tr ng-repeat="data in stockLogsArr"><td class="date">{{getGlobalDateFormat(data.updated_at)}}</td><td class="oldStatus">{{data.old_stock}}</td><td class="nStatus">{{data.new_stock}}</td><td><span ng-if="data.note">{{data.note}}</span> <span ng-if="!data.note">--</span></td><td class="uName">{{data.user_name}}</td></tr><tr ng-if="!stockLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageBoxes/addBoxStock.html','<div class="modal-content" ng-controller="shipmentBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Add Stock for {{ boxName }}</span></div><div class="modal-body"><form class="form-horizontal" name="shipmentBoxStockFrm" novalidate="" ng-submit="shipmentBoxStockFrm.$valid && saveBoxStock()"><div class="row"><div class="col-sm-6"><input id="addqty" type="number" min="0" ng-min="0" ng-minlength="1" ng-model="addqty" name="addqty" class="form-control" placeholder="Pieces" ng-change="ChangeTotalStock(addqty,\'add\')"> <span class="error" ng-show="!shipmentBoxStockFrm.addqty.$error.pattern && shipmentBoxStockFrm.addqty.$error.min && shipmentBoxStockFrm.addqty.$touched">Piece should not be less than 1</span></div><div class="col-sm-6"><input id="addsqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="addsqty" name="addsqty" required="" class="form-control" placeholder="Total Pieces" readonly="readonly"> <span class="error" ng-show="shipmentBoxStockFrm.$submitted && shipmentBoxStockFrm.addsqty.$error.required">Please enter Total Quantity.</span> <span class="error" ng-show="!shipmentBoxStockFrm.addsqty.$error.pattern && shipmentBoxStockFrm.addsqty.$error.minlength && shipmentBoxStockFrm.addsqty.$touched">Pieces should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="shipmentBoxStockFrm.$submitted && shipmentBoxStockFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!shipmentBoxStockFrm.addnote.$error.pattern && shipmentBoxStockFrm.addnote.$error.maxlength && shipmentBoxStockFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="ShipmentBoxId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/shipSettings/manageBoxes/deleteModal.html','<div class="modal-content" ng-controller="shipmentBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this box?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteBox()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/manageBoxes/manageboxes.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-if="permissionArr.indexOf(\'sub_admin_add\') !== - 1" ng-click="addBox()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageBoxes/removeBoxStock.html','<div class="modal-content" ng-controller="shipmentBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Remove Stock</span></div><div class="modal-body"><form class="form-horizontal" name="shipmentBoxStockFrm" novalidate="" ng-submit="shipmentBoxStockFrm.$valid"><div class="row"><div class="col-sm-4"><input id="removeQty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removeQty" name="removeQty" class="form-control" placeholder="Quantity" ng-change="ChangeTotalStock(removeQty,\'remove\')"> <span class="error" ng-show="!shipmentBoxStockFrm.removeQty.$error.pattern && shipmentBoxStockFrm.removeQty.$error.min && shipmentBoxStockFrm.removeQty.$touched">Qty should not be less than 1</span></div><div class="col-sm-4"><input id="removesqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removesqty" name="removesqty" required="" class="form-control" placeholder="Total Quantity" readonly="readonly"> <span class="error" ng-show="shipmentBoxStockFrm.$submitted && shipmentBoxStockFrm.removesqty.$error.required">Please enter Quantity or Box.</span> <span class="error" ng-show="!shipmentBoxStockFrm.removesqty.$error.pattern && shipmentBoxStockFrm.removesqty.$error.min && shipmentBoxStockFrm.removesqty.$touched">Qty should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="shipmentBoxStockFrm.$submitted && shipmentBoxStockFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!shipmentBoxStockFrm.addnote.$error.pattern && shipmentBoxStockFrm.addnote.$error.maxlength && shipmentBoxStockFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="ShipmentBoxId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/shipSettings/manageBoxes/statusModal.html','<div class="modal-content" ng-controller="shipmentBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeBoxStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceBoxes/addServiceBox.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="onerate=\'0\';status=\'1\';service=\'\';name=\'\';code=\'\';"><div class="panel-content" ng-init="getEditedBox()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="boxFrm" novalidate="" ng-submit="boxFrm.$valid && saveBoxData()"><div class="row" ng-if="permissionArr.indexOf(\'shipment_service_box_show\') !== - 1"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.service.$error.required) && boxFrm.service.$touched}"><label for="name" class="col-sm-3 control-label">Service <span class="asterisk_input"></span></label><div class="col-sm-9"><select class="form-control" name="service" id="service" placeholder="Please Select" ng-model="service"><option value="">Please Select</option><option value="fedex" selected="">Fedex</option><option value="usps" selected="">USPS</option></select><span class="error" ng-show="boxFrm.$submitted && boxFrm.service.$error.required">Please select service.</span></div></div></div></div><div class="row" ng-if="permissionArr.indexOf(\'shipment_service_box_show\') !== - 1"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.name.$error.required || boxFrm.name.$error.pattern || boxFrm.name.$error.maxlength) && boxFrm.name.$touched}"><label for="name" class="col-sm-3 control-label">Box Name <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="name" type="text" ng-model="name" limit-to="70" ng-maxlength="70" name="name" required="" class="form-control" placeholder="Box Name"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.name.$error.required">Please enter box name.</span> <span class="error" ng-show="boxFrm.name.$error.maxlength && boxFrm.name.$touched">Box Name should not be greater than 70 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.code.$error.required || boxFrm.code.$error.maxlength) && boxFrm.code.$touched}"><label for="code" class="col-sm-3 control-label">Box Code <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="code" type="text" ng-model="code" limit-to="70" ng-maxlength="70" name="code" required="" class="form-control" placeholder="Box Code"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.code.$error.required">Please enter box code.</span> <span class="error" ng-show="boxFrm.code.$error.maxlength && boxFrm.code.$touched">Box code should not be greater than 70 characters</span></div></div></div></div><div class="row" ng-if="permissionArr.indexOf(\'shipment_service_box_show\') !== - 1"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': boxFrm.inlineRadioOptions.$error.required && boxFrm.inlineRadioOptions.$touched}"><label for="onerateyes" class="col-sm-3 control-label">One Rate <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="onerate" type="radio" name="onerate" id="onerateyes" value="1"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="onerate" type="radio" name="onerate" id="onerateno" value="0"> <span>No</span></label> <span class="error" ng-show="boxFrm.$submitted && boxFrm.onerate.$error.required">Please select one rate.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': boxFrm.inlineRadioOptions.$error.required && boxFrm.inlineRadioOptions.$touched}"><label for="status" class="col-sm-3 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-9"><label class="radio-inline custom-radio nowrap"><input id="status" required="" ng-model="status" type="radio" name="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio1" value="0"> <span>InActive</span></label> <span class="error" ng-show="boxFrm.$submitted && boxFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-6" ng-if="permissionArr.indexOf(\'shipment_service_box_available_qty\') !== - 1"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.availabel_qty.$error.required || boxFrm.availabel_qty.$error.pattern) && boxFrm.availabel_qty.$touched}"><label for="availabel_qty" class="col-sm-3 control-label">Available Qty <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="availabel_qty" type="number" ng-model="availabel_qty" ng-pattern="/^-?[0-9][^\\.]*$/" ng-min="1" name="availabel_qty" required="" class="form-control" value="0" placeholder="Available Qty" readonly=""> <span class="error" ng-show="boxFrm.$submitted && boxFrm.availabel_qty.$error.required">Please enter available qty.</span> <span class="error" ng-show="boxFrm.availabel_qty.$error.pattern">Please enter valid quantity.</span> <span class="error" ng-show="boxFrm.availabel_qty.$error.min && boxFrm.availabel_qty.$touched">Available Qty should not be less than 0</span> <a ng-click="AddStock()" href="javascript:void(0);" title="Add Stock"><i class="fa fa-plus" style="color:#fff;" aria-hidden="true"></i></a>&nbsp; <a ng-click="RemoveStock()" href="javascript:void(0);" title="Remove Stock"><i class="fa fa-minus" style="color:#fff;" aria-hidden="true"></i></a>&nbsp; <a ng-click="ServiceBoxStockLog()" href="javascript:void(0);" title="Stock Log"><i class="fa fa-history" style="color:#fff;" aria-hidden="true"></i></a></div></div></div><div class="col-md-6" ng-if="permissionArr.indexOf(\'shipment_service_box_price\') !== - 1"><div class="form-group row clearfix" ng-class="{\'has-error\': (boxFrm.price.$error.required) && boxFrm.price.$touched}"><label for="price" class="col-sm-3 control-label">Box Price <span class="asterisk_input"></span></label><div class="col-sm-9"><input id="price" type="number" ng-model="price" ng-min="1" name="price" required="" class="form-control" value="0" placeholder="Price"> <span class="error" ng-show="boxFrm.$submitted && boxFrm.price.$error.required">Please enter box price.</span> <span class="error" ng-show="boxFrm.price.$error.min && boxFrm.price.$touched">Price should not be less than 0</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="shipsettings.manage-service-boxes" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="boxeditId"></form></div></div><div id="stockLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Stock Logs</span> <button type="button" class="close" ng-click="closeStockLogs()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!stockLogsLoaded">Loading....</div><div ng-if="stockLogsLoaded" class="datatable-scroll"><div class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="date">Date</th><th class="oldStatus">Old Stock</th><th class="nStatus">New Stock</th><th class="date">Note</th><th class="uName">User Name</th></tr></thead><tbody><tr ng-repeat="data in stockLogsArr"><td class="date">{{getGlobalDateFormat(data.updated_at)}}</td><td class="oldStatus">{{data.old_stock}}</td><td class="nStatus">{{data.new_stock}}</td><td><span ng-if="data.note">{{data.note}}</span> <span ng-if="!data.note">--</span></td><td class="uName">{{data.user_name}}</td></tr><tr ng-if="!stockLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceBoxes/addServiceBoxStock.html','<div class="modal-content" ng-controller="serviceBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Add Stock for {{ boxName }}</span></div><div class="modal-body"><form class="form-horizontal" name="serviceBoxStockFrm" novalidate="" ng-submit="serviceBoxStockFrm.$valid && saveServiceBoxStock()"><div class="row"><div class="col-sm-6"><input id="addqty" type="number" min="0" ng-min="0" ng-minlength="1" ng-model="addqty" name="addqty" class="form-control" placeholder="Pieces" ng-change="ChangeTotalStock(addqty,\'add\')"> <span class="error" ng-show="!serviceBoxStockFrm.addqty.$error.pattern && serviceBoxStockFrm.addqty.$error.min && serviceBoxStockFrm.addqty.$touched">Piece should not be less than 1</span></div><div class="col-sm-6"><input id="addsqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="addsqty" name="addsqty" required="" class="form-control" placeholder="Total Pieces" readonly="readonly"> <span class="error" ng-show="serviceBoxStockFrm.$submitted && serviceBoxStockFrm.addsqty.$error.required">Please enter Total Quantity.</span> <span class="error" ng-show="!serviceBoxStockFrm.addsqty.$error.pattern && serviceBoxStockFrm.addsqty.$error.minlength && serviceBoxStockFrm.addsqty.$touched">Pieces should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="serviceBoxStockFrm.$submitted && serviceBoxStockFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!serviceBoxStockFrm.addnote.$error.pattern && serviceBoxStockFrm.addnote.$error.maxlength && serviceBoxStockFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="ServiceBoxId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceBoxes/deleteModal.html','<div class="modal-content" ng-controller="serviceBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this box?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteBox()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceBoxes/removeServiceBoxStock.html','<div class="modal-content" ng-controller="serviceBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Remove Stock</span></div><div class="modal-body"><form class="form-horizontal" name="serviceBoxStockFrm" novalidate="" ng-submit="serviceBoxStockFrm.$valid && removeServiceBoxStock()"><div class="row"><div class="col-sm-4"><input id="removeQty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removeQty" name="removeQty" class="form-control" placeholder="Quantity" ng-change="ChangeTotalStock(removeQty,\'remove\')"> <span class="error" ng-show="!serviceBoxStockFrm.removeQty.$error.pattern && serviceBoxStockFrm.removeQty.$error.min && serviceBoxStockFrm.removeQty.$touched">Qty should not be less than 1</span></div><div class="col-sm-4"><input id="removesqty" type="number" min="1" ng-min="1" ng-minlength="1" ng-model="removesqty" name="removesqty" required="" class="form-control" placeholder="Total Quantity" readonly="readonly"> <span class="error" ng-show="serviceBoxStockFrm.$submitted && serviceBoxStockFrm.removesqty.$error.required">Please enter Quantity or Box.</span> <span class="error" ng-show="!serviceBoxStockFrm.removesqty.$error.pattern && serviceBoxStockFrm.removesqty.$error.min && serviceBoxStockFrm.removesqty.$touched">Qty should not be less than 1</span></div><div class="col-sm-12"><br><textarea id="addnote" limit-to="200" ng-maxlength="200" ng-model="addnote" name="addnote" required="" class="form-control" placeholder="Note"></textarea> <span class="error" ng-show="serviceBoxStockFrm.$submitted && serviceBoxStockFrm.addnote.$error.required">Please enter note.</span> <span class="error" ng-show="!serviceBoxStockFrm.addnote.$error.pattern && serviceBoxStockFrm.addnote.$error.maxlength && serviceBoxStockFrm.addnote.$touched">Note should not be greater than 200 characters</span></div></div><div class="row text-center"><br><button type="submit" class="btn btn-primary">Save</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">Cancel</button></div><input type="hidden" ng-model="ServiceBoxId"></form></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceBoxes/serviceboxes.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button type="button" ng-if="permissionArr.indexOf(\'shipment_add_service_box\') !== - 1" ng-click="addBox()" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceBoxes/statusModal.html','<div class="modal-content" ng-controller="serviceBoxesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeBoxStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceTypes/addType.html','<div ba-panel="" ng-init="status=\'1\'"><div class="panel-content" ng-init="getEditedType()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="typeFrm" novalidate="" ng-submit="typeFrm.$valid && saveTypeData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (typeFrm.label.$error.required || typeFrm.label.$error.pattern || typeFrm.label.$error.maxlength) && typeFrm.label.$touched}"><label for="typeFrm" class="col-sm-4 control-label">Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="label" type="text" ng-model="label" name="label" required="" class="form-control" placeholder="Label" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="typeFrm.$submitted && typeFrm.label.$error.required">Please enter service type label.</span> <span class="error" ng-show="typeFrm.label.$error.pattern">Please enter valid service type label.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="typeFrm" class="col-sm-4 control-label">Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="code" type="text" ng-model="code" name="code" class="form-control" placeholder="Code" ng-disabled="true"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="typeFrm.$submitted && typeFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="shipsettings.manage-service-types" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="typeId" name="typeId"></form></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceTypes/manageservicetypes.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/shipSettings/manageServiceTypes/statusModal.html','<div class="modal-content" ng-controller="manageServiceTypesCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipSettings/shipmentSettings/shipmentsettings.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getActiveStatus();"><div ng-init="getSettingData()"><form class="form-horizontal" name="shpstFrm" novalidate="" ng-submit="submittedRelayFrm = true"><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="shpstFrm.$valid && saveSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Customer Order Shipping Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="customerStatus" class="col-sm-3 control-label">Status before shipping</label><div class="col-sm-9"><ui-select multiple="" ng-model="ss.customerStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="customerStatus" id="customerStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="customerStatusAfterShipment" class="col-sm-3 control-label">Status after shipping</label><div class="col-sm-9"><select name="customerStatusAfterShipment" id="customerStatusAfterShipment" ng-model="ss.customerStatusAfterShipment" class="form-control"><option value="">Please Select Status</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Mall Order Shipping Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="mallStatus" class="col-sm-3 control-label">Status before creating shipment</label><div class="col-sm-9"><select name="mallStatus" id="mallStatus" ng-model="ss.mallStatus" class="form-control"><option value="">Please Select Status</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="mallStatusAfterShipment" class="col-sm-3 control-label">Status after creating shipment</label><div class="col-sm-9"><select name="mallStatusAfterShipment" id="mallStatusAfterShipment" ng-model="ss.mallStatusAfterShipment" class="form-control"><option value="">Please Select Status</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="mallStatusAfterShip" class="col-sm-3 control-label">Status after ship</label><div class="col-sm-9"><select name="mallStatusAfterShip" id="mallStatusAfterShip" ng-model="ss.mallStatusAfterShip" class="form-control"><option value="">Please Select Status</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Shipment Order Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="shipmentStatus" class="col-sm-3 control-label">Status before shipping</label><div class="col-sm-9"><ui-select multiple="" ng-model="ss.shipmentStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="shipmentStatus" id="shipmentStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="shipmentStatusAfterShipping" class="col-sm-3 control-label">Status after shipping</label><div class="col-sm-9"><select name="shipmentStatusAfterShipping" id="shipmentStatusAfterShipping" ng-model="ss.shipmentStatusAfterShipping" class="form-control"><option value="">Please Select Status</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Office Shipping Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="officeStatus" class="col-sm-3 control-label">Status before shipping</label><div class="col-sm-9"><ui-select multiple="" ng-model="ss.officeStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="officeStatus" id="officeStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="officeStatusAfterShipment" class="col-sm-3 control-label">Status after shipping</label><div class="col-sm-9"><select name="officeStatusAfterShipment" id="officeStatusAfterShipment" ng-model="ss.officeStatusAfterShipment" class="form-control"><option value="">Please Select Status</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="shpstFrm.$valid && saveSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div></div>');
$templateCache.put('app/pages/settings/addressVerificationSettings/addressVerificationSettings.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init=""><div ng-init="getVerificatonSettingData()"><form class="form-horizontal" name="verificatonFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="verificatonFrm.$valid && saveVerificatonSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Address Verification Settings</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row"><label for="autoCheck" class="col-sm-5 control-label">Auto Check</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.autoCheck" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label for="orderCheck" class="col-sm-5 control-label">Save Order Address Check</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.orderCheck" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row" ng-init="getStoreData()"><label for="storeForCheck" class="col-sm-5 control-label">Store For Check</label><div class="col-sm-7"><ui-select multiple="" ng-model="vm.storeForCheck" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="storeForCheck" id="storeForCheck"><ui-select-match placeholder="Store For Check">{{$item.store_name}}</ui-select-match><ui-select-choices repeat="store.store_id as store in storeData | filter: $select.search"><span ng-bind-html="store.store_name"></span></ui-select-choices></ui-select></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="verificatonFrm.$valid && saveVerificatonSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div></div>');
$templateCache.put('app/pages/settings/amazonStores/addStore.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedStore()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="storeFrm" novalidate="" ng-submit="storeFrm.$valid && saveStoreData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="storeName" class="col-sm-4 control-label">Store Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="storeName" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.storeName" name="storeName" required="" class="form-control" placeholder="Store Name"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.storeName.$error.required">Please enter store name.</span> <span class="error" ng-show="!storeFrm.storeName.$error.pattern && storeFrm.storeName.$error.maxlength && storeFrm.storeName.$touched">Store Name should not be greater than 40 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="storeCode" class="col-sm-4 control-label">Store Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="storeCode" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.storeCode" name="storeCode" required="" class="form-control" placeholder="Store Code"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.storeCode.$error.required">Please enter store code.</span> <span class="error" ng-show="!storeFrm.storeCode.$error.pattern && storeFrm.storeCode.$error.maxlength && storeFrm.storeName.$touched">Store Code should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="systemType" class="col-sm-4 control-label">Store Type <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.systemType" class="form-control" name="systemType" id="systemType" required=""><option value="">Select Store Type</option><option value="other">Amazon</option></select><span class="error" ng-show="storeFrm.$submitted && storeFrm.systemType.$error.required">Please select system type.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="storeUrl" class="col-sm-4 control-label">Store URL <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="storeUrl" type="text" ng-model="vm.storeUrl" name="storeUrl" required="" class="form-control" placeholder="Store URL"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.storeUrl.$error.required">Please enter store url.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="autoRefreshTime" class="col-sm-4 control-label">Auto Refresh Time(Sec)<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="autoRefreshTime" limit-to="5" is-number-key="" type="text" ng-model="vm.autoRefreshTime" ng-maxlength="5" name="autoRefreshTime" required="" class="form-control" placeholder="Auto Refresh Time"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.autoRefreshTime.$error.required">Please enter auto refresh time.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="autoImportTime" class="col-sm-4 control-label">Auto Import Time(Sec)<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="autoImportTime" limit-to="5" is-number-key="" type="text" ng-model="vm.autoImportTime" ng-maxlength="5" name="autoImportTime" required="" class="form-control" placeholder="Auto Import Time"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.autoImportTime.$error.required">Please enter auto import time.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="storeToken" class="col-sm-4 control-label">Token</label><div class="col-sm-8"><textarea id="storeToken" disabled="" ng-model="vm.storeToken" name="storeToken" class="form-control" placeholder="Enter Token" style="position:relative"></textarea> <i class="fa fa-copy fa-lg" title="Copy Token" clipboard="" text="vm.storeToken" on-copied="success(\'Token\')" on-error="fail(err)" style="position: absolute;right: 20px;bottom: 8px;cursor: pointer;"></i></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="relay_api_key" class="col-sm-4 control-label">Relay API Key <span class="asterisk_input"></span></label><div class="col-sm-8" style="position:relative"><textarea id="relay_api_key" ng-model="vm.relay_api_key" required="" name="relay_api_key" class="form-control" placeholder="Enter Relay API Key" style="position:relative"></textarea> <span class="error" ng-show="storeFrm.$submitted && storeFrm.relay_api_key.$error.required">Please enter relay api key.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="userName" class="col-sm-4 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-8" style="position:relative"><input id="userName" type="text" ng-model="vm.userName" ng-disabled="vm.storeId" required="" limit-to="20" ng-maxlength="20" name="userName" class="form-control" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/"> <i class="fa fa-copy fa-lg" ng-if="vm.storeId" title="Copy User Name" clipboard="" text="vm.userName" on-copied="success(\'User Name\')" on-error="fail(err)" style="position: absolute;right: 20px;top: 10px;cursor: pointer;"></i> <span class="error" ng-show="storeFrm.$submitted && storeFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="storeFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="storeFrm.userName.$error.maxlength && storeFrm.userName.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="service" class="col-sm-4 control-label">Default Service <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.service" class="form-control" name="service" id="service" required=""><option value="">Select Service</option><option value="fedex">Fedex</option><option value="usps">USPS</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="accountFedex" class="col-sm-4 control-label">Fedex Account <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.accountFedex" class="form-control" name="accountFedex" id="accountFedex" required=""><option value="">Select Account</option><option value="{{ item.account_id }}" ng-repeat="(index, item) in accounts" ng-if="item.account_service==\'fedex\'">{{ item.account_company_name }} ({{ item.account_number}})</option></select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="accountUsps" class="col-sm-4 control-label">USPS Account <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.accountUsps" class="form-control" name="accountUsps" id="accountUsps" required=""><option value="">Select Account</option><option value="{{ item.account_id }}" ng-repeat="(index, item) in accounts" ng-if="item.account_service==\'usps\'">{{ item.account_company_name }} ({{ item.account_number}})</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="ciproductsetting" class="col-sm-4 control-label">Commercial Invoice Setting <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.ciproductsetting" class="form-control" name="ciproductsetting" id="ciproductsetting" required=""><option value="">Select Setting</option><option value="product_name">Product Name only</option><option value="product_description">Product Description only</option><option value="product_name_description">Product Name and Description Both</option></select></div></div></div><div class="col-md-6"><div class="form-group row"><label for="shipmentPopup" class="col-sm-4 control-label">Display Popup</label><div class="col-sm-8"><ba-switcher switcher-style="primary" switcher-value="vm.shipmentPopup" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.amazon-stores" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.storeId"></form></div></div>');
$templateCache.put('app/pages/settings/amazonStores/amazonStoreProducts.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/amazonStores/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteStore()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/amazonStores/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/amazonStores/store.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'store_add\') !== - 1" ng-click="addStore()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/appSettings/appSettings.html','<div class="widgets profile faqfrontend" ba-panel="" ba-panel-title="Global App Settings" ng-init="debug=0;cycle1=\'yes\';cycle2=\'yes\';cycle3=\'yes\';globalSearchCycle=\'yes\';displayDisableIcons=\'yes\'"><div ng-init="getSettings()"><div ng-show="isloaded"><form class="form-horizontal" name="settingFrm" novalidate="" ng-submit="settingFrm.$valid && saveSettings()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-5 control-label">Logo</label><div class="col-sm-7"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Logo</a> <input type="file" ng-show="false" name="FileUploadLogo" id="uploadFile" ng-file-select="onFileSelect($files)" fileread="file"></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.email.$error.required || settingFrm.email.$error.pattern) && settingFrm.email.$touched}"><label for="inputEmail3" class="col-sm-5 control-label">From Email Address <span class="asterisk_input"></span></label><div class="col-sm-7"><input id="email" type="email" maxlength="35" ng-model="email" name="email" required="" class="form-control" placeholder="From Email Address" ng-pattern="/^[a-z]+[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{2,5}$/"> <span class="error" ng-show="settingFrm.$submitted && settingFrm.email.$error.required">Please enter from email.</span> <span class="error" ng-show="settingFrm.email.$error.pattern">Please enter valid email.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.cemail.$error.required || settingFrm.cemail.$error.pattern) && settingFrm.cemail.$touched}"><label for="cemail" class="col-sm-5 control-label">Contact Email Address <span class="asterisk_input"></span></label><div class="col-sm-7"><input id="cemail" maxlength="35" type="email" ng-model="cemail" name="cemail" required="" class="form-control" placeholder="Contact Email Address" ng-pattern="/^[a-z]+[a-zA-Z0-9._+]+@[a-zA-Z0-9]+\\.[a-z.]{2,5}$/"> <span class="error" ng-show="settingFrm.$submitted && settingFrm.cemail.$error.required">Please enter contact email.</span> <span class="error" ng-show="settingFrm.cemail.$error.pattern">Please enter valid email.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.dashboardTime.$error.required || settingFrm.dashboardTime.$error.maxlength) && settingFrm.dashboardTime.$touched}"><label for="dashboardTime" class="col-sm-5 control-label">Dashboard Interval Time (M)<span class="asterisk_input"></span></label><div class="col-sm-7"><input id="dashboardTime" limit-to="3" is-number-key="" min="1" type="number" ng-model="dashboardTime" ng-maxlength="5" name="dashboardTime" required="" class="form-control" placeholder="Dashboard API Call Intervel Time"> <span class="error" ng-show="settingFrm.$submitted && settingFrm.dashboardTime.$error.required">Please enter dashboard interval time.</span> <span class="error" ng-show="settingFrm.dashboardTime.$error.maxlength && settingFrm.dashboardTime.$touched">Time should not be greater than 5 digit.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.orderTime.$error.required || settingFrm.orderTime.$error.maxlength || settingFrm.orderTime.$error.minlength) && settingFrm.orderTime.$touched}"><label for="orderTime" class="col-sm-5 control-label">Orders Interval Time (M)<span class="asterisk_input"></span></label><div class="col-sm-7"><input id="orderTime" limit-to="3" is-number-key="" min="1" type="number" ng-model="orderTime" ng-maxlength="3" name="orderTime" required="" class="form-control" placeholder="Orders API Call Intervel Time"> <span class="error" ng-show="settingFrm.$submitted && settingFrm.orderTime.$error.required">Please enter order interval time.</span> <span class="error" ng-show="settingFrm.orderTime.$error.maxlength && settingFrm.orderTime.$touched">Time should not be greater than 3 digit.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.record.$error.required || settingFrm.record.$error.maxlength) && settingFrm.record.$touched}"><label for="record" class="col-sm-5 control-label">No. of Records in pagination <span class="asterisk_input"></span></label><div class="col-sm-7"><select id="record" class="form-control" ng-model="record" name="record" required=""><option value="">Select No. of Records</option><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select><span class="error" ng-show="settingFrm.$submitted && settingFrm.record.$error.required">Please select record.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.dateFormate.$error.required || settingFrm.dateFormate.$error.maxlength) && settingFrm.dateFormate.$touched}"><label for="dateFormate" class="col-sm-5 control-label">Date Format<span class="asterisk_input"></span></label><div class="col-sm-7"><select id="selected" class="form-control roleData" ng-model="selected"><option ng-repeat="(key,formate) in dateTimeFormate" value="{{key}}">{{formate}}</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.defaultSort.$error.required || settingFrm.defaultSort.$error.maxlength) && settingFrm.defaultSort.$touched}"><label for="record" class="col-sm-5 control-label">Orders Default Sort Column<span class="asterisk_input"></span></label><div class="col-sm-7"><select id="defaultSort" class="form-control" ng-model="defaultSort" name="defaultSort" required=""><option value="">Select Column</option><option value="2">Order Number</option><option value="3">Order From</option><option value="4">Order To</option><option value="5">Total Quantity</option><option value="6">Order Amount</option><option value="7">Order Status</option><option value="8">Order Date</option></select><span class="error" ng-show="settingFrm.$submitted && settingFrm.defaultSort.$error.required">Please select manage order default sort column.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': settingFrm.debug.$error.required && settingFrm.debug.$touched}"><label for="debug" class="col-sm-5 control-label">Debug Mode <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input id="debug" required="" ng-model="debug" type="radio" name="debug" value="1"> <span>On</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="debug" type="radio" name="debug" id="inlineRadio2" value="0"> <span>Off</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.debug.$error.required">Please select debug mode.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': settingFrm.cycle1.$error.required && settingFrm.cycle1.$touched}"><label for="cycle1" class="col-sm-5 control-label">Cycle 1 - (Sun,Mon) <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle1" type="radio" name="cycle1" id="cycle1Rdo1" value="yes"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle1" type="radio" name="cycle1" id="cycle1Rdo2" value="no"> <span>No</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.cycle1.$error.required">Please select cycle 1.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': settingFrm.cycle2.$error.required && settingFrm.cycle2.$touched}"><label for="cycle2" class="col-sm-5 control-label">Cycle 2 - (Tue,Wed) <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle2" type="radio" name="cycle2" id="cycle2Rdo1" value="yes"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle2" type="radio" name="cycle2" id="cycle2Rdo2" value="no"> <span>No</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.cycle2.$error.required">Please select cycle 2.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': settingFrm.cycle3.$error.required && settingFrm.cycle3.$touched}"><label for="cycle3" class="col-sm-5 control-label">Cycle 3 - (Thu,Fri,Sat) <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle3" type="radio" name="cycle3" id="cycle3Rdo1" value="yes"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle3" type="radio" name="cycle3" id="cycle3Rdo2" value="no"> <span>No</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.cycle3.$error.required">Please select cycle 3.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': settingFrm.cycle4.$error.required && settingFrm.cycle4.$touched}"><label for="cycle3" class="col-sm-5 control-label">Cycle 4 - (60, 2) <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle4" type="radio" name="cycle4" id="cycle4Rdo1" value="yes"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="cycle4" type="radio" name="cycle4" id="cycle4Rdo2" value="no"> <span>No</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.cycle4.$error.required">Please select cycle 4.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="globalSearchCycleRdo1" class="col-sm-5 control-label">Global Search Cycle <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="globalSearchCycle" type="radio" name="globalSearchCycle" id="globalSearchCycleRdo1" value="yes"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="globalSearchCycle" type="radio" name="globalSearchCycle" id="globalSearchCycleRdo2" value="no"> <span>No</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.globalSearchCycle.$error.required">Please select global search cycle.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (settingFrm.productDefaultSort.$error.required || settingFrm.productDefaultSort.$error.maxlength) && settingFrm.productDefaultSort.$touched}"><label for="record" class="col-sm-5 control-label">Products Default Sort Column<span class="asterisk_input"></span></label><div class="col-sm-7"><select id="productDefaultSort" class="form-control" ng-model="productDefaultSort" name="productDefaultSort" required=""><option value="">Select Column</option><option value="1">Product Number</option><option value="2">Order From</option><option value="3">Order To</option><option value="4">Product Status</option><option value="5">Order Date</option></select><span class="error" ng-show="settingFrm.$submitted && settingFrm.productDefaultSort.$error.required">Please select manage order default sort column.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="record" class="col-sm-5 control-label">Change Message Position</label><div class="col-sm-7"><select id="messagePosition" class="form-control" ng-model="messagePosition" name="messagePosition"><option value="toast-top-right">Top Right</option><option value="toast-bottom-right">Bottom Right</option><option value="toast-top-left">Top Left</option><option value="toast-bottom-left">Bottom Left</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="displayDisabledIcons" class="col-sm-5 control-label">Display Disable Icons <span class="asterisk_input"></span></label><div class="col-sm-7"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="displayDisableIcons" type="radio" name="displayDisableIcons" id="displayDisableIcons1" value="yes"> <span>Yes</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="displayDisableIcons" type="radio" name="displayDisableIcons" id="displayDisableIcons2" value="no"> <span>No</span></label> <span class="error" ng-show="settingFrm.$submitted && settingFrm.displayDisableIcons.$error.required">Display Disable Icons.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="userId"></form></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div>');
$templateCache.put('app/pages/settings/buttonSetting/buttonSetting.html','<div class="widgets profile shipping-tracker" ba-panel=""><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addEditBtnStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-6" style="margin-bottom: 20px;"><div class="form-group row clearfix"><label for="showOnStatusId" class="col-sm-4 control-label" style="font-size:20px;padding: 20px;">Change status to<span class="asterisk_input"></span></label><div class="col-sm-8" style="padding: 15px;"><ui-select class="form-control" multiple="" ng-model="multipleDemo.selectedPeople" ng-disabled="false" search-enabled="true" append-to-body="true" theme="bootstrap" sortable="true" close-on-select="true" style="width: 800px;"><ui-select-match placeholder="Select Status" class="dipesh">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="person in vm.orderStatus | filter: $select.search"><div ng-bind-html="person.status_label | highlight: $select.search"></div></ui-select-choices></ui-select></div></div></div></div><div class="row" ng-init="getStatusAndEditBtnData()"><div class="col-md-4"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll shipping-inner-panel"><div class="add-fix-height-for-status" style="height: 500px;"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="vm.orderStatus"><tr ng-repeat="status in vm.orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight + \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{sts.name}}" ba-panel-class="light-text with-scroll shipping-inner-panel" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="sts.status"><tr ng-if="sts.status.length == 0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}} <a ng-click="removeStatus(item, sts.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addEditBtnStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n    #status .panel.with-scroll .panel-body{\n        max-height: {{statusHeight}}px;\n    }\n</style>');
$templateCache.put('app/pages/settings/buttonType/addButtonType.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedButtonType()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="buttonTypeFrm" novalidate="" ng-submit="buttonTypeFrm.$valid && saveButtonTypeData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (buttonTypeFrm.buttonType.$error.required || buttonTypeFrm.buttonType.$error.pattern || buttonTypeFrm.buttonType.$error.maxlength) && buttonTypeFrm.buttonType.$touched}"><label for="buttonType" class="col-sm-4 control-label">Button Type <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="buttonType" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.buttonType" name="buttonType" required="" ng-pattern="/^[a-z_-\\s]+$/i" class="form-control" placeholder="Button Type"> <span class="error" ng-show="buttonTypeFrm.$submitted && buttonTypeFrm.buttonType.$error.required">Please enter button type.</span> <span class="error" ng-show="buttonTypeFrm.buttonType.$error.pattern">Button Type contains only characters,space, "_" and "-" value.</span> <span class="error" ng-show="!buttonTypeFrm.buttonType.$error.pattern && buttonTypeFrm.buttonType.$error.maxlength && buttonTypeFrm.buttonType.$touched">Button Type should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="buttonTypeFrm.$submitted && buttonTypeFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.button-type" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="buttonTypeId"></form></div></div>');
$templateCache.put('app/pages/settings/buttonType/buttonType.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'button_type_add\') !== - 1" ng-click="addButtonType()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/buttonType/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteButtonType()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/buttonType/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/category/addCategory.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedCategory()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="categoryFrm" novalidate="" ng-submit="categoryFrm.$valid && saveCategoryData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (categoryFrm.category.$error.required || categoryFrm.category.$error.pattern || categoryFrm.category.$error.maxlength) && categoryFrm.category.$touched}"><label for="category" class="col-sm-4 control-label">Category Label<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="category" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.category" name="category" required="" ng-pattern="/^[a-z_-\\s]+$/i" class="form-control" placeholder="Category Label"> <span class="error" ng-show="categoryFrm.$submitted && categoryFrm.category.$error.required">Please enter category label.</span> <span class="error" ng-show="categoryFrm.category.$error.pattern">Category label contains only characters, space, "_" and "-" value.</span> <span class="error" ng-show="!categoryFrm.category.$error.pattern && categoryFrm.category.$error.maxlength && categoryFrm.category.$touched">Category should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="categoryFrm.$submitted && categoryFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.category" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="categoryId"></form></div></div>');
$templateCache.put('app/pages/settings/category/category.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'category_add\') !== - 1" ng-click="addCategory()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/category/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteCategory()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/category/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/damageSetting/damageSetting.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="reason.set_default=\'0\';sol.set_default=\'0\';"><div ng-init="getDamageSettingData()"><form class="form-horizontal" name="damageSettingFrm" novalidate="" ng-submit="submittedFrm = true"><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="damageSettingFrm.$valid && saveDamageSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Damage Order Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Available Status for Damage Crystal</label><div class="col-md-4"><ui-select multiple="" ng-model="vm.availableOrderStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="availableOrderStatus" id="availableOrderStatus"><ui-select-match placeholder="Available Status for Damage Crystal">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_label as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Damage Reason</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Add Damage Reason</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Damage Reason</th><th class="width-45-per">Set As Default</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'damage_reason\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.damageReason.length > 0" ng-repeat="reason in vm.damageReason" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12"><input type="text" ng-model="reason.name" name="reason{{$index}}" required="" class="form-control height28px" placeholder="Damage Reason" id="itemTitleReason-{{$index}}"> <span class="error" ng-show="submittedFrm && damageSettingFrm[\'reason\' +$index].$error.required">Please enter Damage reason.</span></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12"><select class="form-control roleData" ng-model="reason.set_default" name="reasonDefault{{$index}}" id="itemDefaultReason-{{$index}}"><option value="0" selected="">No Action</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'damage_reason\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.damageReason.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="damageSettingFrm.$valid && saveDamageSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/settings/damageSetting/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/dashboardBlocks/addBlock.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\';blockType=\'none\'"><div class="panel-content" ng-init="getEditedBlock()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="blockFrm" novalidate="" ng-submit="blockFrm.$valid && saveBlockData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (blockFrm.block.$error.required || blockFrm.block.$error.pattern || blockFrm.block.$error.maxlength) && blockFrm.block.$touched}"><label for="blockFrm" class="col-sm-4 control-label">Block Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="block" limit-to="25" ng-maxlength="25" type="text" ng-model="block" name="block" required="" class="form-control" placeholder="Block Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="blockFrm.$submitted && blockFrm.block.$error.required">Please enter block name.</span> <span class="error" ng-show="blockFrm.block.$error.pattern">Please enter valid block name.</span> <span class="error" ng-show="!blockFrm.block.$error.pattern && blockFrm.block.$error.maxlength && blockFrm.block.$touched">block name should not be greater than 25 characters</span></div></div></div></div><div ng-init="getTypeMaster()" class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="type master" class="col-sm-4 control-label">Main Type<span class="asterisk_input"></span></label><div class="col-sm-8"><select required="" class="form-control ng-pristine ng-untouched ng-empty ng-invalid ng-invalid-required" name="mainType" ng-change="setAddOnType(mainType)" ng-model="mainType"><option value="">Select Main Type</option><option value="none">None</option><option value="{{type.name}}" ng-repeat="type in typeData">{{type.name}}</option></select><span class="error" ng-show="blockFrm.$submitted && blockFrm.mainType.$error.required">Please select main type.</span></div></div></div></div><div ng-init="getTypeMaster()" class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="type master" class="col-sm-4 control-label">Add On Type</label><div class="col-sm-8"><ui-select multiple="" name="blockType" ng-model="model.blockType" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Select Add On Type">{{$item.name}}</ui-select-match><ui-select-choices repeat="multipleItem.name as multipleItem in typeMultiSelectData | filter: $select.search">{{multipleItem.name}}</ui-select-choices></ui-select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="date" class="col-sm-4 control-label">Date</label><div class="col-sm-8"><select ng-model="date" id="date" name="date" class="form-control"><option value="">Default Date</option><option value="{{dates}}" ng-repeat="(key,dates) in dateList">{{dates}} Days</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="blockFrm.$submitted && blockFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row" ng-if="blockId"><div class="col-md-12"><div class="form-group row clearfix"><label for="status" class="col-md-2 control-label">Block Status<span>&nbsp;</span></label><div class="col-md-6"><div ui-sref="settings.assign-status" class="panel panel-blur bootstrap-panel xsmall-panel cur-pntr" style="overflow-y:auto;padding: 15px 22px;"><div class="tag" ng-repeat="(key,item) in statusList"><span ng-if="key" style="background-color:{{item}};" class="status-label">{{key}}</span></div></div></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.blocks" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="blockId"></form></div></div>');
$templateCache.put('app/pages/settings/dashboardBlocks/assignStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.blocks" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addBlockStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-4" ng-init="getStatusAndBlockData()"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableCloneOptions" data-ng-model="orderStatus"><tr ng-repeat="item in orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}}</span></td></tr></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ng-repeat="dept in set"><div ba-panel="" ba-panel-title="{{dept._id.block}}" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableOptions" data-ng-model="dept.status"><tr ng-if="dept.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in dept.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-if="item.status_label != \'\'" ng-style="{\'background-color\':item.color_code};" class="status-label cursor"><i ng-if="item.is_active == 1" title="Active" class="fa fa-check-square" aria-hidden="true"></i> <i ng-if="item.is_active == 0" title="In Active" class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{item.status_label}} <a ng-click="removeBlockStatus(item,dept.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span> <span ng-if="item.status_label == \'\'">&nbsp;</span></td></tr></table></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.blocks" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addBlockStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/dashboardBlocks/blockOrder.html','<div class="row role-permission"><span class="col-sm-12 mb-10">Set Block Order by Just dragging Dashboard block up-down.</span><div class="col-sm-12 col-xs-12 col-md-6" ng-init="getActiveBlockData()"><div class="column"><div id="faq-order" ba-panel="" ba-panel-title="Set Dashboard Block Order" ba-panel-class="light-text with-scroll"><table ng-show="isloaded" class="table border-none permission-table"><tbody as-sortable="sortableBlockOptions" ng-model="blockOrder"><tr ng-if="blockOrder.length>0" ng-repeat="block in blockOrder" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><div class="status-label" ng-bind="block.name"></div></td></tr><tr ng-if="blockOrder.length<=0"><td>No data</td></tr></tbody></table><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveBlockOrder()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.blocks" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #faq-order .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/dashboardBlocks/blocks.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'block_order\') !== -1" ui-sref="settings.blocks-order" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-sort"></i>Manage Block Order</button> <button ng-if="permissionArr.indexOf(\'assign_status\') !== - 1" ng-click="assignStatus()" type="button" class="btn btn-warning pull-right btn-with-icon mr-16"><i class="fa fa-list-alt"></i>Assign Status</button> <button ng-if="permissionArr.indexOf(\'block_add\') !== - 1" ng-click="addBlock()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/dashboardBlocks/deleteModal.html','<div class="modal-content" ng-controller="blocksCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteBlock()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/dashboardBlocks/statusModal.html','<div class="modal-content" ng-controller="blocksCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/dashboardSummery/dashboardSummery.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getActiveStatus();"><div ng-init="getDashboardSummeryData()"><form class="form-horizontal" name="dashboardFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="dashboardFrm.$valid && saveDashbordSummery()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Order in Design Status</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="designStatus" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.designStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="designStatus" id="designStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Production Status Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="productionStatus" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.productionStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="productionStatus" id="productionStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Customer Shipping Status Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="shippingStatus" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.shippingStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="shippingStatus" id="shippingStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Mall Shipping Status Settings</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row"><label for="mallShippingStatus" class="col-sm-3 control-label">Status</label><div class="col-sm-9"><ui-select multiple="" ng-model="vm.mallShippingStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="mallShippingStatus" id="mallShippingStatus"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="dashboardFrm.$valid && saveDashbordSummery()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div></div>');
$templateCache.put('app/pages/settings/databaseStatusMap/databaseStatusMap.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getDatabaseSettingData();getActiveStatus()"><form class="form-horizontal" name="settingFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="settingFrm.$valid && saveDatabaseSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Express</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-2 control-label">Map Statuses</label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Database Status</th><th class="width-45-per">Order Status</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i> Add New</button></th></tr></thead><tr ng-if="vm.mapExpressStatusList.length > 0" ng-repeat="map in vm.mapExpressStatusList" class="editable-row"><td><select class="form-control height28px" ng-model="map.database_status" name="relayStatus{{$index}}" id="relayStatus-{{$index}}" required=""><option value="">Database Status</option><option value="{{status.status_name}}" ng-repeat="status in vm.databaseStatusList">{{status.status_name}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'relayStatus\' +$index].$error.required">Please select relay status.</span></td><td><select class="form-control height28px" ng-model="map.order_status" name="orderStatus{{$index}}" id="orderStatus-{{$index}}" required=""><option value="">Order Status</option><option value="{{status.status_code}}" ng-repeat="status in vm.orderStatus">{{status.status_label}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'orderStatus\' +$index].$error.required">Please select order status.</span></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.mapExpressStatusList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Regular</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-2 control-label">Map Statuses</label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Database Status</th><th class="width-45-per">Order Status</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'regular\')"><i class="ion-android-checkmark-circle"></i> Add New</button></th></tr></thead><tr ng-if="vm.mapRegularStatusList.length > 0" ng-repeat="map in vm.mapRegularStatusList" class="editable-row"><td><select class="form-control height28px" ng-model="map.database_status" name="relayStatusReg{{$index}}" id="relayStatusReg-{{$index}}" required=""><option value="">Database Status</option><option value="{{status.status_name}}" ng-repeat="status in vm.databaseStatusList">{{status.status_name}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'relayStatusReg\' +$index].$error.required">Please select relay status.</span></td><td><select class="form-control height28px" ng-model="map.order_status" name="orderStatusReg{{$index}}" id="orderStatusReg-{{$index}}" required=""><option value="">Order Status</option><option value="{{status.status_code}}" ng-repeat="status in vm.orderStatus">{{status.status_label}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'orderStatusReg\' +$index].$error.required">Please select order status.</span></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'regular\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.mapRegularStatusList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Rework</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-2 control-label">Map Statuses</label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Database Status</th><th class="width-45-per">Order Status</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'rework\')"><i class="ion-android-checkmark-circle"></i> Add New</button></th></tr></thead><tr ng-if="vm.mapReworkStatusList.length > 0" ng-repeat="map in vm.mapReworkStatusList" class="editable-row"><td><select class="form-control height28px" ng-model="map.database_status" name="relayStatusRew{{$index}}" id="relayStatusRew-{{$index}}" required=""><option value="">Database Status</option><option value="{{status.status_name}}" ng-repeat="status in vm.databaseStatusList">{{status.status_name}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'relayStatusRew\' +$index].$error.required">Please select relay status.</span></td><td><select class="form-control height28px" ng-model="map.order_status" name="orderStatusRew{{$index}}" id="orderStatusRew-{{$index}}" required=""><option value="">Order Status</option><option value="{{status.status_code}}" ng-repeat="status in vm.orderStatus">{{status.status_label}}</option></select><span class="error" ng-show="webhookFrm.$submitted && webhookFrm[\'orderStatusRew\' +$index].$error.required">Please select order status.</span></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'rework\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.mapReworkStatusList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="settingFrm.$valid && saveDatabaseSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div>');
$templateCache.put('app/pages/settings/databaseStatusMap/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/departments/addDepartment.html','<div ba-panel="" ng-init="status=\'1\';deptType=\'none\'"><div class="panel-content" ng-init="getEditedDepartment()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="departmentFrm" novalidate="" ng-submit="departmentFrm.$valid && saveDepartmentData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (departmentFrm.department.$error.required || departmentFrm.department.$error.pattern || departmentFrm.department.$error.maxlength) && departmentFrm.department.$touched}"><label for="departmentFrm" class="col-sm-4 control-label">Department Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="department" limit-to="20" ng-maxlength="20" type="text" ng-model="department" name="department" required="" class="form-control" placeholder="Department Name" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="departmentFrm.$submitted && departmentFrm.department.$error.required">Please enter department name.</span> <span class="error" ng-show="departmentFrm.department.$error.pattern">Please enter valid department name.</span> <span class="error" ng-show="!departmentFrm.department.$error.pattern && departmentFrm.department.$error.maxlength && departmentFrm.department.$touched">department name should not be greater than 20 characters</span></div></div></div></div><div class="row" ng-init="getDepartmentIconList()"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (departmentFrm.deptIcon.$error.required && departmentFrm.deptIcon.$touched)}"><label for="deptIcon" class="col-sm-4 control-label">Department Icon <span class="asterisk_input"></span></label><div class="col-sm-8"><select id="deptIcon" class="form-control selectpicker" selectpicker="" ng-model="departmentIcon" name="deptIcon" required=""><option value="">Select Icon</option><option ng-repeat="(key,icon) in departmentIconList" value="{{key}}" data-icon="{{key}}">{{icon}}</option></select><span class="error" ng-show="departmentFrm.$submitted && departmentFrm.deptIcon.$error.required">Please select department icon.</span></div></div></div></div><div class="row" ng-if="departmentIcon"><div class="col-md-6"><div class="form-group row"><label class="col-sm-4 control-label">Preview</label><div class="col-sm-8 col-md-4"><div class="dept-icon"><i class="{{departmentIcon}} fa-3x" aria-hidden="true"></i> <span ng-bind="department"></span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="deptType" class="col-sm-4 control-label">Type</label><div class="col-sm-8"><select class="form-control" ng-model="deptType" name="deptType" id="deptType"><option value="none">Select Type</option><option value="is_regular">Regular</option><option value="is_customer">Customer</option><option value="is_express">Express</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="departmentFrm.$submitted && departmentFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row" ng-if="departmentId"><div class="col-md-12"><div class="form-group row clearfix"><label for="status" class="col-md-2 control-label">Department Status<span>&nbsp;</span></label><div class="col-md-6"><div ui-sref="settings.departments-status" class="panel panel-blur bootstrap-panel xsmall-panel cur-pntr" style="overflow-y:auto;padding: 15px 22px;"><div class="tag" ng-repeat="(key,item) in orderStatus"><span ng-if="key" style="background-color:{{item}};" class="status-label">{{key}}</span></div></div></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.departments" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="departmentId"></form></div></div>');
$templateCache.put('app/pages/settings/departments/deleteModal.html','<div class="modal-content" ng-controller="departmentsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteDepartment()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/departments/departmentStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.departments" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addDepartmentStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-4" ng-init="getStatusAndDepartmentData()"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableCloneOptions" data-ng-model="orderStatus"><tr ng-repeat="item in orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}}</span></td></tr></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ng-repeat="dept in set"><div ba-panel="" ba-panel-title="{{dept._id.block}}" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableOptions" data-ng-model="dept.status"><tr ng-if="dept.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in dept.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-if="item.status_label != \'\'" ng-style="{\'background-color\':item.color_code};" class="status-label cursor"><i ng-if="item.is_active == 1" title="Active" class="fa fa-check-square" aria-hidden="true"></i> <i ng-if="item.is_active == 0" title="In Active" class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{item.status_label}} <a ng-click="removeDepartmentStatus(item,dept.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span> <span ng-if="item.status_label == \'\'">&nbsp;</span></td></tr></table></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.departments" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addDepartmentStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/departments/departments.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'select_department\') !== - 1" ng-click="departmentsStatus()" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-list-alt"></i>Department Status</button> <button ng-if="permissionArr.indexOf(\'department_add\') !== - 1" ng-click="addDepartment()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/departments/statusModal.html','<div class="modal-content" ng-controller="departmentsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/documentSetting/documentSetting.html','<style>\n  .cke{\n    color:#000;\n  }\n</style><div ba-panel="" ba-panel-class="with-scroll" class="profile-page" ng-init="status=\'1\'"><div class="panel-content" ng-init="getDocumentSettingData()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="documentSettingFrm" novalidate="" ng-submit="documentSettingFrm.$valid && saveDocumentSettingData()"><div class="row"><div class="col-md-12"><div class="form-group row clearfix" ng-class="{\'has-error\':(documentSettingFrm.documentTitle.$error.required ||documentSettingFrm.documentTitle.$error.maxlength) && documentSettingFrm.documentTitle.$touched}"><label for="documentTitle" class="col-sm-2 control-label">Document Title <span class="asterisk_input"></span></label><div class="col-sm-10"><input type="text" limit-to="255" ng-maxlength="255" placeholder="Document Title" ng-model="documentTitle" class="form-control col-sm-10" name="documentTitle" required="" id="documentTitle"> <span class="error" ng-show="documentSettingFrm.$submitted && documentSettingFrm.documentTitle.$error.required">Please enter document title.</span> <span class="error" ng-show="documentSettingFrm.documentTitle.$error.maxlength && documentSettingFrm.documentTitle.$touched">Document Title should not be greater than 255 characters</span></div></div><div class="form-group row clearfix" ng-class="{\'has-error\': documentSettingFrm.description.$touched && documentSettingFrm.description.$error.required}"><label for="description" class="col-sm-2 control-label">Document Details <span class="asterisk_input"></span></label><div class="col-sm-10"><textarea placeholder="Description" ckeditor="editorOptions" ng-model="description" class="form-control col-sm-10" name="description" required="" id="description"></textarea> <span class="error" ng-show="documentSettingFrm.$submitted && documentSettingFrm.description.$error.required">Please enter description.</span></div></div><div class="form-group row clearfix"><label for="status" class="col-sm-2 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-10"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="documentSettingFrm.$submitted && documentSettingFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></form></div></div>');
$templateCache.put('app/pages/settings/faq/addFaq.html','<style>\n  .cke{\n    color:#000;\n  }\n</style><div ba-panel="" ba-panel-class="with-scroll" class="profile-page" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="vm.getFaqDataById()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="faqFrm" novalidate="" ng-submit="faqFrm.$valid && vm.saveFaq()"><div class="row"><div class="col-md-12"><div class="form-group row clearfix" ng-class="{\'has-error\': (faqFrm.question.$error.required || faqFrm.question.$error.maxlength) && faqFrm.question.$touched}"><label for="question" class="col-sm-2 control-label">FAQ Question <span class="asterisk_input"></span></label><div class="col-sm-10"><textarea limit-to="255" ng-maxlength="255" placeholder="FAQ Question" ng-model="vm.question" class="form-control col-sm-10" name="question" required="" id="FAQQuestion"></textarea> <span class="error" ng-show="faqFrm.$submitted && faqFrm.question.$error.required">Please enter FAQ Question.</span> <span class="error" ng-show="faqFrm.question.$error.maxlength && faqFrm.question.$touched">FAQ question should not be greater than 255 characters</span></div></div><div class="form-group row clearfix" ng-class="{\'has-error\': faqFrm.answer.$touched && faqFrm.answer.$error.required}"><label for="answer" class="col-sm-2 control-label">FAQ Answer <span class="asterisk_input"></span></label><div class="col-sm-10"><textarea placeholder="FAQ Answer" ckeditor="editorOptions" ng-model="vm.answer" class="form-control col-sm-10" name="answer" required="" id="FAQAnswer"></textarea> <span class="error" ng-show="faqFrm.$submitted && faqFrm.answer.$error.required">Please enter FAQ Answer.</span></div></div><div class="form-group row clearfix" ng-class="{\'has-error\': faqFrm.sortorder.$touched && faqFrm.sortorder.$error.required}"><label for="sortorder" class="col-sm-2 control-label">Sort Order <span class="asterisk_input"></span></label><div class="col-sm-10"><input type="number" is-number-key="" min="1" ng-model="vm.sortorder" class="form-control" placeholder="Sort Order" name="sortorder" required="" id="SortOrder"> <span class="error" ng-show="faqFrm.$submitted && faqFrm.sortorder.$error.required">Please enter Sort Order.</span></div></div><div class="form-group row clearfix"><label for="status" class="col-sm-2 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-10"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="faqFrm.$submitted && faqFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.faq" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a></form></div></div>');
$templateCache.put('app/pages/settings/faq/deleteModal.html','<div class="modal-content" ng-controller="faqCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="vm.deleteFaq()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/faq/faq.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'faq_order\') !== -1" ui-sref="settings.faq-order" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-sort"></i>Manage FAQ Order</button> <button ng-if="permissionArr.indexOf(\'faq_add\') !== -1" ng-click="vm.addFaq()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-init="getDataTable()"><table class="table table-bordered" datatable="" dt-options="vm.dtOptions" dt-columns="vm.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/faq/faqOrder.html','<div class="row"><span class="col-sm-12 text-right mb-10">Set FAQ Order by Just dragging FAQ question up-down.</span><div class="col-sm-12 col-xs-12 col-md-12" ng-init="getFaqData()"><div class="column"><div id="faq-order" ba-panel="" ba-panel-title="Set FAQ Order" ba-panel-class="light-text with-scroll"><table ng-show="isloaded" class="table border-none permission-table"><tbody as-sortable="sortableOptions" ng-model="vm.faq"><tr ng-if="vm.faq.length>0" ng-repeat="faq in vm.faq" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><div class="status-label" ng-bind-html="ellipsisQuestion(faq.question)"></div></td></tr><tr ng-if="vm.faq.length<=0"><td>No data</td></tr></tbody></table><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveFaqOrder()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.faq" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #faq-order .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/faq/statusModal.html','<div class="modal-content" ng-controller="faqCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="vm.changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/jobSetting/jobSetting.html','<div class="widgets profile faqfrontend" ba-panel=""><div ng-init="getJobSettingData()"><form class="form-horizontal" name="jobSettingFrm" novalidate="" ng-submit="submittedJobFrm = true"><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="jobSettingFrm.$valid && saveJobSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Open Job Button</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="OJvmExecutionCode" class="col-sm-4 control-label">VM Execution Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.OJvmExecutionCode" class="form-control" placeholder="VM Execution Code" name="OJvmExecutionCode" required="" id="OJvmExecutionCode"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.OJvmExecutionCode.$error.required">Please enter VM execution code.</span></div></div><div class="form-group row clearfix"><label for="OJfileLocation" class="col-sm-4 control-label">File Location <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.OJfileLocation" class="form-control" placeholder="File Location" name="OJfileLocation" required="" id="OJfileLocation"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.OJfileLocation.$error.required">Please enter file location.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Open Job DB Button</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="OJDBvmExecutionCode" class="col-sm-4 control-label">VM Execution Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.OJDBvmExecutionCode" class="form-control" placeholder="VM Execution Code" name="OJDBvmExecutionCode" required="" id="OJDBvmExecutionCode"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.OJDBvmExecutionCode.$error.required">Please enter VM execution code.</span></div></div><div class="form-group row clearfix"><label for="OJDBfileLocation" class="col-sm-4 control-label">File Location <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.OJDBfileLocation" class="form-control" placeholder="File Location" name="OJDBfileLocation" required="" id="OJDBfileLocation"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.OJDBfileLocation.$error.required">Please enter file location.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Create Job Button</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="CJvmExecutionCode" class="col-sm-4 control-label">VM Execution Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.CJvmExecutionCode" class="form-control" placeholder="VM Execution Code" name="CJvmExecutionCode" required="" id="CJvmExecutionCode"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.CJvmExecutionCode.$error.required">Please enter VM execution code.</span></div></div><div class="form-group row clearfix"><label for="CJfont" class="col-sm-4 control-label">Font <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.CJfont" class="form-control" placeholder="Font" name="CJfont" required="" id="CJfont"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.CJfont.$error.required">Please enter font name.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Create 2D Job Button</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="C2DJvmExecutionCode" class="col-sm-4 control-label">VM Execution Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.C2DJvmExecutionCode" class="form-control" placeholder="VM Execution Code" name="C2DJvmExecutionCode" required="" id="C2DJvmExecutionCode"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.C2DJvmExecutionCode.$error.required">Please enter VM execution code.</span></div></div><div class="form-group row clearfix"><label for="C2DJfont" class="col-sm-4 control-label">Font <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.C2DJfont" class="form-control" placeholder="Font" name="C2DJfont" required="" id="C2DJfont"> <span class="error" ng-show="submittedJobFrm && jobSettingFrm.C2DJfont.$error.required">Please enter font name.</span></div></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="jobSettingFrm.$valid && saveJobSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/settings/noyAssembly/noyAssembly.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getActiveStatus();"><div ng-init="getNoyAssemblySetting()"><form class="form-horizontal" name="noyAssemblyFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="saveNoyAssemblySetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Settings</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Noy Assembly Settings</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row"><label for="noyStatusAfterUpload" class="col-sm-5 control-label">Status After Scan Shipment</label><div class="col-sm-7"><select class="form-control" ng-model="vm.noyStatusAfterUpload" name="noyStatusAfterUpload" id="noyStatusAfterUpload"><option value="">Status After Scan Shipment</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Noy Regular Shipping / Assembly Shipping</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row"><label class="col-sm-5 control-label">Assembly Shipping / Regular Shipping</label><div class="col-sm-7"><ba-switcher switcher-style="primary" switcher-value="vm.noyAssemblyShipping" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="saveNoyAssemblySetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Settings</button></div></div></form></div></div>');
$templateCache.put('app/pages/settings/orderPopupButtons/addOrderPopupButton.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\'"><div class="panel-content" ng-init="getEditedOrderPopupButton();getActiveStatusData()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="buttonFrm" novalidate="" ng-submit="buttonFrm.$valid && saveOrderPopupButtonData()"><div class="row"><div class="col-md-6" ng-init="getActiveButtonType()"><div class="form-group row clearfix"><label for="btnType" class="col-sm-4 control-label">Button Type<span class="asterisk_input"></span></label><div class="col-sm-8"><select id="btnType" class="form-control" ng-model="buttonType" name="btnType" required=""><option value="">Select Button Type</option><option ng-repeat="btn in activeButtonType" value="{{btn.button_type}}">{{btn.button_type}}</option></select><span class="error" ng-show="buttonFrm.$submitted && buttonFrm.btnType.$error.required">Please select button type.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (buttonFrm.buttonName.$error.required || buttonFrm.buttonName.$error.pattern || buttonFrm.buttonName.$error.maxlength) && buttonFrm.buttonName.$touched}"><label for="buttonName" class="col-sm-4 control-label">Button Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="buttonName" limit-to="35" ng-maxlength="35" type="text" ng-model="buttonName" name="buttonName" required="" ng-pattern="/^[0-9a-z_-\\s]+$/i" class="form-control" placeholder="Button Name"> <span class="error" ng-show="buttonFrm.$submitted && buttonFrm.buttonName.$error.required">Please enter button name.</span> <span class="error" ng-show="buttonFrm.buttonName.$error.pattern">Please enter valid button name.</span> <span class="error" ng-show="!buttonFrm.buttonName.$error.pattern && buttonFrm.buttonName.$error.maxlength && buttonFrm.buttonName.$touched">Button name should not be greater than 35 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group clearfix" ng-class="{\'has-error\': (buttonFrm.buttonColor.$error.required || buttonFrm.buttonColor.$error.pattern || buttonFrm.buttonColor.$error.maxlength) && buttonFrm.buttonColor.$touched}"><label for="buttonColor" class="col-sm-4 control-label">Button Color <span class="asterisk_input"></span></label><div class="col-sm-8"><color-picker limit-to="7" ng-maxlength="7" event-api="eventApi" ng-model="buttonColor" options="options" name="buttonColor"></color-picker><span class="error" ng-show="buttonFrm.$submitted && buttonFrm.buttonColor.$error.required">Please enter order status color code.</span> <span class="error" ng-if="!buttonFrm.buttonColor.$error.required && pattern">Please enter valid button color code.</span> <span class="error" ng-show="buttonFrm.buttonColor.$error.maxlength && buttonFrm.buttonColor.$touched">Color code not be greater than 7 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="showOnStatusId" class="col-sm-4 control-label">Show on Status<span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" ng-model="showOnStatus.selectd" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect" name="showOnStatus" required="" id="showOnStatusId"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_label as status in orderStatusList | filter: $select.search">{{status.status_label}}</ui-select-choices></ui-select><span class="error" ng-show="buttonFrm.$submitted && buttonFrm.showOnStatus.$error.required">Please select show on status.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="onChangeStatusId" class="col-sm-4 control-label">On Click Change Status<span class="asterisk_input" ng-if="buttonType!=\'Order Log\' && buttonType!=\'Rework\'"></span></label><div class="col-sm-8"><select id="onChangeStatusId" class="form-control" ng-model="onChangeStatus" name="onChangeStatus" ng-disabled="buttonType==\'Order Log\' || buttonType==\'Rework\'" ng-required="buttonType!=\'Order Log\' && buttonType!=\'Rework\'"><option value="">Select Status</option><option ng-repeat="status in orderStatusList" value="{{status.status_code}}">{{status.status_label}}</option></select><span class="error" ng-show="buttonFrm.$submitted && buttonFrm.onChangeStatus.$error.required">Please select change status.</span> <span class="error" ng-show="onChangeStatus && showOnStatus==onChangeStatus">Status not same as show on status</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="buttonFrm.$submitted && buttonFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row" ng-show="buttonType==\'Print Sticker\'" ng-init="getStikerEnableType();"><div class="col-md-6"><div class="form-group row clearfix"><label for="btnType" class="col-sm-4 control-label">Order Type<span class="asterisk_input"></span></label><div class="col-sm-8"><select id="orderType" class="form-control" ng-model="orderType" name="orderType" ng-required="buttonType==\'Print Sticker\'"><option value="">Select Order Type</option><option value="{{type.name}}" ng-repeat="type in typeStickerData">{{type.name}}</option></select><span class="error" ng-show="buttonFrm.$submitted && buttonFrm.orderType.$error.required">Please select order type.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.order-popup-button" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="buttonId"></form></div></div>');
$templateCache.put('app/pages/settings/orderPopupButtons/buttonOrder.html','<div class="row role-permission"><span class="col-sm-12 mb-10">Set Button Order by Just dragging Popup Button up-down.</span><div class="col-sm-12 col-xs-12 col-md-6" ng-init="getActiveButtonData()"><div class="column"><div id="faq-order" ba-panel="" ba-panel-title="Set Dashboard Block Order" ba-panel-class="light-text with-scroll"><table ng-show="isloaded" class="table border-none permission-table"><tbody as-sortable="sortableButtonOptions" ng-model="buttonOrder"><tr ng-if="buttonOrder.length>0" ng-repeat="block in buttonOrder" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><div class="status-label" ng-bind="block.name"></div></td></tr><tr ng-if="buttonOrder.length<=0"><td>No data</td></tr></tbody></table><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveButtonOrder()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.order-popup-button" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #faq-order .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/orderPopupButtons/deleteModal.html','<div class="modal-content" ng-controller="orderPopupButtonsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteOrderPopupButton()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/orderPopupButtons/orderPopupButtons.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'button_sequence\') !== -1" ui-sref="settings.button-order" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-sort"></i>Manage Button Order</button> <button ng-if="permissionArr.indexOf(\'order_button_add\') !== - 1" ng-click="addOrderPopupButton()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/orderPopupButtons/statusModal.html','<div class="modal-content" ng-controller="orderPopupButtonsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/orderPopupEditBtn/orderPopupEditBtn.html','<div class="widgets profile shipping-tracker" ba-panel=""><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addEditBtnStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row" ng-init="getStatusAndEditBtnData()"><div class="col-md-4"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="vm.orderStatus"><tr ng-repeat="status in vm.orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{sts.name}}" ba-panel-class="light-text with-scroll shipping-inner-panel" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="sts.status"><tr ng-if="sts.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}} <a ng-click="removeStatus(item,sts.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addEditBtnStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/orderStatus/addOrderStatus.html','<div ba-panel="" ba-panel-class="with-scroll panel-height" ng-init="status=\'1\';"><div class="panel-content" ng-init="getEditedOrderStatus()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="orderStatusFrm" novalidate="" ng-submit="orderStatusFrm.$valid && saveOrderStatusData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (orderStatusFrm.orderStatusTitle.$error.required || orderStatusFrm.orderStatusTitle.$error.pattern || orderStatusFrm.orderStatusTitle.$error.maxlength) && orderStatusFrm.orderStatusTitle.$touched}"><label for="orderStatusTitle" class="col-sm-4 control-label">Order Status Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" limit-to="30" ng-maxlength="30" ng-model="orderStatusTitle" id="orderStatusTitle" name="orderStatusTitle" required="" class="form-control" placeholder="Order Status Title" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="orderStatusFrm.$submitted && orderStatusFrm.orderStatusTitle.$error.required">Please enter order status title.</span> <span class="error" ng-show="orderStatusFrm.orderStatusTitle.$error.pattern">Please enter valid order status title.</span> <span class="error" ng-show="!orderStatusFrm.orderStatusTitle.$error.pattern && orderStatusFrm.orderStatusTitle.$error.maxlength && orderStatusFrm.orderStatusTitle.$touched">Order status title should not be greater than 30 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (orderStatusFrm.orderStatusCode.$error.required || orderStatusFrm.orderStatusCode.$error.pattern || orderStatusFrm.orderStatusCode.$error.maxlength) && orderStatusFrm.orderStatusCode.$touched}"><label for="orderStatusCode" class="col-sm-4 control-label">Order Status Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" limit-to="50" ng-maxlength="50" ng-model="orderStatusCode" id="orderStatusCode" name="orderStatusCode" required="" class="form-control" placeholder="Order Status Code" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="orderStatusFrm.$submitted && orderStatusFrm.orderStatusCode.$error.required">Please enter order status code.</span> <span class="error" ng-show="orderStatusFrm.orderStatusCode.$error.pattern">Please enter valid order status code.</span> <span class="error" ng-show="!orderStatusFrm.orderStatusCode.$error.pattern && orderStatusFrm.orderStatusCode.$error.maxlength && orderStatusFrm.orderStatusCode.$touched">Order status code should not be greater than 50 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group clearfix" ng-class="{\'has-error\': (orderStatusFrm.orderStatusColorCode.$error.required || orderStatusFrm.orderStatusColorCode.$error.pattern || orderStatusFrm.orderStatusColorCode.$error.maxlength) && orderStatusFrm.orderStatusColorCode.$touched}"><label for="orderStatusColorCode" class="col-sm-4 control-label">Status Color Code <span class="asterisk_input"></span></label><div class="col-sm-8"><color-picker limit-to="7" ng-maxlength="7" event-api="eventApi" ng-model="orderStatusColorCode" options="options" name="orderStatusColorCode"></color-picker><span class="error" ng-show="orderStatusFrm.$submitted && orderStatusFrm.orderStatusColorCode.$error.required">Please enter order status color code.</span> <span class="error" ng-if="!orderStatusFrm.orderStatusColorCode.$error.required && pattern">Please enter valid status color code.</span> <span class="error" ng-show="orderStatusFrm.orderStatusColorCode.$error.maxlength && orderStatusFrm.orderStatusColorCode.$touched">Color code not be greater than 7 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': orderStatusFrm.status.$error.required && orderStatusFrm.status.$touched}"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio1" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="orderStatusFrm.$submitted && orderStatusFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status Category <span class="asterisk_input"></span></label><div class="col-sm-8"><select id="selected" class="form-control roleData" ng-model="orderStatusCategory" name="orderStatusCategory" required=""><option value="">Select Status Category</option><option ng-repeat="formOfTrans in statusCategory" value="{{formOfTrans.value}}">{{formOfTrans.label}}</option></select><span class="error" ng-show="orderStatusFrm.$submitted && orderStatusFrm.orderStatusCategory.$error.required">Please select order status category.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.order-status" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="orderStatusId"></form></div></div>');
$templateCache.put('app/pages/settings/orderStatus/deleteModal.html','<div class="modal-content" ng-controller="orderStatusCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteOrderStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/orderStatus/orderStatus.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'orderstatus_add\') !== - 1" ng-click="addOrderStatus()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/orderStatus/statusModal.html','<div class="modal-content" ng-controller="orderStatusCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/pieChart/addPie.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status = \'1\'"><div class="panel-content" ng-init="getEditedPie()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="pieChartFrm" novalidate="" ng-submit="pieChartFrm.$valid && savePieData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (pieChartFrm.pieChartLabel.$error.required || pieChartFrm.pieChartLabel.$error.pattern || pieChartFrm.pieChartLabel.$error.maxlength) && pieChartFrm.pieChartLabel.$touched}"><label for="pieChartLabel" class="col-sm-4 control-label">Pie Label<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="pieChartLabel" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.pieChartLabel" name="pieChartLabel" required="" ng-pattern="/^[a-z_-\\s]+$/i" class="form-control" placeholder="Pie Label"> <span class="error" ng-show="pieChartFrm.$submitted && pieChartFrm.pieChartLabel.$error.required">Please enter Pie label.</span> <span class="error" ng-show="pieChartFrm.pieChartLabel.$error.pattern">Pie label contains only characters, space, "_" and "-" value.</span> <span class="error" ng-show="!pieChartFrm.pieChartLabel.$error.pattern && pieChartFrm.pieChartLabel.$error.maxlength && pieChartFrm.pieChartLabel.$touched">Pie should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="getDashboardBlocks()"><div class="form-group row clearfix"><label for="dashboardBlock" class="col-sm-4 control-label">Dashboard Block <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select ng-model="vm.dashboardBlock" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" id="dashboardBlock" name="dashboardBlock" required=""><ui-select-match placeholder="Select Dashboard Block">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="sts.name as sts in vm.dashboardBlocksList | filter: $select.search"><span ng-bind-html="sts.name"></span></ui-select-choices></ui-select><span class="error" ng-show="pieChartFrm.$submitted && pieChartFrm.dashboardBlock.$error.required">Please select dashboard block.</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="getActiveStatusData()"><div class="form-group row clearfix"><label for="orderStatusId" class="col-sm-4 control-label">Select Closing Status <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select ng-model="vm.orderStatus" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" id="orderStatusId" name="orderStatus" required=""><ui-select-match placeholder="Select Closing Status">{{$select.selected.status_label}}</ui-select-match><ui-select-choices repeat="sts.status_code as sts in vm.orderStatusList | filter: $select.search"><span ng-bind-html="sts.status_label"></span></ui-select-choices></ui-select><span class="error" ng-show="pieChartFrm.$submitted && pieChartFrm.orderStatus.$error.required">Please select closing status.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-4 control-label">Sticker Settings</label><div class="col-sm-8"><ba-switcher switcher-style="primary" switcher-value="vm.createSticker" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row" ng-if="vm.createSticker"><div class="col-md-6" ng-init="getStikerEnableType()"><div class="form-group row clearfix"><label for="stickerType" class="col-sm-4 control-label">Select Sticker Type <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select ng-model="vm.stickertype" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" id="stickerType" name="stickertype" required=""><ui-select-match placeholder="Select Sticker Type">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="sts.name as sts in vm.enableStckerType | filter: $select.search"><span ng-bind-html="sts.name"></span></ui-select-choices></ui-select><span class="error" ng-show="pieChartFrm.$submitted && pieChartFrm.stickertype.$error.required">Please select sticker type.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="pieChartFrm.$submitted && pieChartFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.pie-chart" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="pieId"></form></div></div>');
$templateCache.put('app/pages/settings/pieChart/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deletePie()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/pieChart/pie.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'add_pie_chart\') !== -1" ng-click="addPie()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/pieChart/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/previewSetting/previewSetting.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init=""><div ng-init="getPreviewSettingData()"><form class="form-horizontal" name="previewSettingFrm" novalidate="" ng-submit="previewSettingFrm.$valid && savePreviewSettings()"><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row" ng-init="getActiveStatus()"><div class="col-md-12"><div class="form-group row"><label for="orderStatusRequestPreview" class="col-sm-3 control-label">Status after Request Preview <span class="asterisk_input"></span></label><div class="col-sm-6"><select name="orderStatusRequestPreview" id="orderStatusRequestPreview" ng-model="orderStatusRequestPreview" class="form-control" required=""><option value="">Please Select Status</option><option value="no-status-change">No Status Change</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select><span class="error" ng-show="previewSettingFrm.$submitted && previewSettingFrm.orderStatusRequestPreview.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="orderStatusAfterPreview" class="col-sm-3 control-label">Status after Preview <span class="asterisk_input"></span></label><div class="col-sm-6"><select name="orderStatusAfterPreview" id="orderStatusAfterPreview" ng-model="orderStatusAfterPreview" class="form-control" required=""><option value="">Please Select Status</option><option value="no-status-change">No Status Change</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select><span class="error" ng-show="previewSettingFrm.$submitted && previewSettingFrm.orderStatusAfterPreview.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="orderStatusAfterApprove" class="col-sm-3 control-label">Status after Approve Preview <span class="asterisk_input"></span></label><div class="col-sm-6"><select name="orderStatusAfterApprove" id="orderStatusAfterApprove" ng-model="orderStatusAfterApprove" class="form-control" required=""><option value="">Please Select Status</option><option value="no-status-change">No Status Change</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select><span class="error" ng-show="previewSettingFrm.$submitted && previewSettingFrm.orderStatusAfterApprove.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="orderStatusAfterReject" class="col-sm-3 control-label">Status after Disapprove Preview <span class="asterisk_input"></span></label><div class="col-sm-6"><select name="orderStatusAfterReject" id="orderStatusAfterReject" ng-model="orderStatusAfterReject" class="form-control" required=""><option value="">Please Select Status</option><option value="no-status-change">No Status Change</option><option ng-repeat="(key, val) in orderStatus" value="{{val.status_code}}">{{ val.status_label }}</option></select><span class="error" ng-show="previewSettingFrm.$submitted && previewSettingFrm.orderStatusAfterReject.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></form></div></div>');
$templateCache.put('app/pages/settings/printLabels/addPrintLabel.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="status=\'1\'"><div class="panel-content" ng-init="getEditedPrintLabel()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="printlabelFrm" novalidate="" ng-submit="printlabelFrm.$valid && savePrintLabelData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (printlabelFrm.printLabel.$error.required || printlabelFrm.printLabel.$error.pattern || printlabelFrm.printLabel.$error.maxlength) && printlabelFrm.printLabel.$touched}"><label for="printLabel" class="col-sm-4 control-label">Print Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="printLabel" limit-to="40" ng-maxlength="40" type="text" ng-model="printLabel" name="printLabel" required="" ng-pattern="/^[a-z_-\\s]+$/i" class="form-control" placeholder="Print Label"> <span class="error" ng-show="printlabelFrm.$submitted && printlabelFrm.printLabel.$error.required">Please enter print label.</span> <span class="error" ng-show="printlabelFrm.printLabel.$error.pattern">Print Label contains only characters,space, "_" and "-" value.</span> <span class="error" ng-show="!printlabelFrm.printLabel.$error.pattern && printlabelFrm.printLabel.$error.maxlength && printlabelFrm.printLabel.$touched">Print Label should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (printlabelFrm.printLabelValue.$error.required || printlabelFrm.printLabelValue.$error.pattern || printlabelFrm.printLabelValue.$error.maxlength) && printlabelFrm.printLabelValue.$touched}"><label for="printLabelValue" class="col-sm-4 control-label">Print Label Value<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="printLabelValue" limit-to="40" ng-maxlength="40" type="text" ng-model="printLabelValue" name="printLabelValue" required="" ng-pattern="/^[a-z\\-_]+$/i" class="form-control" placeholder="Print Label Value"> <span class="error" ng-show="printlabelFrm.$submitted && printlabelFrm.printLabelValue.$error.required">Please enter print label value.</span> <span class="error" ng-show="printlabelFrm.printLabelValue.$error.pattern">Print Label Value contains only characters, "_" and "-" value.</span> <span class="error" ng-show="!printlabelFrm.printLabelValue.$error.pattern && printlabelFrm.printLabelValue.$error.maxlength && printlabelFrm.printLabelValue.$touched">Print Label Value should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="printlabelFrm.$submitted && printlabelFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.print-labels" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="printLabelId"></form></div></div>');
$templateCache.put('app/pages/settings/printLabels/deleteModal.html','<div class="modal-content" ng-controller="printLabelsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deletePrintLabel()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/printLabels/printLabels.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'print_label_add\') !== - 1" ng-click="addPrintLabel()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/printLabels/statusModal.html','<div class="modal-content" ng-controller="printLabelsCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/product/addReportLabel.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedReportLabel();"><form class="form-horizontal" name="reportLabelFrm" novalidate="" ng-submit="reportLabelFrm.$valid && saveReportLabelData()"><div class="row"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>{{productTitle}}</span></uib-accordion-heading><div class="row"><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': (reportLabelFrm.reportLabel.$error.required || reportLabelFrm.reportLabel.$error.maxlength) && reportLabelFrm.reportLabel.$touched}"><label for="reportLabel" class="col-sm-4 control-label">Product Label <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="reportLabel" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.reportLabel" name="reportLabel" required="" class="form-control" placeholder="Product Label"> <span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm.reportLabel.$error.required">Please enter product label.</span> <span class="error" ng-show="!reportLabelFrm.reportLabel.$error.pattern && reportLabelFrm.reportLabel.$error.maxlength && reportLabelFrm.reportLabel.$touched">Product Label should not be greater than 40 characters</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix" ng-class="{\'has-error\': reportLabelFrm.SKU.$error.required && reportLabelFrm.SKU.$touched}"><label for="SKU" class="col-sm-4 control-label">SKU <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" tagging="" tagging-label="" ng-model="vm.SKU" search-enabled="true" sortable="true" title="Select SKU" required="" name="SKU" id="SKU" class="form-control multipleSelect"><ui-select-match placeholder="Select SKU">{{$item}}</ui-select-match><ui-select-choices repeat="sku in availableSKU | filter:$select.search">{{sku}}</ui-select-choices></ui-select><span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm.SKU.$error.required">Please enter sku.</span></div></div></div><div class="col-md-4"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm.status.$error.required">Please select status.</span></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Store Relay Upload</span></uib-accordion-heading><div class="row"><div class="col-sm-8"><table class="table table-bordered"><thead><tr><th>Store Name</th><th>Store Code</th><th class="width-10-per">Relay Upload</th><th class="width-15-per">Express Relay Upload</th></tr></thead><tbody><tr class="editable-row" ng-if="vm.stores_relay.length > 0" ng-repeat="sr in vm.stores_relay"><td>{{ sr.store_name }}</td><td>{{ sr.store_code }}</td><td><ba-switcher switcher-style="primary" switcher-value="sr.is_relay_upload" on-label="Yes" off-label="No" ng-click="changedefaultrelay($index,sr.store_id,sr.is_relay_upload)"></ba-switcher></td><td ng-if="sr.express_disbale==false"><ba-switcher switcher-style="primary" switcher-value="sr.express_relay_upload" on-label="Yes" off-label="No" ng-click="changeExpressRelay($index,sr.store_id,sr.express_relay_upload)"></ba-switcher></td><td ng-if="sr.express_disbale" class="text-center"><span class="label label-danger font-size-14 margin-inline">No</span></td></tr></tbody></table></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Relay Settings</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row"><label class="col-sm-6 control-label">Relay Upload</label><div class="col-sm-6"><ba-switcher switcher-style="primary" switcher-value="vm.isRelayUpload" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label class="col-sm-6 control-label">Orientation</label><div class="col-sm-6"><ba-switcher switcher-style="primary" switcher-value="vm.isOrientation" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div ng-if="vm.isOrientation==true" class="row form-group"><label for="label" class="col-md-2 control-label"></label><div class="col-md-9"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th>Orientation</th><th>Method</th><th>Preset Id</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem()"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.orientationList.length > 0" ng-repeat="orient in vm.orientationList" class="editable-row"><td><input only-caracter="" type="text" ng-model="orient.orientation" limit-to="30" ng-maxlength="30" name="orientation{{$index}}" required="" class="form-control height28px" placeholder="Orientation" id="orientation-{{$index}}"> <span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm[\'orientation\' +$index].$error.required">Please enter orientation.</span></td><td><select class="form-control height28px" ng-model="orient.method" name="method{{$index}}" id="method-{{$index}}" required=""><option value="">Select Method</option><option value="bounding_box">Bounding Box</option><option value="best_fit">Best Fit</option><option value="preset">Preset</option></select><span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm[\'method\' +$index].$error.required">Please select method.</span></td><td><input only-caracter="" type="text" ng-model="orient.preset_id" name="presetId{{$index}}" ng-required="orient.method==\'preset\'" class="form-control height28px" placeholder="Preset Id" id="presetId-{{$index}}"> <span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm[\'presetId\' +$index].$error.required">Please enter preset id.</span></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index)"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.orientationList.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div><div ng-if="vm.isOrientation==false" class="row"><div class="col-md-6"><div class="form-group row"><label for="method" class="col-sm-4 control-label">Method <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control" ng-model="vm.method" name="method" id="method" required=""><option value="">Select Method</option><option value="bounding_box">Bounding Box</option><option value="best_fit">Best Fit</option><option value="preset">Preset</option></select><span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm.method.$error.required">Please select method.</span></div></div></div><div class="col-md-6"><div class="form-group row"><label for="presetId" class="col-sm-4 control-label">Preset Id <span ng-if="vm.method==\'preset\'" class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.presetId" id="presetId" name="presetId" class="form-control" placeholder="Preset Id" ng-required="vm.method==\'preset\'"> <span class="error" ng-show="reportLabelFrm.$submitted && reportLabelFrm.presetId.$error.required">Please enter preset id.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label class="col-sm-6 control-label">Default Basic Settings</label><div class="col-sm-6"><ba-switcher switcher-style="primary" switcher-value="vm.basicSettings" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label class="col-sm-6 control-label">Send Basic Settings</label><div class="col-sm-6"><ba-switcher switcher-style="primary" switcher-value="vm.sendBasicSettings" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="distanceXY" class="col-sm-4 control-label">Distance XY</label><div class="col-sm-8"><div class="input-group mb-0px"><input type="text" is-number-key="" limit-to="5" ng-disabled="vm.basicSettings==true" ng-model="vm.distanceXY" id="distanceXY" name="distanceXY" class="form-control with-primary-addon" placeholder="Distance XY" aria-describedby="distance-xy"> <span class="input-group-addon input-group-addon-default addon-right" id="distance-xy">mm</span></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="distanceLayer" class="col-sm-4 control-label">Distance Layer</label><div class="col-sm-8"><div class="input-group mb-0px"><input type="text" is-number-key="" limit-to="5" ng-disabled="vm.basicSettings==true" ng-model="vm.distanceLayer" id="distanceLayer" name="distanceLayer" class="form-control" placeholder="Distance Layer" aria-describedby="distance-layer"> <span class="input-group-addon input-group-addon-default addon-right" id="distance-layer">mm</span></div></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="layerQuantity" class="col-sm-4 control-label">Layer Quantity</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.basicSettings==true" ng-model="vm.layerQuantity" id="layerQuantity" name="layerQuantity" class="form-control" placeholder="Layer Quantity"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="brightnessMultiplicator" class="col-sm-4 control-label">Brightness Multiplicator</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.basicSettings==true" ng-model="vm.brightnessMultiplicator" id="brightnessMultiplicator" name="brightnessMultiplicator" class="form-control" placeholder="Brightness Multiplicator"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="gainMultiplicator" class="col-sm-4 control-label">Gain Multiplicator</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.basicSettings==true" ng-model="vm.gainMultiplicator" id="gainMultiplicator" name="gainMultiplicator" class="form-control" placeholder="Gain Multiplicator"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="brightness" class="col-sm-4 control-label">Brightness</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.basicSettings==true" ng-model="vm.brightness" id="brightness" name="brightness" class="form-control" placeholder="Brightness"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="gain" class="col-sm-4 control-label">Gain</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.basicSettings==true" ng-model="vm.gain" id="gain" name="gain" class="form-control" placeholder="Gain"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="sharpness" class="col-sm-4 control-label">Sharpness</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.basicSettings==true" ng-model="vm.sharpness" id="sharpness" name="sharpness" class="form-control" placeholder="Sharpness"></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label class="col-sm-6 control-label">Default Text Settings</label><div class="col-sm-6"><ba-switcher switcher-style="primary" switcher-value="vm.textSettings" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label class="col-sm-6 control-label">Send Text Settings</label><div class="col-sm-6"><ba-switcher switcher-style="primary" switcher-value="vm.sendTextSettings" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="additionalLayers" class="col-sm-4 control-label">Additional Layers</label><div class="col-sm-8"><div class="row"><div class="col-md-6 col-sm-6"><input type="text" is-number-key="" ng-disabled="vm.textSettings==true" ng-model="vm.contour" id="contour" name="contour" class="form-control" placeholder="Contour"></div><div class="col-md-6 col-sm-6"><input type="text" is-number-key="" ng-disabled="vm.textSettings==true" ng-model="vm.cover" id="cover" name="cover" class="form-control" placeholder="Cover"></div></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="font" class="col-sm-4 control-label">Font</label><div class="col-sm-8"><select ng-model="vm.font" ng-disabled="vm.textSettings==true" id="font" name="font" class="form-control"><option value="">Select Font</option><option ng-style="{\'font-family\':font}" value="{{font}}" ng-repeat="(key,font) in fontList">{{font}}</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="size" class="col-sm-4 control-label">Size</label><div class="col-sm-8"><input type="text" is-number-key="" limit-to="4" ng-disabled="vm.textSettings==true" ng-model="vm.size" id="size" name="size" class="form-control" placeholder="Size"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="font" class="col-sm-4 control-label">Alignment</label><div class="col-sm-8"><select ng-model="vm.alignment" ng-disabled="vm.textSettings==true" id="alignment" name="alignment" class="form-control"><option value="">Select Alignment</option><option value="left">Left</option><option value="right">Right</option><option value="center">Center</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="rotateZ" class="col-sm-4 control-label">Rotate Z</label><div class="col-sm-8"><input type="text" is-number-key="" ng-disabled="vm.textSettings==true" ng-model="vm.rotateZ" id="rotateZ" name="rotateZ" class="form-control" placeholder="Rotate Z"></div></div></div><div class="col-md-6"><div class="form-group row"><label for="bold" class="col-sm-4 control-label">Bold</label><div class="col-sm-8"><ba-switcher switcher-style="primary" disable="vm.textSettings" switcher-value="vm.bold" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="italic" class="col-sm-4 control-label">Italic</label><div class="col-sm-8"><ba-switcher switcher-style="primary" disable="vm.textSettings" switcher-value="vm.italic" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group row"><label for="mirror" class="col-sm-4 control-label">Mirror</label><div class="col-sm-8"><ba-switcher switcher-style="primary" disable="vm.textSettings" switcher-value="vm.mirror" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row"><label for="relaypersons" class="col-sm-4 control-label">Relay Persons</label><div class="col-sm-8"><input type="text" is-number-key="" ng-model="vm.relaypersons" id="relaypersons" name="relaypersons" class="form-control" placeholder="Relay Persons"></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Cost Settings</span></uib-accordion-heading><div class="row"><div class="col-md-6"><div class="form-group row"><label for="weight" class="col-sm-4 control-label">Weight</label><div class="col-sm-8"><div class="input-group mb-0px"><input type="text" is-number-key="" ng-model="vm.weight" id="weight" name="weight" class="form-control with-primary-addon" placeholder="Weight"> <span class="input-group-addon input-group-addon-default addon-right" id="productweight">lbs</span></div></div></div></div><div class="col-md-6"><div class="form-group row"><label for="cost" class="col-sm-4 control-label">Cost</label><div class="col-sm-8"><div class="input-group mb-0px"><span class="input-group-addon input-group-addon-default addon-left" id="productcost">$</span> <input type="text" is-number-key="" ng-model="vm.cost" id="cost" name="cost" class="form-control" placeholder="Cost"></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group row"><label for="length" class="col-sm-2 control-label">Length, Width & Height</label><div class="col-sm-10"><div class="row"><div class="col-md-4 col-sm-4"><input type="text" is-number-key="" ng-model="vm.length" id="length" name="length" class="form-control" placeholder="Length"></div><div class="col-md-4 col-sm-4"><input type="text" is-number-key="" ng-model="vm.width" id="width" name="width" class="form-control" placeholder="Width"></div><div class="col-md-4 col-sm-4"><div class="input-group mb-0px"><input type="text" is-number-key="" ng-model="vm.height" id="height" name="height" class="form-control" placeholder="Height"> <span class="input-group-addon input-group-addon-default addon-right" id="productheight">(in)</span></div></div></div></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 text-right"><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.create-product" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="reportLabelId"></div></div></form></div></div>');
$templateCache.put('app/pages/settings/product/deleteItemModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/product/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteReportLabel()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/product/reportLabel.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'report_label_add\') !== - 1" ng-click="addReportLabel()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/product/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/productRule/addProductRule.html','<div ba-panel="" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedProductRole()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="productRuleFrm" novalidate="" ng-submit="productRuleFrm.$valid && saveProductRuleData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="ruleName" class="col-sm-4 control-label">Rule Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.ruleName" class="form-control" placeholder="Rule Name" id="ruleName" name="ruleName" required=""> <span class="error" ng-show="productRuleFrm.$submitted && productRuleFrm.ruleName.$error.required">Please enter rule name.</span></div></div></div><div class="col-md-6" ng-init="getActiveStatusData()"><div class="form-group row clearfix"><label for="orderStatusId" class="col-sm-4 control-label">Order Status <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select ng-model="vm.orderStatus" class="btn-group bootstrap-select form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" id="orderStatusId" name="orderStatus" required=""><ui-select-match placeholder="Select Status">{{$select.selected.status_label}}</ui-select-match><ui-select-choices repeat="sts.status_code as sts in vm.orderStatusList | filter: $select.search"><span ng-bind-html="sts.status_label"></span></ui-select-choices></ui-select><span class="error" ng-show="productRuleFrm.$submitted && productRuleFrm.orderStatus.$error.required">Please select order status.</span></div></div></div></div><div class="row"><div class="col-md-6" ng-init="getProductData()"><div class="form-group row clearfix"><label for="productLabelId" class="col-sm-4 control-label">Product <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.productLabel" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" id="productLabelId" name="productLabel" required=""><ui-select-match placeholder="Select Product" allow-clear="true">{{$item.report_label}}</ui-select-match><ui-select-choices repeat="product.report_label as product in vm.productData | filter: $select.search"><span ng-bind-html="product.report_label"></span></ui-select-choices></ui-select><span class="error" ng-show="productRuleFrm.$submitted && productRuleFrm.productLabel.$error.required">Please select product.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="productRuleFrm.$submitted && productRuleFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.product-rule" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="productRuleId"></form></div></div>');
$templateCache.put('app/pages/settings/productRule/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteProductRule()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/productRule/productRule.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'product_rule_order\') !== -1" ui-sref="settings.product-rule-order" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-sort"></i>Manage Rule Order</button> <button ng-if="permissionArr.indexOf(\'product_rule_add\') !== - 1" ng-click="addProductRule()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/productRule/ruleOrder.html','<div class="row role-permission"><span class="col-sm-12 mb-10">Set Rule Order by Just dragging Product rule up-down.</span><div class="col-sm-12 col-xs-12 col-md-6" ng-init="getActiveProductRuleData()"><div class="column"><div id="faq-order" ba-panel="" ba-panel-title="Set Product Rule Order" ba-panel-class="light-text with-scroll"><table ng-show="isloaded" class="table border-none permission-table"><tbody as-sortable="sortableRuleOptions" ng-model="ruleOrder"><tr ng-if="ruleOrder.length>0" ng-repeat="rule in ruleOrder" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><div class="status-label" ng-bind="rule.rule_name"></div></td></tr><tr ng-if="ruleOrder.length<=0"><td>No data</td></tr></tbody></table><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveProductRuleOrder()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.product-rule" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #faq-order .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/productRule/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/pullJobSetting/pullJobSetting.html','<div class="widgets profile" ba-panel=""><div ng-init="getPullJobSettingData();getActiveStatusData()"><form class="form-horizontal" name="pullJobSettingFrm" novalidate="" ng-submit="pullJobSettingFrm.$valid && savePullJobSetting()"><div class="col-md-12"><div class="form-group row clearfix"><label for="showOnStatusId" class="col-sm-3 control-label">Show on Status<span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" ng-model="vm.showOnStatus" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect" name="showOnStatus" required="" id="showOnStatusId"><ui-select-match placeholder="Select Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_label as status in orderStatusList | filter: $select.search">{{status.status_label}}</ui-select-choices></ui-select><span class="error" ng-show="pullJobSettingFrm.$submitted && pullJobSettingFrm.showOnStatus.$error.required">Please select show on status.</span></div></div><div class="form-group row clearfix"><label for="onChangeStatusId" class="col-sm-3 control-label">On Click Change Status<span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select ng-model="vm.onChangeStatus" ng-disabled="false" search-enabled="true" append-to-body="true" class="btn-group bootstrap-select form-control reports" name="onChangeStatus" required="" id="onChangeStatusId"><ui-select-match placeholder="Select Status">{{$select.selected.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatusList | filter: $select.search">{{status.status_label}}</ui-select-choices></ui-select><span class="error" ng-show="pullJobSettingFrm.$submitted && pullJobSettingFrm.onChangeStatus.$error.required">Please select change status.</span></div></div></div><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><button type="submit" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/settings/relayButtonSetting/relayButtonSetting.html','<div class="widgets profile faqfrontend" ba-panel=""><h3 class="with-line">Relay Button Setting</h3><div ng-init="getRelayButtonSettings()"><form class="form-horizontal" name="relayButtonSettingFrm" novalidate="" ng-submit="submittedRelayFrm = true"><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="relayButtonSettingFrm.$valid && SaveRelayButtonSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Create</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="createTitle" class="col-sm-4 control-label">Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.createTitle" class="form-control" placeholder="Create Button Title" name="createTitle" required="" id="createTitle"> <span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.createTitle.$error.required">Please enter create button title.</span></div></div><div class="form-group row clearfix"><label for="createButtonUrl" class="col-sm-4 control-label">Link/URL <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.createButtonUrl" name="createButtonUrl" id="createButtonUrl"><option value="system">System</option><option value="relay">Relay</option><option value="indiaserver">India Server</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.createButtonUrl.$error.required">Please select create button link/URL.</span></div></div><div class="form-group row clearfix"><label for="createButtonEncrypted" class="col-sm-4 control-label">Encrypted <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.createButtonEncrypted" name="createButtonEncrypted" id="createButtonEncrypted"><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.createButtonEncrypted.$error.required">Please select create button Encrypted.</span></div></div><div class="form-group row clearfix"><label for="create_order_status" class="col-md-4 control-label">Download File Status</label><div class="col-md-8"><select class="form-control roleData" ng-model="vm.createOrderStatus" name="create_order_status" id="create_order_status"><option value="">Select Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Ready</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="ready_title" class="col-sm-4 control-label">Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.readyTitle" class="form-control" placeholder="Ready Button Title" name="ready_title" required="" id="ready_title"> <span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.ready_title.$error.required">Please enter ready button title.</span></div></div><div class="form-group row clearfix"><label for="ready_url" class="col-sm-4 control-label">Link/URL <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.readyUrl" name="ready_url" id="ready_url"><option value="system">System</option><option value="relay">Relay</option><option value="indiaserver">India Server</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.ready_url.$error.required">Please select ready button link/URL.</span></div></div><div class="form-group row clearfix"><label for="ready_encrypted" class="col-sm-4 control-label">Encrypted <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.readyEncrypted" name="ready_encrypted" id="ready_encrypted"><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.ready_encrypted.$error.required">Please select ready button Encrypted.</span></div></div><div class="form-group row clearfix"><label for="ready_order_status" class="col-md-4 control-label">Download File Status</label><div class="col-md-8"><select class="form-control roleData" ng-model="vm.readyOrderStatus" name="ready_order_status" id="ready_order_status"><option value="">Select Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>3DC Download</span></uib-accordion-heading><div class="row"><div class="col-md-10"><div class="form-group row clearfix"><label for="title_3dc_download" class="col-sm-4 control-label">Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.title3dcDownload" class="form-control" placeholder="3DC Download Button Title" name="title_3dc_download" required="" id="title_3dc_download"> <span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.title_3dc_download.$error.required">Please enter 3DC download button title.</span></div></div><div class="form-group row clearfix"><label for="url_3dc_download" class="col-sm-4 control-label">Link/URL <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.url3dcDownload" name="url_3dc_download" id="url_3dc_download"><option value="system">System</option><option value="relay">Relay</option><option value="indiaserver">India Server</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.url_3dc_download.$error.required">Please select 3DC download button link/URL.</span></div></div><div class="form-group row clearfix"><label for="url_3dc_encrypted" class="col-sm-4 control-label">Encrypted <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.url3dcEncrypted" name="url_3dc_encrypted" id="url_3dc_encrypted"><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.url_3dc_encrypted.$error.required">Please select 3DC download button Encrypted.</span></div></div><div class="form-group row clearfix"><label for="download3dc_order_status" class="col-md-4 control-label">Download File Status</label><div class="col-md-8"><select class="form-control roleData" ng-model="vm.download3dcOrderStatus" name="download3dc_order_status" id="download3dc_order_status"><option value="">Select Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Upload</span></uib-accordion-heading><div class="row" ng-init="getActiveStatus()"><div class="col-md-10"><div class="form-group row clearfix"><label for="upload" class="col-sm-4 control-label">Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.upload" class="form-control" placeholder="Upload Button Title" name="upload" required="" id="upload"> <span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.upload.$error.required">Upload button title.</span></div></div><div class="form-group row clearfix"><label for="upload_encrypted" class="col-sm-4 control-label">Encrypted <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.uploadEncrypted" name="upload_encrypted" id="upload_encrypted"><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.upload_encrypted.$error.required">Please select Upload button Encrypted.</span></div></div><div class="form-group row clearfix"><label for="upload_order_status_for_upload" class="col-md-4 control-label">Upload File Status</label><div class="col-md-8"><select class="form-control roleData" ng-model="vm.uploadOrderStatusForUpload" name="upload_order_status_for_upload" id="upload_order_status_for_upload"><option value="">Select Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="upload_order_status" class="col-md-4 control-label">Download File Status</label><div class="col-md-8"><select class="form-control roleData" ng-model="vm.uploadOrderStatus" name="upload_order_status" id="upload_order_status"><option value="">Select Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Amazon File Download</span></uib-accordion-heading><div class="row" ng-init="getActiveStatus()"><div class="col-md-10"><div class="form-group row clearfix"><label for="upload" class="col-sm-4 control-label">Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" ng-model="vm.amazonDownload" class="form-control" placeholder="Button Title" name="amazonDownload" required="" id="amazonDownload"> <span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.amazonDownload.$error.required">Amazon button title.</span></div></div><div class="form-group row clearfix"><label for="upload_encrypted" class="col-sm-4 control-label">Encrypted <span class="asterisk_input"></span></label><div class="col-sm-8"><select class="form-control roleData" ng-model="vm.amazonEncrypted" name="amazon_encrypted" id="amazon_encrypted"><option value="Yes">Yes</option><option value="No">No</option></select><span class="error" ng-show="submittedRelayFrm && relayButtonSettingFrm.amazon_encrypted.$error.required">Please select amazon button Encrypted.</span></div></div><div class="form-group row clearfix"><label for="upload_order_status" class="col-md-4 control-label">Download Status</label><div class="col-md-8"><select class="form-control roleData" ng-model="vm.amazoneOrderStatus" name="amazone_order_status" id="amazone_order_status"><option value="">Select Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="relayButtonSettingFrm.$valid && SaveRelayButtonSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div><div style="display:none;"></div></div>');
$templateCache.put('app/pages/settings/reworkSetting/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/reworkSetting/reworkSetting.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="reason.set_default=\'0\';sol.set_default=\'0\';"><div ng-init="getReworkSettingData()"><form class="form-horizontal" name="reworkSettingFrm" novalidate="" ng-submit="submittedFrm = true"><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="reworkSettingFrm.$valid && saveReworkSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Rework Order Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Available Rework Order With Status (For Info Tab)</label><div class="col-md-4"><ui-select multiple="" ng-model="vm.availableOrderStatus" class="form-control reports" ng-disabled="false" append-to-body="true" search-enabled="true" name="availableOrderStatus" id="availableOrderStatus"><ui-select-match placeholder="Available Rework Order With Status">{{$item.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatus | filter: $select.search"><span ng-bind-html="status.status_label"></span></ui-select-choices></ui-select></div></div><div class="form-group row clearfix"><label for="reworkOrderStatus" class="col-md-3 control-label">Rework Order After Create Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.reworkOrderStatus" name="reworkOrderStatus" id="reworkOrderStatus"><option value="">Rework Order After Create Status</option><option value="{{status.status_code}}" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Rework Reason</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Add Rework Reason</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Rework Reason</th><th class="width-45-per">Set As Default</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'rework_reason\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.reworkReason.length > 0" ng-repeat="reason in vm.reworkReason" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12"><input only-caracter="" type="text" ng-model="reason.name" limit-to="30" ng-maxlength="30" name="reason{{$index}}" required="" class="form-control height28px" placeholder="Rework Reason" id="itemTitleReason-{{$index}}"> <span class="error" ng-show="submittedFrm && reworkSettingFrm[\'reason\' +$index].$error.required">Please enter rework reason.</span></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12"><select class="form-control roleData height28px" ng-model="reason.set_default" name="reasonDefault{{$index}}" id="itemDefaultReason-{{$index}}"><option value="0">0</option><option value="1">1</option></select></div></div></div></div></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'rework_reason\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.reworkReason.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Rework Solution</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Add Rework Solution</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Rework Solution</th><th class="width-45-per">Set As Default</th><th class="width-10-per"><button type="button" class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'rework_solution\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.reworkSolution.length > 0" ng-repeat="sol in vm.reworkSolution" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12"><input only-caracter="" type="text" ng-model="sol.name" limit-to="30" ng-maxlength="30" id="itemTitleSol-{{$index}}" name="solution{{$index}}" required="" class="form-control height28px" placeholder="Rework Solution"> <span class="error" ng-show="submittedFrm && reworkSettingFrm[\'solution\' +$index].$error.required">Please enter rework solution.</span></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12"><select class="form-control roleData height28px" ng-model="sol.set_default" name="itemDefault" id="itemDefaultSol-{{$index}}"><option value="0">0</option><option value="1">1</option></select></div></div></div></div></td><td class="text-center"><div class="buttons"><button type="button" class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'rework_solution\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.reworkSolution.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="reworkSettingFrm.$valid && saveReworkSetting()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/settings/store/addStore.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedStore()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="storeFrm" novalidate="" ng-submit="storeFrm.$valid && saveStoreData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="storeName" class="col-sm-4 control-label">Store Name <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="storeName" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.storeName" name="storeName" required="" class="form-control" placeholder="Store Name"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.storeName.$error.required">Please enter store name.</span> <span class="error" ng-show="!storeFrm.storeName.$error.pattern && storeFrm.storeName.$error.maxlength && storeFrm.storeName.$touched">Store Name should not be greater than 40 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="storeCode" class="col-sm-4 control-label">Store Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="storeCode" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.storeCode" name="storeCode" required="" class="form-control" placeholder="Store Code"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.storeCode.$error.required">Please enter store code.</span> <span class="error" ng-show="!storeFrm.storeCode.$error.pattern && storeFrm.storeCode.$error.maxlength && storeFrm.storeName.$touched">Store Code should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="systemType" class="col-sm-4 control-label">Store Type <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.systemType" class="form-control" name="systemType" id="systemType" required=""><option value="">Select Store Type</option><option value="m1">Magento 1</option><option value="m2">Magento 2</option><option value="pos">POS</option><option value="erp">ERP System</option><option value="amazon">Amazon</option><option value="other">Other</option></select><span class="error" ng-show="storeFrm.$submitted && storeFrm.systemType.$error.required">Please select system type.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="storeUrl" class="col-sm-4 control-label">Store URL <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="storeUrl" type="text" ng-model="vm.storeUrl" name="storeUrl" required="" class="form-control" placeholder="Store URL"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.storeUrl.$error.required">Please enter store url.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="autoRefreshTime" class="col-sm-4 control-label">Auto Refresh Time(Sec)<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="autoRefreshTime" limit-to="5" is-number-key="" type="text" ng-model="vm.autoRefreshTime" ng-maxlength="5" name="autoRefreshTime" required="" class="form-control" placeholder="Auto Refresh Time"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.autoRefreshTime.$error.required">Please enter auto refresh time.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="autoImportTime" class="col-sm-4 control-label">Auto Import Time(Sec)<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="autoImportTime" limit-to="5" is-number-key="" type="text" ng-model="vm.autoImportTime" ng-maxlength="5" name="autoImportTime" required="" class="form-control" placeholder="Auto Import Time"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.autoImportTime.$error.required">Please enter auto import time.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="userName" class="col-sm-4 control-label">User Name <span class="asterisk_input"></span></label><div class="col-sm-8" style="position:relative"><input id="userName" type="text" ng-model="vm.userName" ng-disabled="vm.storeId" required="" limit-to="20" ng-maxlength="20" name="userName" class="form-control" placeholder="User Name" ng-pattern="/^[a-zA-Z0-9_.-]*$/"> <i class="fa fa-copy fa-lg" ng-if="vm.storeId" title="Copy User Name" clipboard="" text="vm.userName" on-copied="success(\'User Name\')" on-error="fail(err)" style="position: absolute;right: 20px;top: 10px;cursor: pointer;"></i> <span class="error" ng-show="storeFrm.$submitted && storeFrm.userName.$error.required">Please enter user name.</span> <span class="error" ng-show="storeFrm.userName.$error.pattern">Invalid Username (Ignore space & special characters).</span> <span class="error" ng-show="storeFrm.userName.$error.maxlength && storeFrm.userName.$touched">Username should not be greater than 20 characters</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="storeFrm.$submitted && storeFrm.status.$error.required">Please select status.</span></div></div></div></div><div class="row"><div class="col-md-6"><label for="service" class="col-sm-4 control-label">Default Service</label><div class="col-sm-8"><select ng-model="vm.service" class="form-control" name="service" id="service" required=""><option value="">Select Service</option><option value="fedex">Fedex</option><option value="usps">USPS</option></select></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="accountFedex" class="col-sm-4 control-label">Fedex Account <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.accountFedex" class="form-control" name="accountFedex" id="accountFedex" required=""><option value="">Select Account</option><option value="{{ item.account_id }}" ng-repeat="(index, item) in accounts" ng-if="item.account_service==\'fedex\'">{{ item.account_company_name }} ({{ item.account_number}})</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="accountUsps" class="col-sm-4 control-label">USPS Account <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.accountUsps" class="form-control" name="accountUsps" id="accountUsps" required=""><option value="">Select Account</option><option value="{{ item.account_id }}" ng-repeat="(index, item) in accounts" ng-if="item.account_service==\'usps\'">{{ item.account_company_name }} ({{ item.account_number}})</option></select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="accountUps" class="col-sm-4 control-label">UPS Account <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.accountUps" class="form-control" name="accountUps" id="accountUps" required=""><option value="">Select Account</option><option value="{{ item.account_id }}" ng-repeat="(index, item) in accounts" ng-if="item.account_service==\'ups\'">{{ item.account_company_name }} ({{ item.account_number}})</option></select></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="ciproductsetting" class="col-sm-4 control-label">Commercial Invoice Setting <span class="asterisk_input"></span></label><div class="col-sm-8"><select ng-model="vm.ciproductsetting" class="form-control" name="ciproductsetting" id="ciproductsetting" required=""><option value="">Select Setting</option><option value="product_name">Product Name only</option><option value="product_description">Product Description only</option><option value="product_name_description">Product Name and Description Both</option></select></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="shipmenRateMargin" class="col-sm-4 control-label">Shipment Rate Margin<span class="asterisk_input"></span></label><div class="col-sm-8"><input id="shipmenRateMargin" is-number-key="" type="text" ng-model="vm.shipmenRateMargin" ng-maxlength="5" name="shipmenRateMargin" required="" class="form-control" placeholder="Shipment Rate Margin"> <span class="error" ng-show="storeFrm.$submitted && storeFrm.shipmenRateMargin.$error.required">Please enter shipment rate margin.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="storeToken" class="col-sm-4 control-label">Token</label><div class="col-sm-8"><textarea id="storeToken" disabled="" ng-model="vm.storeToken" name="storeToken" class="form-control" placeholder="Enter Token" style="position:relative"></textarea> <i class="fa fa-copy fa-lg" title="Copy Token" clipboard="" text="vm.storeToken" on-copied="success(\'Token\')" on-error="fail(err)" style="position: absolute;right: 20px;bottom: 8px;cursor: pointer;"></i></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.store" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.storeId"></form></div></div>');
$templateCache.put('app/pages/settings/store/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteStore()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/store/mapStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-sm-12 col-lg-8"><b>Note:</b><span>First status in list will be considered as priority for import orders from magento.</span></div><div class="col-sm-12 col-lg-4"><a ui-sref="settings.store" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addMapStatusData()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div ng-init="getStatusData()" class="row"><div class="col-md-4"><div class="row"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="vm.orderStatus"><tr ng-repeat="status in vm.orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}" ng-init="getStatusMapData()"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{sts._id.magento_status_title}}" ba-panel-class="light-text with-scroll" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="sts.status"><tr ng-if="sts.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}} <a ng-click="removeStatus(item,sts.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.store" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addMapStatusData()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/store/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/store/store.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12"><button ng-if="permissionArr.indexOf(\'store_add\') !== - 1" ng-click="addStore()" type="button" class="btn btn-primary btn-with-icon add-new-btn"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/trackerStatusMap/mapStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-sm-12 col-lg-8"><b>Note:</b><span>First status in list will be considered as priority for import orders from magento.</span></div><div class="col-sm-12 col-lg-4"><button type="button" ng-click="addMapStatusData()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div ng-init="getStatusData()" class="row"><div class="col-md-4"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="vm.orderStatus"><tr ng-repeat="status in vm.orderStatus" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}" ng-init="getStatusMapData()"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{sts._id.magento_status_title}}" ba-panel-class="light-text with-scroll" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="sts.status"><tr ng-if="sts.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}} <a ng-click="removeStatus(item,sts.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="addMapStatusData()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/type/addType.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedProductType()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="productTypeFrm" novalidate="" ng-submit="productTypeFrm.$valid && saveProductTypeData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': (productTypeFrm.product_type.$error.required || productTypeFrm.product_type.$error.pattern || productTypeFrm.product_type.$error.maxlength) && productTypeFrm.product_type.$touched}"><label for="product type" class="col-sm-4 control-label">Type<span class="asterisk_input"></span></label><div class="col-sm-8"><input type="text" name="product_type" id="product_type" ng-model="vm.productType" class="form-control" placeholder="Type" required=""> <span class="error" ng-show="productTypeFrm.$submitted && productTypeFrm.product_type.$error.required">Please enter type.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix" ng-class="{\'has-error\': productTypeFrm.SKU.$error.required && productTypeFrm.SKU.$touched}"><label for="SKU" class="col-sm-4 control-label">SKU KEY VALUE <span class="asterisk_input"></span></label><div class="col-sm-8"><ui-select multiple="" tagging="" tagging-label="" ng-model="vm.SKU" search-enabled="true" sortable="true" title="Select SKU" required="" name="SKU" id="SKU" class="form-control multipleSelect"><ui-select-match placeholder="Select SKU KEY VALUE">{{$item}}</ui-select-match><ui-select-choices repeat="sku in availableSKU | filter:$select.search">{{sku}}</ui-select-choices></ui-select><span class="error" ng-show="productTypeFrm.$submitted && productTypeFrm.SKU.$error.required">Please enter sku key value.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="col-sm-4 control-label">Create Sticker Settings</label><div class="col-sm-8"><ba-switcher switcher-style="primary" switcher-value="vm.swtich" on-label="Yes" off-label="No"></ba-switcher></div></div></div><div class="col-md-6"><div class="form-group"><label class="col-sm-4 control-label">Show In Blocks</label><div class="col-sm-8"><ba-switcher switcher-style="primary" switcher-value="vm.show_in_blocks" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Type Icon</label><div class="col-sm-8"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ vm.image }}" ng-model="vm.image" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Icon</a> <input required="" type="file" ng-show="false" name="FileUploadLogo" id="uploadFile" ng-file-select="onFileSelect($files)" fileread="file"></div><span class="error" ng-show="productTypeFrm.$submitted && productTypeFrm.FileUploadLogo.$error.required">Please select type icon.</span></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="productTypeFrm.$submitted && productTypeFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.type" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="categoryId"></form></div></div>');
$templateCache.put('app/pages/settings/type/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteProductType()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/type/setPriority.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.type" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addTypePriority()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-4" ng-init="getAllTypes()"><div class=""><div class="column"><div id="status" ba-panel="" ba-panel-title="All Types" ba-panel-class="light-text with-scroll"><table class="table border-none" as-sortable="sortableCloneOptions" data-ng-model="allTypes"><tr ng-repeat="item in allTypes" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor">{{item.name}}</span></td></tr></table></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{sts.name}}" ba-panel-class="light-text with-scroll shipping-inner-panel" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="sts.typeData"><tr ng-if="sts.typeData.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.typeData" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span class="status-label cursor">{{item.name}} <a ng-click="removeType(item,sts.typeData)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="settings.type" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="addTypePriority()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/type/setTypePriority.html','<div class="row role-permission"><span class="col-sm-12 mb-10">Set Type Priority by Just dragging Popup Button up-down.</span><div class="col-sm-12 col-xs-12 col-md-6" ng-init="getActiveTypeData()"><div class="column"><div id="faq-order" ba-panel="" ba-panel-title="Set Type Priority Order" ba-panel-class="light-text with-scroll"><table ng-show="isloaded" class="table border-none permission-table"><tbody as-sortable="sortableButtonOptions" ng-model="buttonOrder"><tr ng-if="buttonOrder.length>0" ng-repeat="block in buttonOrder" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><div class="status-label" ng-bind="block.name"></div></td></tr><tr ng-if="buttonOrder.length<=0"><td>No data</td></tr></tbody></table><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveTypePriority()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.type" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #faq-order .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/settings/type/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/type/type.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12">&nbsp; <button ng-if="permissionArr.indexOf(\'set_type_priority\') !== -1" ui-sref="settings.set-type-priority" type="button" class="btn btn-warning pull-right btn-with-icon ng-scope" href="/settings/set-type-priority"><i class="fa fa-sort"></i>Set Type Priority</button>&nbsp;&nbsp; <button ng-if="permissionArr.indexOf(\'product_type_add\') !== - 1" ng-click="addType()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/type/viewType.html','<div ba-panel="" ba-panel-class="with-scroll"><div class="panel-content" ng-init="getViewType()"><div class="row"><div class="col-md-6"><div class="form-group clearfix" ng-class="{\'has-error\': (productTypeFrm.product_type.$error.required || productTypeFrm.product_type.$error.pattern || productTypeFrm.product_type.$error.maxlength) && productTypeFrm.product_type.$touched}"><label for="product Type" class="col-sm-4 control-label">Type<span class=""></span></label><div class="col-sm-8"><label>{{vm.productType }}</label></div></div><div class="form-group clearfix"><label for="status" class="col-sm-4 control-label">Status <span class=""></span></label><div class="col-sm-8"><label>{{vm.status}}</label></div></div><div class="form-group clearfix"><label for="inputFirstName" class="col-sm-4 control-label">Type Icon</label><div class="col-sm-8"><img ng-src="{{ vm.image }}" ng-model="vm.image" ng-click="uploadPicture()"></div></div><a ui-sref="settings.type" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Back</a></div></div></div></div>');
$templateCache.put('app/pages/shipment/orderReadyToShip/changeStatusModal.html','<div class="modal fade" id="changeStatusConfirm" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change <strong ng-if="selectedOrderCount==1">{{selectedOrderCount}} order</strong> <strong ng-if="selectedOrderCount>1">{{selectedOrderCount}} orders</strong> status?</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="updateOrderStatus()">YES</button> <button type="button" class="btn btn-warning" data-dismiss="modal">NO</button></div></div></div></div>');
$templateCache.put('app/pages/shipment/orderReadyToShip/deleteModal.html','<div class="modal-content" ng-controller="readytoshipListCtrl"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this shipment?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteShipment()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/shipment/orderReadyToShip/orderDetails.html','<div id="orderDetailsModel" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content order-details-model"><div class="modal-body"><uib-tabset active="1" class="right-tab tab-height"><div class="row absolute-500-width"><div class="col-lg-7 col-sm-8 col-xs-11"><img width="50" class="pull-left margin-right-10" height="37" ng-src="assets/img/magento_logo_symbol.png"><div class="internal-tab"><span class="white order-number"><b>Order Number : {{orderId}}</b></span> <span class="label white label-tab pull-right ng-binding" ng-style="{\'background-color\':orderStatusColor}">{{ orderStatus }}</span></div></div><div ng-if="permissionArr.indexOf(\'pull_job\') !== - 1 && checkStatusForPullJobBtn(orderDetailsData.orderData.statusName)" class="col-lg-4 col-sm-2 col-xs-6"><button type="button" class="btn btn-primary pull-right mt-5px" ng-click="pullJob(orderDetailsData.orderData.status)">Pull Job</button></div></div><button type="button" class="close close-details white" ng-click="closePopup()" aria-label="Close">&times;</button><uib-tab index="1" heading="Order Details"><div class="row vertical-tab right-tab1"><div class="col-md-12 col-lg-12 left-tab-content"><uib-tabset active="0"><uib-tab heading="Info" index="0"><div class="info-content"><div class="col-sm-12 col-md-12 col-lg-8"><div class="row"><div class="col-md-12 col-lg-12"><div class="col-sm-12 col-md-12 col-lg-12" ng-if="permissionArr.indexOf(\'shipment_buyer_info\') !== - 1"><div ba-panel="" ba-panel-title="Buyer / Recipient Info" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><div class="col-md-6 col-lg-6 order-details-ship-to" ng-if="!editsoldto"><strong>Sold To :</strong><p style="float: right;" ng-if="permissionArr.indexOf(\'change_soldto_address\') !== -1"><a href="javascript:void(0);" ng-click="editSoldTo()" class="btn btn-primary">Edit</a></p><p>{{orderAddress.billing.firstname}} {{orderAddress.billing.lastname}}</p><p>{{orderAddress.billing.company}}</p><p>{{orderAddress.billing.street}}</p><p>{{orderAddress.billing.city}} {{orderAddress.billing.region}} {{orderAddress.billing.country_id}} {{orderAddress.billing.postcode}}</p><p>{{orderAddress.billing.telephone}}</p><p><a href="mailto:{{orderAddress.billing.email}}">{{orderAddress.billing.email}}</a></p></div><div class="col-md-6 col-lg-6 order-details-ship-to" id="editsoldto" ng-if="editsoldto"><form class="form-horizontal" name="soldtoFrm" novalidate="" ng-submit="soldtoFrm.$valid && saveSoldTo()"><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldfirstname" id="soldfirstname" ng-model="soldfirstname" class="form-control" placeholder="First Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldfirstname.$error.required">Please enter first name.</span> <span class="error" ng-show="soldtoFrm.soldfirstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="soldtoFrm.soldfirstname.$error.maxlength && soldtoFrm.soldfirstname.$touched">First Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldlastname" ng-model="soldlastname" class="form-control" placeholder="Last Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldlastname.$error.required">Please enter last name.</span> <span class="error" ng-show="soldtoFrm.soldlastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="soldtoFrm.soldlastname.$error.maxlength && soldtoFrm.soldlastname.$touched">Last Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="soldcompany" ng-model="soldcompany" class="form-control" placeholder="Company" limit-to="150" ng-maxlength="150" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="soldtoFrm.soldcompany.$error.pattern">Please enter valid company name.</span> <span class="error" ng-show="soldtoFrm.soldcompany.$error.maxlength && soldtoFrm.soldcompany.$touched">Company Name should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="soldaddress" ng-model="soldaddress" class="form-control" placeholder="Address" limit-to="150" ng-maxlength="150" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldaddress.$error.required">Please enter address.</span> <span class="error" ng-show="soldtoFrm.soldaddress.$error.maxlength && soldtoFrm.soldaddress.$touched">Address should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldcity" id="soldcity" ng-model="soldcity" class="form-control" placeholder="City" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldcity.$error.required">Please enter city.</span> <span class="error" ng-show="soldtoFrm.soldcity.$error.pattern">Please enter valid city name.</span> <span class="error" ng-show="soldtoFrm.soldcity.$error.maxlength && soldtoFrm.soldcity.$touched">City should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldregion" id="soldregion" ng-model="soldregion" class="form-control" placeholder="Region" limit-to="20" ng-maxlength="20" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldregion.$error.required">Please enter region.</span> <span class="error" ng-show="soldtoFrm.soldregion.$error.pattern">Please enter valid region.</span> <span class="error" ng-show="soldtoFrm.soldregion.$error.maxlength && soldtoFrm.soldregion.$touched">Region should not be greater than 20 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldpostcode" id="soldpostcode" ng-model="soldpostcode" class="form-control" placeholder="Zip Code" limit-to="20" ng-maxlength="20" ng-pattern="/^[0-9\\s-]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldpostcode.$error.required">Please enter zip code.</span> <span class="error" ng-show="soldtoFrm.soldpostcode.$error.pattern">Please enter valid zip code.</span> <span class="error" ng-show="soldtoFrm.soldpostcode.$error.maxlength && soldtoFrm.soldpostcode.$touched">Zip code should not be greater than 20 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="soldcountry" id="soldcountry" ng-model="soldcountry" class="form-control" placeholder="Country" limit-to="2" ng-maxlength="2" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="soldtoFrm.$submitted && soldtoFrm.soldcountry.$error.required">Please enter country.</span> <span class="error" ng-show="soldtoFrm.soldcountry.$error.pattern">Please enter valid country.</span> <span class="error" ng-show="soldtoFrm.soldcountry.$error.maxlength && soldtoFrm.soldcountry.$touched">Country Code should not be greater than 2 characters</span></div><div class="col-md-12 col-sm-12"><button type="button" class="btn btn-warning mr-5" ng-click="cancelSoldTo()">Cancel</button> <button type="submit" class="btn btn-info">Save</button></div></form></div><div class="col-md-6 col-lg-6 order-details-ship-to" ng-if="!editshipto"><strong>Ship To :</strong> <a href="javascript:void(0);" ng-if="permissionArr.indexOf(\'verify_address\') !== -1" ng-click="getOrderVerify()" class="btn btn-primary" style="float: right; margin-left: 5px;">Verify</a> <a href="javascript:void(0);" ng-if="permissionArr.indexOf(\'change_shipto_address\') !== -1" style="float: right;" class="btn btn-primary" ng-click="editShipTo()">Edit</a><br><p>{{orderAddress.shipping.firstname}} {{orderAddress.shipping.lastname}}</p><p>{{orderAddress.shipping.company}}</p><p>{{orderAddress.shipping.street}}</p><p>{{orderAddress.shipping.city}} {{orderAddress.shipping.region}} {{orderAddress.shipping.country_id}} {{orderAddress.shipping.postcode}}</p><p>{{orderAddress.shipping.telephone}}</p><p><a href="mailto:{{orderAddress.shipping.email}}" class="text-success">{{orderAddress.shipping.email}}</a></p><p><strong>Address Type: <span id="addresstype"></span></strong> <span style="color:#6ba03a;font-size: 24px;padding-left: 5px;" ng-if="add_business"><i class="fa fa-building-o"></i></span> <span style="color:#6ba03a;font-size: 24px;" ng-if="add_home"><i class="fa fa-home"></i></span><br><span id="warnings" style="display:none;color:#f9d605;"></span><br><span id="verified" style="display:none;color:#6ba03a;font-weight:bolder;font-size: 20px;">Address Verified</span></p></div><div class="col-md-12 col-lg-6 order-details-ship-to" id="editshipto" ng-if="editshipto"><form class="form-horizontal" name="shiptoFrm" novalidate="" ng-submit="shiptoFrm.$valid && saveShipTo()"><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipfirstname" id="shipfirstname" ng-model="shipfirstname" class="form-control" placeholder="First Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipfirstname.$error.required">Please enter first name.</span> <span class="error" ng-show="shiptoFrm.shipfirstname.$error.pattern">Please enter valid first name.</span> <span class="error" ng-show="shiptoFrm.shipfirstname.$error.maxlength && shiptoFrm.shipfirstname.$touched">First Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shiplastname" ng-model="shiplastname" class="form-control" placeholder="Last Name" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shiplastname.$error.required">Please enter last name.</span> <span class="error" ng-show="shiptoFrm.shiplastname.$error.pattern">Please enter valid last name.</span> <span class="error" ng-show="shiptoFrm.shiplastname.$error.maxlength && shiptoFrm.shiplastname.$touched">Last Name should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="shipcompany" ng-model="shipcompany" class="form-control" placeholder="Company" limit-to="150" ng-maxlength="150" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="shiptoFrm.shipcompany.$error.pattern">Please enter valid company name.</span> <span class="error" ng-show="shiptoFrm.shipcompany.$error.maxlength && shiptoFrm.shipcompany.$touched">Company Name should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-12 col-lg-12"><input type="text" name="shipaddress" ng-model="shipaddress" class="form-control" placeholder="Address" limit-to="150" ng-maxlength="150" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipaddress.$error.required">Please enter address.</span> <span class="error" ng-show="shiptoFrm.shipaddress.$error.maxlength && shiptoFrm.shipaddress.$touched">Address should not be greater than 150 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipcity" id="shipcity" ng-model="shipcity" class="form-control" placeholder="City" limit-to="50" ng-maxlength="50" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipcity.$error.required">Please enter city.</span> <span class="error" ng-show="shiptoFrm.shipcity.$error.pattern">Please enter valid city name.</span> <span class="error" ng-show="shiptoFrm.shipcity.$error.maxlength && shiptoFrm.shipcity.$touched">City should not be greater than 50 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipregion" id="shipregion" ng-model="shipregion" class="form-control" placeholder="Region" limit-to="20" ng-maxlength="20" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipregion.$error.required">Please enter region.</span> <span class="error" ng-show="shiptoFrm.shipregion.$error.pattern">Please enter valid region.</span> <span class="error" ng-show="shiptoFrm.shipregion.$error.maxlength && shiptoFrm.shipregion.$touched">Region should not be greater than 20 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shippostcode" id="shippostcode" ng-model="shippostcode" class="form-control" placeholder="Zip Code" limit-to="20" ng-maxlength="20" ng-pattern="/^[0-9\\s-]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shippostcode.$error.required">Please enter zip code.</span> <span class="error" ng-show="shiptoFrm.shippostcode.$error.pattern">Please enter valid zip code.</span> <span class="error" ng-show="shiptoFrm.shippostcode.$error.maxlength && shiptoFrm.shippostcode.$touched">Zip code should not be greater than 20 characters</span></div><div class="col-sm-12 col-md-6 col-lg-6"><input type="text" name="shipcountry" id="shipcountry" ng-model="shipcountry" class="form-control" placeholder="Country" limit-to="2" ng-maxlength="2" ng-pattern="/^[a-z\\d\\-_\\s]+$/i" required=""> <span class="error" ng-show="shiptoFrm.$submitted && shiptoFrm.shipcountry.$error.required">Please enter country.</span> <span class="error" ng-show="shiptoFrm.shipcountry.$error.pattern">Please enter valid country.</span> <span class="error" ng-show="shiptoFrm.shipcountry.$error.maxlength && shiptoFrm.shipcountry.$touched">Country Code should not be greater than 2 characters</span></div><div class="col-md-12 col-sm-12"><button type="button" class="btn btn-warning mr-5" ng-click="cancelShipTo()">Cancel</button> <button type="submit" class="btn btn-info">Save</button></div></form></div></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="col-sm-12 col-md-12 col-lg-12" ng-if="permissionArr.indexOf(\'shipment_shipping_info\') !== - 1"><div ba-panel="" ba-panel-title="Shipments" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><table border="0" width="100%" class="item-table"><thead><tr><th class="item-product">Tracking #</th><th class="item-product">Shipped Date</th><th class="item-product">Shipped By</th><th class="item-product">Type</th><th class="item-product">Charge</th><th class="item-product">Label</th><th class="item-product">Invoice</th><th class="item-product">Action</th></tr><tr ng-repeat="(index, item) in trackingData"><td class="item-description" ng-if="item.service.toLowerCase() ==\'fedex\' && item.voided==1" style="text-decoration: line-through;"><a href="https://www.fedex.com/apps/fedextrack/?tracknumbers={{ item.tracking_number }}&language=en&cntry_code=us" class="product-link" target="_blank">{{ item.tracking_number }}</a></td><td class="item-description" ng-if="item.service.toLowerCase() ==\'fedex\' && !item.voided"><a href="https://www.fedex.com/apps/fedextrack/?tracknumbers={{ item.tracking_number }}&language=en&cntry_code=us" class="product-link" target="_blank">{{ item.tracking_number }}</a></td><td class="item-description" ng-if="item.service.toLowerCase() ==\'usps\' && item.voided==1" style="text-decoration: line-through;"><a href="https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&tLabels={{ item.tracking_number }}" class="product-link" target="_blank">{{ item.tracking_number }}</a></td><td class="item-description" ng-if="item.service.toLowerCase() ==\'usps\' && !item.voided"><a href="https://tools.usps.com/go/TrackConfirmAction?tRef=fullpage&tLc=2&tLabels={{ item.tracking_number }}" class="product-link" target="_blank">{{ item.tracking_number }}</a></td><td class="item-description" ng-if="item.service.toLowerCase() ==\'ups\' && item.voided==1" style="text-decoration: line-through;"><a href="https://www.ups.com/mobile/track?trackingNumber={{ item.tracking_number }}" class="product-link" target="_blank">{{ item.tracking_number }}</a></td><td class="item-description" ng-if="item.service.toLowerCase() ==\'ups\' && !item.voided"><a href="https://www.ups.com/mobile/track?trackingNumber={{ item.tracking_number }}" class="product-link" target="_blank">{{ item.tracking_number }}</a></td><td class="item-price" ng-if="!item.tracking_number">N/A</td><td class="item-price">{{ getGlobalDateFormat(item.created_at) }}</td><td class="item-price">{{ item.created_by }}</td><td class="item-price" ng-if="item.service_type">{{ item.service_type }}</td><td class="item-price" ng-if="!item.service_type">N/A</td><td class="item-price" ng-if="item.charge">${{ item.charge }}</td><td class="item-price" ng-if="!item.charge">$0</td><td class="item-description" ng-if="item.tracking_file"><a href="{{ item.tracking_file }}" target="_blank" class="btn btn-primary btn-sm"><i class="fa fa-download" aria-hidden="true"></i></a></td><td class="item-price" ng-if="!item.tracking_file">N/A</td><td class="item-description" ng-if="item.invoice_file"><a href="{{ item.invoice_file }}" target="_blank" class="btn btn-primary btn-sm"><i class="fa fa-download" aria-hidden="true"></i></a></td><td class="item-price" ng-if="!item.invoice_file">N/A</td><td class="item-price" ng-if="item.tracking_number && !item.voided && permissionArr.indexOf(\'shipment_tracking_void\') !== - 1"><a href="javascript:void(0);" ng-click="voidlabel(item.shipment_order_number,item.tracking_number)" class="btn btn-danger btn-sm" title="Void Label"><i class="fa fa-times" aria-hidden="true"></i></a></td></tr></thead></table></div></div></div></div></div><div class="row"><div class="col-md-12 col-lg-12"><div class="col-sm-12 col-md-12 col-lg-12" ng-if="permissionArr.indexOf(\'shipment_shipping_info\') !== - 1"><div ba-panel="" ba-panel-title="Shipment Items" ba-panel-class="xsmall-panel with-scroll light-text panel-custom_heading panel-custom_items"><div class="row"><table border="0" width="100%" class="item-table"><thead><tr><th class="item-product">Item</th><th class="item-price" ng-if="permissionArr.indexOf(\'order_item_unit\') !== - 1">Unit $</th><th class="item-qty" ng-if="permissionArr.indexOf(\'order_total_qty\') !== - 1">Qty</th><th class="item-price" ng-if="permissionArr.indexOf(\'order_total_price\') !== - 1">Total $</th><th class="item-qty" ng-if="permissionArr.indexOf(\'order_total_weight\') !== - 1">Total Weight</th></tr></thead><tbody><tr ng-repeat="(index, item) in orderDetailsData.items"><td class="item-description"><div class="product-details"><span class="desc-content editable editable-click editable-disabled" data-name="Description" data-mode="inline" data-type="text" tabindex="-1"><a href="#" class="product-link">{{item.name}}</a></span><br><span class="desc-content editable editable-click editable-disabled" data-name="SKU" data-mode="inline" data-type="text" style="word-wrap: break-word;" tabindex="-1">SKU: {{item.sku}}</span><br><span class="desc-content editable editable-click editable-disabled" data-name="SKU" data-mode="inline" data-type="text" style="word-wrap: break-word;" tabindex="-1">Product Number: {{item.order_item}}</span></div></td><td class="item-price" ng-if="permissionArr.indexOf(\'order_item_unit\') !== - 1">$<span class="editable editable-click editable-disabled" data-name="UnitPrice" data-custom-type="currency" data-type="text" data-mode="popup" tabindex="-1">{{item.price}}</span></td><td class="text-center item-qty" ng-if="permissionArr.indexOf(\'order_total_qty\') !== - 1" style="position:relative"><span class="editable editable-click editable-disabled" data-name="Quantity" data-type="text" data-mode="popup" tabindex="-1">{{item.qty_ordered}}</span></td><td class="item-total" ng-if="permissionArr.indexOf(\'order_total_price\') !== - 1">${{item.total_price}}</td><td class="item-weight" ng-if="permissionArr.indexOf(\'order_total_weight\') !== - 1">{{ item.weight }} lbs</td></tr></tbody></table></div></div></div></div></div></div><div class="col-sm-12 col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Shipping Info" ng-if="permissionArr.indexOf(\'shipment_info\') !== - 1"><input type="hideen" name="entity_id" id="entity_id" value="{{ orderDetailsData.orderData.entity_id }}" style="display: none;"><div class="row" id="rowWeight"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Weight</label></div><div class="col-md-8 col-lg-8"><div class="col-md-4 pull-left" style="padding:0px"><input type="text" class="form-control" name="weight_lbs" id="weight_lbs" ng-model="weight_lbs" placeholder="lb" value="{{ total_weight }}" ng-keyup="getRate()"></div><div class="col-md-4" style="padding-left:2px;padding-right:2px"><input type="number" class="form-control" name="weight_oz" id="weight_oz" ng-model="weight_oz" placeholder="oz" value=""></div><div class="col-md-4 pull-right" style="padding:0px"></div></div></div><div class="row" id="rowService"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Service</label></div><div class="col-md-8 col-lg-8"><select class="form-control" name="service" id="service" placeholder="Please Select Service" ng-model="shippingservice" ng-change="changeShippingService(shippingservice)"><option value="">Please Select Service</option><option value="fedex">Fedex</option><option value="usps">USPS</option><option value="office">Office</option></select></div></div><div class="row" id="rowAccounts"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Accounts</label></div><div class="col-md-8 col-lg-8"><select class="form-control" name="account" id="account" placeholder="Please Select" ng-model="account" ng-change="changeShippingAccount(account)"><option value="">Please Select</option><option ng-repeat="acc in ShipmentAccounts" value="{{acc.account_id}}" ng-selected="{{acc.account_id == orderDetailsData.orderData.account_id }}">{{acc.account_company_name}}</option></select></div></div><div class="row" id="rowServiceType"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Service Type</label></div><div class="col-md-8 col-lg-8"><select class="form-control" name="service_type" id="service_type" placeholder="Please Select Service Type" ng-model="shippingservicetype" ng-change="changeShippingServiceType(shippingservicetype)"><option value="">Please Select Service Type</option><option ng-repeat="data in shipmentServiceType" value="{{ data.code }}">{{ data.label }}</option></select></div></div><div class="row" id="rowPackage"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Package Type</label></div><div class="col-md-7 col-lg-7"><select class="form-control" ng-if="custom_packages > 1" name="package1" id="package1" placeholder="Please Select" ng-model="package1" ng-change="changeShippingPackageType(package1)"><option value="">Please Select</option><option value="YOUR_PACKAGING">Custom Box</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}">{{sbox.service_box_label}}</option><option ng-if="shippingservice == \'usps\'" value="FlatRateEnvelope">Flat Rate Envelope</option><option ng-if="shippingservice == \'usps\'" value="FlatRateGiftCardEnvelope">Gift Card Envelopes</option><option ng-if="shippingservice == \'usps\'" value="FlatRateWindowEnvelope">Window Envelopes</option><option ng-if="shippingservice == \'usps\'" value="SmallFlatRateEnvelope">Small Envelopes</option><option ng-if="shippingservice == \'usps\'" value="FlatRateLegalEnvelope">Flat Rate Legal Envelope</option><option ng-if="shippingservice == \'usps\'" value="FlatRatePaddedEnvelope">Flat Rate Padded Envelope</option><option ng-if="shippingservice == \'usps\'" value="SmallFlatRateBox">Small Flat Rate Box</option><option ng-if="shippingservice == \'usps\'" value="MediumFlatRateBox">Medium Flat Rate Box</option><option ng-if="shippingservice == \'usps\'" value="LargeFlatRateBox">Large Flat Rate Box</option><option ng-if="shippingservice == \'usps\'" value="LargeFlatRateBoxAPOFPO">APO/FPO Box</option><option ng-if="shippingservice == \'usps\'" value="LargeFlatRateBoardGameBox">Large Board Game Box</option></select><select class="form-control" ng-if="custom_packages <= 1" name="package" id="package" placeholder="Please Select" ng-model="package" ng-change="changeShippingPackageType(package)"><option value="">Please Select</option><option ng-repeat="box in ShipmentBoxes" value="{{box.id}}">{{box.name}}</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}">{{sbox.service_box_label}}</option><option ng-if="shippingservice == \'usps\'" value="FlatRateEnvelope">Flat Rate Envelope</option><option ng-if="shippingservice == \'usps\'" value="FlatRateGiftCardEnvelope">Gift Card Envelopes</option><option ng-if="shippingservice == \'usps\'" value="FlatRateWindowEnvelope">Window Envelopes</option><option ng-if="shippingservice == \'usps\'" value="SmallFlatRateEnvelope">Small Envelopes</option><option ng-if="shippingservice == \'usps\'" value="FlatRateLegalEnvelope">Flat Rate Legal Envelope</option><option ng-if="shippingservice == \'usps\'" value="FlatRatePaddedEnvelope">Flat Rate Padded Envelope</option><option ng-if="shippingservice == \'usps\'" value="SmallFlatRateBox">Small Flat Rate Box</option><option ng-if="shippingservice == \'usps\'" value="MediumFlatRateBox">Medium Flat Rate Box</option><option ng-if="shippingservice == \'usps\'" value="LargeFlatRateBox">Large Flat Rate Box</option><option ng-if="shippingservice == \'usps\'" value="LargeFlatRateBoxAPOFPO">APO/FPO Box</option><option ng-if="shippingservice == \'usps\'" value="LargeFlatRateBoardGameBox">Large Board Game Box</option></select></div><div class="col-md-1 col-lg-1" style="padding-top: 10px"><a href="javascript:void(0)" ng-if="shippingservice != \'usps\'" ng-click="openPackageCreate()" style="font-size:20px; font-weight: bolder;">+</a></div></div><div class="row" id="custompackagecount" ng-if="custom_packages > 1"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Custom Packages</label></div><div class="col-md-9 col-lg-9" style="padding-top:10px">{{custom_packages}}</div></div><div class="row" id="rowSize"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Size</label></div><div class="col-md-8 col-lg-8"><div class="col-md-4 pull-left" style="padding:0px"><input type="number" class="form-control" placeholder="Length" name="len" id="len" ng-model="len" value=""></div><div class="col-md-4" style=""><input type="number" class="form-control" placeholder="Width" name="wgh" id="wgh" ng-model="wgh" value=""></div><div class="col-md-4 pull-right" style="padding:0px"><input type="number" class="form-control" placeholder="Height" name="hgt" id="hgt" ng-model="hgt" value=""></div></div></div><div class="row datepicker" id="rowShipDate"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Ship Date</label></div><div class="col-md-8 col-lg-8"><input type="text" name="shipDate" id="shipDate" class="form-control" uib-datepicker-popup="{{format}}" ng-model="dt" is-open="popup1.opened" datepicker-options="shipoptions" ng-required="true" close-text="Close" alt-input-formats="altInputFormats"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><button type="button" class="btn btn-default" ng-click="open1()">Ship Date</button></span></div></div><div class="row" id="rowRate"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Rate</label></div><div class="col-md-8 col-lg-8"><span class="text-success" id="displayRate" style="font-size: 20px; font-weight: bolder;"></span>&nbsp; <button type="button" ng-if="permissionArr.indexOf(\'get_rate\') !== - 1" ng-click="getRate()" id="getrate" class="btn btn-primary">Get Rate <i class="fa fa-refresh"></i></button> <button type="button" id="btncreatelabel" class="btn btn-sm btn-ship btn-success" ng-if="permissionArr.indexOf(\'create_label\') !== - 1" ng-click="createLabel()" ng-disabled="getRateDone">Create Label <i class="fa fa-bolt"></i></button> <span id="downloadlabelpdf"></span></div></div><div class="row" id="rowDeliveryTime"><div class="col-md-3 col-lg-3"><label class="pull-left">Delivery Time</label></div><div class="col-md-8 col-lg-8"><span class="shipping-deliv-time" id="displayDays" style="font-size: 20px; font-weight: bolder;"></span></div></div><div class="row" id="rowSatDel"><div class="col-md-3 col-lg-3" style="padding:10px"><label class="pull-left">Saturday Delivery</label></div><div class="col-md-8 col-lg-8"><input type="checkbox" name="satdelivery" id="satdelivery" ng-model="satdel" ng-click="getRateCheck()" value="saturday">Saturday Delivery</div></div><div class="row" id="rowOffice" style="display: none;padding:10px"><div class="col-md-3 col-lg-3" style=""></div><div class="col-md-8 col-lg-8"><span class="text-success" style="font-size: 20px; font-weight: bolder;"></span> <button type="button" ng-click="createOfficeShipped()" id="createofficeshipped" class="btn btn-success">Create Shipped <i class="fa fa-refresh"></i></button></div></div><div class="row" id="rowCreateLable"><div class="col-md-3 col-lg-3"></div><div class="col-md-8 col-lg-8"></div></div></div><div ba-panel="" ba-panel-title="Comments" ng-if="permissionArr.indexOf(\'shipment_comments\') !== - 1 && commentDataArr.length > 0"><div class="horizontal-scroll ng-scope"><div class="col-md-12" style="padding-bottom:5px"><table class="table table-bordered table-align mt-5px"><thead><tr><th>Order #</th><th>Date | Time</th><th>User Name</th><th>Comment</th></tr></thead><tbody><tr class="ng-scope" ng-repeat="com in commentDataArr"><td class="ng-binding">{{ com.item_id }}</td><td class="ng-binding">{{ getGlobalDateFormat(com.created_at) }}</td><td class="ng-binding">{{ com.username }}</td><td><div style="width:100px;overflow:hidden" title="{{ com.comment }}" class="ng-binding">{{ com.comment }}</div></td></tr></tbody></table></div></div></div></div></div></uib-tab></uib-tabset></div></div></uib-tab></uib-tabset></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><div id="orderDateChangeButton" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeChangeOrderDatePopUp()">&times;</button> <i class="fa fa-wrench" aria-hidden="true"></i><span>Confirmation for change order date</span></div><div class="modal-body text-center" style="font-size: 18px;">Are you sure you want to change the date?</div><div class="row"><div class="modal-body text-center" style="width: 75%; margin-left: 73px;"><div class="form-group row clearfix"><label for="onChangeStatusId" class="col-sm-4 control-label" style="margin-top: 8px;font-size: 15px;">Change status to<span class="asterisk_input"></span></label><div class="col-sm-8"><select id="onChangeStatusId" class="form-control" ng-model="onChangeStatus" name="onChangeStatus" style="font-size: 15px;"><option value="">Select Status</option><option ng-repeat="status in changeStatusButtonsOnClickStatus" value="{{status.status_code}}">{{status.status_label}}</option></select><span class="error" ng-show="!onChangeStatus">Please select change status.</span></div></div></div></div><div class="modal-footer"><button ng-disabled="!onChangeStatus" type="button" class="btn btn-primary" style="width: 60px;" ng-click="changeOrderCreatedDate()">Yes</button> <button type="button" class="btn btn-warning" style="width: 60px;" ng-click="closeChangeOrderDatePopUp()">No</button></div></div></div></div><div id="packageModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal" style="width: 35%;"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Packages</span> <button type="button" class="close" ng-click="closePackageCreate()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height" style="height: 800px"><div class="row"><div class="form-group"><label class="control-label col-sm-3" style="color:#000;">Package Type</label><div class="col-sm-9"><select class="form-control" name="main_package_type" id="main_package_type" placeholder="Please Select" ng-model="packagetype" ng-change="changeMainPackageType(packagetype)"><option value="">Please Select</option><option value="YOUR_PACKAGING">Custom Box</option><option ng-repeat="sbox in ShipmentServiceBoxes" value="{{sbox.service_box_3dcode}}">{{sbox.service_box_label}}</option></select></div></div><br></div><div class="row"><div class="col-sm-12"><div id="packagesrow" style="display: none;"><div class="row pkgrow" style="padding: 10px;"><div class="panel panel-default"><div class="panel-heading"><div style="float: left;width:100px;"><h4 class="panel-title">Package #1</h4></div><div style="float: right;margin-top:-10px;"><button type="button" class="copy btn btn-success" title="Copy Package"><i class="fa fa-copy"></i></button> <button type="button" class="remove btn btn-danger" title="Remove Package"><i class="fa fa-trash"></i></button></div></div><div class="panel-body row-fluid lite-pad"><form class="form form-horizontal"><div class="form-group"><label class="control-label col-sm-3">Description</label><div class="col-sm-9"><input type="text" class="form-control input-sm" name="description[]" id="description" placeholder="Description"></div></div><div class="form-group" id="custompackagetype"><label class="control-label col-sm-3">Package Type</label><div class="col-sm-9"><select class="form-control" name="package_type[]" id="package_type" placeholder="Please Select"><option value="">Please Select</option><option ng-repeat="box in ShipmentBoxes" value="{{box.id}}">{{box.name}}</option></select></div></div><div class="form-group"><div class="row"><div class="col-md-4 col-lg-3" style="padding:10px"><label class="pull-right">Size</label></div><div class="col-md-8 col-lg-9"><div class="col-md-4 pull-left" style="padding:0px"><input type="number" class="form-control" placeholder="L" name="len[]" id="len" value=""></div><div class="col-md-4" style=""><input type="number" class="form-control" placeholder="W" name="wgh[]" id="wgh" value=""></div><div class="col-md-4 pull-right" style="padding:0px"><input type="number" class="form-control" placeholder="H" name="hgt[]" id="hgt" value=""></div></div></div></div><div class="form-group"><label class="control-label col-sm-3">Weight (lbs)</label><div class="col-sm-9"><input type="number" class="form-control input-sm" name="weight[]" id="weight" value="" placeholder="0"></div></div></form></div></div></div></div><div id="packagesrow1"></div><div class="row" style="padding-top: 10px;"><div class="col-sm-12"><button type="button" class="btn btn-primary" ng-if="adpkg" ng-click="addpackage()">Add New Package</button></div></div></div></div></div><div class="modal-footer text-center"><div class="clearfix"><button type="button" class="btn btn-success btn-modal-ok pull-right" ng-click="savePackages()">Save Changes</button> <a class="btn btn-primary pull-left" ng-click="closePackageCreate()">Cancel</a></div></div></div></div></div><style>\n  .right-tab > .tab-content { max-height: {{popupSizeMin}}px; overflow-y: auto; }\n  .shipping-deliv-time { color: #6ba03a; font-size: 14px; }\n  .log-modal-height.modal-body { max-height: 700px; overflow-y: auto; }\n  #packageModel .panel-body { background: #FFF; }\n  #getrate.btn:hover {transform:none;}\n  td.item-description .btn:hover {transform:none;}\n  .form-group label { color:#000; }\n  #rowRate { padding-top: 10px; }\n  #rowDeliveryTime { padding-top: 10px; }\n  .input-group-addon-warning { background-color : #4F6DA2 !important; border-color:#4F6DA2 !important }\n</style>');
$templateCache.put('app/pages/shipment/orderReadyToShip/packageDetails.html','<style>\n  .right-tab > .tab-content\n  {\n    max-height: {{popupSizeMin}}px;\n    overflow-y: auto;\n  }\n  .shipping-deliv-time\n  {\n    color: #6ba03a;\n    font-size: 14px;\n  }\n  .log-modal-height.modal-body\n  {\n    max-height: {{borderSize}}px;\n    overflow-y: auto;\n  }\n</style><div id="packageDetailsModel" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content order-details-model"><div class="modal-body"></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><div id="orderLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Order Logs</span> <button type="button" class="close" ng-click="closeOrderLogs()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Item Status</th><th class="nStatus">New Item Status</th><th class="date">Date</th><th class="date">Action Type</th><th class="date">Transition Type</th></tr></thead><tbody><tr ng-repeat="data in orderLogsArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{data.old_status}}</td><td class="nStatus">{{data.new_status}}</td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td><td><span ng-if="data.action_type">{{data.action_type}}</span> <span ng-if="!data.action_type">--</span></td><td>{{data.transition_type?data.transition_type:\'-\'}}</td></tr><tr ng-if="!orderLogsArr.length"><td colspan="6" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="productLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Product Name Log</span> <button type="button" class="close" ng-click="closeProductLogModal()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Value</th><th class="nStatus">New Value</th><th class="date">Date | Time</th></tr></thead><tbody><tr ng-repeat="data in propLogsArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus"><div class="long-text-wrap">{{data.old_prodcutname}}</div></td><td class="nStatus"><div class="long-text-wrap">{{data.new_productname}}</div></td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td></tr><tr ng-if="!propLogsArr.length"><td colspan="4" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="engravingLogsModel" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Engraving Log</span> <button type="button" class="close" ng-click="closeEngravingLogModal()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!orderLogsLoaded">Loading....</div><div ng-if="orderLogsLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Old Value</th><th class="nStatus">New Value</th><th class="date">Date | Time</th></tr></thead><tbody><tr ng-repeat="data in engLogsArr"><td class="uName">{{data.user_name}}</td><td class="oldStatus"><div class="long-text-wrap">{{data.old_engravingname}}</div></td><td class="nStatus"><div class="long-text-wrap">{{data.new_engravingname}}</div></td><td class="date">{{getGlobalDateFormat(data.created_time)}}</td></tr><tr ng-if="!engLogsArr.length"><td colspan="4" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="openCopyProductDataLogPopUp" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Copy from product log</span> <button type="button" class="close" ng-click="closeCopyProductDataLogPopUp()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!copyProductDataLogLoaded">Loading....</div><div ng-if="copyProductDataLogLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">User Name</th><th class="oldStatus">Copy from which order number</th><th class="date">Date | Time</th></tr></thead><tbody><tr ng-repeat="data in copyProductDataArray"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{data.copy_from_item_increment_id}}</td><td class="date">{{getGlobalDateFormat(data.created_at)}}</td></tr><tr ng-if="!copyProductDataArray.length"><td colspan="3" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="orderDateChangeButton" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeChangeOrderDatePopUp()">&times;</button> <i class="fa fa-wrench" aria-hidden="true"></i><span>Confirmation for change order date</span></div><div class="modal-body text-center" style="font-size: 18px;">Are you sure you want to change the date?</div><div class="row"><div class="modal-body text-center" style="width: 75%; margin-left: 73px;"><div class="form-group row clearfix"><label for="onChangeStatusId" class="col-sm-4 control-label" style="margin-top: 8px;font-size: 15px;">Change status to<span class="asterisk_input"></span></label><div class="col-sm-8"><select id="onChangeStatusId" class="form-control" ng-model="onChangeStatus" name="onChangeStatus" style="font-size: 15px;"><option value="">Select Status</option><option ng-repeat="status in changeStatusButtonsOnClickStatus" value="{{status.status_code}}">{{status.status_label}}</option></select><span class="error" ng-show="!onChangeStatus">Please select change status.</span></div></div></div></div><div class="modal-footer"><button ng-disabled="!onChangeStatus" type="button" class="btn btn-primary" style="width: 60px;" ng-click="changeOrderCreatedDate()">Yes</button> <button type="button" class="btn btn-warning" style="width: 60px;" ng-click="closeChangeOrderDatePopUp()">No</button></div></div></div></div><div id="openChangeOrderDateLogDialog" class="modal fade" role="dialog"><div class="modal-dialog modal-lg log-modal"><div class="modal-content"><div class="modal-header bg-info-danger"><i class="ion-information-circled modal-icon"></i><span>Change order date log</span> <button type="button" class="close" ng-click="closeChangeOrderDateLogDialog()" aria-label="Close">\xD7</button></div><div class="modal-body text-center log-modal-height"><div ng-if="!changeOrderDateLogLoaded">Loading....</div><div ng-if="changeOrderDateLogLoaded" class="datatable-scroll"><table class="table table-bordered border-1px-solid"><thead><tr><th class="uName">Change By Name</th><th class="oldStatus">Old Date</th><th class="date">Current Date</th></tr></thead><tbody><tr ng-repeat="data in changeOrderDateLogArray"><td class="uName">{{data.user_name}}</td><td class="oldStatus">{{getGlobalDateFormat(data.old_date)}}</td><td class="date">{{getGlobalDateFormat(data.current_date)}}</td></tr><tr ng-if="!changeOrderDateLogArray.length"><td colspan="3" class="uName">No data available</td></tr></tbody></table></div></div></div></div></div><div id="damageSettingModalPopUp" class="modal fade rework-modal-color" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header bg-info-danger"><button type="button" class="close" ng-click="closeModalDamageSettingPopUp()">&times;</button> <i class="fa fa-chain-broken" aria-hidden="true"></i><span>Damage Crystal</span></div><form name="damageSettingForm" novalidate="" ng-submit="damageSettingForm.$valid && saveDamageCrystalReport()"><div class="modal-body modal-max-height"><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (damageSettingForm.damageReason.$error.required) && damageSettingForm.damageReason.$touched}"><label for="damageReason">Damage Reason <span class="asterisk_input"></span></label><select required="" id="damageReason" name="damageReason" class="form-control roleData" ng-model="damageReason"><option value="">Select Damage Reason</option><option ng-repeat="item in damageSettingReasonList" value="{{item.name}},{{item.set_default}}" ng-selected="item.set_default==\'1\'">{{item.name}}</option></select><span class="error" ng-show="damageSettingForm.$submitted && damageSettingForm.damageReason.$error.required">Please select Damage reason.</span></div></div><div class="col-md-6"><div class="form-group"><label for="input04">Created By</label> <input type="text" readonly="readonly" ng-model="globals.currentUser.name" class="form-control" placeholder="Created By"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': (damageSettingForm.damageFileOrder.$error.required) && damageSettingForm.damageFileOrder.$touched}"><label for="damageFileOrder">File Order <span class="asterisk_input"></span></label> <input required="" type="text" id="damageFileOrder" name="damageFileOrder" ng-model="dmageSettingPopUpItemIncrementId" class="form-control" placeholder="File Order" disabled=""> <span class="error" ng-show="damageSettingForm.$submitted && damageSettingForm.damageFileOrder.$error.required">Please enter file order.</span></div></div><div class="col-md-6"><div class="form-group"><label for="damageCrystalOrder">Raw material <span class="asterisk_input"></span></label> <input required="" type="text" id="damageCrystalOrder" name="damageCrystalOrder" ng-model="damagesettingCrystalOrder" class="form-control" placeholder="Raw material" uib-typeahead="orderno for orderno in getPrintCrystalItems($viewValue, orderId)" autocomplete="off" typeahead-focus-on-select="false" typeahead-select-on-blur="true"> <span id="error-raw-material" class="error" ng-show="damageSettingForm.$submitted && damageSettingForm.damageCrystalOrder.$error.required">Please enter raw material.</span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label for="damageSpecialInstruction">Special Instruction</label> <textarea rows="2" id="specialInstruction" name="damageSpecialInstruction" ng-model="damageSpecialInstruction" class="form-control" placeholder="Special Instruction"></textarea></div></div><div class="col-md-6"><div class="form-group"><input type="file" class="upload-file-manual" id="manualFileUploadx" name="manualFileUploadx" required="" accept=".png,.jpeg,.jpg" ng-click="hideDamageCrystalImageValidation()" style="width: 210px;"> <label for="manualFileUploadx"><i class="fa fa-upload fa-lg"></i><span id="manualFileUpload-text">Choose a file&hellip;</span></label></div></div><span class="error" id="error-damage-crystal-image-upload-file" style="margin-top: 10px;margin-left: 15px;font-size: 15px; display: none">Please select a file.</span> <span class="error" id="error-damage-crystal-image-upload-invalid-file" style="margin-top: 10px;margin-left: 15px;font-size: 15px; display: none">Please select PNG or JPEG or JPG file.</span></div></div><div class="modal-footer padding-top-0"><button type="submit" class="btn btn-primary">Apply</button> <button type="button" class="btn btn-warning" ng-click="closeModalDamageSettingPopUp()">Cancel</button></div></form></div></div></div>');
$templateCache.put('app/pages/shipment/orderReadyToShip/readytoship.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerOrder.date" type="text" placeholder="Select Date" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="input-group"><input id="orderNumber" type="text" rel="1" ng-model="rts.orderNumber" name="orderNumber" class="form-control" placeholder="Order Number"></div></div><div class="col-md-3"><div class="input-group"><input id="soldTo" type="text" rel="1" ng-model="rts.soldTo" name="soldTo" class="form-control" placeholder="Sold To"></div></div><div class="col-md-3"><div class="input-group"><input id="shipTo" type="text" rel="1" ng-model="rts.shipTo" name="shipTo" class="form-control" placeholder="Ship To"></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div ng-include="\'app/pages/shipment/orderReadyToShip/orderDetails.html\'"></div>');
$templateCache.put('app/pages/shipment/orderReadyToShip/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning !</span></div><div class="modal-body text-center">This account is not for this store</div><div class="modal-footer"><span ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1">Still You want to continue?</span>&nbsp; <button type="button" class="btn btn-success" ng-if="permissionArr.indexOf(\'allow_yes_account\') !== - 1" ng-click="yeschange();$dismiss();">Yes</button> <button type="button" class="btn btn-warning" ng-click="nochange();$dismiss()">No</button></div></div><style type="text/css">\n\tdiv.testclass {\n\t\tz-index: 1051 !important;\n\t}\n</style>');
$templateCache.put('app/pages/shipment/orderReadyToShip/warningModalVoidLabel.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning !</span></div><div class="modal-body text-center">This will void this label</div><div class="modal-footer"><span>Still You want to continue?</span>&nbsp; <button type="button" class="btn btn-success" ng-click="labelvoid(shipment_order_number, trackingnumber);$dismiss()">Yes</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">No</button></div></div><style type="text/css">\n\tdiv.testclass {\n\t\tz-index: 1051 !important;\n\t}\n</style>');
$templateCache.put('app/pages/shipment/shipmentCreate/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">{{ message }}</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/shipment/shipmentCreate/shipmentcreate.html','<div class="widgets profile role-permission" ba-panel="" ba-panel-title="Scanned Orders <span ng-if=\'storeUserName\' style=\'padding-left:25px;\'> Customer Name: {{ storeUserName }} </span> <span ng-if=\'storeUserName\' style=\'padding-left:25px;\'>From Date: {{ fromDate }} 00:00 AM </span> <span ng-if=\'storeUserName\' style=\'padding-left:25px;\'>To Date: {{ toDate }} 23:59 PM</span><div class=\'pull-right\'> <span ng-if=\'storeUserName\'>Total Items : {{totalItems}}</span> / <span ng-show=\'showItemScanned\'>Total Item Scanned : {{duplicateCheckRow.length}}</span> <span ng-show=\'showItemUpdated\'>Total Item Updated : {{updatedItem.length}}</span></div>"><div><form class="form-horizontal" name="changeStatusFrm" novalidate=""><div class="row"><div class="col-md-12 barcodeCont"><div class="form-group row clearfix"><a id="resetScan" class="btn btn-danger btn-with-icon reset-button" href="javascript:void(0);" ng-click="resetScan()"><i class="fa fa-undo"></i> Reset Scan</a> <button id="manualScan" type="button" class="btn btn-success btn-with-icon hide-element" ng-click="doneManualScan()"><i class="ion-android-checkmark-circle"></i>Done Scanning</button> <a ng-show="showItemScanned && duplicateCheckRow.length" class="btn btn-warning btn-with-icon save-cancel-btn" ng-click="resetScan()"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-show="doneScanning && showItemScanned && duplicateCheckRow.length" class="btn btn-primary btn-with-icon save-cancel-btn" ng-click="applyStatus()"><i class="ion-android-checkmark-circle"></i>Create Shipment</button><div class="col-md-3 col-sm-4 pull-right" ng-show="showItemScanned && duplicateCheckRow.length"></div></div><div class="row text-center" id="scanStart"><div class="col-md-offset-4"><div class="col-md-3 col-sm-5"><div class="dept-icon cursor-pointer" ng-click="showScan()"><img src="assets/img/barcode-scanner.png"> <span>Scan Barcode</span></div></div><div class="col-md-3 col-sm-5"><div class="dept-icon cursor-pointer" ng-click="showManualScan()"><i class="fa fa-barcode fa-4x" aria-hidden="true"></i> <span>Manual Scan</span></div></div></div></div><div class="viewOrder" id="viewOrder"><div><div class="col-md-12"><div id="tblOrder1" class="row form-group clearfix"><input type="text" ng-model="barcodeText" class="form-control" placeholder="Enter Order ID" id="txt-barcode" name="txt-barcode" ng-enter="scanBarcode(barcodeText,storeListId)" style="display:none"></div></div><div class="row"><div class="col-md-12 scan"><div class="horizontal-scroll"><table ng-show="isloaded" class="table table-bordered with-scroll row-border hover" id="tblOrder"><thead><tr style="display:none"><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th><th>sddsdsd</th></tr></thead><tbody></tbody></table></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></div></div></div></div></div></div><div class="row"><div class="pull-left summary-footer-barcode-scan"><span ng-if="showTotalItems">Total Items : {{totalItems}}</span>&nbsp;&nbsp; <span ng-show="showItemScanned">Total Item Scanned : {{duplicateCheckRow.length}}</span>&nbsp;&nbsp;</div><div class="btn-scan-barcode-scan"><a ng-show="showItemScanned && duplicateCheckRow.length" class="btn btn-warning btn-with-icon apply-cancel-margin" ng-click="resetScan()"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-show="doneScanning && showItemScanned && duplicateCheckRow.length" class="btn btn-primary btn-with-icon apply-cancel-margin" ng-click="applyStatus()"><i class="ion-android-checkmark-circle"></i>Create Shipment</button><div class="col-md-3 col-sm-4 pull-right" ng-show="showItemScanned && duplicateCheckRow.length"></div></div></div></form></div></div><div id="scan-popup-barcode"><div class="left"><h2>SCAN ORDERS...</h2><p><a href="javascript:void(0);" class="btn btn-warning btn-with-icon" ng-click="doneManualScan();">Done Scanning</a></p></div></div><div class="black_overlay" id="fade"></div>');
$templateCache.put('app/pages/shipment/shipmentCreate/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-android-success modal-icon"></i><span>Success !</span></div><div class="modal-body text-center" style="overflow: scroll;"><div ng-bind-html="to_trusted(message)" style="height: 20px;"></div></div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss();shipmentCreated();">OK</button></div></div>');
$templateCache.put('app/pages/shipment/shipmentCreate/warningMissingModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning !</span></div><div class="modal-body text-center" style="overflow: scroll;"><div ng-bind-html="to_trusted(message)" style="height: 250px;"></div></div><div class="modal-footer"><span ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1">Still You want to continue?</span>&nbsp; <button type="button" class="btn btn-success" ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1" ng-click="yesCreate();$dismiss()">Yes</button> <button type="button" class="btn btn-warning" ng-click="$dismiss();notadd();">No</button></div></div>');
$templateCache.put('app/pages/shipment/shipmentCreate/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Missing !</span></div><div class="modal-body text-center"><div ng-bind-html="to_trusted(message)"></div></div><div class="modal-footer"><span ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1">Still You want to continue?</span>&nbsp; <button type="button" class="btn btn-success" ng-if="permissionArr.indexOf(\'allow_yes\') !== - 1" ng-click="yesadd();$dismiss();">Yes</button> <button type="button" class="btn btn-warning" ng-click="notadd();$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/shipment/shippedList/shippedlist.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll" ng-controller="readytoshipListCtrl"><div class="row"><div class="col-md-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerOrder.date" type="text" placeholder="Select Date" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-md-3"><div class="input-group"><input id="orderNumber" type="text" rel="1" ng-model="spl.orderNumber" name="orderNumber" class="form-control" placeholder="Order Number"></div></div><div class="col-md-3"><div class="input-group"><input id="soldTo" type="text" rel="1" ng-model="spl.soldTo" name="soldTo" class="form-control" placeholder="Sold To"></div></div><div class="col-md-3"><div class="input-group"><input id="shipTo" type="text" rel="1" ng-model="spl.shipTo" name="shipTo" class="form-control" placeholder="Ship To"></div></div></div><div class="row"><div class="col-md-3 pull-right text-right"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTableShipped as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div ng-include="\'app/pages/shipment/orderReadyToShip/orderDetails.html\'"></div>');
$templateCache.put('app/pages/shippingTracker/common/common.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><form class="form-horizontal" name="shippingSupplyFrm" novalidate=""><div class="row"><div class="col-sm-6 col-lg-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerOrder.date" name="datePicker" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-6 col-lg-3"><button type="button" ng-click="searchApply()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div><div class="col-lg-3" ng-init="getActiveStatusData()"><div ng-if="isChangeStatus.change==true" class="form-group row clearfix"><div class="col-lg-8 col-sm-8 col-md-8"><ui-select ng-model="orderChangeStatus.statuscode" ng-disabled="false" search-enabled="true" append-to-body="true" class="btn-group bootstrap-select form-control reports" name="orderChangeStatus" id="orderChangeStatusId"><ui-select-match placeholder="Select Status">{{$select.selected.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatusList | filter: $select.search">{{status.status_label}}</ui-select-choices></ui-select></div><div class="col-lg-4 col-sm-4 col-md-4 pl-0 pr-0 text-left"><button type="button" ng-click="openChangeStatusModal()" class="btn btn-primary btn-icon"><i class="fa fa-check"></i></button> <button type="button" ng-click="cancelChangeStatus()" class="btn btn-danger btn-icon"><i class="fa fa-times"></i></button></div></div><button ng-if="isChangeStatus.change==false && permissionArr.indexOf(\'change_order_status\') !== - 1" type="button" ng-click="resetChangeStatus()" class="mb-10 btn btn-info btn-with-icon"><i class="ion-android-checkmark-circle"></i>Change Status</button></div><div class="col-lg-3 pull-right mb-10" ng-if="supplyOrderTotal.original.recordsTotal>0"><div ba-panel="" ba-panel-class="order-panel overflow-hidden">Orders : {{supplyOrderTotal.total}}</div></div></div></form><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div ng-include="\'app/pages/orders/changeStatusModal.html\'"></div><div ng-include="\'app/pages/orders/orderDetails.html\'"></div>');
$templateCache.put('app/pages/shippingTracker/figuringDashboard/figuringDashboard.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getTypeMaster(); resetManualDate(); getTotalInkStock();"><form class="form-horizontal" name="shippingDashboardFrm" novalidate=""><div class="row"><div class="col-sm-6 col-lg-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerRegular.date" name="datePicker" type="text" readonly="" required=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-6 col-lg-3"><button type="button" ng-click="applyFilter()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetFilter()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div><div class="col-lg-6 pull-right mb-10" ng-if="regularFlag==true"><div ng-if="colour_stock_data.length>0" ba-panel="" ba-panel-class="order-panel myclass" ng-repeat="csdata in colour_stock_data">{{csdata.colour_name}} : {{csdata.colour_stock}}</div><div ba-panel="" ba-panel-class="order-panel">Stock : {{totalInkStock}}</div></div></div><div ng-init="getDynamicStickerCounter()" ng-if="regularFlag==true"><div class="row"><div class="dash-block-width col-md-6 col-sm-6" ng-repeat="(key,chart) in pieChartArr" ng-if="permissionArr.indexOf(\'view-pie-chart-shipping-dashboard-\'+ key) !== -1"><div ba-panel="" ba-panel-title="{{key}}" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row" style="height: 140px"><canvas ng-if="chart.value.length>0" id="doughnut" chart-options="pieChartOptions" chart-colors="chart.color" class="chart chart-doughnut" chart-data="chart.value" chart-labels="chart.lable" chart-click="changeData"></canvas><div style="font-size:15px;top:62%;z-index:-1" class="traffic-text">{{piechartData[key][2]}} <span style="font-size:12px;line-height: 7px;">%</span></div></div></div><div ng-if="permissionArr.indexOf(\'type-setting-\'+ pieChartArrData[key].sticker_type) !== -1" ng-init="getDynamicStickerDetails(pieChartArrData[key].sticker_type, key, pieChartArrData[key])" class="sticker-container"><div class="sticker-header" ng-style="{\'background-color\':obj[key].regStatusColor}"><div class="sticker-order" title="{{obj[key].regStatus}}"><span ng-bind="obj[key].regStatus"></span></div><div><span ng-bind="obj[key].regTotalOrder"></span>/<span ng-bind="obj[key].regTotalProduct"></span> Orders</div></div><div class="sticker-body text-center"><button type="button" ng-disabled="!obj[key].regTotalOrder && !obj[key].regTotalProduct" ng-click="downloadDynamicSticker(pieChartArrData[key])" class="btn btn-danger btn-with-icon"><i class="fa fa-sticky-note-o"></i>{{obj[key].stickerType}}</button></div></div></div></div></div><h3 class="with-line"></h3><div class="row" ng-init="regularFlag==true?getShippingData():\'\'"><div ng-if="storeData.length>0" class="col-lg-2 col-md-4 col-sm-4 margin-top-10" ng-repeat="(key,ship) in storeData"><button type="button" ng-click="open(ship.display_name,\'order-details-popup\',ship.id,ship.username)" ng-style="{\'background-color\':ship.color,\'border-color\':ship.color}" class="btn btn-default btn-with-icon btn-xm shipping-btn min-width-150 white-space-normal"><div class="textclassforcurt" title="{{ship.display_name}} {{ship.position_id}}">{{ship.display_name}} {{ship.position_id}}</div><img class="pull-right" ng-src="assets/img/{{ship.img}}.png" alt="skull" height="20" width="20"></button></div><div ng-if="storeData.length<=0" class="text-center"><span>No data available</span></div></div></form></div><style type="text/css">\n   .myclass\n   {\n      font-weight: bold;\n      text-align: center;\n      width:75px;\n   }\n</style>');
$templateCache.put('app/pages/shippingTracker/figuringDashboard/orderStatusModal.html','<div class="modal-content" ng-init="getRegularStatus()" ng-style="{\'height\': popupSize}"><div class="modal-header bg-info"><div class="row text-center"><div class="col-md-3" ng-init="getRegularStickerdetails()"><div class="dwnldstckr"><button type="button" ng-disabled="designCompleteTotalOrder == 0 && designCompleteTotalProduct == 0" ng-click="downloadUserSticker(\'print\',storeUserName)" class="pull-left btn btn-danger btn-with-icon"><i class="fa fa-download"></i>Download Sticker</button><p class="text-dec">({{designCompleteTotalOrder}}/{{designCompleteTotalProduct}})</p></div></div><div class="col-md-9"><h3 class="col-md-9 col-sm-9">{{storeName}} ({{fromDate}} To {{toDate}}) ({{regOrderTotal?regOrderTotal:0}})</h3><button type="button" class="pull-left btn btn-primary btn-with-icon" ng-if="readyshipment" ng-click="gotoShipmentCreate(storeUserName)"><i class="fa fa-truck"></i> Shipment</button> <button type="button" class="close close-details" ng-click="$dismiss();closePopup();" aria-label="Close">&times;</button></div></div></div><div class="modal-body shipping-modal"><div ng-if="popupSize == 201" class="margin-top-12 text-center" style="margin-top:20px;color: black">No status found</div><div ng-if="popupSize != 201" class="row margin-top-10"><div class="col-md-12"><div class="pie-charts"><div ng-if="key" class="col-md-3 col-sm-6" ng-repeat="(key,value) in statusData"><div ng-click="searchOnOrderList(key,value.status_code,\'all\',fromDate,toDate,storeName)" class="cursor-pointer regular-status-box" ng-style="{\'background-color\':value.color_code?value.color_code:\'#000\'}"><div class="pie-chart-item"><div class="description padding-0"><div class="title-pichart" title="{{ key }}"><div class="cut-text">{{ key }}</div></div><div ng-class="{\'font16px\':chart.smallFont}" class="description-total">Total Orders: {{value.total_orders}}</div><div ng-class="{\'font16px\':chart.smallFont}" class="description-stats">Total Items: {{value.item_total}}</div></div></div></div></div></div></div></div></div><div class="modal-footer"></div></div><style>\n  .shipping-modal.modal-body {\n    max-height: {{popupSizeMin}}px;\n    overflow-y:scroll;\n    overflow-x:hidden;\n  }\n</style>');
$templateCache.put('app/pages/shippingTracker/regular/orderStatus.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-sm-6 col-lg-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerRegular.date" type="text" readonly=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-6 col-lg-3"><button type="button" ng-click="getRegularStatus()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetSearch()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div></div><h3 class="with-line"></h3><div class="row shipping-modal" ng-init="getRegularStatus()"><div class="col-md-12"><div ng-if="popupSize == 201" class="margin-top-12 text-center" style="margin-top:20px;">No status found</div><div ng-if="popupSize != 201" class="pie-charts"><div ng-if="key" class="col-md-3 col-sm-6" ng-repeat="(key,value) in statusData"><div ng-click="searchOnOrderList(key,value.status_code)" class="cursor-pointer regular-status-box" ng-style="{\'background-color\':value.color_code?value.color_code:\'#000\'}"><div class="pie-chart-item"><div class="description padding-0"><div class="title-pichart" title="{{ key }}"><div class="cut-text">{{ key }}</div></div><div ng-class="{\'font16px\':chart.smallFont}" class="description-total">Total Orders: {{value.total_orders}}</div><div ng-class="{\'font16px\':chart.smallFont}" class="description-stats">Total Items: {{value.item_total}}</div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/shippingTracker/regular/regular.html','<div class="widgets profile" ba-panel="" ba-panel-class="with-scroll"><div class="row"><div class="col-lg-3" ng-init="getActiveStatusData()"><div ng-if="isChangeStatus.change==true" class="form-group row clearfix"><div class="col-lg-8 col-sm-8 col-md-8"><ui-select ng-model="orderChangeStatus.statuscode" ng-disabled="false" search-enabled="true" append-to-body="true" class="btn-group bootstrap-select form-control reports" name="orderChangeStatus" id="orderChangeStatusId"><ui-select-match placeholder="Select Status">{{$select.selected.status_label}}</ui-select-match><ui-select-choices repeat="status.status_code as status in orderStatusList | filter: $select.search">{{status.status_label}}</ui-select-choices></ui-select></div><div class="col-lg-4 col-sm-4 col-md-4 pl-0 pr-0 text-left"><button type="button" ng-click="openChangeStatusModal()" class="btn btn-primary btn-icon"><i class="fa fa-check"></i></button> <button type="button" ng-click="cancelChangeStatus()" class="btn btn-danger btn-icon"><i class="fa fa-times"></i></button></div></div><button ng-if="isChangeStatus.change==false && permissionArr.indexOf(\'change_order_status\') !== - 1" type="button" ng-click="resetChangeStatus()" class="mb-10 btn btn-info btn-with-icon"><i class="ion-android-checkmark-circle"></i>Change Status</button></div><div class="col-md-6 col-sm-12 pull-right"><a ui-sref="shipping-board.regular-status" class="btn btn-warning btn-with-icon pull-right"><i class="fa fa-arrow-left"></i>Back</a><div ba-panel="" ba-panel-class="order-panel overflow-hidden"><span ng-if="storeName?storeName:\'\'">{{storeName}}</span> ( {{getDateByFormat(datePickerRegular.date.startDate,\'YYYY-MM-DD\')}} To {{getDateByFormat(datePickerRegular.date.endDate,\'YYYY-MM-DD\')}} )</div></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns" dt-instance="showCase.dtInstance"></table></div></div></div></div><div ng-include="\'app/pages/orders/changeStatusModal.html\'"></div><div ng-include="\'app/pages/orders/orderDetails.html\'"></div>');
$templateCache.put('app/pages/shippingTracker/shippingBlock/shippingBlock.html','<div class="widgets profile shipping-tracker" ba-panel=""><div ng-init="getSelectedStatusData()"><form class="form-horizontal" name="shippingFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="saveShippingBlockStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="isloaded" class="row"><div class="col-md-4"><div class="row" ng-init="getActiveStatusData()"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Status" ba-panel-class="light-text with-scroll"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="vm.orderStatusData"><tr ng-repeat="status in vm.orderStatusData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="{{sts.block}}" ba-panel-class="light-text with-scroll" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptionStatus" ng-model="sts.status"><tr ng-if="sts.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}} <a ng-click="removeRegularStatus(item,sts.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><button type="submit" ng-click="saveShippingBlockStatus()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/shippingTracker/shippingTrackerDashboard/orderStatusModal.html','<div class="modal-content" ng-init="getRegularStatus()" ng-style="{\'height\': popupSize}"><div class="modal-header bg-info"><div class="row text-center"><div class="col-md-3" ng-init="getRegularStickerdetails()"><div class="dwnldstckr"><button type="button" ng-disabled="designCompleteTotalOrder == 0 && designCompleteTotalProduct == 0" ng-click="downloadUserSticker(\'print\',storeUserName)" class="pull-left btn btn-danger btn-with-icon"><i class="fa fa-download"></i>Download Sticker</button><p class="text-dec">({{designCompleteTotalOrder}}/{{designCompleteTotalProduct}})</p></div></div><div class="col-md-9"><h3 class="col-md-9 col-sm-9">{{storeName}} ({{fromDate}} To {{toDate}}) ({{regOrderTotal?regOrderTotal:0}})</h3><button type="button" class="pull-left btn btn-primary btn-with-icon" ng-if="readyshipment" ng-click="gotoShipmentCreate(storeUserName)"><i class="fa fa-truck"></i> Shipment</button> <button type="button" class="close close-details" ng-click="$dismiss();closePopup();" aria-label="Close">&times;</button></div></div></div><div class="modal-body shipping-modal"><div ng-if="popupSize == 201" class="margin-top-12 text-center" style="margin-top:20px;color: black">No status found</div><div ng-if="popupSize != 201" class="row margin-top-10"><div class="col-md-12"><div class="pie-charts"><div ng-if="key" class="col-md-3 col-sm-6" ng-repeat="(key,value) in statusData"><div ng-click="searchOnOrderList(key,value.status_code,\'all\',fromDate,toDate,storeName)" class="cursor-pointer regular-status-box" ng-style="{\'background-color\':value.color_code?value.color_code:\'#000\'}"><div class="pie-chart-item"><div class="description padding-0"><div class="title-pichart" title="{{ key }}"><div class="cut-text">{{ key }}</div></div><div ng-class="{\'font16px\':chart.smallFont}" class="description-total">Total Orders: {{value.total_orders}}</div><div ng-class="{\'font16px\':chart.smallFont}" class="description-stats">Total Items: {{value.item_total}}</div></div></div></div></div></div></div></div></div><div class="modal-footer"></div></div><style>\n  .shipping-modal.modal-body {\n    max-height: {{popupSizeMin}}px;\n    overflow-y:scroll;\n    overflow-x:hidden;\n  }\n</style>');
$templateCache.put('app/pages/shippingTracker/shippingTrackerDashboard/shippingTrackerDashboard.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="getTypeMaster(); resetManualDate();"><form class="form-horizontal" name="shippingDashboardFrm" novalidate=""><div class="row"><div class="col-sm-6 col-lg-3"><div class="input-group"><input id="dateRange" date-range-picker="" aria-describedby="basic-addon2" class="form-control date-picker with-warning-addon" options="options" ng-model="datePickerRegular.date" name="datePicker" type="text" readonly="" required=""> <span ng-click="focusInput()" class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2"><i class="fa fa-calendar"></i></span></div></div><div class="col-sm-6 col-lg-3"><button type="button" ng-click="applyFilter()" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Apply</button> <button type="button" ng-click="resetFilter()" class="btn btn-primary btn-with-icon"><i class="ion-android-warning"></i>Reset</button></div><div class="col-lg-6 pull-right mb-10" ng-if="regularFlag==true"><div ba-panel="" ba-panel-class="order-panel">Orders : {{totalCounterShow}}</div></div></div><div ng-init="getDynamicStickerCounter()" ng-if="regularFlag==true"><div class="row"><div class="dash-block-width col-md-6 col-sm-6" ng-repeat="(key,chart) in pieChartArr" ng-if="permissionArr.indexOf(\'view-pie-chart-shipping-dashboard-\'+ key) !== -1"><div ba-panel="" ba-panel-title="{{key}}" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row" style="height: 140px"><canvas ng-if="chart.value.length>0" id="doughnut" chart-options="pieChartOptions" chart-colors="chart.color" class="chart chart-doughnut" chart-data="chart.value" chart-labels="chart.lable" chart-click="changeData"></canvas><div style="font-size:15px;top:62%;z-index:-1" class="traffic-text">{{piechartData[key][2]}} <span style="font-size:12px;line-height: 7px;">%</span></div></div></div><div ng-if="permissionArr.indexOf(\'type-setting-\'+ pieChartArrData[key].sticker_type) !== -1" ng-init="getDynamicStickerDetails(pieChartArrData[key].sticker_type, key, pieChartArrData[key])" class="sticker-container"><div class="sticker-header" ng-style="{\'background-color\':obj[key].regStatusColor}"><div class="sticker-order" title="{{obj[key].regStatus}}"><span ng-bind="obj[key].regStatus"></span></div><div><span ng-bind="obj[key].regTotalOrder"></span>/<span ng-bind="obj[key].regTotalProduct"></span> Orders</div></div><div class="sticker-body text-center"><button type="button" ng-disabled="!obj[key].regTotalOrder && !obj[key].regTotalProduct" ng-click="downloadDynamicSticker(pieChartArrData[key])" class="btn btn-danger btn-with-icon"><i class="fa fa-sticky-note-o"></i>{{obj[key].stickerType}}</button></div></div></div></div></div><h3 class="with-line"></h3><div class="row" ng-init="regularFlag==true?getShippingData():\'\'"><div ng-if="storeData.length>0" class="col-lg-2 col-md-4 col-sm-4 margin-top-10" ng-repeat="(key,ship) in storeData"><button type="button" ng-click="open(ship.display_name,\'order-details-popup\',ship.id,ship.username)" ng-style="{\'background-color\':ship.color,\'border-color\':ship.color}" class="btn btn-default btn-with-icon btn-xm shipping-btn min-width-150 white-space-normal"><div class="textclassforcurt" title="{{ship.display_name}} {{ship.position_id}}">{{ship.display_name}} {{ship.position_id}}</div><img class="pull-right" ng-src="assets/img/{{ship.img}}.png" alt="skull" height="20" width="20"></button></div><div ng-if="storeData.length<=0" class="text-center"><span>No data available</span></div></div></form></div>');
$templateCache.put('app/pages/shippingTracker/shippingTrackerSettings/dashboardPreview.html','<div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveDashboardOrder()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="shipping-board.shipping-settings" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><div class="col-md-4" ng-init="getShippingData()"><div class="row"><span class="col-sm-12 mb-10">Set Order by Just dragging Customer data up-down.</span><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="All Customers" ba-panel-class="light-text with-scroll"><div ng-if="!previewLoaded"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div><table ng-if="previewLoaded" class="table border-none shipping"><tbody as-sortable="sortableOptions" ng-model="storeData"><tr ng-if="storeData.length>0" ng-repeat="(key,ship) in storeData" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><button type="button" ng-style="{\'background-color\':\'#d9534f\',\'border-color\':\'#d43f3a\'}" class="btn btn-default btn-with-icon btn-xm shipping-btn cursor min-width-150 white-space-normal"><div class="textclassforcurt" title="{{ship.display_name}} {{ship.position_id}}">{{ship.display_name}} {{ship.position_id}}</div></button></td></tr><tr ng-if="storeData.length<=0"><td>No data</td></tr></tbody></table></div></div></div></div></div><div class="row"><div class="col-sm-12 col-md-12"><button type="button" ng-click="saveDashboardOrder()" class="btn btn-primary btn-with-icon save-permission"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="shipping-board.shipping-settings" class="btn btn-warning btn-with-icon save-permission"><i class="ion-android-warning"></i>Cancel</a></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/shippingTracker/shippingTrackerSettings/shippingTrackerSettings.html','<div class="widgets profile shipping-tracker" ba-panel=""><div ng-init="getSelectedStatusData()"><form class="form-horizontal" name="shippingFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="shipping-board.dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveShippingTrackerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ng-if="permissionArr.indexOf(\'preview_dashboard\') !== -1" ui-sref="shipping-board.preview-dashboard" type="button" class="btn btn-warning pull-right btn-with-icon"><i class="fa fa-sort"></i>Manage Sequence</button></div></div><div ng-show="isloaded" class="panel-heading-padding row"><div class="col-md-4"><div class="row" ng-init="getRegularStatusData()"><div class="col-sm-12 col-xs-12 col-md-12"><div class="column"><div id="status" ba-panel="" ba-panel-title="<label style=\'background-color:#00abff\'>All Status</label>" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableCloneOptions" ng-model="stc.regularStatusData"><tr ng-repeat="status in stc.regularStatusData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" ng-style="{\'background-color\':status.color_code};" class="status-label cursor">{{status.status_label}}</span></td></tr></tbody></table></div></div></div></div></div><div class="dept-height" ng-style="{\'max-height\': windowHeight+ \'px\'}"><div class="col-md-6" ng-repeat="set in setOfSets"><div ba-panel="" ba-panel-title="<label ng-style={\'background-color\':sts._id.color_code}>{{sts._id.block}} <img class=\'pull-right m-top-8\' ng-src=\'assets/img/{{sts._id.img}}.png\' alt=\'skull\' height=\'20\' width=\'20\'></label>" ba-panel-class="light-text with-scroll shipping-inner-panel" ng-repeat="sts in set"><table class="table border-none"><tbody as-sortable="sortableOptionStatus" ng-model="sts.status"><tr ng-if="sts.status.length==0" as-sortable-item=""><td as-sortable-item-handle="" class="align-left">&nbsp;</td></tr><tr ng-repeat="item in sts.status" as-sortable-item=""><td class="align-left" as-sortable-item-handle=""><span ng-style="{\'background-color\':item.color_code};" class="status-label cursor">{{item.status_label}} <a ng-click="removeRegularStatus(item,sts.status)" data-no-drag="" class="btn btn-xs color-white"><span class="glyphicon glyphicon-remove"></span></a></span></td></tr></tbody></table></div></div></div></div><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveShippingTrackerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/stickerSettings/3dcategory/addOnRepeat.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="extra.set_default=\'0\';bg.set_default=\'0\';eng.set_default=\'0\'"><div ng-init="getAddOnRepeatData()"><form class="form-horizontal" name="addOnRepeatFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="saveAddOnRepeatSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>3DCategory</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">3DCategory</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-10-per">3D Category Name</th><th class="width-25-per">3D Category Title</th><th class="width-20-per">3D Price</th><th class="width-20-per">Our Cost</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'cat\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="cat.catData.length > 0" ng-repeat="exp in cat.catData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemNameExp-{{$index}}"><input only-caracter="" type="text" ng-model="exp.name" limit-to="30" value="{{exp.name}}" ng-maxlength="30" name="itemName" required="" class="form-control height28px" placeholder="3Dcategory Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExp-{{$index}}"><input only-caracter="" type="text" ng-model="exp.title" limit-to="50" value="{{exp.title}}" ng-maxlength="50" name="itemTitle" required="" class="form-control height28px" placeholder="3Dcategory Title"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExp-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="exp.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height28px" placeholder="3Dcategory Price"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemPriceExp-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="exp.price" limit-to="30" ng-maxlength="30" name="itemPrice" required="" class="form-control height28px" placeholder="Our Cost"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'cat\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="cat.catData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="saveAddOnRepeatSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/3dcategory/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/addOnRepeat/addOnRepeat.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="extra.set_default=\'0\';bg.set_default=\'0\';eng.set_default=\'0\'"><div ng-init="getAddOnRepeatData()"><form class="form-horizontal" name="addOnRepeatFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="saveAddOnRepeatSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Extra People</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Add Extra People</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Number of Person</th><th class="width-45-per">Price</th><th class="width-45-per">Set As Default</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'extrapeople\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="aor.extraPeopleData.length > 0" ng-repeat="extra in aor.extraPeopleData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExtra-{{$index}}"><input only-caracter="" type="text" ng-model="extra.name" limit-to="30" value="{{extra.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height28px" placeholder="Number of Person"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExtra-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="extra.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height28px" placeholder="Price"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemDefaultExtra-{{$index}}"><select class="form-control roleData height28px" ng-model="extra.set_default" name="itemDefault" id="itemDefault"><option value="0" ng-selected="extra.set_default==\'0\'">0</option><option value="1" ng-selected="extra.set_default==\'1\'">1</option></select></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'extrapeople\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="aor.extraPeopleData.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Express</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Express Type</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Type</th><th class="width-45-per">Price</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="aor.expressData.length > 0" ng-repeat="exp in aor.expressData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExp-{{$index}}"><input only-caracter="" type="text" ng-model="exp.name" limit-to="30" value="{{exp.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height28px" placeholder="Express Type"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExp-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="exp.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height28px" placeholder="Price"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="aor.expressData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Background</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Background</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Background</th><th class="width-45-per">Price</th><th class="width-45-per">Set As Default</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'background\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="aor.backgroundData.length > 0" ng-repeat="bg in aor.backgroundData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleBG-{{$index}}"><input only-caracter="" type="text" ng-model="bg.name" limit-to="30" value="{{bg.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height28px" placeholder="Background"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueBG-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="bg.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height28px" placeholder="Price"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemDefaultBG-{{$index}}"><select class="form-control roleData height28px" ng-model="bg.set_default" name="itemDefault" id="itemDefault"><option value="0" ng-selected="bg.set_default==\'0\'">0</option><option value="1" ng-selected="bg.set_default==\'1\'">1</option></select></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'background\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="aor.backgroundData.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Engraving</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Engraving</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Engraving</th><th class="width-45-per">Price</th><th class="width-45-per">Set As Default</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'engraving\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="aor.engravingData.length > 0" ng-repeat="eng in aor.engravingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleEng-{{$index}}"><input only-caracter="" type="text" ng-model="eng.name" limit-to="30" value="{{eng.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height28px" placeholder="Engraving"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueEng-{{$index}}"><input type="number" is-number-key="" min="0" ng-model="eng.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height28px" placeholder="Price"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemDefaultEng-{{$index}}"><select class="form-control roleData height28px" ng-model="eng.set_default" name="itemDefault" id="itemDefault"><option value="0" ng-selected="eng.set_default==\'0\'">0</option><option value="1" ng-selected="eng.set_default==\'1\'">1</option></select></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'engraving\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="aor.engravingData.length < 1"><td colspan="4">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="button" ng-click="saveAddOnRepeatSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/addOnRepeat/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/customerSticker/customerSticker.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="vm.availableOrderStatus=\'0\';vm.finalOrderStatus=\'0\'"><div ng-init="getCustomerStickerData()"><form class="form-horizontal" name="customerStickerFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveCustomerStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.customer-sticker-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Customer Sticker Preview</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Customer Sticker Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Customer Available Order With Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.availableOrderStatus" name="availableOrderStatus" id="availableOrderStatus"><option value="0">Customer Available Order With Status</option><option value="{{status.status_code}}" ng-selected="vm.availableOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="finalOrderStatus" class="col-md-3 control-label">Customer Final Order Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.finalOrderStatus" name="finalOrderStatus" id="finalOrderStatus"><option value="0">Customer Final Order Status</option><option value="{{status.status_code}}" ng-selected="vm.finalOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="maxOrderNumber" class="col-md-3 control-label">Customer Maximum Order Number Per PDf Document</label><div class="col-md-4"><input type="number" is-number-key="" min="1" ng-model="vm.maxOrderNumber" class="form-control" placeholder="Customer Maximum Order Number"></div></div><div class="form-group row"><label for="displayIcon" class="col-sm-3 control-label">Display Icon</label><div class="col-sm-4"><ba-switcher switcher-style="primary" switcher-value="vm.displayIcon" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Customer Label Print Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="printLabel" class="col-md-3 control-label">Customer Select Label To Print</label><div class="col-md-4"><ui-select multiple="" ng-model="vm.printLabel" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Select Label To Print">{{$item.label_name}}</ui-select-match><ui-select-choices repeat="multipleItem in printLabelData | filter: $select.search">{{multipleItem.label_name}}</ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Customer Font Size Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Customer Enter Entity To Print Custom Font</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Entity Name</th><th class="width-45-per">Font Size</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'fontsize\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.fontSizeData.length > 0" ng-repeat="item in vm.fontSizeData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleFont-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Entity Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueFont-{{$index}}"><input type="number" is-number-key="" min="1" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Font Size"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'fontsize\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.fontSizeData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Customer Layaway Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Customer Select Layaway Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Layaway Label</th><th class="width-45-per">Layaway Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'layaway\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.layAwayLabelData.length > 0" ng-repeat="item in vm.layAwayLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleLayaway-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Layaway Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueLayaway-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Layaway Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'layaway\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.layAwayLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Customer Shipping Method Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Customer Select Shipping Method To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Shipping Method</th><th class="width-45-per">Shipping Method Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'shipping\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.shippingData.length > 0" ng-repeat="item in vm.shippingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleShipping-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Shipping Method"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueShipping-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Shipping Method Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'shipping\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.shippingData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Customer Express Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Customer Select Express Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Label</th><th class="width-45-per">Express Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="vm.expressLabelData.length > 0" ng-repeat="item in vm.expressLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExpress-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Express Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExpress-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Express Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="vm.expressLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveCustomerStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.customer-sticker-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Customer Sticker Preview</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/customerSticker/customerStickerPreview.html','<div ba-panel="" ba-panel-class="with-scroll role-permission"><div class="panel-content" ng-init="getCustomerStickerData();getCustomerPreviewData();"><div class="row"><div class="col-sm-12 col-md-12"><span>Set Label Order by Just dragging label up-down.</span> <a ui-sref="sticker-settings.customer-sticker" class="btn btn-warning save-permission btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveCustomerStickerOrder()" class="btn btn-success btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-5"><div class="column"><div id="status" ba-panel="" ba-panel-title="Customer Sticker Labels" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="vm.customerPreviewData"><tr ng-if="vm.customerPreviewData.length>0" ng-repeat="label in vm.customerPreviewData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor" ng-style="{\'font-size\':label.font?(label.font+3):15}">{{label.label_name}}</span></td></tr><tr ng-if="vm.customerPreviewData.length<=0"><td>No data</td></tr></tbody></table></div></div></div><div class="col-md-7" ng-if="vm.customerPreviewData.length>0"><div class="sticker"><ul class="pl-mb-0" style="list-style-type: none;"><li ng-repeat="label in vm.firstArray" class="text-center pt-5px"><span ng-if="(label.label_code != \'barcode\' || label.label_code != \'encrypted_barcode\') && label.label_code != \'layaway\' && label.label_code != \'express\'" ng-style="{\'font-size\':label.font?(label.font+4):15}">{{label.label_name}}</span><div ng-if="label.label_code == \'barcode\' || label.label_code == \'encrypted_barcode\'"><img src="assets/img/barcode-image.jpg" alt="barcode" width="210" height="45"></div></li></ul><div ng-if="(typeListkey[\'express\'] || typeListkey[\'layaway\'])" class="pt-5px clearfix"><span ng-if="typeListkey[\'layaway\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-right right-lable-stcr">{{typeListkey[\'layaway\']}}</span> <span ng-if="typeListkey[\'express\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-left left-lable-stcr">{{typeListkey[\'express\']}}</span></div></div></div></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/stickerSettings/customerSticker/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/damageSticker/damageSticker.html','<div class="widgets profile faqfrontend" ba-panel=""><div ng-init="getActiveAndEditedStatus()"><form class="form-horizontal" name="damageStickerFrm" novalidate=""><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveDamageStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div><uib-accordion close-others="oneAtATime"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Regular Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="changeRegularStatus" class="col-md-3 control-label">Status after regular reprint sticker</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.changeRegularStatus" name="changeRegularStatus" id="changeRegularStatus"><option value="">Select Status</option><option value="{{status.status_code}}" ng-selected="vm.changeRegularStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Express Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="changeExpressStatus" class="col-md-3 control-label">Status after express reprint sticker</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.changeExpressStatus" name="changeExpressStatus" id="changeExpressStatus"><option value="">Select Status</option><option value="{{status.status_code}}" ng-selected="vm.changeExpressStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Rework Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="changeReworkStatus" class="col-md-3 control-label">Status after rework reprint sticker</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.changeReworkStatus" name="changeReworkStatus" id="changeReworkStatus"><option value="">Select Status</option><option value="{{status.status_code}}" ng-selected="vm.changeReworkStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Customer Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="changeCustomerStatus" class="col-md-3 control-label">Status after customer reprint sticker</label><div class="col-md-4"><select class="form-control roleData" ng-model="vm.changeCustomerStatus" name="changeCustomerStatus" id="changeCustomerStatus"><option value="">Select Status</option><option value="{{status.status_code}}" ng-selected="vm.changeCustomerStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div></div></div></uib-accordion-group></uib-accordion><div class="row"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveDamageStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/dynamicSticker/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/dynamicSticker/printPreview.html','<div ba-panel="" ba-panel-class="with-scroll role-permission"><div class="panel-content" ng-init="getPrintPreviewData();getPrintStickerData()"><div class="row"><div class="col-sm-12 col-md-12"><span>Set Label Order by Just dragging label up-down.</span> <a ng-click="doTheBack()" class="btn btn-warning save-permission btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintPreviewOrder()" class="btn btn-success btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-5"><div class="column"><div id="status" ba-panel="" ba-panel-title="Sticker Labels" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="ps.printPreviewData"><tr ng-if="ps.printPreviewData.length>0" ng-repeat="label in ps.printPreviewData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor" ng-style="{\'font-size\':label.font?(label.font+3):15}">{{label.label_name}}</span></td></tr><tr ng-if="ps.printPreviewData.length<=0"><td>No data</td></tr></tbody></table></div></div></div><div class="col-md-7" ng-if="ps.printPreviewData.length>0"><div class="sticker"><ul class="pl-mb-0" style="list-style-type: none;"><li ng-repeat="label in ps.firstArray" class="text-center pt-5px"><span ng-if="(label.label_code != \'barcode\' || label.label_code != \'encrypted_barcode\') && label.label_code != \'layaway\' && label.label_code != \'express\'" ng-style="{\'font-size\':label.font?(label.font+5):15}">{{label.label_name}}</span><div ng-if="label.label_code == \'barcode\' || label.label_code == \'encrypted_barcode\'"><img src="assets/img/barcode-image.jpg" alt="barcode" width="210" height="45"></div></li></ul><div ng-if="(typeListkey[\'express\'] || typeListkey[\'layaway\'])" class="pt-5px clearfix"><span ng-if="typeListkey[\'layaway\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-right right-lable-stcr">{{typeListkey[\'layaway\']}}</span> <span ng-if="typeListkey[\'express\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-left left-lable-stcr">{{typeListkey[\'express\']}}</span></div></div></div></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/stickerSettings/dynamicSticker/printSticker.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="ps.availableOrderStatus=\'0\';ps.finalOrderStatus=\'0\'"><div ng-init="getPrintStickerData()"><form class="form-horizontal" name="printStickerFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button><button ui-sref="sticker-settings.dynamic-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Sticker Preview</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Sticker Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Available Order With Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="ps.availableOrderStatus" name="availableOrderStatus" id="availableOrderStatus"><option value="0">Available Order With Status</option><option value="{{status.status_code}}" ng-selected="ps.availableOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="finalOrderStatus" class="col-md-3 control-label">Final Order Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="ps.finalOrderStatus" name="finalOrderStatus" id="finalOrderStatus"><option value="0">Final Order Status</option><option value="{{status.status_code}}" ng-selected="ps.finalOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="maxOrderNumber" class="col-md-3 control-label">Maximum Order Number Per PDF Document</label><div class="col-md-4"><input type="number" is-number-key="" min="1" ng-model="ps.maxOrderNumber" class="form-control" placeholder="Maximum Order Number"></div></div><div class="form-group row"><label for="displayIcon" class="col-sm-3 control-label">Display Icon</label><div class="col-sm-4"><ba-switcher switcher-style="primary" switcher-value="ps.displayIcon" on-label="Yes" off-label="No"></ba-switcher></div></div><div class="form-group row"><label for="newSticker" class="col-sm-3 control-label">New Sticker</label><div class="col-sm-4"><ba-switcher switcher-style="primary" switcher-value="ps.newSticker" on-label="Yes" off-label="No"></ba-switcher></div></div><div class="form-group row"><label for="newSticker2" class="col-sm-3 control-label">New Sticker 2</label><div class="col-sm-4"><select class="form-control" name="newSticker2" id="newSticker2" ng-model="ps.newSticker2"><option value="" selected="selected">Select Option</option><option value="oldsticker">Old Sticker</option><option value="newlandscapesticker">Sticker With Image</option><option value="newportraitsticker">Portrait Sticker</option><option value="noysticker">4X6 Sticker - Noy</option></select></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Label Print Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="printLabel" class="col-md-3 control-label">Select Label To Print</label><div class="col-md-4"><ui-select multiple="" ng-model="ps.printLabel" ng-disabled="false" search-enabled="true" append-to-body="true" on-select="onSelected($item)" class="form-control multipleSelect"><ui-select-match placeholder="Select Label To Print">{{$item.label_name}}</ui-select-match><ui-select-choices repeat="multipleItem in printLabelData | filter: $select.search">{{multipleItem.label_name}}</ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Font Size Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Enter Entity To Print Custom Font</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Entity Name</th><th class="width-45-per">Font Size</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'fontsize\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.fontSizeData.length > 0" ng-repeat="font in ps.fontSizeData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleFont-{{$index}}"><input type="text" ng-model="font.name" limit-to="30" value="{{font.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Entity Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueFont-{{$index}}"><input type="number" is-number-key="" min="1" ng-model="font.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Font Size"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'fontsize\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.fontSizeData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Layaway Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Layaway Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Layaway Label</th><th class="width-45-per">Layaway Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'layaway\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.layAwayLabelData.length > 0" ng-repeat="lay in ps.layAwayLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleLayaway-{{$index}}"><input type="text" ng-model="lay.name" limit-to="30" value="{{lay.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Layaway Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueLayaway-{{$index}}"><input type="text" ng-model="lay.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Layaway Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'layaway\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.layAwayLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Shipping Method Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Shipping Method To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Shipping Method</th><th class="width-45-per">Shipping Method Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'shipping\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.shippingData.length > 0" ng-repeat="ship in ps.shippingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleShipping-{{$index}}"><input type="text" ng-model="ship.name" limit-to="50" value="{{ship.name}}" ng-maxlength="50" name="itemTitle" required="" class="form-control height27px" placeholder="Shipping Method"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueShipping-{{$index}}"><input type="text" ng-model="ship.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Shipping Method Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'shipping\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.shippingData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Express Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Express Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Label</th><th class="width-45-per">Express Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.expressLabelData.length > 0" ng-repeat="item in ps.expressLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExpress-{{$index}}"><input type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Express Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExpress-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Express Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.expressLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.dynamic-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Sticker Preview</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/expressSticker/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/expressSticker/expressSticker.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="exp.availableOrderStatus=\'0\';exp.finalOrderStatus=\'0\'"><div ng-init="getExpressStickerData()"><form class="form-horizontal" name="expressStickerFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveExpressStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.express-sticker-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Express Sticker Preview</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Express Print Sticker Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Express Available Order With Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="exp.availableOrderStatus" name="availableOrderStatus" id="availableOrderStatus"><option value="0">Express Available Order With Status</option><option value="{{status.status_code}}" ng-selected="exp.availableOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="finalOrderStatus" class="col-md-3 control-label">Express Final Order Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="exp.finalOrderStatus" name="finalOrderStatus" id="finalOrderStatus"><option value="0">Express Final Order Status</option><option value="{{status.status_code}}" ng-selected="exp.finalOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="maxOrderNumber" class="col-md-3 control-label">Express Maximum Order Number Per PDf Document</label><div class="col-md-4"><input type="number" is-number-key="" min="1" ng-model="exp.maxOrderNumber" class="form-control" placeholder="Express Maximum Order Number"></div></div><div class="form-group row"><label for="displayIcon" class="col-sm-3 control-label">Display Icon</label><div class="col-sm-4"><ba-switcher switcher-style="primary" switcher-value="exp.displayIcon" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Express Label Print Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="printLabel" class="col-md-3 control-label">Express Select Label To Print</label><div class="col-md-4"><ui-select multiple="" ng-model="exp.printLabel" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Express Select Label To Print">{{$item.label_name}}</ui-select-match><ui-select-choices repeat="multipleItem in printLabelData | filter: $select.search">{{multipleItem.label_name}}</ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Express Font Size Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Express Enter Entity To Print Custom Font</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Entity Name</th><th class="width-45-per">Font Size</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'fontsize\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="exp.fontSizeData.length > 0" ng-repeat="font in exp.fontSizeData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleFont-{{$index}}"><input only-caracter="" type="text" ng-model="font.name" limit-to="30" value="{{font.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Entity Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueFont-{{$index}}"><input type="number" is-number-key="" min="1" ng-model="font.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Font Size"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'fontsize\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="exp.fontSizeData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Express Layaway Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Express Select Layaway Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Layaway Label</th><th class="width-45-per">Layaway Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'layaway\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="exp.layAwayLabelData.length > 0" ng-repeat="lay in exp.layAwayLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleLayaway-{{$index}}"><input only-caracter="" type="text" ng-model="lay.name" limit-to="30" value="{{lay.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Layaway Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueLayaway-{{$index}}"><input type="text" ng-model="lay.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Layaway Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'layaway\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="exp.layAwayLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Express Shipping Method Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Express Select Shipping Method To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Shipping Method</th><th class="width-45-per">Shipping Method Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'shipping\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="exp.shippingData.length > 0" ng-repeat="ship in exp.shippingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleShipping-{{$index}}"><input only-caracter="" type="text" ng-model="ship.name" limit-to="30" value="{{ship.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Shipping Method"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueShipping-{{$index}}"><input type="text" ng-model="ship.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Shipping Method Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'shipping\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="exp.shippingData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Express Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Express Order Select Express Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Label</th><th class="width-45-per">Express Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="exp.expressLabelData.length > 0" ng-repeat="item in exp.expressLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExpress-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Express Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExpress-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Express Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="exp.expressLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveExpressStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.express-sticker-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Express Sticker Preview</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/expressSticker/expressStickerPreview.html','<div ba-panel="" ba-panel-class="with-scroll role-permission"><div class="panel-content" ng-init="getExpressPreviewData();getExpressStickerData()"><div class="row"><div class="col-sm-12 col-md-12"><span>Set Label Order by Just dragging label up-down.</span> <a ui-sref="sticker-settings.express-sticker" class="btn btn-warning save-permission btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveExpressStickerOrder()" class="btn btn-success btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-5"><div class="column"><div id="status" ba-panel="" ba-panel-title="Express Sticker Labels" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="exp.expressPreviewData"><tr ng-if="exp.expressPreviewData.length>0" ng-repeat="label in exp.expressPreviewData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor" ng-style="{\'font-size\':label.font?(label.font+3):15}">{{label.label_name}}</span></td></tr><tr ng-if="exp.expressPreviewData.length<=0"><td>No data</td></tr></tbody></table></div></div></div><div class="col-md-7" ng-if="exp.expressPreviewData.length>0"><div class="sticker"><ul class="pl-mb-0" style="list-style-type: none;"><li ng-repeat="label in exp.firstArray" class="text-center pt-5px"><span ng-if="(label.label_code != \'barcode\' || label.label_code != \'encrypted_barcode\') && label.label_code != \'layaway\' && label.label_code != \'express\'" ng-style="{\'font-size\':label.font?(label.font+4):15}">{{label.label_name}}</span><div ng-if="label.label_code == \'barcode\' || label.label_code == \'encrypted_barcode\'"><img src="assets/img/barcode-image.jpg" alt="barcode" width="210" height="45"></div></li></ul><div ng-if="(typeListkey[\'express\'] || typeListkey[\'layaway\'])" class="pt-5px clearfix"><span ng-if="typeListkey[\'layaway\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-right right-lable-stcr">{{typeListkey[\'layaway\']}}</span> <span ng-if="typeListkey[\'express\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-left left-lable-stcr">{{typeListkey[\'express\']}}</span></div></div></div></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/stickerSettings/printSticker/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/printSticker/printPreview.html','<div ba-panel="" ba-panel-class="with-scroll role-permission"><div class="panel-content" ng-init="getPrintPreviewData();getPrintStickerData()"><div class="row"><div class="col-sm-12 col-md-12"><span>Set Label Order by Just dragging label up-down.</span> <a ui-sref="sticker-settings.print-sticker" class="btn btn-warning save-permission btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintPreviewOrder()" class="btn btn-success btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-5"><div class="column"><div id="status" ba-panel="" ba-panel-title="Print Sticker Labels" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="ps.printPreviewData"><tr ng-if="ps.printPreviewData.length>0" ng-repeat="label in ps.printPreviewData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor" ng-style="{\'font-size\':label.font?(label.font+3):15}">{{label.label_name}}</span></td></tr><tr ng-if="ps.printPreviewData.length<=0"><td>No data</td></tr></tbody></table></div></div></div><div class="col-md-7" ng-if="ps.printPreviewData.length>0"><div class="sticker"><ul class="pl-mb-0" style="list-style-type: none;"><li ng-repeat="label in ps.firstArray" class="text-center pt-5px"><span ng-if="(label.label_code != \'barcode\' || label.label_code != \'encrypted_barcode\') && label.label_code != \'layaway\' && label.label_code != \'express\'" ng-style="{\'font-size\':label.font?(label.font+5):15}">{{label.label_name}}</span><div ng-if="label.label_code == \'barcode\' || label.label_code == \'encrypted_barcode\'"><img src="assets/img/barcode-image.jpg" alt="barcode" width="210" height="45"></div></li></ul><div ng-if="(typeListkey[\'express\'] || typeListkey[\'layaway\'])" class="pt-5px clearfix"><span ng-if="typeListkey[\'layaway\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-right right-lable-stcr">{{typeListkey[\'layaway\']}}</span> <span ng-if="typeListkey[\'express\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-left left-lable-stcr">{{typeListkey[\'express\']}}</span></div></div></div></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/stickerSettings/printSticker/printSticker.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="ps.availableOrderStatus=\'0\';ps.finalOrderStatus=\'0\'"><div ng-init="getPrintStickerData()"><form class="form-horizontal" name="printStickerFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button><button ui-sref="sticker-settings.print-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Print Sticker Preview</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Print Sticker Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Available Order With Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="ps.availableOrderStatus" name="availableOrderStatus" id="availableOrderStatus"><option value="0">Available Order With Status</option><option value="{{status.status_code}}" ng-selected="ps.availableOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="finalOrderStatus" class="col-md-3 control-label">Final Order Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="ps.finalOrderStatus" name="finalOrderStatus" id="finalOrderStatus"><option value="0">Final Order Status</option><option value="{{status.status_code}}" ng-selected="ps.finalOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="maxOrderNumber" class="col-md-3 control-label">Maximum Order Number Per PDF Document</label><div class="col-md-4"><input type="number" is-number-key="" min="1" ng-model="ps.maxOrderNumber" class="form-control" placeholder="Maximum Order Number"></div></div><div class="form-group row"><label for="displayIcon" class="col-sm-3 control-label">Display Icon</label><div class="col-sm-4"><ba-switcher switcher-style="primary" switcher-value="ps.displayIcon" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Label Print Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="printLabel" class="col-md-3 control-label">Select Label To Print</label><div class="col-md-4"><ui-select multiple="" ng-model="ps.printLabel" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Select Label To Print">{{$item.label_name}}</ui-select-match><ui-select-choices repeat="multipleItem in printLabelData | filter: $select.search">{{multipleItem.label_name}}</ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Font Size Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Enter Entity To Print Custom Font</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Entity Name</th><th class="width-45-per">Font Size</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'fontsize\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.fontSizeData.length > 0" ng-repeat="font in ps.fontSizeData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleFont-{{$index}}"><input only-caracter="" type="text" ng-model="font.name" limit-to="30" value="{{font.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Entity Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueFont-{{$index}}"><input type="number" is-number-key="" min="1" ng-model="font.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Font Size"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'fontsize\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.fontSizeData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Layaway Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Layaway Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Layaway Label</th><th class="width-45-per">Layaway Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'layaway\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.layAwayLabelData.length > 0" ng-repeat="lay in ps.layAwayLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleLayaway-{{$index}}"><input only-caracter="" type="text" ng-model="lay.name" limit-to="30" value="{{lay.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Layaway Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueLayaway-{{$index}}"><input type="text" ng-model="lay.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Layaway Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'layaway\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.layAwayLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Shipping Method Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Shipping Method To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Shipping Method</th><th class="width-45-per">Shipping Method Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'shipping\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.shippingData.length > 0" ng-repeat="ship in ps.shippingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleShipping-{{$index}}"><input only-caracter="" type="text" ng-model="ship.name" limit-to="50" value="{{ship.name}}" ng-maxlength="50" name="itemTitle" required="" class="form-control height27px" placeholder="Shipping Method"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueShipping-{{$index}}"><input type="text" ng-model="ship.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Shipping Method Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'shipping\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.shippingData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Express Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Express Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Label</th><th class="width-45-per">Express Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ps.expressLabelData.length > 0" ng-repeat="item in ps.expressLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExpress-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Express Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExpress-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Express Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ps.expressLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.print-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Print Sticker Preview</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/reworkSticker/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/reworkSticker/reworkPreview.html','<div ba-panel="" ba-panel-class="with-scroll role-permission"><div class="panel-content" ng-init="getReworkPreviewData();getReworkStickerData()"><div class="row"><div class="col-sm-12 col-md-12"><span>Set Label Order by Just dragging label up-down.</span> <a ui-sref="sticker-settings.rework-sticker" class="btn btn-warning save-permission btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="savePrintPreviewOrder()" class="btn btn-success btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-5"><div class="column"><div id="status" ba-panel="" ba-panel-title="Rework Sticker Labels" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="rs.printPreviewData"><tr ng-if="rs.printPreviewData.length>0" ng-repeat="label in rs.printPreviewData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor" ng-style="{\'font-size\':label.font?(label.font+3):15}">{{label.label_name}}</span></td></tr><tr ng-if="rs.printPreviewData.length<=0"><td>No data</td></tr></tbody></table></div></div></div><div class="col-md-7" ng-if="rs.printPreviewData.length>0"><div class="sticker"><ul class="pl-mb-0" style="list-style-type: none;"><li ng-repeat="label in rs.firstArray" class="text-center pt-5px"><span ng-if="label.label_code != \'barcode\' && label.label_code != \'layaway\' && label.label_code != \'express\'" ng-style="{\'font-size\':label.font?(label.font+5):15}">{{label.label_name}}</span><div ng-if="label.label_code == \'barcode\'"><img src="assets/img/barcode-image.jpg" alt="barcode" width="210" height="45"></div></li></ul><div ng-if="(typeListkey[\'express\'] || typeListkey[\'layaway\'])" class="pt-5px clearfix"><span ng-if="typeListkey[\'layaway\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-right right-lable-stcr">{{typeListkey[\'layaway\']}}</span> <span ng-if="typeListkey[\'express\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-left left-lable-stcr">{{typeListkey[\'express\']}}</span></div></div></div></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/pages/stickerSettings/reworkSticker/reworkSticker.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="rs.availableOrderStatus=\'0\';rs.finalOrderStatus=\'0\'"><div ng-init="getReworkStickerData()"><form class="form-horizontal" name="printStickerFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveReworkStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button><button ui-sref="sticker-settings.rework-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Rework Sticker Preview</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Rework Sticker Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Available Order With Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="rs.availableOrderStatus" name="availableOrderStatus" id="availableOrderStatus"><option value="0">Available Order With Status</option><option value="{{status.status_code}}" ng-selected="rs.availableOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="finalOrderStatus" class="col-md-3 control-label">Final Order Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="rs.finalOrderStatus" name="finalOrderStatus" id="finalOrderStatus"><option value="0">Final Order Status</option><option value="{{status.status_code}}" ng-selected="rs.finalOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="maxOrderNumber" class="col-md-3 control-label">Maximum Order Number Per PDF Document</label><div class="col-md-4"><input type="number" is-number-key="" min="1" ng-model="rs.maxOrderNumber" class="form-control" placeholder="Maximum Order Number"></div></div><div class="form-group row"><label for="displayIcon" class="col-sm-3 control-label">Display Icon</label><div class="col-sm-4"><ba-switcher switcher-style="primary" switcher-value="rs.displayIcon" on-label="Yes" off-label="No"></ba-switcher></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Label Print Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="printLabel" class="col-md-3 control-label">Select Label To Print</label><div class="col-md-4"><ui-select multiple="" ng-model="rs.printLabel" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Select Label To Print">{{$item.label_name}}</ui-select-match><ui-select-choices repeat="multipleItem in printLabelData | filter: $select.search">{{multipleItem.label_name}}</ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Font Size Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Enter Entity To Print Custom Font</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Entity Name</th><th class="width-45-per">Font Size</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'fontsize\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="rs.fontSizeData.length > 0" ng-repeat="font in rs.fontSizeData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleFont-{{$index}}"><input only-caracter="" type="text" ng-model="font.name" limit-to="30" value="{{font.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Entity Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueFont-{{$index}}"><input type="number" is-number-key="" min="1" ng-model="font.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Font Size"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'fontsize\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="rs.fontSizeData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Layaway Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Layaway Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Layaway Label</th><th class="width-45-per">Layaway Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'layaway\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="rs.layAwayLabelData.length > 0" ng-repeat="lay in rs.layAwayLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleLayaway-{{$index}}"><input only-caracter="" type="text" ng-model="lay.name" limit-to="30" value="{{lay.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Layaway Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueLayaway-{{$index}}"><input type="text" ng-model="lay.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Layaway Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'layaway\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="rs.layAwayLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Shipping Method Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Shipping Method To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Shipping Method</th><th class="width-45-per">Shipping Method Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'shipping\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="rs.shippingData.length > 0" ng-repeat="ship in rs.shippingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleShipping-{{$index}}"><input only-caracter="" type="text" ng-model="ship.name" limit-to="50" value="{{ship.name}}" ng-maxlength="50" name="itemTitle" required="" class="form-control height27px" placeholder="Shipping Method"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueShipping-{{$index}}"><input type="text" ng-model="ship.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Shipping Method Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'shipping\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="rs.shippingData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Express Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Select Express Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Label</th><th class="width-45-per">Express Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="rs.expressLabelData.length > 0" ng-repeat="item in rs.expressLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExpress-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Express Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExpress-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Express Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="rs.expressLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveReworkStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.rework-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Rework Sticker Preview</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/supplySticker/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="removeItem()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/stickerSettings/supplySticker/supplySticker.html','<div class="widgets profile faqfrontend" ba-panel="" ng-init="ss.availableOrderStatus=\'0\';ss.finalOrderStatus=\'0\'"><div ng-init="getSupplyStickerData()"><form class="form-horizontal" name="supplyStickerFrm" novalidate=""><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveSupplyStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.supply-sticker-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Supply Sticker Preview</button></div></div><uib-accordion close-others="oneAtATime" ng-show="isloaded"><uib-accordion-group is-open="menuStatus[0].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[0].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[0].isOpen}"></i> <span>Supply Sticker Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div ng-init="getActiveStatus()"><div class="form-group row clearfix"><label for="availableOrderStatus" class="col-md-3 control-label">Supply Available Order With Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="ss.availableOrderStatus" name="availableOrderStatus" id="availableOrderStatus"><option value="0">Supply Available Order With Status</option><option value="{{status.status_code}}" ng-selected="ss.availableOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="finalOrderStatus" class="col-md-3 control-label">Supply Final Order Status</label><div class="col-md-4"><select class="form-control roleData" ng-model="ss.finalOrderStatus" name="finalOrderStatus" id="finalOrderStatus"><option value="0">Supply Final Order Status</option><option value="{{status.status_code}}" ng-selected="ss.finalOrderStatus==status.status_code" ng-repeat="status in orderStatus">{{status.status_label}}</option></select></div></div><div class="form-group row clearfix"><label for="maxOrderNumber" class="col-md-3 control-label">Supply Maximum Order Number Per PDf Document</label><div class="col-md-4"><input type="number" is-number-key="" min="1" ng-model="ss.maxOrderNumber" class="form-control" placeholder="Supply Maximum Order Number"></div></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[1].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[1].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[1].isOpen}"></i> <span>Supply Label Print Setting</span></uib-accordion-heading><div class="row"><div class="col-md-12"><div class="form-group row clearfix"><label for="printLabel" class="col-md-3 control-label">Supply Select Label To Print</label><div class="col-md-4"><ui-select multiple="" ng-model="ss.printLabel" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control multipleSelect"><ui-select-match placeholder="Select Label To Print">{{$item.label_name}}</ui-select-match><ui-select-choices repeat="multipleItem in printLabelData | filter: $select.search">{{multipleItem.label_name}}</ui-select-choices></ui-select></div></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[2].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[2].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[2].isOpen}"></i> <span>Supply Font Size Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Supply Enter Entity To Print Custom Font</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Entity Name</th><th class="width-45-per">Font Size</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'fontsize\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ss.fontSizeData.length > 0" ng-repeat="item in ss.fontSizeData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleFont-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Entity Name"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueFont-{{$index}}"><input type="number" is-number-key="" min="1" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Font Size"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'fontsize\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ss.fontSizeData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[3].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[3].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[3].isOpen}"></i> <span>Supply Layaway Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Supply Select Layaway Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Layaway Label</th><th class="width-45-per">Layaway Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'layaway\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ss.layAwayLabelData.length > 0" ng-repeat="item in ss.layAwayLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleLayaway-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Layaway Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueLayaway-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Layaway Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'layaway\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ss.layAwayLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[4].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[4].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[4].isOpen}"></i> <span>Supply Shipping Method Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Supply Select Shipping Method To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Shipping Method</th><th class="width-45-per">Shipping Method Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'shipping\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ss.shippingData.length > 0" ng-repeat="item in ss.shippingData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleShipping-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Shipping Method"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueShipping-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Shipping Method Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'shipping\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ss.shippingData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group><uib-accordion-group is-open="menuStatus[5].isOpen" panel-class="panel accordion-panel panel-blur"><uib-accordion-heading><i class="glyphicon pull-right" ng-class="{\'fa fa-angle-up fa-lg\': menuStatus[5].isOpen, \'fa fa-angle-down fa-lg\': !menuStatus[5].isOpen}"></i> <span>Supply Express Label Setting</span></uib-accordion-heading><div class="row form-group"><label for="label" class="col-md-3 control-label">Supply Select Express Label To Print</label><div class="col-md-7"><div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="width-45-per">Express Label</th><th class="width-45-per">Express Label Print</th><th class="width-10-per"><button class="btn btn-warning btn-xs btn-with-icon" ng-click="addItem(\'express\')"><i class="ion-android-checkmark-circle"></i>Add New</button></th></tr></thead><tr ng-if="ss.expressLabelData.length > 0" ng-repeat="item in ss.expressLabelData" class="editable-row"><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemTitleExpress-{{$index}}"><input only-caracter="" type="text" ng-model="item.name" limit-to="30" value="{{item.name}}" ng-maxlength="30" name="itemTitle" required="" class="form-control height27px" placeholder="Express Label"></div></div></div></div></td><td><div class="row"><div class="col-md-12"><div class="row clearfix"><div class="col-sm-12" id="itemValueExpress-{{$index}}"><input type="text" ng-model="item.value" limit-to="30" ng-maxlength="30" name="itemValue" required="" class="form-control height27px" placeholder="Express Label Print"></div></div></div></div></td><td class="text-center"><div class="buttons"><button class="btn btn-danger btn-xs btn-with-icon" ng-click="confirmDelete($index,\'express\')"><i class="fa fa-trash-o fa-lg white"></i>Delete</button></div></td></tr><tr ng-if="ss.expressLabelData.length < 1"><td colspan="3">No data available in table</td></tr></table></div></div></div></uib-accordion-group></uib-accordion><div class="row" ng-show="isloaded"><div class="col-sm-12 col-md-12"><a ui-sref="dashboard" class="btn btn-warning btn-with-icon save-permission pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveSupplyStickerSettings()" class="btn btn-primary btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save Config</button> <button ui-sref="sticker-settings.supply-sticker-preview" type="button" class="btn btn-info btn-with-icon add-new-btn"><i class="fa fa-eye"></i>Supply Sticker Preview</button></div></div><div ng-show="!isloaded" class="row"><div class="col-md-12"><img class="center-block" width="50" height="50" ng-src="{{::( loaderImage| appImage )}}"><br><p class="text-center">Loading</p></div></div></form></div></div>');
$templateCache.put('app/pages/stickerSettings/supplySticker/supplyStickerPreview.html','<div ba-panel="" ba-panel-class="with-scroll role-permission"><div class="panel-content" ng-init="getSupplyStickerData();getSupplyPreviewData();"><div class="row"><div class="col-sm-12 col-md-12"><span>Set Label Order by Just dragging label up-down.</span> <a ui-sref="sticker-settings.supply-sticker" class="btn btn-warning save-permission btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button type="submit" ng-click="saveSupplyStickerOrder()" class="btn btn-success btn-with-icon save-permission pull-right"><i class="ion-android-checkmark-circle"></i>Save</button></div></div><div class="row"><div class="col-md-5"><div class="column"><div id="status" ba-panel="" ba-panel-title="Supply Sticker Labels" ba-panel-class="light-text with-scroll shipping-inner-panel"><table class="table border-none"><tbody as-sortable="sortableOptions" ng-model="ss.supplyPreviewData"><tr ng-if="ss.supplyPreviewData.length>0" ng-repeat="label in ss.supplyPreviewData" as-sortable-item=""><td class="align-left"><span as-sortable-item-handle="" class="status-label cursor" ng-style="{\'font-size\':label.font?(label.font+3):15}">{{label.label_name}}</span></td></tr><tr ng-if="ss.supplyPreviewData.length<=0"><td>No data</td></tr></tbody></table></div></div></div><div class="col-md-7" ng-if="ss.supplyPreviewData.length>0"><div class="sticker"><ul class="pl-mb-0" style="list-style-type: none;"><li ng-repeat="label in ss.firstArray" class="text-center pt-5px"><span ng-if="(label.label_code != \'barcode\' || label.label_code != \'encrypted_barcode\') && label.label_code != \'express\'" ng-style="{\'font-size\':label.font?(label.font+4):15}">{{label.label_name}}</span><div ng-if="label.label_code == \'barcode\' || label.label_code == \'encrypted_barcode\'"><img src="assets/img/barcode-image.jpg" alt="barcode" width="210" height="45"></div></li></ul><div ng-if="(typeListkey[\'express\'] || typeListkey[\'layaway\'])" class="pt-5px clearfix"><span ng-if="typeListkey[\'layaway\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-right right-lable-stcr">{{typeListkey[\'layaway\']}}</span> <span ng-if="typeListkey[\'express\']" ng-style="{\'font-size\':label.font?(label.font+4):15}" class="pull-left left-lable-stcr">{{typeListkey[\'express\']}}</span></div></div></div></div></div></div><style>\n  #status .panel.with-scroll .panel-body{\n    max-height: {{statusHeight}}px;\n  }\n</style>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-if="permissionArr.indexOf(item.permissionKey) !== -1 || item.name == \'dashboard\'" ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="{ selected: currentState==item.name}" ba-sidebar-toggling-item="item" title="{{ ::item.title }}"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu,\'selected\': currentState==subitem.name}" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled && permissionArr.indexOf(subitem.permissionKey) !== -1)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref?subitem.fixedHref:\'\')}}"><i class="fa fa-angle-double-right"></i> {{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li ng-if="activePageTitle != \'Dashboard\'"><a href="#/dashboard">Home</a></li><li ng-if="prevStateTitle"><a ui-sref="{{prevState}}">{{prevStateTitle}}</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><img ng-if="!globalSetting.file" class="hidden-xs" width="150px" ng-src="{{::( \'logo\' | profilePicture )}}"> <img ng-if="globalSetting.file" class="hidden-xs" width="150px" height="40px" ng-src="{{logoUrl+globalSetting.file}}"></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="search search1show"><i class="ion-ios-search-strong" ng-click="startSearch()"></i> <input id="searchInput" ng-enter="orderListGlobalSearch()" ng-blur="orderListGlobalSearch()" ng-model="search" type="text" placeholder="Search for orders"></div><div class="user-profile clearfix"><label class="usernameTop hidden-xs">{{globals.currentUser.firstname}} {{globals.currentUser.lastname}}</label><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link" ng-if="globals.currentUser.profile_pic"><img ng-src="{{profilePickUrl+globals.currentUser.profile_pic}}"></a> <a uib-dropdown-toggle="" class="profile-toggle-link" ng-if="!globals.currentUser.profile_pic"><img ng-if="globals.currentUser.gender == \'male\'" ng-src="{{::(\'male-profile\' | profilePicture )}}"> <img ng-if="globals.currentUser.gender == \'female\'" ng-src="{{::(\'female-profile\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="#/profile/view-profile"><i class="fa fa-user"></i>Profile</a></li><li><a href="" class="signout" ng-click="logOut()"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div><msg-center></msg-center></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue" ng-disabled="disable==true"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on" ng-bind="onLabel?onLabel:\'ON\'"></span> <span class="handle"></span> <span class="handle handle-off" ng-bind="offLabel?offLabel:\'OFF\'"></span></div></div></label>');
$templateCache.put('app/pages/settings/store/magentoStatus/addMagentoStatus.html','<div ba-panel="" ba-panel-class="with-scroll" ng-init="vm.status=\'1\'"><div class="panel-content" ng-init="getEditedMagentoStatus()"><span class="col-sm-12 text-right requiredLabel">Fields marked with <span class="asterisk_input"></span> are mandatory.</span><form class="form-horizontal" name="magentoStatusFrm" novalidate="" ng-submit="magentoStatusFrm.$valid && saveMagentoStatusData()"><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="magentoStatusTitle" class="col-sm-4 control-label">Magento Status Title <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="magentoStatusTitle" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.magentoStatusTitle" name="magentoStatusTitle" required="" class="form-control" placeholder="Magento Status Title" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="magentoStatusFrm.$submitted && magentoStatusFrm.magentoStatusTitle.$error.required">Please enter magento status title.</span> <span class="error" ng-show="magentoStatusFrm.magentoStatusTitle.$error.pattern">Please enter valid magento status title.</span> <span class="error" ng-show="magentoStatusFrm.magentoStatusTitle.$error.maxlength && magentoStatusFrm.magentoStatusTitle.$touched">Magento Status Title should not be greater than 40 characters.</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="magentoStatusCode" class="col-sm-4 control-label">Magento Status Code <span class="asterisk_input"></span></label><div class="col-sm-8"><input id="magentoStatusCode" limit-to="40" ng-maxlength="40" type="text" ng-model="vm.magentoStatusCode" name="magentoStatusCode" required="" class="form-control" placeholder="Magento Status Code" ng-pattern="/^[a-z\\d\\-_\\s]+$/i"> <span class="error" ng-show="magentoStatusFrm.$submitted && magentoStatusFrm.magentoStatusCode.$error.required">Please enter magento status code.</span> <span class="error" ng-show="magentoStatusFrm.magentoStatusCode.$error.pattern">Please enter valid magento status code.</span> <span class="error" ng-show="magentoStatusFrm.magentoStatusCode.$error.maxlength && magentoStatusFrm.magentoStatusCode.$touched">Magento Status Code should not be greater than 40 characters</span></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="status" class="col-sm-4 control-label">Status <span class="asterisk_input"></span></label><div class="col-sm-8"><label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="status" value="1"> <span>Active</span></label> <label class="radio-inline custom-radio nowrap"><input required="" ng-model="vm.status" type="radio" name="status" id="inlineRadio2" value="0"> <span>InActive</span></label> <span class="error" ng-show="magentoStatusFrm.$submitted && magentoStatusFrm.status.$error.required">Please select status.</span></div></div></div></div><button type="submit" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Save</button> <a ui-sref="settings.magento-status" class="btn btn-warning btn-with-icon save-profile"><i class="ion-android-warning"></i>Cancel</a> <input type="hidden" ng-model="vm.magentoStatusId"></form></div></div>');
$templateCache.put('app/pages/settings/store/magentoStatus/deleteModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to delete this record?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="deleteMagentoStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');
$templateCache.put('app/pages/settings/store/magentoStatus/magentoStatus.html','<div class="widgets profile" ba-panel=""><div class="row"><div class="col-md-12"><a ui-sref="settings.store" class="btn btn-warning btn-with-icon pull-right"><i class="ion-android-warning"></i>Cancel</a> <button ng-if="permissionArr.indexOf(\'magento_status_add\') !== - 1" ng-click="addMagentoStatus()" type="button" class="btn btn-primary btn-with-icon add-new-btn mr-16"><i class="ion-android-checkmark-circle"></i>Add New</button></div></div><div class="row"><div class="col-md-12 datatable-scroll"><div ng-controller="getDataTable as showCase"><table class="table table-bordered" datatable="" dt-options="showCase.dtOptions" dt-columns="showCase.dtColumns"></table></div></div></div></div>');
$templateCache.put('app/pages/settings/store/magentoStatus/statusModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body text-center">Are you sure you want to change status?</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="changeStatus()">YES</button> <button type="button" class="btn btn-warning" ng-click="$dismiss()">NO</button></div></div>');}]);